// symbols list for auto complete
const symbols = [
  {
    symbol: 'A',
    'Security Name': 'Agilent Technologies,  ',

    'CQS symbol': 'A',
    'NASDAQ symbol': 'A',
  },
  {
    symbol: 'AA',
    'Security Name': 'Alcoa Corporation  ',

    'CQS symbol': 'AA',
    'NASDAQ symbol': 'AA',
  },
  {
    symbol: 'AAA',
    'Security Name': 'Listed Funds Trust AAF First Priority CLO Bond ETF',

    'CQS symbol': 'AAA',
    'NASDAQ symbol': 'AAA',
  },
  {
    symbol: 'AAAU',
    'Security Name': 'Perth Mint Physical Gold ETF',

    'CQS symbol': 'AAAU',
    'NASDAQ symbol': 'AAAU',
  },
  {
    symbol: 'AACG',
    'Security Name':
      'ATA Creativity Global  American Depositary Shares, each representing two common shares',

    'NASDAQ symbol': 'AACG',
  },
  {
    symbol: 'AACQ',
    'Security Name': 'Artius Acquisition    ',

    'NASDAQ symbol': 'AACQ',
  },
  {
    symbol: 'AACQU',
    'Security Name':
      'Artius Acquisition   Unit consisting of one ordinary share and one third redeemable warrant',

    'NASDAQ symbol': 'AACQU',
  },
  {
    symbol: 'AACQW',
    'Security Name': 'Artius Acquisition   Warrant',

    'NASDAQ symbol': 'AACQW',
  },
  {
    symbol: 'AADR',
    'Security Name': 'AdvisorShares Dorsey Wright ADR ETF',

    'CQS symbol': 'AADR',
    'NASDAQ symbol': 'AADR',
  },
  {
    symbol: 'AAIC',
    'Security Name': 'Arlington Asset Investment Corp  (new)',

    'CQS symbol': 'AAIC',
    'NASDAQ symbol': 'AAIC',
  },
  {
    symbol: 'AAIC$B',
    'Security Name': 'Arlington Asset Investment Corp 700% ',

    'CQS symbol': 'AAICpB',
    'NASDAQ symbol': 'AAICB',
  },
  {
    symbol: 'AAIC$C',
    'Security Name':
      'Arlington Asset Investment Corp 8250% Seies C FixedtoFloating Rate Cumulative Redeemable Preferred Stock   ',

    'CQS symbol': 'AAICpC',
    'NASDAQ symbol': 'AAICC',
  },
  {
    symbol: 'AAL',
    'Security Name': 'American Airlines Group,   ',

    'NASDAQ symbol': 'AAL',
  },
  {
    symbol: 'AAMC',
    'Security Name': 'Altisource Asset Management Corp Com',

    'CQS symbol': 'AAMC',
    'NASDAQ symbol': 'AAMC',
  },
  {
    symbol: 'AAME',
    'Security Name': 'Atlantic American Corporation  ',

    'NASDAQ symbol': 'AAME',
  },
  {
    symbol: 'AAN',
    'Security Name': 'Aarons Holdings Company,   ',

    'CQS symbol': 'AAN',
    'NASDAQ symbol': 'AAN',
  },
  {
    symbol: 'AAOI',
    'Security Name': 'Applied Optoelectronics,   ',

    'NASDAQ symbol': 'AAOI',
  },
  {
    symbol: 'AAON',
    'Security Name': 'AAON,   ',

    'NASDAQ symbol': 'AAON',
  },
  {
    symbol: 'AAP',
    'Security Name': 'Advance Auto Parts ',

    'CQS symbol': 'AAP',
    'NASDAQ symbol': 'AAP',
  },
  {
    symbol: 'AAPL',
    'Security Name': 'Apple   ',

    'NASDAQ symbol': 'AAPL',
  },
  {
    symbol: 'AAT',
    'Security Name': 'American Assets Trust,  ',

    'CQS symbol': 'AAT',
    'NASDAQ symbol': 'AAT',
  },
  {
    symbol: 'AAU',
    'Security Name': 'Almaden Minerals, Ltd Common Shares',

    'CQS symbol': 'AAU',
    'NASDAQ symbol': 'AAU',
  },
  {
    symbol: 'AAWW',
    'Security Name': 'Atlas Air Worldwide Holdings  ',

    'NASDAQ symbol': 'AAWW',
  },
  {
    symbol: 'AAXJ',
    'Security Name': 'iShares MSCI All Country Asia ex Japan Index Fund',

    'NASDAQ symbol': 'AAXJ',
  },
  {
    symbol: 'AAXN',
    'Security Name': 'Axon Enterprise,   ',

    'NASDAQ symbol': 'AAXN',
  },
  {
    symbol: 'AB',
    'Security Name': 'AllianceBernstein Holding LP  Units',

    'CQS symbol': 'AB',
    'NASDAQ symbol': 'AB',
  },
  {
    symbol: 'ABB',
    'Security Name': 'ABB Ltd ',

    'CQS symbol': 'ABB',
    'NASDAQ symbol': 'ABB',
  },
  {
    symbol: 'ABBV',
    'Security Name': 'AbbVie  ',

    'CQS symbol': 'ABBV',
    'NASDAQ symbol': 'ABBV',
  },
  {
    symbol: 'ABC',
    'Security Name': 'AmerisourceBergen Corporation ',

    'CQS symbol': 'ABC',
    'NASDAQ symbol': 'ABC',
  },
  {
    symbol: 'ABCB',
    'Security Name': 'Ameris Bancorp  ',

    'NASDAQ symbol': 'ABCB',
  },
  {
    symbol: 'ABCM',
    'Security Name': 'Abcam plc  American Depositary Shares',

    'NASDAQ symbol': 'ABCM',
  },
  {
    symbol: 'ABEO',
    'Security Name': 'Abeona Therapeutics   ',

    'NASDAQ symbol': 'ABEO',
  },
  {
    symbol: 'ABEQ',
    'Security Name': 'Absolute Core Strategy ETF',

    'CQS symbol': 'ABEQ',
    'NASDAQ symbol': 'ABEQ',
  },
  {
    symbol: 'ABEV',
    'Security Name':
      'Ambev SA American Depositary Shares (Each representing 1 Common Share)',

    'CQS symbol': 'ABEV',
    'NASDAQ symbol': 'ABEV',
  },
  {
    symbol: 'ABG',
    'Security Name': 'Asbury Automotive Group  ',

    'CQS symbol': 'ABG',
    'NASDAQ symbol': 'ABG',
  },
  {
    symbol: 'ABIO',
    'Security Name': 'ARCA biopharma,   ',

    'NASDAQ symbol': 'ABIO',
  },
  {
    symbol: 'ABM',
    'Security Name': 'ABM Industries orporated ',

    'CQS symbol': 'ABM',
    'NASDAQ symbol': 'ABM',
  },
  {
    symbol: 'ABMD',
    'Security Name': 'ABIOMED,   ',

    'NASDAQ symbol': 'ABMD',
  },
  {
    symbol: 'ABR',
    'Security Name': 'Arbor Realty Trust ',

    'CQS symbol': 'ABR',
    'NASDAQ symbol': 'ABR',
  },
  {
    symbol: 'ABR$A',
    'Security Name': 'Arbor Realty Trust Preferred Series A',

    'CQS symbol': 'ABRpA',
    'NASDAQ symbol': 'ABRA',
  },
  {
    symbol: 'ABR$B',
    'Security Name':
      'Arbor Realty Trust Cumulative Redeemable Preferred Series B',

    'CQS symbol': 'ABRpB',
    'NASDAQ symbol': 'ABRB',
  },
  {
    symbol: 'ABR$C',
    'Security Name':
      'Arbor Realty Trust Cumulative Redeemable Preferred Series C',

    'CQS symbol': 'ABRpC',
    'NASDAQ symbol': 'ABRC',
  },
  {
    symbol: 'ABST',
    'Security Name': 'Absolute Software Corporation  ',

    'NASDAQ symbol': 'ABST',
  },
  {
    symbol: 'ABT',
    'Security Name': 'Abbott Laboratories ',

    'CQS symbol': 'ABT',
    'NASDAQ symbol': 'ABT',
  },
  {
    symbol: 'ABTX',
    'Security Name': 'Allegiance Bancshares,   ',

    'NASDAQ symbol': 'ABTX',
  },
  {
    symbol: 'ABUS',
    'Security Name': 'Arbutus Biopharma Corporation  ',

    'NASDAQ symbol': 'ABUS',
  },
  {
    symbol: 'AC',
    'Security Name': 'Associated Capital Group,  ',

    'CQS symbol': 'AC',
    'NASDAQ symbol': 'AC',
  },
  {
    symbol: 'ACA',
    'Security Name': 'Arcosa,   ',

    'CQS symbol': 'ACA',
    'NASDAQ symbol': 'ACA',
  },
  {
    symbol: 'ACACU',
    'Security Name': 'Acies Acquisition Corp  Unit',

    'NASDAQ symbol': 'ACACU',
  },
  {
    symbol: 'ACAD',
    'Security Name': 'ACADIA Pharmaceuticals   ',

    'NASDAQ symbol': 'ACAD',
  },
  {
    symbol: 'ACAM',
    'Security Name': 'Acamar Partners Acquisition Corp   ',

    'NASDAQ symbol': 'ACAM',
  },
  {
    symbol: 'ACAMU',
    'Security Name': 'Acamar Partners Acquisition Corp  Units',

    'NASDAQ symbol': 'ACAMU',
  },
  {
    symbol: 'ACAMW',
    'Security Name': 'Acamar Partners Acquisition Corp  Warrant',

    'NASDAQ symbol': 'ACAMW',
  },
  {
    symbol: 'ACB',
    'Security Name': 'Aurora Cannabis  Common Shares',

    'CQS symbol': 'ACB',
    'NASDAQ symbol': 'ACB',
  },
  {
    symbol: 'ACBI',
    'Security Name': 'Atlantic Capital Bancshares,   ',

    'NASDAQ symbol': 'ACBI',
  },
  {
    symbol: 'ACC',
    'Security Name': 'American Campus Communities  ',

    'CQS symbol': 'ACC',
    'NASDAQ symbol': 'ACC',
  },
  {
    symbol: 'ACCD',
    'Security Name': 'Accolade,   ',

    'NASDAQ symbol': 'ACCD',
  },
  {
    symbol: 'ACCO',
    'Security Name': 'Acco Brands Corporation ',

    'CQS symbol': 'ACCO',
    'NASDAQ symbol': 'ACCO',
  },
  {
    symbol: 'ACEL',
    'Security Name': 'Accel Entertainment,  ',

    'CQS symbol': 'ACEL',
    'NASDAQ symbol': 'ACEL',
  },
  {
    symbol: 'ACER',
    'Security Name': 'Acer Therapeutics   ',

    'NASDAQ symbol': 'ACER',
  },
  {
    symbol: 'ACES',
    'Security Name': 'ALPS Clean Energy ETF',

    'CQS symbol': 'ACES',
    'NASDAQ symbol': 'ACES',
  },
  {
    symbol: 'ACET',
    'Security Name': 'Adicet Bio,   ',

    'NASDAQ symbol': 'ACET',
  },
  {
    symbol: 'ACEV',
    'Security Name': 'ACE Convergence Acquisition Corp   Ordinary Shares',

    'NASDAQ symbol': 'ACEV',
  },
  {
    symbol: 'ACEVU',
    'Security Name': 'ACE Convergence Acquisition Corp  Unit',

    'NASDAQ symbol': 'ACEVU',
  },
  {
    symbol: 'ACEVW',
    'Security Name': 'ACE Convergence Acquisition Corp  Warrant',

    'NASDAQ symbol': 'ACEVW',
  },
  {
    symbol: 'ACGL',
    'Security Name': 'Arch Capital Group Ltd  ',

    'NASDAQ symbol': 'ACGL',
  },
  {
    symbol: 'ACGLO',
    'Security Name':
      'Arch Capital Group Ltd  Depositary Shares Each Representing 1/1,000th Interest in a Share of545% NonCumulative Preferred Shares, Series F',

    'NASDAQ symbol': 'ACGLO',
  },
  {
    symbol: 'ACGLP',
    'Security Name':
      'Arch Capital Group Ltd  Depositary Shares Representing Interest in 525% NonCumulative Preferred Series E Shrs',

    'NASDAQ symbol': 'ACGLP',
  },
  {
    symbol: 'ACH',
    'Security Name':
      'Aluminum Corporation of China Limited American Depositary Shares',

    'CQS symbol': 'ACH',
    'NASDAQ symbol': 'ACH',
  },
  {
    symbol: 'ACHC',
    'Security Name': 'Acadia Healthcare Company,   ',

    'NASDAQ symbol': 'ACHC',
  },
  {
    symbol: 'ACHV',
    'Security Name': 'Achieve Life Sciences,    Common Shares',

    'NASDAQ symbol': 'ACHV',
  },
  {
    symbol: 'ACI',
    'Security Name': 'Albertsons Companies,   ',

    'CQS symbol': 'ACI',
    'NASDAQ symbol': 'ACI',
  },
  {
    symbol: 'ACIA',
    'Security Name': 'Acacia Communications,   ',

    'NASDAQ symbol': 'ACIA',
  },
  {
    symbol: 'ACICU',
    'Security Name':
      'Atlas Crest Investment Corp Units, each consisting of one  , and onethird of one redeemable warrant',

    'CQS symbol': 'ACICU',
    'NASDAQ symbol': 'ACIC=',
  },
  {
    symbol: 'ACIO',
    'Security Name': 'ETF Series Solutions Aptus Collared ome Opportunity ETF',

    'CQS symbol': 'ACIO',
    'NASDAQ symbol': 'ACIO',
  },
  {
    symbol: 'ACIU',
    'Security Name': 'AC Immune SA  ',

    'NASDAQ symbol': 'ACIU',
  },
  {
    symbol: 'ACIW',
    'Security Name': 'ACI Worldwide,   ',

    'NASDAQ symbol': 'ACIW',
  },
  {
    symbol: 'ACLS',
    'Security Name': 'Axcelis Technologies,   ',

    'NASDAQ symbol': 'ACLS',
  },
  {
    symbol: 'ACM',
    'Security Name': 'AECOM ',

    'CQS symbol': 'ACM',
    'NASDAQ symbol': 'ACM',
  },
  {
    symbol: 'ACMR',
    'Security Name': 'ACM Research,    ',

    'NASDAQ symbol': 'ACMR',
  },
  {
    symbol: 'ACN',
    'Security Name': 'Accenture plc  Ordinary Shares (Ireland)',

    'CQS symbol': 'ACN',
    'NASDAQ symbol': 'ACN',
  },
  {
    symbol: 'ACNB',
    'Security Name': 'ACNB Corporation  ',

    'NASDAQ symbol': 'ACNB',
  },
  {
    symbol: 'ACND',
    'Security Name': 'Ascendant Digital Acquisition Corp  Ordinary Shares',

    'CQS symbol': 'ACND',
    'NASDAQ symbol': 'ACND',
  },
  {
    symbol: 'ACNDU',
    'Security Name':
      'Ascendant Digital Acquisition Corp Units, each consisting of one  ordinary share and onehalf of one redeemable warrant',

    'CQS symbol': 'ACNDU',
    'NASDAQ symbol': 'ACND=',
  },
  {
    symbol: 'ACNDW',
    'Security Name':
      'Ascendant Digital Acquisition Corp Warrants, each whole warrant exercisable for one  ordinary share at an exercise price of $1150 per share',

    'CQS symbol': 'ACNDWS',
    'NASDAQ symbol': 'ACND+',
  },
  {
    symbol: 'ACOR',
    'Security Name': 'Acorda Therapeutics,   ',

    'NASDAQ symbol': 'ACOR',
  },
  {
    symbol: 'ACP',
    'Security Name': 'Aberdeen ome Credit Strategies Fund Common Shares',

    'CQS symbol': 'ACP',
    'NASDAQ symbol': 'ACP',
  },
  {
    symbol: 'ACRE',
    'Security Name': 'Ares Commercial Real Estate Corporation ',

    'CQS symbol': 'ACRE',
    'NASDAQ symbol': 'ACRE',
  },
  {
    symbol: 'ACRS',
    'Security Name': 'Aclaris Therapeutics,   ',

    'NASDAQ symbol': 'ACRS',
  },
  {
    symbol: 'ACRX',
    'Security Name': 'AcelRx Pharmaceuticals,   ',

    'NASDAQ symbol': 'ACRX',
  },
  {
    symbol: 'ACSG',
    'Security Name': 'Xtrackers MSCI ACWI ex USA ESG Leaders Equity ETF',

    'CQS symbol': 'ACSG',
    'NASDAQ symbol': 'ACSG',
  },
  {
    symbol: 'ACSI',
    'Security Name': 'American Customer Satisfaction ETF',

    'CQS symbol': 'ACSI',
    'NASDAQ symbol': 'ACSI',
  },
  {
    symbol: 'ACST',
    'Security Name': 'Acasti Pharma,    ',

    'NASDAQ symbol': 'ACST',
  },
  {
    symbol: 'ACTC',
    'Security Name': 'ArcLight Clean Transition Corp   Ordinary Shares',

    'NASDAQ symbol': 'ACTC',
  },
  {
    symbol: 'ACTCU',
    'Security Name': 'ArcLight Clean Transition Corp  Unit',

    'NASDAQ symbol': 'ACTCU',
  },
  {
    symbol: 'ACTCW',
    'Security Name': 'ArcLight Clean Transition Corp  Warrant',

    'NASDAQ symbol': 'ACTCW',
  },
  {
    symbol: 'ACTG',
    'Security Name': 'Acacia Research Corporation  ',

    'NASDAQ symbol': 'ACTG',
  },
  {
    symbol: 'ACTV',
    'Security Name': 'LeaderShares Activist Leaders ETF',

    'CQS symbol': 'ACTV',
    'NASDAQ symbol': 'ACTV',
  },
  {
    symbol: 'ACU',
    'Security Name': 'Acme United Corporation ',

    'CQS symbol': 'ACU',
    'NASDAQ symbol': 'ACU',
  },
  {
    symbol: 'ACV',
    'Security Name':
      'AllianzGI Diversified ome & Convertible Fund Common Shares of Beneficial Interest',

    'CQS symbol': 'ACV',
    'NASDAQ symbol': 'ACV',
  },
  {
    symbol: 'ACVF',
    'Security Name': 'American Conservative Values ETF',

    'CQS symbol': 'ACVF',
    'NASDAQ symbol': 'ACVF',
  },
  {
    symbol: 'ACWF',
    'Security Name': 'iShares MSCI Global Multifactor ETF',

    'CQS symbol': 'ACWF',
    'NASDAQ symbol': 'ACWF',
  },
  {
    symbol: 'ACWI',
    'Security Name': 'iShares MSCI ACWI Index Fund',

    'NASDAQ symbol': 'ACWI',
  },
  {
    symbol: 'ACWV',
    'Security Name': 'iShares MSCI Global Min Vol Factor ETF',

    'CQS symbol': 'ACWV',
    'NASDAQ symbol': 'ACWV',
  },
  {
    symbol: 'ACWX',
    'Security Name': 'iShares MSCI ACWI ex US Index Fund',

    'NASDAQ symbol': 'ACWX',
  },
  {
    symbol: 'ACY',
    'Security Name': 'AeroCentury Corp ',

    'CQS symbol': 'ACY',
    'NASDAQ symbol': 'ACY',
  },
  {
    symbol: 'ADAP',
    'Security Name': 'Adaptimmune Therapeutics plc  American Depositary Shares',

    'NASDAQ symbol': 'ADAP',
  },
  {
    symbol: 'ADBE',
    'Security Name': 'Adobe   ',

    'NASDAQ symbol': 'ADBE',
  },
  {
    symbol: 'ADC',
    'Security Name': 'Agree Realty Corporation ',

    'CQS symbol': 'ADC',
    'NASDAQ symbol': 'ADC',
  },
  {
    symbol: 'ADCT',
    'Security Name': 'ADC Therapeutics SA Common Shares',

    'CQS symbol': 'ADCT',
    'NASDAQ symbol': 'ADCT',
  },
  {
    symbol: 'ADES',
    'Security Name': 'Advanced Emissions Solutions,   ',

    'NASDAQ symbol': 'ADES',
  },
  {
    symbol: 'ADFI',
    'Security Name': 'Anfield Dynamic Fixed ome ETF',

    'CQS symbol': 'ADFI',
    'NASDAQ symbol': 'ADFI',
  },
  {
    symbol: 'ADI',
    'Security Name': 'Analog Devices,   ',

    'NASDAQ symbol': 'ADI',
  },
  {
    symbol: 'ADIL',
    'Security Name': 'Adial Pharmaceuticals,   ',

    'NASDAQ symbol': 'ADIL',
  },
  {
    symbol: 'ADILW',
    'Security Name': 'Adial Pharmaceuticals,   Warrant',

    'NASDAQ symbol': 'ADILW',
  },
  {
    symbol: 'ADM',
    'Security Name': 'ArcherDanielsMidland Company ',

    'CQS symbol': 'ADM',
    'NASDAQ symbol': 'ADM',
  },
  {
    symbol: 'ADMA',
    'Security Name': 'ADMA Biologics   ',

    'NASDAQ symbol': 'ADMA',
  },
  {
    symbol: 'ADME',
    'Security Name': 'Aptus Drawdown Managed Equity ETF',

    'CQS symbol': 'ADME',
    'NASDAQ symbol': 'ADME',
  },
  {
    symbol: 'ADMP',
    'Security Name': 'Adamis Pharmaceuticals Corporation  ',

    'NASDAQ symbol': 'ADMP',
  },
  {
    symbol: 'ADMS',
    'Security Name': 'Adamas Pharmaceuticals,   ',

    'NASDAQ symbol': 'ADMS',
  },
  {
    symbol: 'ADNT',
    'Security Name': 'Adient plc Ordinary Shares ',

    'CQS symbol': 'ADNT',
    'NASDAQ symbol': 'ADNT',
  },
  {
    symbol: 'ADOCU',
    'Security Name': 'Edoc Acquisition Corp  Unit',

    'NASDAQ symbol': 'ADOCU',
  },
  {
    symbol: 'ADP',
    'Security Name': 'Automatic Data Processing,   ',

    'NASDAQ symbol': 'ADP',
  },
  {
    symbol: 'ADPT',
    'Security Name': 'Adaptive Biotechnologies Corporation  ',

    'NASDAQ symbol': 'ADPT',
  },
  {
    symbol: 'ADRE',
    'Security Name': 'Invesco BLDRS Emerging Markets 50 ADR Index Fund',

    'NASDAQ symbol': 'ADRE',
  },
  {
    symbol: 'ADS',
    'Security Name': 'Alliance Data Systems Corporation ',

    'CQS symbol': 'ADS',
    'NASDAQ symbol': 'ADS',
  },
  {
    symbol: 'ADSK',
    'Security Name': 'Autodesk,   ',

    'NASDAQ symbol': 'ADSK',
  },
  {
    symbol: 'ADT',
    'Security Name': 'ADT  ',

    'CQS symbol': 'ADT',
    'NASDAQ symbol': 'ADT',
  },
  {
    symbol: 'ADTN',
    'Security Name': 'ADTRAN,   ',

    'NASDAQ symbol': 'ADTN',
  },
  {
    symbol: 'ADTX',
    'Security Name': 'ADiTx Therapeutics,   ',

    'NASDAQ symbol': 'ADTX',
  },
  {
    symbol: 'ADUS',
    'Security Name': 'Addus HomeCare Corporation  ',

    'NASDAQ symbol': 'ADUS',
  },
  {
    symbol: 'ADV',
    'Security Name': 'Advantage Solutions     ',

    'NASDAQ symbol': 'ADV',
  },
  {
    symbol: 'ADVM',
    'Security Name': 'Adverum Biotechnologies,   ',

    'NASDAQ symbol': 'ADVM',
  },
  {
    symbol: 'ADVWW',
    'Security Name': 'Advantage Solutions    Warrant',

    'NASDAQ symbol': 'ADVWW',
  },
  {
    symbol: 'ADX',
    'Security Name': 'Adams Diversified Equity Fund ',

    'CQS symbol': 'ADX',
    'NASDAQ symbol': 'ADX',
  },
  {
    symbol: 'ADXN',
    'Security Name': 'Addex Therapeutics Ltd  American Depositary Shares',

    'NASDAQ symbol': 'ADXN',
  },
  {
    symbol: 'ADXS',
    'Security Name': 'Advaxis,   ',

    'NASDAQ symbol': 'ADXS',
  },
  {
    symbol: 'AE',
    'Security Name': 'Adams Resources & Energy,  ',

    'CQS symbol': 'AE',
    'NASDAQ symbol': 'AE',
  },
  {
    symbol: 'AEB',
    'Security Name': 'AEGON NV Perp Cap Secs Floating Rate (Netherlands)',

    'CQS symbol': 'AEB',
    'NASDAQ symbol': 'AEB',
  },
  {
    symbol: 'AEE',
    'Security Name': 'Ameren Corporation ',

    'CQS symbol': 'AEE',
    'NASDAQ symbol': 'AEE',
  },
  {
    symbol: 'AEF',
    'Security Name': 'Aberdeen Emerging Markets Equity ome Fund,  ',

    'CQS symbol': 'AEF',
    'NASDAQ symbol': 'AEF',
  },
  {
    symbol: 'AEFC',
    'Security Name':
      'Aegon Funding Company LLC 510% Subordinated Notes due 2049',

    'CQS symbol': 'AEFC',
    'NASDAQ symbol': 'AEFC',
  },
  {
    symbol: 'AEG',
    'Security Name': 'AEGON NV ',

    'CQS symbol': 'AEG',
    'NASDAQ symbol': 'AEG',
  },
  {
    symbol: 'AEGN',
    'Security Name': 'Aegion Corp   ',

    'NASDAQ symbol': 'AEGN',
  },
  {
    symbol: 'AEHL',
    'Security Name': 'Antelope Enterprise Holdings Limited  ',

    'NASDAQ symbol': 'AEHL',
  },
  {
    symbol: 'AEHR',
    'Security Name': 'Aehr Test Systems  ',

    'NASDAQ symbol': 'AEHR',
  },
  {
    symbol: 'AEIS',
    'Security Name': 'Advanced Energy Industries,   ',

    'NASDAQ symbol': 'AEIS',
  },
  {
    symbol: 'AEL',
    'Security Name': 'American Equity Investment Life Holding Company ',

    'CQS symbol': 'AEL',
    'NASDAQ symbol': 'AEL',
  },
  {
    symbol: 'AEL$A',
    'Security Name': 'American Equity Investment Life Holding Company ',

    'CQS symbol': 'AELpA',
    'NASDAQ symbol': 'AELA',
  },
  {
    symbol: 'AEL$B',
    'Security Name': 'American Equity Investment Life Holding Company B',

    'CQS symbol': 'AELpB',
    'NASDAQ symbol': 'AELB',
  },
  {
    symbol: 'AEM',
    'Security Name': 'Agnico Eagle Mines Limited ',

    'CQS symbol': 'AEM',
    'NASDAQ symbol': 'AEM',
  },
  {
    symbol: 'AEMD',
    'Security Name': 'Aethlon Medical,   ',

    'NASDAQ symbol': 'AEMD',
  },
  {
    symbol: 'AENZ',
    'Security Name': 'Aenza SAA American Depositary Shares',

    'CQS symbol': 'AENZ',
    'NASDAQ symbol': 'AENZ',
  },
  {
    symbol: 'AEO',
    'Security Name': 'American Eagle Outfitters,  ',

    'CQS symbol': 'AEO',
    'NASDAQ symbol': 'AEO',
  },
  {
    symbol: 'AEP',
    'Security Name': 'American Electric Power Company,   ',

    'NASDAQ symbol': 'AEP',
  },
  {
    symbol: 'AEPPL',
    'Security Name': 'American Electric Power Company,   Corporate Unit',

    'NASDAQ symbol': 'AEPPL',
  },
  {
    symbol: 'AEPPZ',
    'Security Name': 'American Electric Power Company,   Corporate Unit',

    'NASDAQ symbol': 'AEPPZ',
  },
  {
    symbol: 'AER',
    'Security Name': 'AerCap Holdings NV Ordinary Shares',

    'CQS symbol': 'AER',
    'NASDAQ symbol': 'AER',
  },
  {
    symbol: 'AERI',
    'Security Name': 'Aerie Pharmaceuticals,   ',

    'NASDAQ symbol': 'AERI',
  },
  {
    symbol: 'AES',
    'Security Name': 'The AES Corporation ',

    'CQS symbol': 'AES',
    'NASDAQ symbol': 'AES',
  },
  {
    symbol: 'AESE',
    'Security Name': 'Allied Esports Entertainment,   ',

    'NASDAQ symbol': 'AESE',
  },
  {
    symbol: 'AESR',
    'Security Name': 'Anfield US Equity Sector Rotation ETF',

    'CQS symbol': 'AESR',
    'NASDAQ symbol': 'AESR',
  },
  {
    symbol: 'AEY',
    'Security Name': 'ADDvantage Technologies Group,   ',

    'NASDAQ symbol': 'AEY',
  },
  {
    symbol: 'AEYE',
    'Security Name': 'AudioEye,   ',

    'NASDAQ symbol': 'AEYE',
  },
  {
    symbol: 'AEZS',
    'Security Name': 'Aeterna Zentaris   ',

    'NASDAQ symbol': 'AEZS',
  },
  {
    symbol: 'AFB',
    'Security Name': 'AllianceBernstein National Municipal ome Fund ',

    'CQS symbol': 'AFB',
    'NASDAQ symbol': 'AFB',
  },
  {
    symbol: 'AFC',
    'Security Name':
      'Allied Capital Corporation Allied Capital Corporation 6875% Notes due April 15, 2047',

    'CQS symbol': 'AFC',
    'NASDAQ symbol': 'AFC',
  },
  {
    symbol: 'AFG',
    'Security Name': 'American Financial Group,  ',

    'CQS symbol': 'AFG',
    'NASDAQ symbol': 'AFG',
  },
  {
    symbol: 'AFGB',
    'Security Name':
      'American Financial Group,  5875% Subordinated Debentures due 2059',

    'CQS symbol': 'AFGB',
    'NASDAQ symbol': 'AFGB',
  },
  {
    symbol: 'AFGC',
    'Security Name':
      'American Financial Group,  5125% Subordinated Debentures due 2059',

    'CQS symbol': 'AFGC',
    'NASDAQ symbol': 'AFGC',
  },
  {
    symbol: 'AFGD',
    'Security Name':
      'American Financial Group,  5625% Subordinated Debentures due 2060',

    'CQS symbol': 'AFGD',
    'NASDAQ symbol': 'AFGD',
  },
  {
    symbol: 'AFGE',
    'Security Name':
      'American Financial Group,  4500% Subordinated Debentures due 2060',

    'CQS symbol': 'AFGE',
    'NASDAQ symbol': 'AFGE',
  },
  {
    symbol: 'AFI',
    'Security Name': 'Armstrong Flooring,  ',

    'CQS symbol': 'AFI',
    'NASDAQ symbol': 'AFI',
  },
  {
    symbol: 'AFIB',
    'Security Name': 'Acutus Medical,   ',

    'NASDAQ symbol': 'AFIB',
  },
  {
    symbol: 'AFIF',
    'Security Name': 'Anfield Universal Fixed ome ETF',

    'CQS symbol': 'AFIF',
    'NASDAQ symbol': 'AFIF',
  },
  {
    symbol: 'AFIN',
    'Security Name': 'American Finance Trust,    ',

    'NASDAQ symbol': 'AFIN',
  },
  {
    symbol: 'AFINP',
    'Security Name':
      'American Finance Trust,   750% Series A Cumulative Redeemable Perpetual Preferred Stock',

    'NASDAQ symbol': 'AFINP',
  },
  {
    symbol: 'AFK',
    'Security Name': 'VanEck VectorsAfrica Index ETF',

    'CQS symbol': 'AFK',
    'NASDAQ symbol': 'AFK',
  },
  {
    symbol: 'AFL',
    'Security Name': 'AFLAC orporated ',

    'CQS symbol': 'AFL',
    'NASDAQ symbol': 'AFL',
  },
  {
    symbol: 'AFLG',
    'Security Name': 'First Trust Active Factor Large Cap ETF',

    'CQS symbol': 'AFLG',
    'NASDAQ symbol': 'AFLG',
  },
  {
    symbol: 'AFMC',
    'Security Name': 'First Trust Active Factor Mid Cap ETF',

    'CQS symbol': 'AFMC',
    'NASDAQ symbol': 'AFMC',
  },
  {
    symbol: 'AFMD',
    'Security Name': 'Affimed NV  ',

    'NASDAQ symbol': 'AFMD',
  },
  {
    symbol: 'AFSM',
    'Security Name': 'First Trust Active Factor Small Cap ETF',

    'CQS symbol': 'AFSM',
    'NASDAQ symbol': 'AFSM',
  },
  {
    symbol: 'AFT',
    'Security Name': 'Apollo Senior Floating Rate Fund  ',

    'CQS symbol': 'AFT',
    'NASDAQ symbol': 'AFT',
  },
  {
    symbol: 'AFTY',
    'Security Name': 'Pacer CSOP FTSE China A50 ETF',

    'CQS symbol': 'AFTY',
    'NASDAQ symbol': 'AFTY',
  },
  {
    symbol: 'AFYA',
    'Security Name': 'Afya Limited   Common Shares',

    'NASDAQ symbol': 'AFYA',
  },
  {
    symbol: 'AG',
    'Security Name': 'First Majestic Silver Corp Ordinary Shares (Canada)',

    'CQS symbol': 'AG',
    'NASDAQ symbol': 'AG',
  },
  {
    symbol: 'AGBA',
    'Security Name': 'AGBA Acquisition Limited  Ordinary Share',

    'NASDAQ symbol': 'AGBA',
  },
  {
    symbol: 'AGBAR',
    'Security Name': 'AGBA Acquisition Limited  Right',

    'NASDAQ symbol': 'AGBAR',
  },
  {
    symbol: 'AGBAU',
    'Security Name': 'AGBA Acquisition Limited  Unit',

    'NASDAQ symbol': 'AGBAU',
  },
  {
    symbol: 'AGBAW',
    'Security Name': 'AGBA Acquisition Limited  Warrant',

    'NASDAQ symbol': 'AGBAW',
  },
  {
    symbol: 'AGC',
    'Security Name': 'Altimeter Growth Corp   Ordinary Shares',

    'NASDAQ symbol': 'AGC',
  },
  {
    symbol: 'AGCO',
    'Security Name': 'AGCO Corporation ',

    'CQS symbol': 'AGCO',
    'NASDAQ symbol': 'AGCO',
  },
  {
    symbol: 'AGCUU',
    'Security Name': 'Altimeter Growth Corp  Unit',

    'NASDAQ symbol': 'AGCUU',
  },
  {
    symbol: 'AGCWW',
    'Security Name': 'Altimeter Growth Corp  Warrant',

    'NASDAQ symbol': 'AGCWW',
  },
  {
    symbol: 'AGD',
    'Security Name': 'Aberdeen Global Dynamic Dividend Fund',

    'CQS symbol': 'AGD',
    'NASDAQ symbol': 'AGD',
  },
  {
    symbol: 'AGE',
    'Security Name': 'AgeX Therapeutics,  ',

    'CQS symbol': 'AGE',
    'NASDAQ symbol': 'AGE',
  },
  {
    symbol: 'AGEN',
    'Security Name': 'Agenus   ',

    'NASDAQ symbol': 'AGEN',
  },
  {
    symbol: 'AGFS',
    'Security Name': 'AgroFresh Solutions,   ',

    'NASDAQ symbol': 'AGFS',
  },
  {
    symbol: 'AGG',
    'Security Name': 'iShares Core US Aggregate Bond ETF',

    'CQS symbol': 'AGG',
    'NASDAQ symbol': 'AGG',
  },
  {
    symbol: 'AGGP',
    'Security Name': 'IQ Enhanced Core Plus Bond US ETF',

    'CQS symbol': 'AGGP',
    'NASDAQ symbol': 'AGGP',
  },
  {
    symbol: 'AGGY',
    'Security Name': 'WisdomTree Yield Enhanced US Aggregate Bond Fund',

    'CQS symbol': 'AGGY',
    'NASDAQ symbol': 'AGGY',
  },
  {
    symbol: 'AGI',
    'Security Name': 'Alamos Gold   Common Shares',

    'CQS symbol': 'AGI',
    'NASDAQ symbol': 'AGI',
  },
  {
    symbol: 'AGIO',
    'Security Name': 'Agios Pharmaceuticals,   ',

    'NASDAQ symbol': 'AGIO',
  },
  {
    symbol: 'AGLE',
    'Security Name': 'Aeglea BioTherapeutics,   ',

    'NASDAQ symbol': 'AGLE',
  },
  {
    symbol: 'AGM',
    'Security Name': 'Federal Agricultural Mortgage Corporation ',

    'CQS symbol': 'AGM',
    'NASDAQ symbol': 'AGM',
  },
  {
    symbol: 'AGM$C',
    'Security Name':
      'Federal Agricultural Mortgage Corporation Preferred Series C Fixed to Fltg',

    'CQS symbol': 'AGMpC',
    'NASDAQ symbol': 'AGMC',
  },
  {
    symbol: 'AGM$D',
    'Security Name':
      'Federal Agricultural Mortgage Corporation 5700% NonCumulative Preferred Stock, Series D',

    'CQS symbol': 'AGMpD',
    'NASDAQ symbol': 'AGMD',
  },
  {
    symbol: 'AGM$E',
    'Security Name':
      'Federal Agricultural Mortgage Corporation 5750% NonCumulative Preferred Stock, Series E',

    'CQS symbol': 'AGMpE',
    'NASDAQ symbol': 'AGME',
  },
  {
    symbol: 'AGM$F',
    'Security Name':
      'Federal Agricultural Mortgage Corporation 5250% NonCumulative Preferred Stock, Series F',

    'CQS symbol': 'AGMpF',
    'NASDAQ symbol': 'AGMF',
  },
  {
    symbol: 'AGMA',
    'Security Name': 'Federal Agricultural Mortgage Corporation ',

    'CQS symbol': 'AGMA',
    'NASDAQ symbol': 'AGMA',
  },
  {
    symbol: 'AGMH',
    'Security Name': 'AGM Group Holdings    Ordinary Shares',

    'NASDAQ symbol': 'AGMH',
  },
  {
    symbol: 'AGNC',
    'Security Name': 'AGNC Investment Corp  ',

    'NASDAQ symbol': 'AGNC',
  },
  {
    symbol: 'AGNCM',
    'Security Name':
      'AGNC Investment Corp  Depositary Shares rep 6875% Series D FixedtoFloating Cumulative Redeemable Preferred Stock',

    'NASDAQ symbol': 'AGNCM',
  },
  {
    symbol: 'AGNCN',
    'Security Name':
      'AGNC Investment Corp  Depositary Shares Each Representing a 1/1,000th Interest in a Share of 700% Series C FixedToFloating Rate Cumulative Redeemable Preferred Stock',

    'NASDAQ symbol': 'AGNCN',
  },
  {
    symbol: 'AGNCO',
    'Security Name':
      'AGNC Investment Corp  Depositary Shares, each representing a 1/1,000th interest in a share of Series E FixedtoFloating Cumulative Redeemable Preferred Stock',

    'NASDAQ symbol': 'AGNCO',
  },
  {
    symbol: 'AGNCP',
    'Security Name':
      'AGNC Investment Corp  Depositary Shares Each Representing a 1/1,000th Interest in a Share of 6125% Series F FixedtoFloating Rate Cumulative Redeemable Preferred Stock',

    'NASDAQ symbol': 'AGNCP',
  },
  {
    symbol: 'AGO',
    'Security Name': 'Assured Guaranty Ltd ',

    'CQS symbol': 'AGO',
    'NASDAQ symbol': 'AGO',
  },
  {
    symbol: 'AGO$B',
    'Security Name': 'Assured Guaranty Ltd',

    'CQS symbol': 'AGOpB',
    'NASDAQ symbol': 'AGOB',
  },
  {
    symbol: 'AGO$E',
    'Security Name': 'Assured Guaranty Ltd',

    'CQS symbol': 'AGOpE',
    'NASDAQ symbol': 'AGOE',
  },
  {
    symbol: 'AGO$F',
    'Security Name': 'Assured Guaranty Ltd',

    'CQS symbol': 'AGOpF',
    'NASDAQ symbol': 'AGOF',
  },
  {
    symbol: 'AGQ',
    'Security Name': 'ProShares Ultra Silver',

    'CQS symbol': 'AGQ',
    'NASDAQ symbol': 'AGQ',
  },
  {
    symbol: 'AGR',
    'Security Name': 'Avangrid,  ',

    'CQS symbol': 'AGR',
    'NASDAQ symbol': 'AGR',
  },
  {
    symbol: 'AGRO',
    'Security Name': 'Adecoagro SA Common Shares',

    'CQS symbol': 'AGRO',
    'NASDAQ symbol': 'AGRO',
  },
  {
    symbol: 'AGRX',
    'Security Name': 'Agile Therapeutics,   ',

    'NASDAQ symbol': 'AGRX',
  },
  {
    symbol: 'AGS',
    'Security Name': 'PlayAGS,  ',

    'CQS symbol': 'AGS',
    'NASDAQ symbol': 'AGS',
  },
  {
    symbol: 'AGT',
    'Security Name': 'iShares MSCI Argentina and Global Exposure ETF',

    'CQS symbol': 'AGT',
    'NASDAQ symbol': 'AGT',
  },
  {
    symbol: 'AGTC',
    'Security Name': 'Applied Genetic Technologies Corporation  ',

    'NASDAQ symbol': 'AGTC',
  },
  {
    symbol: 'AGX',
    'Security Name': 'Argan,  ',

    'CQS symbol': 'AGX',
    'NASDAQ symbol': 'AGX',
  },
  {
    symbol: 'AGYS',
    'Security Name': 'Agilysys,   ',

    'NASDAQ symbol': 'AGYS',
  },
  {
    symbol: 'AGZ',
    'Security Name': 'iShares  Agency Bond ETF',

    'CQS symbol': 'AGZ',
    'NASDAQ symbol': 'AGZ',
  },
  {
    symbol: 'AGZD',
    'Security Name': 'WisdomTree Interest Rate Hedged US Aggregate Bond Fund',

    'NASDAQ symbol': 'AGZD',
  },
  {
    symbol: 'AHAC',
    'Security Name': 'Alpha Healthcare Acquisition Corp  ',

    'NASDAQ symbol': 'AHAC',
  },
  {
    symbol: 'AHACU',
    'Security Name': 'Alpha Healthcare Acquisition Corp  Unit',

    'NASDAQ symbol': 'AHACU',
  },
  {
    symbol: 'AHACW',
    'Security Name': 'Alpha Healthcare Acquisition Corp  Warrant',

    'NASDAQ symbol': 'AHACW',
  },
  {
    symbol: 'AHC',
    'Security Name': 'AH Belo Corporation (TX) ',

    'CQS symbol': 'AHC',
    'NASDAQ symbol': 'AHC',
  },
  {
    symbol: 'AHCO',
    'Security Name': 'AdaptHealth Corp    ',

    'NASDAQ symbol': 'AHCO',
  },
  {
    symbol: 'AHH',
    'Security Name': 'Armada Hoffler Properties,  ',

    'CQS symbol': 'AHH',
    'NASDAQ symbol': 'AHH',
  },
  {
    symbol: 'AHH$A',
    'Security Name':
      'Armada Hoffler Properties,  675% Series A Cumulative Redeemable Perpetual Preferred Stock',

    'CQS symbol': 'AHHpA',
    'NASDAQ symbol': 'AHHA',
  },
  {
    symbol: 'AHL$C',
    'Security Name':
      'Aspen Insurance Holdings Limited 595% FixedtoFloating Rate Perpetual NonCumulative Preference Shares',

    'CQS symbol': 'AHLpC',
    'NASDAQ symbol': 'AHLC',
  },
  {
    symbol: 'AHL$D',
    'Security Name':
      'Aspen Insurance Holdings Limited 5625% Perpetual NonCumulative Preference Shares',

    'CQS symbol': 'AHLpD',
    'NASDAQ symbol': 'AHLD',
  },
  {
    symbol: 'AHL$E',
    'Security Name':
      'Aspen Insurance Holdings Limited Depositary Shares, each representing a 1/1000th interest in a share of 5625% Perpetual NonCumulative Preference Shares',

    'CQS symbol': 'AHLpE',
    'NASDAQ symbol': 'AHLE',
  },
  {
    symbol: 'AHPI',
    'Security Name': 'Allied Healthcare Products,   ',

    'NASDAQ symbol': 'AHPI',
  },
  {
    symbol: 'AHT',
    'Security Name': 'Ashford Hospitality Trust  ',

    'CQS symbol': 'AHT',
    'NASDAQ symbol': 'AHT',
  },
  {
    symbol: 'AHT$D',
    'Security Name':
      'Ashford Hospitality Trust  845% Series D Cumulative Preferred Stock',

    'CQS symbol': 'AHTpD',
    'NASDAQ symbol': 'AHTD',
  },
  {
    symbol: 'AHT$F',
    'Security Name':
      'Ashford Hospitality Trust  7375% Series F Cumulative Preferred Stock',

    'CQS symbol': 'AHTpF',
    'NASDAQ symbol': 'AHTF',
  },
  {
    symbol: 'AHT$G',
    'Security Name':
      'Ashford Hospitality Trust  7375% Series G Cumulative Preferred Stock',

    'CQS symbol': 'AHTpG',
    'NASDAQ symbol': 'AHTG',
  },
  {
    symbol: 'AHT$H',
    'Security Name':
      'Ashford Hospitality Trust  750% Series H Cumulative Preferred Stock',

    'CQS symbol': 'AHTpH',
    'NASDAQ symbol': 'AHTH',
  },
  {
    symbol: 'AHT$I',
    'Security Name':
      'Ashford Hospitality Trust  750% Series I Cumulative Preferred Stock',

    'CQS symbol': 'AHTpI',
    'NASDAQ symbol': 'AHTI',
  },
  {
    symbol: 'AIA',
    'Security Name': 'iShares Asia 50 ETF',

    'NASDAQ symbol': 'AIA',
  },
  {
    symbol: 'AIC',
    'Security Name': 'Arlington Asset Investment Corp 6750% Notes due 2025',

    'CQS symbol': 'AIC',
    'NASDAQ symbol': 'AIC',
  },
  {
    symbol: 'AIEQ',
    'Security Name': 'AI Powered Equity ETF',

    'CQS symbol': 'AIEQ',
    'NASDAQ symbol': 'AIEQ',
  },
  {
    symbol: 'AIF',
    'Security Name': 'Apollo Tactical ome Fund  ',

    'CQS symbol': 'AIF',
    'NASDAQ symbol': 'AIF',
  },
  {
    symbol: 'AIG',
    'Security Name': 'American International Group,  New ',

    'CQS symbol': 'AIG',
    'NASDAQ symbol': 'AIG',
  },
  {
    symbol: 'AIG$A',
    'Security Name': 'American International Group,  ',

    'CQS symbol': 'AIGpA',
    'NASDAQ symbol': 'AIGA',
  },
  {
    symbol: 'AIGW',
    'Security Name':
      'American International Group,  Warrant expiring January 19, 2021',

    'CQS symbol': 'AIGWS',
    'NASDAQ symbol': 'AIG+',
  },
  {
    symbol: 'AIH',
    'Security Name':
      'Aesthetic Medical International Holdings Group Ltd  American Depositary Shares',

    'NASDAQ symbol': 'AIH',
  },
  {
    symbol: 'AIHS',
    'Security Name': 'Senmiao Technology Limited  ',

    'NASDAQ symbol': 'AIHS',
  },
  {
    symbol: 'AIIQ',
    'Security Name': 'AI Powered International Equity ETF',

    'CQS symbol': 'AIIQ',
    'NASDAQ symbol': 'AIIQ',
  },
  {
    symbol: 'AIKI',
    'Security Name': 'AIkido Pharma   ',

    'NASDAQ symbol': 'AIKI',
  },
  {
    symbol: 'AIM',
    'Security Name': 'AIM ImmunoTech  ',

    'CQS symbol': 'AIM',
    'NASDAQ symbol': 'AIM',
  },
  {
    symbol: 'AIMC',
    'Security Name': 'Altra Industrial Motion Corp  ',

    'NASDAQ symbol': 'AIMC',
  },
  {
    symbol: 'AIN',
    'Security Name': 'Albany International Corporation ',

    'CQS symbol': 'AIN',
    'NASDAQ symbol': 'AIN',
  },
  {
    symbol: 'A',
    'Security Name': 'Ashford  (Holding Company) ',

    'CQS symbol': 'A',
    'NASDAQ symbol': 'A',
  },
  {
    symbol: 'AINV',
    'Security Name': 'Apollo Investment Corporation  Closed End Fund',

    'NASDAQ symbol': 'AINV',
  },
  {
    symbol: 'AIO',
    'Security Name':
      'AllianzGI Artificial Intelligence & Technology Opportunities Fund Common Shares',

    'CQS symbol': 'AIO',
    'NASDAQ symbol': 'AIO',
  },
  {
    symbol: 'AIQ',
    'Security Name': 'Global X Artificial Intelligence & Technology ETF',

    'NASDAQ symbol': 'AIQ',
  },
  {
    symbol: 'AIR',
    'Security Name': 'AAR Corp ',

    'CQS symbol': 'AIR',
    'NASDAQ symbol': 'AIR',
  },
  {
    symbol: 'AIRCV',
    'Security Name': 'Apartment ome REIT Corp  When Issued',

    'CQS symbol': 'AIRCw',
    'NASDAQ symbol': 'AIRC#',
  },
  {
    symbol: 'AIRG',
    'Security Name': 'Airgain,   ',

    'NASDAQ symbol': 'AIRG',
  },
  {
    symbol: 'AIRI',
    'Security Name': 'Air Industries Group ',

    'CQS symbol': 'AIRI',
    'NASDAQ symbol': 'AIRI',
  },
  {
    symbol: 'AIRR',
    'Security Name': 'First Trust RBA American Industrial Renaissance ETF',

    'NASDAQ symbol': 'AIRR',
  },
  {
    symbol: 'AIRT',
    'Security Name': 'Air T,   ',

    'NASDAQ symbol': 'AIRT',
  },
  {
    symbol: 'AIRTP',
    'Security Name': 'Air T,   Trust Preferred Securities',

    'NASDAQ symbol': 'AIRTP',
  },
  {
    symbol: 'AIRTW',
    'Security Name':
      'Air T,   Air T Funding Warrants to Purchase Trust Preferred',

    'NASDAQ symbol': 'AIRTW',
  },
  {
    symbol: 'AIT',
    'Security Name': 'Applied Industrial Technologies,  ',

    'CQS symbol': 'AIT',
    'NASDAQ symbol': 'AIT',
  },
  {
    symbol: 'AIV',
    'Security Name': 'Apartment Investment and Management Company ',

    'CQS symbol': 'AIV',
    'NASDAQ symbol': 'AIV',
  },
  {
    symbol: 'AIVV',
    'Security Name':
      'Apartment Investment and Management Company   ExDistribution When Issued',

    'CQS symbol': 'AIVw',
    'NASDAQ symbol': 'AIV#',
  },
  {
    symbol: 'AIW',
    'Security Name': 'Arlington Asset Investment Corp 6625% Notes due 2023',

    'CQS symbol': 'AIW',
    'NASDAQ symbol': 'AIW',
  },
  {
    symbol: 'AIZ',
    'Security Name': 'Assurant,  ',

    'CQS symbol': 'AIZ',
    'NASDAQ symbol': 'AIZ',
  },
  {
    symbol: 'AIZN',
    'Security Name': 'Assurant,  525% Subordinated Notes due 2061',

    'CQS symbol': 'AIZN',
    'NASDAQ symbol': 'AIZN',
  },
  {
    symbol: 'AIZP',
    'Security Name':
      'Assurant,  650% Series D Mandatory Convertible Preferred Stock, $100 par value',

    'CQS symbol': 'AIZP',
    'NASDAQ symbol': 'AIZP',
  },
  {
    symbol: 'AJAXU',
    'Security Name':
      'Ajax I Units, each consisting of one  ordinary share and onefourth of one redeemable warrant',

    'CQS symbol': 'AJAXU',
    'NASDAQ symbol': 'AJAX=',
  },
  {
    symbol: 'AJG',
    'Security Name': 'Arthur J Gallagher & Co ',

    'CQS symbol': 'AJG',
    'NASDAQ symbol': 'AJG',
  },
  {
    symbol: 'AJRD',
    'Security Name': 'Aerojet Rocketdyne Holdings,  ',

    'CQS symbol': 'AJRD',
    'NASDAQ symbol': 'AJRD',
  },
  {
    symbol: 'AJX',
    'Security Name': 'Great Ajax Corp ',

    'CQS symbol': 'AJX',
    'NASDAQ symbol': 'AJX',
  },
  {
    symbol: 'AJXA',
    'Security Name': 'Great Ajax Corp 725% Convertible Senior Notes due 2024',

    'CQS symbol': 'AJXA',
    'NASDAQ symbol': 'AJXA',
  },
  {
    symbol: 'AKAM',
    'Security Name': 'Akamai Technologies,   ',

    'NASDAQ symbol': 'AKAM',
  },
  {
    symbol: 'AKBA',
    'Security Name': 'Akebia Therapeutics,   ',

    'NASDAQ symbol': 'AKBA',
  },
  {
    symbol: 'AKER',
    'Security Name': 'Akers Biosciences   ',

    'NASDAQ symbol': 'AKER',
  },
  {
    symbol: 'AKOA',
    'Security Name': 'Embotelladora Andina SA ',

    'CQS symbol': 'AKOA',
    'NASDAQ symbol': 'AKOA',
  },
  {
    symbol: 'AKOB',
    'Security Name': 'Embotelladora Andina SA ',

    'CQS symbol': 'AKOB',
    'NASDAQ symbol': 'AKOB',
  },
  {
    symbol: 'AKR',
    'Security Name': 'Acadia Realty Trust ',

    'CQS symbol': 'AKR',
    'NASDAQ symbol': 'AKR',
  },
  {
    symbol: 'AKRO',
    'Security Name': 'Akero Therapeutics,   ',

    'NASDAQ symbol': 'AKRO',
  },
  {
    symbol: 'AKTS',
    'Security Name': 'Akoustis Technologies,   ',

    'NASDAQ symbol': 'AKTS',
  },
  {
    symbol: 'AKTX',
    'Security Name': 'Akari Therapeutics Plc  American Depositary Shares',

    'NASDAQ symbol': 'AKTX',
  },
  {
    symbol: 'AKU',
    'Security Name': 'Akumin   Common Shares',

    'NASDAQ symbol': 'AKU',
  },
  {
    symbol: 'AKUS',
    'Security Name': 'Akouos,   ',

    'NASDAQ symbol': 'AKUS',
  },
  {
    symbol: 'AL',
    'Security Name': 'Air Lease Corporation  ',

    'CQS symbol': 'AL',
    'NASDAQ symbol': 'AL',
  },
  {
    symbol: 'AL$A',
    'Security Name':
      'Air Lease Corporation 6150% FixedtoFloating Rate NonCumulative Perpetual Preferred Stock, Series A',

    'CQS symbol': 'ALpA',
    'NASDAQ symbol': 'ALA',
  },
  {
    symbol: 'ALAC',
    'Security Name': 'Alberton Acquisition Corporation  Ordinary Shares',

    'NASDAQ symbol': 'ALAC',
  },
  {
    symbol: 'ALACR',
    'Security Name': 'Alberton Acquisition Corporation  Rights',

    'NASDAQ symbol': 'ALACR',
  },
  {
    symbol: 'ALACU',
    'Security Name': 'Alberton Acquisition Corporation  Unit',

    'NASDAQ symbol': 'ALACU',
  },
  {
    symbol: 'ALACW',
    'Security Name': 'Alberton Acquisition Corporation  Warrant',

    'NASDAQ symbol': 'ALACW',
  },
  {
    symbol: 'ALB',
    'Security Name': 'Albemarle Corporation ',

    'CQS symbol': 'ALB',
    'NASDAQ symbol': 'ALB',
  },
  {
    symbol: 'ALBO',
    'Security Name': 'Albireo Pharma,   ',

    'NASDAQ symbol': 'ALBO',
  },
  {
    symbol: 'ALC',
    'Security Name': 'Alcon  Ordinary Shares',

    'CQS symbol': 'ALC',
    'NASDAQ symbol': 'ALC',
  },
  {
    symbol: 'ALCO',
    'Security Name': 'Alico,   ',

    'NASDAQ symbol': 'ALCO',
  },
  {
    symbol: 'ALDX',
    'Security Name': 'Aldeyra Therapeutics,   ',

    'NASDAQ symbol': 'ALDX',
  },
  {
    symbol: 'ALE',
    'Security Name': 'Allete, ',

    'CQS symbol': 'ALE',
    'NASDAQ symbol': 'ALE',
  },
  {
    symbol: 'ALEC',
    'Security Name': 'Alector,   ',

    'NASDAQ symbol': 'ALEC',
  },
  {
    symbol: 'ALEX',
    'Security Name': 'Alexander & Baldwin,   REIT Holding Company',

    'CQS symbol': 'ALEX',
    'NASDAQ symbol': 'ALEX',
  },
  {
    symbol: 'ALFA',
    'Security Name': 'AlphaClone Alternative Alpha ETF',

    'CQS symbol': 'ALFA',
    'NASDAQ symbol': 'ALFA',
  },
  {
    symbol: 'ALG',
    'Security Name': 'Alamo Group,  ',

    'CQS symbol': 'ALG',
    'NASDAQ symbol': 'ALG',
  },
  {
    symbol: 'ALGM',
    'Security Name': 'Allegro MicroSystems,   ',

    'NASDAQ symbol': 'ALGM',
  },
  {
    symbol: 'ALGN',
    'Security Name': 'Align Technology,   ',

    'NASDAQ symbol': 'ALGN',
  },
  {
    symbol: 'ALGS',
    'Security Name': 'Aligos Therapeutics,   ',

    'NASDAQ symbol': 'ALGS',
  },
  {
    symbol: 'ALGT',
    'Security Name': 'Allegiant Travel Company  ',

    'NASDAQ symbol': 'ALGT',
  },
  {
    symbol: 'ALIM',
    'Security Name': 'Alimera Sciences,   ',

    'NASDAQ symbol': 'ALIM',
  },
  {
    symbol: 'ALIN$A',
    'Security Name': 'Altera Infrastructure LP 725% Series A ',

    'CQS symbol': 'ALINpA',
    'NASDAQ symbol': 'ALINA',
  },
  {
    symbol: 'ALIN$B',
    'Security Name': 'Altera Infrastructure LP 850% Series B ',

    'CQS symbol': 'ALINpB',
    'NASDAQ symbol': 'ALINB',
  },
  {
    symbol: 'ALIN$E',
    'Security Name': 'Altera Infrastructure LP 8875% Series E ',

    'CQS symbol': 'ALINpE',
    'NASDAQ symbol': 'ALINE',
  },
  {
    symbol: 'ALJJ',
    'Security Name': 'ALJ Regional Holdings,   ',

    'NASDAQ symbol': 'ALJJ',
  },
  {
    symbol: 'ALK',
    'Security Name': 'Alaska Air Group,  ',

    'CQS symbol': 'ALK',
    'NASDAQ symbol': 'ALK',
  },
  {
    symbol: 'ALKS',
    'Security Name': 'Alkermes plc  Ordinary Shares',

    'NASDAQ symbol': 'ALKS',
  },
  {
    symbol: 'ALL',
    'Security Name': 'Allstate Corporation (The) ',

    'CQS symbol': 'ALL',
    'NASDAQ symbol': 'ALL',
  },
  {
    symbol: 'ALL$B',
    'Security Name':
      'Allstate Corporation (The) 5100% FixedtoFloating Rate Subordinated Debentures due 2053',

    'CQS symbol': 'ALLpB',
    'NASDAQ symbol': 'ALLB',
  },
  {
    symbol: 'ALL$G',
    'Security Name':
      'Allstate Corporation (The) Depositary Shares each representing a 1/1,000th interest in a share of Fixed Rate Noncumulative Perpetual Preferred Stock, Series G',

    'CQS symbol': 'ALLpG',
    'NASDAQ symbol': 'ALLG',
  },
  {
    symbol: 'ALL$H',
    'Security Name':
      'Allstate Corporation (The) Depositary Shares each representing a 1/1,000th interest in a share of Fixed Rate Noncumulative Perpetual Preferred Stock, Series H',

    'CQS symbol': 'ALLpH',
    'NASDAQ symbol': 'ALLH',
  },
  {
    symbol: 'ALL$I',
    'Security Name':
      'Allstate Corporation (The) Depositary Shares each representing a 1/1,000th interest in a share of Fixed Rate Noncumulative Perpetual Preferred Stock, Series I',

    'CQS symbol': 'ALLpI',
    'NASDAQ symbol': 'ALLI',
  },
  {
    symbol: 'ALLE',
    'Security Name': 'Allegion plc Ordinary Shares',

    'CQS symbol': 'ALLE',
    'NASDAQ symbol': 'ALLE',
  },
  {
    symbol: 'ALLK',
    'Security Name': 'Allakos   ',

    'NASDAQ symbol': 'ALLK',
  },
  {
    symbol: 'ALLO',
    'Security Name': 'Allogene Therapeutics,   ',

    'NASDAQ symbol': 'ALLO',
  },
  {
    symbol: 'ALLT',
    'Security Name': 'Allot Ltd  Ordinary Shares',

    'NASDAQ symbol': 'ALLT',
  },
  {
    symbol: 'ALLY',
    'Security Name': 'Ally Financial  ',

    'CQS symbol': 'ALLY',
    'NASDAQ symbol': 'ALLY',
  },
  {
    symbol: 'ALLY$A',
    'Security Name':
      'GMAC Capital Trust I Fixed Rate Floating Rate Trust Preferred Securities, Series 2',

    'CQS symbol': 'ALLYpA',
    'NASDAQ symbol': 'ALLYA',
  },
  {
    symbol: 'ALNA',
    'Security Name': 'Allena Pharmaceuticals,   ',

    'NASDAQ symbol': 'ALNA',
  },
  {
    symbol: 'ALNY',
    'Security Name': 'Alnylam Pharmaceuticals,   ',

    'NASDAQ symbol': 'ALNY',
  },
  {
    symbol: 'ALOT',
    'Security Name': 'AstroNova,   ',

    'NASDAQ symbol': 'ALOT',
  },
  {
    symbol: 'ALP$Q',
    'Security Name':
      'Alabama Power Company 500%  Preferred Stock, Cumulative, Par Value $1 Per Share (Stated Capital $25 Per Share)',

    'CQS symbol': 'ALPpQ',
    'NASDAQ symbol': 'ALPQ',
  },
  {
    symbol: 'ALPN',
    'Security Name': 'Alpine Immune Sciences,   ',

    'NASDAQ symbol': 'ALPN',
  },
  {
    symbol: 'ALRM',
    'Security Name': 'Alarmcom Holdings,   ',

    'NASDAQ symbol': 'ALRM',
  },
  {
    symbol: 'ALRN',
    'Security Name': 'Aileron Therapeutics,   ',

    'NASDAQ symbol': 'ALRN',
  },
  {
    symbol: 'ALRS',
    'Security Name': 'Alerus Financial Corporation  ',

    'NASDAQ symbol': 'ALRS',
  },
  {
    symbol: 'ALSK',
    'Security Name': 'Alaska Communications Systems Group,   ',

    'NASDAQ symbol': 'ALSK',
  },
  {
    symbol: 'ALSN',
    'Security Name': 'Allison Transmission Holdings,  ',

    'CQS symbol': 'ALSN',
    'NASDAQ symbol': 'ALSN',
  },
  {
    symbol: 'ALT',
    'Security Name': 'Altimmune,   ',

    'NASDAQ symbol': 'ALT',
  },
  {
    symbol: 'ALTA',
    'Security Name': 'Altabancorp  ',

    'NASDAQ symbol': 'ALTA',
  },
  {
    symbol: 'ALTG',
    'Security Name': 'Alta Equipment Group   ',

    'CQS symbol': 'ALTG',
    'NASDAQ symbol': 'ALTG',
  },
  {
    symbol: 'ALTGW',
    'Security Name': 'Alta Equipment Group  Warrants',

    'CQS symbol': 'ALTGWS',
    'NASDAQ symbol': 'ALTG+',
  },
  {
    symbol: 'ALTL',
    'Security Name': 'Pacer Lunt Large Cap Alternator ETF',

    'CQS symbol': 'ALTL',
    'NASDAQ symbol': 'ALTL',
  },
  {
    symbol: 'ALTM',
    'Security Name': 'Altus Midstream Company   ',

    'NASDAQ symbol': 'ALTM',
  },
  {
    symbol: 'ALTR',
    'Security Name': 'Altair Engineering    ',

    'NASDAQ symbol': 'ALTR',
  },
  {
    symbol: 'ALTS',
    'Security Name': 'ProShares Morningstar Alternatives Solution ETF',

    'CQS symbol': 'ALTS',
    'NASDAQ symbol': 'ALTS',
  },
  {
    symbol: 'ALTY',
    'Security Name': 'Global X SuperDividend Alternatives ETF',

    'NASDAQ symbol': 'ALTY',
  },
  {
    symbol: 'ALUS',
    'Security Name': 'Alussa Energy Acquisition Corp  Ordinary Shares',

    'CQS symbol': 'ALUS',
    'NASDAQ symbol': 'ALUS',
  },
  {
    symbol: 'ALUSU',
    'Security Name':
      'Alussa Energy Acquisition Corp Units, each consisting of one  Ordinary Share, and onehalf of one redeemable warrant',

    'CQS symbol': 'ALUSU',
    'NASDAQ symbol': 'ALUS=',
  },
  {
    symbol: 'ALUSW',
    'Security Name':
      'Alussa Energy Acquisition Corp Redeemable Warrants, each whole warrant exercisable for one Ordinary Share at an exercise price of $1150',

    'CQS symbol': 'ALUSWS',
    'NASDAQ symbol': 'ALUS+',
  },
  {
    symbol: 'ALV',
    'Security Name': 'Autoliv,  ',

    'CQS symbol': 'ALV',
    'NASDAQ symbol': 'ALV',
  },
  {
    symbol: 'ALVR',
    'Security Name': 'AlloVir,   ',

    'NASDAQ symbol': 'ALVR',
  },
  {
    symbol: 'ALX',
    'Security Name': "Alexander's,  ",

    'CQS symbol': 'ALX',
    'NASDAQ symbol': 'ALX',
  },
  {
    symbol: 'ALXN',
    'Security Name': 'Alexion Pharmaceuticals,   ',

    'NASDAQ symbol': 'ALXN',
  },
  {
    symbol: 'ALXO',
    'Security Name': 'ALX Oncology Holdings   ',

    'NASDAQ symbol': 'ALXO',
  },
  {
    symbol: 'ALYA',
    'Security Name': 'Alithya Group    subordinate voting shares',

    'NASDAQ symbol': 'ALYA',
  },
  {
    symbol: 'AM',
    'Security Name': 'Antero Midstream Corporation ',

    'CQS symbol': 'AM',
    'NASDAQ symbol': 'AM',
  },
  {
    symbol: 'AMAL',
    'Security Name': 'Amalgamated Bank   ',

    'NASDAQ symbol': 'AMAL',
  },
  {
    symbol: 'AMAT',
    'Security Name': 'Applied Materials,   ',

    'NASDAQ symbol': 'AMAT',
  },
  {
    symbol: 'AMBA',
    'Security Name': 'Ambarella,   Ordinary Shares',

    'NASDAQ symbol': 'AMBA',
  },
  {
    symbol: 'AMBC',
    'Security Name': 'Ambac Financial Group,  ',

    'CQS symbol': 'AMBC',
    'NASDAQ symbol': 'AMBC',
  },
  {
    symbol: 'AMBCW',
    'Security Name': 'Ambac Financial Group,  Warrants',

    'CQS symbol': 'AMBCWS',
    'NASDAQ symbol': 'AMBC+',
  },
  {
    symbol: 'AMBO',
    'Security Name':
      'Ambow Education Holding Ltd American , each representing two  ordinary shares',

    'CQS symbol': 'AMBO',
    'NASDAQ symbol': 'AMBO',
  },
  {
    symbol: 'AMC',
    'Security Name': 'AMC Entertainment Holdings,   ',

    'CQS symbol': 'AMC',
    'NASDAQ symbol': 'AMC',
  },
  {
    symbol: 'AMCA',
    'Security Name': 'iShares Russell 1000 Pure US Revenue ETF',

    'NASDAQ symbol': 'AMCA',
  },
  {
    symbol: 'AMCI',
    'Security Name': 'AMCI Acquisition Corp   ',

    'NASDAQ symbol': 'AMCI',
  },
  {
    symbol: 'AMCIU',
    'Security Name': 'AMCI Acquisition Corp  Unit',

    'NASDAQ symbol': 'AMCIU',
  },
  {
    symbol: 'AMCIW',
    'Security Name': 'AMCI Acquisition Corp  Warrant',

    'NASDAQ symbol': 'AMCIW',
  },
  {
    symbol: 'AMCR',
    'Security Name': 'Amcor plc Ordinary Shares',

    'CQS symbol': 'AMCR',
    'NASDAQ symbol': 'AMCR',
  },
  {
    symbol: 'AMCX',
    'Security Name': 'AMC Networks    ',

    'NASDAQ symbol': 'AMCX',
  },
  {
    symbol: 'AMD',
    'Security Name': 'Advanced Micro Devices,   ',

    'NASDAQ symbol': 'AMD',
  },
  {
    symbol: 'AME',
    'Security Name': 'AMETEK, ',

    'CQS symbol': 'AME',
    'NASDAQ symbol': 'AME',
  },
  {
    symbol: 'AMED',
    'Security Name': 'Amedisys   ',

    'NASDAQ symbol': 'AMED',
  },
  {
    symbol: 'AMEH',
    'Security Name': 'Apollo Medical Holdings,   ',

    'NASDAQ symbol': 'AMEH',
  },
  {
    symbol: 'AMER',
    'Security Name': 'Emles Made in America ETF',

    'CQS symbol': 'AMER',
    'NASDAQ symbol': 'AMER',
  },
  {
    symbol: 'AMG',
    'Security Name': 'Affiliated Managers Group,  ',

    'CQS symbol': 'AMG',
    'NASDAQ symbol': 'AMG',
  },
  {
    symbol: 'AMGN',
    'Security Name': 'Amgen   ',

    'NASDAQ symbol': 'AMGN',
  },
  {
    symbol: 'AMH',
    'Security Name':
      'American Homes 4 Rent Common Shares of Beneficial Interest',

    'CQS symbol': 'AMH',
    'NASDAQ symbol': 'AMH',
  },
  {
    symbol: 'AMH$D',
    'Security Name':
      'American Homes 4 Rent 65% Series D Cumulative Perpetual Preferred Shares of Beneficial Interest',

    'CQS symbol': 'AMHpD',
    'NASDAQ symbol': 'AMHD',
  },
  {
    symbol: 'AMH$E',
    'Security Name':
      'American Homes 4 Rent 635% Series E Cumulative Redeemable Perpetual Preferred Shares of Beneficial Interest',

    'CQS symbol': 'AMHpE',
    'NASDAQ symbol': 'AMHE',
  },
  {
    symbol: 'AMH$F',
    'Security Name':
      'American Homes 4 Rent 5875% Series F Cumulative Redeemable Perpetual Preferred Shares',

    'CQS symbol': 'AMHpF',
    'NASDAQ symbol': 'AMHF',
  },
  {
    symbol: 'AMH$G',
    'Security Name':
      'American Homes 4 Rent Series G cumulative redeemable perpetual preferred shares of beneficial interest',

    'CQS symbol': 'AMHpG',
    'NASDAQ symbol': 'AMHG',
  },
  {
    symbol: 'AMH$H',
    'Security Name':
      'American Homes 4 Rent Series H cumulative redeemable perpetual Preferred Shares of Beneficial Interest',

    'CQS symbol': 'AMHpH',
    'NASDAQ symbol': 'AMHH',
  },
  {
    symbol: 'AMHC',
    'Security Name': 'Amplitude Healthcare Acquisition Corporation   ',

    'NASDAQ symbol': 'AMHC',
  },
  {
    symbol: 'AMHCU',
    'Security Name': 'Amplitude Healthcare Acquisition Corporation  Unit',

    'NASDAQ symbol': 'AMHCU',
  },
  {
    symbol: 'AMHCW',
    'Security Name': 'Amplitude Healthcare Acquisition Corporation  Warrant',

    'NASDAQ symbol': 'AMHCW',
  },
  {
    symbol: 'AMJ',
    'Security Name': 'JPMorgan Chase Capital XVI JP Morgan Alerian MLP ETN',

    'CQS symbol': 'AMJ',
    'NASDAQ symbol': 'AMJ',
  },
  {
    symbol: 'AMK',
    'Security Name': 'AssetMark Financial Holdings,  ',

    'CQS symbol': 'AMK',
    'NASDAQ symbol': 'AMK',
  },
  {
    symbol: 'AMKR',
    'Security Name': 'Amkor Technology,   ',

    'NASDAQ symbol': 'AMKR',
  },
  {
    symbol: 'AMLP',
    'Security Name': 'Alerian MLP ETF',

    'CQS symbol': 'AMLP',
    'NASDAQ symbol': 'AMLP',
  },
  {
    symbol: 'AMN',
    'Security Name': 'AMN Healthcare Services  AMN Healthcare Services ',

    'CQS symbol': 'AMN',
    'NASDAQ symbol': 'AMN',
  },
  {
    symbol: 'AMNA',
    'Security Name': 'ETRACS Alerian Midstream Energy Index ETN',

    'CQS symbol': 'AMNA',
    'NASDAQ symbol': 'AMNA',
  },
  {
    symbol: 'AMNB',
    'Security Name': 'American National Bankshares,   ',

    'NASDAQ symbol': 'AMNB',
  },
  {
    symbol: 'AMND',
    'Security Name':
      'UBS AG ETRACS Alerian Midstream Energy High Dividend Index ETN',

    'CQS symbol': 'AMND',
    'NASDAQ symbol': 'AMND',
  },
  {
    symbol: 'AMOM',
    'Security Name': 'QRAFT AIEnhanced US Large Cap Momentum ETF',

    'CQS symbol': 'AMOM',
    'NASDAQ symbol': 'AMOM',
  },
  {
    symbol: 'AMOT',
    'Security Name': 'Allied Motion Technologies,   ',

    'NASDAQ symbol': 'AMOT',
  },
  {
    symbol: 'AMOV',
    'Security Name': 'America Movil, SAB de CV  American Depositary Shares',

    'CQS symbol': 'AMOV',
    'NASDAQ symbol': 'AMOV',
  },
  {
    symbol: 'AMP',
    'Security Name': 'Ameriprise Financial,  ',

    'CQS symbol': 'AMP',
    'NASDAQ symbol': 'AMP',
  },
  {
    symbol: 'AMPE',
    'Security Name': 'Ampio Pharmaceuticals, ',

    'CQS symbol': 'AMPE',
    'NASDAQ symbol': 'AMPE',
  },
  {
    symbol: 'AMPH',
    'Security Name': 'Amphastar Pharmaceuticals,   ',

    'NASDAQ symbol': 'AMPH',
  },
  {
    symbol: 'AMPY',
    'Security Name': 'Amplify Energy Corp ',

    'CQS symbol': 'AMPY',
    'NASDAQ symbol': 'AMPY',
  },
  {
    symbol: 'AMRB',
    'Security Name': 'American River Bankshares  ',

    'NASDAQ symbol': 'AMRB',
  },
  {
    symbol: 'AMRC',
    'Security Name': 'Ameresco,   ',

    'CQS symbol': 'AMRC',
    'NASDAQ symbol': 'AMRC',
  },
  {
    symbol: 'AMRH',
    'Security Name': 'Ameri Holdings,   ',

    'NASDAQ symbol': 'AMRH',
  },
  {
    symbol: 'AMRHW',
    'Security Name': 'Ameri Holdings,   Warrant',

    'NASDAQ symbol': 'AMRHW',
  },
  {
    symbol: 'AMRK',
    'Security Name': 'AMark Precious Metals,   ',

    'NASDAQ symbol': 'AMRK',
  },
  {
    symbol: 'AMRN',
    'Security Name':
      'Amarin Corporation plc  American Depositary Shares, each representing one Ordinary Share',

    'NASDAQ symbol': 'AMRN',
  },
  {
    symbol: 'AMRS',
    'Security Name': 'Amyris,   ',

    'NASDAQ symbol': 'AMRS',
  },
  {
    symbol: 'AMRX',
    'Security Name': 'Amneal Pharmaceuticals,   ',

    'CQS symbol': 'AMRX',
    'NASDAQ symbol': 'AMRX',
  },
  {
    symbol: 'AMS',
    'Security Name': 'American Shared Hospital Services ',

    'CQS symbol': 'AMS',
    'NASDAQ symbol': 'AMS',
  },
  {
    symbol: 'AMSC',
    'Security Name': 'American Superconductor Corporation  ',

    'NASDAQ symbol': 'AMSC',
  },
  {
    symbol: 'AMSF',
    'Security Name': 'AMERISAFE,   ',

    'NASDAQ symbol': 'AMSF',
  },
  {
    symbol: 'AMST',
    'Security Name': 'Amesite   ',

    'NASDAQ symbol': 'AMST',
  },
  {
    symbol: 'AMSWA',
    'Security Name': 'American Software,    ',

    'NASDAQ symbol': 'AMSWA',
  },
  {
    symbol: 'AMT',
    'Security Name': 'American Tower Corporation (REIT) ',

    'CQS symbol': 'AMT',
    'NASDAQ symbol': 'AMT',
  },
  {
    symbol: 'AMTB',
    'Security Name': 'Amerant Bancorp    ',

    'NASDAQ symbol': 'AMTB',
  },
  {
    symbol: 'AMTBB',
    'Security Name': 'Amerant Bancorp   Class B ',

    'NASDAQ symbol': 'AMTBB',
  },
  {
    symbol: 'AMTI',
    'Security Name': 'Applied Molecular Transport   ',

    'NASDAQ symbol': 'AMTI',
  },
  {
    symbol: 'AMTR',
    'Security Name': 'ETRACS Alerian Midstream Energy Total Return Index ETN',

    'CQS symbol': 'AMTR',
    'NASDAQ symbol': 'AMTR',
  },
  {
    symbol: 'AMTX',
    'Security Name': 'Aemetis,   ',

    'NASDAQ symbol': 'AMTX',
  },
  {
    symbol: 'AMUB',
    'Security Name': 'ETRACS Alerian MLP Index ETN Series B due July 18, 2042',

    'CQS symbol': 'AMUB',
    'NASDAQ symbol': 'AMUB',
  },
  {
    symbol: 'AMWD',
    'Security Name': 'American Woodmark Corporation  ',

    'NASDAQ symbol': 'AMWD',
  },
  {
    symbol: 'AMWL',
    'Security Name': 'American Well Corporation  ',

    'CQS symbol': 'AMWL',
    'NASDAQ symbol': 'AMWL',
  },
  {
    symbol: 'AMX',
    'Security Name':
      'America Movil, SAB de CV American Depository Receipt Series L',

    'CQS symbol': 'AMX',
    'NASDAQ symbol': 'AMX',
  },
  {
    symbol: 'AMYT',
    'Security Name': 'Amryt Pharma plc  American Depositary Shares',

    'NASDAQ symbol': 'AMYT',
  },
  {
    symbol: 'AMZA',
    'Security Name': 'InfraCap MLP ETF',

    'CQS symbol': 'AMZA',
    'NASDAQ symbol': 'AMZA',
  },
  {
    symbol: 'AMZN',
    'Security Name': 'Amazon,   ',

    'NASDAQ symbol': 'AMZN',
  },
  {
    symbol: 'AN',
    'Security Name': 'AutoNation,  ',

    'CQS symbol': 'AN',
    'NASDAQ symbol': 'AN',
  },
  {
    symbol: 'ANAB',
    'Security Name': 'AnaptysBio,   ',

    'NASDAQ symbol': 'ANAB',
  },
  {
    symbol: 'ANAT',
    'Security Name': 'American National Group,   ',

    'NASDAQ symbol': 'ANAT',
  },
  {
    symbol: 'ANCN',
    'Security Name': 'Anchiano Therapeutics Ltd  American Depositary Shares',

    'NASDAQ symbol': 'ANCN',
  },
  {
    symbol: 'ANDA',
    'Security Name': 'Andina Acquisition Corp III  Ordinary Shares',

    'NASDAQ symbol': 'ANDA',
  },
  {
    symbol: 'ANDAR',
    'Security Name': 'Andina Acquisition Corp III  Right',

    'NASDAQ symbol': 'ANDAR',
  },
  {
    symbol: 'ANDAU',
    'Security Name': 'Andina Acquisition Corp III  Unit',

    'NASDAQ symbol': 'ANDAU',
  },
  {
    symbol: 'ANDAW',
    'Security Name': 'Andina Acquisition Corp III  Warrant',

    'NASDAQ symbol': 'ANDAW',
  },
  {
    symbol: 'ANDE',
    'Security Name': 'The Andersons,   ',

    'NASDAQ symbol': 'ANDE',
  },
  {
    symbol: 'ANET',
    'Security Name': 'Arista Networks,  ',

    'CQS symbol': 'ANET',
    'NASDAQ symbol': 'ANET',
  },
  {
    symbol: 'ANEW',
    'Security Name': 'ProShares MSCI Transformational Changes ETF',

    'CQS symbol': 'ANEW',
    'NASDAQ symbol': 'ANEW',
  },
  {
    symbol: 'ANF',
    'Security Name': 'Abercrombie & Fitch Company ',

    'CQS symbol': 'ANF',
    'NASDAQ symbol': 'ANF',
  },
  {
    symbol: 'ANGI',
    'Security Name': 'ANGI Homeservices    ',

    'NASDAQ symbol': 'ANGI',
  },
  {
    symbol: 'ANGL',
    'Security Name': 'VanEck Vectors Fallen Angel High Yield Bond ETF',

    'NASDAQ symbol': 'ANGL',
  },
  {
    symbol: 'ANGO',
    'Security Name': 'AngioDynamics,   ',

    'NASDAQ symbol': 'ANGO',
  },
  {
    symbol: 'ANH',
    'Security Name': 'Anworth Mortgage Asset Corporation ',

    'CQS symbol': 'ANH',
    'NASDAQ symbol': 'ANH',
  },
  {
    symbol: 'ANH$A',
    'Security Name':
      'Anworth Mortgage Asset Corporation Series A Preferred Stock',

    'CQS symbol': 'ANHpA',
    'NASDAQ symbol': 'ANHA',
  },
  {
    symbol: 'ANH$B',
    'Security Name':
      'Anworth Mortgage Asset  Corporation Preferred Stock Series B 625%',

    'CQS symbol': 'ANHpB',
    'NASDAQ symbol': 'ANHB',
  },
  {
    symbol: 'ANH$C',
    'Security Name':
      'Anworth Mortgage Asset  Corporation 7625% Series C Cumulative Redeemable  Preferred Stock',

    'CQS symbol': 'ANHpC',
    'NASDAQ symbol': 'ANHC',
  },
  {
    symbol: 'ANIK',
    'Security Name': 'Anika Therapeutics   ',

    'NASDAQ symbol': 'ANIK',
  },
  {
    symbol: 'ANIP',
    'Security Name': 'ANI Pharmaceuticals,   ',

    'NASDAQ symbol': 'ANIP',
  },
  {
    symbol: 'ANIX',
    'Security Name': 'Anixa Biosciences,   ',

    'NASDAQ symbol': 'ANIX',
  },
  {
    symbol: 'ANNX',
    'Security Name': 'Annexon,   ',

    'NASDAQ symbol': 'ANNX',
  },
  {
    symbol: 'ANPC',
    'Security Name':
      'AnPac BioMedical Science Co, Ltd  American Depositary Shares',

    'NASDAQ symbol': 'ANPC',
  },
  {
    symbol: 'ANSS',
    'Security Name': 'ANSYS,   ',

    'NASDAQ symbol': 'ANSS',
  },
  {
    symbol: 'ANTE',
    'Security Name':
      'AirNet Technology   American Depositary Shares, each representing ten ordinary shares',

    'NASDAQ symbol': 'ANTE',
  },
  {
    symbol: 'ANTM',
    'Security Name': 'Anthem,  ',

    'CQS symbol': 'ANTM',
    'NASDAQ symbol': 'ANTM',
  },
  {
    symbol: 'ANVS',
    'Security Name': 'Annovis Bio,  ',

    'CQS symbol': 'ANVS',
    'NASDAQ symbol': 'ANVS',
  },
  {
    symbol: 'ANY',
    'Security Name': 'Sphere 3D Corp  Common Shares',

    'NASDAQ symbol': 'ANY',
  },
  {
    symbol: 'AOA',
    'Security Name': 'iShares Core Aggressive Allocation ETF',

    'CQS symbol': 'AOA',
    'NASDAQ symbol': 'AOA',
  },
  {
    symbol: 'AOD',
    'Security Name': 'Aberdeen Total Dynamic Dividend Fund ',

    'CQS symbol': 'AOD',
    'NASDAQ symbol': 'AOD',
  },
  {
    symbol: 'AOK',
    'Security Name': 'iShares Core Conservative Allocation ETF',

    'CQS symbol': 'AOK',
    'NASDAQ symbol': 'AOK',
  },
  {
    symbol: 'AOM',
    'Security Name': 'iShares Core Moderate Allocation ETF',

    'CQS symbol': 'AOM',
    'NASDAQ symbol': 'AOM',
  },
  {
    symbol: 'AON',
    'Security Name': 'Aon plc  Ordinary Shares (Ireland)',

    'CQS symbol': 'AON',
    'NASDAQ symbol': 'AON',
  },
  {
    symbol: 'AONE',
    'Security Name': 'one  Ordinary Shares',

    'CQS symbol': 'AONE',
    'NASDAQ symbol': 'AONE',
  },
  {
    symbol: 'AONEU',
    'Security Name':
      'one Units, each consisting of one  Ordinary Share, and one third of one Warrant to acquire one  Ordinary Share',

    'CQS symbol': 'AONEU',
    'NASDAQ symbol': 'AONE=',
  },
  {
    symbol: 'AONEW',
    'Security Name':
      'one Warrants, each whole warrant exercisable for one  ordinary share at an exercise price of $1150',

    'CQS symbol': 'AONEWS',
    'NASDAQ symbol': 'AONE+',
  },
  {
    symbol: 'AOR',
    'Security Name': 'iShares Core Growth Allocation ETF',

    'CQS symbol': 'AOR',
    'NASDAQ symbol': 'AOR',
  },
  {
    symbol: 'AOS',
    'Security Name': 'AO Smith Corporation ',

    'CQS symbol': 'AOS',
    'NASDAQ symbol': 'AOS',
  },
  {
    symbol: 'AOSL',
    'Security Name': 'Alpha and Omega Semiconductor Limited  Common Shares',

    'NASDAQ symbol': 'AOSL',
  },
  {
    symbol: 'AOUT',
    'Security Name': 'American Outdoor Brands,   ',

    'NASDAQ symbol': 'AOUT',
  },
  {
    symbol: 'AP',
    'Security Name': 'AmpcoPittsburgh Corporation ',

    'CQS symbol': 'AP',
    'NASDAQ symbol': 'AP',
  },
  {
    symbol: 'APW',
    'Security Name':
      'AmpcoPittsburgh Corporation Series A Warrants to purchase Shares of ',

    'CQS symbol': 'APWS',
    'NASDAQ symbol': 'AP+',
  },
  {
    symbol: 'APA',
    'Security Name': 'Apache Corporation  ',

    'NASDAQ symbol': 'APA',
  },
  {
    symbol: 'APAM',
    'Security Name': 'Artisan Partners Asset Management   ',

    'CQS symbol': 'APAM',
    'NASDAQ symbol': 'APAM',
  },
  {
    symbol: 'APD',
    'Security Name': 'Air Products and Chemicals,  ',

    'CQS symbol': 'APD',
    'NASDAQ symbol': 'APD',
  },
  {
    symbol: 'APDN',
    'Security Name': 'Applied DNA Sciences,   ',

    'NASDAQ symbol': 'APDN',
  },
  {
    symbol: 'APEI',
    'Security Name': 'American Public Education,   ',

    'NASDAQ symbol': 'APEI',
  },
  {
    symbol: 'APEN',
    'Security Name': 'Apollo Endosurgery,   ',

    'NASDAQ symbol': 'APEN',
  },
  {
    symbol: 'APG',
    'Security Name': 'APi Group Corporation ',

    'CQS symbol': 'APG',
    'NASDAQ symbol': 'APG',
  },
  {
    symbol: 'APH',
    'Security Name': 'Amphenol Corporation ',

    'CQS symbol': 'APH',
    'NASDAQ symbol': 'APH',
  },
  {
    symbol: 'APHA',
    'Security Name': 'Aphria   Common Shares',

    'NASDAQ symbol': 'APHA',
  },
  {
    symbol: 'API',
    'Security Name': 'Agora,   ADS',

    'NASDAQ symbol': 'API',
  },
  {
    symbol: 'APLE',
    'Security Name': 'Apple Hospitality REIT,  Common Shares',

    'CQS symbol': 'APLE',
    'NASDAQ symbol': 'APLE',
  },
  {
    symbol: 'APLS',
    'Security Name': 'Apellis Pharmaceuticals,   ',

    'NASDAQ symbol': 'APLS',
  },
  {
    symbol: 'APLT',
    'Security Name': 'Applied Therapeutics,   ',

    'NASDAQ symbol': 'APLT',
  },
  {
    symbol: 'APM',
    'Security Name': 'Aptorum Group Limited   Ordinary Shares',

    'NASDAQ symbol': 'APM',
  },
  {
    symbol: 'APO',
    'Security Name': 'Apollo Global Management,   ',

    'CQS symbol': 'APO',
    'NASDAQ symbol': 'APO',
  },
  {
    symbol: 'APO$A',
    'Security Name':
      'Apollo Global Management,  6375% Series A Preferred Shares',

    'CQS symbol': 'APOpA',
    'NASDAQ symbol': 'APOA',
  },
  {
    symbol: 'APO$B',
    'Security Name':
      'Apollo Global Management,  6375% Series B Preferred Shares',

    'CQS symbol': 'APOpB',
    'NASDAQ symbol': 'APOB',
  },
  {
    symbol: 'APOG',
    'Security Name': 'Apogee Enterprises,   ',

    'NASDAQ symbol': 'APOG',
  },
  {
    symbol: 'APOP',
    'Security Name': 'Cellect Biotechnology Ltd  American Depositary Shares',

    'NASDAQ symbol': 'APOP',
  },
  {
    symbol: 'APOPW',
    'Security Name':
      'Cellect Biotechnology Ltd  Warrants to Purchase ADR (1 WT and $750 to purchase 02 ADS)',

    'NASDAQ symbol': 'APOPW',
  },
  {
    symbol: 'APPF',
    'Security Name': 'AppFolio,    ',

    'NASDAQ symbol': 'APPF',
  },
  {
    symbol: 'APPN',
    'Security Name': 'Appian Corporation   ',

    'NASDAQ symbol': 'APPN',
  },
  {
    symbol: 'APPS',
    'Security Name': 'Digital Turbine,   ',

    'NASDAQ symbol': 'APPS',
  },
  {
    symbol: 'APRE',
    'Security Name': 'Aprea Therapeutics,   ',

    'NASDAQ symbol': 'APRE',
  },
  {
    symbol: 'APRN',
    'Security Name': 'Blue Apron Holdings,   ',

    'CQS symbol': 'APRN',
    'NASDAQ symbol': 'APRN',
  },
  {
    symbol: 'APSG',
    'Security Name': 'Apollo Strategic Growth Capital  Ordinary Shares',

    'CQS symbol': 'APSG',
    'NASDAQ symbol': 'APSG',
  },
  {
    symbol: 'APSGU',
    'Security Name':
      'Apollo Strategic Growth Capital Units, each consisting of one  Ordinary Share and onethird Warrant',

    'CQS symbol': 'APSGU',
    'NASDAQ symbol': 'APSG=',
  },
  {
    symbol: 'APSGW',
    'Security Name':
      'Apollo Strategic Growth Capital Warrants, each exercisable for one  Ordinary Share at an exercise price of $1150 per share',

    'CQS symbol': 'APSGWS',
    'NASDAQ symbol': 'APSG+',
  },
  {
    symbol: 'APT',
    'Security Name': 'Alpha Pro Tech, Ltd ',

    'CQS symbol': 'APT',
    'NASDAQ symbol': 'APT',
  },
  {
    symbol: 'APTO',
    'Security Name': 'Aptose Biosciences,   Common Shares',

    'NASDAQ symbol': 'APTO',
  },
  {
    symbol: 'APTS',
    'Security Name': 'Preferred Apartment Communities,  ',

    'CQS symbol': 'APTS',
    'NASDAQ symbol': 'APTS',
  },
  {
    symbol: 'APTV',
    'Security Name': 'Aptiv PLC Ordinary Shares',

    'CQS symbol': 'APTV',
    'NASDAQ symbol': 'APTV',
  },
  {
    symbol: 'APTV$A',
    'Security Name':
      'Aptiv PLC 550% Series A Mandatory Convertible Preferred Shares',

    'CQS symbol': 'APTVpA',
    'NASDAQ symbol': 'APTVA',
  },
  {
    symbol: 'APTX',
    'Security Name': 'Aptinyx   ',

    'NASDAQ symbol': 'APTX',
  },
  {
    symbol: 'APVO',
    'Security Name': 'Aptevo Therapeutics   ',

    'NASDAQ symbol': 'APVO',
  },
  {
    symbol: 'APWC',
    'Security Name':
      'Asia Pacific Wire   Common shares, Par value 01 per share',

    'NASDAQ symbol': 'APWC',
  },
  {
    symbol: 'APXT',
    'Security Name': 'Apex Technology Acquisition Corporation   ',

    'NASDAQ symbol': 'APXT',
  },
  {
    symbol: 'APXTU',
    'Security Name': 'Apex Technology Acquisition Corporation  Unit',

    'NASDAQ symbol': 'APXTU',
  },
  {
    symbol: 'APXTW',
    'Security Name': 'Apex Technology Acquisition Corporation  Warrant',

    'NASDAQ symbol': 'APXTW',
  },
  {
    symbol: 'APYX',
    'Security Name': 'Apyx Medical Corporation  ',

    'NASDAQ symbol': 'APYX',
  },
  {
    symbol: 'AQB',
    'Security Name': 'AquaBounty Technologies,   ',

    'NASDAQ symbol': 'AQB',
  },
  {
    symbol: 'AQMS',
    'Security Name': 'Aqua Metals,   ',

    'NASDAQ symbol': 'AQMS',
  },
  {
    symbol: 'AQN',
    'Security Name': 'Algonquin Power & Utilities Corp Common Shares',

    'CQS symbol': 'AQN',
    'NASDAQ symbol': 'AQN',
  },
  {
    symbol: 'AQNA',
    'Security Name':
      'Algonquin Power & Utilities Corp 6875% FixedtoFloating Rate Subordinated Notes Series 2018A due October 17, 2078',

    'CQS symbol': 'AQNA',
    'NASDAQ symbol': 'AQNA',
  },
  {
    symbol: 'AQNB',
    'Security Name':
      'Algonquin Power & Utilities Corp 620% FixedtoFloating Subordinated Notes Series 2019A due July 1, 2079',

    'CQS symbol': 'AQNB',
    'NASDAQ symbol': 'AQNB',
  },
  {
    symbol: 'AQST',
    'Security Name': 'Aquestive Therapeutics,   ',

    'NASDAQ symbol': 'AQST',
  },
  {
    symbol: 'AQUA',
    'Security Name': 'Evoqua Water Technologies Corp ',

    'CQS symbol': 'AQUA',
    'NASDAQ symbol': 'AQUA',
  },
  {
    symbol: 'AR',
    'Security Name': 'Antero Resources Corporation ',

    'CQS symbol': 'AR',
    'NASDAQ symbol': 'AR',
  },
  {
    symbol: 'ARA',
    'Security Name': 'American Renal Associates Holdings,  ',

    'CQS symbol': 'ARA',
    'NASDAQ symbol': 'ARA',
  },
  {
    symbol: 'ARAV',
    'Security Name': 'Aravive,   ',

    'NASDAQ symbol': 'ARAV',
  },
  {
    symbol: 'ARAY',
    'Security Name': 'Accuray orporated  ',

    'NASDAQ symbol': 'ARAY',
  },
  {
    symbol: 'ARB',
    'Security Name': 'AltShares Merger Arbitrage ETF',

    'CQS symbol': 'ARB',
    'NASDAQ symbol': 'ARB',
  },
  {
    symbol: 'ARBGU',
    'Security Name': 'Aequi Acquisition Corp  Unit',

    'NASDAQ symbol': 'ARBGU',
  },
  {
    symbol: 'ARC',
    'Security Name': 'ARC Document Solutions,  ',

    'CQS symbol': 'ARC',
    'NASDAQ symbol': 'ARC',
  },
  {
    symbol: 'ARCB',
    'Security Name': 'ArcBest Corporation  ',

    'NASDAQ symbol': 'ARCB',
  },
  {
    symbol: 'ARCC',
    'Security Name': 'Ares Capital Corporation  Closed End Fund',

    'NASDAQ symbol': 'ARCC',
  },
  {
    symbol: 'ARCE',
    'Security Name': 'Arco Platform Limited   Common Shares',

    'NASDAQ symbol': 'ARCE',
  },
  {
    symbol: 'ARCH',
    'Security Name': 'Arch Resources,   ',

    'CQS symbol': 'ARCH',
    'NASDAQ symbol': 'ARCH',
  },
  {
    symbol: 'ARCM',
    'Security Name': 'Arrow Reserve Capital Management ETF',

    'CQS symbol': 'ARCM',
    'NASDAQ symbol': 'ARCM',
  },
  {
    symbol: 'ARCO',
    'Security Name': 'Arcos Dorados Holdings   Shares',

    'CQS symbol': 'ARCO',
    'NASDAQ symbol': 'ARCO',
  },
  {
    symbol: 'ARCT',
    'Security Name': 'Arcturus Therapeutics Holdings   ',

    'NASDAQ symbol': 'ARCT',
  },
  {
    symbol: 'ARD',
    'Security Name': 'Ardagh Group SA Common Shares',

    'CQS symbol': 'ARD',
    'NASDAQ symbol': 'ARD',
  },
  {
    symbol: 'ARDC',
    'Security Name': 'Ares Dynamic Credit Allocation Fund,  Common Shares',

    'CQS symbol': 'ARDC',
    'NASDAQ symbol': 'ARDC',
  },
  {
    symbol: 'ARDS',
    'Security Name': 'Aridis Pharmaceuticals   ',

    'NASDAQ symbol': 'ARDS',
  },
  {
    symbol: 'ARDX',
    'Security Name': 'Ardelyx,   ',

    'NASDAQ symbol': 'ARDX',
  },
  {
    symbol: 'ARE',
    'Security Name': 'Alexandria Real Estate Equities,  ',

    'CQS symbol': 'ARE',
    'NASDAQ symbol': 'ARE',
  },
  {
    symbol: 'AREC',
    'Security Name': 'American Resources Corporation   ',

    'NASDAQ symbol': 'AREC',
  },
  {
    symbol: 'ARES',
    'Security Name': 'Ares Management Corporation  ',

    'CQS symbol': 'ARES',
    'NASDAQ symbol': 'ARES',
  },
  {
    symbol: 'ARES$A',
    'Security Name':
      'Ares Management Corporation 700% Series A Preferred Stock',

    'CQS symbol': 'ARESpA',
    'NASDAQ symbol': 'ARESA',
  },
  {
    symbol: 'ARGD',
    'Security Name':
      'Argo Group International Holdings, Ltd 65% Senior Notes Due 2042',

    'CQS symbol': 'ARGD',
    'NASDAQ symbol': 'ARGD',
  },
  {
    symbol: 'ARGO',
    'Security Name': 'Argo Group International Holdings, Ltd',

    'CQS symbol': 'ARGO',
    'NASDAQ symbol': 'ARGO',
  },
  {
    symbol: 'ARGO$A',
    'Security Name':
      'Argo Group International Holdings, Ltd Depositary Shares, Each Representing a 1/1,000th Interest in a 700% Resettable Fixed Rate Preference Share, Series A',

    'CQS symbol': 'ARGOpA',
    'NASDAQ symbol': 'ARGOA',
  },
  {
    symbol: 'ARGT',
    'Security Name': 'Global X MSCI Argentina ETF',

    'CQS symbol': 'ARGT',
    'NASDAQ symbol': 'ARGT',
  },
  {
    symbol: 'ARGX',
    'Security Name': 'argenx SE  American Depositary Shares',

    'NASDAQ symbol': 'ARGX',
  },
  {
    symbol: 'ARI',
    'Security Name': 'Apollo Commercial Real Estate Finance, ',

    'CQS symbol': 'ARI',
    'NASDAQ symbol': 'ARI',
  },
  {
    symbol: 'ARKF',
    'Security Name': 'ARK Fintech Innovation ETF',

    'CQS symbol': 'ARKF',
    'NASDAQ symbol': 'ARKF',
  },
  {
    symbol: 'ARKG',
    'Security Name': 'ARK Genomic Revolution ETF',

    'CQS symbol': 'ARKG',
    'NASDAQ symbol': 'ARKG',
  },
  {
    symbol: 'ARKK',
    'Security Name': 'ARK Innovation ETF',

    'CQS symbol': 'ARKK',
    'NASDAQ symbol': 'ARKK',
  },
  {
    symbol: 'ARKQ',
    'Security Name': 'ARK Autonomous Technology & Robotics ETF',

    'CQS symbol': 'ARKQ',
    'NASDAQ symbol': 'ARKQ',
  },
  {
    symbol: 'ARKR',
    'Security Name': 'Ark Restaurants Corp  ',

    'NASDAQ symbol': 'ARKR',
  },
  {
    symbol: 'ARKW',
    'Security Name': 'ARK Next Generation Internet ETF',

    'CQS symbol': 'ARKW',
    'NASDAQ symbol': 'ARKW',
  },
  {
    symbol: 'ARL',
    'Security Name': 'American Realty Investors,  ',

    'CQS symbol': 'ARL',
    'NASDAQ symbol': 'ARL',
  },
  {
    symbol: 'ARLO',
    'Security Name': 'Arlo Technologies,  ',

    'CQS symbol': 'ARLO',
    'NASDAQ symbol': 'ARLO',
  },
  {
    symbol: 'ARLP',
    'Security Name':
      'Alliance Resource Partners, LP  Common Units Representing Limited Partnership Interests',

    'NASDAQ symbol': 'ARLP',
  },
  {
    symbol: 'ARMK',
    'Security Name': 'Aramark ',

    'CQS symbol': 'ARMK',
    'NASDAQ symbol': 'ARMK',
  },
  {
    symbol: 'ARMP',
    'Security Name': 'Armata Pharmaceuticals,  ',

    'CQS symbol': 'ARMP',
    'NASDAQ symbol': 'ARMP',
  },
  {
    symbol: 'ARMR',
    'Security Name': 'Exchange Listed Funds Trust Armor US Equity Index ETF',

    'CQS symbol': 'ARMR',
    'NASDAQ symbol': 'ARMR',
  },
  {
    symbol: 'ARNA',
    'Security Name': 'Arena Pharmaceuticals,   ',

    'NASDAQ symbol': 'ARNA',
  },
  {
    symbol: 'ARNC',
    'Security Name': 'Arconic Corporation  ',

    'CQS symbol': 'ARNC',
    'NASDAQ symbol': 'ARNC',
  },
  {
    symbol: 'AROC',
    'Security Name': 'Archrock,  ',

    'CQS symbol': 'AROC',
    'NASDAQ symbol': 'AROC',
  },
  {
    symbol: 'AROW',
    'Security Name': 'Arrow Financial Corporation  ',

    'NASDAQ symbol': 'AROW',
  },
  {
    symbol: 'ARPO',
    'Security Name': 'Aerpio Pharmaceuticals,   ',

    'NASDAQ symbol': 'ARPO',
  },
  {
    symbol: 'ARQT',
    'Security Name': 'Arcutis Biotherapeutics,   ',

    'NASDAQ symbol': 'ARQT',
  },
  {
    symbol: 'ARR',
    'Security Name': 'ARMOUR Residential REIT, ',

    'CQS symbol': 'ARR',
    'NASDAQ symbol': 'ARR',
  },
  {
    symbol: 'ARR$C',
    'Security Name':
      'ARMOUR Residential REIT,  7% Series C Cumulative Redeemable Preferred Stock (liquidation preference $2500 per share)',

    'CQS symbol': 'ARRpC',
    'NASDAQ symbol': 'ARRC',
  },
  {
    symbol: 'ARRY',
    'Security Name': 'Array Technologies,   ',

    'NASDAQ symbol': 'ARRY',
  },
  {
    symbol: 'ARTL',
    'Security Name': 'Artelo Biosciences,   ',

    'NASDAQ symbol': 'ARTL',
  },
  {
    symbol: 'ARTLW',
    'Security Name': 'Artelo Biosciences,   Warrant',

    'NASDAQ symbol': 'ARTLW',
  },
  {
    symbol: 'ARTNA',
    'Security Name': 'Artesian Resources Corporation   NonVoting ',

    'NASDAQ symbol': 'ARTNA',
  },
  {
    symbol: 'ARTW',
    'Security Name': "Art'sWay Manufacturing Co,   ",

    'NASDAQ symbol': 'ARTW',
  },
  {
    symbol: 'ARVN',
    'Security Name': 'Arvinas,   ',

    'NASDAQ symbol': 'ARVN',
  },
  {
    symbol: 'ARW',
    'Security Name': 'Arrow Electronics,  ',

    'CQS symbol': 'ARW',
    'NASDAQ symbol': 'ARW',
  },
  {
    symbol: 'ARWR',
    'Security Name': 'Arrowhead Pharmaceuticals,   ',

    'NASDAQ symbol': 'ARWR',
  },
  {
    symbol: 'ARYA',
    'Security Name': 'ARYA Sciences Acquisition Corp III   Ordinary Shares',

    'NASDAQ symbol': 'ARYA',
  },
  {
    symbol: 'ASA',
    'Security Name': 'ASA  Gold and Precious Metals Limited',

    'CQS symbol': 'ASA',
    'NASDAQ symbol': 'ASA',
  },
  {
    symbol: 'ASAN',
    'Security Name': 'Asana,   ',

    'CQS symbol': 'ASAN',
    'NASDAQ symbol': 'ASAN',
  },
  {
    symbol: 'ASAQ',
    'Security Name': 'Atlantic Street Acquisition Corp  ',

    'CQS symbol': 'ASAQ',
    'NASDAQ symbol': 'ASAQ',
  },
  {
    symbol: 'ASAQU',
    'Security Name':
      'Atlantic Street Acquisition Corp Units, each consisting of one share of   and onehalf of one Warrant',

    'CQS symbol': 'ASAQU',
    'NASDAQ symbol': 'ASAQ=',
  },
  {
    symbol: 'ASAQW',
    'Security Name':
      'Atlantic Street Acquisition Corp Warrants, each whole warrant exercisable for one share of   at an exercise price of $1150 per share',

    'CQS symbol': 'ASAQWS',
    'NASDAQ symbol': 'ASAQ+',
  },
  {
    symbol: 'ASB',
    'Security Name': 'Associated BancCorp ',

    'CQS symbol': 'ASB',
    'NASDAQ symbol': 'ASB',
  },
  {
    symbol: 'ASB$C',
    'Security Name':
      'Associated BancCorp Depositary shares, each representing a 1/40th ownership interest in a share of 6125% NonCumulative Perpetual Preferred Stock, Series C',

    'CQS symbol': 'ASBpC',
    'NASDAQ symbol': 'ASBC',
  },
  {
    symbol: 'ASB$D',
    'Security Name':
      'Associated BancCorp Depositary Shares, each representing a 1/40th interest in a share of Associated BancCorp 5375% NonCumulative Perpetual Preferred Stock, Series D',

    'CQS symbol': 'ASBpD',
    'NASDAQ symbol': 'ASBD',
  },
  {
    symbol: 'ASB$E',
    'Security Name':
      'Associated BancCorp Depositary Shares, each representing a 1/40th interest in a share of 5875% NonCumulative Perpetual Preferred Stock, Series E',

    'CQS symbol': 'ASBpE',
    'NASDAQ symbol': 'ASBE',
  },
  {
    symbol: 'ASB$F',
    'Security Name':
      'Associated BancCorp Depositary Shares, each representing a 1/40th interest in a share of Associated BancCorp 5625% NonCumulative Perpetual Preferred Stock, Series F',

    'CQS symbol': 'ASBpF',
    'NASDAQ symbol': 'ASBF',
  },
  {
    symbol: 'ASC',
    'Security Name': 'Ardmore Shipping Corporation ',

    'CQS symbol': 'ASC',
    'NASDAQ symbol': 'ASC',
  },
  {
    symbol: 'ASEA',
    'Security Name': 'Global X FTSE Southeast Asia ETF',

    'CQS symbol': 'ASEA',
    'NASDAQ symbol': 'ASEA',
  },
  {
    symbol: 'ASET',
    'Security Name': 'FlexShares Real Assets Allocation Index Fund',

    'NASDAQ symbol': 'ASET',
  },
  {
    symbol: 'ASG',
    'Security Name': 'Liberty AllStar Growth Fund, ',

    'CQS symbol': 'ASG',
    'NASDAQ symbol': 'ASG',
  },
  {
    symbol: 'ASGI',
    'Security Name':
      'Aberdeen Standard Global Infrastructure ome Fund Common Shares of Beneficial Interest',

    'CQS symbol': 'ASGI',
    'NASDAQ symbol': 'ASGI',
  },
  {
    symbol: 'ASGN',
    'Security Name': 'ASGN orporated ',

    'CQS symbol': 'ASGN',
    'NASDAQ symbol': 'ASGN',
  },
  {
    symbol: 'ASH',
    'Security Name': 'Ashland Global Holdings  ',

    'CQS symbol': 'ASH',
    'NASDAQ symbol': 'ASH',
  },
  {
    symbol: 'ASHR',
    'Security Name': 'Xtrackers Harvest CSI 300 China AShares ETF',

    'CQS symbol': 'ASHR',
    'NASDAQ symbol': 'ASHR',
  },
  {
    symbol: 'ASHS',
    'Security Name': 'Xtrackers Harvest CSI 500 China AShares Small Cap ETF',

    'CQS symbol': 'ASHS',
    'NASDAQ symbol': 'ASHS',
  },
  {
    symbol: 'ASHX',
    'Security Name': 'Xtrackers MSCI China A lusion Equity ETF',

    'CQS symbol': 'ASHX',
    'NASDAQ symbol': 'ASHX',
  },
  {
    symbol: 'ASIX',
    'Security Name': 'AdvanSix   ',

    'CQS symbol': 'ASIX',
    'NASDAQ symbol': 'ASIX',
  },
  {
    symbol: 'ASLN',
    'Security Name':
      'ASLAN Pharmaceuticals Limited  American Depositary Shares',

    'NASDAQ symbol': 'ASLN',
  },
  {
    symbol: 'ASM',
    'Security Name': 'Avino Silver & Gold Mines Ltd Common Shares (Canada)',

    'CQS symbol': 'ASM',
    'NASDAQ symbol': 'ASM',
  },
  {
    symbol: 'ASMB',
    'Security Name': 'Assembly Biosciences,   ',

    'NASDAQ symbol': 'ASMB',
  },
  {
    symbol: 'ASML',
    'Security Name': 'ASML Holding NV  New York Registry Shares',

    'NASDAQ symbol': 'ASML',
  },
  {
    symbol: 'ASND',
    'Security Name': 'Ascendis Pharma A/S  American Depositary Shares',

    'NASDAQ symbol': 'ASND',
  },
  {
    symbol: 'ASO',
    'Security Name': 'Academy Sports and Outdoors,   ',

    'NASDAQ symbol': 'ASO',
  },
  {
    symbol: 'ASPL',
    'Security Name': 'Aspirational Consumer Lifestyle Corp  Ordinary Shares',

    'CQS symbol': 'ASPL',
    'NASDAQ symbol': 'ASPL',
  },
  {
    symbol: 'ASPLU',
    'Security Name':
      'Aspirational Consumer Lifestyle Corp Units, each consisting of one  ordinary share and onethird of one redeemable warrant',

    'CQS symbol': 'ASPLU',
    'NASDAQ symbol': 'ASPL=',
  },
  {
    symbol: 'ASPLW',
    'Security Name':
      'Aspirational Consumer Lifestyle Corp Redeemable Warrants, each whole warrant exercisable for one  ordinary share at an exercise price of $1150',

    'CQS symbol': 'ASPLWS',
    'NASDAQ symbol': 'ASPL+',
  },
  {
    symbol: 'ASPN',
    'Security Name': 'Aspen Aerogels,  ',

    'CQS symbol': 'ASPN',
    'NASDAQ symbol': 'ASPN',
  },
  {
    symbol: 'ASPS',
    'Security Name': 'Altisource Portfolio Solutions SA  ',

    'NASDAQ symbol': 'ASPS',
  },
  {
    symbol: 'ASPU',
    'Security Name': 'Aspen Group   ',

    'NASDAQ symbol': 'ASPU',
  },
  {
    symbol: 'ASR',
    'Security Name': 'Grupo Aeroportuario del Sureste, SA de CV ',

    'CQS symbol': 'ASR',
    'NASDAQ symbol': 'ASR',
  },
  {
    symbol: 'ASRT',
    'Security Name': 'Assertio Holdings,   ',

    'NASDAQ symbol': 'ASRT',
  },
  {
    symbol: 'ASRV',
    'Security Name': 'AmeriServ Financial   ',

    'NASDAQ symbol': 'ASRV',
  },
  {
    symbol: 'ASRVP',
    'Security Name':
      'AmeriServ Financial   AmeriServ Financial Trust I  845% Beneficial Unsecured Securities, Series A',

    'NASDAQ symbol': 'ASRVP',
  },
  {
    symbol: 'ASTC',
    'Security Name': 'Astrotech Corporation  ',

    'NASDAQ symbol': 'ASTC',
  },
  {
    symbol: 'ASTE',
    'Security Name': 'Astec Industries,   ',

    'NASDAQ symbol': 'ASTE',
  },
  {
    symbol: 'ASUR',
    'Security Name': 'Asure Software   ',

    'NASDAQ symbol': 'ASUR',
  },
  {
    symbol: 'ASX',
    'Security Name':
      'ASE Technology Holding Co, Ltd American Depositary Shares (each representing Two Common Shares) ',

    'CQS symbol': 'ASX',
    'NASDAQ symbol': 'ASX',
  },
  {
    symbol: 'ASYS',
    'Security Name': 'Amtech Systems,   ',

    'NASDAQ symbol': 'ASYS',
  },
  {
    symbol: 'AT',
    'Security Name': 'Atlantic Power Corporation Ordinary Shares (Canada)',

    'CQS symbol': 'AT',
    'NASDAQ symbol': 'AT',
  },
  {
    symbol: 'ATACU',
    'Security Name':
      'Altimar Acquisition Corporation Units, each consisting of one  ordinary share and onethird of one redeemable warrant',

    'CQS symbol': 'ATACU',
    'NASDAQ symbol': 'ATAC=',
  },
  {
    symbol: 'ATAX',
    'Security Name':
      'America First Multifamily Investors, LP  Beneficial Unit Certificates (BUCs) representing Limited Partnership Interests',

    'NASDAQ symbol': 'ATAX',
  },
  {
    symbol: 'ATCO',
    'Security Name': 'Atlas Corp Common Shares',

    'CQS symbol': 'ATCO',
    'NASDAQ symbol': 'ATCO',
  },
  {
    symbol: 'ATCO$D',
    'Security Name': 'Atlas Corp 795% Series D',

    'CQS symbol': 'ATCOpD',
    'NASDAQ symbol': 'ATCOD',
  },
  {
    symbol: 'ATCO$E',
    'Security Name': 'Atlas Corp 825% Series E',

    'CQS symbol': 'ATCOpE',
    'NASDAQ symbol': 'ATCOE',
  },
  {
    symbol: 'ATCO$G',
    'Security Name': 'Atlas Corp 820% Series G',

    'CQS symbol': 'ATCOpG',
    'NASDAQ symbol': 'ATCOG',
  },
  {
    symbol: 'ATCO$H',
    'Security Name': 'Atlas Corp 7875% Series H',

    'CQS symbol': 'ATCOpH',
    'NASDAQ symbol': 'ATCOH',
  },
  {
    symbol: 'ATCO$I',
    'Security Name': 'Atlas Corp Series I FixedtoFloating ',

    'CQS symbol': 'ATCOpI',
    'NASDAQ symbol': 'ATCOI',
  },
  {
    symbol: 'ATCX',
    'Security Name': 'Atlas Technical Consultants,    ',

    'NASDAQ symbol': 'ATCX',
  },
  {
    symbol: 'ATEC',
    'Security Name': 'Alphatec Holdings,   ',

    'NASDAQ symbol': 'ATEC',
  },
  {
    symbol: 'ATEN',
    'Security Name': 'A10 Networks,  ',

    'CQS symbol': 'ATEN',
    'NASDAQ symbol': 'ATEN',
  },
  {
    symbol: 'ATEST',
    'Security Name': 'Tick Pilot Test Control ',

    'Test Issue': 'Y',

    'CQS symbol': 'ATEST',
    'NASDAQ symbol': 'ATEST',
  },
  {
    symbol: 'ATESTA',
    'Security Name': 'Tick Pilot Test Group 1 ',

    'Test Issue': 'Y',

    'CQS symbol': 'ATESTA',
    'NASDAQ symbol': 'ATESTA',
  },
  {
    symbol: 'ATESTB',
    'Security Name': 'Tick pilot Test 2 ',

    'Test Issue': 'Y',

    'CQS symbol': 'ATESTB',
    'NASDAQ symbol': 'ATESTB',
  },
  {
    symbol: 'ATESTC',
    'Security Name': 'Tick Pilot Test 3 ',

    'Test Issue': 'Y',

    'CQS symbol': 'ATESTC',
    'NASDAQ symbol': 'ATESTC',
  },
  {
    symbol: 'ATEX',
    'Security Name': 'Anterix   ',

    'NASDAQ symbol': 'ATEX',
  },
  {
    symbol: 'ATGE',
    'Security Name': 'Adtalem Global Education  ',

    'CQS symbol': 'ATGE',
    'NASDAQ symbol': 'ATGE',
  },
  {
    symbol: 'ATH',
    'Security Name': 'Athene Holding Ltd  Common Shares',

    'CQS symbol': 'ATH',
    'NASDAQ symbol': 'ATH',
  },
  {
    symbol: 'ATH$A',
    'Security Name':
      'Athene Holding Ltd Depositary Shares, Each Representing a 1/1,000th Interest in a 635% FixedtoFloating Rate Perpetual NonCumulative Preference Share, Series A',

    'CQS symbol': 'ATHpA',
    'NASDAQ symbol': 'ATHA',
  },
  {
    symbol: 'ATH$B',
    'Security Name':
      'Athene Holding Ltd Depositary Shares, Each Representing a 1/1,000th Interest in a 5625% Fixed Rate Perpetual Non Cumulative Preference Share, Series B, par value $100 per share',

    'CQS symbol': 'ATHpB',
    'NASDAQ symbol': 'ATHB',
  },
  {
    symbol: 'ATH$C',
    'Security Name':
      'Athene Holding Ltd Depositary Shares, each representing a 1/1,000th Interest in a Share of 6375% FixedRate Reset Perpetual NonCumulative Preference Shares, Series C',

    'CQS symbol': 'ATHpC',
    'NASDAQ symbol': 'ATHC',
  },
  {
    symbol: 'ATHA',
    'Security Name': 'Athira Pharma,   ',

    'NASDAQ symbol': 'ATHA',
  },
  {
    symbol: 'ATHE',
    'Security Name':
      'Alterity Therapeutics Limited  American Depositary Shares',

    'NASDAQ symbol': 'ATHE',
  },
  {
    symbol: 'ATHM',
    'Security Name':
      'Autohome  American Depositary Shares, each representing one  ordinary share',

    'CQS symbol': 'ATHM',
    'NASDAQ symbol': 'ATHM',
  },
  {
    symbol: 'ATHX',
    'Security Name': 'Athersys,   ',

    'NASDAQ symbol': 'ATHX',
  },
  {
    symbol: 'ATI',
    'Security Name': 'Allegheny Technologies orporated ',

    'CQS symbol': 'ATI',
    'NASDAQ symbol': 'ATI',
  },
  {
    symbol: 'ATIF',
    'Security Name': 'ATIF Holdings Limited  Ordinary Shares',

    'NASDAQ symbol': 'ATIF',
  },
  {
    symbol: 'ATKR',
    'Security Name': 'Atkore International Group  ',

    'CQS symbol': 'ATKR',
    'NASDAQ symbol': 'ATKR',
  },
  {
    symbol: 'ATLC',
    'Security Name': 'Atlanticus Holdings Corporation  ',

    'NASDAQ symbol': 'ATLC',
  },
  {
    symbol: 'ATLO',
    'Security Name': 'Ames National Corporation  ',

    'NASDAQ symbol': 'ATLO',
  },
  {
    symbol: 'ATMP',
    'Security Name': 'iPath Select MLP ETN',

    'CQS symbol': 'ATMP',
    'NASDAQ symbol': 'ATMP',
  },
  {
    symbol: 'ATNF',
    'Security Name': '180 Life Sciences Corp  ',

    'NASDAQ symbol': 'ATNF',
  },
  {
    symbol: 'ATNFW',
    'Security Name': '180 Life Sciences Corp  Warrant',

    'NASDAQ symbol': 'ATNFW',
  },
  {
    symbol: 'ATNI',
    'Security Name': 'ATN International,   ',

    'NASDAQ symbol': 'ATNI',
  },
  {
    symbol: 'ATNM',
    'Security Name': 'Actinium Pharmaceuticals,  (Delaware) ',

    'CQS symbol': 'ATNM',
    'NASDAQ symbol': 'ATNM',
  },
  {
    symbol: 'ATNX',
    'Security Name': 'Athenex,   ',

    'NASDAQ symbol': 'ATNX',
  },
  {
    symbol: 'ATO',
    'Security Name': 'Atmos Energy Corporation ',

    'CQS symbol': 'ATO',
    'NASDAQ symbol': 'ATO',
  },
  {
    symbol: 'ATOM',
    'Security Name': 'Atomera orporated  ',

    'NASDAQ symbol': 'ATOM',
  },
  {
    symbol: 'ATOS',
    'Security Name': 'Atossa Therapeutics,   ',

    'NASDAQ symbol': 'ATOS',
  },
  {
    symbol: 'ATR',
    'Security Name': 'AptarGroup,  ',

    'CQS symbol': 'ATR',
    'NASDAQ symbol': 'ATR',
  },
  {
    symbol: 'ATRA',
    'Security Name': 'Atara Biotherapeutics,   ',

    'NASDAQ symbol': 'ATRA',
  },
  {
    symbol: 'ATRC',
    'Security Name': 'AtriCure,   ',

    'NASDAQ symbol': 'ATRC',
  },
  {
    symbol: 'ATRI',
    'Security Name': 'Atrion Corporation  ',

    'NASDAQ symbol': 'ATRI',
  },
  {
    symbol: 'ATRO',
    'Security Name': 'Astronics Corporation  ',

    'NASDAQ symbol': 'ATRO',
  },
  {
    symbol: 'ATRS',
    'Security Name': 'Antares Pharma,   ',

    'NASDAQ symbol': 'ATRS',
  },
  {
    symbol: 'ATSG',
    'Security Name': 'Air Transport Services Group,   ',

    'NASDAQ symbol': 'ATSG',
  },
  {
    symbol: 'ATTO',
    'Security Name': 'Atento SA Ordinary Shares',

    'CQS symbol': 'ATTO',
    'NASDAQ symbol': 'ATTO',
  },
  {
    symbol: 'ATUS',
    'Security Name': 'Altice USA,   ',

    'CQS symbol': 'ATUS',
    'NASDAQ symbol': 'ATUS',
  },
  {
    symbol: 'ATV',
    'Security Name': 'Acorn International,  ADS',

    'CQS symbol': 'ATV',
    'NASDAQ symbol': 'ATV',
  },
  {
    symbol: 'ATVI',
    'Security Name': 'Activision Blizzard,   ',

    'NASDAQ symbol': 'ATVI',
  },
  {
    symbol: 'ATXI',
    'Security Name': 'Avenue Therapeutics,   ',

    'NASDAQ symbol': 'ATXI',
  },
  {
    symbol: 'AU',
    'Security Name': 'AngloGold Ashanti Limited ',

    'CQS symbol': 'AU',
    'NASDAQ symbol': 'AU',
  },
  {
    symbol: 'AUB',
    'Security Name': 'Atlantic Union Bankshares Corporation  ',

    'NASDAQ symbol': 'AUB',
  },
  {
    symbol: 'AUBAP',
    'Security Name':
      'Atlantic Union Bankshares Corporation  Depositary Shares each representing a 1/400th ownership interest in a share of 6875%Perpetual NonCumulative Preferred Stock, Series A',

    'NASDAQ symbol': 'AUBAP',
  },
  {
    symbol: 'AUBN',
    'Security Name': 'Auburn National Bancorporation,   ',

    'NASDAQ symbol': 'AUBN',
  },
  {
    symbol: 'AUDC',
    'Security Name': 'AudioCodes Ltd  Ordinary Shares',

    'NASDAQ symbol': 'AUDC',
  },
  {
    symbol: 'AUGZ',
    'Security Name': 'TrueShares Structured Outcome (August) ETF',

    'CQS symbol': 'AUGZ',
    'NASDAQ symbol': 'AUGZ',
  },
  {
    symbol: 'AUMN',
    'Security Name': 'Golden Minerals Company ',

    'CQS symbol': 'AUMN',
    'NASDAQ symbol': 'AUMN',
  },
  {
    symbol: 'AUPH',
    'Security Name': 'Aurinia Pharmaceuticals   Common Shares',

    'NASDAQ symbol': 'AUPH',
  },
  {
    symbol: 'AUSF',
    'Security Name': 'Global X Funds Global X Adaptive US Factor ETF',

    'CQS symbol': 'AUSF',
    'NASDAQ symbol': 'AUSF',
  },
  {
    symbol: 'AUTL',
    'Security Name': 'Autolus Therapeutics plc  American Depositary Shares',

    'NASDAQ symbol': 'AUTL',
  },
  {
    symbol: 'AUTO',
    'Security Name': 'AutoWeb,   ',

    'NASDAQ symbol': 'AUTO',
  },
  {
    symbol: 'AUVI',
    'Security Name': 'Applied UV,   ',

    'NASDAQ symbol': 'AUVI',
  },
  {
    symbol: 'AUY',
    'Security Name': 'Yamana Gold  Ordinary Shares (Canada)',

    'CQS symbol': 'AUY',
    'NASDAQ symbol': 'AUY',
  },
  {
    symbol: 'AVA',
    'Security Name': 'Avista Corporation ',

    'CQS symbol': 'AVA',
    'NASDAQ symbol': 'AVA',
  },
  {
    symbol: 'AVAL',
    'Security Name':
      'Grupo Aval Acciones y Valores SA ADR (Each representing 20 preferred shares)',

    'CQS symbol': 'AVAL',
    'NASDAQ symbol': 'AVAL',
  },
  {
    symbol: 'AVAN',
    'Security Name': 'Avanti Acquisition Corp  Ordinary Shares',

    'CQS symbol': 'AVAN',
    'NASDAQ symbol': 'AVAN',
  },
  {
    symbol: 'AVANU',
    'Security Name':
      'Avanti Acquisition Corp Units, each consisting of one  ordinary share, and redeemable warrant',

    'CQS symbol': 'AVANU',
    'NASDAQ symbol': 'AVAN=',
  },
  {
    symbol: 'AVANW',
    'Security Name':
      'Avanti Acquisition Corp Redeemable Warrants, each whole warrant exercisable for one  ordinary share at an exercise price of $1150',

    'CQS symbol': 'AVANWS',
    'NASDAQ symbol': 'AVAN+',
  },
  {
    symbol: 'AVAV',
    'Security Name': 'AeroVironment,   ',

    'NASDAQ symbol': 'AVAV',
  },
  {
    symbol: 'AVB',
    'Security Name': 'AvalonBay Communities,  ',

    'CQS symbol': 'AVB',
    'NASDAQ symbol': 'AVB',
  },
  {
    symbol: 'AVCO',
    'Security Name': 'Avalon GloboCare Corp  ',

    'NASDAQ symbol': 'AVCO',
  },
  {
    symbol: 'AVCT',
    'Security Name': 'American Virtual Cloud Technologies,    ',

    'NASDAQ symbol': 'AVCT',
  },
  {
    symbol: 'AVCTW',
    'Security Name':
      'American Virtual Cloud Technologies,    Warrant expiring 4/7/2020',

    'NASDAQ symbol': 'AVCTW',
  },
  {
    symbol: 'AVD',
    'Security Name': 'American Vanguard Corporation  ($010 Par Value)',

    'CQS symbol': 'AVD',
    'NASDAQ symbol': 'AVD',
  },
  {
    symbol: 'AVDE',
    'Security Name': 'Avantis International Equity ETF',

    'CQS symbol': 'AVDE',
    'NASDAQ symbol': 'AVDE',
  },
  {
    symbol: 'AVDL',
    'Security Name':
      'Avadel Pharmaceuticals plc  American Depositary Shares each representing one Ordinary Share',

    'NASDAQ symbol': 'AVDL',
  },
  {
    symbol: 'AVDV',
    'Security Name': 'Avantis International Small Cap Value ETF',

    'CQS symbol': 'AVDV',
    'NASDAQ symbol': 'AVDV',
  },
  {
    symbol: 'AVEM',
    'Security Name': 'Avantis Emerging Markets Equity ETF',

    'CQS symbol': 'AVEM',
    'NASDAQ symbol': 'AVEM',
  },
  {
    symbol: 'AVEO',
    'Security Name': 'AVEO Pharmaceuticals,   ',

    'NASDAQ symbol': 'AVEO',
  },
  {
    symbol: 'AVGO',
    'Security Name': 'Broadcom   ',

    'NASDAQ symbol': 'AVGO',
  },
  {
    symbol: 'AVGOP',
    'Security Name':
      'Broadcom   800% Mandatory Convertible Preferred Stock, Series A',

    'NASDAQ symbol': 'AVGOP',
  },
  {
    symbol: 'AVGR',
    'Security Name': 'Avinger,   ',

    'NASDAQ symbol': 'AVGR',
  },
  {
    symbol: 'AVID',
    'Security Name': 'Avid Technology,   ',

    'NASDAQ symbol': 'AVID',
  },
  {
    symbol: 'AVIG',
    'Security Name': 'Avantis Core Fixed ome ETF',

    'CQS symbol': 'AVIG',
    'NASDAQ symbol': 'AVIG',
  },
  {
    symbol: 'AVIR',
    'Security Name': 'Atea Pharmaceuticals,   ',

    'NASDAQ symbol': 'AVIR',
  },
  {
    symbol: 'AVK',
    'Security Name': 'Advent Convertible and ome Fund',

    'CQS symbol': 'AVK',
    'NASDAQ symbol': 'AVK',
  },
  {
    symbol: 'AVLR',
    'Security Name': 'Avalara,  ',

    'CQS symbol': 'AVLR',
    'NASDAQ symbol': 'AVLR',
  },
  {
    symbol: 'AVNS',
    'Security Name': 'Avanos Medical,  ',

    'CQS symbol': 'AVNS',
    'NASDAQ symbol': 'AVNS',
  },
  {
    symbol: 'AVNT',
    'Security Name': 'Avient Corporation ',

    'CQS symbol': 'AVNT',
    'NASDAQ symbol': 'AVNT',
  },
  {
    symbol: 'AVNW',
    'Security Name': 'Aviat Networks,   ',

    'NASDAQ symbol': 'AVNW',
  },
  {
    symbol: 'AVO',
    'Security Name': 'Mission Produce,   ',

    'NASDAQ symbol': 'AVO',
  },
  {
    symbol: 'AVRO',
    'Security Name': 'AVROBIO,   ',

    'NASDAQ symbol': 'AVRO',
  },
  {
    symbol: 'AVSF',
    'Security Name': 'Avantis ShortTerm Fixed ome ETF',

    'CQS symbol': 'AVSF',
    'NASDAQ symbol': 'AVSF',
  },
  {
    symbol: 'AVT',
    'Security Name': 'Avnet,   ',

    'NASDAQ symbol': 'AVT',
  },
  {
    symbol: 'AVTR',
    'Security Name': 'Avantor,  ',

    'CQS symbol': 'AVTR',
    'NASDAQ symbol': 'AVTR',
  },
  {
    symbol: 'AVTR$A',
    'Security Name': 'Avantor,  Series A Mandatory Convertible Preferred Stock',

    'CQS symbol': 'AVTRpA',
    'NASDAQ symbol': 'AVTRA',
  },
  {
    symbol: 'AVUS',
    'Security Name': 'Avantis US Equity ETF',

    'CQS symbol': 'AVUS',
    'NASDAQ symbol': 'AVUS',
  },
  {
    symbol: 'AVUV',
    'Security Name': 'Avantis US Small Cap Value ETF',

    'CQS symbol': 'AVUV',
    'NASDAQ symbol': 'AVUV',
  },
  {
    symbol: 'AVXL',
    'Security Name': 'Anavex Life Sciences Corp  ',

    'NASDAQ symbol': 'AVXL',
  },
  {
    symbol: 'AVY',
    'Security Name': 'Avery Dennison Corporation ',

    'CQS symbol': 'AVY',
    'NASDAQ symbol': 'AVY',
  },
  {
    symbol: 'AVYA',
    'Security Name': 'Avaya Holdings Corp ',

    'CQS symbol': 'AVYA',
    'NASDAQ symbol': 'AVYA',
  },
  {
    symbol: 'AWAY',
    'Security Name': 'ETFMG Travel Tech ETF',

    'CQS symbol': 'AWAY',
    'NASDAQ symbol': 'AWAY',
  },
  {
    symbol: 'AWF',
    'Security Name': 'Alliancebernstein Global High ome Fund',

    'CQS symbol': 'AWF',
    'NASDAQ symbol': 'AWF',
  },
  {
    symbol: 'AWH',
    'Security Name': "Aspira Women's Health   ",

    'NASDAQ symbol': 'AWH',
  },
  {
    symbol: 'AWI',
    'Security Name': 'Armstrong World Industries  ',

    'CQS symbol': 'AWI',
    'NASDAQ symbol': 'AWI',
  },
  {
    symbol: 'AWK',
    'Security Name': 'American Water Works Company,  ',

    'CQS symbol': 'AWK',
    'NASDAQ symbol': 'AWK',
  },
  {
    symbol: 'AWP',
    'Security Name':
      'Aberdeen Global Premier Properties Fund Common Shares of Beneficial Interest',

    'CQS symbol': 'AWP',
    'NASDAQ symbol': 'AWP',
  },
  {
    symbol: 'AWR',
    'Security Name': 'American States Water Company ',

    'CQS symbol': 'AWR',
    'NASDAQ symbol': 'AWR',
  },
  {
    symbol: 'AWRE',
    'Security Name': 'Aware,   ',

    'NASDAQ symbol': 'AWRE',
  },
  {
    symbol: 'AWTM',
    'Security Name': 'Aware UltraShort Duration Enhanced ome ETF',

    'CQS symbol': 'AWTM',
    'NASDAQ symbol': 'AWTM',
  },
  {
    symbol: 'AWX',
    'Security Name': 'Avalon Holdings Corporation ',

    'CQS symbol': 'AWX',
    'NASDAQ symbol': 'AWX',
  },
  {
    symbol: 'AX',
    'Security Name': 'Axos Financial,  ',

    'CQS symbol': 'AX',
    'NASDAQ symbol': 'AX',
  },
  {
    symbol: 'AXAS',
    'Security Name': 'Abraxas Petroleum Corporation  ',

    'NASDAQ symbol': 'AXAS',
  },
  {
    symbol: 'AXDX',
    'Security Name': 'Accelerate Diagnostics,   ',

    'NASDAQ symbol': 'AXDX',
  },
  {
    symbol: 'AXGN',
    'Security Name': 'Axogen,   ',

    'NASDAQ symbol': 'AXGN',
  },
  {
    symbol: 'AXL',
    'Security Name': 'American Axle & Manufacturing Holdings,  ',

    'CQS symbol': 'AXL',
    'NASDAQ symbol': 'AXL',
  },
  {
    symbol: 'AXLA',
    'Security Name': 'Axcella Health   ',

    'NASDAQ symbol': 'AXLA',
  },
  {
    symbol: 'AXNX',
    'Security Name': 'Axonics Modulation Technologies,   ',

    'NASDAQ symbol': 'AXNX',
  },
  {
    symbol: 'AXO',
    'Security Name': 'Axos Financial,  625% Subordinated Notes Due 2026',

    'CQS symbol': 'AXO',
    'NASDAQ symbol': 'AXO',
  },
  {
    symbol: 'AXP',
    'Security Name': 'American Express Company ',

    'CQS symbol': 'AXP',
    'NASDAQ symbol': 'AXP',
  },
  {
    symbol: 'AXR',
    'Security Name': 'AMREP Corporation ',

    'CQS symbol': 'AXR',
    'NASDAQ symbol': 'AXR',
  },
  {
    symbol: 'AXS',
    'Security Name': 'Axis Capital Holdings Limited ',

    'CQS symbol': 'AXS',
    'NASDAQ symbol': 'AXS',
  },
  {
    symbol: 'AXS$E',
    'Security Name':
      'Axis Capital Holdings Limited Depositary Shares, each representing 1/100th interest in a share of a 550% Series E Preferred Shares',

    'CQS symbol': 'AXSpE',
    'NASDAQ symbol': 'AXSE',
  },
  {
    symbol: 'AXSM',
    'Security Name': 'Axsome Therapeutics,   ',

    'NASDAQ symbol': 'AXSM',
  },
  {
    symbol: 'AXTA',
    'Security Name': 'Axalta Coating Systems Ltd Common Shares',

    'CQS symbol': 'AXTA',
    'NASDAQ symbol': 'AXTA',
  },
  {
    symbol: 'AXTI',
    'Security Name': 'AXT   ',

    'NASDAQ symbol': 'AXTI',
  },
  {
    symbol: 'AXU',
    'Security Name': 'Alexco Resource Corp Common Shares (Canada)',

    'CQS symbol': 'AXU',
    'NASDAQ symbol': 'AXU',
  },
  {
    symbol: 'AY',
    'Security Name':
      'Atlantica Sustainable Infrastructure plc  Ordinary Shares',

    'NASDAQ symbol': 'AY',
  },
  {
    symbol: 'AYI',
    'Security Name': 'Acuity Brands,  ',

    'CQS symbol': 'AYI',
    'NASDAQ symbol': 'AYI',
  },
  {
    symbol: 'AYLA',
    'Security Name': 'Ayala Pharmaceuticals,   ',

    'NASDAQ symbol': 'AYLA',
  },
  {
    symbol: 'AYRO',
    'Security Name': 'AYRO,   ',

    'NASDAQ symbol': 'AYRO',
  },
  {
    symbol: 'AYTU',
    'Security Name': 'Aytu BioScience,   ',

    'NASDAQ symbol': 'AYTU',
  },
  {
    symbol: 'AYX',
    'Security Name': 'Alteryx,   ',

    'CQS symbol': 'AYX',
    'NASDAQ symbol': 'AYX',
  },
  {
    symbol: 'AZAA',
    'Security Name': 'AllianzIM US Large Cap Buffer10 Apr ETF',

    'CQS symbol': 'AZAA',
    'NASDAQ symbol': 'AZAA',
  },
  {
    symbol: 'AZAL',
    'Security Name': 'AllianzIM US Large Cap Buffer10 Jul ETF',

    'CQS symbol': 'AZAL',
    'NASDAQ symbol': 'AZAL',
  },
  {
    symbol: 'AZAO',
    'Security Name': 'AllianzIM US Large Cap Buffer10 Oct ETF',

    'CQS symbol': 'AZAO',
    'NASDAQ symbol': 'AZAO',
  },
  {
    symbol: 'AZBA',
    'Security Name': 'AllianzIM US Large Cap Buffer20 Apr ETF',

    'CQS symbol': 'AZBA',
    'NASDAQ symbol': 'AZBA',
  },
  {
    symbol: 'AZBL',
    'Security Name': 'AllianzIM US Large Cap Buffer20 Jul ETF',

    'CQS symbol': 'AZBL',
    'NASDAQ symbol': 'AZBL',
  },
  {
    symbol: 'AZBO',
    'Security Name': 'AllianzIM US Large Cap Buffer20 Oct ETF',

    'CQS symbol': 'AZBO',
    'NASDAQ symbol': 'AZBO',
  },
  {
    symbol: 'AZEK',
    'Security Name': 'The AZEK Company   ',

    'CQS symbol': 'AZEK',
    'NASDAQ symbol': 'AZEK',
  },
  {
    symbol: 'AZN',
    'Security Name': 'AstraZeneca PLC  American Depositary Shares',

    'NASDAQ symbol': 'AZN',
  },
  {
    symbol: 'AZO',
    'Security Name': 'AutoZone,  ',

    'CQS symbol': 'AZO',
    'NASDAQ symbol': 'AZO',
  },
  {
    symbol: 'AZPN',
    'Security Name': 'Aspen Technology,   ',

    'Financial Status': 'E',
    'NASDAQ symbol': 'AZPN',
  },
  {
    symbol: 'AZRE',
    'Security Name': 'Azure Power Global Limited Equity Shares',

    'CQS symbol': 'AZRE',
    'NASDAQ symbol': 'AZRE',
  },
  {
    symbol: 'AZRX',
    'Security Name': 'AzurRx BioPharma,   ',

    'NASDAQ symbol': 'AZRX',
  },
  {
    symbol: 'AZUL',
    'Security Name':
      'Azul SA American Depositary Shares (each representing three preferred shares)',

    'CQS symbol': 'AZUL',
    'NASDAQ symbol': 'AZUL',
  },
  {
    symbol: 'AZYO',
    'Security Name': 'Aziyo Biologics,    ',

    'NASDAQ symbol': 'AZYO',
  },
  {
    symbol: 'AZZ',
    'Security Name': 'AZZ ',

    'CQS symbol': 'AZZ',
    'NASDAQ symbol': 'AZZ',
  },
  {
    symbol: 'B',
    'Security Name': 'Barnes Group,  ',

    'CQS symbol': 'B',
    'NASDAQ symbol': 'B',
  },
  {
    symbol: 'BA',
    'Security Name': 'Boeing Company (The) ',

    'CQS symbol': 'BA',
    'NASDAQ symbol': 'BA',
  },
  {
    symbol: 'BAB',
    'Security Name': 'Invesco Taxable Municipal Bond ETF',

    'CQS symbol': 'BAB',
    'NASDAQ symbol': 'BAB',
  },
  {
    symbol: 'BABA',
    'Security Name':
      'Alibaba Group Holding Limited American Depositary Shares each representing eight Ordinary share',

    'CQS symbol': 'BABA',
    'NASDAQ symbol': 'BABA',
  },
  {
    symbol: 'BAC',
    'Security Name': 'Bank of America Corporation ',

    'CQS symbol': 'BAC',
    'NASDAQ symbol': 'BAC',
  },
  {
    symbol: 'BAC$A',
    'Security Name':
      'Bank of America Corporation Depositary Shares, each representing a 1/1,000 th interest in a share of Bank of America Corporation 6000% NonCumulative',

    'CQS symbol': 'BACpA',
    'NASDAQ symbol': 'BACA',
  },
  {
    symbol: 'BAC$B',
    'Security Name':
      'Bank of America Corporation Depositary Shares, each representing a 1/1,000th interest in a share of 6000% NonCumulative Preferred Stock, Series GG',

    'CQS symbol': 'BACpB',
    'NASDAQ symbol': 'BACB',
  },
  {
    symbol: 'BAC$C',
    'Security Name':
      'Bank of America Corporation Depositary Shares, each representing a 1/1,000th interest in a share of 6200% NonCumulative Preferred Stock, Series C',

    'CQS symbol': 'BACpC',
    'NASDAQ symbol': 'BACC',
  },
  {
    symbol: 'BAC$E',
    'Security Name':
      'Bank of America Corporation Depositary Sh repstg 1/1000th Perp Pfd Ser E',

    'CQS symbol': 'BACpE',
    'NASDAQ symbol': 'BACE',
  },
  {
    symbol: 'BAC$K',
    'Security Name':
      'Bank of America Corporation Depositary Shares, each representing a 1/1,000th interest in a share of 5875% Non Cumulative Preferred Stock, Series HH',

    'CQS symbol': 'BACpK',
    'NASDAQ symbol': 'BACK',
  },
  {
    symbol: 'BAC$L',
    'Security Name':
      'Bank of America Corporation Non Cumulative Perpetual Conv Pfd Ser L',

    'Round Lot Size': '10',

    'CQS symbol': 'BACpL',
    'NASDAQ symbol': 'BACL',
  },
  {
    symbol: 'BAC$M',
    'Security Name':
      'Bank of America Corporation Depositary Shares, each representing a 1/1,000th interest in a share of 5375% NonCumulative Preferred Stock, Series KK',

    'CQS symbol': 'BACpM',
    'NASDAQ symbol': 'BACM',
  },
  {
    symbol: 'BAC$N',
    'Security Name':
      'Bank of America Corporation Depositary shares, each representing 1/1,000th interest in a share of 5000% NonCumulative Preferred Stock, Series LL',

    'CQS symbol': 'BACpN',
    'NASDAQ symbol': 'BACN',
  },
  {
    symbol: 'BAC$O',
    'Security Name':
      'Bank of America Corporation Depositary shares, each representing 1/1,000th interest in a share of 4375% NonCumulative Preferred Stock, Series NN',

    'CQS symbol': 'BACpO',
    'NASDAQ symbol': 'BACO',
  },
  {
    symbol: 'BAF',
    'Security Name': 'BlackRock Municipal ome Investment Quality Trust',

    'CQS symbol': 'BAF',
    'NASDAQ symbol': 'BAF',
  },
  {
    symbol: 'BAH',
    'Security Name': 'Booz Allen Hamilton Holding Corporation ',

    'CQS symbol': 'BAH',
    'NASDAQ symbol': 'BAH',
  },
  {
    symbol: 'BAK',
    'Security Name': 'Braskem SA ADR',

    'CQS symbol': 'BAK',
    'NASDAQ symbol': 'BAK',
  },
  {
    symbol: 'BAL',
    'Security Name':
      'iPathA Series B Bloomberg Cotton Subindex Total Return ETN',

    'CQS symbol': 'BAL',
    'NASDAQ symbol': 'BAL',
  },
  {
    symbol: 'BALY',
    'Security Name': "Bally's Corporation ",

    'CQS symbol': 'BALY',
    'NASDAQ symbol': 'BALY',
  },
  {
    symbol: 'BAM',
    'Security Name': 'Brookfield Asset Management  ',

    'CQS symbol': 'BAM',
    'NASDAQ symbol': 'BAM',
  },
  {
    symbol: 'BAMH',
    'Security Name':
      'Brookfield Finance  4625% Subordinated Notes due October 16, 2080',

    'CQS symbol': 'BAMH',
    'NASDAQ symbol': 'BAMH',
  },
  {
    symbol: 'BAMI',
    'Security Name': 'Brookfield Finance  450% Perpetual Subordinated Notes',

    'CQS symbol': 'BAMI',
    'NASDAQ symbol': 'BAMI',
  },
  {
    symbol: 'BANC',
    'Security Name': 'Banc of California,  ',

    'CQS symbol': 'BANC',
    'NASDAQ symbol': 'BANC',
  },
  {
    symbol: 'BANC$D',
    'Security Name':
      'Banc of California,  Depositary Shares each representing a 1/40th interest in a share of 7375% NonCumulative Perpetual Preferred Stock, Series D',

    'CQS symbol': 'BANCpD',
    'NASDAQ symbol': 'BANCD',
  },
  {
    symbol: 'BANC$E',
    'Security Name':
      'Banc of California,  Depositary Shares Each Representing a 1/40th Interest in a Share of 7000% NonCumulative Perpetual Preferred Stock, Series E',

    'CQS symbol': 'BANCpE',
    'NASDAQ symbol': 'BANCE',
  },
  {
    symbol: 'BAND',
    'Security Name': 'Bandwidth    ',

    'NASDAQ symbol': 'BAND',
  },
  {
    symbol: 'BANF',
    'Security Name': 'BancFirst Corporation  ',

    'NASDAQ symbol': 'BANF',
  },
  {
    symbol: 'BANFP',
    'Security Name':
      'BancFirst Corporation  72% Cumulative Trust Preferred Securities',

    'NASDAQ symbol': 'BANFP',
  },
  {
    symbol: 'BANR',
    'Security Name': 'Banner Corporation  ',

    'NASDAQ symbol': 'BANR',
  },
  {
    symbol: 'BANX',
    'Security Name': 'StoneCastle Financial Corp  ',

    'NASDAQ symbol': 'BANX',
  },
  {
    symbol: 'BAP',
    'Security Name': 'Credicorp Ltd ',

    'CQS symbol': 'BAP',
    'NASDAQ symbol': 'BAP',
  },
  {
    symbol: 'BAPR',
    'Security Name': 'Innovator S&P 500 Buffer ETF  April ',

    'CQS symbol': 'BAPR',
    'NASDAQ symbol': 'BAPR',
  },
  {
    symbol: 'BAR',
    'Security Name': 'GraniteShares Gold Trust Shares of Beneficial Interest',

    'CQS symbol': 'BAR',
    'NASDAQ symbol': 'BAR',
  },
  {
    symbol: 'BASI',
    'Security Name': 'Bioanalytical Systems,   ',

    'NASDAQ symbol': 'BASI',
  },
  {
    symbol: 'BATL',
    'Security Name': 'Battalion Oil Corporation ',

    'CQS symbol': 'BATL',
    'NASDAQ symbol': 'BATL',
  },
  {
    symbol: 'BATRA',
    'Security Name': 'Liberty Media Corporation  Series A Liberty Braves ',

    'NASDAQ symbol': 'BATRA',
  },
  {
    symbol: 'BATRK',
    'Security Name': 'Liberty Media Corporation  Series C Liberty Braves ',

    'NASDAQ symbol': 'BATRK',
  },
  {
    symbol: 'BATT',
    'Security Name': 'Amplify Lithium & Battery Technology ETF',

    'CQS symbol': 'BATT',
    'NASDAQ symbol': 'BATT',
  },
  {
    symbol: 'BAUG',
    'Security Name': 'Innovator S&P 500 Buffer ETF  August',

    'CQS symbol': 'BAUG',
    'NASDAQ symbol': 'BAUG',
  },
  {
    symbol: 'BAX',
    'Security Name': 'Baxter International  ',

    'CQS symbol': 'BAX',
    'NASDAQ symbol': 'BAX',
  },
  {
    symbol: 'BB',
    'Security Name': 'BlackBerry Limited ',

    'CQS symbol': 'BB',
    'NASDAQ symbol': 'BB',
  },
  {
    symbol: 'BBAR',
    'Security Name': 'Banco BBVA Argentina SA ADS',

    'CQS symbol': 'BBAR',
    'NASDAQ symbol': 'BBAR',
  },
  {
    symbol: 'BBAX',
    'Security Name': 'JPMorgan BetaBuilders Developed Asiaex Japan ETF ',

    'CQS symbol': 'BBAX',
    'NASDAQ symbol': 'BBAX',
  },
  {
    symbol: 'BBBY',
    'Security Name': 'Bed Bath & Beyond   ',

    'NASDAQ symbol': 'BBBY',
  },
  {
    symbol: 'BBC',
    'Security Name': 'Virtus LifeSci Biotech Clinical Trials ETF',

    'CQS symbol': 'BBC',
    'NASDAQ symbol': 'BBC',
  },
  {
    symbol: 'BBCA',
    'Security Name': 'JPMorgan BetaBuilders Canada ETF ',

    'CQS symbol': 'BBCA',
    'NASDAQ symbol': 'BBCA',
  },
  {
    symbol: 'BBCP',
    'Security Name': 'Concrete Pumping Holdings,    ',

    'NASDAQ symbol': 'BBCP',
  },
  {
    symbol: 'BBD',
    'Security Name': 'Banco Bradesco Sa American Depositary Shares',

    'CQS symbol': 'BBD',
    'NASDAQ symbol': 'BBD',
  },
  {
    symbol: 'BBDC',
    'Security Name': 'Barings BDC,  ',

    'CQS symbol': 'BBDC',
    'NASDAQ symbol': 'BBDC',
  },
  {
    symbol: 'BBDO',
    'Security Name':
      'Banco Bradesco Sa American Depositary Shares (each representing one Common Share)',

    'CQS symbol': 'BBDO',
    'NASDAQ symbol': 'BBDO',
  },
  {
    symbol: 'BBEU',
    'Security Name': 'JPMorgan BetaBuilders Europe ETF ',

    'CQS symbol': 'BBEU',
    'NASDAQ symbol': 'BBEU',
  },
  {
    symbol: 'BBF',
    'Security Name': 'BlackRock Municipal ome Investment Trust',

    'CQS symbol': 'BBF',
    'NASDAQ symbol': 'BBF',
  },
  {
    symbol: 'BBGI',
    'Security Name': 'Beasley Broadcast Group,    ',

    'NASDAQ symbol': 'BBGI',
  },
  {
    symbol: 'BBH',
    'Security Name': 'VanEck Vectors Biotech ETF',

    'NASDAQ symbol': 'BBH',
  },
  {
    symbol: 'BBI',
    'Security Name': 'Brickell Biotech,   ',

    'NASDAQ symbol': 'BBI',
  },
  {
    symbol: 'BBIG',
    'Security Name': 'Vo Ventures,   ',

    'NASDAQ symbol': 'BBIG',
  },
  {
    symbol: 'BBIN',
    'Security Name': 'JPMorgan BetaBuilders International Equity ETF',

    'CQS symbol': 'BBIN',
    'NASDAQ symbol': 'BBIN',
  },
  {
    symbol: 'BBIO',
    'Security Name': 'BridgeBio Pharma,   ',

    'NASDAQ symbol': 'BBIO',
  },
  {
    symbol: 'BBJP',
    'Security Name': 'JPMorgan BetaBuilders Japan ETF ',

    'CQS symbol': 'BBJP',
    'NASDAQ symbol': 'BBJP',
  },
  {
    symbol: 'BBK',
    'Security Name': 'Blackrock Municipal Bond Trust',

    'CQS symbol': 'BBK',
    'NASDAQ symbol': 'BBK',
  },
  {
    symbol: 'BBL',
    'Security Name': 'BHP Group PlcSponsored ADR',

    'CQS symbol': 'BBL',
    'NASDAQ symbol': 'BBL',
  },
  {
    symbol: 'BBMC',
    'Security Name': 'JPMorgan BetaBuilders US Mid Cap Equity ETF',

    'CQS symbol': 'BBMC',
    'NASDAQ symbol': 'BBMC',
  },
  {
    symbol: 'BBN',
    'Security Name':
      'BlackRock Taxable Municipal Bond Trust Common Shares of Beneficial Interest',

    'CQS symbol': 'BBN',
    'NASDAQ symbol': 'BBN',
  },
  {
    symbol: 'BBP',
    'Security Name': 'Virtus LifeSci Biotech Products ETF',

    'CQS symbol': 'BBP',
    'NASDAQ symbol': 'BBP',
  },
  {
    symbol: 'BBQ',
    'Security Name': 'BBQ Holdings,    ',

    'NASDAQ symbol': 'BBQ',
  },
  {
    symbol: 'BBRE',
    'Security Name': 'JPMorgan BetaBuilders MSCI US REIT ETF ',

    'CQS symbol': 'BBRE',
    'NASDAQ symbol': 'BBRE',
  },
  {
    symbol: 'BBSA',
    'Security Name': 'JPMorgan BetaBuilders 15 Year US Aggregate Bond ETF ',

    'CQS symbol': 'BBSA',
    'NASDAQ symbol': 'BBSA',
  },
  {
    symbol: 'BBSC',
    'Security Name': 'JPMorgan BetaBuilders US Small Cap Equity ETF',

    'CQS symbol': 'BBSC',
    'NASDAQ symbol': 'BBSC',
  },
  {
    symbol: 'BBSI',
    'Security Name': 'Barrett Business Services,   ',

    'NASDAQ symbol': 'BBSI',
  },
  {
    symbol: 'BBU',
    'Security Name':
      'Brookfield Business Partners LP Limited Partnership Units ',

    'CQS symbol': 'BBU',
    'NASDAQ symbol': 'BBU',
  },
  {
    symbol: 'BBUS',
    'Security Name': 'JPMorgan BetaBuilders US Equity ETF',

    'CQS symbol': 'BBUS',
    'NASDAQ symbol': 'BBUS',
  },
  {
    symbol: 'BBVA',
    'Security Name': 'Banco Bilbao Vizcaya Argentaria SA ',

    'CQS symbol': 'BBVA',
    'NASDAQ symbol': 'BBVA',
  },
  {
    symbol: 'BBW',
    'Security Name': 'BuildABear Workshop,  ',

    'CQS symbol': 'BBW',
    'NASDAQ symbol': 'BBW',
  },
  {
    symbol: 'BBY',
    'Security Name': 'Best Buy Co,  ',

    'CQS symbol': 'BBY',
    'NASDAQ symbol': 'BBY',
  },
  {
    symbol: 'BC',
    'Security Name': 'Brunswick Corporation ',

    'CQS symbol': 'BC',
    'NASDAQ symbol': 'BC',
  },
  {
    symbol: 'BC$A',
    'Security Name': 'Brunswick Corporation 6500% Senior Notes due 2048',

    'CQS symbol': 'BCpA',
    'NASDAQ symbol': 'BCA',
  },
  {
    symbol: 'BC$B',
    'Security Name': 'Brunswick Corporation 6625% Senior Notes due 2049',

    'CQS symbol': 'BCpB',
    'NASDAQ symbol': 'BCB',
  },
  {
    symbol: 'BC$C',
    'Security Name': 'Brunswick Corporation 6375% Notes due 2049',

    'CQS symbol': 'BCpC',
    'NASDAQ symbol': 'BCC',
  },
  {
    symbol: 'BCAT',
    'Security Name':
      'BlackRock Capital Allocation Trust Common Shares of Beneficial Interest',

    'CQS symbol': 'BCAT',
    'NASDAQ symbol': 'BCAT',
  },
  {
    symbol: 'BCBP',
    'Security Name': 'BCB Bancorp,  (NJ)  ',

    'NASDAQ symbol': 'BCBP',
  },
  {
    symbol: 'BCC',
    'Security Name': 'Boise Cascade, LLC ',

    'CQS symbol': 'BCC',
    'NASDAQ symbol': 'BCC',
  },
  {
    symbol: 'BCD',
    'Security Name':
      'Aberdeen Standard Bloomberg All Commodity Longer Dated Strategy K1 Free ETF',

    'CQS symbol': 'BCD',
    'NASDAQ symbol': 'BCD',
  },
  {
    symbol: 'BCDA',
    'Security Name': 'BioCardia,   ',

    'NASDAQ symbol': 'BCDA',
  },
  {
    symbol: 'BCDAW',
    'Security Name': 'BioCardia,   Warrant',

    'NASDAQ symbol': 'BCDAW',
  },
  {
    symbol: 'BCE',
    'Security Name': 'BCE,  ',

    'CQS symbol': 'BCE',
    'NASDAQ symbol': 'BCE',
  },
  {
    symbol: 'BCEI',
    'Security Name': 'Bonanza Creek Energy,  ',

    'CQS symbol': 'BCEI',
    'NASDAQ symbol': 'BCEI',
  },
  {
    symbol: 'BCEL',
    'Security Name': 'Atreca,    ',

    'NASDAQ symbol': 'BCEL',
  },
  {
    symbol: 'BCH',
    'Security Name': 'Banco De Chile Banco De Chile ADS',

    'CQS symbol': 'BCH',
    'NASDAQ symbol': 'BCH',
  },
  {
    symbol: 'BCI',
    'Security Name':
      'Aberdeen Standard Bloomberg All Commodity Strategy K1 Free ETF',

    'CQS symbol': 'BCI',
    'NASDAQ symbol': 'BCI',
  },
  {
    symbol: 'BCLI',
    'Security Name': 'Brainstorm Cell Therapeutics   ',

    'NASDAQ symbol': 'BCLI',
  },
  {
    symbol: 'BCM',
    'Security Name': 'iPath Pure Beta Broad Commodity ETN',

    'CQS symbol': 'BCM',
    'NASDAQ symbol': 'BCM',
  },
  {
    symbol: 'BCML',
    'Security Name': 'BayCom Corp  ',

    'NASDAQ symbol': 'BCML',
  },
  {
    symbol: 'BCO',
    'Security Name': 'Brinks Company (The) ',

    'CQS symbol': 'BCO',
    'NASDAQ symbol': 'BCO',
  },
  {
    symbol: 'BCOR',
    'Security Name': 'Blucora,   ',

    'NASDAQ symbol': 'BCOR',
  },
  {
    symbol: 'BCOV',
    'Security Name': 'Brightcove   ',

    'NASDAQ symbol': 'BCOV',
  },
  {
    symbol: 'BCOW',
    'Security Name': '1895 Bancorp of Wisconsin,   ',

    'NASDAQ symbol': 'BCOW',
  },
  {
    symbol: 'BCPC',
    'Security Name': 'Balchem Corporation  ',

    'NASDAQ symbol': 'BCPC',
  },
  {
    symbol: 'BCRX',
    'Security Name': 'BioCryst Pharmaceuticals,   ',

    'NASDAQ symbol': 'BCRX',
  },
  {
    symbol: 'BCS',
    'Security Name': 'Barclays PLC ',

    'CQS symbol': 'BCS',
    'NASDAQ symbol': 'BCS',
  },
  {
    symbol: 'BCSF',
    'Security Name': 'Bain Capital Specialty Finance,  ',

    'CQS symbol': 'BCSF',
    'NASDAQ symbol': 'BCSF',
  },
  {
    symbol: 'BCTG',
    'Security Name': 'BCTG Acquisition Corp  ',

    'NASDAQ symbol': 'BCTG',
  },
  {
    symbol: 'BCV',
    'Security Name': 'Bancroft Fund, Ltd',

    'CQS symbol': 'BCV',
    'NASDAQ symbol': 'BCV',
  },
  {
    symbol: 'BCV$A',
    'Security Name':
      'Bancroft Fund Limited 5375% Series A Cumulative Preferred Shares',

    'CQS symbol': 'BCVpA',
    'NASDAQ symbol': 'BCVA',
  },
  {
    symbol: 'BCX',
    'Security Name': 'BlackRock Resources Common Shares of Beneficial Interest',

    'CQS symbol': 'BCX',
    'NASDAQ symbol': 'BCX',
  },
  {
    symbol: 'BCYC',
    'Security Name': 'Bicycle Therapeutics plc  American Depositary Shares',

    'NASDAQ symbol': 'BCYC',
  },
  {
    symbol: 'BDC',
    'Security Name': 'Belden  ',

    'CQS symbol': 'BDC',
    'NASDAQ symbol': 'BDC',
  },
  {
    symbol: 'BDCX',
    'Security Name':
      'ETRACS Quarterly Pay 15X  Leveraged Wells Fargo BDC Index ETN',

    'CQS symbol': 'BDCX',
    'NASDAQ symbol': 'BDCX',
  },
  {
    symbol: 'BDCY',
    'Security Name':
      'ETRACS 2xMonthly Leveraged Wells Fargo Diversified Business Development Company Index ETN Series B due October 21, 2049',

    'CQS symbol': 'BDCY',
    'NASDAQ symbol': 'BDCY',
  },
  {
    symbol: 'BDCZ',
    'Security Name':
      'ETRACS Wells Fargo Business Development Company Index ETN Series B due April 26, 2041',

    'CQS symbol': 'BDCZ',
    'NASDAQ symbol': 'BDCZ',
  },
  {
    symbol: 'BDEC',
    'Security Name': 'Innovator S&P 500 Buffer ETF  December',

    'CQS symbol': 'BDEC',
    'NASDAQ symbol': 'BDEC',
  },
  {
    symbol: 'BDGE',
    'Security Name': 'Bridge Bancorp,   ',

    'NASDAQ symbol': 'BDGE',
  },
  {
    symbol: 'BDJ',
    'Security Name': 'Blackrock Enhanced Equity Dividend Trust',

    'CQS symbol': 'BDJ',
    'NASDAQ symbol': 'BDJ',
  },
  {
    symbol: 'BDL',
    'Security Name': "Flanigan's Enterprises,  ",

    'CQS symbol': 'BDL',
    'NASDAQ symbol': 'BDL',
  },
  {
    symbol: 'BDN',
    'Security Name': 'Brandywine Realty Trust ',

    'CQS symbol': 'BDN',
    'NASDAQ symbol': 'BDN',
  },
  {
    symbol: 'BDR',
    'Security Name': 'Blonder Tongue Laboratories,  ',

    'CQS symbol': 'BDR',
    'NASDAQ symbol': 'BDR',
  },
  {
    symbol: 'BDRY',
    'Security Name': 'Breakwave Dry Bulk Shipping ETF',

    'CQS symbol': 'BDRY',
    'NASDAQ symbol': 'BDRY',
  },
  {
    symbol: 'BDSI',
    'Security Name': 'BioDelivery Sciences International,   ',

    'NASDAQ symbol': 'BDSI',
  },
  {
    symbol: 'BDSX',
    'Security Name': 'Biodesix,   ',

    'NASDAQ symbol': 'BDSX',
  },
  {
    symbol: 'BDTX',
    'Security Name': 'Black Diamond Therapeutics,   ',

    'NASDAQ symbol': 'BDTX',
  },
  {
    symbol: 'BDX',
    'Security Name': 'Becton, Dickinson and Company ',

    'CQS symbol': 'BDX',
    'NASDAQ symbol': 'BDX',
  },
  {
    symbol: 'BDXB',
    'Security Name':
      'Becton, Dickinson and Company Depositary Shares, each Representing a 1/20th Interest in a Share of 600% Mandatory Convertible Preferred Stock, Series B',

    'CQS symbol': 'BDXB',
    'NASDAQ symbol': 'BDXB',
  },
  {
    symbol: 'BE',
    'Security Name': 'Bloom Energy Corporation  ',

    'CQS symbol': 'BE',
    'NASDAQ symbol': 'BE',
  },
  {
    symbol: 'BEAM',
    'Security Name': 'Beam Therapeutics   ',

    'NASDAQ symbol': 'BEAM',
  },
  {
    symbol: 'BEAT',
    'Security Name': 'BioTelemetry,   ',

    'NASDAQ symbol': 'BEAT',
  },
  {
    symbol: 'BECN',
    'Security Name': 'Beacon Roofing Supply,   ',

    'NASDAQ symbol': 'BECN',
  },
  {
    symbol: 'BEDU',
    'Security Name':
      'Bright Scholar Education Holdings Limited American Depositary Shares, each  representing one  Ordinary Share',

    'CQS symbol': 'BEDU',
    'NASDAQ symbol': 'BEDU',
  },
  {
    symbol: 'BEEM',
    'Security Name': 'Beam Global  ',

    'NASDAQ symbol': 'BEEM',
  },
  {
    symbol: 'BEEMW',
    'Security Name': 'Beam Global  Warrant',

    'NASDAQ symbol': 'BEEMW',
  },
  {
    symbol: 'BEKE',
    'Security Name':
      'KE Holdings  American Depositary Shares (each representing three  Ordinary Shares)',

    'CQS symbol': 'BEKE',
    'NASDAQ symbol': 'BEKE',
  },
  {
    symbol: 'BELFA',
    'Security Name': 'Bel Fuse    ',

    'NASDAQ symbol': 'BELFA',
  },
  {
    symbol: 'BELFB',
    'Security Name': 'Bel Fuse   Class B ',

    'NASDAQ symbol': 'BELFB',
  },
  {
    symbol: 'BEN',
    'Security Name': 'Franklin Resources,  ',

    'CQS symbol': 'BEN',
    'NASDAQ symbol': 'BEN',
  },
  {
    symbol: 'BEP',
    'Security Name': 'Brookfield Renewable Partners LP ',

    'CQS symbol': 'BEP',
    'NASDAQ symbol': 'BEP',
  },
  {
    symbol: 'BEP$A',
    'Security Name':
      'Brookfield Renewable Partners LP 525%  Preferred Limited Partnership Units, Series 17',

    'CQS symbol': 'BEPpA',
    'NASDAQ symbol': 'BEPA',
  },
  {
    symbol: 'BEPC',
    'Security Name':
      'Brookfield Renewable Corporation  Subordinate Voting Shares ',

    'CQS symbol': 'BEPC',
    'NASDAQ symbol': 'BEPC',
  },
  {
    symbol: 'BERY',
    'Security Name': 'Berry Global Group,  ',

    'CQS symbol': 'BERY',
    'NASDAQ symbol': 'BERY',
  },
  {
    symbol: 'BEST',
    'Security Name':
      'BEST  American Depositary Shares, each representing one  Ordinary Share',

    'CQS symbol': 'BEST',
    'NASDAQ symbol': 'BEST',
  },
  {
    symbol: 'BETZ',
    'Security Name': 'Roundhill Sports Betting & iGaming ETF',

    'CQS symbol': 'BETZ',
    'NASDAQ symbol': 'BETZ',
  },
  {
    symbol: 'BFA',
    'Security Name': 'Brown Forman   ',

    'CQS symbol': 'BFA',
    'NASDAQ symbol': 'BFA',
  },
  {
    symbol: 'BFB',
    'Security Name': 'Brown Forman  Class B ',

    'CQS symbol': 'BFB',
    'NASDAQ symbol': 'BFB',
  },
  {
    symbol: 'BFAM',
    'Security Name': 'Bright Horizons Family Solutions  ',

    'CQS symbol': 'BFAM',
    'NASDAQ symbol': 'BFAM',
  },
  {
    symbol: 'BFC',
    'Security Name': 'Bank First Corporation  ',

    'NASDAQ symbol': 'BFC',
  },
  {
    symbol: 'BFEB',
    'Security Name': 'Innovator S&P 500 Buffer ETF  February',

    'CQS symbol': 'BFEB',
    'NASDAQ symbol': 'BFEB',
  },
  {
    symbol: 'BFIN',
    'Security Name': 'BankFinancial Corporation  ',

    'NASDAQ symbol': 'BFIN',
  },
  {
    symbol: 'BFIT',
    'Security Name': 'Global X Health & Wellness Thematic ETF',

    'NASDAQ symbol': 'BFIT',
  },
  {
    symbol: 'BFK',
    'Security Name': 'BlackRock Municipal ome Trust',

    'CQS symbol': 'BFK',
    'NASDAQ symbol': 'BFK',
  },
  {
    symbol: 'BFO',
    'Security Name': 'Blackrock Florida Municipal 2020 Term Trust',

    'CQS symbol': 'BFO',
    'NASDAQ symbol': 'BFO',
  },
  {
    symbol: 'BFOR',
    'Security Name': "Barron's 400",

    'CQS symbol': 'BFOR',
    'NASDAQ symbol': 'BFOR',
  },
  {
    symbol: 'BFRA',
    'Security Name': 'Biofrontera AG  American Depositary Shares',

    'NASDAQ symbol': 'BFRA',
  },
  {
    symbol: 'BFS',
    'Security Name': 'Saul Centers,  ',

    'CQS symbol': 'BFS',
    'NASDAQ symbol': 'BFS',
  },
  {
    symbol: 'BFS$D',
    'Security Name':
      'Saul Centers,  Depositary Shares, each representing 1/100th of a share of 6125% Series D Cumulative Redeemable Preferred Stock',

    'CQS symbol': 'BFSpD',
    'NASDAQ symbol': 'BFSD',
  },
  {
    symbol: 'BFS$E',
    'Security Name':
      'Saul Centers,  Depositary shares, each representing a 1/100th fractional interest in a share of 6000% Series E Cumulative Redeemable Preferred Stock',

    'CQS symbol': 'BFSpE',
    'NASDAQ symbol': 'BFSE',
  },
  {
    symbol: 'BFST',
    'Security Name': 'Business First Bancshares,   ',

    'NASDAQ symbol': 'BFST',
  },
  {
    symbol: 'BFT',
    'Security Name': 'Foley Trasimene Acquisition Corp II  ',

    'CQS symbol': 'BFT',
    'NASDAQ symbol': 'BFT',
  },
  {
    symbol: 'BFTU',
    'Security Name':
      'Foley Trasimene Acquisition Corp II Units, each consisting of one share of  , and onethird of one warrant',

    'CQS symbol': 'BFTU',
    'NASDAQ symbol': 'BFT=',
  },
  {
    symbol: 'BFTW',
    'Security Name':
      'Foley Trasimene Acquisition Corp II Warrants, each whole warrant exercisable for one share of   at an exercise price of $1150 per share',

    'CQS symbol': 'BFTWS',
    'NASDAQ symbol': 'BFT+',
  },
  {
    symbol: 'BFTR',
    'Security Name': 'BlackRock Future Innovators ETF',

    'CQS symbol': 'BFTR',
    'NASDAQ symbol': 'BFTR',
  },
  {
    symbol: 'BFY',
    'Security Name': 'BlackRock New York Municipal ome Trust II',

    'CQS symbol': 'BFY',
    'NASDAQ symbol': 'BFY',
  },
  {
    symbol: 'BFZ',
    'Security Name': 'BlackRock California Municipal ome Trust',

    'CQS symbol': 'BFZ',
    'NASDAQ symbol': 'BFZ',
  },
  {
    symbol: 'BG',
    'Security Name': 'Bunge Limited Bunge Limited',

    'CQS symbol': 'BG',
    'NASDAQ symbol': 'BG',
  },
  {
    symbol: 'BGB',
    'Security Name': 'Blackstone / GSO Strategic Credit Fund Common Shares',

    'CQS symbol': 'BGB',
    'NASDAQ symbol': 'BGB',
  },
  {
    symbol: 'BGCP',
    'Security Name': 'BGC Partners,    ',

    'NASDAQ symbol': 'BGCP',
  },
  {
    symbol: 'BGFV',
    'Security Name': 'Big 5 Sporting Goods Corporation  ',

    'NASDAQ symbol': 'BGFV',
  },
  {
    symbol: 'BGH',
    'Security Name':
      'Barings Global Short Duration High Yield Fund Common Shares of Beneficial Interests',

    'CQS symbol': 'BGH',
    'NASDAQ symbol': 'BGH',
  },
  {
    symbol: 'BGI',
    'Security Name': 'Birks Group  ',

    'CQS symbol': 'BGI',
    'NASDAQ symbol': 'BGI',
  },
  {
    symbol: 'BGIO',
    'Security Name':
      'BlackRock 2022 Global ome Opportunity Trust Common Shares of Beneficial Interest',

    'CQS symbol': 'BGIO',
    'NASDAQ symbol': 'BGIO',
  },
  {
    symbol: 'BGNE',
    'Security Name': 'BeiGene, Ltd  American Depositary Shares',

    'NASDAQ symbol': 'BGNE',
  },
  {
    symbol: 'BGR',
    'Security Name': 'BlackRock Energy and Resources Trust',

    'CQS symbol': 'BGR',
    'NASDAQ symbol': 'BGR',
  },
  {
    symbol: 'BGRN',
    'Security Name': 'iShares Global Green Bond ETF',

    'NASDAQ symbol': 'BGRN',
  },
  {
    symbol: 'BGS',
    'Security Name': 'B&G Foods,  B&G Foods,  ',

    'CQS symbol': 'BGS',
    'NASDAQ symbol': 'BGS',
  },
  {
    symbol: 'BGSF',
    'Security Name': 'BG Staffing  ',

    'CQS symbol': 'BGSF',
    'NASDAQ symbol': 'BGSF',
  },
  {
    symbol: 'BGT',
    'Security Name': 'BlackRock Floating Rate ome Trust',

    'CQS symbol': 'BGT',
    'NASDAQ symbol': 'BGT',
  },
  {
    symbol: 'BGX',
    'Security Name': 'Blackstone GSO Long Short Credit ome Fund Common Shares',

    'CQS symbol': 'BGX',
    'NASDAQ symbol': 'BGX',
  },
  {
    symbol: 'BGY',
    'Security Name': 'Blackrock Enhanced International Dividend Trust',

    'CQS symbol': 'BGY',
    'NASDAQ symbol': 'BGY',
  },
  {
    symbol: 'BH',
    'Security Name': 'Biglari Holdings  Class B ',

    'Round Lot Size': '10',

    'CQS symbol': 'BH',
    'NASDAQ symbol': 'BH',
  },
  {
    symbol: 'BHA',
    'Security Name': 'Biglari Holdings   ',

    'Round Lot Size': '10',

    'CQS symbol': 'BHA',
    'NASDAQ symbol': 'BHA',
  },
  {
    symbol: 'BHAT',
    'Security Name':
      'Blue Hat Interactive Entertainment Technology  Ordinary Shares',

    'NASDAQ symbol': 'BHAT',
  },
  {
    symbol: 'BHB',
    'Security Name': 'Bar Harbor Bankshares,  ',

    'CQS symbol': 'BHB',
    'NASDAQ symbol': 'BHB',
  },
  {
    symbol: 'BHC',
    'Security Name': 'Bausch Health Companies  ',

    'CQS symbol': 'BHC',
    'NASDAQ symbol': 'BHC',
  },
  {
    symbol: 'BHE',
    'Security Name': 'Benchmark Electronics,  ',

    'CQS symbol': 'BHE',
    'NASDAQ symbol': 'BHE',
  },
  {
    symbol: 'BHF',
    'Security Name': 'Brighthouse Financial,   ',

    'NASDAQ symbol': 'BHF',
  },
  {
    symbol: 'BHFAL',
    'Security Name':
      'Brighthouse Financial,   Junior Subordinated Debentures due 2058',

    'NASDAQ symbol': 'BHFAL',
  },
  {
    symbol: 'BHFAN',
    'Security Name':
      'Brighthouse Financial,   depositary shares, each representing a 1/1,000th interest in a share of 5375% NonCumulative Preferred Stock, Series C',

    'NASDAQ symbol': 'BHFAN',
  },
  {
    symbol: 'BHFAO',
    'Security Name':
      'Brighthouse Financial,   Depositary Shares, each representing a 1/1,000th interest in a share of 6750% NonCumulative Preferred Stock, Series B',

    'NASDAQ symbol': 'BHFAO',
  },
  {
    symbol: 'BHFAP',
    'Security Name':
      'Brighthouse Financial,   Depositary Shares 66% NonCumulative Preferred Stock, Series A',

    'NASDAQ symbol': 'BHFAP',
  },
  {
    symbol: 'BHK',
    'Security Name': 'Blackrock Core Bond Trust Blackrock Core Bond Trust',

    'CQS symbol': 'BHK',
    'NASDAQ symbol': 'BHK',
  },
  {
    symbol: 'BHLB',
    'Security Name': 'Berkshire Hills Bancorp,  ',

    'CQS symbol': 'BHLB',
    'NASDAQ symbol': 'BHLB',
  },
  {
    symbol: 'BHP',
    'Security Name':
      'BHP Group Limited American Depositary Shares (Each representing two Ordinary Shares)',

    'CQS symbol': 'BHP',
    'NASDAQ symbol': 'BHP',
  },
  {
    symbol: 'BHR',
    'Security Name': 'Braemar Hotels & Resorts  ',

    'CQS symbol': 'BHR',
    'NASDAQ symbol': 'BHR',
  },
  {
    symbol: 'BHR$B',
    'Security Name':
      'Braemar Hotels & Resorts  550% Series B Cumulative Convertible Preferred Stock, par value $001 per share',

    'CQS symbol': 'BHRpB',
    'NASDAQ symbol': 'BHRB',
  },
  {
    symbol: 'BHR$D',
    'Security Name':
      'Braemar Hotels & Resorts  825% Series D Cumulative Preferred Stock,  par value $001 per share',

    'CQS symbol': 'BHRpD',
    'NASDAQ symbol': 'BHRD',
  },
  {
    symbol: 'BHSEU',
    'Security Name': 'Bull Horn Holdings Corp  Unit',

    'NASDAQ symbol': 'BHSEU',
  },
  {
    symbol: 'BHTG',
    'Security Name': 'BioHiTech Global,   ',

    'NASDAQ symbol': 'BHTG',
  },
  {
    symbol: 'BHV',
    'Security Name': 'BlackRock Virginia Municipal Bond Trust',

    'CQS symbol': 'BHV',
    'NASDAQ symbol': 'BHV',
  },
  {
    symbol: 'BHVN',
    'Security Name':
      'Biohaven Pharmaceutical Holding Company Ltd Common Shares',

    'CQS symbol': 'BHVN',
    'NASDAQ symbol': 'BHVN',
  },
  {
    symbol: 'BIB',
    'Security Name': 'ProShares Ultra Nasdaq Biotechnology',

    'NASDAQ symbol': 'BIB',
  },
  {
    symbol: 'BIBL',
    'Security Name': 'Inspire 100 ETF',

    'CQS symbol': 'BIBL',
    'NASDAQ symbol': 'BIBL',
  },
  {
    symbol: 'BICK',
    'Security Name': 'First Trust BICK Index Fund',

    'NASDAQ symbol': 'BICK',
  },
  {
    symbol: 'BIDU',
    'Security Name':
      'Baidu,   American Depositary Shares, each representing one tenth  ordinary share',

    'NASDAQ symbol': 'BIDU',
  },
  {
    symbol: 'BIF',
    'Security Name': 'Boulder Growth & ome Fund, ',

    'CQS symbol': 'BIF',
    'NASDAQ symbol': 'BIF',
  },
  {
    symbol: 'BIG',
    'Security Name': 'Big Lots,  ',

    'CQS symbol': 'BIG',
    'NASDAQ symbol': 'BIG',
  },
  {
    symbol: 'BIGC',
    'Security Name': 'BigCommerce Holdings,   Series 1 ',

    'NASDAQ symbol': 'BIGC',
  },
  {
    symbol: 'BIIB',
    'Security Name': 'Biogen   ',

    'NASDAQ symbol': 'BIIB',
  },
  {
    symbol: 'BIL',
    'Security Name': 'SPDR Bloomberg Barclays 13 Month TBill ETF',

    'CQS symbol': 'BIL',
    'NASDAQ symbol': 'BIL',
  },
  {
    symbol: 'BILI',
    'Security Name': 'Bilibili   American Depositary Shares',

    'NASDAQ symbol': 'BILI',
  },
  {
    symbol: 'BILL',
    'Security Name': 'Billcom Holdings,  ',

    'CQS symbol': 'BILL',
    'NASDAQ symbol': 'BILL',
  },
  {
    symbol: 'BILS',
    'Security Name': 'SPDR Bloomberg Barclays 312 Month TBill ETF',

    'CQS symbol': 'BILS',
    'NASDAQ symbol': 'BILS',
  },
  {
    symbol: 'BIMI',
    'Security Name': 'BOQI International Medical   ',

    'NASDAQ symbol': 'BIMI',
  },
  {
    symbol: 'BIO',
    'Security Name': 'BioRad Laboratories,   ',

    'CQS symbol': 'BIO',
    'NASDAQ symbol': 'BIO',
  },
  {
    symbol: 'BIOB',
    'Security Name': 'BioRad Laboratories,  Class B  ',

    'CQS symbol': 'BIOB',
    'NASDAQ symbol': 'BIOB',
  },
  {
    symbol: 'BIOC',
    'Security Name': 'Biocept,   ',

    'NASDAQ symbol': 'BIOC',
  },
  {
    symbol: 'BIOL',
    'Security Name': 'Biolase,   ',

    'NASDAQ symbol': 'BIOL',
  },
  {
    symbol: 'BIOX',
    'Security Name': 'Bioceres Crop Solutions Corp Ordinary Shares',

    'CQS symbol': 'BIOX',
    'NASDAQ symbol': 'BIOX',
  },
  {
    symbol: 'BIP',
    'Security Name':
      'Brookfield Infrastructure Partners LP Limited Partnership Units',

    'CQS symbol': 'BIP',
    'NASDAQ symbol': 'BIP',
  },
  {
    symbol: 'BIP$A',
    'Security Name':
      'Brookfield Infrastructure Partners LP 5125%  Preferred Limited Partnership Units, Series 13',

    'CQS symbol': 'BIPpA',
    'NASDAQ symbol': 'BIPA',
  },
  {
    symbol: 'BIPC',
    'Security Name':
      'Brookfield Infrastructure Partners LP  Subordinate Voting Shares ',

    'CQS symbol': 'BIPC',
    'NASDAQ symbol': 'BIPC',
  },
  {
    symbol: 'BIS',
    'Security Name': 'ProShares UltraShort Nasdaq Biotechnology',

    'NASDAQ symbol': 'BIS',
  },
  {
    symbol: 'BIT',
    'Security Name':
      'BlackRock MultiSector ome Trust Common Shares of Beneficial Interest',

    'CQS symbol': 'BIT',
    'NASDAQ symbol': 'BIT',
  },
  {
    symbol: 'BIV',
    'Security Name': 'Vanguard IntermediateTerm Bond ETF',

    'CQS symbol': 'BIV',
    'NASDAQ symbol': 'BIV',
  },
  {
    symbol: 'BIVI',
    'Security Name': 'BioVie   ',

    'NASDAQ symbol': 'BIVI',
  },
  {
    symbol: 'BIZD',
    'Security Name': 'VanEck Vectors BDC ome ETF',

    'CQS symbol': 'BIZD',
    'NASDAQ symbol': 'BIZD',
  },
  {
    symbol: 'BJ',
    'Security Name': "BJ's Wholesale Club Holdings,  ",

    'CQS symbol': 'BJ',
    'NASDAQ symbol': 'BJ',
  },
  {
    symbol: 'BJAN',
    'Security Name': 'Innovator S&P 500 Buffer ETF  January',

    'CQS symbol': 'BJAN',
    'NASDAQ symbol': 'BJAN',
  },
  {
    symbol: 'BJK',
    'Security Name': 'VanEck Vectors Gaming ETF',

    'NASDAQ symbol': 'BJK',
  },
  {
    symbol: 'BJRI',
    'Security Name': "BJ's Restaurants,   ",

    'NASDAQ symbol': 'BJRI',
  },
  {
    symbol: 'BJUL',
    'Security Name': 'Innovator ETFs Trust Innovator S&P 500 Buffer ETF  July',

    'CQS symbol': 'BJUL',
    'NASDAQ symbol': 'BJUL',
  },
  {
    symbol: 'BJUN',
    'Security Name': 'Innovator S&P 500 Buffer ETF  June',

    'CQS symbol': 'BJUN',
    'NASDAQ symbol': 'BJUN',
  },
  {
    symbol: 'BK',
    'Security Name': 'The Bank of New York Mellon Corporation ',

    'CQS symbol': 'BK',
    'NASDAQ symbol': 'BK',
  },
  {
    symbol: 'BK$C',
    'Security Name':
      'Bank Of New York Mellon Corporation (The) Dep Shs Repstg 1/4000th Perp Pfd Ser C',

    'CQS symbol': 'BKpC',
    'NASDAQ symbol': 'BKC',
  },
  {
    symbol: 'BKAG',
    'Security Name': 'BNY Mellon Core Bond ETF',

    'CQS symbol': 'BKAG',
    'NASDAQ symbol': 'BKAG',
  },
  {
    symbol: 'BKCC',
    'Security Name': 'BlackRock Capital Investment Corporation  ',

    'NASDAQ symbol': 'BKCC',
  },
  {
    symbol: 'BKD',
    'Security Name': 'Brookdale Senior Living  ',

    'CQS symbol': 'BKD',
    'NASDAQ symbol': 'BKD',
  },
  {
    symbol: 'BKE',
    'Security Name': 'Buckle,  (The) ',

    'CQS symbol': 'BKE',
    'NASDAQ symbol': 'BKE',
  },
  {
    symbol: 'BKEM',
    'Security Name': 'BNY Mellon Emerging Markets Equity ETF',

    'CQS symbol': 'BKEM',
    'NASDAQ symbol': 'BKEM',
  },
  {
    symbol: 'BKEP',
    'Security Name':
      'Blueknight Energy Partners LP, LLC  Common Units representing Limited Partner Interests',

    'NASDAQ symbol': 'BKEP',
  },
  {
    symbol: 'BKEPP',
    'Security Name':
      'Blueknight Energy Partners LP, LLC  Series A Preferred Units',

    'NASDAQ symbol': 'BKEPP',
  },
  {
    symbol: 'BKF',
    'Security Name': 'iShares MSCI BRIC Index Fund',

    'CQS symbol': 'BKF',
    'NASDAQ symbol': 'BKF',
  },
  {
    symbol: 'BKH',
    'Security Name': 'Black Hills Corporation ',

    'CQS symbol': 'BKH',
    'NASDAQ symbol': 'BKH',
  },
  {
    symbol: 'BKHY',
    'Security Name': 'BNY Mellon High Yield Beta ETF',

    'CQS symbol': 'BKHY',
    'NASDAQ symbol': 'BKHY',
  },
  {
    symbol: 'BKI',
    'Security Name': 'Black Knight,   ',

    'CQS symbol': 'BKI',
    'NASDAQ symbol': 'BKI',
  },
  {
    symbol: 'BKIE',
    'Security Name': 'BNY Mellon International Equity ETF',

    'CQS symbol': 'BKIE',
    'NASDAQ symbol': 'BKIE',
  },
  {
    symbol: 'BKK',
    'Security Name': 'Blackrock Municipal 2020 Term Trust',

    'CQS symbol': 'BKK',
    'NASDAQ symbol': 'BKK',
  },
  {
    symbol: 'BKLC',
    'Security Name': 'BNY Mellon US Large Cap Core Equity ETF',

    'CQS symbol': 'BKLC',
    'NASDAQ symbol': 'BKLC',
  },
  {
    symbol: 'BKLN',
    'Security Name': 'Invesco Senior Loan ETF',

    'CQS symbol': 'BKLN',
    'NASDAQ symbol': 'BKLN',
  },
  {
    symbol: 'BKMC',
    'Security Name': 'BNY Mellon US Mid Cap Core Equity ETF',

    'CQS symbol': 'BKMC',
    'NASDAQ symbol': 'BKMC',
  },
  {
    symbol: 'BKN',
    'Security Name': 'BlackRock Investment Quality Municipal Trust  (The)',

    'CQS symbol': 'BKN',
    'NASDAQ symbol': 'BKN',
  },
  {
    symbol: 'BKNG',
    'Security Name': 'Booking Holdings   ',

    'NASDAQ symbol': 'BKNG',
  },
  {
    symbol: 'BKR',
    'Security Name': 'Baker Hughes Company  ',

    'CQS symbol': 'BKR',
    'NASDAQ symbol': 'BKR',
  },
  {
    symbol: 'BKSB',
    'Security Name': 'BNY Mellon Short Duration Corporate Bond ETF',

    'CQS symbol': 'BKSB',
    'NASDAQ symbol': 'BKSB',
  },
  {
    symbol: 'BKSC',
    'Security Name': 'Bank of South Carolina Corp  ',

    'NASDAQ symbol': 'BKSC',
  },
  {
    symbol: 'BKSE',
    'Security Name': 'BNY Mellon US Small Cap Core Equity ETF',

    'CQS symbol': 'BKSE',
    'NASDAQ symbol': 'BKSE',
  },
  {
    symbol: 'BKT',
    'Security Name': 'BlackRock ome Trust  (The)',

    'CQS symbol': 'BKT',
    'NASDAQ symbol': 'BKT',
  },
  {
    symbol: 'BKTI',
    'Security Name': 'BK Technologies Corporation ',

    'CQS symbol': 'BKTI',
    'NASDAQ symbol': 'BKTI',
  },
  {
    symbol: 'BKU',
    'Security Name': 'BankUnited,  ',

    'CQS symbol': 'BKU',
    'NASDAQ symbol': 'BKU',
  },
  {
    symbol: 'BKYI',
    'Security Name': 'BIOkey International,   ',

    'NASDAQ symbol': 'BKYI',
  },
  {
    symbol: 'BL',
    'Security Name': 'BlackLine,   ',

    'NASDAQ symbol': 'BL',
  },
  {
    symbol: 'BLBD',
    'Security Name': 'Blue Bird Corporation  ',

    'NASDAQ symbol': 'BLBD',
  },
  {
    symbol: 'BLCM',
    'Security Name': 'Bellicum Pharmaceuticals,   ',

    'NASDAQ symbol': 'BLCM',
  },
  {
    symbol: 'BLCN',
    'Security Name': 'Siren Nasdaq NexGen Economy ETF',

    'NASDAQ symbol': 'BLCN',
  },
  {
    symbol: 'BLCT',
    'Security Name': 'BlueCity Holdings Limited  American Depositary Shares',

    'NASDAQ symbol': 'BLCT',
  },
  {
    symbol: 'BLD',
    'Security Name': 'TopBuild Corp ',

    'CQS symbol': 'BLD',
    'NASDAQ symbol': 'BLD',
  },
  {
    symbol: 'BLDG',
    'Security Name': 'Cambria Global Real Estate ETF',

    'CQS symbol': 'BLDG',
    'NASDAQ symbol': 'BLDG',
  },
  {
    symbol: 'BLDP',
    'Security Name': 'Ballard Power Systems,   Common Shares',

    'NASDAQ symbol': 'BLDP',
  },
  {
    symbol: 'BLDR',
    'Security Name': 'Builders FirstSource,   ',

    'NASDAQ symbol': 'BLDR',
  },
  {
    symbol: 'BLE',
    'Security Name': 'BlackRock Municipal ome Trust II',

    'CQS symbol': 'BLE',
    'NASDAQ symbol': 'BLE',
  },
  {
    symbol: 'BLES',
    'Security Name': 'Inspire Global Hope ETF',

    'CQS symbol': 'BLES',
    'NASDAQ symbol': 'BLES',
  },
  {
    symbol: 'BLFS',
    'Security Name': 'BioLife Solutions,   ',

    'NASDAQ symbol': 'BLFS',
  },
  {
    symbol: 'BLHY',
    'Security Name': 'Virtus Newfleet Dynamic Credit',

    'CQS symbol': 'BLHY',
    'NASDAQ symbol': 'BLHY',
  },
  {
    symbol: 'BLI',
    'Security Name': 'Berkeley Lights,   ',

    'NASDAQ symbol': 'BLI',
  },
  {
    symbol: 'BLIN',
    'Security Name': 'Bridgeline Digital,   ',

    'NASDAQ symbol': 'BLIN',
  },
  {
    symbol: 'BLK',
    'Security Name': 'BlackRock,  ',

    'CQS symbol': 'BLK',
    'NASDAQ symbol': 'BLK',
  },
  {
    symbol: 'BLKB',
    'Security Name': 'Blackbaud,   ',

    'NASDAQ symbol': 'BLKB',
  },
  {
    symbol: 'BLL',
    'Security Name': 'Ball Corporation ',

    'CQS symbol': 'BLL',
    'NASDAQ symbol': 'BLL',
  },
  {
    symbol: 'BLMN',
    'Security Name': "Bloomin' Brands,   ",

    'NASDAQ symbol': 'BLMN',
  },
  {
    symbol: 'BLNK',
    'Security Name': 'Blink Charging Co  ',

    'NASDAQ symbol': 'BLNK',
  },
  {
    symbol: 'BLNKW',
    'Security Name': 'Blink Charging Co  Warrant',

    'NASDAQ symbol': 'BLNKW',
  },
  {
    symbol: 'BLOK',
    'Security Name': 'Amplify Transformational Data Sharing ETF',

    'CQS symbol': 'BLOK',
    'NASDAQ symbol': 'BLOK',
  },
  {
    symbol: 'BLPH',
    'Security Name': 'Bellerophon Therapeutics,   ',

    'NASDAQ symbol': 'BLPH',
  },
  {
    symbol: 'BLRX',
    'Security Name': 'BioLineRx Ltd  American Depositary Shares',

    'NASDAQ symbol': 'BLRX',
  },
  {
    symbol: 'BLSA',
    'Security Name': 'BCLS Acquisition Corp   Ordinary Shares',

    'NASDAQ symbol': 'BLSA',
  },
  {
    symbol: 'BLU',
    'Security Name': 'BELLUS Health   Common Shares',

    'NASDAQ symbol': 'BLU',
  },
  {
    symbol: 'BLUE',
    'Security Name': 'bluebird bio,   ',

    'NASDAQ symbol': 'BLUE',
  },
  {
    symbol: 'BLV',
    'Security Name': 'Vanguard LongTerm Bond ETF',

    'CQS symbol': 'BLV',
    'NASDAQ symbol': 'BLV',
  },
  {
    symbol: 'BLW',
    'Security Name': 'Blackrock Limited Duration ome Trust',

    'CQS symbol': 'BLW',
    'NASDAQ symbol': 'BLW',
  },
  {
    symbol: 'BLX',
    'Security Name': 'Banco Latinoamericano de Comercio Exterior, SA',

    'CQS symbol': 'BLX',
    'NASDAQ symbol': 'BLX',
  },
  {
    symbol: 'BMA',
    'Security Name':
      'Banco Macro SA  ADR (representing Ten Class B Common Shares)',

    'CQS symbol': 'BMA',
    'NASDAQ symbol': 'BMA',
  },
  {
    symbol: 'BMAR',
    'Security Name': 'Innovator S&P 500 Buffer ETF  March',

    'CQS symbol': 'BMAR',
    'NASDAQ symbol': 'BMAR',
  },
  {
    symbol: 'BMAY',
    'Security Name': 'Innovator S&P 500 Buffer ETF  May',

    'CQS symbol': 'BMAY',
    'NASDAQ symbol': 'BMAY',
  },
  {
    symbol: 'BMCH',
    'Security Name': 'BMC Stock Holdings,   ',

    'NASDAQ symbol': 'BMCH',
  },
  {
    symbol: 'BME',
    'Security Name': 'Blackrock Health Sciences Trust',

    'CQS symbol': 'BME',
    'NASDAQ symbol': 'BME',
  },
  {
    symbol: 'BMED',
    'Security Name': 'BlackRock Future Health ETF',

    'CQS symbol': 'BMED',
    'NASDAQ symbol': 'BMED',
  },
  {
    symbol: 'BMEZ',
    'Security Name':
      'BlackRock Health Sciences Trust II Common Shares of Beneficial Interest',

    'CQS symbol': 'BMEZ',
    'NASDAQ symbol': 'BMEZ',
  },
  {
    symbol: 'BMI',
    'Security Name': 'Badger Meter,  ',

    'CQS symbol': 'BMI',
    'NASDAQ symbol': 'BMI',
  },
  {
    symbol: 'BML$G',
    'Security Name':
      'Bank of America Corporation Bank of America Corporation Depositary Shares (Each representing a 1/1200th interest in a share of Floating Rate NonCumulative Preferred Stock , Series 1)',

    'CQS symbol': 'BMLpG',
    'NASDAQ symbol': 'BMLG',
  },
  {
    symbol: 'BML$H',
    'Security Name':
      'Bank of America Corporation Bank of America Corporation Depositary Shares (Each representing a 1/1200th interest in a Share of Floating Rate NonCumulative Preferred Stock, Series 2)',

    'CQS symbol': 'BMLpH',
    'NASDAQ symbol': 'BMLH',
  },
  {
    symbol: 'BML$J',
    'Security Name':
      'Bank of America Corporation Bank of America Corporation Depositary Shares (Each representing a 1/1200th interest in a Share of Floating Rate NonCumulative Preferred Stock, Series 4)',

    'CQS symbol': 'BMLpJ',
    'NASDAQ symbol': 'BMLJ',
  },
  {
    symbol: 'BML$L',
    'Security Name':
      'Bank of America Corporation Bank of America Corporation Depositary Shares (Each representing a 1/1200th Interest in a Share of Floating Rate NonCumulative Preferred Stock, Series 5)',

    'CQS symbol': 'BMLpL',
    'NASDAQ symbol': 'BMLL',
  },
  {
    symbol: 'BMLP',
    'Security Name': 'Dorsey Wright MLP Index ETNs due December 10, 2036',

    'NASDAQ symbol': 'BMLP',
  },
  {
    symbol: 'BMO',
    'Security Name': 'Bank Of Montreal ',

    'CQS symbol': 'BMO',
    'NASDAQ symbol': 'BMO',
  },
  {
    symbol: 'BMRA',
    'Security Name': 'Biomerica,   ',

    'NASDAQ symbol': 'BMRA',
  },
  {
    symbol: 'BMRC',
    'Security Name': 'Bank of Marin Bancorp  ',

    'NASDAQ symbol': 'BMRC',
  },
  {
    symbol: 'BMRN',
    'Security Name': 'BioMarin Pharmaceutical   ',

    'NASDAQ symbol': 'BMRN',
  },
  {
    symbol: 'BMTC',
    'Security Name': 'Bryn Mawr Bank Corporation  ',

    'NASDAQ symbol': 'BMTC',
  },
  {
    symbol: 'BMY',
    'Security Name': 'BristolMyers Squibb Company ',

    'CQS symbol': 'BMY',
    'NASDAQ symbol': 'BMY',
  },
  {
    symbol: 'BMYR',
    'Security Name': 'BristolMyers Squibb Company Contingent Value Rights',

    'CQS symbol': 'BMYr',
    'NASDAQ symbol': 'BMY^',
  },
  {
    symbol: 'BND',
    'Security Name': 'Vanguard Total Bond Market ETF',

    'NASDAQ symbol': 'BND',
  },
  {
    symbol: 'BNDC',
    'Security Name': 'FlexShares Core Select Bond Fund',

    'CQS symbol': 'BNDC',
    'NASDAQ symbol': 'BNDC',
  },
  {
    symbol: 'BNDW',
    'Security Name': 'Vanguard Total World Bond ETF',

    'NASDAQ symbol': 'BNDW',
  },
  {
    symbol: 'BNDX',
    'Security Name': 'Vanguard Total International Bond ETF',

    'NASDAQ symbol': 'BNDX',
  },
  {
    symbol: 'BNED',
    'Security Name': 'Barnes & Noble Education,  ',

    'CQS symbol': 'BNED',
    'NASDAQ symbol': 'BNED',
  },
  {
    symbol: 'BNFT',
    'Security Name': 'Benefitfocus,   ',

    'NASDAQ symbol': 'BNFT',
  },
  {
    symbol: 'BNGO',
    'Security Name': 'Bionano Genomics,   ',

    'NASDAQ symbol': 'BNGO',
  },
  {
    symbol: 'BNGOW',
    'Security Name': 'Bionano Genomics,   Warrant',

    'NASDAQ symbol': 'BNGOW',
  },
  {
    symbol: 'BNKD',
    'Security Name':
      'MicroSectors US Big Banks Index 3X Inverse Leveraged ETNs',

    'CQS symbol': 'BNKD',
    'NASDAQ symbol': 'BNKD',
  },
  {
    symbol: 'BNKO',
    'Security Name': 'MicroSectors US Big Banks Index 2X Leveraged ETNs',

    'CQS symbol': 'BNKO',
    'NASDAQ symbol': 'BNKO',
  },
  {
    symbol: 'BNKU',
    'Security Name': 'MicroSectors US Big Banks Index 3X Leveraged ETNs',

    'CQS symbol': 'BNKU',
    'NASDAQ symbol': 'BNKU',
  },
  {
    symbol: 'BNKZ',
    'Security Name':
      'MicroSectors US Big Banks Index 2X Inverse Leveraged ETNs',

    'CQS symbol': 'BNKZ',
    'NASDAQ symbol': 'BNKZ',
  },
  {
    symbol: 'BNL',
    'Security Name': 'Broadstone Net Lease,   ',

    'CQS symbol': 'BNL',
    'NASDAQ symbol': 'BNL',
  },
  {
    symbol: 'BNO',
    'Security Name': 'United States Brent Oil Fund, LP ETV',

    'CQS symbol': 'BNO',
    'NASDAQ symbol': 'BNO',
  },
  {
    symbol: 'BNOV',
    'Security Name': 'Innovator S&P 500 Buffer ETF  November',

    'CQS symbol': 'BNOV',
    'NASDAQ symbol': 'BNOV',
  },
  {
    symbol: 'BNR',
    'Security Name': 'Burning Rock Biotech Limited  American Depositary Shares',

    'NASDAQ symbol': 'BNR',
  },
  {
    symbol: 'BNS',
    'Security Name': 'Bank Nova Scotia Halifax Pfd 3 Ordinary Shares',

    'CQS symbol': 'BNS',
    'NASDAQ symbol': 'BNS',
  },
  {
    symbol: 'BNSO',
    'Security Name': 'Bonso Electronics International,   ',

    'NASDAQ symbol': 'BNSO',
  },
  {
    symbol: 'BNTC',
    'Security Name': 'Benitec Biopharma   ',

    'NASDAQ symbol': 'BNTC',
  },
  {
    symbol: 'BNTX',
    'Security Name': 'BioNTech SE  American Depositary Shares',

    'NASDAQ symbol': 'BNTX',
  },
  {
    symbol: 'BNY',
    'Security Name': 'BlackRock New York Municipal ome Trust',

    'CQS symbol': 'BNY',
    'NASDAQ symbol': 'BNY',
  },
  {
    symbol: 'BOACU',
    'Security Name':
      'Bluescape Opportunities Acquisition Corp Units, each consisting of one  ordinary share, and onehalf of one redeemable warrant',

    'CQS symbol': 'BOACU',
    'NASDAQ symbol': 'BOAC=',
  },
  {
    symbol: 'BOCH',
    'Security Name': 'Bank of Commerce Holdings (CA)  ',

    'NASDAQ symbol': 'BOCH',
  },
  {
    symbol: 'BOCT',
    'Security Name': 'Innovator S&P 500 Buffer ETF  October',

    'CQS symbol': 'BOCT',
    'NASDAQ symbol': 'BOCT',
  },
  {
    symbol: 'BOE',
    'Security Name':
      'Blackrock Enhanced Global Dividend Trust Common Shares of Beneficial Interest',

    'CQS symbol': 'BOE',
    'NASDAQ symbol': 'BOE',
  },
  {
    symbol: 'BOH',
    'Security Name': 'Bank of Hawaii Corporation ',

    'CQS symbol': 'BOH',
    'NASDAQ symbol': 'BOH',
  },
  {
    symbol: 'BOIL',
    'Security Name': 'ProShares Ultra Bloomberg Natural Gas',

    'CQS symbol': 'BOIL',
    'NASDAQ symbol': 'BOIL',
  },
  {
    symbol: 'BOKF',
    'Security Name': 'BOK Financial Corporation  ',

    'NASDAQ symbol': 'BOKF',
  },
  {
    symbol: 'BOKFL',
    'Security Name':
      'BOK Financial Corporation  5375% Subordinated Notes due 2056',

    'NASDAQ symbol': 'BOKFL',
  },
  {
    symbol: 'BOMN',
    'Security Name': 'Boston Omaha Corporation   ',

    'NASDAQ symbol': 'BOMN',
  },
  {
    symbol: 'BOND',
    'Security Name':
      'PIMCO Active Bond ExchangeTraded Fund ExchangeTraded Fund',

    'CQS symbol': 'BOND',
    'NASDAQ symbol': 'BOND',
  },
  {
    symbol: 'BOOM',
    'Security Name': 'DMC Global   ',

    'NASDAQ symbol': 'BOOM',
  },
  {
    symbol: 'BOOT',
    'Security Name': 'Boot Barn Holdings,  ',

    'CQS symbol': 'BOOT',
    'NASDAQ symbol': 'BOOT',
  },
  {
    symbol: 'BORR',
    'Security Name': 'Borr Drilling Limited Common Shares',

    'CQS symbol': 'BORR',
    'NASDAQ symbol': 'BORR',
  },
  {
    symbol: 'BOSC',
    'Security Name': 'BOS Better Online Solutions  Ordinary Shares',

    'NASDAQ symbol': 'BOSC',
  },
  {
    symbol: 'BOSS',
    'Security Name': 'Global X Funds Global X FounderRun Companies ETF',

    'CQS symbol': 'BOSS',
    'NASDAQ symbol': 'BOSS',
  },
  {
    symbol: 'BOTJ',
    'Security Name': 'Bank of the James Financial Group,   ',

    'NASDAQ symbol': 'BOTJ',
  },
  {
    symbol: 'BOTZ',
    'Security Name': 'Global X Robotics & Artificial Intelligence ETF',

    'NASDAQ symbol': 'BOTZ',
  },
  {
    symbol: 'BOUT',
    'Security Name': 'Innovator IBD Breakout Opportunities ETF',

    'CQS symbol': 'BOUT',
    'NASDAQ symbol': 'BOUT',
  },
  {
    symbol: 'BOWX',
    'Security Name': 'BowX Acquisition Corp   ',

    'NASDAQ symbol': 'BOWX',
  },
  {
    symbol: 'BOWXU',
    'Security Name': 'BowX Acquisition Corp  Unit',

    'NASDAQ symbol': 'BOWXU',
  },
  {
    symbol: 'BOWXW',
    'Security Name': 'BowX Acquisition Corp  Warrant',

    'NASDAQ symbol': 'BOWXW',
  },
  {
    symbol: 'BOX',
    'Security Name': 'Box,   ',

    'CQS symbol': 'BOX',
    'NASDAQ symbol': 'BOX',
  },
  {
    symbol: 'BOXL',
    'Security Name': 'Boxlight Corporation   ',

    'NASDAQ symbol': 'BOXL',
  },
  {
    symbol: 'BP',
    'Security Name': 'BP plc ',

    'CQS symbol': 'BP',
    'NASDAQ symbol': 'BP',
  },
  {
    symbol: 'BPFH',
    'Security Name': 'Boston Private Financial Holdings,   ',

    'NASDAQ symbol': 'BPFH',
  },
  {
    symbol: 'BPMC',
    'Security Name': 'Blueprint Medicines Corporation  ',

    'NASDAQ symbol': 'BPMC',
  },
  {
    symbol: 'BPMP',
    'Security Name':
      'BP Midstream Partners LP Common Units representing Limited Partner Interests',

    'CQS symbol': 'BPMP',
    'NASDAQ symbol': 'BPMP',
  },
  {
    symbol: 'BPOP',
    'Security Name': 'Popular,   ',

    'NASDAQ symbol': 'BPOP',
  },
  {
    symbol: 'BPOPM',
    'Security Name':
      'Popular,   Popular Capital Trust II  6125% Cumulative Monthly ome Trust Preferred Securities',

    'NASDAQ symbol': 'BPOPM',
  },
  {
    symbol: 'BPOPN',
    'Security Name':
      'Popular,   Popular Capital Trust I 670% Cumulative Monthly ome Trust Preferred Securities',

    'NASDAQ symbol': 'BPOPN',
  },
  {
    symbol: 'BPRN',
    'Security Name': 'The Bank of Preton  ',

    'NASDAQ symbol': 'BPRN',
  },
  {
    symbol: 'BPT',
    'Security Name': 'BP Prudhoe Bay Royalty Trust ',

    'CQS symbol': 'BPT',
    'NASDAQ symbol': 'BPT',
  },
  {
    symbol: 'BPTH',
    'Security Name': 'BioPath Holdings,   ',

    'NASDAQ symbol': 'BPTH',
  },
  {
    symbol: 'BPY',
    'Security Name':
      'Brookfield Property Partners LP  Limited Partnership Units',

    'NASDAQ symbol': 'BPY',
  },
  {
    symbol: 'BPYPN',
    'Security Name':
      'Brookfield Property Partners LP  5750%  Cumulative Redeemable Perpetual Preferred Units, Series 3',

    'NASDAQ symbol': 'BPYPN',
  },
  {
    symbol: 'BPYPO',
    'Security Name':
      'Brookfield Property Partners LP  6375%  Cumulative Redeemable Perpetual Preferred Units, Series 2',

    'NASDAQ symbol': 'BPYPO',
  },
  {
    symbol: 'BPYPP',
    'Security Name':
      'Brookfield Property Partners LP  650%  Cumulative Redeemable Perpetual Preferred Units',

    'NASDAQ symbol': 'BPYPP',
  },
  {
    symbol: 'BPYU',
    'Security Name': 'Brookfield Property REIT    ',

    'NASDAQ symbol': 'BPYU',
  },
  {
    symbol: 'BPYUP',
    'Security Name':
      'Brookfield Property REIT   6375% Series A Preferred Stock',

    'NASDAQ symbol': 'BPYUP',
  },
  {
    symbol: 'BQ',
    'Security Name':
      'Boqii Holding Limited American Depositary Shares, representing  Ordinary Shares',

    'CQS symbol': 'BQ',
    'NASDAQ symbol': 'BQ',
  },
  {
    symbol: 'BR',
    'Security Name': 'Broadridge Financial Solutions, ',

    'CQS symbol': 'BR',
    'NASDAQ symbol': 'BR',
  },
  {
    symbol: 'BRBR',
    'Security Name': 'BellRing Brands,   ',

    'CQS symbol': 'BRBR',
    'NASDAQ symbol': 'BRBR',
  },
  {
    symbol: 'BRBS',
    'Security Name': 'Blue Ridge Bankshares,  ',

    'CQS symbol': 'BRBS',
    'NASDAQ symbol': 'BRBS',
  },
  {
    symbol: 'BRC',
    'Security Name': 'Brady Corporation ',

    'CQS symbol': 'BRC',
    'NASDAQ symbol': 'BRC',
  },
  {
    symbol: 'BREZU',
    'Security Name': 'Breeze Holdings Acquisition Corp  Unit',

    'NASDAQ symbol': 'BREZU',
  },
  {
    symbol: 'BRF',
    'Security Name': 'VanEck Vectors Brazil SmallCap ETF',

    'CQS symbol': 'BRF',
    'NASDAQ symbol': 'BRF',
  },
  {
    symbol: 'BRFS',
    'Security Name': 'BRF SA',

    'CQS symbol': 'BRFS',
    'NASDAQ symbol': 'BRFS',
  },
  {
    symbol: 'BRG',
    'Security Name': 'Bluerock Residential Growth REIT,   ',

    'CQS symbol': 'BRG',
    'NASDAQ symbol': 'BRG',
  },
  {
    symbol: 'BRG$A',
    'Security Name':
      'Bluerock Residential Growth REIT,  8250% Series A Cumulative Redeemable Preferred Stock ($001 par value per share)',

    'CQS symbol': 'BRGpA',
    'NASDAQ symbol': 'BRGA',
  },
  {
    symbol: 'BRG$C',
    'Security Name':
      'Bluerock Residential Growth REIT,  7625% Series C Cumulative Redeemable Preferred Stock',

    'CQS symbol': 'BRGpC',
    'NASDAQ symbol': 'BRGC',
  },
  {
    symbol: 'BRG$D',
    'Security Name':
      'Bluerock Residential Growth REIT,  7125% Series D, Cumulative Preferred Stock ($001 par value per share)',

    'CQS symbol': 'BRGpD',
    'NASDAQ symbol': 'BRGD',
  },
  {
    symbol: 'BRID',
    'Security Name': 'Bridgford Foods Corporation  ',

    'NASDAQ symbol': 'BRID',
  },
  {
    'Nasdaq Traded': 'N',
    symbol: 'BRKA',
    'Security Name': 'Berkshire Hathaway  ',

    'Round Lot Size': '1',

    'CQS symbol': 'BRKA',
    'NASDAQ symbol': 'BRKA',
  },
  {
    symbol: 'BRKB',
    'Security Name': 'Berkshire Hathaway  New ',

    'CQS symbol': 'BRKB',
    'NASDAQ symbol': 'BRKB',
  },
  {
    symbol: 'BRKL',
    'Security Name': 'Brookline Bancorp,   ',

    'NASDAQ symbol': 'BRKL',
  },
  {
    symbol: 'BRKR',
    'Security Name': 'Bruker Corporation  ',

    'NASDAQ symbol': 'BRKR',
  },
  {
    symbol: 'BRKS',
    'Security Name': 'Brooks Automation,   ',

    'NASDAQ symbol': 'BRKS',
  },
  {
    symbol: 'BRLI',
    'Security Name': 'Brilliant Acquisition Corporation  Ordinary Shares',

    'NASDAQ symbol': 'BRLI',
  },
  {
    symbol: 'BRLIR',
    'Security Name': 'Brilliant Acquisition Corporation  Rights',

    'NASDAQ symbol': 'BRLIR',
  },
  {
    symbol: 'BRLIU',
    'Security Name': 'Brilliant Acquisition Corporation  Unit',

    'NASDAQ symbol': 'BRLIU',
  },
  {
    symbol: 'BRLIW',
    'Security Name': 'Brilliant Acquisition Corporation  Warrants',

    'NASDAQ symbol': 'BRLIW',
  },
  {
    symbol: 'BRMK',
    'Security Name': 'Broadmark Realty Capital  ',

    'CQS symbol': 'BRMK',
    'NASDAQ symbol': 'BRMK',
  },
  {
    symbol: 'BRMKW',
    'Security Name':
      'Broadmark Realty Capital  Warrants, each exercisable for one fourth (1/4th) share of  at an exercise price of $2875 per quarter share',

    'CQS symbol': 'BRMKWS',
    'NASDAQ symbol': 'BRMK+',
  },
  {
    symbol: 'BRN',
    'Security Name': 'Barnwell Industries,  ',

    'CQS symbol': 'BRN',
    'NASDAQ symbol': 'BRN',
  },
  {
    symbol: 'BRO',
    'Security Name': 'Brown & Brown,  ',

    'CQS symbol': 'BRO',
    'NASDAQ symbol': 'BRO',
  },
  {
    symbol: 'BROG',
    'Security Name': 'Brooge Energy Limited   Ordinary Shares',

    'NASDAQ symbol': 'BROG',
  },
  {
    symbol: 'BROGW',
    'Security Name': 'Brooge Energy Limited   Warrant',

    'NASDAQ symbol': 'BROGW',
  },
  {
    symbol: 'BRP',
    'Security Name': 'BRP Group,    ',

    'NASDAQ symbol': 'BRP',
  },
  {
    symbol: 'BRPA',
    'Security Name': 'Big Rock Partners Acquisition Corp  ',

    'NASDAQ symbol': 'BRPA',
  },
  {
    symbol: 'BRPAR',
    'Security Name': 'Big Rock Partners Acquisition Corp  Right',

    'NASDAQ symbol': 'BRPAR',
  },
  {
    symbol: 'BRPAU',
    'Security Name': 'Big Rock Partners Acquisition Corp  Unit',

    'NASDAQ symbol': 'BRPAU',
  },
  {
    symbol: 'BRPAW',
    'Security Name': 'Big Rock Partners Acquisition Corp  Warrant',

    'NASDAQ symbol': 'BRPAW',
  },
  {
    symbol: 'BRQS',
    'Security Name': 'Borqs Technologies,    Ordinary Shares',

    'NASDAQ symbol': 'BRQS',
  },
  {
    symbol: 'BRT',
    'Security Name': 'BRT Apartments Corp (MD) ',

    'CQS symbol': 'BRT',
    'NASDAQ symbol': 'BRT',
  },
  {
    symbol: 'BRX',
    'Security Name': 'Brixmor Property Group  ',

    'CQS symbol': 'BRX',
    'NASDAQ symbol': 'BRX',
  },
  {
    symbol: 'BRY',
    'Security Name': 'Berry Corporation (bry)  ',

    'NASDAQ symbol': 'BRY',
  },
  {
    symbol: 'BRZU',
    'Security Name': 'Direxion Daily Brazil Bull 2X Shares',

    'CQS symbol': 'BRZU',
    'NASDAQ symbol': 'BRZU',
  },
  {
    symbol: 'BSA',
    'Security Name': 'BrightSphere Investment Group  5125% Notes due 2031',

    'CQS symbol': 'BSA',
    'NASDAQ symbol': 'BSA',
  },
  {
    symbol: 'BSAC',
    'Security Name': 'Banco Santander  Chile ADS',

    'CQS symbol': 'BSAC',
    'NASDAQ symbol': 'BSAC',
  },
  {
    symbol: 'BSAE',
    'Security Name': 'Invesco BulletShares 2021 USD Emerging Markets Debt ETF',

    'NASDAQ symbol': 'BSAE',
  },
  {
    symbol: 'BSBE',
    'Security Name': 'Invesco BulletShares 2022 USD Emerging Markets Debt ETF',

    'NASDAQ symbol': 'BSBE',
  },
  {
    symbol: 'BSBK',
    'Security Name': 'Bogota Financial Corp  ',

    'NASDAQ symbol': 'BSBK',
  },
  {
    symbol: 'BSBR',
    'Security Name':
      'Banco Santander Brasil SA American Depositary Shares, each representing one unit',

    'CQS symbol': 'BSBR',
    'NASDAQ symbol': 'BSBR',
  },
  {
    symbol: 'BSCE',
    'Security Name': 'Invesco BulletShares 2023 USD Emerging Markets Debt ETF',

    'NASDAQ symbol': 'BSCE',
  },
  {
    symbol: 'BSCK',
    'Security Name': 'Invesco BulletShares 2020 Corporate Bond ETF',

    'NASDAQ symbol': 'BSCK',
  },
  {
    symbol: 'BSCL',
    'Security Name': 'Invesco BulletShares 2021 Corporate Bond ETF',

    'NASDAQ symbol': 'BSCL',
  },
  {
    symbol: 'BSCM',
    'Security Name': 'Invesco BulletShares 2022 Corporate Bond ETF',

    'NASDAQ symbol': 'BSCM',
  },
  {
    symbol: 'BSCN',
    'Security Name': 'Invesco BulletShares 2023 Corporate Bond ETF',

    'NASDAQ symbol': 'BSCN',
  },
  {
    symbol: 'BSCO',
    'Security Name': 'Invesco BulletShares 2024 Corporate Bond ETF',

    'NASDAQ symbol': 'BSCO',
  },
  {
    symbol: 'BSCP',
    'Security Name': 'Invesco BulletShares 2025 Corporate Bond ETF',

    'NASDAQ symbol': 'BSCP',
  },
  {
    symbol: 'BSCQ',
    'Security Name': 'Invesco BulletShares 2026 Corporate Bond ETF',

    'NASDAQ symbol': 'BSCQ',
  },
  {
    symbol: 'BSCR',
    'Security Name': 'Invesco BulletShares 2027 Corporate Bond ETF',

    'NASDAQ symbol': 'BSCR',
  },
  {
    symbol: 'BSCS',
    'Security Name': 'Invesco BulletShares 2028 Corporate Bond ETF',

    'NASDAQ symbol': 'BSCS',
  },
  {
    symbol: 'BSCT',
    'Security Name': 'Invesco BulletShares 2029 Corporate Bond ETF',

    'NASDAQ symbol': 'BSCT',
  },
  {
    symbol: 'BSCU',
    'Security Name': 'Invesco BulletShares 2030 Corporate Bond ETF',

    'NASDAQ symbol': 'BSCU',
  },
  {
    symbol: 'BSD',
    'Security Name': 'BlackRock Strategic Municipal Trust  (The) ',

    'CQS symbol': 'BSD',
    'NASDAQ symbol': 'BSD',
  },
  {
    symbol: 'BSDE',
    'Security Name': 'Invesco BulletShares 2024 USD Emerging Markets Debt ETF',

    'NASDAQ symbol': 'BSDE',
  },
  {
    symbol: 'BSE',
    'Security Name':
      'Blackrock New York Municipal ome Quality Trust Common Shares of Beneficial Interest',

    'CQS symbol': 'BSE',
    'NASDAQ symbol': 'BSE',
  },
  {
    symbol: 'BSEP',
    'Security Name':
      'Innovator ETFs Trust Innovator S&P 500 Buffer ETF  September',

    'CQS symbol': 'BSEP',
    'NASDAQ symbol': 'BSEP',
  },
  {
    symbol: 'BSET',
    'Security Name': 'Bassett Furniture Industries, orporated  ',

    'NASDAQ symbol': 'BSET',
  },
  {
    symbol: 'BSGM',
    'Security Name': 'BioSig Technologies,   ',

    'NASDAQ symbol': 'BSGM',
  },
  {
    symbol: 'BSIG',
    'Security Name': 'BrightSphere Investment Group  ',

    'CQS symbol': 'BSIG',
    'NASDAQ symbol': 'BSIG',
  },
  {
    symbol: 'BSJK',
    'Security Name': 'Invesco BulletShares 2020 High Yield Corporate Bond ETF',

    'NASDAQ symbol': 'BSJK',
  },
  {
    symbol: 'BSJL',
    'Security Name': 'Invesco BulletShares 2021 High Yield Corporate Bond ETF',

    'NASDAQ symbol': 'BSJL',
  },
  {
    symbol: 'BSJM',
    'Security Name': 'Invesco BulletShares 2022 High Yield Corporate Bond ETF',

    'NASDAQ symbol': 'BSJM',
  },
  {
    symbol: 'BSJN',
    'Security Name': 'Invesco BulletShares 2023 High Yield Corporate Bond ETF',

    'NASDAQ symbol': 'BSJN',
  },
  {
    symbol: 'BSJO',
    'Security Name': 'Invesco BulletShares 2024 High Yield Corporate Bond ETF',

    'NASDAQ symbol': 'BSJO',
  },
  {
    symbol: 'BSJP',
    'Security Name': 'Invesco BulletShares 2025 High Yield Corporate Bond ETF',

    'NASDAQ symbol': 'BSJP',
  },
  {
    symbol: 'BSJQ',
    'Security Name': 'Invesco BulletShares 2026 High Yield Corporate Bond ETF',

    'NASDAQ symbol': 'BSJQ',
  },
  {
    symbol: 'BSJR',
    'Security Name': 'Invesco BulletShares 2027 High Yield Corporate Bond ETF',

    'NASDAQ symbol': 'BSJR',
  },
  {
    symbol: 'BSJS',
    'Security Name': 'Invesco BulletShares 2028 High Yield Corporate Bond ETF',

    'NASDAQ symbol': 'BSJS',
  },
  {
    symbol: 'BSL',
    'Security Name':
      'Blackstone GSO Senior Floating Rate Term Fund Common Shares of Beneficial Interest',

    'CQS symbol': 'BSL',
    'NASDAQ symbol': 'BSL',
  },
  {
    symbol: 'BSM',
    'Security Name':
      'Black Stone Minerals, LP Common units representing limited partner interests',

    'CQS symbol': 'BSM',
    'NASDAQ symbol': 'BSM',
  },
  {
    symbol: 'BSML',
    'Security Name': 'Invesco BulletShares 2021 Municipal Bond ETF',

    'NASDAQ symbol': 'BSML',
  },
  {
    symbol: 'BSMM',
    'Security Name': 'Invesco BulletShares 2022 Municipal Bond ETF',

    'NASDAQ symbol': 'BSMM',
  },
  {
    symbol: 'BSMN',
    'Security Name': 'Invesco BulletShares 2023 Municipal Bond ETF',

    'NASDAQ symbol': 'BSMN',
  },
  {
    symbol: 'BSMO',
    'Security Name': 'Invesco BulletShares 2024 Municipal Bond ETF',

    'NASDAQ symbol': 'BSMO',
  },
  {
    symbol: 'BSMP',
    'Security Name': 'Invesco BulletShares 2025 Municipal Bond ETF',

    'NASDAQ symbol': 'BSMP',
  },
  {
    symbol: 'BSMQ',
    'Security Name': 'Invesco BulletShares 2026 Municipal Bond ETF',

    'NASDAQ symbol': 'BSMQ',
  },
  {
    symbol: 'BSMR',
    'Security Name': 'Invesco BulletShares 2027 Municipal Bond ETF',

    'NASDAQ symbol': 'BSMR',
  },
  {
    symbol: 'BSMS',
    'Security Name': 'Invesco BulletShares 2028 Municipal Bond ETF',

    'NASDAQ symbol': 'BSMS',
  },
  {
    symbol: 'BSMT',
    'Security Name': 'Invesco BulletShares 2029 Municipal Bond ETF',

    'NASDAQ symbol': 'BSMT',
  },
  {
    symbol: 'BSMU',
    'Security Name': 'Invesco BulletShares 2030 Municipal Bond ETF',

    'NASDAQ symbol': 'BSMU',
  },
  {
    symbol: 'BSMX',
    'Security Name':
      'Banco Santander Mexico, SA, Institucion de Banca Multiple, Grupo Financiero Santander Mexico',

    'CQS symbol': 'BSMX',
    'NASDAQ symbol': 'BSMX',
  },
  {
    symbol: 'BSN',
    'Security Name': 'Broadstone Acquisition Corp  Ordinary Shares',

    'CQS symbol': 'BSN',
    'NASDAQ symbol': 'BSN',
  },
  {
    symbol: 'BSNU',
    'Security Name':
      'Broadstone Acquisition Corp Units, each consisting of one  ordinary share and onehalf of one redeemable warrant',

    'CQS symbol': 'BSNU',
    'NASDAQ symbol': 'BSN=',
  },
  {
    symbol: 'BSNW',
    'Security Name':
      'Broadstone Acquisition Corp Warrants, each whole warrant exercisable for one  ordinary share at an exercise price of $1150 per share',

    'CQS symbol': 'BSNWS',
    'NASDAQ symbol': 'BSN+',
  },
  {
    symbol: 'BSQR',
    'Security Name': 'BSQUARE Corporation  ',

    'NASDAQ symbol': 'BSQR',
  },
  {
    symbol: 'BSRR',
    'Security Name': 'Sierra Bancorp  ',

    'NASDAQ symbol': 'BSRR',
  },
  {
    symbol: 'BST',
    'Security Name':
      'BlackRock Science and Technology Trust Common Shares of Beneficial Interest',

    'CQS symbol': 'BST',
    'NASDAQ symbol': 'BST',
  },
  {
    symbol: 'BSTZ',
    'Security Name':
      'BlackRock Science and Technology Trust II Common Shares of Beneficial Interest',

    'CQS symbol': 'BSTZ',
    'NASDAQ symbol': 'BSTZ',
  },
  {
    symbol: 'BSV',
    'Security Name': 'Vanguard ShortTerm Bond ETF',

    'CQS symbol': 'BSV',
    'NASDAQ symbol': 'BSV',
  },
  {
    symbol: 'BSVN',
    'Security Name': 'Bank7 Corp  ',

    'NASDAQ symbol': 'BSVN',
  },
  {
    symbol: 'BSX',
    'Security Name': 'Boston Scientific Corporation ',

    'CQS symbol': 'BSX',
    'NASDAQ symbol': 'BSX',
  },
  {
    symbol: 'BSX$A',
    'Security Name':
      'Boston Scientific Corporation 550% Mandatory Convertible Preferred Stock, Series A',

    'CQS symbol': 'BSXpA',
    'NASDAQ symbol': 'BSXA',
  },
  {
    symbol: 'BSY',
    'Security Name': 'Bentley Systems, orporated  Class B ',

    'NASDAQ symbol': 'BSY',
  },
  {
    symbol: 'BTA',
    'Security Name':
      'BlackRock LongTerm Municipal Advantage Trust BlackRock LongTerm Municipal Advantage Trust Common Shares of Beneficial Interest',

    'CQS symbol': 'BTA',
    'NASDAQ symbol': 'BTA',
  },
  {
    symbol: 'BTAI',
    'Security Name': 'BioXcel Therapeutics,   ',

    'NASDAQ symbol': 'BTAI',
  },
  {
    symbol: 'BTAL',
    'Security Name': 'AGFiQ US Market Neutral AntiBeta Fund',

    'CQS symbol': 'BTAL',
    'NASDAQ symbol': 'BTAL',
  },
  {
    symbol: 'BTAQ',
    'Security Name':
      'Burgundy Technology Acquisition Corporation   Ordinary Shares',

    'NASDAQ symbol': 'BTAQ',
  },
  {
    symbol: 'BTAQU',
    'Security Name': 'Burgundy Technology Acquisition Corporation  Unit',

    'NASDAQ symbol': 'BTAQU',
  },
  {
    symbol: 'BTAQW',
    'Security Name': 'Burgundy Technology Acquisition Corporation  Warrant',

    'NASDAQ symbol': 'BTAQW',
  },
  {
    symbol: 'BTBT',
    'Security Name': 'Bit Digital,   Ordinary Share',

    'NASDAQ symbol': 'BTBT',
  },
  {
    symbol: 'BTEC',
    'Security Name': 'Pripal Healthcare Innovators Index ETF',

    'NASDAQ symbol': 'BTEC',
  },
  {
    symbol: 'BTEK',
    'Security Name': 'BlackRock Future Tech ETF',

    'CQS symbol': 'BTEK',
    'NASDAQ symbol': 'BTEK',
  },
  {
    symbol: 'BTG',
    'Security Name': 'B2Gold Corp Common shares (Canada)',

    'CQS symbol': 'BTG',
    'NASDAQ symbol': 'BTG',
  },
  {
    symbol: 'BTI',
    'Security Name': 'British American Tobacco  Industries, plc  ADR',

    'CQS symbol': 'BTI',
    'NASDAQ symbol': 'BTI',
  },
  {
    symbol: 'BTN',
    'Security Name': 'Ballantyne Strong,  ',

    'CQS symbol': 'BTN',
    'NASDAQ symbol': 'BTN',
  },
  {
    symbol: 'BTO',
    'Security Name': 'John Hancock Financial Opportunities Fund ',

    'CQS symbol': 'BTO',
    'NASDAQ symbol': 'BTO',
  },
  {
    symbol: 'BTT',
    'Security Name': 'BlackRock Municipal 2030 Target Term Trust',

    'CQS symbol': 'BTT',
    'NASDAQ symbol': 'BTT',
  },
  {
    symbol: 'BTU',
    'Security Name': 'Peabody Energy Corporation  ',

    'CQS symbol': 'BTU',
    'NASDAQ symbol': 'BTU',
  },
  {
    symbol: 'BTWNU',
    'Security Name': 'Bridgetown Holdings Limited  Units',

    'NASDAQ symbol': 'BTWNU',
  },
  {
    symbol: 'BTYS',
    'Security Name': 'iPath Series B US Treasury 10year Bear ETN',

    'CQS symbol': 'BTYS',
    'NASDAQ symbol': 'BTYS',
  },
  {
    symbol: 'BTZ',
    'Security Name': 'BlackRock Credit Allocation ome Trust',

    'CQS symbol': 'BTZ',
    'NASDAQ symbol': 'BTZ',
  },
  {
    symbol: 'BUD',
    'Security Name': 'AnheuserBusch Inbev SA Sponsored ADR (Belgium)',

    'CQS symbol': 'BUD',
    'NASDAQ symbol': 'BUD',
  },
  {
    symbol: 'BUFF',
    'Security Name': 'Innovator Laddered Fund of S&P 500 Power Buffer ETFs',

    'CQS symbol': 'BUFF',
    'NASDAQ symbol': 'BUFF',
  },
  {
    symbol: 'BUFR',
    'Security Name': 'FT Cboe Vest Fund of Buffer ETFs',

    'CQS symbol': 'BUFR',
    'NASDAQ symbol': 'BUFR',
  },
  {
    symbol: 'BUG',
    'Security Name': 'Global X Cybersecurity ETF',

    'NASDAQ symbol': 'BUG',
  },
  {
    symbol: 'BUI',
    'Security Name':
      'BlackRock Utility, Infrastructure & Power Opportunities Trust',

    'CQS symbol': 'BUI',
    'NASDAQ symbol': 'BUI',
  },
  {
    symbol: 'BUL',
    'Security Name': 'Pacer US Cash Cows Growth ETF',

    'CQS symbol': 'BUL',
    'NASDAQ symbol': 'BUL',
  },
  {
    symbol: 'BUR',
    'Security Name': 'Burford Capital Limited Ordinary Shares',

    'CQS symbol': 'BUR',
    'NASDAQ symbol': 'BUR',
  },
  {
    symbol: 'BURL',
    'Security Name': 'Burlington Stores,  ',

    'CQS symbol': 'BURL',
    'NASDAQ symbol': 'BURL',
  },
  {
    symbol: 'BUSE',
    'Security Name': 'First Busey Corporation  ',

    'NASDAQ symbol': 'BUSE',
  },
  {
    symbol: 'BUYZ',
    'Security Name': 'Franklin Disruptive Commerce ETF',

    'CQS symbol': 'BUYZ',
    'NASDAQ symbol': 'BUYZ',
  },
  {
    symbol: 'BV',
    'Security Name': 'BrightView Holdings,  ',

    'CQS symbol': 'BV',
    'NASDAQ symbol': 'BV',
  },
  {
    symbol: 'BVH',
    'Security Name': 'Bluegreen Vacations Holding Corporation  ',

    'CQS symbol': 'BVH',
    'NASDAQ symbol': 'BVH',
  },
  {
    symbol: 'BVN',
    'Security Name': 'Buenaventura Mining Company ',

    'CQS symbol': 'BVN',
    'NASDAQ symbol': 'BVN',
  },
  {
    symbol: 'BVXV',
    'Security Name': 'BiondVax Pharmaceuticals Ltd  American Depositary Shares',

    'NASDAQ symbol': 'BVXV',
  },
  {
    symbol: 'BW',
    'Security Name': 'Babcock & Wilcox Enterprises,  ',

    'CQS symbol': 'BW',
    'NASDAQ symbol': 'BW',
  },
  {
    symbol: 'BWA',
    'Security Name': 'BorgWarner  ',

    'CQS symbol': 'BWA',
    'NASDAQ symbol': 'BWA',
  },
  {
    symbol: 'BWACU',
    'Security Name': 'BETTER WORLD ACQUISITION CORP  Unit',

    'NASDAQ symbol': 'BWACU',
  },
  {
    symbol: 'BWAY',
    'Security Name': 'Brainsway Ltd  American Depositary Shares',

    'NASDAQ symbol': 'BWAY',
  },
  {
    symbol: 'BWB',
    'Security Name': 'Bridgewater Bancshares,   ',

    'NASDAQ symbol': 'BWB',
  },
  {
    symbol: 'BWEN',
    'Security Name': 'Broadwind,   ',

    'NASDAQ symbol': 'BWEN',
  },
  {
    symbol: 'BWFG',
    'Security Name': 'Bankwell Financial Group,   ',

    'NASDAQ symbol': 'BWFG',
  },
  {
    symbol: 'BWG',
    'Security Name': 'BrandywineGLOBAL Global ome Opportunities Fund ',

    'CQS symbol': 'BWG',
    'NASDAQ symbol': 'BWG',
  },
  {
    symbol: 'BWLA',
    'Security Name': 'Bowl America,   ',

    'CQS symbol': 'BWLA',
    'NASDAQ symbol': 'BWLA',
  },
  {
    symbol: 'BWMX',
    'Security Name': 'Betterware de Mexico, SAB de CV  Ordinary Shares',

    'NASDAQ symbol': 'BWMX',
  },
  {
    symbol: 'BWX',
    'Security Name': 'SPDR Bloomberg Barclays Intl Treasury Bd',

    'CQS symbol': 'BWX',
    'NASDAQ symbol': 'BWX',
  },
  {
    symbol: 'BWXT',
    'Security Name': 'BWX Technologies,  ',

    'CQS symbol': 'BWXT',
    'NASDAQ symbol': 'BWXT',
  },
  {
    symbol: 'BWZ',
    'Security Name':
      'SPDR Bloomberg Barclays Short Term International Treasury Bond ETF',

    'CQS symbol': 'BWZ',
    'NASDAQ symbol': 'BWZ',
  },
  {
    symbol: 'BX',
    'Security Name': 'The Blackstone Group   ',

    'CQS symbol': 'BX',
    'NASDAQ symbol': 'BX',
  },
  {
    symbol: 'BXC',
    'Security Name': 'Bluelinx Holdings  ',

    'CQS symbol': 'BXC',
    'NASDAQ symbol': 'BXC',
  },
  {
    symbol: 'BXG',
    'Security Name': 'Bluegreen Vacations Corporation ',

    'CQS symbol': 'BXG',
    'NASDAQ symbol': 'BXG',
  },
  {
    symbol: 'BXMT',
    'Security Name': 'Blackstone Mortgage Trust,  ',

    'CQS symbol': 'BXMT',
    'NASDAQ symbol': 'BXMT',
  },
  {
    symbol: 'BXMX',
    'Security Name':
      'Nuveen S&P 500 BuyWrite ome Fund Common Shares of Beneficial Interest',

    'CQS symbol': 'BXMX',
    'NASDAQ symbol': 'BXMX',
  },
  {
    symbol: 'BXP',
    'Security Name': 'Boston Properties,  ',

    'CQS symbol': 'BXP',
    'NASDAQ symbol': 'BXP',
  },
  {
    symbol: 'BXP$B',
    'Security Name':
      "Boston Properties,  Depositary Shares, each representing 1/100th of a share of the Issuer's 525% Sockeries B Cumulative Redeemable Preferred St",

    'CQS symbol': 'BXPpB',
    'NASDAQ symbol': 'BXPB',
  },
  {
    symbol: 'BXRX',
    'Security Name': 'Baudax Bio,   ',

    'NASDAQ symbol': 'BXRX',
  },
  {
    symbol: 'BXS',
    'Security Name': 'BancorpSouth Bank ',

    'CQS symbol': 'BXS',
    'NASDAQ symbol': 'BXS',
  },
  {
    symbol: 'BXS$A',
    'Security Name':
      'BancorpSouth Bank 550% Series A NonCumulative Perpetual Preferred Stock',

    'CQS symbol': 'BXSpA',
    'NASDAQ symbol': 'BXSA',
  },
  {
    symbol: 'BY',
    'Security Name': 'Byline Bancorp,  ',

    'CQS symbol': 'BY',
    'NASDAQ symbol': 'BY',
  },
  {
    symbol: 'BYD',
    'Security Name': 'Boyd Gaming Corporation ',

    'CQS symbol': 'BYD',
    'NASDAQ symbol': 'BYD',
  },
  {
    symbol: 'BYFC',
    'Security Name': 'Broadway Financial Corporation  ',

    'NASDAQ symbol': 'BYFC',
  },
  {
    symbol: 'BYLD',
    'Security Name': 'iShares Yield Optimized Bond ETF',

    'CQS symbol': 'BYLD',
    'NASDAQ symbol': 'BYLD',
  },
  {
    symbol: 'BYM',
    'Security Name':
      'Blackrock Municipal ome Quality Trust Common Shares of Beneficial Interest',

    'CQS symbol': 'BYM',
    'NASDAQ symbol': 'BYM',
  },
  {
    symbol: 'BYND',
    'Security Name': 'Beyond Meat,   ',

    'NASDAQ symbol': 'BYND',
  },
  {
    symbol: 'BYSI',
    'Security Name': 'BeyondSpring,   Ordinary Shares',

    'NASDAQ symbol': 'BYSI',
  },
  {
    symbol: 'BZH',
    'Security Name': 'Beazer Homes USA,  ',

    'CQS symbol': 'BZH',
    'NASDAQ symbol': 'BZH',
  },
  {
    symbol: 'BZM',
    'Security Name':
      'BlackRock Maryland Municipal Bond Trust Common shares of beneficial interest',

    'CQS symbol': 'BZM',
    'NASDAQ symbol': 'BZM',
  },
  {
    symbol: 'BZQ',
    'Security Name': 'ProShares UltraShort MSCI Brazil Capped',

    'CQS symbol': 'BZQ',
    'NASDAQ symbol': 'BZQ',
  },
  {
    symbol: 'BZUN',
    'Security Name': 'Baozun   American Depositary Shares',

    'NASDAQ symbol': 'BZUN',
  },
  {
    symbol: 'C',
    'Security Name': 'Citigroup,  ',

    'CQS symbol': 'C',
    'NASDAQ symbol': 'C',
  },
  {
    symbol: 'C$J',
    'Security Name': 'Citigroup  Dep Shs Repstg 1/1000 Pfd Ser J Fixed/Fltg',

    'CQS symbol': 'CpJ',
    'NASDAQ symbol': 'CJ',
  },
  {
    symbol: 'C$K',
    'Security Name': 'Citigroup  Dep Shs Repstg 1/1000th Pfd Ser K',

    'CQS symbol': 'CpK',
    'NASDAQ symbol': 'CK',
  },
  {
    symbol: 'C$N',
    'Security Name':
      'Citigroup Capital XIII 7875% Fixed rate Floating Rate trust Preferred Securities (TruPS)',

    'CQS symbol': 'CpN',
    'NASDAQ symbol': 'CN',
  },
  {
    symbol: 'C$S',
    'Security Name':
      'Citigroup  Depositary Shares, each representing a 1/1,000th interest in a share of 6300% Noncumulative Preferred Stock, Series S',

    'CQS symbol': 'CpS',
    'NASDAQ symbol': 'CS',
  },
  {
    symbol: 'CAAP',
    'Security Name': 'Corporacion America Airports SA Common Shares',

    'CQS symbol': 'CAAP',
    'NASDAQ symbol': 'CAAP',
  },
  {
    symbol: 'CAAS',
    'Security Name': 'China Automotive Systems,   ',

    'NASDAQ symbol': 'CAAS',
  },
  {
    symbol: 'CABA',
    'Security Name': 'Cabaletta Bio,   ',

    'NASDAQ symbol': 'CABA',
  },
  {
    symbol: 'CABO',
    'Security Name': 'Cable One,  ',

    'CQS symbol': 'CABO',
    'NASDAQ symbol': 'CABO',
  },
  {
    symbol: 'CAC',
    'Security Name': 'Camden National Corporation  ',

    'NASDAQ symbol': 'CAC',
  },
  {
    symbol: 'CACC',
    'Security Name': 'Credit Acceptance Corporation  ',

    'NASDAQ symbol': 'CACC',
  },
  {
    symbol: 'CACG',
    'Security Name': 'ClearBridge All Cap Growth ETF',

    'NASDAQ symbol': 'CACG',
  },
  {
    symbol: 'CACI',
    'Security Name': 'CACI International,   ',

    'CQS symbol': 'CACI',
    'NASDAQ symbol': 'CACI',
  },
  {
    symbol: 'CADE',
    'Security Name': 'Cadence Bancorporation  ',

    'CQS symbol': 'CADE',
    'NASDAQ symbol': 'CADE',
  },
  {
    symbol: 'CAE',
    'Security Name': 'CAE  Ordinary Shares',

    'CQS symbol': 'CAE',
    'NASDAQ symbol': 'CAE',
  },
  {
    symbol: 'CAF',
    'Security Name': 'Morgan Stanley China A Share Fund  ',

    'CQS symbol': 'CAF',
    'NASDAQ symbol': 'CAF',
  },
  {
    symbol: 'CAG',
    'Security Name': 'ConAgra Brands,  ',

    'CQS symbol': 'CAG',
    'NASDAQ symbol': 'CAG',
  },
  {
    symbol: 'CAH',
    'Security Name': 'Cardinal Health,  ',

    'CQS symbol': 'CAH',
    'NASDAQ symbol': 'CAH',
  },
  {
    symbol: 'CAI',
    'Security Name': 'CAI International,  ',

    'CQS symbol': 'CAI',
    'NASDAQ symbol': 'CAI',
  },
  {
    symbol: 'CAI$A',
    'Security Name':
      'CAI International,  850% Series A FixedtoFloating Rate Cumulative Redeemable Perpetual Preferred Stock',

    'CQS symbol': 'CAIpA',
    'NASDAQ symbol': 'CAIA',
  },
  {
    symbol: 'CAI$B',
    'Security Name':
      'CAI International,  850% Series B FixedtoFloating Rate Cumulative Redeemable Perpetual Preferred Stock',

    'CQS symbol': 'CAIpB',
    'NASDAQ symbol': 'CAIB',
  },
  {
    symbol: 'CAJ',
    'Security Name': 'Canon,  American Depositary Shares',

    'CQS symbol': 'CAJ',
    'NASDAQ symbol': 'CAJ',
  },
  {
    symbol: 'CAKE',
    'Security Name': 'The Cheesecake Factory orporated  ',

    'NASDAQ symbol': 'CAKE',
  },
  {
    symbol: 'CAL',
    'Security Name': 'Caleres,  ',

    'CQS symbol': 'CAL',
    'NASDAQ symbol': 'CAL',
  },
  {
    symbol: 'CALA',
    'Security Name': 'Calithera Biosciences,   ',

    'NASDAQ symbol': 'CALA',
  },
  {
    symbol: 'CALB',
    'Security Name': 'California BanCorp  ',

    'NASDAQ symbol': 'CALB',
  },
  {
    symbol: 'CALF',
    'Security Name': 'Pacer US Small Cap Cash Cows 100 ETF',

    'CQS symbol': 'CALF',
    'NASDAQ symbol': 'CALF',
  },
  {
    symbol: 'CALM',
    'Security Name': 'CalMaine Foods,   ',

    'NASDAQ symbol': 'CALM',
  },
  {
    symbol: 'CALT',
    'Security Name': 'Calliditas Therapeutics AB  American Depositary Shares',

    'NASDAQ symbol': 'CALT',
  },
  {
    symbol: 'CALX',
    'Security Name': 'Calix,  ',

    'CQS symbol': 'CALX',
    'NASDAQ symbol': 'CALX',
  },
  {
    symbol: 'CAMP',
    'Security Name': 'CalAmp Corp  ',

    'NASDAQ symbol': 'CAMP',
  },
  {
    symbol: 'CAMT',
    'Security Name': 'Camtek Ltd  Ordinary Shares',

    'NASDAQ symbol': 'CAMT',
  },
  {
    symbol: 'CAN',
    'Security Name': 'Canaan   American Depositary Shares',

    'NASDAQ symbol': 'CAN',
  },
  {
    symbol: 'CANE',
    'Security Name': 'Teucrium Sugar Fund ETV',

    'CQS symbol': 'CANE',
    'NASDAQ symbol': 'CANE',
  },
  {
    symbol: 'CANF',
    'Security Name': 'CanFite Biopharma Ltd Sponsored ADR (Israel)',

    'CQS symbol': 'CANF',
    'NASDAQ symbol': 'CANF',
  },
  {
    symbol: 'CANG',
    'Security Name':
      'Cango  American Depositary Shares,  each representing two (2)  Ordinary Shares',

    'CQS symbol': 'CANG',
    'NASDAQ symbol': 'CANG',
  },
  {
    symbol: 'CAPU',
    'Security Name':
      'Capitol Investment Corp V Units, each consisting of one share of  , and onethird of one redeemable warrant',

    'CQS symbol': 'CAPU',
    'NASDAQ symbol': 'CAP=',
  },
  {
    symbol: 'CAPA',
    'Security Name': 'HighCape Capital Acquisition Corp   ',

    'NASDAQ symbol': 'CAPA',
  },
  {
    symbol: 'CAPAU',
    'Security Name': 'HighCape Capital Acquisition Corp  Unit',

    'NASDAQ symbol': 'CAPAU',
  },
  {
    symbol: 'CAPAW',
    'Security Name': 'HighCape Capital Acquisition Corp  Warrant',

    'NASDAQ symbol': 'CAPAW',
  },
  {
    symbol: 'CAPE',
    'Security Name': 'iPath Shiller CAPE ETN',

    'CQS symbol': 'CAPE',
    'NASDAQ symbol': 'CAPE',
  },
  {
    symbol: 'CAPL',
    'Security Name':
      'CrossAmerica Partners LP Common Units representing limited partner interests',

    'CQS symbol': 'CAPL',
    'NASDAQ symbol': 'CAPL',
  },
  {
    symbol: 'CAPR',
    'Security Name': 'Capricor Therapeutics,   ',

    'NASDAQ symbol': 'CAPR',
  },
  {
    symbol: 'CAR',
    'Security Name': 'Avis Budget Group,   ',

    'NASDAQ symbol': 'CAR',
  },
  {
    symbol: 'CARA',
    'Security Name': 'Cara Therapeutics,   ',

    'NASDAQ symbol': 'CARA',
  },
  {
    symbol: 'CARE',
    'Security Name': 'Carter Bankshares,   ',

    'NASDAQ symbol': 'CARE',
  },
  {
    symbol: 'CARG',
    'Security Name': 'CarGurus,    ',

    'NASDAQ symbol': 'CARG',
  },
  {
    symbol: 'CARR',
    'Security Name': 'Carrier Global Corporation  ',

    'CQS symbol': 'CARR',
    'NASDAQ symbol': 'CARR',
  },
  {
    symbol: 'CARS',
    'Security Name': 'Carscom   ',

    'CQS symbol': 'CARS',
    'NASDAQ symbol': 'CARS',
  },
  {
    symbol: 'CARV',
    'Security Name': 'Carver Bancorp,   ',

    'NASDAQ symbol': 'CARV',
  },
  {
    symbol: 'CARZ',
    'Security Name': 'First Trust NASDAQ Global Auto Index Fund',

    'NASDAQ symbol': 'CARZ',
  },
  {
    symbol: 'CASU',
    'Security Name':
      'Cascade Acquisition Corp Units, each consisting of one share of   and onehalf of one Redeemable Warrant',

    'CQS symbol': 'CASU',
    'NASDAQ symbol': 'CAS=',
  },
  {
    symbol: 'CASA',
    'Security Name': 'Casa Systems,   ',

    'NASDAQ symbol': 'CASA',
  },
  {
    symbol: 'CASH',
    'Security Name': 'Meta Financial Group,   ',

    'NASDAQ symbol': 'CASH',
  },
  {
    symbol: 'CASI',
    'Security Name': 'CASI Pharmaceuticals,   ',

    'NASDAQ symbol': 'CASI',
  },
  {
    symbol: 'CASS',
    'Security Name': 'Cass Information Systems,   ',

    'NASDAQ symbol': 'CASS',
  },
  {
    symbol: 'CASY',
    'Security Name': 'Caseys General Stores,   ',

    'NASDAQ symbol': 'CASY',
  },
  {
    symbol: 'CAT',
    'Security Name': 'Caterpillar,  ',

    'CQS symbol': 'CAT',
    'NASDAQ symbol': 'CAT',
  },
  {
    symbol: 'CATB',
    'Security Name': 'Catabasis Pharmaceuticals,   ',

    'NASDAQ symbol': 'CATB',
  },
  {
    symbol: 'CATC',
    'Security Name': 'Cambridge Bancorp  ',

    'NASDAQ symbol': 'CATC',
  },
  {
    symbol: 'CATH',
    'Security Name': 'Global X S&P 500 Catholic Values ETF',

    'NASDAQ symbol': 'CATH',
  },
  {
    symbol: 'CATM',
    'Security Name': 'Cardtronics plc  ',

    'NASDAQ symbol': 'CATM',
  },
  {
    symbol: 'CATO',
    'Security Name': 'Cato Corporation (The)  ',

    'CQS symbol': 'CATO',
    'NASDAQ symbol': 'CATO',
  },
  {
    symbol: 'CATY',
    'Security Name': 'Cathay General Bancorp  ',

    'NASDAQ symbol': 'CATY',
  },
  {
    symbol: 'CB',
    'Security Name': 'Chubb Limited  ',

    'CQS symbol': 'CB',
    'NASDAQ symbol': 'CB',
  },
  {
    symbol: 'CBAN',
    'Security Name': 'Colony Bankcorp,   ',

    'NASDAQ symbol': 'CBAN',
  },
  {
    symbol: 'CBAT',
    'Security Name': 'CBAK Energy Technology,   ',

    'NASDAQ symbol': 'CBAT',
  },
  {
    symbol: 'CBAY',
    'Security Name': 'CymaBay Therapeutics   ',

    'NASDAQ symbol': 'CBAY',
  },
  {
    symbol: 'CBB',
    'Security Name': 'Cinnati Bell  ',

    'CQS symbol': 'CBB',
    'NASDAQ symbol': 'CBB',
  },
  {
    symbol: 'CBB$B',
    'Security Name': 'Cinnati Bell  Preferred Stock',

    'CQS symbol': 'CBBpB',
    'NASDAQ symbol': 'CBBB',
  },
  {
    symbol: 'CBD',
    'Security Name':
      'Companhia Brasileira de Distribuicao American Depsitary Shares; each representing one Common Share',

    'CQS symbol': 'CBD',
    'NASDAQ symbol': 'CBD',
  },
  {
    symbol: 'CBFV',
    'Security Name': 'CB Financial Services,   ',

    'NASDAQ symbol': 'CBFV',
  },
  {
    symbol: 'CBH',
    'Security Name':
      'AllianzGI Convertible & ome 2024 Target Term Fund Common Shares of Beneficial Interest',

    'CQS symbol': 'CBH',
    'NASDAQ symbol': 'CBH',
  },
  {
    symbol: 'CBIO',
    'Security Name': 'Catalyst Biosciences,    ',

    'NASDAQ symbol': 'CBIO',
  },
  {
    symbol: 'CBLI',
    'Security Name': 'Cleveland BioLabs,   ',

    'NASDAQ symbol': 'CBLI',
  },
  {
    symbol: 'CBLS',
    'Security Name': 'Changebridge Capital Long/Short Equity ETF',

    'CQS symbol': 'CBLS',
    'NASDAQ symbol': 'CBLS',
  },
  {
    symbol: 'CBMB',
    'Security Name': 'CBM Bancorp,   ',

    'NASDAQ symbol': 'CBMB',
  },
  {
    symbol: 'CBMG',
    'Security Name': 'Cellular Biomedicine Group,   ',

    'NASDAQ symbol': 'CBMG',
  },
  {
    symbol: 'CBNK',
    'Security Name': 'Capital Bancorp,   ',

    'NASDAQ symbol': 'CBNK',
  },
  {
    symbol: 'CBO',
    'Security Name': 'CBO (Listing Market  NYSE  Networks A/E) ',

    'Test Issue': 'Y',

    'CQS symbol': 'CBO',
    'NASDAQ symbol': 'CBO',
  },
  {
    symbol: 'CBOE',
    'Security Name': 'Cboe Global Markets,  ',

    'CQS symbol': 'CBOE',
    'NASDAQ symbol': 'CBOE',
  },
  {
    symbol: 'CBON',
    'Security Name': 'VanEck Vectors ChinaAMC China Bond ETF',

    'CQS symbol': 'CBON',
    'NASDAQ symbol': 'CBON',
  },
  {
    symbol: 'CBPO',
    'Security Name': 'China Biologic Products Holdings,   ',

    'NASDAQ symbol': 'CBPO',
  },
  {
    symbol: 'CBRE',
    'Security Name': 'CBRE Group   ',

    'CQS symbol': 'CBRE',
    'NASDAQ symbol': 'CBRE',
  },
  {
    symbol: 'CBRL',
    'Security Name': 'Cracker Barrel Old Country Store,   ',

    'NASDAQ symbol': 'CBRL',
  },
  {
    symbol: 'CBSE',
    'Security Name': 'Changebridge Capital Sustainable Equity ETF',

    'CQS symbol': 'CBSE',
    'NASDAQ symbol': 'CBSE',
  },
  {
    symbol: 'CBSH',
    'Security Name': 'Commerce Bancshares,   ',

    'NASDAQ symbol': 'CBSH',
  },
  {
    symbol: 'CBT',
    'Security Name': 'Cabot Corporation ',

    'CQS symbol': 'CBT',
    'NASDAQ symbol': 'CBT',
  },
  {
    symbol: 'CBTX',
    'Security Name': 'CBTX,   ',

    'NASDAQ symbol': 'CBTX',
  },
  {
    symbol: 'CBU',
    'Security Name': 'Community Bank System,  ',

    'CQS symbol': 'CBU',
    'NASDAQ symbol': 'CBU',
  },
  {
    symbol: 'CBX',
    'Security Name': 'CBX (Listing Market NYSE Networks AE) ',

    'Test Issue': 'Y',

    'CQS symbol': 'CBX',
    'NASDAQ symbol': 'CBX',
  },
  {
    symbol: 'CBZ',
    'Security Name': 'CBIZ,  ',

    'CQS symbol': 'CBZ',
    'NASDAQ symbol': 'CBZ',
  },
  {
    symbol: 'CC',
    'Security Name': 'Chemours Company (The) ',

    'CQS symbol': 'CC',
    'NASDAQ symbol': 'CC',
  },
  {
    symbol: 'CCAC',
    'Security Name': 'CITIC Capital Acquisition Corp  Ordinary Shares',

    'CQS symbol': 'CCAC',
    'NASDAQ symbol': 'CCAC',
  },
  {
    symbol: 'CCACU',
    'Security Name': 'CITIC Capital Acquisition Corp Units',

    'CQS symbol': 'CCACU',
    'NASDAQ symbol': 'CCAC=',
  },
  {
    symbol: 'CCACW',
    'Security Name':
      'CITIC Capital Acquisition Corp Warrants, each whole warrant exercisable for one  ordinary share at an exercise price of $1150 per share',

    'CQS symbol': 'CCACWS',
    'NASDAQ symbol': 'CCAC+',
  },
  {
    symbol: 'CCAP',
    'Security Name': 'Crescent Capital BDC,   ',

    'NASDAQ symbol': 'CCAP',
  },
  {
    symbol: 'CCB',
    'Security Name': 'Coastal Financial Corporation  ',

    'NASDAQ symbol': 'CCB',
  },
  {
    symbol: 'CCBG',
    'Security Name': 'Capital City Bank Group  ',

    'NASDAQ symbol': 'CCBG',
  },
  {
    symbol: 'CCC',
    'Security Name': 'Clarivate Plc Ordinary Shares',

    'CQS symbol': 'CCC',
    'NASDAQ symbol': 'CCC',
  },
  {
    symbol: 'CCCC',
    'Security Name': 'C4 Therapeutics,   ',

    'NASDAQ symbol': 'CCCC',
  },
  {
    symbol: 'CCD',
    'Security Name': 'Calamos Dynamic Convertible & ome Fund  Common Shares',

    'NASDAQ symbol': 'CCD',
  },
  {
    symbol: 'CCEP',
    'Security Name': 'CocaCola European Partners plc Ordinary Shares',

    'CQS symbol': 'CCEP',
    'NASDAQ symbol': 'CCEP',
  },
  {
    symbol: 'CCF',
    'Security Name': 'Chase Corporation ',

    'CQS symbol': 'CCF',
    'NASDAQ symbol': 'CCF',
  },
  {
    symbol: 'CCI',
    'Security Name': 'Crown Castle International Corp (REIT) ',

    'CQS symbol': 'CCI',
    'NASDAQ symbol': 'CCI',
  },
  {
    symbol: 'CCIV',
    'Security Name': 'Churchill Capital Corp IV  ',

    'CQS symbol': 'CCIV',
    'NASDAQ symbol': 'CCIV',
  },
  {
    symbol: 'CCIVU',
    'Security Name':
      'Churchill Capital Corp IV Units, each consisting of one share of   and onefifth of one redeemable warrant',

    'CQS symbol': 'CCIVU',
    'NASDAQ symbol': 'CCIV=',
  },
  {
    symbol: 'CCIVW',
    'Security Name':
      'Churchill Capital Corp IV Warrants, each exercisable for one share of   at an exercise price of $1150 per share',

    'CQS symbol': 'CCIVWS',
    'NASDAQ symbol': 'CCIV+',
  },
  {
    symbol: 'CCJ',
    'Security Name': 'Cameco Corporation ',

    'CQS symbol': 'CCJ',
    'NASDAQ symbol': 'CCJ',
  },
  {
    symbol: 'CCK',
    'Security Name': 'Crown Holdings, ',

    'CQS symbol': 'CCK',
    'NASDAQ symbol': 'CCK',
  },
  {
    symbol: 'CCL',
    'Security Name': 'Carnival Corporation ',

    'CQS symbol': 'CCL',
    'NASDAQ symbol': 'CCL',
  },
  {
    symbol: 'CCLP',
    'Security Name': 'CSI Compressco LP  common units',

    'NASDAQ symbol': 'CCLP',
  },
  {
    symbol: 'CCM',
    'Security Name':
      'Concord Medical Services Holdings Limited ADS (Each represents three ordinary shares)',

    'CQS symbol': 'CCM',
    'NASDAQ symbol': 'CCM',
  },
  {
    symbol: 'CCMP',
    'Security Name': 'CMC Materials,   ',

    'NASDAQ symbol': 'CCMP',
  },
  {
    symbol: 'CCNC',
    'Security Name': 'Code Chain New Continent Limited  ',

    'NASDAQ symbol': 'CCNC',
  },
  {
    symbol: 'CCNE',
    'Security Name': 'CNB Financial Corporation  ',

    'NASDAQ symbol': 'CCNE',
  },
  {
    symbol: 'CCNEP',
    'Security Name':
      'CNB Financial Corporation  Depositary shares, each representing a 1/40th ownership interest in a share of 7125% Series A Fixed Rate NonCumulative Perpetual Preferred Stock',

    'NASDAQ symbol': 'CCNEP',
  },
  {
    symbol: 'CCO',
    'Security Name': 'Clear Channel Outdoor Holdings,  ',

    'CQS symbol': 'CCO',
    'NASDAQ symbol': 'CCO',
  },
  {
    symbol: 'CCOI',
    'Security Name': 'Cogent Communications Holdings,   ',

    'NASDAQ symbol': 'CCOI',
  },
  {
    symbol: 'CCON',
    'Security Name': 'Direxion Connected Consumer ETF',

    'CQS symbol': 'CCON',
    'NASDAQ symbol': 'CCON',
  },
  {
    symbol: 'CCOR',
    'Security Name': 'Core Alternative ETF',

    'CQS symbol': 'CCOR',
    'NASDAQ symbol': 'CCOR',
  },
  {
    symbol: 'CCR',
    'Security Name':
      'CONSOL Coal Resources LP Common Units representing limited partner interests',

    'CQS symbol': 'CCR',
    'NASDAQ symbol': 'CCR',
  },
  {
    symbol: 'CCRC',
    'Security Name': 'China Customer Relations Centers,   Ordinary Shares',

    'NASDAQ symbol': 'CCRC',
  },
  {
    symbol: 'CCRN',
    'Security Name': 'Cross Country Healthcare,   ',

    'NASDAQ symbol': 'CCRN',
  },
  {
    symbol: 'CCRV',
    'Security Name':
      'iShares US ETF Trust iShares Commodity Curve Carry Strategy ETF',

    'CQS symbol': 'CCRV',
    'NASDAQ symbol': 'CCRV',
  },
  {
    symbol: 'CCS',
    'Security Name': 'Century Communities,  ',

    'CQS symbol': 'CCS',
    'NASDAQ symbol': 'CCS',
  },
  {
    symbol: 'CCU',
    'Security Name': 'Compania Cervecerias Unidas, SA ',

    'CQS symbol': 'CCU',
    'NASDAQ symbol': 'CCU',
  },
  {
    symbol: 'CCX',
    'Security Name': 'Churchill Capital Corp II  ',

    'CQS symbol': 'CCX',
    'NASDAQ symbol': 'CCX',
  },
  {
    symbol: 'CCXU',
    'Security Name':
      'Churchill Capital Corp II Units, each consisting of one share of  , $00001 par value, and onethird of one redeemable warrant',

    'CQS symbol': 'CCXU',
    'NASDAQ symbol': 'CCX=',
  },
  {
    symbol: 'CCXW',
    'Security Name':
      'Churchill Capital Corp II Warrants, each exercisable for one share of   at an exercise price of $1150 per share',

    'CQS symbol': 'CCXWS',
    'NASDAQ symbol': 'CCX+',
  },
  {
    symbol: 'CCXI',
    'Security Name': 'ChemoCentryx,   ',

    'NASDAQ symbol': 'CCXI',
  },
  {
    symbol: 'CCZ',
    'Security Name': 'Comcast Holdings ZONES',

    'CQS symbol': 'CCZ',
    'NASDAQ symbol': 'CCZ',
  },
  {
    symbol: 'CD',
    'Security Name':
      'Chindata Group Holdings Limited  American Depositary Shares',

    'NASDAQ symbol': 'CD',
  },
  {
    symbol: 'CDAK',
    'Security Name': 'Codiak BioSciences,   ',

    'NASDAQ symbol': 'CDAK',
  },
  {
    symbol: 'CDAY',
    'Security Name': 'Ceridian HCM Holding  ',

    'CQS symbol': 'CDAY',
    'NASDAQ symbol': 'CDAY',
  },
  {
    symbol: 'CDC',
    'Security Name': 'VictoryShares US EQ ome Enhanced Volatility Wtd ETF',

    'NASDAQ symbol': 'CDC',
  },
  {
    symbol: 'CDE',
    'Security Name': 'Coeur Mining,  ',

    'CQS symbol': 'CDE',
    'NASDAQ symbol': 'CDE',
  },
  {
    symbol: 'CDEV',
    'Security Name': 'Centennial Resource Development,    ',

    'NASDAQ symbol': 'CDEV',
  },
  {
    symbol: 'CDK',
    'Security Name': 'CDK Global,   ',

    'NASDAQ symbol': 'CDK',
  },
  {
    symbol: 'CDL',
    'Security Name': 'VictoryShares US Large Cap High Div Volatility Wtd ETF',

    'NASDAQ symbol': 'CDL',
  },
  {
    symbol: 'CDLX',
    'Security Name': 'Cardlytics,   ',

    'NASDAQ symbol': 'CDLX',
  },
  {
    symbol: 'CDMO',
    'Security Name': 'Avid Bioservices,   ',

    'NASDAQ symbol': 'CDMO',
  },
  {
    symbol: 'CDMOP',
    'Security Name':
      'Avid Bioservices,   1050% Series E Convertible Preferred Stock',

    'NASDAQ symbol': 'CDMOP',
  },
  {
    symbol: 'CDNA',
    'Security Name': 'CareDx,   ',

    'NASDAQ symbol': 'CDNA',
  },
  {
    symbol: 'CDNS',
    'Security Name': 'Cadence Design Systems,   ',

    'NASDAQ symbol': 'CDNS',
  },
  {
    symbol: 'CDOR',
    'Security Name': 'Condor Hospitality Trust,  ',

    'CQS symbol': 'CDOR',
    'NASDAQ symbol': 'CDOR',
  },
  {
    symbol: 'CDR',
    'Security Name': 'Cedar Realty Trust,  ',

    'CQS symbol': 'CDR',
    'NASDAQ symbol': 'CDR',
  },
  {
    symbol: 'CDR$B',
    'Security Name':
      'Cedar Realty Trust,  725% Series B Cumulative Redeemable Preferred Stock',

    'CQS symbol': 'CDRpB',
    'NASDAQ symbol': 'CDRB',
  },
  {
    symbol: 'CDR$C',
    'Security Name':
      'Cedar Realty Trust,  650% Series C Cumulative Redeemable Preferred Stock',

    'CQS symbol': 'CDRpC',
    'NASDAQ symbol': 'CDRC',
  },
  {
    symbol: 'CDTX',
    'Security Name': 'Cidara Therapeutics,   ',

    'NASDAQ symbol': 'CDTX',
  },
  {
    symbol: 'CDW',
    'Security Name': 'CDW Corporation  ',

    'NASDAQ symbol': 'CDW',
  },
  {
    symbol: 'CDXC',
    'Security Name': 'ChromaDex Corporation  ',

    'NASDAQ symbol': 'CDXC',
  },
  {
    symbol: 'CDXS',
    'Security Name': 'Codexis,   ',

    'NASDAQ symbol': 'CDXS',
  },
  {
    symbol: 'CDZI',
    'Security Name': 'Cadiz,   ',

    'NASDAQ symbol': 'CDZI',
  },
  {
    symbol: 'CE',
    'Security Name': 'Celanese Corporation Celanese Corporation ',

    'CQS symbol': 'CE',
    'NASDAQ symbol': 'CE',
  },
  {
    symbol: 'CEA',
    'Security Name': 'China Eastern Airlines Corporation Ltd ',

    'CQS symbol': 'CEA',
    'NASDAQ symbol': 'CEA',
  },
  {
    symbol: 'CECE',
    'Security Name': 'CECO Environmental Corp  ',

    'NASDAQ symbol': 'CECE',
  },
  {
    symbol: 'CEE',
    'Security Name': 'The Central and Eastern Europe Fund,  (The) ',

    'CQS symbol': 'CEE',
    'NASDAQ symbol': 'CEE',
  },
  {
    symbol: 'CEF',
    'Security Name': 'Sprott Physical Gold and Silver Trust Units',

    'CQS symbol': 'CEF',
    'NASDAQ symbol': 'CEF',
  },
  {
    symbol: 'CEFA',
    'Security Name': 'Global X S&P Catholic Values Developed exUS ETF',

    'NASDAQ symbol': 'CEFA',
  },
  {
    symbol: 'CEFD',
    'Security Name':
      'ETRACS Monthly Pay 15X Leveraged ClosedEnd Fund Index ETN',

    'CQS symbol': 'CEFD',
    'NASDAQ symbol': 'CEFD',
  },
  {
    symbol: 'CEFS',
    'Security Name': 'Exchange Listed Funds Trust ETF',

    'CQS symbol': 'CEFS',
    'NASDAQ symbol': 'CEFS',
  },
  {
    symbol: 'CEI',
    'Security Name': 'Camber Energy,  ',

    'CQS symbol': 'CEI',
    'NASDAQ symbol': 'CEI',
  },
  {
    symbol: 'CEIX',
    'Security Name': 'CONSOL Energy   ',

    'CQS symbol': 'CEIX',
    'NASDAQ symbol': 'CEIX',
  },
  {
    symbol: 'CEL',
    'Security Name': 'Cellcom Israel, Ltd Ordinary Shares',

    'CQS symbol': 'CEL',
    'NASDAQ symbol': 'CEL',
  },
  {
    symbol: 'CELC',
    'Security Name': 'Celcuity   ',

    'NASDAQ symbol': 'CELC',
  },
  {
    symbol: 'CELGR',
    'Security Name':
      'BristolMyers Squibb Company Celegne Contingent Value Rights',

    'CQS symbol': 'CELGr',
    'NASDAQ symbol': 'CELG^',
  },
  {
    symbol: 'CELH',
    'Security Name': 'Celsius Holdings,   ',

    'NASDAQ symbol': 'CELH',
  },
  {
    symbol: 'CELP',
    'Security Name':
      'Cypress Environmental Partners, LP Common Units representing limited partner interests',

    'CQS symbol': 'CELP',
    'NASDAQ symbol': 'CELP',
  },
  {
    symbol: 'CEM',
    'Security Name': 'ClearBridge MLP and Midstream Fund  ',

    'CQS symbol': 'CEM',
    'NASDAQ symbol': 'CEM',
  },
  {
    symbol: 'CEMB',
    'Security Name': 'iShares JP Morgan EM Corporate Bond ETF',

    'CQS symbol': 'CEMB',
    'NASDAQ symbol': 'CEMB',
  },
  {
    symbol: 'CEMI',
    'Security Name': 'Chembio Diagnostics,   ',

    'NASDAQ symbol': 'CEMI',
  },
  {
    symbol: 'CEN',
    'Security Name': 'Center Coast Brookfield MLP & Energy Infrastructure Fund',

    'CQS symbol': 'CEN',
    'NASDAQ symbol': 'CEN',
  },
  {
    symbol: 'CENT',
    'Security Name': 'Central Garden & Pet Company  ',

    'NASDAQ symbol': 'CENT',
  },
  {
    symbol: 'CENTA',
    'Security Name': 'Central Garden & Pet Company    Nonvoting',

    'NASDAQ symbol': 'CENTA',
  },
  {
    symbol: 'CENX',
    'Security Name': 'Century Aluminum Company  ',

    'NASDAQ symbol': 'CENX',
  },
  {
    symbol: 'CEO',
    'Security Name': 'CNOOC Limited ',

    'CQS symbol': 'CEO',
    'NASDAQ symbol': 'CEO',
  },
  {
    symbol: 'CEPU',
    'Security Name':
      'Central Puerto SA American Depositary Shares (each represents ten Common Shares)',

    'CQS symbol': 'CEPU',
    'NASDAQ symbol': 'CEPU',
  },
  {
    symbol: 'CEQP',
    'Security Name': 'Crestwood Equity Partners LP',

    'CQS symbol': 'CEQP',
    'NASDAQ symbol': 'CEQP',
  },
  {
    symbol: 'CEQP$',
    'Security Name':
      'Crestwood Equity Partners LP Preferred Units representing limited partner interests',

    'CQS symbol': 'CEQPp',
    'NASDAQ symbol': 'CEQP',
  },
  {
    symbol: 'CERC',
    'Security Name': 'Cerecor   ',

    'NASDAQ symbol': 'CERC',
  },
  {
    symbol: 'CERE',
    'Security Name': 'Cerevel Therapeutics Holdings,   ',

    'NASDAQ symbol': 'CERE',
  },
  {
    symbol: 'CEREW',
    'Security Name': 'Cerevel Therapeutics Holdings,   Warrant',

    'NASDAQ symbol': 'CEREW',
  },
  {
    symbol: 'CERN',
    'Security Name': 'Cerner Corporation  ',

    'NASDAQ symbol': 'CERN',
  },
  {
    symbol: 'CERS',
    'Security Name': 'Cerus Corporation  ',

    'NASDAQ symbol': 'CERS',
  },
  {
    symbol: 'CET',
    'Security Name': 'Central Securities Corporation ',

    'CQS symbol': 'CET',
    'NASDAQ symbol': 'CET',
  },
  {
    symbol: 'CETX',
    'Security Name': 'Cemtrex   ',

    'NASDAQ symbol': 'CETX',
  },
  {
    symbol: 'CETXP',
    'Security Name': 'Cemtrex   Series 1 Preferred Stock',

    'NASDAQ symbol': 'CETXP',
  },
  {
    symbol: 'CETXW',
    'Security Name': 'Cemtrex   Series 1 Warrant',

    'NASDAQ symbol': 'CETXW',
  },
  {
    symbol: 'CEV',
    'Security Name':
      'Eaton Vance California Municipal ome Trust Shares of Beneficial Interest',

    'CQS symbol': 'CEV',
    'NASDAQ symbol': 'CEV',
  },
  {
    symbol: 'CEVA',
    'Security Name': 'CEVA,   ',

    'NASDAQ symbol': 'CEVA',
  },
  {
    symbol: 'CEW',
    'Security Name': 'WisdomTree Emerging Currency Strategy Fund',

    'CQS symbol': 'CEW',
    'NASDAQ symbol': 'CEW',
  },
  {
    symbol: 'CEY',
    'Security Name':
      'VictoryShares Emerging Market High Div Volatility Wtd ETF',

    'NASDAQ symbol': 'CEY',
  },
  {
    symbol: 'CEZ',
    'Security Name': 'VictoryShares Emerging Market Volatility Wtd ETF',

    'NASDAQ symbol': 'CEZ',
  },
  {
    symbol: 'CF',
    'Security Name': 'CF Industries Holdings,  ',

    'CQS symbol': 'CF',
    'NASDAQ symbol': 'CF',
  },
  {
    symbol: 'CFA',
    'Security Name': 'VictoryShares US 500 Volatility Wtd ETF',

    'NASDAQ symbol': 'CFA',
  },
  {
    symbol: 'CFACU',
    'Security Name': 'CF Finance Acquisition Corp III  Unit',

    'NASDAQ symbol': 'CFACU',
  },
  {
    symbol: 'CFB',
    'Security Name': 'CrossFirst Bankshares,   ',

    'NASDAQ symbol': 'CFB',
  },
  {
    symbol: 'CFBI',
    'Security Name': 'Community First Bancshares,   ',

    'NASDAQ symbol': 'CFBI',
  },
  {
    symbol: 'CFBK',
    'Security Name': 'CF Bankshares   ',

    'NASDAQ symbol': 'CFBK',
  },
  {
    symbol: 'CFCV',
    'Security Name': 'ClearBridge Focus Value ETF',

    'CQS symbol': 'CFCV',
    'NASDAQ symbol': 'CFCV',
  },
  {
    symbol: 'CFFI',
    'Security Name': 'C&F Financial Corporation  ',

    'NASDAQ symbol': 'CFFI',
  },
  {
    symbol: 'CFFN',
    'Security Name': 'Capitol Federal Financial,   ',

    'NASDAQ symbol': 'CFFN',
  },
  {
    symbol: 'CFG',
    'Security Name': 'Citizens Financial Group,  ',

    'CQS symbol': 'CFG',
    'NASDAQ symbol': 'CFG',
  },
  {
    symbol: 'CFG$D',
    'Security Name':
      'Citizens Financial Group,  Depositary Shares, each representing a 1/40th Interest in a Share of 6350% FixedtoFloating Rate NonCumulative Perpetual Preferred Stock, Series D',

    'CQS symbol': 'CFGpD',
    'NASDAQ symbol': 'CFGD',
  },
  {
    symbol: 'CFG$E',
    'Security Name':
      'Citizens Financial Group,  Depositary Shares Each Representing 1/40th Interest in a Share of 5000% FixedRate NonCumulative Perpetual Preferred Stock, Series E',

    'CQS symbol': 'CFGpE',
    'NASDAQ symbol': 'CFGE',
  },
  {
    symbol: 'CFII',
    'Security Name': 'CF Finance Acquisition Corp II   ',

    'NASDAQ symbol': 'CFII',
  },
  {
    symbol: 'CFIIU',
    'Security Name': 'CF Finance Acquisition Corp II  Unit',

    'NASDAQ symbol': 'CFIIU',
  },
  {
    symbol: 'CFIIW',
    'Security Name': 'CF Finance Acquisition Corp II  Warrant',

    'NASDAQ symbol': 'CFIIW',
  },
  {
    symbol: 'CFMS',
    'Security Name': 'Conformis,   ',

    'NASDAQ symbol': 'CFMS',
  },
  {
    symbol: 'CFO',
    'Security Name': 'VictoryShares US 500 Enhanced Volatility Wtd ETF',

    'NASDAQ symbol': 'CFO',
  },
  {
    symbol: 'CFR',
    'Security Name': 'Cullen/Frost Bankers,  ',

    'CQS symbol': 'CFR',
    'NASDAQ symbol': 'CFR',
  },
  {
    symbol: 'CFR$B',
    'Security Name':
      'Cullen/Frost Bankers,  Depositary Shares, each representing a 1/40th ownership interest in a share of 4450% noncumulative perpetual preferred stock, Series B',

    'CQS symbol': 'CFRpB',
    'NASDAQ symbol': 'CFRB',
  },
  {
    symbol: 'CFRX',
    'Security Name': 'ContraFect Corporation  ',

    'NASDAQ symbol': 'CFRX',
  },
  {
    symbol: 'CFX',
    'Security Name': 'Colfax Corporation ',

    'CQS symbol': 'CFX',
    'NASDAQ symbol': 'CFX',
  },
  {
    symbol: 'CFXA',
    'Security Name': 'Colfax Corporation 575% Tangible Equity Units',

    'CQS symbol': 'CFXA',
    'NASDAQ symbol': 'CFXA',
  },
  {
    symbol: 'CG',
    'Security Name': 'The Carlyle Group   ',

    'NASDAQ symbol': 'CG',
  },
  {
    symbol: 'CGA',
    'Security Name': 'China Green Agriculture,  ',

    'CQS symbol': 'CGA',
    'NASDAQ symbol': 'CGA',
  },
  {
    symbol: 'CGBD',
    'Security Name': 'TCG BDC,   ',

    'NASDAQ symbol': 'CGBD',
  },
  {
    symbol: 'CGC',
    'Security Name': 'Canopy Growth Corporation  Common Shares',

    'NASDAQ symbol': 'CGC',
  },
  {
    symbol: 'CGEN',
    'Security Name': 'Compugen Ltd  Ordinary Shares',

    'NASDAQ symbol': 'CGEN',
  },
  {
    symbol: 'CGIX',
    'Security Name': 'Cancer Genetics,   ',

    'NASDAQ symbol': 'CGIX',
  },
  {
    symbol: 'CGNX',
    'Security Name': 'Cognex Corporation  ',

    'NASDAQ symbol': 'CGNX',
  },
  {
    symbol: 'CGO',
    'Security Name': 'Calamos Global Total Return Fund  ',

    'NASDAQ symbol': 'CGO',
  },
  {
    symbol: 'CGRO',
    'Security Name': 'Collective Growth Corporation   ',

    'NASDAQ symbol': 'CGRO',
  },
  {
    symbol: 'CGROU',
    'Security Name': 'Collective Growth Corporation  Unit',

    'NASDAQ symbol': 'CGROU',
  },
  {
    symbol: 'CGROW',
    'Security Name': 'Collective Growth Corporation  Warrant',

    'NASDAQ symbol': 'CGROW',
  },
  {
    symbol: 'CGW',
    'Security Name': 'Invesco S&P Global Water Index ETF',

    'CQS symbol': 'CGW',
    'NASDAQ symbol': 'CGW',
  },
  {
    symbol: 'CHA',
    'Security Name': 'China Telecom Corp Ltd ADS',

    'CQS symbol': 'CHA',
    'NASDAQ symbol': 'CHA',
  },
  {
    symbol: 'CHAD',
    'Security Name': 'Direxion Daily CSI 300 China A Shares Bear 1X Shares',

    'CQS symbol': 'CHAD',
    'NASDAQ symbol': 'CHAD',
  },
  {
    symbol: 'CHAQ',
    'Security Name': 'Chardan Healthcare Acquisition 2 Corp ',

    'CQS symbol': 'CHAQ',
    'NASDAQ symbol': 'CHAQ',
  },
  {
    symbol: 'CHAQU',
    'Security Name':
      'Chardan Healthcare Acquisition 2 Corp Units, each consisting of one share of , and one Warrant entitling the holder to purchase onehalf of a share of ',

    'CQS symbol': 'CHAQU',
    'NASDAQ symbol': 'CHAQ=',
  },
  {
    symbol: 'CHAQW',
    'Security Name':
      'Chardan Healthcare Acquisition 2 Corp Warrants, entitling the holder thereof to purchase onehalf (1/2) of a share of  at a price of $1150 per whole share',

    'CQS symbol': 'CHAQWS',
    'NASDAQ symbol': 'CHAQ+',
  },
  {
    symbol: 'CHAU',
    'Security Name': 'Direxion Daily CSI 300 China A Share Bull 2X Shares',

    'CQS symbol': 'CHAU',
    'NASDAQ symbol': 'CHAU',
  },
  {
    symbol: 'CHB',
    'Security Name': 'Global X China Biotech Innovation ETF',

    'NASDAQ symbol': 'CHB',
  },
  {
    symbol: 'CHCI',
    'Security Name': 'Comstock Holding Companies,    ',

    'NASDAQ symbol': 'CHCI',
  },
  {
    symbol: 'CHCO',
    'Security Name': 'City Holding Company  ',

    'NASDAQ symbol': 'CHCO',
  },
  {
    symbol: 'CHCT',
    'Security Name': 'Community Healthcare Trust orporated ',

    'CQS symbol': 'CHCT',
    'NASDAQ symbol': 'CHCT',
  },
  {
    symbol: 'CHD',
    'Security Name': 'Church & Dwight Company,  ',

    'CQS symbol': 'CHD',
    'NASDAQ symbol': 'CHD',
  },
  {
    symbol: 'CHDN',
    'Security Name': 'Churchill Downs, orporated  ',

    'NASDAQ symbol': 'CHDN',
  },
  {
    symbol: 'CHE',
    'Security Name': 'Chemed Corp',

    'CQS symbol': 'CHE',
    'NASDAQ symbol': 'CHE',
  },
  {
    symbol: 'CHEF',
    'Security Name': "The Chefs' Warehouse,   ",

    'NASDAQ symbol': 'CHEF',
  },
  {
    symbol: 'CHEK',
    'Security Name': 'CheckCap Ltd  Ordinary Share',

    'NASDAQ symbol': 'CHEK',
  },
  {
    symbol: 'CHEKZ',
    'Security Name': 'CheckCap Ltd  Series C Warrant',

    'NASDAQ symbol': 'CHEKZ',
  },
  {
    symbol: 'CHEP',
    'Security Name': 'AGFiQ US Market Neutral Value Fund',

    'CQS symbol': 'CHEP',
    'NASDAQ symbol': 'CHEP',
  },
  {
    symbol: 'CHFS',
    'Security Name': 'CHF Solutions,   ',

    'NASDAQ symbol': 'CHFS',
  },
  {
    symbol: 'CHFWU',
    'Security Name':
      'ConsonanceHFW Acquisition Corp Units, each consisting of one  Ordinary Share, and onethird of one Warrant to acquire one  Ordinary Share',

    'CQS symbol': 'CHFWU',
    'NASDAQ symbol': 'CHFW=',
  },
  {
    symbol: 'CHGG',
    'Security Name': 'Chegg,  ',

    'CQS symbol': 'CHGG',
    'NASDAQ symbol': 'CHGG',
  },
  {
    symbol: 'CHGX',
    'Security Name': 'Change Finance US Large Cap Fossil Fuel Free ETF',

    'CQS symbol': 'CHGX',
    'NASDAQ symbol': 'CHGX',
  },
  {
    symbol: 'CHH',
    'Security Name': 'Choice Hotels International,  ',

    'CQS symbol': 'CHH',
    'NASDAQ symbol': 'CHH',
  },
  {
    symbol: 'CHI',
    'Security Name': 'Calamos Convertible Opportunities and ome Fund  ',

    'NASDAQ symbol': 'CHI',
  },
  {
    symbol: 'CHIC',
    'Security Name':
      'Global X Funds Global X MSCI China Communication Services ETF',

    'CQS symbol': 'CHIC',
    'NASDAQ symbol': 'CHIC',
  },
  {
    symbol: 'CHIE',
    'Security Name': 'Global X MSCI China Energy ETF',

    'CQS symbol': 'CHIE',
    'NASDAQ symbol': 'CHIE',
  },
  {
    symbol: 'CHIH',
    'Security Name': 'Global X Funds Global X MSCI China Health Care ETF',

    'CQS symbol': 'CHIH',
    'NASDAQ symbol': 'CHIH',
  },
  {
    symbol: 'CHII',
    'Security Name': 'Global X MSCI China Industrials ETF',

    'CQS symbol': 'CHII',
    'NASDAQ symbol': 'CHII',
  },
  {
    symbol: 'CHIK',
    'Security Name':
      'Global X Funds Global X MSCI China Information Technology ETF',

    'CQS symbol': 'CHIK',
    'NASDAQ symbol': 'CHIK',
  },
  {
    symbol: 'CHIL',
    'Security Name': 'Global X Funds Global X MSCI China LargeCap 50 ETF',

    'CQS symbol': 'CHIL',
    'NASDAQ symbol': 'CHIL',
  },
  {
    symbol: 'CHIM',
    'Security Name': 'Global X MSCI China Materials ETF',

    'CQS symbol': 'CHIM',
    'NASDAQ symbol': 'CHIM',
  },
  {
    symbol: 'CHIQ',
    'Security Name': 'Global X MSCI China Consumer Discretionary ETF',

    'CQS symbol': 'CHIQ',
    'NASDAQ symbol': 'CHIQ',
  },
  {
    symbol: 'CHIR',
    'Security Name': 'Global X Funds Global X MSCI China Real Estate ETF',

    'CQS symbol': 'CHIR',
    'NASDAQ symbol': 'CHIR',
  },
  {
    symbol: 'CHIS',
    'Security Name': 'Global X Funds Global X MSCI China Consumer Staples ETF',

    'CQS symbol': 'CHIS',
    'NASDAQ symbol': 'CHIS',
  },
  {
    symbol: 'CHIU',
    'Security Name': 'Global X Funds Global X MSCI China Utilities ETF',

    'CQS symbol': 'CHIU',
    'NASDAQ symbol': 'CHIU',
  },
  {
    symbol: 'CHIX',
    'Security Name': 'Global X MSCI China Financials ETF',

    'CQS symbol': 'CHIX',
    'NASDAQ symbol': 'CHIX',
  },
  {
    symbol: 'CHKP',
    'Security Name': 'Check Point Software Technologies Ltd  Ordinary Shares',

    'NASDAQ symbol': 'CHKP',
  },
  {
    symbol: 'CHL',
    'Security Name': 'China Mobile Limited ',

    'CQS symbol': 'CHL',
    'NASDAQ symbol': 'CHL',
  },
  {
    symbol: 'CHMA',
    'Security Name': 'Chiasma,   ',

    'NASDAQ symbol': 'CHMA',
  },
  {
    symbol: 'CHMG',
    'Security Name': 'Chemung Financial Corp  ',

    'NASDAQ symbol': 'CHMG',
  },
  {
    symbol: 'CHMI',
    'Security Name': 'Cherry Hill Mortgage Investment Corporation ',

    'CQS symbol': 'CHMI',
    'NASDAQ symbol': 'CHMI',
  },
  {
    symbol: 'CHMI$A',
    'Security Name':
      'Cherry Hill Mortgage Investment Corporation 820% Series A Cumulative Redeemable Preferred Stock',

    'CQS symbol': 'CHMIpA',
    'NASDAQ symbol': 'CHMIA',
  },
  {
    symbol: 'CHMI$B',
    'Security Name':
      'Cherry Hill Mortgage Investment Corporation 8250% Series B FixedtoFloating Rate Cumulative Redeemable Preferred Stock',

    'CQS symbol': 'CHMIpB',
    'NASDAQ symbol': 'CHMIB',
  },
  {
    symbol: 'CHN',
    'Security Name': 'China Fund,  (The) ',

    'CQS symbol': 'CHN',
    'NASDAQ symbol': 'CHN',
  },
  {
    symbol: 'CHNA',
    'Security Name': 'Loncar China BioPharma ETF',

    'NASDAQ symbol': 'CHNA',
  },
  {
    symbol: 'CHNG',
    'Security Name': 'Change Healthcare   ',

    'NASDAQ symbol': 'CHNG',
  },
  {
    symbol: 'CHNGU',
    'Security Name': 'Change Healthcare   Tangible Equity Units',

    'NASDAQ symbol': 'CHNGU',
  },
  {
    symbol: 'CHNR',
    'Security Name': 'China Natural Resources,   ',

    'NASDAQ symbol': 'CHNR',
  },
  {
    symbol: 'CHPM',
    'Security Name': 'CHP Merger Corp   ',

    'NASDAQ symbol': 'CHPM',
  },
  {
    symbol: 'CHPMU',
    'Security Name': 'CHP Merger Corp  Unit',

    'NASDAQ symbol': 'CHPMU',
  },
  {
    symbol: 'CHPMW',
    'Security Name': 'CHP Merger Corp  Warrant',

    'NASDAQ symbol': 'CHPMW',
  },
  {
    symbol: 'CHRA',
    'Security Name': 'Charah Solutions,  ',

    'CQS symbol': 'CHRA',
    'NASDAQ symbol': 'CHRA',
  },
  {
    symbol: 'CHRS',
    'Security Name': 'Coherus BioSciences,   ',

    'NASDAQ symbol': 'CHRS',
  },
  {
    symbol: 'CHRW',
    'Security Name': 'CH Robinson Worldwide,   ',

    'NASDAQ symbol': 'CHRW',
  },
  {
    symbol: 'CHS',
    'Security Name': "Chico's FAS,  ",

    'CQS symbol': 'CHS',
    'NASDAQ symbol': 'CHS',
  },
  {
    symbol: 'CHSCL',
    'Security Name':
      'CHS   Class B Cumulative Redeemable Preferred Stock, Series 4',

    'NASDAQ symbol': 'CHSCL',
  },
  {
    symbol: 'CHSCM',
    'Security Name':
      'CHS   Class B Reset Rate Cumulative Redeemable Preferred Stock, Series 3',

    'NASDAQ symbol': 'CHSCM',
  },
  {
    symbol: 'CHSCN',
    'Security Name': 'CHS   Preferred Class B Series 2 Reset Rate',

    'NASDAQ symbol': 'CHSCN',
  },
  {
    symbol: 'CHSCO',
    'Security Name': 'CHS   Class B Cumulative Redeemable Preferred Stock',

    'NASDAQ symbol': 'CHSCO',
  },
  {
    symbol: 'CHSCP',
    'Security Name': 'CHS   8%  Cumulative Redeemable Preferred Stock',

    'NASDAQ symbol': 'CHSCP',
  },
  {
    symbol: 'CHT',
    'Security Name': 'Chunghwa Telecom Co, Ltd',

    'CQS symbol': 'CHT',
    'NASDAQ symbol': 'CHT',
  },
  {
    symbol: 'CHTR',
    'Security Name': 'Charter Communications,    ',

    'NASDAQ symbol': 'CHTR',
  },
  {
    symbol: 'CHU',
    'Security Name': 'China Unicom (Hong Kong) Ltd ',

    'CQS symbol': 'CHU',
    'NASDAQ symbol': 'CHU',
  },
  {
    symbol: 'CHUY',
    'Security Name': "Chuy's Holdings,   ",

    'NASDAQ symbol': 'CHUY',
  },
  {
    symbol: 'CHW',
    'Security Name': 'Calamos Global Dynamic ome Fund  ',

    'NASDAQ symbol': 'CHW',
  },
  {
    symbol: 'CHWY',
    'Security Name': 'Chewy,   ',

    'CQS symbol': 'CHWY',
    'NASDAQ symbol': 'CHWY',
  },
  {
    symbol: 'CHX',
    'Security Name': 'ChampionX Corporation  ',

    'CQS symbol': 'CHX',
    'NASDAQ symbol': 'CHX',
  },
  {
    symbol: 'CHY',
    'Security Name': 'Calamos Convertible and High ome Fund  ',

    'NASDAQ symbol': 'CHY',
  },
  {
    symbol: 'CI',
    'Security Name': 'Cigna Corporation ',

    'CQS symbol': 'CI',
    'NASDAQ symbol': 'CI',
  },
  {
    symbol: 'CIA',
    'Security Name': 'Citizens,    ($100 Par)',

    'CQS symbol': 'CIA',
    'NASDAQ symbol': 'CIA',
  },
  {
    symbol: 'CIB',
    'Security Name': 'BanColombia SA ',

    'CQS symbol': 'CIB',
    'NASDAQ symbol': 'CIB',
  },
  {
    symbol: 'CIBR',
    'Security Name': 'First Trust NASDAQ Cybersecurity ETF',

    'NASDAQ symbol': 'CIBR',
  },
  {
    symbol: 'CID',
    'Security Name': 'VictoryShares International High Div Volatility Wtd ETF',

    'NASDAQ symbol': 'CID',
  },
  {
    symbol: 'CIDM',
    'Security Name': 'Cinedigm Corp   ',

    'NASDAQ symbol': 'CIDM',
  },
  {
    symbol: 'CIEN',
    'Security Name': 'Ciena Corporation ',

    'CQS symbol': 'CIEN',
    'NASDAQ symbol': 'CIEN',
  },
  {
    symbol: 'CIF',
    'Security Name': 'MFS Intermediate High ome Fund ',

    'CQS symbol': 'CIF',
    'NASDAQ symbol': 'CIF',
  },
  {
    symbol: 'CIG',
    'Security Name': 'Comp En De Mn Cemig ADS American Depositary Shares',

    'CQS symbol': 'CIG',
    'NASDAQ symbol': 'CIG',
  },
  {
    symbol: 'CIGC',
    'Security Name': 'Comp En De Mn Cemig ADS American Depositary Receipts',

    'CQS symbol': 'CIGC',
    'NASDAQ symbol': 'CIGC',
  },
  {
    symbol: 'CIGI',
    'Security Name':
      'Colliers International Group    Subordinate Voting Shares',

    'NASDAQ symbol': 'CIGI',
  },
  {
    symbol: 'CIH',
    'Security Name': 'China Index Holdings Limited  American ',

    'NASDAQ symbol': 'CIH',
  },
  {
    symbol: 'CII',
    'Security Name': 'Blackrock Capital and ome Fund, ',

    'CQS symbol': 'CII',
    'NASDAQ symbol': 'CII',
  },
  {
    symbol: 'CIIC',
    'Security Name': 'CIIG Merger Corp   ',

    'NASDAQ symbol': 'CIIC',
  },
  {
    symbol: 'CIICU',
    'Security Name': 'CIIG Merger Corp  Units',

    'NASDAQ symbol': 'CIICU',
  },
  {
    symbol: 'CIICW',
    'Security Name': 'CIIG Merger Corp  Warrants',

    'NASDAQ symbol': 'CIICW',
  },
  {
    symbol: 'CIK',
    'Security Name': 'Credit Suisse Asset Management ome Fund,  ',

    'CQS symbol': 'CIK',
    'NASDAQ symbol': 'CIK',
  },
  {
    symbol: 'CIL',
    'Security Name': 'VictoryShares International Volatility Wtd ETF',

    'NASDAQ symbol': 'CIL',
  },
  {
    symbol: 'CIM',
    'Security Name': 'Chimera Investment Corporation ',

    'CQS symbol': 'CIM',
    'NASDAQ symbol': 'CIM',
  },
  {
    symbol: 'CIM$A',
    'Security Name':
      'Chimera Investment Corporation 800% Series A Cumulative Redeemable Preferred Stock',

    'CQS symbol': 'CIMpA',
    'NASDAQ symbol': 'CIMA',
  },
  {
    symbol: 'CIM$B',
    'Security Name':
      'Chimera Investment Corporation 800% Series B FixedtoFloating Rate Cumulative Redeemable Preferred Stock',

    'CQS symbol': 'CIMpB',
    'NASDAQ symbol': 'CIMB',
  },
  {
    symbol: 'CIM$C',
    'Security Name':
      'Chimera Investment Corporation 775% Series C FixedtoFloating Rate  Cumulative Redeemable  Preferred Stock',

    'CQS symbol': 'CIMpC',
    'NASDAQ symbol': 'CIMC',
  },
  {
    symbol: 'CIM$D',
    'Security Name':
      'Chimera Investment Corporation 800% Series D FixedtoFloating Rate Cumulative Redeemable Preferred Stock',

    'CQS symbol': 'CIMpD',
    'NASDAQ symbol': 'CIMD',
  },
  {
    symbol: 'CINF',
    'Security Name': 'Cinnati Financial Corporation  ',

    'NASDAQ symbol': 'CINF',
  },
  {
    symbol: 'CINR',
    'Security Name':
      'Ciner Resources LP Common Units representing Limited Partner Interests',

    'CQS symbol': 'CINR',
    'NASDAQ symbol': 'CINR',
  },
  {
    symbol: 'CIO',
    'Security Name': 'City Office REIT,  ',

    'CQS symbol': 'CIO',
    'NASDAQ symbol': 'CIO',
  },
  {
    symbol: 'CIO$A',
    'Security Name':
      'City Office REIT,  6625% Series A Cumulative Redeemable Preferred Stock',

    'CQS symbol': 'CIOpA',
    'NASDAQ symbol': 'CIOA',
  },
  {
    symbol: 'CIR',
    'Security Name': 'CIRCOR International,  ',

    'CQS symbol': 'CIR',
    'NASDAQ symbol': 'CIR',
  },
  {
    symbol: 'CIT',
    'Security Name': 'CIT Group  (DEL) ',

    'CQS symbol': 'CIT',
    'NASDAQ symbol': 'CIT',
  },
  {
    symbol: 'CIT$B',
    'Security Name':
      'CIT Group  (DEL) 5625 % NonCumulative Perpetual Preferred Stock, Series B',

    'CQS symbol': 'CITpB',
    'NASDAQ symbol': 'CITB',
  },
  {
    symbol: 'CIVB',
    'Security Name': 'Civista Bancshares,    ',

    'NASDAQ symbol': 'CIVB',
  },
  {
    symbol: 'CIX',
    'Security Name': 'CompX International  ',

    'CQS symbol': 'CIX',
    'NASDAQ symbol': 'CIX',
  },
  {
    symbol: 'CIXX',
    'Security Name': 'CI Financial Corp Common Shares',

    'CQS symbol': 'CIXX',
    'NASDAQ symbol': 'CIXX',
  },
  {
    symbol: 'CIZ',
    'Security Name': 'VictoryShares Developed Enhanced Volatility Wtd ETF',

    'NASDAQ symbol': 'CIZ',
  },
  {
    symbol: 'CIZN',
    'Security Name': 'Citizens Holding Company  ',

    'NASDAQ symbol': 'CIZN',
  },
  {
    symbol: 'CJJD',
    'Security Name': 'China JoJo Drugstores,   ',

    'NASDAQ symbol': 'CJJD',
  },
  {
    symbol: 'CKH',
    'Security Name': 'SEACOR Holdings  ',

    'CQS symbol': 'CKH',
    'NASDAQ symbol': 'CKH',
  },
  {
    symbol: 'CKPT',
    'Security Name': 'Checkpoint Therapeutics,   ',

    'NASDAQ symbol': 'CKPT',
  },
  {
    symbol: 'CKX',
    'Security Name': 'CKX Lands,  ',

    'CQS symbol': 'CKX',
    'NASDAQ symbol': 'CKX',
  },
  {
    symbol: 'CL',
    'Security Name': 'ColgatePalmolive Company ',

    'CQS symbol': 'CL',
    'NASDAQ symbol': 'CL',
  },
  {
    symbol: 'CLA',
    'Security Name': 'Colonnade Acquisition Corp  Ordinary Shares',

    'CQS symbol': 'CLA',
    'NASDAQ symbol': 'CLA',
  },
  {
    symbol: 'CLAU',
    'Security Name':
      'Colonnade Acquisition Corp Units, each consisting of one  ordinary share and onehalf of one redeemable warrant',

    'CQS symbol': 'CLAU',
    'NASDAQ symbol': 'CLA=',
  },
  {
    symbol: 'CLAW',
    'Security Name':
      'Colonnade Acquisition Corp Warrants, each whole warrant exercisable for one  ordinary share at an exercise price of $1150 per share',

    'CQS symbol': 'CLAWS',
    'NASDAQ symbol': 'CLA+',
  },
  {
    symbol: 'CLAR',
    'Security Name': 'Clarus Corporation  ',

    'NASDAQ symbol': 'CLAR',
  },
  {
    symbol: 'CLB',
    'Security Name': 'Core Laboratories NV ',

    'CQS symbol': 'CLB',
    'NASDAQ symbol': 'CLB',
  },
  {
    symbol: 'CLBK',
    'Security Name': 'Columbia Financial,   ',

    'NASDAQ symbol': 'CLBK',
  },
  {
    symbol: 'CLBS',
    'Security Name': 'Caladrius Biosciences,   ',

    'NASDAQ symbol': 'CLBS',
  },
  {
    symbol: 'CLCT',
    'Security Name': 'Collectors Universe,   ',

    'NASDAQ symbol': 'CLCT',
  },
  {
    symbol: 'CLDB',
    'Security Name': 'Cortland Bancorp  ',

    'NASDAQ symbol': 'CLDB',
  },
  {
    symbol: 'CLDR',
    'Security Name': 'Cloudera,  ',

    'CQS symbol': 'CLDR',
    'NASDAQ symbol': 'CLDR',
  },
  {
    symbol: 'CLDT',
    'Security Name':
      'Chatham Lodging Trust (REIT) Common Shares of Beneficial Interest',

    'CQS symbol': 'CLDT',
    'NASDAQ symbol': 'CLDT',
  },
  {
    symbol: 'CLDX',
    'Security Name': 'Celldex Therapeutics,   ',

    'NASDAQ symbol': 'CLDX',
  },
  {
    symbol: 'CLEU',
    'Security Name':
      'China Liberal Education Holdings Limited  Ordinary Shares',

    'NASDAQ symbol': 'CLEU',
  },
  {
    symbol: 'CLF',
    'Security Name': 'ClevelandCliffs  ',

    'CQS symbol': 'CLF',
    'NASDAQ symbol': 'CLF',
  },
  {
    symbol: 'CLFD',
    'Security Name': 'Clearfield,   ',

    'NASDAQ symbol': 'CLFD',
  },
  {
    symbol: 'CLGN',
    'Security Name':
      'CollPlant Biotechnologies Ltd  American Depositary Shares',

    'NASDAQ symbol': 'CLGN',
  },
  {
    symbol: 'CLGX',
    'Security Name': 'CoreLogic,  ',

    'CQS symbol': 'CLGX',
    'NASDAQ symbol': 'CLGX',
  },
  {
    symbol: 'CLH',
    'Security Name': 'Clean Harbors,  ',

    'CQS symbol': 'CLH',
    'NASDAQ symbol': 'CLH',
  },
  {
    symbol: 'CLI',
    'Security Name': 'MackCali Realty Corporation ',

    'CQS symbol': 'CLI',
    'NASDAQ symbol': 'CLI',
  },
  {
    symbol: 'CLII',
    'Security Name':
      'Climate Change Crisis Real Impact I Acquisition Corporation  ',

    'CQS symbol': 'CLII',
    'NASDAQ symbol': 'CLII',
  },
  {
    symbol: 'CLIIU',
    'Security Name':
      'Climate Change Crisis Real Impact I Acquisition Corporation Units, each consisting of one share of   and onehalf of one Warrant',

    'CQS symbol': 'CLIIU',
    'NASDAQ symbol': 'CLII=',
  },
  {
    symbol: 'CLIIW',
    'Security Name':
      'Climate Change Crisis Real Impact I Acquisition Corporation Warrants, each whole warrant exercisable for one share of   at an exercise price of $1150',

    'CQS symbol': 'CLIIWS',
    'NASDAQ symbol': 'CLII+',
  },
  {
    symbol: 'CLIR',
    'Security Name': 'ClearSign Technologies Corporation  ',

    'NASDAQ symbol': 'CLIR',
  },
  {
    symbol: 'CLIX',
    'Security Name': 'ProShares Long Online/Short Stores ETF',

    'CQS symbol': 'CLIX',
    'NASDAQ symbol': 'CLIX',
  },
  {
    symbol: 'CLLS',
    'Security Name': 'Cellectis SA  American Depositary Shares',

    'NASDAQ symbol': 'CLLS',
  },
  {
    symbol: 'CLM',
    'Security Name': 'Cornerstone Strategic Value Fund,  New ',

    'CQS symbol': 'CLM',
    'NASDAQ symbol': 'CLM',
  },
  {
    symbol: 'CLMT',
    'Security Name':
      'Calumet Specialty Products Partners, LP  Common units representing limited partner interests',

    'NASDAQ symbol': 'CLMT',
  },
  {
    symbol: 'CLNC',
    'Security Name': 'Colony Credit Real Estate,   ',

    'CQS symbol': 'CLNC',
    'NASDAQ symbol': 'CLNC',
  },
  {
    symbol: 'CLNE',
    'Security Name': 'Clean Energy Fuels Corp  ',

    'NASDAQ symbol': 'CLNE',
  },
  {
    symbol: 'CLNY',
    'Security Name': 'Colony Capital, ',

    'CQS symbol': 'CLNY',
    'NASDAQ symbol': 'CLNY',
  },
  {
    symbol: 'CLNY$G',
    'Security Name':
      'Colony Capital,  750% Series G cumulative redeemable perpetual preferred stock',

    'CQS symbol': 'CLNYpG',
    'NASDAQ symbol': 'CLNYG',
  },
  {
    symbol: 'CLNY$H',
    'Security Name':
      'Colony Capital,  7125% Series H cumulative redeemable perpetual preferred stock',

    'CQS symbol': 'CLNYpH',
    'NASDAQ symbol': 'CLNYH',
  },
  {
    symbol: 'CLNY$I',
    'Security Name':
      'Colony Capital,  715% Series I Cumulative Redeemable Perpetual Preferred Stock',

    'CQS symbol': 'CLNYpI',
    'NASDAQ symbol': 'CLNYI',
  },
  {
    symbol: 'CLNY$J',
    'Security Name':
      'Colony Capital,  7125% Series J Cumulative Redeemable Perpetual Preferred Stock',

    'CQS symbol': 'CLNYpJ',
    'NASDAQ symbol': 'CLNYJ',
  },
  {
    symbol: 'CLOU',
    'Security Name': 'Global X Cloud Computing ETF',

    'NASDAQ symbol': 'CLOU',
  },
  {
    symbol: 'CLPR',
    'Security Name': 'Clipper Realty  ',

    'CQS symbol': 'CLPR',
    'NASDAQ symbol': 'CLPR',
  },
  {
    symbol: 'CLPS',
    'Security Name': 'CLPS orporation  ',

    'NASDAQ symbol': 'CLPS',
  },
  {
    symbol: 'CLPT',
    'Security Name': 'ClearPoint Neuro   ',

    'NASDAQ symbol': 'CLPT',
  },
  {
    symbol: 'CLR',
    'Security Name': 'Continental Resources,  ',

    'CQS symbol': 'CLR',
    'NASDAQ symbol': 'CLR',
  },
  {
    symbol: 'CLRB',
    'Security Name': 'Cellectar Biosciences,   ',

    'NASDAQ symbol': 'CLRB',
  },
  {
    symbol: 'CLRBZ',
    'Security Name': 'Cellectar Biosciences,   Series A Warrants',

    'NASDAQ symbol': 'CLRBZ',
  },
  {
    symbol: 'CLRG',
    'Security Name': 'IQ Chaikin US Large Cap ETF',

    'NASDAQ symbol': 'CLRG',
  },
  {
    symbol: 'CLRO',
    'Security Name': 'ClearOne,   ',

    'NASDAQ symbol': 'CLRO',
  },
  {
    symbol: 'CLS',
    'Security Name': 'Celestica,  ',

    'CQS symbol': 'CLS',
    'NASDAQ symbol': 'CLS',
  },
  {
    symbol: 'CLSD',
    'Security Name': 'Clearside Biomedical,   ',

    'NASDAQ symbol': 'CLSD',
  },
  {
    symbol: 'CLSK',
    'Security Name': 'CleanSpark,   ',

    'NASDAQ symbol': 'CLSK',
  },
  {
    symbol: 'CLSN',
    'Security Name': 'Celsion Corporation  ',

    'NASDAQ symbol': 'CLSN',
  },
  {
    symbol: 'CLTL',
    'Security Name': 'Invesco Treasury Collateral ETF',

    'CQS symbol': 'CLTL',
    'NASDAQ symbol': 'CLTL',
  },
  {
    symbol: 'CLVS',
    'Security Name': 'Clovis Oncology,   ',

    'NASDAQ symbol': 'CLVS',
  },
  {
    symbol: 'CLW',
    'Security Name': 'Clearwater Paper Corporation ',

    'CQS symbol': 'CLW',
    'NASDAQ symbol': 'CLW',
  },
  {
    symbol: 'CLWT',
    'Security Name': 'Euro Tech Holdings Company Limited  Ordinary Shares',

    'NASDAQ symbol': 'CLWT',
  },
  {
    symbol: 'CLX',
    'Security Name': 'Clorox Company (The) ',

    'CQS symbol': 'CLX',
    'NASDAQ symbol': 'CLX',
  },
  {
    symbol: 'CLXT',
    'Security Name': 'Calyxt,   ',

    'NASDAQ symbol': 'CLXT',
  },
  {
    symbol: 'CM',
    'Security Name': 'Canadian Imperial Bank of Commerce ',

    'CQS symbol': 'CM',
    'NASDAQ symbol': 'CM',
  },
  {
    symbol: 'CMA',
    'Security Name': 'Comerica orporated ',

    'CQS symbol': 'CMA',
    'NASDAQ symbol': 'CMA',
  },
  {
    symbol: 'CMBM',
    'Security Name': 'Cambium Networks Corporation  Ordinary Shares',

    'NASDAQ symbol': 'CMBM',
  },
  {
    symbol: 'CMBS',
    'Security Name': 'iShares CMBS Bond ETF',

    'CQS symbol': 'CMBS',
    'NASDAQ symbol': 'CMBS',
  },
  {
    symbol: 'CMC',
    'Security Name': 'Commercial Metals Company ',

    'CQS symbol': 'CMC',
    'NASDAQ symbol': 'CMC',
  },
  {
    symbol: 'CMCL',
    'Security Name': 'Caledonia Mining Corporation Plc Common Shares',

    'CQS symbol': 'CMCL',
    'NASDAQ symbol': 'CMCL',
  },
  {
    symbol: 'CMCM',
    'Security Name':
      'Cheetah Mobile  American Depositary Shares, each representing 10 Class Ordinary Shares',

    'CQS symbol': 'CMCM',
    'NASDAQ symbol': 'CMCM',
  },
  {
    symbol: 'CMCO',
    'Security Name': 'Columbus McKinnon Corporation  ',

    'NASDAQ symbol': 'CMCO',
  },
  {
    symbol: 'CMCSA',
    'Security Name': 'Comcast Corporation   ',

    'NASDAQ symbol': 'CMCSA',
  },
  {
    symbol: 'CMCT',
    'Security Name': 'CIM Commercial Trust Corporation  ',

    'NASDAQ symbol': 'CMCT',
  },
  {
    symbol: 'CMCTP',
    'Security Name':
      'CIM Commercial Trust Corporation  Series L Preferred Stock',

    'NASDAQ symbol': 'CMCTP',
  },
  {
    symbol: 'CMD',
    'Security Name': 'Cantel Medical Corp ',

    'CQS symbol': 'CMD',
    'NASDAQ symbol': 'CMD',
  },
  {
    symbol: 'CMDY',
    'Security Name': 'iShares Bloomberg Roll Select Commodity Strategy ETF',

    'CQS symbol': 'CMDY',
    'NASDAQ symbol': 'CMDY',
  },
  {
    symbol: 'CME',
    'Security Name': 'CME Group    ',

    'NASDAQ symbol': 'CME',
  },
  {
    symbol: 'CMF',
    'Security Name': 'iShares California Muni Bond ETF',

    'CQS symbol': 'CMF',
    'NASDAQ symbol': 'CMF',
  },
  {
    symbol: 'CMFNL',
    'Security Name': 'Investcorp Credit Management BDC,   6125% Notes due 2023',

    'NASDAQ symbol': 'CMFNL',
  },
  {
    symbol: 'CMG',
    'Security Name': 'Chipotle Mexican Grill,  ',

    'CQS symbol': 'CMG',
    'NASDAQ symbol': 'CMG',
  },
  {
    symbol: 'CMI',
    'Security Name': 'Cummins  ',

    'CQS symbol': 'CMI',
    'NASDAQ symbol': 'CMI',
  },
  {
    symbol: 'CMLF',
    'Security Name': 'CM Life Sciences,    ',

    'NASDAQ symbol': 'CMLF',
  },
  {
    symbol: 'CMLFU',
    'Security Name': 'CM Life Sciences,   Unit',

    'NASDAQ symbol': 'CMLFU',
  },
  {
    symbol: 'CMLFW',
    'Security Name': 'CM Life Sciences,   Warrant',

    'NASDAQ symbol': 'CMLFW',
  },
  {
    symbol: 'CMLS',
    'Security Name': 'Cumulus Media    ',

    'NASDAQ symbol': 'CMLS',
  },
  {
    symbol: 'CMO',
    'Security Name': 'Capstead Mortgage Corporation ',

    'CQS symbol': 'CMO',
    'NASDAQ symbol': 'CMO',
  },
  {
    symbol: 'CMO$E',
    'Security Name': 'Capstead Mortgage Corporation Pfd Ser E',

    'CQS symbol': 'CMOpE',
    'NASDAQ symbol': 'CMOE',
  },
  {
    symbol: 'CMP',
    'Security Name': 'Compass Minerals Intl  ',

    'CQS symbol': 'CMP',
    'NASDAQ symbol': 'CMP',
  },
  {
    symbol: 'CMPI',
    'Security Name': 'Checkmate Pharmaceuticals,   ',

    'NASDAQ symbol': 'CMPI',
  },
  {
    symbol: 'CMPR',
    'Security Name': 'Cimpress plc  Ordinary Shares',

    'NASDAQ symbol': 'CMPR',
  },
  {
    symbol: 'CMPS',
    'Security Name': 'COMPASS Pathways Plc  American ',

    'NASDAQ symbol': 'CMPS',
  },
  {
    symbol: 'CMRE',
    'Security Name': 'Costamare   $00001 par value',

    'CQS symbol': 'CMRE',
    'NASDAQ symbol': 'CMRE',
  },
  {
    symbol: 'CMRE$B',
    'Security Name':
      'Costamare  Perpetual Preferred Stock Series B (Marshall Islands)',

    'CQS symbol': 'CMREpB',
    'NASDAQ symbol': 'CMREB',
  },
  {
    symbol: 'CMRE$C',
    'Security Name':
      'Costamare  Perpetual Preferred Series C (Marshall Islands)',

    'CQS symbol': 'CMREpC',
    'NASDAQ symbol': 'CMREC',
  },
  {
    symbol: 'CMRE$D',
    'Security Name':
      'Costamare  875% Series D Cumulative Redeemable Perpetual Preferred Stock',

    'CQS symbol': 'CMREpD',
    'NASDAQ symbol': 'CMRED',
  },
  {
    symbol: 'CMRE$E',
    'Security Name':
      'Costamare  8875% Series E Cumulative Redeemable Perpetual Preferred Stock, par value $00001',

    'CQS symbol': 'CMREpE',
    'NASDAQ symbol': 'CMREE',
  },
  {
    symbol: 'CMRX',
    'Security Name': 'Chimerix,   ',

    'NASDAQ symbol': 'CMRX',
  },
  {
    symbol: 'CMS',
    'Security Name': 'CMS Energy Corporation ',

    'CQS symbol': 'CMS',
    'NASDAQ symbol': 'CMS',
  },
  {
    symbol: 'CMS$B',
    'Security Name': 'CMS Energy Corporation Preferred Stock',

    'Round Lot Size': '10',

    'CQS symbol': 'CMSpB',
    'NASDAQ symbol': 'CMSB',
  },
  {
    symbol: 'CMSA',
    'Security Name':
      'CMS Energy Corporation 5625% Junior Subordinated Notes due 2078',

    'CQS symbol': 'CMSA',
    'NASDAQ symbol': 'CMSA',
  },
  {
    symbol: 'CMSC',
    'Security Name':
      'CMS Energy Corporation 5875% Junior Subordinated Notes due 2078',

    'CQS symbol': 'CMSC',
    'NASDAQ symbol': 'CMSC',
  },
  {
    symbol: 'CMSD',
    'Security Name':
      'CMS Energy Corporation 5875% Junior Subordinated Notes due 2079',

    'CQS symbol': 'CMSD',
    'NASDAQ symbol': 'CMSD',
  },
  {
    symbol: 'CMT',
    'Security Name': 'Core Molding Technologies  ',

    'CQS symbol': 'CMT',
    'NASDAQ symbol': 'CMT',
  },
  {
    symbol: 'CMTL',
    'Security Name': 'Comtech Telecommunications Corp  ',

    'NASDAQ symbol': 'CMTL',
  },
  {
    symbol: 'CMU',
    'Security Name': 'MFS Municipal ome Trust ',

    'CQS symbol': 'CMU',
    'NASDAQ symbol': 'CMU',
  },
  {
    symbol: 'CN',
    'Security Name': 'Xtrackers MSCI All China Equity ETF',

    'CQS symbol': 'CN',
    'NASDAQ symbol': 'CN',
  },
  {
    symbol: 'CNA',
    'Security Name': 'CNA Financial Corporation ',

    'CQS symbol': 'CNA',
    'NASDAQ symbol': 'CNA',
  },
  {
    symbol: 'CNBKA',
    'Security Name': 'Century Bancorp,    ',

    'NASDAQ symbol': 'CNBKA',
  },
  {
    symbol: 'CNBS',
    'Security Name': 'Amplify Seymour Cannabis ETF',

    'CQS symbol': 'CNBS',
    'NASDAQ symbol': 'CNBS',
  },
  {
    symbol: 'CNC',
    'Security Name': 'Centene Corporation ',

    'CQS symbol': 'CNC',
    'NASDAQ symbol': 'CNC',
  },
  {
    symbol: 'CNCE',
    'Security Name': 'Concert Pharmaceuticals,   ',

    'NASDAQ symbol': 'CNCE',
  },
  {
    symbol: 'CNCR',
    'Security Name': 'Loncar Cancer Immunotherapy ETF',

    'NASDAQ symbol': 'CNCR',
  },
  {
    symbol: 'CNDT',
    'Security Name': 'Conduent orporated  ',

    'NASDAQ symbol': 'CNDT',
  },
  {
    symbol: 'CNET',
    'Security Name': 'ZW Data Action Technologies   ',

    'NASDAQ symbol': 'CNET',
  },
  {
    symbol: 'CNF',
    'Security Name':
      'CNFinance Holdings Limited American Depositary Shares, each representing  twenty (20) Ordinary Shares',

    'CQS symbol': 'CNF',
    'NASDAQ symbol': 'CNF',
  },
  {
    symbol: 'CNFR',
    'Security Name': 'Conifer Holdings,   ',

    'NASDAQ symbol': 'CNFR',
  },
  {
    symbol: 'CNFRL',
    'Security Name': 'Conifer Holdings,   Senior Unsecured Notes',

    'NASDAQ symbol': 'CNFRL',
  },
  {
    symbol: 'CNHI',
    'Security Name': 'CNH Industrial NV Common Shares',

    'CQS symbol': 'CNHI',
    'NASDAQ symbol': 'CNHI',
  },
  {
    symbol: 'CNI',
    'Security Name': 'Canadian National Railway Company ',

    'CQS symbol': 'CNI',
    'NASDAQ symbol': 'CNI',
  },
  {
    symbol: 'CNK',
    'Security Name': 'Cinemark Holdings  Cinemark Holdings,  ',

    'CQS symbol': 'CNK',
    'NASDAQ symbol': 'CNK',
  },
  {
    symbol: 'CNMD',
    'Security Name': 'CONMED Corporation ',

    'CQS symbol': 'CNMD',
    'NASDAQ symbol': 'CNMD',
  },
  {
    symbol: 'CNNB',
    'Security Name': 'Cinnati Bancorp,   ',

    'NASDAQ symbol': 'CNNB',
  },
  {
    symbol: 'CNNE',
    'Security Name': 'Cannae Holdings,  ',

    'CQS symbol': 'CNNE',
    'NASDAQ symbol': 'CNNE',
  },
  {
    symbol: 'CNO',
    'Security Name': 'CNO Financial Group,  ',

    'CQS symbol': 'CNO',
    'NASDAQ symbol': 'CNO',
  },
  {
    symbol: 'CNO$A',
    'Security Name':
      'CNO Financial Group,  5125% Subordinated Debentures due 2060',

    'CQS symbol': 'CNOpA',
    'NASDAQ symbol': 'CNOA',
  },
  {
    symbol: 'CNOB',
    'Security Name': 'ConnectOne Bancorp,   ',

    'NASDAQ symbol': 'CNOB',
  },
  {
    symbol: 'CNP',
    'Security Name': 'CenterPoint Energy,  (Holding Co) ',

    'CQS symbol': 'CNP',
    'NASDAQ symbol': 'CNP',
  },
  {
    symbol: 'CNP$B',
    'Security Name':
      'CenterPoint Energy,  Depositary Shares Each Representing a 1/20th Interest in a Share of 700% Series B Mandatory Convertible Preferred Stock',

    'CQS symbol': 'CNPpB',
    'NASDAQ symbol': 'CNPB',
  },
  {
    symbol: 'CNQ',
    'Security Name': 'Canadian Natural Resources Limited ',

    'CQS symbol': 'CNQ',
    'NASDAQ symbol': 'CNQ',
  },
  {
    symbol: 'CNR',
    'Security Name': 'Cornerstone Building Brands,  ',

    'CQS symbol': 'CNR',
    'NASDAQ symbol': 'CNR',
  },
  {
    symbol: 'CNRG',
    'Security Name': 'SPDR S&P Kensho Clean Power ETF',

    'CQS symbol': 'CNRG',
    'NASDAQ symbol': 'CNRG',
  },
  {
    symbol: 'CNS',
    'Security Name': 'Cohen & Steers  ',

    'CQS symbol': 'CNS',
    'NASDAQ symbol': 'CNS',
  },
  {
    symbol: 'CNSL',
    'Security Name': 'Consolidated Communications Holdings,   ',

    'NASDAQ symbol': 'CNSL',
  },
  {
    symbol: 'CNSP',
    'Security Name': 'CNS Pharmaceuticals,   ',

    'NASDAQ symbol': 'CNSP',
  },
  {
    symbol: 'CNST',
    'Security Name': 'Constellation Pharmaceuticals,   ',

    'NASDAQ symbol': 'CNST',
  },
  {
    symbol: 'CNTG',
    'Security Name': 'Centogene NV  Common Shares',

    'NASDAQ symbol': 'CNTG',
  },
  {
    symbol: 'CNTY',
    'Security Name': 'Century Casinos,   ',

    'NASDAQ symbol': 'CNTY',
  },
  {
    symbol: 'CNX',
    'Security Name': 'CNX Resources Corporation ',

    'CQS symbol': 'CNX',
    'NASDAQ symbol': 'CNX',
  },
  {
    symbol: 'CNXC',
    'Security Name': 'Concentrix Corporation  ',

    'NASDAQ symbol': 'CNXC',
  },
  {
    symbol: 'CNXN',
    'Security Name': 'PC Connection,   ',

    'NASDAQ symbol': 'CNXN',
  },
  {
    symbol: 'CNXT',
    'Security Name': 'VanEck Vectors ChinaAMC SMEChNext ETF',

    'CQS symbol': 'CNXT',
    'NASDAQ symbol': 'CNXT',
  },
  {
    symbol: 'CNYA',
    'Security Name': 'iShares MSCI China A ETF',

    'CQS symbol': 'CNYA',
    'NASDAQ symbol': 'CNYA',
  },
  {
    symbol: 'CO',
    'Security Name': 'Global Cord Blood Corporation ',

    'CQS symbol': 'CO',
    'NASDAQ symbol': 'CO',
  },
  {
    symbol: 'COCP',
    'Security Name': 'Cocrystal Pharma,   ',

    'NASDAQ symbol': 'COCP',
  },
  {
    symbol: 'CODA',
    'Security Name': 'Coda Octopus Group,   ',

    'NASDAQ symbol': 'CODA',
  },
  {
    symbol: 'CODI',
    'Security Name':
      'D/B/A Compass Diversified Holdings Shares of Beneficial Interest',

    'CQS symbol': 'CODI',
    'NASDAQ symbol': 'CODI',
  },
  {
    symbol: 'CODI$A',
    'Security Name':
      'Compass Diversified Holdings 7250% Series A Preferred Shares representing beneficial interest in Compass Diversified Holdings',

    'CQS symbol': 'CODIpA',
    'NASDAQ symbol': 'CODIA',
  },
  {
    symbol: 'CODI$B',
    'Security Name':
      'Compass Diversified Holdings 7875% Series B FixedtoFloating Rate Cumulative Preferred Shares representing beneficial interests in Compass Diversified Holdings',

    'CQS symbol': 'CODIpB',
    'NASDAQ symbol': 'CODIB',
  },
  {
    symbol: 'CODI$C',
    'Security Name':
      'Compass Diversified Holdings 7875% Series C Cumulative Preferred Shares',

    'CQS symbol': 'CODIpC',
    'NASDAQ symbol': 'CODIC',
  },
  {
    symbol: 'CODX',
    'Security Name': 'CoDiagnostics,   ',

    'NASDAQ symbol': 'CODX',
  },
  {
    symbol: 'COE',
    'Security Name':
      'China Online Education Group American depositary shares, each representing 15  ordinary shares',

    'CQS symbol': 'COE',
    'NASDAQ symbol': 'COE',
  },
  {
    symbol: 'COF',
    'Security Name': 'Capital One Financial Corporation ',

    'CQS symbol': 'COF',
    'NASDAQ symbol': 'COF',
  },
  {
    symbol: 'COF$G',
    'Security Name':
      'Capital One Financial Corporation Depositary Shares, Each Representing a 1/40th Interest in a Share of Fixed Rate NonCumulative Perpetual Preferred Stock, Series G',

    'CQS symbol': 'COFpG',
    'NASDAQ symbol': 'COFG',
  },
  {
    symbol: 'COF$H',
    'Security Name':
      'Capital One Financial Corporation Depositary Shares, Each Representing 1/40th Interest in a Share of Fixed Rate NonCumulative Perpetual Preferred Stock, Series H',

    'CQS symbol': 'COFpH',
    'NASDAQ symbol': 'COFH',
  },
  {
    symbol: 'COF$I',
    'Security Name':
      'Capital One Financial Corporation Depositary shares each representing a 1/40th interest in a share of Fixed Rate NonCumulative Perpetual Preferred Stock, Series I of the Issuer',

    'CQS symbol': 'COFpI',
    'NASDAQ symbol': 'COFI',
  },
  {
    symbol: 'COF$J',
    'Security Name':
      'Capital One Financial Corporation Depositary Shares, Each Representing a 1/40th Interest in a Share of Fixed Rate Non Cumulative Perpetual Preferred Stock, Series J',

    'CQS symbol': 'COFpJ',
    'NASDAQ symbol': 'COFJ',
  },
  {
    symbol: 'COF$K',
    'Security Name':
      'Capital One Financial Corporation Depositary Shares, Each Representing a 1/40th Ownership Interest in a Share of Fixed Rate NonCumulative Perpetual Preferred Stock, Series K',

    'CQS symbol': 'COFpK',
    'NASDAQ symbol': 'COFK',
  },
  {
    symbol: 'COFS',
    'Security Name': 'ChoiceOne Financial Services,   ',

    'NASDAQ symbol': 'COFS',
  },
  {
    symbol: 'COG',
    'Security Name': 'Cabot Oil & Gas Corporation ',

    'CQS symbol': 'COG',
    'NASDAQ symbol': 'COG',
  },
  {
    symbol: 'COGT',
    'Security Name': 'Cogent Biosciences,   ',

    'NASDAQ symbol': 'COGT',
  },
  {
    symbol: 'COHN',
    'Security Name': 'Cohen & Company ',

    'CQS symbol': 'COHN',
    'NASDAQ symbol': 'COHN',
  },
  {
    symbol: 'COHR',
    'Security Name': 'Coherent,   ',

    'NASDAQ symbol': 'COHR',
  },
  {
    symbol: 'COHU',
    'Security Name': 'Cohu,   ',

    'NASDAQ symbol': 'COHU',
  },
  {
    symbol: 'COKE',
    'Security Name': 'CocaCola Consolidated,   ',

    'NASDAQ symbol': 'COKE',
  },
  {
    symbol: 'COLB',
    'Security Name': 'Columbia Banking System,   ',

    'NASDAQ symbol': 'COLB',
  },
  {
    symbol: 'COLD',
    'Security Name': 'Americold Realty Trust Common Shares',

    'CQS symbol': 'COLD',
    'NASDAQ symbol': 'COLD',
  },
  {
    symbol: 'COLL',
    'Security Name': 'Collegium Pharmaceutical,   ',

    'NASDAQ symbol': 'COLL',
  },
  {
    symbol: 'COLM',
    'Security Name': 'Columbia Sportswear Company  ',

    'NASDAQ symbol': 'COLM',
  },
  {
    symbol: 'COM',
    'Security Name': 'Direxion Auspice Broad Commodity Strategy ETF',

    'CQS symbol': 'COM',
    'NASDAQ symbol': 'COM',
  },
  {
    symbol: 'COMB',
    'Security Name':
      'GraniteShares Bloomberg Commodity Broad Strategy No K1 ETF',

    'CQS symbol': 'COMB',
    'NASDAQ symbol': 'COMB',
  },
  {
    symbol: 'COMM',
    'Security Name': 'CommScope Holding Company,   ',

    'NASDAQ symbol': 'COMM',
  },
  {
    symbol: 'COMT',
    'Security Name': 'iShares Commodities Select Strategy ETF',

    'NASDAQ symbol': 'COMT',
  },
  {
    symbol: 'CONE',
    'Security Name': 'CyrusOne   ',

    'NASDAQ symbol': 'CONE',
  },
  {
    symbol: 'CONN',
    'Security Name': "Conn's,   ",

    'NASDAQ symbol': 'CONN',
  },
  {
    symbol: 'CONXU',
    'Security Name': 'CONX Corp  Unit',

    'NASDAQ symbol': 'CONXU',
  },
  {
    symbol: 'COO',
    'Security Name': 'The Cooper Companies,  ',

    'CQS symbol': 'COO',
    'NASDAQ symbol': 'COO',
  },
  {
    symbol: 'COOP',
    'Security Name': 'Mr Cooper Group   ',

    'NASDAQ symbol': 'COOP',
  },
  {
    symbol: 'COP',
    'Security Name': 'ConocoPhillips ',

    'CQS symbol': 'COP',
    'NASDAQ symbol': 'COP',
  },
  {
    symbol: 'COPX',
    'Security Name': 'Global X Copper Miners ETF',

    'CQS symbol': 'COPX',
    'NASDAQ symbol': 'COPX',
  },
  {
    symbol: 'COR',
    'Security Name': 'CoreSite Realty Corporation ',

    'CQS symbol': 'COR',
    'NASDAQ symbol': 'COR',
  },
  {
    symbol: 'CORE',
    'Security Name': 'CoreMark Holding Company,   ',

    'NASDAQ symbol': 'CORE',
  },
  {
    symbol: 'CORN',
    'Security Name': 'Teucrium Corn Fund ETV',

    'CQS symbol': 'CORN',
    'NASDAQ symbol': 'CORN',
  },
  {
    symbol: 'CORP',
    'Security Name':
      'Pimco Investment Grade Corporate Bond Index ExchangeTraded Fund',

    'CQS symbol': 'CORP',
    'NASDAQ symbol': 'CORP',
  },
  {
    symbol: 'CORR',
    'Security Name': 'CorEnergy Infrastructure Trust,  ',

    'CQS symbol': 'CORR',
    'NASDAQ symbol': 'CORR',
  },
  {
    symbol: 'CORR$A',
    'Security Name':
      'CorEnergy Infrastructure Trust,  Depositary Shares, each representing a 1/100th fractional interest of a share of 7375% Series A Cumulative Redeemable Preferred Stock',

    'CQS symbol': 'CORRpA',
    'NASDAQ symbol': 'CORRA',
  },
  {
    symbol: 'CORT',
    'Security Name': 'Corcept Therapeutics orporated  ',

    'NASDAQ symbol': 'CORT',
  },
  {
    symbol: 'COST',
    'Security Name': 'Costco Wholesale Corporation  ',

    'NASDAQ symbol': 'COST',
  },
  {
    symbol: 'COTY',
    'Security Name': 'Coty   ',

    'CQS symbol': 'COTY',
    'NASDAQ symbol': 'COTY',
  },
  {
    symbol: 'COUP',
    'Security Name': 'Coupa Software orporated  ',

    'NASDAQ symbol': 'COUP',
  },
  {
    symbol: 'COW',
    'Security Name':
      'iPathA Series B Bloomberg Livestock Subindex Total Return ETN',

    'CQS symbol': 'COW',
    'NASDAQ symbol': 'COW',
  },
  {
    symbol: 'COWN',
    'Security Name': 'Cowen    ',

    'NASDAQ symbol': 'COWN',
  },
  {
    symbol: 'COWNL',
    'Security Name': 'Cowen   775% Senior Notes due 2033',

    'NASDAQ symbol': 'COWNL',
  },
  {
    symbol: 'COWNZ',
    'Security Name': 'Cowen   735% Senior Notes Due 2027',

    'NASDAQ symbol': 'COWNZ',
  },
  {
    symbol: 'COWZ',
    'Security Name': 'Pacer US Cash Cows 100 ETF',

    'CQS symbol': 'COWZ',
    'NASDAQ symbol': 'COWZ',
  },
  {
    symbol: 'CP',
    'Security Name': 'Canadian Pacific Railway Limited ',

    'CQS symbol': 'CP',
    'NASDAQ symbol': 'CP',
  },
  {
    symbol: 'CPA',
    'Security Name': 'Copa Holdings, SA Copa Holdings, SA  ',

    'CQS symbol': 'CPA',
    'NASDAQ symbol': 'CPA',
  },
  {
    symbol: 'CPAC',
    'Security Name':
      'Cementos Pacasmayo SAA American Depositary Shares (Each representing five Common Shares)',

    'CQS symbol': 'CPAC',
    'NASDAQ symbol': 'CPAC',
  },
  {
    symbol: 'CPAH',
    'Security Name': 'CounterPath Corporation  ',

    'NASDAQ symbol': 'CPAH',
  },
  {
    symbol: 'CPB',
    'Security Name': 'Campbell Soup Company ',

    'CQS symbol': 'CPB',
    'NASDAQ symbol': 'CPB',
  },
  {
    symbol: 'CPE',
    'Security Name': 'Callon Petroleum Company ',

    'CQS symbol': 'CPE',
    'NASDAQ symbol': 'CPE',
  },
  {
    symbol: 'CPER',
    'Security Name': 'United States Copper Index Fund ETV',

    'CQS symbol': 'CPER',
    'NASDAQ symbol': 'CPER',
  },
  {
    symbol: 'CPF',
    'Security Name': 'Central Pacific Financial Corp New',

    'CQS symbol': 'CPF',
    'NASDAQ symbol': 'CPF',
  },
  {
    symbol: 'CPG',
    'Security Name':
      'Crescent Point Energy Corporation Ordinary Shares (Canada)',

    'CQS symbol': 'CPG',
    'NASDAQ symbol': 'CPG',
  },
  {
    symbol: 'CPHC',
    'Security Name': 'Canterbury Park Holding Corporation  ',

    'NASDAQ symbol': 'CPHC',
  },
  {
    symbol: 'CPHI',
    'Security Name': 'China Pharma Holdings,  ',

    'CQS symbol': 'CPHI',
    'NASDAQ symbol': 'CPHI',
  },
  {
    symbol: 'CPI',
    'Security Name': 'IQ Real Return ETF',

    'CQS symbol': 'CPI',
    'NASDAQ symbol': 'CPI',
  },
  {
    symbol: 'CPIX',
    'Security Name': 'Cumberland Pharmaceuticals   ',

    'NASDAQ symbol': 'CPIX',
  },
  {
    symbol: 'CPK',
    'Security Name': 'Chesapeake Utilities Corporation ',

    'CQS symbol': 'CPK',
    'NASDAQ symbol': 'CPK',
  },
  {
    symbol: 'CPLG',
    'Security Name': 'CorePoint Lodging   ',

    'CQS symbol': 'CPLG',
    'NASDAQ symbol': 'CPLG',
  },
  {
    symbol: 'CPLP',
    'Security Name':
      'Capital Product Partners LP  common units representing limited partner interests',

    'NASDAQ symbol': 'CPLP',
  },
  {
    symbol: 'CPRI',
    'Security Name': 'Capri Holdings Limited Ordinary Shares',

    'CQS symbol': 'CPRI',
    'NASDAQ symbol': 'CPRI',
  },
  {
    symbol: 'CPRT',
    'Security Name': 'Copart,   ',

    'NASDAQ symbol': 'CPRT',
  },
  {
    symbol: 'CPRX',
    'Security Name': 'Catalyst Pharmaceuticals,   ',

    'NASDAQ symbol': 'CPRX',
  },
  {
    symbol: 'CPS',
    'Security Name': 'CooperStandard Holdings  ',

    'CQS symbol': 'CPS',
    'NASDAQ symbol': 'CPS',
  },
  {
    symbol: 'CPSH',
    'Security Name': 'CPS Technologies Corp  ',

    'NASDAQ symbol': 'CPSH',
  },
  {
    symbol: 'CPSI',
    'Security Name': 'Computer Programs and Systems,   ',

    'NASDAQ symbol': 'CPSI',
  },
  {
    symbol: 'CPSR',
    'Security Name': 'Capstar Special Purpose Acquisition Corp  ',

    'CQS symbol': 'CPSR',
    'NASDAQ symbol': 'CPSR',
  },
  {
    symbol: 'CPSRU',
    'Security Name':
      'Capstar Special Purpose Acquisition Corp Units, each consisting of one share of   and onehalf of one Warrant',

    'CQS symbol': 'CPSRU',
    'NASDAQ symbol': 'CPSR=',
  },
  {
    symbol: 'CPSRW',
    'Security Name':
      'Capstar Special Purpose Acquisition Corp Warrants, each whole warrant exercisable for one share of   at an exercise price of $1150',

    'CQS symbol': 'CPSRWS',
    'NASDAQ symbol': 'CPSR+',
  },
  {
    symbol: 'CPSS',
    'Security Name': 'Consumer Portfolio Services,   ',

    'NASDAQ symbol': 'CPSS',
  },
  {
    symbol: 'CPST',
    'Security Name': 'Capstone Turbine Corporation  ',

    'NASDAQ symbol': 'CPST',
  },
  {
    symbol: 'CPT',
    'Security Name': 'Camden Property Trust ',

    'CQS symbol': 'CPT',
    'NASDAQ symbol': 'CPT',
  },
  {
    symbol: 'CPTA',
    'Security Name': 'Capitala Finance Corp  ',

    'NASDAQ symbol': 'CPTA',
  },
  {
    symbol: 'CPTAG',
    'Security Name': 'Capitala Finance Corp  575% Convertible Notes Due 2022',

    'NASDAQ symbol': 'CPTAG',
  },
  {
    symbol: 'CPTAL',
    'Security Name': 'Capitala Finance Corp  6% Notes Due 2022',

    'NASDAQ symbol': 'CPTAL',
  },
  {
    symbol: 'CPZ',
    'Security Name': 'Calamos Long/Short Equity & Dynamic ome Trust  ',

    'NASDAQ symbol': 'CPZ',
  },
  {
    symbol: 'CQP',
    'Security Name':
      'Cheniere Energy Partners, LP Cheniere Energy Partners, LP Common Units',

    'CQS symbol': 'CQP',
    'NASDAQ symbol': 'CQP',
  },
  {
    symbol: 'CQQQ',
    'Security Name': 'Invesco China Technology ETF',

    'CQS symbol': 'CQQQ',
    'NASDAQ symbol': 'CQQQ',
  },
  {
    symbol: 'CR',
    'Security Name': 'Crane Co ',

    'CQS symbol': 'CR',
    'NASDAQ symbol': 'CR',
  },
  {
    symbol: 'CRAI',
    'Security Name': 'CRA International,  ',

    'NASDAQ symbol': 'CRAI',
  },
  {
    symbol: 'CRAK',
    'Security Name': 'VanEck Vectors Oil Refiners ETF',

    'CQS symbol': 'CRAK',
    'NASDAQ symbol': 'CRAK',
  },
  {
    symbol: 'CRBN',
    'Security Name': 'iShares MSCI ACWI Low Carbon Target ETF',

    'CQS symbol': 'CRBN',
    'NASDAQ symbol': 'CRBN',
  },
  {
    symbol: 'CRBP',
    'Security Name': 'Corbus Pharmaceuticals Holdings,   ',

    'NASDAQ symbol': 'CRBP',
  },
  {
    symbol: 'CRC',
    'Security Name': 'California Resources Corporation ',

    'CQS symbol': 'CRC',
    'NASDAQ symbol': 'CRC',
  },
  {
    symbol: 'CRDA',
    'Security Name': 'Crawford & Company ',

    'CQS symbol': 'CRDA',
    'NASDAQ symbol': 'CRDA',
  },
  {
    symbol: 'CRDB',
    'Security Name': 'Crawford & Company ',

    'CQS symbol': 'CRDB',
    'NASDAQ symbol': 'CRDB',
  },
  {
    symbol: 'CRDF',
    'Security Name': 'Cardiff Oncology,   ',

    'NASDAQ symbol': 'CRDF',
  },
  {
    symbol: 'CREE',
    'Security Name': 'Cree,   ',

    'NASDAQ symbol': 'CREE',
  },
  {
    symbol: 'CREG',
    'Security Name': 'China Recycling Energy Corporation  ',

    'NASDAQ symbol': 'CREG',
  },
  {
    symbol: 'CRESY',
    'Security Name':
      'Cresud SACIF y A  American Depositary Shares, each representing ten shares of ',

    'NASDAQ symbol': 'CRESY',
  },
  {
    symbol: 'CREX',
    'Security Name': 'Creative Realities,   ',

    'NASDAQ symbol': 'CREX',
  },
  {
    symbol: 'CREXW',
    'Security Name': 'Creative Realities,   Warrant',

    'NASDAQ symbol': 'CREXW',
  },
  {
    symbol: 'CRF',
    'Security Name': 'Cornerstone Total Return Fund,  (The) ',

    'CQS symbol': 'CRF',
    'NASDAQ symbol': 'CRF',
  },
  {
    symbol: 'CRH',
    'Security Name': 'CRH PLC American Depositary Shares',

    'CQS symbol': 'CRH',
    'NASDAQ symbol': 'CRH',
  },
  {
    symbol: 'CRHC',
    'Security Name': 'Cohn Robbins Holdings Corp  Ordinary Shares',

    'CQS symbol': 'CRHC',
    'NASDAQ symbol': 'CRHC',
  },
  {
    symbol: 'CRHCU',
    'Security Name':
      'Cohn Robbins Holdings Corp Units, each consisting of one  ordinary share and onethird of one redeemable warrant',

    'CQS symbol': 'CRHCU',
    'NASDAQ symbol': 'CRHC=',
  },
  {
    symbol: 'CRHCW',
    'Security Name':
      'Cohn Robbins Holdings Corp Redeemable warrants, each whole warrant exercisable for one  ordinary share at an exercise price of $1150',

    'CQS symbol': 'CRHCWS',
    'NASDAQ symbol': 'CRHC+',
  },
  {
    symbol: 'CRHM',
    'Security Name':
      'CRH Medical Corporation Common Shares of Beneficial Interest',

    'CQS symbol': 'CRHM',
    'NASDAQ symbol': 'CRHM',
  },
  {
    symbol: 'CRI',
    'Security Name': "Carter's,  ",

    'CQS symbol': 'CRI',
    'NASDAQ symbol': 'CRI',
  },
  {
    symbol: 'CRIS',
    'Security Name': 'Curis,   ',

    'NASDAQ symbol': 'CRIS',
  },
  {
    symbol: 'CRK',
    'Security Name': 'Comstock Resources,  ',

    'CQS symbol': 'CRK',
    'NASDAQ symbol': 'CRK',
  },
  {
    symbol: 'CRL',
    'Security Name': 'Charles River Laboratories International,  ',

    'CQS symbol': 'CRL',
    'NASDAQ symbol': 'CRL',
  },
  {
    symbol: 'CRM',
    'Security Name': 'Salesforcecom  ',

    'CQS symbol': 'CRM',
    'NASDAQ symbol': 'CRM',
  },
  {
    symbol: 'CRMD',
    'Security Name': 'CorMedix  ',

    'CQS symbol': 'CRMD',
    'NASDAQ symbol': 'CRMD',
  },
  {
    symbol: 'CRMT',
    'Security Name': "America's CarMart,   ",

    'NASDAQ symbol': 'CRMT',
  },
  {
    symbol: 'CRNC',
    'Security Name': 'Cerence   ',

    'NASDAQ symbol': 'CRNC',
  },
  {
    symbol: 'CRNT',
    'Security Name': 'Ceragon Networks Ltd  Ordinary Shares',

    'NASDAQ symbol': 'CRNT',
  },
  {
    symbol: 'CRNX',
    'Security Name': 'Crinetics Pharmaceuticals,   ',

    'NASDAQ symbol': 'CRNX',
  },
  {
    symbol: 'CROC',
    'Security Name': 'ProShares UltraShort Australian Dollar',

    'CQS symbol': 'CROC',
    'NASDAQ symbol': 'CROC',
  },
  {
    symbol: 'CRON',
    'Security Name': 'Cronos Group   Common Share',

    'NASDAQ symbol': 'CRON',
  },
  {
    symbol: 'CROX',
    'Security Name': 'Crocs,   ',

    'NASDAQ symbol': 'CROX',
  },
  {
    symbol: 'CRS',
    'Security Name': 'Carpenter Technology Corporation ',

    'CQS symbol': 'CRS',
    'NASDAQ symbol': 'CRS',
  },
  {
    symbol: 'CRSA',
    'Security Name': 'Crescent Acquisition Corp   ',

    'NASDAQ symbol': 'CRSA',
  },
  {
    symbol: 'CRSAU',
    'Security Name': 'Crescent Acquisition Corp  Unit',

    'NASDAQ symbol': 'CRSAU',
  },
  {
    symbol: 'CRSAW',
    'Security Name': 'Crescent Acquisition Corp  Warrant',

    'NASDAQ symbol': 'CRSAW',
  },
  {
    symbol: 'CRSP',
    'Security Name': 'CRISPR Therapeutics AG  Common Shares',

    'NASDAQ symbol': 'CRSP',
  },
  {
    symbol: 'CRSR',
    'Security Name': 'Corsair Gaming,   ',

    'NASDAQ symbol': 'CRSR',
  },
  {
    symbol: 'CRT',
    'Security Name': 'Cross Timbers Royalty Trust ',

    'CQS symbol': 'CRT',
    'NASDAQ symbol': 'CRT',
  },
  {
    symbol: 'CRTD',
    'Security Name': 'Creatd   ',

    'NASDAQ symbol': 'CRTD',
  },
  {
    symbol: 'CRTDW',
    'Security Name': 'Creatd   Warrant',

    'NASDAQ symbol': 'CRTDW',
  },
  {
    symbol: 'CRTO',
    'Security Name': 'Criteo SA  American Depositary Shares',

    'NASDAQ symbol': 'CRTO',
  },
  {
    symbol: 'CRTX',
    'Security Name': 'Cortexyme,   ',

    'NASDAQ symbol': 'CRTX',
  },
  {
    symbol: 'CRUS',
    'Security Name': 'Cirrus Logic,   ',

    'NASDAQ symbol': 'CRUS',
  },
  {
    symbol: 'CRVL',
    'Security Name': 'CorVel Corp  ',

    'NASDAQ symbol': 'CRVL',
  },
  {
    symbol: 'CRVS',
    'Security Name': 'Corvus Pharmaceuticals,   ',

    'NASDAQ symbol': 'CRVS',
  },
  {
    symbol: 'CRWD',
    'Security Name': 'CrowdStrike Holdings,    ',

    'NASDAQ symbol': 'CRWD',
  },
  {
    symbol: 'CRWS',
    'Security Name': 'Crown Crafts,   ',

    'NASDAQ symbol': 'CRWS',
  },
  {
    symbol: 'CRY',
    'Security Name': 'CryoLife,  ',

    'CQS symbol': 'CRY',
    'NASDAQ symbol': 'CRY',
  },
  {
    symbol: 'CS',
    'Security Name': 'Credit Suisse Group American Depositary Shares',

    'CQS symbol': 'CS',
    'NASDAQ symbol': 'CS',
  },
  {
    symbol: 'CSA',
    'Security Name': 'VictoryShares US Small Cap Volatility Wtd ETF',

    'NASDAQ symbol': 'CSA',
  },
  {
    symbol: 'CSB',
    'Security Name': 'VictoryShares US Small Cap High Div Volatility Wtd ETF',

    'NASDAQ symbol': 'CSB',
  },
  {
    symbol: 'CSBR',
    'Security Name': 'Champions Oncology,   ',

    'NASDAQ symbol': 'CSBR',
  },
  {
    symbol: 'CSCO',
    'Security Name': 'Cisco Systems,   ',

    'NASDAQ symbol': 'CSCO',
  },
  {
    symbol: 'CSCW',
    'Security Name': 'Color Star Technology Co Ltd  Ordinary Shares',

    'NASDAQ symbol': 'CSCW',
  },
  {
    symbol: 'CSD',
    'Security Name': 'Invesco S&P SpinOff ETF',

    'CQS symbol': 'CSD',
    'NASDAQ symbol': 'CSD',
  },
  {
    symbol: 'CSF',
    'Security Name': 'VictoryShares US Discovery Enhanced Volatility Wtd ETF',

    'NASDAQ symbol': 'CSF',
  },
  {
    symbol: 'CSGP',
    'Security Name': 'CoStar Group,   ',

    'NASDAQ symbol': 'CSGP',
  },
  {
    symbol: 'CSGS',
    'Security Name': 'CSG Systems International,   ',

    'NASDAQ symbol': 'CSGS',
  },
  {
    symbol: 'CSII',
    'Security Name': 'Cardiovascular Systems,   ',

    'NASDAQ symbol': 'CSII',
  },
  {
    symbol: 'CSIQ',
    'Security Name': 'Canadian Solar   Common Shares',

    'NASDAQ symbol': 'CSIQ',
  },
  {
    symbol: 'CSL',
    'Security Name': 'Carlisle Companies orporated ',

    'CQS symbol': 'CSL',
    'NASDAQ symbol': 'CSL',
  },
  {
    symbol: 'CSLT',
    'Security Name': 'Castlight Health,  Class B ',

    'CQS symbol': 'CSLT',
    'NASDAQ symbol': 'CSLT',
  },
  {
    symbol: 'CSM',
    'Security Name': 'ProShares Large Cap Core Plus',

    'CQS symbol': 'CSM',
    'NASDAQ symbol': 'CSM',
  },
  {
    symbol: 'CSML',
    'Security Name': 'IQ Chaikin US Small Cap ETF',

    'NASDAQ symbol': 'CSML',
  },
  {
    symbol: 'CSOD',
    'Security Name': 'Cornerstone OnDemand,   ',

    'NASDAQ symbol': 'CSOD',
  },
  {
    symbol: 'CSPI',
    'Security Name': 'CSP   ',

    'NASDAQ symbol': 'CSPI',
  },
  {
    symbol: 'CSPR',
    'Security Name': 'Casper Sleep  ',

    'CQS symbol': 'CSPR',
    'NASDAQ symbol': 'CSPR',
  },
  {
    symbol: 'CSQ',
    'Security Name': 'Calamos Strategic Total Return Fund  ',

    'NASDAQ symbol': 'CSQ',
  },
  {
    symbol: 'CSSE',
    'Security Name': 'Chicken Soup for the Soul Entertainment,    ',

    'NASDAQ symbol': 'CSSE',
  },
  {
    symbol: 'CSSEN',
    'Security Name':
      'Chicken Soup for the Soul Entertainment,   950% Notes due 2025',

    'NASDAQ symbol': 'CSSEN',
  },
  {
    symbol: 'CSSEP',
    'Security Name':
      'Chicken Soup for the Soul Entertainment,   975% Series A Cumulative Redeemable Perpetual Preferred Stock',

    'NASDAQ symbol': 'CSSEP',
  },
  {
    symbol: 'CSTE',
    'Security Name': 'Caesarstone Ltd  Ordinary Shares',

    'NASDAQ symbol': 'CSTE',
  },
  {
    symbol: 'CSTL',
    'Security Name': 'Castle Biosciences,   ',

    'NASDAQ symbol': 'CSTL',
  },
  {
    symbol: 'CSTM',
    'Security Name': 'Constellium SE Ordinary Shares (France)',

    'CQS symbol': 'CSTM',
    'NASDAQ symbol': 'CSTM',
  },
  {
    symbol: 'CSTR',
    'Security Name': 'CapStar Financial Holdings,   ',

    'NASDAQ symbol': 'CSTR',
  },
  {
    symbol: 'CSU',
    'Security Name': 'Capital Senior Living Corporation ',

    'CQS symbol': 'CSU',
    'NASDAQ symbol': 'CSU',
  },
  {
    symbol: 'CSV',
    'Security Name': 'Carriage Services,  ',

    'CQS symbol': 'CSV',
    'NASDAQ symbol': 'CSV',
  },
  {
    symbol: 'CSWC',
    'Security Name': 'Capital Southwest Corporation  ',

    'NASDAQ symbol': 'CSWC',
  },
  {
    symbol: 'CSWCL',
    'Security Name': 'Capital Southwest Corporation  595% Notes due 2022',

    'NASDAQ symbol': 'CSWCL',
  },
  {
    symbol: 'CSWI',
    'Security Name': 'CSW Industrials,   ',

    'NASDAQ symbol': 'CSWI',
  },
  {
    symbol: 'CSX',
    'Security Name': 'CSX Corporation  ',

    'NASDAQ symbol': 'CSX',
  },
  {
    symbol: 'CTA$A',
    'Security Name': 'EI du Pont de Nemours and Company Preferred Stock',

    'CQS symbol': 'CTApA',
    'NASDAQ symbol': 'CTAA',
  },
  {
    symbol: 'CTA$B',
    'Security Name': 'EI du Pont de Nemours and Company Preferred Stock',

    'CQS symbol': 'CTApB',
    'NASDAQ symbol': 'CTAB',
  },
  {
    symbol: 'CTAA',
    'Security Name': 'Qwest Corporation 7% Notes due 2056',

    'CQS symbol': 'CTAA',
    'NASDAQ symbol': 'CTAA',
  },
  {
    symbol: 'CTACU',
    'Security Name':
      'Cerberus Telecom Acquisition Corp Units, each consisting of one  ordinary share and onethird of one redeemable warrant',

    'CQS symbol': 'CTACU',
    'NASDAQ symbol': 'CTAC=',
  },
  {
    symbol: 'CTAS',
    'Security Name': 'Cintas Corporation  ',

    'NASDAQ symbol': 'CTAS',
  },
  {
    symbol: 'CTB',
    'Security Name': 'Cooper Tire & Rubber Company ',

    'CQS symbol': 'CTB',
    'NASDAQ symbol': 'CTB',
  },
  {
    symbol: 'CTBB',
    'Security Name': 'Qwest Corporation 65% Notes due 2056',

    'CQS symbol': 'CTBB',
    'NASDAQ symbol': 'CTBB',
  },
  {
    symbol: 'CTBI',
    'Security Name': 'Community Trust Bancorp,   ',

    'NASDAQ symbol': 'CTBI',
  },
  {
    symbol: 'CTDD',
    'Security Name': 'Qwest Corporation 675% Notes due 2057',

    'CQS symbol': 'CTDD',
    'NASDAQ symbol': 'CTDD',
  },
  {
    symbol: 'CTEC',
    'Security Name': 'Global X CleanTech ETF',

    'NASDAQ symbol': 'CTEC',
  },
  {
    symbol: 'CTEK',
    'Security Name': 'CynergisTek,  ',

    'CQS symbol': 'CTEK',
    'NASDAQ symbol': 'CTEK',
  },
  {
    symbol: 'CTEST',
    'Security Name': 'NYSE Test One ',

    'Test Issue': 'Y',

    'CQS symbol': 'CTEST',
    'NASDAQ symbol': 'CTEST',
  },
  {
    symbol: 'CTESTE',
    'Security Name': 'NYSE Test One ',

    'Test Issue': 'Y',

    'CQS symbol': 'CTESTE',
    'NASDAQ symbol': 'CTESTE',
  },
  {
    symbol: 'CTESTG',
    'Security Name': 'NYSE Test One ',

    'Test Issue': 'Y',

    'CQS symbol': 'CTESTG',
    'NASDAQ symbol': 'CTESTG',
  },
  {
    symbol: 'CTESTL',
    'Security Name': 'NYSE Test One ',

    'Test Issue': 'Y',

    'CQS symbol': 'CTESTL',
    'NASDAQ symbol': 'CTESTL',
  },
  {
    symbol: 'CTESTO',
    'Security Name': 'NYSE Test One ',

    'Test Issue': 'Y',

    'CQS symbol': 'CTESTO',
    'NASDAQ symbol': 'CTESTO',
  },
  {
    symbol: 'CTESTS',
    'Security Name': 'NYSE Test Six ',

    'Test Issue': 'Y',

    'CQS symbol': 'CTESTS',
    'NASDAQ symbol': 'CTESTS',
  },
  {
    symbol: 'CTESTV',
    'Security Name': 'NYSE Test One ',

    'Test Issue': 'Y',

    'CQS symbol': 'CTESTV',
    'NASDAQ symbol': 'CTESTV',
  },
  {
    symbol: 'CTG',
    'Security Name': 'Computer Task Group, orporated  ',

    'NASDAQ symbol': 'CTG',
  },
  {
    symbol: 'CTHR',
    'Security Name': 'Charles & Colvard Ltd  ',

    'NASDAQ symbol': 'CTHR',
  },
  {
    symbol: 'CTIB',
    'Security Name': 'Yunhong CTI Ltd  ',

    'NASDAQ symbol': 'CTIB',
  },
  {
    symbol: 'CTIC',
    'Security Name': 'CTI BioPharma Corp  ',

    'NASDAQ symbol': 'CTIC',
  },
  {
    symbol: 'CTK',
    'Security Name':
      'CooTek (Cayman)  American Depositary Shares, each representing 50  Ordinary Shares',

    'CQS symbol': 'CTK',
    'NASDAQ symbol': 'CTK',
  },
  {
    symbol: 'CTLT',
    'Security Name': 'Catalent,  ',

    'CQS symbol': 'CTLT',
    'NASDAQ symbol': 'CTLT',
  },
  {
    symbol: 'CTMX',
    'Security Name': 'CytomX Therapeutics,   ',

    'NASDAQ symbol': 'CTMX',
  },
  {
    symbol: 'CTO',
    'Security Name': 'CTO Realty Growth,   ',

    'CQS symbol': 'CTO',
    'NASDAQ symbol': 'CTO',
  },
  {
    symbol: 'CTR',
    'Security Name': 'ClearBridge MLP and Midstream Total Return Fund  ',

    'CQS symbol': 'CTR',
    'NASDAQ symbol': 'CTR',
  },
  {
    symbol: 'CTRA',
    'Security Name': 'Contura Energy,  ',

    'CQS symbol': 'CTRA',
    'NASDAQ symbol': 'CTRA',
  },
  {
    symbol: 'CTRE',
    'Security Name': 'CareTrust REIT,   ',

    'NASDAQ symbol': 'CTRE',
  },
  {
    symbol: 'CTRM',
    'Security Name': 'Castor Maritime   Common Shares',

    'NASDAQ symbol': 'CTRM',
  },
  {
    symbol: 'CTRN',
    'Security Name': 'Citi Trends,   ',

    'NASDAQ symbol': 'CTRN',
  },
  {
    symbol: 'CTS',
    'Security Name': 'CTS Corporation ',

    'CQS symbol': 'CTS',
    'NASDAQ symbol': 'CTS',
  },
  {
    symbol: 'CTSH',
    'Security Name': 'Cognizant Technology Solutions Corporation   ',

    'NASDAQ symbol': 'CTSH',
  },
  {
    symbol: 'CTSO',
    'Security Name': 'Cytosorbents Corporation  ',

    'NASDAQ symbol': 'CTSO',
  },
  {
    symbol: 'CTT',
    'Security Name': 'CatchMark Timber Trust,   ',

    'CQS symbol': 'CTT',
    'NASDAQ symbol': 'CTT',
  },
  {
    symbol: 'CTVA',
    'Security Name': 'Corteva,   ',

    'CQS symbol': 'CTVA',
    'NASDAQ symbol': 'CTVA',
  },
  {
    symbol: 'CTXR',
    'Security Name': 'Citius Pharmaceuticals,   ',

    'NASDAQ symbol': 'CTXR',
  },
  {
    symbol: 'CTXRW',
    'Security Name': 'Citius Pharmaceuticals,   Warrant',

    'NASDAQ symbol': 'CTXRW',
  },
  {
    symbol: 'CTXS',
    'Security Name': 'Citrix Systems,   ',

    'NASDAQ symbol': 'CTXS',
  },
  {
    symbol: 'CTY',
    'Security Name': 'Qwest Corporation 6125% Notes due 2053',

    'CQS symbol': 'CTY',
    'NASDAQ symbol': 'CTY',
  },
  {
    symbol: 'CUB',
    'Security Name': 'Cubic Corporation ',

    'CQS symbol': 'CUB',
    'NASDAQ symbol': 'CUB',
  },
  {
    symbol: 'CUBA',
    'Security Name': 'The Herzfeld Caribbean Basin Fund,   Closed End FUnd',

    'NASDAQ symbol': 'CUBA',
  },
  {
    symbol: 'CUBB',
    'Security Name': 'Customers Bancorp,  5375% Subordinated Notes Due 2034',

    'CQS symbol': 'CUBB',
    'NASDAQ symbol': 'CUBB',
  },
  {
    symbol: 'CUBE',
    'Security Name': 'CubeSmart Common Shares',

    'CQS symbol': 'CUBE',
    'NASDAQ symbol': 'CUBE',
  },
  {
    symbol: 'CUBI',
    'Security Name': 'Customers Bancorp,  ',

    'CQS symbol': 'CUBI',
    'NASDAQ symbol': 'CUBI',
  },
  {
    symbol: 'CUBI$C',
    'Security Name':
      'Customers Bancorp,  FixedtoFloating Rate NonCumulative Perpetual Preferred Stock, Series C',

    'CQS symbol': 'CUBIpC',
    'NASDAQ symbol': 'CUBIC',
  },
  {
    symbol: 'CUBI$D',
    'Security Name':
      'Customers Bancorp,  FixedtoFloating Rate NonCumulative Perpetual Preferred Stock, Series D',

    'CQS symbol': 'CUBIpD',
    'NASDAQ symbol': 'CUBID',
  },
  {
    symbol: 'CUBI$E',
    'Security Name':
      'Customers Bancorp,  FixedtoFloating Rate NonCumulative Perpetual Preferred Stock, Series E',

    'CQS symbol': 'CUBIpE',
    'NASDAQ symbol': 'CUBIE',
  },
  {
    symbol: 'CUBI$F',
    'Security Name':
      'Customers Bancorp,  FixedtoFloating Rate NonCumulative Perpetual Preferred Stock, Series F',

    'CQS symbol': 'CUBIpF',
    'NASDAQ symbol': 'CUBIF',
  },
  {
    symbol: 'CUE',
    'Security Name': 'Cue Biopharma,   ',

    'NASDAQ symbol': 'CUE',
  },
  {
    symbol: 'CUK',
    'Security Name': 'Carnival Plc ADS ADS',

    'CQS symbol': 'CUK',
    'NASDAQ symbol': 'CUK',
  },
  {
    symbol: 'CULP',
    'Security Name': 'Culp,  ',

    'CQS symbol': 'CULP',
    'NASDAQ symbol': 'CULP',
  },
  {
    symbol: 'CURE',
    'Security Name': 'Direxion Daily Healthcare Bull 3X Shares',

    'CQS symbol': 'CURE',
    'NASDAQ symbol': 'CURE',
  },
  {
    symbol: 'CURI',
    'Security Name': 'CuriosityStream     ',

    'NASDAQ symbol': 'CURI',
  },
  {
    symbol: 'CURIW',
    'Security Name': 'CuriosityStream    Warrant',

    'NASDAQ symbol': 'CURIW',
  },
  {
    symbol: 'CURO',
    'Security Name': 'CURO Group Holdings Corp ',

    'CQS symbol': 'CURO',
    'NASDAQ symbol': 'CURO',
  },
  {
    symbol: 'CUT',
    'Security Name': 'Invesco MSCI Global Timber ETF',

    'CQS symbol': 'CUT',
    'NASDAQ symbol': 'CUT',
  },
  {
    symbol: 'CUTR',
    'Security Name': 'Cutera,   ',

    'NASDAQ symbol': 'CUTR',
  },
  {
    symbol: 'CUZ',
    'Security Name': 'Cousins Properties orporated ',

    'CQS symbol': 'CUZ',
    'NASDAQ symbol': 'CUZ',
  },
  {
    symbol: 'CVA',
    'Security Name': 'Covanta Holding Corporation ',

    'CQS symbol': 'CVA',
    'NASDAQ symbol': 'CVA',
  },
  {
    symbol: 'CVAC',
    'Security Name': 'CureVac NV  Ordinary Shares',

    'NASDAQ symbol': 'CVAC',
  },
  {
    symbol: 'CVBF',
    'Security Name': 'CVB Financial Corporation  ',

    'NASDAQ symbol': 'CVBF',
  },
  {
    symbol: 'CVCO',
    'Security Name': 'Cavco Industries,   ',

    'NASDAQ symbol': 'CVCO',
  },
  {
    symbol: 'CVCY',
    'Security Name': 'Central Valley Community Bancorp  ',

    'NASDAQ symbol': 'CVCY',
  },
  {
    symbol: 'CVE',
    'Security Name': 'Cenovus Energy  ',

    'CQS symbol': 'CVE',
    'NASDAQ symbol': 'CVE',
  },
  {
    symbol: 'CVEO',
    'Security Name': 'Civeo Corporation (Canada) Common Shares',

    'CQS symbol': 'CVEO',
    'NASDAQ symbol': 'CVEO',
  },
  {
    symbol: 'CVET',
    'Security Name': 'Covetrus,   ',

    'NASDAQ symbol': 'CVET',
  },
  {
    symbol: 'CVGI',
    'Security Name': 'Commercial Vehicle Group,   ',

    'NASDAQ symbol': 'CVGI',
  },
  {
    symbol: 'CVGW',
    'Security Name': 'Calavo Growers,   ',

    'NASDAQ symbol': 'CVGW',
  },
  {
    symbol: 'CVI',
    'Security Name': 'CVR Energy  ',

    'CQS symbol': 'CVI',
    'NASDAQ symbol': 'CVI',
  },
  {
    symbol: 'CVLG',
    'Security Name': 'Covenant Logistics Group,    ',

    'NASDAQ symbol': 'CVLG',
  },
  {
    symbol: 'CVLT',
    'Security Name': 'Commvault Systems,   ',

    'NASDAQ symbol': 'CVLT',
  },
  {
    symbol: 'CVLY',
    'Security Name': 'Codorus Valley Bancorp,   ',

    'NASDAQ symbol': 'CVLY',
  },
  {
    symbol: 'CVM',
    'Security Name': 'CelSci Corporation ',

    'CQS symbol': 'CVM',
    'NASDAQ symbol': 'CVM',
  },
  {
    symbol: 'CVNA',
    'Security Name': 'Carvana Co  ',

    'CQS symbol': 'CVNA',
    'NASDAQ symbol': 'CVNA',
  },
  {
    symbol: 'CVR',
    'Security Name': 'Chicago Rivet & Machine Co ',

    'CQS symbol': 'CVR',
    'NASDAQ symbol': 'CVR',
  },
  {
    symbol: 'CVS',
    'Security Name': 'CVS Health Corporation ',

    'CQS symbol': 'CVS',
    'NASDAQ symbol': 'CVS',
  },
  {
    symbol: 'CVU',
    'Security Name': 'CPI Aerostructures,  ',

    'CQS symbol': 'CVU',
    'NASDAQ symbol': 'CVU',
  },
  {
    symbol: 'CVV',
    'Security Name': 'CVD Equipment Corporation  ',

    'NASDAQ symbol': 'CVV',
  },
  {
    symbol: 'CVX',
    'Security Name': 'Chevron Corporation ',

    'CQS symbol': 'CVX',
    'NASDAQ symbol': 'CVX',
  },
  {
    symbol: 'CVY',
    'Security Name': 'Invesco Zacks MultiAsset ome ETF',

    'CQS symbol': 'CVY',
    'NASDAQ symbol': 'CVY',
  },
  {
    symbol: 'CW',
    'Security Name': 'CurtissWright Corporation ',

    'CQS symbol': 'CW',
    'NASDAQ symbol': 'CW',
  },
  {
    symbol: 'CWB',
    'Security Name': 'SPDR Bloomberg Barclays Convertible Securities ETF',

    'CQS symbol': 'CWB',
    'NASDAQ symbol': 'CWB',
  },
  {
    symbol: 'CWBC',
    'Security Name': 'Community West Bancshares  ',

    'NASDAQ symbol': 'CWBC',
  },
  {
    symbol: 'CWBR',
    'Security Name': 'CohBar,   ',

    'NASDAQ symbol': 'CWBR',
  },
  {
    symbol: 'CWCO',
    'Security Name': 'Consolidated Water Co Ltd  Ordinary Shares',

    'NASDAQ symbol': 'CWCO',
  },
  {
    symbol: 'CWEB',
    'Security Name': 'Direxion Daily CSI China Internet Index Bull 2X Shares',

    'CQS symbol': 'CWEB',
    'NASDAQ symbol': 'CWEB',
  },
  {
    symbol: 'CWEN',
    'Security Name': 'Clearway Energy,  Class C ',

    'CQS symbol': 'CWEN',
    'NASDAQ symbol': 'CWEN',
  },
  {
    symbol: 'CWENA',
    'Security Name': 'Clearway Energy,   ',

    'CQS symbol': 'CWENA',
    'NASDAQ symbol': 'CWENA',
  },
  {
    symbol: 'CWH',
    'Security Name': 'Camping World Holdings,   Commom Stock',

    'CQS symbol': 'CWH',
    'NASDAQ symbol': 'CWH',
  },
  {
    symbol: 'CWI',
    'Security Name': 'SPDR MSCI ACWI exUS ETF',

    'CQS symbol': 'CWI',
    'NASDAQ symbol': 'CWI',
  },
  {
    symbol: 'CWK',
    'Security Name': 'Cushman & Wakefield plc Ordinary Shares',

    'CQS symbol': 'CWK',
    'NASDAQ symbol': 'CWK',
  },
  {
    symbol: 'CWS',
    'Security Name': 'AdvisorShares Focused Equity ETF',

    'CQS symbol': 'CWS',
    'NASDAQ symbol': 'CWS',
  },
  {
    symbol: 'CWST',
    'Security Name': 'Casella Waste Systems,    ',

    'NASDAQ symbol': 'CWST',
  },
  {
    symbol: 'CWT',
    'Security Name': 'California Water Service Group ',

    'CQS symbol': 'CWT',
    'NASDAQ symbol': 'CWT',
  },
  {
    symbol: 'CX',
    'Security Name': 'Cemex, SAB de CV Sponsored ADR',

    'CQS symbol': 'CX',
    'NASDAQ symbol': 'CX',
  },
  {
    symbol: 'CXDC',
    'Security Name': 'China XD Plastics Company Limited  ',

    'NASDAQ symbol': 'CXDC',
  },
  {
    symbol: 'CXDO',
    'Security Name': 'Crexendo,   ',

    'NASDAQ symbol': 'CXDO',
  },
  {
    symbol: 'CXE',
    'Security Name': 'MFS High ome Municipal Trust ',

    'CQS symbol': 'CXE',
    'NASDAQ symbol': 'CXE',
  },
  {
    symbol: 'CXH',
    'Security Name': 'MFS Investment Grade Municipal Trust ',

    'CQS symbol': 'CXH',
    'NASDAQ symbol': 'CXH',
  },
  {
    symbol: 'CXO',
    'Security Name': 'Concho Resources  ',

    'CQS symbol': 'CXO',
    'NASDAQ symbol': 'CXO',
  },
  {
    symbol: 'CXP',
    'Security Name': 'Columbia Property Trust,  ',

    'CQS symbol': 'CXP',
    'NASDAQ symbol': 'CXP',
  },
  {
    symbol: 'CXSE',
    'Security Name': 'WisdomTree China exStateOwned Enterprises Fund',

    'NASDAQ symbol': 'CXSE',
  },
  {
    symbol: 'CXW',
    'Security Name': 'CoreCivic,  ',

    'CQS symbol': 'CXW',
    'NASDAQ symbol': 'CXW',
  },
  {
    symbol: 'CYAD',
    'Security Name': 'Celyad SA  American Depositary Shares',

    'NASDAQ symbol': 'CYAD',
  },
  {
    symbol: 'CYAN',
    'Security Name': 'Cyanotech Corporation  ',

    'NASDAQ symbol': 'CYAN',
  },
  {
    symbol: 'CYB',
    'Security Name': 'WisdomTree Chinese Yuan Strategy Fund',

    'CQS symbol': 'CYB',
    'NASDAQ symbol': 'CYB',
  },
  {
    symbol: 'CYBE',
    'Security Name': 'CyberOptics Corporation  ',

    'NASDAQ symbol': 'CYBE',
  },
  {
    symbol: 'CYBR',
    'Security Name': 'CyberArk Software Ltd  Ordinary Shares',

    'NASDAQ symbol': 'CYBR',
  },
  {
    symbol: 'CYCC',
    'Security Name': 'Cyclacel Pharmaceuticals,   ',

    'NASDAQ symbol': 'CYCC',
  },
  {
    symbol: 'CYCCP',
    'Security Name':
      'Cyclacel Pharmaceuticals,   6% Convertible Preferred Stock',

    'NASDAQ symbol': 'CYCCP',
  },
  {
    symbol: 'CYCN',
    'Security Name': 'Cyclerion Therapeutics,    ',

    'NASDAQ symbol': 'CYCN',
  },
  {
    symbol: 'CYD',
    'Security Name': 'China Yuchai International Limited ',

    'CQS symbol': 'CYD',
    'NASDAQ symbol': 'CYD',
  },
  {
    symbol: 'CYH',
    'Security Name': 'Community Health Systems,  ',

    'CQS symbol': 'CYH',
    'NASDAQ symbol': 'CYH',
  },
  {
    symbol: 'CYRN',
    'Security Name': 'CYREN Ltd  Ordinary Shares',

    'NASDAQ symbol': 'CYRN',
  },
  {
    symbol: 'CYRX',
    'Security Name': 'CryoPort,   ',

    'NASDAQ symbol': 'CYRX',
  },
  {
    symbol: 'CYTK',
    'Security Name': 'Cytokinetics, orporated  ',

    'NASDAQ symbol': 'CYTK',
  },
  {
    symbol: 'CZA',
    'Security Name': 'Invesco Zacks MidCap ETF',

    'CQS symbol': 'CZA',
    'NASDAQ symbol': 'CZA',
  },
  {
    symbol: 'CZNC',
    'Security Name': 'Citizens & Northern Corp  ',

    'NASDAQ symbol': 'CZNC',
  },
  {
    symbol: 'CZR',
    'Security Name': 'Caesars Entertainment,   ',

    'NASDAQ symbol': 'CZR',
  },
  {
    symbol: 'CZWI',
    'Security Name': 'Citizens Community Bancorp,   ',

    'NASDAQ symbol': 'CZWI',
  },
  {
    symbol: 'CZZ',
    'Security Name': 'Cosan Limited  ',

    'CQS symbol': 'CZZ',
    'NASDAQ symbol': 'CZZ',
  },
  {
    symbol: 'D',
    'Security Name': 'Dominion Energy,  ',

    'CQS symbol': 'D',
    'NASDAQ symbol': 'D',
  },
  {
    symbol: 'DAC',
    'Security Name': 'Danaos Corporation ',

    'CQS symbol': 'DAC',
    'NASDAQ symbol': 'DAC',
  },
  {
    symbol: 'DADA',
    'Security Name': 'Dada Nexus Limited  American Depositary Shares',

    'NASDAQ symbol': 'DADA',
  },
  {
    symbol: 'DAIO',
    'Security Name': 'Data I/O Corporation  ',

    'NASDAQ symbol': 'DAIO',
  },
  {
    symbol: 'DAKT',
    'Security Name': 'Daktronics,   ',

    'NASDAQ symbol': 'DAKT',
  },
  {
    symbol: 'DAL',
    'Security Name': 'Delta Air Lines,  ',

    'CQS symbol': 'DAL',
    'NASDAQ symbol': 'DAL',
  },
  {
    symbol: 'DALI',
    'Security Name': 'First Trust DorseyWright DALI 1 ETF',

    'NASDAQ symbol': 'DALI',
  },
  {
    symbol: 'DALT',
    'Security Name': 'Anfield Capital Diversified Alternatives ETF ETF',

    'CQS symbol': 'DALT',
    'NASDAQ symbol': 'DALT',
  },
  {
    symbol: 'DAN',
    'Security Name': 'Dana orporated  ',

    'CQS symbol': 'DAN',
    'NASDAQ symbol': 'DAN',
  },
  {
    symbol: 'DAO',
    'Security Name':
      'Youdao,  American Depositary Shares, each representing one  Ordinary Share',

    'CQS symbol': 'DAO',
    'NASDAQ symbol': 'DAO',
  },
  {
    symbol: 'DAR',
    'Security Name': 'Darling Ingredients  ',

    'CQS symbol': 'DAR',
    'NASDAQ symbol': 'DAR',
  },
  {
    symbol: 'DARE',
    'Security Name': 'Dare Bioscience,   ',

    'NASDAQ symbol': 'DARE',
  },
  {
    symbol: 'DAUG',
    'Security Name': 'FT Cboe Vest US Equity Deep Buffer ETF  August',

    'CQS symbol': 'DAUG',
    'NASDAQ symbol': 'DAUG',
  },
  {
    symbol: 'DAVA',
    'Security Name':
      'Endava plc American Depositary Shares (each representing one  Ordinary Share)',

    'CQS symbol': 'DAVA',
    'NASDAQ symbol': 'DAVA',
  },
  {
    symbol: 'DAX',
    'Security Name': 'Global X DAX Germany ETF',

    'NASDAQ symbol': 'DAX',
  },
  {
    symbol: 'DB',
    'Security Name': 'Deutsche Bank AG ',

    'CQS symbol': 'DB',
    'NASDAQ symbol': 'DB',
  },
  {
    symbol: 'DBA',
    'Security Name': 'Invesco DB Agriculture Fund',

    'CQS symbol': 'DBA',
    'NASDAQ symbol': 'DBA',
  },
  {
    symbol: 'DBAW',
    'Security Name': 'Xtrackers MSCI All World ex US Hedged Equity ETF',

    'CQS symbol': 'DBAW',
    'NASDAQ symbol': 'DBAW',
  },
  {
    symbol: 'DBB',
    'Security Name': 'Invesco DB Base Metals Fund',

    'CQS symbol': 'DBB',
    'NASDAQ symbol': 'DBB',
  },
  {
    symbol: 'DBC',
    'Security Name': 'Invesco DB Commodity Index Tracking Fund',

    'CQS symbol': 'DBC',
    'NASDAQ symbol': 'DBC',
  },
  {
    symbol: 'DBD',
    'Security Name': 'Diebold Nixdorf orporated ',

    'CQS symbol': 'DBD',
    'NASDAQ symbol': 'DBD',
  },
  {
    symbol: 'DBDR',
    'Security Name': 'Roman DBDR Tech Acquisition Corp   ',

    'NASDAQ symbol': 'DBDR',
  },
  {
    symbol: 'DBDRU',
    'Security Name': 'Roman DBDR Tech Acquisition Corp  Unit',

    'NASDAQ symbol': 'DBDRU',
  },
  {
    symbol: 'DBDRW',
    'Security Name': 'Roman DBDR Tech Acquisition Corp  Warrant',

    'NASDAQ symbol': 'DBDRW',
  },
  {
    symbol: 'DBE',
    'Security Name': 'Invesco DB Energy Fund',

    'CQS symbol': 'DBE',
    'NASDAQ symbol': 'DBE',
  },
  {
    symbol: 'DBEF',
    'Security Name': 'Xtrackers MSCI EAFE Hedged Equity ETF',

    'CQS symbol': 'DBEF',
    'NASDAQ symbol': 'DBEF',
  },
  {
    symbol: 'DBEH',
    'Security Name': 'iM DBi Hedge Strategy ETF',

    'CQS symbol': 'DBEH',
    'NASDAQ symbol': 'DBEH',
  },
  {
    symbol: 'DBEM',
    'Security Name': 'Xtrackers MSCI Emerging Markets Hedged Equity ETF',

    'CQS symbol': 'DBEM',
    'NASDAQ symbol': 'DBEM',
  },
  {
    symbol: 'DBEU',
    'Security Name': 'Xtrackers MSCI Europe Hedged Equity ETF',

    'CQS symbol': 'DBEU',
    'NASDAQ symbol': 'DBEU',
  },
  {
    symbol: 'DBEZ',
    'Security Name': 'Xtrackers MSCI Eurozone Hedged Equity ETF',

    'CQS symbol': 'DBEZ',
    'NASDAQ symbol': 'DBEZ',
  },
  {
    symbol: 'DBGR',
    'Security Name': 'Xtrackers MSCI Germany Hedged Equity ETF',

    'CQS symbol': 'DBGR',
    'NASDAQ symbol': 'DBGR',
  },
  {
    symbol: 'DBI',
    'Security Name': 'Designer Brands   ',

    'CQS symbol': 'DBI',
    'NASDAQ symbol': 'DBI',
  },
  {
    symbol: 'DBJP',
    'Security Name': 'Xtrackers MSCI Japan Hedged Equity ETF',

    'CQS symbol': 'DBJP',
    'NASDAQ symbol': 'DBJP',
  },
  {
    symbol: 'DBL',
    'Security Name':
      'DoubleLine Opportunistic Credit Fund Common Shares of Beneficial Interest',

    'CQS symbol': 'DBL',
    'NASDAQ symbol': 'DBL',
  },
  {
    symbol: 'DBLV',
    'Security Name': 'AdvisorShares DoubleLine Value Equity ETF',

    'CQS symbol': 'DBLV',
    'NASDAQ symbol': 'DBLV',
  },
  {
    symbol: 'DBMF',
    'Security Name': 'iM DBi Managed Futures Strategy ETF ETF',

    'CQS symbol': 'DBMF',
    'NASDAQ symbol': 'DBMF',
  },
  {
    symbol: 'DBO',
    'Security Name': 'Invesco DB Oil Fund',

    'CQS symbol': 'DBO',
    'NASDAQ symbol': 'DBO',
  },
  {
    symbol: 'DBOC',
    'Security Name': 'Innovator Double Stacker 9 Buffer ETF  October',

    'CQS symbol': 'DBOC',
    'NASDAQ symbol': 'DBOC',
  },
  {
    symbol: 'DBP',
    'Security Name': 'Invesco DB Precious Metals Fund',

    'CQS symbol': 'DBP',
    'NASDAQ symbol': 'DBP',
  },
  {
    symbol: 'DBS',
    'Security Name': 'Invesco DB Silver Fund',

    'CQS symbol': 'DBS',
    'NASDAQ symbol': 'DBS',
  },
  {
    symbol: 'DBV',
    'Security Name': 'Invesco DB G10 Currency Harvest Fund',

    'CQS symbol': 'DBV',
    'NASDAQ symbol': 'DBV',
  },
  {
    symbol: 'DBVT',
    'Security Name': 'DBV Technologies SA  American Depositary Shares',

    'NASDAQ symbol': 'DBVT',
  },
  {
    symbol: 'DBX',
    'Security Name': 'Dropbox,    ',

    'NASDAQ symbol': 'DBX',
  },
  {
    symbol: 'DCBO',
    'Security Name': 'Docebo   Common Shares',

    'NASDAQ symbol': 'DCBO',
  },
  {
    symbol: 'DCF',
    'Security Name':
      'BNY Mellon Alcentra Global Credit ome 2024 Target Term Fund,  ',

    'CQS symbol': 'DCF',
    'NASDAQ symbol': 'DCF',
  },
  {
    symbol: 'DCI',
    'Security Name': 'Donaldson Company,  ',

    'CQS symbol': 'DCI',
    'NASDAQ symbol': 'DCI',
  },
  {
    symbol: 'DCO',
    'Security Name': 'Ducommun orporated ',

    'CQS symbol': 'DCO',
    'NASDAQ symbol': 'DCO',
  },
  {
    symbol: 'DCOM',
    'Security Name': 'Dime Community Bancshares,   ',

    'NASDAQ symbol': 'DCOM',
  },
  {
    symbol: 'DCOMP',
    'Security Name':
      'Dime Community Bancshares,   550% FixedRate NonCumulative Perpetual Preferred Stock, Series A',

    'NASDAQ symbol': 'DCOMP',
  },
  {
    symbol: 'DCP',
    'Security Name': 'DCP Midstream,  LP Common Units ',

    'CQS symbol': 'DCP',
    'NASDAQ symbol': 'DCP',
  },
  {
    symbol: 'DCP$B',
    'Security Name':
      'DCP Midstream LP 7875% Series B FixedtoFloating Rate Cumulative Redeemable Perpetual Preferred Units',

    'CQS symbol': 'DCPpB',
    'NASDAQ symbol': 'DCPB',
  },
  {
    symbol: 'DCP$C',
    'Security Name':
      'DCP Midstream LP 795% Series C FixedtoFloating Rate Cumulative Redeemable Perpetual Preferred Units',

    'CQS symbol': 'DCPpC',
    'NASDAQ symbol': 'DCPC',
  },
  {
    symbol: 'DCPH',
    'Security Name': 'Deciphera Pharmaceuticals,   ',

    'NASDAQ symbol': 'DCPH',
  },
  {
    symbol: 'DCRBU',
    'Security Name': 'Decarbonization Plus Acquisition Corporation  Unit',

    'NASDAQ symbol': 'DCRBU',
  },
  {
    symbol: 'DCT',
    'Security Name': 'Duck Creek Technologies,   ',

    'NASDAQ symbol': 'DCT',
  },
  {
    symbol: 'DCTH',
    'Security Name': 'Delcath Systems,   ',

    'NASDAQ symbol': 'DCTH',
  },
  {
    symbol: 'DCUE',
    'Security Name': 'Dominion Energy,  2019 Series A Corporate Units',

    'CQS symbol': 'DCUE',
    'NASDAQ symbol': 'DCUE',
  },
  {
    symbol: 'DD',
    'Security Name': 'DuPont de Nemours,  ',

    'CQS symbol': 'DD',
    'NASDAQ symbol': 'DD',
  },
  {
    symbol: 'DDD',
    'Security Name': '3D Systems Corporation ',

    'CQS symbol': 'DDD',
    'NASDAQ symbol': 'DDD',
  },
  {
    symbol: 'DDF',
    'Security Name': 'Delaware Investments Dividend & ome Fund,  ',

    'CQS symbol': 'DDF',
    'NASDAQ symbol': 'DDF',
  },
  {
    symbol: 'DDG',
    'Security Name': 'ProShares Short Oil & Gas',

    'CQS symbol': 'DDG',
    'NASDAQ symbol': 'DDG',
  },
  {
    symbol: 'DDIV',
    'Security Name': 'First Trust Dorsey Wright Momentum & Dividend ETF',

    'NASDAQ symbol': 'DDIV',
  },
  {
    symbol: 'DDLS',
    'Security Name':
      'WisdomTree Dynamic Currency Hedged International SmallCap Equity Fund',

    'CQS symbol': 'DDLS',
    'NASDAQ symbol': 'DDLS',
  },
  {
    symbol: 'DDM',
    'Security Name': 'ProShares Ultra Dow30',

    'CQS symbol': 'DDM',
    'NASDAQ symbol': 'DDM',
  },
  {
    symbol: 'DDOG',
    'Security Name': 'Datadog,    ',

    'NASDAQ symbol': 'DDOG',
  },
  {
    symbol: 'DDS',
    'Security Name': "Dillard's,  ",

    'CQS symbol': 'DDS',
    'NASDAQ symbol': 'DDS',
  },
  {
    symbol: 'DDT',
    'Security Name': "Dillard's Capital Trust I",

    'CQS symbol': 'DDT',
    'NASDAQ symbol': 'DDT',
  },
  {
    symbol: 'DDWM',
    'Security Name':
      'WisdomTree Dynamic Currency Hedged International Equity Fund',

    'CQS symbol': 'DDWM',
    'NASDAQ symbol': 'DDWM',
  },
  {
    symbol: 'DE',
    'Security Name': 'Deere & Company ',

    'CQS symbol': 'DE',
    'NASDAQ symbol': 'DE',
  },
  {
    symbol: 'DEA',
    'Security Name': 'Easterly Government Properties,  ',

    'CQS symbol': 'DEA',
    'NASDAQ symbol': 'DEA',
  },
  {
    symbol: 'DECK',
    'Security Name': 'Deckers Outdoor Corporation ',

    'CQS symbol': 'DECK',
    'NASDAQ symbol': 'DECK',
  },
  {
    symbol: 'DECZ',
    'Security Name': 'TrueShares Structured Outcome (December) ETF',

    'CQS symbol': 'DECZ',
    'NASDAQ symbol': 'DECZ',
  },
  {
    symbol: 'DEED',
    'Security Name': 'First Trust TCW Securitized Plus ETF',

    'CQS symbol': 'DEED',
    'NASDAQ symbol': 'DEED',
  },
  {
    symbol: 'DEEF',
    'Security Name': 'Xtrackers FTSE Developed ex US Comprehensive Factor ETF',

    'CQS symbol': 'DEEF',
    'NASDAQ symbol': 'DEEF',
  },
  {
    symbol: 'DEEP',
    'Security Name': 'Roundhill Acquirers Deep Value ETF',

    'CQS symbol': 'DEEP',
    'NASDAQ symbol': 'DEEP',
  },
  {
    symbol: 'DEF',
    'Security Name': 'Invesco Defensive Equity ETF',

    'CQS symbol': 'DEF',
    'NASDAQ symbol': 'DEF',
  },
  {
    symbol: 'DEFA',
    'Security Name': 'iShares Adaptive Currency Hedged MSCI EAFE ETF',

    'CQS symbol': 'DEFA',
    'NASDAQ symbol': 'DEFA',
  },
  {
    symbol: 'DEFN',
    'Security Name': 'Emles Trust Emles Protective Allocation ETF',

    'CQS symbol': 'DEFN',
    'NASDAQ symbol': 'DEFN',
  },
  {
    symbol: 'DEH',
    'Security Name': 'D8 Holdings Corp  Ordinary Shares',

    'CQS symbol': 'DEH',
    'NASDAQ symbol': 'DEH',
  },
  {
    symbol: 'DEHU',
    'Security Name':
      'D8 Holdings Corp Units, each consisting of one  ordinary share and onehalf of one redeemable warrant',

    'CQS symbol': 'DEHU',
    'NASDAQ symbol': 'DEH=',
  },
  {
    symbol: 'DEHW',
    'Security Name':
      'D8 Holdings Corp Warrants, each whole warrant exercisable for one  ordinary share at an exercise price of $1150 per share',

    'CQS symbol': 'DEHWS',
    'NASDAQ symbol': 'DEH+',
  },
  {
    symbol: 'DEI',
    'Security Name': 'Douglas Emmett,  ',

    'CQS symbol': 'DEI',
    'NASDAQ symbol': 'DEI',
  },
  {
    symbol: 'DELL',
    'Security Name': 'Dell Technologies  Class C  ',

    'CQS symbol': 'DELL',
    'NASDAQ symbol': 'DELL',
  },
  {
    symbol: 'DEM',
    'Security Name': 'WisdomTree Emerging Markets High Dividend Fund',

    'CQS symbol': 'DEM',
    'NASDAQ symbol': 'DEM',
  },
  {
    symbol: 'DEMZ',
    'Security Name': 'DEMZ Political Contributions ETF',

    'NASDAQ symbol': 'DEMZ',
  },
  {
    symbol: 'DEN',
    'Security Name': 'Denbury  ',

    'CQS symbol': 'DEN',
    'NASDAQ symbol': 'DEN',
  },
  {
    symbol: 'DENN',
    'Security Name': "Denny's Corporation  ",

    'NASDAQ symbol': 'DENN',
  },
  {
    symbol: 'DEO',
    'Security Name': 'Diageo plc ',

    'CQS symbol': 'DEO',
    'NASDAQ symbol': 'DEO',
  },
  {
    symbol: 'DES',
    'Security Name': 'WisdomTree US SmallCap Dividend Fund',

    'CQS symbol': 'DES',
    'NASDAQ symbol': 'DES',
  },
  {
    symbol: 'DESP',
    'Security Name': 'Despegarcom, Corp Ordinary Shares',

    'CQS symbol': 'DESP',
    'NASDAQ symbol': 'DESP',
  },
  {
    symbol: 'DEUS',
    'Security Name': 'Xtrackers Russell 1000 Comprehensive Factor ETF',

    'CQS symbol': 'DEUS',
    'NASDAQ symbol': 'DEUS',
  },
  {
    symbol: 'DEW',
    'Security Name': 'WisdomTree Global High Dividend Fund',

    'CQS symbol': 'DEW',
    'NASDAQ symbol': 'DEW',
  },
  {
    symbol: 'DEX',
    'Security Name':
      'Delaware Enhanced Global Dividend Common Shares of Beneficial Interest',

    'CQS symbol': 'DEX',
    'NASDAQ symbol': 'DEX',
  },
  {
    symbol: 'DFAE',
    'Security Name': 'Dimensional Emerging Core Equity Market ETF',

    'CQS symbol': 'DFAE',
    'NASDAQ symbol': 'DFAE',
  },
  {
    symbol: 'DFAI',
    'Security Name': 'Dimensional International Core Equity Market ETF',

    'CQS symbol': 'DFAI',
    'NASDAQ symbol': 'DFAI',
  },
  {
    symbol: 'DFAU',
    'Security Name': 'Dimensional US Core Equity Market ETF',

    'CQS symbol': 'DFAU',
    'NASDAQ symbol': 'DFAU',
  },
  {
    symbol: 'DFE',
    'Security Name': 'WisdomTree Europe SmallCap Dividend Fund',

    'CQS symbol': 'DFE',
    'NASDAQ symbol': 'DFE',
  },
  {
    symbol: 'DFEB',
    'Security Name': 'FT Cboe Vest US Equity Deep Buffer ETF  February',

    'CQS symbol': 'DFEB',
    'NASDAQ symbol': 'DFEB',
  },
  {
    symbol: 'DFEN',
    'Security Name': 'Direxion Daily Aerospace & Defense Bull 3X Shares',

    'CQS symbol': 'DFEN',
    'NASDAQ symbol': 'DFEN',
  },
  {
    symbol: 'DFFN',
    'Security Name': 'Diffusion Pharmaceuticals   ',

    'NASDAQ symbol': 'DFFN',
  },
  {
    symbol: 'DFHT',
    'Security Name': 'Deerfield Healthcare Technology Acquisitions Corp   ',

    'NASDAQ symbol': 'DFHT',
  },
  {
    symbol: 'DFHTU',
    'Security Name': 'Deerfield Healthcare Technology Acquisitions Corp  Unit',

    'NASDAQ symbol': 'DFHTU',
  },
  {
    symbol: 'DFHTW',
    'Security Name':
      'Deerfield Healthcare Technology Acquisitions Corp  Warrant',

    'NASDAQ symbol': 'DFHTW',
  },
  {
    symbol: 'DFIN',
    'Security Name': 'Donnelley Financial Solutions,   ',

    'CQS symbol': 'DFIN',
    'NASDAQ symbol': 'DFIN',
  },
  {
    symbol: 'DFJ',
    'Security Name': 'WisdomTree Japan SmallCap Fund',

    'CQS symbol': 'DFJ',
    'NASDAQ symbol': 'DFJ',
  },
  {
    symbol: 'DFND',
    'Security Name': 'Siren DIVCON Dividend Defender ETF',

    'CQS symbol': 'DFND',
    'NASDAQ symbol': 'DFND',
  },
  {
    symbol: 'DFNL',
    'Security Name': 'Davis Select Financial ETF',

    'NASDAQ symbol': 'DFNL',
  },
  {
    symbol: 'DFNS',
    'Security Name': 'LGL Systems Acquisition Corp ',

    'CQS symbol': 'DFNS',
    'NASDAQ symbol': 'DFNS',
  },
  {
    symbol: 'DFNSU',
    'Security Name': 'LGL Systems Acquisition Corp Units',

    'CQS symbol': 'DFNSU',
    'NASDAQ symbol': 'DFNS=',
  },
  {
    symbol: 'DFNSW',
    'Security Name':
      'LGL Systems Acquisition Corp Redeemable Warrants, each whole warrant exercisable for shares of   at an exercise price of $1150 per share',

    'CQS symbol': 'DFNSWS',
    'NASDAQ symbol': 'DFNS+',
  },
  {
    symbol: 'DFP',
    'Security Name': 'Flaherty & Crumrine Dynamic Preferred and ome Fund  ',

    'CQS symbol': 'DFP',
    'NASDAQ symbol': 'DFP',
  },
  {
    symbol: 'DFPH',
    'Security Name': 'DFP Healthcare Acquisitions Corp   ',

    'NASDAQ symbol': 'DFPH',
  },
  {
    symbol: 'DFPHU',
    'Security Name': 'DFP Healthcare Acquisitions Corp  Unit',

    'NASDAQ symbol': 'DFPHU',
  },
  {
    symbol: 'DFPHW',
    'Security Name': 'DFP Healthcare Acquisitions Corp  Warrant',

    'NASDAQ symbol': 'DFPHW',
  },
  {
    symbol: 'DFS',
    'Security Name': 'Discover Financial Services ',

    'CQS symbol': 'DFS',
    'NASDAQ symbol': 'DFS',
  },
  {
    symbol: 'DFVL',
    'Security Name': 'iPath US Treasury 5 Year Bull ETN',

    'CQS symbol': 'DFVL',
    'NASDAQ symbol': 'DFVL',
  },
  {
    symbol: 'DFVS',
    'Security Name': 'iPath US Treasury 5 Year Bear ETN',

    'CQS symbol': 'DFVS',
    'NASDAQ symbol': 'DFVS',
  },
  {
    symbol: 'DG',
    'Security Name': 'Dollar General Corporation ',

    'CQS symbol': 'DG',
    'NASDAQ symbol': 'DG',
  },
  {
    symbol: 'DGICA',
    'Security Name': 'Donegal Group,    ',

    'NASDAQ symbol': 'DGICA',
  },
  {
    symbol: 'DGICB',
    'Security Name': 'Donegal Group,   Class B ',

    'NASDAQ symbol': 'DGICB',
  },
  {
    symbol: 'DGII',
    'Security Name': 'Digi International   ',

    'NASDAQ symbol': 'DGII',
  },
  {
    symbol: 'DGL',
    'Security Name': 'Invesco DB Gold Fund',

    'CQS symbol': 'DGL',
    'NASDAQ symbol': 'DGL',
  },
  {
    symbol: 'DGLY',
    'Security Name': 'Digital Ally,   ',

    'NASDAQ symbol': 'DGLY',
  },
  {
    symbol: 'DGNR',
    'Security Name': 'Dragoneer Growth Opportunities Corp  Ordinary Shares',

    'CQS symbol': 'DGNR',
    'NASDAQ symbol': 'DGNR',
  },
  {
    symbol: 'DGNRU',
    'Security Name':
      'Dragoneer Growth Opportunities Corp Units, each consisting of one  ordinary share, and onefourth of one redeemable warrant',

    'CQS symbol': 'DGNRU',
    'NASDAQ symbol': 'DGNR=',
  },
  {
    symbol: 'DGNRW',
    'Security Name':
      'Dragoneer Growth Opportunities Corp Redeemable warrants, each whole warrant exercisable for one  ordinary share at an exercise price of $1150',

    'CQS symbol': 'DGNRWS',
    'NASDAQ symbol': 'DGNR+',
  },
  {
    symbol: 'DGNS',
    'Security Name': 'Dragoneer Growth Opportunities Corp II   Ordinary Shares',

    'NASDAQ symbol': 'DGNS',
  },
  {
    symbol: 'DGP',
    'Security Name': 'DB Gold Double Long ETN due February 15, 2038',

    'CQS symbol': 'DGP',
    'NASDAQ symbol': 'DGP',
  },
  {
    symbol: 'DGRE',
    'Security Name': 'WisdomTree Emerging Markets Quality Dividend Growth Fund',

    'NASDAQ symbol': 'DGRE',
  },
  {
    symbol: 'DGRO',
    'Security Name': 'iShares Core Dividend Growth ETF',

    'CQS symbol': 'DGRO',
    'NASDAQ symbol': 'DGRO',
  },
  {
    symbol: 'DGRS',
    'Security Name': 'WisdomTree US SmallCap Quality Dividend Growth Fund',

    'NASDAQ symbol': 'DGRS',
  },
  {
    symbol: 'DGRW',
    'Security Name': 'WisdomTree US Quality Dividend Growth Fund',

    'NASDAQ symbol': 'DGRW',
  },
  {
    symbol: 'DGS',
    'Security Name': 'WisdomTree Emerging Market SmallCap Fund',

    'CQS symbol': 'DGS',
    'NASDAQ symbol': 'DGS',
  },
  {
    symbol: 'DGT',
    'Security Name': 'SPDR Global Dow ETF (based on The Global Dow)',

    'CQS symbol': 'DGT',
    'NASDAQ symbol': 'DGT',
  },
  {
    symbol: 'DGX',
    'Security Name': 'Quest Diagnostics orporated ',

    'CQS symbol': 'DGX',
    'NASDAQ symbol': 'DGX',
  },
  {
    symbol: 'DGZ',
    'Security Name': 'DB Gold Short ETN due February 15, 2038',

    'CQS symbol': 'DGZ',
    'NASDAQ symbol': 'DGZ',
  },
  {
    symbol: 'DHC',
    'Security Name':
      'Diversified Healthcare Trust   Common Shares of Beneficial Interest',

    'NASDAQ symbol': 'DHC',
  },
  {
    symbol: 'DHCNI',
    'Security Name':
      'Diversified Healthcare Trust   5625% Senior Notes due 2042',

    'NASDAQ symbol': 'DHCNI',
  },
  {
    symbol: 'DHCNL',
    'Security Name':
      'Diversified Healthcare Trust   625% Senior Notes Due 2046',

    'NASDAQ symbol': 'DHCNL',
  },
  {
    symbol: 'DHF',
    'Security Name': 'BNY Mellon High Yield Strategies Fund ',

    'CQS symbol': 'DHF',
    'NASDAQ symbol': 'DHF',
  },
  {
    symbol: 'DHI',
    'Security Name': 'DR Horton,  ',

    'CQS symbol': 'DHI',
    'NASDAQ symbol': 'DHI',
  },
  {
    symbol: 'DHIL',
    'Security Name': 'Diamond Hill Investment Group,    ',

    'NASDAQ symbol': 'DHIL',
  },
  {
    symbol: 'DHR',
    'Security Name': 'Danaher Corporation ',

    'CQS symbol': 'DHR',
    'NASDAQ symbol': 'DHR',
  },
  {
    symbol: 'DHR$A',
    'Security Name':
      'Danaher Corporation 475% Mandatory Convertible Preferred Stock, Series A',

    'CQS symbol': 'DHRpA',
    'NASDAQ symbol': 'DHRA',
  },
  {
    symbol: 'DHR$B',
    'Security Name':
      'Danaher Corporation 500% Mandatory Convertible Preferred Stock, Series B',

    'CQS symbol': 'DHRpB',
    'NASDAQ symbol': 'DHRB',
  },
  {
    symbol: 'DHS',
    'Security Name': 'WisdomTree US High Dividend Fund',

    'CQS symbol': 'DHS',
    'NASDAQ symbol': 'DHS',
  },
  {
    symbol: 'DHT',
    'Security Name': 'DHT Holdings, ',

    'CQS symbol': 'DHT',
    'NASDAQ symbol': 'DHT',
  },
  {
    symbol: 'DHX',
    'Security Name': 'DHI Group,  ',

    'CQS symbol': 'DHX',
    'NASDAQ symbol': 'DHX',
  },
  {
    symbol: 'DHY',
    'Security Name': 'Credit Suisse High Yield Bond Fund ',

    'CQS symbol': 'DHY',
    'NASDAQ symbol': 'DHY',
  },
  {
    symbol: 'DIA',
    'Security Name': 'SPDR Dow Jones Industrial Average ETF',

    'CQS symbol': 'DIA',
    'NASDAQ symbol': 'DIA',
  },
  {
    symbol: 'DIAL',
    'Security Name': 'Columbia Diversified Fixed ome Allocation ETF',

    'CQS symbol': 'DIAL',
    'NASDAQ symbol': 'DIAL',
  },
  {
    symbol: 'DIAX',
    'Security Name':
      'Nuveen Dow 30SM Dynamic Overwrite Fund Common Shares of Beneficial Interest',

    'CQS symbol': 'DIAX',
    'NASDAQ symbol': 'DIAX',
  },
  {
    symbol: 'DIG',
    'Security Name': 'ProShares Ultra Oil & Gas',

    'CQS symbol': 'DIG',
    'NASDAQ symbol': 'DIG',
  },
  {
    symbol: 'DIM',
    'Security Name': 'WisdomTree International MidCap Dividend Fund',

    'CQS symbol': 'DIM',
    'NASDAQ symbol': 'DIM',
  },
  {
    symbol: 'DIN',
    'Security Name': 'Dine Brands Global,  ',

    'CQS symbol': 'DIN',
    'NASDAQ symbol': 'DIN',
  },
  {
    symbol: 'DINT',
    'Security Name': 'Davis Select International ETF',

    'NASDAQ symbol': 'DINT',
  },
  {
    symbol: 'DIOD',
    'Security Name': 'Diodes orporated  ',

    'NASDAQ symbol': 'DIOD',
  },
  {
    symbol: 'DIS',
    'Security Name': 'Walt Disney Company (The) ',

    'CQS symbol': 'DIS',
    'NASDAQ symbol': 'DIS',
  },
  {
    symbol: 'DISCA',
    'Security Name': 'Discovery,   Series A ',

    'NASDAQ symbol': 'DISCA',
  },
  {
    symbol: 'DISCB',
    'Security Name': 'Discovery,   Series B ',

    'NASDAQ symbol': 'DISCB',
  },
  {
    symbol: 'DISCK',
    'Security Name': 'Discovery,   Series C ',

    'NASDAQ symbol': 'DISCK',
  },
  {
    symbol: 'DISH',
    'Security Name': 'DISH Network Corporation   ',

    'NASDAQ symbol': 'DISH',
  },
  {
    symbol: 'DIT',
    'Security Name': 'AMCON Distributing Company ',

    'Round Lot Size': '10',

    'CQS symbol': 'DIT',
    'NASDAQ symbol': 'DIT',
  },
  {
    symbol: 'DIV',
    'Security Name': 'Global X Super Dividend ETF',

    'CQS symbol': 'DIV',
    'NASDAQ symbol': 'DIV',
  },
  {
    symbol: 'DIVA',
    'Security Name': 'AGFiQ Hedged Dividend ome Fund',

    'CQS symbol': 'DIVA',
    'NASDAQ symbol': 'DIVA',
  },
  {
    symbol: 'DIVB',
    'Security Name': 'iShares US Dividend and Buyback ETF',

    'CQS symbol': 'DIVB',
    'NASDAQ symbol': 'DIVB',
  },
  {
    symbol: 'DIVO',
    'Security Name': 'Amplify CWP Enhanced Dividend ome ETF',

    'CQS symbol': 'DIVO',
    'NASDAQ symbol': 'DIVO',
  },
  {
    symbol: 'DJCB',
    'Security Name':
      'ETRACS Bloomberg Commodity Index Total Return ETN Series B due October 31, 2039',

    'CQS symbol': 'DJCB',
    'NASDAQ symbol': 'DJCB',
  },
  {
    symbol: 'DJCI',
    'Security Name':
      'ETRACS Linked to the Bloomberg Commodity Index Total Return due October 31, 2039',

    'CQS symbol': 'DJCI',
    'NASDAQ symbol': 'DJCI',
  },
  {
    symbol: 'DJCO',
    'Security Name': 'Daily Journal Corp (SC)  ',

    'NASDAQ symbol': 'DJCO',
  },
  {
    symbol: 'DJD',
    'Security Name': 'Invesco Dow Jones Industrial Average Dividend ETF',

    'CQS symbol': 'DJD',
    'NASDAQ symbol': 'DJD',
  },
  {
    symbol: 'DJP',
    'Security Name': 'iPath Bloomberg Commodity Index Total Return ETN',

    'CQS symbol': 'DJP',
    'NASDAQ symbol': 'DJP',
  },
  {
    symbol: 'DJUL',
    'Security Name': 'FT Cboe Vest US Equity Deep Buffer ETF  July',

    'CQS symbol': 'DJUL',
    'NASDAQ symbol': 'DJUL',
  },
  {
    symbol: 'DJUN',
    'Security Name': 'FT Cboe Vest US Equity Deep Buffer ETF  June',

    'CQS symbol': 'DJUN',
    'NASDAQ symbol': 'DJUN',
  },
  {
    symbol: 'DK',
    'Security Name': 'Delek US Holdings,  ',

    'CQS symbol': 'DK',
    'NASDAQ symbol': 'DK',
  },
  {
    symbol: 'DKL',
    'Security Name':
      'Delek Logistics Partners, LP Common Units representing Limited Partner Interests',

    'CQS symbol': 'DKL',
    'NASDAQ symbol': 'DKL',
  },
  {
    symbol: 'DKNG',
    'Security Name': 'DraftKings    ',

    'NASDAQ symbol': 'DKNG',
  },
  {
    symbol: 'DKS',
    'Security Name': "Dick's Sporting Goods  ",

    'CQS symbol': 'DKS',
    'NASDAQ symbol': 'DKS',
  },
  {
    symbol: 'DL',
    'Security Name':
      'China Distance Education Holdings Limited American Depositary Shares',

    'CQS symbol': 'DL',
    'NASDAQ symbol': 'DL',
  },
  {
    symbol: 'DLA',
    'Security Name': 'Delta Apparel,  ',

    'CQS symbol': 'DLA',
    'NASDAQ symbol': 'DLA',
  },
  {
    symbol: 'DLB',
    'Security Name': 'Dolby Laboratories ',

    'CQS symbol': 'DLB',
    'NASDAQ symbol': 'DLB',
  },
  {
    symbol: 'DLHC',
    'Security Name': 'DLH Holdings Corp  ',

    'NASDAQ symbol': 'DLHC',
  },
  {
    symbol: 'DLN',
    'Security Name': 'WisdomTree US LargeCap Dividend Fund',

    'CQS symbol': 'DLN',
    'NASDAQ symbol': 'DLN',
  },
  {
    symbol: 'DLNG',
    'Security Name': 'Dynagas LNG Partners LP Common Units',

    'CQS symbol': 'DLNG',
    'NASDAQ symbol': 'DLNG',
  },
  {
    symbol: 'DLNG$A',
    'Security Name':
      'Dynagas LNG Partners LP 900% Series A Cumulative Redeemable Preferred Units',

    'CQS symbol': 'DLNGpA',
    'NASDAQ symbol': 'DLNGA',
  },
  {
    symbol: 'DLNG$B',
    'Security Name':
      'Dynagas LNG Partners LP 875% Series B Fixed to Floating Rate Cumulative Redeemable Perpetual Preferred Units, liquidation preference $2500 per Uni',

    'CQS symbol': 'DLNGpB',
    'NASDAQ symbol': 'DLNGB',
  },
  {
    symbol: 'DLPN',
    'Security Name': 'Dolphin Entertainment,   ',

    'NASDAQ symbol': 'DLPN',
  },
  {
    symbol: 'DLPNW',
    'Security Name': 'Dolphin Entertainment,   Warrant',

    'NASDAQ symbol': 'DLPNW',
  },
  {
    symbol: 'DLR',
    'Security Name': 'Digital Realty Trust,  ',

    'CQS symbol': 'DLR',
    'NASDAQ symbol': 'DLR',
  },
  {
    symbol: 'DLR$C',
    'Security Name':
      'Digital Realty Trust,  6625% Series C Cumulative Redeemable Perpetual Preferred Stock',

    'CQS symbol': 'DLRpC',
    'NASDAQ symbol': 'DLRC',
  },
  {
    symbol: 'DLR$J',
    'Security Name':
      'Digital Realty Trust,  5250% Series J Cumulative Redeemable Preferred Stock',

    'CQS symbol': 'DLRpJ',
    'NASDAQ symbol': 'DLRJ',
  },
  {
    symbol: 'DLR$K',
    'Security Name':
      'Digital Realty Trust,  5850% Series K Cumulative Redeemable Preferred Stock, par value $001 per share',

    'CQS symbol': 'DLRpK',
    'NASDAQ symbol': 'DLRK',
  },
  {
    symbol: 'DLR$L',
    'Security Name':
      'Digital Realty Trust,  5200% Series L Cumulative Redeemable Preferred Stock',

    'CQS symbol': 'DLRpL',
    'NASDAQ symbol': 'DLRL',
  },
  {
    symbol: 'DLS',
    'Security Name': 'WisdomTree International SmallCap Fund',

    'CQS symbol': 'DLS',
    'NASDAQ symbol': 'DLS',
  },
  {
    symbol: 'DLTH',
    'Security Name': 'Duluth Holdings   Class B ',

    'NASDAQ symbol': 'DLTH',
  },
  {
    symbol: 'DLTR',
    'Security Name': 'Dollar Tree,   ',

    'NASDAQ symbol': 'DLTR',
  },
  {
    symbol: 'DLX',
    'Security Name': 'Deluxe Corporation ',

    'CQS symbol': 'DLX',
    'NASDAQ symbol': 'DLX',
  },
  {
    symbol: 'DLY',
    'Security Name':
      'DoubleLine Yield Opportunities Fund Common Shares of Beneficial Interest',

    'CQS symbol': 'DLY',
    'NASDAQ symbol': 'DLY',
  },
  {
    symbol: 'DMAC',
    'Security Name': 'DiaMedica Therapeutics   ',

    'NASDAQ symbol': 'DMAC',
  },
  {
    symbol: 'DMAY',
    'Security Name': 'FT Cboe Vest US Equity Deep Buffer ETF  May',

    'CQS symbol': 'DMAY',
    'NASDAQ symbol': 'DMAY',
  },
  {
    symbol: 'DMB',
    'Security Name': 'BNY Mellon Municipal Bond Infrastructure Fund,  ',

    'CQS symbol': 'DMB',
    'NASDAQ symbol': 'DMB',
  },
  {
    symbol: 'DMDV',
    'Security Name': 'AAM S&P Developed Markets High Dividend Value ETF',

    'CQS symbol': 'DMDV',
    'NASDAQ symbol': 'DMDV',
  },
  {
    symbol: 'DMF',
    'Security Name': 'BNY Mellon Municipal ome  ',

    'CQS symbol': 'DMF',
    'NASDAQ symbol': 'DMF',
  },
  {
    symbol: 'DMLP',
    'Security Name':
      'Dorchester Minerals, LP  Common Units Representing Limited Partnership Interests',

    'NASDAQ symbol': 'DMLP',
  },
  {
    symbol: 'DMO',
    'Security Name': 'Western Asset Mortgage Opportunity Fund  ',

    'CQS symbol': 'DMO',
    'NASDAQ symbol': 'DMO',
  },
  {
    symbol: 'DMRC',
    'Security Name': 'Digimarc Corporation  ',

    'NASDAQ symbol': 'DMRC',
  },
  {
    symbol: 'DMRE',
    'Security Name': 'DeltaShares S&P EM 100 & Managed Risk ETF',

    'CQS symbol': 'DMRE',
    'NASDAQ symbol': 'DMRE',
  },
  {
    symbol: 'DMRI',
    'Security Name': 'DeltaShares S&P International Managed Risk ETF',

    'CQS symbol': 'DMRI',
    'NASDAQ symbol': 'DMRI',
  },
  {
    symbol: 'DMRL',
    'Security Name': 'DeltaShares S&P 500 Managed Risk ETF',

    'CQS symbol': 'DMRL',
    'NASDAQ symbol': 'DMRL',
  },
  {
    symbol: 'DMRM',
    'Security Name': 'DeltaShares S&P 400 Managed Risk ETF',

    'CQS symbol': 'DMRM',
    'NASDAQ symbol': 'DMRM',
  },
  {
    symbol: 'DMRS',
    'Security Name': 'DeltaShares S&P 600 Managed Risk ETF',

    'CQS symbol': 'DMRS',
    'NASDAQ symbol': 'DMRS',
  },
  {
    symbol: 'DMS',
    'Security Name': 'Digital Media Solutions,   Ordinary Shares',

    'CQS symbol': 'DMS',
    'NASDAQ symbol': 'DMS',
  },
  {
    symbol: 'DMSW',
    'Security Name': 'Digital Media Solutions,  Warrants, ',

    'CQS symbol': 'DMSWS',
    'NASDAQ symbol': 'DMS+',
  },
  {
    symbol: 'DMTK',
    'Security Name': 'DermTech,   ',

    'NASDAQ symbol': 'DMTK',
  },
  {
    symbol: 'DMXF',
    'Security Name': 'iShares ESG Advanced MSCI EAFE ETF',

    'NASDAQ symbol': 'DMXF',
  },
  {
    symbol: 'DMYD',
    'Security Name': 'dMY Technology Group,  II  ',

    'CQS symbol': 'DMYD',
    'NASDAQ symbol': 'DMYD',
  },
  {
    symbol: 'DMYDU',
    'Security Name':
      'dMY Technology Group,  II Units, each consisting of one share of   and onethird of one redeemable warrant',

    'CQS symbol': 'DMYDU',
    'NASDAQ symbol': 'DMYD=',
  },
  {
    symbol: 'DMYDW',
    'Security Name': 'dMY Technology Group,  II Redeemable Warrants',

    'CQS symbol': 'DMYDWS',
    'NASDAQ symbol': 'DMYD+',
  },
  {
    symbol: 'DMYIU',
    'Security Name':
      'dMY Technology Group,  III Units, each consisting of one share of   and onefourth of one redeemable warrant',

    'CQS symbol': 'DMYIU',
    'NASDAQ symbol': 'DMYI=',
  },
  {
    symbol: 'DMYT',
    'Security Name': 'dMY Technology Group,   ',

    'CQS symbol': 'DMYT',
    'NASDAQ symbol': 'DMYT',
  },
  {
    symbol: 'DMYTU',
    'Security Name':
      'dMY Technology Group,  Units, each consisting of one share of   and onehalf of one redeemable Warrant',

    'CQS symbol': 'DMYTU',
    'NASDAQ symbol': 'DMYT=',
  },
  {
    symbol: 'DMYTW',
    'Security Name':
      'dMY Technology Group,  Redeemable Warrants, each whole warrant exercisable for one share of  , each at an exercise price of $1150 per share',

    'CQS symbol': 'DMYTWS',
    'NASDAQ symbol': 'DMYT+',
  },
  {
    symbol: 'DNB',
    'Security Name': 'Dun & Bradstreet Holdings,  ',

    'CQS symbol': 'DNB',
    'NASDAQ symbol': 'DNB',
  },
  {
    symbol: 'DNK',
    'Security Name':
      'Phoenix Tree Holdings Limited American Depositary Shares, each representing ten (10)  ordinary shares',

    'CQS symbol': 'DNK',
    'NASDAQ symbol': 'DNK',
  },
  {
    symbol: 'DNKN',
    'Security Name': "Dunkin' Brands Group,   ",

    'NASDAQ symbol': 'DNKN',
  },
  {
    symbol: 'DNL',
    'Security Name': 'WisdomTree Global exUS Quality Dividend Growth Fund',

    'CQS symbol': 'DNL',
    'NASDAQ symbol': 'DNL',
  },
  {
    symbol: 'DNLI',
    'Security Name': 'Denali Therapeutics   ',

    'NASDAQ symbol': 'DNLI',
  },
  {
    symbol: 'DNN',
    'Security Name': 'Denison Mines Corp Ordinary Shares (Canada)',

    'CQS symbol': 'DNN',
    'NASDAQ symbol': 'DNN',
  },
  {
    symbol: 'DNOV',
    'Security Name': 'FT Cboe Vest US Equity Deep Buffer ETF  November',

    'CQS symbol': 'DNOV',
    'NASDAQ symbol': 'DNOV',
  },
  {
    symbol: 'DNOW',
    'Security Name': 'NOW  ',

    'CQS symbol': 'DNOW',
    'NASDAQ symbol': 'DNOW',
  },
  {
    symbol: 'DNP',
    'Security Name': 'DNP Select ome Fund,  ',

    'CQS symbol': 'DNP',
    'NASDAQ symbol': 'DNP',
  },
  {
    symbol: 'DOC',
    'Security Name':
      'Physicians Realty Trust Common Shares of Beneficial Interest',

    'CQS symbol': 'DOC',
    'NASDAQ symbol': 'DOC',
  },
  {
    symbol: 'DOCT',
    'Security Name': 'FT Cboe Vest US Equity Deep Buffer ETF  October',

    'CQS symbol': 'DOCT',
    'NASDAQ symbol': 'DOCT',
  },
  {
    symbol: 'DOCU',
    'Security Name': 'DocuSign,   ',

    'NASDAQ symbol': 'DOCU',
  },
  {
    symbol: 'DOG',
    'Security Name': 'ProShares Short Dow30',

    'CQS symbol': 'DOG',
    'NASDAQ symbol': 'DOG',
  },
  {
    symbol: 'DOGZ',
    'Security Name': 'Dogness (International) Corporation   ',

    'NASDAQ symbol': 'DOGZ',
  },
  {
    symbol: 'DOL',
    'Security Name': 'WisdomTree International LargeCap Dividend Fund',

    'CQS symbol': 'DOL',
    'NASDAQ symbol': 'DOL',
  },
  {
    symbol: 'DOMO',
    'Security Name': 'Domo,   Class B ',

    'NASDAQ symbol': 'DOMO',
  },
  {
    symbol: 'DON',
    'Security Name': 'WisdomTree US MidCap Dividend Fund',

    'CQS symbol': 'DON',
    'NASDAQ symbol': 'DON',
  },
  {
    symbol: 'DOO',
    'Security Name': 'WisdomTree International Dividend Top 100 Fund',

    'CQS symbol': 'DOO',
    'NASDAQ symbol': 'DOO',
  },
  {
    symbol: 'DOOO',
    'Security Name': 'BRP   Common Subordinate Voting Shares',

    'NASDAQ symbol': 'DOOO',
  },
  {
    symbol: 'DOOR',
    'Security Name':
      'Masonite International Corporation Ordinary Shares (Canada)',

    'CQS symbol': 'DOOR',
    'NASDAQ symbol': 'DOOR',
  },
  {
    symbol: 'DORM',
    'Security Name': 'Dorman Products,   ',

    'NASDAQ symbol': 'DORM',
  },
  {
    symbol: 'DOV',
    'Security Name': 'Dover Corporation ',

    'CQS symbol': 'DOV',
    'NASDAQ symbol': 'DOV',
  },
  {
    symbol: 'DOW',
    'Security Name': 'Dow   ',

    'CQS symbol': 'DOW',
    'NASDAQ symbol': 'DOW',
  },
  {
    symbol: 'DOX',
    'Security Name': 'Amdocs Limited  Ordinary Shares',

    'NASDAQ symbol': 'DOX',
  },
  {
    symbol: 'DOYU',
    'Security Name':
      'DouYu International Holdings Limited  American Depositary Shares',

    'NASDAQ symbol': 'DOYU',
  },
  {
    symbol: 'DPG',
    'Security Name': 'Duff & Phelps Utility and Infrastructure Fund ',

    'CQS symbol': 'DPG',
    'NASDAQ symbol': 'DPG',
  },
  {
    symbol: 'DPST',
    'Security Name': 'Direxion Daily Regional Banks Bull 3X Shares',

    'CQS symbol': 'DPST',
    'NASDAQ symbol': 'DPST',
  },
  {
    symbol: 'DPW',
    'Security Name': 'DPW Holdings,  ',

    'CQS symbol': 'DPW',
    'NASDAQ symbol': 'DPW',
  },
  {
    symbol: 'DPZ',
    'Security Name': "Domino's Pizza  ",

    'CQS symbol': 'DPZ',
    'NASDAQ symbol': 'DPZ',
  },
  {
    symbol: 'DQ',
    'Security Name':
      'DAQO New Energy Corp American Depositary Shares, each representing five ordinary shares',

    'CQS symbol': 'DQ',
    'NASDAQ symbol': 'DQ',
  },
  {
    symbol: 'DRAD',
    'Security Name': 'Digirad Corporation  ',

    'NASDAQ symbol': 'DRAD',
  },
  {
    symbol: 'DRADP',
    'Security Name':
      'Digirad Corporation  Series A Cumulative Perpetual Preferred Stock',

    'NASDAQ symbol': 'DRADP',
  },
  {
    symbol: 'DRD',
    'Security Name': 'DRDGOLD Limited American Depositary Shares',

    'CQS symbol': 'DRD',
    'NASDAQ symbol': 'DRD',
  },
  {
    symbol: 'DRE',
    'Security Name': 'Duke Realty Corporation ',

    'CQS symbol': 'DRE',
    'NASDAQ symbol': 'DRE',
  },
  {
    symbol: 'DRH',
    'Security Name': 'Diamondrock Hospitality Company ',

    'CQS symbol': 'DRH',
    'NASDAQ symbol': 'DRH',
  },
  {
    symbol: 'DRH$A',
    'Security Name':
      'Diamondrock Hospitality Company 8250% Series A Cumulative Redeemable Preferred Stock',

    'CQS symbol': 'DRHpA',
    'NASDAQ symbol': 'DRHA',
  },
  {
    symbol: 'DRI',
    'Security Name': 'Darden Restaurants,  ',

    'CQS symbol': 'DRI',
    'NASDAQ symbol': 'DRI',
  },
  {
    symbol: 'DRIO',
    'Security Name': 'DarioHealth Corp  ',

    'NASDAQ symbol': 'DRIO',
  },
  {
    symbol: 'DRIOW',
    'Security Name': 'DarioHealth Corp  Warrant',

    'NASDAQ symbol': 'DRIOW',
  },
  {
    symbol: 'DRIP',
    'Security Name': 'Direxion Daily S&P Oil & Gas Exp & Prod Bear 2X Shares',

    'CQS symbol': 'DRIP',
    'NASDAQ symbol': 'DRIP',
  },
  {
    symbol: 'DRIV',
    'Security Name': 'Global X Autonomous & Electric Vehicles ETF',

    'NASDAQ symbol': 'DRIV',
  },
  {
    symbol: 'DRN',
    'Security Name': 'Direxion Daily Real Estate Bull 3x Shares',

    'CQS symbol': 'DRN',
    'NASDAQ symbol': 'DRN',
  },
  {
    symbol: 'DRNA',
    'Security Name': 'Dicerna Pharmaceuticals,   ',

    'NASDAQ symbol': 'DRNA',
  },
  {
    symbol: 'DRQ',
    'Security Name': 'DrilQuip,  ',

    'CQS symbol': 'DRQ',
    'NASDAQ symbol': 'DRQ',
  },
  {
    symbol: 'DRRX',
    'Security Name': 'DURECT Corporation  ',

    'NASDAQ symbol': 'DRRX',
  },
  {
    symbol: 'DRSK',
    'Security Name': 'Aptus Defined Risk ETF ',

    'CQS symbol': 'DRSK',
    'NASDAQ symbol': 'DRSK',
  },
  {
    symbol: 'DRTT',
    'Security Name': 'DIRTT Environmental Solutions Ltd  Common Shares',

    'NASDAQ symbol': 'DRTT',
  },
  {
    symbol: 'DRUA',
    'Security Name':
      'Dominion Energy,  2016 Series A 525% Enhanced Junior Subordinated Notes due 2076',

    'CQS symbol': 'DRUA',
    'NASDAQ symbol': 'DRUA',
  },
  {
    symbol: 'DRV',
    'Security Name': 'Drexion Daily Real Estate Bear 3x Shares',

    'CQS symbol': 'DRV',
    'NASDAQ symbol': 'DRV',
  },
  {
    symbol: 'DRW',
    'Security Name': 'WisdomTree Global exUS Real Estate Index',

    'CQS symbol': 'DRW',
    'NASDAQ symbol': 'DRW',
  },
  {
    symbol: 'DS',
    'Security Name': 'Drive Shack ',

    'CQS symbol': 'DS',
    'NASDAQ symbol': 'DS',
  },
  {
    symbol: 'DS$B',
    'Security Name': 'Drive Shack  Preferred Series B',

    'CQS symbol': 'DSpB',
    'NASDAQ symbol': 'DSB',
  },
  {
    symbol: 'DS$C',
    'Security Name': 'Drive Shack  Preferred Series C',

    'CQS symbol': 'DSpC',
    'NASDAQ symbol': 'DSC',
  },
  {
    symbol: 'DS$D',
    'Security Name': 'Drive Shack  Pfd Ser D',

    'CQS symbol': 'DSpD',
    'NASDAQ symbol': 'DSD',
  },
  {
    symbol: 'DSAC',
    'Security Name': 'Duddell Street Acquisition Corp   Ordinary Shares',

    'NASDAQ symbol': 'DSAC',
  },
  {
    symbol: 'DSACU',
    'Security Name': 'Duddell Street Acquisition Corp  Unit',

    'NASDAQ symbol': 'DSACU',
  },
  {
    symbol: 'DSACW',
    'Security Name': 'Duddell Street Acquisition Corp  Warrant',

    'NASDAQ symbol': 'DSACW',
  },
  {
    symbol: 'DSE',
    'Security Name': 'Duff & Phelps Select MLP and Midstream Energy Fund ',

    'CQS symbol': 'DSE',
    'NASDAQ symbol': 'DSE',
  },
  {
    symbol: 'DSEP',
    'Security Name': 'FT Cboe Vest US Equity Deep Buffer ETF  September',

    'CQS symbol': 'DSEP',
    'NASDAQ symbol': 'DSEP',
  },
  {
    symbol: 'DSGX',
    'Security Name': 'The Descartes Systems Group   ',

    'NASDAQ symbol': 'DSGX',
  },
  {
    symbol: 'DSI',
    'Security Name': 'iShares MSCI KLD 400 Social ETF',

    'CQS symbol': 'DSI',
    'NASDAQ symbol': 'DSI',
  },
  {
    symbol: 'DSKE',
    'Security Name': 'Daseke,   ',

    'NASDAQ symbol': 'DSKE',
  },
  {
    symbol: 'DSKEW',
    'Security Name': 'Daseke,   Warrant',

    'NASDAQ symbol': 'DSKEW',
  },
  {
    symbol: 'DSL',
    'Security Name':
      'DoubleLine ome Solutions Fund Common Shares of Beneficial Interests',

    'CQS symbol': 'DSL',
    'NASDAQ symbol': 'DSL',
  },
  {
    symbol: 'DSM',
    'Security Name': 'BNY Mellon Strategic Municipal Bond Fund,  ',

    'CQS symbol': 'DSM',
    'NASDAQ symbol': 'DSM',
  },
  {
    symbol: 'DSOC',
    'Security Name': 'Innovator Double Stacker ETF  October',

    'CQS symbol': 'DSOC',
    'NASDAQ symbol': 'DSOC',
  },
  {
    symbol: 'DSPG',
    'Security Name': 'DSP Group,   ',

    'NASDAQ symbol': 'DSPG',
  },
  {
    symbol: 'DSS',
    'Security Name': 'Document Security Systems,  ',

    'CQS symbol': 'DSS',
    'NASDAQ symbol': 'DSS',
  },
  {
    symbol: 'DSSI',
    'Security Name': 'Diamond S Shipping   ',

    'CQS symbol': 'DSSI',
    'NASDAQ symbol': 'DSSI',
  },
  {
    symbol: 'DSTL',
    'Security Name': 'Distillate US Fundamental Stability & Value ETF',

    'CQS symbol': 'DSTL',
    'NASDAQ symbol': 'DSTL',
  },
  {
    symbol: 'DSU',
    'Security Name': 'Blackrock Debt Strategies Fund,  ',

    'CQS symbol': 'DSU',
    'NASDAQ symbol': 'DSU',
  },
  {
    symbol: 'DSWL',
    'Security Name': 'Deswell Industries,   Common Shares',

    'NASDAQ symbol': 'DSWL',
  },
  {
    symbol: 'DSX',
    'Security Name': 'Diana Shipping  ',

    'CQS symbol': 'DSX',
    'NASDAQ symbol': 'DSX',
  },
  {
    symbol: 'DSX$B',
    'Security Name':
      'Diana Shipping  Perpetual Preferred Shares Series B (Marshall Islands)',

    'CQS symbol': 'DSXpB',
    'NASDAQ symbol': 'DSXB',
  },
  {
    symbol: 'DT',
    'Security Name': 'Dynatrace,  ',

    'CQS symbol': 'DT',
    'NASDAQ symbol': 'DT',
  },
  {
    symbol: 'DTB',
    'Security Name':
      'DTE Energy Company 2020 Series G 4375% Junior Subordinated Debentures due 2080',

    'CQS symbol': 'DTB',
    'NASDAQ symbol': 'DTB',
  },
  {
    symbol: 'DTD',
    'Security Name': 'WisdomTree US Total Dividend Fund',

    'CQS symbol': 'DTD',
    'NASDAQ symbol': 'DTD',
  },
  {
    symbol: 'DTE',
    'Security Name': 'DTE Energy Company ',

    'CQS symbol': 'DTE',
    'NASDAQ symbol': 'DTE',
  },
  {
    symbol: 'DTEA',
    'Security Name': 'DAVIDsTEA   ',

    'NASDAQ symbol': 'DTEA',
  },
  {
    symbol: 'DTEC',
    'Security Name': 'ALPS ETF Trust ALPS Disruptive Technologies ETF',

    'CQS symbol': 'DTEC',
    'NASDAQ symbol': 'DTEC',
  },
  {
    symbol: 'DTF',
    'Security Name': 'DTF TaxFree ome,  ',

    'CQS symbol': 'DTF',
    'NASDAQ symbol': 'DTF',
  },
  {
    symbol: 'DTH',
    'Security Name': 'WisdomTree International High Dividend Fund',

    'CQS symbol': 'DTH',
    'NASDAQ symbol': 'DTH',
  },
  {
    symbol: 'DTIL',
    'Security Name': 'Precision BioSciences,   ',

    'NASDAQ symbol': 'DTIL',
  },
  {
    symbol: 'DTJ',
    'Security Name':
      'DTE Energy Company 2016 Series B 5375% Junior Subordinated Debentures due 2076',

    'CQS symbol': 'DTJ',
    'NASDAQ symbol': 'DTJ',
  },
  {
    symbol: 'DTLA$',
    'Security Name':
      'Brookfield DTLA  7625% Series A Cumulative Redeemable Preferred Stock',

    'CQS symbol': 'DTLAp',
    'NASDAQ symbol': 'DTLA',
  },
  {
    symbol: 'DTN',
    'Security Name': 'WisdomTree US Dividend exFinancials Fund',

    'CQS symbol': 'DTN',
    'NASDAQ symbol': 'DTN',
  },
  {
    symbol: 'DTP',
    'Security Name': 'DTE Energy Company 625% Corporate Units',

    'CQS symbol': 'DTP',
    'NASDAQ symbol': 'DTP',
  },
  {
    symbol: 'DTSS',
    'Security Name': 'Datasea   ',

    'NASDAQ symbol': 'DTSS',
  },
  {
    symbol: 'DTW',
    'Security Name':
      'DTE Energy Company 2017 Series E 525% Junior Subordinated Debentures due 2077',

    'CQS symbol': 'DTW',
    'NASDAQ symbol': 'DTW',
  },
  {
    symbol: 'DTY',
    'Security Name':
      'DTE Energy Company 2016 Series F 600% Junior Subordinated Debentures due 2076',

    'CQS symbol': 'DTY',
    'NASDAQ symbol': 'DTY',
  },
  {
    symbol: 'DUAL',
    'Security Name': 'North Shore Dual Share Class ETF',

    'CQS symbol': 'DUAL',
    'NASDAQ symbol': 'DUAL',
  },
  {
    symbol: 'DUC',
    'Security Name': 'Duff & Phelps Utility & Corporate Bond Trust,  ',

    'CQS symbol': 'DUC',
    'NASDAQ symbol': 'DUC',
  },
  {
    symbol: 'DUG',
    'Security Name': 'ProShares UltraShort Oil & Gas',

    'CQS symbol': 'DUG',
    'NASDAQ symbol': 'DUG',
  },
  {
    symbol: 'DUK',
    'Security Name': 'Duke Energy Corporation (Holding Company) ',

    'CQS symbol': 'DUK',
    'NASDAQ symbol': 'DUK',
  },
  {
    symbol: 'DUK$A',
    'Security Name':
      'Duke Energy Corporation Depositary Shares, each representing a 1/1,000th interest in a share of 575% Series A Cumulative Redeemable Perpetual Preferred Stock',

    'CQS symbol': 'DUKpA',
    'NASDAQ symbol': 'DUKA',
  },
  {
    symbol: 'DUKB',
    'Security Name':
      'Duke Energy Corporation 5625% Junior Subordinated Debentures due 2078',

    'CQS symbol': 'DUKB',
    'NASDAQ symbol': 'DUKB',
  },
  {
    symbol: 'DUKH',
    'Security Name':
      'Duke Energy Corporation 5125% Junior Subordinated Debentures due 2073',

    'CQS symbol': 'DUKH',
    'NASDAQ symbol': 'DUKH',
  },
  {
    symbol: 'DUO',
    'Security Name': 'Fangdd Network Group Ltd  American Depositary Shares',

    'NASDAQ symbol': 'DUO',
  },
  {
    symbol: 'DUOT',
    'Security Name': 'Duos Technologies Group,   ',

    'NASDAQ symbol': 'DUOT',
  },
  {
    symbol: 'DURA',
    'Security Name': 'VanEck Vectors Morningstar Durable Dividend ETF',

    'CQS symbol': 'DURA',
    'NASDAQ symbol': 'DURA',
  },
  {
    symbol: 'DUSA',
    'Security Name': 'Davis Select US Equity ETF',

    'NASDAQ symbol': 'DUSA',
  },
  {
    symbol: 'DUSL',
    'Security Name': 'Direxion Daily Industrials Bull 3X Shares',

    'CQS symbol': 'DUSL',
    'NASDAQ symbol': 'DUSL',
  },
  {
    symbol: 'DUST',
    'Security Name': 'Direxion Daily Gold Miners Index Bear 2X Shares',

    'CQS symbol': 'DUST',
    'NASDAQ symbol': 'DUST',
  },
  {
    symbol: 'DVA',
    'Security Name': 'DaVita  ',

    'CQS symbol': 'DVA',
    'NASDAQ symbol': 'DVA',
  },
  {
    symbol: 'DVAX',
    'Security Name': 'Dynavax Technologies Corporation  ',

    'NASDAQ symbol': 'DVAX',
  },
  {
    symbol: 'DVD',
    'Security Name': 'Dover Motorsports,  ',

    'CQS symbol': 'DVD',
    'NASDAQ symbol': 'DVD',
  },
  {
    symbol: 'DVLU',
    'Security Name': 'First Trust Dorsey Wright Momentum & Value ETF',

    'NASDAQ symbol': 'DVLU',
  },
  {
    symbol: 'DVN',
    'Security Name': 'Devon Energy Corporation ',

    'CQS symbol': 'DVN',
    'NASDAQ symbol': 'DVN',
  },
  {
    symbol: 'DVOL',
    'Security Name': 'First Trust Dorsey Wright Momentum & Low Volatility ETF',

    'NASDAQ symbol': 'DVOL',
  },
  {
    symbol: 'DVY',
    'Security Name': 'iShares Select Dividend ETF',

    'NASDAQ symbol': 'DVY',
  },
  {
    symbol: 'DVYA',
    'Security Name':
      'iShares Asia / Pacific Dividend 30 Index Fund Exchange Traded Fund',

    'CQS symbol': 'DVYA',
    'NASDAQ symbol': 'DVYA',
  },
  {
    symbol: 'DVYE',
    'Security Name':
      'iShares Emerging Markets Dividend Index Fund Exchange Traded Fund',

    'CQS symbol': 'DVYE',
    'NASDAQ symbol': 'DVYE',
  },
  {
    symbol: 'DWAS',
    'Security Name': 'Invesco DWA SmallCap Momentum ETF',

    'NASDAQ symbol': 'DWAS',
  },
  {
    symbol: 'DWAT',
    'Security Name': 'Arrow DWA Tactical ETF',

    'NASDAQ symbol': 'DWAT',
  },
  {
    symbol: 'DWAW',
    'Security Name': 'AdvisorShares Dorsey Wright FSM All Cap World ETF',

    'NASDAQ symbol': 'DWAW',
  },
  {
    symbol: 'DWCR',
    'Security Name': 'Arrow DWA Country Rotation ETF',

    'NASDAQ symbol': 'DWCR',
  },
  {
    symbol: 'DWEQ',
    'Security Name': 'AdvisorShares Dorsey Wright Alpha Equal Weight ETF',

    'NASDAQ symbol': 'DWEQ',
  },
  {
    symbol: 'DWFI',
    'Security Name': 'SPDR Dorsey Wright Fixed ome Allocation ETF',

    'NASDAQ symbol': 'DWFI',
  },
  {
    symbol: 'DWLD',
    'Security Name': 'Davis Select Worldwide ETF',

    'NASDAQ symbol': 'DWLD',
  },
  {
    symbol: 'DWM',
    'Security Name': 'WisdomTree International Equity Fund',

    'CQS symbol': 'DWM',
    'NASDAQ symbol': 'DWM',
  },
  {
    symbol: 'DWMC',
    'Security Name': 'AdvisorShares Dorsey Wright MicroCap ETF',

    'NASDAQ symbol': 'DWMC',
  },
  {
    symbol: 'DWMF',
    'Security Name': 'WisdomTree International Multifactor Fund',

    'CQS symbol': 'DWMF',
    'NASDAQ symbol': 'DWMF',
  },
  {
    symbol: 'DWPP',
    'Security Name': "First Trust Dorsey Wright People's Portfolio ETF",

    'NASDAQ symbol': 'DWPP',
  },
  {
    symbol: 'DWSH',
    'Security Name': 'AdvisorShares Dorsey Wright Short ETF',

    'NASDAQ symbol': 'DWSH',
  },
  {
    symbol: 'DWSN',
    'Security Name': 'Dawson Geophysical Company  ',

    'NASDAQ symbol': 'DWSN',
  },
  {
    symbol: 'DWUS',
    'Security Name': 'AdvisorShares Dorsey Wright FSM US Core ETF',

    'NASDAQ symbol': 'DWUS',
  },
  {
    symbol: 'DWX',
    'Security Name': 'SPDR S&P International Dividend ETF',

    'CQS symbol': 'DWX',
    'NASDAQ symbol': 'DWX',
  },
  {
    symbol: 'DX',
    'Security Name': 'Dynex Capital,  ',

    'CQS symbol': 'DX',
    'NASDAQ symbol': 'DX',
  },
  {
    symbol: 'DX$B',
    'Security Name': 'Dynex Capital,  Preferred Series B',

    'CQS symbol': 'DXpB',
    'NASDAQ symbol': 'DXB',
  },
  {
    symbol: 'DX$C',
    'Security Name':
      'Dynex Capital,  6900% Series C FixedtoFloating Rate Cumulative Redeemable Preferred Stock',

    'CQS symbol': 'DXpC',
    'NASDAQ symbol': 'DXC',
  },
  {
    symbol: 'DXC',
    'Security Name': 'DXC Technology Company  ',

    'CQS symbol': 'DXC',
    'NASDAQ symbol': 'DXC',
  },
  {
    symbol: 'DXCM',
    'Security Name': 'DexCom,   ',

    'NASDAQ symbol': 'DXCM',
  },
  {
    symbol: 'DXD',
    'Security Name': 'ProShares UltraShort Dow30',

    'CQS symbol': 'DXD',
    'NASDAQ symbol': 'DXD',
  },
  {
    symbol: 'DXF',
    'Security Name':
      'Dunxin Financial Holdings Limited American Depositary Shares',

    'CQS symbol': 'DXF',
    'NASDAQ symbol': 'DXF',
  },
  {
    symbol: 'DXGE',
    'Security Name': 'WisdomTree Germany Hedged Equity Fund',

    'NASDAQ symbol': 'DXGE',
  },
  {
    symbol: 'DXJ',
    'Security Name': 'WisdomTree Japan Hedged Equity Fund',

    'CQS symbol': 'DXJ',
    'NASDAQ symbol': 'DXJ',
  },
  {
    symbol: 'DXJS',
    'Security Name': 'WisdomTree Japan Hedged SmallCap Equity Fund',

    'NASDAQ symbol': 'DXJS',
  },
  {
    symbol: 'DXLG',
    'Security Name': 'Destination XL Group,   ',

    'NASDAQ symbol': 'DXLG',
  },
  {
    symbol: 'DXPE',
    'Security Name': 'DXP Enterprises,   ',

    'NASDAQ symbol': 'DXPE',
  },
  {
    symbol: 'DXR',
    'Security Name': 'Daxor Corporation ',

    'CQS symbol': 'DXR',
    'NASDAQ symbol': 'DXR',
  },
  {
    symbol: 'DXYN',
    'Security Name': 'The Dixie Group,   ',

    'NASDAQ symbol': 'DXYN',
  },
  {
    symbol: 'DY',
    'Security Name': 'Dycom Industries,  ',

    'CQS symbol': 'DY',
    'NASDAQ symbol': 'DY',
  },
  {
    symbol: 'DYAI',
    'Security Name': 'Dyadic International,   ',

    'NASDAQ symbol': 'DYAI',
  },
  {
    symbol: 'DYFN',
    'Security Name':
      'Angel Oak Dynamic Financial Strategies ome Term Trust Common Shares of Beneficial Interest',

    'CQS symbol': 'DYFN',
    'NASDAQ symbol': 'DYFN',
  },
  {
    symbol: 'DYHG',
    'Security Name': 'Direxion Dynamic Hedge ETF',

    'CQS symbol': 'DYHG',
    'NASDAQ symbol': 'DYHG',
  },
  {
    symbol: 'DYN',
    'Security Name': 'Dyne Therapeutics,   ',

    'NASDAQ symbol': 'DYN',
  },
  {
    symbol: 'DYNF',
    'Security Name': 'BlackRock US Equity Factor Rotation ETF',

    'CQS symbol': 'DYNF',
    'NASDAQ symbol': 'DYNF',
  },
  {
    symbol: 'DYNT',
    'Security Name': 'Dynatronics Corporation  ',

    'NASDAQ symbol': 'DYNT',
  },
  {
    symbol: 'DZSI',
    'Security Name': 'DZS   ',

    'NASDAQ symbol': 'DZSI',
  },
  {
    symbol: 'DZZ',
    'Security Name': 'DB Gold Double Short ETN due February 15, 2038',

    'CQS symbol': 'DZZ',
    'NASDAQ symbol': 'DZZ',
  },
  {
    symbol: 'E',
    'Security Name': 'ENI SpA ',

    'CQS symbol': 'E',
    'NASDAQ symbol': 'E',
  },
  {
    symbol: 'EA',
    'Security Name': 'Electronic Arts   ',

    'NASDAQ symbol': 'EA',
  },
  {
    symbol: 'EAD',
    'Security Name': 'Wells Fargo ome Opportunities Fund Common Shares',

    'CQS symbol': 'EAD',
    'NASDAQ symbol': 'EAD',
  },
  {
    symbol: 'EAF',
    'Security Name': 'GrafTech International Ltd ',

    'CQS symbol': 'EAF',
    'NASDAQ symbol': 'EAF',
  },
  {
    symbol: 'EAGG',
    'Security Name': 'iShares ESG Aware US Aggregate Bond ETF',

    'CQS symbol': 'EAGG',
    'NASDAQ symbol': 'EAGG',
  },
  {
    symbol: 'EAI',
    'Security Name':
      'Entergy Arkansas, LLC First Mortgage Bonds, 4875% Series Due September 1, 2066',

    'CQS symbol': 'EAI',
    'NASDAQ symbol': 'EAI',
  },
  {
    symbol: 'EAOA',
    'Security Name': 'iShares ESG Aware Aggressive Allocation ETF',

    'CQS symbol': 'EAOA',
    'NASDAQ symbol': 'EAOA',
  },
  {
    symbol: 'EAOK',
    'Security Name': 'iShares ESG Aware Conservative Allocation ETF',

    'CQS symbol': 'EAOK',
    'NASDAQ symbol': 'EAOK',
  },
  {
    symbol: 'EAOM',
    'Security Name': 'iShares ESG Aware Moderate Allocation ETF',

    'CQS symbol': 'EAOM',
    'NASDAQ symbol': 'EAOM',
  },
  {
    symbol: 'EAOR',
    'Security Name': 'iShares ESG Aware Growth Allocation ETF',

    'CQS symbol': 'EAOR',
    'NASDAQ symbol': 'EAOR',
  },
  {
    symbol: 'EAR',
    'Security Name': 'Eargo,   ',

    'NASDAQ symbol': 'EAR',
  },
  {
    symbol: 'EARN',
    'Security Name':
      'Ellington Residential Mortgage REIT Common Shares of Beneficial Interest',

    'CQS symbol': 'EARN',
    'NASDAQ symbol': 'EARN',
  },
  {
    symbol: 'EARS',
    'Security Name': 'Auris Medical Holding Ltd  Common Shares',

    'NASDAQ symbol': 'EARS',
  },
  {
    symbol: 'EASG',
    'Security Name': 'Xtrackers MSCI EAFE ESG Leaders Equity ETF',

    'CQS symbol': 'EASG',
    'NASDAQ symbol': 'EASG',
  },
  {
    symbol: 'EAST',
    'Security Name': 'Eastside Distilling,   ',

    'NASDAQ symbol': 'EAST',
  },
  {
    symbol: 'EAT',
    'Security Name': 'Brinker International,  ',

    'CQS symbol': 'EAT',
    'NASDAQ symbol': 'EAT',
  },
  {
    symbol: 'EB',
    'Security Name': 'Eventbrite,   ',

    'CQS symbol': 'EB',
    'NASDAQ symbol': 'EB',
  },
  {
    symbol: 'EBAY',
    'Security Name': 'eBay   ',

    'NASDAQ symbol': 'EBAY',
  },
  {
    symbol: 'EBAYL',
    'Security Name': 'eBay   60% Notes Due 2056',

    'NASDAQ symbol': 'EBAYL',
  },
  {
    symbol: 'EBC',
    'Security Name': 'Eastern Bankshares,   ',

    'NASDAQ symbol': 'EBC',
  },
  {
    symbol: 'EBF',
    'Security Name': 'Ennis,  ',

    'CQS symbol': 'EBF',
    'NASDAQ symbol': 'EBF',
  },
  {
    symbol: 'EBIX',
    'Security Name': 'Ebix,   ',

    'NASDAQ symbol': 'EBIX',
  },
  {
    symbol: 'EBIZ',
    'Security Name': 'Global X Ecommerce ETF',

    'NASDAQ symbol': 'EBIZ',
  },
  {
    symbol: 'EBLU',
    'Security Name': 'Ecofin Global Water ESG Fund',

    'CQS symbol': 'EBLU',
    'NASDAQ symbol': 'EBLU',
  },
  {
    symbol: 'EBMT',
    'Security Name': 'Eagle Bancorp Montana,   ',

    'NASDAQ symbol': 'EBMT',
  },
  {
    symbol: 'EBND',
    'Security Name': 'SPDR Bloomberg Barclays Emerging Markets Local Bond ETF',

    'CQS symbol': 'EBND',
    'NASDAQ symbol': 'EBND',
  },
  {
    symbol: 'EBON',
    'Security Name': 'Ebang International Holdings    Ordinary Shares',

    'NASDAQ symbol': 'EBON',
  },
  {
    symbol: 'EBR',
    'Security Name':
      'Centrais Electricas Brasileiras S A American Depositary Shares (Each representing one Common Share)',

    'CQS symbol': 'EBR',
    'NASDAQ symbol': 'EBR',
  },
  {
    symbol: 'EBRB',
    'Security Name':
      'Centrais Electricas Brasileiras SA Eletrobr?!s American Depositary Shares (Each representing one Preferred Share)',

    'CQS symbol': 'EBRB',
    'NASDAQ symbol': 'EBRB',
  },
  {
    symbol: 'EBS',
    'Security Name': 'Emergent Biosolutions,  ',

    'CQS symbol': 'EBS',
    'NASDAQ symbol': 'EBS',
  },
  {
    symbol: 'EBSB',
    'Security Name': 'Meridian Bancorp,   ',

    'NASDAQ symbol': 'EBSB',
  },
  {
    symbol: 'EBTC',
    'Security Name': 'Enterprise Bancorp   ',

    'NASDAQ symbol': 'EBTC',
  },
  {
    symbol: 'EC',
    'Security Name': 'Ecopetrol SA American Depositary Shares',

    'CQS symbol': 'EC',
    'NASDAQ symbol': 'EC',
  },
  {
    symbol: 'ECC',
    'Security Name': 'Eagle Point Credit Company  ',

    'CQS symbol': 'ECC',
    'NASDAQ symbol': 'ECC',
  },
  {
    symbol: 'ECCB',
    'Security Name':
      'Eagle Point Credit Company  775% Series B Term Preferred Stock due 2026',

    'CQS symbol': 'ECCB',
    'NASDAQ symbol': 'ECCB',
  },
  {
    symbol: 'ECCX',
    'Security Name': 'Eagle Point Credit Company  66875% Notes due 2028',

    'CQS symbol': 'ECCX',
    'NASDAQ symbol': 'ECCX',
  },
  {
    symbol: 'ECCY',
    'Security Name': 'Eagle Point Credit Company  675% Notes due 2027',

    'CQS symbol': 'ECCY',
    'NASDAQ symbol': 'ECCY',
  },
  {
    symbol: 'ECF',
    'Security Name': 'Ellsworth Growth and ome Fund Ltd',

    'CQS symbol': 'ECF',
    'NASDAQ symbol': 'ECF',
  },
  {
    symbol: 'ECF$A',
    'Security Name':
      'Ellsworth Growth and ome Fund Ltd 525% Series A Cumulative Preferred Shares (Liquidation Preference $2500 per share)',

    'CQS symbol': 'ECFpA',
    'NASDAQ symbol': 'ECFA',
  },
  {
    symbol: 'ECH',
    'Security Name': 'iShares  iShares MSCI Chile ETF',

    'CQS symbol': 'ECH',
    'NASDAQ symbol': 'ECH',
  },
  {
    symbol: 'ECHO',
    'Security Name': 'Echo Global Logistics,   ',

    'NASDAQ symbol': 'ECHO',
  },
  {
    symbol: 'ECL',
    'Security Name': 'Ecolab  ',

    'CQS symbol': 'ECL',
    'NASDAQ symbol': 'ECL',
  },
  {
    symbol: 'ECLN',
    'Security Name': 'First Trust EIP Carbon Impact ETF',

    'CQS symbol': 'ECLN',
    'NASDAQ symbol': 'ECLN',
  },
  {
    symbol: 'ECNS',
    'Security Name': 'iShares MSCI China SmallCap ETF',

    'CQS symbol': 'ECNS',
    'NASDAQ symbol': 'ECNS',
  },
  {
    symbol: 'ECOL',
    'Security Name': 'US Ecology,   ',

    'NASDAQ symbol': 'ECOL',
  },
  {
    symbol: 'ECOLW',
    'Security Name': 'US Ecology,   warrant',

    'NASDAQ symbol': 'ECOLW',
  },
  {
    symbol: 'ECOM',
    'Security Name': 'ChannelAdvisor Corporation ',

    'CQS symbol': 'ECOM',
    'NASDAQ symbol': 'ECOM',
  },
  {
    symbol: 'ECON',
    'Security Name': 'Columbia Emerging Markets Consumer ETF',

    'CQS symbol': 'ECON',
    'NASDAQ symbol': 'ECON',
  },
  {
    symbol: 'ECOR',
    'Security Name': 'electroCore,   ',

    'NASDAQ symbol': 'ECOR',
  },
  {
    symbol: 'ECOW',
    'Security Name': 'Pacer Emerging Markets Cash Cows 100 ETF',

    'NASDAQ symbol': 'ECOW',
  },
  {
    symbol: 'ECOZ',
    'Security Name': 'TrueShares ESG Active Opportunities ETF',

    'CQS symbol': 'ECOZ',
    'NASDAQ symbol': 'ECOZ',
  },
  {
    symbol: 'ECPG',
    'Security Name': 'Encore Capital Group   ',

    'NASDAQ symbol': 'ECPG',
  },
  {
    symbol: 'ED',
    'Security Name': 'Consolidated Edison,  ',

    'CQS symbol': 'ED',
    'NASDAQ symbol': 'ED',
  },
  {
    symbol: 'EDAP',
    'Security Name':
      'EDAP TMS SA  American Depositary Shares, each representing One Ordinary Share',

    'NASDAQ symbol': 'EDAP',
  },
  {
    symbol: 'EDC',
    'Security Name': 'Direxion Emerging Markets Bull 3X Shares',

    'CQS symbol': 'EDC',
    'NASDAQ symbol': 'EDC',
  },
  {
    symbol: 'EDD',
    'Security Name':
      'Morgan Stanley Emerging Markets Domestic Debt Fund,  Morgan Stanley Emerging Markets Domestic Debt Fund,  ',

    'CQS symbol': 'EDD',
    'NASDAQ symbol': 'EDD',
  },
  {
    symbol: 'EDEN',
    'Security Name': 'iShares  iShares MSCI Denmark ETF',

    'CQS symbol': 'EDEN',
    'NASDAQ symbol': 'EDEN',
  },
  {
    symbol: 'EDF',
    'Security Name':
      'Stone Harbor Emerging Markets ome Fund Common Shares of Beneficial Interest',

    'CQS symbol': 'EDF',
    'NASDAQ symbol': 'EDF',
  },
  {
    symbol: 'EDI',
    'Security Name':
      'Stone Harbor Emerging Markets Total ome Fund Common Shares of Beneficial Interests',

    'CQS symbol': 'EDI',
    'NASDAQ symbol': 'EDI',
  },
  {
    symbol: 'EDIT',
    'Security Name': 'Editas Medicine,   ',

    'NASDAQ symbol': 'EDIT',
  },
  {
    symbol: 'EDIV',
    'Security Name': 'SPDR S&P Emerging Markets Dividend ETF',

    'CQS symbol': 'EDIV',
    'NASDAQ symbol': 'EDIV',
  },
  {
    symbol: 'EDN',
    'Security Name':
      'Empresa Distribuidora Y Comercializadora Norte SA (Edenor) Empresa Distribuidora Y Comercializadora Norte SA (Edenor) American Depositary Shares',

    'CQS symbol': 'EDN',
    'NASDAQ symbol': 'EDN',
  },
  {
    symbol: 'EDOC',
    'Security Name': 'Global X Telemedicine & Digital Health ETF',

    'NASDAQ symbol': 'EDOC',
  },
  {
    symbol: 'EDOG',
    'Security Name': 'ALPS Emerging Sector Dividend Dogs ETF',

    'CQS symbol': 'EDOG',
    'NASDAQ symbol': 'EDOG',
  },
  {
    symbol: 'EDOW',
    'Security Name': 'First Trust Dow 30 Equal Weight ETF',

    'CQS symbol': 'EDOW',
    'NASDAQ symbol': 'EDOW',
  },
  {
    symbol: 'EDRY',
    'Security Name': 'EuroDry Ltd  Common Shares',

    'NASDAQ symbol': 'EDRY',
  },
  {
    symbol: 'EDSA',
    'Security Name': 'Edesa Biotech,   Common Shares',

    'NASDAQ symbol': 'EDSA',
  },
  {
    symbol: 'EDTK',
    'Security Name':
      'Skillful Craftsman Education Technology Limited  Ordinary Share',

    'NASDAQ symbol': 'EDTK',
  },
  {
    symbol: 'EDU',
    'Security Name':
      'New Oriental Education & Technology Group,  Sponsored ADR representing 1 Ordinary Share (Cayman Islands)',

    'CQS symbol': 'EDU',
    'NASDAQ symbol': 'EDU',
  },
  {
    symbol: 'EDUC',
    'Security Name': 'Educational Development Corporation  ',

    'NASDAQ symbol': 'EDUC',
  },
  {
    symbol: 'EDUT',
    'Security Name': 'Global X Education ETF',

    'NASDAQ symbol': 'EDUT',
  },
  {
    symbol: 'EDV',
    'Security Name': 'Vanguard Extended Duration Treasury ETF',

    'CQS symbol': 'EDV',
    'NASDAQ symbol': 'EDV',
  },
  {
    symbol: 'EDZ',
    'Security Name': 'Direxion Emerging Markets Bear 3X Shares',

    'CQS symbol': 'EDZ',
    'NASDAQ symbol': 'EDZ',
  },
  {
    symbol: 'EEA',
    'Security Name': 'The European Equity Fund,  ',

    'CQS symbol': 'EEA',
    'NASDAQ symbol': 'EEA',
  },
  {
    symbol: 'EEFT',
    'Security Name': 'Euronet Worldwide,   ',

    'NASDAQ symbol': 'EEFT',
  },
  {
    symbol: 'EEH',
    'Security Name':
      'Aktiebolaget Svensk Exportkredit (Swed Ex Cred Corp) Elements (SM) Linked to the SPECTRUM Large Cap US Sector Momentum Index developed by BNP Paribas due August 8, 2022, MediumTerm Notes, Series D',

    'CQS symbol': 'EEH',
    'NASDAQ symbol': 'EEH',
  },
  {
    symbol: 'EELV',
    'Security Name': 'Invesco S&P Emerging Markets Low Volatility ETF',

    'CQS symbol': 'EELV',
    'NASDAQ symbol': 'EELV',
  },
  {
    symbol: 'EEM',
    'Security Name': 'iShares MSCI Emerging Index Fund',

    'CQS symbol': 'EEM',
    'NASDAQ symbol': 'EEM',
  },
  {
    symbol: 'EEMA',
    'Security Name': 'iShares MSCI Emerging Markets Asia ETF',

    'NASDAQ symbol': 'EEMA',
  },
  {
    symbol: 'EEMD',
    'Security Name': 'AAM S&P Emerging Markets High Dividend Value ETF',

    'CQS symbol': 'EEMD',
    'NASDAQ symbol': 'EEMD',
  },
  {
    symbol: 'EEMO',
    'Security Name': 'Invesco S&P Emerging Markets Momentum ETF',

    'CQS symbol': 'EEMO',
    'NASDAQ symbol': 'EEMO',
  },
  {
    symbol: 'EEMS',
    'Security Name': 'Ishares MSCI Emerging Markets Small Cap Index Fund',

    'CQS symbol': 'EEMS',
    'NASDAQ symbol': 'EEMS',
  },
  {
    symbol: 'EEMV',
    'Security Name': 'iShares MSCI Emerging Markets Min Vol Factor ETF',

    'CQS symbol': 'EEMV',
    'NASDAQ symbol': 'EEMV',
  },
  {
    symbol: 'EEMX',
    'Security Name': 'SPDR MSCI Emerging Markets Fuel Reserves Free ETF',

    'CQS symbol': 'EEMX',
    'NASDAQ symbol': 'EEMX',
  },
  {
    symbol: 'EES',
    'Security Name': 'WisdomTree US SmallCap Fund',

    'CQS symbol': 'EES',
    'NASDAQ symbol': 'EES',
  },
  {
    symbol: 'EET',
    'Security Name': 'ProShares Ultra MSCI Emerging Markets',

    'CQS symbol': 'EET',
    'NASDAQ symbol': 'EET',
  },
  {
    symbol: 'EEV',
    'Security Name': 'ProShares UltraShort MSCI Emerging Markets',

    'CQS symbol': 'EEV',
    'NASDAQ symbol': 'EEV',
  },
  {
    symbol: 'EEX',
    'Security Name': 'Emerald Holding,  ',

    'CQS symbol': 'EEX',
    'NASDAQ symbol': 'EEX',
  },
  {
    symbol: 'EFA',
    'Security Name': 'iShares MSCI EAFE ETF',

    'CQS symbol': 'EFA',
    'NASDAQ symbol': 'EFA',
  },
  {
    symbol: 'EFAD',
    'Security Name': 'ProShares Trust ProShares MSCI EAFE Dividend Growers ETF',

    'CQS symbol': 'EFAD',
    'NASDAQ symbol': 'EFAD',
  },
  {
    symbol: 'EFAS',
    'Security Name': 'Global X MSCI SuperDividend EAFE ETF',

    'NASDAQ symbol': 'EFAS',
  },
  {
    symbol: 'EFAV',
    'Security Name': 'iShares MSCI EAFE Min Vol Factor ETF',

    'CQS symbol': 'EFAV',
    'NASDAQ symbol': 'EFAV',
  },
  {
    symbol: 'EFAX',
    'Security Name': 'SPDR MSCI EAFE Fossil Fuel Reserves Free ETF',

    'CQS symbol': 'EFAX',
    'NASDAQ symbol': 'EFAX',
  },
  {
    symbol: 'EFC',
    'Security Name': 'Ellington Financial   ',

    'CQS symbol': 'EFC',
    'NASDAQ symbol': 'EFC',
  },
  {
    symbol: 'EFC$A',
    'Security Name':
      'Ellington Financial  6750% Series A FixedtoFloating Rate Cumulative Redeemable Preferred Stock',

    'CQS symbol': 'EFCpA',
    'NASDAQ symbol': 'EFCA',
  },
  {
    symbol: 'EFF',
    'Security Name':
      'Eaton vance FloatingRate ome Plus Fund Common Shares of Beneficial Interest',

    'CQS symbol': 'EFF',
    'NASDAQ symbol': 'EFF',
  },
  {
    symbol: 'EFG',
    'Security Name': 'iShares MSCI EAFE Growth ETF',

    'CQS symbol': 'EFG',
    'NASDAQ symbol': 'EFG',
  },
  {
    symbol: 'EFIV',
    'Security Name': 'SPDR S&P 500 ESG ETF',

    'CQS symbol': 'EFIV',
    'NASDAQ symbol': 'EFIV',
  },
  {
    symbol: 'EFL',
    'Security Name':
      'Eaton Vance FloatingRate 2022 Target Term Trust Common Shares of Beneficial Interest',

    'CQS symbol': 'EFL',
    'NASDAQ symbol': 'EFL',
  },
  {
    symbol: 'EFNL',
    'Security Name': 'iShares  iShares MSCI Finland ETF',

    'CQS symbol': 'EFNL',
    'NASDAQ symbol': 'EFNL',
  },
  {
    symbol: 'EFO',
    'Security Name': 'ProShares Ultra MSCI EAFE',

    'CQS symbol': 'EFO',
    'NASDAQ symbol': 'EFO',
  },
  {
    symbol: 'EFOI',
    'Security Name': 'Energy Focus,   ',

    'NASDAQ symbol': 'EFOI',
  },
  {
    symbol: 'EFR',
    'Security Name':
      'Eaton Vance Senior FloatingRate Fund Common Shares of Beneficial Interest',

    'CQS symbol': 'EFR',
    'NASDAQ symbol': 'EFR',
  },
  {
    symbol: 'EFSC',
    'Security Name': 'Enterprise Financial Services Corporation  ',

    'NASDAQ symbol': 'EFSC',
  },
  {
    symbol: 'EFT',
    'Security Name':
      'Eaton Vance Floating Rate ome Trust Common Shares of Beneficial Interest',

    'CQS symbol': 'EFT',
    'NASDAQ symbol': 'EFT',
  },
  {
    symbol: 'EFU',
    'Security Name': 'ProShares UltraShort MSCI EAFE',

    'CQS symbol': 'EFU',
    'NASDAQ symbol': 'EFU',
  },
  {
    symbol: 'EFV',
    'Security Name': 'iShares MSCI EAFE Value ETF',

    'CQS symbol': 'EFV',
    'NASDAQ symbol': 'EFV',
  },
  {
    symbol: 'EFX',
    'Security Name': 'Equifax,  ',

    'CQS symbol': 'EFX',
    'NASDAQ symbol': 'EFX',
  },
  {
    symbol: 'EFZ',
    'Security Name': 'ProShares Short MSCI EAFE',

    'CQS symbol': 'EFZ',
    'NASDAQ symbol': 'EFZ',
  },
  {
    symbol: 'EGAN',
    'Security Name': 'eGain Corporation  ',

    'NASDAQ symbol': 'EGAN',
  },
  {
    symbol: 'EGBN',
    'Security Name': 'Eagle Bancorp,   ',

    'NASDAQ symbol': 'EGBN',
  },
  {
    symbol: 'EGF',
    'Security Name': 'Blackrock Enhanced Government Fund,  ',

    'CQS symbol': 'EGF',
    'NASDAQ symbol': 'EGF',
  },
  {
    symbol: 'EGHT',
    'Security Name': '8x8  ',

    'CQS symbol': 'EGHT',
    'NASDAQ symbol': 'EGHT',
  },
  {
    symbol: 'EGIS',
    'Security Name': '2ndVote Society Defended ETF',

    'CQS symbol': 'EGIS',
    'NASDAQ symbol': 'EGIS',
  },
  {
    symbol: 'EGLE',
    'Security Name': 'Eagle Bulk Shipping   ',

    'NASDAQ symbol': 'EGLE',
  },
  {
    symbol: 'EGO',
    'Security Name': 'Eldorado Gold Corporation Ordinary Shares',

    'CQS symbol': 'EGO',
    'NASDAQ symbol': 'EGO',
  },
  {
    symbol: 'EGOV',
    'Security Name': 'NIC   ',

    'NASDAQ symbol': 'EGOV',
  },
  {
    symbol: 'EGP',
    'Security Name': 'EastGroup Properties,  ',

    'CQS symbol': 'EGP',
    'NASDAQ symbol': 'EGP',
  },
  {
    symbol: 'EGPT',
    'Security Name': 'VanEck Vectors Egypt Index ETF',

    'CQS symbol': 'EGPT',
    'NASDAQ symbol': 'EGPT',
  },
  {
    symbol: 'EGRX',
    'Security Name': 'Eagle Pharmaceuticals,   ',

    'NASDAQ symbol': 'EGRX',
  },
  {
    symbol: 'EGY',
    'Security Name': 'VAALCO Energy,   ',

    'CQS symbol': 'EGY',
    'NASDAQ symbol': 'EGY',
  },
  {
    symbol: 'EH',
    'Security Name': 'EHang Holdings Limited  ADS',

    'NASDAQ symbol': 'EH',
  },
  {
    symbol: 'EHC',
    'Security Name': 'Encompass Health Corporation ',

    'CQS symbol': 'EHC',
    'NASDAQ symbol': 'EHC',
  },
  {
    symbol: 'EHI',
    'Security Name': 'Western Asset Global High ome Fund  ',

    'CQS symbol': 'EHI',
    'NASDAQ symbol': 'EHI',
  },
  {
    symbol: 'EHT',
    'Security Name':
      'Eaton Vance High ome 2021 Target Term Trust Common Shares of Beneficial Interest',

    'CQS symbol': 'EHT',
    'NASDAQ symbol': 'EHT',
  },
  {
    symbol: 'EHTH',
    'Security Name': 'eHealth,   ',

    'NASDAQ symbol': 'EHTH',
  },
  {
    symbol: 'EIC',
    'Security Name': 'Eagle Point ome Company  ',

    'CQS symbol': 'EIC',
    'NASDAQ symbol': 'EIC',
  },
  {
    symbol: 'EIDO',
    'Security Name': 'iShares MSCI Indonesia ETF',

    'CQS symbol': 'EIDO',
    'NASDAQ symbol': 'EIDO',
  },
  {
    symbol: 'EIDX',
    'Security Name': 'Eidos Therapeutics,   ',

    'NASDAQ symbol': 'EIDX',
  },
  {
    symbol: 'EIG',
    'Security Name': 'Employers Holdings  ',

    'CQS symbol': 'EIG',
    'NASDAQ symbol': 'EIG',
  },
  {
    symbol: 'EIGI',
    'Security Name': 'Endurance International Group Holdings,   ',

    'NASDAQ symbol': 'EIGI',
  },
  {
    symbol: 'EIGR',
    'Security Name': 'Eiger BioPharmaceuticals,   ',

    'NASDAQ symbol': 'EIGR',
  },
  {
    symbol: 'EIM',
    'Security Name':
      'Eaton Vance Municipal Bond Fund Common Shares of Beneficial Interest, $01 par value',

    'CQS symbol': 'EIM',
    'NASDAQ symbol': 'EIM',
  },
  {
    symbol: 'E',
    'Security Name': 'VanEck Vectors Energy ome ETF',

    'CQS symbol': 'E',
    'NASDAQ symbol': 'E',
  },
  {
    symbol: 'EIRL',
    'Security Name': 'iShares Trust iShares MSCI Ireland ETF',

    'CQS symbol': 'EIRL',
    'NASDAQ symbol': 'EIRL',
  },
  {
    symbol: 'EIS',
    'Security Name': 'iShares  iShares MSCI Israel ETF',

    'CQS symbol': 'EIS',
    'NASDAQ symbol': 'EIS',
  },
  {
    symbol: 'EIX',
    'Security Name': 'Edison International ',

    'CQS symbol': 'EIX',
    'NASDAQ symbol': 'EIX',
  },
  {
    symbol: 'EJAN',
    'Security Name':
      'Innovator ETFs Trust Innovator MSCI Emerging Markets Power Buffer ETF  January',

    'CQS symbol': 'EJAN',
    'NASDAQ symbol': 'EJAN',
  },
  {
    symbol: 'EJUL',
    'Security Name': 'Innovator MSCI Emerging Markets Power Buffer ETF  July',

    'CQS symbol': 'EJUL',
    'NASDAQ symbol': 'EJUL',
  },
  {
    symbol: 'EKAR',
    'Security Name': 'Capital Link NextGen Vehicles & Technology ETF',

    'CQS symbol': 'EKAR',
    'NASDAQ symbol': 'EKAR',
  },
  {
    symbol: 'EKSO',
    'Security Name': 'Ekso Bionics Holdings,   ',

    'NASDAQ symbol': 'EKSO',
  },
  {
    symbol: 'EL',
    'Security Name': 'Estee Lauder Companies,  (The) ',

    'CQS symbol': 'EL',
    'NASDAQ symbol': 'EL',
  },
  {
    symbol: 'ELA',
    'Security Name': 'Envela Corporation ',

    'CQS symbol': 'ELA',
    'NASDAQ symbol': 'ELA',
  },
  {
    symbol: 'ELAN',
    'Security Name': 'Elanco Animal Health orporated ',

    'CQS symbol': 'ELAN',
    'NASDAQ symbol': 'ELAN',
  },
  {
    symbol: 'ELAT',
    'Security Name':
      'Elanco Animal Health orporated 500% Tangible Equity Units',

    'CQS symbol': 'ELAT',
    'NASDAQ symbol': 'ELAT',
  },
  {
    symbol: 'ELC',
    'Security Name':
      'Entergy Louisiana,  Collateral Trust Mortgage Bonds, 4875 % Series due September 1, 2066',

    'CQS symbol': 'ELC',
    'NASDAQ symbol': 'ELC',
  },
  {
    symbol: 'ELD',
    'Security Name': 'WisdomTree Emerging Markets Local Debt Fund',

    'CQS symbol': 'ELD',
    'NASDAQ symbol': 'ELD',
  },
  {
    symbol: 'ELF',
    'Security Name': 'elf Beauty,  ',

    'CQS symbol': 'ELF',
    'NASDAQ symbol': 'ELF',
  },
  {
    symbol: 'ELJ',
    'Security Name':
      'Entergy Louisiana,  First Mortgage Bonds, 525% Series due July 1, 2052',

    'CQS symbol': 'ELJ',
    'NASDAQ symbol': 'ELJ',
  },
  {
    symbol: 'ELLO',
    'Security Name': 'Ellomay Capital Ltd Ordinary Shares (Israel)',

    'CQS symbol': 'ELLO',
    'NASDAQ symbol': 'ELLO',
  },
  {
    symbol: 'ELMD',
    'Security Name': 'Electromed,  ',

    'CQS symbol': 'ELMD',
    'NASDAQ symbol': 'ELMD',
  },
  {
    symbol: 'ELOX',
    'Security Name': 'Eloxx Pharmaceuticals,   ',

    'NASDAQ symbol': 'ELOX',
  },
  {
    symbol: 'ELP',
    'Security Name': 'Companhia Paranaense de Energia (COPEL) ',

    'CQS symbol': 'ELP',
    'NASDAQ symbol': 'ELP',
  },
  {
    symbol: 'ELS',
    'Security Name': 'Equity Lifestyle Properties,  ',

    'CQS symbol': 'ELS',
    'NASDAQ symbol': 'ELS',
  },
  {
    symbol: 'ELSE',
    'Security Name': 'ElectroSensors,   ',

    'NASDAQ symbol': 'ELSE',
  },
  {
    symbol: 'ELTK',
    'Security Name': 'Eltek Ltd  Ordinary Shares',

    'NASDAQ symbol': 'ELTK',
  },
  {
    symbol: 'ELU',
    'Security Name':
      'Entergy Louisiana,  First Mortgage Bonds, 470% Series due June 1, 2063',

    'CQS symbol': 'ELU',
    'NASDAQ symbol': 'ELU',
  },
  {
    symbol: 'ELVT',
    'Security Name': 'Elevate Credit,  ',

    'CQS symbol': 'ELVT',
    'NASDAQ symbol': 'ELVT',
  },
  {
    symbol: 'ELY',
    'Security Name': 'Callaway Golf Company ',

    'CQS symbol': 'ELY',
    'NASDAQ symbol': 'ELY',
  },
  {
    symbol: 'ELYS',
    'Security Name': 'Elys Game Technology, Corp   ',

    'NASDAQ symbol': 'ELYS',
  },
  {
    symbol: 'EMAG',
    'Security Name': 'VanEck Vectors Emerging Markets Aggregate Bond ETF',

    'CQS symbol': 'EMAG',
    'NASDAQ symbol': 'EMAG',
  },
  {
    symbol: 'EMAN',
    'Security Name': 'eMagin Corporation ',

    'CQS symbol': 'EMAN',
    'NASDAQ symbol': 'EMAN',
  },
  {
    symbol: 'EMB',
    'Security Name': 'iShares JP Morgan USD Emerging Markets Bond ETF',

    'NASDAQ symbol': 'EMB',
  },
  {
    symbol: 'EMBD',
    'Security Name': 'Global X Emerging Markets Bond ETF',

    'CQS symbol': 'EMBD',
    'NASDAQ symbol': 'EMBD',
  },
  {
    symbol: 'EMBH',
    'Security Name': 'iShares Interest Rate Hedged Emerging Markets Bond ETF',

    'CQS symbol': 'EMBH',
    'NASDAQ symbol': 'EMBH',
  },
  {
    symbol: 'EMCB',
    'Security Name': 'WisdomTree Emerging Markets Corporate Bond Fund',

    'NASDAQ symbol': 'EMCB',
  },
  {
    symbol: 'EMCF',
    'Security Name': 'Emclaire Financial Corp  ',

    'NASDAQ symbol': 'EMCF',
  },
  {
    symbol: 'EMD',
    'Security Name': 'Western Asset Emerging Markets Debt Fund  ',

    'CQS symbol': 'EMD',
    'NASDAQ symbol': 'EMD',
  },
  {
    symbol: 'EMDV',
    'Security Name': 'ProShares MSCI Emerging Markets Dividend Growers ETF',

    'CQS symbol': 'EMDV',
    'NASDAQ symbol': 'EMDV',
  },
  {
    symbol: 'EME',
    'Security Name': 'EMCOR Group,  ',

    'CQS symbol': 'EME',
    'NASDAQ symbol': 'EME',
  },
  {
    symbol: 'EMF',
    'Security Name': 'Templeton Emerging Markets Fund ',

    'CQS symbol': 'EMF',
    'NASDAQ symbol': 'EMF',
  },
  {
    symbol: 'EMFM',
    'Security Name': 'Global X MSCI Next Emerging & Frontier ETF',

    'CQS symbol': 'EMFM',
    'NASDAQ symbol': 'EMFM',
  },
  {
    symbol: 'EMGF',
    'Security Name': 'iShares MSCI Emerging Markets Multifactor ETF',

    'CQS symbol': 'EMGF',
    'NASDAQ symbol': 'EMGF',
  },
  {
    symbol: 'EMHY',
    'Security Name': 'iShares JP Morgan EM High Yield Bond ETF',

    'CQS symbol': 'EMHY',
    'NASDAQ symbol': 'EMHY',
  },
  {
    symbol: 'EMIF',
    'Security Name': 'iShares S&P Emerging Markets Infrastructure Index Fund',

    'NASDAQ symbol': 'EMIF',
  },
  {
    symbol: 'EMKR',
    'Security Name': 'EMCORE Corporation  ',

    'NASDAQ symbol': 'EMKR',
  },
  {
    symbol: 'EML',
    'Security Name': 'Eastern Company (The)  ',

    'NASDAQ symbol': 'EML',
  },
  {
    symbol: 'EMLC',
    'Security Name': 'VanEck Vectors JP Morgan EM Local Currency Bond ETF',

    'CQS symbol': 'EMLC',
    'NASDAQ symbol': 'EMLC',
  },
  {
    symbol: 'EMLP',
    'Security Name': 'First Trust North American Energy Infrastructure Fund',

    'CQS symbol': 'EMLP',
    'NASDAQ symbol': 'EMLP',
  },
  {
    symbol: 'EMMF',
    'Security Name': 'WisdomTree Emerging Markets Multifactor Fund',

    'CQS symbol': 'EMMF',
    'NASDAQ symbol': 'EMMF',
  },
  {
    symbol: 'EMN',
    'Security Name': 'Eastman Chemical Company ',

    'CQS symbol': 'EMN',
    'NASDAQ symbol': 'EMN',
  },
  {
    symbol: 'EMNT',
    'Security Name':
      'PIMCO Enhanced Short Maturity Active ESG ExchangeTraded Fund',

    'CQS symbol': 'EMNT',
    'NASDAQ symbol': 'EMNT',
  },
  {
    symbol: 'EMO',
    'Security Name': 'ClearBridge Energy Midstream Opportunity Fund  ',

    'CQS symbol': 'EMO',
    'NASDAQ symbol': 'EMO',
  },
  {
    symbol: 'EMP',
    'Security Name':
      'Entergy Mississippi, LLC First Mortgage Bonds, 490% Series Due October 1, 2066',

    'CQS symbol': 'EMP',
    'NASDAQ symbol': 'EMP',
  },
  {
    symbol: 'EMPW',
    'Security Name': 'Empower Ltd  Ordinary Shares',

    'CQS symbol': 'EMPW',
    'NASDAQ symbol': 'EMPW',
  },
  {
    symbol: 'EMPWU',
    'Security Name':
      'Empower Ltd Units, each consisting of one  ordinary share, $00001 par value, and onethird of one redeemable warrant',

    'CQS symbol': 'EMPWU',
    'NASDAQ symbol': 'EMPW=',
  },
  {
    symbol: 'EMPWW',
    'Security Name':
      'Empower Ltd Redeemable Warrants, each whole warrant exercisable for one  ordinary share at an exercise price of $1150',

    'CQS symbol': 'EMPWWS',
    'NASDAQ symbol': 'EMPW+',
  },
  {
    symbol: 'EMQQ',
    'Security Name': 'Emerging Markets Internet and Ecommerce ETF (The)',

    'CQS symbol': 'EMQQ',
    'NASDAQ symbol': 'EMQQ',
  },
  {
    symbol: 'EMR',
    'Security Name': 'Emerson Electric Company ',

    'CQS symbol': 'EMR',
    'NASDAQ symbol': 'EMR',
  },
  {
    symbol: 'EMSG',
    'Security Name': 'Xtrackers MSCI Emerging Markets ESG Leaders Equity ETF',

    'CQS symbol': 'EMSG',
    'NASDAQ symbol': 'EMSG',
  },
  {
    symbol: 'EMSH',
    'Security Name': 'ProShares Short Term USD Emerging Markets Bond ETF',

    'CQS symbol': 'EMSH',
    'NASDAQ symbol': 'EMSH',
  },
  {
    symbol: 'EMTL',
    'Security Name': 'SPDR DoubleLine Emerging Markets Fixed ome ETF',

    'CQS symbol': 'EMTL',
    'NASDAQ symbol': 'EMTL',
  },
  {
    symbol: 'EMTY',
    'Security Name': 'ProShares Decline of the Retail Store ETF',

    'CQS symbol': 'EMTY',
    'NASDAQ symbol': 'EMTY',
  },
  {
    symbol: 'EMX',
    'Security Name': 'EMX Royalty Corporation Common Shares (Canada)',

    'CQS symbol': 'EMX',
    'NASDAQ symbol': 'EMX',
  },
  {
    symbol: 'EMXC',
    'Security Name': 'iShares MSCI Emerging Markets ex China ETF',

    'NASDAQ symbol': 'EMXC',
  },
  {
    symbol: 'EMXF',
    'Security Name': 'iShares ESG Advanced MSCI EM ETF',

    'NASDAQ symbol': 'EMXF',
  },
  {
    symbol: 'ENB',
    'Security Name': 'Enbridge  ',

    'CQS symbol': 'ENB',
    'NASDAQ symbol': 'ENB',
  },
  {
    symbol: 'ENBA',
    'Security Name':
      'Enbridge  6375% FixedtoFloating Rate Subordinated Notes Series 2018B due 2078',

    'CQS symbol': 'ENBA',
    'NASDAQ symbol': 'ENBA',
  },
  {
    symbol: 'ENBL',
    'Security Name':
      'Enable Midstream Partners, LP Common Units representing limited partner interests',

    'CQS symbol': 'ENBL',
    'NASDAQ symbol': 'ENBL',
  },
  {
    symbol: 'ENDP',
    'Security Name': 'Endo International plc  Ordinary Shares',

    'NASDAQ symbol': 'ENDP',
  },
  {
    symbol: 'ENFR',
    'Security Name': 'Alerian Energy Infrastructure ETF',

    'CQS symbol': 'ENFR',
    'NASDAQ symbol': 'ENFR',
  },
  {
    symbol: 'ENG',
    'Security Name': 'ENGlobal Corporation  ',

    'NASDAQ symbol': 'ENG',
  },
  {
    symbol: 'ENIA',
    'Security Name': 'Enel Americas SA American Depositary Shares',

    'CQS symbol': 'ENIA',
    'NASDAQ symbol': 'ENIA',
  },
  {
    symbol: 'ENIC',
    'Security Name':
      'Enel Chile SA American Depositary Shares (Each representing 50 shares of )',

    'CQS symbol': 'ENIC',
    'NASDAQ symbol': 'ENIC',
  },
  {
    symbol: 'ENJ',
    'Security Name':
      'Entergy New Orleans, LLC First Mortgage Bonds, 50% Series due December 1, 2052',

    'CQS symbol': 'ENJ',
    'NASDAQ symbol': 'ENJ',
  },
  {
    symbol: 'ENLC',
    'Security Name':
      'EnLink Midstream, LLC Common Units representing Limited Partner Interests',

    'CQS symbol': 'ENLC',
    'NASDAQ symbol': 'ENLC',
  },
  {
    symbol: 'ENLV',
    'Security Name': 'Enlivex Therapeutics Ltd  Ordinary Shares',

    'NASDAQ symbol': 'ENLV',
  },
  {
    symbol: 'ENO',
    'Security Name':
      'Entergy New Orleans, LLC First Mortgage Bonds, 550% Series due April 1, 2066',

    'CQS symbol': 'ENO',
    'NASDAQ symbol': 'ENO',
  },
  {
    symbol: 'ENOB',
    'Security Name': 'Enochian Biosciences,   ',

    'NASDAQ symbol': 'ENOB',
  },
  {
    symbol: 'ENOR',
    'Security Name': 'iShares  iShares MSCI Norway ETF',

    'CQS symbol': 'ENOR',
    'NASDAQ symbol': 'ENOR',
  },
  {
    symbol: 'ENPC',
    'Security Name': 'Executive Network Partnering Corporation  ',

    'CQS symbol': 'ENPC',
    'NASDAQ symbol': 'ENPC',
  },
  {
    symbol: 'ENPCU',
    'Security Name':
      'Executive Network Partnering Corporation Units, each consisting of one share of  , and onequarter of one redeemable warrant',

    'CQS symbol': 'ENPCU',
    'NASDAQ symbol': 'ENPC=',
  },
  {
    symbol: 'ENPCW',
    'Security Name':
      'Executive Network Partnering Corporation Warrants, each whole warrant exercisable for one share of   at an exercise price of $2875',

    'CQS symbol': 'ENPCWS',
    'NASDAQ symbol': 'ENPC+',
  },
  {
    symbol: 'ENPH',
    'Security Name': 'Enphase Energy,   ',

    'NASDAQ symbol': 'ENPH',
  },
  {
    symbol: 'ENR',
    'Security Name': 'Energizer Holdings,  ',

    'CQS symbol': 'ENR',
    'NASDAQ symbol': 'ENR',
  },
  {
    symbol: 'ENR$A',
    'Security Name':
      'Energizer Holdings,  750% Series A Mandatory Convertible Preferred Stock',

    'CQS symbol': 'ENRpA',
    'NASDAQ symbol': 'ENRA',
  },
  {
    symbol: 'ENS',
    'Security Name': 'EnerSys ',

    'CQS symbol': 'ENS',
    'NASDAQ symbol': 'ENS',
  },
  {
    symbol: 'ENSG',
    'Security Name': 'The Ensign Group,   ',

    'NASDAQ symbol': 'ENSG',
  },
  {
    symbol: 'ENSV',
    'Security Name': 'Enservco Corporation ',

    'CQS symbol': 'ENSV',
    'NASDAQ symbol': 'ENSV',
  },
  {
    symbol: 'ENTA',
    'Security Name': 'Enanta Pharmaceuticals,   ',

    'NASDAQ symbol': 'ENTA',
  },
  {
    symbol: 'ENTG',
    'Security Name': 'Entegris,   ',

    'NASDAQ symbol': 'ENTG',
  },
  {
    symbol: 'ENTR',
    'Security Name': 'ERShares Entrepreneur 30 ETF',

    'CQS symbol': 'ENTR',
    'NASDAQ symbol': 'ENTR',
  },
  {
    symbol: 'ENTX',
    'Security Name': 'Entera Bio Ltd  Ordinary Shares',

    'NASDAQ symbol': 'ENTX',
  },
  {
    symbol: 'ENTXW',
    'Security Name': 'Entera Bio Ltd  Warrant',

    'NASDAQ symbol': 'ENTXW',
  },
  {
    symbol: 'ENV',
    'Security Name': 'Envestnet,  ',

    'CQS symbol': 'ENV',
    'NASDAQ symbol': 'ENV',
  },
  {
    symbol: 'ENVA',
    'Security Name': 'Enova International,  ',

    'CQS symbol': 'ENVA',
    'NASDAQ symbol': 'ENVA',
  },
  {
    symbol: 'ENX',
    'Security Name':
      'Eaton Vance New York Municipal Bond Fund Common Shares of Beneficial Interest, $01 par value',

    'CQS symbol': 'ENX',
    'NASDAQ symbol': 'ENX',
  },
  {
    symbol: 'ENZ',
    'Security Name': 'Enzo Biochem,   ($001 Par Value)',

    'CQS symbol': 'ENZ',
    'NASDAQ symbol': 'ENZ',
  },
  {
    symbol: 'ENZL',
    'Security Name': 'iShares MSCI New Zealand ETF',

    'NASDAQ symbol': 'ENZL',
  },
  {
    symbol: 'EOD',
    'Security Name': 'Wells Fargo Global Dividend Opportunity Fund',

    'CQS symbol': 'EOD',
    'NASDAQ symbol': 'EOD',
  },
  {
    symbol: 'EOG',
    'Security Name': 'EOG Resources,  ',

    'CQS symbol': 'EOG',
    'NASDAQ symbol': 'EOG',
  },
  {
    symbol: 'EOI',
    'Security Name':
      'Eaton Vance Enhance Equity ome Fund Eaton Vance Enhanced Equity ome Fund Shares of Beneficial Interest',

    'CQS symbol': 'EOI',
    'NASDAQ symbol': 'EOI',
  },
  {
    symbol: 'EOLS',
    'Security Name': 'Evolus,   ',

    'NASDAQ symbol': 'EOLS',
  },
  {
    symbol: 'EOS',
    'Security Name': 'Eaton Vance Enhance Equity ome Fund II ',

    'CQS symbol': 'EOS',
    'NASDAQ symbol': 'EOS',
  },
  {
    symbol: 'EOSE',
    'Security Name': 'Eos Energy Enterprises,   ',

    'NASDAQ symbol': 'EOSE',
  },
  {
    symbol: 'EOSEW',
    'Security Name': 'Eos Energy Enterprises,   Warrant',

    'NASDAQ symbol': 'EOSEW',
  },
  {
    symbol: 'EOT',
    'Security Name':
      'Eaton Vance Municipal ome Trust EATON VANCE NATIONAL MUNICIPAL OPPORTUNITIES TRUST',

    'CQS symbol': 'EOT',
    'NASDAQ symbol': 'EOT',
  },
  {
    symbol: 'EP$C',
    'Security Name': 'El Paso Corporation Preferred Stock',

    'CQS symbol': 'EPpC',
    'NASDAQ symbol': 'EPC',
  },
  {
    symbol: 'EPAC',
    'Security Name': 'Enerpac Tool Group Corp ',

    'CQS symbol': 'EPAC',
    'NASDAQ symbol': 'EPAC',
  },
  {
    symbol: 'EPAM',
    'Security Name': 'EPAM Systems,  ',

    'CQS symbol': 'EPAM',
    'NASDAQ symbol': 'EPAM',
  },
  {
    symbol: 'EPAY',
    'Security Name': 'Bottomline Technologies,   ',

    'NASDAQ symbol': 'EPAY',
  },
  {
    symbol: 'EPC',
    'Security Name': 'Edgewell Personal Care Company ',

    'CQS symbol': 'EPC',
    'NASDAQ symbol': 'EPC',
  },
  {
    symbol: 'EPD',
    'Security Name': 'Enterprise Products Partners LP ',

    'CQS symbol': 'EPD',
    'NASDAQ symbol': 'EPD',
  },
  {
    symbol: 'EPHE',
    'Security Name': 'iShares MSCI Philippines ETF',

    'CQS symbol': 'EPHE',
    'NASDAQ symbol': 'EPHE',
  },
  {
    symbol: 'EPI',
    'Security Name': 'WisdomTree India Earnings Fund',

    'CQS symbol': 'EPI',
    'NASDAQ symbol': 'EPI',
  },
  {
    symbol: 'EPIX',
    'Security Name': 'ESSA Pharma   ',

    'NASDAQ symbol': 'EPIX',
  },
  {
    symbol: 'EPM',
    'Security Name': 'Evolution Petroleum Corporation,  ',

    'CQS symbol': 'EPM',
    'NASDAQ symbol': 'EPM',
  },
  {
    symbol: 'EPOL',
    'Security Name': 'iShares Trust iShares MSCI Poland ETF',

    'CQS symbol': 'EPOL',
    'NASDAQ symbol': 'EPOL',
  },
  {
    symbol: 'EPP',
    'Security Name': 'iShares MSCI Pacific ExJapan Index Fund',

    'CQS symbol': 'EPP',
    'NASDAQ symbol': 'EPP',
  },
  {
    symbol: 'EPR',
    'Security Name': 'EPR Properties ',

    'CQS symbol': 'EPR',
    'NASDAQ symbol': 'EPR',
  },
  {
    symbol: 'EPR$C',
    'Security Name':
      'EPR Properties 575% Series C Cumulative Convertible Preferred Shares',

    'CQS symbol': 'EPRpC',
    'NASDAQ symbol': 'EPRC',
  },
  {
    symbol: 'EPR$E',
    'Security Name': 'EPR Properties Series E Cumulative Conv Pfd Shs Ser E',

    'CQS symbol': 'EPRpE',
    'NASDAQ symbol': 'EPRE',
  },
  {
    symbol: 'EPR$G',
    'Security Name':
      'EPR Properties 5750% Series G Cumulative Redeemable Preferred Shares',

    'CQS symbol': 'EPRpG',
    'NASDAQ symbol': 'EPRG',
  },
  {
    symbol: 'EPRF',
    'Security Name': 'Innovator S&P Investment Grade Preferred ETF',

    'CQS symbol': 'EPRF',
    'NASDAQ symbol': 'EPRF',
  },
  {
    symbol: 'EPRT',
    'Security Name': 'Essential Properties Realty Trust,  ',

    'CQS symbol': 'EPRT',
    'NASDAQ symbol': 'EPRT',
  },
  {
    symbol: 'EPS',
    'Security Name': 'WisdomTree US LargeCap Fund',

    'CQS symbol': 'EPS',
    'NASDAQ symbol': 'EPS',
  },
  {
    symbol: 'EPSN',
    'Security Name': 'Epsilon Energy Ltd  Common Shares',

    'NASDAQ symbol': 'EPSN',
  },
  {
    symbol: 'EPU',
    'Security Name': 'iShares Trust iShares MSCI Peru ETF',

    'CQS symbol': 'EPU',
    'NASDAQ symbol': 'EPU',
  },
  {
    symbol: 'EPV',
    'Security Name': 'ProShares UltraShort FTSE Europe ETF',

    'CQS symbol': 'EPV',
    'NASDAQ symbol': 'EPV',
  },
  {
    symbol: 'EPZM',
    'Security Name': 'Epizyme,   ',

    'NASDAQ symbol': 'EPZM',
  },
  {
    symbol: 'EQ',
    'Security Name': 'Equillium,   ',

    'NASDAQ symbol': 'EQ',
  },
  {
    symbol: 'EQAL',
    'Security Name': 'Invesco Russell 1000 Equal Weight ETF',

    'CQS symbol': 'EQAL',
    'NASDAQ symbol': 'EQAL',
  },
  {
    symbol: 'EQBK',
    'Security Name': 'Equity Bancshares,    ',

    'NASDAQ symbol': 'EQBK',
  },
  {
    symbol: 'EQC',
    'Security Name': 'Equity Commonwealth Common Shares of Beneficial Interest',

    'CQS symbol': 'EQC',
    'NASDAQ symbol': 'EQC',
  },
  {
    symbol: 'EQC$D',
    'Security Name': 'Equity Commonwealth 650% Pfd Conv Shs Ser D',

    'CQS symbol': 'EQCpD',
    'NASDAQ symbol': 'EQCD',
  },
  {
    symbol: 'EQD',
    'Security Name': 'Equity Distribution Acquisition Corp  ',

    'CQS symbol': 'EQD',
    'NASDAQ symbol': 'EQD',
  },
  {
    symbol: 'EQDU',
    'Security Name': 'Equity Distribution Acquisition Corp Units',

    'CQS symbol': 'EQDU',
    'NASDAQ symbol': 'EQD=',
  },
  {
    symbol: 'EQDW',
    'Security Name':
      'Equity Distribution Acquisition Corp Warrants, each whole warrant exercisable for one share of   at an exercise price of $1150',

    'CQS symbol': 'EQDWS',
    'NASDAQ symbol': 'EQD+',
  },
  {
    symbol: 'EQH',
    'Security Name': 'Equitable Holdings,  ',

    'CQS symbol': 'EQH',
    'NASDAQ symbol': 'EQH',
  },
  {
    symbol: 'EQH$A',
    'Security Name': 'Equitable Holdings,  Depositary Shares',

    'CQS symbol': 'EQHpA',
    'NASDAQ symbol': 'EQHA',
  },
  {
    symbol: 'EQIX',
    'Security Name': 'Equinix,   ',

    'NASDAQ symbol': 'EQIX',
  },
  {
    symbol: 'EQL',
    'Security Name': 'ALPS Equal Sector Weight ETF',

    'CQS symbol': 'EQL',
    'NASDAQ symbol': 'EQL',
  },
  {
    symbol: 'EQNR',
    'Security Name': 'Equinor ASA',

    'CQS symbol': 'EQNR',
    'NASDAQ symbol': 'EQNR',
  },
  {
    symbol: 'EQOP',
    'Security Name': 'Natixis US Equity Opportunities ETF',

    'CQS symbol': 'EQOP',
    'NASDAQ symbol': 'EQOP',
  },
  {
    symbol: 'EQOS',
    'Security Name': 'Diginex Limited  Ordinary Shares',

    'NASDAQ symbol': 'EQOS',
  },
  {
    symbol: 'EQOSW',
    'Security Name': 'Diginex Limited  Warrant',

    'NASDAQ symbol': 'EQOSW',
  },
  {
    symbol: 'EQR',
    'Security Name': 'Equity Residential Common Shares of Beneficial Interest',

    'CQS symbol': 'EQR',
    'NASDAQ symbol': 'EQR',
  },
  {
    symbol: 'EQRR',
    'Security Name': 'ProShares Equities for Rising Rates ETF',

    'NASDAQ symbol': 'EQRR',
  },
  {
    symbol: 'EQS',
    'Security Name': 'Equus Total Return,  ',

    'CQS symbol': 'EQS',
    'NASDAQ symbol': 'EQS',
  },
  {
    symbol: 'EQT',
    'Security Name': 'EQT Corporation ',

    'CQS symbol': 'EQT',
    'NASDAQ symbol': 'EQT',
  },
  {
    symbol: 'EQWL',
    'Security Name': 'Invesco S&P 100 Equal Weight ETF',

    'CQS symbol': 'EQWL',
    'NASDAQ symbol': 'EQWL',
  },
  {
    symbol: 'EQX',
    'Security Name': 'Equinox Gold Corp Common Shares',

    'CQS symbol': 'EQX',
    'NASDAQ symbol': 'EQX',
  },
  {
    symbol: 'ERC',
    'Security Name': 'Wells Fargo MultiSector ome Fund , no par value',

    'CQS symbol': 'ERC',
    'NASDAQ symbol': 'ERC',
  },
  {
    symbol: 'ERES',
    'Security Name': 'East Resources Acquisition Company   ',

    'NASDAQ symbol': 'ERES',
  },
  {
    symbol: 'ERESU',
    'Security Name': 'East Resources Acquisition Company  Unit',

    'NASDAQ symbol': 'ERESU',
  },
  {
    symbol: 'ERESW',
    'Security Name': 'East Resources Acquisition Company  Warrant',

    'NASDAQ symbol': 'ERESW',
  },
  {
    symbol: 'ERF',
    'Security Name': 'Enerplus Corporation ',

    'CQS symbol': 'ERF',
    'NASDAQ symbol': 'ERF',
  },
  {
    symbol: 'ERH',
    'Security Name': 'Wells Fargo Utilities and High ome Fund',

    'CQS symbol': 'ERH',
    'NASDAQ symbol': 'ERH',
  },
  {
    symbol: 'ERIC',
    'Security Name':
      'Ericsson  American Depositary Shares each representing 1 underlying Class B share',

    'NASDAQ symbol': 'ERIC',
  },
  {
    symbol: 'ERIE',
    'Security Name': 'Erie Indemnity Company   ',

    'NASDAQ symbol': 'ERIE',
  },
  {
    symbol: 'ERII',
    'Security Name': 'Energy Recovery,   ',

    'NASDAQ symbol': 'ERII',
  },
  {
    symbol: 'ERJ',
    'Security Name': 'Embraer SA ',

    'CQS symbol': 'ERJ',
    'NASDAQ symbol': 'ERJ',
  },
  {
    symbol: 'ERM',
    'Security Name': 'EquityCompass Risk Manager ETF',

    'CQS symbol': 'ERM',
    'NASDAQ symbol': 'ERM',
  },
  {
    symbol: 'ERSX',
    'Security Name': 'ERShares NonUS Small Cap ETF',

    'CQS symbol': 'ERSX',
    'NASDAQ symbol': 'ERSX',
  },
  {
    symbol: 'ERUS',
    'Security Name': 'iShares MSCI iShares MSCI Russia ETF ',

    'CQS symbol': 'ERUS',
    'NASDAQ symbol': 'ERUS',
  },
  {
    symbol: 'ERX',
    'Security Name': 'Direxion Energy Bull 2X Shares',

    'CQS symbol': 'ERX',
    'NASDAQ symbol': 'ERX',
  },
  {
    symbol: 'ERY',
    'Security Name': 'Direxion Daily Energy Bear 2X Shares',

    'CQS symbol': 'ERY',
    'NASDAQ symbol': 'ERY',
  },
  {
    symbol: 'ERYP',
    'Security Name': 'Erytech Pharma SA  American Depositary Shares',

    'NASDAQ symbol': 'ERYP',
  },
  {
    symbol: 'ES',
    'Security Name': 'Eversource Energy (D/B/A) ',

    'CQS symbol': 'ES',
    'NASDAQ symbol': 'ES',
  },
  {
    symbol: 'ESBA',
    'Security Name':
      'Empire State Realty OP, LP Series ES Operating Partnership Units Representing Limited Partnership Interests',

    'CQS symbol': 'ESBA',
    'NASDAQ symbol': 'ESBA',
  },
  {
    symbol: 'ESBK',
    'Security Name': 'Elmira Savings Bank NY (The)  ',

    'NASDAQ symbol': 'ESBK',
  },
  {
    symbol: 'ESCA',
    'Security Name': 'Escalade, orporated  ',

    'NASDAQ symbol': 'ESCA',
  },
  {
    symbol: 'ESCR',
    'Security Name':
      'Xtrackers Bloomberg Barclays US Investment Grade Corporate ESG ETF',

    'CQS symbol': 'ESCR',
    'NASDAQ symbol': 'ESCR',
  },
  {
    symbol: 'ESE',
    'Security Name': 'ESCO Technologies  ',

    'CQS symbol': 'ESE',
    'NASDAQ symbol': 'ESE',
  },
  {
    symbol: 'ESEA',
    'Security Name': 'Euroseas Ltd  ',

    'NASDAQ symbol': 'ESEA',
  },
  {
    symbol: 'ESEB',
    'Security Name': 'Xtrackers JP Morgan ESG Emerging Markets Sovereign ETF',

    'CQS symbol': 'ESEB',
    'NASDAQ symbol': 'ESEB',
  },
  {
    symbol: 'ESG',
    'Security Name':
      'FlexShares Trust FlexShares STOXX US ESG Impact Index Fund',

    'CQS symbol': 'ESG',
    'NASDAQ symbol': 'ESG',
  },
  {
    symbol: 'ESGA',
    'Security Name': 'American Century Sustainable Equity ETF',

    'CQS symbol': 'ESGA',
    'NASDAQ symbol': 'ESGA',
  },
  {
    symbol: 'ESGC',
    'Security Name': 'Eros STX Global Corporation A Ordinary Shares',

    'CQS symbol': 'ESGC',
    'NASDAQ symbol': 'ESGC',
  },
  {
    symbol: 'ESGD',
    'Security Name': 'iShares ESG Aware MSCI EAFE ETF',

    'NASDAQ symbol': 'ESGD',
  },
  {
    symbol: 'ESGE',
    'Security Name': 'iShares ESG Aware MSCI EM ETF',

    'NASDAQ symbol': 'ESGE',
  },
  {
    symbol: 'ESGG',
    'Security Name':
      'FlexShares Trust FlexShares STOXX Global ESG Impact Index Fund',

    'CQS symbol': 'ESGG',
    'NASDAQ symbol': 'ESGG',
  },
  {
    symbol: 'ESGN',
    'Security Name': 'Columbia Sustainable International Equity ome ETF',

    'CQS symbol': 'ESGN',
    'NASDAQ symbol': 'ESGN',
  },
  {
    symbol: 'ESGR',
    'Security Name': 'Enstar Group Limited  Ordinary Shares',

    'NASDAQ symbol': 'ESGR',
  },
  {
    symbol: 'ESGRO',
    'Security Name':
      'Enstar Group Limited   700% Perpetual NonCumulative Preference Shares, Series E',

    'NASDAQ symbol': 'ESGRO',
  },
  {
    symbol: 'ESGRP',
    'Security Name':
      'Enstar Group Limited  Depositary Shares Each Representing 1/1000th of an interest in Preference Shares',

    'NASDAQ symbol': 'ESGRP',
  },
  {
    symbol: 'ESGS',
    'Security Name': 'Columbia Sustainable US Equity ome ETF',

    'CQS symbol': 'ESGS',
    'NASDAQ symbol': 'ESGS',
  },
  {
    symbol: 'ESGU',
    'Security Name': 'iShares ESG Aware MSCI USA ETF',

    'NASDAQ symbol': 'ESGU',
  },
  {
    symbol: 'ESGV',
    'Security Name': 'Vanguard ESG US Stock ETF',

    'CQS symbol': 'ESGV',
    'NASDAQ symbol': 'ESGV',
  },
  {
    symbol: 'ESHY',
    'Security Name':
      'Xtrackers JP Morgan ESG USD High Yield Corporate Bond ETF',

    'CQS symbol': 'ESHY',
    'NASDAQ symbol': 'ESHY',
  },
  {
    symbol: 'ESI',
    'Security Name': 'Element Solutions  ',

    'CQS symbol': 'ESI',
    'NASDAQ symbol': 'ESI',
  },
  {
    symbol: 'ESLT',
    'Security Name': 'Elbit Systems Ltd  Ordinary Shares',

    'NASDAQ symbol': 'ESLT',
  },
  {
    symbol: 'ESML',
    'Security Name': 'iShares ESG Aware MSCI USA SmallCap ETF',

    'CQS symbol': 'ESML',
    'NASDAQ symbol': 'ESML',
  },
  {
    symbol: 'ESNG',
    'Security Name': 'Direxion MSCI USA ESG  Leaders vs Laggards ETF',

    'CQS symbol': 'ESNG',
    'NASDAQ symbol': 'ESNG',
  },
  {
    symbol: 'ESNT',
    'Security Name': 'Essent Group Ltd Common Shares',

    'CQS symbol': 'ESNT',
    'NASDAQ symbol': 'ESNT',
  },
  {
    symbol: 'ESP',
    'Security Name': 'Espey Mfg & Electronics Corp ',

    'CQS symbol': 'ESP',
    'NASDAQ symbol': 'ESP',
  },
  {
    symbol: 'ESPO',
    'Security Name': 'VanEck Vectors Video Gaming and eSports ETF',

    'NASDAQ symbol': 'ESPO',
  },
  {
    symbol: 'ESPR',
    'Security Name': 'Esperion Therapeutics,   ',

    'NASDAQ symbol': 'ESPR',
  },
  {
    symbol: 'ESQ',
    'Security Name': 'Esquire Financial Holdings,   ',

    'NASDAQ symbol': 'ESQ',
  },
  {
    symbol: 'ESRT',
    'Security Name': 'Empire State Realty Trust,   ',

    'CQS symbol': 'ESRT',
    'NASDAQ symbol': 'ESRT',
  },
  {
    symbol: 'ESS',
    'Security Name': 'Essex Property Trust,  ',

    'CQS symbol': 'ESS',
    'NASDAQ symbol': 'ESS',
  },
  {
    symbol: 'ESSA',
    'Security Name': 'ESSA Bancorp,   ',

    'NASDAQ symbol': 'ESSA',
  },
  {
    symbol: 'ESSC',
    'Security Name': 'East Stone Acquisition Corporation  Ordinary Shares',

    'NASDAQ symbol': 'ESSC',
  },
  {
    symbol: 'ESSCR',
    'Security Name': 'East Stone Acquisition Corporation  Right',

    'NASDAQ symbol': 'ESSCR',
  },
  {
    symbol: 'ESSCU',
    'Security Name': 'East Stone Acquisition Corporation  Unit',

    'NASDAQ symbol': 'ESSCU',
  },
  {
    symbol: 'ESSCW',
    'Security Name': 'East Stone Acquisition Corporation  Warrant',

    'NASDAQ symbol': 'ESSCW',
  },
  {
    symbol: 'ESTA',
    'Security Name': 'Establishment Labs Holdings   Common Shares',

    'NASDAQ symbol': 'ESTA',
  },
  {
    symbol: 'ESTC',
    'Security Name': 'Elastic NV Ordinary Shares',

    'CQS symbol': 'ESTC',
    'NASDAQ symbol': 'ESTC',
  },
  {
    symbol: 'ESTE',
    'Security Name': 'Earthstone Energy,   ',

    'CQS symbol': 'ESTE',
    'NASDAQ symbol': 'ESTE',
  },
  {
    symbol: 'ESXB',
    'Security Name': 'Community Bankers Trust Corporation  ',

    'NASDAQ symbol': 'ESXB',
  },
  {
    symbol: 'ET',
    'Security Name': 'Energy Transfer LP Common Units ',

    'CQS symbol': 'ET',
    'NASDAQ symbol': 'ET',
  },
  {
    symbol: 'ETAC',
    'Security Name': 'EMerge Technology Acquisition Corp   ',

    'NASDAQ symbol': 'ETAC',
  },
  {
    symbol: 'ETACU',
    'Security Name': 'EMerge Technology Acquisition Corp  Unit',

    'NASDAQ symbol': 'ETACU',
  },
  {
    symbol: 'ETACW',
    'Security Name': 'EMerge Technology Acquisition Corp  Warrant',

    'NASDAQ symbol': 'ETACW',
  },
  {
    symbol: 'ETB',
    'Security Name':
      'Eaton Vance TaxManaged BuyWrite ome Fund Eaton Vance TaxManaged BuyWrite ome Fund Common Shares of Beneficial Interest',

    'CQS symbol': 'ETB',
    'NASDAQ symbol': 'ETB',
  },
  {
    symbol: 'ETG',
    'Security Name':
      'Eaton Vance TaxAdvantaged Global Dividend ome Fund Common Shares of Beneficial Interest',

    'CQS symbol': 'ETG',
    'NASDAQ symbol': 'ETG',
  },
  {
    symbol: 'ETH',
    'Security Name': 'Ethan Allen Interiors  ',

    'CQS symbol': 'ETH',
    'NASDAQ symbol': 'ETH',
  },
  {
    symbol: 'ETHO',
    'Security Name': 'Etho Climate Leadership US ETF',

    'CQS symbol': 'ETHO',
    'NASDAQ symbol': 'ETHO',
  },
  {
    symbol: 'ETI$',
    'Security Name':
      'Entergy Texas  5375% Series A Preferred Stock, Cumulative, No Par Value',

    'CQS symbol': 'ETIp',
    'NASDAQ symbol': 'ETI',
  },
  {
    symbol: 'ETJ',
    'Security Name':
      'Eaton Vance RiskManaged Diversified Equity ome Fund Common Shares of Beneficial Interest',

    'CQS symbol': 'ETJ',
    'NASDAQ symbol': 'ETJ',
  },
  {
    symbol: 'ETM',
    'Security Name': 'Entercom Communications Corp ',

    'CQS symbol': 'ETM',
    'NASDAQ symbol': 'ETM',
  },
  {
    symbol: 'ETN',
    'Security Name': 'Eaton Corporation, PLC Ordinary Shares',

    'CQS symbol': 'ETN',
    'NASDAQ symbol': 'ETN',
  },
  {
    symbol: 'ETNB',
    'Security Name': '89bio,   ',

    'NASDAQ symbol': 'ETNB',
  },
  {
    symbol: 'ETO',
    'Security Name': 'Eaton Vance TaxAdvantage Global Dividend Opp ',

    'CQS symbol': 'ETO',
    'NASDAQ symbol': 'ETO',
  },
  {
    symbol: 'ETON',
    'Security Name': 'Eton Pharmaceuticals,   ',

    'NASDAQ symbol': 'ETON',
  },
  {
    symbol: 'ETP$C',
    'Security Name':
      'Energy Transfer Operating LP Series C FixedtoFloating Rate Cumulative Redeemable Perpetual Preferred Units',

    'CQS symbol': 'ETPpC',
    'NASDAQ symbol': 'ETPC',
  },
  {
    symbol: 'ETP$D',
    'Security Name':
      'Energy Transfer Operating LP 7625% Series D FixedtoFloating Rate Cumulative Redeemable Perpetual Preferred Units',

    'CQS symbol': 'ETPpD',
    'NASDAQ symbol': 'ETPD',
  },
  {
    symbol: 'ETP$E',
    'Security Name':
      'Energy Transfer Operating, LP Series E FixedtoFloating Rate Cumulative Redeemable Perpetual Preferred Units',

    'CQS symbol': 'ETPpE',
    'NASDAQ symbol': 'ETPE',
  },
  {
    symbol: 'ETR',
    'Security Name': 'Entergy Corporation ',

    'CQS symbol': 'ETR',
    'NASDAQ symbol': 'ETR',
  },
  {
    symbol: 'ETRN',
    'Security Name': 'Equitrans Midstream Corporation  ',

    'CQS symbol': 'ETRN',
    'NASDAQ symbol': 'ETRN',
  },
  {
    symbol: 'ETSY',
    'Security Name': 'Etsy,   ',

    'NASDAQ symbol': 'ETSY',
  },
  {
    symbol: 'ETTX',
    'Security Name': 'Entasis Therapeutics Holdings   ',

    'NASDAQ symbol': 'ETTX',
  },
  {
    symbol: 'ETV',
    'Security Name':
      'Eaton Vance Corporation Eaton Vance TaxManaged BuyWrite Opportunities Fund Common Shares of Beneficial Interest',

    'CQS symbol': 'ETV',
    'NASDAQ symbol': 'ETV',
  },
  {
    symbol: 'ETW',
    'Security Name':
      'Eaton Vance Corporation Eaton Vance TaxManaged Global BuyWrite Opportunites Fund Common Shares of Beneficial Interest',

    'CQS symbol': 'ETW',
    'NASDAQ symbol': 'ETW',
  },
  {
    symbol: 'ETX',
    'Security Name':
      'Eaton Vance Municipal ome 2028 Term Trust Common Shares of Beneficial Interest',

    'CQS symbol': 'ETX',
    'NASDAQ symbol': 'ETX',
  },
  {
    symbol: 'ETY',
    'Security Name':
      'Eaton Vance TaxManaged Diversified Equity ome Fund Common Shares of Beneficial Interest,',

    'CQS symbol': 'ETY',
    'NASDAQ symbol': 'ETY',
  },
  {
    symbol: 'EUCRU',
    'Security Name': 'Eucrates Biomedical Acquisition Corp  Unit',

    'NASDAQ symbol': 'EUCRU',
  },
  {
    symbol: 'EUDG',
    'Security Name': 'WisdomTree Europe Quality Dividend Growth Fund',

    'CQS symbol': 'EUDG',
    'NASDAQ symbol': 'EUDG',
  },
  {
    symbol: 'EUDV',
    'Security Name': 'ProShares MSCI Europe Dividend Growers ETF',

    'CQS symbol': 'EUDV',
    'NASDAQ symbol': 'EUDV',
  },
  {
    symbol: 'EUFN',
    'Security Name': 'iShares MSCI Europe Financials Sector Index Fund',

    'NASDAQ symbol': 'EUFN',
  },
  {
    symbol: 'EUFX',
    'Security Name': 'ProShares Short Euro',

    'CQS symbol': 'EUFX',
    'NASDAQ symbol': 'EUFX',
  },
  {
    symbol: 'EUM',
    'Security Name': 'ProShares Short MSCI Emerging Markets',

    'CQS symbol': 'EUM',
    'NASDAQ symbol': 'EUM',
  },
  {
    symbol: 'EUO',
    'Security Name': 'ProShares UltraShort Euro',

    'CQS symbol': 'EUO',
    'NASDAQ symbol': 'EUO',
  },
  {
    symbol: 'EURL',
    'Security Name': 'Direxion Daily FTSE Europe Bull 3x Shares',

    'CQS symbol': 'EURL',
    'NASDAQ symbol': 'EURL',
  },
  {
    symbol: 'EURN',
    'Security Name': 'Euronav NV Ordinary Shares',

    'CQS symbol': 'EURN',
    'NASDAQ symbol': 'EURN',
  },
  {
    symbol: 'EURZ',
    'Security Name': 'Xtrackers Eurozone Equity ETF',

    'CQS symbol': 'EURZ',
    'NASDAQ symbol': 'EURZ',
  },
  {
    symbol: 'EUSA',
    'Security Name': 'iShares MSCI USA Equal Weighted ETF',

    'CQS symbol': 'EUSA',
    'NASDAQ symbol': 'EUSA',
  },
  {
    symbol: 'EUSB',
    'Security Name': 'iShares ESG Advanced Total USD Bond Market ETF',

    'CQS symbol': 'EUSB',
    'NASDAQ symbol': 'EUSB',
  },
  {
    symbol: 'EUSC',
    'Security Name': 'WisdomTree Europe Hedged SmallCap Equity Fund',

    'CQS symbol': 'EUSC',
    'NASDAQ symbol': 'EUSC',
  },
  {
    symbol: 'EV',
    'Security Name': 'Eaton Vance Corporation ',

    'CQS symbol': 'EV',
    'NASDAQ symbol': 'EV',
  },
  {
    symbol: 'EVA',
    'Security Name':
      'Enviva Partners, LP Common units representing limited partner interests',

    'CQS symbol': 'EVA',
    'NASDAQ symbol': 'EVA',
  },
  {
    symbol: 'EVBG',
    'Security Name': 'Everbridge,   ',

    'NASDAQ symbol': 'EVBG',
  },
  {
    symbol: 'EVBN',
    'Security Name': 'Evans Bancorp,  ',

    'CQS symbol': 'EVBN',
    'NASDAQ symbol': 'EVBN',
  },
  {
    symbol: 'EVC',
    'Security Name': 'Entravision Communications Corporation ',

    'CQS symbol': 'EVC',
    'NASDAQ symbol': 'EVC',
  },
  {
    symbol: 'EVER',
    'Security Name': 'EverQuote,    ',

    'NASDAQ symbol': 'EVER',
  },
  {
    symbol: 'EVF',
    'Security Name': 'Eaton Vance Senior ome Trust ',

    'CQS symbol': 'EVF',
    'NASDAQ symbol': 'EVF',
  },
  {
    symbol: 'EVFM',
    'Security Name': 'Evofem Biosciences,   ',

    'NASDAQ symbol': 'EVFM',
  },
  {
    symbol: 'EVG',
    'Security Name':
      'Eaton Vance Short Diversified ome Fund Eaton Vance Short Duration Diversified ome Fund Common Shares of Beneficial Interest',

    'CQS symbol': 'EVG',
    'NASDAQ symbol': 'EVG',
  },
  {
    symbol: 'EVGBC',
    'Security Name': 'Eaton Vance Global ome Builder NextShares',

    'NASDAQ symbol': 'EVGBC',
    NextShares: 'Y',
  },
  {
    symbol: 'EVGN',
    'Security Name': 'Evogene Ltd  Ordinary Shares',

    'NASDAQ symbol': 'EVGN',
  },
  {
    symbol: 'EVH',
    'Security Name': 'Evolent Health,   ',

    'CQS symbol': 'EVH',
    'NASDAQ symbol': 'EVH',
  },
  {
    symbol: 'EVI',
    'Security Name': 'EVI Industries,   ',

    'CQS symbol': 'EVI',
    'NASDAQ symbol': 'EVI',
  },
  {
    symbol: 'EVK',
    'Security Name': 'EverGlory International Group,   ',

    'NASDAQ symbol': 'EVK',
  },
  {
    symbol: 'EVLMC',
    'Security Name':
      'Eaton Vance TABS 5to15 Year Laddered Municipal Bond NextShares',

    'NASDAQ symbol': 'EVLMC',
    NextShares: 'Y',
  },
  {
    symbol: 'EVLO',
    'Security Name': 'Evelo Biosciences,   ',

    'NASDAQ symbol': 'EVLO',
  },
  {
    symbol: 'EVM',
    'Security Name':
      'Eaton Vance California Municipal Bond Fund Common Shares of Beneficial Interest, $01 par value',

    'CQS symbol': 'EVM',
    'NASDAQ symbol': 'EVM',
  },
  {
    symbol: 'EVN',
    'Security Name': 'Eaton Vance Municipal ome Trust ',

    'CQS symbol': 'EVN',
    'NASDAQ symbol': 'EVN',
  },
  {
    symbol: 'EVOK',
    'Security Name': 'Evoke Pharma,   ',

    'NASDAQ symbol': 'EVOK',
  },
  {
    symbol: 'EVOL',
    'Security Name': 'Evolving Systems,   ',

    'NASDAQ symbol': 'EVOL',
  },
  {
    symbol: 'EVOP',
    'Security Name': 'EVO Payments,    ',

    'NASDAQ symbol': 'EVOP',
  },
  {
    symbol: 'EVR',
    'Security Name': 'Evercore   ',

    'CQS symbol': 'EVR',
    'NASDAQ symbol': 'EVR',
  },
  {
    symbol: 'EVRG',
    'Security Name': 'Evergy,  ',

    'CQS symbol': 'EVRG',
    'NASDAQ symbol': 'EVRG',
  },
  {
    symbol: 'EVRI',
    'Security Name': 'Everi Holdings  ',

    'CQS symbol': 'EVRI',
    'NASDAQ symbol': 'EVRI',
  },
  {
    symbol: 'EVSTC',
    'Security Name': 'Eaton Vance Stock NextShares',

    'NASDAQ symbol': 'EVSTC',
    NextShares: 'Y',
  },
  {
    symbol: 'EVT',
    'Security Name':
      'Eaton Vance Tax Advantaged Dividend ome Fund Common Shares of Beneficial Interest',

    'CQS symbol': 'EVT',
    'NASDAQ symbol': 'EVT',
  },
  {
    symbol: 'EVTC',
    'Security Name': 'Evertec,  ',

    'CQS symbol': 'EVTC',
    'NASDAQ symbol': 'EVTC',
  },
  {
    symbol: 'EVV',
    'Security Name':
      'Eaton Vance Limited Duration ome Fund Common Shares of Beneficial Interest',

    'CQS symbol': 'EVV',
    'NASDAQ symbol': 'EVV',
  },
  {
    symbol: 'EVX',
    'Security Name': 'VanEck Vectors Environmental Services ETF',

    'CQS symbol': 'EVX',
    'NASDAQ symbol': 'EVX',
  },
  {
    symbol: 'EVY',
    'Security Name':
      'Eaton Vance New York Municipal ome Trust Shares of Beneficial Interest',

    'CQS symbol': 'EVY',
    'NASDAQ symbol': 'EVY',
  },
  {
    symbol: 'EW',
    'Security Name': 'Edwards Lifesciences Corporation ',

    'CQS symbol': 'EW',
    'NASDAQ symbol': 'EW',
  },
  {
    symbol: 'EWA',
    'Security Name': 'iShares MSCI Australia Index Fund',

    'CQS symbol': 'EWA',
    'NASDAQ symbol': 'EWA',
  },
  {
    symbol: 'EWBC',
    'Security Name': 'East West Bancorp,   ',

    'NASDAQ symbol': 'EWBC',
  },
  {
    symbol: 'EWC',
    'Security Name': 'iShares MSCI Canada Index Fund',

    'CQS symbol': 'EWC',
    'NASDAQ symbol': 'EWC',
  },
  {
    symbol: 'EWCO',
    'Security Name': 'Invesco S&P 500 Equal Weight Communication Services ETF',

    'CQS symbol': 'EWCO',
    'NASDAQ symbol': 'EWCO',
  },
  {
    symbol: 'EWD',
    'Security Name': 'iShares  iShares MSCI Sweden ETF',

    'CQS symbol': 'EWD',
    'NASDAQ symbol': 'EWD',
  },
  {
    symbol: 'EWEB',
    'Security Name': 'Global X Emerging Markets Internet & Ecommerce ETF',

    'NASDAQ symbol': 'EWEB',
  },
  {
    symbol: 'EWG',
    'Security Name': 'iShares MSCI Germany Index Fund',

    'CQS symbol': 'EWG',
    'NASDAQ symbol': 'EWG',
  },
  {
    symbol: 'EWGS',
    'Security Name': 'Ishares MSCI Germany Small Cap ETF',

    'CQS symbol': 'EWGS',
    'NASDAQ symbol': 'EWGS',
  },
  {
    symbol: 'EWH',
    'Security Name': 'iShares MSCI Hong Kong Index Fund',

    'CQS symbol': 'EWH',
    'NASDAQ symbol': 'EWH',
  },
  {
    symbol: 'EWI',
    'Security Name': 'iShares  iShares MSCI Italy ETF',

    'CQS symbol': 'EWI',
    'NASDAQ symbol': 'EWI',
  },
  {
    symbol: 'EWJ',
    'Security Name': 'iShares MSCI Japan Index Fund',

    'CQS symbol': 'EWJ',
    'NASDAQ symbol': 'EWJ',
  },
  {
    symbol: 'EWJE',
    'Security Name': 'iShares MSCI Japan Equal Weighted ETF',

    'NASDAQ symbol': 'EWJE',
  },
  {
    symbol: 'EWJV',
    'Security Name': 'iShares MSCI Japan Value ETF',

    'NASDAQ symbol': 'EWJV',
  },
  {
    symbol: 'EWK',
    'Security Name': 'iShares  iShares MSCI Belgium ETF',

    'CQS symbol': 'EWK',
    'NASDAQ symbol': 'EWK',
  },
  {
    symbol: 'EWL',
    'Security Name': 'iShares  iShares MSCI Switzerland ETF',

    'CQS symbol': 'EWL',
    'NASDAQ symbol': 'EWL',
  },
  {
    symbol: 'EWM',
    'Security Name': 'iShares MSCI Malaysia Index Fund',

    'CQS symbol': 'EWM',
    'NASDAQ symbol': 'EWM',
  },
  {
    symbol: 'EWMC',
    'Security Name': 'Invesco S&P MidCap 400 Equal Weight ETF',

    'CQS symbol': 'EWMC',
    'NASDAQ symbol': 'EWMC',
  },
  {
    symbol: 'EWN',
    'Security Name': 'iShares MSCI Netherlands Index Fund',

    'CQS symbol': 'EWN',
    'NASDAQ symbol': 'EWN',
  },
  {
    symbol: 'EWO',
    'Security Name': 'iShares  iShares MSCI Austria ETF',

    'CQS symbol': 'EWO',
    'NASDAQ symbol': 'EWO',
  },
  {
    symbol: 'EWP',
    'Security Name': 'iShares  iShares MSCI Spain ETF',

    'CQS symbol': 'EWP',
    'NASDAQ symbol': 'EWP',
  },
  {
    symbol: 'EWQ',
    'Security Name': 'iShares MSCI France Index Fund',

    'CQS symbol': 'EWQ',
    'NASDAQ symbol': 'EWQ',
  },
  {
    symbol: 'EWRE',
    'Security Name': 'Invesco S&P 500 Equal Weight Real Estate ETF',

    'CQS symbol': 'EWRE',
    'NASDAQ symbol': 'EWRE',
  },
  {
    symbol: 'EWS',
    'Security Name': 'iShares  iShares MSCI Singapore ETF',

    'CQS symbol': 'EWS',
    'NASDAQ symbol': 'EWS',
  },
  {
    symbol: 'EWSC',
    'Security Name': 'Invesco S&P SmallCap 600 Equal Weight ETF',

    'CQS symbol': 'EWSC',
    'NASDAQ symbol': 'EWSC',
  },
  {
    symbol: 'EWT',
    'Security Name': 'iShares  iShares MSCI Taiwan ETF',

    'CQS symbol': 'EWT',
    'NASDAQ symbol': 'EWT',
  },
  {
    symbol: 'EWU',
    'Security Name': 'iShares MSCI United Kingdom ETF',

    'CQS symbol': 'EWU',
    'NASDAQ symbol': 'EWU',
  },
  {
    symbol: 'EWUS',
    'Security Name': 'Ishares MSCI United Kingdom Small Cap ETF',

    'CQS symbol': 'EWUS',
    'NASDAQ symbol': 'EWUS',
  },
  {
    symbol: 'EWV',
    'Security Name': 'ProShares UltraShort MSCI Japan',

    'CQS symbol': 'EWV',
    'NASDAQ symbol': 'EWV',
  },
  {
    symbol: 'EWW',
    'Security Name': 'iShares  iShares MSCI Mexico ETF',

    'CQS symbol': 'EWW',
    'NASDAQ symbol': 'EWW',
  },
  {
    symbol: 'EWX',
    'Security Name': 'SPDR S&P Emerging Markets Small Cap ETF',

    'CQS symbol': 'EWX',
    'NASDAQ symbol': 'EWX',
  },
  {
    symbol: 'EWY',
    'Security Name': 'iShares  iShares MSCI South Korea ETF',

    'CQS symbol': 'EWY',
    'NASDAQ symbol': 'EWY',
  },
  {
    symbol: 'EWZ',
    'Security Name': 'iShares  iShares MSCI Brazil ETF',

    'CQS symbol': 'EWZ',
    'NASDAQ symbol': 'EWZ',
  },
  {
    symbol: 'EWZS',
    'Security Name': 'iShares MSCI Brazil SmallCap ETF',

    'NASDAQ symbol': 'EWZS',
  },
  {
    symbol: 'EXAS',
    'Security Name': 'Exact Sciences Corporation  ',

    'NASDAQ symbol': 'EXAS',
  },
  {
    symbol: 'EXC',
    'Security Name': 'Exelon Corporation  ',

    'NASDAQ symbol': 'EXC',
  },
  {
    symbol: 'EXD',
    'Security Name':
      'Eaton Vance TaxManaged BuyWrite Strategy Fund Common Shares of Beneficial Interest',

    'CQS symbol': 'EXD',
    'NASDAQ symbol': 'EXD',
  },
  {
    symbol: 'EXEL',
    'Security Name': 'Exelixis,   ',

    'NASDAQ symbol': 'EXEL',
  },
  {
    symbol: 'EXFO',
    'Security Name': 'EXFO   Subordinate Voting Shares',

    'NASDAQ symbol': 'EXFO',
  },
  {
    symbol: 'EXG',
    'Security Name':
      'Eaton Vance TaxManaged Global Diversified Equity ome Fund Eaton Vance TaxManaged Global Diversified Equity ome Fund Common Shares of Beneficial Interest',

    'CQS symbol': 'EXG',
    'NASDAQ symbol': 'EXG',
  },
  {
    symbol: 'EXI',
    'Security Name': 'iShares Global Industrials ETF',

    'CQS symbol': 'EXI',
    'NASDAQ symbol': 'EXI',
  },
  {
    symbol: 'EXK',
    'Security Name': 'Endeavour Silver Corporation Ordinary Shares (Canada)',

    'CQS symbol': 'EXK',
    'NASDAQ symbol': 'EXK',
  },
  {
    symbol: 'EXLS',
    'Security Name': 'ExlService Holdings,   ',

    'NASDAQ symbol': 'EXLS',
  },
  {
    symbol: 'EXN',
    'Security Name': 'Excellon Resources  Common Shares',

    'CQS symbol': 'EXN',
    'NASDAQ symbol': 'EXN',
  },
  {
    symbol: 'EXP',
    'Security Name': 'Eagle Materials  ',

    'CQS symbol': 'EXP',
    'NASDAQ symbol': 'EXP',
  },
  {
    symbol: 'EXPC',
    'Security Name': 'Experience Investment Corp   ',

    'NASDAQ symbol': 'EXPC',
  },
  {
    symbol: 'EXPCU',
    'Security Name': 'Experience Investment Corp  Unit',

    'NASDAQ symbol': 'EXPCU',
  },
  {
    symbol: 'EXPCW',
    'Security Name': 'Experience Investment Corp  Warrants',

    'NASDAQ symbol': 'EXPCW',
  },
  {
    symbol: 'EXPD',
    'Security Name': 'Expeditors International of Washington,   ',

    'NASDAQ symbol': 'EXPD',
  },
  {
    symbol: 'EXPE',
    'Security Name': 'Expedia Group,   ',

    'NASDAQ symbol': 'EXPE',
  },
  {
    symbol: 'EXPI',
    'Security Name': 'eXp World Holdings,   ',

    'NASDAQ symbol': 'EXPI',
  },
  {
    symbol: 'EXPO',
    'Security Name': 'Exponent,   ',

    'NASDAQ symbol': 'EXPO',
  },
  {
    symbol: 'EXPR',
    'Security Name': 'Express,  ',

    'CQS symbol': 'EXPR',
    'NASDAQ symbol': 'EXPR',
  },
  {
    symbol: 'EXR',
    'Security Name': 'Extra Space Storage  ',

    'CQS symbol': 'EXR',
    'NASDAQ symbol': 'EXR',
  },
  {
    symbol: 'EXTN',
    'Security Name': 'Exterran Corporation ',

    'CQS symbol': 'EXTN',
    'NASDAQ symbol': 'EXTN',
  },
  {
    symbol: 'EXTR',
    'Security Name': 'Extreme Networks,   ',

    'NASDAQ symbol': 'EXTR',
  },
  {
    symbol: 'EYE',
    'Security Name': 'National Vision Holdings,   ',

    'NASDAQ symbol': 'EYE',
  },
  {
    symbol: 'EYEG',
    'Security Name': 'Eyegate Pharmaceuticals,   ',

    'NASDAQ symbol': 'EYEG',
  },
  {
    symbol: 'EYEN',
    'Security Name': 'Eyenovia,   ',

    'NASDAQ symbol': 'EYEN',
  },
  {
    symbol: 'EYES',
    'Security Name': 'Second Sight Medical Products,   ',

    'NASDAQ symbol': 'EYES',
  },
  {
    symbol: 'EYESW',
    'Security Name':
      'Second Sight Medical Products,   Warrants expiring 3/14/2024',

    'NASDAQ symbol': 'EYESW',
  },
  {
    symbol: 'EYLD',
    'Security Name': 'Cambria ETF Trust Cambria Emerging Shareholder Yield ETF',

    'CQS symbol': 'EYLD',
    'NASDAQ symbol': 'EYLD',
  },
  {
    symbol: 'EYPT',
    'Security Name': 'EyePoint Pharmaceuticals,   ',

    'NASDAQ symbol': 'EYPT',
  },
  {
    symbol: 'EZA',
    'Security Name': 'iShares MSCI South Africa Index Fund',

    'CQS symbol': 'EZA',
    'NASDAQ symbol': 'EZA',
  },
  {
    symbol: 'EZJ',
    'Security Name': 'ProShares Ultra MSCI Japan',

    'CQS symbol': 'EZJ',
    'NASDAQ symbol': 'EZJ',
  },
  {
    symbol: 'EZM',
    'Security Name': 'WisdomTree US MidCap Fund',

    'CQS symbol': 'EZM',
    'NASDAQ symbol': 'EZM',
  },
  {
    symbol: 'EZPW',
    'Security Name': 'EZCORP,    NonVoting ',

    'NASDAQ symbol': 'EZPW',
  },
  {
    symbol: 'EZU',
    'Security Name': 'iShares MSCI Eurozone ETF',

    'CQS symbol': 'EZU',
    'NASDAQ symbol': 'EZU',
  },
  {
    symbol: 'F',
    'Security Name': 'Ford Motor Company ',

    'CQS symbol': 'F',
    'NASDAQ symbol': 'F',
  },
  {
    symbol: 'F$B',
    'Security Name': 'Ford Motor Company 620% Notes due June 1, 2059',

    'CQS symbol': 'FpB',
    'NASDAQ symbol': 'FB',
  },
  {
    symbol: 'F$C',
    'Security Name': 'Ford Motor Company 6% Notes due December 1, 2059',

    'CQS symbol': 'FpC',
    'NASDAQ symbol': 'FC',
  },
  {
    symbol: 'FAAR',
    'Security Name': 'First Trust Alternative Absolute Return Strategy ETF',

    'NASDAQ symbol': 'FAAR',
  },
  {
    symbol: 'FAB',
    'Security Name': 'First Trust Multi Cap Value AlphaDEX Fund',

    'NASDAQ symbol': 'FAB',
  },
  {
    symbol: 'FAD',
    'Security Name': 'First Trust Multi Cap Growth AlphaDEX Fund',

    'NASDAQ symbol': 'FAD',
  },
  {
    symbol: 'FAF',
    'Security Name': 'First American Corporation (New) ',

    'CQS symbol': 'FAF',
    'NASDAQ symbol': 'FAF',
  },
  {
    symbol: 'FAII',
    'Security Name': 'Fortress Value Acquisition Corp II  ',

    'CQS symbol': 'FAII',
    'NASDAQ symbol': 'FAII',
  },
  {
    symbol: 'FAIIU',
    'Security Name':
      'Fortress Value Acquisition Corp II Units, each consisting of one share of   and onefifth of one Warrant',

    'CQS symbol': 'FAIIU',
    'NASDAQ symbol': 'FAII=',
  },
  {
    symbol: 'FAIIW',
    'Security Name':
      'Fortress Value Acquisition Corp II Warrants, each whole warrant exercisable for one share of   at an exercise price of $1150 per share',

    'CQS symbol': 'FAIIWS',
    'NASDAQ symbol': 'FAII+',
  },
  {
    symbol: 'FALN',
    'Security Name': 'iShares Fallen Angels USD Bond ETF',

    'NASDAQ symbol': 'FALN',
  },
  {
    symbol: 'FAM',
    'Security Name':
      'First Trust/Aberdeen Global Opportunity ome Fund First Trust/Aberdeen Global Opportunity ome Fund Common Shares of Beneficial Interest',

    'CQS symbol': 'FAM',
    'NASDAQ symbol': 'FAM',
  },
  {
    symbol: 'FAMI',
    'Security Name': 'Farmmi,   Ordinary Shares',

    'NASDAQ symbol': 'FAMI',
  },
  {
    symbol: 'FAN',
    'Security Name': 'First Trust Global Wind Energy ETF',

    'CQS symbol': 'FAN',
    'NASDAQ symbol': 'FAN',
  },
  {
    symbol: 'FANG',
    'Security Name': 'Diamondback Energy,   Commmon Stock',

    'NASDAQ symbol': 'FANG',
  },
  {
    symbol: 'FANH',
    'Security Name':
      'Fanhua   American depositary shares, each representing 20 ordinary shares',

    'NASDAQ symbol': 'FANH',
  },
  {
    symbol: 'FARM',
    'Security Name': 'Farmer Brothers Company  ',

    'NASDAQ symbol': 'FARM',
  },
  {
    symbol: 'FARO',
    'Security Name': 'FARO Technologies,   ',

    'NASDAQ symbol': 'FARO',
  },
  {
    symbol: 'FAS',
    'Security Name': 'Direxion Financial Bull 3X Shares',

    'CQS symbol': 'FAS',
    'NASDAQ symbol': 'FAS',
  },
  {
    symbol: 'FAST',
    'Security Name': 'Fastenal Company  ',

    'NASDAQ symbol': 'FAST',
  },
  {
    symbol: 'FAT',
    'Security Name': 'FAT Brands   ',

    'NASDAQ symbol': 'FAT',
  },
  {
    symbol: 'FATBP',
    'Security Name': 'FAT Brands   825% Series B Cumulative Preferred Stock',

    'NASDAQ symbol': 'FATBP',
  },
  {
    symbol: 'FATBW',
    'Security Name': 'FAT Brands   Warrant',

    'NASDAQ symbol': 'FATBW',
  },
  {
    symbol: 'FATE',
    'Security Name': 'Fate Therapeutics,   ',

    'NASDAQ symbol': 'FATE',
  },
  {
    symbol: 'FAUG',
    'Security Name': 'FT Cboe Vest US Equity Buffer ETF  August',

    'CQS symbol': 'FAUG',
    'NASDAQ symbol': 'FAUG',
  },
  {
    symbol: 'FAX',
    'Security Name': 'Aberdeen AsiaPacific ome Fund  ',

    'CQS symbol': 'FAX',
    'NASDAQ symbol': 'FAX',
  },
  {
    symbol: 'FAZ',
    'Security Name': 'Direxion Financial Bear 3X Shares',

    'CQS symbol': 'FAZ',
    'NASDAQ symbol': 'FAZ',
  },
  {
    symbol: 'FB',
    'Security Name': 'Facebook,    ',

    'NASDAQ symbol': 'FB',
  },
  {
    symbol: 'FBC',
    'Security Name': 'Flagstar Bancorp,  ',

    'CQS symbol': 'FBC',
    'NASDAQ symbol': 'FBC',
  },
  {
    symbol: 'FBCG',
    'Security Name': 'Fidelity Blue Chip Growth ETF',

    'CQS symbol': 'FBCG',
    'NASDAQ symbol': 'FBCG',
  },
  {
    symbol: 'FBCV',
    'Security Name': 'Fidelity Blue Chip Value ETF',

    'CQS symbol': 'FBCV',
    'NASDAQ symbol': 'FBCV',
  },
  {
    symbol: 'FBGX',
    'Security Name': 'UBS AG FI Enhanced Large Cap Growth ETN',

    'CQS symbol': 'FBGX',
    'NASDAQ symbol': 'FBGX',
  },
  {
    symbol: 'FBHS',
    'Security Name': 'Fortune Brands Home & Security,  ',

    'CQS symbol': 'FBHS',
    'NASDAQ symbol': 'FBHS',
  },
  {
    symbol: 'FBIO',
    'Security Name': 'Fortress Biotech,   ',

    'NASDAQ symbol': 'FBIO',
  },
  {
    symbol: 'FBIOP',
    'Security Name':
      'Fortress Biotech,   9375% Series A Cumulative Redeemable Perpetual Preferred Stock',

    'NASDAQ symbol': 'FBIOP',
  },
  {
    symbol: 'FBIZ',
    'Security Name': 'First Business Financial Services,   ',

    'NASDAQ symbol': 'FBIZ',
  },
  {
    symbol: 'FBK',
    'Security Name': 'FB Financial Corporation ',

    'CQS symbol': 'FBK',
    'NASDAQ symbol': 'FBK',
  },
  {
    symbol: 'FBM',
    'Security Name': 'Foundation Building Materials,  ',

    'CQS symbol': 'FBM',
    'NASDAQ symbol': 'FBM',
  },
  {
    symbol: 'FBMS',
    'Security Name': 'The First Bancshares,   ',

    'NASDAQ symbol': 'FBMS',
  },
  {
    symbol: 'FBNC',
    'Security Name': 'First Bancorp  ',

    'NASDAQ symbol': 'FBNC',
  },
  {
    symbol: 'FBND',
    'Security Name': 'Fidelity Total Bond ETF',

    'CQS symbol': 'FBND',
    'NASDAQ symbol': 'FBND',
  },
  {
    symbol: 'FBP',
    'Security Name': 'First BanCorp New ',

    'CQS symbol': 'FBP',
    'NASDAQ symbol': 'FBP',
  },
  {
    symbol: 'FBRX',
    'Security Name': 'Forte Biosciences,    ',

    'NASDAQ symbol': 'FBRX',
  },
  {
    symbol: 'FBSS',
    'Security Name': 'Fauquier Bankshares,   ',

    'NASDAQ symbol': 'FBSS',
  },
  {
    symbol: 'FBT',
    'Security Name': 'First Trust Amex Biotech Index Fund',

    'CQS symbol': 'FBT',
    'NASDAQ symbol': 'FBT',
  },
  {
    symbol: 'FBZ',
    'Security Name': 'First Trust Brazil AlphaDEX Fund',

    'NASDAQ symbol': 'FBZ',
  },
  {
    symbol: 'FC',
    'Security Name': 'Franklin Covey Company ',

    'CQS symbol': 'FC',
    'NASDAQ symbol': 'FC',
  },
  {
    symbol: 'FCA',
    'Security Name': 'First Trust China AlphaDEX Fund',

    'NASDAQ symbol': 'FCA',
  },
  {
    symbol: 'FCAC',
    'Security Name': 'Falcon Capital Acquisition Corp   ',

    'NASDAQ symbol': 'FCAC',
  },
  {
    symbol: 'FCACU',
    'Security Name': 'Falcon Capital Acquisition Corp  Unit',

    'NASDAQ symbol': 'FCACU',
  },
  {
    symbol: 'FCACW',
    'Security Name': 'Falcon Capital Acquisition Corp  Warrant',

    'NASDAQ symbol': 'FCACW',
  },
  {
    symbol: 'FCAL',
    'Security Name': 'First Trust California Municipal High ome ETF',

    'NASDAQ symbol': 'FCAL',
  },
  {
    symbol: 'FCAP',
    'Security Name': 'First Capital,   ',

    'NASDAQ symbol': 'FCAP',
  },
  {
    symbol: 'FCAU',
    'Security Name': 'Fiat Chrysler Automobiles NV Common Shares',

    'CQS symbol': 'FCAU',
    'NASDAQ symbol': 'FCAU',
  },
  {
    symbol: 'FCBC',
    'Security Name': 'First Community Bankshares,   ',

    'NASDAQ symbol': 'FCBC',
  },
  {
    symbol: 'FCBP',
    'Security Name': 'First Choice Bancorp  ',

    'NASDAQ symbol': 'FCBP',
  },
  {
    symbol: 'FCCO',
    'Security Name': 'First Community Corporation  ',

    'NASDAQ symbol': 'FCCO',
  },
  {
    symbol: 'FCCY',
    'Security Name': '1st Constitution Bancorp (NJ)  ',

    'NASDAQ symbol': 'FCCY',
  },
  {
    symbol: 'FCEF',
    'Security Name': 'First Trust CEF ome Opportunity ETF',

    'NASDAQ symbol': 'FCEF',
  },
  {
    symbol: 'FCEL',
    'Security Name': 'FuelCell Energy,   ',

    'NASDAQ symbol': 'FCEL',
  },
  {
    symbol: 'FCF',
    'Security Name': 'First Commonwealth Financial Corporation ',

    'CQS symbol': 'FCF',
    'NASDAQ symbol': 'FCF',
  },
  {
    symbol: 'FCFS',
    'Security Name': 'FirstCash,   ',

    'NASDAQ symbol': 'FCFS',
  },
  {
    symbol: 'FCG',
    'Security Name': 'First Trust Natural Gas ETF',

    'CQS symbol': 'FCG',
    'NASDAQ symbol': 'FCG',
  },
  {
    symbol: 'FCN',
    'Security Name': 'FTI Consulting,  ',

    'CQS symbol': 'FCN',
    'NASDAQ symbol': 'FCN',
  },
  {
    symbol: 'FCNCA',
    'Security Name': 'First Citizens BancShares,    ',

    'NASDAQ symbol': 'FCNCA',
  },
  {
    symbol: 'FCNCP',
    'Security Name':
      'First Citizens BancShares,   Depositary Shares Each Representing a 1/40th Interest in a Share of 5375% NonCumulative Perpetual Preferred Stock, Series A',

    'NASDAQ symbol': 'FCNCP',
  },
  {
    symbol: 'FCO',
    'Security Name': 'Aberdeen Global ome Fund,  ',

    'CQS symbol': 'FCO',
    'NASDAQ symbol': 'FCO',
  },
  {
    symbol: 'FCOM',
    'Security Name': 'Fidelity MSCI Communication Services Index ETF',

    'CQS symbol': 'FCOM',
    'NASDAQ symbol': 'FCOM',
  },
  {
    symbol: 'FCOR',
    'Security Name': 'Fidelity Corporate Bond ETF',

    'CQS symbol': 'FCOR',
    'NASDAQ symbol': 'FCOR',
  },
  {
    symbol: 'FCPI',
    'Security Name': 'Fidelity Stocks for Inflation ETF ',

    'CQS symbol': 'FCPI',
    'NASDAQ symbol': 'FCPI',
  },
  {
    symbol: 'FCPT',
    'Security Name': 'Four Corners Property Trust,  ',

    'CQS symbol': 'FCPT',
    'NASDAQ symbol': 'FCPT',
  },
  {
    symbol: 'FCRD',
    'Security Name': 'First Eagle Alternative Capital BDC,   ',

    'NASDAQ symbol': 'FCRD',
  },
  {
    symbol: 'FCRW',
    'Security Name':
      'First Eagle Alternative Capital BDC,  6125% Notes Due 2023',

    'CQS symbol': 'FCRW',
    'NASDAQ symbol': 'FCRW',
  },
  {
    symbol: 'FCRZ',
    'Security Name':
      'First Eagle Alternative Capital BDC,  675% Notes due 2022',

    'CQS symbol': 'FCRZ',
    'NASDAQ symbol': 'FCRZ',
  },
  {
    symbol: 'FCT',
    'Security Name':
      'First Trust Senior Floating Rate ome Fund II Common Shares of Beneficial Interest',

    'CQS symbol': 'FCT',
    'NASDAQ symbol': 'FCT',
  },
  {
    symbol: 'FCTR',
    'Security Name': 'First Trust Lunt US Factor Rotation ETF',

    'CQS symbol': 'FCTR',
    'NASDAQ symbol': 'FCTR',
  },
  {
    symbol: 'FCVT',
    'Security Name': 'First Trust SSI Strategic Convertible Securities ETF',

    'NASDAQ symbol': 'FCVT',
  },
  {
    symbol: 'FCX',
    'Security Name': 'FreeportMcMoRan,  ',

    'CQS symbol': 'FCX',
    'NASDAQ symbol': 'FCX',
  },
  {
    symbol: 'FDBC',
    'Security Name': 'Fidelity D & D Bancorp,   ',

    'NASDAQ symbol': 'FDBC',
  },
  {
    symbol: 'FDD',
    'Security Name':
      'First Trust Dow Jones STOXX Select Dividend 30 Index Fund',

    'CQS symbol': 'FDD',
    'NASDAQ symbol': 'FDD',
  },
  {
    symbol: 'FDEM',
    'Security Name': 'Fidelity Emerging Markets Multifactor ETF',

    'CQS symbol': 'FDEM',
    'NASDAQ symbol': 'FDEM',
  },
  {
    symbol: 'FDEU',
    'Security Name':
      'First Trust Dynamic Europe Equity ome Fund Common Shares of Beneficial Interest',

    'CQS symbol': 'FDEU',
    'NASDAQ symbol': 'FDEU',
  },
  {
    symbol: 'FDEV',
    'Security Name': 'Fidelity Emerging Markets Multifactor ETF',

    'CQS symbol': 'FDEV',
    'NASDAQ symbol': 'FDEV',
  },
  {
    symbol: 'FDG',
    'Security Name': 'American Century Focused Dynamic Growth ETF',

    'CQS symbol': 'FDG',
    'NASDAQ symbol': 'FDG',
  },
  {
    symbol: 'FDHY',
    'Security Name': 'Fidelity High Yield Factor ETF',

    'CQS symbol': 'FDHY',
    'NASDAQ symbol': 'FDHY',
  },
  {
    symbol: 'FDIS',
    'Security Name': 'Fidelity MSCI Consumer Discretionary Index ETF',

    'CQS symbol': 'FDIS',
    'NASDAQ symbol': 'FDIS',
  },
  {
    symbol: 'FDIV',
    'Security Name': 'First Trust Strategic ome ETF',

    'NASDAQ symbol': 'FDIV',
  },
  {
    symbol: 'FDL',
    'Security Name': 'First Trust Morningstar ETF',

    'CQS symbol': 'FDL',
    'NASDAQ symbol': 'FDL',
  },
  {
    symbol: 'FDLO',
    'Security Name': 'Fidelity Low Volatility Factor ETF',

    'CQS symbol': 'FDLO',
    'NASDAQ symbol': 'FDLO',
  },
  {
    symbol: 'FDM',
    'Security Name': 'First Trust DJ Select MicroCap ETF',

    'CQS symbol': 'FDM',
    'NASDAQ symbol': 'FDM',
  },
  {
    symbol: 'FDMO',
    'Security Name': 'Fidelity Momentum Factor ETF',

    'CQS symbol': 'FDMO',
    'NASDAQ symbol': 'FDMO',
  },
  {
    symbol: 'FDN',
    'Security Name': 'First Trust DJ Internet Index Fund',

    'CQS symbol': 'FDN',
    'NASDAQ symbol': 'FDN',
  },
  {
    symbol: 'FDNI',
    'Security Name': 'First Trust Dow Jones International Internet ETF',

    'NASDAQ symbol': 'FDNI',
  },
  {
    symbol: 'FDP',
    'Security Name': 'Fresh Del Monte Produce,  ',

    'CQS symbol': 'FDP',
    'NASDAQ symbol': 'FDP',
  },
  {
    symbol: 'FDRR',
    'Security Name': 'Fidelity Dividend ETF for Rising Rates',

    'CQS symbol': 'FDRR',
    'NASDAQ symbol': 'FDRR',
  },
  {
    symbol: 'FDS',
    'Security Name': 'FactSet Research Systems  ',

    'CQS symbol': 'FDS',
    'NASDAQ symbol': 'FDS',
  },
  {
    symbol: 'FDT',
    'Security Name': 'First Trust Developed Markets ExUS AlphaDEX Fund',

    'NASDAQ symbol': 'FDT',
  },
  {
    symbol: 'FDTS',
    'Security Name':
      'First Trust Developed Markets exUS Small Cap AlphaDEX Fund',

    'NASDAQ symbol': 'FDTS',
  },
  {
    symbol: 'FDUS',
    'Security Name': 'Fidus Investment Corporation  ',

    'NASDAQ symbol': 'FDUS',
  },
  {
    symbol: 'FDUSG',
    'Security Name': 'Fidus Investment Corporation  5375% Notes Due 2024',

    'NASDAQ symbol': 'FDUSG',
  },
  {
    symbol: 'FDUSL',
    'Security Name': 'Fidus Investment Corporation  5875% Notes due 2023',

    'NASDAQ symbol': 'FDUSL',
  },
  {
    symbol: 'FDUSZ',
    'Security Name': 'Fidus Investment Corporation  6% Notes due 2024',

    'NASDAQ symbol': 'FDUSZ',
  },
  {
    symbol: 'FDVV',
    'Security Name': 'Fidelity High Dividend ETF',

    'CQS symbol': 'FDVV',
    'NASDAQ symbol': 'FDVV',
  },
  {
    symbol: 'FDX',
    'Security Name': 'FedEx Corporation ',

    'CQS symbol': 'FDX',
    'NASDAQ symbol': 'FDX',
  },
  {
    symbol: 'FE',
    'Security Name': 'FirstEnergy Corp ',

    'CQS symbol': 'FE',
    'NASDAQ symbol': 'FE',
  },
  {
    symbol: 'FEAC',
    'Security Name': 'Flying Eagle Acquisition Corp  ',

    'CQS symbol': 'FEAC',
    'NASDAQ symbol': 'FEAC',
  },
  {
    symbol: 'FEACU',
    'Security Name':
      'Flying Eagle Acquisition Corp Units, each consisting of one share of   and onefourth of one redeemable warrant',

    'CQS symbol': 'FEACU',
    'NASDAQ symbol': 'FEAC=',
  },
  {
    symbol: 'FEACW',
    'Security Name':
      'Flying Eagle Acquisition Corp Warrants, each whole warrant exercisable for one share of   at an exercise price of $1150 per share',

    'CQS symbol': 'FEACWS',
    'NASDAQ symbol': 'FEAC+',
  },
  {
    symbol: 'FEDU',
    'Security Name':
      'Four Seasons Education (Cayman)  American Depositary Shares, each two ADSs representing one ordinary share',

    'CQS symbol': 'FEDU',
    'NASDAQ symbol': 'FEDU',
  },
  {
    symbol: 'FEDX',
    'Security Name': 'Emles Federal Contractors ETF',

    'CQS symbol': 'FEDX',
    'NASDAQ symbol': 'FEDX',
  },
  {
    symbol: 'FEI',
    'Security Name':
      'First Trust MLP and Energy ome Fund Common Shares of Beneficial Interest',

    'CQS symbol': 'FEI',
    'NASDAQ symbol': 'FEI',
  },
  {
    symbol: 'FEIM',
    'Security Name': 'Frequency Electronics,   ',

    'NASDAQ symbol': 'FEIM',
  },
  {
    symbol: 'FELE',
    'Security Name': 'Franklin Electric Co,   ',

    'NASDAQ symbol': 'FELE',
  },
  {
    symbol: 'FEM',
    'Security Name': 'First Trust Emerging Markets AlphaDEX Fund',

    'NASDAQ symbol': 'FEM',
  },
  {
    symbol: 'FEMB',
    'Security Name': 'First Trust Emerging Markets Local Currency Bond ETF',

    'NASDAQ symbol': 'FEMB',
  },
  {
    symbol: 'FEMS',
    'Security Name': 'First Trust Emerging Markets Small Cap AlphaDEX Fund',

    'NASDAQ symbol': 'FEMS',
  },
  {
    symbol: 'FEN',
    'Security Name': 'First Trust Energy ome and Growth Fund',

    'CQS symbol': 'FEN',
    'NASDAQ symbol': 'FEN',
  },
  {
    symbol: 'FENC',
    'Security Name': 'Fennec Pharmaceuticals   ',

    'NASDAQ symbol': 'FENC',
  },
  {
    symbol: 'FENG',
    'Security Name':
      'Phoenix New Media Limited American Depositary Shares, each representing 8  ordinary shares',

    'CQS symbol': 'FENG',
    'NASDAQ symbol': 'FENG',
  },
  {
    symbol: 'FENY',
    'Security Name': 'Fidelity MSCI Energy Index ETF',

    'CQS symbol': 'FENY',
    'NASDAQ symbol': 'FENY',
  },
  {
    symbol: 'FEO',
    'Security Name':
      'First Trust/Aberdeen Emerging Opportunity Fund Common Shares of Beneficial Interest',

    'CQS symbol': 'FEO',
    'NASDAQ symbol': 'FEO',
  },
  {
    symbol: 'FEP',
    'Security Name': 'First Trust Europe AlphaDEX Fund',

    'NASDAQ symbol': 'FEP',
  },
  {
    symbol: 'FET',
    'Security Name': 'Forum Energy Technologies,  ',

    'CQS symbol': 'FET',
    'NASDAQ symbol': 'FET',
  },
  {
    symbol: 'FEUL',
    'Security Name': 'Credit Suisse FI Enhanced Europe 50 ETNs',

    'CQS symbol': 'FEUL',
    'NASDAQ symbol': 'FEUL',
  },
  {
    symbol: 'FEUZ',
    'Security Name': 'First Trust Eurozone AlphaDEX ETF',

    'NASDAQ symbol': 'FEUZ',
  },
  {
    symbol: 'FEX',
    'Security Name': 'First Trust Large Cap Core AlphaDEX Fund',

    'NASDAQ symbol': 'FEX',
  },
  {
    symbol: 'FEYE',
    'Security Name': 'FireEye,   ',

    'NASDAQ symbol': 'FEYE',
  },
  {
    symbol: 'FEZ',
    'Security Name': 'SPDR DJ Euro STOXX 50 Etf',

    'CQS symbol': 'FEZ',
    'NASDAQ symbol': 'FEZ',
  },
  {
    symbol: 'FF',
    'Security Name': 'FutureFuel Corp  Common shares',

    'CQS symbol': 'FF',
    'NASDAQ symbol': 'FF',
  },
  {
    symbol: 'FFA',
    'Security Name': 'First Trust Enhanced Equity ome Fund',

    'CQS symbol': 'FFA',
    'NASDAQ symbol': 'FFA',
  },
  {
    symbol: 'FFBC',
    'Security Name': 'First Financial Bancorp  ',

    'NASDAQ symbol': 'FFBC',
  },
  {
    symbol: 'FFBW',
    'Security Name': 'FFBW,   ',

    'NASDAQ symbol': 'FFBW',
  },
  {
    symbol: 'FFC',
    'Security Name':
      'Flaherty & Crumrine Preferred and ome Securities Fund orporated',

    'CQS symbol': 'FFC',
    'NASDAQ symbol': 'FFC',
  },
  {
    symbol: 'FFEB',
    'Security Name': 'FT Cboe Vest US Equity Buffer ETF  February',

    'CQS symbol': 'FFEB',
    'NASDAQ symbol': 'FFEB',
  },
  {
    symbol: 'FFEU',
    'Security Name':
      'Barclays ETN  FI Enhanced Europe 50 Exchange Traded Notes Series C',

    'CQS symbol': 'FFEU',
    'NASDAQ symbol': 'FFEU',
  },
  {
    symbol: 'FFG',
    'Security Name': 'FBL Financial Group,  ',

    'CQS symbol': 'FFG',
    'NASDAQ symbol': 'FFG',
  },
  {
    symbol: 'FFHG',
    'Security Name': 'Formula Folios Hedged Growth ETF ',

    'CQS symbol': 'FFHG',
    'NASDAQ symbol': 'FFHG',
  },
  {
    symbol: 'FFHL',
    'Security Name': 'Fuwei Films (Holdings) Co, Ltd  ORDINARY SHARES',

    'NASDAQ symbol': 'FFHL',
  },
  {
    symbol: 'FFIC',
    'Security Name': 'Flushing Financial Corporation  ',

    'NASDAQ symbol': 'FFIC',
  },
  {
    symbol: 'FFIN',
    'Security Name': 'First Financial Bankshares,   ',

    'NASDAQ symbol': 'FFIN',
  },
  {
    symbol: 'FFIU',
    'Security Name': 'UVA Unconstrained MediumTerm Fixed ome ETF',

    'CQS symbol': 'FFIU',
    'NASDAQ symbol': 'FFIU',
  },
  {
    symbol: 'FFIV',
    'Security Name': 'F5 Networks,   ',

    'NASDAQ symbol': 'FFIV',
  },
  {
    symbol: 'FFNW',
    'Security Name': 'First Financial Northwest,   ',

    'NASDAQ symbol': 'FFNW',
  },
  {
    symbol: 'FFR',
    'Security Name':
      'First Trust FTSE EPRA/NAREIT Global Real Estate Index Fund',

    'CQS symbol': 'FFR',
    'NASDAQ symbol': 'FFR',
  },
  {
    symbol: 'FFSG',
    'Security Name': 'FormulaFolios Smart Growth ETF',

    'CQS symbol': 'FFSG',
    'NASDAQ symbol': 'FFSG',
  },
  {
    symbol: 'FFTG',
    'Security Name': 'FormulaFolios Tactical Growth ETF',

    'CQS symbol': 'FFTG',
    'NASDAQ symbol': 'FFTG',
  },
  {
    symbol: 'FFTI',
    'Security Name': 'FormulaFolios Tactical ome ETF',

    'CQS symbol': 'FFTI',
    'NASDAQ symbol': 'FFTI',
  },
  {
    symbol: 'FFTY',
    'Security Name': 'Innovator IBD 50 ETF',

    'CQS symbol': 'FFTY',
    'NASDAQ symbol': 'FFTY',
  },
  {
    symbol: 'FFWM',
    'Security Name': 'First Foundation   ',

    'NASDAQ symbol': 'FFWM',
  },
  {
    symbol: 'FGB',
    'Security Name':
      'First Trust Specialty Finance and Financial Opportunities Fund',

    'CQS symbol': 'FGB',
    'NASDAQ symbol': 'FGB',
  },
  {
    symbol: 'FGBI',
    'Security Name': 'First Guaranty Bancshares,   ',

    'NASDAQ symbol': 'FGBI',
  },
  {
    symbol: 'FGD',
    'Security Name': 'First Trust DJ Global Select Dividend',

    'CQS symbol': 'FGD',
    'NASDAQ symbol': 'FGD',
  },
  {
    symbol: 'FGEN',
    'Security Name': 'FibroGen,   ',

    'NASDAQ symbol': 'FGEN',
  },
  {
    symbol: 'FGM',
    'Security Name': 'First Trust Germany AlphaDEX Fund',

    'NASDAQ symbol': 'FGM',
  },
  {
    symbol: 'FGNA',
    'Security Name': 'FG New America Acquisition Corp  ',

    'CQS symbol': 'FGNA',
    'NASDAQ symbol': 'FGNA',
  },
  {
    symbol: 'FGNAU',
    'Security Name': 'FG New America Acquisition Corp Units',

    'CQS symbol': 'FGNAU',
    'NASDAQ symbol': 'FGNA=',
  },
  {
    symbol: 'FGNAW',
    'Security Name':
      'FG New America Acquisition Corp Warrants, each whole warrant exercisable for one share of   at an exercise price of $1150 per share',

    'CQS symbol': 'FGNAWS',
    'NASDAQ symbol': 'FGNA+',
  },
  {
    symbol: 'FHB',
    'Security Name': 'First Hawaiian,   ',

    'NASDAQ symbol': 'FHB',
  },
  {
    symbol: 'FHI',
    'Security Name': 'Federated Hermes,  ',

    'CQS symbol': 'FHI',
    'NASDAQ symbol': 'FHI',
  },
  {
    symbol: 'FHLC',
    'Security Name': 'Fidelity MSCI Health Care Index ETF',

    'CQS symbol': 'FHLC',
    'NASDAQ symbol': 'FHLC',
  },
  {
    symbol: 'FHN',
    'Security Name': 'First Horizon Corporation ',

    'CQS symbol': 'FHN',
    'NASDAQ symbol': 'FHN',
  },
  {
    symbol: 'FHN$A',
    'Security Name': 'First Horizon Corporation Depositary Shares',

    'CQS symbol': 'FHNpA',
    'NASDAQ symbol': 'FHNA',
  },
  {
    symbol: 'FHN$B',
    'Security Name':
      'First Horizon Corporation Depositary Shares, each representing a 1/400th interest in a share of NonCumulative Perpetual Preferred Stock, Series B',

    'CQS symbol': 'FHNpB',
    'NASDAQ symbol': 'FHNB',
  },
  {
    symbol: 'FHN$C',
    'Security Name':
      'First Horizon Corporation Depositary Shares, each representing a 1/400th interest in a share of NonCumulative Perpetual Preferred Stock, Series C',

    'CQS symbol': 'FHNpC',
    'NASDAQ symbol': 'FHNC',
  },
  {
    symbol: 'FHN$D',
    'Security Name':
      'First Horizon Corporation Depositary Shares, each representing a 1/400th interest in a share of NonCumulative Perpetual Preferred Stock, Series D',

    'CQS symbol': 'FHNpD',
    'NASDAQ symbol': 'FHND',
  },
  {
    symbol: 'FHN$E',
    'Security Name':
      'First Horizon Corporation Depositary Shares, each representing a 1/4,000th interest in a share of NonCumulative Perpetual Preferred Stock, Series E',

    'CQS symbol': 'FHNpE',
    'NASDAQ symbol': 'FHNE',
  },
  {
    symbol: 'FHTX',
    'Security Name': 'Foghorn Therapeutics   ',

    'NASDAQ symbol': 'FHTX',
  },
  {
    symbol: 'FI',
    'Security Name': "Frank's International NV ",

    'CQS symbol': 'FI',
    'NASDAQ symbol': 'FI',
  },
  {
    symbol: 'FIBK',
    'Security Name': 'First Interstate BancSystem,    ',

    'NASDAQ symbol': 'FIBK',
  },
  {
    symbol: 'FIBR',
    'Security Name': 'iShares US Fixed ome Balanced Risk Factor ETF',

    'CQS symbol': 'FIBR',
    'NASDAQ symbol': 'FIBR',
  },
  {
    symbol: 'FICO',
    'Security Name': 'Fair Isaac Corproation ',

    'CQS symbol': 'FICO',
    'NASDAQ symbol': 'FICO',
  },
  {
    symbol: 'FID',
    'Security Name': 'First Trust S&P International Dividend Aristocrats ETF',

    'NASDAQ symbol': 'FID',
  },
  {
    symbol: 'FIDI',
    'Security Name': 'Fidelity International High Dividend ETF',

    'CQS symbol': 'FIDI',
    'NASDAQ symbol': 'FIDI',
  },
  {
    symbol: 'FIDU',
    'Security Name': 'Fidelity MSCI Industrials Index ETF',

    'CQS symbol': 'FIDU',
    'NASDAQ symbol': 'FIDU',
  },
  {
    symbol: 'FIEE',
    'Security Name': 'UBS AG FI Enhanced Europe 50 ETN due February 12, 2026',

    'CQS symbol': 'FIEE',
    'NASDAQ symbol': 'FIEE',
  },
  {
    symbol: 'FIF',
    'Security Name':
      'First Trust Energy Infrastructure Fund Common Shares of Beneficial Interest',

    'CQS symbol': 'FIF',
    'NASDAQ symbol': 'FIF',
  },
  {
    symbol: 'FIHD',
    'Security Name':
      'UBS AG UBS AG FI Enhanced Global High Yield ETN due March 3, 2026',

    'CQS symbol': 'FIHD',
    'NASDAQ symbol': 'FIHD',
  },
  {
    symbol: 'FIII',
    'Security Name': 'Forum Merger III Corporation   ',

    'NASDAQ symbol': 'FIII',
  },
  {
    symbol: 'FIIIU',
    'Security Name': 'Forum Merger III Corporation  Units',

    'NASDAQ symbol': 'FIIIU',
  },
  {
    symbol: 'FIIIW',
    'Security Name': 'Forum Merger III Corporation  Warrant',

    'NASDAQ symbol': 'FIIIW',
  },
  {
    symbol: 'FILL',
    'Security Name': 'iShares MSCI Global Energy Producers Fund',

    'CQS symbol': 'FILL',
    'NASDAQ symbol': 'FILL',
  },
  {
    symbol: 'FINS',
    'Security Name':
      'Angel Oak Financial Strategies ome Term Trust Common Shares of Beneficial Interest',

    'CQS symbol': 'FINS',
    'NASDAQ symbol': 'FINS',
  },
  {
    symbol: 'FINV',
    'Security Name': 'FinVolution Group American Depositary Shares',

    'CQS symbol': 'FINV',
    'NASDAQ symbol': 'FINV',
  },
  {
    symbol: 'FINX',
    'Security Name': 'Global X FinTech ETF',

    'NASDAQ symbol': 'FINX',
  },
  {
    symbol: 'FIS',
    'Security Name': 'Fidelity National Information Services,  ',

    'CQS symbol': 'FIS',
    'NASDAQ symbol': 'FIS',
  },
  {
    symbol: 'FISI',
    'Security Name': 'Financial Institutions,   ',

    'NASDAQ symbol': 'FISI',
  },
  {
    symbol: 'FISK',
    'Security Name':
      'Empire State Realty OP, LP Series 250 Operating Partnership Units Representing Limited Partnership Interests',

    'CQS symbol': 'FISK',
    'NASDAQ symbol': 'FISK',
  },
  {
    symbol: 'FISR',
    'Security Name': 'SPDR SSGA Fixed ome Sector Rotation ETF',

    'CQS symbol': 'FISR',
    'NASDAQ symbol': 'FISR',
  },
  {
    symbol: 'FISV',
    'Security Name': 'Fiserv,   ',

    'NASDAQ symbol': 'FISV',
  },
  {
    symbol: 'FIT',
    'Security Name': 'Fitbit,   ',

    'CQS symbol': 'FIT',
    'NASDAQ symbol': 'FIT',
  },
  {
    symbol: 'FITB',
    'Security Name': 'Fifth Third Bancorp  ',

    'NASDAQ symbol': 'FITB',
  },
  {
    symbol: 'FITBI',
    'Security Name':
      'Fifth Third Bancorp  Depositary Share repstg 1/1000th Ownership Interest Perp Pfd Series I',

    'NASDAQ symbol': 'FITBI',
  },
  {
    symbol: 'FITBO',
    'Security Name':
      'Fifth Third Bancorp  Depositary Shares each representing a 1/1000th ownership interest in a share of NonCumulative Perpetual Preferred Stock, Series K',

    'NASDAQ symbol': 'FITBO',
  },
  {
    symbol: 'FITBP',
    'Security Name':
      'Fifth Third Bancorp  Depositary Shares each representing 1/40th share of Fifth Third 600% NonCumulative Perpetual Class B Preferred Stock, Series A',

    'NASDAQ symbol': 'FITBP',
  },
  {
    symbol: 'FITE',
    'Security Name': 'SPDR S&P Kensho Future Security ETF ',

    'CQS symbol': 'FITE',
    'NASDAQ symbol': 'FITE',
  },
  {
    symbol: 'FIV',
    'Security Name':
      'First Trust Senior Floating Rate 2022 Target Term Fund Common Shares of Beneficial Interest',

    'CQS symbol': 'FIV',
    'NASDAQ symbol': 'FIV',
  },
  {
    symbol: 'FIVA',
    'Security Name': 'Fidelity International Value Factor ETF',

    'CQS symbol': 'FIVA',
    'NASDAQ symbol': 'FIVA',
  },
  {
    symbol: 'FIVE',
    'Security Name': 'Five Below,   ',

    'NASDAQ symbol': 'FIVE',
  },
  {
    symbol: 'FIVG',
    'Security Name': 'Defiance Next Gen Connectivity ETF',

    'CQS symbol': 'FIVG',
    'NASDAQ symbol': 'FIVG',
  },
  {
    symbol: 'FIVN',
    'Security Name': 'Five9,   ',

    'NASDAQ symbol': 'FIVN',
  },
  {
    symbol: 'FIW',
    'Security Name': 'First Trust Water ETF',

    'CQS symbol': 'FIW',
    'NASDAQ symbol': 'FIW',
  },
  {
    symbol: 'FIX',
    'Security Name': 'Comfort Systems USA,  ',

    'CQS symbol': 'FIX',
    'NASDAQ symbol': 'FIX',
  },
  {
    symbol: 'FIXD',
    'Security Name': 'First Trust TCW Opportunistic Fixed ome ETF',

    'NASDAQ symbol': 'FIXD',
  },
  {
    symbol: 'FIXX',
    'Security Name': 'Homology Medicines,   ',

    'NASDAQ symbol': 'FIXX',
  },
  {
    symbol: 'FIYY',
    'Security Name':
      'Barclays ETN  FI Enhanced Global High Yield Exchange Traded Notes Series B',

    'CQS symbol': 'FIYY',
    'NASDAQ symbol': 'FIYY',
  },
  {
    symbol: 'FIZZ',
    'Security Name': 'National Beverage Corp  ',

    'NASDAQ symbol': 'FIZZ',
  },
  {
    symbol: 'FJNK',
    'Security Name': 'Pacific Global Focused High Yield ETF',

    'CQS symbol': 'FJNK',
    'NASDAQ symbol': 'FJNK',
  },
  {
    symbol: 'FJP',
    'Security Name': 'First Trust Japan AlphaDEX Fund',

    'NASDAQ symbol': 'FJP',
  },
  {
    symbol: 'FJUL',
    'Security Name': 'FT Cboe Vest US Equity Buffer ETF  July',

    'CQS symbol': 'FJUL',
    'NASDAQ symbol': 'FJUL',
  },
  {
    symbol: 'FJUN',
    'Security Name': 'FT Cboe Vest US Equity Buffer ETF  June',

    'CQS symbol': 'FJUN',
    'NASDAQ symbol': 'FJUN',
  },
  {
    symbol: 'FKU',
    'Security Name': 'First Trust United Kingdom AlphaDEX Fund',

    'NASDAQ symbol': 'FKU',
  },
  {
    symbol: 'FL',
    'Security Name': 'Foot Locker, ',

    'CQS symbol': 'FL',
    'NASDAQ symbol': 'FL',
  },
  {
    symbol: 'FLAU',
    'Security Name': 'Franklin FTSE Australia ETF',

    'CQS symbol': 'FLAU',
    'NASDAQ symbol': 'FLAU',
  },
  {
    symbol: 'FLAX',
    'Security Name': 'Franklin FTSE Asia ex Japan ETF',

    'CQS symbol': 'FLAX',
    'NASDAQ symbol': 'FLAX',
  },
  {
    symbol: 'FLBL',
    'Security Name': 'Franklin Liberty Senior Loan ETF',

    'CQS symbol': 'FLBL',
    'NASDAQ symbol': 'FLBL',
  },
  {
    symbol: 'FLBR',
    'Security Name': 'Franklin FTSE Brazil ETF',

    'CQS symbol': 'FLBR',
    'NASDAQ symbol': 'FLBR',
  },
  {
    symbol: 'FLC',
    'Security Name': 'Flaherty & Crumrine Total Return Fund  ',

    'CQS symbol': 'FLC',
    'NASDAQ symbol': 'FLC',
  },
  {
    symbol: 'FLCA',
    'Security Name': 'Franklin FTSE Canada ETF',

    'CQS symbol': 'FLCA',
    'NASDAQ symbol': 'FLCA',
  },
  {
    symbol: 'FLCB',
    'Security Name': 'Franklin Liberty US Core Bond ETF',

    'CQS symbol': 'FLCB',
    'NASDAQ symbol': 'FLCB',
  },
  {
    symbol: 'FLCH',
    'Security Name': 'Franklin FTSE China ETF',

    'CQS symbol': 'FLCH',
    'NASDAQ symbol': 'FLCH',
  },
  {
    symbol: 'FLCO',
    'Security Name': 'Franklin Liberty Investment Grade Corporate ETF',

    'CQS symbol': 'FLCO',
    'NASDAQ symbol': 'FLCO',
  },
  {
    symbol: 'FLDM',
    'Security Name': 'Fluidigm Corporation  ',

    'NASDAQ symbol': 'FLDM',
  },
  {
    symbol: 'FLDR',
    'Security Name': 'Fidelity Low Duration Bond Factor ETF',

    'CQS symbol': 'FLDR',
    'NASDAQ symbol': 'FLDR',
  },
  {
    symbol: 'FLEE',
    'Security Name': 'Franklin FTSE Europe ETF',

    'CQS symbol': 'FLEE',
    'NASDAQ symbol': 'FLEE',
  },
  {
    symbol: 'FLEH',
    'Security Name': 'Franklin FTSE Europe Hedged ETF',

    'CQS symbol': 'FLEH',
    'NASDAQ symbol': 'FLEH',
  },
  {
    symbol: 'FLEU',
    'Security Name': 'Barclays ETN  FI Enhanced Europe 50 ETN Series B',

    'CQS symbol': 'FLEU',
    'NASDAQ symbol': 'FLEU',
  },
  {
    symbol: 'FLEX',
    'Security Name': 'Flex Ltd  Ordinary Shares',

    'NASDAQ symbol': 'FLEX',
  },
  {
    symbol: 'FLFR',
    'Security Name': 'Franklin FTSE France ETF',

    'CQS symbol': 'FLFR',
    'NASDAQ symbol': 'FLFR',
  },
  {
    symbol: 'FLGB',
    'Security Name': 'Franklin FTSE United Kingdom ETF',

    'CQS symbol': 'FLGB',
    'NASDAQ symbol': 'FLGB',
  },
  {
    symbol: 'FLGE',
    'Security Name': 'Credit Suisse FI Large Cap Growth Enhanced ETN',

    'CQS symbol': 'FLGE',
    'NASDAQ symbol': 'FLGE',
  },
  {
    symbol: 'FLGR',
    'Security Name': 'Franklin FTSE Germany ETF',

    'CQS symbol': 'FLGR',
    'NASDAQ symbol': 'FLGR',
  },
  {
    symbol: 'FLGT',
    'Security Name': 'Fulgent Genetics,   ',

    'NASDAQ symbol': 'FLGT',
  },
  {
    symbol: 'FLGV',
    'Security Name': 'Franklin Liberty US Treasury Bond ETF',

    'CQS symbol': 'FLGV',
    'NASDAQ symbol': 'FLGV',
  },
  {
    symbol: 'FLHK',
    'Security Name': 'Franklin FTSE Hong Kong ETF',

    'CQS symbol': 'FLHK',
    'NASDAQ symbol': 'FLHK',
  },
  {
    symbol: 'FLHY',
    'Security Name': 'Franklin Liberty High Yield Corporate ETF ',

    'CQS symbol': 'FLHY',
    'NASDAQ symbol': 'FLHY',
  },
  {
    symbol: 'FLIA',
    'Security Name': 'Franklin Liberty International Aggregate Bond ETF ',

    'CQS symbol': 'FLIA',
    'NASDAQ symbol': 'FLIA',
  },
  {
    symbol: 'FLIC',
    'Security Name': 'The First of Long Island Corporation  ',

    'NASDAQ symbol': 'FLIC',
  },
  {
    symbol: 'FLIN',
    'Security Name': 'Franklin FTSE India ETF',

    'CQS symbol': 'FLIN',
    'NASDAQ symbol': 'FLIN',
  },
  {
    symbol: 'FLIR',
    'Security Name': 'FLIR Systems,   ',

    'NASDAQ symbol': 'FLIR',
  },
  {
    symbol: 'FLIY',
    'Security Name': 'Franklin FTSE Italy ETF',

    'CQS symbol': 'FLIY',
    'NASDAQ symbol': 'FLIY',
  },
  {
    symbol: 'FLJH',
    'Security Name': 'Franklin FTSE Japan Hedged ETF',

    'CQS symbol': 'FLJH',
    'NASDAQ symbol': 'FLJH',
  },
  {
    symbol: 'FLJP',
    'Security Name': 'Franklin FTSE Japan ETF',

    'CQS symbol': 'FLJP',
    'NASDAQ symbol': 'FLJP',
  },
  {
    symbol: 'FLKR',
    'Security Name': 'Franklin FTSE South Korea ETF',

    'CQS symbol': 'FLKR',
    'NASDAQ symbol': 'FLKR',
  },
  {
    symbol: 'FLL',
    'Security Name': 'Full House Resorts,   ',

    'NASDAQ symbol': 'FLL',
  },
  {
    symbol: 'FLLA',
    'Security Name': 'Franklin FTSE Latin America ETF',

    'CQS symbol': 'FLLA',
    'NASDAQ symbol': 'FLLA',
  },
  {
    symbol: 'FLLV',
    'Security Name': 'Franklin Liberty US Low Volatility ETF',

    'CQS symbol': 'FLLV',
    'NASDAQ symbol': 'FLLV',
  },
  {
    symbol: 'FLM',
    'Security Name': 'First Trust Global Engineering and Construction ETF',

    'CQS symbol': 'FLM',
    'NASDAQ symbol': 'FLM',
  },
  {
    symbol: 'FLMB',
    'Security Name':
      'Franklin Templeton ETF Trust Franklin Liberty Federal TaxFree Bond ETF',

    'CQS symbol': 'FLMB',
    'NASDAQ symbol': 'FLMB',
  },
  {
    symbol: 'FLMI',
    'Security Name':
      'Franklin Templeton ETF Trust Franklin Liberty Federal Intermediate TaxFree Bond Opportunities ETF',

    'CQS symbol': 'FLMI',
    'NASDAQ symbol': 'FLMI',
  },
  {
    symbol: 'FLMN',
    'Security Name': 'Falcon Minerals Corporation   ',

    'NASDAQ symbol': 'FLMN',
  },
  {
    symbol: 'FLMNW',
    'Security Name': 'Falcon Minerals Corporation  Warrant',

    'NASDAQ symbol': 'FLMNW',
  },
  {
    symbol: 'FLMX',
    'Security Name': 'Franklin FTSE Mexico ETF',

    'CQS symbol': 'FLMX',
    'NASDAQ symbol': 'FLMX',
  },
  {
    symbol: 'FLN',
    'Security Name': 'First Trust Latin America AlphaDEX Fund',

    'NASDAQ symbol': 'FLN',
  },
  {
    symbol: 'FLNG',
    'Security Name': 'FLEX LNG Ltd Ordinary Shares',

    'CQS symbol': 'FLNG',
    'NASDAQ symbol': 'FLNG',
  },
  {
    symbol: 'FLNT',
    'Security Name': 'Fluent,   ',

    'NASDAQ symbol': 'FLNT',
  },
  {
    symbol: 'FLO',
    'Security Name': 'Flowers Foods,  ',

    'CQS symbol': 'FLO',
    'NASDAQ symbol': 'FLO',
  },
  {
    symbol: 'FLOT',
    'Security Name': 'iShares Floating Rate Bond ETF',

    'CQS symbol': 'FLOT',
    'NASDAQ symbol': 'FLOT',
  },
  {
    symbol: 'FLOW',
    'Security Name': 'SPX FLOW,  ',

    'CQS symbol': 'FLOW',
    'NASDAQ symbol': 'FLOW',
  },
  {
    symbol: 'FLQD',
    'Security Name': 'Franklin LibertyQ Global Dividend ETF',

    'CQS symbol': 'FLQD',
    'NASDAQ symbol': 'FLQD',
  },
  {
    symbol: 'FLQE',
    'Security Name': 'Franklin LibertyQ Emerging Markets ETF',

    'CQS symbol': 'FLQE',
    'NASDAQ symbol': 'FLQE',
  },
  {
    symbol: 'FLQG',
    'Security Name': 'Franklin LibertyQ Global Equity ETF',

    'CQS symbol': 'FLQG',
    'NASDAQ symbol': 'FLQG',
  },
  {
    symbol: 'FLQH',
    'Security Name': 'Franklin LibertyQ International Equity Hedged ETF',

    'CQS symbol': 'FLQH',
    'NASDAQ symbol': 'FLQH',
  },
  {
    symbol: 'FLQL',
    'Security Name': 'Franklin LibertyQ US Equity ETF',

    'CQS symbol': 'FLQL',
    'NASDAQ symbol': 'FLQL',
  },
  {
    symbol: 'FLQM',
    'Security Name': 'Franklin LibertyQ US Mid Cap Equity ETF',

    'CQS symbol': 'FLQM',
    'NASDAQ symbol': 'FLQM',
  },
  {
    symbol: 'FLQS',
    'Security Name': 'Franklin LibertyQ US Small Cap Equity ETF',

    'CQS symbol': 'FLQS',
    'NASDAQ symbol': 'FLQS',
  },
  {
    symbol: 'FLR',
    'Security Name': 'Fluor Corporation ',

    'CQS symbol': 'FLR',
    'NASDAQ symbol': 'FLR',
  },
  {
    symbol: 'FLRG',
    'Security Name': 'Fidelity US Multifactor ETF',

    'CQS symbol': 'FLRG',
    'NASDAQ symbol': 'FLRG',
  },
  {
    symbol: 'FLRN',
    'Security Name':
      'SPDR Bloomberg Barclays Investment Grade Floating Rate ETF',

    'CQS symbol': 'FLRN',
    'NASDAQ symbol': 'FLRN',
  },
  {
    symbol: 'FLRT',
    'Security Name': 'Pacific Global ETF Trust Pacific Global Senior Loan ETF',

    'CQS symbol': 'FLRT',
    'NASDAQ symbol': 'FLRT',
  },
  {
    symbol: 'FLRU',
    'Security Name': 'Franklin FTSE Russia ETF',

    'CQS symbol': 'FLRU',
    'NASDAQ symbol': 'FLRU',
  },
  {
    symbol: 'FLS',
    'Security Name': 'Flowserve Corporation ',

    'CQS symbol': 'FLS',
    'NASDAQ symbol': 'FLS',
  },
  {
    symbol: 'FLSA',
    'Security Name': 'Franklin FTSE Saudi Arabia ETF',

    'CQS symbol': 'FLSA',
    'NASDAQ symbol': 'FLSA',
  },
  {
    symbol: 'FLSP',
    'Security Name': 'Franklin Liberty Systematic Style Premia ETF',

    'CQS symbol': 'FLSP',
    'NASDAQ symbol': 'FLSP',
  },
  {
    symbol: 'FLSW',
    'Security Name': 'Franklin FTSE Switzerland ETF',

    'CQS symbol': 'FLSW',
    'NASDAQ symbol': 'FLSW',
  },
  {
    symbol: 'FLT',
    'Security Name': 'FleetCor Technologies,  ',

    'CQS symbol': 'FLT',
    'NASDAQ symbol': 'FLT',
  },
  {
    symbol: 'FLTB',
    'Security Name': 'Fidelity Limited Term Bond ETF',

    'CQS symbol': 'FLTB',
    'NASDAQ symbol': 'FLTB',
  },
  {
    symbol: 'FLTR',
    'Security Name': 'VanEck Vectors Investment Grade Floating Rate ETF',

    'CQS symbol': 'FLTR',
    'NASDAQ symbol': 'FLTR',
  },
  {
    symbol: 'FLTW',
    'Security Name': 'Franklin FTSE Taiwan ETF',

    'CQS symbol': 'FLTW',
    'NASDAQ symbol': 'FLTW',
  },
  {
    symbol: 'FLUD',
    'Security Name': 'Franklin Liberty Ultra Short Bond ETF',

    'CQS symbol': 'FLUD',
    'NASDAQ symbol': 'FLUD',
  },
  {
    symbol: 'FLUX',
    'Security Name': 'Flux Power Holdings,   ',

    'NASDAQ symbol': 'FLUX',
  },
  {
    symbol: 'FLV',
    'Security Name': 'American Century Focused Large Cap Value ETF',

    'CQS symbol': 'FLV',
    'NASDAQ symbol': 'FLV',
  },
  {
    symbol: 'FLWS',
    'Security Name': '1800FLOWERSCOM,    ',

    'NASDAQ symbol': 'FLWS',
  },
  {
    symbol: 'FLXN',
    'Security Name': 'Flexion Therapeutics,   ',

    'NASDAQ symbol': 'FLXN',
  },
  {
    symbol: 'FLXS',
    'Security Name': 'Flexsteel Industries,   ',

    'NASDAQ symbol': 'FLXS',
  },
  {
    symbol: 'FLY',
    'Security Name': 'Fly Leasing Limited',

    'CQS symbol': 'FLY',
    'NASDAQ symbol': 'FLY',
  },
  {
    symbol: 'FLYT',
    'Security Name': 'Direxion Flight to Safety Strategy ETF',

    'CQS symbol': 'FLYT',
    'NASDAQ symbol': 'FLYT',
  },
  {
    symbol: 'FLZA',
    'Security Name': 'Franklin FTSE South Africa ETF',

    'CQS symbol': 'FLZA',
    'NASDAQ symbol': 'FLZA',
  },
  {
    symbol: 'FM',
    'Security Name': 'iShares MSCI Frontier 100 Fund',

    'CQS symbol': 'FM',
    'NASDAQ symbol': 'FM',
  },
  {
    symbol: 'FMAC',
    'Security Name': 'FirstMark Horizon Acquisition Corp  ',

    'CQS symbol': 'FMAC',
    'NASDAQ symbol': 'FMAC',
  },
  {
    symbol: 'FMACU',
    'Security Name':
      'FirstMark Horizon Acquisition Corp Units, each consisting of one share of   and onethird of one redeemable warrant',

    'CQS symbol': 'FMACU',
    'NASDAQ symbol': 'FMAC=',
  },
  {
    symbol: 'FMACW',
    'Security Name':
      'FirstMark Horizon Acquisition Corp Redeemable warrants, each whole warrant exercisable for one share of   at an exercise price of $1150',

    'CQS symbol': 'FMACWS',
    'NASDAQ symbol': 'FMAC+',
  },
  {
    symbol: 'FMAO',
    'Security Name': 'Farmers & Merchants Bancorp,   ',

    'NASDAQ symbol': 'FMAO',
  },
  {
    symbol: 'FMAT',
    'Security Name': 'Fidelity MSCI Materials Index ETF',

    'CQS symbol': 'FMAT',
    'NASDAQ symbol': 'FMAT',
  },
  {
    symbol: 'FMAY',
    'Security Name': 'FT Cboe Vest US Equity Buffer ETF  May',

    'CQS symbol': 'FMAY',
    'NASDAQ symbol': 'FMAY',
  },
  {
    symbol: 'FMB',
    'Security Name': 'First Trust Managed Municipal ETF',

    'NASDAQ symbol': 'FMB',
  },
  {
    symbol: 'FMBH',
    'Security Name': 'First Mid Bancshares,   ',

    'NASDAQ symbol': 'FMBH',
  },
  {
    symbol: 'FMBI',
    'Security Name': 'First Midwest Bancorp,   ',

    'NASDAQ symbol': 'FMBI',
  },
  {
    symbol: 'FMBIO',
    'Security Name':
      'First Midwest Bancorp,   Depositary Shares Each Representing a 1/40th Interest in a Share of Fixed Rate NonCumulative Perpetual Preferred Stock, Series C',

    'NASDAQ symbol': 'FMBIO',
  },
  {
    symbol: 'FMBIP',
    'Security Name':
      'First Midwest Bancorp,   Depositary Shares Each Representing a 1/40th Interest in a Share of Fixed Rate NonCumulative Perpetual Preferred Stock, Series A',

    'NASDAQ symbol': 'FMBIP',
  },
  {
    symbol: 'FMC',
    'Security Name': 'FMC Corporation ',

    'CQS symbol': 'FMC',
    'NASDAQ symbol': 'FMC',
  },
  {
    symbol: 'FMF',
    'Security Name': 'First Trust Managed Futures Strategy Fund',

    'CQS symbol': 'FMF',
    'NASDAQ symbol': 'FMF',
  },
  {
    symbol: 'FMHI',
    'Security Name': 'First Trust Municipal High ome ETF',

    'NASDAQ symbol': 'FMHI',
  },
  {
    symbol: 'FMIL',
    'Security Name': 'Fidelity New Millennium ETF',

    'CQS symbol': 'FMIL',
    'NASDAQ symbol': 'FMIL',
  },
  {
    symbol: 'FMK',
    'Security Name': 'First Trust Mega Cap AlphaDEX Fund',

    'NASDAQ symbol': 'FMK',
  },
  {
    symbol: 'FMN',
    'Security Name': 'Federated Hermes Premier Municipal ome Fund',

    'CQS symbol': 'FMN',
    'NASDAQ symbol': 'FMN',
  },
  {
    symbol: 'FMNB',
    'Security Name': 'Farmers National Banc Corp  ',

    'NASDAQ symbol': 'FMNB',
  },
  {
    symbol: 'FMO',
    'Security Name':
      'Fiduciary/Claymore Energy Infrastructure Fund Common Shares of Beneficial Interest',

    'CQS symbol': 'FMO',
    'NASDAQ symbol': 'FMO',
  },
  {
    symbol: 'FMS',
    'Security Name': 'Fresenius Medical Care AG ',

    'CQS symbol': 'FMS',
    'NASDAQ symbol': 'FMS',
  },
  {
    symbol: 'FMTX',
    'Security Name': 'Forma Therapeutics Holdings,   ',

    'NASDAQ symbol': 'FMTX',
  },
  {
    symbol: 'FMX',
    'Security Name': 'Fomento Economico Mexicano SAB de CV ',

    'CQS symbol': 'FMX',
    'NASDAQ symbol': 'FMX',
  },
  {
    symbol: 'FMY',
    'Security Name':
      'First Trust Motgage ome Fund Common Shares of Beneficial Interest',

    'CQS symbol': 'FMY',
    'NASDAQ symbol': 'FMY',
  },
  {
    symbol: 'FN',
    'Security Name': 'Fabrinet Ordinary Shares',

    'CQS symbol': 'FN',
    'NASDAQ symbol': 'FN',
  },
  {
    symbol: 'FNB',
    'Security Name': 'FNB Corporation ',

    'CQS symbol': 'FNB',
    'NASDAQ symbol': 'FNB',
  },
  {
    symbol: 'FNB$E',
    'Security Name':
      'FNB Corporation Depositary Shares, each representing a 1/40th interest in a share of FixedtoFloating Rate NonCumulative Perpetual Preferred  Stock, Series E',

    'CQS symbol': 'FNBpE',
    'NASDAQ symbol': 'FNBE',
  },
  {
    symbol: 'FNCB',
    'Security Name': 'FNCB Bancorp   ',

    'NASDAQ symbol': 'FNCB',
  },
  {
    symbol: 'FNCL',
    'Security Name': 'Fidelity MSCI Financials Index ETF',

    'CQS symbol': 'FNCL',
    'NASDAQ symbol': 'FNCL',
  },
  {
    symbol: 'FND',
    'Security Name': 'Floor & Decor Holdings,  ',

    'CQS symbol': 'FND',
    'NASDAQ symbol': 'FND',
  },
  {
    symbol: 'FNDA',
    'Security Name': 'Schwab Fundamental US Small Company Index ETF',

    'CQS symbol': 'FNDA',
    'NASDAQ symbol': 'FNDA',
  },
  {
    symbol: 'FNDB',
    'Security Name': 'Schwab Fundamental US Broad Market Index ETF',

    'CQS symbol': 'FNDB',
    'NASDAQ symbol': 'FNDB',
  },
  {
    symbol: 'FNDC',
    'Security Name': 'Schwab Fundamental International Small Company Index ETF',

    'CQS symbol': 'FNDC',
    'NASDAQ symbol': 'FNDC',
  },
  {
    symbol: 'FNDE',
    'Security Name':
      'Schwab Fundamental Emerging Markets Large Company Index ETF',

    'CQS symbol': 'FNDE',
    'NASDAQ symbol': 'FNDE',
  },
  {
    symbol: 'FNDF',
    'Security Name': 'Schwab Fundamental International Large Company Index ETF',

    'CQS symbol': 'FNDF',
    'NASDAQ symbol': 'FNDF',
  },
  {
    symbol: 'FNDX',
    'Security Name': 'Schwab Fundamental US Large Company Index ETF',

    'CQS symbol': 'FNDX',
    'NASDAQ symbol': 'FNDX',
  },
  {
    symbol: 'FNF',
    'Security Name': 'FNF Group of Fidelity National Financial,  ',

    'CQS symbol': 'FNF',
    'NASDAQ symbol': 'FNF',
  },
  {
    symbol: 'FNGD',
    'Security Name':
      'MicroSectors FANG  Index 3X Inverse Leveraged ETNs due January 8, 2038',

    'CQS symbol': 'FNGD',
    'NASDAQ symbol': 'FNGD',
  },
  {
    symbol: 'FNGO',
    'Security Name':
      'MicroSectors FANG  Index 2X Leveraged ETNs due January 8, 2038',

    'CQS symbol': 'FNGO',
    'NASDAQ symbol': 'FNGO',
  },
  {
    symbol: 'FNGS',
    'Security Name': 'MicroSectors FANG  ETNs due January 8, 2038',

    'CQS symbol': 'FNGS',
    'NASDAQ symbol': 'FNGS',
  },
  {
    symbol: 'FNGU',
    'Security Name':
      'MicroSectors FANG  Index 3X Leveraged ETNs due January 8, 2038',

    'CQS symbol': 'FNGU',
    'NASDAQ symbol': 'FNGU',
  },
  {
    symbol: 'FNGZ',
    'Security Name':
      'MicroSectors FANG  Index 2X Inverse Leveraged ETNs due January 8, 2038',

    'CQS symbol': 'FNGZ',
    'NASDAQ symbol': 'FNGZ',
  },
  {
    symbol: 'FNHC',
    'Security Name': 'FedNat Holding Company  ',

    'NASDAQ symbol': 'FNHC',
  },
  {
    symbol: 'FNI',
    'Security Name': 'First Trust Chindia ETF',

    'CQS symbol': 'FNI',
    'NASDAQ symbol': 'FNI',
  },
  {
    symbol: 'FNK',
    'Security Name': 'First Trust Mid Cap Value AlphaDEX Fund',

    'NASDAQ symbol': 'FNK',
  },
  {
    symbol: 'FNKO',
    'Security Name': 'Funko,    ',

    'NASDAQ symbol': 'FNKO',
  },
  {
    symbol: 'FNLC',
    'Security Name': 'First Bancorp,  (ME)  ',

    'NASDAQ symbol': 'FNLC',
  },
  {
    symbol: 'FNOV',
    'Security Name': 'FT Cboe Vest US Equity Buffer ETF  November',

    'CQS symbol': 'FNOV',
    'NASDAQ symbol': 'FNOV',
  },
  {
    symbol: 'FNV',
    'Security Name': 'FrancoNevada Corporation',

    'CQS symbol': 'FNV',
    'NASDAQ symbol': 'FNV',
  },
  {
    symbol: 'FNWB',
    'Security Name': 'First Northwest Bancorp  ',

    'NASDAQ symbol': 'FNWB',
  },
  {
    symbol: 'FNX',
    'Security Name': 'First Trust Mid Cap Core AlphaDEX Fund',

    'NASDAQ symbol': 'FNX',
  },
  {
    symbol: 'FNY',
    'Security Name': 'First Trust Mid Cap Growth AlphaDEX Fund',

    'NASDAQ symbol': 'FNY',
  },
  {
    symbol: 'FOCS',
    'Security Name': 'Focus Financial Partners   ',

    'NASDAQ symbol': 'FOCS',
  },
  {
    symbol: 'FOCT',
    'Security Name': 'FT Cboe Vest US Equity Buffer ETF  October',

    'CQS symbol': 'FOCT',
    'NASDAQ symbol': 'FOCT',
  },
  {
    symbol: 'FOE',
    'Security Name': 'Ferro Corporation ',

    'CQS symbol': 'FOE',
    'NASDAQ symbol': 'FOE',
  },
  {
    symbol: 'FOF',
    'Security Name': 'Cohen & Steers ClosedEnd Opportunity Fund,  ',

    'CQS symbol': 'FOF',
    'NASDAQ symbol': 'FOF',
  },
  {
    symbol: 'FOLD',
    'Security Name': 'Amicus Therapeutics,   ',

    'NASDAQ symbol': 'FOLD',
  },
  {
    symbol: 'FONR',
    'Security Name': 'Fonar Corporation  ',

    'NASDAQ symbol': 'FONR',
  },
  {
    symbol: 'FOR',
    'Security Name': 'Forestar Group   ',

    'CQS symbol': 'FOR',
    'NASDAQ symbol': 'FOR',
  },
  {
    symbol: 'FORD',
    'Security Name': 'Forward Industries,   ',

    'NASDAQ symbol': 'FORD',
  },
  {
    symbol: 'FORM',
    'Security Name': 'FormFactor,   ',

    'NASDAQ symbol': 'FORM',
  },
  {
    symbol: 'FORR',
    'Security Name': 'Forrester Research,   ',

    'NASDAQ symbol': 'FORR',
  },
  {
    symbol: 'FORTY',
    'Security Name': 'Formula Systems (1985) Ltd  American Depositary Shares',

    'NASDAQ symbol': 'FORTY',
  },
  {
    symbol: 'FOSL',
    'Security Name': 'Fossil Group,   ',

    'NASDAQ symbol': 'FOSL',
  },
  {
    symbol: 'FOUR',
    'Security Name': 'Shift4 Payments,   ',

    'CQS symbol': 'FOUR',
    'NASDAQ symbol': 'FOUR',
  },
  {
    symbol: 'FOVL',
    'Security Name': 'iShares Focused Value Factor ETF',

    'CQS symbol': 'FOVL',
    'NASDAQ symbol': 'FOVL',
  },
  {
    symbol: 'FOX',
    'Security Name': 'Fox Corporation  Class B ',

    'NASDAQ symbol': 'FOX',
  },
  {
    symbol: 'FOXA',
    'Security Name': 'Fox Corporation   ',

    'NASDAQ symbol': 'FOXA',
  },
  {
    symbol: 'FOXF',
    'Security Name': 'Fox Factory Holding Corp  ',

    'NASDAQ symbol': 'FOXF',
  },
  {
    symbol: 'FPA',
    'Security Name': 'First Trust Asia Pacific ExJapan AlphaDEX Fund',

    'NASDAQ symbol': 'FPA',
  },
  {
    symbol: 'FPACU',
    'Security Name':
      'Far Peak Acquisition Corporation Units, each consisting of one  ordinary share, and onethird of one redeemable warrant',

    'CQS symbol': 'FPACU',
    'NASDAQ symbol': 'FPAC=',
  },
  {
    symbol: 'FPAY',
    'Security Name': 'FlexShopper,   ',

    'NASDAQ symbol': 'FPAY',
  },
  {
    symbol: 'FPE',
    'Security Name': 'First Trust Preferred Securities and ome ETF ETF',

    'CQS symbol': 'FPE',
    'NASDAQ symbol': 'FPE',
  },
  {
    symbol: 'FPEI',
    'Security Name':
      'First Trust Institutional Preferred Securities and ome ETF',

    'CQS symbol': 'FPEI',
    'NASDAQ symbol': 'FPEI',
  },
  {
    symbol: 'FPF',
    'Security Name':
      'First Trust Intermediate Duration Preferred & ome Fund Common Shares of Beneficial Interest',

    'CQS symbol': 'FPF',
    'NASDAQ symbol': 'FPF',
  },
  {
    symbol: 'FPH',
    'Security Name': 'Five Point Holdings, LLC  Common Shares',

    'CQS symbol': 'FPH',
    'NASDAQ symbol': 'FPH',
  },
  {
    symbol: 'FPI',
    'Security Name': 'Farmland Partners  ',

    'CQS symbol': 'FPI',
    'NASDAQ symbol': 'FPI',
  },
  {
    symbol: 'FPI$B',
    'Security Name':
      'Farmland Partners  Series B Participating Preferred Stock',

    'CQS symbol': 'FPIpB',
    'NASDAQ symbol': 'FPIB',
  },
  {
    symbol: 'FPL',
    'Security Name':
      'First Trust New Opportunities MLP & Energy Fund Common Shares of Beneficial Interest',

    'CQS symbol': 'FPL',
    'NASDAQ symbol': 'FPL',
  },
  {
    symbol: 'FPRX',
    'Security Name': 'Five Prime Therapeutics,   ',

    'NASDAQ symbol': 'FPRX',
  },
  {
    symbol: 'FPX',
    'Security Name': 'First Trust US Equity Opportunities ETF',

    'CQS symbol': 'FPX',
    'NASDAQ symbol': 'FPX',
  },
  {
    symbol: 'FPXE',
    'Security Name': 'First Trust IPOX Europe Equity Opportunities ETF',

    'NASDAQ symbol': 'FPXE',
  },
  {
    symbol: 'FPXI',
    'Security Name': 'First Trust International Equity Opportunities ETF',

    'NASDAQ symbol': 'FPXI',
  },
  {
    symbol: 'FQAL',
    'Security Name': 'Fidelity Quality Factor ETF',

    'CQS symbol': 'FQAL',
    'NASDAQ symbol': 'FQAL',
  },
  {
    symbol: 'FR',
    'Security Name': 'First Industrial Realty Trust,  ',

    'CQS symbol': 'FR',
    'NASDAQ symbol': 'FR',
  },
  {
    symbol: 'FRA',
    'Security Name': 'Blackrock Floating Rate ome Strategies Fund   ',

    'CQS symbol': 'FRA',
    'NASDAQ symbol': 'FRA',
  },
  {
    symbol: 'FRAF',
    'Security Name': 'Franklin Financial Services Corporation  ',

    'NASDAQ symbol': 'FRAF',
  },
  {
    symbol: 'FRAK',
    'Security Name': 'VanEck Vectors Unconventional Oil & Gas ETF',

    'CQS symbol': 'FRAK',
    'NASDAQ symbol': 'FRAK',
  },
  {
    symbol: 'FRAN',
    'Security Name': "Francesca's Holdings Corporation  ",

    'NASDAQ symbol': 'FRAN',
  },
  {
    symbol: 'FRBA',
    'Security Name': 'First Bank  ',

    'NASDAQ symbol': 'FRBA',
  },
  {
    symbol: 'FRBK',
    'Security Name': 'Republic First Bancorp,   ',

    'NASDAQ symbol': 'FRBK',
  },
  {
    symbol: 'FRC',
    'Security Name': 'FIRST REPUBLIC BANK ',

    'CQS symbol': 'FRC',
    'NASDAQ symbol': 'FRC',
  },
  {
    symbol: 'FRC$G',
    'Security Name':
      'FIRST REPUBLIC BANK Depositary Shares, each representing a 1/40th interest in a share of 550% Noncumulative Perpetual Series G Preferred Stock',

    'CQS symbol': 'FRCpG',
    'NASDAQ symbol': 'FRCG',
  },
  {
    symbol: 'FRC$H',
    'Security Name':
      'FIRST REPUBLIC BANK Depositary Shares, each representing a 1/40th interest in a share of 5125% Noncumulative Perpetual Series H Preferred Stock, par value $001 per share',

    'CQS symbol': 'FRCpH',
    'NASDAQ symbol': 'FRCH',
  },
  {
    symbol: 'FRC$I',
    'Security Name':
      'FIRST REPUBLIC BANK Depositary Shares, each representing a 1/40th interest in a share of 550% Noncumulative Perpetual Series I Preferred Stock, par value $001 per share',

    'CQS symbol': 'FRCpI',
    'NASDAQ symbol': 'FRCI',
  },
  {
    symbol: 'FRC$J',
    'Security Name':
      'FIRST REPUBLIC BANK Depositary Shares, Each Representing a 1/40th Interest in a Share of 470% Noncumulative Perpetual Series J Preferred Stock',

    'CQS symbol': 'FRCpJ',
    'NASDAQ symbol': 'FRCJ',
  },
  {
    symbol: 'FRC$K',
    'Security Name':
      'FIRST REPUBLIC BANK Depositary Shares, Each Representing a 1/40th Interest in a Share of 4125% Noncumulative Perpetual Series K Preferred Stock',

    'CQS symbol': 'FRCpK',
    'NASDAQ symbol': 'FRCK',
  },
  {
    symbol: 'FRD',
    'Security Name': 'Friedman Industries  ',

    'CQS symbol': 'FRD',
    'NASDAQ symbol': 'FRD',
  },
  {
    symbol: 'FRDM',
    'Security Name': 'Freedom 100 Emerging Markets ETF',

    'CQS symbol': 'FRDM',
    'NASDAQ symbol': 'FRDM',
  },
  {
    symbol: 'FREE',
    'Security Name': 'Whole Earth Brands,    ',

    'NASDAQ symbol': 'FREE',
  },
  {
    symbol: 'FREEW',
    'Security Name': 'Whole Earth Brands,   Warrant',

    'NASDAQ symbol': 'FREEW',
  },
  {
    symbol: 'FREL',
    'Security Name': 'Fidelity MSCI Real Estate Index ETF',

    'CQS symbol': 'FREL',
    'NASDAQ symbol': 'FREL',
  },
  {
    symbol: 'FREQ',
    'Security Name': 'Frequency Therapeutics,   ',

    'NASDAQ symbol': 'FREQ',
  },
  {
    symbol: 'FRG',
    'Security Name': 'Franchise Group,   ',

    'NASDAQ symbol': 'FRG',
  },
  {
    symbol: 'FRGAP',
    'Security Name':
      'Franchise Group,   750% Series A Cumulative Perpetual Preferred Stock',

    'NASDAQ symbol': 'FRGAP',
  },
  {
    symbol: 'FRGI',
    'Security Name': 'Fiesta Restaurant Group,   ',

    'NASDAQ symbol': 'FRGI',
  },
  {
    symbol: 'FRHC',
    'Security Name': 'Freedom Holding Corp  ',

    'NASDAQ symbol': 'FRHC',
  },
  {
    symbol: 'FRI',
    'Security Name': 'First Trust S&P REIT Index Fund',

    'CQS symbol': 'FRI',
    'NASDAQ symbol': 'FRI',
  },
  {
    symbol: 'FRLG',
    'Security Name':
      'Large Cap Growth IndexLinked Exchange Traded Notes due 2028',

    'CQS symbol': 'FRLG',
    'NASDAQ symbol': 'FRLG',
  },
  {
    symbol: 'FRLN',
    'Security Name': 'Freeline Therapeutics Holdings plc  ADSs',

    'NASDAQ symbol': 'FRLN',
  },
  {
    symbol: 'FRME',
    'Security Name': 'First Merchants Corporation  ',

    'NASDAQ symbol': 'FRME',
  },
  {
    symbol: 'FRO',
    'Security Name': 'Frontline Ltd Ordinary Shares',

    'CQS symbol': 'FRO',
    'NASDAQ symbol': 'FRO',
  },
  {
    symbol: 'FROG',
    'Security Name': 'JFrog Ltd  Ordinary shares',

    'NASDAQ symbol': 'FROG',
  },
  {
    symbol: 'FRPH',
    'Security Name': 'FRP Holdings,   ',

    'NASDAQ symbol': 'FRPH',
  },
  {
    symbol: 'FRPT',
    'Security Name': 'Freshpet,   ',

    'NASDAQ symbol': 'FRPT',
  },
  {
    symbol: 'FRSX',
    'Security Name':
      'Foresight Autonomous Holdings Ltd  American Depositary Shares',

    'NASDAQ symbol': 'FRSX',
  },
  {
    symbol: 'FRT',
    'Security Name': 'Federal Realty Investment Trust ',

    'CQS symbol': 'FRT',
    'NASDAQ symbol': 'FRT',
  },
  {
    symbol: 'FRT$C',
    'Security Name':
      'Federal Realty Investment Trust Depositary Shares, each representing a 1/1000th interest in a 5000% Series C Cumulative Redeemable Preferred Share',

    'CQS symbol': 'FRTpC',
    'NASDAQ symbol': 'FRTC',
  },
  {
    symbol: 'FRTA',
    'Security Name': 'Forterra,   ',

    'NASDAQ symbol': 'FRTA',
  },
  {
    symbol: 'FRXU',
    'Security Name':
      'Forest Road Acquisition Corp Units, each consisting of one share of   and onethird of one Redeemable Warrant',

    'CQS symbol': 'FRXU',
    'NASDAQ symbol': 'FRX=',
  },
  {
    symbol: 'FSBW',
    'Security Name': 'FS Bancorp,   ',

    'NASDAQ symbol': 'FSBW',
  },
  {
    symbol: 'FSD',
    'Security Name':
      'First Trust High ome Long Short Fund Common Shares of Beneficial Interest',

    'CQS symbol': 'FSD',
    'NASDAQ symbol': 'FSD',
  },
  {
    symbol: 'FSDC',
    'Security Name': 'FS Development Corp   ',

    'NASDAQ symbol': 'FSDC',
  },
  {
    symbol: 'FSEA',
    'Security Name': 'First Seacoast Bancorp  ',

    'NASDAQ symbol': 'FSEA',
  },
  {
    symbol: 'FSEP',
    'Security Name': 'FT Cboe Vest US Equity Buffer ETF  September',

    'CQS symbol': 'FSEP',
    'NASDAQ symbol': 'FSEP',
  },
  {
    symbol: 'FSFG',
    'Security Name': 'First Savings Financial Group,   ',

    'NASDAQ symbol': 'FSFG',
  },
  {
    symbol: 'FSI',
    'Security Name': 'Flexible Solutions International   (CDA)',

    'CQS symbol': 'FSI',
    'NASDAQ symbol': 'FSI',
  },
  {
    symbol: 'FSK',
    'Security Name': 'FS KKR Capital Corp ',

    'CQS symbol': 'FSK',
    'NASDAQ symbol': 'FSK',
  },
  {
    symbol: 'FSKR',
    'Security Name': 'FS KKR Capital Corp II ',

    'CQS symbol': 'FSKR',
    'NASDAQ symbol': 'FSKR',
  },
  {
    symbol: 'FSLF',
    'Security Name': 'First Eagle Senior Loan Fund ',

    'CQS symbol': 'FSLF',
    'NASDAQ symbol': 'FSLF',
  },
  {
    symbol: 'FSLR',
    'Security Name': 'First Solar,   ',

    'NASDAQ symbol': 'FSLR',
  },
  {
    symbol: 'FSLY',
    'Security Name': 'Fastly,   ',

    'CQS symbol': 'FSLY',
    'NASDAQ symbol': 'FSLY',
  },
  {
    symbol: 'FSM',
    'Security Name': 'Fortuna Silver Mines  Ordinary Shares (Canada)',

    'CQS symbol': 'FSM',
    'NASDAQ symbol': 'FSM',
  },
  {
    symbol: 'FSMB',
    'Security Name': 'First Trust Short Duration Managed Municipal ETF',

    'CQS symbol': 'FSMB',
    'NASDAQ symbol': 'FSMB',
  },
  {
    symbol: 'FSMD',
    'Security Name': 'Fidelity SmallMid Multifactor ETF',

    'CQS symbol': 'FSMD',
    'NASDAQ symbol': 'FSMD',
  },
  {
    symbol: 'FSP',
    'Security Name': 'Franklin Street Properties Corp ',

    'CQS symbol': 'FSP',
    'NASDAQ symbol': 'FSP',
  },
  {
    symbol: 'FSR',
    'Security Name': 'Fisker   ',

    'CQS symbol': 'FSR',
    'NASDAQ symbol': 'FSR',
  },
  {
    symbol: 'FSRW',
    'Security Name': 'Fisker  Warrants, ',

    'CQS symbol': 'FSRWS',
    'NASDAQ symbol': 'FSR+',
  },
  {
    symbol: 'FSRV',
    'Security Name': 'FinServ Acquisition Corp   ',

    'NASDAQ symbol': 'FSRV',
  },
  {
    symbol: 'FSRVU',
    'Security Name': 'FinServ Acquisition Corp  Unit',

    'NASDAQ symbol': 'FSRVU',
  },
  {
    symbol: 'FSRVW',
    'Security Name': 'FinServ Acquisition Corp  Warrant',

    'NASDAQ symbol': 'FSRVW',
  },
  {
    symbol: 'FSS',
    'Security Name': 'Federal Signal Corporation ',

    'CQS symbol': 'FSS',
    'NASDAQ symbol': 'FSS',
  },
  {
    symbol: 'FST',
    'Security Name': 'FAST Acquisition Corp  ',

    'CQS symbol': 'FST',
    'NASDAQ symbol': 'FST',
  },
  {
    symbol: 'FSTU',
    'Security Name':
      'FAST Acquisition Corp Units, each consisting of one share of   and onehalf of one redeemable warrant',

    'CQS symbol': 'FSTU',
    'NASDAQ symbol': 'FST=',
  },
  {
    symbol: 'FSTW',
    'Security Name':
      'FAST Acquisition Corp Warrants, each whole warrant exercisable for one share of   at an exercise price of $1150',

    'CQS symbol': 'FSTWS',
    'NASDAQ symbol': 'FST+',
  },
  {
    symbol: 'FSTA',
    'Security Name': 'Fidelity MSCI COnsumer Staples Index ETF',

    'CQS symbol': 'FSTA',
    'NASDAQ symbol': 'FSTA',
  },
  {
    symbol: 'FSTR',
    'Security Name': 'LB Foster Company  ',

    'NASDAQ symbol': 'FSTR',
  },
  {
    symbol: 'FSTX',
    'Security Name': 'Fstar Therapeutics,    ',

    'NASDAQ symbol': 'FSTX',
  },
  {
    symbol: 'FSV',
    'Security Name': 'FirstService Corporation  Common Shares',

    'NASDAQ symbol': 'FSV',
  },
  {
    symbol: 'FSZ',
    'Security Name': 'First Trust Switzerland AlphaDEX Fund',

    'NASDAQ symbol': 'FSZ',
  },
  {
    symbol: 'FT',
    'Security Name': 'Franklin Universal Trust ',

    'CQS symbol': 'FT',
    'NASDAQ symbol': 'FT',
  },
  {
    symbol: 'FTA',
    'Security Name': 'First Trust Large Cap Value AlphaDEX Fund',

    'NASDAQ symbol': 'FTA',
  },
  {
    symbol: 'FTAG',
    'Security Name': 'First Trust Indxx Global Agriculture ETF',

    'NASDAQ symbol': 'FTAG',
  },
  {
    symbol: 'FTAI',
    'Security Name':
      'Fortress Transportation and Infrastructure Investors LLC Common Shares',

    'CQS symbol': 'FTAI',
    'NASDAQ symbol': 'FTAI',
  },
  {
    symbol: 'FTAI$A',
    'Security Name':
      'Fortress Transportation and Infrastructure Investors LLC 825% Fixed to Floating Rate Series A Cumulative Perpetual Redeemable Preferred Shares',

    'CQS symbol': 'FTAIpA',
    'NASDAQ symbol': 'FTAIA',
  },
  {
    symbol: 'FTAI$B',
    'Security Name':
      'Fortress Transportation and Infrastructure Investors LLC 800% FixedtoFloating Rate Series B Cumulative Perpetual Redeemable Preferred Shares',

    'CQS symbol': 'FTAIpB',
    'NASDAQ symbol': 'FTAIB',
  },
  {
    symbol: 'FTC',
    'Security Name': 'First Trust Large Cap Growth AlphaDEX Fund',

    'NASDAQ symbol': 'FTC',
  },
  {
    symbol: 'FTCH',
    'Security Name': 'Farfetch Limited  Ordinary Shares',

    'CQS symbol': 'FTCH',
    'NASDAQ symbol': 'FTCH',
  },
  {
    symbol: 'FTCS',
    'Security Name': 'First Trust Capital Strength ETF',

    'NASDAQ symbol': 'FTCS',
  },
  {
    symbol: 'FTCVU',
    'Security Name': 'FinTech Acquisition Corp V  Unit',

    'NASDAQ symbol': 'FTCVU',
  },
  {
    symbol: 'FTDR',
    'Security Name': 'frontdoor,   ',

    'NASDAQ symbol': 'FTDR',
  },
  {
    symbol: 'FTEC',
    'Security Name': 'Fidelity MSCI Information Technology Index ETF',

    'CQS symbol': 'FTEC',
    'NASDAQ symbol': 'FTEC',
  },
  {
    symbol: 'FTEK',
    'Security Name': 'Fuel Tech,   ',

    'NASDAQ symbol': 'FTEK',
  },
  {
    symbol: 'FTF',
    'Security Name':
      'Franklin Limited Duration ome Trust Common Shares of Beneficial Interest',

    'CQS symbol': 'FTF',
    'NASDAQ symbol': 'FTF',
  },
  {
    symbol: 'FTFT',
    'Security Name': 'Future FinTech Group   ',

    'NASDAQ symbol': 'FTFT',
  },
  {
    symbol: 'FTGC',
    'Security Name': 'First Trust Global Tactical Commodity Strategy Fund',

    'NASDAQ symbol': 'FTGC',
  },
  {
    symbol: 'FTHI',
    'Security Name': 'First Trust BuyWrite ome ETF',

    'NASDAQ symbol': 'FTHI',
  },
  {
    symbol: 'FTHM',
    'Security Name': 'Fathom Holdings   ',

    'NASDAQ symbol': 'FTHM',
  },
  {
    symbol: 'FTHY',
    'Security Name': 'First Trust High Yield Opportunities 2027 Term Fund ',

    'CQS symbol': 'FTHY',
    'NASDAQ symbol': 'FTHY',
  },
  {
    symbol: 'FTI',
    'Security Name': 'TechnipFMC plc Ordinary Share',

    'CQS symbol': 'FTI',
    'NASDAQ symbol': 'FTI',
  },
  {
    symbol: 'FTIV',
    'Security Name': 'FinTech Acquisition Corp IV   ',

    'NASDAQ symbol': 'FTIV',
  },
  {
    symbol: 'FTIVU',
    'Security Name': 'FinTech Acquisition Corp IV  Unit',

    'NASDAQ symbol': 'FTIVU',
  },
  {
    symbol: 'FTIVW',
    'Security Name': 'FinTech Acquisition Corp IV  Warrant',

    'NASDAQ symbol': 'FTIVW',
  },
  {
    symbol: 'FTK',
    'Security Name': 'Flotek Industries,  ',

    'CQS symbol': 'FTK',
    'NASDAQ symbol': 'FTK',
  },
  {
    symbol: 'FTLB',
    'Security Name': 'First Trust Hedged BuyWrite ome ETF',

    'NASDAQ symbol': 'FTLB',
  },
  {
    symbol: 'FTLS',
    'Security Name': 'First Trust Long/Short Equity',

    'CQS symbol': 'FTLS',
    'NASDAQ symbol': 'FTLS',
  },
  {
    symbol: 'FTNT',
    'Security Name': 'Fortinet,   ',

    'NASDAQ symbol': 'FTNT',
  },
  {
    symbol: 'FTOC',
    'Security Name': 'FTAC Olympus Acquisition Corp   Ordinary Shares',

    'NASDAQ symbol': 'FTOC',
  },
  {
    symbol: 'FTOCU',
    'Security Name': 'FTAC Olympus Acquisition Corp  Unit',

    'NASDAQ symbol': 'FTOCU',
  },
  {
    symbol: 'FTOCW',
    'Security Name': 'FTAC Olympus Acquisition Corp  Warrant',

    'NASDAQ symbol': 'FTOCW',
  },
  {
    symbol: 'FTRI',
    'Security Name': 'First Trust Indxx Global Natural Resources ome ETF',

    'NASDAQ symbol': 'FTRI',
  },
  {
    symbol: 'FTS',
    'Security Name': 'Fortis  Common Shares',

    'CQS symbol': 'FTS',
    'NASDAQ symbol': 'FTS',
  },
  {
    symbol: 'FTSD',
    'Security Name': 'Franklin Liberty Short Duration US Government ETF',

    'CQS symbol': 'FTSD',
    'NASDAQ symbol': 'FTSD',
  },
  {
    symbol: 'FTSI',
    'Security Name': 'FTS International,   ',

    'CQS symbol': 'FTSI',
    'NASDAQ symbol': 'FTSI',
  },
  {
    symbol: 'FTSL',
    'Security Name': 'First Trust Senior Loan Fund ETF',

    'NASDAQ symbol': 'FTSL',
  },
  {
    symbol: 'FTSM',
    'Security Name': 'First Trust Enhanced Short Maturity ETF',

    'NASDAQ symbol': 'FTSM',
  },
  {
    symbol: 'FTV',
    'Security Name': 'Fortive Corporation  ',

    'CQS symbol': 'FTV',
    'NASDAQ symbol': 'FTV',
  },
  {
    symbol: 'FTV$A',
    'Security Name':
      'Fortive Corporation 500% Mandatory Convertible Preferred Stock, Series A',

    'CQS symbol': 'FTVpA',
    'NASDAQ symbol': 'FTVA',
  },
  {
    symbol: 'FTXD',
    'Security Name': 'First Trust Nasdaq Retail ETF',

    'NASDAQ symbol': 'FTXD',
  },
  {
    symbol: 'FTXG',
    'Security Name': 'First Trust Nasdaq Food & Beverage ETF',

    'NASDAQ symbol': 'FTXG',
  },
  {
    symbol: 'FTXH',
    'Security Name': 'First Trust Nasdaq Pharmaceuticals ETF',

    'NASDAQ symbol': 'FTXH',
  },
  {
    symbol: 'FTXL',
    'Security Name': 'First Trust Nasdaq Semiconductor ETF',

    'NASDAQ symbol': 'FTXL',
  },
  {
    symbol: 'FTXN',
    'Security Name': 'First Trust Nasdaq Oil & Gas ETF',

    'NASDAQ symbol': 'FTXN',
  },
  {
    symbol: 'FTXO',
    'Security Name': 'First Trust Nasdaq Bank ETF',

    'NASDAQ symbol': 'FTXO',
  },
  {
    symbol: 'FTXR',
    'Security Name': 'First Trust Nasdaq Transportation ETF',

    'NASDAQ symbol': 'FTXR',
  },
  {
    symbol: 'FUBO',
    'Security Name': 'fuboTV  ',

    'CQS symbol': 'FUBO',
    'NASDAQ symbol': 'FUBO',
  },
  {
    symbol: 'FUD',
    'Security Name':
      'ETRACS USB Bloomberg Commodity Index Exchange Traded Notes ETRACS UBS Bloomberg CMCI Food ETN',

    'CQS symbol': 'FUD',
    'NASDAQ symbol': 'FUD',
  },
  {
    symbol: 'FUE',
    'Security Name':
      'ELEMENTS Linked to the ICE BofAML Commodity Index eXtra Biofuels Total Return',

    'CQS symbol': 'FUE',
    'NASDAQ symbol': 'FUE',
  },
  {
    symbol: 'FUL',
    'Security Name': 'H B Fuller Company ',

    'CQS symbol': 'FUL',
    'NASDAQ symbol': 'FUL',
  },
  {
    symbol: 'FULC',
    'Security Name': 'Fulcrum Therapeutics,   ',

    'NASDAQ symbol': 'FULC',
  },
  {
    symbol: 'FULT',
    'Security Name': 'Fulton Financial Corporation  ',

    'NASDAQ symbol': 'FULT',
  },
  {
    symbol: 'FULTP',
    'Security Name':
      'Fulton Financial Corporation  Depositary Shares Each Representing a 1/40th Interest in a Share of Fixed Rate NonCumulative Perpetual Preferred Stock, Series A',

    'NASDAQ symbol': 'FULTP',
  },
  {
    symbol: 'FUMB',
    'Security Name': 'First Trust Ultra Short Duration Municipal ETF',

    'CQS symbol': 'FUMB',
    'NASDAQ symbol': 'FUMB',
  },
  {
    symbol: 'FUN',
    'Security Name': 'Cedar Fair, LP ',

    'CQS symbol': 'FUN',
    'NASDAQ symbol': 'FUN',
  },
  {
    symbol: 'FUNC',
    'Security Name': 'First United Corporation  ',

    'NASDAQ symbol': 'FUNC',
  },
  {
    symbol: 'FUND',
    'Security Name': 'Sprott Focus Trust,   Closed End Fund',

    'NASDAQ symbol': 'FUND',
  },
  {
    symbol: 'FUNL',
    'Security Name': 'CornerCap Fundametrics LargeCap ETF',

    'CQS symbol': 'FUNL',
    'NASDAQ symbol': 'FUNL',
  },
  {
    symbol: 'FURY',
    'Security Name': 'Fury Gold Mines Limited Common Shares',

    'CQS symbol': 'FURY',
    'NASDAQ symbol': 'FURY',
  },
  {
    symbol: 'FUSB',
    'Security Name': 'First US Bancshares,   ',

    'NASDAQ symbol': 'FUSB',
  },
  {
    symbol: 'FUSE',
    'Security Name': 'Fusion Acquisition Corp  ',

    'CQS symbol': 'FUSE',
    'NASDAQ symbol': 'FUSE',
  },
  {
    symbol: 'FUSEU',
    'Security Name':
      'Fusion Acquisition Corp Units, each consisting of one share of   and onehalf of one redeemable Warrant',

    'CQS symbol': 'FUSEU',
    'NASDAQ symbol': 'FUSE=',
  },
  {
    symbol: 'FUSEW',
    'Security Name':
      'Fusion Acquisition Corp Warrants, each whole warrant exercisable for one share of   at an exercise price of $1150 per share',

    'CQS symbol': 'FUSEWS',
    'NASDAQ symbol': 'FUSE+',
  },
  {
    symbol: 'FUSN',
    'Security Name': 'Fusion Pharmaceuticals   Common Shares',

    'NASDAQ symbol': 'FUSN',
  },
  {
    symbol: 'FUT',
    'Security Name': 'ProShares Managed Futures Strategy ETF',

    'CQS symbol': 'FUT',
    'NASDAQ symbol': 'FUT',
  },
  {
    symbol: 'FUTU',
    'Security Name': 'Futu Holdings Limited  American Depositary Shares',

    'NASDAQ symbol': 'FUTU',
  },
  {
    symbol: 'FUTY',
    'Security Name': 'Fidelity MSCI Utilities Index ETF',

    'CQS symbol': 'FUTY',
    'NASDAQ symbol': 'FUTY',
  },
  {
    symbol: 'FUV',
    'Security Name': 'Arcimoto,   ',

    'NASDAQ symbol': 'FUV',
  },
  {
    symbol: 'FV',
    'Security Name': 'First Trust Dorsey Wright Focus 5 ETF',

    'NASDAQ symbol': 'FV',
  },
  {
    symbol: 'FVAL',
    'Security Name': 'Fidelity Value Factor ETF',

    'CQS symbol': 'FVAL',
    'NASDAQ symbol': 'FVAL',
  },
  {
    symbol: 'FVAM',
    'Security Name': '5:01 Acquisition Corp   ',

    'NASDAQ symbol': 'FVAM',
  },
  {
    symbol: 'FVC',
    'Security Name': 'First Trust Dorsey Wright Dynamic Focus 5 ETF',

    'NASDAQ symbol': 'FVC',
  },
  {
    symbol: 'FVCB',
    'Security Name': 'FVCBankcorp,   ',

    'NASDAQ symbol': 'FVCB',
  },
  {
    symbol: 'FVD',
    'Security Name': 'First Trust VL Dividend',

    'CQS symbol': 'FVD',
    'NASDAQ symbol': 'FVD',
  },
  {
    symbol: 'FVE',
    'Security Name': 'Five Star Senior Living   Common Shares',

    'NASDAQ symbol': 'FVE',
  },
  {
    symbol: 'FVL',
    'Security Name': 'First Trust Value Line 100 Fund',

    'CQS symbol': 'FVL',
    'NASDAQ symbol': 'FVL',
  },
  {
    symbol: 'FVRR',
    'Security Name': 'Fiverr International Ltd Ordinary Shares, no par value',

    'CQS symbol': 'FVRR',
    'NASDAQ symbol': 'FVRR',
  },
  {
    symbol: 'FWDB',
    'Security Name': 'AdvisorShares FolioBeyond Smart Core Bond ETF',

    'CQS symbol': 'FWDB',
    'NASDAQ symbol': 'FWDB',
  },
  {
    symbol: 'FWONA',
    'Security Name': 'Liberty Media Corporation  Series A Liberty Formula One ',

    'NASDAQ symbol': 'FWONA',
  },
  {
    symbol: 'FWONK',
    'Security Name': 'Liberty Media Corporation  Series C Liberty Formula One ',

    'NASDAQ symbol': 'FWONK',
  },
  {
    symbol: 'FWP',
    'Security Name': 'Forward Pharma A/S  American Depositary Shares',

    'NASDAQ symbol': 'FWP',
  },
  {
    symbol: 'FWRD',
    'Security Name': 'Forward Air Corporation  ',

    'NASDAQ symbol': 'FWRD',
  },
  {
    symbol: 'FXA',
    'Security Name': 'Invesco CurrencyShares Australian Dollar Trust',

    'CQS symbol': 'FXA',
    'NASDAQ symbol': 'FXA',
  },
  {
    symbol: 'FXB',
    'Security Name': 'Invesco CurrencyShares British Pound Sterling Trust',

    'CQS symbol': 'FXB',
    'NASDAQ symbol': 'FXB',
  },
  {
    symbol: 'FXC',
    'Security Name': 'Invesco CurrencyShares Canadian Dollar Trust',

    'CQS symbol': 'FXC',
    'NASDAQ symbol': 'FXC',
  },
  {
    symbol: 'FXD',
    'Security Name': 'First Trust Cons Discret AlphaDEX',

    'CQS symbol': 'FXD',
    'NASDAQ symbol': 'FXD',
  },
  {
    symbol: 'FXE',
    'Security Name': 'Invesco CurrencyShares Euro Currency Trust',

    'CQS symbol': 'FXE',
    'NASDAQ symbol': 'FXE',
  },
  {
    symbol: 'FXF',
    'Security Name': 'Invesco CurrencyShares Swiss Franc Trust',

    'CQS symbol': 'FXF',
    'NASDAQ symbol': 'FXF',
  },
  {
    symbol: 'FXG',
    'Security Name': 'First Trust Cons Staples AlphaDEX',

    'CQS symbol': 'FXG',
    'NASDAQ symbol': 'FXG',
  },
  {
    symbol: 'FXH',
    'Security Name': 'First Trust Health Care AlphaDEX',

    'CQS symbol': 'FXH',
    'NASDAQ symbol': 'FXH',
  },
  {
    symbol: 'FXI',
    'Security Name': 'iShares China LargeCap ETF',

    'CQS symbol': 'FXI',
    'NASDAQ symbol': 'FXI',
  },
  {
    symbol: 'FXL',
    'Security Name': 'First Trust Technology AlphaDEX',

    'CQS symbol': 'FXL',
    'NASDAQ symbol': 'FXL',
  },
  {
    symbol: 'FXN',
    'Security Name': 'First Trust Energy AlphaDEX Fund',

    'CQS symbol': 'FXN',
    'NASDAQ symbol': 'FXN',
  },
  {
    symbol: 'FXNC',
    'Security Name': 'First National Corporation  ',

    'NASDAQ symbol': 'FXNC',
  },
  {
    symbol: 'FXO',
    'Security Name': 'First Trust Financials AlphaDEX',

    'CQS symbol': 'FXO',
    'NASDAQ symbol': 'FXO',
  },
  {
    symbol: 'FXP',
    'Security Name': 'ProShares Ultrashort FTSE China 50',

    'CQS symbol': 'FXP',
    'NASDAQ symbol': 'FXP',
  },
  {
    symbol: 'FXR',
    'Security Name': 'First Trust Industrials AlphaDEX',

    'CQS symbol': 'FXR',
    'NASDAQ symbol': 'FXR',
  },
  {
    symbol: 'FXU',
    'Security Name': 'First Trust Utilities AlphaDEX Fund',

    'CQS symbol': 'FXU',
    'NASDAQ symbol': 'FXU',
  },
  {
    symbol: 'FXY',
    'Security Name': 'Invesco CurrencyShares Japanese Yen Trust',

    'CQS symbol': 'FXY',
    'NASDAQ symbol': 'FXY',
  },
  {
    symbol: 'FXZ',
    'Security Name': 'First Trust Materials AlphaDEX Fund',

    'CQS symbol': 'FXZ',
    'NASDAQ symbol': 'FXZ',
  },
  {
    symbol: 'FYC',
    'Security Name': 'First Trust Small Cap Growth AlphaDEX Fund',

    'NASDAQ symbol': 'FYC',
  },
  {
    symbol: 'FYLD',
    'Security Name': 'Cambria Foreign Shareholder Yield ETF',

    'CQS symbol': 'FYLD',
    'NASDAQ symbol': 'FYLD',
  },
  {
    symbol: 'FYT',
    'Security Name': 'First Trust Small Cap Value AlphaDEX Fund',

    'NASDAQ symbol': 'FYT',
  },
  {
    symbol: 'FYX',
    'Security Name': 'First Trust Small Cap Core AlphaDEX Fund',

    'NASDAQ symbol': 'FYX',
  },
  {
    symbol: 'G',
    'Security Name': 'Genpact Limited ',

    'CQS symbol': 'G',
    'NASDAQ symbol': 'G',
  },
  {
    symbol: 'GAA',
    'Security Name': 'Cambria Global Asset Allocation ETF',

    'CQS symbol': 'GAA',
    'NASDAQ symbol': 'GAA',
  },
  {
    symbol: 'GAB',
    'Security Name': 'Gabelli Equity Trust,  (The) ',

    'CQS symbol': 'GAB',
    'NASDAQ symbol': 'GAB',
  },
  {
    symbol: 'GAB$G',
    'Security Name':
      'Gabelli Equity Trust,  (The) Series G Cumulative Preferred Stock',

    'CQS symbol': 'GABpG',
    'NASDAQ symbol': 'GABG',
  },
  {
    symbol: 'GAB$H',
    'Security Name': 'Gabelli Equity Trust,  (The) Pfd Ser H',

    'CQS symbol': 'GABpH',
    'NASDAQ symbol': 'GABH',
  },
  {
    symbol: 'GAB$J',
    'Security Name':
      'Gabelli Equity Trust,  (The) 545% Series J Cumulative Preferred Stock',

    'CQS symbol': 'GABpJ',
    'NASDAQ symbol': 'GABJ',
  },
  {
    symbol: 'GAB$K',
    'Security Name':
      'Gabelli Equity Trust,  (The) 500% Series K Cumulative Preferred Stock',

    'CQS symbol': 'GABpK',
    'NASDAQ symbol': 'GABK',
  },
  {
    symbol: 'GABC',
    'Security Name': 'German American Bancorp,   ',

    'NASDAQ symbol': 'GABC',
  },
  {
    symbol: 'GAIA',
    'Security Name': 'Gaia,    ',

    'NASDAQ symbol': 'GAIA',
  },
  {
    symbol: 'GAIN',
    'Security Name':
      'Gladstone Investment Corporation  Business Development Company',

    'NASDAQ symbol': 'GAIN',
  },
  {
    symbol: 'GAINL',
    'Security Name':
      'Gladstone Investment Corporation  6375% Series E Cumulative Term Preferred Stock due 2025',

    'NASDAQ symbol': 'GAINL',
  },
  {
    symbol: 'GAINM',
    'Security Name':
      'Gladstone Investment Corporation  625% Series D Cumulative Term Preferred Stock',

    'NASDAQ symbol': 'GAINM',
  },
  {
    symbol: 'GAL',
    'Security Name': 'SPDR SSgA Global Allocation ETF',

    'CQS symbol': 'GAL',
    'NASDAQ symbol': 'GAL',
  },
  {
    symbol: 'GALT',
    'Security Name': 'Galectin Therapeutics   ',

    'NASDAQ symbol': 'GALT',
  },
  {
    symbol: 'GAM',
    'Security Name': 'General American Investors,  ',

    'CQS symbol': 'GAM',
    'NASDAQ symbol': 'GAM',
  },
  {
    symbol: 'GAM$B',
    'Security Name':
      'General American Investors Company,  Cumulative Preferred Stock',

    'CQS symbol': 'GAMpB',
    'NASDAQ symbol': 'GAMB',
  },
  {
    symbol: 'GAMR',
    'Security Name': 'Wedbush ETFMG Video Game Tech ETF',

    'CQS symbol': 'GAMR',
    'NASDAQ symbol': 'GAMR',
  },
  {
    symbol: 'GAN',
    'Security Name': 'GAN Limited  Ordinary Shares',

    'NASDAQ symbol': 'GAN',
  },
  {
    symbol: 'GASS',
    'Security Name': 'StealthGas,   ',

    'NASDAQ symbol': 'GASS',
  },
  {
    symbol: 'GATO',
    'Security Name': 'Gatos Silver,  ',

    'CQS symbol': 'GATO',
    'NASDAQ symbol': 'GATO',
  },
  {
    symbol: 'GATX',
    'Security Name': 'GATX Corporation ',

    'CQS symbol': 'GATX',
    'NASDAQ symbol': 'GATX',
  },
  {
    symbol: 'GAU',
    'Security Name': 'Galiano Gold ',

    'CQS symbol': 'GAU',
    'NASDAQ symbol': 'GAU',
  },
  {
    symbol: 'GAZ',
    'Security Name':
      'Barclays Bank PLC iPath Series B Bloomberg Natural Gas Subindex Total Return ETN',

    'CQS symbol': 'GAZ',
    'NASDAQ symbol': 'GAZ',
  },
  {
    symbol: 'GB',
    'Security Name': 'Global Blue Group Holding AG Ordinary Shares',

    'CQS symbol': 'GB',
    'NASDAQ symbol': 'GB',
  },
  {
    symbol: 'GBW',
    'Security Name':
      'Global Blue Group Holding AG Warrants exercisable for one Ordinary Share of Global Blue Group Holding AG at a price of $1150 per share',

    'CQS symbol': 'GBWS',
    'NASDAQ symbol': 'GB+',
  },
  {
    symbol: 'GBAB',
    'Security Name':
      'Guggenheim Taxable Municipal Bond & Investment Grade Debt Trust Common Shares of Beneficial Interest',

    'CQS symbol': 'GBAB',
    'NASDAQ symbol': 'GBAB',
  },
  {
    symbol: 'GBCI',
    'Security Name': 'Glacier Bancorp,   ',

    'NASDAQ symbol': 'GBCI',
  },
  {
    symbol: 'GBDC',
    'Security Name': 'Golub Capital BDC,   ',

    'NASDAQ symbol': 'GBDC',
  },
  {
    symbol: 'GBDV',
    'Security Name': 'Global Beta ETF Trust Global Beta Smart ome ETF',

    'CQS symbol': 'GBDV',
    'NASDAQ symbol': 'GBDV',
  },
  {
    symbol: 'GBF',
    'Security Name': 'iShares Government/Credit Bond ETF',

    'CQS symbol': 'GBF',
    'NASDAQ symbol': 'GBF',
  },
  {
    symbol: 'GBGR',
    'Security Name': 'Global Beta MomentumGrowth ETF',

    'CQS symbol': 'GBGR',
    'NASDAQ symbol': 'GBGR',
  },
  {
    symbol: 'GBIL',
    'Security Name': 'Goldman Sachs Access Treasury 01 Year ETF',

    'CQS symbol': 'GBIL',
    'NASDAQ symbol': 'GBIL',
  },
  {
    symbol: 'GBIO',
    'Security Name': 'Generation Bio Co  ',

    'NASDAQ symbol': 'GBIO',
  },
  {
    symbol: 'GBL',
    'Security Name': 'Gamco Investors,  ',

    'CQS symbol': 'GBL',
    'NASDAQ symbol': 'GBL',
  },
  {
    symbol: 'GBLI',
    'Security Name': 'Global Indemnity Group, LLC   ',

    'NASDAQ symbol': 'GBLI',
  },
  {
    symbol: 'GBLIL',
    'Security Name':
      'Global Indemnity Group, LLC  7875% Subordinated Notes due 2047',

    'NASDAQ symbol': 'GBLIL',
  },
  {
    symbol: 'GBLO',
    'Security Name': 'Global Beta Low Beta ETF',

    'CQS symbol': 'GBLO',
    'NASDAQ symbol': 'GBLO',
  },
  {
    symbol: 'GBR',
    'Security Name': 'New Concept Energy,  ',

    'CQS symbol': 'GBR',
    'NASDAQ symbol': 'GBR',
  },
  {
    symbol: 'GBT',
    'Security Name': 'Global Blood Therapeutics,   ',

    'NASDAQ symbol': 'GBT',
  },
  {
    symbol: 'GBUG',
    'Security Name': 'Barclays Bank PLC Pacer iPath Gold ETNs',

    'CQS symbol': 'GBUG',
    'NASDAQ symbol': 'GBUG',
  },
  {
    symbol: 'GBX',
    'Security Name': 'Greenbrier Companies,  (The) ',

    'CQS symbol': 'GBX',
    'NASDAQ symbol': 'GBX',
  },
  {
    symbol: 'GCBC',
    'Security Name': 'Greene County Bancorp,   ',

    'NASDAQ symbol': 'GCBC',
  },
  {
    symbol: 'GCC',
    'Security Name': 'WisdomTree Continuous Commodity Index Fund',

    'CQS symbol': 'GCC',
    'NASDAQ symbol': 'GCC',
  },
  {
    symbol: 'GCI',
    'Security Name': 'Gannett Co,  ',

    'CQS symbol': 'GCI',
    'NASDAQ symbol': 'GCI',
  },
  {
    symbol: 'GCMG',
    'Security Name': 'GCM Grosvenor    ',

    'NASDAQ symbol': 'GCMG',
  },
  {
    symbol: 'GCMGW',
    'Security Name': 'GCM Grosvenor   Warrant',

    'NASDAQ symbol': 'GCMGW',
  },
  {
    symbol: 'GCO',
    'Security Name': 'Genesco  ',

    'CQS symbol': 'GCO',
    'NASDAQ symbol': 'GCO',
  },
  {
    symbol: 'GCOR',
    'Security Name':
      'Goldman Sachs ETF Trust Goldman Sachs Access US Aggregate Bond ETF',

    'CQS symbol': 'GCOR',
    'NASDAQ symbol': 'GCOR',
  },
  {
    symbol: 'GCOW',
    'Security Name': 'Pacer Global Cash Cows Dividend ETF',

    'CQS symbol': 'GCOW',
    'NASDAQ symbol': 'GCOW',
  },
  {
    symbol: 'GCP',
    'Security Name': 'GCP Applied Technologies  ',

    'CQS symbol': 'GCP',
    'NASDAQ symbol': 'GCP',
  },
  {
    symbol: 'GCV',
    'Security Name': 'Gabelli Convertible and ome Securities Fund,  (The) ',

    'CQS symbol': 'GCV',
    'NASDAQ symbol': 'GCV',
  },
  {
    symbol: 'GD',
    'Security Name': 'General Dynamics Corporation ',

    'CQS symbol': 'GD',
    'NASDAQ symbol': 'GD',
  },
  {
    symbol: 'GDDY',
    'Security Name': 'GoDaddy   ',

    'CQS symbol': 'GDDY',
    'NASDAQ symbol': 'GDDY',
  },
  {
    symbol: 'GDEN',
    'Security Name': 'Golden Entertainment,   ',

    'NASDAQ symbol': 'GDEN',
  },
  {
    symbol: 'GDL',
    'Security Name': 'GDL Fund, The Common Shares of Beneficial Interest',

    'CQS symbol': 'GDL',
    'NASDAQ symbol': 'GDL',
  },
  {
    symbol: 'GDL$C',
    'Security Name':
      'The GDL Fund Series C Cumulative Puttable and Callable Preferred Shares',

    'CQS symbol': 'GDLpC',
    'NASDAQ symbol': 'GDLC',
  },
  {
    symbol: 'GDMA',
    'Security Name': 'GadsdenA DynamicA MultiAssetA ETF',

    'CQS symbol': 'GDMA',
    'NASDAQ symbol': 'GDMA',
  },
  {
    symbol: 'GDO',
    'Security Name':
      'Western Asset Global Corporate Defined Opportunity Fund  Western Asset Global Corporate Defined Opportunity Fund ',

    'CQS symbol': 'GDO',
    'NASDAQ symbol': 'GDO',
  },
  {
    symbol: 'GDOT',
    'Security Name': 'Green Dot Corporation  , $0001 par value',

    'CQS symbol': 'GDOT',
    'NASDAQ symbol': 'GDOT',
  },
  {
    symbol: 'GDP',
    'Security Name': 'Goodrich Petroleum Corporation ',

    'CQS symbol': 'GDP',
    'NASDAQ symbol': 'GDP',
  },
  {
    symbol: 'GDRX',
    'Security Name': 'GoodRx Holdings,    ',

    'NASDAQ symbol': 'GDRX',
  },
  {
    symbol: 'GDS',
    'Security Name': 'GDS Holdings Limited  American Depositary Shares',

    'NASDAQ symbol': 'GDS',
  },
  {
    symbol: 'GDV',
    'Security Name':
      'Gabelli Dividend & ome Trust Common Shares of Beneficial Interest',

    'CQS symbol': 'GDV',
    'NASDAQ symbol': 'GDV',
  },
  {
    symbol: 'GDV$G',
    'Security Name':
      'Gabelli Dividend 525% Series G Cumulative Preferred Shares, par value $0001 per share',

    'CQS symbol': 'GDVpG',
    'NASDAQ symbol': 'GDVG',
  },
  {
    symbol: 'GDV$H',
    'Security Name':
      'The Gabelli Dividend & ome Trust 5375% Series H Cumulative Preferred Shares',

    'CQS symbol': 'GDVpH',
    'NASDAQ symbol': 'GDVH',
  },
  {
    symbol: 'GDVD',
    'Security Name': 'Pripal Active Global Dividend ome ETF',

    'CQS symbol': 'GDVD',
    'NASDAQ symbol': 'GDVD',
  },
  {
    symbol: 'GDX',
    'Security Name': 'VanEck Vectors Gold Miners ETF',

    'CQS symbol': 'GDX',
    'NASDAQ symbol': 'GDX',
  },
  {
    symbol: 'GDXD',
    'Security Name': 'MicroSectors Gold Miners 3X Inverse Leveraged ETNs',

    'CQS symbol': 'GDXD',
    'NASDAQ symbol': 'GDXD',
  },
  {
    symbol: 'GDXJ',
    'Security Name': 'VanEck Vectors Junior Gold Miners ETF',

    'CQS symbol': 'GDXJ',
    'NASDAQ symbol': 'GDXJ',
  },
  {
    symbol: 'GDXU',
    'Security Name': 'MicroSectors Gold Miners 3X Leveraged ETN',

    'CQS symbol': 'GDXU',
    'NASDAQ symbol': 'GDXU',
  },
  {
    symbol: 'GDYN',
    'Security Name': 'Grid Dynamics Holdings,    ',

    'NASDAQ symbol': 'GDYN',
  },
  {
    symbol: 'GDYNW',
    'Security Name': 'Grid Dynamics Holdings,   Warrant',

    'NASDAQ symbol': 'GDYNW',
  },
  {
    symbol: 'GE',
    'Security Name': 'General Electric Company ',

    'CQS symbol': 'GE',
    'NASDAQ symbol': 'GE',
  },
  {
    symbol: 'GEC',
    'Security Name': 'Great Elm Capital Group,    ',

    'NASDAQ symbol': 'GEC',
  },
  {
    symbol: 'GECC',
    'Security Name': 'Great Elm Capital Corp  ',

    'NASDAQ symbol': 'GECC',
  },
  {
    symbol: 'GECCL',
    'Security Name': 'Great Elm Capital Corp  650% Notes due 2022',

    'NASDAQ symbol': 'GECCL',
  },
  {
    symbol: 'GECCM',
    'Security Name': 'Great Elm Capital Corp  675% Notes Due 2025',

    'NASDAQ symbol': 'GECCM',
  },
  {
    symbol: 'GECCN',
    'Security Name': 'Great Elm Capital Corp  Notes',

    'NASDAQ symbol': 'GECCN',
  },
  {
    symbol: 'GEF',
    'Security Name': 'Greif   ',

    'CQS symbol': 'GEF',
    'NASDAQ symbol': 'GEF',
  },
  {
    symbol: 'GEFB',
    'Security Name': 'Greif,  Corporation Class B ',

    'CQS symbol': 'GEFB',
    'NASDAQ symbol': 'GEFB',
  },
  {
    symbol: 'GEL',
    'Security Name': 'Genesis Energy, LP Common Units',

    'CQS symbol': 'GEL',
    'NASDAQ symbol': 'GEL',
  },
  {
    symbol: 'GEM',
    'Security Name': 'Goldman Sachs ActiveBeta Emerging Markets Equity ETF',

    'CQS symbol': 'GEM',
    'NASDAQ symbol': 'GEM',
  },
  {
    symbol: 'GEN',
    'Security Name': 'Genesis Healthcare,  ',

    'CQS symbol': 'GEN',
    'NASDAQ symbol': 'GEN',
  },
  {
    symbol: 'GENC',
    'Security Name': 'Gencor Industries   ',

    'NASDAQ symbol': 'GENC',
  },
  {
    symbol: 'GENE',
    'Security Name':
      'Genetic Technologies Ltd  American Depositary Shares representing 600 ordinary shares',

    'NASDAQ symbol': 'GENE',
  },
  {
    symbol: 'GENY',
    'Security Name': 'Pripal Millennials Index ETF',

    'NASDAQ symbol': 'GENY',
  },
  {
    symbol: 'GEO',
    'Security Name': 'Geo Group  (The) REIT',

    'CQS symbol': 'GEO',
    'NASDAQ symbol': 'GEO',
  },
  {
    symbol: 'GEOS',
    'Security Name': 'Geospace Technologies Corporation  ',

    'NASDAQ symbol': 'GEOS',
  },
  {
    symbol: 'GER',
    'Security Name': 'Goldman Sachs MLP Energy Renaissance Fund',

    'CQS symbol': 'GER',
    'NASDAQ symbol': 'GER',
  },
  {
    symbol: 'GERM',
    'Security Name': 'ETFMG Treatments Testing and Advancements ETF',

    'CQS symbol': 'GERM',
    'NASDAQ symbol': 'GERM',
  },
  {
    symbol: 'GERN',
    'Security Name': 'Geron Corporation  ',

    'NASDAQ symbol': 'GERN',
  },
  {
    symbol: 'GES',
    'Security Name': 'Guess?,  ',

    'CQS symbol': 'GES',
    'NASDAQ symbol': 'GES',
  },
  {
    symbol: 'GEVO',
    'Security Name': 'Gevo,   ',

    'NASDAQ symbol': 'GEVO',
  },
  {
    symbol: 'GF',
    'Security Name': 'New Germany Fund,  (The) ',

    'CQS symbol': 'GF',
    'NASDAQ symbol': 'GF',
  },
  {
    symbol: 'GFED',
    'Security Name': 'Guaranty Federal Bancshares,   ',

    'NASDAQ symbol': 'GFED',
  },
  {
    symbol: 'GFF',
    'Security Name': 'Griffon Corporation ',

    'CQS symbol': 'GFF',
    'NASDAQ symbol': 'GFF',
  },
  {
    symbol: 'GFI',
    'Security Name': 'Gold Fields Limited American Depositary Shares',

    'CQS symbol': 'GFI',
    'NASDAQ symbol': 'GFI',
  },
  {
    symbol: 'GFL',
    'Security Name':
      'GFL Environmental  Subordinate voting shares, no par value',

    'CQS symbol': 'GFL',
    'NASDAQ symbol': 'GFL',
  },
  {
    symbol: 'GFLU',
    'Security Name': 'GFL Environmental  Tangible Equity Units',

    'CQS symbol': 'GFLU',
    'NASDAQ symbol': 'GFLU',
  },
  {
    symbol: 'GFN',
    'Security Name': 'General Finance Corporation  ',

    'NASDAQ symbol': 'GFN',
  },
  {
    symbol: 'GFNCP',
    'Security Name':
      'General Finance Corporation  Cumulative Redeemable Perpetual Preferred Series C',

    'NASDAQ symbol': 'GFNCP',
  },
  {
    symbol: 'GFNSL',
    'Security Name': 'General Finance Corporation  Senior Notes due 2021',

    'NASDAQ symbol': 'GFNSL',
  },
  {
    symbol: 'GFNSZ',
    'Security Name': 'General Finance Corporation  7875% Senior Notes due 2025',

    'NASDAQ symbol': 'GFNSZ',
  },
  {
    symbol: 'GGAL',
    'Security Name':
      'Grupo Financiero Galicia SA  American Depositary Shares, Class B Shares underlying',

    'NASDAQ symbol': 'GGAL',
  },
  {
    symbol: 'GGB',
    'Security Name': 'Gerdau SA ',

    'CQS symbol': 'GGB',
    'NASDAQ symbol': 'GGB',
  },
  {
    symbol: 'GGG',
    'Security Name': 'Graco  ',

    'CQS symbol': 'GGG',
    'NASDAQ symbol': 'GGG',
  },
  {
    symbol: 'GGM',
    'Security Name':
      'Guggenheim Credit Allocation Fund Common Shares of Beneficial Interest',

    'CQS symbol': 'GGM',
    'NASDAQ symbol': 'GGM',
  },
  {
    symbol: 'GGN',
    'Security Name': 'GAMCO Global Gold, Natural Resources & ome Trust',

    'CQS symbol': 'GGN',
    'NASDAQ symbol': 'GGN',
  },
  {
    symbol: 'GGN$B',
    'Security Name':
      'GAMCO Global Gold, Natural Reources & ome Trust 500% Series B Cumulative 2500 Liquidation Preference',

    'CQS symbol': 'GGNpB',
    'NASDAQ symbol': 'GGNB',
  },
  {
    symbol: 'GGO',
    'Security Name':
      'The Gabelli Go Anywhere Trust Common Shares of Beneficial Interest',

    'CQS symbol': 'GGO',
    'NASDAQ symbol': 'GGO',
  },
  {
    symbol: 'GGO$A',
    'Security Name':
      'The Gabelli Go Anywhere Trust Series A Cumulative Puttable and Callable Preferred Shares',

    'CQS symbol': 'GGOpA',
    'NASDAQ symbol': 'GGOA',
  },
  {
    symbol: 'GGT',
    'Security Name': 'Gabelli MultiMedia Trust,  (The) ',

    'CQS symbol': 'GGT',
    'NASDAQ symbol': 'GGT',
  },
  {
    symbol: 'GGT$E',
    'Security Name':
      'Gabelli MultiMedia Trust  (The) 5125% Series E Cumulative Preferred Stock',

    'CQS symbol': 'GGTpE',
    'NASDAQ symbol': 'GGTE',
  },
  {
    symbol: 'GGT$G',
    'Security Name':
      'Gabelli MultiMedia Trust  (The) 5125% Series G Cumulative Preferred Shares',

    'CQS symbol': 'GGTpG',
    'NASDAQ symbol': 'GGTG',
  },
  {
    symbol: 'GGZ',
    'Security Name':
      'Gabelli Global Small and Mid Cap Value Trust (The) Common Shares of Beneficial Interest',

    'CQS symbol': 'GGZ',
    'NASDAQ symbol': 'GGZ',
  },
  {
    symbol: 'GGZ$A',
    'Security Name':
      'Gabelli Global Small and Mid Cap Value Trust (The) 5450% Series A Cumulative Preferred Shares (Liquidation Preference $2500 per share)',

    'CQS symbol': 'GGZpA',
    'NASDAQ symbol': 'GGZA',
  },
  {
    symbol: 'GH',
    'Security Name': 'Guardant Health,   ',

    'NASDAQ symbol': 'GH',
  },
  {
    symbol: 'GHC',
    'Security Name': 'Graham Holdings Company ',

    'CQS symbol': 'GHC',
    'NASDAQ symbol': 'GHC',
  },
  {
    symbol: 'GHG',
    'Security Name':
      'GreenTree Hospitality Group Ltd American depositary shares, each representing one  ordinary share',

    'CQS symbol': 'GHG',
    'NASDAQ symbol': 'GHG',
  },
  {
    symbol: 'GHIV',
    'Security Name': 'Gores Holdings IV,    ',

    'NASDAQ symbol': 'GHIV',
  },
  {
    symbol: 'GHIVU',
    'Security Name': 'Gores Holdings IV,   Unit',

    'NASDAQ symbol': 'GHIVU',
  },
  {
    symbol: 'GHIVW',
    'Security Name': 'Gores Holdings IV,   Warrant',

    'NASDAQ symbol': 'GHIVW',
  },
  {
    symbol: 'GHL',
    'Security Name': 'Greenhill & Co,  ',

    'CQS symbol': 'GHL',
    'NASDAQ symbol': 'GHL',
  },
  {
    symbol: 'GHLD',
    'Security Name': 'Guild Holdings Company  ',

    'CQS symbol': 'GHLD',
    'NASDAQ symbol': 'GHLD',
  },
  {
    symbol: 'GHM',
    'Security Name': 'Graham Corporation ',

    'CQS symbol': 'GHM',
    'NASDAQ symbol': 'GHM',
  },
  {
    symbol: 'GHSI',
    'Security Name': 'Guardion Health Sciences,   ',

    'NASDAQ symbol': 'GHSI',
  },
  {
    symbol: 'GHY',
    'Security Name': 'PGIM Global High Yield Fund, ',

    'CQS symbol': 'GHY',
    'NASDAQ symbol': 'GHY',
  },
  {
    symbol: 'GHYB',
    'Security Name': 'Goldman Sachs Access High Yield Corporate Bond ETF',

    'CQS symbol': 'GHYB',
    'NASDAQ symbol': 'GHYB',
  },
  {
    symbol: 'GHYG',
    'Security Name': 'iShares US & Intl High Yield Corp Bond ETF',

    'CQS symbol': 'GHYG',
    'NASDAQ symbol': 'GHYG',
  },
  {
    symbol: 'GIB',
    'Security Name': 'CGI  ',

    'CQS symbol': 'GIB',
    'NASDAQ symbol': 'GIB',
  },
  {
    symbol: 'GIFI',
    'Security Name': 'Gulf Island Fabrication,   ',

    'NASDAQ symbol': 'GIFI',
  },
  {
    symbol: 'GIGB',
    'Security Name': 'Goldman Sachs Access Investment Grade Corporate Bond ETF',

    'CQS symbol': 'GIGB',
    'NASDAQ symbol': 'GIGB',
  },
  {
    symbol: 'GIGE',
    'Security Name': 'SoFi Gig Economy ETF',

    'NASDAQ symbol': 'GIGE',
  },
  {
    symbol: 'GIGM',
    'Security Name': 'GigaMedia Limited  Ordinary Shares',

    'NASDAQ symbol': 'GIGM',
  },
  {
    symbol: 'GII',
    'Security Name': 'SPDR S&P Global Infrastructure ETF',

    'CQS symbol': 'GII',
    'NASDAQ symbol': 'GII',
  },
  {
    symbol: 'GIII',
    'Security Name': 'GIII Apparel Group, LTD  ',

    'NASDAQ symbol': 'GIII',
  },
  {
    symbol: 'GIK',
    'Security Name': 'GigCapital3,  ',

    'CQS symbol': 'GIK',
    'NASDAQ symbol': 'GIK',
  },
  {
    symbol: 'GIKU',
    'Security Name':
      'GigCapital3,  Units, each consisting of one share of  and threefourths of one Redeemable Warrant to purchase one share of ',

    'CQS symbol': 'GIKU',
    'NASDAQ symbol': 'GIK=',
  },
  {
    symbol: 'GIKW',
    'Security Name':
      'GigCapital3,  Redeemable Warrants, each exercisable for one share of  at an exercise price of $1150 per share',

    'CQS symbol': 'GIKWS',
    'NASDAQ symbol': 'GIK+',
  },
  {
    symbol: 'GIL',
    'Security Name': 'Gildan Activewear,   Sub Vot ',

    'CQS symbol': 'GIL',
    'NASDAQ symbol': 'GIL',
  },
  {
    symbol: 'GILD',
    'Security Name': 'Gilead Sciences,   ',

    'NASDAQ symbol': 'GILD',
  },
  {
    symbol: 'GILT',
    'Security Name': 'Gilat Satellite Networks Ltd  Ordinary Shares',

    'NASDAQ symbol': 'GILT',
  },
  {
    symbol: 'GIM',
    'Security Name': 'Templeton Global ome Fund,  ',

    'CQS symbol': 'GIM',
    'NASDAQ symbol': 'GIM',
  },
  {
    symbol: 'GINN',
    'Security Name': 'Goldman Sachs Innovate Equity ETF',

    'CQS symbol': 'GINN',
    'NASDAQ symbol': 'GINN',
  },
  {
    symbol: 'GIS',
    'Security Name': 'General Mills,  ',

    'CQS symbol': 'GIS',
    'NASDAQ symbol': 'GIS',
  },
  {
    symbol: 'GIX',
    'Security Name': 'GigCapital2,  ',

    'CQS symbol': 'GIX',
    'NASDAQ symbol': 'GIX',
  },
  {
    symbol: 'GIXR',
    'Security Name':
      'GigCapital2,  Rights, each exchangeable into onetwentieth of a share of ',

    'CQS symbol': 'GIXr',
    'NASDAQ symbol': 'GIX^',
  },
  {
    symbol: 'GIXU',
    'Security Name':
      'GigCapital2,  Units, each consisting of one share of  and one Warrant',

    'CQS symbol': 'GIXU',
    'NASDAQ symbol': 'GIX=',
  },
  {
    symbol: 'GIXW',
    'Security Name':
      'GigCapital2,  Warrants exercisable for one share of  at an exercise price of $1150 per share',

    'CQS symbol': 'GIXWS',
    'NASDAQ symbol': 'GIX+',
  },
  {
    symbol: 'GJH',
    'Security Name': 'Synthetic Fixedome Securities  6375% (STRATS) Cl A1',

    'CQS symbol': 'GJH',
    'NASDAQ symbol': 'GJH',
  },
  {
    symbol: 'GJO',
    'Security Name':
      'Synthetic Fixedome Securities,  Synthetic Fixedome Securities,  on behalf of STRATS(SM) Trust for WalMart Stores,  Securities, Series 20045',

    'CQS symbol': 'GJO',
    'NASDAQ symbol': 'GJO',
  },
  {
    symbol: 'GJP',
    'Security Name':
      'Synthetic Fixedome Securities,  Synthetic Fixedome Securities,  on behalf of STRATS (SM) Trust for Dominion Resources,  Securities, Series 20056, Floating Rate Structured Repackaged AssetBacked Trust Securities (STRATS) Certificates',

    'CQS symbol': 'GJP',
    'NASDAQ symbol': 'GJP',
  },
  {
    symbol: 'GJR',
    'Security Name':
      'Synthetic Fixedome Securities,  STRATS Trust for Procter&Gamble Securities, Series 20061',

    'CQS symbol': 'GJR',
    'NASDAQ symbol': 'GJR',
  },
  {
    symbol: 'GJS',
    'Security Name':
      'Goldman Sachs Group Securities STRATS Trust for Goldman Sachs Group Securities, Series 20062',

    'CQS symbol': 'GJS',
    'NASDAQ symbol': 'GJS',
  },
  {
    symbol: 'GJT',
    'Security Name':
      'Synthetic Fixedome Securities,  Synthetic Fixedome Securities,  Floating Rate Structured Repackaged AssetBacked Trust Securities Certificates, Series 20063',

    'CQS symbol': 'GJT',
    'NASDAQ symbol': 'GJT',
  },
  {
    symbol: 'GKOS',
    'Security Name': 'Glaukos Corporation ',

    'CQS symbol': 'GKOS',
    'NASDAQ symbol': 'GKOS',
  },
  {
    symbol: 'GL',
    'Security Name': 'Globe Life  ',

    'CQS symbol': 'GL',
    'NASDAQ symbol': 'GL',
  },
  {
    symbol: 'GL$C',
    'Security Name':
      'Globe Life  6125% Junior Subordinated Debentures due 2056',

    'CQS symbol': 'GLpC',
    'NASDAQ symbol': 'GLC',
  },
  {
    symbol: 'GLAD',
    'Security Name': 'Gladstone Capital Corporation  ',

    'NASDAQ symbol': 'GLAD',
  },
  {
    symbol: 'GLADD',
    'Security Name': 'Gladstone Capital Corporation  6125% Notes due 2023',

    'NASDAQ symbol': 'GLADD',
  },
  {
    symbol: 'GLADL',
    'Security Name': 'Gladstone Capital Corporation  5375% Notes due 2024',

    'NASDAQ symbol': 'GLADL',
  },
  {
    symbol: 'GLBS',
    'Security Name': 'Globus Maritime Limited  ',

    'NASDAQ symbol': 'GLBS',
  },
  {
    symbol: 'GLBZ',
    'Security Name': 'Glen Burnie Bancorp  ',

    'NASDAQ symbol': 'GLBZ',
  },
  {
    symbol: 'GLCN',
    'Security Name': 'VanEck Vectors China Growth Leaders ETF',

    'CQS symbol': 'GLCN',
    'NASDAQ symbol': 'GLCN',
  },
  {
    symbol: 'GLD',
    'Security Name': 'SPDR Gold Trust',

    'CQS symbol': 'GLD',
    'NASDAQ symbol': 'GLD',
  },
  {
    symbol: 'GLDD',
    'Security Name': 'Great Lakes Dredge & Dock Corporation  ',

    'NASDAQ symbol': 'GLDD',
  },
  {
    symbol: 'GLDG',
    'Security Name': 'GoldMining  Common Shares',

    'CQS symbol': 'GLDG',
    'NASDAQ symbol': 'GLDG',
  },
  {
    symbol: 'GLDI',
    'Security Name':
      'Credit Suisse Gold Shares Covered Call Exchange Traded Notes',

    'NASDAQ symbol': 'GLDI',
  },
  {
    symbol: 'GLDM',
    'Security Name': 'SPDR Gold MiniShares Trust',

    'CQS symbol': 'GLDM',
    'NASDAQ symbol': 'GLDM',
  },
  {
    symbol: 'GLEO',
    'Security Name': 'Galileo Acquisition Corp Ordinary Shares',

    'CQS symbol': 'GLEO',
    'NASDAQ symbol': 'GLEO',
  },
  {
    symbol: 'GLEOU',
    'Security Name':
      'Galileo Acquisition Corp Units, each consisting of one Ordinary Share and one Redeemable Warrant',

    'CQS symbol': 'GLEOU',
    'NASDAQ symbol': 'GLEO=',
  },
  {
    symbol: 'GLEOW',
    'Security Name':
      'Galileo Acquisition Corp Redeemable Warrants, each whole warrant exercisable for one Ordinary Share at an exercise price of $1150',

    'CQS symbol': 'GLEOWS',
    'NASDAQ symbol': 'GLEO+',
  },
  {
    symbol: 'GLG',
    'Security Name': 'TD Holdings,   ',

    'NASDAQ symbol': 'GLG',
  },
  {
    symbol: 'GLIBA',
    'Security Name': 'GCI Liberty,    ',

    'NASDAQ symbol': 'GLIBA',
  },
  {
    symbol: 'GLIBP',
    'Security Name':
      'GCI Liberty,   Series A Cumulative Redeemable Preferred Stock',

    'NASDAQ symbol': 'GLIBP',
  },
  {
    symbol: 'GLIF',
    'Security Name': 'AGFiQ Global Infrastructure ETF',

    'CQS symbol': 'GLIF',
    'NASDAQ symbol': 'GLIF',
  },
  {
    symbol: 'GLIN',
    'Security Name': 'VanEck Vectors India Growth Leaders ETF',

    'CQS symbol': 'GLIN',
    'NASDAQ symbol': 'GLIN',
  },
  {
    symbol: 'GLL',
    'Security Name': 'ProShares UltraShort Gold',

    'CQS symbol': 'GLL',
    'NASDAQ symbol': 'GLL',
  },
  {
    symbol: 'GLMD',
    'Security Name': 'Galmed Pharmaceuticals Ltd  Ordinary Shares',

    'NASDAQ symbol': 'GLMD',
  },
  {
    symbol: 'GLNG',
    'Security Name': 'Golar LNG Limited  Common Shares',

    'NASDAQ symbol': 'GLNG',
  },
  {
    symbol: 'GLO',
    'Security Name': 'Clough Global Opportunities Fund ',

    'CQS symbol': 'GLO',
    'NASDAQ symbol': 'GLO',
  },
  {
    symbol: 'GLOB',
    'Security Name': 'Globant SA Common Shares',

    'CQS symbol': 'GLOB',
    'NASDAQ symbol': 'GLOB',
  },
  {
    symbol: 'GLOG',
    'Security Name': 'GasLog Ltd Common Shares',

    'CQS symbol': 'GLOG',
    'NASDAQ symbol': 'GLOG',
  },
  {
    symbol: 'GLOG$A',
    'Security Name':
      'GasLog LP 875% Series A Cumulative Redeemable Perpetual Preference Shares',

    'CQS symbol': 'GLOGpA',
    'NASDAQ symbol': 'GLOGA',
  },
  {
    symbol: 'GLOP',
    'Security Name':
      'GasLog Partners LP Common Units representing limited partnership interests',

    'CQS symbol': 'GLOP',
    'NASDAQ symbol': 'GLOP',
  },
  {
    symbol: 'GLOP$A',
    'Security Name':
      'GasLog Partners LP 8625% Series A Cumulative Redeemable Perpetual Fixed to Floating Rate Preference Units',

    'CQS symbol': 'GLOPpA',
    'NASDAQ symbol': 'GLOPA',
  },
  {
    symbol: 'GLOP$B',
    'Security Name':
      'GasLog Partners LP 8200% Series B Cumulative Redeemable Perpetual Fixed to Floating Rate Preference Units',

    'CQS symbol': 'GLOPpB',
    'NASDAQ symbol': 'GLOPB',
  },
  {
    symbol: 'GLOP$C',
    'Security Name':
      'GasLog Partners LP 8500% Series C Cumulative Redeemable Perpetual Fixed to Floating Rate Preference Units',

    'CQS symbol': 'GLOPpC',
    'NASDAQ symbol': 'GLOPC',
  },
  {
    symbol: 'GLP',
    'Security Name':
      'Global Partners LP Global Partners LP Common Units representing Limited Partner Interests',

    'CQS symbol': 'GLP',
    'NASDAQ symbol': 'GLP',
  },
  {
    symbol: 'GLP$A',
    'Security Name':
      'Global Partners LP 975% Series A FixedtoFloating Rate Cumulative Redeemable Perpetual Preferred Units representing limited partner interests',

    'CQS symbol': 'GLPpA',
    'NASDAQ symbol': 'GLPA',
  },
  {
    symbol: 'GLPG',
    'Security Name': 'Galapagos NV  American Depositary Shares',

    'NASDAQ symbol': 'GLPG',
  },
  {
    symbol: 'GLPI',
    'Security Name': 'Gaming and Leisure Properties,   ',

    'NASDAQ symbol': 'GLPI',
  },
  {
    symbol: 'GLQ',
    'Security Name':
      'Clough Global Equity Fund Clough Global Equity Fund Common Shares of Beneficial Interest',

    'CQS symbol': 'GLQ',
    'NASDAQ symbol': 'GLQ',
  },
  {
    symbol: 'GLRE',
    'Security Name': 'Greenlight Reinsurance, Ltd   Ordinary Shares',

    'NASDAQ symbol': 'GLRE',
  },
  {
    symbol: 'GLSI',
    'Security Name': 'Greenwich LifeSciences,   ',

    'NASDAQ symbol': 'GLSI',
  },
  {
    symbol: 'GLT',
    'Security Name': 'Glatfelter Corporation ',

    'CQS symbol': 'GLT',
    'NASDAQ symbol': 'GLT',
  },
  {
    symbol: 'GLTO',
    'Security Name': 'Galecto,   ',

    'NASDAQ symbol': 'GLTO',
  },
  {
    symbol: 'GLTR',
    'Security Name':
      'Aberdeen Standard Physical Precious Metals Basket Shares ETF',

    'CQS symbol': 'GLTR',
    'NASDAQ symbol': 'GLTR',
  },
  {
    symbol: 'GLU',
    'Security Name':
      'Gabelli Global Utility Common Shares of Beneficial Ownership',

    'CQS symbol': 'GLU',
    'NASDAQ symbol': 'GLU',
  },
  {
    symbol: 'GLU$A',
    'Security Name':
      'The Gabelli Global Utility and ome Trust Series A Cumulative Puttable and Callable Preferred Shares',

    'CQS symbol': 'GLUpA',
    'NASDAQ symbol': 'GLUA',
  },
  {
    symbol: 'GLU$B',
    'Security Name':
      'The Gabelli Global Utility and ome Trust Series B Cumulative Puttable and Callable Preferred Shares',

    'CQS symbol': 'GLUpB',
    'NASDAQ symbol': 'GLUB',
  },
  {
    symbol: 'GLUU',
    'Security Name': 'Glu Mobile   ',

    'NASDAQ symbol': 'GLUU',
  },
  {
    symbol: 'GLV',
    'Security Name':
      'Clough Global Dividend and ome Fund Common Shares of beneficial interest',

    'CQS symbol': 'GLV',
    'NASDAQ symbol': 'GLV',
  },
  {
    symbol: 'GLW',
    'Security Name': 'Corning orporated ',

    'CQS symbol': 'GLW',
    'NASDAQ symbol': 'GLW',
  },
  {
    symbol: 'GLYC',
    'Security Name': 'GlycoMimetics,   ',

    'NASDAQ symbol': 'GLYC',
  },
  {
    symbol: 'GM',
    'Security Name': 'General Motors Company ',

    'CQS symbol': 'GM',
    'NASDAQ symbol': 'GM',
  },
  {
    symbol: 'GMAB',
    'Security Name': 'Genmab A/S  American Depositary Shares',

    'NASDAQ symbol': 'GMAB',
  },
  {
    symbol: 'GMBL',
    'Security Name': 'Esports Entertainment Group   ',

    'NASDAQ symbol': 'GMBL',
  },
  {
    symbol: 'GMBLW',
    'Security Name': 'Esports Entertainment Group   Warrant',

    'NASDAQ symbol': 'GMBLW',
  },
  {
    symbol: 'GMDA',
    'Security Name': 'Gamida Cell Ltd  Ordinary Shares',

    'NASDAQ symbol': 'GMDA',
  },
  {
    symbol: 'GME',
    'Security Name': 'GameStop Corporation ',

    'CQS symbol': 'GME',
    'NASDAQ symbol': 'GME',
  },
  {
    symbol: 'GMED',
    'Security Name': 'Globus Medical,   ',

    'CQS symbol': 'GMED',
    'NASDAQ symbol': 'GMED',
  },
  {
    symbol: 'GMF',
    'Security Name': 'SPDR S&P Emerging Asia Pacific ETF',

    'CQS symbol': 'GMF',
    'NASDAQ symbol': 'GMF',
  },
  {
    symbol: 'GMLP',
    'Security Name':
      'Golar LNG Partners LP  Common Units Representing Limited Partnership',

    'NASDAQ symbol': 'GMLP',
  },
  {
    symbol: 'GMLPP',
    'Security Name':
      'Golar LNG Partners LP  875% Series A Cumulative Redeemable Preferred Units',

    'NASDAQ symbol': 'GMLPP',
  },
  {
    symbol: 'GMOM',
    'Security Name': 'Cambria Global Momentum ETF',

    'CQS symbol': 'GMOM',
    'NASDAQ symbol': 'GMOM',
  },
  {
    symbol: 'GMRE',
    'Security Name': 'Global Medical REIT  ',

    'CQS symbol': 'GMRE',
    'NASDAQ symbol': 'GMRE',
  },
  {
    symbol: 'GMRE$A',
    'Security Name':
      'Global Medical REIT  Series A Cumulative Redeemable Preferred Stock',

    'CQS symbol': 'GMREpA',
    'NASDAQ symbol': 'GMREA',
  },
  {
    symbol: 'GMS',
    'Security Name': 'GMS  ',

    'CQS symbol': 'GMS',
    'NASDAQ symbol': 'GMS',
  },
  {
    symbol: 'GMTA',
    'Security Name': 'GATX Corporation 5625% Senior Notes due 2066',

    'CQS symbol': 'GMTA',
    'NASDAQ symbol': 'GMTA',
  },
  {
    symbol: 'GNAF',
    'Security Name':
      'MicroSectors FANG  Index Inverse ETNs due January 8, 2038',

    'CQS symbol': 'GNAF',
    'NASDAQ symbol': 'GNAF',
  },
  {
    symbol: 'GNCA',
    'Security Name': 'Genocea Biosciences,   ',

    'NASDAQ symbol': 'GNCA',
  },
  {
    symbol: 'GNE',
    'Security Name': 'Genie Energy Ltd Class B  Stock',

    'CQS symbol': 'GNE',
    'NASDAQ symbol': 'GNE',
  },
  {
    symbol: 'GNE$A',
    'Security Name':
      'Genie Energy Ltd Series 2012  A Preferred Stock, $001 par value',

    'CQS symbol': 'GNEpA',
    'NASDAQ symbol': 'GNEA',
  },
  {
    symbol: 'GNFT',
    'Security Name': 'GENFIT SA  American Depositary Shares',

    'NASDAQ symbol': 'GNFT',
  },
  {
    symbol: 'GNK',
    'Security Name':
      'Genco Shipping & Trading Limited Ordinary Shares New (Marshall Islands)',

    'CQS symbol': 'GNK',
    'NASDAQ symbol': 'GNK',
  },
  {
    symbol: 'GNL',
    'Security Name': 'Global Net Lease,  ',

    'CQS symbol': 'GNL',
    'NASDAQ symbol': 'GNL',
  },
  {
    symbol: 'GNL$A',
    'Security Name':
      'Global Net Lease,  725% Series A Cumulative Redeemable Preferred Stock, $001 par value per share',

    'CQS symbol': 'GNLpA',
    'NASDAQ symbol': 'GNLA',
  },
  {
    symbol: 'GNL$B',
    'Security Name':
      'Global Net Lease,  6875% Series B Cumulative Redeemable Perpetual Preferred Stock',

    'CQS symbol': 'GNLpB',
    'NASDAQ symbol': 'GNLB',
  },
  {
    symbol: 'GNLN',
    'Security Name': 'Greenlane Holdings,    ',

    'NASDAQ symbol': 'GNLN',
  },
  {
    symbol: 'GNMA',
    'Security Name': 'iShares GNMA Bond ETF',

    'NASDAQ symbol': 'GNMA',
  },
  {
    symbol: 'GNMK',
    'Security Name': 'GenMark Diagnostics,   ',

    'NASDAQ symbol': 'GNMK',
  },
  {
    symbol: 'GNOM',
    'Security Name': 'Global X Genomics & Biotechnology ETF',

    'NASDAQ symbol': 'GNOM',
  },
  {
    symbol: 'GNPKU',
    'Security Name':
      'Genesis Park Acquisition Corp Units, each consisting of one  ordinary share, and onehalf of one redeemable warrant',

    'CQS symbol': 'GNPKU',
    'NASDAQ symbol': 'GNPK=',
  },
  {
    symbol: 'GNPX',
    'Security Name': 'Genprex,   ',

    'NASDAQ symbol': 'GNPX',
  },
  {
    symbol: 'GNR',
    'Security Name': 'SPDR S&P Global Natural Resources ETF',

    'CQS symbol': 'GNR',
    'NASDAQ symbol': 'GNR',
  },
  {
    symbol: 'GNRC',
    'Security Name': 'Generac Holdlings  ',

    'CQS symbol': 'GNRC',
    'NASDAQ symbol': 'GNRC',
  },
  {
    symbol: 'GNRS',
    'Security Name': 'Greenrose Acquisition Corp  ',

    'NASDAQ symbol': 'GNRS',
  },
  {
    symbol: 'GNRSU',
    'Security Name': 'Greenrose Acquisition Corp  Unit',

    'NASDAQ symbol': 'GNRSU',
  },
  {
    symbol: 'GNRSW',
    'Security Name': 'Greenrose Acquisition Corp  Warrant',

    'NASDAQ symbol': 'GNRSW',
  },
  {
    symbol: 'GNSS',
    'Security Name': 'Genasys   ',

    'NASDAQ symbol': 'GNSS',
  },
  {
    symbol: 'GNT',
    'Security Name': 'GAMCO Natural Resources, Gold & ome Trust',

    'CQS symbol': 'GNT',
    'NASDAQ symbol': 'GNT',
  },
  {
    symbol: 'GNT$A',
    'Security Name':
      'GAMCO Natural Resources, Gold & ome Tust  520% Series A Cumulative Preferred Shares (Liquidation Preference $2500 per share)',

    'CQS symbol': 'GNTpA',
    'NASDAQ symbol': 'GNTA',
  },
  {
    symbol: 'GNTX',
    'Security Name': 'Gentex Corporation  ',

    'NASDAQ symbol': 'GNTX',
  },
  {
    symbol: 'GNTY',
    'Security Name': 'Guaranty Bancshares,   ',

    'NASDAQ symbol': 'GNTY',
  },
  {
    symbol: 'GNUS',
    'Security Name': 'Genius Brands International,   ',

    'NASDAQ symbol': 'GNUS',
  },
  {
    symbol: 'GNW',
    'Security Name': 'Genworth Financial  ',

    'CQS symbol': 'GNW',
    'NASDAQ symbol': 'GNW',
  },
  {
    symbol: 'GO',
    'Security Name': 'Grocery Outlet Holding Corp  ',

    'NASDAQ symbol': 'GO',
  },
  {
    symbol: 'GOAC',
    'Security Name': 'GO Acquisition Corp  ',

    'CQS symbol': 'GOAC',
    'NASDAQ symbol': 'GOAC',
  },
  {
    symbol: 'GOACU',
    'Security Name':
      'GO Acquisition Corp Units, each consisting of one share of   and onethird of one Warrant',

    'CQS symbol': 'GOACU',
    'NASDAQ symbol': 'GOAC=',
  },
  {
    symbol: 'GOACW',
    'Security Name':
      'GO Acquisition Corp Warrants, each whole warrant exercisable for one share of   at an exercise price of $1150',

    'CQS symbol': 'GOACWS',
    'NASDAQ symbol': 'GOAC+',
  },
  {
    symbol: 'GOAT',
    'Security Name': 'VanEck Vectors Morningstar Global Wide Moat ETF',

    'CQS symbol': 'GOAT',
    'NASDAQ symbol': 'GOAT',
  },
  {
    symbol: 'GOAU',
    'Security Name': 'US Global GO Gold and Precious Metal Miners ETF',

    'CQS symbol': 'GOAU',
    'NASDAQ symbol': 'GOAU',
  },
  {
    symbol: 'GOCO',
    'Security Name': 'GoHealth,    ',

    'NASDAQ symbol': 'GOCO',
  },
  {
    symbol: 'GOED',
    'Security Name': '1847 Goedeker  Commom Stock',

    'CQS symbol': 'GOED',
    'NASDAQ symbol': 'GOED',
  },
  {
    symbol: 'GOEX',
    'Security Name': 'Global X Gold Explorers ETF',

    'CQS symbol': 'GOEX',
    'NASDAQ symbol': 'GOEX',
  },
  {
    symbol: 'GOF',
    'Security Name':
      'Guggenheim Strategic Opportunities Fund Common Shares of Beneficial Interest',

    'CQS symbol': 'GOF',
    'NASDAQ symbol': 'GOF',
  },
  {
    symbol: 'GOGL',
    'Security Name': 'Golden Ocean Group Limited  ',

    'NASDAQ symbol': 'GOGL',
  },
  {
    symbol: 'GOGO',
    'Security Name': 'Gogo   ',

    'NASDAQ symbol': 'GOGO',
  },
  {
    symbol: 'GOL',
    'Security Name':
      'Gol Linhas Aereas Inteligentes SA Sponsored ADR representing 2 Pfd Shares',

    'CQS symbol': 'GOL',
    'NASDAQ symbol': 'GOL',
  },
  {
    symbol: 'GOLD',
    'Security Name': 'Barrick Gold Corporation  (BC)',

    'CQS symbol': 'GOLD',
    'NASDAQ symbol': 'GOLD',
  },
  {
    symbol: 'GOLF',
    'Security Name': 'Acushnet Holdings Corp ',

    'CQS symbol': 'GOLF',
    'NASDAQ symbol': 'GOLF',
  },
  {
    symbol: 'GOOD',
    'Security Name':
      'Gladstone Commercial Corporation  Real Estate Investment Trust',

    'NASDAQ symbol': 'GOOD',
  },
  {
    symbol: 'GOODM',
    'Security Name':
      'Gladstone Commercial Corporation  Series D Cumulative Redeemable Preferred Stock',

    'NASDAQ symbol': 'GOODM',
  },
  {
    symbol: 'GOODN',
    'Security Name':
      'Gladstone Commercial Corporation  6625% Series E Cumulative Redeemable Preferred Stock',

    'NASDAQ symbol': 'GOODN',
  },
  {
    symbol: 'GOOG',
    'Security Name': 'Alphabet   Class C Capital Stock',

    'NASDAQ symbol': 'GOOG',
  },
  {
    symbol: 'GOOGL',
    'Security Name': 'Alphabet    ',

    'NASDAQ symbol': 'GOOGL',
  },
  {
    symbol: 'GOOS',
    'Security Name': 'Canada Goose Holdings  Subordinate Voting Shares',

    'CQS symbol': 'GOOS',
    'NASDAQ symbol': 'GOOS',
  },
  {
    symbol: 'GORO',
    'Security Name': 'Gold Resource Corporation ',

    'CQS symbol': 'GORO',
    'NASDAQ symbol': 'GORO',
  },
  {
    symbol: 'GOSS',
    'Security Name': 'Gossamer Bio,   ',

    'NASDAQ symbol': 'GOSS',
  },
  {
    symbol: 'GOVT',
    'Security Name': 'iShares US Treasury Bond ETF',

    'CQS symbol': 'GOVT',
    'NASDAQ symbol': 'GOVT',
  },
  {
    symbol: 'GOVX',
    'Security Name': 'GeoVax Labs,   ',

    'NASDAQ symbol': 'GOVX',
  },
  {
    symbol: 'GOVXW',
    'Security Name': 'GeoVax Labs,   Warrants',

    'NASDAQ symbol': 'GOVXW',
  },
  {
    symbol: 'GOVZ',
    'Security Name': 'iShares 25  Year Treasury STRIPS Bond ETF',

    'CQS symbol': 'GOVZ',
    'NASDAQ symbol': 'GOVZ',
  },
  {
    symbol: 'GP',
    'Security Name': 'GreenPower Motor Company   Common Shares',

    'NASDAQ symbol': 'GP',
  },
  {
    symbol: 'GPC',
    'Security Name': 'Genuine Parts Company ',

    'CQS symbol': 'GPC',
    'NASDAQ symbol': 'GPC',
  },
  {
    symbol: 'GPI',
    'Security Name': 'Group 1 Automotive,  ',

    'CQS symbol': 'GPI',
    'NASDAQ symbol': 'GPI',
  },
  {
    symbol: 'GPJA',
    'Security Name':
      'Georgia Power Company Series 2017A 500% Junior Subordinated Notes due October 1, 2077',

    'CQS symbol': 'GPJA',
    'NASDAQ symbol': 'GPJA',
  },
  {
    symbol: 'GPK',
    'Security Name': 'Graphic Packaging Holding Company',

    'CQS symbol': 'GPK',
    'NASDAQ symbol': 'GPK',
  },
  {
    symbol: 'GPL',
    'Security Name': 'Great Panther Mining Limited Ordinary Shares (Canada)',

    'CQS symbol': 'GPL',
    'NASDAQ symbol': 'GPL',
  },
  {
    symbol: 'GPM',
    'Security Name': 'Guggenheim Enhanced Equity ome Fund',

    'CQS symbol': 'GPM',
    'NASDAQ symbol': 'GPM',
  },
  {
    symbol: 'GPMT',
    'Security Name': 'Granite Point Mortgage Trust  ',

    'CQS symbol': 'GPMT',
    'NASDAQ symbol': 'GPMT',
  },
  {
    symbol: 'GPN',
    'Security Name': 'Global Payments  ',

    'CQS symbol': 'GPN',
    'NASDAQ symbol': 'GPN',
  },
  {
    symbol: 'GPP',
    'Security Name': 'Green Plains Partners LP  Common Units',

    'NASDAQ symbol': 'GPP',
  },
  {
    symbol: 'GPRE',
    'Security Name': 'Green Plains,   ',

    'NASDAQ symbol': 'GPRE',
  },
  {
    symbol: 'GPRK',
    'Security Name': 'Geopark Ltd Common Shares',

    'CQS symbol': 'GPRK',
    'NASDAQ symbol': 'GPRK',
  },
  {
    symbol: 'GPRO',
    'Security Name': 'GoPro,    ',

    'NASDAQ symbol': 'GPRO',
  },
  {
    symbol: 'GPS',
    'Security Name': 'Gap,  (The) ',

    'CQS symbol': 'GPS',
    'NASDAQ symbol': 'GPS',
  },
  {
    symbol: 'GPX',
    'Security Name': 'GP Strategies Corporation ',

    'CQS symbol': 'GPX',
    'NASDAQ symbol': 'GPX',
  },
  {
    symbol: 'GQRE',
    'Security Name': 'FlexShares Global Quality Real Estate Index Fund',

    'CQS symbol': 'GQRE',
    'NASDAQ symbol': 'GQRE',
  },
  {
    symbol: 'GRA',
    'Security Name': 'WR Grace & Co ',

    'CQS symbol': 'GRA',
    'NASDAQ symbol': 'GRA',
  },
  {
    symbol: 'GRAY',
    'Security Name': 'Graybug Vision,   ',

    'NASDAQ symbol': 'GRAY',
  },
  {
    symbol: 'GRBK',
    'Security Name': 'Green Brick Partners,   ',

    'NASDAQ symbol': 'GRBK',
  },
  {
    symbol: 'GRC',
    'Security Name': 'GormanRupp Company (The) ',

    'CQS symbol': 'GRC',
    'NASDAQ symbol': 'GRC',
  },
  {
    symbol: 'GRCY',
    'Security Name': 'Greencity Acquisition Corporation  Ordinary Shares',

    'NASDAQ symbol': 'GRCY',
  },
  {
    symbol: 'GRCYU',
    'Security Name': 'Greencity Acquisition Corporation  Unit',

    'NASDAQ symbol': 'GRCYU',
  },
  {
    symbol: 'GRCYW',
    'Security Name': 'Greencity Acquisition Corporation  Warrants',

    'NASDAQ symbol': 'GRCYW',
  },
  {
    symbol: 'GREK',
    'Security Name': 'Global X MSCI Greece ETF',

    'CQS symbol': 'GREK',
    'NASDAQ symbol': 'GREK',
  },
  {
    symbol: 'GRES',
    'Security Name': 'IQ ARB Global Resources ETF',

    'CQS symbol': 'GRES',
    'NASDAQ symbol': 'GRES',
  },
  {
    symbol: 'GRF',
    'Security Name': 'Eagle Capital Growth Fund,  ',

    'CQS symbol': 'GRF',
    'NASDAQ symbol': 'GRF',
  },
  {
    symbol: 'GRFS',
    'Security Name': 'Grifols, SA  American Depositary Shares',

    'NASDAQ symbol': 'GRFS',
  },
  {
    symbol: 'GRID',
    'Security Name':
      'First Trust NASDAQ Clean Edge Smart Grid Infrastructure Index Fund',

    'NASDAQ symbol': 'GRID',
  },
  {
    symbol: 'GRIF',
    'Security Name': 'Griffin Industrial Realty,   ',

    'NASDAQ symbol': 'GRIF',
  },
  {
    symbol: 'GRIL',
    'Security Name': 'Muscle Maker,   ',

    'NASDAQ symbol': 'GRIL',
  },
  {
    symbol: 'GRIN',
    'Security Name': 'Grindrod Shipping Holdings Ltd  Ordinary Shares',

    'NASDAQ symbol': 'GRIN',
  },
  {
    symbol: 'GRMN',
    'Security Name': 'Garmin Ltd  ',

    'NASDAQ symbol': 'GRMN',
  },
  {
    symbol: 'GRN',
    'Security Name': 'iPath Series B Carbon ExchangeTraded Notes',

    'CQS symbol': 'GRN',
    'NASDAQ symbol': 'GRN',
  },
  {
    symbol: 'GRNB',
    'Security Name': 'VanEck Vectors Green Bond ETF',

    'CQS symbol': 'GRNB',
    'NASDAQ symbol': 'GRNB',
  },
  {
    symbol: 'GRNQ',
    'Security Name': 'Greenpro Capital Corp  ',

    'NASDAQ symbol': 'GRNQ',
  },
  {
    symbol: 'GRNV',
    'Security Name': 'GreenVision Acquisition Corp  ',

    'NASDAQ symbol': 'GRNV',
  },
  {
    symbol: 'GRNVR',
    'Security Name': 'GreenVision Acquisition Corp  Rights',

    'NASDAQ symbol': 'GRNVR',
  },
  {
    symbol: 'GRNVU',
    'Security Name': 'GreenVision Acquisition Corp  Unit',

    'NASDAQ symbol': 'GRNVU',
  },
  {
    symbol: 'GRNVW',
    'Security Name': 'GreenVision Acquisition Corp  Warrant',

    'NASDAQ symbol': 'GRNVW',
  },
  {
    symbol: 'GROW',
    'Security Name': 'US Global Investors,    ',

    'NASDAQ symbol': 'GROW',
  },
  {
    symbol: 'GRPU',
    'Security Name':
      'Granite Real Estate  Stapled Units, each consisting of one unit of Granite Real Estate Trust and one common share of Granite REIT ',

    'CQS symbol': 'GRPU',
    'NASDAQ symbol': 'GRP=',
  },
  {
    symbol: 'GRPN',
    'Security Name': 'Groupon,   ',

    'NASDAQ symbol': 'GRPN',
  },
  {
    symbol: 'GRSV',
    'Security Name': 'Gores Holdings V,   ',

    'NASDAQ symbol': 'GRSV',
  },
  {
    symbol: 'GRSVU',
    'Security Name': 'Gores Holdings V,   Unit',

    'NASDAQ symbol': 'GRSVU',
  },
  {
    symbol: 'GRSVW',
    'Security Name': 'Gores Holdings V,   Warrant',

    'NASDAQ symbol': 'GRSVW',
  },
  {
    symbol: 'GRTS',
    'Security Name': 'Gritstone Oncology,   ',

    'NASDAQ symbol': 'GRTS',
  },
  {
    symbol: 'GRTX',
    'Security Name': 'Galera Therapeutics,   ',

    'NASDAQ symbol': 'GRTX',
  },
  {
    symbol: 'GRU',
    'Security Name':
      'ELEMENTS Linked to the ICE BofAML Commodity Index eXtra Grains Total Return',

    'CQS symbol': 'GRU',
    'NASDAQ symbol': 'GRU',
  },
  {
    symbol: 'GRUB',
    'Security Name': 'GrubHub  ',

    'CQS symbol': 'GRUB',
    'NASDAQ symbol': 'GRUB',
  },
  {
    symbol: 'GRVY',
    'Security Name':
      'GRAVITY Co, Ltd  American depositary shares, each representing one common share',

    'NASDAQ symbol': 'GRVY',
  },
  {
    symbol: 'GRWG',
    'Security Name': 'GrowGeneration Corp  ',

    'NASDAQ symbol': 'GRWG',
  },
  {
    symbol: 'GRX',
    'Security Name':
      'The Gabelli Healthcare & Wellness Trust Common Shares of Beneficial Interest',

    'CQS symbol': 'GRX',
    'NASDAQ symbol': 'GRX',
  },
  {
    symbol: 'GRX$B',
    'Security Name': 'Gabelli Healthcare Preferred Series B',

    'CQS symbol': 'GRXpB',
    'NASDAQ symbol': 'GRXB',
  },
  {
    symbol: 'GS',
    'Security Name': 'Goldman Sachs Group,  (The) ',

    'CQS symbol': 'GS',
    'NASDAQ symbol': 'GS',
  },
  {
    symbol: 'GS$A',
    'Security Name':
      'Goldman Sachs Group,  (The) Depositary Shares each representing 1/1000th Interest in a Share of Floating Rate NonCumulative Preferred Stock Series A',

    'CQS symbol': 'GSpA',
    'NASDAQ symbol': 'GSA',
  },
  {
    symbol: 'GS$C',
    'Security Name':
      'Goldman Sachs Group,  (The) Depositary Share repstg 1/1000th Preferred Series C',

    'CQS symbol': 'GSpC',
    'NASDAQ symbol': 'GSC',
  },
  {
    symbol: 'GS$D',
    'Security Name':
      'Goldman Sachs Group,  (The) Dep Shs repstg 1/1000 Pfd Ser D Fltg',

    'CQS symbol': 'GSpD',
    'NASDAQ symbol': 'GSD',
  },
  {
    symbol: 'GS$J',
    'Security Name':
      'Goldman Sachs Group  Depositary Shs Repstg 1/1000th Pfd Ser J Fixed to Fltg Rate',

    'CQS symbol': 'GSpJ',
    'NASDAQ symbol': 'GSJ',
  },
  {
    symbol: 'GS$K',
    'Security Name':
      'Goldman Sachs Group,  (The) Dep Shs Repstg 1/1000 Int Sh Fxd/Fltg Non Cum Pfd Stk Ser K',

    'CQS symbol': 'GSpK',
    'NASDAQ symbol': 'GSK',
  },
  {
    symbol: 'GS$N',
    'Security Name':
      'Goldman Sachs Group,  (The) Depositary Shares, Each Representing 1/1,000th Interest in a Share of 630% NonCumulative Preferred Stock, Series N',

    'CQS symbol': 'GSpN',
    'NASDAQ symbol': 'GSN',
  },
  {
    symbol: 'GSAH',
    'Security Name': 'GS Acquisition Holdings Corp II  ',

    'CQS symbol': 'GSAH',
    'NASDAQ symbol': 'GSAH',
  },
  {
    symbol: 'GSAHU',
    'Security Name':
      'GS Acquisition Holdings Corp II Units, each consisting of one share of   and onequarter of one redeemable Warrant',

    'CQS symbol': 'GSAHU',
    'NASDAQ symbol': 'GSAH=',
  },
  {
    symbol: 'GSAHW',
    'Security Name':
      'GS Acquisition Holdings Corp II Redeemable Warrants, each whole warrant exercisable for one share of   at an exercise price of $1150',

    'CQS symbol': 'GSAHWS',
    'NASDAQ symbol': 'GSAH+',
  },
  {
    symbol: 'GSAT',
    'Security Name': 'Globalstar,  ',

    'CQS symbol': 'GSAT',
    'NASDAQ symbol': 'GSAT',
  },
  {
    symbol: 'GSBC',
    'Security Name': 'Great Southern Bancorp,   ',

    'NASDAQ symbol': 'GSBC',
  },
  {
    symbol: 'GSBD',
    'Security Name': 'Goldman Sachs BDC,  ',

    'CQS symbol': 'GSBD',
    'NASDAQ symbol': 'GSBD',
  },
  {
    symbol: 'GSEE',
    'Security Name': 'Goldman Sachs MarketBeta Emerging Markets Equity ETF',

    'CQS symbol': 'GSEE',
    'NASDAQ symbol': 'GSEE',
  },
  {
    symbol: 'GSEU',
    'Security Name': 'Goldman Sachs ActiveBeta Europe Equity ETF',

    'CQS symbol': 'GSEU',
    'NASDAQ symbol': 'GSEU',
  },
  {
    symbol: 'GSEW',
    'Security Name': 'Goldman Sachs Equal Weight US Large Cap Equity ETF',

    'CQS symbol': 'GSEW',
    'NASDAQ symbol': 'GSEW',
  },
  {
    symbol: 'GSG',
    'Security Name': 'iShares GSCI CommodityIndexed Trust Fund',

    'CQS symbol': 'GSG',
    'NASDAQ symbol': 'GSG',
  },
  {
    symbol: 'GSHD',
    'Security Name': 'Goosehead Insurance,    ',

    'NASDAQ symbol': 'GSHD',
  },
  {
    symbol: 'GSID',
    'Security Name': 'Goldman Sachs MarketBeta International Equity ETF',

    'CQS symbol': 'GSID',
    'NASDAQ symbol': 'GSID',
  },
  {
    symbol: 'GSIE',
    'Security Name': 'Goldman Sachs ActiveBeta International Equity ETF',

    'CQS symbol': 'GSIE',
    'NASDAQ symbol': 'GSIE',
  },
  {
    symbol: 'GSIG',
    'Security Name':
      'Golden Sachs ETF Trust Goldman Sachs Access Investment Grade Corporate 15 Year Bond ETF',

    'CQS symbol': 'GSIG',
    'NASDAQ symbol': 'GSIG',
  },
  {
    symbol: 'GSIT',
    'Security Name': 'GSI Technology,   ',

    'NASDAQ symbol': 'GSIT',
  },
  {
    symbol: 'GSJY',
    'Security Name': 'Goldman Sachs ActiveBeta Japan Equity ETF',

    'CQS symbol': 'GSJY',
    'NASDAQ symbol': 'GSJY',
  },
  {
    symbol: 'GSK',
    'Security Name': 'GlaxoSmithKline PLC ',

    'CQS symbol': 'GSK',
    'NASDAQ symbol': 'GSK',
  },
  {
    symbol: 'GSKY',
    'Security Name': 'GreenSky,   ',

    'NASDAQ symbol': 'GSKY',
  },
  {
    symbol: 'GSL',
    'Security Name': 'Global Ship Lease  New  Common Shares',

    'CQS symbol': 'GSL',
    'NASDAQ symbol': 'GSL',
  },
  {
    symbol: 'GSL$B',
    'Security Name':
      'Global Ship Lease,   Representing 1/100th Perpetual Preferred Series B% (Marshall Island)',

    'CQS symbol': 'GSLpB',
    'NASDAQ symbol': 'GSLB',
  },
  {
    symbol: 'GSLC',
    'Security Name': 'Goldman Sachs ActiveBeta US Large Cap Equity ETF',

    'CQS symbol': 'GSLC',
    'NASDAQ symbol': 'GSLC',
  },
  {
    symbol: 'GSLD',
    'Security Name': 'Global Ship Lease,  800% Senior Notes due 2024',

    'CQS symbol': 'GSLD',
    'NASDAQ symbol': 'GSLD',
  },
  {
    symbol: 'GSM',
    'Security Name': 'Ferroglobe PLC  Ordinary Shares',

    'NASDAQ symbol': 'GSM',
  },
  {
    symbol: 'GSMG',
    'Security Name':
      'Glory Star New Media Group Holdings Limited  Ordinary Share',

    'NASDAQ symbol': 'GSMG',
  },
  {
    symbol: 'GSMGW',
    'Security Name': 'Glory Star New Media Group Holdings Limited  Warrant',

    'NASDAQ symbol': 'GSMGW',
  },
  {
    symbol: 'GSP',
    'Security Name':
      'Barclays Bank PLC iPath Exchange Traded Notes due June 12, 2036 Linked to GSCI Total Return Index',

    'CQS symbol': 'GSP',
    'NASDAQ symbol': 'GSP',
  },
  {
    symbol: 'GSS',
    'Security Name': 'Golden Star Resources, Ltd ',

    'CQS symbol': 'GSS',
    'NASDAQ symbol': 'GSS',
  },
  {
    symbol: 'GSSC',
    'Security Name': 'GS ActiveBeta US Small Cap Equity ETF',

    'CQS symbol': 'GSSC',
    'NASDAQ symbol': 'GSSC',
  },
  {
    symbol: 'GSST',
    'Security Name': 'Goldman Sachs Access Ultra Short Bond ETF',

    'CQS symbol': 'GSST',
    'NASDAQ symbol': 'GSST',
  },
  {
    symbol: 'GSUM',
    'Security Name': 'Gridsum Holding   American Depositary Shares',

    'NASDAQ symbol': 'GSUM',
  },
  {
    symbol: 'GSUS',
    'Security Name': 'Goldman Sachs MarketBeta US Equity ETF',

    'CQS symbol': 'GSUS',
    'NASDAQ symbol': 'GSUS',
  },
  {
    symbol: 'GSV',
    'Security Name': 'Gold Standard Ventures Corporation  (Canada)',

    'CQS symbol': 'GSV',
    'NASDAQ symbol': 'GSV',
  },
  {
    symbol: 'GSX',
    'Security Name':
      'GSX Techedu  American Depositary Shares, three of which representing two  Ordinary Shares',

    'CQS symbol': 'GSX',
    'NASDAQ symbol': 'GSX',
  },
  {
    symbol: 'GSY',
    'Security Name': 'Invesco Ultra Short Duration ETF',

    'CQS symbol': 'GSY',
    'NASDAQ symbol': 'GSY',
  },
  {
    symbol: 'GT',
    'Security Name': 'The Goodyear Tire & Rubber Company  ',

    'NASDAQ symbol': 'GT',
  },
  {
    symbol: 'GTE',
    'Security Name': 'Gran Tierra Energy  ',

    'CQS symbol': 'GTE',
    'NASDAQ symbol': 'GTE',
  },
  {
    symbol: 'GTEC',
    'Security Name':
      'Greenland Technologies Holding Corporation  Ordinary Shares',

    'NASDAQ symbol': 'GTEC',
  },
  {
    symbol: 'GTES',
    'Security Name': 'Gates Industrial Corporation plc Ordinary Shares',

    'CQS symbol': 'GTES',
    'NASDAQ symbol': 'GTES',
  },
  {
    symbol: 'GTH',
    'Security Name': 'Genetron Holdings Limited  American Depositary Shares',

    'NASDAQ symbol': 'GTH',
  },
  {
    symbol: 'GTHX',
    'Security Name': 'G1 Therapeutics,   ',

    'NASDAQ symbol': 'GTHX',
  },
  {
    symbol: 'GTIM',
    'Security Name': 'Good Times Restaurants   ',

    'NASDAQ symbol': 'GTIM',
  },
  {
    symbol: 'GTIP',
    'Security Name': 'Goldman Sachs Access Inflation Protected USD Bond ETF',

    'CQS symbol': 'GTIP',
    'NASDAQ symbol': 'GTIP',
  },
  {
    symbol: 'GTLS',
    'Security Name': 'Chart Industries,   ',

    'NASDAQ symbol': 'GTLS',
  },
  {
    symbol: 'GTN',
    'Security Name': 'Gray Television,  ',

    'CQS symbol': 'GTN',
    'NASDAQ symbol': 'GTN',
  },
  {
    symbol: 'GTNA',
    'Security Name': 'Gray Television,   ',

    'CQS symbol': 'GTNA',
    'NASDAQ symbol': 'GTNA',
  },
  {
    symbol: 'GTO',
    'Security Name': 'Invesco Total Return Bond ETF',

    'CQS symbol': 'GTO',
    'NASDAQ symbol': 'GTO',
  },
  {
    symbol: 'GTS',
    'Security Name': 'TripleS Management Corporation Class B ',

    'CQS symbol': 'GTS',
    'NASDAQ symbol': 'GTS',
  },
  {
    symbol: 'GTT',
    'Security Name': 'GTT Communications,  ',

    'CQS symbol': 'GTT',
    'NASDAQ symbol': 'GTT',
  },
  {
    symbol: 'GTY',
    'Security Name': 'Getty Realty Corporation ',

    'CQS symbol': 'GTY',
    'NASDAQ symbol': 'GTY',
  },
  {
    symbol: 'GTYH',
    'Security Name': 'GTY Technology Holdings,   ',

    'NASDAQ symbol': 'GTYH',
  },
  {
    symbol: 'GUDB',
    'Security Name': 'Sage ESG Intermediate Credit ETF',

    'CQS symbol': 'GUDB',
    'NASDAQ symbol': 'GUDB',
  },
  {
    symbol: 'GUNR',
    'Security Name':
      'FlexShares Global Upstream Natural Resources Index Fund ETF',

    'CQS symbol': 'GUNR',
    'NASDAQ symbol': 'GUNR',
  },
  {
    symbol: 'GURE',
    'Security Name': 'Gulf Resources,   ',

    'NASDAQ symbol': 'GURE',
  },
  {
    symbol: 'GURU',
    'Security Name': 'Global X Guru Index ETF',

    'CQS symbol': 'GURU',
    'NASDAQ symbol': 'GURU',
  },
  {
    symbol: 'GUSH',
    'Security Name': 'Direxion Daily S&P Oil & Gas Exp & Prod Bull 2X Shares',

    'CQS symbol': 'GUSH',
    'NASDAQ symbol': 'GUSH',
  },
  {
    symbol: 'GUT',
    'Security Name': 'Gabelli Utility Trust (The) ',

    'CQS symbol': 'GUT',
    'NASDAQ symbol': 'GUT',
  },
  {
    symbol: 'GUT$A',
    'Security Name':
      'Gabelli Utility Trust (The) 5625% Series A Cumulative Preferred Shares',

    'CQS symbol': 'GUTpA',
    'NASDAQ symbol': 'GUTA',
  },
  {
    symbol: 'GUT$C',
    'Security Name':
      'Gabelli Utility Trust (The) 5375% Series C Cumulative Preferred Shares',

    'CQS symbol': 'GUTpC',
    'NASDAQ symbol': 'GUTC',
  },
  {
    symbol: 'GV',
    'Security Name': 'Goldfield Corporation (The) ',

    'CQS symbol': 'GV',
    'NASDAQ symbol': 'GV',
  },
  {
    symbol: 'GVA',
    'Security Name': 'Granite Construction orporated ',

    'CQS symbol': 'GVA',
    'NASDAQ symbol': 'GVA',
  },
  {
    symbol: 'GVAL',
    'Security Name': 'Cambria Global Value ETF',

    'CQS symbol': 'GVAL',
    'NASDAQ symbol': 'GVAL',
  },
  {
    symbol: 'GVI',
    'Security Name': 'iShares Intermediate Government/Credit Bond ETF',

    'CQS symbol': 'GVI',
    'NASDAQ symbol': 'GVI',
  },
  {
    symbol: 'GVIP',
    'Security Name': 'Goldman Sachs Hedge Industry VIP ETF',

    'CQS symbol': 'GVIP',
    'NASDAQ symbol': 'GVIP',
  },
  {
    symbol: 'GVP',
    'Security Name': 'GSE Systems,   ',

    'NASDAQ symbol': 'GVP',
  },
  {
    symbol: 'GWACU',
    'Security Name': 'Good Works Acquisition Corp  Unit',

    'NASDAQ symbol': 'GWACU',
  },
  {
    symbol: 'GWB',
    'Security Name': 'Great Western Bancorp,  ',

    'CQS symbol': 'GWB',
    'NASDAQ symbol': 'GWB',
  },
  {
    symbol: 'GWGH',
    'Security Name': 'GWG Holdings,   ',

    'NASDAQ symbol': 'GWGH',
  },
  {
    symbol: 'GWPH',
    'Security Name': 'GW Pharmaceuticals Plc  American Depositary Shares',

    'NASDAQ symbol': 'GWPH',
  },
  {
    symbol: 'GWRE',
    'Security Name': 'Guidewire Software,  ',

    'CQS symbol': 'GWRE',
    'NASDAQ symbol': 'GWRE',
  },
  {
    symbol: 'GWRS',
    'Security Name': 'Global Water Resources,   ',

    'NASDAQ symbol': 'GWRS',
  },
  {
    symbol: 'GWW',
    'Security Name': 'WW Grainger,  ',

    'CQS symbol': 'GWW',
    'NASDAQ symbol': 'GWW',
  },
  {
    symbol: 'GWX',
    'Security Name': 'SPDR S&P International SmallCap ETF',

    'CQS symbol': 'GWX',
    'NASDAQ symbol': 'GWX',
  },
  {
    symbol: 'GXC',
    'Security Name': 'SPDR S&P China ETF',

    'CQS symbol': 'GXC',
    'NASDAQ symbol': 'GXC',
  },
  {
    symbol: 'GXF',
    'Security Name': 'Global X FTSE Nordic Region ETF',

    'CQS symbol': 'GXF',
    'NASDAQ symbol': 'GXF',
  },
  {
    symbol: 'GXG',
    'Security Name': 'Global X MSCI Colombia ETF',

    'CQS symbol': 'GXG',
    'NASDAQ symbol': 'GXG',
  },
  {
    symbol: 'GXGX',
    'Security Name': 'GX Acquisition Corp   ',

    'NASDAQ symbol': 'GXGX',
  },
  {
    symbol: 'GXGXU',
    'Security Name': 'GX Acquisition Corp  Unit',

    'NASDAQ symbol': 'GXGXU',
  },
  {
    symbol: 'GXGXW',
    'Security Name': 'GX Acquisition Corp  Warrant',

    'NASDAQ symbol': 'GXGXW',
  },
  {
    symbol: 'GXTG',
    'Security Name': 'Global X Thematic Growth ETF',

    'NASDAQ symbol': 'GXTG',
  },
  {
    symbol: 'GYC',
    'Security Name':
      'Corporate Asset Backed Corp CABCO Corporate Asset Backed Corporation CABCO Series 2004102 Trust (SBC Communications, ) Collared Floating Rate Cllable Certificates',

    'CQS symbol': 'GYC',
    'NASDAQ symbol': 'GYC',
  },
  {
    symbol: 'GYLD',
    'Security Name': 'Arrow Dow Jones Global Yield ETF ETF',

    'CQS symbol': 'GYLD',
    'NASDAQ symbol': 'GYLD',
  },
  {
    symbol: 'GYRO',
    'Security Name': 'Gyrodyne , LLC  ',

    'NASDAQ symbol': 'GYRO',
  },
  {
    symbol: 'H',
    'Security Name': 'Hyatt Hotels Corporation  ',

    'CQS symbol': 'H',
    'NASDAQ symbol': 'H',
  },
  {
    symbol: 'HA',
    'Security Name': 'Hawaiian Holdings,   ',

    'NASDAQ symbol': 'HA',
  },
  {
    symbol: 'HAACU',
    'Security Name': 'Health Assurance Acquisition Corp  SAIL Securities',

    'NASDAQ symbol': 'HAACU',
  },
  {
    symbol: 'HACK',
    'Security Name': 'ETFMG Prime Cyber Security ETF',

    'CQS symbol': 'HACK',
    'NASDAQ symbol': 'HACK',
  },
  {
    symbol: 'HAE',
    'Security Name': 'Haemonetics Corporation ',

    'CQS symbol': 'HAE',
    'NASDAQ symbol': 'HAE',
  },
  {
    symbol: 'HAFC',
    'Security Name': 'Hanmi Financial Corporation  ',

    'NASDAQ symbol': 'HAFC',
  },
  {
    symbol: 'HAIL',
    'Security Name': 'SPDR S&P Kensho Smart Mobility ETF',

    'CQS symbol': 'HAIL',
    'NASDAQ symbol': 'HAIL',
  },
  {
    symbol: 'HAIN',
    'Security Name': 'The Hain Celestial Group,   ',

    'NASDAQ symbol': 'HAIN',
  },
  {
    symbol: 'HAL',
    'Security Name': 'Halliburton Company ',

    'CQS symbol': 'HAL',
    'NASDAQ symbol': 'HAL',
  },
  {
    symbol: 'HALL',
    'Security Name': 'Hallmark Financial Services,   ',

    'NASDAQ symbol': 'HALL',
  },
  {
    symbol: 'HALO',
    'Security Name': 'Halozyme Therapeutics,   ',

    'NASDAQ symbol': 'HALO',
  },
  {
    symbol: 'HAP',
    'Security Name': 'VanEck Vectors Natural Resources ETF',

    'CQS symbol': 'HAP',
    'NASDAQ symbol': 'HAP',
  },
  {
    symbol: 'HAPP',
    'Security Name': 'Happiness Biotech Group Limited  Ordinary Shares',

    'NASDAQ symbol': 'HAPP',
  },
  {
    symbol: 'HARP',
    'Security Name': 'Harpoon Therapeutics,   ',

    'NASDAQ symbol': 'HARP',
  },
  {
    symbol: 'HAS',
    'Security Name': 'Hasbro,   ',

    'NASDAQ symbol': 'HAS',
  },
  {
    symbol: 'HASI',
    'Security Name': 'Hannon Armstrong Sustainable Infrastructure Capital,  ',

    'CQS symbol': 'HASI',
    'NASDAQ symbol': 'HASI',
  },
  {
    symbol: 'HAUZ',
    'Security Name': 'Xtrackers International Real Estate ETF',

    'CQS symbol': 'HAUZ',
    'NASDAQ symbol': 'HAUZ',
  },
  {
    symbol: 'HAWX',
    'Security Name': 'iShares Currency Hedged MSCI ACWI ex US ETF',

    'CQS symbol': 'HAWX',
    'NASDAQ symbol': 'HAWX',
  },
  {
    symbol: 'HAYN',
    'Security Name': 'Haynes International,   ',

    'NASDAQ symbol': 'HAYN',
  },
  {
    symbol: 'HBAN',
    'Security Name': 'Huntington Bancshares orporated  ',

    'NASDAQ symbol': 'HBAN',
  },
  {
    symbol: 'HBANN',
    'Security Name':
      'Huntington Bancshares orporated  Depositary Shares each representing a 1/40th interest in a share of 5875% Series C NonCumulative Perpetual Preferred Stock',

    'NASDAQ symbol': 'HBANN',
  },
  {
    symbol: 'HBANO',
    'Security Name': 'Huntington Bancshares orporated  Depositary Shares',

    'NASDAQ symbol': 'HBANO',
  },
  {
    symbol: 'HBB',
    'Security Name': 'Hamilton Beach Brands Holding Company   ',

    'CQS symbol': 'HBB',
    'NASDAQ symbol': 'HBB',
  },
  {
    symbol: 'HBCP',
    'Security Name': 'Home Bancorp,   ',

    'NASDAQ symbol': 'HBCP',
  },
  {
    symbol: 'HBI',
    'Security Name': 'Hanesbrands  ',

    'CQS symbol': 'HBI',
    'NASDAQ symbol': 'HBI',
  },
  {
    symbol: 'HBIO',
    'Security Name': 'Harvard Bioscience,   ',

    'NASDAQ symbol': 'HBIO',
  },
  {
    symbol: 'HBM',
    'Security Name': 'Hudbay Minerals  Ordinary Shares (Canada)',

    'CQS symbol': 'HBM',
    'NASDAQ symbol': 'HBM',
  },
  {
    symbol: 'HBMD',
    'Security Name': 'Howard Bancorp,   ',

    'NASDAQ symbol': 'HBMD',
  },
  {
    symbol: 'HBNC',
    'Security Name': 'Horizon Bancorp,   ',

    'NASDAQ symbol': 'HBNC',
  },
  {
    symbol: 'HBP',
    'Security Name': 'Huttig Building Products,   ',

    'NASDAQ symbol': 'HBP',
  },
  {
    symbol: 'HBT',
    'Security Name': 'HBT Financial,   ',

    'NASDAQ symbol': 'HBT',
  },
  {
    symbol: 'HCA',
    'Security Name': 'HCA Healthcare,  ',

    'CQS symbol': 'HCA',
    'NASDAQ symbol': 'HCA',
  },
  {
    symbol: 'HCAC',
    'Security Name': 'Hennessy Capital Acquisition Corp IV   ',

    'NASDAQ symbol': 'HCAC',
  },
  {
    symbol: 'HCACU',
    'Security Name': 'Hennessy Capital Acquisition Corp IV  Unit',

    'NASDAQ symbol': 'HCACU',
  },
  {
    symbol: 'HCACW',
    'Security Name': 'Hennessy Capital Acquisition Corp IV  Warrant',

    'NASDAQ symbol': 'HCACW',
  },
  {
    symbol: 'HCAP',
    'Security Name': 'Harvest Capital Credit Corporation  ',

    'NASDAQ symbol': 'HCAP',
  },
  {
    symbol: 'HCAPZ',
    'Security Name': 'Harvest Capital Credit Corporation  6125% Notes due 2022',

    'NASDAQ symbol': 'HCAPZ',
  },
  {
    symbol: 'HCAT',
    'Security Name': 'Health Catalyst,   ',

    'NASDAQ symbol': 'HCAT',
  },
  {
    symbol: 'HCC',
    'Security Name': 'Warrior Met Coal,  ',

    'CQS symbol': 'HCC',
    'NASDAQ symbol': 'HCC',
  },
  {
    symbol: 'HCCH',
    'Security Name': 'HL Acquisitions Corp  Ordinary Shares',

    'NASDAQ symbol': 'HCCH',
  },
  {
    symbol: 'HCCHR',
    'Security Name': 'HL Acquisitions Corp  Right',

    'NASDAQ symbol': 'HCCHR',
  },
  {
    symbol: 'HCCHU',
    'Security Name': 'HL Acquisitions Corp  Unit',

    'NASDAQ symbol': 'HCCHU',
  },
  {
    symbol: 'HCCHW',
    'Security Name': 'HL Acquisitions Corp  Warrant',

    'NASDAQ symbol': 'HCCHW',
  },
  {
    symbol: 'HCCI',
    'Security Name': 'HeritageCrystal Clean,   ',

    'NASDAQ symbol': 'HCCI',
  },
  {
    symbol: 'HCDI',
    'Security Name': 'Harbor Custom Development,   ',

    'NASDAQ symbol': 'HCDI',
  },
  {
    symbol: 'HCFT',
    'Security Name': 'Hunt Companies Finance Trust,  ',

    'CQS symbol': 'HCFT',
    'NASDAQ symbol': 'HCFT',
  },
  {
    symbol: 'HCHC',
    'Security Name': 'HC2 Holdings,  ',

    'CQS symbol': 'HCHC',
    'NASDAQ symbol': 'HCHC',
  },
  {
    symbol: 'HCI',
    'Security Name': 'HCI Group,  ',

    'CQS symbol': 'HCI',
    'NASDAQ symbol': 'HCI',
  },
  {
    symbol: 'HCKT',
    'Security Name': 'The Hackett Group,   ',

    'NASDAQ symbol': 'HCKT',
  },
  {
    symbol: 'HCM',
    'Security Name':
      'Hutchison China MediTech Limited  American Depositary Shares',

    'NASDAQ symbol': 'HCM',
  },
  {
    symbol: 'HCRB',
    'Security Name': 'Hartford Core Bond ETF',

    'CQS symbol': 'HCRB',
    'NASDAQ symbol': 'HCRB',
  },
  {
    symbol: 'HCSG',
    'Security Name': 'Healthcare Services Group,   ',

    'NASDAQ symbol': 'HCSG',
  },
  {
    symbol: 'HCXY',
    'Security Name': 'Hercules Capital,  625% Notes due 2033',

    'CQS symbol': 'HCXY',
    'NASDAQ symbol': 'HCXY',
  },
  {
    symbol: 'HCXZ',
    'Security Name': 'Hercules Capital,  525% Notes due 2025',

    'CQS symbol': 'HCXZ',
    'NASDAQ symbol': 'HCXZ',
  },
  {
    symbol: 'HD',
    'Security Name': 'Home Depot,  (The) ',

    'CQS symbol': 'HD',
    'NASDAQ symbol': 'HD',
  },
  {
    symbol: 'HDAW',
    'Security Name':
      'Xtrackers MSCI All World ex US High Dividend Yield Equity ETF',

    'CQS symbol': 'HDAW',
    'NASDAQ symbol': 'HDAW',
  },
  {
    symbol: 'HDB',
    'Security Name': 'HDFC Bank Limited ',

    'CQS symbol': 'HDB',
    'NASDAQ symbol': 'HDB',
  },
  {
    symbol: 'HDEF',
    'Security Name': 'Xtrackers MSCI EAFE High Dividend Yield Equity ETF',

    'CQS symbol': 'HDEF',
    'NASDAQ symbol': 'HDEF',
  },
  {
    symbol: 'HDG',
    'Security Name': 'ProShares Hedge Replication ETF',

    'CQS symbol': 'HDG',
    'NASDAQ symbol': 'HDG',
  },
  {
    symbol: 'HDGE',
    'Security Name': 'Ranger Equity Bear Bear ETF',

    'CQS symbol': 'HDGE',
    'NASDAQ symbol': 'HDGE',
  },
  {
    symbol: 'HDIV',
    'Security Name': 'QRAFT AIEnhanced US High Dividend ETF',

    'CQS symbol': 'HDIV',
    'NASDAQ symbol': 'HDIV',
  },
  {
    symbol: 'HDLB',
    'Security Name':
      'ETRACS Monthly Pay 2xLeveraged US High Dividend Low Volatility ETN Series B due September 30, 2044',

    'CQS symbol': 'HDLB',
    'NASDAQ symbol': 'HDLB',
  },
  {
    symbol: 'HDMV',
    'Security Name':
      'First Trust ExchangeTraded Fund III First Trust Horizon Managed Volatility Developed International ETF',

    'CQS symbol': 'HDMV',
    'NASDAQ symbol': 'HDMV',
  },
  {
    symbol: 'HDS',
    'Security Name': 'HD Supply Holdings,   ',

    'NASDAQ symbol': 'HDS',
  },
  {
    symbol: 'HDSN',
    'Security Name': 'Hudson Technologies,   ',

    'NASDAQ symbol': 'HDSN',
  },
  {
    symbol: 'HDV',
    'Security Name': 'iShares Core High Dividend ETF',

    'CQS symbol': 'HDV',
    'NASDAQ symbol': 'HDV',
  },
  {
    symbol: 'HE',
    'Security Name': 'Hawaiian Electric Industries,  ',

    'CQS symbol': 'HE',
    'NASDAQ symbol': 'HE',
  },
  {
    symbol: 'HEAR',
    'Security Name': 'Turtle Beach Corporation  ',

    'NASDAQ symbol': 'HEAR',
  },
  {
    symbol: 'HEC',
    'Security Name': 'Hudson Executive Investment Corp   ',

    'NASDAQ symbol': 'HEC',
  },
  {
    symbol: 'HECCU',
    'Security Name': 'Hudson Executive Investment Corp  Units',

    'NASDAQ symbol': 'HECCU',
  },
  {
    symbol: 'HECCW',
    'Security Name': 'Hudson Executive Investment Corp  Warrant',

    'NASDAQ symbol': 'HECCW',
  },
  {
    symbol: 'HEDJ',
    'Security Name': 'WisdomTree Europe Hedged Equity Fund',

    'CQS symbol': 'HEDJ',
    'NASDAQ symbol': 'HEDJ',
  },
  {
    symbol: 'HEEM',
    'Security Name': 'iShares Currency Hedged MSCI Emerging Markets ETF',

    'CQS symbol': 'HEEM',
    'NASDAQ symbol': 'HEEM',
  },
  {
    symbol: 'HEES',
    'Security Name': 'H&E Equipment Services,   ',

    'NASDAQ symbol': 'HEES',
  },
  {
    symbol: 'HEFA',
    'Security Name': 'iShares Currency Hedged MSCI EAFE ETF',

    'CQS symbol': 'HEFA',
    'NASDAQ symbol': 'HEFA',
  },
  {
    symbol: 'HEI',
    'Security Name': 'Heico Corporation ',

    'CQS symbol': 'HEI',
    'NASDAQ symbol': 'HEI',
  },
  {
    symbol: 'HEIA',
    'Security Name': 'Heico Corporation ',

    'CQS symbol': 'HEIA',
    'NASDAQ symbol': 'HEIA',
  },
  {
    symbol: 'HELE',
    'Security Name': 'Helen of Troy Limited  ',

    'NASDAQ symbol': 'HELE',
  },
  {
    symbol: 'HELX',
    'Security Name': 'Franklin Genomic Advancements ETF',

    'CQS symbol': 'HELX',
    'NASDAQ symbol': 'HELX',
  },
  {
    symbol: 'HEP',
    'Security Name': 'Holly Energy Partners, LP ',

    'CQS symbol': 'HEP',
    'NASDAQ symbol': 'HEP',
  },
  {
    symbol: 'HEPA',
    'Security Name': 'Hepion Pharmaceuticals,   ',

    'NASDAQ symbol': 'HEPA',
  },
  {
    symbol: 'HEQ',
    'Security Name':
      'John Hancock Hedged Equity & ome Fund Common Shares of Beneficial Interest',

    'CQS symbol': 'HEQ',
    'NASDAQ symbol': 'HEQ',
  },
  {
    symbol: 'HERD',
    'Security Name': 'Pacer Cash Cows Fund of Funds ETF',

    'NASDAQ symbol': 'HERD',
  },
  {
    symbol: 'HERO',
    'Security Name': 'Global X Video Games & Esports ETF',

    'NASDAQ symbol': 'HERO',
  },
  {
    symbol: 'HES',
    'Security Name': 'Hess Corporation ',

    'CQS symbol': 'HES',
    'NASDAQ symbol': 'HES',
  },
  {
    symbol: 'HESM',
    'Security Name': 'Hess Midstream LP  Share',

    'CQS symbol': 'HESM',
    'NASDAQ symbol': 'HESM',
  },
  {
    symbol: 'HEWC',
    'Security Name': 'iShares Currency Hedged MSCI Canada ETF',

    'CQS symbol': 'HEWC',
    'NASDAQ symbol': 'HEWC',
  },
  {
    symbol: 'HEWG',
    'Security Name': 'iShares Currency Hedged MSCI Germany ETF',

    'NASDAQ symbol': 'HEWG',
  },
  {
    symbol: 'HEWJ',
    'Security Name': 'iShares Currency Hedged MSCI Japan ETF',

    'CQS symbol': 'HEWJ',
    'NASDAQ symbol': 'HEWJ',
  },
  {
    symbol: 'HEWU',
    'Security Name': 'iShares Currency Hedged MSCI United Kingdom ETF',

    'CQS symbol': 'HEWU',
    'NASDAQ symbol': 'HEWU',
  },
  {
    symbol: 'HEWW',
    'Security Name': 'iShares Currency Hedged MSCI Mexico ETF',

    'CQS symbol': 'HEWW',
    'NASDAQ symbol': 'HEWW',
  },
  {
    symbol: 'HEXO',
    'Security Name': 'HEXO Corp Common Shares',

    'CQS symbol': 'HEXO',
    'NASDAQ symbol': 'HEXO',
  },
  {
    symbol: 'HEZU',
    'Security Name': 'iShares Currency Hedged MSCI Eurozone ETF',

    'CQS symbol': 'HEZU',
    'NASDAQ symbol': 'HEZU',
  },
  {
    symbol: 'HFBL',
    'Security Name': 'Home Federal Bancorp,  of Louisiana  ',

    'NASDAQ symbol': 'HFBL',
  },
  {
    symbol: 'HFC',
    'Security Name': 'HollyFrontier Corporation ',

    'CQS symbol': 'HFC',
    'NASDAQ symbol': 'HFC',
  },
  {
    symbol: 'HFEN',
    'Security Name': 'HF Enterprises   ',

    'NASDAQ symbol': 'HFEN',
  },
  {
    symbol: 'HFFG',
    'Security Name': 'HF Foods Group   ',

    'NASDAQ symbol': 'HFFG',
  },
  {
    symbol: 'HFRO',
    'Security Name': 'Highland ome Fund',

    'CQS symbol': 'HFRO',
    'NASDAQ symbol': 'HFRO',
  },
  {
    symbol: 'HFRO$A',
    'Security Name':
      'Highland ome Fund 5375% Series A Cumulative Preferred Shares',

    'CQS symbol': 'HFROpA',
    'NASDAQ symbol': 'HFROA',
  },
  {
    symbol: 'HFWA',
    'Security Name': 'Heritage Financial Corporation  ',

    'NASDAQ symbol': 'HFWA',
  },
  {
    symbol: 'HFXI',
    'Security Name': 'IQ 50 Percent Hedged FTSE International ETF',

    'CQS symbol': 'HFXI',
    'NASDAQ symbol': 'HFXI',
  },
  {
    symbol: 'HGBL',
    'Security Name': 'Heritage Global   ',

    'NASDAQ symbol': 'HGBL',
  },
  {
    symbol: 'HGEN',
    'Security Name': 'Humanigen,   ',

    'NASDAQ symbol': 'HGEN',
  },
  {
    symbol: 'HGH',
    'Security Name':
      'Hartford Financial Services Group,  (The) 7875% Fixed to Floating Rate Junior Subordinated Debentures due 2042',

    'CQS symbol': 'HGH',
    'NASDAQ symbol': 'HGH',
  },
  {
    symbol: 'HGLB',
    'Security Name': 'Highland Global Allocation Fund ',

    'CQS symbol': 'HGLB',
    'NASDAQ symbol': 'HGLB',
  },
  {
    symbol: 'HGSH',
    'Security Name': 'China HGS Real Estate,   ',

    'NASDAQ symbol': 'HGSH',
  },
  {
    symbol: 'HGV',
    'Security Name': 'Hilton Grand Vacations   ',

    'CQS symbol': 'HGV',
    'NASDAQ symbol': 'HGV',
  },
  {
    symbol: 'HHC',
    'Security Name': 'Howard Hughes Corporation (The) ',

    'CQS symbol': 'HHC',
    'NASDAQ symbol': 'HHC',
  },
  {
    symbol: 'HHR',
    'Security Name': 'HeadHunter Group PLC  American Depositary Shares',

    'NASDAQ symbol': 'HHR',
  },
  {
    symbol: 'HI',
    'Security Name': 'Hillenbrand  ',

    'CQS symbol': 'HI',
    'NASDAQ symbol': 'HI',
  },
  {
    symbol: 'HIBB',
    'Security Name': 'Hibbett Sports,   ',

    'NASDAQ symbol': 'HIBB',
  },
  {
    symbol: 'HIBL',
    'Security Name': 'Direxion Daily S&P 500 High Beta Bull 3X Shares',

    'CQS symbol': 'HIBL',
    'NASDAQ symbol': 'HIBL',
  },
  {
    symbol: 'HIBS',
    'Security Name': 'Direxion Daily S&P 500 High Beta Bear 3X Shares',

    'CQS symbol': 'HIBS',
    'NASDAQ symbol': 'HIBS',
  },
  {
    symbol: 'HIE',
    'Security Name':
      'Miller/Howard High ome Equity Fund Common Shares of Beneficial Interest',

    'CQS symbol': 'HIE',
    'NASDAQ symbol': 'HIE',
  },
  {
    symbol: 'HIFS',
    'Security Name': 'Hingham Institution for Savings  ',

    'NASDAQ symbol': 'HIFS',
  },
  {
    symbol: 'HIG',
    'Security Name': 'Hartford Financial Services Group,  (The) ',

    'CQS symbol': 'HIG',
    'NASDAQ symbol': 'HIG',
  },
  {
    symbol: 'HIG$G',
    'Security Name':
      'Hartford Financial Services Group,  (The) Depositary Shares each representing a 1/1,000th interest in a share of 6000% NonCumulative Preferred Stock, Series G, $001 par value',

    'CQS symbol': 'HIGpG',
    'NASDAQ symbol': 'HIGG',
  },
  {
    symbol: 'HIGAU',
    'Security Name':
      'HIG Acquisition Corp Units, each consisting of one  ordinary share, $00001 par value, and onethird of one redeemable warrant',

    'CQS symbol': 'HIGAU',
    'NASDAQ symbol': 'HIGA=',
  },
  {
    symbol: 'HIHO',
    'Security Name': 'Highway Holdings Limited  ',

    'NASDAQ symbol': 'HIHO',
  },
  {
    symbol: 'HII',
    'Security Name': 'Huntington Ingalls Industries,  ',

    'CQS symbol': 'HII',
    'NASDAQ symbol': 'HII',
  },
  {
    symbol: 'HIL',
    'Security Name': 'Hill International,  ',

    'CQS symbol': 'HIL',
    'NASDAQ symbol': 'HIL',
  },
  {
    symbol: 'HIMX',
    'Security Name':
      'Himax Technologies,   American depositary shares, each of which represents two ordinary shares',

    'NASDAQ symbol': 'HIMX',
  },
  {
    symbol: 'HIO',
    'Security Name': 'Western Asset High ome Opportunity Fund,  ',

    'CQS symbol': 'HIO',
    'NASDAQ symbol': 'HIO',
  },
  {
    symbol: 'HIPR',
    'Security Name': 'Direxion High Growth ETF',

    'CQS symbol': 'HIPR',
    'NASDAQ symbol': 'HIPR',
  },
  {
    symbol: 'HIPS',
    'Security Name': 'GraniteShares HIPS US High ome ETF',

    'CQS symbol': 'HIPS',
    'NASDAQ symbol': 'HIPS',
  },
  {
    symbol: 'HIW',
    'Security Name': 'Highwoods Properties,  ',

    'CQS symbol': 'HIW',
    'NASDAQ symbol': 'HIW',
  },
  {
    symbol: 'HIX',
    'Security Name': 'Western Asset High ome Fund II  ',

    'CQS symbol': 'HIX',
    'NASDAQ symbol': 'HIX',
  },
  {
    symbol: 'HJLI',
    'Security Name': 'Hancock Jaffe Laboratories,   ',

    'NASDAQ symbol': 'HJLI',
  },
  {
    symbol: 'HJLIW',
    'Security Name': 'Hancock Jaffe Laboratories,   Warrants',

    'NASDAQ symbol': 'HJLIW',
  },
  {
    symbol: 'HJPX',
    'Security Name': 'iShares Currency Hedged JPXNikkei 400 ETF',

    'CQS symbol': 'HJPX',
    'NASDAQ symbol': 'HJPX',
  },
  {
    symbol: 'HKIB',
    'Security Name':
      'AMTD International  American Depositary Shares, each representing one  Ordinary Share',

    'CQS symbol': 'HKIB',
    'NASDAQ symbol': 'HKIB',
  },
  {
    symbol: 'HL',
    'Security Name': 'Hecla Mining Company ',

    'CQS symbol': 'HL',
    'NASDAQ symbol': 'HL',
  },
  {
    symbol: 'HL$B',
    'Security Name': 'Hecla Mining Company Preferred Stock',

    'CQS symbol': 'HLpB',
    'NASDAQ symbol': 'HLB',
  },
  {
    symbol: 'HLAL',
    'Security Name': 'Wahed FTSE USA Shariah ETF',

    'NASDAQ symbol': 'HLAL',
  },
  {
    symbol: 'HLF',
    'Security Name': 'Herbalife Nutrition Ltd ',

    'CQS symbol': 'HLF',
    'NASDAQ symbol': 'HLF',
  },
  {
    symbol: 'HLG',
    'Security Name': 'Hailiang Education Group   American Depositary Shares',

    'NASDAQ symbol': 'HLG',
  },
  {
    symbol: 'HLI',
    'Security Name': 'Houlihan Lokey,   ',

    'CQS symbol': 'HLI',
    'NASDAQ symbol': 'HLI',
  },
  {
    symbol: 'HLIO',
    'Security Name': 'Helios Technologies,   ',

    'NASDAQ symbol': 'HLIO',
  },
  {
    symbol: 'HLIT',
    'Security Name': 'Harmonic   ',

    'NASDAQ symbol': 'HLIT',
  },
  {
    symbol: 'HLM$',
    'Security Name': 'Hillman Group Capital Trust Preferred Stock',

    'CQS symbol': 'HLMp',
    'NASDAQ symbol': 'HLM',
  },
  {
    symbol: 'HLNE',
    'Security Name': 'Hamilton Lane orporated   ',

    'NASDAQ symbol': 'HLNE',
  },
  {
    symbol: 'HLT',
    'Security Name': 'Hilton Worldwide Holdings   ',

    'CQS symbol': 'HLT',
    'NASDAQ symbol': 'HLT',
  },
  {
    symbol: 'HLX',
    'Security Name': 'Helix Energy Solutions Group,  ',

    'CQS symbol': 'HLX',
    'NASDAQ symbol': 'HLX',
  },
  {
    symbol: 'HLXA',
    'Security Name': 'Helix Acquisition Corp   Ordinary Shares',

    'NASDAQ symbol': 'HLXA',
  },
  {
    symbol: 'HMC',
    'Security Name': 'Honda Motor Company, Ltd ',

    'CQS symbol': 'HMC',
    'NASDAQ symbol': 'HMC',
  },
  {
    symbol: 'HMG',
    'Security Name': 'HMG/Courtland Properties,  ',

    'CQS symbol': 'HMG',
    'NASDAQ symbol': 'HMG',
  },
  {
    symbol: 'HMHC',
    'Security Name': 'Houghton Mifflin Harcourt Company  ',

    'NASDAQ symbol': 'HMHC',
  },
  {
    symbol: 'HMI',
    'Security Name':
      'Huami Corporation American Depositary Shares, each representing four  Ordinary Shares',

    'CQS symbol': 'HMI',
    'NASDAQ symbol': 'HMI',
  },
  {
    symbol: 'HMLP',
    'Security Name':
      'Hoegh LNG Partners LP Common Units representing Limited Partner Interests',

    'CQS symbol': 'HMLP',
    'NASDAQ symbol': 'HMLP',
  },
  {
    symbol: 'HMLP$A',
    'Security Name':
      'Hoegh LNG Partners LP 875% Series A Cumulative Redeemable Preferred Units',

    'CQS symbol': 'HMLPpA',
    'NASDAQ symbol': 'HMLPA',
  },
  {
    symbol: 'HMN',
    'Security Name': 'Horace Mann Educators Corporation ',

    'CQS symbol': 'HMN',
    'NASDAQ symbol': 'HMN',
  },
  {
    symbol: 'HMNF',
    'Security Name': 'HMN Financial,   ',

    'NASDAQ symbol': 'HMNF',
  },
  {
    symbol: 'HMOP',
    'Security Name': 'Hartford Municipal Opportunities ETF',

    'CQS symbol': 'HMOP',
    'NASDAQ symbol': 'HMOP',
  },
  {
    symbol: 'HMST',
    'Security Name': 'HomeStreet,   ',

    'NASDAQ symbol': 'HMST',
  },
  {
    symbol: 'HMSY',
    'Security Name': 'HMS Holdings Corp  ',

    'NASDAQ symbol': 'HMSY',
  },
  {
    symbol: 'HMTV',
    'Security Name': 'Hemisphere Media Group,    ',

    'NASDAQ symbol': 'HMTV',
  },
  {
    symbol: 'HMY',
    'Security Name': 'Harmony Gold Mining Company Limited',

    'CQS symbol': 'HMY',
    'NASDAQ symbol': 'HMY',
  },
  {
    symbol: 'HNDL',
    'Security Name': 'Strategy Shares Nasdaq 7HANDL Index ETF',

    'NASDAQ symbol': 'HNDL',
  },
  {
    symbol: 'HNGR',
    'Security Name': 'Hanger,  ',

    'CQS symbol': 'HNGR',
    'NASDAQ symbol': 'HNGR',
  },
  {
    symbol: 'HNI',
    'Security Name': 'HNI Corporation ',

    'CQS symbol': 'HNI',
    'NASDAQ symbol': 'HNI',
  },
  {
    symbol: 'HNNA',
    'Security Name': 'Hennessy Advisors,   ',

    'NASDAQ symbol': 'HNNA',
  },
  {
    symbol: 'HNP',
    'Security Name': 'Huaneng Power Intl ',

    'CQS symbol': 'HNP',
    'NASDAQ symbol': 'HNP',
  },
  {
    symbol: 'HNRG',
    'Security Name': 'Hallador Energy Company  ',

    'NASDAQ symbol': 'HNRG',
  },
  {
    symbol: 'HNW',
    'Security Name':
      'Pioneer Diversified High ome Trust Pioneer Diversified High ome Trust Common Shares of Beneficial Interest',

    'CQS symbol': 'HNW',
    'NASDAQ symbol': 'HNW',
  },
  {
    symbol: 'HOFT',
    'Security Name': 'Hooker Furniture Corporation  ',

    'NASDAQ symbol': 'HOFT',
  },
  {
    symbol: 'HOFV',
    'Security Name': 'Hall of Fame Resort &amp; Entertainment Company  ',

    'NASDAQ symbol': 'HOFV',
  },
  {
    symbol: 'HOFVW',
    'Security Name': 'Hall of Fame Resort &amp; Entertainment Company  Warrant',

    'NASDAQ symbol': 'HOFVW',
  },
  {
    symbol: 'HOG',
    'Security Name': 'HarleyDavidson,  ',

    'CQS symbol': 'HOG',
    'NASDAQ symbol': 'HOG',
  },
  {
    symbol: 'HOL',
    'Security Name': 'Holicity    ',

    'NASDAQ symbol': 'HOL',
  },
  {
    symbol: 'HOLD',
    'Security Name': 'AdvisorShares Sage Core Reserves ETF',

    'CQS symbol': 'HOLD',
    'NASDAQ symbol': 'HOLD',
  },
  {
    symbol: 'HOLI',
    'Security Name': 'Hollysys Automation Technologies, Ltd  ',

    'NASDAQ symbol': 'HOLI',
  },
  {
    symbol: 'HOLUU',
    'Security Name': 'Holicity   Unit',

    'NASDAQ symbol': 'HOLUU',
  },
  {
    symbol: 'HOLUW',
    'Security Name': 'Holicity   Warrant',

    'NASDAQ symbol': 'HOLUW',
  },
  {
    symbol: 'HOLX',
    'Security Name': 'Hologic,   ',

    'NASDAQ symbol': 'HOLX',
  },
  {
    symbol: 'HOMB',
    'Security Name': 'Home BancShares,   ',

    'NASDAQ symbol': 'HOMB',
  },
  {
    symbol: 'HOME',
    'Security Name': 'At Home Group  ',

    'CQS symbol': 'HOME',
    'NASDAQ symbol': 'HOME',
  },
  {
    symbol: 'HOMZ',
    'Security Name': 'Hoya Capital Housing ETF',

    'CQS symbol': 'HOMZ',
    'NASDAQ symbol': 'HOMZ',
  },
  {
    symbol: 'HON',
    'Security Name': 'Honeywell International  ',

    'CQS symbol': 'HON',
    'NASDAQ symbol': 'HON',
  },
  {
    symbol: 'HONE',
    'Security Name': 'HarborOne Bancorp,   ',

    'NASDAQ symbol': 'HONE',
  },
  {
    symbol: 'HOOK',
    'Security Name': 'HOOKIPA Pharma   ',

    'NASDAQ symbol': 'HOOK',
  },
  {
    symbol: 'HOPE',
    'Security Name': 'Hope Bancorp,   ',

    'NASDAQ symbol': 'HOPE',
  },
  {
    symbol: 'HOTH',
    'Security Name': 'Hoth Therapeutics,   ',

    'NASDAQ symbol': 'HOTH',
  },
  {
    symbol: 'HOV',
    'Security Name': 'Hovnanian Enterprises,   ',

    'CQS symbol': 'HOV',
    'NASDAQ symbol': 'HOV',
  },
  {
    symbol: 'HOVNP',
    'Security Name':
      'Hovnanian Enterprises   Depositary Share representing 1/1000th of 7625% Series A Preferred Stock',

    'NASDAQ symbol': 'HOVNP',
  },
  {
    symbol: 'HP',
    'Security Name': 'Helmerich & Payne,  ',

    'CQS symbol': 'HP',
    'NASDAQ symbol': 'HP',
  },
  {
    symbol: 'HPE',
    'Security Name': 'Hewlett Packard Enterprise Company ',

    'CQS symbol': 'HPE',
    'NASDAQ symbol': 'HPE',
  },
  {
    symbol: 'HPF',
    'Security Name': 'John Hancock Pfd ome Fund II Pfd ome Fund II',

    'CQS symbol': 'HPF',
    'NASDAQ symbol': 'HPF',
  },
  {
    symbol: 'HPI',
    'Security Name':
      'John Hancock Preferred ome Fund Common Shares of Beneficial Interest',

    'CQS symbol': 'HPI',
    'NASDAQ symbol': 'HPI',
  },
  {
    symbol: 'HPK',
    'Security Name': 'HighPeak Energy,   ',

    'NASDAQ symbol': 'HPK',
  },
  {
    symbol: 'HPKEW',
    'Security Name': 'HighPeak Energy,   Warrant',

    'NASDAQ symbol': 'HPKEW',
  },
  {
    symbol: 'HPP',
    'Security Name': 'Hudson Pacific Properties,  ',

    'CQS symbol': 'HPP',
    'NASDAQ symbol': 'HPP',
  },
  {
    symbol: 'HPQ',
    'Security Name': 'HP  ',

    'CQS symbol': 'HPQ',
    'NASDAQ symbol': 'HPQ',
  },
  {
    symbol: 'HPR',
    'Security Name': 'HighPoint Resources Corporation ',

    'CQS symbol': 'HPR',
    'NASDAQ symbol': 'HPR',
  },
  {
    symbol: 'HPS',
    'Security Name':
      'John Hancock Preferred ome Fund III Preferred ome Fund III',

    'CQS symbol': 'HPS',
    'NASDAQ symbol': 'HPS',
  },
  {
    symbol: 'HPX',
    'Security Name': 'HPX Corp  Ordinary Shares',

    'CQS symbol': 'HPX',
    'NASDAQ symbol': 'HPX',
  },
  {
    symbol: 'HPXU',
    'Security Name':
      'HPX Corp Units, each consisting of one  ordinary share and onehalf of one redeemable warrant',

    'CQS symbol': 'HPXU',
    'NASDAQ symbol': 'HPX=',
  },
  {
    symbol: 'HPXW',
    'Security Name':
      'HPX Corp Redeemable warrants, each whole warrant exercisable for one  ordinary share at an exercise price of $1150',

    'CQS symbol': 'HPXWS',
    'NASDAQ symbol': 'HPX+',
  },
  {
    symbol: 'HQH',
    'Security Name': 'Tekla Healthcare Investors ',

    'CQS symbol': 'HQH',
    'NASDAQ symbol': 'HQH',
  },
  {
    symbol: 'HQI',
    'Security Name': 'HireQuest,   ',

    'NASDAQ symbol': 'HQI',
  },
  {
    symbol: 'HQL',
    'Security Name': 'TeklaLife Sciences Investors ',

    'CQS symbol': 'HQL',
    'NASDAQ symbol': 'HQL',
  },
  {
    symbol: 'HQY',
    'Security Name': 'HealthEquity,   ',

    'NASDAQ symbol': 'HQY',
  },
  {
    symbol: 'HR',
    'Security Name': 'Healthcare Realty Trust orporated ',

    'CQS symbol': 'HR',
    'NASDAQ symbol': 'HR',
  },
  {
    symbol: 'HRB',
    'Security Name': 'H&R Block,  ',

    'CQS symbol': 'HRB',
    'NASDAQ symbol': 'HRB',
  },
  {
    symbol: 'HRC',
    'Security Name': 'HillRom Holdings  ',

    'CQS symbol': 'HRC',
    'NASDAQ symbol': 'HRC',
  },
  {
    symbol: 'HRI',
    'Security Name': 'Herc Holdings   ',

    'CQS symbol': 'HRI',
    'NASDAQ symbol': 'HRI',
  },
  {
    symbol: 'HRL',
    'Security Name': 'Hormel Foods Corporation ',

    'CQS symbol': 'HRL',
    'NASDAQ symbol': 'HRL',
  },
  {
    symbol: 'HRMY',
    'Security Name': 'Harmony Biosciences Holdings,   ',

    'NASDAQ symbol': 'HRMY',
  },
  {
    symbol: 'HROW',
    'Security Name': 'Harrow Health,   ',

    'NASDAQ symbol': 'HROW',
  },
  {
    symbol: 'HRTG',
    'Security Name': 'Heritage Insurance Holdings,  ',

    'CQS symbol': 'HRTG',
    'NASDAQ symbol': 'HRTG',
  },
  {
    symbol: 'HRTX',
    'Security Name': 'Heron Therapeutics,     ',

    'NASDAQ symbol': 'HRTX',
  },
  {
    symbol: 'HRZN',
    'Security Name': 'Horizon Technology Finance Corporation  ',

    'NASDAQ symbol': 'HRZN',
  },
  {
    symbol: 'HSAQ',
    'Security Name':
      'Health Sciences Acquisitions Corporation 2  Ordinary Shares',

    'NASDAQ symbol': 'HSAQ',
  },
  {
    symbol: 'HSBC',
    'Security Name': 'HSBC Holdings, plc ',

    'CQS symbol': 'HSBC',
    'NASDAQ symbol': 'HSBC',
  },
  {
    symbol: 'HSBC$A',
    'Security Name': 'HSBC Holdings, plc ADR SER A REP 1/40 PFD SER A',

    'CQS symbol': 'HSBCpA',
    'NASDAQ symbol': 'HSBCA',
  },
  {
    symbol: 'HSC',
    'Security Name': 'Harsco Corporation ',

    'CQS symbol': 'HSC',
    'NASDAQ symbol': 'HSC',
  },
  {
    symbol: 'HSCZ',
    'Security Name': 'iShares Currency Hedged MSCI EAFE SmallCap ETF',

    'CQS symbol': 'HSCZ',
    'NASDAQ symbol': 'HSCZ',
  },
  {
    symbol: 'HSDT',
    'Security Name': 'Helius Medical Technologies,    ',

    'NASDAQ symbol': 'HSDT',
  },
  {
    symbol: 'HSIC',
    'Security Name': 'Henry Schein,   ',

    'NASDAQ symbol': 'HSIC',
  },
  {
    symbol: 'HSII',
    'Security Name': 'Heidrick & Struggles International,   ',

    'NASDAQ symbol': 'HSII',
  },
  {
    symbol: 'HSKA',
    'Security Name': 'Heska Corporation  ',

    'NASDAQ symbol': 'HSKA',
  },
  {
    symbol: 'HSMV',
    'Security Name': 'First Trust Horizon Managed Volatility Small/Mid ETF',

    'CQS symbol': 'HSMV',
    'NASDAQ symbol': 'HSMV',
  },
  {
    symbol: 'HSON',
    'Security Name': 'Hudson Global,   ',

    'NASDAQ symbol': 'HSON',
  },
  {
    symbol: 'HSRT',
    'Security Name': 'Hartford Short Duration ETF',

    'CQS symbol': 'HSRT',
    'NASDAQ symbol': 'HSRT',
  },
  {
    symbol: 'HST',
    'Security Name': 'Host Hotels   ',

    'NASDAQ symbol': 'HST',
  },
  {
    symbol: 'HSTM',
    'Security Name': 'HealthStream,   ',

    'NASDAQ symbol': 'HSTM',
  },
  {
    symbol: 'HSTO',
    'Security Name': 'Histogen   ',

    'NASDAQ symbol': 'HSTO',
  },
  {
    symbol: 'HSY',
    'Security Name': 'The Hershey Company ',

    'CQS symbol': 'HSY',
    'NASDAQ symbol': 'HSY',
  },
  {
    symbol: 'HT',
    'Security Name':
      'Hersha Hospitality Trust  Common Shares of Beneficial Interest',

    'CQS symbol': 'HT',
    'NASDAQ symbol': 'HT',
  },
  {
    symbol: 'HT$C',
    'Security Name':
      'Hersha Hospitality Trust 6875% Series C Cumulative Redeemable Preferred Shares of Beneficial Interest',

    'CQS symbol': 'HTpC',
    'NASDAQ symbol': 'HTC',
  },
  {
    symbol: 'HT$D',
    'Security Name':
      'Hersha Hospitality Trust 650% Series D Cumulative Redeemable Preferred Shares of Beneficial Interest, $001 par value per share',

    'CQS symbol': 'HTpD',
    'NASDAQ symbol': 'HTD',
  },
  {
    symbol: 'HT$E',
    'Security Name':
      'Hersha Hospitality Trust 650% Series E Cumulative Redeemable Preferred Shares of Beneficial Interest',

    'CQS symbol': 'HTpE',
    'NASDAQ symbol': 'HTE',
  },
  {
    symbol: 'HTA',
    'Security Name': 'Healthcare Trust of America,   ',

    'CQS symbol': 'HTA',
    'NASDAQ symbol': 'HTA',
  },
  {
    symbol: 'HTAB',
    'Security Name': 'Hartford Schroders TaxAware Bond ETF',

    'CQS symbol': 'HTAB',
    'NASDAQ symbol': 'HTAB',
  },
  {
    symbol: 'HTBI',
    'Security Name': 'HomeTrust Bancshares,   ',

    'NASDAQ symbol': 'HTBI',
  },
  {
    symbol: 'HTBK',
    'Security Name': 'Heritage Commerce Corp  ',

    'NASDAQ symbol': 'HTBK',
  },
  {
    symbol: 'HTBX',
    'Security Name': 'Heat Biologics,   ',

    'NASDAQ symbol': 'HTBX',
  },
  {
    symbol: 'HTD',
    'Security Name':
      'John Hancock Tax Advantaged Dividend ome Fund Common Shares of Beneficial Interest',

    'CQS symbol': 'HTD',
    'NASDAQ symbol': 'HTD',
  },
  {
    symbol: 'HTEC',
    'Security Name': 'Robo Global Healthcare Technology and Innovation ETF',

    'CQS symbol': 'HTEC',
    'NASDAQ symbol': 'HTEC',
  },
  {
    symbol: 'HTFA',
    'Security Name':
      'Horizon Technology Finance Corporation 625% Notes due 2022',

    'CQS symbol': 'HTFA',
    'NASDAQ symbol': 'HTFA',
  },
  {
    symbol: 'HTGC',
    'Security Name': 'Hercules Capital,  ',

    'CQS symbol': 'HTGC',
    'NASDAQ symbol': 'HTGC',
  },
  {
    symbol: 'HTGM',
    'Security Name': 'HTG Molecular Diagnostics,   ',

    'NASDAQ symbol': 'HTGM',
  },
  {
    symbol: 'HTH',
    'Security Name': 'Hilltop Holdings ',

    'CQS symbol': 'HTH',
    'NASDAQ symbol': 'HTH',
  },
  {
    symbol: 'HTHT',
    'Security Name':
      'Huazhu Group Limited  American Depositary Shares, each representing one Ordinary Share',

    'NASDAQ symbol': 'HTHT',
  },
  {
    symbol: 'HTIA',
    'Security Name':
      'Healthcare Trust,   7375% Series A Cumulative Redeemable Perpetual Preferred Stock',

    'NASDAQ symbol': 'HTIA',
  },
  {
    symbol: 'HTLD',
    'Security Name': 'Heartland Express,   ',

    'NASDAQ symbol': 'HTLD',
  },
  {
    symbol: 'HTLF',
    'Security Name': 'Heartland Financial USA,   ',

    'NASDAQ symbol': 'HTLF',
  },
  {
    symbol: 'HTLFP',
    'Security Name':
      'Heartland Financial USA,   Depositary Shares, each representing a 1/400th ownership interest in a share of 700% FixedRate Reset NonCumulative Perpetual Preferred Stock, Series E',

    'NASDAQ symbol': 'HTLFP',
  },
  {
    symbol: 'HTPAU',
    'Security Name':
      'Highland Transcend Partners I Corp Units, each consisting of one  ordinary share and onethird of one redeemable warrant',

    'CQS symbol': 'HTPAU',
    'NASDAQ symbol': 'HTPA=',
  },
  {
    symbol: 'HTRB',
    'Security Name': 'Hartford Total Return Bond ETF',

    'CQS symbol': 'HTRB',
    'NASDAQ symbol': 'HTRB',
  },
  {
    symbol: 'HTUS',
    'Security Name': 'Hull Tactical US ETF',

    'CQS symbol': 'HTUS',
    'NASDAQ symbol': 'HTUS',
  },
  {
    symbol: 'HTY',
    'Security Name':
      'John Hancock TaxAdvantaged Global Shareholder Yield Fund Common Shares of Beneficial Interest',

    'CQS symbol': 'HTY',
    'NASDAQ symbol': 'HTY',
  },
  {
    symbol: 'HUBB',
    'Security Name': 'Hubbell  ',

    'CQS symbol': 'HUBB',
    'NASDAQ symbol': 'HUBB',
  },
  {
    symbol: 'HUBG',
    'Security Name': 'Hub Group,    ',

    'NASDAQ symbol': 'HUBG',
  },
  {
    symbol: 'HUBS',
    'Security Name': 'HubSpot,  ',

    'CQS symbol': 'HUBS',
    'NASDAQ symbol': 'HUBS',
  },
  {
    symbol: 'HUGE',
    'Security Name': 'FSD Pharma   Class B Subordinate Voting Shares',

    'NASDAQ symbol': 'HUGE',
  },
  {
    symbol: 'HUIZ',
    'Security Name': 'Huize Holding Limited  American Depositary Shares',

    'NASDAQ symbol': 'HUIZ',
  },
  {
    symbol: 'HUM',
    'Security Name': 'Humana  ',

    'CQS symbol': 'HUM',
    'NASDAQ symbol': 'HUM',
  },
  {
    symbol: 'HUN',
    'Security Name': 'Huntsman Corporation ',

    'CQS symbol': 'HUN',
    'NASDAQ symbol': 'HUN',
  },
  {
    symbol: 'HURC',
    'Security Name': 'Hurco Companies,   ',

    'NASDAQ symbol': 'HURC',
  },
  {
    symbol: 'HURN',
    'Security Name': 'Huron Consulting Group   ',

    'NASDAQ symbol': 'HURN',
  },
  {
    symbol: 'HUSA',
    'Security Name': 'Houston American Energy Corporation ',

    'CQS symbol': 'HUSA',
    'NASDAQ symbol': 'HUSA',
  },
  {
    symbol: 'HUSN',
    'Security Name': 'Hudson Capital   Ordinary Shares',

    'NASDAQ symbol': 'HUSN',
  },
  {
    symbol: 'HUSV',
    'Security Name':
      'First Trust ExchangeTraded Fund III First Trust Horizon Managed Volatility Domestic ETF',

    'CQS symbol': 'HUSV',
    'NASDAQ symbol': 'HUSV',
  },
  {
    symbol: 'HUYA',
    'Security Name':
      'HUYA  American depositary shares, each  representing one  ordinary share',

    'CQS symbol': 'HUYA',
    'NASDAQ symbol': 'HUYA',
  },
  {
    symbol: 'HVBC',
    'Security Name': 'HV Bancorp,   ',

    'NASDAQ symbol': 'HVBC',
  },
  {
    symbol: 'HVT',
    'Security Name': 'Haverty Furniture Companies,  ',

    'CQS symbol': 'HVT',
    'NASDAQ symbol': 'HVT',
  },
  {
    symbol: 'HVTA',
    'Security Name': 'Haverty Furniture Companies,  ',

    'CQS symbol': 'HVTA',
    'NASDAQ symbol': 'HVTA',
  },
  {
    symbol: 'HWBK',
    'Security Name': 'Hawthorn Bancshares,   ',

    'NASDAQ symbol': 'HWBK',
  },
  {
    symbol: 'HWC',
    'Security Name': 'Hancock Whitney Corporation  ',

    'NASDAQ symbol': 'HWC',
  },
  {
    symbol: 'HWCC',
    'Security Name': 'Houston Wire & Cable Company  ',

    'NASDAQ symbol': 'HWCC',
  },
  {
    symbol: 'HWCPL',
    'Security Name':
      'Hancock Whitney Corporation  595% Subordinated Notes due 2045',

    'NASDAQ symbol': 'HWCPL',
  },
  {
    symbol: 'HWCPZ',
    'Security Name':
      'Hancock Whitney Corporation  625% Subordinated Notes due 2060',

    'NASDAQ symbol': 'HWCPZ',
  },
  {
    symbol: 'HWKN',
    'Security Name': 'Hawkins,   ',

    'NASDAQ symbol': 'HWKN',
  },
  {
    symbol: 'HWM',
    'Security Name': 'Howmet Aerospace  ',

    'CQS symbol': 'HWM',
    'NASDAQ symbol': 'HWM',
  },
  {
    symbol: 'HWM$',
    'Security Name': 'Howmet Aerospace  $375 Preferred Stock',

    'CQS symbol': 'HWMp',
    'NASDAQ symbol': 'HWM',
  },
  {
    symbol: 'HX',
    'Security Name': 'Hexindai   American Depositary Shares',

    'NASDAQ symbol': 'HX',
  },
  {
    symbol: 'HXL',
    'Security Name': 'Hexcel Corporation ',

    'CQS symbol': 'HXL',
    'NASDAQ symbol': 'HXL',
  },
  {
    symbol: 'HY',
    'Security Name': 'HysterYale Materials Handling,   ',

    'CQS symbol': 'HY',
    'NASDAQ symbol': 'HY',
  },
  {
    symbol: 'HYAC',
    'Security Name': 'Haymaker Acquisition Corp II   ',

    'NASDAQ symbol': 'HYAC',
  },
  {
    symbol: 'HYACU',
    'Security Name': 'Haymaker Acquisition Corp II  Unit',

    'NASDAQ symbol': 'HYACU',
  },
  {
    symbol: 'HYACW',
    'Security Name': 'Haymaker Acquisition Corp II  Warrant',

    'NASDAQ symbol': 'HYACW',
  },
  {
    symbol: 'HYB',
    'Security Name': 'New America High ome Fund,  (The) ',

    'CQS symbol': 'HYB',
    'NASDAQ symbol': 'HYB',
  },
  {
    symbol: 'HYBB',
    'Security Name': 'iShares BB Rated Corporate Bond ETF',

    'CQS symbol': 'HYBB',
    'NASDAQ symbol': 'HYBB',
  },
  {
    symbol: 'HYD',
    'Security Name':
      'VanEck Vectors ETF Trust VanEck Vectors High Yield Muni ETF',

    'CQS symbol': 'HYD',
    'NASDAQ symbol': 'HYD',
  },
  {
    symbol: 'HYDB',
    'Security Name': 'iShares High Yield Bond Factor ETF',

    'CQS symbol': 'HYDB',
    'NASDAQ symbol': 'HYDB',
  },
  {
    symbol: 'HYDW',
    'Security Name': 'Xtrackers Low Beta High Yield Bond ETF',

    'CQS symbol': 'HYDW',
    'NASDAQ symbol': 'HYDW',
  },
  {
    symbol: 'HYEM',
    'Security Name': 'VanEck Vectors Emerging Markets High Yield Bond ETF',

    'CQS symbol': 'HYEM',
    'NASDAQ symbol': 'HYEM',
  },
  {
    symbol: 'HYG',
    'Security Name': 'iShares iBoxx $ High Yield Corporate Bond ETF',

    'CQS symbol': 'HYG',
    'NASDAQ symbol': 'HYG',
  },
  {
    symbol: 'HYGH',
    'Security Name': 'iShares Interest Rate Hedged High Yield Bond ETF',

    'CQS symbol': 'HYGH',
    'NASDAQ symbol': 'HYGH',
  },
  {
    symbol: 'HYGV',
    'Security Name': 'FlexShares High Yield ValueScored Bond Index Fund',

    'CQS symbol': 'HYGV',
    'NASDAQ symbol': 'HYGV',
  },
  {
    symbol: 'HYHG',
    'Security Name': 'ProShares High Yield Interest Rate Hedged',

    'CQS symbol': 'HYHG',
    'NASDAQ symbol': 'HYHG',
  },
  {
    symbol: 'HYI',
    'Security Name': 'Western Asset High Yield Defined Opportunity Fund  ',

    'CQS symbol': 'HYI',
    'NASDAQ symbol': 'HYI',
  },
  {
    symbol: 'HYLB',
    'Security Name': 'Xtrackers USD High Yield Corporate Bond ETF',

    'CQS symbol': 'HYLB',
    'NASDAQ symbol': 'HYLB',
  },
  {
    symbol: 'HYLD',
    'Security Name': 'High Yield ETF',

    'CQS symbol': 'HYLD',
    'NASDAQ symbol': 'HYLD',
  },
  {
    symbol: 'HYLN',
    'Security Name': 'Hyliion Holdings Corp  ',

    'CQS symbol': 'HYLN',
    'NASDAQ symbol': 'HYLN',
  },
  {
    symbol: 'HYLNW',
    'Security Name': 'Hyliion Holdings Corp Warrants',

    'CQS symbol': 'HYLNWS',
    'NASDAQ symbol': 'HYLN+',
  },
  {
    symbol: 'HYLS',
    'Security Name': 'First Trust High Yield Long/Short ETF',

    'NASDAQ symbol': 'HYLS',
  },
  {
    symbol: 'HYLV',
    'Security Name':
      'IndexIQ ETF Trust IQ S&P High Yield Low Volatility Bond ETF',

    'CQS symbol': 'HYLV',
    'NASDAQ symbol': 'HYLV',
  },
  {
    symbol: 'HYMB',
    'Security Name':
      'SPDR Nuveen Bloomberg Barclays High Yield Municipal Bond ETF',

    'CQS symbol': 'HYMB',
    'NASDAQ symbol': 'HYMB',
  },
  {
    symbol: 'HYMC',
    'Security Name': 'Hycroft Mining Holding Corporation   ',

    'NASDAQ symbol': 'HYMC',
  },
  {
    symbol: 'HYMCW',
    'Security Name': 'Hycroft Mining Holding Corporation  Warrant',

    'NASDAQ symbol': 'HYMCW',
  },
  {
    symbol: 'HYMCZ',
    'Security Name': 'Hycroft Mining Holding Corporation  Warrant',

    'NASDAQ symbol': 'HYMCZ',
  },
  {
    symbol: 'HYRE',
    'Security Name': 'HyreCar   ',

    'NASDAQ symbol': 'HYRE',
  },
  {
    symbol: 'HYS',
    'Security Name':
      'PIMCO 05 Year High Yield Corporat Bond Index ExchangeTraded Fund',

    'CQS symbol': 'HYS',
    'NASDAQ symbol': 'HYS',
  },
  {
    symbol: 'HYT',
    'Security Name': 'Blackrock Corporate High Yield Fund,  ',

    'CQS symbol': 'HYT',
    'NASDAQ symbol': 'HYT',
  },
  {
    symbol: 'HYTR',
    'Security Name': 'CP High Yield Trend ETF',

    'CQS symbol': 'HYTR',
    'NASDAQ symbol': 'HYTR',
  },
  {
    symbol: 'HYUP',
    'Security Name': 'Xtrackers High Beta High Yield Bond ETF',

    'CQS symbol': 'HYUP',
    'NASDAQ symbol': 'HYUP',
  },
  {
    symbol: 'HYXF',
    'Security Name': 'iShares ESG Advanced High Yield Corporate Bond ETF',

    'NASDAQ symbol': 'HYXF',
  },
  {
    symbol: 'HYXU',
    'Security Name': 'iShares International High Yield Bond ETF',

    'CQS symbol': 'HYXU',
    'NASDAQ symbol': 'HYXU',
  },
  {
    symbol: 'HYZD',
    'Security Name': 'WisdomTree Interest Rate Hedged High Yield Bond Fund',

    'NASDAQ symbol': 'HYZD',
  },
  {
    symbol: 'HZAC',
    'Security Name': 'Horizon Acquisition Corporation  Ordinary Shares',

    'CQS symbol': 'HZAC',
    'NASDAQ symbol': 'HZAC',
  },
  {
    symbol: 'HZACU',
    'Security Name':
      'Horizon Acquisition Corporation Units, each consisting of one  Ordinary Shares and onethird of one Redeemable warrant',

    'CQS symbol': 'HZACU',
    'NASDAQ symbol': 'HZAC=',
  },
  {
    symbol: 'HZACW',
    'Security Name':
      'Horizon Acquisition Corporation Warrants, each whole warrant exercisable for one  ordinary share at an exercise price of $1150',

    'CQS symbol': 'HZACWS',
    'NASDAQ symbol': 'HZAC+',
  },
  {
    symbol: 'HZN',
    'Security Name': 'Horizon Global Corporation Common Shares',

    'CQS symbol': 'HZN',
    'NASDAQ symbol': 'HZN',
  },
  {
    symbol: 'HZNP',
    'Security Name':
      'Horizon Therapeutics Public Limited Company  Ordinary Shares',

    'NASDAQ symbol': 'HZNP',
  },
  {
    symbol: 'HZO',
    'Security Name': 'MarineMax,   (FL) ',

    'CQS symbol': 'HZO',
    'NASDAQ symbol': 'HZO',
  },
  {
    symbol: 'HZONU',
    'Security Name':
      'Horizon Acquisition Corporation II Units, each consisting of one  ordinary share, and onethird of one redeemable warrant',

    'CQS symbol': 'HZONU',
    'NASDAQ symbol': 'HZON=',
  },
  {
    symbol: 'IAA',
    'Security Name': 'IAA,   ',

    'CQS symbol': 'IAA',
    'NASDAQ symbol': 'IAA',
  },
  {
    symbol: 'IAC',
    'Security Name': 'IAC/InterActiveCorp  ',

    'NASDAQ symbol': 'IAC',
  },
  {
    symbol: 'IACA',
    'Security Name': 'ION Acquisition Corp 1 Ltd  Ordinary Shares',

    'CQS symbol': 'IACA',
    'NASDAQ symbol': 'IACA',
  },
  {
    symbol: 'IACAU',
    'Security Name':
      'ION Acquisition Corp 1 Ltd Units, each consisting of one  ordinary share and onethird of one redeemable warrant',

    'CQS symbol': 'IACAU',
    'NASDAQ symbol': 'IACA=',
  },
  {
    symbol: 'IACAW',
    'Security Name':
      'ION Acquisition Corp 1 Ltd Warrants, each whole warrant exercisable for one  ordinary share at an exercise price of $1150 per share',

    'CQS symbol': 'IACAWS',
    'NASDAQ symbol': 'IACA+',
  },
  {
    symbol: 'IAE',
    'Security Name':
      'Voya Asia Pacific High Dividend Equity ome Fund ING Asia Pacific High Dividend Equity ome Fund Common Shares of Beneficial Interest',

    'CQS symbol': 'IAE',
    'NASDAQ symbol': 'IAE',
  },
  {
    symbol: 'IAF',
    'Security Name': 'Aberdeen Australia Equity Fund  ',

    'CQS symbol': 'IAF',
    'NASDAQ symbol': 'IAF',
  },
  {
    symbol: 'IAG',
    'Security Name': 'Iamgold Corporation Ordinary Shares',

    'CQS symbol': 'IAG',
    'NASDAQ symbol': 'IAG',
  },
  {
    symbol: 'IAGG',
    'Security Name': 'iShares International Aggregate Bond Fund',

    'CQS symbol': 'IAGG',
    'NASDAQ symbol': 'IAGG',
  },
  {
    symbol: 'IAI',
    'Security Name': 'iShares US BrokerDealers & Securities Exchanges ETF',

    'CQS symbol': 'IAI',
    'NASDAQ symbol': 'IAI',
  },
  {
    symbol: 'IAK',
    'Security Name': 'iShares US Insurance ETF',

    'CQS symbol': 'IAK',
    'NASDAQ symbol': 'IAK',
  },
  {
    symbol: 'IART',
    'Security Name': 'Integra LifeSciences Holdings Corporation  ',

    'NASDAQ symbol': 'IART',
  },
  {
    symbol: 'IAT',
    'Security Name': 'iShares US Regional Banks ETF',

    'CQS symbol': 'IAT',
    'NASDAQ symbol': 'IAT',
  },
  {
    symbol: 'IAU',
    'Security Name': 'ishares Gold Trust',

    'CQS symbol': 'IAU',
    'NASDAQ symbol': 'IAU',
  },
  {
    symbol: 'IAUF',
    'Security Name': 'iShares Gold Strategy ETF',

    'CQS symbol': 'IAUF',
    'NASDAQ symbol': 'IAUF',
  },
  {
    symbol: 'IBA',
    'Security Name': 'Industrias Bachoco, SAB de CV ',

    'CQS symbol': 'IBA',
    'NASDAQ symbol': 'IBA',
  },
  {
    symbol: 'IBB',
    'Security Name': 'iShares Nasdaq Biotechnology Index Fund',

    'NASDAQ symbol': 'IBB',
  },
  {
    symbol: 'IBBJ',
    'Security Name': 'Defiance Nasdaq Junior Biotechnology ETF',

    'NASDAQ symbol': 'IBBJ',
  },
  {
    symbol: 'IBCE',
    'Security Name': 'iShares iBonds Mar 2023 Term Corporate exFinancials ETF',

    'CQS symbol': 'IBCE',
    'NASDAQ symbol': 'IBCE',
  },
  {
    symbol: 'IBCP',
    'Security Name': 'Independent Bank Corporation  ',

    'NASDAQ symbol': 'IBCP',
  },
  {
    symbol: 'IBD',
    'Security Name': 'Inspire Corporate Bond Impact ETF',

    'CQS symbol': 'IBD',
    'NASDAQ symbol': 'IBD',
  },
  {
    symbol: 'IBDD',
    'Security Name': 'iShares iBonds Mar 2023 Term Corporate ETF',

    'CQS symbol': 'IBDD',
    'NASDAQ symbol': 'IBDD',
  },
  {
    symbol: 'IBDL',
    'Security Name': 'iShares iBonds Dec 2020 Term Corporate ETF',

    'CQS symbol': 'IBDL',
    'NASDAQ symbol': 'IBDL',
  },
  {
    symbol: 'IBDM',
    'Security Name': 'iShares iBonds Dec 2021 Term Corporate ETF',

    'CQS symbol': 'IBDM',
    'NASDAQ symbol': 'IBDM',
  },
  {
    symbol: 'IBDN',
    'Security Name': 'iShares iBonds Dec 2022 Term Corporate ETF',

    'CQS symbol': 'IBDN',
    'NASDAQ symbol': 'IBDN',
  },
  {
    symbol: 'IBDO',
    'Security Name': 'iShares iBonds Dec 2023 Term Corporate ETF',

    'CQS symbol': 'IBDO',
    'NASDAQ symbol': 'IBDO',
  },
  {
    symbol: 'IBDP',
    'Security Name': 'iShares iBonds Dec 2024 Term Corporate ETF',

    'CQS symbol': 'IBDP',
    'NASDAQ symbol': 'IBDP',
  },
  {
    symbol: 'IBDQ',
    'Security Name': 'iShares iBonds Dec 2025 Term Corporate ETF',

    'CQS symbol': 'IBDQ',
    'NASDAQ symbol': 'IBDQ',
  },
  {
    symbol: 'IBDR',
    'Security Name': 'iShares iBonds Dec 2026 Term Corporate ETF',

    'CQS symbol': 'IBDR',
    'NASDAQ symbol': 'IBDR',
  },
  {
    symbol: 'IBDS',
    'Security Name': 'iShares iBonds Dec 2027 Term Corporate ETF',

    'CQS symbol': 'IBDS',
    'NASDAQ symbol': 'IBDS',
  },
  {
    symbol: 'IBDT',
    'Security Name': 'iShares iBonds Dec 2028 Term Corporate ETF',

    'CQS symbol': 'IBDT',
    'NASDAQ symbol': 'IBDT',
  },
  {
    symbol: 'IBDU',
    'Security Name': 'iShares iBonds Dec 2029 Term Corporate ETF',

    'CQS symbol': 'IBDU',
    'NASDAQ symbol': 'IBDU',
  },
  {
    symbol: 'IBDV',
    'Security Name': 'iShares iBonds Dec 2030 Term Corporate ETF',

    'CQS symbol': 'IBDV',
    'NASDAQ symbol': 'IBDV',
  },
  {
    symbol: 'IBEX',
    'Security Name': 'IBEX Limited  Common Share',

    'NASDAQ symbol': 'IBEX',
  },
  {
    symbol: 'IBHA',
    'Security Name': 'iShares iBonds 2021 Term High Yield and ome ETF',

    'CQS symbol': 'IBHA',
    'NASDAQ symbol': 'IBHA',
  },
  {
    symbol: 'IBHB',
    'Security Name': 'iShares iBonds 2022 Term High Yield and ome ETF',

    'CQS symbol': 'IBHB',
    'NASDAQ symbol': 'IBHB',
  },
  {
    symbol: 'IBHC',
    'Security Name': 'iShares iBonds 2023 Term High Yield and ome ETF',

    'CQS symbol': 'IBHC',
    'NASDAQ symbol': 'IBHC',
  },
  {
    symbol: 'IBHD',
    'Security Name': 'iShares iBonds 2024 Term High Yield and ome ETF',

    'CQS symbol': 'IBHD',
    'NASDAQ symbol': 'IBHD',
  },
  {
    symbol: 'IBHE',
    'Security Name': 'iShares iBonds 2025 Term High Yield and ome ETF',

    'CQS symbol': 'IBHE',
    'NASDAQ symbol': 'IBHE',
  },
  {
    symbol: 'IBHF',
    'Security Name': 'iShares iBonds 2026 Term High Yield and ome ETF',

    'CQS symbol': 'IBHF',
    'NASDAQ symbol': 'IBHF',
  },
  {
    symbol: 'IBIO',
    'Security Name': 'iBio,  ',

    'CQS symbol': 'IBIO',
    'NASDAQ symbol': 'IBIO',
  },
  {
    symbol: 'IBKR',
    'Security Name': 'Interactive Brokers Group,    ',

    'NASDAQ symbol': 'IBKR',
  },
  {
    symbol: 'IBM',
    'Security Name': 'International Business Machines Corporation ',

    'CQS symbol': 'IBM',
    'NASDAQ symbol': 'IBM',
  },
  {
    symbol: 'IBMJ',
    'Security Name': 'iShares iBonds Dec 2021 Term Muni Bond ETF',

    'CQS symbol': 'IBMJ',
    'NASDAQ symbol': 'IBMJ',
  },
  {
    symbol: 'IBMK',
    'Security Name': 'iShares iBonds Dec 2022 Term Muni Bond ETF',

    'CQS symbol': 'IBMK',
    'NASDAQ symbol': 'IBMK',
  },
  {
    symbol: 'IBML',
    'Security Name': 'iShares iBonds Dec 2023 Term Muni Bond ETF',

    'CQS symbol': 'IBML',
    'NASDAQ symbol': 'IBML',
  },
  {
    symbol: 'IBMM',
    'Security Name': 'iShares iBonds Dec 2024 Term Muni Bond ETF',

    'CQS symbol': 'IBMM',
    'NASDAQ symbol': 'IBMM',
  },
  {
    symbol: 'IBMN',
    'Security Name': 'iShares iBonds Dec 2025 Term Muni Bond ETF',

    'CQS symbol': 'IBMN',
    'NASDAQ symbol': 'IBMN',
  },
  {
    symbol: 'IBMO',
    'Security Name': 'iShares iBonds Dec 2026 Term Muni Bond ETF',

    'CQS symbol': 'IBMO',
    'NASDAQ symbol': 'IBMO',
  },
  {
    symbol: 'IBMP',
    'Security Name': 'iShares iBonds Dec 2027 Term Muni Bond ETF',

    'CQS symbol': 'IBMP',
    'NASDAQ symbol': 'IBMP',
  },
  {
    symbol: 'IBMQ',
    'Security Name': 'iShares iBonds Dec 2028 Term Muni Bond ETF',

    'CQS symbol': 'IBMQ',
    'NASDAQ symbol': 'IBMQ',
  },
  {
    symbol: 'IBN',
    'Security Name': 'ICICI Bank Limited ',

    'CQS symbol': 'IBN',
    'NASDAQ symbol': 'IBN',
  },
  {
    symbol: 'IBND',
    'Security Name': 'SPDR Bloomberg Barclays International Corporate Bond ETF',

    'CQS symbol': 'IBND',
    'NASDAQ symbol': 'IBND',
  },
  {
    symbol: 'IBO',
    'Security Name': 'IBO (Listing Market  NYSE Amex Network B F) ',

    'Test Issue': 'Y',

    'CQS symbol': 'IBO',
    'NASDAQ symbol': 'IBO',
  },
  {
    symbol: 'IBOC',
    'Security Name': 'International Bancshares Corporation  ',

    'NASDAQ symbol': 'IBOC',
  },
  {
    symbol: 'IBP',
    'Security Name': 'Installed Building Products,  ',

    'CQS symbol': 'IBP',
    'NASDAQ symbol': 'IBP',
  },
  {
    symbol: 'IBTA',
    'Security Name': 'iShares iBonds Dec 2021 Term Treasury ETF',

    'NASDAQ symbol': 'IBTA',
  },
  {
    symbol: 'IBTB',
    'Security Name': 'iShares iBonds Dec 2022 Term Treasury ETF',

    'NASDAQ symbol': 'IBTB',
  },
  {
    symbol: 'IBTD',
    'Security Name': 'iShares iBonds Dec 2023 Term Treasury ETF',

    'NASDAQ symbol': 'IBTD',
  },
  {
    symbol: 'IBTE',
    'Security Name': 'iShares iBonds Dec 2024 Term Treasury ETF',

    'NASDAQ symbol': 'IBTE',
  },
  {
    symbol: 'IBTF',
    'Security Name': 'iShares iBonds Dec 2025 Term Treasury ETF',

    'NASDAQ symbol': 'IBTF',
  },
  {
    symbol: 'IBTG',
    'Security Name': 'iShares iBonds Dec 2026 Term Treasury ETF',

    'NASDAQ symbol': 'IBTG',
  },
  {
    symbol: 'IBTH',
    'Security Name': 'iShares iBonds Dec 2027 Term Treasury ETF',

    'NASDAQ symbol': 'IBTH',
  },
  {
    symbol: 'IBTI',
    'Security Name': 'iShares iBonds Dec 2028 Term Treasury ETF',

    'NASDAQ symbol': 'IBTI',
  },
  {
    symbol: 'IBTJ',
    'Security Name': 'iShares iBonds Dec 2029 Term Treasury ETF',

    'NASDAQ symbol': 'IBTJ',
  },
  {
    symbol: 'IBTK',
    'Security Name': 'iShares iBonds Dec 2030 Term Treasury ETF',

    'NASDAQ symbol': 'IBTK',
  },
  {
    symbol: 'IBTX',
    'Security Name': 'Independent Bank Group,   ',

    'NASDAQ symbol': 'IBTX',
  },
  {
    symbol: 'IBUY',
    'Security Name': 'Amplify ETF Trust Amplify Online Retail ETF',

    'CQS symbol': 'IBUY',
    'NASDAQ symbol': 'IBUY',
  },
  {
    symbol: 'ICAD',
    'Security Name': 'icad   ',

    'NASDAQ symbol': 'ICAD',
  },
  {
    symbol: 'ICBK',
    'Security Name': 'County Bancorp,   ',

    'NASDAQ symbol': 'ICBK',
  },
  {
    symbol: 'ICCC',
    'Security Name': 'ImmuCell Corporation  ',

    'NASDAQ symbol': 'ICCC',
  },
  {
    symbol: 'ICCH',
    'Security Name': 'ICC Holdings,   ',

    'NASDAQ symbol': 'ICCH',
  },
  {
    symbol: 'ICD',
    'Security Name': 'Independence Contract Drilling,  ',

    'CQS symbol': 'ICD',
    'NASDAQ symbol': 'ICD',
  },
  {
    symbol: 'ICE',
    'Security Name': 'Intercontinental Exchange  ',

    'CQS symbol': 'ICE',
    'NASDAQ symbol': 'ICE',
  },
  {
    symbol: 'ICF',
    'Security Name': 'iShares Cohen & Steers REIT ETF',

    'CQS symbol': 'ICF',
    'NASDAQ symbol': 'ICF',
  },
  {
    symbol: 'ICFI',
    'Security Name': 'ICF International,   ',

    'NASDAQ symbol': 'ICFI',
  },
  {
    symbol: 'ICHR',
    'Security Name': 'Ichor Holdings  Ordinary Shares',

    'NASDAQ symbol': 'ICHR',
  },
  {
    symbol: 'ICL',
    'Security Name': 'ICL Group Ltd Ordinary Shares',

    'CQS symbol': 'ICL',
    'NASDAQ symbol': 'ICL',
  },
  {
    symbol: 'ICLK',
    'Security Name':
      'iClick Interactive Asia Group Limited  American Depositary Shares',

    'NASDAQ symbol': 'ICLK',
  },
  {
    symbol: 'ICLN',
    'Security Name': 'iShares S&P Global Clean Energy Index Fund',

    'NASDAQ symbol': 'ICLN',
  },
  {
    symbol: 'ICLR',
    'Security Name': 'ICON plc  Ordinary Shares',

    'NASDAQ symbol': 'ICLR',
  },
  {
    symbol: 'ICMB',
    'Security Name': 'Investcorp Credit Management BDC,   ',

    'NASDAQ symbol': 'ICMB',
  },
  {
    symbol: 'ICOL',
    'Security Name': 'iShares  iShares MSCI Colombia ETF',

    'CQS symbol': 'ICOL',
    'NASDAQ symbol': 'ICOL',
  },
  {
    symbol: 'ICON',
    'Security Name': 'Iconix Brand Group,   ',

    'NASDAQ symbol': 'ICON',
  },
  {
    symbol: 'ICOW',
    'Security Name': 'Pacer Developed Markets International Cash Cows 100 ETF',

    'CQS symbol': 'ICOW',
    'NASDAQ symbol': 'ICOW',
  },
  {
    symbol: 'ICPT',
    'Security Name': 'Intercept Pharmaceuticals,   ',

    'NASDAQ symbol': 'ICPT',
  },
  {
    symbol: 'ICSH',
    'Security Name': 'BlackRock Ultra ShortTerm Bond ETF',

    'CQS symbol': 'ICSH',
    'NASDAQ symbol': 'ICSH',
  },
  {
    symbol: 'ICUI',
    'Security Name': 'ICU Medical,   ',

    'NASDAQ symbol': 'ICUI',
  },
  {
    symbol: 'ICVT',
    'Security Name': 'iShares Convertible Bond ETF',

    'CQS symbol': 'ICVT',
    'NASDAQ symbol': 'ICVT',
  },
  {
    symbol: 'ID',
    'Security Name': 'PARTS iD,   ',

    'CQS symbol': 'ID',
    'NASDAQ symbol': 'ID',
  },
  {
    symbol: 'IDA',
    'Security Name': 'IDACORP,  ',

    'CQS symbol': 'IDA',
    'NASDAQ symbol': 'IDA',
  },
  {
    symbol: 'IDCC',
    'Security Name': 'InterDigital,   ',

    'NASDAQ symbol': 'IDCC',
  },
  {
    symbol: 'IDE',
    'Security Name':
      'Voya Infrastructure, Industrials and Materials Fund Common Shares of Beneficial Interest',

    'CQS symbol': 'IDE',
    'NASDAQ symbol': 'IDE',
  },
  {
    symbol: 'IDEV',
    'Security Name': 'iShares Core MSCI International Developed Markets ETF',

    'CQS symbol': 'IDEV',
    'NASDAQ symbol': 'IDEV',
  },
  {
    symbol: 'IDEX',
    'Security Name': 'Ideanomics,   ',

    'NASDAQ symbol': 'IDEX',
  },
  {
    symbol: 'IDHD',
    'Security Name':
      'Invesco S&P International Developed High Dividend Low Volatility ETF',

    'CQS symbol': 'IDHD',
    'NASDAQ symbol': 'IDHD',
  },
  {
    symbol: 'IDHQ',
    'Security Name': 'Invesco S&P International Developed Quality ETF',

    'CQS symbol': 'IDHQ',
    'NASDAQ symbol': 'IDHQ',
  },
  {
    symbol: 'IDIV',
    'Security Name': 'US Equity Cumulative Dividends Fund Series 2027 Shares',

    'CQS symbol': 'IDIV',
    'NASDAQ symbol': 'IDIV',
  },
  {
    symbol: 'IDLB',
    'Security Name': 'Invesco FTSE International Low Beta Equal Weight ETF',

    'NASDAQ symbol': 'IDLB',
  },
  {
    symbol: 'IDLV',
    'Security Name': 'Invesco S&P International Developed Low Volatility ETF',

    'CQS symbol': 'IDLV',
    'NASDAQ symbol': 'IDLV',
  },
  {
    symbol: 'IDMO',
    'Security Name': 'Invesco S&P International Developed Momentum ETF',

    'CQS symbol': 'IDMO',
    'NASDAQ symbol': 'IDMO',
  },
  {
    symbol: 'IDN',
    'Security Name': 'Intellicheck,   ',

    'NASDAQ symbol': 'IDN',
  },
  {
    symbol: 'IDNA',
    'Security Name': 'iShares Genomics Immunology and Healthcare ETF',

    'CQS symbol': 'IDNA',
    'NASDAQ symbol': 'IDNA',
  },
  {
    symbol: 'IDOG',
    'Security Name': 'ALPS International Sector Dividend Dogs ETF',

    'CQS symbol': 'IDOG',
    'NASDAQ symbol': 'IDOG',
  },
  {
    symbol: 'IDRA',
    'Security Name': 'Idera Pharmaceuticals,   ',

    'NASDAQ symbol': 'IDRA',
  },
  {
    symbol: 'IDRV',
    'Security Name': 'iShares SelfDriving EV and Tech ETF',

    'CQS symbol': 'IDRV',
    'NASDAQ symbol': 'IDRV',
  },
  {
    symbol: 'IDT',
    'Security Name': 'IDT Corporation Class B ',

    'CQS symbol': 'IDT',
    'NASDAQ symbol': 'IDT',
  },
  {
    symbol: 'IDU',
    'Security Name': 'iShares US Utilities ETF',

    'CQS symbol': 'IDU',
    'NASDAQ symbol': 'IDU',
  },
  {
    symbol: 'IDV',
    'Security Name': 'iShares International Select Dividend ETF',

    'CQS symbol': 'IDV',
    'NASDAQ symbol': 'IDV',
  },
  {
    symbol: 'IDX',
    'Security Name': 'VanEck Vectors Indonesia Index ETF',

    'CQS symbol': 'IDX',
    'NASDAQ symbol': 'IDX',
  },
  {
    symbol: 'IDXG',
    'Security Name': 'Interpace Biosciences,   ',

    'Financial Status': 'H',
    'NASDAQ symbol': 'IDXG',
  },
  {
    symbol: 'IDXX',
    'Security Name': 'IDEXX Laboratories,   ',

    'NASDAQ symbol': 'IDXX',
  },
  {
    symbol: 'IDYA',
    'Security Name': 'IDEAYA Biosciences,   ',

    'NASDAQ symbol': 'IDYA',
  },
  {
    symbol: 'IEA',
    'Security Name': 'Infrastructure and Energy Alternatives,   ',

    'NASDAQ symbol': 'IEA',
  },
  {
    symbol: 'IEAWW',
    'Security Name': 'Infrastructure and Energy Alternatives,   Warrant',

    'NASDAQ symbol': 'IEAWW',
  },
  {
    symbol: 'IEC',
    'Security Name': 'IEC Electronics Corp  ',

    'NASDAQ symbol': 'IEC',
  },
  {
    symbol: 'IECS',
    'Security Name': 'iShares Evolved US Consumer Staples ETF',

    'CQS symbol': 'IECS',
    'NASDAQ symbol': 'IECS',
  },
  {
    symbol: 'IEDI',
    'Security Name': 'iShares Evolved US Discretionary Spending ETF',

    'CQS symbol': 'IEDI',
    'NASDAQ symbol': 'IEDI',
  },
  {
    symbol: 'IEF',
    'Security Name': 'iShares 710 Year Treasury Bond ETF',

    'NASDAQ symbol': 'IEF',
  },
  {
    symbol: 'IEFA',
    'Security Name': 'iShares Core MSCI EAFE ETF',

    'CQS symbol': 'IEFA',
    'NASDAQ symbol': 'IEFA',
  },
  {
    symbol: 'IEFN',
    'Security Name': 'iShares Evolved US Financials ETF',

    'CQS symbol': 'IEFN',
    'NASDAQ symbol': 'IEFN',
  },
  {
    symbol: 'IEHS',
    'Security Name': 'iShares Evolved US Healthcare Staples ETF',

    'CQS symbol': 'IEHS',
    'NASDAQ symbol': 'IEHS',
  },
  {
    symbol: 'IEI',
    'Security Name': 'iShares 37 Year Treasury Bond ETF',

    'NASDAQ symbol': 'IEI',
  },
  {
    symbol: 'IEIH',
    'Security Name': 'iShares Evolved US Innovative Healthcare ETF',

    'CQS symbol': 'IEIH',
    'NASDAQ symbol': 'IEIH',
  },
  {
    symbol: 'IEME',
    'Security Name': 'iShares Evolved US Media and Entertainment ETF',

    'CQS symbol': 'IEME',
    'NASDAQ symbol': 'IEME',
  },
  {
    symbol: 'IEMG',
    'Security Name': 'iShares Core MSCI Emerging Markets ETF',

    'CQS symbol': 'IEMG',
    'NASDAQ symbol': 'IEMG',
  },
  {
    symbol: 'IEO',
    'Security Name': 'iShares US Oil & Gas Exploration & Production ETF',

    'CQS symbol': 'IEO',
    'NASDAQ symbol': 'IEO',
  },
  {
    symbol: 'IEP',
    'Security Name': 'Icahn Enterprises LP  Depositary units',

    'NASDAQ symbol': 'IEP',
  },
  {
    symbol: 'IESC',
    'Security Name': 'IES Holdings,   ',

    'NASDAQ symbol': 'IESC',
  },
  {
    symbol: 'IETC',
    'Security Name': 'iShares Evolved US Technology ETF',

    'CQS symbol': 'IETC',
    'NASDAQ symbol': 'IETC',
  },
  {
    symbol: 'IEUR',
    'Security Name': 'iShares Core MSCI Europe ETF',

    'CQS symbol': 'IEUR',
    'NASDAQ symbol': 'IEUR',
  },
  {
    symbol: 'IEUS',
    'Security Name': 'iShares MSCI Europe SmallCap ETF',

    'NASDAQ symbol': 'IEUS',
  },
  {
    symbol: 'IEV',
    'Security Name': 'iShares Europe ETF',

    'CQS symbol': 'IEV',
    'NASDAQ symbol': 'IEV',
  },
  {
    symbol: 'IEX',
    'Security Name': 'IDEX Corporation ',

    'CQS symbol': 'IEX',
    'NASDAQ symbol': 'IEX',
  },
  {
    symbol: 'IEZ',
    'Security Name': 'iShares US Oil Equipment & Services ETF',

    'CQS symbol': 'IEZ',
    'NASDAQ symbol': 'IEZ',
  },
  {
    symbol: 'IFF',
    'Security Name': 'Internationa Flavors & Fragrances,  ',

    'CQS symbol': 'IFF',
    'NASDAQ symbol': 'IFF',
  },
  {
    symbol: 'IFFT',
    'Security Name':
      'International Flavors & Fragrances,  600% Tangible Equity Units',

    'CQS symbol': 'IFFT',
    'NASDAQ symbol': 'IFFT',
  },
  {
    symbol: 'IFGL',
    'Security Name':
      'iShares FTSE EPRA/NAREIT Global Real Estate exUS Index Fund',

    'NASDAQ symbol': 'IFGL',
  },
  {
    symbol: 'IFMK',
    'Security Name': 'iFresh   ',

    'NASDAQ symbol': 'IFMK',
  },
  {
    symbol: 'IFN',
    'Security Name': 'India Fund,  (The) ',

    'CQS symbol': 'IFN',
    'NASDAQ symbol': 'IFN',
  },
  {
    symbol: 'IFRA',
    'Security Name': 'iShares US Infrastructure ETF',

    'CQS symbol': 'IFRA',
    'NASDAQ symbol': 'IFRA',
  },
  {
    symbol: 'IFRX',
    'Security Name': 'InflaRx NV  ',

    'NASDAQ symbol': 'IFRX',
  },
  {
    symbol: 'IFS',
    'Security Name': 'Intercorp Financial Services  Common Shares',

    'CQS symbol': 'IFS',
    'NASDAQ symbol': 'IFS',
  },
  {
    symbol: 'IFV',
    'Security Name': 'First Trust Dorsey Wright International Focus 5 ETF',

    'NASDAQ symbol': 'IFV',
  },
  {
    symbol: 'IG',
    'Security Name': 'Pripal Investment Grade Corporate Active ETF',

    'CQS symbol': 'IG',
    'NASDAQ symbol': 'IG',
  },
  {
    symbol: 'IGA',
    'Security Name':
      'Voya Global Advantage and Premium Opportunity Fund Common Shares of Beneficial Interest',

    'CQS symbol': 'IGA',
    'NASDAQ symbol': 'IGA',
  },
  {
    symbol: 'IGAC',
    'Security Name': 'IG Acquisition Corp   ',

    'NASDAQ symbol': 'IGAC',
  },
  {
    symbol: 'IGACU',
    'Security Name': 'IG Acquisition Corp  Unit',

    'NASDAQ symbol': 'IGACU',
  },
  {
    symbol: 'IGACW',
    'Security Name': 'IG Acquisition Corp  Warrant',

    'NASDAQ symbol': 'IGACW',
  },
  {
    symbol: 'IGBH',
    'Security Name': 'iShares Interest Rate Hedged LongTerm Corporate Bond ETF',

    'CQS symbol': 'IGBH',
    'NASDAQ symbol': 'IGBH',
  },
  {
    symbol: 'IGC',
    'Security Name': 'India Globalization Capital  ',

    'CQS symbol': 'IGC',
    'NASDAQ symbol': 'IGC',
  },
  {
    symbol: 'IGD',
    'Security Name': 'Voya Global Equity Dividend and Premium Opportunity Fund',

    'CQS symbol': 'IGD',
    'NASDAQ symbol': 'IGD',
  },
  {
    symbol: 'IGE',
    'Security Name': 'iShares North American Natural Resources ETF',

    'CQS symbol': 'IGE',
    'NASDAQ symbol': 'IGE',
  },
  {
    symbol: 'IGEB',
    'Security Name': 'iShares Investment Grade Bond Factor ETF',

    'CQS symbol': 'IGEB',
    'NASDAQ symbol': 'IGEB',
  },
  {
    symbol: 'IGF',
    'Security Name': 'iShares Global Infrastructure ETF',

    'NASDAQ symbol': 'IGF',
  },
  {
    symbol: 'IGHG',
    'Security Name': 'ProShares Investment GradeInterest Rate Hedged',

    'CQS symbol': 'IGHG',
    'NASDAQ symbol': 'IGHG',
  },
  {
    symbol: 'IGI',
    'Security Name':
      'Western Asset Investment Grade Defined Opportunity Trust  ',

    'CQS symbol': 'IGI',
    'NASDAQ symbol': 'IGI',
  },
  {
    symbol: 'IGIB',
    'Security Name': 'iShares 510 Year Investment Grade Corporate Bond ETF',

    'NASDAQ symbol': 'IGIB',
  },
  {
    symbol: 'IGIC',
    'Security Name':
      'International General Insurance Holdings Ltd  Ordinary Shares',

    'NASDAQ symbol': 'IGIC',
  },
  {
    symbol: 'IGICW',
    'Security Name':
      'International General Insurance Holdings Ltd  Warrant expiring 3/17/2025',

    'NASDAQ symbol': 'IGICW',
  },
  {
    symbol: 'IGLB',
    'Security Name': 'iShares 10  Year Investment Grade Corporate Bond ETF',

    'CQS symbol': 'IGLB',
    'NASDAQ symbol': 'IGLB',
  },
  {
    symbol: 'IGM',
    'Security Name': 'iShares Expanded Tech Sector ETF',

    'CQS symbol': 'IGM',
    'NASDAQ symbol': 'IGM',
  },
  {
    symbol: 'IGMS',
    'Security Name': 'IGM Biosciences,   ',

    'NASDAQ symbol': 'IGMS',
  },
  {
    symbol: 'IGN',
    'Security Name': 'iShares North American TechMultimedia Networking ETF',

    'CQS symbol': 'IGN',
    'NASDAQ symbol': 'IGN',
  },
  {
    symbol: 'IGOV',
    'Security Name': 'iShares International Treasury Bond ETF',

    'NASDAQ symbol': 'IGOV',
  },
  {
    symbol: 'IGR',
    'Security Name': 'CBRE Clarion Global Real Estate ome Fund ',

    'CQS symbol': 'IGR',
    'NASDAQ symbol': 'IGR',
  },
  {
    symbol: 'IGRO',
    'Security Name': 'iShares International Dividend Growth ETF',

    'CQS symbol': 'IGRO',
    'NASDAQ symbol': 'IGRO',
  },
  {
    symbol: 'IGSB',
    'Security Name': 'iShares 15 Year Investment Grade Corporate Bond ETF',

    'NASDAQ symbol': 'IGSB',
  },
  {
    symbol: 'IGT',
    'Security Name': 'International Game Technology Ordinary Shares',

    'CQS symbol': 'IGT',
    'NASDAQ symbol': 'IGT',
  },
  {
    symbol: 'IGV',
    'Security Name': 'iShares Expanded TechSoftware Sector ETF',

    'CQS symbol': 'IGV',
    'NASDAQ symbol': 'IGV',
  },
  {
    symbol: 'IGZ',
    'Security Name': 'IGZ (Listing Market NYSE Arca Network B F) ',

    'Test Issue': 'Y',

    'CQS symbol': 'IGZ',
    'NASDAQ symbol': 'IGZ',
  },
  {
    symbol: 'IH',
    'Security Name':
      'iHuman  American depositary shares, each representing five  ordinary shares',

    'CQS symbol': 'IH',
    'NASDAQ symbol': 'IH',
  },
  {
    symbol: 'IHAK',
    'Security Name': 'iShares Cybersecurity and Tech ETF',

    'CQS symbol': 'IHAK',
    'NASDAQ symbol': 'IHAK',
  },
  {
    symbol: 'IHC',
    'Security Name': 'Independence Holding Company ',

    'CQS symbol': 'IHC',
    'NASDAQ symbol': 'IHC',
  },
  {
    symbol: 'IHD',
    'Security Name':
      'Voya Emerging Markets High ome Dividend Equity Fund Common Shares',

    'CQS symbol': 'IHD',
    'NASDAQ symbol': 'IHD',
  },
  {
    symbol: 'IHDG',
    'Security Name':
      'WisdomTree International Hedged Quality Dividend Growth Fund',

    'CQS symbol': 'IHDG',
    'NASDAQ symbol': 'IHDG',
  },
  {
    symbol: 'IHE',
    'Security Name': 'iShares US Pharmaceutical ETF',

    'CQS symbol': 'IHE',
    'NASDAQ symbol': 'IHE',
  },
  {
    symbol: 'IHF',
    'Security Name': 'iShares US Health Care Providers ETF',

    'CQS symbol': 'IHF',
    'NASDAQ symbol': 'IHF',
  },
  {
    symbol: 'IHG',
    'Security Name':
      'Intercontinental Hotels Group American Depositary Shares (Each representing one Ordinary Share)',

    'CQS symbol': 'IHG',
    'NASDAQ symbol': 'IHG',
  },
  {
    symbol: 'IHI',
    'Security Name': 'iShares US Medical Devices ETF',

    'CQS symbol': 'IHI',
    'NASDAQ symbol': 'IHI',
  },
  {
    symbol: 'IHIT',
    'Security Name':
      'Invesco High ome 2023 Target Term Fund Common Shares of Beneficial Interest',

    'CQS symbol': 'IHIT',
    'NASDAQ symbol': 'IHIT',
  },
  {
    symbol: 'IHRT',
    'Security Name': 'iHeartMedia,    ',

    'NASDAQ symbol': 'IHRT',
  },
  {
    symbol: 'IHT',
    'Security Name':
      'InnSuites Hospitality Trust Shares of Beneficial Interest',

    'CQS symbol': 'IHT',
    'NASDAQ symbol': 'IHT',
  },
  {
    symbol: 'IHTA',
    'Security Name':
      'Invesco High ome 2024 Target Term Fund Common Shares of Beneficial Interest, No par value per share',

    'CQS symbol': 'IHTA',
    'NASDAQ symbol': 'IHTA',
  },
  {
    symbol: 'IHY',
    'Security Name': 'VanEck Vectors International High Yield Bond',

    'CQS symbol': 'IHY',
    'NASDAQ symbol': 'IHY',
  },
  {
    symbol: 'IHYF',
    'Security Name': 'Invesco High Yield Bond Factor ETF',

    'NASDAQ symbol': 'IHYF',
  },
  {
    symbol: 'IIACU',
    'Security Name': 'Investindustrial Acquisition Corp Unit',

    'CQS symbol': 'IIACU',
    'NASDAQ symbol': 'IIAC=',
  },
  {
    symbol: 'IID',
    'Security Name':
      'Voya International High Dividend Equity ome Fund Common Shares of Beneficial Interest',

    'CQS symbol': 'IID',
    'NASDAQ symbol': 'IID',
  },
  {
    symbol: 'IIF',
    'Security Name': 'Morgan Stanley India Investment Fund,  ',

    'CQS symbol': 'IIF',
    'NASDAQ symbol': 'IIF',
  },
  {
    symbol: 'IIGD',
    'Security Name': 'Invesco Investment Grade Defensive ETF',

    'CQS symbol': 'IIGD',
    'NASDAQ symbol': 'IIGD',
  },
  {
    symbol: 'IIGV',
    'Security Name': 'Invesco Investment Grade Value ETF',

    'CQS symbol': 'IIGV',
    'NASDAQ symbol': 'IIGV',
  },
  {
    symbol: 'III',
    'Security Name': 'Information Services Group,   ',

    'NASDAQ symbol': 'III',
  },
  {
    symbol: 'IIIN',
    'Security Name': 'Insteel Industries,   ',

    'NASDAQ symbol': 'IIIN',
  },
  {
    symbol: 'IIIV',
    'Security Name': 'i3 Verticals,   ',

    'NASDAQ symbol': 'IIIV',
  },
  {
    symbol: 'IIM',
    'Security Name': 'Invesco Value Municipal ome Trust ',

    'CQS symbol': 'IIM',
    'NASDAQ symbol': 'IIM',
  },
  {
    symbol: 'IIN',
    'Security Name': 'IntriCon Corporation  ',

    'NASDAQ symbol': 'IIN',
  },
  {
    symbol: 'IIPR',
    'Security Name': 'Innovative Industrial Properties,  ',

    'CQS symbol': 'IIPR',
    'NASDAQ symbol': 'IIPR',
  },
  {
    symbol: 'IIPR$A',
    'Security Name':
      'Innovative Industrial Properties,  900% Series A Cumulative Redeemable Preferred Stock',

    'CQS symbol': 'IIPRpA',
    'NASDAQ symbol': 'IIPRA',
  },
  {
    symbol: 'IIVI',
    'Security Name': 'IIVI orporated  ',

    'NASDAQ symbol': 'IIVI',
  },
  {
    symbol: 'IIVIP',
    'Security Name':
      'IIVI orporated  600% Series A Mandatory Convertible Preferred Stock',

    'NASDAQ symbol': 'IIVIP',
  },
  {
    symbol: 'IJAN',
    'Security Name':
      'Innovator ETFs Trust Innovator MSCI EAFE Power Buffer ETF  January',

    'CQS symbol': 'IJAN',
    'NASDAQ symbol': 'IJAN',
  },
  {
    symbol: 'IJH',
    'Security Name': 'iShares Core S&P MidCap ETF',

    'CQS symbol': 'IJH',
    'NASDAQ symbol': 'IJH',
  },
  {
    symbol: 'IJJ',
    'Security Name': 'iShares S&P MidCap 400 Value ETF',

    'CQS symbol': 'IJJ',
    'NASDAQ symbol': 'IJJ',
  },
  {
    symbol: 'IJK',
    'Security Name': 'iShares S&P MidCap 400 Growth ETF',

    'CQS symbol': 'IJK',
    'NASDAQ symbol': 'IJK',
  },
  {
    symbol: 'IJR',
    'Security Name': 'iShares Core S&P SmallCap ETF',

    'CQS symbol': 'IJR',
    'NASDAQ symbol': 'IJR',
  },
  {
    symbol: 'IJS',
    'Security Name': 'iShares S&P SmallCap 600 Value ETF',

    'CQS symbol': 'IJS',
    'NASDAQ symbol': 'IJS',
  },
  {
    symbol: 'IJT',
    'Security Name': 'iShares S&P SmallCap 600 Growth ETF',

    'NASDAQ symbol': 'IJT',
  },
  {
    symbol: 'IJUL',
    'Security Name': 'Innovator MSCI EAFE Power Buffer ETF  July',

    'CQS symbol': 'IJUL',
    'NASDAQ symbol': 'IJUL',
  },
  {
    symbol: 'IKNX',
    'Security Name': 'Ikonics Corporation  ',

    'NASDAQ symbol': 'IKNX',
  },
  {
    symbol: 'ILF',
    'Security Name': 'iShares Latin America 40 ETF',

    'CQS symbol': 'ILF',
    'NASDAQ symbol': 'ILF',
  },
  {
    symbol: 'ILMN',
    'Security Name': 'Illumina,   ',

    'NASDAQ symbol': 'ILMN',
  },
  {
    symbol: 'ILPT',
    'Security Name':
      'Industrial Logistics Properties Trust  Common Shares of Beneficial Interest',

    'NASDAQ symbol': 'ILPT',
  },
  {
    symbol: 'ILTB',
    'Security Name': 'iShares Core 10  Year USD Bond ETF',

    'CQS symbol': 'ILTB',
    'NASDAQ symbol': 'ILTB',
  },
  {
    symbol: 'IMAB',
    'Security Name': 'IMAB  American Depositary Shares',

    'NASDAQ symbol': 'IMAB',
  },
  {
    symbol: 'IMAC',
    'Security Name': 'IMAC Holdings,   ',

    'NASDAQ symbol': 'IMAC',
  },
  {
    symbol: 'IMACW',
    'Security Name': 'IMAC Holdings,   Warrant',

    'NASDAQ symbol': 'IMACW',
  },
  {
    symbol: 'IMAX',
    'Security Name': 'Imax Corporation ',

    'CQS symbol': 'IMAX',
    'NASDAQ symbol': 'IMAX',
  },
  {
    symbol: 'IMBI',
    'Security Name': 'iMedia Brands,    ',

    'NASDAQ symbol': 'IMBI',
  },
  {
    symbol: 'IMGN',
    'Security Name': 'ImmunoGen,   ',

    'NASDAQ symbol': 'IMGN',
  },
  {
    symbol: 'IMH',
    'Security Name': 'Impac Mortgage Holdings,   ',

    'CQS symbol': 'IMH',
    'NASDAQ symbol': 'IMH',
  },
  {
    symbol: 'IMKTA',
    'Security Name': 'Ingles Markets, orporated   ',

    'NASDAQ symbol': 'IMKTA',
  },
  {
    symbol: 'IMLP',
    'Security Name': 'iPath S&P MLP ETN',

    'CQS symbol': 'IMLP',
    'NASDAQ symbol': 'IMLP',
  },
  {
    symbol: 'IMMP',
    'Security Name': 'Immutep Limited  American Depositary Shares',

    'NASDAQ symbol': 'IMMP',
  },
  {
    symbol: 'IMMR',
    'Security Name': 'Immersion Corporation  ',

    'NASDAQ symbol': 'IMMR',
  },
  {
    symbol: 'IMNM',
    'Security Name': 'Immunome,   ',

    'NASDAQ symbol': 'IMNM',
  },
  {
    symbol: 'IMO',
    'Security Name': 'Imperial Oil Limited ',

    'CQS symbol': 'IMO',
    'NASDAQ symbol': 'IMO',
  },
  {
    symbol: 'IMOM',
    'Security Name': 'Alpha Architect International Quantitative Momentum ETF',

    'CQS symbol': 'IMOM',
    'NASDAQ symbol': 'IMOM',
  },
  {
    symbol: 'IMOS',
    'Security Name': 'ChipMOS TECHNOLOGIES   American Depositary Shares',

    'NASDAQ symbol': 'IMOS',
  },
  {
    symbol: 'IMPX',
    'Security Name': 'AEABridges Impact Corp  Ordinary Shares',

    'CQS symbol': 'IMPX',
    'NASDAQ symbol': 'IMPX',
  },
  {
    symbol: 'IMPXU',
    'Security Name':
      'AEABridges Impact Corp Units, each consisting of one  ordinary share, and onehalf of one redeemable warrant',

    'CQS symbol': 'IMPXU',
    'NASDAQ symbol': 'IMPX=',
  },
  {
    symbol: 'IMPXW',
    'Security Name':
      'AEABridges Impact Corp Warrants, each whole warrant exercisable for one  ordinary share at an exercise price of $1150',

    'CQS symbol': 'IMPXWS',
    'NASDAQ symbol': 'IMPX+',
  },
  {
    symbol: 'IMRA',
    'Security Name': 'IMARA   ',

    'NASDAQ symbol': 'IMRA',
  },
  {
    symbol: 'IMRN',
    'Security Name': 'Immuron Limited  American Depositary Shares',

    'NASDAQ symbol': 'IMRN',
  },
  {
    symbol: 'IMRNW',
    'Security Name': 'Immuron Limited  Warrants',

    'NASDAQ symbol': 'IMRNW',
  },
  {
    symbol: 'IMTB',
    'Security Name': 'iShares Core 510 Year USD Bond ETF',

    'CQS symbol': 'IMTB',
    'NASDAQ symbol': 'IMTB',
  },
  {
    symbol: 'IMTE',
    'Security Name': 'Integrated Media Technology Limited  Ordinary Shares',

    'NASDAQ symbol': 'IMTE',
  },
  {
    symbol: 'IMTM',
    'Security Name': 'iShares MSCI Intl Momentum Factor ETF',

    'CQS symbol': 'IMTM',
    'NASDAQ symbol': 'IMTM',
  },
  {
    symbol: 'IMTX',
    'Security Name': 'Immatics NV  Ordinary Shares',

    'NASDAQ symbol': 'IMTX',
  },
  {
    symbol: 'IMTXW',
    'Security Name': 'Immatics NV  Warrants',

    'NASDAQ symbol': 'IMTXW',
  },
  {
    symbol: 'IMUX',
    'Security Name': 'Immunic,    ',

    'NASDAQ symbol': 'IMUX',
  },
  {
    symbol: 'IMV',
    'Security Name': 'IMV   Common Shares',

    'NASDAQ symbol': 'IMV',
  },
  {
    symbol: 'IMVT',
    'Security Name': 'Immunovant,    ',

    'NASDAQ symbol': 'IMVT',
  },
  {
    symbol: 'IMXI',
    'Security Name': 'International Money Express,   ',

    'NASDAQ symbol': 'IMXI',
  },
  {
    symbol: 'INAQ',
    'Security Name': 'INSU Acquisition Corp II   ',

    'NASDAQ symbol': 'INAQ',
  },
  {
    symbol: 'INAQU',
    'Security Name': 'INSU Acquisition Corp II  Unit',

    'NASDAQ symbol': 'INAQU',
  },
  {
    symbol: 'INAQW',
    'Security Name': 'INSU Acquisition Corp II  Warrant',

    'NASDAQ symbol': 'INAQW',
  },
  {
    symbol: 'INBK',
    'Security Name': 'First Internet Bancorp  ',

    'NASDAQ symbol': 'INBK',
  },
  {
    symbol: 'INBKL',
    'Security Name':
      'First Internet Bancorp  60% FixedtoFloating Rate Subordinated Notes due 2026',

    'NASDAQ symbol': 'INBKL',
  },
  {
    symbol: 'INBKZ',
    'Security Name':
      'First Internet Bancorp  FixedtoFloating Rate Subordinated Notes Due 2029',

    'NASDAQ symbol': 'INBKZ',
  },
  {
    symbol: 'INBX',
    'Security Name': 'Inhibrx,   ',

    'NASDAQ symbol': 'INBX',
  },
  {
    symbol: 'O',
    'Security Name': 'Columbia India Consumer ETF',

    'CQS symbol': 'O',
    'NASDAQ symbol': 'O',
  },
  {
    symbol: 'Y',
    'Security Name': 'yte Corporation  ',

    'NASDAQ symbol': 'Y',
  },
  {
    symbol: 'INDA',
    'Security Name': 'Ishares MSCI India ETF',

    'CQS symbol': 'INDA',
    'NASDAQ symbol': 'INDA',
  },
  {
    symbol: 'INDB',
    'Security Name': 'Independent Bank Corp  ',

    'NASDAQ symbol': 'INDB',
  },
  {
    symbol: 'INDF',
    'Security Name': 'Nifty India Financials ETF',

    'CQS symbol': 'INDF',
    'NASDAQ symbol': 'INDF',
  },
  {
    symbol: 'INDL',
    'Security Name': 'Direxion Daily MSCI India Bull 2X Shares',

    'CQS symbol': 'INDL',
    'NASDAQ symbol': 'INDL',
  },
  {
    symbol: 'INDO',
    'Security Name': 'Indonesia Energy Corporation Limited Ordinary Shares',

    'CQS symbol': 'INDO',
    'NASDAQ symbol': 'INDO',
  },
  {
    symbol: 'INDS',
    'Security Name': 'Pacer Benchmark Industrial Real Estate SCTR ETF',

    'CQS symbol': 'INDS',
    'NASDAQ symbol': 'INDS',
  },
  {
    symbol: 'INDY',
    'Security Name': 'iShares S&P India Nifty 50 Index Fund',

    'NASDAQ symbol': 'INDY',
  },
  {
    symbol: 'INFI',
    'Security Name': 'Infinity Pharmaceuticals,   ',

    'NASDAQ symbol': 'INFI',
  },
  {
    symbol: 'INFN',
    'Security Name': 'Infinera Corporation  ',

    'NASDAQ symbol': 'INFN',
  },
  {
    symbol: 'INFO',
    'Security Name': 'IHS Markit Ltd Common Shares',

    'CQS symbol': 'INFO',
    'NASDAQ symbol': 'INFO',
  },
  {
    symbol: 'INFR',
    'Security Name': 'Legg Mason Global Infrastructure ETF',

    'NASDAQ symbol': 'INFR',
  },
  {
    symbol: 'INFU',
    'Security Name': 'InfuSystems Holdings,  ',

    'CQS symbol': 'INFU',
    'NASDAQ symbol': 'INFU',
  },
  {
    symbol: 'INFY',
    'Security Name': 'Infosys Limited American Depositary Shares',

    'CQS symbol': 'INFY',
    'NASDAQ symbol': 'INFY',
  },
  {
    symbol: 'ING',
    'Security Name': 'ING Group, NV ',

    'CQS symbol': 'ING',
    'NASDAQ symbol': 'ING',
  },
  {
    symbol: 'INGN',
    'Security Name': 'Inogen,   ',

    'NASDAQ symbol': 'INGN',
  },
  {
    symbol: 'INGR',
    'Security Name': 'Ingredion orporated ',

    'CQS symbol': 'INGR',
    'NASDAQ symbol': 'INGR',
  },
  {
    symbol: 'INKM',
    'Security Name': 'SPDR SSgA ome Allocation ETF',

    'CQS symbol': 'INKM',
    'NASDAQ symbol': 'INKM',
  },
  {
    symbol: 'INM',
    'Security Name': 'InMed Pharmaceuticals   Common Shares',

    'NASDAQ symbol': 'INM',
  },
  {
    symbol: 'INMB',
    'Security Name': 'INmune Bio   ',

    'NASDAQ symbol': 'INMB',
  },
  {
    symbol: 'INMD',
    'Security Name': 'InMode Ltd   Ordinary Shares',

    'NASDAQ symbol': 'INMD',
  },
  {
    symbol: 'INN',
    'Security Name': 'Summit Hotel Properties,  ',

    'CQS symbol': 'INN',
    'NASDAQ symbol': 'INN',
  },
  {
    symbol: 'INN$D',
    'Security Name':
      'Summit Hotel Properties,  645% Series D Cumulative Redeemable Preferred Stock',

    'CQS symbol': 'INNpD',
    'NASDAQ symbol': 'INND',
  },
  {
    symbol: 'INN$E',
    'Security Name':
      'Summit Hotel Properties,  6250% Series E Cumulative Redeemable Preferred Stock',

    'CQS symbol': 'INNpE',
    'NASDAQ symbol': 'INNE',
  },
  {
    symbol: 'INO',
    'Security Name': 'Inovio Pharmaceuticals,   ',

    'NASDAQ symbol': 'INO',
  },
  {
    symbol: 'INOD',
    'Security Name': 'Innodata   ',

    'NASDAQ symbol': 'INOD',
  },
  {
    symbol: 'INOV',
    'Security Name': 'Inovalon Holdings,    ',

    'NASDAQ symbol': 'INOV',
  },
  {
    symbol: 'INPX',
    'Security Name': 'Inpixon   ',

    'NASDAQ symbol': 'INPX',
  },
  {
    symbol: 'INS',
    'Security Name': 'Intelligent Systems Corporation ',

    'CQS symbol': 'INS',
    'NASDAQ symbol': 'INS',
  },
  {
    symbol: 'INSE',
    'Security Name': 'Inspired Entertainment,   ',

    'NASDAQ symbol': 'INSE',
  },
  {
    symbol: 'INSG',
    'Security Name': 'Inseego Corp  ',

    'NASDAQ symbol': 'INSG',
  },
  {
    symbol: 'INSI',
    'Security Name': 'Insight Select ome Fund',

    'CQS symbol': 'INSI',
    'NASDAQ symbol': 'INSI',
  },
  {
    symbol: 'INSM',
    'Security Name': 'Insmed,   ',

    'NASDAQ symbol': 'INSM',
  },
  {
    symbol: 'INSP',
    'Security Name': 'Inspire Medical Systems,  ',

    'CQS symbol': 'INSP',
    'NASDAQ symbol': 'INSP',
  },
  {
    symbol: 'INSW',
    'Security Name': 'International Seaways,   ',

    'CQS symbol': 'INSW',
    'NASDAQ symbol': 'INSW',
  },
  {
    symbol: 'INSW$A',
    'Security Name':
      'International Seaways,  850% Senior Notes due June 30, 2023',

    'CQS symbol': 'INSWpA',
    'NASDAQ symbol': 'INSWA',
  },
  {
    symbol: 'INT',
    'Security Name': 'World Fuel Services Corporation ',

    'CQS symbol': 'INT',
    'NASDAQ symbol': 'INT',
  },
  {
    symbol: 'INTC',
    'Security Name': 'Intel Corporation  ',

    'NASDAQ symbol': 'INTC',
  },
  {
    symbol: 'INTF',
    'Security Name': 'iShares MSCI Intl Multifactor ETF',

    'CQS symbol': 'INTF',
    'NASDAQ symbol': 'INTF',
  },
  {
    symbol: 'INTG',
    'Security Name': 'The Intergroup Corporation  ',

    'NASDAQ symbol': 'INTG',
  },
  {
    symbol: 'INTT',
    'Security Name': 'inTest Corporation ',

    'CQS symbol': 'INTT',
    'NASDAQ symbol': 'INTT',
  },
  {
    symbol: 'INTU',
    'Security Name': 'Intuit   ',

    'NASDAQ symbol': 'INTU',
  },
  {
    symbol: 'INTZ',
    'Security Name': 'Intrusion   ',

    'NASDAQ symbol': 'INTZ',
  },
  {
    symbol: 'INUV',
    'Security Name': 'Inuvo, ',

    'CQS symbol': 'INUV',
    'NASDAQ symbol': 'INUV',
  },
  {
    symbol: 'INVA',
    'Security Name': 'Innoviva,   ',

    'NASDAQ symbol': 'INVA',
  },
  {
    symbol: 'INVE',
    'Security Name': 'Identiv,   ',

    'NASDAQ symbol': 'INVE',
  },
  {
    symbol: 'INVH',
    'Security Name': 'Invitation Homes  ',

    'CQS symbol': 'INVH',
    'NASDAQ symbol': 'INVH',
  },
  {
    symbol: 'INVO',
    'Security Name': 'INVO BioScience,   ',

    'NASDAQ symbol': 'INVO',
  },
  {
    symbol: 'INZY',
    'Security Name': 'Inozyme Pharma,   ',

    'NASDAQ symbol': 'INZY',
  },
  {
    symbol: 'IO',
    'Security Name': 'Ion Geophysical Corporation ',

    'CQS symbol': 'IO',
    'NASDAQ symbol': 'IO',
  },
  {
    symbol: 'IONS',
    'Security Name': 'Ionis Pharmaceuticals,   ',

    'NASDAQ symbol': 'IONS',
  },
  {
    symbol: 'IOO',
    'Security Name': 'iShares Global 100 ETF',

    'CQS symbol': 'IOO',
    'NASDAQ symbol': 'IOO',
  },
  {
    symbol: 'IOR',
    'Security Name': 'ome Opportunity Realty Investors,  ',

    'CQS symbol': 'IOR',
    'NASDAQ symbol': 'IOR',
  },
  {
    symbol: 'IOSP',
    'Security Name': 'Innospec   ',

    'NASDAQ symbol': 'IOSP',
  },
  {
    symbol: 'IOVA',
    'Security Name': 'Iovance Biotherapeutics,   ',

    'NASDAQ symbol': 'IOVA',
  },
  {
    symbol: 'IP',
    'Security Name': 'International Paper Company ',

    'CQS symbol': 'IP',
    'NASDAQ symbol': 'IP',
  },
  {
    symbol: 'IPAC',
    'Security Name': 'iShares Core MSCI Pacific ETF',

    'CQS symbol': 'IPAC',
    'NASDAQ symbol': 'IPAC',
  },
  {
    symbol: 'IPAR',
    'Security Name': 'Inter Parfums,   ',

    'NASDAQ symbol': 'IPAR',
  },
  {
    symbol: 'IPAY',
    'Security Name': 'ETFMG Prime Mobile Payments ETF',

    'CQS symbol': 'IPAY',
    'NASDAQ symbol': 'IPAY',
  },
  {
    symbol: 'IPB',
    'Security Name':
      'Merrill Lynch & Co,  60518% Index Plus Trust Certificates Series 20031',

    'CQS symbol': 'IPB',
    'NASDAQ symbol': 'IPB',
  },
  {
    symbol: 'IPDN',
    'Security Name': 'Professional Diversity Network,   ',

    'NASDAQ symbol': 'IPDN',
  },
  {
    symbol: 'IPFF',
    'Security Name': 'iShares International Preferred Stock ETF',

    'CQS symbol': 'IPFF',
    'NASDAQ symbol': 'IPFF',
  },
  {
    symbol: 'IPG',
    'Security Name': 'Interpublic Group of Companies,  (The) ',

    'CQS symbol': 'IPG',
    'NASDAQ symbol': 'IPG',
  },
  {
    symbol: 'IPGP',
    'Security Name': 'IPG Photonics Corporation  ',

    'NASDAQ symbol': 'IPGP',
  },
  {
    symbol: 'IPHA',
    'Security Name': 'Innate Pharma SA  American Depositary Shares',

    'NASDAQ symbol': 'IPHA',
  },
  {
    symbol: 'IPHI',
    'Security Name': 'Inphi Corporation  ',

    'NASDAQ symbol': 'IPHI',
  },
  {
    symbol: 'IPI',
    'Security Name': 'Intrepid Potash,  ',

    'CQS symbol': 'IPI',
    'NASDAQ symbol': 'IPI',
  },
  {
    symbol: 'IPKW',
    'Security Name': 'Invesco International BuyBack Achievers ETF',

    'NASDAQ symbol': 'IPKW',
  },
  {
    symbol: 'IPLDP',
    'Security Name':
      'Interstate Power and Light Company  Interstate Power & Light Company Perp Preferred 510% Series D',

    'NASDAQ symbol': 'IPLDP',
  },
  {
    symbol: 'IPO',
    'Security Name': 'Renaissance IPO ETF',

    'CQS symbol': 'IPO',
    'NASDAQ symbol': 'IPO',
  },
  {
    symbol: 'IPOB',
    'Security Name':
      'Social Capital Hedosophia Holdings Corp II  Ordinary Shares',

    'CQS symbol': 'IPOB',
    'NASDAQ symbol': 'IPOB',
  },
  {
    symbol: 'IPOBU',
    'Security Name':
      'Social Capital Hedosophia Holdings Corp II Units, each consisting of one  ordinary share and onequarter of one redeemable warrant',

    'CQS symbol': 'IPOBU',
    'NASDAQ symbol': 'IPOB=',
  },
  {
    symbol: 'IPOBW',
    'Security Name':
      'Social Capital Hedosophia Holdings Corp II Redeemable Warrants, each whole warrant exercisable for one  ordinary share at an exercise price of $1150',

    'CQS symbol': 'IPOBWS',
    'NASDAQ symbol': 'IPOB+',
  },
  {
    symbol: 'IPOC',
    'Security Name':
      'Social Capital Hedosophia Holdings Corp III  Ordinary Shares',

    'CQS symbol': 'IPOC',
    'NASDAQ symbol': 'IPOC',
  },
  {
    symbol: 'IPOCU',
    'Security Name':
      'Social Capital Hedosophia Holdings Corp III Units, each consisting of one  ordinary share and onequarter of one redeemable warrant',

    'CQS symbol': 'IPOCU',
    'NASDAQ symbol': 'IPOC=',
  },
  {
    symbol: 'IPOCW',
    'Security Name':
      'Social Capital Hedosophia Holdings Corp III Redeemable Warrants, each whole warrant exercisable for one  ordinary share at an exercise price of $1150',

    'CQS symbol': 'IPOCWS',
    'NASDAQ symbol': 'IPOC+',
  },
  {
    symbol: 'IPOD',
    'Security Name':
      'Social Capital Hedosophia Holdings Corp IV  Ordinary Shares',

    'CQS symbol': 'IPOD',
    'NASDAQ symbol': 'IPOD',
  },
  {
    symbol: 'IPODU',
    'Security Name':
      'Social Capital Hedosophia Holdings Corp IV Units, each consisting of one  ordinary share and onefourth of one redeemable warrant',

    'CQS symbol': 'IPODU',
    'NASDAQ symbol': 'IPOD=',
  },
  {
    symbol: 'IPODW',
    'Security Name':
      'Social Capital Hedosophia Holdings Corp IV Redeemable Warrants, each whole warrant exercisable for one  ordinary share at an exercise price of $1150',

    'CQS symbol': 'IPODWS',
    'NASDAQ symbol': 'IPOD+',
  },
  {
    symbol: 'IPOE',
    'Security Name':
      'Social Capital Hedosophia Holdings Corp V  Ordinary Shares',

    'CQS symbol': 'IPOE',
    'NASDAQ symbol': 'IPOE',
  },
  {
    symbol: 'IPOEU',
    'Security Name':
      'Social Capital Hedosophia Holdings Corp V Units, each consisting of one  ordinary share and onefourth of one redeemable warrant',

    'CQS symbol': 'IPOEU',
    'NASDAQ symbol': 'IPOE=',
  },
  {
    symbol: 'IPOEW',
    'Security Name':
      'Social Capital Hedosophia Holdings Corp V Redeemable Warrants, each whole warrant exercisable for one  ordinary share at an exercise price of $1150',

    'CQS symbol': 'IPOEWS',
    'NASDAQ symbol': 'IPOE+',
  },
  {
    symbol: 'IPOF',
    'Security Name':
      'Social Capital Hedosophia Holdings Corp VI  Ordinary Shares',

    'CQS symbol': 'IPOF',
    'NASDAQ symbol': 'IPOF',
  },
  {
    symbol: 'IPOFU',
    'Security Name':
      'Social Capital Hedosophia Holdings Corp VI Units, each consisting of one  ordinary share and onefourth of one redeemable warrant',

    'CQS symbol': 'IPOFU',
    'NASDAQ symbol': 'IPOF=',
  },
  {
    symbol: 'IPOFW',
    'Security Name':
      'Social Capital Hedosophia Holdings Corp VI Redeemable warrants, each whole warrant exercisable for one  ordinary share at an exercise price of $1150',

    'CQS symbol': 'IPOFWS',
    'NASDAQ symbol': 'IPOF+',
  },
  {
    symbol: 'IPOS',
    'Security Name': 'Renaissance Capital Greenwich Fund',

    'CQS symbol': 'IPOS',
    'NASDAQ symbol': 'IPOS',
  },
  {
    symbol: 'IPV',
    'Security Name': 'InterPrivate Acquisition Corp ',

    'CQS symbol': 'IPV',
    'NASDAQ symbol': 'IPV',
  },
  {
    symbol: 'IPVU',
    'Security Name':
      'InterPrivate Acquisition Corp Units, each consisting of one share of , $0001 par value, and onehalf of one Warrant',

    'CQS symbol': 'IPVU',
    'NASDAQ symbol': 'IPV=',
  },
  {
    symbol: 'IPVW',
    'Security Name':
      'InterPrivate Acquisition Corp Redeemable Warrants, each whole warrant exercisable for shares of  at an exercise price of $1150 per share',

    'CQS symbol': 'IPVWS',
    'NASDAQ symbol': 'IPV+',
  },
  {
    symbol: 'IPWR',
    'Security Name': 'Ideal Power   ',

    'NASDAQ symbol': 'IPWR',
  },
  {
    symbol: 'IQ',
    'Security Name': 'iQIYI,   American Depositary Shares',

    'NASDAQ symbol': 'IQ',
  },
  {
    symbol: 'IQDE',
    'Security Name':
      'FlexShares International Quality Dividend Defensive Index Fund',

    'CQS symbol': 'IQDE',
    'NASDAQ symbol': 'IQDE',
  },
  {
    symbol: 'IQDF',
    'Security Name': 'FlexShares International Quality Dividend Index Fund',

    'CQS symbol': 'IQDF',
    'NASDAQ symbol': 'IQDF',
  },
  {
    symbol: 'IQDG',
    'Security Name': 'WisdomTree International Quality Dividend Growth Fund',

    'CQS symbol': 'IQDG',
    'NASDAQ symbol': 'IQDG',
  },
  {
    symbol: 'IQDY',
    'Security Name':
      'FlexShares International Quality Dividend Dynamic Index Fund',

    'CQS symbol': 'IQDY',
    'NASDAQ symbol': 'IQDY',
  },
  {
    symbol: 'IQI',
    'Security Name': 'Invesco Quality Municipal ome Trust ',

    'CQS symbol': 'IQI',
    'NASDAQ symbol': 'IQI',
  },
  {
    symbol: 'IQIN',
    'Security Name': 'IQ 500 International ETF',

    'CQS symbol': 'IQIN',
    'NASDAQ symbol': 'IQIN',
  },
  {
    symbol: 'IQLT',
    'Security Name': 'iShares MSCI Intl Quality Factor ETF',

    'CQS symbol': 'IQLT',
    'NASDAQ symbol': 'IQLT',
  },
  {
    symbol: 'IQM',
    'Security Name': 'Franklin Intelligent Machines ETF',

    'CQS symbol': 'IQM',
    'NASDAQ symbol': 'IQM',
  },
  {
    symbol: 'IQSI',
    'Security Name': 'IQ Candriam ESG International Equity ETF',

    'CQS symbol': 'IQSI',
    'NASDAQ symbol': 'IQSI',
  },
  {
    symbol: 'IQSU',
    'Security Name': 'IQ Candriam ESG US Equity ETF',

    'CQS symbol': 'IQSU',
    'NASDAQ symbol': 'IQSU',
  },
  {
    symbol: 'IQV',
    'Security Name': 'IQVIA Holdings,  ',

    'CQS symbol': 'IQV',
    'NASDAQ symbol': 'IQV',
  },
  {
    symbol: 'IR',
    'Security Name': 'Ingersoll Rand  ',

    'CQS symbol': 'IR',
    'NASDAQ symbol': 'IR',
  },
  {
    symbol: 'IRBO',
    'Security Name':
      'iShares Robotics and Artificial Intelligence Multisector ETF',

    'CQS symbol': 'IRBO',
    'NASDAQ symbol': 'IRBO',
  },
  {
    symbol: 'IRBT',
    'Security Name': 'iRobot Corporation  ',

    'NASDAQ symbol': 'IRBT',
  },
  {
    symbol: 'IRCP',
    'Security Name': 'IRSA Propiedades Comerciales SA  American ',

    'NASDAQ symbol': 'IRCP',
  },
  {
    symbol: 'IRDM',
    'Security Name': 'Iridium Communications   ',

    'NASDAQ symbol': 'IRDM',
  },
  {
    symbol: 'IRET',
    'Security Name':
      'Investors Real Estate Trust Shares of Beneficial Interest',

    'CQS symbol': 'IRET',
    'NASDAQ symbol': 'IRET',
  },
  {
    symbol: 'IRET$C',
    'Security Name':
      'Investors Real Estate Trust 6625% Series C Cumulative Redeemable Preferred Shares (Liquidation Preference $2500 Per Share)',

    'CQS symbol': 'IRETpC',
    'NASDAQ symbol': 'IRETC',
  },
  {
    symbol: 'IRIX',
    'Security Name': 'IRIDEX Corporation  ',

    'NASDAQ symbol': 'IRIX',
  },
  {
    symbol: 'IRL',
    'Security Name': 'New Ireland Fund,  (The) ',

    'CQS symbol': 'IRL',
    'NASDAQ symbol': 'IRL',
  },
  {
    symbol: 'IRM',
    'Security Name': 'Iron Mountain orporated (Delaware) REIT',

    'CQS symbol': 'IRM',
    'NASDAQ symbol': 'IRM',
  },
  {
    symbol: 'IRMD',
    'Security Name': 'iRadimed Corporation  ',

    'NASDAQ symbol': 'IRMD',
  },
  {
    symbol: 'IROQ',
    'Security Name': 'IF Bancorp,   ',

    'NASDAQ symbol': 'IROQ',
  },
  {
    symbol: 'IRR',
    'Security Name':
      'Voya Natural Resources Equity ome Fund Common Shares of Beneficial Interest',

    'CQS symbol': 'IRR',
    'NASDAQ symbol': 'IRR',
  },
  {
    symbol: 'IRS',
    'Security Name': 'IRSA Inversiones Y Representaciones SA ',

    'CQS symbol': 'IRS',
    'NASDAQ symbol': 'IRS',
  },
  {
    symbol: 'IRT',
    'Security Name': 'Independence Realty Trust,  ',

    'CQS symbol': 'IRT',
    'NASDAQ symbol': 'IRT',
  },
  {
    symbol: 'IRTC',
    'Security Name': 'iRhythm Technologies,   ',

    'NASDAQ symbol': 'IRTC',
  },
  {
    symbol: 'IRWD',
    'Security Name': 'Ironwood Pharmaceuticals,    ',

    'NASDAQ symbol': 'IRWD',
  },
  {
    symbol: 'ISBC',
    'Security Name': 'Investors Bancorp,   ',

    'NASDAQ symbol': 'ISBC',
  },
  {
    symbol: 'ISCF',
    'Security Name': 'iShares MSCI Intl SmallCap Multifactor ETF',

    'CQS symbol': 'ISCF',
    'NASDAQ symbol': 'ISCF',
  },
  {
    symbol: 'ISD',
    'Security Name': 'PGIM High Yield Bond Fund, ',

    'CQS symbol': 'ISD',
    'NASDAQ symbol': 'ISD',
  },
  {
    symbol: 'ISDR',
    'Security Name': 'Issuer Direct Corporation ',

    'CQS symbol': 'ISDR',
    'NASDAQ symbol': 'ISDR',
  },
  {
    symbol: 'ISDX',
    'Security Name': 'Invesco RAFI Strategic Developed exUS ETF',

    'NASDAQ symbol': 'ISDX',
  },
  {
    symbol: 'ISEE',
    'Security Name': 'IVERIC bio,   ',

    'NASDAQ symbol': 'ISEE',
  },
  {
    symbol: 'ISEM',
    'Security Name': 'Invesco RAFI Strategic Emerging Markets ETF',

    'NASDAQ symbol': 'ISEM',
  },
  {
    symbol: 'ISHG',
    'Security Name': 'iShares 13 Year International Treasury Bond ETF',

    'NASDAQ symbol': 'ISHG',
  },
  {
    symbol: 'ISIG',
    'Security Name': 'Insignia Systems,   ',

    'NASDAQ symbol': 'ISIG',
  },
  {
    symbol: 'ISMD',
    'Security Name': 'Inspire Small/Mid Cap Impact ETF',

    'CQS symbol': 'ISMD',
    'NASDAQ symbol': 'ISMD',
  },
  {
    symbol: 'ISNS',
    'Security Name': 'Image Sensing Systems,   ',

    'NASDAQ symbol': 'ISNS',
  },
  {
    symbol: 'ISR',
    'Security Name': 'IsoRay,   (DE)',

    'CQS symbol': 'ISR',
    'NASDAQ symbol': 'ISR',
  },
  {
    symbol: 'ISRA',
    'Security Name': 'VanEck Vectors Israel ETF',

    'CQS symbol': 'ISRA',
    'NASDAQ symbol': 'ISRA',
  },
  {
    symbol: 'ISRG',
    'Security Name': 'Intuitive Surgical,   ',

    'NASDAQ symbol': 'ISRG',
  },
  {
    symbol: 'ISSC',
    'Security Name': 'Innovative Solutions and Support,   ',

    'NASDAQ symbol': 'ISSC',
  },
  {
    symbol: 'ISTB',
    'Security Name': 'iShares Core 15 Year USD Bond ETF',

    'NASDAQ symbol': 'ISTB',
  },
  {
    symbol: 'ISTR',
    'Security Name': 'Investar Holding Corporation  ',

    'NASDAQ symbol': 'ISTR',
  },
  {
    symbol: 'ISZE',
    'Security Name': 'iShares MSCI Intl Size Factor ETF',

    'CQS symbol': 'ISZE',
    'NASDAQ symbol': 'ISZE',
  },
  {
    symbol: 'IT',
    'Security Name': 'Gartner,  ',

    'CQS symbol': 'IT',
    'NASDAQ symbol': 'IT',
  },
  {
    symbol: 'ITA',
    'Security Name': 'iShares US Aerospace & Defense ETF',

    'CQS symbol': 'ITA',
    'NASDAQ symbol': 'ITA',
  },
  {
    symbol: 'ITAC',
    'Security Name': 'Industrial Tech Acquisitions,    ',

    'NASDAQ symbol': 'ITAC',
  },
  {
    symbol: 'ITACU',
    'Security Name': 'Industrial Tech Acquisitions,   Unit',

    'NASDAQ symbol': 'ITACU',
  },
  {
    symbol: 'ITACW',
    'Security Name': 'Industrial Tech Acquisitions,   Warrant',

    'NASDAQ symbol': 'ITACW',
  },
  {
    symbol: 'ITB',
    'Security Name': 'iShares US Home Construction ETF',

    'CQS symbol': 'ITB',
    'NASDAQ symbol': 'ITB',
  },
  {
    symbol: 'ITCB',
    'Security Name':
      'Itau CorpBanca American Depositary Shares (each representing 1,500 shares of , no par value)',

    'CQS symbol': 'ITCB',
    'NASDAQ symbol': 'ITCB',
  },
  {
    symbol: 'ITCI',
    'Security Name': 'IntraCellular Therapies   ',

    'NASDAQ symbol': 'ITCI',
  },
  {
    symbol: 'ITEQ',
    'Security Name': 'BlueStar Israel Technology ETF',

    'CQS symbol': 'ITEQ',
    'NASDAQ symbol': 'ITEQ',
  },
  {
    symbol: 'ITGR',
    'Security Name': 'Integer Holdings Corporation ',

    'CQS symbol': 'ITGR',
    'NASDAQ symbol': 'ITGR',
  },
  {
    symbol: 'ITI',
    'Security Name': 'Iteris,   ',

    'NASDAQ symbol': 'ITI',
  },
  {
    symbol: 'ITIC',
    'Security Name': 'Investors Title Company  ',

    'NASDAQ symbol': 'ITIC',
  },
  {
    symbol: 'ITM',
    'Security Name':
      'VanEck Vectors ETF Trust VanEck Vectors Intermediate Muni ETF',

    'CQS symbol': 'ITM',
    'NASDAQ symbol': 'ITM',
  },
  {
    symbol: 'ITMR',
    'Security Name': 'Itamar Medical Ltd  American ',

    'NASDAQ symbol': 'ITMR',
  },
  {
    symbol: 'ITOS',
    'Security Name': 'iTeos Therapeutics,   ',

    'NASDAQ symbol': 'ITOS',
  },
  {
    symbol: 'ITOT',
    'Security Name': 'iShares Core S&P Total US Stock Market ETF',

    'CQS symbol': 'ITOT',
    'NASDAQ symbol': 'ITOT',
  },
  {
    symbol: 'ITP',
    'Security Name': 'IT Tech Packaging,  ',

    'CQS symbol': 'ITP',
    'NASDAQ symbol': 'ITP',
  },
  {
    symbol: 'ITRG',
    'Security Name': 'Integra Resources Corp Common Shares',

    'CQS symbol': 'ITRG',
    'NASDAQ symbol': 'ITRG',
  },
  {
    symbol: 'ITRI',
    'Security Name': 'Itron,   ',

    'NASDAQ symbol': 'ITRI',
  },
  {
    symbol: 'ITRM',
    'Security Name': 'Iterum Therapeutics plc  Ordinary Share',

    'NASDAQ symbol': 'ITRM',
  },
  {
    symbol: 'ITRN',
    'Security Name': 'Ituran Location and Control Ltd  Ordinary Shares',

    'NASDAQ symbol': 'ITRN',
  },
  {
    symbol: 'ITT',
    'Security Name': 'ITT   ',

    'CQS symbol': 'ITT',
    'NASDAQ symbol': 'ITT',
  },
  {
    symbol: 'ITUB',
    'Security Name':
      'Itau Unibanco Banco Holding SA American Depositary Shares (Each repstg 500 Preferred shares)',

    'CQS symbol': 'ITUB',
    'NASDAQ symbol': 'ITUB',
  },
  {
    symbol: 'ITW',
    'Security Name': 'Illinois Tool Works  ',

    'CQS symbol': 'ITW',
    'NASDAQ symbol': 'ITW',
  },
  {
    symbol: 'IUS',
    'Security Name': 'Invesco RAFI Strategic US ETF',

    'NASDAQ symbol': 'IUS',
  },
  {
    symbol: 'IUSB',
    'Security Name': 'iShares Core Total USD Bond Market ETF',

    'NASDAQ symbol': 'IUSB',
  },
  {
    symbol: 'IUSG',
    'Security Name': 'iShares Core S&P US Growth ETF',

    'NASDAQ symbol': 'IUSG',
  },
  {
    symbol: 'IUSS',
    'Security Name': 'Invesco RAFI Strategic US Small Company ETF',

    'NASDAQ symbol': 'IUSS',
  },
  {
    symbol: 'IUSV',
    'Security Name': 'iShares Core S&P US Value ETF',

    'NASDAQ symbol': 'IUSV',
  },
  {
    symbol: 'IVA',
    'Security Name': 'Inventiva SA  American ',

    'NASDAQ symbol': 'IVA',
  },
  {
    symbol: 'IVAC',
    'Security Name': 'Intevac,   ',

    'NASDAQ symbol': 'IVAC',
  },
  {
    symbol: 'IVAL',
    'Security Name': 'Alpha Architect International Quantitative Value ETF',

    'CQS symbol': 'IVAL',
    'NASDAQ symbol': 'IVAL',
  },
  {
    symbol: 'IVC',
    'Security Name': 'Invacare Corporation ',

    'CQS symbol': 'IVC',
    'NASDAQ symbol': 'IVC',
  },
  {
    symbol: 'IVE',
    'Security Name': 'iShares S&P 500 Value ETF',

    'CQS symbol': 'IVE',
    'NASDAQ symbol': 'IVE',
  },
  {
    symbol: 'IVES',
    'Security Name': 'Wedbush ETFMG Global Cloud Technology ETF',

    'CQS symbol': 'IVES',
    'NASDAQ symbol': 'IVES',
  },
  {
    symbol: 'IVH',
    'Security Name':
      'Ivy High ome Opportunities Fund Common Shares of Beneficial Interest',

    'CQS symbol': 'IVH',
    'NASDAQ symbol': 'IVH',
  },
  {
    symbol: 'IVLU',
    'Security Name': 'iShares MSCI Intl Value Factor ETF',

    'CQS symbol': 'IVLU',
    'NASDAQ symbol': 'IVLU',
  },
  {
    symbol: 'IVOG',
    'Security Name': 'Vanguard S&P MidCap 400 Growth ETF',

    'CQS symbol': 'IVOG',
    'NASDAQ symbol': 'IVOG',
  },
  {
    symbol: 'IVOL',
    'Security Name':
      'Quadratic Interest Rate Volatility and Inflation Hedge ETF',

    'CQS symbol': 'IVOL',
    'NASDAQ symbol': 'IVOL',
  },
  {
    symbol: 'IVOO',
    'Security Name': 'Vanguard S&P MidCap 400 ETF',

    'CQS symbol': 'IVOO',
    'NASDAQ symbol': 'IVOO',
  },
  {
    symbol: 'IVOV',
    'Security Name': 'Vanguard S&P MidCap 400 Value ETF',

    'CQS symbol': 'IVOV',
    'NASDAQ symbol': 'IVOV',
  },
  {
    symbol: 'IVR',
    'Security Name': 'INVESCO MORTGAGE CAPITAL  ',

    'CQS symbol': 'IVR',
    'NASDAQ symbol': 'IVR',
  },
  {
    symbol: 'IVR$A',
    'Security Name': 'Invesco Mortgage Capital  Pfd Ser A',

    'CQS symbol': 'IVRpA',
    'NASDAQ symbol': 'IVRA',
  },
  {
    symbol: 'IVR$B',
    'Security Name':
      'Invesco Mortgage Capital  Preferred Series B Cum Fxd to Fltg',

    'CQS symbol': 'IVRpB',
    'NASDAQ symbol': 'IVRB',
  },
  {
    symbol: 'IVR$C',
    'Security Name':
      'INVESCO MORTGAGE CAPITAL  75% FixedtoFloating Series C Cumulative Redeemable Preferred Stock, Liquation Preference $2500 per Share',

    'CQS symbol': 'IVRpC',
    'NASDAQ symbol': 'IVRC',
  },
  {
    symbol: 'IVV',
    'Security Name': 'iShares Core S&P 500 ETF',

    'CQS symbol': 'IVV',
    'NASDAQ symbol': 'IVV',
  },
  {
    symbol: 'IVW',
    'Security Name': 'iShares S&P 500 Growth ETF',

    'CQS symbol': 'IVW',
    'NASDAQ symbol': 'IVW',
  },
  {
    symbol: 'IVZ',
    'Security Name': 'Invesco Ltd ',

    'CQS symbol': 'IVZ',
    'NASDAQ symbol': 'IVZ',
  },
  {
    symbol: 'IWB',
    'Security Name': 'iShares Russell 1000 ETF',

    'CQS symbol': 'IWB',
    'NASDAQ symbol': 'IWB',
  },
  {
    symbol: 'IWC',
    'Security Name': 'iShares Microcap ETF',

    'CQS symbol': 'IWC',
    'NASDAQ symbol': 'IWC',
  },
  {
    symbol: 'IWD',
    'Security Name': 'iShares Russell 1000 Value ETF',

    'CQS symbol': 'IWD',
    'NASDAQ symbol': 'IWD',
  },
  {
    symbol: 'IWF',
    'Security Name': 'iShares Russell 1000 Growth ETF',

    'CQS symbol': 'IWF',
    'NASDAQ symbol': 'IWF',
  },
  {
    symbol: 'IWFH',
    'Security Name': 'iShares Virtual Work and Life Multisector ETF',

    'CQS symbol': 'IWFH',
    'NASDAQ symbol': 'IWFH',
  },
  {
    symbol: 'IWL',
    'Security Name': 'iShares Russell Top 200 ETF',

    'CQS symbol': 'IWL',
    'NASDAQ symbol': 'IWL',
  },
  {
    symbol: 'IWM',
    'Security Name': 'iShares Russell 2000 ETF',

    'CQS symbol': 'IWM',
    'NASDAQ symbol': 'IWM',
  },
  {
    symbol: 'IWN',
    'Security Name': 'iShares Russell 2000 Value ETF',

    'CQS symbol': 'IWN',
    'NASDAQ symbol': 'IWN',
  },
  {
    symbol: 'IWO',
    'Security Name': 'iShares Russell 2000 Growth ETF',

    'CQS symbol': 'IWO',
    'NASDAQ symbol': 'IWO',
  },
  {
    symbol: 'IWP',
    'Security Name': 'iShares Russell Midcap Growth ETF',

    'CQS symbol': 'IWP',
    'NASDAQ symbol': 'IWP',
  },
  {
    symbol: 'IWR',
    'Security Name': 'iShares Russell MidCap ETF',

    'CQS symbol': 'IWR',
    'NASDAQ symbol': 'IWR',
  },
  {
    symbol: 'IWS',
    'Security Name': 'iShares Russell Midcap Value ETF',

    'CQS symbol': 'IWS',
    'NASDAQ symbol': 'IWS',
  },
  {
    symbol: 'IWV',
    'Security Name': 'iShares Russell 3000 ETF',

    'CQS symbol': 'IWV',
    'NASDAQ symbol': 'IWV',
  },
  {
    symbol: 'IWX',
    'Security Name': 'iShares Russell Top 200 Value ETF',

    'CQS symbol': 'IWX',
    'NASDAQ symbol': 'IWX',
  },
  {
    symbol: 'IWY',
    'Security Name': 'iShares Russell Top 200 Growth ETF',

    'CQS symbol': 'IWY',
    'NASDAQ symbol': 'IWY',
  },
  {
    symbol: 'IX',
    'Security Name': 'Orix Corp Ads ',

    'CQS symbol': 'IX',
    'NASDAQ symbol': 'IX',
  },
  {
    symbol: 'IXC',
    'Security Name': 'iShares Global Energy ETF',

    'CQS symbol': 'IXC',
    'NASDAQ symbol': 'IXC',
  },
  {
    symbol: 'IXG',
    'Security Name': 'iShares Global Financial ETF',

    'CQS symbol': 'IXG',
    'NASDAQ symbol': 'IXG',
  },
  {
    symbol: 'IXJ',
    'Security Name': 'iShares Global Healthcare ETF',

    'CQS symbol': 'IXJ',
    'NASDAQ symbol': 'IXJ',
  },
  {
    symbol: 'IXN',
    'Security Name': 'iShares Global Tech ETF',

    'CQS symbol': 'IXN',
    'NASDAQ symbol': 'IXN',
  },
  {
    symbol: 'IXP',
    'Security Name': 'iShares Global Comm Services ETF',

    'CQS symbol': 'IXP',
    'NASDAQ symbol': 'IXP',
  },
  {
    symbol: 'IXSE',
    'Security Name': 'WisdomTree India ExStateOwned Enterprises Fund',

    'CQS symbol': 'IXSE',
    'NASDAQ symbol': 'IXSE',
  },
  {
    symbol: 'IXUS',
    'Security Name': 'iShares Core MSCI Total International Stock ETF',

    'NASDAQ symbol': 'IXUS',
  },
  {
    symbol: 'IYC',
    'Security Name': 'iShares US Consumer Services ETF',

    'CQS symbol': 'IYC',
    'NASDAQ symbol': 'IYC',
  },
  {
    symbol: 'IYE',
    'Security Name': 'iShares US Energy ETF',

    'CQS symbol': 'IYE',
    'NASDAQ symbol': 'IYE',
  },
  {
    symbol: 'IYF',
    'Security Name': 'iShares US Financial ETF',

    'CQS symbol': 'IYF',
    'NASDAQ symbol': 'IYF',
  },
  {
    symbol: 'IYG',
    'Security Name': 'iShares US Financial Services ETF',

    'CQS symbol': 'IYG',
    'NASDAQ symbol': 'IYG',
  },
  {
    symbol: 'IYH',
    'Security Name': 'iShares US Healthcare ETF',

    'CQS symbol': 'IYH',
    'NASDAQ symbol': 'IYH',
  },
  {
    symbol: 'IYJ',
    'Security Name': 'iShares US Industrials ETF',

    'CQS symbol': 'IYJ',
    'NASDAQ symbol': 'IYJ',
  },
  {
    symbol: 'IYK',
    'Security Name': 'iShares US Consumer Goods ETF',

    'CQS symbol': 'IYK',
    'NASDAQ symbol': 'IYK',
  },
  {
    symbol: 'IYLD',
    'Security Name': 'iShares Morningstar MultiAsset ome ETF',

    'CQS symbol': 'IYLD',
    'NASDAQ symbol': 'IYLD',
  },
  {
    symbol: 'IYM',
    'Security Name': 'iShares US Basic Materials ETF',

    'CQS symbol': 'IYM',
    'NASDAQ symbol': 'IYM',
  },
  {
    symbol: 'IYR',
    'Security Name': 'iShares US Real Estate ETF',

    'CQS symbol': 'IYR',
    'NASDAQ symbol': 'IYR',
  },
  {
    symbol: 'IYT',
    'Security Name': 'iShares Transportation AverageETF',

    'CQS symbol': 'IYT',
    'NASDAQ symbol': 'IYT',
  },
  {
    symbol: 'IYW',
    'Security Name': 'iShares US Technology ETF',

    'CQS symbol': 'IYW',
    'NASDAQ symbol': 'IYW',
  },
  {
    symbol: 'IYY',
    'Security Name': 'iShares Dow Jones US ETF',

    'CQS symbol': 'IYY',
    'NASDAQ symbol': 'IYY',
  },
  {
    symbol: 'IYZ',
    'Security Name': 'iShares US Telecommunications ETF',

    'CQS symbol': 'IYZ',
    'NASDAQ symbol': 'IYZ',
  },
  {
    symbol: 'IZEA',
    'Security Name': 'IZEA Worldwide,   ',

    'NASDAQ symbol': 'IZEA',
  },
  {
    symbol: 'IZRL',
    'Security Name': 'ARK Israel Innovative Technology ETF',

    'CQS symbol': 'IZRL',
    'NASDAQ symbol': 'IZRL',
  },
  {
    symbol: 'J',
    'Security Name': 'Jacobs Engineering Group  ',

    'CQS symbol': 'J',
    'NASDAQ symbol': 'J',
  },
  {
    symbol: 'JAAA',
    'Security Name': 'Janus Henderson AAA CLO ETF',

    'CQS symbol': 'JAAA',
    'NASDAQ symbol': 'JAAA',
  },
  {
    symbol: 'JACK',
    'Security Name': 'Jack In The Box   ',

    'NASDAQ symbol': 'JACK',
  },
  {
    symbol: 'JAGG',
    'Security Name': 'JPMorgan US Aggregate Bond ETF',

    'CQS symbol': 'JAGG',
    'NASDAQ symbol': 'JAGG',
  },
  {
    symbol: 'JAGX',
    'Security Name': 'Jaguar Health,   ',

    'NASDAQ symbol': 'JAGX',
  },
  {
    symbol: 'JAKK',
    'Security Name': 'JAKKS Pacific,   ',

    'NASDAQ symbol': 'JAKK',
  },
  {
    symbol: 'JAMF',
    'Security Name': 'Jamf Holding Corp  ',

    'NASDAQ symbol': 'JAMF',
  },
  {
    symbol: 'JAN',
    'Security Name': 'JanOne   ',

    'NASDAQ symbol': 'JAN',
  },
  {
    symbol: 'JAX',
    'Security Name': "J Alexander's Holdings,  ",

    'CQS symbol': 'JAX',
    'NASDAQ symbol': 'JAX',
  },
  {
    symbol: 'JAZZ',
    'Security Name': 'Jazz Pharmaceuticals plc  Ordinary Shares',

    'NASDAQ symbol': 'JAZZ',
  },
  {
    symbol: 'JBGS',
    'Security Name': 'JBG SMITH Properties Common Shares ',

    'CQS symbol': 'JBGS',
    'NASDAQ symbol': 'JBGS',
  },
  {
    symbol: 'JBHT',
    'Security Name': 'JB Hunt Transport Services,   ',

    'NASDAQ symbol': 'JBHT',
  },
  {
    symbol: 'JBK',
    'Security Name':
      'Lehman ABS 350 350% Adjustable Corp Backed Tr Certs GS Cap I',

    'CQS symbol': 'JBK',
    'NASDAQ symbol': 'JBK',
  },
  {
    symbol: 'JBL',
    'Security Name': 'Jabil  ',

    'CQS symbol': 'JBL',
    'NASDAQ symbol': 'JBL',
  },
  {
    symbol: 'JBLU',
    'Security Name': 'JetBlue Airways Corporation  ',

    'NASDAQ symbol': 'JBLU',
  },
  {
    symbol: 'JBSS',
    'Security Name': 'John B Sanfilippo & Son,   ',

    'NASDAQ symbol': 'JBSS',
  },
  {
    symbol: 'JBT',
    'Security Name': 'John Bean Technologies Corporation ',

    'CQS symbol': 'JBT',
    'NASDAQ symbol': 'JBT',
  },
  {
    symbol: 'JCE',
    'Security Name':
      'Nuveen Core Equity Alpha Fund Nuveen Core Equity Alpha Fund Common Shares of Beneficial Interest',

    'CQS symbol': 'JCE',
    'NASDAQ symbol': 'JCE',
  },
  {
    symbol: 'JCI',
    'Security Name': 'Johnson Controls International plc Ordinary Share',

    'CQS symbol': 'JCI',
    'NASDAQ symbol': 'JCI',
  },
  {
    symbol: 'JCO',
    'Security Name':
      'Nuveen Credit Opportunities 2022 Target Term Fund Common Shares of Beneficial Interest',

    'CQS symbol': 'JCO',
    'NASDAQ symbol': 'JCO',
  },
  {
    symbol: 'JCOM',
    'Security Name': 'j2 Global,   ',

    'NASDAQ symbol': 'JCOM',
  },
  {
    symbol: 'JCPB',
    'Security Name': 'JPMorgan Core Plus Bond ETF',

    'CQS symbol': 'JCPB',
    'NASDAQ symbol': 'JCPB',
  },
  {
    symbol: 'JCS',
    'Security Name': 'Communications Systems,   ',

    'NASDAQ symbol': 'JCS',
  },
  {
    symbol: 'JCTCF',
    'Security Name': 'JewettCameron Trading Company  Common Shares',

    'NASDAQ symbol': 'JCTCF',
  },
  {
    symbol: 'JD',
    'Security Name': 'JDcom,   American Depositary Shares',

    'NASDAQ symbol': 'JD',
  },
  {
    symbol: 'JDD',
    'Security Name':
      'Nuveen Diversified Dividend and ome Fund Shares of Beneficial Interest',

    'CQS symbol': 'JDD',
    'NASDAQ symbol': 'JDD',
  },
  {
    symbol: 'JDIV',
    'Security Name': 'JPMorgan US Dividend ETF',

    'CQS symbol': 'JDIV',
    'NASDAQ symbol': 'JDIV',
  },
  {
    symbol: 'JDST',
    'Security Name': 'Direxion Daily Junior Gold Miners Index Bear 2X Shares',

    'CQS symbol': 'JDST',
    'NASDAQ symbol': 'JDST',
  },
  {
    symbol: 'JE',
    'Security Name': 'Just Energy Group,  Ordinary Shares (Canada)',

    'CQS symbol': 'JE',
    'NASDAQ symbol': 'JE',
  },
  {
    symbol: 'JEF',
    'Security Name': 'Jefferies Financial Group  ',

    'CQS symbol': 'JEF',
    'NASDAQ symbol': 'JEF',
  },
  {
    symbol: 'JELD',
    'Security Name': 'JELDWEN Holding,  ',

    'CQS symbol': 'JELD',
    'NASDAQ symbol': 'JELD',
  },
  {
    symbol: 'JEMD',
    'Security Name':
      'Nuveen Emerging Markets Debt 2022 Target Term Fund Common Shares of Beneficial Interest, $001 par value per share',

    'CQS symbol': 'JEMD',
    'NASDAQ symbol': 'JEMD',
  },
  {
    symbol: 'JEPI',
    'Security Name': 'JPMorgan Equity Premium ome ETF',

    'CQS symbol': 'JEPI',
    'NASDAQ symbol': 'JEPI',
  },
  {
    symbol: 'JEQ',
    'Security Name': 'Aberdeen Japan Equity Fund,   ',

    'CQS symbol': 'JEQ',
    'NASDAQ symbol': 'JEQ',
  },
  {
    symbol: 'JETS',
    'Security Name': 'US Global Jets ETF',

    'CQS symbol': 'JETS',
    'NASDAQ symbol': 'JETS',
  },
  {
    symbol: 'JFIN',
    'Security Name': 'Jiayin Group   American Depositary Shares',

    'NASDAQ symbol': 'JFIN',
  },
  {
    symbol: 'JFR',
    'Security Name': 'Nuveen Floating Rate ome Fund ',

    'CQS symbol': 'JFR',
    'NASDAQ symbol': 'JFR',
  },
  {
    symbol: 'JFU',
    'Security Name': '9F   American Depositary Shares',

    'NASDAQ symbol': 'JFU',
  },
  {
    symbol: 'JG',
    'Security Name': 'Aurora Mobile Limited  American Depositary Shares',

    'NASDAQ symbol': 'JG',
  },
  {
    symbol: 'JGH',
    'Security Name':
      'Nuveen Global High ome Fund Common Shares of Beneficial Interest',

    'CQS symbol': 'JGH',
    'NASDAQ symbol': 'JGH',
  },
  {
    symbol: 'JGLD',
    'Security Name': 'Amplify Pure Junior Gold Miners ETF',

    'CQS symbol': 'JGLD',
    'NASDAQ symbol': 'JGLD',
  },
  {
    symbol: 'JHAA',
    'Security Name': 'Nuveen Corporate ome 2023 Target Term Fund',

    'CQS symbol': 'JHAA',
    'NASDAQ symbol': 'JHAA',
  },
  {
    symbol: 'JHB',
    'Security Name': 'Nuveen Corporate ome November 2021 Target Term Fund',

    'CQS symbol': 'JHB',
    'NASDAQ symbol': 'JHB',
  },
  {
    symbol: 'JHCS',
    'Security Name': 'John Hancock Multifactor Media and Communications ETF',

    'CQS symbol': 'JHCS',
    'NASDAQ symbol': 'JHCS',
  },
  {
    symbol: 'JHEM',
    'Security Name': 'John Hancock Multifactor Emerging Markets ETF',

    'CQS symbol': 'JHEM',
    'NASDAQ symbol': 'JHEM',
  },
  {
    symbol: 'JHG',
    'Security Name': 'Janus Henderson Group plc Ordinary Shares',

    'CQS symbol': 'JHG',
    'NASDAQ symbol': 'JHG',
  },
  {
    symbol: 'JHI',
    'Security Name': 'John Hancock Investors Trust ',

    'CQS symbol': 'JHI',
    'NASDAQ symbol': 'JHI',
  },
  {
    symbol: 'JHMA',
    'Security Name': 'John Hancock Multifactor Materials ETF',

    'CQS symbol': 'JHMA',
    'NASDAQ symbol': 'JHMA',
  },
  {
    symbol: 'JHMC',
    'Security Name': 'John Hancock Multifactor Consumer Discretionary ETF',

    'CQS symbol': 'JHMC',
    'NASDAQ symbol': 'JHMC',
  },
  {
    symbol: 'JHMD',
    'Security Name':
      'John Hancock ExchangeTraded Fund Trust John Hancock Multifactor Developed International ETF',

    'CQS symbol': 'JHMD',
    'NASDAQ symbol': 'JHMD',
  },
  {
    symbol: 'JHME',
    'Security Name': 'John Hancock Multifactor Energy ETF',

    'CQS symbol': 'JHME',
    'NASDAQ symbol': 'JHME',
  },
  {
    symbol: 'JHMF',
    'Security Name': 'John Hancock Multifactor Financials ETF',

    'CQS symbol': 'JHMF',
    'NASDAQ symbol': 'JHMF',
  },
  {
    symbol: 'JHMH',
    'Security Name': 'John Hancock Multifactor Healthcare ETF',

    'CQS symbol': 'JHMH',
    'NASDAQ symbol': 'JHMH',
  },
  {
    symbol: 'JHMI',
    'Security Name': 'John Hancock Multifactor Industrials ETF',

    'CQS symbol': 'JHMI',
    'NASDAQ symbol': 'JHMI',
  },
  {
    symbol: 'JHML',
    'Security Name': 'John Hancock Multifactor Large Cap ETF',

    'CQS symbol': 'JHML',
    'NASDAQ symbol': 'JHML',
  },
  {
    symbol: 'JHMM',
    'Security Name': 'John Hancock Multifactor Mid Cap ETF',

    'CQS symbol': 'JHMM',
    'NASDAQ symbol': 'JHMM',
  },
  {
    symbol: 'JHMS',
    'Security Name': 'John Hancock Multifactor Consumer Staples ETF',

    'CQS symbol': 'JHMS',
    'NASDAQ symbol': 'JHMS',
  },
  {
    symbol: 'JHMT',
    'Security Name': 'John Hancock Multifactor Technology ETF',

    'CQS symbol': 'JHMT',
    'NASDAQ symbol': 'JHMT',
  },
  {
    symbol: 'JHMU',
    'Security Name': 'John Hancock Multifactor Utilities ETF',

    'CQS symbol': 'JHMU',
    'NASDAQ symbol': 'JHMU',
  },
  {
    symbol: 'JHS',
    'Security Name': 'John Hancock ome Securities Trust ',

    'CQS symbol': 'JHS',
    'NASDAQ symbol': 'JHS',
  },
  {
    symbol: 'JHSC',
    'Security Name': 'John Hancock Multifactor Small Cap ETF',

    'CQS symbol': 'JHSC',
    'NASDAQ symbol': 'JHSC',
  },
  {
    symbol: 'JHX',
    'Security Name':
      'James Hardie Industries plc American Depositary Shares (Ireland)',

    'CQS symbol': 'JHX',
    'NASDAQ symbol': 'JHX',
  },
  {
    symbol: 'JIG',
    'Security Name': 'JPMorgan International Growth ETF',

    'CQS symbol': 'JIG',
    'NASDAQ symbol': 'JIG',
  },
  {
    symbol: 'JIGB',
    'Security Name': 'JPMorgan Corporate Bond Research Enhanced ETF',

    'CQS symbol': 'JIGB',
    'NASDAQ symbol': 'JIGB',
  },
  {
    symbol: 'JIH',
    'Security Name': 'Juniper Industrial Holdings,   ',

    'CQS symbol': 'JIH',
    'NASDAQ symbol': 'JIH',
  },
  {
    symbol: 'JIHU',
    'Security Name':
      'Juniper Industrial Holdings,  Units, each consisting of one share of  , $00001 par value per share, and onehalf of one warrant',

    'CQS symbol': 'JIHU',
    'NASDAQ symbol': 'JIH=',
  },
  {
    symbol: 'JIHW',
    'Security Name':
      'Juniper Industrial Holdings,  Redeemable warrants luded as part of the units',

    'CQS symbol': 'JIHWS',
    'NASDAQ symbol': 'JIH+',
  },
  {
    symbol: 'JILL',
    'Security Name': 'J Jill,  ',

    'CQS symbol': 'JILL',
    'NASDAQ symbol': 'JILL',
  },
  {
    symbol: 'JJA',
    'Security Name':
      'iPathA Series B Bloomberg Agriculture Subindex Total Return ETN',

    'CQS symbol': 'JJA',
    'NASDAQ symbol': 'JJA',
  },
  {
    symbol: 'JJC',
    'Security Name':
      'iPathA Series B Bloomberg Copper Subindex Total Return ETN',

    'CQS symbol': 'JJC',
    'NASDAQ symbol': 'JJC',
  },
  {
    symbol: 'JJE',
    'Security Name':
      'iPathA Series B Bloomberg Energy Subindex Total Return ETN',

    'CQS symbol': 'JJE',
    'NASDAQ symbol': 'JJE',
  },
  {
    symbol: 'JJG',
    'Security Name':
      'iPathA Series B Bloomberg Grains Subindex Total Return ETN',

    'CQS symbol': 'JJG',
    'NASDAQ symbol': 'JJG',
  },
  {
    symbol: 'JJM',
    'Security Name':
      'iPathA Series B Bloomberg Industrial Metals Subindex Total Return ETN',

    'CQS symbol': 'JJM',
    'NASDAQ symbol': 'JJM',
  },
  {
    symbol: 'JJN',
    'Security Name':
      'iPathA Series B Bloomberg Nickel Subindex Total Return ETN',

    'CQS symbol': 'JJN',
    'NASDAQ symbol': 'JJN',
  },
  {
    symbol: 'JJP',
    'Security Name':
      'iPathA Series B Bloomberg Precious Metals Subindex Total Return ETN',

    'CQS symbol': 'JJP',
    'NASDAQ symbol': 'JJP',
  },
  {
    symbol: 'JJS',
    'Security Name':
      'iPathA Series B Bloomberg Softs Subindex Total Return ETN',

    'CQS symbol': 'JJS',
    'NASDAQ symbol': 'JJS',
  },
  {
    symbol: 'JJSF',
    'Security Name': 'J & J Snack Foods Corp  ',

    'NASDAQ symbol': 'JJSF',
  },
  {
    symbol: 'JJT',
    'Security Name': 'iPathA Series B Bloomberg Tin Subindex Total Return ETN',

    'CQS symbol': 'JJT',
    'NASDAQ symbol': 'JJT',
  },
  {
    symbol: 'JJU',
    'Security Name':
      'iPathA Series B Bloomberg Aluminum Subindex Total Return ETN',

    'CQS symbol': 'JJU',
    'NASDAQ symbol': 'JJU',
  },
  {
    symbol: 'JKD',
    'Security Name': 'iShares Morningstar LargeCap ETF',

    'CQS symbol': 'JKD',
    'NASDAQ symbol': 'JKD',
  },
  {
    symbol: 'JKE',
    'Security Name': 'iShares Morningstar LargeCap Growth ETF',

    'CQS symbol': 'JKE',
    'NASDAQ symbol': 'JKE',
  },
  {
    symbol: 'JKF',
    'Security Name': 'iShares Morningstar LargeCap  Value ETF',

    'CQS symbol': 'JKF',
    'NASDAQ symbol': 'JKF',
  },
  {
    symbol: 'JKG',
    'Security Name': 'iShares Morningstar MidCap ETF',

    'CQS symbol': 'JKG',
    'NASDAQ symbol': 'JKG',
  },
  {
    symbol: 'JKH',
    'Security Name': 'iShares Morningstar MidCap Growth ETF',

    'CQS symbol': 'JKH',
    'NASDAQ symbol': 'JKH',
  },
  {
    symbol: 'JKHY',
    'Security Name': 'Jack Henry & Associates,   ',

    'NASDAQ symbol': 'JKHY',
  },
  {
    symbol: 'JKI',
    'Security Name': 'iShares Morningstar MidCap ETF',

    'NASDAQ symbol': 'JKI',
  },
  {
    symbol: 'JKJ',
    'Security Name': 'iShares Morningstar SmallCap ETF',

    'CQS symbol': 'JKJ',
    'NASDAQ symbol': 'JKJ',
  },
  {
    symbol: 'JKK',
    'Security Name': 'iShares Morningstar SmallCap Growth ETF',

    'CQS symbol': 'JKK',
    'NASDAQ symbol': 'JKK',
  },
  {
    symbol: 'JKL',
    'Security Name': 'iShares Morningstar SmallCap Value ETFnd',

    'CQS symbol': 'JKL',
    'NASDAQ symbol': 'JKL',
  },
  {
    symbol: 'JKS',
    'Security Name':
      'JinkoSolar Holding Company Limited American Depositary Shares (each representing 4 Common Shares)',

    'CQS symbol': 'JKS',
    'NASDAQ symbol': 'JKS',
  },
  {
    symbol: 'JLL',
    'Security Name': 'Jones Lang LaSalle orporated ',

    'CQS symbol': 'JLL',
    'NASDAQ symbol': 'JLL',
  },
  {
    symbol: 'JLS',
    'Security Name': 'Nuveen Mortgage and ome Fund',

    'CQS symbol': 'JLS',
    'NASDAQ symbol': 'JLS',
  },
  {
    symbol: 'JMBS',
    'Security Name': 'Janus Henderson MortgageBacked Securities ETF',

    'CQS symbol': 'JMBS',
    'NASDAQ symbol': 'JMBS',
  },
  {
    symbol: 'JMIA',
    'Security Name':
      'Jumia Technologies AG American Depositary Shares, each representing two Ordinary Shares',

    'CQS symbol': 'JMIA',
    'NASDAQ symbol': 'JMIA',
  },
  {
    symbol: 'JMIN',
    'Security Name': 'JPMorgan US Minimum Volatility ETF',

    'CQS symbol': 'JMIN',
    'NASDAQ symbol': 'JMIN',
  },
  {
    symbol: 'JMM',
    'Security Name': 'Nuveen MultiMarket ome Fund (MA)',

    'CQS symbol': 'JMM',
    'NASDAQ symbol': 'JMM',
  },
  {
    symbol: 'JMOM',
    'Security Name': 'JPMorgan US Momentum Factor ETF',

    'CQS symbol': 'JMOM',
    'NASDAQ symbol': 'JMOM',
  },
  {
    symbol: 'JMP',
    'Security Name': 'JMP Group LLC Common Shares',

    'CQS symbol': 'JMP',
    'NASDAQ symbol': 'JMP',
  },
  {
    symbol: 'JMPNL',
    'Security Name': 'JMP Group LLC  725% Senior Notes due 2027',

    'NASDAQ symbol': 'JMPNL',
  },
  {
    symbol: 'JMPNZ',
    'Security Name': 'JMP Group LLC  6875% Senior Notes due 2029',

    'NASDAQ symbol': 'JMPNZ',
  },
  {
    symbol: 'JMST',
    'Security Name': 'JPMorgan UltraShort Municipal ome ETF',

    'CQS symbol': 'JMST',
    'NASDAQ symbol': 'JMST',
  },
  {
    symbol: 'JMUB',
    'Security Name': 'JPMorgan Municipal ETF',

    'CQS symbol': 'JMUB',
    'NASDAQ symbol': 'JMUB',
  },
  {
    symbol: 'JNCE',
    'Security Name': 'Jounce Therapeutics,   ',

    'NASDAQ symbol': 'JNCE',
  },
  {
    symbol: 'JNJ',
    'Security Name': 'Johnson & Johnson ',

    'CQS symbol': 'JNJ',
    'NASDAQ symbol': 'JNJ',
  },
  {
    symbol: 'JNK',
    'Security Name': 'SPDR Bloomberg Barclays High Yield Bond ETF',

    'CQS symbol': 'JNK',
    'NASDAQ symbol': 'JNK',
  },
  {
    symbol: 'JNPR',
    'Security Name': 'Juniper Networks,  ',

    'CQS symbol': 'JNPR',
    'NASDAQ symbol': 'JNPR',
  },
  {
    symbol: 'JNUG',
    'Security Name': 'Direxion Daily Junior Gold Miners Index Bull 2X Shares',

    'CQS symbol': 'JNUG',
    'NASDAQ symbol': 'JNUG',
  },
  {
    symbol: 'JO',
    'Security Name':
      'iPathA Series B Bloomberg Coffee Subindex Total Return ETN',

    'CQS symbol': 'JO',
    'NASDAQ symbol': 'JO',
  },
  {
    symbol: 'JOB',
    'Security Name': 'GEE Group  ',

    'CQS symbol': 'JOB',
    'NASDAQ symbol': 'JOB',
  },
  {
    symbol: 'JOBS',
    'Security Name':
      '51job,   American Depositary Shares, each representing two common shares',

    'NASDAQ symbol': 'JOBS',
  },
  {
    symbol: 'JOE',
    'Security Name': 'St Joe Company (The) ',

    'CQS symbol': 'JOE',
    'NASDAQ symbol': 'JOE',
  },
  {
    symbol: 'JOET',
    'Security Name': 'Virtus Terranova US Quality Momentum ETF',

    'NASDAQ symbol': 'JOET',
  },
  {
    symbol: 'JOF',
    'Security Name': 'Japan Smaller Capitalization Fund  ',

    'CQS symbol': 'JOF',
    'NASDAQ symbol': 'JOF',
  },
  {
    symbol: 'JOUT',
    'Security Name': 'Johnson Outdoors    ',

    'NASDAQ symbol': 'JOUT',
  },
  {
    symbol: 'JOYY',
    'Security Name':
      'Infusive US Trust ETF Infusive Compounding Global Equities ETF',

    'CQS symbol': 'JOYY',
    'NASDAQ symbol': 'JOYY',
  },
  {
    symbol: 'JP',
    'Security Name':
      'Jupai Holdings Limited American Depositary Shares, each representing six ordinary shares',

    'CQS symbol': 'JP',
    'NASDAQ symbol': 'JP',
  },
  {
    symbol: 'JPC',
    'Security Name': 'Nuveen Preferred & ome Opportunities Fund',

    'CQS symbol': 'JPC',
    'NASDAQ symbol': 'JPC',
  },
  {
    symbol: 'JPEM',
    'Security Name': 'JPMorgan Diversified Return Emerging Markets Equity ETF',

    'CQS symbol': 'JPEM',
    'NASDAQ symbol': 'JPEM',
  },
  {
    symbol: 'JPHY',
    'Security Name': 'JPMorgan Research Enhanced High Yield ETF',

    'CQS symbol': 'JPHY',
    'NASDAQ symbol': 'JPHY',
  },
  {
    symbol: 'JPI',
    'Security Name':
      'Nuveen Preferred and ome Term Fund Common Shares of Beneficial Interest',

    'CQS symbol': 'JPI',
    'NASDAQ symbol': 'JPI',
  },
  {
    symbol: 'JPIB',
    'Security Name':
      'JP Morgan ExchangeTraded Fund Trust JPMorgan International Bond Opportunities ETF',

    'CQS symbol': 'JPIB',
    'NASDAQ symbol': 'JPIB',
  },
  {
    symbol: 'JPIN',
    'Security Name': 'JPMorgan Diversified Return International Equity ETF',

    'CQS symbol': 'JPIN',
    'NASDAQ symbol': 'JPIN',
  },
  {
    symbol: 'JPM',
    'Security Name': 'JP Morgan Chase & Co ',

    'CQS symbol': 'JPM',
    'NASDAQ symbol': 'JPM',
  },
  {
    symbol: 'JPM$C',
    'Security Name':
      'J P Morgan Chase & Co Depositary Shares, each representing a 1/400th interest in a share of 600% NonCumulative  Preferred Stock, Series EE',

    'CQS symbol': 'JPMpC',
    'NASDAQ symbol': 'JPMC',
  },
  {
    symbol: 'JPM$D',
    'Security Name':
      'J P Morgan Chase & Co Depositary Shares, each representing a 1/400th  interest in a share of 575% NonCumulative  Preferred Stock, Series DD',

    'CQS symbol': 'JPMpD',
    'NASDAQ symbol': 'JPMD',
  },
  {
    symbol: 'JPM$G',
    'Security Name':
      'J P Morgan Chase & Co Depositary Shares, each representing a 1/400th interest in a share of 610% NonCumulative Preferred Stock, Series AA',

    'CQS symbol': 'JPMpG',
    'NASDAQ symbol': 'JPMG',
  },
  {
    symbol: 'JPM$H',
    'Security Name':
      'J P Morgan Chase & Co Depositary Shares, each representing a 1/400th interest in a share of 615% NonCumulative Preferred Stock, Series BB',

    'CQS symbol': 'JPMpH',
    'NASDAQ symbol': 'JPMH',
  },
  {
    symbol: 'JPM$J',
    'Security Name':
      'J P Morgan Chase & Co Depositary Shares, each representing a 1/400th interest in a share of JPMorgan Chase & Co 475% NonCumulative Preferred Stock, Series GG',

    'CQS symbol': 'JPMpJ',
    'NASDAQ symbol': 'JPMJ',
  },
  {
    symbol: 'JPMB',
    'Security Name': 'JPMorgan USD Emerging Markets Sovereign Bond ETF',

    'CQS symbol': 'JPMB',
    'NASDAQ symbol': 'JPMB',
  },
  {
    symbol: 'JPME',
    'Security Name': 'JPMorgan Diversified Return US Mid Cap Equity ETF',

    'CQS symbol': 'JPME',
    'NASDAQ symbol': 'JPME',
  },
  {
    symbol: 'JPN',
    'Security Name': 'Xtrackers Japan JPXNikkei 400 Equity ETF',

    'CQS symbol': 'JPN',
    'NASDAQ symbol': 'JPN',
  },
  {
    symbol: 'JPS',
    'Security Name': 'Nuveen Preferred & ome Securities Fund',

    'CQS symbol': 'JPS',
    'NASDAQ symbol': 'JPS',
  },
  {
    symbol: 'JPSE',
    'Security Name': 'JPMorgan Diversified Return US Small Cap Equity ETF',

    'CQS symbol': 'JPSE',
    'NASDAQ symbol': 'JPSE',
  },
  {
    symbol: 'JPST',
    'Security Name': 'JPMorgan UltraShort ome ETF',

    'CQS symbol': 'JPST',
    'NASDAQ symbol': 'JPST',
  },
  {
    symbol: 'JPT',
    'Security Name':
      'Nuveen Preferred and ome 2022 Term Fund Common Shares of Beneficial Interest',

    'CQS symbol': 'JPT',
    'NASDAQ symbol': 'JPT',
  },
  {
    symbol: 'JPUS',
    'Security Name': 'JPMorgan Diversified Return US Equity ETF',

    'CQS symbol': 'JPUS',
    'NASDAQ symbol': 'JPUS',
  },
  {
    symbol: 'JPXN',
    'Security Name': 'iShares JPXNikkei 400 ETF',

    'CQS symbol': 'JPXN',
    'NASDAQ symbol': 'JPXN',
  },
  {
    symbol: 'JQC',
    'Security Name':
      'Nuveen Credit Strategies ome Fund Shares of Beneficial Interest',

    'CQS symbol': 'JQC',
    'NASDAQ symbol': 'JQC',
  },
  {
    symbol: 'JQUA',
    'Security Name': 'JPMorgan US Quality Factor ETF',

    'CQS symbol': 'JQUA',
    'NASDAQ symbol': 'JQUA',
  },
  {
    symbol: 'JRI',
    'Security Name':
      'Nuveen Real Asset ome and Growth Fund Common Shares of Beneficial Interest',

    'CQS symbol': 'JRI',
    'NASDAQ symbol': 'JRI',
  },
  {
    symbol: 'JRJC',
    'Security Name':
      'China Finance Online Co Limited  American Depositary Shares',

    'NASDAQ symbol': 'JRJC',
  },
  {
    symbol: 'JRO',
    'Security Name':
      'Nuveen Floating Rate ome Opportuntiy Fund Shares of Beneficial Interest',

    'CQS symbol': 'JRO',
    'NASDAQ symbol': 'JRO',
  },
  {
    symbol: 'JRS',
    'Security Name':
      'Nuveen Real Estate ome Fund Common Shares of Beneficial Interest',

    'CQS symbol': 'JRS',
    'NASDAQ symbol': 'JRS',
  },
  {
    symbol: 'JRSH',
    'Security Name': 'Jerash Holdings (US),   ',

    'NASDAQ symbol': 'JRSH',
  },
  {
    symbol: 'JRVR',
    'Security Name': 'James River Group Holdings, Ltd  Common Shares',

    'NASDAQ symbol': 'JRVR',
  },
  {
    symbol: 'JSD',
    'Security Name':
      'Nuveen Short Duration Credit Opportunities Fund Common Shares of Beneficial Interest',

    'CQS symbol': 'JSD',
    'NASDAQ symbol': 'JSD',
  },
  {
    symbol: 'JSM',
    'Security Name':
      'Navient Corporation  6% Senior Notes due December 15, 2043',

    'NASDAQ symbol': 'JSM',
  },
  {
    symbol: 'JSMD',
    'Security Name': 'Janus Henderson Small/Mid Cap Growth Alpha ETF',

    'NASDAQ symbol': 'JSMD',
  },
  {
    symbol: 'JSML',
    'Security Name': 'Janus Henderson Small Cap Growth Alpha ETF',

    'NASDAQ symbol': 'JSML',
  },
  {
    symbol: 'JT',
    'Security Name': 'Jianpu Technology  American depositary shares',

    'CQS symbol': 'JT',
    'NASDAQ symbol': 'JT',
  },
  {
    symbol: 'JTA',
    'Security Name':
      'Nuveen TaxAdvantaged Total Return Strategy Fund Common Share of Beneficial Interest',

    'CQS symbol': 'JTA',
    'NASDAQ symbol': 'JTA',
  },
  {
    symbol: 'JTD',
    'Security Name':
      'Nuveen TaxAdvantaged Dividend Growth Fund Common Shares of Beneficial Interest',

    'CQS symbol': 'JTD',
    'NASDAQ symbol': 'JTD',
  },
  {
    symbol: 'JULZ',
    'Security Name': 'TrueShares Structured Outcome (July) ETF',

    'CQS symbol': 'JULZ',
    'NASDAQ symbol': 'JULZ',
  },
  {
    symbol: 'JUPW',
    'Security Name': 'Jupiter Wellness,   ',

    'NASDAQ symbol': 'JUPW',
  },
  {
    symbol: 'JUPWW',
    'Security Name': 'Jupiter Wellness,   Warrant',

    'NASDAQ symbol': 'JUPWW',
  },
  {
    symbol: 'JUST',
    'Security Name': 'Goldman Sachs JUST US Large Cap Equity ETF',

    'CQS symbol': 'JUST',
    'NASDAQ symbol': 'JUST',
  },
  {
    symbol: 'JVA',
    'Security Name': 'Coffee Holding Co,   ',

    'NASDAQ symbol': 'JVA',
  },
  {
    symbol: 'JVAL',
    'Security Name': 'JPMorgan US Value Factor ETF',

    'CQS symbol': 'JVAL',
    'NASDAQ symbol': 'JVAL',
  },
  {
    symbol: 'JWA',
    'Security Name': 'John Wiley & Sons,  ',

    'CQS symbol': 'JWA',
    'NASDAQ symbol': 'JWA',
  },
  {
    symbol: 'JWB',
    'Security Name': 'John Wiley & Sons,  ',

    'CQS symbol': 'JWB',
    'NASDAQ symbol': 'JWB',
  },
  {
    symbol: 'JWN',
    'Security Name': 'Nordstrom,  ',

    'CQS symbol': 'JWN',
    'NASDAQ symbol': 'JWN',
  },
  {
    symbol: 'JWS',
    'Security Name': 'Jaws Acquisition Corp  Ordinary Shares',

    'CQS symbol': 'JWS',
    'NASDAQ symbol': 'JWS',
  },
  {
    symbol: 'JWSU',
    'Security Name':
      'Jaws Acquisition Corp Units, each consisting of one  ordinary share and onethird of one redeemable warrant',

    'CQS symbol': 'JWSU',
    'NASDAQ symbol': 'JWS=',
  },
  {
    symbol: 'JWSW',
    'Security Name':
      'Jaws Acquisition Corp Redeemable Warrants, each whole warrant exercisable for one  ordinary share at an exercise price of $1150',

    'CQS symbol': 'JWSWS',
    'NASDAQ symbol': 'JWS+',
  },
  {
    symbol: 'JXI',
    'Security Name': 'iShares Global Utilities ETF',

    'CQS symbol': 'JXI',
    'NASDAQ symbol': 'JXI',
  },
  {
    symbol: 'JYAC',
    'Security Name': 'Jiya Acquisition Corp   ',

    'NASDAQ symbol': 'JYAC',
  },
  {
    symbol: 'JYNT',
    'Security Name': 'The Joint Corp  ',

    'NASDAQ symbol': 'JYNT',
  },
  {
    symbol: 'K',
    'Security Name': 'Kellogg Company ',

    'CQS symbol': 'K',
    'NASDAQ symbol': 'K',
  },
  {
    symbol: 'KAI',
    'Security Name': 'Kadant  ',

    'CQS symbol': 'KAI',
    'NASDAQ symbol': 'KAI',
  },
  {
    symbol: 'KALA',
    'Security Name': 'Kala Pharmaceuticals,   ',

    'NASDAQ symbol': 'KALA',
  },
  {
    symbol: 'KALL',
    'Security Name': 'KraneShares MSCI All China Index ETF',

    'CQS symbol': 'KALL',
    'NASDAQ symbol': 'KALL',
  },
  {
    symbol: 'KALU',
    'Security Name': 'Kaiser Aluminum Corporation  ',

    'NASDAQ symbol': 'KALU',
  },
  {
    symbol: 'KALV',
    'Security Name': 'KalVista Pharmaceuticals,   ',

    'NASDAQ symbol': 'KALV',
  },
  {
    symbol: 'KAMN',
    'Security Name': 'Kaman Corporation ',

    'CQS symbol': 'KAMN',
    'NASDAQ symbol': 'KAMN',
  },
  {
    symbol: 'KAPR',
    'Security Name': 'Innovator Russell 2000 Power Buffer ETF April',

    'CQS symbol': 'KAPR',
    'NASDAQ symbol': 'KAPR',
  },
  {
    symbol: 'KAR',
    'Security Name': 'KAR Auction Services,  ',

    'CQS symbol': 'KAR',
    'NASDAQ symbol': 'KAR',
  },
  {
    symbol: 'KARS',
    'Security Name':
      'KraneShares Electric Vehicles and Future Mobility Index ETF',

    'CQS symbol': 'KARS',
    'NASDAQ symbol': 'KARS',
  },
  {
    symbol: 'KB',
    'Security Name': 'KB Financial Group ',

    'CQS symbol': 'KB',
    'NASDAQ symbol': 'KB',
  },
  {
    symbol: 'KBA',
    'Security Name': 'KraneShares Bosera MSCI China A ETF',

    'CQS symbol': 'KBA',
    'NASDAQ symbol': 'KBA',
  },
  {
    symbol: 'KBAL',
    'Security Name': 'Kimball International,   Class B ',

    'NASDAQ symbol': 'KBAL',
  },
  {
    symbol: 'KBE',
    'Security Name': 'SPDR S&P Bank ETF',

    'CQS symbol': 'KBE',
    'NASDAQ symbol': 'KBE',
  },
  {
    symbol: 'KBH',
    'Security Name': 'KB Home ',

    'CQS symbol': 'KBH',
    'NASDAQ symbol': 'KBH',
  },
  {
    symbol: 'KBNT',
    'Security Name': 'Kubient,   ',

    'NASDAQ symbol': 'KBNT',
  },
  {
    symbol: 'KBNTW',
    'Security Name': 'Kubient,   Warrant',

    'NASDAQ symbol': 'KBNTW',
  },
  {
    symbol: 'KBR',
    'Security Name': 'KBR,  ',

    'CQS symbol': 'KBR',
    'NASDAQ symbol': 'KBR',
  },
  {
    symbol: 'KBSF',
    'Security Name': 'KBS Fashion Group Limited  ',

    'NASDAQ symbol': 'KBSF',
  },
  {
    symbol: 'KBWB',
    'Security Name': 'Invesco KBW Bank ETF',

    'NASDAQ symbol': 'KBWB',
  },
  {
    symbol: 'KBWD',
    'Security Name': 'Invesco KBW High Dividend Yield Financial ETF',

    'NASDAQ symbol': 'KBWD',
  },
  {
    symbol: 'KBWP',
    'Security Name': 'Invesco KBW Property & Casualty Insurance ETF',

    'NASDAQ symbol': 'KBWP',
  },
  {
    symbol: 'KBWR',
    'Security Name': 'Invesco KBW Regional Banking ETF',

    'NASDAQ symbol': 'KBWR',
  },
  {
    symbol: 'KBWY',
    'Security Name': 'Invesco KBW Premium Yield Equity REIT ETF',

    'NASDAQ symbol': 'KBWY',
  },
  {
    symbol: 'KC',
    'Security Name':
      'Kingsoft Cloud Holdings Limited  American Depositary Shares',

    'NASDAQ symbol': 'KC',
  },
  {
    symbol: 'KCAPL',
    'Security Name': 'Portman Ridge Finance Corporation  6125% Notes due 2022',

    'NASDAQ symbol': 'KCAPL',
  },
  {
    symbol: 'KCCB',
    'Security Name':
      'KraneShares CCBS China Corporate High Yield Bond USD Index ETF',

    'CQS symbol': 'KCCB',
    'NASDAQ symbol': 'KCCB',
  },
  {
    symbol: 'KCE',
    'Security Name': 'SPDR S&P Capital Markets ETF',

    'CQS symbol': 'KCE',
    'NASDAQ symbol': 'KCE',
  },
  {
    symbol: 'KCNY',
    'Security Name': 'KraneShares E Fund China Commercial Paper ETF',

    'CQS symbol': 'KCNY',
    'NASDAQ symbol': 'KCNY',
  },
  {
    symbol: 'KDFI',
    'Security Name': 'KFA Dynamic Fixed ome ETF',

    'CQS symbol': 'KDFI',
    'NASDAQ symbol': 'KDFI',
  },
  {
    symbol: 'KDMN',
    'Security Name': 'Kadmon Holdings,   ',

    'NASDAQ symbol': 'KDMN',
  },
  {
    symbol: 'KDNY',
    'Security Name': 'Chinook Therapeutics,   ',

    'NASDAQ symbol': 'KDNY',
  },
  {
    symbol: 'KDP',
    'Security Name': 'Keurig Dr Pepper   ',

    'NASDAQ symbol': 'KDP',
  },
  {
    symbol: 'KE',
    'Security Name': 'Kimball Electronics,   ',

    'NASDAQ symbol': 'KE',
  },
  {
    symbol: 'KELYA',
    'Security Name': 'Kelly Services,    ',

    'NASDAQ symbol': 'KELYA',
  },
  {
    symbol: 'KELYB',
    'Security Name': 'Kelly Services,   Class B ',

    'NASDAQ symbol': 'KELYB',
  },
  {
    symbol: 'KEMQ',
    'Security Name':
      'KraneShares Emerging Markets Consumer Technology Index ETF',

    'CQS symbol': 'KEMQ',
    'NASDAQ symbol': 'KEMQ',
  },
  {
    symbol: 'KEMX',
    'Security Name': 'KraneShares MSCI Emerging Markets ex China Index ETF',

    'CQS symbol': 'KEMX',
    'NASDAQ symbol': 'KEMX',
  },
  {
    symbol: 'KEN',
    'Security Name': 'Kenon Holdings Ltd Ordinary Shares',

    'CQS symbol': 'KEN',
    'NASDAQ symbol': 'KEN',
  },
  {
    symbol: 'KEP',
    'Security Name': 'Korea Electric Power Corporation ',

    'CQS symbol': 'KEP',
    'NASDAQ symbol': 'KEP',
  },
  {
    symbol: 'KEQU',
    'Security Name': 'Kewaunee Scientific Corporation  ',

    'NASDAQ symbol': 'KEQU',
  },
  {
    symbol: 'KERN',
    'Security Name': 'Akerna Corp  ',

    'NASDAQ symbol': 'KERN',
  },
  {
    symbol: 'KERNW',
    'Security Name': 'Akerna Corp  Warrant',

    'NASDAQ symbol': 'KERNW',
  },
  {
    symbol: 'KESG',
    'Security Name': 'KraneShares MSCI China ESG Leaders Index ETF',

    'CQS symbol': 'KESG',
    'NASDAQ symbol': 'KESG',
  },
  {
    symbol: 'KEX',
    'Security Name': 'Kirby Corporation ',

    'CQS symbol': 'KEX',
    'NASDAQ symbol': 'KEX',
  },
  {
    symbol: 'KEY',
    'Security Name': 'KeyCorp ',

    'CQS symbol': 'KEY',
    'NASDAQ symbol': 'KEY',
  },
  {
    symbol: 'KEY$I',
    'Security Name':
      'KeyCorp Depositary Shares Each Representing a 1/40th Ownership Interest in a Share of FixedtoFloating Rate Perpetual NonCumulative Preferred Stock, Series E',

    'CQS symbol': 'KEYpI',
    'NASDAQ symbol': 'KEYI',
  },
  {
    symbol: 'KEY$J',
    'Security Name':
      'KeyCorp Depositary Shares each representing a 1/40th ownership interest in a share of Fixed Rate Perpetual NonCumulative Preferred Stock, Series F',

    'CQS symbol': 'KEYpJ',
    'NASDAQ symbol': 'KEYJ',
  },
  {
    symbol: 'KEY$K',
    'Security Name':
      'KeyCorp Depositary Shares, each representing a 1/40th ownership interest in a share of Fixed Rate Perpetual NonCumulative Preferred Stock, Series G',

    'CQS symbol': 'KEYpK',
    'NASDAQ symbol': 'KEYK',
  },
  {
    symbol: 'KEYS',
    'Security Name': 'Keysight Technologies  ',

    'CQS symbol': 'KEYS',
    'NASDAQ symbol': 'KEYS',
  },
  {
    symbol: 'KF',
    'Security Name': 'Korea Fund,  (The) New ',

    'CQS symbol': 'KF',
    'NASDAQ symbol': 'KF',
  },
  {
    symbol: 'KFFB',
    'Security Name': 'Kentucky First Federal Bancorp  ',

    'NASDAQ symbol': 'KFFB',
  },
  {
    symbol: 'KFRC',
    'Security Name': 'Kforce,   ',

    'NASDAQ symbol': 'KFRC',
  },
  {
    symbol: 'KFS',
    'Security Name': 'Kingsway Financial Services,   (DE)',

    'CQS symbol': 'KFS',
    'NASDAQ symbol': 'KFS',
  },
  {
    symbol: 'KFVG',
    'Security Name':
      'KraneShares Trust KraneShares CICC China 5G and Semiconductor Index ETF',

    'CQS symbol': 'KFVG',
    'NASDAQ symbol': 'KFVG',
  },
  {
    symbol: 'KFY',
    'Security Name': 'Korn Ferry ',

    'CQS symbol': 'KFY',
    'NASDAQ symbol': 'KFY',
  },
  {
    symbol: 'KFYP',
    'Security Name': 'KraneShares CICC China Leaders 100 Index ETF',

    'CQS symbol': 'KFYP',
    'NASDAQ symbol': 'KFYP',
  },
  {
    symbol: 'KGC',
    'Security Name': 'Kinross Gold Corporation ',

    'CQS symbol': 'KGC',
    'NASDAQ symbol': 'KGC',
  },
  {
    symbol: 'KGRN',
    'Security Name': 'KraneShares MSCI China Environment Index ETF',

    'CQS symbol': 'KGRN',
    'NASDAQ symbol': 'KGRN',
  },
  {
    symbol: 'KHC',
    'Security Name': 'The Kraft Heinz Company  ',

    'NASDAQ symbol': 'KHC',
  },
  {
    symbol: 'KIDS',
    'Security Name': 'OrthoPediatrics Corp  ',

    'NASDAQ symbol': 'KIDS',
  },
  {
    symbol: 'KIE',
    'Security Name': 'SPDR S&P Insurance ETF',

    'CQS symbol': 'KIE',
    'NASDAQ symbol': 'KIE',
  },
  {
    symbol: 'KIM',
    'Security Name': 'Kimco Realty Corporation ',

    'CQS symbol': 'KIM',
    'NASDAQ symbol': 'KIM',
  },
  {
    symbol: 'KIM$L',
    'Security Name':
      'Kimco Realty Corporation Class L Depositary Shares, each of which represents a oneone thousandth fractional interest in a share of 5125% Class L Cumulative Redeemable Preferred Stock, liquidation preference $25,00000 per share',

    'CQS symbol': 'KIMpL',
    'NASDAQ symbol': 'KIML',
  },
  {
    symbol: 'KIM$M',
    'Security Name':
      'Kimco Realty Corporation Class M Depositary Shares, each of which represents a oneone thousandth fractional interest in a share of 525% Class M Cumulative Redeemable Preferred Stock, liquidation preference $25,00000 per share',

    'CQS symbol': 'KIMpM',
    'NASDAQ symbol': 'KIMM',
  },
  {
    symbol: 'KIN',
    'Security Name': 'Kindred Biosciences,   ',

    'NASDAQ symbol': 'KIN',
  },
  {
    symbol: 'KINS',
    'Security Name': 'Kingstone Companies,   ',

    'NASDAQ symbol': 'KINS',
  },
  {
    symbol: 'KIO',
    'Security Name': 'KKR ome Opportunities Fund Common Shares',

    'CQS symbol': 'KIO',
    'NASDAQ symbol': 'KIO',
  },
  {
    symbol: 'KIQ',
    'Security Name': 'Kelso Technologies  Ordinary Shares',

    'CQS symbol': 'KIQ',
    'NASDAQ symbol': 'KIQ',
  },
  {
    symbol: 'KIRK',
    'Security Name': "Kirkland's,   ",

    'NASDAQ symbol': 'KIRK',
  },
  {
    symbol: 'KJAN',
    'Security Name':
      'Innovator ETFs Trust Innovator Russell 2000 Power Buffer ETF  January',

    'CQS symbol': 'KJAN',
    'NASDAQ symbol': 'KJAN',
  },
  {
    symbol: 'KJUL',
    'Security Name': 'Innovator Russell 2000 Power Buffer ETF  July',

    'CQS symbol': 'KJUL',
    'NASDAQ symbol': 'KJUL',
  },
  {
    symbol: 'KKR',
    'Security Name': 'KKR & Co  ',

    'CQS symbol': 'KKR',
    'NASDAQ symbol': 'KKR',
  },
  {
    symbol: 'KKR$A',
    'Security Name': 'KKR & Co  675% Series A Preferred Stock',

    'CQS symbol': 'KKRpA',
    'NASDAQ symbol': 'KKRA',
  },
  {
    symbol: 'KKR$B',
    'Security Name': 'KKR & Co  650% Series B Preferred Stock',

    'CQS symbol': 'KKRpB',
    'NASDAQ symbol': 'KKRB',
  },
  {
    symbol: 'KKR$C',
    'Security Name':
      'KKR & Co  600% Series C Mandatory Convertible Preferred Stock',

    'CQS symbol': 'KKRpC',
    'NASDAQ symbol': 'KKRC',
  },
  {
    symbol: 'KL',
    'Security Name': 'Kirkland Lake Gold Ltd Common Shares',

    'CQS symbol': 'KL',
    'NASDAQ symbol': 'KL',
  },
  {
    symbol: 'KLAC',
    'Security Name': 'KLA Corporation   ',

    'NASDAQ symbol': 'KLAC',
  },
  {
    symbol: 'KLCD',
    'Security Name': 'KFA Large Cap Quality Dividend Index ETF',

    'CQS symbol': 'KLCD',
    'NASDAQ symbol': 'KLCD',
  },
  {
    symbol: 'KLDO',
    'Security Name': 'Kaleido Biosciences,   ',

    'NASDAQ symbol': 'KLDO',
  },
  {
    symbol: 'KLDW',
    'Security Name': 'Knowledge Leaders Developed World ETF',

    'CQS symbol': 'KLDW',
    'NASDAQ symbol': 'KLDW',
  },
  {
    symbol: 'KLIC',
    'Security Name': 'Kulicke and Soffa Industries,   ',

    'NASDAQ symbol': 'KLIC',
  },
  {
    symbol: 'KLR',
    'Security Name': 'Kaleyra,  ',

    'CQS symbol': 'KLR',
    'NASDAQ symbol': 'KLR',
  },
  {
    symbol: 'KLRW',
    'Security Name': 'Kaleyra,  Warrants',

    'CQS symbol': 'KLRWS',
    'NASDAQ symbol': 'KLR+',
  },
  {
    symbol: 'KLXE',
    'Security Name': 'KLX Energy Services Holdings,    ',

    'NASDAQ symbol': 'KLXE',
  },
  {
    symbol: 'KMB',
    'Security Name': 'KimberlyClark Corporation ',

    'CQS symbol': 'KMB',
    'NASDAQ symbol': 'KMB',
  },
  {
    symbol: 'KMDA',
    'Security Name': 'Kamada Ltd  Ordinary Shares',

    'NASDAQ symbol': 'KMDA',
  },
  {
    symbol: 'KMED',
    'Security Name':
      'KraneShares Trust KraneShares Emerging Markets Healthcare Index ETF',

    'CQS symbol': 'KMED',
    'NASDAQ symbol': 'KMED',
  },
  {
    symbol: 'KMF',
    'Security Name': 'Kayne Anderson NextGen Energy & Infrastructure, ',

    'CQS symbol': 'KMF',
    'NASDAQ symbol': 'KMF',
  },
  {
    symbol: 'KMI',
    'Security Name': 'Kinder Morgan,  ',

    'CQS symbol': 'KMI',
    'NASDAQ symbol': 'KMI',
  },
  {
    symbol: 'KMLM',
    'Security Name': 'KFA Mount Lucas Index Strategy ETF',

    'CQS symbol': 'KMLM',
    'NASDAQ symbol': 'KMLM',
  },
  {
    symbol: 'KMPR',
    'Security Name': 'Kemper Corporation',

    'CQS symbol': 'KMPR',
    'NASDAQ symbol': 'KMPR',
  },
  {
    symbol: 'KMT',
    'Security Name': 'Kennametal  ',

    'CQS symbol': 'KMT',
    'NASDAQ symbol': 'KMT',
  },
  {
    symbol: 'KMX',
    'Security Name': 'CarMax ',

    'CQS symbol': 'KMX',
    'NASDAQ symbol': 'KMX',
  },
  {
    symbol: 'KN',
    'Security Name': 'Knowles Corporation ',

    'CQS symbol': 'KN',
    'NASDAQ symbol': 'KN',
  },
  {
    symbol: 'KNAB',
    'Security Name': 'MicroSectors US Big Banks Index Inverse ETNs',

    'CQS symbol': 'KNAB',
    'NASDAQ symbol': 'KNAB',
  },
  {
    symbol: 'KNDI',
    'Security Name': 'Kandi Technologies Group,   ',

    'NASDAQ symbol': 'KNDI',
  },
  {
    symbol: 'KNG',
    'Security Name':
      'ETF Series Solutions ETF Cboe Vest S&P 500 Dividend Aristocrats Target ome ETF',

    'CQS symbol': 'KNG',
    'NASDAQ symbol': 'KNG',
  },
  {
    symbol: 'KNL',
    'Security Name': 'Knoll,  ',

    'CQS symbol': 'KNL',
    'NASDAQ symbol': 'KNL',
  },
  {
    symbol: 'KNOP',
    'Security Name':
      'KNOT Offshore Partners LP Common Units representing Limited Partner Interests',

    'CQS symbol': 'KNOP',
    'NASDAQ symbol': 'KNOP',
  },
  {
    symbol: 'KNSA',
    'Security Name': 'Kiniksa Pharmaceuticals, Ltd   ',

    'NASDAQ symbol': 'KNSA',
  },
  {
    symbol: 'KNSL',
    'Security Name': 'Kinsale Capital Group,   ',

    'NASDAQ symbol': 'KNSL',
  },
  {
    symbol: 'KNTE',
    'Security Name': 'Kinnate Biopharma   ',

    'NASDAQ symbol': 'KNTE',
  },
  {
    symbol: 'KNX',
    'Security Name': 'KnightSwift Transportation Holdings ',

    'CQS symbol': 'KNX',
    'NASDAQ symbol': 'KNX',
  },
  {
    symbol: 'KO',
    'Security Name': 'CocaCola Company (The) ',

    'CQS symbol': 'KO',
    'NASDAQ symbol': 'KO',
  },
  {
    symbol: 'KOCT',
    'Security Name': 'Innovator Russell 2000 Power Buffer ETF  October',

    'CQS symbol': 'KOCT',
    'NASDAQ symbol': 'KOCT',
  },
  {
    symbol: 'KOD',
    'Security Name': 'Kodiak Sciences   ',

    'NASDAQ symbol': 'KOD',
  },
  {
    symbol: 'KODK',
    'Security Name': 'Eastman Kodak Company Common New',

    'CQS symbol': 'KODK',
    'NASDAQ symbol': 'KODK',
  },
  {
    symbol: 'KOF',
    'Security Name':
      'Coca Cola Femsa SAB de CV  American Depositary Shares, each representing 10 Units (each Unit consists of 3 Series B Shares and 5 Series L Shares)',

    'CQS symbol': 'KOF',
    'NASDAQ symbol': 'KOF',
  },
  {
    symbol: 'KOIN',
    'Security Name': 'Capital Link NextGen Protocol ETF',

    'CQS symbol': 'KOIN',
    'NASDAQ symbol': 'KOIN',
  },
  {
    symbol: 'KOKU',
    'Security Name': 'Xtrackers MSCI Kokusai Equity ETF',

    'CQS symbol': 'KOKU',
    'NASDAQ symbol': 'KOKU',
  },
  {
    symbol: 'KOL',
    'Security Name': 'VanEck Vectors Coal ETF',

    'CQS symbol': 'KOL',
    'NASDAQ symbol': 'KOL',
  },
  {
    symbol: 'KOLD',
    'Security Name': 'ProShares UltraShort Bloomberg Natural Gas',

    'CQS symbol': 'KOLD',
    'NASDAQ symbol': 'KOLD',
  },
  {
    symbol: 'KOMP',
    'Security Name': 'SPDR S&P Kensho New Economies Composite ETF',

    'CQS symbol': 'KOMP',
    'NASDAQ symbol': 'KOMP',
  },
  {
    symbol: 'KOP',
    'Security Name': 'Koppers Holdings  Koppers Holdings  ',

    'CQS symbol': 'KOP',
    'NASDAQ symbol': 'KOP',
  },
  {
    symbol: 'KOPN',
    'Security Name': 'Kopin Corporation  ',

    'NASDAQ symbol': 'KOPN',
  },
  {
    symbol: 'KOR',
    'Security Name': 'Corvus Gold   Common Shares',

    'NASDAQ symbol': 'KOR',
  },
  {
    symbol: 'KORP',
    'Security Name': 'American Century Diversified Corporate Bond ETF',

    'CQS symbol': 'KORP',
    'NASDAQ symbol': 'KORP',
  },
  {
    symbol: 'KORU',
    'Security Name': 'Direxion Daily South Korea Bull 3X Shares',

    'CQS symbol': 'KORU',
    'NASDAQ symbol': 'KORU',
  },
  {
    symbol: 'KOS',
    'Security Name': 'Kosmos Energy Ltd Common Shares (DE)',

    'CQS symbol': 'KOS',
    'NASDAQ symbol': 'KOS',
  },
  {
    symbol: 'KOSS',
    'Security Name': 'Koss Corporation  ',

    'NASDAQ symbol': 'KOSS',
  },
  {
    symbol: 'KPTI',
    'Security Name': 'Karyopharm Therapeutics   ',

    'NASDAQ symbol': 'KPTI',
  },
  {
    symbol: 'KR',
    'Security Name': 'Kroger Company (The) ',

    'CQS symbol': 'KR',
    'NASDAQ symbol': 'KR',
  },
  {
    symbol: 'KRA',
    'Security Name': 'Kraton Corporation ',

    'CQS symbol': 'KRA',
    'NASDAQ symbol': 'KRA',
  },
  {
    symbol: 'KRBN',
    'Security Name': 'KFA Global Carbon ETF',

    'CQS symbol': 'KRBN',
    'NASDAQ symbol': 'KRBN',
  },
  {
    symbol: 'KRBP',
    'Security Name': 'Kiromic BioPharma,   ',

    'NASDAQ symbol': 'KRBP',
  },
  {
    symbol: 'KRC',
    'Security Name': 'Kilroy Realty Corporation ',

    'CQS symbol': 'KRC',
    'NASDAQ symbol': 'KRC',
  },
  {
    symbol: 'KRE',
    'Security Name': 'SPDR S&P Regional Banking ETF',

    'CQS symbol': 'KRE',
    'NASDAQ symbol': 'KRE',
  },
  {
    symbol: 'KREF',
    'Security Name': 'KKR Real Estate Finance Trust  ',

    'CQS symbol': 'KREF',
    'NASDAQ symbol': 'KREF',
  },
  {
    symbol: 'KRG',
    'Security Name': 'Kite Realty Group Trust ',

    'CQS symbol': 'KRG',
    'NASDAQ symbol': 'KRG',
  },
  {
    symbol: 'KRKR',
    'Security Name': '36Kr Holdings   American Depositary Shares',

    'NASDAQ symbol': 'KRKR',
  },
  {
    symbol: 'KRMA',
    'Security Name': 'Global X Conscious Companies ETF',

    'NASDAQ symbol': 'KRMA',
  },
  {
    symbol: 'KRMD',
    'Security Name': 'Repro Med Systems,   ',

    'NASDAQ symbol': 'KRMD',
  },
  {
    symbol: 'KRNT',
    'Security Name': 'Kornit Digital Ltd  Ordinary Shares',

    'NASDAQ symbol': 'KRNT',
  },
  {
    symbol: 'KRNY',
    'Security Name': 'Kearny Financial  ',

    'NASDAQ symbol': 'KRNY',
  },
  {
    symbol: 'KRO',
    'Security Name': 'Kronos Worldwide  ',

    'CQS symbol': 'KRO',
    'NASDAQ symbol': 'KRO',
  },
  {
    symbol: 'KRON',
    'Security Name': 'Kronos Bio,   ',

    'NASDAQ symbol': 'KRON',
  },
  {
    symbol: 'KROS',
    'Security Name': 'Keros Therapeutics,   ',

    'NASDAQ symbol': 'KROS',
  },
  {
    symbol: 'KRP',
    'Security Name':
      'Kimbell Royalty Partners Common Units Representing Limited Partner Interests',

    'CQS symbol': 'KRP',
    'NASDAQ symbol': 'KRP',
  },
  {
    symbol: 'KRTX',
    'Security Name': 'Karuna Therapeutics,   ',

    'NASDAQ symbol': 'KRTX',
  },
  {
    symbol: 'KRUS',
    'Security Name': 'Kura Sushi USA,    ',

    'NASDAQ symbol': 'KRUS',
  },
  {
    symbol: 'KRYS',
    'Security Name': 'Krystal Biotech,   ',

    'NASDAQ symbol': 'KRYS',
  },
  {
    symbol: 'KSA',
    'Security Name': 'iShares Trust iShares MSCI Saudi Arabia ETF',

    'CQS symbol': 'KSA',
    'NASDAQ symbol': 'KSA',
  },
  {
    symbol: 'KSCD',
    'Security Name': 'KFA Small Cap Quality Dividend Index ETF',

    'CQS symbol': 'KSCD',
    'NASDAQ symbol': 'KSCD',
  },
  {
    symbol: 'KSM',
    'Security Name': 'DWS Strategic Municipal ome Trust',

    'CQS symbol': 'KSM',
    'NASDAQ symbol': 'KSM',
  },
  {
    symbol: 'KSMT',
    'Security Name': 'Kismet Acquisition One Corp  Ordinary Shares',

    'NASDAQ symbol': 'KSMT',
  },
  {
    symbol: 'KSMTU',
    'Security Name': 'Kismet Acquisition One Corp  Unit',

    'NASDAQ symbol': 'KSMTU',
  },
  {
    symbol: 'KSMTW',
    'Security Name': 'Kismet Acquisition One Corp  Warrant',

    'NASDAQ symbol': 'KSMTW',
  },
  {
    symbol: 'KSPN',
    'Security Name': 'Kaspien Holdings   ',

    'NASDAQ symbol': 'KSPN',
  },
  {
    symbol: 'KSS',
    'Security Name': "Kohl's Corporation ",

    'CQS symbol': 'KSS',
    'NASDAQ symbol': 'KSS',
  },
  {
    symbol: 'KSU',
    'Security Name': 'Kansas City Southern ',

    'CQS symbol': 'KSU',
    'NASDAQ symbol': 'KSU',
  },
  {
    symbol: 'KSU$',
    'Security Name': 'Kansas City Southern Preferred Stock',

    'Round Lot Size': '10',

    'CQS symbol': 'KSUp',
    'NASDAQ symbol': 'KSU',
  },
  {
    symbol: 'KT',
    'Security Name': 'KT Corporation ',

    'CQS symbol': 'KT',
    'NASDAQ symbol': 'KT',
  },
  {
    symbol: 'KTB',
    'Security Name': 'Kontoor Brands,   ',

    'CQS symbol': 'KTB',
    'NASDAQ symbol': 'KTB',
  },
  {
    symbol: 'KTCC',
    'Security Name': 'Key Tronic Corporation  ',

    'NASDAQ symbol': 'KTCC',
  },
  {
    symbol: 'KTF',
    'Security Name': 'DWS Municipal ome Trust',

    'CQS symbol': 'KTF',
    'NASDAQ symbol': 'KTF',
  },
  {
    symbol: 'KTH',
    'Security Name':
      'Structures Products Cp 8% CorTS Issued by Peco Energy Cap Tr II Preferred Stock',

    'CQS symbol': 'KTH',
    'NASDAQ symbol': 'KTH',
  },
  {
    symbol: 'KTN',
    'Security Name':
      'Structured Products Corp 8205% CorTS 8205% Corporate Backed Trust Securities (CorTS)',

    'CQS symbol': 'KTN',
    'NASDAQ symbol': 'KTN',
  },
  {
    symbol: 'KTOS',
    'Security Name': 'Kratos Defense & Security Solutions,   ',

    'NASDAQ symbol': 'KTOS',
  },
  {
    symbol: 'KTOV',
    'Security Name': 'Kitov Pharma Ltd  American Depositary Shares',

    'NASDAQ symbol': 'KTOV',
  },
  {
    symbol: 'KTRA',
    'Security Name': 'Kintara Therapeutics,   ',

    'NASDAQ symbol': 'KTRA',
  },
  {
    symbol: 'KURA',
    'Security Name': 'Kura Oncology,   ',

    'NASDAQ symbol': 'KURA',
  },
  {
    symbol: 'KURE',
    'Security Name': 'KraneShares MSCI All China Health Care Index ETF',

    'CQS symbol': 'KURE',
    'NASDAQ symbol': 'KURE',
  },
  {
    symbol: 'KVHI',
    'Security Name': 'KVH Industries,   ',

    'NASDAQ symbol': 'KVHI',
  },
  {
    symbol: 'KVLE',
    'Security Name':
      'KraneShares Trust KFA Value Line Dynamic Core Equity Index ETF',

    'CQS symbol': 'KVLE',
    'NASDAQ symbol': 'KVLE',
  },
  {
    symbol: 'KW',
    'Security Name': 'KennedyWilson Holdings  ',

    'CQS symbol': 'KW',
    'NASDAQ symbol': 'KW',
  },
  {
    symbol: 'KWACU',
    'Security Name':
      'Kingswood Acquisition Corp Units, each consisting of one share of   and threefourths of one redeemable warrant',

    'CQS symbol': 'KWACU',
    'NASDAQ symbol': 'KWAC=',
  },
  {
    symbol: 'KWEB',
    'Security Name': 'KraneShares Trust KraneShares CSI China Internet ETF',

    'CQS symbol': 'KWEB',
    'NASDAQ symbol': 'KWEB',
  },
  {
    symbol: 'KWR',
    'Security Name': 'Quaker Chemical Corporation ',

    'CQS symbol': 'KWR',
    'NASDAQ symbol': 'KWR',
  },
  {
    symbol: 'KWT',
    'Security Name': 'iShares Trust iShares MSCI Kuwait ETF',

    'CQS symbol': 'KWT',
    'NASDAQ symbol': 'KWT',
  },
  {
    symbol: 'KXI',
    'Security Name': 'iShares Global Consumer Staples ETF',

    'CQS symbol': 'KXI',
    'NASDAQ symbol': 'KXI',
  },
  {
    symbol: 'KXIN',
    'Security Name': 'Kaixin Auto Holdings  Ordinary Share',

    'NASDAQ symbol': 'KXIN',
  },
  {
    symbol: 'KYMR',
    'Security Name': 'Kymera Therapeutics,   ',

    'NASDAQ symbol': 'KYMR',
  },
  {
    symbol: 'KYN',
    'Security Name': 'Kayne Anderson Energy Infrastructure Fund, ',

    'CQS symbol': 'KYN',
    'NASDAQ symbol': 'KYN',
  },
  {
    symbol: 'KZIA',
    'Security Name': 'Kazia Therapeutics Limited  American Depositary Shares',

    'NASDAQ symbol': 'KZIA',
  },
  {
    symbol: 'KZR',
    'Security Name': 'Kezar Life Sciences,   ',

    'NASDAQ symbol': 'KZR',
  },
  {
    symbol: 'L',
    'Security Name': 'Loews Corporation ',

    'CQS symbol': 'L',
    'NASDAQ symbol': 'L',
  },
  {
    symbol: 'LABD',
    'Security Name': 'Direxion Daily S&P Biotech Bear 3X Shares',

    'CQS symbol': 'LABD',
    'NASDAQ symbol': 'LABD',
  },
  {
    symbol: 'LABU',
    'Security Name': 'Direxion Daily S&P Biotech Bull 3X Shares',

    'CQS symbol': 'LABU',
    'NASDAQ symbol': 'LABU',
  },
  {
    symbol: 'LAC',
    'Security Name': 'Lithium Americas Corp Common Shares',

    'CQS symbol': 'LAC',
    'NASDAQ symbol': 'LAC',
  },
  {
    symbol: 'LACQ',
    'Security Name': 'Leisure Acquisition Corp  ',

    'NASDAQ symbol': 'LACQ',
  },
  {
    symbol: 'LACQU',
    'Security Name': 'Leisure Acquisition Corp  Unit',

    'NASDAQ symbol': 'LACQU',
  },
  {
    symbol: 'LACQW',
    'Security Name': 'Leisure Acquisition Corp  Warrant',

    'NASDAQ symbol': 'LACQW',
  },
  {
    symbol: 'LAD',
    'Security Name': 'Lithia Motors,  ',

    'CQS symbol': 'LAD',
    'NASDAQ symbol': 'LAD',
  },
  {
    symbol: 'LADR',
    'Security Name': 'Ladder Capital Corp  ',

    'CQS symbol': 'LADR',
    'NASDAQ symbol': 'LADR',
  },
  {
    symbol: 'LAIX',
    'Security Name':
      'LAIX  American Depositary Shares, each  representing one  Ordinary Share',

    'CQS symbol': 'LAIX',
    'NASDAQ symbol': 'LAIX',
  },
  {
    symbol: 'LAKE',
    'Security Name': 'Lakeland Industries,   ',

    'NASDAQ symbol': 'LAKE',
  },
  {
    symbol: 'LAMR',
    'Security Name': 'Lamar Advertising Company   ',

    'NASDAQ symbol': 'LAMR',
  },
  {
    symbol: 'LANC',
    'Security Name': 'Lancaster Colony Corporation  ',

    'NASDAQ symbol': 'LANC',
  },
  {
    symbol: 'LAND',
    'Security Name': 'Gladstone Land Corporation  ',

    'NASDAQ symbol': 'LAND',
  },
  {
    symbol: 'LANDO',
    'Security Name':
      'Gladstone Land Corporation  600% Series B Cumulative Redeemable Preferred Stock',

    'NASDAQ symbol': 'LANDO',
  },
  {
    symbol: 'LANDP',
    'Security Name':
      'Gladstone Land Corporation  6375% Series A Cumulative Term Preferred Stock',

    'NASDAQ symbol': 'LANDP',
  },
  {
    symbol: 'LARK',
    'Security Name': 'Landmark Bancorp   ',

    'NASDAQ symbol': 'LARK',
  },
  {
    symbol: 'LASR',
    'Security Name': 'nLIGHT,   ',

    'NASDAQ symbol': 'LASR',
  },
  {
    symbol: 'LATN',
    'Security Name': 'Union Acquisition Corp II  Ordinary Shares',

    'NASDAQ symbol': 'LATN',
  },
  {
    symbol: 'LATNU',
    'Security Name': 'Union Acquisition Corp II  Units',

    'NASDAQ symbol': 'LATNU',
  },
  {
    symbol: 'LATNW',
    'Security Name': 'Union Acquisition Corp II  Warrant',

    'NASDAQ symbol': 'LATNW',
  },
  {
    symbol: 'LAUR',
    'Security Name': 'Laureate Education,    ',

    'NASDAQ symbol': 'LAUR',
  },
  {
    symbol: 'LAWS',
    'Security Name': 'Lawson Products,   ',

    'NASDAQ symbol': 'LAWS',
  },
  {
    symbol: 'LAZ',
    'Security Name': 'Lazard LTD Lazard, LTD  ',

    'CQS symbol': 'LAZ',
    'NASDAQ symbol': 'LAZ',
  },
  {
    symbol: 'LAZR',
    'Security Name': 'Luminar Technologies,     ',

    'NASDAQ symbol': 'LAZR',
  },
  {
    symbol: 'LAZRW',
    'Security Name': 'Luminar Technologies,    Warrant',

    'NASDAQ symbol': 'LAZRW',
  },
  {
    symbol: 'LAZY',
    'Security Name': 'Lazydays Holdings,   ',

    'NASDAQ symbol': 'LAZY',
  },
  {
    symbol: 'LB',
    'Security Name': 'L Brands, ',

    'CQS symbol': 'LB',
    'NASDAQ symbol': 'LB',
  },
  {
    symbol: 'LBAI',
    'Security Name': 'Lakeland Bancorp,   ',

    'NASDAQ symbol': 'LBAI',
  },
  {
    symbol: 'LBAY',
    'Security Name': 'Leatherback Long/Short Alternative Yield ETF',

    'CQS symbol': 'LBAY',
    'NASDAQ symbol': 'LBAY',
  },
  {
    symbol: 'LBC',
    'Security Name': 'Luther Burbank Corporation  ',

    'NASDAQ symbol': 'LBC',
  },
  {
    symbol: 'LBJ',
    'Security Name': 'Direxion Daily Latin America Bull 2X Shares',

    'CQS symbol': 'LBJ',
    'NASDAQ symbol': 'LBJ',
  },
  {
    symbol: 'LBRDA',
    'Security Name': 'Liberty Broadband Corporation   ',

    'NASDAQ symbol': 'LBRDA',
  },
  {
    symbol: 'LBRDK',
    'Security Name': 'Liberty Broadband Corporation  Class C ',

    'NASDAQ symbol': 'LBRDK',
  },
  {
    symbol: 'LBRT',
    'Security Name': 'Liberty Oilfield Services   ',

    'CQS symbol': 'LBRT',
    'NASDAQ symbol': 'LBRT',
  },
  {
    symbol: 'LBTYA',
    'Security Name': 'Liberty Global plc   Ordinary Shares',

    'NASDAQ symbol': 'LBTYA',
  },
  {
    symbol: 'LBTYB',
    'Security Name': 'Liberty Global plc  Class B Ordinary Shares',

    'NASDAQ symbol': 'LBTYB',
  },
  {
    symbol: 'LBTYK',
    'Security Name': 'Liberty Global plc  Class C Ordinary Shares',

    'NASDAQ symbol': 'LBTYK',
  },
  {
    symbol: 'LC',
    'Security Name': 'LendingClub Corporation ',

    'CQS symbol': 'LC',
    'NASDAQ symbol': 'LC',
  },
  {
    symbol: 'LCA',
    'Security Name': 'Landcadia Holdings II,    ',

    'NASDAQ symbol': 'LCA',
  },
  {
    symbol: 'LCAHU',
    'Security Name': 'Landcadia Holdings II,   Unit',

    'NASDAQ symbol': 'LCAHU',
  },
  {
    symbol: 'LCAHW',
    'Security Name': 'Landcadia Holdings II,   Warrant',

    'NASDAQ symbol': 'LCAHW',
  },
  {
    symbol: 'LCAP',
    'Security Name': 'Lionheart Acquisition Corp II   ',

    'NASDAQ symbol': 'LCAP',
  },
  {
    symbol: 'LCAPU',
    'Security Name': 'Lionheart Acquisition Corp II  Unit',

    'NASDAQ symbol': 'LCAPU',
  },
  {
    symbol: 'LCAPW',
    'Security Name': 'Lionheart Acquisition Corp II  Warrant',

    'NASDAQ symbol': 'LCAPW',
  },
  {
    symbol: 'LCG',
    'Security Name': 'Sterling Capital Focus Equity ETF',

    'CQS symbol': 'LCG',
    'NASDAQ symbol': 'LCG',
  },
  {
    symbol: 'LCI',
    'Security Name': 'Lannett Co  ',

    'CQS symbol': 'LCI',
    'NASDAQ symbol': 'LCI',
  },
  {
    symbol: 'LCII',
    'Security Name': 'LCI Industries',

    'CQS symbol': 'LCII',
    'NASDAQ symbol': 'LCII',
  },
  {
    symbol: 'LCNB',
    'Security Name': 'LCNB Corporation  ',

    'NASDAQ symbol': 'LCNB',
  },
  {
    symbol: 'LCR',
    'Security Name': 'Leuthold Core ETF',

    'CQS symbol': 'LCR',
    'NASDAQ symbol': 'LCR',
  },
  {
    symbol: 'LCTX',
    'Security Name': 'Lineage Cell Therapeutics,  ',

    'CQS symbol': 'LCTX',
    'NASDAQ symbol': 'LCTX',
  },
  {
    symbol: 'LCUT',
    'Security Name': 'Lifetime Brands,   ',

    'NASDAQ symbol': 'LCUT',
  },
  {
    symbol: 'LCY',
    'Security Name': 'Landcadia Holdings III,    ',

    'NASDAQ symbol': 'LCY',
  },
  {
    symbol: 'LCYAU',
    'Security Name': 'Landcadia Holdings III,   Unit',

    'NASDAQ symbol': 'LCYAU',
  },
  {
    symbol: 'LCYAW',
    'Security Name': 'Landcadia Holdings III,   Warrant',

    'NASDAQ symbol': 'LCYAW',
  },
  {
    symbol: 'LD',
    'Security Name': 'iPath Bloomberg Lead Subindex Total Return SM Index ETN',

    'CQS symbol': 'LD',
    'NASDAQ symbol': 'LD',
  },
  {
    symbol: 'LDEM',
    'Security Name': 'iShares ESG MSCI EM Leaders ETF',

    'NASDAQ symbol': 'LDEM',
  },
  {
    symbol: 'LDL',
    'Security Name': 'Lydall,  ',

    'CQS symbol': 'LDL',
    'NASDAQ symbol': 'LDL',
  },
  {
    symbol: 'LDOS',
    'Security Name': 'Leidos Holdings,  ',

    'CQS symbol': 'LDOS',
    'NASDAQ symbol': 'LDOS',
  },
  {
    symbol: 'LDP',
    'Security Name': 'Cohen & Steers Limited Duration Preferred and ome Fund, ',

    'CQS symbol': 'LDP',
    'NASDAQ symbol': 'LDP',
  },
  {
    symbol: 'LDRS',
    'Security Name': 'Innovator IBD ETF Leaders ETF',

    'CQS symbol': 'LDRS',
    'NASDAQ symbol': 'LDRS',
  },
  {
    symbol: 'LDSF',
    'Security Name': 'First Trust Low Duration Strategic Focus ETF',

    'NASDAQ symbol': 'LDSF',
  },
  {
    symbol: 'LDUR',
    'Security Name': 'PIMCO Enhanced Low Duration Active ExchangeTraded Fund',

    'CQS symbol': 'LDUR',
    'NASDAQ symbol': 'LDUR',
  },
  {
    symbol: 'LE',
    'Security Name': "Lands' End,   ",

    'NASDAQ symbol': 'LE',
  },
  {
    symbol: 'LEA',
    'Security Name': 'Lear Corporation ',

    'CQS symbol': 'LEA',
    'NASDAQ symbol': 'LEA',
  },
  {
    symbol: 'LEAD',
    'Security Name': 'Siren DIVCON Leaders Dividend ETF',

    'CQS symbol': 'LEAD',
    'NASDAQ symbol': 'LEAD',
  },
  {
    symbol: 'LEAF',
    'Security Name': 'Leaf Group Ltd ',

    'CQS symbol': 'LEAF',
    'NASDAQ symbol': 'LEAF',
  },
  {
    symbol: 'LEAP',
    'Security Name': 'Ribbit LEAP, Ltd  Ordinary Shares',

    'CQS symbol': 'LEAP',
    'NASDAQ symbol': 'LEAP',
  },
  {
    symbol: 'LEAPU',
    'Security Name':
      'Ribbit LEAP, Ltd Units, each consisting of one  Ordinary Share, and one fifth of one Warrant to acquire one  Ordinary Share',

    'CQS symbol': 'LEAPU',
    'NASDAQ symbol': 'LEAP=',
  },
  {
    symbol: 'LEAPW',
    'Security Name':
      'Ribbit LEAP, Ltd Warrants, each whole warrant exercisable for one  Ordinary Share at an exercise price of $1150',

    'CQS symbol': 'LEAPWS',
    'NASDAQ symbol': 'LEAP+',
  },
  {
    symbol: 'LECO',
    'Security Name': 'Loln Electric Holdings,   Common Shares',

    'NASDAQ symbol': 'LECO',
  },
  {
    symbol: 'LEDS',
    'Security Name': 'SemiLEDS Corporation  ',

    'NASDAQ symbol': 'LEDS',
  },
  {
    symbol: 'LEE',
    'Security Name': 'Lee Enterprises, orporated ',

    'CQS symbol': 'LEE',
    'NASDAQ symbol': 'LEE',
  },
  {
    symbol: 'LEG',
    'Security Name': 'Leggett & Platt, orporated ',

    'CQS symbol': 'LEG',
    'NASDAQ symbol': 'LEG',
  },
  {
    symbol: 'LEGH',
    'Security Name': 'Legacy Housing Corporation  ',

    'NASDAQ symbol': 'LEGH',
  },
  {
    symbol: 'LEGN',
    'Security Name': 'Legend Biotech Corporation  American Depositary Shares',

    'NASDAQ symbol': 'LEGN',
  },
  {
    symbol: 'LEGR',
    'Security Name': 'First Trust Indxx Innovative Transaction & Process ETF',

    'NASDAQ symbol': 'LEGR',
  },
  {
    symbol: 'LEJU',
    'Security Name':
      'Leju Holdings Limited American Depositary Shares, each representing one Ordinary share',

    'CQS symbol': 'LEJU',
    'NASDAQ symbol': 'LEJU',
  },
  {
    symbol: 'LEMB',
    'Security Name': 'iShares JP Morgan EM Local Currency Bond',

    'CQS symbol': 'LEMB',
    'NASDAQ symbol': 'LEMB',
  },
  {
    symbol: 'LEN',
    'Security Name': 'Lennar Corporation  ',

    'CQS symbol': 'LEN',
    'NASDAQ symbol': 'LEN',
  },
  {
    symbol: 'LENB',
    'Security Name': 'Lennar Corporation Class B',

    'CQS symbol': 'LENB',
    'NASDAQ symbol': 'LENB',
  },
  {
    symbol: 'LEND',
    'Security Name':
      'Amplify CrowdBureau Online Lending and Digital Banking ETF',

    'CQS symbol': 'LEND',
    'NASDAQ symbol': 'LEND',
  },
  {
    symbol: 'LEO',
    'Security Name': 'BNY Mellon Strategic Municipals,  ',

    'CQS symbol': 'LEO',
    'NASDAQ symbol': 'LEO',
  },
  {
    symbol: 'LESL',
    'Security Name': "Leslie's,   ",

    'NASDAQ symbol': 'LESL',
  },
  {
    symbol: 'LEU',
    'Security Name': 'Centrus Energy Corp  ',

    'CQS symbol': 'LEU',
    'NASDAQ symbol': 'LEU',
  },
  {
    symbol: 'LEVI',
    'Security Name': 'Levi Strauss & Co  ',

    'CQS symbol': 'LEVI',
    'NASDAQ symbol': 'LEVI',
  },
  {
    symbol: 'LEVL',
    'Security Name': 'Level One Bancorp,   ',

    'NASDAQ symbol': 'LEVL',
  },
  {
    symbol: 'LEVLP',
    'Security Name':
      'Level One Bancorp,   Depositary Shares, Each Representing a 1/100th Interest in a Share of 750% NonCumulative Perpetual Preferred Stock, Series B',

    'NASDAQ symbol': 'LEVLP',
  },
  {
    symbol: 'LFAC',
    'Security Name': 'LF Capital Acquistion Corp   ',

    'NASDAQ symbol': 'LFAC',
  },
  {
    symbol: 'LFACU',
    'Security Name': 'LF Capital Acquistion Corp  Unit',

    'NASDAQ symbol': 'LFACU',
  },
  {
    symbol: 'LFACW',
    'Security Name': 'LF Capital Acquistion Corp  Warrant',

    'NASDAQ symbol': 'LFACW',
  },
  {
    symbol: 'LFC',
    'Security Name':
      'China Life Insurance Company Limited American Depositary Shares',

    'CQS symbol': 'LFC',
    'NASDAQ symbol': 'LFC',
  },
  {
    symbol: 'LFEQ',
    'Security Name': 'VanEck Vectors Long/Flat Trend ETF',

    'CQS symbol': 'LFEQ',
    'NASDAQ symbol': 'LFEQ',
  },
  {
    symbol: 'LFTRU',
    'Security Name': 'Lefteris Acquisition Corp  Unit',

    'NASDAQ symbol': 'LFTRU',
  },
  {
    symbol: 'LFUS',
    'Security Name': 'Littelfuse,   ',

    'NASDAQ symbol': 'LFUS',
  },
  {
    symbol: 'LFVN',
    'Security Name': 'Lifevantage Corporation  ',

    'NASDAQ symbol': 'LFVN',
  },
  {
    symbol: 'LGFA',
    'Security Name': 'Lions Gate Entertainment Corporation  Voting Shares',

    'CQS symbol': 'LGFA',
    'NASDAQ symbol': 'LGFA',
  },
  {
    symbol: 'LGFB',
    'Security Name':
      'Lions Gate Entertainment Corporation Class B NonVoting Shares',

    'CQS symbol': 'LGFB',
    'NASDAQ symbol': 'LGFB',
  },
  {
    symbol: 'LGH',
    'Security Name': 'HCM Defender 500 Index ETF',

    'CQS symbol': 'LGH',
    'NASDAQ symbol': 'LGH',
  },
  {
    symbol: 'LGHL',
    'Security Name': 'Lion Group Holding Ltd  American Depositary Share',

    'NASDAQ symbol': 'LGHL',
  },
  {
    symbol: 'LGHLW',
    'Security Name': 'Lion Group Holding Ltd  Warrant',

    'NASDAQ symbol': 'LGHLW',
  },
  {
    symbol: 'LGI',
    'Security Name': 'Lazard Global Total Return and ome Fund ',

    'CQS symbol': 'LGI',
    'NASDAQ symbol': 'LGI',
  },
  {
    symbol: 'LGIH',
    'Security Name': 'LGI Homes,   ',

    'NASDAQ symbol': 'LGIH',
  },
  {
    symbol: 'LGL',
    'Security Name': 'LGL Group,  (The) ',

    'CQS symbol': 'LGL',
    'NASDAQ symbol': 'LGL',
  },
  {
    symbol: 'LGLW',
    'Security Name': 'LGL Group,  (The) Warrants',

    'CQS symbol': 'LGLWS',
    'NASDAQ symbol': 'LGL+',
  },
  {
    symbol: 'LGLV',
    'Security Name': 'SPDR SSGA US Large Cap Low Volatility Index ETF',

    'CQS symbol': 'LGLV',
    'NASDAQ symbol': 'LGLV',
  },
  {
    symbol: 'LGND',
    'Security Name': 'Ligand Pharmaceuticals orporated  ',

    'NASDAQ symbol': 'LGND',
  },
  {
    symbol: 'LGOV',
    'Security Name': 'First Trust Long Duration Opportunities ETF',

    'CQS symbol': 'LGOV',
    'NASDAQ symbol': 'LGOV',
  },
  {
    symbol: 'LGVW',
    'Security Name': 'Longview Acquisition Corp  ',

    'CQS symbol': 'LGVW',
    'NASDAQ symbol': 'LGVW',
  },
  {
    symbol: 'LGVWU',
    'Security Name':
      'Longview Acquisition Corp Units, each consisting of one share of  , and onethird of one warrant',

    'CQS symbol': 'LGVWU',
    'NASDAQ symbol': 'LGVW=',
  },
  {
    symbol: 'LGVWW',
    'Security Name':
      'Longview Acquisition Corp Redeemable Warrants, each whole warrant exercisable for one share of  , each at an exercise price of $1150 per share',

    'CQS symbol': 'LGVWWS',
    'NASDAQ symbol': 'LGVW+',
  },
  {
    symbol: 'LH',
    'Security Name': 'Laboratory Corporation of America Holdings ',

    'CQS symbol': 'LH',
    'NASDAQ symbol': 'LH',
  },
  {
    symbol: 'LHCG',
    'Security Name': 'LHC Group  ',

    'NASDAQ symbol': 'LHCG',
  },
  {
    symbol: 'LHX',
    'Security Name': 'L3Harris Technologies,  ',

    'CQS symbol': 'LHX',
    'NASDAQ symbol': 'LHX',
  },
  {
    symbol: 'LI',
    'Security Name': 'Li Auto   American Depositary Shares',

    'NASDAQ symbol': 'LI',
  },
  {
    symbol: 'LIFE',
    'Security Name': 'aTyr Pharma,   ',

    'NASDAQ symbol': 'LIFE',
  },
  {
    symbol: 'LII',
    'Security Name': 'Lennox International,  ',

    'CQS symbol': 'LII',
    'NASDAQ symbol': 'LII',
  },
  {
    symbol: 'LILA',
    'Security Name': 'Liberty Latin America Ltd   ',

    'NASDAQ symbol': 'LILA',
  },
  {
    symbol: 'LILAK',
    'Security Name': 'Liberty Latin America Ltd  Class C ',

    'NASDAQ symbol': 'LILAK',
  },
  {
    symbol: 'LIN',
    'Security Name': 'Linde plc Ordinary Share',

    'CQS symbol': 'LIN',
    'NASDAQ symbol': 'LIN',
  },
  {
    symbol: 'L',
    'Security Name': 'Loln Educational Services Corporation  ',

    'NASDAQ symbol': 'L',
  },
  {
    symbol: 'LIND',
    'Security Name': 'Lindblad Expeditions Holdings    ',

    'NASDAQ symbol': 'LIND',
  },
  {
    symbol: 'LINX',
    'Security Name':
      'Linx SA American Depositary Shares, each representing one common share',

    'CQS symbol': 'LINX',
    'NASDAQ symbol': 'LINX',
  },
  {
    symbol: 'LIQT',
    'Security Name': 'LiqTech International,   ',

    'NASDAQ symbol': 'LIQT',
  },
  {
    symbol: 'LIT',
    'Security Name': 'Global X Lithium & Battery Tech ETF',

    'CQS symbol': 'LIT',
    'NASDAQ symbol': 'LIT',
  },
  {
    symbol: 'LITB',
    'Security Name':
      'LightInTheBox Holding Co, Ltd American Depositary Shares, each representing 2 ordinary shares',

    'CQS symbol': 'LITB',
    'NASDAQ symbol': 'LITB',
  },
  {
    symbol: 'LITE',
    'Security Name': 'Lumentum Holdings   ',

    'NASDAQ symbol': 'LITE',
  },
  {
    symbol: 'LIV',
    'Security Name': 'Emles @Home ETF',

    'CQS symbol': 'LIV',
    'NASDAQ symbol': 'LIV',
  },
  {
    symbol: 'LIVE',
    'Security Name': 'Live Ventures orporated  ',

    'NASDAQ symbol': 'LIVE',
  },
  {
    symbol: 'LIVK',
    'Security Name': 'LIV Capital Acquisition Corp   Ordinary Shares',

    'NASDAQ symbol': 'LIVK',
  },
  {
    symbol: 'LIVKU',
    'Security Name': 'LIV Capital Acquisition Corp  Unit',

    'NASDAQ symbol': 'LIVKU',
  },
  {
    symbol: 'LIVKW',
    'Security Name': 'LIV Capital Acquisition Corp  Warrant',

    'NASDAQ symbol': 'LIVKW',
  },
  {
    symbol: 'LIVN',
    'Security Name': 'LivaNova PLC  Ordinary Shares',

    'NASDAQ symbol': 'LIVN',
  },
  {
    symbol: 'LIVX',
    'Security Name': 'LiveXLive Media,   ',

    'NASDAQ symbol': 'LIVX',
  },
  {
    symbol: 'LIXT',
    'Security Name': 'Lixte Biotechnology Holdings,   ',

    'NASDAQ symbol': 'LIXT',
  },
  {
    symbol: 'LIXTW',
    'Security Name': 'Lixte Biotechnology Holdings,   Warrants',

    'NASDAQ symbol': 'LIXTW',
  },
  {
    symbol: 'LIZI',
    'Security Name': 'LIZHI   American Depositary Shares',

    'NASDAQ symbol': 'LIZI',
  },
  {
    symbol: 'LJPC',
    'Security Name': 'La Jolla Pharmaceutical Company  ',

    'NASDAQ symbol': 'LJPC',
  },
  {
    symbol: 'LKCO',
    'Security Name': 'Luokung Technology Corp  Ordinary Shares',

    'NASDAQ symbol': 'LKCO',
  },
  {
    symbol: 'LKFN',
    'Security Name': 'Lakeland Financial Corporation  ',

    'NASDAQ symbol': 'LKFN',
  },
  {
    symbol: 'LKOR',
    'Security Name':
      'FlexShares Trust FlexShares CreditScored US Long Corporate Bond Index Fund',

    'CQS symbol': 'LKOR',
    'NASDAQ symbol': 'LKOR',
  },
  {
    symbol: 'LKQ',
    'Security Name': 'LKQ Corporation  ',

    'NASDAQ symbol': 'LKQ',
  },
  {
    symbol: 'LL',
    'Security Name': 'Lumber Liquidators Holdings,  ',

    'CQS symbol': 'LL',
    'NASDAQ symbol': 'LL',
  },
  {
    symbol: 'LLIT',
    'Security Name': 'Lianluo Smart Limited   ',

    'NASDAQ symbol': 'LLIT',
  },
  {
    symbol: 'LLNW',
    'Security Name': 'Limelight Networks,   ',

    'NASDAQ symbol': 'LLNW',
  },
  {
    symbol: 'LLY',
    'Security Name': 'Eli Lilly and Company ',

    'CQS symbol': 'LLY',
    'NASDAQ symbol': 'LLY',
  },
  {
    symbol: 'LMAT',
    'Security Name': 'LeMaitre Vascular,   ',

    'NASDAQ symbol': 'LMAT',
  },
  {
    symbol: 'LMB',
    'Security Name': 'Limbach Holdings,   ',

    'NASDAQ symbol': 'LMB',
  },
  {
    symbol: 'LMBS',
    'Security Name': 'First Trust Low Duration Opportunities ETF',

    'NASDAQ symbol': 'LMBS',
  },
  {
    symbol: 'LMFA',
    'Security Name': 'LM Funding America,   ',

    'NASDAQ symbol': 'LMFA',
  },
  {
    symbol: 'LMLB',
    'Security Name':
      'ETRACS Monthly Pay 2xLeveraged Wells Fargo MLP ExEnergy ETN Series B due June 24, 2044',

    'CQS symbol': 'LMLB',
    'NASDAQ symbol': 'LMLB',
  },
  {
    symbol: 'LMND',
    'Security Name': 'Lemonade,  ',

    'CQS symbol': 'LMND',
    'NASDAQ symbol': 'LMND',
  },
  {
    symbol: 'LMNL',
    'Security Name': 'Liminal BioSciences   Common Shares',

    'NASDAQ symbol': 'LMNL',
  },
  {
    symbol: 'LMNR',
    'Security Name': 'Limoneira Co  ',

    'NASDAQ symbol': 'LMNR',
  },
  {
    symbol: 'LMNX',
    'Security Name': 'Luminex Corporation  ',

    'NASDAQ symbol': 'LMNX',
  },
  {
    symbol: 'LMPX',
    'Security Name': 'LMP Automotive Holdings,   ',

    'NASDAQ symbol': 'LMPX',
  },
  {
    symbol: 'LMRK',
    'Security Name': 'Landmark Infrastructure Partners LP  Common Units',

    'NASDAQ symbol': 'LMRK',
  },
  {
    symbol: 'LMRKN',
    'Security Name': 'Landmark Infrastructure Partners LP  Preferred Stock',

    'NASDAQ symbol': 'LMRKN',
  },
  {
    symbol: 'LMRKO',
    'Security Name': 'Landmark Infrastructure Partners LP  Preferred Units',

    'NASDAQ symbol': 'LMRKO',
  },
  {
    symbol: 'LMRKP',
    'Security Name':
      'Landmark Infrastructure Partners LP  800% Series A Cumulative Redeemable Perpetual Preferred Units',

    'NASDAQ symbol': 'LMRKP',
  },
  {
    symbol: 'LMST',
    'Security Name': 'Limestone Bancorp,   ',

    'NASDAQ symbol': 'LMST',
  },
  {
    symbol: 'LMT',
    'Security Name': 'Lockheed Martin Corporation ',

    'CQS symbol': 'LMT',
    'NASDAQ symbol': 'LMT',
  },
  {
    symbol: 'LN',
    'Security Name':
      'LINE Corporation American Depositary Shares (each representing one share of )',

    'CQS symbol': 'LN',
    'NASDAQ symbol': 'LN',
  },
  {
    symbol: 'LNC',
    'Security Name': 'Loln National Corporation ',

    'CQS symbol': 'LNC',
    'NASDAQ symbol': 'LNC',
  },
  {
    symbol: 'LND',
    'Security Name':
      'Brasilagro Brazilian Agric Real Estate Co Sponsored ADR (Brazil)',

    'CQS symbol': 'LND',
    'NASDAQ symbol': 'LND',
  },
  {
    symbol: 'LNDC',
    'Security Name': 'Landec Corporation  ',

    'NASDAQ symbol': 'LNDC',
  },
  {
    symbol: 'LNFAU',
    'Security Name':
      'L&amp;F Acquisition Corp Units, each consisting of one  ordinary share, and onehalf of one redeemable warrant',

    'CQS symbol': 'LNFAU',
    'NASDAQ symbol': 'LNFA=',
  },
  {
    symbol: 'LNG',
    'Security Name': 'Cheniere Energy,  ',

    'CQS symbol': 'LNG',
    'NASDAQ symbol': 'LNG',
  },
  {
    symbol: 'LNGR',
    'Security Name': 'Global X Longevity Thematic ETF',

    'NASDAQ symbol': 'LNGR',
  },
  {
    symbol: 'LNN',
    'Security Name': 'Lindsay Corporation ',

    'CQS symbol': 'LNN',
    'NASDAQ symbol': 'LNN',
  },
  {
    symbol: 'LNSR',
    'Security Name': 'LENSAR,   ',

    'NASDAQ symbol': 'LNSR',
  },
  {
    symbol: 'LNT',
    'Security Name': 'Alliant Energy Corporation  ',

    'NASDAQ symbol': 'LNT',
  },
  {
    symbol: 'LNTH',
    'Security Name': 'Lantheus Holdings,   ',

    'NASDAQ symbol': 'LNTH',
  },
  {
    symbol: 'LOAC',
    'Security Name': 'Longevity Acquisition Corporation  Ordinary Shares',

    'NASDAQ symbol': 'LOAC',
  },
  {
    symbol: 'LOACR',
    'Security Name': 'Longevity Acquisition Corporation  Right',

    'NASDAQ symbol': 'LOACR',
  },
  {
    symbol: 'LOACU',
    'Security Name': 'Longevity Acquisition Corporation  Units',

    'NASDAQ symbol': 'LOACU',
  },
  {
    symbol: 'LOACW',
    'Security Name': 'Longevity Acquisition Corporation  Warrant',

    'NASDAQ symbol': 'LOACW',
  },
  {
    symbol: 'LOAK',
    'Security Name': 'Live Oak Acquisition Corp ',

    'CQS symbol': 'LOAK',
    'NASDAQ symbol': 'LOAK',
  },
  {
    symbol: 'LOAKU',
    'Security Name':
      'Live Oak Acquisition Corp Units, each consisting of one share of  and threefourths of one Redeemable Warrant to purchase one share of ',

    'CQS symbol': 'LOAKU',
    'NASDAQ symbol': 'LOAK=',
  },
  {
    symbol: 'LOAKW',
    'Security Name':
      'Live Oak Acquisition Corp Redeemable Warrants, each whole warrant exercisable for one share of   at an exercise price of $1150',

    'CQS symbol': 'LOAKWS',
    'NASDAQ symbol': 'LOAK+',
  },
  {
    symbol: 'LOAN',
    'Security Name': 'Manhattan Bridge Capital,   ',

    'NASDAQ symbol': 'LOAN',
  },
  {
    symbol: 'LOB',
    'Security Name': 'Live Oak Bancshares,   ',

    'NASDAQ symbol': 'LOB',
  },
  {
    symbol: 'LOCO',
    'Security Name': 'El Pollo Loco Holdings,   ',

    'NASDAQ symbol': 'LOCO',
  },
  {
    symbol: 'LODE',
    'Security Name': 'Comstock Mining,  ',

    'CQS symbol': 'LODE',
    'NASDAQ symbol': 'LODE',
  },
  {
    symbol: 'LOGC',
    'Security Name': 'LogicBio Therapeutics,   ',

    'NASDAQ symbol': 'LOGC',
  },
  {
    symbol: 'LOGI',
    'Security Name': 'Logitech International SA  Registered Shares',

    'NASDAQ symbol': 'LOGI',
  },
  {
    symbol: 'LOKBU',
    'Security Name':
      'Live Oak Acquisition Corp II Units, each consisting of one share of   and onethird of one redeemable warrant',

    'CQS symbol': 'LOKBU',
    'NASDAQ symbol': 'LOKB=',
  },
  {
    symbol: 'LOMA',
    'Security Name':
      'Loma Negra Compania Industrial Argentina Sociedad Anonima ADS',

    'CQS symbol': 'LOMA',
    'NASDAQ symbol': 'LOMA',
  },
  {
    symbol: 'LOOP',
    'Security Name': 'Loop Industries,   ',

    'NASDAQ symbol': 'LOOP',
  },
  {
    symbol: 'LOPE',
    'Security Name': 'Grand Canyon Education,   ',

    'NASDAQ symbol': 'LOPE',
  },
  {
    symbol: 'LORL',
    'Security Name': 'Loral Space and Communications,   ',

    'NASDAQ symbol': 'LORL',
  },
  {
    symbol: 'LOUP',
    'Security Name': 'Innovator Loup Frontier Tech E',

    'CQS symbol': 'LOUP',
    'NASDAQ symbol': 'LOUP',
  },
  {
    symbol: 'LOV',
    'Security Name':
      'Spark Networks,  American Depositary Shares (each representing onetenth of an Ordinary Share)',

    'CQS symbol': 'LOV',
    'NASDAQ symbol': 'LOV',
  },
  {
    symbol: 'LOVE',
    'Security Name': 'The Lovesac Company  ',

    'NASDAQ symbol': 'LOVE',
  },
  {
    symbol: 'LOW',
    'Security Name': "Lowe's Companies,  ",

    'CQS symbol': 'LOW',
    'NASDAQ symbol': 'LOW',
  },
  {
    symbol: 'LOWC',
    'Security Name': 'SPDR MSCI ACWI Low Carbon Target ETF',

    'CQS symbol': 'LOWC',
    'NASDAQ symbol': 'LOWC',
  },
  {
    symbol: 'LPCN',
    'Security Name': 'Lipocine   ',

    'NASDAQ symbol': 'LPCN',
  },
  {
    symbol: 'LPG',
    'Security Name': 'Dorian LPG Ltd ',

    'CQS symbol': 'LPG',
    'NASDAQ symbol': 'LPG',
  },
  {
    symbol: 'LPI',
    'Security Name': 'Laredo Petroleum,  ',

    'CQS symbol': 'LPI',
    'NASDAQ symbol': 'LPI',
  },
  {
    symbol: 'LPL',
    'Security Name': 'LG Display Co, Ltd AMERICAN ',

    'CQS symbol': 'LPL',
    'NASDAQ symbol': 'LPL',
  },
  {
    symbol: 'LPLA',
    'Security Name': 'LPL Financial Holdings   ',

    'NASDAQ symbol': 'LPLA',
  },
  {
    symbol: 'LPRO',
    'Security Name': 'Open Lending Corporation   ',

    'NASDAQ symbol': 'LPRO',
  },
  {
    symbol: 'LPSN',
    'Security Name': 'LivePerson,   ',

    'NASDAQ symbol': 'LPSN',
  },
  {
    symbol: 'LPTH',
    'Security Name': 'LightPath Technologies,    ',

    'NASDAQ symbol': 'LPTH',
  },
  {
    symbol: 'LPTX',
    'Security Name': 'Leap Therapeutics,   ',

    'NASDAQ symbol': 'LPTX',
  },
  {
    symbol: 'LPX',
    'Security Name': 'LouisianaPacific Corporation ',

    'CQS symbol': 'LPX',
    'NASDAQ symbol': 'LPX',
  },
  {
    symbol: 'LQD',
    'Security Name': 'iShares iBoxx $ Investment Grade Corporate Bond ETF',

    'CQS symbol': 'LQD',
    'NASDAQ symbol': 'LQD',
  },
  {
    symbol: 'LQDA',
    'Security Name': 'Liquidia Corporation  ',

    'NASDAQ symbol': 'LQDA',
  },
  {
    symbol: 'LQDH',
    'Security Name': 'iShares Interest Rate Hedged Corporate Bond ETF',

    'CQS symbol': 'LQDH',
    'NASDAQ symbol': 'LQDH',
  },
  {
    symbol: 'LQDI',
    'Security Name': 'iShares Inflation Hedged Corporate Bond ETF',

    'CQS symbol': 'LQDI',
    'NASDAQ symbol': 'LQDI',
  },
  {
    symbol: 'LQDT',
    'Security Name': 'Liquidity Services,   ',

    'NASDAQ symbol': 'LQDT',
  },
  {
    symbol: 'LRCX',
    'Security Name': 'Lam Research Corporation  ',

    'NASDAQ symbol': 'LRCX',
  },
  {
    symbol: 'LRGE',
    'Security Name': 'ClearBridge Large Cap Growth ESG ETF',

    'NASDAQ symbol': 'LRGE',
  },
  {
    symbol: 'LRGF',
    'Security Name': 'iShares MSCI USA Multifactor ETF',

    'CQS symbol': 'LRGF',
    'NASDAQ symbol': 'LRGF',
  },
  {
    symbol: 'LRMR',
    'Security Name': 'Larimar Therapeutics,   ',

    'NASDAQ symbol': 'LRMR',
  },
  {
    symbol: 'LRN',
    'Security Name': 'K12  ',

    'CQS symbol': 'LRN',
    'NASDAQ symbol': 'LRN',
  },
  {
    symbol: 'LRNZ',
    'Security Name': 'TrueShares Technology, AI & Deep Learning ETF',

    'CQS symbol': 'LRNZ',
    'NASDAQ symbol': 'LRNZ',
  },
  {
    symbol: 'LSAC',
    'Security Name': 'LifeSci Acquisition Corp  ',

    'NASDAQ symbol': 'LSAC',
  },
  {
    symbol: 'LSACU',
    'Security Name': 'LifeSci Acquisition Corp  Unit 1 COM & 1 WT',

    'NASDAQ symbol': 'LSACU',
  },
  {
    symbol: 'LSACW',
    'Security Name': 'LifeSci Acquisition Corp  Warrant',

    'NASDAQ symbol': 'LSACW',
  },
  {
    symbol: 'LSAF',
    'Security Name': 'LeaderShares AlphaFactor US Core Equity ETF',

    'CQS symbol': 'LSAF',
    'NASDAQ symbol': 'LSAF',
  },
  {
    symbol: 'LSAQ',
    'Security Name': 'LifeSci Acquisition II Corp  ',

    'NASDAQ symbol': 'LSAQ',
  },
  {
    symbol: 'LSAT',
    'Security Name': 'LeaderShares AlphaFactor Tactical Focused ETF',

    'CQS symbol': 'LSAT',
    'NASDAQ symbol': 'LSAT',
  },
  {
    symbol: 'LSBK',
    'Security Name': 'Lake Shore Bancorp,   ',

    'NASDAQ symbol': 'LSBK',
  },
  {
    symbol: 'LSCC',
    'Security Name': 'Lattice Semiconductor Corporation  ',

    'NASDAQ symbol': 'LSCC',
  },
  {
    symbol: 'LSF',
    'Security Name': 'Laird Superfood,  ',

    'CQS symbol': 'LSF',
    'NASDAQ symbol': 'LSF',
  },
  {
    symbol: 'LSI',
    'Security Name': 'Life Storage,  ',

    'CQS symbol': 'LSI',
    'NASDAQ symbol': 'LSI',
  },
  {
    symbol: 'LSLT',
    'Security Name': 'Pacer Salt Low truBeta US Market ETF',

    'CQS symbol': 'LSLT',
    'NASDAQ symbol': 'LSLT',
  },
  {
    symbol: 'LSPD',
    'Security Name': 'Lightspeed POS  Subordinate Voting Shares',

    'CQS symbol': 'LSPD',
    'NASDAQ symbol': 'LSPD',
  },
  {
    symbol: 'LSST',
    'Security Name':
      'Natixis ETF Trust Natixis Loomis Sayles Short Duration ome ETF',

    'CQS symbol': 'LSST',
    'NASDAQ symbol': 'LSST',
  },
  {
    symbol: 'LSTR',
    'Security Name': 'Landstar System,   ',

    'NASDAQ symbol': 'LSTR',
  },
  {
    symbol: 'LSXMA',
    'Security Name': 'Liberty Media Corporation  Series A Liberty SiriusXM ',

    'NASDAQ symbol': 'LSXMA',
  },
  {
    symbol: 'LSXMB',
    'Security Name': 'Liberty Media Corporation  Series B Liberty SiriusXM ',

    'NASDAQ symbol': 'LSXMB',
  },
  {
    symbol: 'LSXMK',
    'Security Name': 'Liberty Media Corporation  Series C Liberty SiriusXM ',

    'NASDAQ symbol': 'LSXMK',
  },
  {
    symbol: 'LTBR',
    'Security Name': 'Lightbridge Corporation  ',

    'NASDAQ symbol': 'LTBR',
  },
  {
    symbol: 'LTC',
    'Security Name': 'LTC Properties,  ',

    'CQS symbol': 'LTC',
    'NASDAQ symbol': 'LTC',
  },
  {
    symbol: 'LTHM',
    'Security Name': 'Livent Corporation ',

    'CQS symbol': 'LTHM',
    'NASDAQ symbol': 'LTHM',
  },
  {
    symbol: 'LTL',
    'Security Name': 'ProShares Ultra Telecommunications ProShares',

    'CQS symbol': 'LTL',
    'NASDAQ symbol': 'LTL',
  },
  {
    symbol: 'LTPZ',
    'Security Name': 'Pimco 15  Year US TIPS Index ExchangeTraded Fund',

    'CQS symbol': 'LTPZ',
    'NASDAQ symbol': 'LTPZ',
  },
  {
    symbol: 'LTRN',
    'Security Name': 'Lantern Pharma   ',

    'NASDAQ symbol': 'LTRN',
  },
  {
    symbol: 'LTRPA',
    'Security Name': 'Liberty TripAdvisor Holdings,   Series A ',

    'NASDAQ symbol': 'LTRPA',
  },
  {
    symbol: 'LTRPB',
    'Security Name': 'Liberty TripAdvisor Holdings,   Series B ',

    'NASDAQ symbol': 'LTRPB',
  },
  {
    symbol: 'LTRX',
    'Security Name': 'Lantronix,   ',

    'NASDAQ symbol': 'LTRX',
  },
  {
    symbol: 'LU',
    'Security Name':
      'Lufax Holding Ltd American Depositary Shares, two of which representing one Ordinary Share',

    'CQS symbol': 'LU',
    'NASDAQ symbol': 'LU',
  },
  {
    symbol: 'LUB',
    'Security Name': "Luby's,  ",

    'CQS symbol': 'LUB',
    'NASDAQ symbol': 'LUB',
  },
  {
    symbol: 'LULU',
    'Security Name': 'lululemon athletica   ',

    'NASDAQ symbol': 'LULU',
  },
  {
    symbol: 'LUMN',
    'Security Name': 'CenturyLink,  d/b/a Lumen Technologies,  ',

    'CQS symbol': 'LUMN',
    'NASDAQ symbol': 'LUMN',
  },
  {
    symbol: 'LUMO',
    'Security Name': 'Lumos Pharma,   ',

    'NASDAQ symbol': 'LUMO',
  },
  {
    symbol: 'LUNA',
    'Security Name': 'Luna Innovations orporated  ',

    'NASDAQ symbol': 'LUNA',
  },
  {
    symbol: 'LUNG',
    'Security Name': 'Pulmonx Corporation  ',

    'NASDAQ symbol': 'LUNG',
  },
  {
    symbol: 'LUV',
    'Security Name': 'Southwest Airlines Company ',

    'CQS symbol': 'LUV',
    'NASDAQ symbol': 'LUV',
  },
  {
    symbol: 'LUXAU',
    'Security Name': 'Lux Health Tech Acquisition Corp  Units',

    'NASDAQ symbol': 'LUXAU',
  },
  {
    symbol: 'LUXE',
    'Security Name': 'Emles Trust Emles Luxury Goods ETF',

    'CQS symbol': 'LUXE',
    'NASDAQ symbol': 'LUXE',
  },
  {
    symbol: 'LVHD',
    'Security Name': 'Legg Mason Low Volatility High Dividend ETF',

    'NASDAQ symbol': 'LVHD',
  },
  {
    symbol: 'LVHI',
    'Security Name':
      'Legg Mason International Low Volatility High Dividend ETF',

    'CQS symbol': 'LVHI',
    'NASDAQ symbol': 'LVHI',
  },
  {
    symbol: 'LVS',
    'Security Name': 'Las Vegas Sands Corp ',

    'CQS symbol': 'LVS',
    'NASDAQ symbol': 'LVS',
  },
  {
    symbol: 'LW',
    'Security Name': 'Lamb Weston Holdings,   ',

    'CQS symbol': 'LW',
    'NASDAQ symbol': 'LW',
  },
  {
    symbol: 'LWAY',
    'Security Name': 'Lifeway Foods,   ',

    'NASDAQ symbol': 'LWAY',
  },
  {
    symbol: 'LX',
    'Security Name': 'LexinFintech Holdings Ltd  American Depositary Shares',

    'NASDAQ symbol': 'LX',
  },
  {
    symbol: 'LXEH',
    'Security Name':
      'Lixiang Education Holding Co, Ltd  American Depositary Shares',

    'NASDAQ symbol': 'LXEH',
  },
  {
    symbol: 'LXFR',
    'Security Name': 'Luxfer Holdings PLC Ordinary Shares',

    'CQS symbol': 'LXFR',
    'NASDAQ symbol': 'LXFR',
  },
  {
    symbol: 'LXP',
    'Security Name': 'Lexington Realty Trust ',

    'CQS symbol': 'LXP',
    'NASDAQ symbol': 'LXP',
  },
  {
    symbol: 'LXP$C',
    'Security Name': 'Lexington Realty Trust  Preferred Conv Series C',

    'CQS symbol': 'LXPpC',
    'NASDAQ symbol': 'LXPC',
  },
  {
    symbol: 'LXRX',
    'Security Name': 'Lexicon Pharmaceuticals,   ',

    'NASDAQ symbol': 'LXRX',
  },
  {
    symbol: 'LXU',
    'Security Name': 'LSB Industries,  ',

    'CQS symbol': 'LXU',
    'NASDAQ symbol': 'LXU',
  },
  {
    symbol: 'LYB',
    'Security Name':
      'LyondellBasell Industries NV Ordinary Shares  (Netherlands)',

    'CQS symbol': 'LYB',
    'NASDAQ symbol': 'LYB',
  },
  {
    symbol: 'LYFE',
    'Security Name': '2ndVote Life Neutral Plus ETF',

    'CQS symbol': 'LYFE',
    'NASDAQ symbol': 'LYFE',
  },
  {
    symbol: 'LYFT',
    'Security Name': 'Lyft,    ',

    'NASDAQ symbol': 'LYFT',
  },
  {
    symbol: 'LYG',
    'Security Name': 'Lloyds Banking Group Plc American Depositary Shares',

    'CQS symbol': 'LYG',
    'NASDAQ symbol': 'LYG',
  },
  {
    symbol: 'LYL',
    'Security Name': 'Dragon Victory International Limited  Ordinary Shares',

    'NASDAQ symbol': 'LYL',
  },
  {
    symbol: 'LYRA',
    'Security Name': 'Lyra Therapeutics,   ',

    'NASDAQ symbol': 'LYRA',
  },
  {
    symbol: 'LYTS',
    'Security Name': 'LSI Industries   ',

    'NASDAQ symbol': 'LYTS',
  },
  {
    symbol: 'LYV',
    'Security Name': 'Live Nation Entertainment,  ',

    'CQS symbol': 'LYV',
    'NASDAQ symbol': 'LYV',
  },
  {
    symbol: 'LZB',
    'Security Name': 'LaZBoy orporated ',

    'CQS symbol': 'LZB',
    'NASDAQ symbol': 'LZB',
  },
  {
    symbol: 'M',
    'Security Name': "Macy's  ",

    'CQS symbol': 'M',
    'NASDAQ symbol': 'M',
  },
  {
    symbol: 'MA',
    'Security Name': 'Mastercard orporated ',

    'CQS symbol': 'MA',
    'NASDAQ symbol': 'MA',
  },
  {
    symbol: 'MAA',
    'Security Name': 'MidAmerica Apartment Communities,  ',

    'CQS symbol': 'MAA',
    'NASDAQ symbol': 'MAA',
  },
  {
    symbol: 'MAA$I',
    'Security Name':
      'MidAmerica Apartment Communities,  850% Series I Cumulative Redeemable Preferred Stock',

    'CQS symbol': 'MAApI',
    'NASDAQ symbol': 'MAAI',
  },
  {
    symbol: 'MAAC',
    'Security Name': 'Montes Archimedes Acquisition Corp   ',

    'NASDAQ symbol': 'MAAC',
  },
  {
    symbol: 'MAACU',
    'Security Name': 'Montes Archimedes Acquisition Corp  Unit',

    'NASDAQ symbol': 'MAACU',
  },
  {
    symbol: 'MAACW',
    'Security Name': 'Montes Archimedes Acquisition Corp  Warrant',

    'NASDAQ symbol': 'MAACW',
  },
  {
    symbol: 'MAAX',
    'Security Name':
      'VanEck Vectors ETF Trust VanEck Vectors Muni Allocation ETF',

    'CQS symbol': 'MAAX',
    'NASDAQ symbol': 'MAAX',
  },
  {
    symbol: 'MAC',
    'Security Name': 'Macerich Company (The) ',

    'CQS symbol': 'MAC',
    'NASDAQ symbol': 'MAC',
  },
  {
    symbol: 'MACK',
    'Security Name': 'Merrimack Pharmaceuticals,   ',

    'NASDAQ symbol': 'MACK',
  },
  {
    symbol: 'MACU',
    'Security Name': 'Mallard Acquisition Corp  ',

    'NASDAQ symbol': 'MACU',
  },
  {
    symbol: 'MACUU',
    'Security Name': 'Mallard Acquisition Corp  Unit',

    'NASDAQ symbol': 'MACUU',
  },
  {
    symbol: 'MACUW',
    'Security Name': 'Mallard Acquisition Corp  Warrant',

    'NASDAQ symbol': 'MACUW',
  },
  {
    symbol: 'MAG',
    'Security Name': 'MAG Silver Corporation Ordinary Shares',

    'CQS symbol': 'MAG',
    'NASDAQ symbol': 'MAG',
  },
  {
    symbol: 'MAGA',
    'Security Name': 'Point Bridge GOP Stock Tracker ETF',

    'CQS symbol': 'MAGA',
    'NASDAQ symbol': 'MAGA',
  },
  {
    symbol: 'MAGS',
    'Security Name': 'Magal Security Systems Ltd  Ordinary Shares',

    'NASDAQ symbol': 'MAGS',
  },
  {
    symbol: 'MAIN',
    'Security Name': 'Main Street Capital Corporation ',

    'CQS symbol': 'MAIN',
    'NASDAQ symbol': 'MAIN',
  },
  {
    symbol: 'MAN',
    'Security Name': 'ManpowerGroup ',

    'CQS symbol': 'MAN',
    'NASDAQ symbol': 'MAN',
  },
  {
    symbol: 'MANH',
    'Security Name': 'Manhattan Associates,   ',

    'NASDAQ symbol': 'MANH',
  },
  {
    symbol: 'MANT',
    'Security Name': 'ManTech International Corporation   ',

    'NASDAQ symbol': 'MANT',
  },
  {
    symbol: 'MANU',
    'Security Name': 'Manchester United Ltd  Ordinary Shares',

    'CQS symbol': 'MANU',
    'NASDAQ symbol': 'MANU',
  },
  {
    symbol: 'MAR',
    'Security Name': 'Marriott International   ',

    'NASDAQ symbol': 'MAR',
  },
  {
    symbol: 'MARA',
    'Security Name': 'Marathon Patent Group,   ',

    'NASDAQ symbol': 'MARA',
  },
  {
    symbol: 'MARB',
    'Security Name': 'First Trust Merger Arbitrage ETF',

    'CQS symbol': 'MARB',
    'NASDAQ symbol': 'MARB',
  },
  {
    symbol: 'MARK',
    'Security Name': 'Remark Holdings,   ',

    'NASDAQ symbol': 'MARK',
  },
  {
    symbol: 'MARPS',
    'Security Name': 'Marine Petroleum Trust  Units of Beneficial Interest',

    'NASDAQ symbol': 'MARPS',
  },
  {
    symbol: 'MAS',
    'Security Name': 'Masco Corporation ',

    'CQS symbol': 'MAS',
    'NASDAQ symbol': 'MAS',
  },
  {
    symbol: 'MASI',
    'Security Name': 'Masimo Corporation  ',

    'NASDAQ symbol': 'MASI',
  },
  {
    symbol: 'MAT',
    'Security Name': 'Mattel,   ',

    'NASDAQ symbol': 'MAT',
  },
  {
    symbol: 'MATW',
    'Security Name': 'Matthews International Corporation   ',

    'NASDAQ symbol': 'MATW',
  },
  {
    symbol: 'MATX',
    'Security Name': 'Matson,  ',

    'CQS symbol': 'MATX',
    'NASDAQ symbol': 'MATX',
  },
  {
    symbol: 'MAV',
    'Security Name':
      'Pioneer Municipal High ome Advantage Trust Common Shares of Beneficial Interest',

    'CQS symbol': 'MAV',
    'NASDAQ symbol': 'MAV',
  },
  {
    symbol: 'MAX',
    'Security Name': 'MediaAlpha,   ',

    'CQS symbol': 'MAX',
    'NASDAQ symbol': 'MAX',
  },
  {
    symbol: 'MAXN',
    'Security Name': 'Maxeon Solar Technologies, Ltd  Ordinary Shares',

    'NASDAQ symbol': 'MAXN',
  },
  {
    symbol: 'MAXR',
    'Security Name': 'Maxar Technologies ',

    'CQS symbol': 'MAXR',
    'NASDAQ symbol': 'MAXR',
  },
  {
    symbol: 'MAYS',
    'Security Name': 'J W Mays,   ',

    'NASDAQ symbol': 'MAYS',
  },
  {
    symbol: 'MBB',
    'Security Name': 'iShares MBS ETF',

    'NASDAQ symbol': 'MBB',
  },
  {
    symbol: 'MBBB',
    'Security Name': "VanEck Vectors Moody's Analytics BBB Corporate Bond ETF",

    'CQS symbol': 'MBBB',
    'NASDAQ symbol': 'MBBB',
  },
  {
    symbol: 'MBCN',
    'Security Name': 'Middlefield Banc Corp  ',

    'NASDAQ symbol': 'MBCN',
  },
  {
    symbol: 'MBI',
    'Security Name': 'MBIA  ',

    'CQS symbol': 'MBI',
    'NASDAQ symbol': 'MBI',
  },
  {
    symbol: 'MBII',
    'Security Name': 'Marrone Bio Innovations,   ',

    'NASDAQ symbol': 'MBII',
  },
  {
    symbol: 'MBIN',
    'Security Name': 'Merchants Bancorp  ',

    'NASDAQ symbol': 'MBIN',
  },
  {
    symbol: 'MBINO',
    'Security Name':
      'Merchants Bancorp  Depositary Shares Each Representing a 1/40th Interest in a Share of Series B FixedtoFloating Rate',

    'NASDAQ symbol': 'MBINO',
  },
  {
    symbol: 'MBINP',
    'Security Name':
      'Merchants Bancorp  700% FixedtoFloating Rate Series A NonCumulative Perpetual Preferred Stock',

    'NASDAQ symbol': 'MBINP',
  },
  {
    symbol: 'MBIO',
    'Security Name': 'Mustang Bio,   ',

    'NASDAQ symbol': 'MBIO',
  },
  {
    symbol: 'MBNKP',
    'Security Name':
      'Medallion Bank  FixedtoFloating Rate NonCumulative Perpetual Preferred Stock, Series F',

    'NASDAQ symbol': 'MBNKP',
  },
  {
    symbol: 'MBOT',
    'Security Name': 'Microbot Medical    ',

    'NASDAQ symbol': 'MBOT',
  },
  {
    symbol: 'MBRX',
    'Security Name': 'Moleculin Biotech,   ',

    'NASDAQ symbol': 'MBRX',
  },
  {
    symbol: 'MBSD',
    'Security Name':
      'FlexShares Trust FlexShares Disciplined Duration MBS Index Fund',

    'CQS symbol': 'MBSD',
    'NASDAQ symbol': 'MBSD',
  },
  {
    symbol: 'MBT',
    'Security Name': 'Mobile TeleSystems PJSC',

    'CQS symbol': 'MBT',
    'NASDAQ symbol': 'MBT',
  },
  {
    symbol: 'MBUU',
    'Security Name': 'Malibu Boats,   ',

    'NASDAQ symbol': 'MBUU',
  },
  {
    symbol: 'MBWM',
    'Security Name': 'Mercantile Bank Corporation  ',

    'NASDAQ symbol': 'MBWM',
  },
  {
    symbol: 'MC',
    'Security Name': 'Moelis & Company  ',

    'CQS symbol': 'MC',
    'NASDAQ symbol': 'MC',
  },
  {
    symbol: 'MCA',
    'Security Name': 'Blackrock MuniYield California Quality Fund,  ',

    'CQS symbol': 'MCA',
    'NASDAQ symbol': 'MCA',
  },
  {
    symbol: 'MCAC',
    'Security Name': 'Mountain Crest Acquisition Corp  ',

    'NASDAQ symbol': 'MCAC',
  },
  {
    symbol: 'MCACR',
    'Security Name': 'Mountain Crest Acquisition Corp  Right',

    'NASDAQ symbol': 'MCACR',
  },
  {
    symbol: 'MCACU',
    'Security Name': 'Mountain Crest Acquisition Corp  Unit',

    'NASDAQ symbol': 'MCACU',
  },
  {
    symbol: 'MCB',
    'Security Name': 'Metropolitan Bank Holding Corp ',

    'CQS symbol': 'MCB',
    'NASDAQ symbol': 'MCB',
  },
  {
    symbol: 'MCBC',
    'Security Name': 'Macatawa Bank Corporation  ',

    'NASDAQ symbol': 'MCBC',
  },
  {
    symbol: 'MCBS',
    'Security Name': 'MetroCity Bankshares,   ',

    'NASDAQ symbol': 'MCBS',
  },
  {
    symbol: 'MCC',
    'Security Name': 'Medley Capital Corporation ',

    'CQS symbol': 'MCC',
    'NASDAQ symbol': 'MCC',
  },
  {
    symbol: 'MCD',
    'Security Name': "McDonald's Corporation ",

    'CQS symbol': 'MCD',
    'NASDAQ symbol': 'MCD',
  },
  {
    symbol: 'MCEF',
    'Security Name': 'First Trust Municipal CEF ome Opportunity ETF',

    'NASDAQ symbol': 'MCEF',
  },
  {
    symbol: 'MCEP',
    'Security Name': 'MidCon Energy Partners, LP  Common Units',

    'NASDAQ symbol': 'MCEP',
  },
  {
    symbol: 'MCF',
    'Security Name': 'Contango Oil & Gas Company  (TX)',

    'CQS symbol': 'MCF',
    'NASDAQ symbol': 'MCF',
  },
  {
    symbol: 'MCFE',
    'Security Name': 'McAfee Corp   ',

    'NASDAQ symbol': 'MCFE',
  },
  {
    symbol: 'MCFT',
    'Security Name': 'MasterCraft Boat Holdings,   ',

    'NASDAQ symbol': 'MCFT',
  },
  {
    symbol: 'MCHI',
    'Security Name': 'iShares MSCI China ETF',

    'NASDAQ symbol': 'MCHI',
  },
  {
    symbol: 'MCHP',
    'Security Name': 'Microchip Technology orporated  ',

    'NASDAQ symbol': 'MCHP',
  },
  {
    symbol: 'MCHX',
    'Security Name': 'Marchex,   Class B ',

    'NASDAQ symbol': 'MCHX',
  },
  {
    symbol: 'MCI',
    'Security Name': 'Barings Corporate Investors ',

    'CQS symbol': 'MCI',
    'NASDAQ symbol': 'MCI',
  },
  {
    symbol: 'MCK',
    'Security Name': 'McKesson Corporation ',

    'CQS symbol': 'MCK',
    'NASDAQ symbol': 'MCK',
  },
  {
    symbol: 'MCMJ',
    'Security Name': 'Merida Merger Corp I  ',

    'NASDAQ symbol': 'MCMJ',
  },
  {
    symbol: 'MCMJW',
    'Security Name': 'Merida Merger Corp I  Warrant',

    'NASDAQ symbol': 'MCMJW',
  },
  {
    symbol: 'MCN',
    'Security Name': 'Madison Covered Call & Equity Strategy Fund ',

    'CQS symbol': 'MCN',
    'NASDAQ symbol': 'MCN',
  },
  {
    symbol: 'MCO',
    'Security Name': "Moody's Corporation ",

    'CQS symbol': 'MCO',
    'NASDAQ symbol': 'MCO',
  },
  {
    symbol: 'MCR',
    'Security Name': 'MFS Charter ome Trust ',

    'CQS symbol': 'MCR',
    'NASDAQ symbol': 'MCR',
  },
  {
    symbol: 'MCRB',
    'Security Name': 'Seres Therapeutics,   ',

    'NASDAQ symbol': 'MCRB',
  },
  {
    symbol: 'MCRI',
    'Security Name': 'Monarch Casino & Resort,   ',

    'NASDAQ symbol': 'MCRI',
  },
  {
    symbol: 'MCRO',
    'Security Name': 'IQ Hedge Macro Tracker ETF',

    'CQS symbol': 'MCRO',
    'NASDAQ symbol': 'MCRO',
  },
  {
    symbol: 'MCS',
    'Security Name': 'Marcus Corporation (The) ',

    'CQS symbol': 'MCS',
    'NASDAQ symbol': 'MCS',
  },
  {
    symbol: 'MCV',
    'Security Name': 'Medley Capital Corporation 6125% Senior Notes due 2023',

    'CQS symbol': 'MCV',
    'NASDAQ symbol': 'MCV',
  },
  {
    symbol: 'MCY',
    'Security Name': 'Mercury General Corporation ',

    'CQS symbol': 'MCY',
    'NASDAQ symbol': 'MCY',
  },
  {
    symbol: 'MD',
    'Security Name': 'Mednax,  ',

    'CQS symbol': 'MD',
    'NASDAQ symbol': 'MD',
  },
  {
    symbol: 'MDB',
    'Security Name': 'MongoDB,    ',

    'NASDAQ symbol': 'MDB',
  },
  {
    symbol: 'MDC',
    'Security Name': 'MDC Holdings,  ',

    'CQS symbol': 'MDC',
    'NASDAQ symbol': 'MDC',
  },
  {
    symbol: 'MDCA',
    'Security Name': 'MDC Partners    Subordinate Voting Shares',

    'NASDAQ symbol': 'MDCA',
  },
  {
    symbol: 'MDGL',
    'Security Name': 'Madrigal Pharmaceuticals,   ',

    'NASDAQ symbol': 'MDGL',
  },
  {
    symbol: 'MDGS',
    'Security Name': 'Medigus Ltd  American Depositary Shares',

    'NASDAQ symbol': 'MDGS',
  },
  {
    symbol: 'MDGSW',
    'Security Name': 'Medigus Ltd  Series C Warrant',

    'NASDAQ symbol': 'MDGSW',
  },
  {
    symbol: 'MDIA',
    'Security Name': 'Mediaco Holding    ',

    'NASDAQ symbol': 'MDIA',
  },
  {
    symbol: 'MDIV',
    'Security Name': 'First Trust MultiAsset Diversified ome Index Fund',

    'NASDAQ symbol': 'MDIV',
  },
  {
    symbol: 'MDJH',
    'Security Name': 'MDJM LTD  Ordinary Shares',

    'NASDAQ symbol': 'MDJH',
  },
  {
    symbol: 'MDLA',
    'Security Name': 'Medallia,  ',

    'CQS symbol': 'MDLA',
    'NASDAQ symbol': 'MDLA',
  },
  {
    symbol: 'MDLQ',
    'Security Name': 'Medley LLC 725% Notes due 2024',

    'CQS symbol': 'MDLQ',
    'NASDAQ symbol': 'MDLQ',
  },
  {
    symbol: 'MDLX',
    'Security Name': 'Medley LLC 6875% Senior Notes due 2026',

    'CQS symbol': 'MDLX',
    'NASDAQ symbol': 'MDLX',
  },
  {
    symbol: 'MDLY',
    'Security Name': 'Medley Management   ',

    'CQS symbol': 'MDLY',
    'NASDAQ symbol': 'MDLY',
  },
  {
    symbol: 'MDLZ',
    'Security Name': 'Mondelez International,    ',

    'NASDAQ symbol': 'MDLZ',
  },
  {
    symbol: 'MDNA',
    'Security Name': 'Medicenna Therapeutics Corp  Common Shares',

    'NASDAQ symbol': 'MDNA',
  },
  {
    symbol: 'MDP',
    'Security Name': 'Meredith Corporation ',

    'CQS symbol': 'MDP',
    'NASDAQ symbol': 'MDP',
  },
  {
    symbol: 'MDRR',
    'Security Name': 'Medalist Diversified REIT,   ',

    'NASDAQ symbol': 'MDRR',
  },
  {
    symbol: 'MDRRP',
    'Security Name':
      'Medalist Diversified REIT,   Series A Cumulative Redeemable Preferred Stock',

    'NASDAQ symbol': 'MDRRP',
  },
  {
    symbol: 'MDRX',
    'Security Name': 'Allscripts Healthcare Solutions,   ',

    'NASDAQ symbol': 'MDRX',
  },
  {
    symbol: 'MDT',
    'Security Name': 'Medtronic plc Ordinary Shares',

    'CQS symbol': 'MDT',
    'NASDAQ symbol': 'MDT',
  },
  {
    symbol: 'MDU',
    'Security Name': 'MDU Resources Group,   (Holding Company)',

    'CQS symbol': 'MDU',
    'NASDAQ symbol': 'MDU',
  },
  {
    symbol: 'MDVL',
    'Security Name': 'MedAvail Holdings,    ',

    'NASDAQ symbol': 'MDVL',
  },
  {
    symbol: 'MDWD',
    'Security Name': 'MediWound Ltd  Ordinary Shares',

    'NASDAQ symbol': 'MDWD',
  },
  {
    symbol: 'MDXG',
    'Security Name': 'MiMedx Group,   ',

    'NASDAQ symbol': 'MDXG',
  },
  {
    symbol: 'MDY',
    'Security Name': 'SPDR MidCap Trust Series I',

    'CQS symbol': 'MDY',
    'NASDAQ symbol': 'MDY',
  },
  {
    symbol: 'MDYG',
    'Security Name':
      'SPDR S&P 400 Mid Cap Growth ETF (based on S&P MidCap 400 Growth Indexsymbol: MUV)',

    'CQS symbol': 'MDYG',
    'NASDAQ symbol': 'MDYG',
  },
  {
    symbol: 'MDYV',
    'Security Name':
      'SPDR S&P 400 Mid Cap Value ETF (based on S&P MidCap 400 Value Indexsymbol: MGD',

    'CQS symbol': 'MDYV',
    'NASDAQ symbol': 'MDYV',
  },
  {
    symbol: 'MEAR',
    'Security Name': 'BlackRock Short Maturity Municipal Bond ETF',

    'CQS symbol': 'MEAR',
    'NASDAQ symbol': 'MEAR',
  },
  {
    symbol: 'MEC',
    'Security Name': 'Mayville Engineering Company,  ',

    'CQS symbol': 'MEC',
    'NASDAQ symbol': 'MEC',
  },
  {
    symbol: 'MED',
    'Security Name': 'MEDIFAST  ',

    'CQS symbol': 'MED',
    'NASDAQ symbol': 'MED',
  },
  {
    symbol: 'MEDP',
    'Security Name': 'Medpace Holdings,   ',

    'NASDAQ symbol': 'MEDP',
  },
  {
    symbol: 'MEDS',
    'Security Name': 'Trxade Group,   ',

    'NASDAQ symbol': 'MEDS',
  },
  {
    symbol: 'MEG',
    'Security Name': 'Montrose Environmental Group,  ',

    'CQS symbol': 'MEG',
    'NASDAQ symbol': 'MEG',
  },
  {
    symbol: 'MEI',
    'Security Name': 'Methode Electronics,  ',

    'CQS symbol': 'MEI',
    'NASDAQ symbol': 'MEI',
  },
  {
    symbol: 'MEIP',
    'Security Name': 'MEI Pharma,   ',

    'NASDAQ symbol': 'MEIP',
  },
  {
    symbol: 'MELI',
    'Security Name': 'MercadoLibre,   ',

    'NASDAQ symbol': 'MELI',
  },
  {
    symbol: 'MEN',
    'Security Name': 'Blackrock MuniEnhanced Fund,  ',

    'CQS symbol': 'MEN',
    'NASDAQ symbol': 'MEN',
  },
  {
    symbol: 'MEOH',
    'Security Name': 'Methanex Corporation  ',

    'NASDAQ symbol': 'MEOH',
  },
  {
    symbol: 'MER$K',
    'Security Name':
      'Bank of America Corporation ome Capital Obligation Notes initially due December 15, 2066',

    'CQS symbol': 'MERpK',
    'NASDAQ symbol': 'MERK',
  },
  {
    symbol: 'MERC',
    'Security Name': 'Mercer International   ',

    'NASDAQ symbol': 'MERC',
  },
  {
    symbol: 'MESA',
    'Security Name': 'Mesa Air Group,   ',

    'NASDAQ symbol': 'MESA',
  },
  {
    symbol: 'MESO',
    'Security Name': 'Mesoblast Limited  American Depositary Shares',

    'NASDAQ symbol': 'MESO',
  },
  {
    symbol: 'MET',
    'Security Name': 'MetLife,  ',

    'CQS symbol': 'MET',
    'NASDAQ symbol': 'MET',
  },
  {
    symbol: 'MET$A',
    'Security Name': 'MetLife,  Preferred Series A Floating Rate',

    'CQS symbol': 'METpA',
    'NASDAQ symbol': 'META',
  },
  {
    symbol: 'MET$E',
    'Security Name':
      'MetLife,  Depositary shares, each representing a 1/1000th interest in a share of the Issuera??s 5625% NonCumulative Preferred Stock, Series E',

    'CQS symbol': 'METpE',
    'NASDAQ symbol': 'METE',
  },
  {
    symbol: 'MET$F',
    'Security Name':
      'MetLife,  Depositary Shares, each representing a 1/1,000th interest in a share of 475% NonCumulative Preferred Stock, Series F',

    'CQS symbol': 'METpF',
    'NASDAQ symbol': 'METF',
  },
  {
    symbol: 'METC',
    'Security Name': 'Ramaco Resources,   ',

    'NASDAQ symbol': 'METC',
  },
  {
    symbol: 'METX',
    'Security Name': 'Meten EdtechX Education Group Ltd  Ordinary Shares',

    'NASDAQ symbol': 'METX',
  },
  {
    symbol: 'METXW',
    'Security Name': 'Meten EdtechX Education Group Ltd  Warrant',

    'NASDAQ symbol': 'METXW',
  },
  {
    symbol: 'MEXX',
    'Security Name': 'Direxion Daily MSCI Mexico Bull 3X Shares',

    'CQS symbol': 'MEXX',
    'NASDAQ symbol': 'MEXX',
  },
  {
    symbol: 'MFA',
    'Security Name': 'MFA Financial, ',

    'CQS symbol': 'MFA',
    'NASDAQ symbol': 'MFA',
  },
  {
    symbol: 'MFA$B',
    'Security Name': 'MFA Financial,  Preferred Series B',

    'CQS symbol': 'MFApB',
    'NASDAQ symbol': 'MFAB',
  },
  {
    symbol: 'MFA$C',
    'Security Name':
      'MFA Financial,  650% Series C FixedtoFloating Rate Cumulative Redeemable Preferred Stock',

    'CQS symbol': 'MFApC',
    'NASDAQ symbol': 'MFAC',
  },
  {
    symbol: 'MFAC',
    'Security Name': 'Megalith Financial Acquisition Corp  ',

    'CQS symbol': 'MFAC',
    'NASDAQ symbol': 'MFAC',
  },
  {
    symbol: 'MFACU',
    'Security Name':
      'Megalith Financial Acquisition Corp Units, each consisting of one share of  , $00001 par value, and one redeemable warrant',

    'CQS symbol': 'MFACU',
    'NASDAQ symbol': 'MFAC=',
  },
  {
    symbol: 'MFACW',
    'Security Name':
      'Megalith Financial Acquisition Corp Warrants, each warrant exercisable for one share of   at an exercise price of $1150',

    'CQS symbol': 'MFACWS',
    'NASDAQ symbol': 'MFAC+',
  },
  {
    symbol: 'MFC',
    'Security Name': 'Manulife Financial Corporation ',

    'CQS symbol': 'MFC',
    'NASDAQ symbol': 'MFC',
  },
  {
    symbol: 'MFD',
    'Security Name': 'Macquarie First Trust Global ',

    'CQS symbol': 'MFD',
    'NASDAQ symbol': 'MFD',
  },
  {
    symbol: 'MFDX',
    'Security Name':
      'PIMCO Equitiy Series PIMCO RAFI Dynamic MultiFactor International Equity ETF',

    'CQS symbol': 'MFDX',
    'NASDAQ symbol': 'MFDX',
  },
  {
    symbol: 'MFEM',
    'Security Name':
      'PIMCO Equitiy Series PIMCO RAFI Dynamic MultiFactor Emerging Markets Equity ETF',

    'CQS symbol': 'MFEM',
    'NASDAQ symbol': 'MFEM',
  },
  {
    symbol: 'MFG',
    'Security Name': 'Mizuho Financial Group,  Sponosred ADR (Japan)',

    'CQS symbol': 'MFG',
    'NASDAQ symbol': 'MFG',
  },
  {
    symbol: 'MFGP',
    'Security Name': 'Micro Focus Intl PLC ADS each representing One Ord Sh',

    'CQS symbol': 'MFGP',
    'NASDAQ symbol': 'MFGP',
  },
  {
    symbol: 'MFH',
    'Security Name': 'Mercurity Fintech Holding   American Depositary Shares',

    'NASDAQ symbol': 'MFH',
  },
  {
    symbol: 'MFIN',
    'Security Name': 'Medallion Financial Corp  ',

    'NASDAQ symbol': 'MFIN',
  },
  {
    symbol: 'MFINL',
    'Security Name': 'Medallion Financial Corp  9000% Notes due 2021',

    'NASDAQ symbol': 'MFINL',
  },
  {
    symbol: 'MFL',
    'Security Name':
      'Blackrock MuniHoldings Investment Quality Fund Common Shares of Beneficial Interest',

    'CQS symbol': 'MFL',
    'NASDAQ symbol': 'MFL',
  },
  {
    symbol: 'MFM',
    'Security Name': 'MFS Municipal ome Trust ',

    'CQS symbol': 'MFM',
    'NASDAQ symbol': 'MFM',
  },
  {
    symbol: 'MFMS',
    'Security Name': 'Motley Fool SmallCap Growth ETF',

    'CQS symbol': 'MFMS',
    'NASDAQ symbol': 'MFMS',
  },
  {
    symbol: 'MFNC',
    'Security Name': 'Mackinac Financial Corporation  ',

    'NASDAQ symbol': 'MFNC',
  },
  {
    symbol: 'MFO',
    'Security Name': 'MFA Financial,  800% Senior Notes due 2042',

    'CQS symbol': 'MFO',
    'NASDAQ symbol': 'MFO',
  },
  {
    symbol: 'MFT',
    'Security Name':
      'Blackrock MuniYield Investment Quality Fund Common Shares of Beneficial Interest',

    'CQS symbol': 'MFT',
    'NASDAQ symbol': 'MFT',
  },
  {
    symbol: 'MFUS',
    'Security Name':
      'PIMCO Equitiy Series PIMCO RAFI Dynamic MultiFactor US Equity ETF',

    'CQS symbol': 'MFUS',
    'NASDAQ symbol': 'MFUS',
  },
  {
    symbol: 'MFV',
    'Security Name': 'MFS Special Value Trust ',

    'CQS symbol': 'MFV',
    'NASDAQ symbol': 'MFV',
  },
  {
    symbol: 'MG',
    'Security Name': 'Mistras Group  ',

    'CQS symbol': 'MG',
    'NASDAQ symbol': 'MG',
  },
  {
    symbol: 'MGA',
    'Security Name': 'Magna International,  ',

    'CQS symbol': 'MGA',
    'NASDAQ symbol': 'MGA',
  },
  {
    symbol: 'MGC',
    'Security Name': 'Vanguard Mega Cap ETF',

    'CQS symbol': 'MGC',
    'NASDAQ symbol': 'MGC',
  },
  {
    symbol: 'MGEE',
    'Security Name': 'MGE Energy   ',

    'NASDAQ symbol': 'MGEE',
  },
  {
    symbol: 'MGEN',
    'Security Name': 'Miragen Therapeutics,   ',

    'NASDAQ symbol': 'MGEN',
  },
  {
    symbol: 'MGF',
    'Security Name': 'MFS Government Markets ome Trust ',

    'CQS symbol': 'MGF',
    'NASDAQ symbol': 'MGF',
  },
  {
    symbol: 'MGI',
    'Security Name': 'Moneygram International,   ',

    'NASDAQ symbol': 'MGI',
  },
  {
    symbol: 'MGIC',
    'Security Name': 'Magic Software Enterprises Ltd  Ordinary Shares',

    'NASDAQ symbol': 'MGIC',
  },
  {
    symbol: 'MGK',
    'Security Name': 'Vanguard Mega Cap Growth ETF',

    'CQS symbol': 'MGK',
    'NASDAQ symbol': 'MGK',
  },
  {
    symbol: 'MGLN',
    'Security Name': 'Magellan Health,   ',

    'NASDAQ symbol': 'MGLN',
  },
  {
    symbol: 'MGM',
    'Security Name': 'MGM Resorts International ',

    'CQS symbol': 'MGM',
    'NASDAQ symbol': 'MGM',
  },
  {
    symbol: 'MGMT',
    'Security Name': 'Ballast Small/Mid Cap ETF',

    'CQS symbol': 'MGMT',
    'NASDAQ symbol': 'MGMT',
  },
  {
    symbol: 'MGNI',
    'Security Name': 'Magnite,   ',

    'NASDAQ symbol': 'MGNI',
  },
  {
    symbol: 'MGNX',
    'Security Name': 'MacroGenics,   ',

    'NASDAQ symbol': 'MGNX',
  },
  {
    symbol: 'MGP',
    'Security Name':
      'MGM Growth Properties LLC  common shares representing limited liability company interests',

    'CQS symbol': 'MGP',
    'NASDAQ symbol': 'MGP',
  },
  {
    symbol: 'MGPI',
    'Security Name': 'MGP Ingredients,   ',

    'NASDAQ symbol': 'MGPI',
  },
  {
    symbol: 'MGR',
    'Security Name':
      'Affiliated Managers Group,  5875% Junior Subordinated Notes due 2059',

    'CQS symbol': 'MGR',
    'NASDAQ symbol': 'MGR',
  },
  {
    symbol: 'MGRB',
    'Security Name':
      'Affiliated Managers Group,  4750% Junior Subordinated Notes due 2060',

    'CQS symbol': 'MGRB',
    'NASDAQ symbol': 'MGRB',
  },
  {
    symbol: 'MGRC',
    'Security Name': 'McGrath RentCorp  ',

    'NASDAQ symbol': 'MGRC',
  },
  {
    symbol: 'MGTA',
    'Security Name': 'Magenta Therapeutics,   ',

    'NASDAQ symbol': 'MGTA',
  },
  {
    symbol: 'MGTX',
    'Security Name': 'MeiraGTx Holdings plc  Ordinary Shares',

    'NASDAQ symbol': 'MGTX',
  },
  {
    symbol: 'MGU',
    'Security Name': 'Macquarie Global Infrastructure Total Return Fund  ',

    'CQS symbol': 'MGU',
    'NASDAQ symbol': 'MGU',
  },
  {
    symbol: 'MGV',
    'Security Name': 'Vanguard Mega Cap Value ETF',

    'CQS symbol': 'MGV',
    'NASDAQ symbol': 'MGV',
  },
  {
    symbol: 'MGY',
    'Security Name': 'Magnolia Oil & Gas Corporation  ',

    'CQS symbol': 'MGY',
    'NASDAQ symbol': 'MGY',
  },
  {
    symbol: 'MGYR',
    'Security Name': 'Magyar Bancorp,   ',

    'NASDAQ symbol': 'MGYR',
  },
  {
    symbol: 'MH$A',
    'Security Name': 'Maiden Holdings, Ltd Pref Shs Ser A (Bermuda)',

    'CQS symbol': 'MHpA',
    'NASDAQ symbol': 'MHA',
  },
  {
    symbol: 'MH$C',
    'Security Name':
      'Maiden Holdings North America, Ltd 7125% NonCumulative Preference Shares, Series C',

    'CQS symbol': 'MHpC',
    'NASDAQ symbol': 'MHC',
  },
  {
    symbol: 'MH$D',
    'Security Name':
      'Maiden Holdings, Ltd 6700% NonCumulative Preference Shares, Series D',

    'CQS symbol': 'MHpD',
    'NASDAQ symbol': 'MHD',
  },
  {
    symbol: 'MHD',
    'Security Name': 'Blackrock MuniHoldings Fund,  ',

    'CQS symbol': 'MHD',
    'NASDAQ symbol': 'MHD',
  },
  {
    symbol: 'MHE',
    'Security Name': 'BlackRock Massachusetts TaxExempt Trust',

    'CQS symbol': 'MHE',
    'NASDAQ symbol': 'MHE',
  },
  {
    symbol: 'MHF',
    'Security Name': 'Western Asset Municipal High ome Fund,  ',

    'CQS symbol': 'MHF',
    'NASDAQ symbol': 'MHF',
  },
  {
    symbol: 'MHH',
    'Security Name': 'Mastech Digital,  ',

    'CQS symbol': 'MHH',
    'NASDAQ symbol': 'MHH',
  },
  {
    symbol: 'MHI',
    'Security Name':
      'Pioneer Municipal High ome Trust Common Shares of Beneficial Interest',

    'CQS symbol': 'MHI',
    'NASDAQ symbol': 'MHI',
  },
  {
    symbol: 'MHK',
    'Security Name': 'Mohawk Industries,  ',

    'CQS symbol': 'MHK',
    'NASDAQ symbol': 'MHK',
  },
  {
    symbol: 'MHLA',
    'Security Name': 'Maiden Holdings, Ltd 6625% Notes due 2046',

    'CQS symbol': 'MHLA',
    'NASDAQ symbol': 'MHLA',
  },
  {
    symbol: 'MHLD',
    'Security Name': 'Maiden Holdings, Ltd  ',

    'NASDAQ symbol': 'MHLD',
  },
  {
    symbol: 'MHN',
    'Security Name': 'Blackrock MuniHoldings New York Quality Fund,  ',

    'CQS symbol': 'MHN',
    'NASDAQ symbol': 'MHN',
  },
  {
    symbol: 'MHNC',
    'Security Name': 'Maiden Holdings North America, Ltd 775% Notes due 2043',

    'CQS symbol': 'MHNC',
    'NASDAQ symbol': 'MHNC',
  },
  {
    symbol: 'MHO',
    'Security Name': 'M/I Homes,  ',

    'CQS symbol': 'MHO',
    'NASDAQ symbol': 'MHO',
  },
  {
    symbol: 'MIC',
    'Security Name': 'Macquarie Infrastructure Corporation ',

    'CQS symbol': 'MIC',
    'NASDAQ symbol': 'MIC',
  },
  {
    symbol: 'MICT',
    'Security Name': 'MICT,   ',

    'NASDAQ symbol': 'MICT',
  },
  {
    symbol: 'MID',
    'Security Name': 'American Century Mid Cap Growth Impact ETF',

    'CQS symbol': 'MID',
    'NASDAQ symbol': 'MID',
  },
  {
    symbol: 'MIDD',
    'Security Name': 'The Middleby Corporation  ',

    'NASDAQ symbol': 'MIDD',
  },
  {
    symbol: 'MIDF',
    'Security Name': 'iShares MSCI USA MidCap Multifactor ETF',

    'CQS symbol': 'MIDF',
    'NASDAQ symbol': 'MIDF',
  },
  {
    symbol: 'MIDU',
    'Security Name': 'Direxion Mid Cap Bull 3X Shares',

    'CQS symbol': 'MIDU',
    'NASDAQ symbol': 'MIDU',
  },
  {
    symbol: 'MIE',
    'Security Name': 'Cohen & Steers MLP ome and Energy Opportunity Fund,  ',

    'CQS symbol': 'MIE',
    'NASDAQ symbol': 'MIE',
  },
  {
    symbol: 'MIG',
    'Security Name': "VanEck Vectors Moody's Analytics IG Corporate Bond ETF",

    'CQS symbol': 'MIG',
    'NASDAQ symbol': 'MIG',
  },
  {
    symbol: 'MIK',
    'Security Name': 'The Michaels Companies,   ',

    'NASDAQ symbol': 'MIK',
  },
  {
    symbol: 'MILN',
    'Security Name': 'Global X Millennials Thematic ETF',

    'NASDAQ symbol': 'MILN',
  },
  {
    symbol: 'MIME',
    'Security Name': 'Mimecast Limited  Ordinary Shares',

    'NASDAQ symbol': 'MIME',
  },
  {
    symbol: 'MIN',
    'Security Name': 'MFS Intermediate ome Trust ',

    'CQS symbol': 'MIN',
    'NASDAQ symbol': 'MIN',
  },
  {
    symbol: 'M',
    'Security Name': 'AdvisorShares Newfleet Multisector ome ETF',

    'CQS symbol': 'M',
    'NASDAQ symbol': 'M',
  },
  {
    symbol: 'MIND',
    'Security Name': 'MIND Technology,   ',

    'NASDAQ symbol': 'MIND',
  },
  {
    symbol: 'MINDP',
    'Security Name':
      'MIND Technology,   Series A 900% Series A Cumulative Preferred Stock',

    'NASDAQ symbol': 'MINDP',
  },
  {
    symbol: 'MINT',
    'Security Name': 'PIMCO Enhanced Short Maturity Active ExchangeTraded Fund',

    'CQS symbol': 'MINT',
    'NASDAQ symbol': 'MINT',
  },
  {
    symbol: 'MIRM',
    'Security Name': 'Mirum Pharmaceuticals,   ',

    'NASDAQ symbol': 'MIRM',
  },
  {
    symbol: 'MIST',
    'Security Name': 'Milestone Pharmaceuticals   Common Shares',

    'NASDAQ symbol': 'MIST',
  },
  {
    symbol: 'MITK',
    'Security Name': 'Mitek Systems,   ',

    'NASDAQ symbol': 'MITK',
  },
  {
    symbol: 'MITO',
    'Security Name': 'Stealth BioTherapeutics Corp  American Depositary Shares',

    'NASDAQ symbol': 'MITO',
  },
  {
    symbol: 'MITT',
    'Security Name': 'AG Mortgage Investment Trust,  ',

    'CQS symbol': 'MITT',
    'NASDAQ symbol': 'MITT',
  },
  {
    symbol: 'MITT$A',
    'Security Name': 'AG Mortgage Investment Trust,  825% Preferred Series A',

    'CQS symbol': 'MITTpA',
    'NASDAQ symbol': 'MITTA',
  },
  {
    symbol: 'MITT$B',
    'Security Name': 'AG Mortgage Investment Trust,  Preferred Series B',

    'CQS symbol': 'MITTpB',
    'NASDAQ symbol': 'MITTB',
  },
  {
    symbol: 'MITT$C',
    'Security Name':
      'AG Mortgage Investment Trust,  800% Series C FixedtoFloating Rate Cumulative Redeemable Preferred Stock, $001 par value per share',

    'CQS symbol': 'MITTpC',
    'NASDAQ symbol': 'MITTC',
  },
  {
    symbol: 'MIXT',
    'Security Name':
      'MiX Telematics Limited American Depositary Shares, each representing 25 Ordinary Shares',

    'CQS symbol': 'MIXT',
    'NASDAQ symbol': 'MIXT',
  },
  {
    symbol: 'MIY',
    'Security Name': 'Blackrock MuniYield Michigan Quality Fund,  ',

    'CQS symbol': 'MIY',
    'NASDAQ symbol': 'MIY',
  },
  {
    symbol: 'MJ',
    'Security Name': 'ETFMG Alternative Harvest ETF',

    'CQS symbol': 'MJ',
    'NASDAQ symbol': 'MJ',
  },
  {
    symbol: 'MJJ',
    'Security Name': 'MicroSectors Cannabis ETNs',

    'CQS symbol': 'MJJ',
    'NASDAQ symbol': 'MJJ',
  },
  {
    symbol: 'MJO',
    'Security Name': 'MicroSectors Cannabis 2X Leveraged ETNs',

    'CQS symbol': 'MJO',
    'NASDAQ symbol': 'MJO',
  },
  {
    symbol: 'MKC',
    'Security Name': 'McCormick & Company, orporated ',

    'CQS symbol': 'MKC',
    'NASDAQ symbol': 'MKC',
  },
  {
    symbol: 'MKCV',
    'Security Name': 'McCormick & Company, orporated ',

    'CQS symbol': 'MKCV',
    'NASDAQ symbol': 'MKCV',
  },
  {
    symbol: 'MKD',
    'Security Name': 'Molecular Data   ADS',

    'NASDAQ symbol': 'MKD',
  },
  {
    symbol: 'MKGI',
    'Security Name': 'Monaker Group,   ',

    'NASDAQ symbol': 'MKGI',
  },
  {
    symbol: 'MKL',
    'Security Name': 'Markel Corporation ',

    'Round Lot Size': '10',

    'CQS symbol': 'MKL',
    'NASDAQ symbol': 'MKL',
  },
  {
    symbol: 'MKSI',
    'Security Name': 'MKS Instruments,   ',

    'NASDAQ symbol': 'MKSI',
  },
  {
    symbol: 'MKTX',
    'Security Name': 'MarketAxess Holdings,   ',

    'NASDAQ symbol': 'MKTX',
  },
  {
    symbol: 'MLAB',
    'Security Name': 'Mesa Laboratories,   ',

    'NASDAQ symbol': 'MLAB',
  },
  {
    symbol: 'MLAC',
    'Security Name':
      'Malacca Straits Acquisition Company Limited   Ordinary Shares',

    'NASDAQ symbol': 'MLAC',
  },
  {
    symbol: 'MLACU',
    'Security Name': 'Malacca Straits Acquisition Company Limited  Units',

    'NASDAQ symbol': 'MLACU',
  },
  {
    symbol: 'MLACW',
    'Security Name': 'Malacca Straits Acquisition Company Limited  Warrants',

    'NASDAQ symbol': 'MLACW',
  },
  {
    symbol: 'MLCO',
    'Security Name':
      'Melco Resorts & Entertainment Limited  American Depositary Shares ',

    'NASDAQ symbol': 'MLCO',
  },
  {
    symbol: 'MLHR',
    'Security Name': 'Herman Miller,   ',

    'NASDAQ symbol': 'MLHR',
  },
  {
    symbol: 'MLI',
    'Security Name': 'Mueller Industries,  ',

    'CQS symbol': 'MLI',
    'NASDAQ symbol': 'MLI',
  },
  {
    symbol: 'MLM',
    'Security Name': 'Martin Marietta Materials,  ',

    'CQS symbol': 'MLM',
    'NASDAQ symbol': 'MLM',
  },
  {
    symbol: 'MLN',
    'Security Name': 'VanEck Vectors ETF Trust VanEck Vectors Long Muni ETF',

    'CQS symbol': 'MLN',
    'NASDAQ symbol': 'MLN',
  },
  {
    symbol: 'MLND',
    'Security Name': 'Millendo Therapeutics,    ',

    'NASDAQ symbol': 'MLND',
  },
  {
    symbol: 'MLP',
    'Security Name': 'Maui Land & Pineapple Company,  ',

    'CQS symbol': 'MLP',
    'NASDAQ symbol': 'MLP',
  },
  {
    symbol: 'MLPA',
    'Security Name': 'Global X MLP ETF',

    'CQS symbol': 'MLPA',
    'NASDAQ symbol': 'MLPA',
  },
  {
    symbol: 'MLPB',
    'Security Name':
      'ETRACS Alerian MLP Infrastructure Index ETN Series B due April 2, 2040',

    'CQS symbol': 'MLPB',
    'NASDAQ symbol': 'MLPB',
  },
  {
    symbol: 'MLPO',
    'Security Name':
      'Credit Suisse Group Exchange Traded Notes due December 4, 2034, Linked to the S&P MLP Index',

    'CQS symbol': 'MLPO',
    'NASDAQ symbol': 'MLPO',
  },
  {
    symbol: 'MLPR',
    'Security Name': 'ETRACS Quarterly Pay 15X Leveraged Alerian MLP Index ETN',

    'CQS symbol': 'MLPR',
    'NASDAQ symbol': 'MLPR',
  },
  {
    symbol: 'MLPX',
    'Security Name': 'Global X MLP & Energy Infrastructure ETF',

    'CQS symbol': 'MLPX',
    'NASDAQ symbol': 'MLPX',
  },
  {
    symbol: 'MLPY',
    'Security Name': 'Morgan Stanley Cushing MLP High ome Index ETN',

    'CQS symbol': 'MLPY',
    'NASDAQ symbol': 'MLPY',
  },
  {
    symbol: 'MLR',
    'Security Name': 'Miller Industries,  ',

    'CQS symbol': 'MLR',
    'NASDAQ symbol': 'MLR',
  },
  {
    symbol: 'MLSS',
    'Security Name': 'Milestone Scientific,  ',

    'CQS symbol': 'MLSS',
    'NASDAQ symbol': 'MLSS',
  },
  {
    symbol: 'MLVF',
    'Security Name': 'Malvern Bancorp,   ',

    'NASDAQ symbol': 'MLVF',
  },
  {
    symbol: 'MMAC',
    'Security Name': 'MMA Capital Holdings,   ',

    'NASDAQ symbol': 'MMAC',
  },
  {
    symbol: 'MMC',
    'Security Name': 'Marsh & McLennan Companies,  ',

    'CQS symbol': 'MMC',
    'NASDAQ symbol': 'MMC',
  },
  {
    symbol: 'MMD',
    'Security Name': 'MainStay MacKay DefinedTerm Municipal Opportunities Fund',

    'CQS symbol': 'MMD',
    'NASDAQ symbol': 'MMD',
  },
  {
    symbol: 'MMI',
    'Security Name': 'Marcus & Millichap,  ',

    'CQS symbol': 'MMI',
    'NASDAQ symbol': 'MMI',
  },
  {
    symbol: 'MMIN',
    'Security Name': 'IQ MacKay Municipal Insured ETF ',

    'CQS symbol': 'MMIN',
    'NASDAQ symbol': 'MMIN',
  },
  {
    symbol: 'MMIT',
    'Security Name': 'IQ MacKay Municipal Intermediate ETF',

    'CQS symbol': 'MMIT',
    'NASDAQ symbol': 'MMIT',
  },
  {
    symbol: 'MMLG',
    'Security Name': 'First Trust MultiManager Large Growth ETF',

    'CQS symbol': 'MMLG',
    'NASDAQ symbol': 'MMLG',
  },
  {
    symbol: 'MMLP',
    'Security Name':
      'Martin Midstream Partners LP  Common Units Representing Limited Partnership Interests',

    'NASDAQ symbol': 'MMLP',
  },
  {
    symbol: 'MMM',
    'Security Name': '3M Company ',

    'CQS symbol': 'MMM',
    'NASDAQ symbol': 'MMM',
  },
  {
    symbol: 'MMP',
    'Security Name': 'Magellan Midstream Partners LP Limited Partnership',

    'CQS symbol': 'MMP',
    'NASDAQ symbol': 'MMP',
  },
  {
    symbol: 'MMS',
    'Security Name': 'Maximus,  ',

    'CQS symbol': 'MMS',
    'NASDAQ symbol': 'MMS',
  },
  {
    symbol: 'MMSI',
    'Security Name': 'Merit Medical Systems,   ',

    'NASDAQ symbol': 'MMSI',
  },
  {
    symbol: 'MMT',
    'Security Name': 'MFS Multimarket ome Trust ',

    'CQS symbol': 'MMT',
    'NASDAQ symbol': 'MMT',
  },
  {
    symbol: 'MMTM',
    'Security Name': 'SPDR S&P 1500 Momentum Tilt ETF',

    'CQS symbol': 'MMTM',
    'NASDAQ symbol': 'MMTM',
  },
  {
    symbol: 'MMU',
    'Security Name': 'Western Asset Managed Municipals Fund,  ',

    'CQS symbol': 'MMU',
    'NASDAQ symbol': 'MMU',
  },
  {
    symbol: 'MMX',
    'Security Name': 'Maverix Metals  Common Shares',

    'CQS symbol': 'MMX',
    'NASDAQ symbol': 'MMX',
  },
  {
    symbol: 'MMYT',
    'Security Name': 'MakeMyTrip Limited  Ordinary Shares',

    'NASDAQ symbol': 'MMYT',
  },
  {
    symbol: 'MN',
    'Security Name': 'Manning & Napier,   ',

    'CQS symbol': 'MN',
    'NASDAQ symbol': 'MN',
  },
  {
    symbol: 'MNA',
    'Security Name': 'IQ Merger Arbitrage ETF',

    'CQS symbol': 'MNA',
    'NASDAQ symbol': 'MNA',
  },
  {
    symbol: 'MNCL',
    'Security Name': 'Monocle Acquisition Corporation  ',

    'NASDAQ symbol': 'MNCL',
  },
  {
    symbol: 'MNCLU',
    'Security Name': 'Monocle Acquisition Corporation  Units',

    'NASDAQ symbol': 'MNCLU',
  },
  {
    symbol: 'MNCLW',
    'Security Name': 'Monocle Acquisition Corporation  Warrants',

    'NASDAQ symbol': 'MNCLW',
  },
  {
    symbol: 'MNDO',
    'Security Name': 'MIND CTI Ltd  Ordinary Shares',

    'NASDAQ symbol': 'MNDO',
  },
  {
    symbol: 'MNKD',
    'Security Name': 'MannKind Corporation  ',

    'NASDAQ symbol': 'MNKD',
  },
  {
    symbol: 'MNOV',
    'Security Name': 'MediciNova,   ',

    'NASDAQ symbol': 'MNOV',
  },
  {
    symbol: 'MNP',
    'Security Name': 'Western Asset Municipal Partners Fund,  ',

    'CQS symbol': 'MNP',
    'NASDAQ symbol': 'MNP',
  },
  {
    symbol: 'MNPR',
    'Security Name': 'Monopar Therapeutics   ',

    'NASDAQ symbol': 'MNPR',
  },
  {
    symbol: 'MNR',
    'Security Name': 'Monmouth Real Estate Investment Corporation  ',

    'CQS symbol': 'MNR',
    'NASDAQ symbol': 'MNR',
  },
  {
    symbol: 'MNR$C',
    'Security Name':
      'Monmouth Real Estate Investment Corporation 6125% Series C Cumulative Redeemable Preferred Stock',

    'CQS symbol': 'MNRpC',
    'NASDAQ symbol': 'MNRC',
  },
  {
    symbol: 'MNRL',
    'Security Name': 'Brigham Minerals,   ',

    'CQS symbol': 'MNRL',
    'NASDAQ symbol': 'MNRL',
  },
  {
    symbol: 'MNRO',
    'Security Name': 'Monro,    ',

    'NASDAQ symbol': 'MNRO',
  },
  {
    symbol: 'MNSB',
    'Security Name': 'MainStreet Bancshares,   ',

    'NASDAQ symbol': 'MNSB',
  },
  {
    symbol: 'MNSBP',
    'Security Name': 'MainStreet Bancshares,   Depositary Shares',

    'NASDAQ symbol': 'MNSBP',
  },
  {
    symbol: 'MNSO',
    'Security Name':
      'MINISO Group Holding Limited American Depositary Shares, each representing four  Ordinary Shares',

    'CQS symbol': 'MNSO',
    'NASDAQ symbol': 'MNSO',
  },
  {
    symbol: 'MNST',
    'Security Name': 'Monster Beverage Corporation  ',

    'NASDAQ symbol': 'MNST',
  },
  {
    symbol: 'MNTX',
    'Security Name': 'Manitex International,   ',

    'NASDAQ symbol': 'MNTX',
  },
  {
    symbol: 'MO',
    'Security Name': 'Altria Group, ',

    'CQS symbol': 'MO',
    'NASDAQ symbol': 'MO',
  },
  {
    symbol: 'MOAT',
    'Security Name': 'VanEck Vectors Morningstar Wide Moat ETF',

    'CQS symbol': 'MOAT',
    'NASDAQ symbol': 'MOAT',
  },
  {
    symbol: 'MOD',
    'Security Name': 'Modine Manufacturing Company ',

    'CQS symbol': 'MOD',
    'NASDAQ symbol': 'MOD',
  },
  {
    symbol: 'MODN',
    'Security Name': 'Model N,  ',

    'CQS symbol': 'MODN',
    'NASDAQ symbol': 'MODN',
  },
  {
    symbol: 'MOFG',
    'Security Name': 'MidWestOne Financial Group,   ',

    'NASDAQ symbol': 'MOFG',
  },
  {
    symbol: 'MOGA',
    'Security Name': 'Moog   ',

    'CQS symbol': 'MOGA',
    'NASDAQ symbol': 'MOGA',
  },
  {
    symbol: 'MOGB',
    'Security Name': 'Moog  Class B ',

    'CQS symbol': 'MOGB',
    'NASDAQ symbol': 'MOGB',
  },
  {
    symbol: 'MOGO',
    'Security Name': 'Mogo   Common Shares',

    'NASDAQ symbol': 'MOGO',
  },
  {
    symbol: 'MOGU',
    'Security Name':
      'MOGU  American Depositary Shares (each  representing 25  Ordinary Shares)',

    'CQS symbol': 'MOGU',
    'NASDAQ symbol': 'MOGU',
  },
  {
    symbol: 'MOH',
    'Security Name': 'Molina Healthcare  ',

    'CQS symbol': 'MOH',
    'NASDAQ symbol': 'MOH',
  },
  {
    symbol: 'MOHO',
    'Security Name': 'ECMOHO Limited  American Depositary Shares',

    'NASDAQ symbol': 'MOHO',
  },
  {
    symbol: 'MOM',
    'Security Name': 'AGFiQ US Market Neutral Momentum Fund',

    'CQS symbol': 'MOM',
    'NASDAQ symbol': 'MOM',
  },
  {
    symbol: 'MOMO',
    'Security Name': 'Momo   American Depositary Shares',

    'NASDAQ symbol': 'MOMO',
  },
  {
    symbol: 'MOO',
    'Security Name': 'VanEck Vectors Agribusiness ETF',

    'CQS symbol': 'MOO',
    'NASDAQ symbol': 'MOO',
  },
  {
    symbol: 'MOON',
    'Security Name': 'Direxion Moonshot Innovators ETF',

    'CQS symbol': 'MOON',
    'NASDAQ symbol': 'MOON',
  },
  {
    symbol: 'MOR',
    'Security Name': 'MorphoSys AG  American Depositary Shares',

    'NASDAQ symbol': 'MOR',
  },
  {
    symbol: 'MORF',
    'Security Name': 'Morphic Holding,   ',

    'NASDAQ symbol': 'MORF',
  },
  {
    symbol: 'MORN',
    'Security Name': 'Morningstar,   ',

    'NASDAQ symbol': 'MORN',
  },
  {
    symbol: 'MORT',
    'Security Name': 'VanEck Vectors Mortgage REIT ome ETF',

    'CQS symbol': 'MORT',
    'NASDAQ symbol': 'MORT',
  },
  {
    symbol: 'MOS',
    'Security Name': 'Mosaic Company (The) ',

    'CQS symbol': 'MOS',
    'NASDAQ symbol': 'MOS',
  },
  {
    symbol: 'MOSY',
    'Security Name': 'MoSys,   ',

    'NASDAQ symbol': 'MOSY',
  },
  {
    symbol: 'MOTI',
    'Security Name': 'VanEck Vectors Morningstar International Moat ETF',

    'CQS symbol': 'MOTI',
    'NASDAQ symbol': 'MOTI',
  },
  {
    symbol: 'MOTNU',
    'Security Name': 'Motion Acquisition Corp  Unit',

    'NASDAQ symbol': 'MOTNU',
  },
  {
    symbol: 'MOTO',
    'Security Name': 'SmartETFs Smart Transportation & Technology ETF',

    'CQS symbol': 'MOTO',
    'NASDAQ symbol': 'MOTO',
  },
  {
    symbol: 'MOTS',
    'Security Name': 'Motus GI Holdings,   ',

    'NASDAQ symbol': 'MOTS',
  },
  {
    symbol: 'MOV',
    'Security Name': 'Movado Group  ',

    'CQS symbol': 'MOV',
    'NASDAQ symbol': 'MOV',
  },
  {
    symbol: 'MOXC',
    'Security Name': 'Moxian,   ',

    'NASDAQ symbol': 'MOXC',
  },
  {
    symbol: 'MP',
    'Security Name': 'MP Materials Corp ',

    'CQS symbol': 'MP',
    'NASDAQ symbol': 'MP',
  },
  {
    symbol: 'MPW',
    'Security Name': 'MP Materials Corp Warrants',

    'CQS symbol': 'MPWS',
    'NASDAQ symbol': 'MP+',
  },
  {
    symbol: 'MPA',
    'Security Name': 'Blackrock MuniYield Pennsylvania Quality Fund ',

    'CQS symbol': 'MPA',
    'NASDAQ symbol': 'MPA',
  },
  {
    symbol: 'MPAA',
    'Security Name': 'Motorcar Parts of America,   ',

    'NASDAQ symbol': 'MPAA',
  },
  {
    symbol: 'MPB',
    'Security Name': 'Mid Penn Bancorp  ',

    'NASDAQ symbol': 'MPB',
  },
  {
    symbol: 'MPC',
    'Security Name': 'Marathon Petroleum Corporation ',

    'CQS symbol': 'MPC',
    'NASDAQ symbol': 'MPC',
  },
  {
    symbol: 'MPLN',
    'Security Name': 'MultiPlan Corporation  ',

    'CQS symbol': 'MPLN',
    'NASDAQ symbol': 'MPLN',
  },
  {
    symbol: 'MPLNW',
    'Security Name': 'MultiPlan Corporation Warrants',

    'CQS symbol': 'MPLNWS',
    'NASDAQ symbol': 'MPLN+',
  },
  {
    symbol: 'MPLX',
    'Security Name':
      'MPLX LP Common Units Representing Limited Partner Interests',

    'CQS symbol': 'MPLX',
    'NASDAQ symbol': 'MPLX',
  },
  {
    symbol: 'MPV',
    'Security Name': 'Barings Participation Investors ',

    'CQS symbol': 'MPV',
    'NASDAQ symbol': 'MPV',
  },
  {
    symbol: 'MPW',
    'Security Name': 'Medical Properties Trust,  ',

    'CQS symbol': 'MPW',
    'NASDAQ symbol': 'MPW',
  },
  {
    symbol: 'MPWR',
    'Security Name': 'Monolithic Power Systems,   ',

    'NASDAQ symbol': 'MPWR',
  },
  {
    symbol: 'MPX',
    'Security Name': 'Marine Products Corporation ',

    'CQS symbol': 'MPX',
    'NASDAQ symbol': 'MPX',
  },
  {
    symbol: 'MQT',
    'Security Name': 'Blackrock MuniYield Quality Fund II,  ',

    'CQS symbol': 'MQT',
    'NASDAQ symbol': 'MQT',
  },
  {
    symbol: 'MQY',
    'Security Name': 'Blackrock MuniYield Quality Fund,  ',

    'CQS symbol': 'MQY',
    'NASDAQ symbol': 'MQY',
  },
  {
    symbol: 'MRAM',
    'Security Name': 'Everspin Technologies,   ',

    'NASDAQ symbol': 'MRAM',
  },
  {
    symbol: 'MRBK',
    'Security Name': 'Meridian Corporation  ',

    'NASDAQ symbol': 'MRBK',
  },
  {
    symbol: 'MRC',
    'Security Name': 'MRC Global  ',

    'CQS symbol': 'MRC',
    'NASDAQ symbol': 'MRC',
  },
  {
    symbol: 'MRCC',
    'Security Name': 'Monroe Capital Corporation  ',

    'NASDAQ symbol': 'MRCC',
  },
  {
    symbol: 'MRCCL',
    'Security Name': 'Monroe Capital Corporation  575% Notes due 2023',

    'NASDAQ symbol': 'MRCCL',
  },
  {
    symbol: 'MRCY',
    'Security Name': 'Mercury Systems   ',

    'NASDAQ symbol': 'MRCY',
  },
  {
    symbol: 'MREO',
    'Security Name': 'Mereo BioPharma Group plc  American Depositary Shares',

    'NASDAQ symbol': 'MREO',
  },
  {
    symbol: 'MRGR',
    'Security Name': 'ProShares Merger ETF',

    'CQS symbol': 'MRGR',
    'NASDAQ symbol': 'MRGR',
  },
  {
    symbol: 'MRIN',
    'Security Name': 'Marin Software orporated  ',

    'NASDAQ symbol': 'MRIN',
  },
  {
    symbol: 'MRK',
    'Security Name': 'Merck & Company,   (new)',

    'CQS symbol': 'MRK',
    'NASDAQ symbol': 'MRK',
  },
  {
    symbol: 'MRKR',
    'Security Name': 'Marker Therapeutics,   ',

    'NASDAQ symbol': 'MRKR',
  },
  {
    symbol: 'MRLN',
    'Security Name': 'Marlin Business Services Corp  ',

    'NASDAQ symbol': 'MRLN',
  },
  {
    symbol: 'MRNA',
    'Security Name': 'Moderna,   ',

    'NASDAQ symbol': 'MRNA',
  },
  {
    symbol: 'MRNS',
    'Security Name': 'Marinus Pharmaceuticals,   ',

    'NASDAQ symbol': 'MRNS',
  },
  {
    symbol: 'MRO',
    'Security Name': 'Marathon Oil Corporation ',

    'CQS symbol': 'MRO',
    'NASDAQ symbol': 'MRO',
  },
  {
    symbol: 'MRSK',
    'Security Name': 'Agility Shares Managed Risk ETF',

    'CQS symbol': 'MRSK',
    'NASDAQ symbol': 'MRSK',
  },
  {
    symbol: 'MRSN',
    'Security Name': 'Mersana Therapeutics,   ',

    'NASDAQ symbol': 'MRSN',
  },
  {
    symbol: 'MRTN',
    'Security Name': 'Marten Transport, Ltd  ',

    'NASDAQ symbol': 'MRTN',
  },
  {
    symbol: 'MRTX',
    'Security Name': 'Mirati Therapeutics,   ',

    'NASDAQ symbol': 'MRTX',
  },
  {
    symbol: 'MRUS',
    'Security Name': 'Merus NV  Common Shares',

    'NASDAQ symbol': 'MRUS',
  },
  {
    symbol: 'MRVI',
    'Security Name': 'Maravai LifeSciences Holdings,    ',

    'NASDAQ symbol': 'MRVI',
  },
  {
    symbol: 'MRVL',
    'Security Name': 'Marvell Technology Group Ltd  ',

    'NASDAQ symbol': 'MRVL',
  },
  {
    symbol: 'MS',
    'Security Name': 'Morgan Stanley ',

    'CQS symbol': 'MS',
    'NASDAQ symbol': 'MS',
  },
  {
    symbol: 'MS$A',
    'Security Name': 'Morgan Stanley Dep Shs repstg 1/1000 Pfd Ser A',

    'CQS symbol': 'MSpA',
    'NASDAQ symbol': 'MSA',
  },
  {
    symbol: 'MS$E',
    'Security Name':
      'Morgan Stanley DEPOSITARY SHARES REP 1/1000TH SHARES FIXED/FLTG PREFERRED STOCK SERIES E',

    'CQS symbol': 'MSpE',
    'NASDAQ symbol': 'MSE',
  },
  {
    symbol: 'MS$F',
    'Security Name':
      'Morgan Stanley Dep Shs Rpstg 1/1000th Int Prd Ser F Fxd to Flag',

    'CQS symbol': 'MSpF',
    'NASDAQ symbol': 'MSF',
  },
  {
    symbol: 'MS$I',
    'Security Name':
      'Morgan Stanley  Representing 1/1000th Preferred Series 1 Fixed to Floating Non (Cum)',

    'CQS symbol': 'MSpI',
    'NASDAQ symbol': 'MSI',
  },
  {
    symbol: 'MS$K',
    'Security Name':
      'Morgan Stanley Depositary Shares, each representing 1/1,000th of a share of FixedtoFloating Rate NonCumulative Preferred Stock,  Series K',

    'CQS symbol': 'MSpK',
    'NASDAQ symbol': 'MSK',
  },
  {
    symbol: 'MS$L',
    'Security Name':
      'Morgan Stanley Depositary Shares, each representing 1/1,000th of a share of 4875% NonCumulative Preferred Stock, Series L',

    'CQS symbol': 'MSpL',
    'NASDAQ symbol': 'MSL',
  },
  {
    symbol: 'MSA',
    'Security Name': 'MSA Safety orporated ',

    'CQS symbol': 'MSA',
    'NASDAQ symbol': 'MSA',
  },
  {
    symbol: 'MSB',
    'Security Name': 'Mesabi Trust ',

    'CQS symbol': 'MSB',
    'NASDAQ symbol': 'MSB',
  },
  {
    symbol: 'MSBI',
    'Security Name': 'Midland States Bancorp,   ',

    'NASDAQ symbol': 'MSBI',
  },
  {
    symbol: 'MSC',
    'Security Name':
      'Studio City International Holdings Limited American depositary shares, each representing four   ordinary shares',

    'CQS symbol': 'MSC',
    'NASDAQ symbol': 'MSC',
  },
  {
    symbol: 'MSCI',
    'Security Name': 'MSCI  ',

    'CQS symbol': 'MSCI',
    'NASDAQ symbol': 'MSCI',
  },
  {
    symbol: 'MSD',
    'Security Name': 'Morgan Stanley Emerging Markets Debt Fund,  ',

    'CQS symbol': 'MSD',
    'NASDAQ symbol': 'MSD',
  },
  {
    symbol: 'MSEX',
    'Security Name': 'Middlesex Water Company  ',

    'NASDAQ symbol': 'MSEX',
  },
  {
    symbol: 'MSFT',
    'Security Name': 'Microsoft Corporation  ',

    'NASDAQ symbol': 'MSFT',
  },
  {
    symbol: 'MSGE',
    'Security Name': 'Madison Square Garden Entertainment Corp   ',

    'CQS symbol': 'MSGE',
    'NASDAQ symbol': 'MSGE',
  },
  {
    symbol: 'MSGN',
    'Security Name': 'MSG Networks  ',

    'CQS symbol': 'MSGN',
    'NASDAQ symbol': 'MSGN',
  },
  {
    symbol: 'MSGS',
    'Security Name': 'Madison Square Garden Sports Corp   (New)',

    'CQS symbol': 'MSGS',
    'NASDAQ symbol': 'MSGS',
  },
  {
    symbol: 'MSI',
    'Security Name': 'Motorola Solutions,  ',

    'CQS symbol': 'MSI',
    'NASDAQ symbol': 'MSI',
  },
  {
    symbol: 'MSM',
    'Security Name': 'MSC Industrial Direct Company,  ',

    'CQS symbol': 'MSM',
    'NASDAQ symbol': 'MSM',
  },
  {
    symbol: 'MSN',
    'Security Name': 'Emerson Radio Corporation ',

    'CQS symbol': 'MSN',
    'NASDAQ symbol': 'MSN',
  },
  {
    symbol: 'MSON',
    'Security Name': 'MISONIX,   ',

    'NASDAQ symbol': 'MSON',
  },
  {
    symbol: 'MSOS',
    'Security Name': 'AdvisorShares Trust AdvisorShares Pure US Cannabis ETF',

    'CQS symbol': 'MSOS',
    'NASDAQ symbol': 'MSOS',
  },
  {
    symbol: 'MSP',
    'Security Name': 'Datto Holding Corp ',

    'CQS symbol': 'MSP',
    'NASDAQ symbol': 'MSP',
  },
  {
    symbol: 'MSTB',
    'Security Name': 'LHA Market State Tactical Beta ETF',

    'CQS symbol': 'MSTB',
    'NASDAQ symbol': 'MSTB',
  },
  {
    symbol: 'MSTR',
    'Security Name': 'MicroStrategy orporated   ',

    'NASDAQ symbol': 'MSTR',
  },
  {
    symbol: 'MSVB',
    'Security Name': 'MidSouthern Bancorp,   ',

    'NASDAQ symbol': 'MSVB',
  },
  {
    symbol: 'MSVX',
    'Security Name': 'LHA Market State Alpha Seeker ETF',

    'CQS symbol': 'MSVX',
    'NASDAQ symbol': 'MSVX',
  },
  {
    symbol: 'MT',
    'Security Name': 'Arcelor Mittal NY Registry Shares NEW',

    'CQS symbol': 'MT',
    'NASDAQ symbol': 'MT',
  },
  {
    symbol: 'MTA',
    'Security Name': 'Metalla Royalty & Streaming Ltd Common Shares',

    'CQS symbol': 'MTA',
    'NASDAQ symbol': 'MTA',
  },
  {
    symbol: 'MTB',
    'Security Name': 'M&T Bank Corporation ',

    'CQS symbol': 'MTB',
    'NASDAQ symbol': 'MTB',
  },
  {
    symbol: 'MTBC',
    'Security Name': 'MTBC,   ',

    'NASDAQ symbol': 'MTBC',
  },
  {
    symbol: 'MTBCP',
    'Security Name':
      'MTBC,   11% Series A Cumulative Redeemable Perpetual Preferred Stock',

    'NASDAQ symbol': 'MTBCP',
  },
  {
    symbol: 'MTC',
    'Security Name': 'MMTec,   Common Shares',

    'NASDAQ symbol': 'MTC',
  },
  {
    symbol: 'MTCH',
    'Security Name': 'Match Group,   ',

    'NASDAQ symbol': 'MTCH',
  },
  {
    symbol: 'MTCN',
    'Security Name':
      'ArcelorMittal 550% Mandatorily Convertible Subordinated Notes due 2023',

    'CQS symbol': 'MTCN',
    'NASDAQ symbol': 'MTCN',
  },
  {
    symbol: 'MTCR',
    'Security Name': 'Metacrine,   ',

    'NASDAQ symbol': 'MTCR',
  },
  {
    symbol: 'MTD',
    'Security Name': 'MettlerToledo International,  ',

    'CQS symbol': 'MTD',
    'NASDAQ symbol': 'MTD',
  },
  {
    symbol: 'MTDR',
    'Security Name': 'Matador Resources Company ',

    'CQS symbol': 'MTDR',
    'NASDAQ symbol': 'MTDR',
  },
  {
    symbol: 'MTEM',
    'Security Name': 'Molecular Templates,   ',

    'NASDAQ symbol': 'MTEM',
  },
  {
    symbol: 'MTEX',
    'Security Name': 'Mannatech, orporated  ',

    'NASDAQ symbol': 'MTEX',
  },
  {
    symbol: 'MTG',
    'Security Name': 'MGIC Investment Corporation ',

    'CQS symbol': 'MTG',
    'NASDAQ symbol': 'MTG',
  },
  {
    symbol: 'MTGP',
    'Security Name': 'WisdomTree Mortgage Plus Bond Fund',

    'CQS symbol': 'MTGP',
    'NASDAQ symbol': 'MTGP',
  },
  {
    symbol: 'MTH',
    'Security Name': 'Meritage Homes Corporation ',

    'CQS symbol': 'MTH',
    'NASDAQ symbol': 'MTH',
  },
  {
    symbol: 'MTL',
    'Security Name':
      'Mechel PAO American Depositary Shares (Each rep 1 common shares)',

    'CQS symbol': 'MTL',
    'NASDAQ symbol': 'MTL',
  },
  {
    symbol: 'MTL$',
    'Security Name':
      'Mechel PAO American Depositary Shares (each representing onehalf of a Preferred Share)',

    'CQS symbol': 'MTLp',
    'NASDAQ symbol': 'MTL',
  },
  {
    symbol: 'MTLS',
    'Security Name': 'Materialise NV  American Depositary Shares',

    'NASDAQ symbol': 'MTLS',
  },
  {
    symbol: 'MTN',
    'Security Name': 'Vail Resorts,  ',

    'CQS symbol': 'MTN',
    'NASDAQ symbol': 'MTN',
  },
  {
    symbol: 'MTNB',
    'Security Name': 'Matinas Biopharma Holdings,  ',

    'CQS symbol': 'MTNB',
    'NASDAQ symbol': 'MTNB',
  },
  {
    symbol: 'MTOR',
    'Security Name': 'Meritor,  ',

    'CQS symbol': 'MTOR',
    'NASDAQ symbol': 'MTOR',
  },
  {
    symbol: 'MTP',
    'Security Name': 'Midatech Pharma PLC  American Depositary Shares',

    'NASDAQ symbol': 'MTP',
  },
  {
    symbol: 'MTR',
    'Security Name': 'Mesa Royalty Trust ',

    'CQS symbol': 'MTR',
    'NASDAQ symbol': 'MTR',
  },
  {
    symbol: 'MTRN',
    'Security Name': 'Materion Corporation',

    'CQS symbol': 'MTRN',
    'NASDAQ symbol': 'MTRN',
  },
  {
    symbol: 'MTRX',
    'Security Name': 'Matrix Service Company  ',

    'NASDAQ symbol': 'MTRX',
  },
  {
    symbol: 'MTSC',
    'Security Name': 'MTS Systems Corporation  ',

    'NASDAQ symbol': 'MTSC',
  },
  {
    symbol: 'MTSI',
    'Security Name': 'MACOM Technology Solutions Holdings,   ',

    'NASDAQ symbol': 'MTSI',
  },
  {
    symbol: 'MTSL',
    'Security Name': 'MER Telemanagement Solutions Ltd  Ordinary Shares',

    'NASDAQ symbol': 'MTSL',
  },
  {
    symbol: 'MTT',
    'Security Name': 'Western Asset Municipal Defined Opportunity Trust  ',

    'CQS symbol': 'MTT',
    'NASDAQ symbol': 'MTT',
  },
  {
    symbol: 'MTUM',
    'Security Name': 'iShares MSCI USA Momentum Factor ETF',

    'CQS symbol': 'MTUM',
    'NASDAQ symbol': 'MTUM',
  },
  {
    symbol: 'MTW',
    'Security Name': 'Manitowoc Company,  (The) ',

    'CQS symbol': 'MTW',
    'NASDAQ symbol': 'MTW',
  },
  {
    symbol: 'MTX',
    'Security Name': 'Minerals Technologies  ',

    'CQS symbol': 'MTX',
    'NASDAQ symbol': 'MTX',
  },
  {
    symbol: 'MTZ',
    'Security Name': 'MasTec,  ',

    'CQS symbol': 'MTZ',
    'NASDAQ symbol': 'MTZ',
  },
  {
    symbol: 'MU',
    'Security Name': 'Micron Technology,   ',

    'NASDAQ symbol': 'MU',
  },
  {
    symbol: 'MUA',
    'Security Name': 'Blackrock MuniAssets Fund,  ',

    'CQS symbol': 'MUA',
    'NASDAQ symbol': 'MUA',
  },
  {
    symbol: 'MUB',
    'Security Name': 'iShares National Muni Bond ETF',

    'CQS symbol': 'MUB',
    'NASDAQ symbol': 'MUB',
  },
  {
    symbol: 'MUC',
    'Security Name': 'Blackrock MuniHoldings California Quality Fund,   ',

    'CQS symbol': 'MUC',
    'NASDAQ symbol': 'MUC',
  },
  {
    symbol: 'MUE',
    'Security Name': 'Blackrock MuniHoldings Quality Fund II,  ',

    'CQS symbol': 'MUE',
    'NASDAQ symbol': 'MUE',
  },
  {
    symbol: 'MUFG',
    'Security Name': 'Mitsubishi UFJ Financial Group,  ',

    'CQS symbol': 'MUFG',
    'NASDAQ symbol': 'MUFG',
  },
  {
    symbol: 'MUH',
    'Security Name': 'Blackrock MuniHoldings Fund II,  ',

    'CQS symbol': 'MUH',
    'NASDAQ symbol': 'MUH',
  },
  {
    symbol: 'MUI',
    'Security Name': 'Blackrock Muni Intermediate Duration Fund  ',

    'CQS symbol': 'MUI',
    'NASDAQ symbol': 'MUI',
  },
  {
    symbol: 'MUJ',
    'Security Name': 'Blackrock MuniHoldings New Jersey Quality Fund,  ',

    'CQS symbol': 'MUJ',
    'NASDAQ symbol': 'MUJ',
  },
  {
    symbol: 'MUNI',
    'Security Name':
      'PIMCO Intermediate Municipal Bond Active ExchangeTraded Fund',

    'CQS symbol': 'MUNI',
    'NASDAQ symbol': 'MUNI',
  },
  {
    symbol: 'MUR',
    'Security Name': 'Murphy Oil Corporation ',

    'CQS symbol': 'MUR',
    'NASDAQ symbol': 'MUR',
  },
  {
    symbol: 'MUS',
    'Security Name': 'Blackrock MuniHoldings Quality Fund,  ',

    'CQS symbol': 'MUS',
    'NASDAQ symbol': 'MUS',
  },
  {
    symbol: 'MUSA',
    'Security Name': 'Murphy USA  ',

    'CQS symbol': 'MUSA',
    'NASDAQ symbol': 'MUSA',
  },
  {
    symbol: 'MUST',
    'Security Name': 'Columbia MultiSector Municipal ome ETF',

    'CQS symbol': 'MUST',
    'NASDAQ symbol': 'MUST',
  },
  {
    symbol: 'MUX',
    'Security Name': 'McEwen Mining  ',

    'CQS symbol': 'MUX',
    'NASDAQ symbol': 'MUX',
  },
  {
    symbol: 'MVBF',
    'Security Name': 'MVB Financial Corp  ',

    'NASDAQ symbol': 'MVBF',
  },
  {
    symbol: 'MVC',
    'Security Name': 'MVC Capital,  ',

    'CQS symbol': 'MVC',
    'NASDAQ symbol': 'MVC',
  },
  {
    symbol: 'MVCD',
    'Security Name': 'MVC Capital,  625% Senior Notes due 2022',

    'CQS symbol': 'MVCD',
    'NASDAQ symbol': 'MVCD',
  },
  {
    symbol: 'MVF',
    'Security Name': 'Blackrock MuniVest Fund,  ',

    'CQS symbol': 'MVF',
    'NASDAQ symbol': 'MVF',
  },
  {
    symbol: 'MVIN',
    'Security Name': 'Natixis ETF Trust ETF',

    'CQS symbol': 'MVIN',
    'NASDAQ symbol': 'MVIN',
  },
  {
    symbol: 'MVIS',
    'Security Name': 'MicroVision,   ',

    'NASDAQ symbol': 'MVIS',
  },
  {
    symbol: 'MVO',
    'Security Name': 'MV Oil Trust Units of Beneficial Interests',

    'CQS symbol': 'MVO',
    'NASDAQ symbol': 'MVO',
  },
  {
    symbol: 'MVRL',
    'Security Name': 'ETRACS Monthly Pay 15X Leveraged Mortgage REIT ETN',

    'CQS symbol': 'MVRL',
    'NASDAQ symbol': 'MVRL',
  },
  {
    symbol: 'MVT',
    'Security Name': 'Blackrock MuniVest Fund II,   ',

    'CQS symbol': 'MVT',
    'NASDAQ symbol': 'MVT',
  },
  {
    symbol: 'MVV',
    'Security Name': 'ProShares Ultra MidCap400',

    'CQS symbol': 'MVV',
    'NASDAQ symbol': 'MVV',
  },
  {
    symbol: 'MWA',
    'Security Name': 'MUELLER WATER PRODUCTS ',

    'CQS symbol': 'MWA',
    'NASDAQ symbol': 'MWA',
  },
  {
    symbol: 'MWK',
    'Security Name': 'Mohawk Group Holdings,   ',

    'NASDAQ symbol': 'MWK',
  },
  {
    symbol: 'MX',
    'Security Name':
      'MagnaChip Semiconductor Corporation Depositary Shares, each representing one share of ',

    'CQS symbol': 'MX',
    'NASDAQ symbol': 'MX',
  },
  {
    symbol: 'MXC',
    'Security Name': 'Mexco Energy Corporation ',

    'CQS symbol': 'MXC',
    'NASDAQ symbol': 'MXC',
  },
  {
    symbol: 'MXDU',
    'Security Name': 'Nationwide Maximum Diversification US Core Equity ETF',

    'CQS symbol': 'MXDU',
    'NASDAQ symbol': 'MXDU',
  },
  {
    symbol: 'MXE',
    'Security Name': 'Mexico Equity and ome Fund,  (The) ',

    'CQS symbol': 'MXE',
    'NASDAQ symbol': 'MXE',
  },
  {
    symbol: 'MXF',
    'Security Name': 'Mexico Fund,  (The) ',

    'CQS symbol': 'MXF',
    'NASDAQ symbol': 'MXF',
  },
  {
    symbol: 'MXI',
    'Security Name': 'iShares Global Materials ETF',

    'CQS symbol': 'MXI',
    'NASDAQ symbol': 'MXI',
  },
  {
    symbol: 'MXIM',
    'Security Name': 'Maxim Integrated Products,   ',

    'NASDAQ symbol': 'MXIM',
  },
  {
    symbol: 'MXL',
    'Security Name': 'MaxLinear,  ',

    'CQS symbol': 'MXL',
    'NASDAQ symbol': 'MXL',
  },
  {
    symbol: 'MYC',
    'Security Name': 'Blackrock MuniYield California Fund,  ',

    'CQS symbol': 'MYC',
    'NASDAQ symbol': 'MYC',
  },
  {
    symbol: 'MYD',
    'Security Name': 'Blackrock MuniYield Fund,   ',

    'CQS symbol': 'MYD',
    'NASDAQ symbol': 'MYD',
  },
  {
    symbol: 'MYE',
    'Security Name': 'Myers Industries,  ',

    'CQS symbol': 'MYE',
    'NASDAQ symbol': 'MYE',
  },
  {
    symbol: 'MYF',
    'Security Name': 'Blackrock MuniYield Investment Fund ',

    'CQS symbol': 'MYF',
    'NASDAQ symbol': 'MYF',
  },
  {
    symbol: 'MYFW',
    'Security Name': 'First Western Financial,   ',

    'NASDAQ symbol': 'MYFW',
  },
  {
    symbol: 'MYGN',
    'Security Name': 'Myriad Genetics,   ',

    'NASDAQ symbol': 'MYGN',
  },
  {
    symbol: 'MYI',
    'Security Name': 'Blackrock MuniYield Quality Fund III,  ',

    'CQS symbol': 'MYI',
    'NASDAQ symbol': 'MYI',
  },
  {
    symbol: 'MYJ',
    'Security Name': 'Blackrock MuniYield New Jersey Fund,  ',

    'CQS symbol': 'MYJ',
    'NASDAQ symbol': 'MYJ',
  },
  {
    symbol: 'MYN',
    'Security Name': 'Blackrock MuniYield New York Quality Fund, ',

    'CQS symbol': 'MYN',
    'NASDAQ symbol': 'MYN',
  },
  {
    symbol: 'MYO',
    'Security Name': 'Myomo  ',

    'CQS symbol': 'MYO',
    'NASDAQ symbol': 'MYO',
  },
  {
    symbol: 'MYOV',
    'Security Name': 'Myovant Sciences Ltd Common Shares',

    'CQS symbol': 'MYOV',
    'NASDAQ symbol': 'MYOV',
  },
  {
    symbol: 'MYRG',
    'Security Name': 'MYR Group,   ',

    'NASDAQ symbol': 'MYRG',
  },
  {
    symbol: 'MYSZ',
    'Security Name': 'My Size,   ',

    'NASDAQ symbol': 'MYSZ',
  },
  {
    symbol: 'MYT',
    'Security Name': 'Urban Tea,   Ordinary Shares',

    'NASDAQ symbol': 'MYT',
  },
  {
    symbol: 'MYY',
    'Security Name': 'ProShares Short MidCap400',

    'CQS symbol': 'MYY',
    'NASDAQ symbol': 'MYY',
  },
  {
    symbol: 'MZA',
    'Security Name': 'Blackrock MuniYield Arizona Fund,  ',

    'CQS symbol': 'MZA',
    'NASDAQ symbol': 'MZA',
  },
  {
    symbol: 'MZZ',
    'Security Name': 'ProShares UltraShort MidCap400',

    'CQS symbol': 'MZZ',
    'NASDAQ symbol': 'MZZ',
  },
  {
    symbol: 'NAC',
    'Security Name': 'Nuveen California Quality Municipal ome Fund',

    'CQS symbol': 'NAC',
    'NASDAQ symbol': 'NAC',
  },
  {
    symbol: 'NACP',
    'Security Name':
      'Impact Shares Trust I Impact Shares NAACP Minority Empowerment ETF',

    'CQS symbol': 'NACP',
    'NASDAQ symbol': 'NACP',
  },
  {
    symbol: 'NAD',
    'Security Name': 'Nuveen Quality Municipal ome Fund ',

    'CQS symbol': 'NAD',
    'NASDAQ symbol': 'NAD',
  },
  {
    symbol: 'NAII',
    'Security Name': 'Natural Alternatives International,   ',

    'NASDAQ symbol': 'NAII',
  },
  {
    symbol: 'NAIL',
    'Security Name': 'Direxion Daily Homebuilders & Supplies Bull 3X Shares',

    'CQS symbol': 'NAIL',
    'NASDAQ symbol': 'NAIL',
  },
  {
    symbol: 'NAK',
    'Security Name': 'Northern Dynasty Minerals, Ltd ',

    'CQS symbol': 'NAK',
    'NASDAQ symbol': 'NAK',
  },
  {
    symbol: 'NAKD',
    'Security Name': 'Naked Brand Group Limited  Ordinary Shares',

    'NASDAQ symbol': 'NAKD',
  },
  {
    symbol: 'NAN',
    'Security Name': 'Nuveen New York Quality Municipal ome Fund ',

    'CQS symbol': 'NAN',
    'NASDAQ symbol': 'NAN',
  },
  {
    symbol: 'NANR',
    'Security Name': 'SPDR S&P North American Natural Resources ETF',

    'CQS symbol': 'NANR',
    'NASDAQ symbol': 'NANR',
  },
  {
    symbol: 'NAOV',
    'Security Name': 'NanoVibronix,   ',

    'NASDAQ symbol': 'NAOV',
  },
  {
    symbol: 'NAPR',
    'Security Name': 'Innovator Nasdaq100 Power Buffer ETF  April',

    'CQS symbol': 'NAPR',
    'NASDAQ symbol': 'NAPR',
  },
  {
    symbol: 'NARI',
    'Security Name': 'Inari Medical,   ',

    'NASDAQ symbol': 'NARI',
  },
  {
    symbol: 'NAT',
    'Security Name': 'Nordic American Tankers Limited ',

    'CQS symbol': 'NAT',
    'NASDAQ symbol': 'NAT',
  },
  {
    symbol: 'NATH',
    'Security Name': "Nathan's Famous,   ",

    'NASDAQ symbol': 'NATH',
  },
  {
    symbol: 'NATI',
    'Security Name': 'National Instruments Corporation  ',

    'NASDAQ symbol': 'NATI',
  },
  {
    symbol: 'NATR',
    'Security Name': "Nature's Sunshine Products,   ",

    'NASDAQ symbol': 'NATR',
  },
  {
    symbol: 'NAV',
    'Security Name': 'Navistar International Corporation ',

    'CQS symbol': 'NAV',
    'NASDAQ symbol': 'NAV',
  },
  {
    symbol: 'NAV$D',
    'Security Name': 'Navistar International Corporation Preferred Stock',

    'CQS symbol': 'NAVpD',
    'NASDAQ symbol': 'NAVD',
  },
  {
    symbol: 'NAVB',
    'Security Name': 'Navidea Biopharmaceuticals,  ',

    'CQS symbol': 'NAVB',
    'NASDAQ symbol': 'NAVB',
  },
  {
    symbol: 'NAVI',
    'Security Name': 'Navient Corporation  ',

    'NASDAQ symbol': 'NAVI',
  },
  {
    symbol: 'NAZ',
    'Security Name': 'Nuveen Arizona Quality Municipal ome Fund ',

    'CQS symbol': 'NAZ',
    'NASDAQ symbol': 'NAZ',
  },
  {
    symbol: 'NBA',
    'Security Name': 'New Beginnings Acquisition Corp ',

    'CQS symbol': 'NBA',
    'NASDAQ symbol': 'NBA',
  },
  {
    symbol: 'NBAU',
    'Security Name':
      'New Beginnings Acquisition Corp Units, each consisting of one share of , and one redeemable warrant',

    'CQS symbol': 'NBAU',
    'NASDAQ symbol': 'NBA=',
  },
  {
    symbol: 'NBAW',
    'Security Name':
      'New Beginnings Acquisition Corp Redeemable Warrants, each warrant exercisable for one share of  at an exercise price of $1150',

    'CQS symbol': 'NBAWS',
    'NASDAQ symbol': 'NBA+',
  },
  {
    symbol: 'NBAC',
    'Security Name': 'Newborn Acquisition Corp  Ordinary Shares',

    'NASDAQ symbol': 'NBAC',
  },
  {
    symbol: 'NBACR',
    'Security Name': 'Newborn Acquisition Corp  Right',

    'NASDAQ symbol': 'NBACR',
  },
  {
    symbol: 'NBACU',
    'Security Name': 'Newborn Acquisition Corp  Unit',

    'NASDAQ symbol': 'NBACU',
  },
  {
    symbol: 'NBACW',
    'Security Name': 'Newborn Acquisition Corp  Warrant',

    'NASDAQ symbol': 'NBACW',
  },
  {
    symbol: 'NBB',
    'Security Name':
      'Nuveen Taxable Municipal ome Fund Common Shares of Beneficial Interest',

    'CQS symbol': 'NBB',
    'NASDAQ symbol': 'NBB',
  },
  {
    symbol: 'NBEV',
    'Security Name': 'NewAge,   ',

    'NASDAQ symbol': 'NBEV',
  },
  {
    symbol: 'NBH',
    'Security Name': 'Neuberger Berman Municipal Fund  ',

    'CQS symbol': 'NBH',
    'NASDAQ symbol': 'NBH',
  },
  {
    symbol: 'NBHC',
    'Security Name': 'National Bank Holdings Corporation ',

    'CQS symbol': 'NBHC',
    'NASDAQ symbol': 'NBHC',
  },
  {
    symbol: 'NBIX',
    'Security Name': 'Neurocrine Biosciences,   ',

    'NASDAQ symbol': 'NBIX',
  },
  {
    symbol: 'NBLX',
    'Security Name':
      'Noble Midstream Partners LP  Common Units, Representing Limited Partner Interests',

    'NASDAQ symbol': 'NBLX',
  },
  {
    symbol: 'NBN',
    'Security Name': 'Northeast Bank  ',

    'NASDAQ symbol': 'NBN',
  },
  {
    symbol: 'NBO',
    'Security Name': 'Neuberger Berman New York Municipal Fund  ',

    'CQS symbol': 'NBO',
    'NASDAQ symbol': 'NBO',
  },
  {
    symbol: 'NBR',
    'Security Name': 'Nabors Industries Ltd',

    'CQS symbol': 'NBR',
    'NASDAQ symbol': 'NBR',
  },
  {
    symbol: 'NBR$A',
    'Security Name':
      'Nabors Industries Ltd 600% Mandatory Convertible Preferred Shares, Series A',

    'CQS symbol': 'NBRpA',
    'NASDAQ symbol': 'NBRA',
  },
  {
    symbol: 'NBRV',
    'Security Name': 'Nabriva Therapeutics plc  Ordinary Shares',

    'NASDAQ symbol': 'NBRV',
  },
  {
    symbol: 'NBSE',
    'Security Name': 'NeuBase Therapeutics,    ',

    'NASDAQ symbol': 'NBSE',
  },
  {
    symbol: 'NBTB',
    'Security Name': 'NBT Bancorp   ',

    'NASDAQ symbol': 'NBTB',
  },
  {
    symbol: 'NBW',
    'Security Name': 'Neuberger Berman California Municipal Fund  ',

    'CQS symbol': 'NBW',
    'NASDAQ symbol': 'NBW',
  },
  {
    symbol: 'NBY',
    'Security Name': 'NovaBay Pharmaceuticals,  ',

    'CQS symbol': 'NBY',
    'NASDAQ symbol': 'NBY',
  },
  {
    symbol: 'NC',
    'Security Name': 'NACCO Industries,  ',

    'CQS symbol': 'NC',
    'NASDAQ symbol': 'NC',
  },
  {
    symbol: 'NCA',
    'Security Name': 'Nuveen California Municipal Value Fund,  ',

    'CQS symbol': 'NCA',
    'NASDAQ symbol': 'NCA',
  },
  {
    symbol: 'NCB',
    'Security Name':
      'Nuveen California Municipal Value Fund 2 Common Shares of Beneficial Interest',

    'CQS symbol': 'NCB',
    'NASDAQ symbol': 'NCB',
  },
  {
    symbol: 'NCBS',
    'Security Name': 'Nicolet Bankshares   ',

    'NASDAQ symbol': 'NCBS',
  },
  {
    symbol: 'NCLH',
    'Security Name': 'Norwegian Cruise Line Holdings Ltd Ordinary Shares',

    'CQS symbol': 'NCLH',
    'NASDAQ symbol': 'NCLH',
  },
  {
    symbol: 'NCMI',
    'Security Name': 'National CineMedia,   ',

    'NASDAQ symbol': 'NCMI',
  },
  {
    symbol: 'NCNA',
    'Security Name': 'NuCana plc  American Depositary Shares',

    'NASDAQ symbol': 'NCNA',
  },
  {
    symbol: 'NCNO',
    'Security Name': 'nCino,   ',

    'NASDAQ symbol': 'NCNO',
  },
  {
    symbol: 'NCR',
    'Security Name': 'NCR Corporation ',

    'CQS symbol': 'NCR',
    'NASDAQ symbol': 'NCR',
  },
  {
    symbol: 'NCSM',
    'Security Name': 'NCS Multistage Holdings,   ',

    'NASDAQ symbol': 'NCSM',
  },
  {
    symbol: 'NCTY',
    'Security Name': 'The9 Limited  American ',

    'NASDAQ symbol': 'NCTY',
  },
  {
    symbol: 'NCV',
    'Security Name': 'AllianzGI Convertible & ome Fund',

    'CQS symbol': 'NCV',
    'NASDAQ symbol': 'NCV',
  },
  {
    symbol: 'NCV$A',
    'Security Name':
      'AllianzGI Convertible & ome Fund 5625% Series A Cumulative Preferred Shares  (Liquidation Preference $2500 per share)',

    'CQS symbol': 'NCVpA',
    'NASDAQ symbol': 'NCVA',
  },
  {
    symbol: 'NCZ',
    'Security Name':
      'AllianzGI Convertible & ome Fund II Common Shares of Beneficial Interest',

    'CQS symbol': 'NCZ',
    'NASDAQ symbol': 'NCZ',
  },
  {
    symbol: 'NCZ$A',
    'Security Name':
      'AllianzGI Convertible & ome Fund II 550% Series A Cumulative Preferred Shares (Liquidation Preference $2500 per share)',

    'CQS symbol': 'NCZpA',
    'NASDAQ symbol': 'NCZA',
  },
  {
    symbol: 'NDAQ',
    'Security Name': 'Nasdaq,   ',

    'NASDAQ symbol': 'NDAQ',
  },
  {
    symbol: 'NDLS',
    'Security Name': 'Noodles & Company  ',

    'NASDAQ symbol': 'NDLS',
  },
  {
    symbol: 'NDMO',
    'Security Name':
      'Nuveen Dynamic Municipal Opportunities Fund Common Shares of Beneficial Interest',

    'CQS symbol': 'NDMO',
    'NASDAQ symbol': 'NDMO',
  },
  {
    symbol: 'NDP',
    'Security Name': 'Tortoise Energy Independence Fund,  ',

    'CQS symbol': 'NDP',
    'NASDAQ symbol': 'NDP',
  },
  {
    symbol: 'NDRA',
    'Security Name': 'ENDRA Life Sciences   ',

    'NASDAQ symbol': 'NDRA',
  },
  {
    symbol: 'NDRAW',
    'Security Name': 'ENDRA Life Sciences   Warrants',

    'NASDAQ symbol': 'NDRAW',
  },
  {
    symbol: 'NDSN',
    'Security Name': 'Nordson Corporation  ',

    'NASDAQ symbol': 'NDSN',
  },
  {
    symbol: 'NEA',
    'Security Name':
      'Nuveen AMTFree Quality Municipal ome Fund Common Shares of Beneficial Interest Par Value $01',

    'CQS symbol': 'NEA',
    'NASDAQ symbol': 'NEA',
  },
  {
    symbol: 'NEAR',
    'Security Name': 'BlackRock Short Maturity Bond ETF',

    'CQS symbol': 'NEAR',
    'NASDAQ symbol': 'NEAR',
  },
  {
    symbol: 'NEE',
    'Security Name': 'NextEra Energy,  ',

    'CQS symbol': 'NEE',
    'NASDAQ symbol': 'NEE',
  },
  {
    symbol: 'NEE$K',
    'Security Name':
      'NextEra Energy,  Series K Junior Subordinated Debentures due June 1, 2076',

    'CQS symbol': 'NEEpK',
    'NASDAQ symbol': 'NEEK',
  },
  {
    symbol: 'NEE$N',
    'Security Name':
      'NextEra Energy,  Series N Junior Subordinated Debentures due March 1, 2079',

    'CQS symbol': 'NEEpN',
    'NASDAQ symbol': 'NEEN',
  },
  {
    symbol: 'NEE$O',
    'Security Name': 'NextEra Energy,  4872% Corporate Units',

    'CQS symbol': 'NEEpO',
    'NASDAQ symbol': 'NEEO',
  },
  {
    symbol: 'NEE$P',
    'Security Name': 'NextEra Energy,  5279% Corporate Units',

    'CQS symbol': 'NEEpP',
    'NASDAQ symbol': 'NEEP',
  },
  {
    symbol: 'NEE$Q',
    'Security Name': 'NextEra Energy,  6219% Corporate Units',

    'CQS symbol': 'NEEpQ',
    'NASDAQ symbol': 'NEEQ',
  },
  {
    symbol: 'NEM',
    'Security Name': 'Newmont Corporation',

    'CQS symbol': 'NEM',
    'NASDAQ symbol': 'NEM',
  },
  {
    symbol: 'NEN',
    'Security Name':
      'New England Realty Associates Limited Partnership  Depositary Receipts Evidencing Units of Limited Partnership',

    'CQS symbol': 'NEN',
    'NASDAQ symbol': 'NEN',
  },
  {
    symbol: 'NEO',
    'Security Name': 'NeoGenomics,   ',

    'NASDAQ symbol': 'NEO',
  },
  {
    symbol: 'NEOG',
    'Security Name': 'Neogen Corporation  ',

    'NASDAQ symbol': 'NEOG',
  },
  {
    symbol: 'NEON',
    'Security Name': 'Neonode   ',

    'NASDAQ symbol': 'NEON',
  },
  {
    symbol: 'NEOS',
    'Security Name': 'Neos Therapeutics,   ',

    'NASDAQ symbol': 'NEOS',
  },
  {
    symbol: 'NEP',
    'Security Name':
      'NextEra Energy Partners, LP Common Units representing limited partner interests',

    'CQS symbol': 'NEP',
    'NASDAQ symbol': 'NEP',
  },
  {
    symbol: 'NEPH',
    'Security Name': 'Nephros,   ',

    'NASDAQ symbol': 'NEPH',
  },
  {
    symbol: 'NEPT',
    'Security Name': 'Neptune Wellness Solutions   Ordinary Shares',

    'NASDAQ symbol': 'NEPT',
  },
  {
    symbol: 'NERD',
    'Security Name': 'Roundhill BITKRAFT Esports & Digital Entertainment ETF',

    'CQS symbol': 'NERD',
    'NASDAQ symbol': 'NERD',
  },
  {
    symbol: 'NERV',
    'Security Name': 'Minerva Neurosciences,   ',

    'NASDAQ symbol': 'NERV',
  },
  {
    symbol: 'NES',
    'Security Name': 'Nuverra Environmental Solutions,  ',

    'CQS symbol': 'NES',
    'NASDAQ symbol': 'NES',
  },
  {
    symbol: 'NESR',
    'Security Name': 'National Energy Services Reunited Corp  Ordinary Shares',

    'NASDAQ symbol': 'NESR',
  },
  {
    symbol: 'NESRW',
    'Security Name': 'National Energy Services Reunited Corp  Warrant',

    'NASDAQ symbol': 'NESRW',
  },
  {
    symbol: 'NET',
    'Security Name': 'Cloudflare,   ',

    'CQS symbol': 'NET',
    'NASDAQ symbol': 'NET',
  },
  {
    symbol: 'NETE',
    'Security Name': 'Net Element,   ',

    'NASDAQ symbol': 'NETE',
  },
  {
    symbol: 'NETL',
    'Security Name': 'NETLease Corporate Real Estate ETF',

    'CQS symbol': 'NETL',
    'NASDAQ symbol': 'NETL',
  },
  {
    symbol: 'NEU',
    'Security Name': 'NewMarket Corp ',

    'CQS symbol': 'NEU',
    'NASDAQ symbol': 'NEU',
  },
  {
    symbol: 'NEV',
    'Security Name':
      'Nuveen Enhanced Municipal Value Fund Common Shares of Beneficial Interest',

    'CQS symbol': 'NEV',
    'NASDAQ symbol': 'NEV',
  },
  {
    symbol: 'NEW',
    'Security Name':
      'Puxin Limited American Depositary Shares, each representing two Ordinary Shares',

    'CQS symbol': 'NEW',
    'NASDAQ symbol': 'NEW',
  },
  {
    symbol: 'NEWA',
    'Security Name': 'Newater Technology,   Ordinary Shares',

    'NASDAQ symbol': 'NEWA',
  },
  {
    symbol: 'NEWR',
    'Security Name': 'New Relic,  ',

    'CQS symbol': 'NEWR',
    'NASDAQ symbol': 'NEWR',
  },
  {
    symbol: 'NEWT',
    'Security Name': 'Newtek Business Services Corp  ',

    'NASDAQ symbol': 'NEWT',
  },
  {
    symbol: 'NEWTI',
    'Security Name': 'Newtek Business Services Corp  625% Notes Due 2023',

    'NASDAQ symbol': 'NEWTI',
  },
  {
    symbol: 'NEWTL',
    'Security Name': 'Newtek Business Services Corp  575% Notes due 2024',

    'NASDAQ symbol': 'NEWTL',
  },
  {
    symbol: 'NEX',
    'Security Name': 'NexTier Oilfield Solutions  ',

    'CQS symbol': 'NEX',
    'NASDAQ symbol': 'NEX',
  },
  {
    symbol: 'NEXA',
    'Security Name': 'Nexa Resources SA Common Shares',

    'CQS symbol': 'NEXA',
    'NASDAQ symbol': 'NEXA',
  },
  {
    symbol: 'NEXT',
    'Security Name': 'NextDecade Corporation  ',

    'NASDAQ symbol': 'NEXT',
  },
  {
    symbol: 'NFBK',
    'Security Name': 'Northfield Bancorp,   ',

    'NASDAQ symbol': 'NFBK',
  },
  {
    symbol: 'NFE',
    'Security Name': 'New Fortress Energy    ',

    'NASDAQ symbol': 'NFE',
  },
  {
    symbol: 'NFG',
    'Security Name': 'National Fuel Gas Company ',

    'CQS symbol': 'NFG',
    'NASDAQ symbol': 'NFG',
  },
  {
    symbol: 'NFH',
    'Security Name': 'New Frontier Health Corporation Ordinary Shares',

    'CQS symbol': 'NFH',
    'NASDAQ symbol': 'NFH',
  },
  {
    symbol: 'NFHW',
    'Security Name': 'New Frontier Health Corporation Warrants',

    'CQS symbol': 'NFHWS',
    'NASDAQ symbol': 'NFH+',
  },
  {
    symbol: 'NFJ',
    'Security Name': 'AllianzGI Dividend, Interest & Premium Strategy Fund',

    'CQS symbol': 'NFJ',
    'NASDAQ symbol': 'NFJ',
  },
  {
    symbol: 'NFLT',
    'Security Name': 'Virtus Newfleet MultiSector Bond ETF',

    'CQS symbol': 'NFLT',
    'NASDAQ symbol': 'NFLT',
  },
  {
    symbol: 'NFLX',
    'Security Name': 'Netflix,   ',

    'NASDAQ symbol': 'NFLX',
  },
  {
    symbol: 'NFRA',
    'Security Name': 'FlexShares STOXX Global Broad Infrastructure Index Fund',

    'CQS symbol': 'NFRA',
    'NASDAQ symbol': 'NFRA',
  },
  {
    symbol: 'NFTY',
    'Security Name': 'First Trust India Nifty 50 Equal Weight ETF',

    'NASDAQ symbol': 'NFTY',
  },
  {
    symbol: 'NG',
    'Security Name': 'Novagold Resources ',

    'CQS symbol': 'NG',
    'NASDAQ symbol': 'NG',
  },
  {
    symbol: 'NGA',
    'Security Name': 'Northern Genesis Acquisition Corp ',

    'CQS symbol': 'NGA',
    'NASDAQ symbol': 'NGA',
  },
  {
    symbol: 'NGAU',
    'Security Name':
      'Northern Genesis Acquisition Corp Units, each consisting of one share of  and onehalf of one redeemable warrant',

    'CQS symbol': 'NGAU',
    'NASDAQ symbol': 'NGA=',
  },
  {
    symbol: 'NGAW',
    'Security Name':
      'Northern Genesis Acquisition Corp Redeemable Warrants, each warrant exercisable for shares of  at an exercise price of $1150 per share',

    'CQS symbol': 'NGAWS',
    'NASDAQ symbol': 'NGA+',
  },
  {
    symbol: 'NGACU',
    'Security Name': 'NextGen Acquisition Corporation  Units',

    'NASDAQ symbol': 'NGACU',
  },
  {
    symbol: 'NGD',
    'Security Name': 'New Gold ',

    'CQS symbol': 'NGD',
    'NASDAQ symbol': 'NGD',
  },
  {
    symbol: 'NGE',
    'Security Name': 'Global X MSCI Nigeria ETF',

    'CQS symbol': 'NGE',
    'NASDAQ symbol': 'NGE',
  },
  {
    symbol: 'NGG',
    'Security Name':
      'National Grid Transco, PLC National Grid PLC (NEW) American Depositary Shares',

    'CQS symbol': 'NGG',
    'NASDAQ symbol': 'NGG',
  },
  {
    symbol: 'NGHC',
    'Security Name': 'National General Holdings Corp  ',

    'NASDAQ symbol': 'NGHC',
  },
  {
    symbol: 'NGHCN',
    'Security Name':
      'National General Holdings Corp  Depositary Shares, each representing 1/40th of a share of 750% NonCumulative Preferred Stock, Series C',

    'NASDAQ symbol': 'NGHCN',
  },
  {
    symbol: 'NGHCO',
    'Security Name': 'National General Holdings Corp  Depositary Shares',

    'NASDAQ symbol': 'NGHCO',
  },
  {
    symbol: 'NGHCP',
    'Security Name':
      'National General Holdings Corp  750% NonCumulative Preferred Stock, Series A',

    'NASDAQ symbol': 'NGHCP',
  },
  {
    symbol: 'NGHCZ',
    'Security Name':
      'National General Holdings Corp  7625% Subordinated Notes due 2055',

    'NASDAQ symbol': 'NGHCZ',
  },
  {
    symbol: 'NGL',
    'Security Name':
      'NGL ENERGY PARTNERS LP Common Units representing Limited Partner Interests',

    'CQS symbol': 'NGL',
    'NASDAQ symbol': 'NGL',
  },
  {
    symbol: 'NGL$B',
    'Security Name':
      'NGL ENERGY PARTNERS LP 900% Class B FixedtoFloating Rate Cumulative Redeemable Perpetual Preferred Units representing limited partnership interests',

    'CQS symbol': 'NGLpB',
    'NASDAQ symbol': 'NGLB',
  },
  {
    symbol: 'NGL$C',
    'Security Name':
      'NGL ENERGY PARTNERS LP 9625% Class C FixedtoFloating Rate Cumulative  Redeemable Perpetual Preferred Units representing  limited partner interests',

    'CQS symbol': 'NGLpC',
    'NASDAQ symbol': 'NGLC',
  },
  {
    symbol: 'NGLS$A',
    'Security Name':
      'Targa Resources Partners LP 900% Series A FixedtoFloating Rate Cumulative Redeemable Perpetual Preferred Units representing preferred equity interests',

    'CQS symbol': 'NGLSpA',
    'NASDAQ symbol': 'NGLSA',
  },
  {
    symbol: 'NGM',
    'Security Name': 'NGM Biopharmaceuticals,   ',

    'NASDAQ symbol': 'NGM',
  },
  {
    symbol: 'NGMS',
    'Security Name': 'NeoGames SA  Ordinary Shares',

    'NASDAQ symbol': 'NGMS',
  },
  {
    symbol: 'NGS',
    'Security Name': 'Natural Gas Services Group,  ',

    'CQS symbol': 'NGS',
    'NASDAQ symbol': 'NGS',
  },
  {
    symbol: 'NGVC',
    'Security Name': 'Natural Grocers by Vitamin Cottage,  ',

    'CQS symbol': 'NGVC',
    'NASDAQ symbol': 'NGVC',
  },
  {
    symbol: 'NGVT',
    'Security Name': 'Ingevity Corporation  ',

    'CQS symbol': 'NGVT',
    'NASDAQ symbol': 'NGVT',
  },
  {
    symbol: 'NH',
    'Security Name': 'NantHealth,   ',

    'NASDAQ symbol': 'NH',
  },
  {
    symbol: 'NHA',
    'Security Name': 'Nuveen Municipal 2021 Target Term Fund Fund',

    'CQS symbol': 'NHA',
    'NASDAQ symbol': 'NHA',
  },
  {
    symbol: 'NHC',
    'Security Name': 'National HealthCare Corporation ',

    'CQS symbol': 'NHC',
    'NASDAQ symbol': 'NHC',
  },
  {
    symbol: 'NHF',
    'Security Name': 'NexPoint Strategic Opportunities Fund',

    'CQS symbol': 'NHF',
    'NASDAQ symbol': 'NHF',
  },
  {
    symbol: 'NHI',
    'Security Name': 'National Health Investors,  ',

    'CQS symbol': 'NHI',
    'NASDAQ symbol': 'NHI',
  },
  {
    symbol: 'NHIC',
    'Security Name': 'NewHold Investment Corp   ',

    'NASDAQ symbol': 'NHIC',
  },
  {
    symbol: 'NHICU',
    'Security Name': 'NewHold Investment Corp  Unit',

    'NASDAQ symbol': 'NHICU',
  },
  {
    symbol: 'NHICW',
    'Security Name': 'NewHold Investment Corp  Warrant',

    'NASDAQ symbol': 'NHICW',
  },
  {
    symbol: 'NHLD',
    'Security Name': 'National Holdings Corporation  ',

    'NASDAQ symbol': 'NHLD',
  },
  {
    symbol: 'NHLDW',
    'Security Name': 'National Holdings Corporation  Warrants',

    'NASDAQ symbol': 'NHLDW',
  },
  {
    symbol: 'NHS',
    'Security Name': 'Neuberger Berman High Yield Strategies Fund',

    'CQS symbol': 'NHS',
    'NASDAQ symbol': 'NHS',
  },
  {
    symbol: 'NHTC',
    'Security Name': 'Natural Health Trends Corp  Commn Stock',

    'NASDAQ symbol': 'NHTC',
  },
  {
    symbol: 'NI',
    'Security Name': 'NiSource  ',

    'CQS symbol': 'NI',
    'NASDAQ symbol': 'NI',
  },
  {
    symbol: 'NI$B',
    'Security Name':
      'NiSource,  Depositary Shares representing 1/1,000th ownership interest in a share of 650% Series B Preferred Stock and 1/1,000th ownership interest in a share of Series B1 Preferred Stock',

    'CQS symbol': 'NIpB',
    'NASDAQ symbol': 'NIB',
  },
  {
    symbol: 'NIB',
    'Security Name': 'iPath Bloomberg Cocoa Subindex Total Return SM IndexETN',

    'CQS symbol': 'NIB',
    'NASDAQ symbol': 'NIB',
  },
  {
    symbol: 'NICE',
    'Security Name':
      'NICE Ltd  American Depositary Shares each representing one Ordinary Share',

    'NASDAQ symbol': 'NICE',
  },
  {
    symbol: 'NICK',
    'Security Name': 'Nicholas Financial,   ',

    'NASDAQ symbol': 'NICK',
  },
  {
    symbol: 'NID',
    'Security Name':
      'Nuveen Intermediate Duration Municipal Term Fund Common Shares of Beneficial Interest',

    'CQS symbol': 'NID',
    'NASDAQ symbol': 'NID',
  },
  {
    symbol: 'NIE',
    'Security Name': 'AllianzGI Equity & Convertible ome Fund',

    'CQS symbol': 'NIE',
    'NASDAQ symbol': 'NIE',
  },
  {
    symbol: 'NIFE',
    'Security Name': 'Direxion Fallen Knives ETF',

    'CQS symbol': 'NIFE',
    'NASDAQ symbol': 'NIFE',
  },
  {
    symbol: 'NIM',
    'Security Name': 'Nuveen Select Maturities Municipal Fund ',

    'CQS symbol': 'NIM',
    'NASDAQ symbol': 'NIM',
  },
  {
    symbol: 'NINE',
    'Security Name': 'Nine Energy Service,  ',

    'CQS symbol': 'NINE',
    'NASDAQ symbol': 'NINE',
  },
  {
    symbol: 'NIO',
    'Security Name':
      'NIO  American depositary shares, each  representing one  ordinary share',

    'CQS symbol': 'NIO',
    'NASDAQ symbol': 'NIO',
  },
  {
    symbol: 'NIQ',
    'Security Name':
      'Nuveenn Intermediate Duration Quality Municipal Term Fund Common Shares of Beneficial Interest',

    'CQS symbol': 'NIQ',
    'NASDAQ symbol': 'NIQ',
  },
  {
    symbol: 'NISN',
    'Security Name':
      'NiSun Intl Enterprise Development Group Co, Ltd   Common Shares',

    'NASDAQ symbol': 'NISN',
  },
  {
    symbol: 'NIU',
    'Security Name': 'Niu Technologies  American Depositary Shares',

    'NASDAQ symbol': 'NIU',
  },
  {
    symbol: 'NJAN',
    'Security Name':
      'Innovator ETFs Trust Innovator Nasdaq100 Power Buffer ETF  January',

    'CQS symbol': 'NJAN',
    'NASDAQ symbol': 'NJAN',
  },
  {
    symbol: 'NJR',
    'Security Name': 'NewJersey Resources Corporation ',

    'CQS symbol': 'NJR',
    'NASDAQ symbol': 'NJR',
  },
  {
    symbol: 'NJUL',
    'Security Name': 'Innovator Nasdaq100 Power Buffer ETF  July',

    'CQS symbol': 'NJUL',
    'NASDAQ symbol': 'NJUL',
  },
  {
    symbol: 'NJV',
    'Security Name':
      'Nuveen New Jersey Municipal Value Fund Common Shares of Beneficial Interest',

    'CQS symbol': 'NJV',
    'NASDAQ symbol': 'NJV',
  },
  {
    symbol: 'NK',
    'Security Name': 'NantKwest,   ',

    'NASDAQ symbol': 'NK',
  },
  {
    symbol: 'NKE',
    'Security Name': 'Nike,  ',

    'CQS symbol': 'NKE',
    'NASDAQ symbol': 'NKE',
  },
  {
    symbol: 'NKG',
    'Security Name': 'Nuveen Georgia Quality Municipal ome Fund ',

    'CQS symbol': 'NKG',
    'NASDAQ symbol': 'NKG',
  },
  {
    symbol: 'NKLA',
    'Security Name': 'Nikola Corporation  ',

    'NASDAQ symbol': 'NKLA',
  },
  {
    symbol: 'NKSH',
    'Security Name': 'National Bankshares,   ',

    'NASDAQ symbol': 'NKSH',
  },
  {
    symbol: 'NKTR',
    'Security Name': 'Nektar Therapeutics  ',

    'NASDAQ symbol': 'NKTR',
  },
  {
    symbol: 'NKTX',
    'Security Name': 'Nkarta,   ',

    'NASDAQ symbol': 'NKTX',
  },
  {
    symbol: 'NKX',
    'Security Name': 'Nuveen California AMTFree Quality Municipal ome Fund',

    'CQS symbol': 'NKX',
    'NASDAQ symbol': 'NKX',
  },
  {
    symbol: 'NL',
    'Security Name': 'NL Industries,  ',

    'CQS symbol': 'NL',
    'NASDAQ symbol': 'NL',
  },
  {
    symbol: 'NLOK',
    'Security Name': 'NortonLifeLock   ',

    'NASDAQ symbol': 'NLOK',
  },
  {
    symbol: 'NLR',
    'Security Name': 'VanEck Vectors Uranium & Nuclear Energy ETF',

    'CQS symbol': 'NLR',
    'NASDAQ symbol': 'NLR',
  },
  {
    symbol: 'NLS',
    'Security Name': 'Nautilus,  ',

    'CQS symbol': 'NLS',
    'NASDAQ symbol': 'NLS',
  },
  {
    symbol: 'NLSN',
    'Security Name': 'Nielsen NV Ordinary Shares',

    'CQS symbol': 'NLSN',
    'NASDAQ symbol': 'NLSN',
  },
  {
    symbol: 'NLTX',
    'Security Name': 'Neoleukin Therapeutics,   ',

    'NASDAQ symbol': 'NLTX',
  },
  {
    symbol: 'NLY',
    'Security Name': 'Annaly Capital Management  ',

    'CQS symbol': 'NLY',
    'NASDAQ symbol': 'NLY',
  },
  {
    symbol: 'NLY$D',
    'Security Name': 'Annaly Capital Management  Preferred Series D',

    'CQS symbol': 'NLYpD',
    'NASDAQ symbol': 'NLYD',
  },
  {
    symbol: 'NLY$F',
    'Security Name': 'Annaly Capital Management  695% Series F',

    'CQS symbol': 'NLYpF',
    'NASDAQ symbol': 'NLYF',
  },
  {
    symbol: 'NLY$G',
    'Security Name':
      'Annaly Capital Management  650% Series G FixedtoFloating Rate Cumulative Redeemable Preferred Stock',

    'CQS symbol': 'NLYpG',
    'NASDAQ symbol': 'NLYG',
  },
  {
    symbol: 'NLY$I',
    'Security Name':
      'Annaly Capital Management  6750% Series I FixedtoFloating Rate Cumulative Redeemable Preferred Stock',

    'CQS symbol': 'NLYpI',
    'NASDAQ symbol': 'NLYI',
  },
  {
    symbol: 'NM',
    'Security Name': 'Navios Maritime Holdings  ',

    'CQS symbol': 'NM',
    'NASDAQ symbol': 'NM',
  },
  {
    symbol: 'NM$G',
    'Security Name':
      'Navios Maritime Holdings  Sponsored ADR Representing 1/100th Perpetual Preferred Series G (Marshall Islands)',

    'CQS symbol': 'NMpG',
    'NASDAQ symbol': 'NMG',
  },
  {
    symbol: 'NM$H',
    'Security Name':
      'Navios Maritime Holdings  Sponsored ADR Representing 1/100th Perp Preferred Series H%',

    'CQS symbol': 'NMpH',
    'NASDAQ symbol': 'NMH',
  },
  {
    symbol: 'NMCI',
    'Security Name':
      'Navios Maritime Containers LP  Common units representing limited partner interests',

    'NASDAQ symbol': 'NMCI',
  },
  {
    symbol: 'NMCO',
    'Security Name': 'Nuveen Municipal Credit Opportunities Fund Common Shares',

    'CQS symbol': 'NMCO',
    'NASDAQ symbol': 'NMCO',
  },
  {
    symbol: 'NMFC',
    'Security Name': 'New Mountain Finance Corporation  ',

    'NASDAQ symbol': 'NMFC',
  },
  {
    symbol: 'NMFCL',
    'Security Name': 'New Mountain Finance Corporation  575% Notes due 2023',

    'NASDAQ symbol': 'NMFCL',
  },
  {
    symbol: 'NMI',
    'Security Name': 'Nuveen Municipal ome Fund,  ',

    'CQS symbol': 'NMI',
    'NASDAQ symbol': 'NMI',
  },
  {
    symbol: 'NMIH',
    'Security Name': 'NMI Holdings   ',

    'NASDAQ symbol': 'NMIH',
  },
  {
    symbol: 'NMK$B',
    'Security Name': 'Niagara Mohawk Holdings,  Preferred Stock',

    'Round Lot Size': '10',

    'CQS symbol': 'NMKpB',
    'NASDAQ symbol': 'NMKB',
  },
  {
    symbol: 'NMK$C',
    'Security Name': 'Niagara Mohawk Holdings,  Preferred Stock',

    'Round Lot Size': '10',

    'CQS symbol': 'NMKpC',
    'NASDAQ symbol': 'NMKC',
  },
  {
    symbol: 'NML',
    'Security Name': 'Neuberger Berman MLP and Energy ome Fund  ',

    'CQS symbol': 'NML',
    'NASDAQ symbol': 'NML',
  },
  {
    symbol: 'NMM',
    'Security Name':
      'Navios Maritime Partners LP Common Units Representing Limited Partner Interests',

    'CQS symbol': 'NMM',
    'NASDAQ symbol': 'NMM',
  },
  {
    symbol: 'NMMC',
    'Security Name': 'North Mountain Merger Corp   ',

    'NASDAQ symbol': 'NMMC',
  },
  {
    symbol: 'NMMCU',
    'Security Name': 'North Mountain Merger Corp  Unit',

    'NASDAQ symbol': 'NMMCU',
  },
  {
    symbol: 'NMMCW',
    'Security Name': 'North Mountain Merger Corp  Warrant',

    'NASDAQ symbol': 'NMMCW',
  },
  {
    symbol: 'NMR',
    'Security Name': 'Nomura Holdings  ADR American Depositary Shares',

    'CQS symbol': 'NMR',
    'NASDAQ symbol': 'NMR',
  },
  {
    symbol: 'NMRD',
    'Security Name': 'Nemaura Medical   ',

    'NASDAQ symbol': 'NMRD',
  },
  {
    symbol: 'NMRK',
    'Security Name': 'Newmark Group,    ',

    'NASDAQ symbol': 'NMRK',
  },
  {
    symbol: 'NMS',
    'Security Name': 'Nuveen Minnesota Quality Municipal ome Fund ',

    'CQS symbol': 'NMS',
    'NASDAQ symbol': 'NMS',
  },
  {
    symbol: 'NMT',
    'Security Name': 'Nuveen Massachusetts Quality Municipal ome Fund ',

    'CQS symbol': 'NMT',
    'NASDAQ symbol': 'NMT',
  },
  {
    symbol: 'NMTR',
    'Security Name': '9 Meters Biopharma,   ',

    'NASDAQ symbol': 'NMTR',
  },
  {
    symbol: 'NMY',
    'Security Name': 'Nuveen Maryland Quality Municipal ome Fund ',

    'CQS symbol': 'NMY',
    'NASDAQ symbol': 'NMY',
  },
  {
    symbol: 'NMZ',
    'Security Name':
      'Nuveen Municipal High ome Opportunity Fund , $001 par value, per share',

    'CQS symbol': 'NMZ',
    'NASDAQ symbol': 'NMZ',
  },
  {
    symbol: 'NNA',
    'Security Name': 'Navios Maritime Acquisition Corporation ',

    'CQS symbol': 'NNA',
    'NASDAQ symbol': 'NNA',
  },
  {
    symbol: 'NNBR',
    'Security Name': 'NN,   ',

    'NASDAQ symbol': 'NNBR',
  },
  {
    symbol: 'NNDM',
    'Security Name': 'Nano Dimension Ltd  American Depositary Shares',

    'NASDAQ symbol': 'NNDM',
  },
  {
    symbol: 'NNI',
    'Security Name': 'Nelnet,  ',

    'CQS symbol': 'NNI',
    'NASDAQ symbol': 'NNI',
  },
  {
    symbol: 'NNN',
    'Security Name': 'National Retail Properties ',

    'CQS symbol': 'NNN',
    'NASDAQ symbol': 'NNN',
  },
  {
    symbol: 'NNN$F',
    'Security Name':
      'National Retail Properties Depositary Shares, each representing a 1/100th interest in a share of 520% Series F Cumulative Redeemable Preferred Stock',

    'CQS symbol': 'NNNpF',
    'NASDAQ symbol': 'NNNF',
  },
  {
    symbol: 'NNOX',
    'Security Name': 'NANOX IMAGING LTD  Ordinary Shares',

    'NASDAQ symbol': 'NNOX',
  },
  {
    symbol: 'NNVC',
    'Security Name': 'NanoViricides,  ',

    'CQS symbol': 'NNVC',
    'NASDAQ symbol': 'NNVC',
  },
  {
    symbol: 'NNY',
    'Security Name': 'Nuveen New York Municipal Value Fund,  ',

    'CQS symbol': 'NNY',
    'NASDAQ symbol': 'NNY',
  },
  {
    symbol: 'NOA',
    'Security Name':
      'North American Construction Group Ltd Common Shares (no par)',

    'CQS symbol': 'NOA',
    'NASDAQ symbol': 'NOA',
  },
  {
    symbol: 'NOACU',
    'Security Name': 'Natural Order Acquisition Corp  Unit',

    'NASDAQ symbol': 'NOACU',
  },
  {
    symbol: 'NOAH',
    'Security Name': 'Noah Holdings Limited',

    'CQS symbol': 'NOAH',
    'NASDAQ symbol': 'NOAH',
  },
  {
    symbol: 'NOBL',
    'Security Name': 'ProShares S&P 500 Dividend Aristocrats ETF',

    'CQS symbol': 'NOBL',
    'NASDAQ symbol': 'NOBL',
  },
  {
    symbol: 'NOC',
    'Security Name': 'Northrop Grumman Corporation ',

    'CQS symbol': 'NOC',
    'NASDAQ symbol': 'NOC',
  },
  {
    symbol: 'NOCT',
    'Security Name': 'Innovator Nasdaq100 Power Buffer ETF October',

    'CQS symbol': 'NOCT',
    'NASDAQ symbol': 'NOCT',
  },
  {
    symbol: 'NODK',
    'Security Name': 'NI Holdings,   ',

    'NASDAQ symbol': 'NODK',
  },
  {
    symbol: 'NOG',
    'Security Name': 'Northern Oil and Gas,  ',

    'CQS symbol': 'NOG',
    'NASDAQ symbol': 'NOG',
  },
  {
    symbol: 'NOK',
    'Security Name': 'Nokia Corporation Sponsored American Depositary Shares',

    'CQS symbol': 'NOK',
    'NASDAQ symbol': 'NOK',
  },
  {
    symbol: 'NOM',
    'Security Name': 'Nuveen Missouri Quality Municipal ome Fund ',

    'CQS symbol': 'NOM',
    'NASDAQ symbol': 'NOM',
  },
  {
    symbol: 'NOMD',
    'Security Name': 'Nomad Foods Limited Ordinary Shares',

    'CQS symbol': 'NOMD',
    'NASDAQ symbol': 'NOMD',
  },
  {
    symbol: 'NORW',
    'Security Name': 'Global X MSCI Norway ETF',

    'CQS symbol': 'NORW',
    'NASDAQ symbol': 'NORW',
  },
  {
    symbol: 'NOV',
    'Security Name': 'National Oilwell Varco,  ',

    'CQS symbol': 'NOV',
    'NASDAQ symbol': 'NOV',
  },
  {
    symbol: 'NOVA',
    'Security Name': 'Sunnova Energy International  ',

    'CQS symbol': 'NOVA',
    'NASDAQ symbol': 'NOVA',
  },
  {
    symbol: 'NOVN',
    'Security Name': 'Novan,   ',

    'NASDAQ symbol': 'NOVN',
  },
  {
    symbol: 'NOVS',
    'Security Name': 'Novus Capital Corporation  ',

    'NASDAQ symbol': 'NOVS',
  },
  {
    symbol: 'NOVSU',
    'Security Name': 'Novus Capital Corporation  Units',

    'NASDAQ symbol': 'NOVSU',
  },
  {
    symbol: 'NOVSW',
    'Security Name': 'Novus Capital Corporation  Warrants',

    'NASDAQ symbol': 'NOVSW',
  },
  {
    symbol: 'NOVT',
    'Security Name': 'Novanta   Common Shares',

    'NASDAQ symbol': 'NOVT',
  },
  {
    symbol: 'NOW',
    'Security Name': 'ServiceNow,  ',

    'CQS symbol': 'NOW',
    'NASDAQ symbol': 'NOW',
  },
  {
    symbol: 'NP',
    'Security Name': 'Neenah,  ',

    'CQS symbol': 'NP',
    'NASDAQ symbol': 'NP',
  },
  {
    symbol: 'NPA',
    'Security Name': 'New Providence Acquisition Corp   ',

    'NASDAQ symbol': 'NPA',
  },
  {
    symbol: 'NPAUU',
    'Security Name': 'New Providence Acquisition Corp  Unit',

    'NASDAQ symbol': 'NPAUU',
  },
  {
    symbol: 'NPAWW',
    'Security Name': 'New Providence Acquisition Corp  Warrant',

    'NASDAQ symbol': 'NPAWW',
  },
  {
    symbol: 'NPK',
    'Security Name': 'National Presto Industries,  ',

    'CQS symbol': 'NPK',
    'NASDAQ symbol': 'NPK',
  },
  {
    symbol: 'NPN',
    'Security Name':
      'Nuveen Pennsylvania Municipal Value Fund Common Shares of Beneficial Interest',

    'CQS symbol': 'NPN',
    'NASDAQ symbol': 'NPN',
  },
  {
    symbol: 'NPO',
    'Security Name': 'EnPro Industries ',

    'CQS symbol': 'NPO',
    'NASDAQ symbol': 'NPO',
  },
  {
    symbol: 'NPTN',
    'Security Name': 'NeoPhotonics Corporation ',

    'CQS symbol': 'NPTN',
    'NASDAQ symbol': 'NPTN',
  },
  {
    symbol: 'NPV',
    'Security Name': 'Nuveen Virginia Quality Municipal ome Fund ',

    'CQS symbol': 'NPV',
    'NASDAQ symbol': 'NPV',
  },
  {
    symbol: 'NQP',
    'Security Name': 'Nuveen Pennsylvania Quality Municipal ome Fund ',

    'CQS symbol': 'NQP',
    'NASDAQ symbol': 'NQP',
  },
  {
    symbol: 'NR',
    'Security Name': 'Newpark Resources,  ',

    'CQS symbol': 'NR',
    'NASDAQ symbol': 'NR',
  },
  {
    symbol: 'NRBO',
    'Security Name': 'NeuroBo Pharmaceuticals,   ',

    'NASDAQ symbol': 'NRBO',
  },
  {
    symbol: 'NRC',
    'Security Name': 'National Research Corporation  ',

    'NASDAQ symbol': 'NRC',
  },
  {
    symbol: 'NREF',
    'Security Name': 'NexPoint Real Estate Finance,  ',

    'CQS symbol': 'NREF',
    'NASDAQ symbol': 'NREF',
  },
  {
    symbol: 'NREF$A',
    'Security Name':
      'NexPoint Real Estate Finance,  850% Series A Cumulative Redeemable Preferred Stock',

    'CQS symbol': 'NREFpA',
    'NASDAQ symbol': 'NREFA',
  },
  {
    symbol: 'NRG',
    'Security Name': 'NRG Energy,  ',

    'CQS symbol': 'NRG',
    'NASDAQ symbol': 'NRG',
  },
  {
    symbol: 'NRGD',
    'Security Name': 'MicroSectors US Big Oil Index 3X Inverse Leveraged ETN',

    'CQS symbol': 'NRGD',
    'NASDAQ symbol': 'NRGD',
  },
  {
    symbol: 'NRGO',
    'Security Name': 'MicroSectors US Big Oil Index 2X Leveraged ETN',

    'CQS symbol': 'NRGO',
    'NASDAQ symbol': 'NRGO',
  },
  {
    symbol: 'NRGU',
    'Security Name': 'MicroSectors US Big Oil Index 3X Leveraged ETN',

    'CQS symbol': 'NRGU',
    'NASDAQ symbol': 'NRGU',
  },
  {
    symbol: 'NRGX',
    'Security Name':
      'PIMCO Energy and Tactical Credit Opportunities Fund Common Shares of Beneficial Interest',

    'CQS symbol': 'NRGX',
    'NASDAQ symbol': 'NRGX',
  },
  {
    symbol: 'NRGZ',
    'Security Name': 'MicroSectors US Big Oil Index 2X Inverse Leveraged ETN',

    'CQS symbol': 'NRGZ',
    'NASDAQ symbol': 'NRGZ',
  },
  {
    symbol: 'NRIM',
    'Security Name': 'Northrim BanCorp   ',

    'NASDAQ symbol': 'NRIM',
  },
  {
    symbol: 'NRIX',
    'Security Name': 'Nurix Therapeutics,   ',

    'NASDAQ symbol': 'NRIX',
  },
  {
    symbol: 'NRK',
    'Security Name': 'Nuveen New York AMTFree Quality Municipal ome Fund ',

    'CQS symbol': 'NRK',
    'NASDAQ symbol': 'NRK',
  },
  {
    symbol: 'NRO',
    'Security Name':
      'Neuberger Berman Real Estate Securities ome Fund,  Neuberger Berman Real Estate Securities ome Fund, ',

    'CQS symbol': 'NRO',
    'NASDAQ symbol': 'NRO',
  },
  {
    symbol: 'NRP',
    'Security Name': 'Natural Resource Partners LP Limited Partnership',

    'CQS symbol': 'NRP',
    'NASDAQ symbol': 'NRP',
  },
  {
    symbol: 'NRT',
    'Security Name': 'North European Oil Royality Trust ',

    'CQS symbol': 'NRT',
    'NASDAQ symbol': 'NRT',
  },
  {
    symbol: 'NRUC',
    'Security Name':
      'National Rural Utilities Cooperative Finance Corporation 5500% Subordinated Notes due 2064 (Subordinated Deferrable Interest Notes)',

    'CQS symbol': 'NRUC',
    'NASDAQ symbol': 'NRUC',
  },
  {
    symbol: 'NRZ',
    'Security Name': 'New Residential Investment Corp ',

    'CQS symbol': 'NRZ',
    'NASDAQ symbol': 'NRZ',
  },
  {
    symbol: 'NRZ$A',
    'Security Name':
      'New Residential Investment Corp 750% Series A FixedtoFloating Rate Cumulative Redeemable Preferred Stock',

    'CQS symbol': 'NRZpA',
    'NASDAQ symbol': 'NRZA',
  },
  {
    symbol: 'NRZ$B',
    'Security Name':
      'New Residential Investment Corp 7125% Series B FixedtoFloating Rate Cumulative Redeemable Preferred Stock',

    'CQS symbol': 'NRZpB',
    'NASDAQ symbol': 'NRZB',
  },
  {
    symbol: 'NRZ$C',
    'Security Name':
      'New Residential Investment Corp 6375% Series C FixedtoFloating Rate Cumulative Redeemable Preferred Stock',

    'CQS symbol': 'NRZpC',
    'NASDAQ symbol': 'NRZC',
  },
  {
    symbol: 'NS',
    'Security Name': 'Nustar Energy LP  Common Units',

    'CQS symbol': 'NS',
    'NASDAQ symbol': 'NS',
  },
  {
    symbol: 'NS$A',
    'Security Name':
      'Nustar Energy LP 850% Series A FixedtoFloating Rate Cumulative Redeemable Perpetual Preferred Units',

    'CQS symbol': 'NSpA',
    'NASDAQ symbol': 'NSA',
  },
  {
    symbol: 'NS$B',
    'Security Name':
      'Nustar Energy LP 7625% Series B FixedtoFloating Rate Cumulative Redeemable Perpetual Preferred Units representing limited partner interests',

    'CQS symbol': 'NSpB',
    'NASDAQ symbol': 'NSB',
  },
  {
    symbol: 'NS$C',
    'Security Name':
      'Nustar Energy LP 900% Series C FixedtoFloating Rate Cumulative Redeemable Perpetual Preferred Units',

    'CQS symbol': 'NSpC',
    'NASDAQ symbol': 'NSC',
  },
  {
    symbol: 'NSA',
    'Security Name':
      'National Storage Affiliates Trust Common Shares of Beneficial Interest',

    'CQS symbol': 'NSA',
    'NASDAQ symbol': 'NSA',
  },
  {
    symbol: 'NSA$A',
    'Security Name':
      'National Storage Affiliates Trust 6000% Series A Cumulative Redeemable Preferred Shares of Beneficial Interest (Liquidation Preference $2500 per share)',

    'CQS symbol': 'NSApA',
    'NASDAQ symbol': 'NSAA',
  },
  {
    symbol: 'NSC',
    'Security Name': 'Norfolk Southern Corporation ',

    'CQS symbol': 'NSC',
    'NASDAQ symbol': 'NSC',
  },
  {
    symbol: 'NSCO',
    'Security Name': 'Nesco Holdings,  ',

    'CQS symbol': 'NSCO',
    'NASDAQ symbol': 'NSCO',
  },
  {
    symbol: 'NSCOW',
    'Security Name':
      'Nesco Holdings,  Redeemable Warrants, exercisable for  Ordinary Shares at an exercise price of $1150 per share',

    'CQS symbol': 'NSCOWS',
    'NASDAQ symbol': 'NSCO+',
  },
  {
    symbol: 'NSEC',
    'Security Name': 'National Security Group,   ',

    'NASDAQ symbol': 'NSEC',
  },
  {
    symbol: 'NSH',
    'Security Name': 'NavSight Holdings,   ',

    'CQS symbol': 'NSH',
    'NASDAQ symbol': 'NSH',
  },
  {
    symbol: 'NSHU',
    'Security Name':
      'NavSight Holdings,  Units, each consisting of one share of   and onehalf of one Warrant',

    'CQS symbol': 'NSHU',
    'NASDAQ symbol': 'NSH=',
  },
  {
    symbol: 'NSHW',
    'Security Name':
      'NavSight Holdings,  Warrants, each whole warrant exercisable for one share of   at an exercise price of $1150 per whole share',

    'CQS symbol': 'NSHWS',
    'NASDAQ symbol': 'NSH+',
  },
  {
    symbol: 'NSIT',
    'Security Name': 'Insight Enterprises,   ',

    'NASDAQ symbol': 'NSIT',
  },
  {
    symbol: 'NSL',
    'Security Name': 'Nuveen Senior ome Fund ',

    'CQS symbol': 'NSL',
    'NASDAQ symbol': 'NSL',
  },
  {
    symbol: 'NSP',
    'Security Name': 'Insperity,  ',

    'CQS symbol': 'NSP',
    'NASDAQ symbol': 'NSP',
  },
  {
    symbol: 'NSPR',
    'Security Name': 'InspireMD  ',

    'CQS symbol': 'NSPR',
    'NASDAQ symbol': 'NSPR',
  },
  {
    symbol: 'NSPRB',
    'Security Name': 'InspireMD,  Series B Warrants, (Expiring March 14, 2022)',

    'CQS symbol': 'NSPRWSB',
    'NASDAQ symbol': 'NSPR+B',
  },
  {
    symbol: 'NSPRW',
    'Security Name': 'InspireMD,  Warrants',

    'CQS symbol': 'NSPRWS',
    'NASDAQ symbol': 'NSPR+',
  },
  {
    symbol: 'NSS',
    'Security Name':
      'NuStar Logistics, LP 7625% FixedtoFloating Rate Subordinated Notes due 2043',

    'CQS symbol': 'NSS',
    'NASDAQ symbol': 'NSS',
  },
  {
    symbol: 'NSSC',
    'Security Name': 'NAPCO Security Technologies,   ',

    'NASDAQ symbol': 'NSSC',
  },
  {
    symbol: 'NSTG',
    'Security Name': 'NanoString Technologies,   ',

    'NASDAQ symbol': 'NSTG',
  },
  {
    symbol: 'NSYS',
    'Security Name': 'Nortech Systems orporated  ',

    'NASDAQ symbol': 'NSYS',
  },
  {
    symbol: 'NTAP',
    'Security Name': 'NetApp,   ',

    'NASDAQ symbol': 'NTAP',
  },
  {
    symbol: 'NTB',
    'Security Name':
      'Bank of NT Butterfield & Son Limited (The) Voting Ordinary Shares',

    'CQS symbol': 'NTB',
    'NASDAQ symbol': 'NTB',
  },
  {
    symbol: 'NTCO',
    'Security Name': 'Natura &Co Holding SA American Depositary Shares ',

    'CQS symbol': 'NTCO',
    'NASDAQ symbol': 'NTCO',
  },
  {
    symbol: 'NTCT',
    'Security Name': 'NetScout Systems,   ',

    'NASDAQ symbol': 'NTCT',
  },
  {
    symbol: 'NTEC',
    'Security Name': 'Intec Pharma Ltd  Ordinary Shares',

    'NASDAQ symbol': 'NTEC',
  },
  {
    symbol: 'NTES',
    'Security Name':
      'NetEase,   American Depositary Shares, each representing 5 ordinary shares',

    'NASDAQ symbol': 'NTES',
  },
  {
    symbol: 'NTEST',
    'Security Name': 'NYSE Tick Pilot Test SymControl',

    'Test Issue': 'Y',

    'CQS symbol': 'NTEST',
    'NASDAQ symbol': 'NTEST',
  },
  {
    symbol: 'NTESTA',
    'Security Name': 'NYSE Tick Pilot Test SymG1',

    'Test Issue': 'Y',

    'CQS symbol': 'NTESTA',
    'NASDAQ symbol': 'NTESTA',
  },
  {
    symbol: 'NTESTB',
    'Security Name': 'NYSE Tick Pilot Test SymG2',

    'Test Issue': 'Y',

    'CQS symbol': 'NTESTB',
    'NASDAQ symbol': 'NTESTB',
  },
  {
    symbol: 'NTESTC',
    'Security Name': 'Tick Pilot Test C ',

    'Test Issue': 'Y',

    'CQS symbol': 'NTESTC',
    'NASDAQ symbol': 'NTESTC',
  },
  {
    symbol: 'NTG',
    'Security Name': 'Tortoise Midstream Energy Fund,  ',

    'CQS symbol': 'NTG',
    'NASDAQ symbol': 'NTG',
  },
  {
    symbol: 'NTGR',
    'Security Name': 'NETGEAR,   ',

    'NASDAQ symbol': 'NTGR',
  },
  {
    symbol: 'NTIC',
    'Security Name': 'Northern Technologies International Corporation  ',

    'NASDAQ symbol': 'NTIC',
  },
  {
    symbol: 'NTIP',
    'Security Name': 'Network1 Technologies,  ',

    'CQS symbol': 'NTIP',
    'NASDAQ symbol': 'NTIP',
  },
  {
    symbol: 'NTLA',
    'Security Name': 'Intellia Therapeutics,   ',

    'NASDAQ symbol': 'NTLA',
  },
  {
    symbol: 'NTN',
    'Security Name': 'NTN Buzztime,  ',

    'CQS symbol': 'NTN',
    'NASDAQ symbol': 'NTN',
  },
  {
    symbol: 'NTNX',
    'Security Name': 'Nutanix,    ',

    'NASDAQ symbol': 'NTNX',
  },
  {
    symbol: 'NTP',
    'Security Name': 'Nam Tai Property  ',

    'CQS symbol': 'NTP',
    'NASDAQ symbol': 'NTP',
  },
  {
    symbol: 'NTR',
    'Security Name': 'Nutrien Ltd Common Shares',

    'CQS symbol': 'NTR',
    'NASDAQ symbol': 'NTR',
  },
  {
    symbol: 'NTRA',
    'Security Name': 'Natera,   ',

    'NASDAQ symbol': 'NTRA',
  },
  {
    symbol: 'NTRS',
    'Security Name': 'Northern Trust Corporation  ',

    'NASDAQ symbol': 'NTRS',
  },
  {
    symbol: 'NTRSO',
    'Security Name':
      'Northern Trust Corporation  Depositary Shares Each Representing a 1/1,000th Interest in a Share of Series E NonCumulative Perpetual Preferred Stock',

    'NASDAQ symbol': 'NTRSO',
  },
  {
    symbol: 'NTST',
    'Security Name': 'NetSTREIT Corp ',

    'CQS symbol': 'NTST',
    'NASDAQ symbol': 'NTST',
  },
  {
    symbol: 'NTSX',
    'Security Name': 'WisdomTree 90/60 US Balanced Fund',

    'CQS symbol': 'NTSX',
    'NASDAQ symbol': 'NTSX',
  },
  {
    symbol: 'NTUS',
    'Security Name': 'Natus Medical orporated  ',

    'NASDAQ symbol': 'NTUS',
  },
  {
    symbol: 'NTWK',
    'Security Name': 'NETSOL Technologies   ',

    'NASDAQ symbol': 'NTWK',
  },
  {
    symbol: 'NTZ',
    'Security Name': 'Natuzzi, SpA',

    'CQS symbol': 'NTZ',
    'NASDAQ symbol': 'NTZ',
  },
  {
    symbol: 'NUAG',
    'Security Name': 'Nuveen Enhanced Yield US Aggregate Bond ETF',

    'CQS symbol': 'NUAG',
    'NASDAQ symbol': 'NUAG',
  },
  {
    symbol: 'NUAN',
    'Security Name': 'Nuance Communications,   ',

    'NASDAQ symbol': 'NUAN',
  },
  {
    symbol: 'NUBD',
    'Security Name': 'Nuveen ESG US Aggregate Bond ETF',

    'CQS symbol': 'NUBD',
    'NASDAQ symbol': 'NUBD',
  },
  {
    symbol: 'NUDM',
    'Security Name': 'Nuveen ESG International Developed Markets Equity ETF',

    'CQS symbol': 'NUDM',
    'NASDAQ symbol': 'NUDM',
  },
  {
    symbol: 'NUE',
    'Security Name': 'Nucor Corporation ',

    'CQS symbol': 'NUE',
    'NASDAQ symbol': 'NUE',
  },
  {
    symbol: 'NUEM',
    'Security Name': 'Nuveen ESG Emerging Markets Equity ETF',

    'CQS symbol': 'NUEM',
    'NASDAQ symbol': 'NUEM',
  },
  {
    symbol: 'NUGT',
    'Security Name': 'Direxion Daily Gold Miners Index Bull 2XShares',

    'CQS symbol': 'NUGT',
    'NASDAQ symbol': 'NUGT',
  },
  {
    symbol: 'NUHY',
    'Security Name': 'Nuveen ESG High Yield Corporate Bond ETF',

    'CQS symbol': 'NUHY',
    'NASDAQ symbol': 'NUHY',
  },
  {
    symbol: 'NULC',
    'Security Name': 'Nuveen ESG LargeCap ETF',

    'CQS symbol': 'NULC',
    'NASDAQ symbol': 'NULC',
  },
  {
    symbol: 'NULG',
    'Security Name': 'Nuveen ESG LargeCap Growth ETF',

    'CQS symbol': 'NULG',
    'NASDAQ symbol': 'NULG',
  },
  {
    symbol: 'NULV',
    'Security Name': 'Nuveen ESG LargeCap Value ETF',

    'CQS symbol': 'NULV',
    'NASDAQ symbol': 'NULV',
  },
  {
    symbol: 'NUM',
    'Security Name': 'Nuveen Michigan Quality Municipal ome Fund ',

    'CQS symbol': 'NUM',
    'NASDAQ symbol': 'NUM',
  },
  {
    symbol: 'NUMG',
    'Security Name': 'Nuveen ESG MidCap Growth ETF',

    'CQS symbol': 'NUMG',
    'NASDAQ symbol': 'NUMG',
  },
  {
    symbol: 'NUMV',
    'Security Name': 'Nuveen ESG MidCap Value ETF',

    'CQS symbol': 'NUMV',
    'NASDAQ symbol': 'NUMV',
  },
  {
    symbol: 'NUO',
    'Security Name': 'Nuveen Ohio Quality Municipal ome Fund ',

    'CQS symbol': 'NUO',
    'NASDAQ symbol': 'NUO',
  },
  {
    symbol: 'NURE',
    'Security Name': 'Nuveen ShortTerm REIT ETF',

    'CQS symbol': 'NURE',
    'NASDAQ symbol': 'NURE',
  },
  {
    symbol: 'NURO',
    'Security Name': 'NeuroMetrix,   ',

    'NASDAQ symbol': 'NURO',
  },
  {
    symbol: 'NUS',
    'Security Name': 'Nu Skin Enterprises,  ',

    'CQS symbol': 'NUS',
    'NASDAQ symbol': 'NUS',
  },
  {
    symbol: 'NUSA',
    'Security Name': 'Nuveen Enhanced Yield 15 Year US Aggregate Bond ETF',

    'CQS symbol': 'NUSA',
    'NASDAQ symbol': 'NUSA',
  },
  {
    symbol: 'NUSC',
    'Security Name': 'Nuveen ESG SmallCap ETF',

    'CQS symbol': 'NUSC',
    'NASDAQ symbol': 'NUSC',
  },
  {
    symbol: 'NUSI',
    'Security Name': 'Nationwide RiskManaged ome ETF',

    'CQS symbol': 'NUSI',
    'NASDAQ symbol': 'NUSI',
  },
  {
    symbol: 'NUV',
    'Security Name': 'Nuveen Municipal Value Fund,  ',

    'CQS symbol': 'NUV',
    'NASDAQ symbol': 'NUV',
  },
  {
    symbol: 'NUVA',
    'Security Name': 'NuVasive,   ',

    'NASDAQ symbol': 'NUVA',
  },
  {
    symbol: 'NUW',
    'Security Name': 'Nuveen AMTFree Municipal Value Fund',

    'CQS symbol': 'NUW',
    'NASDAQ symbol': 'NUW',
  },
  {
    symbol: 'NUZE',
    'Security Name': 'NuZee,   ',

    'NASDAQ symbol': 'NUZE',
  },
  {
    symbol: 'NVAX',
    'Security Name': 'Novavax,   ',

    'NASDAQ symbol': 'NVAX',
  },
  {
    symbol: 'NVCN',
    'Security Name': 'Neovasc   Common Shares',

    'NASDAQ symbol': 'NVCN',
  },
  {
    symbol: 'NVCR',
    'Security Name': 'NovoCure Limited  Ordinary Shares',

    'NASDAQ symbol': 'NVCR',
  },
  {
    symbol: 'NVDA',
    'Security Name': 'NVIDIA Corporation  ',

    'NASDAQ symbol': 'NVDA',
  },
  {
    symbol: 'NVEC',
    'Security Name': 'NVE Corporation  ',

    'NASDAQ symbol': 'NVEC',
  },
  {
    symbol: 'NVEE',
    'Security Name': 'NV5 Global,   ',

    'NASDAQ symbol': 'NVEE',
  },
  {
    symbol: 'NVFY',
    'Security Name': 'Nova Lifestyle,   ',

    'NASDAQ symbol': 'NVFY',
  },
  {
    symbol: 'NVG',
    'Security Name': 'Nuveen AMTFree Municipal Credit ome Fund ',

    'CQS symbol': 'NVG',
    'NASDAQ symbol': 'NVG',
  },
  {
    symbol: 'NVGS',
    'Security Name':
      'Navigator Holdings Ltd Ordinary Shares (Marshall Islands)',

    'CQS symbol': 'NVGS',
    'NASDAQ symbol': 'NVGS',
  },
  {
    symbol: 'NVIV',
    'Security Name': 'InVivo Therapeutics Holdings Corp  ',

    'NASDAQ symbol': 'NVIV',
  },
  {
    symbol: 'NVMI',
    'Security Name': 'Nova Measuring Instruments Ltd  Ordinary Shares',

    'NASDAQ symbol': 'NVMI',
  },
  {
    symbol: 'NVMZ',
    'Security Name': 'TrueShares Structured Outcome (November) ETF',

    'CQS symbol': 'NVMZ',
    'NASDAQ symbol': 'NVMZ',
  },
  {
    symbol: 'NVO',
    'Security Name': 'Novo Nordisk A/S ',

    'CQS symbol': 'NVO',
    'NASDAQ symbol': 'NVO',
  },
  {
    symbol: 'NVQ',
    'Security Name': 'QRAFT AIEnhanced US Next Value ETF',

    'CQS symbol': 'NVQ',
    'NASDAQ symbol': 'NVQ',
  },
  {
    symbol: 'NVR',
    'Security Name': 'NVR,  ',

    'Round Lot Size': '10',

    'CQS symbol': 'NVR',
    'NASDAQ symbol': 'NVR',
  },
  {
    symbol: 'NVRO',
    'Security Name': 'Nevro Corp ',

    'CQS symbol': 'NVRO',
    'NASDAQ symbol': 'NVRO',
  },
  {
    symbol: 'NVS',
    'Security Name': 'Novartis AG ',

    'CQS symbol': 'NVS',
    'NASDAQ symbol': 'NVS',
  },
  {
    symbol: 'NVST',
    'Security Name': 'Envista Holdings Corporation ',

    'CQS symbol': 'NVST',
    'NASDAQ symbol': 'NVST',
  },
  {
    symbol: 'NVT',
    'Security Name': 'nVent Electric plc Ordinary Shares ',

    'CQS symbol': 'NVT',
    'NASDAQ symbol': 'NVT',
  },
  {
    symbol: 'NVTA',
    'Security Name': 'Invitae Corporation ',

    'CQS symbol': 'NVTA',
    'NASDAQ symbol': 'NVTA',
  },
  {
    symbol: 'NVUS',
    'Security Name': 'Novus Therapeutics,   ',

    'NASDAQ symbol': 'NVUS',
  },
  {
    symbol: 'NWBI',
    'Security Name': 'Northwest Bancshares,   ',

    'NASDAQ symbol': 'NWBI',
  },
  {
    symbol: 'NWE',
    'Security Name': 'NorthWestern Corporation  ',

    'NASDAQ symbol': 'NWE',
  },
  {
    symbol: 'NWFL',
    'Security Name': 'Norwood Financial Corp  ',

    'NASDAQ symbol': 'NWFL',
  },
  {
    symbol: 'NWG',
    'Security Name': 'NatWest Group plc American Depositary Shares',

    'CQS symbol': 'NWG',
    'NASDAQ symbol': 'NWG',
  },
  {
    symbol: 'NWHM',
    'Security Name': 'New Home Company  (The) ',

    'CQS symbol': 'NWHM',
    'NASDAQ symbol': 'NWHM',
  },
  {
    symbol: 'NWL',
    'Security Name': 'Newell Brands   ',

    'NASDAQ symbol': 'NWL',
  },
  {
    symbol: 'NWLI',
    'Security Name': 'National Western Life Group,    ',

    'NASDAQ symbol': 'NWLI',
  },
  {
    symbol: 'NWN',
    'Security Name': 'Northwest Natural Holding Company ',

    'CQS symbol': 'NWN',
    'NASDAQ symbol': 'NWN',
  },
  {
    symbol: 'NWPX',
    'Security Name': 'Northwest Pipe Company  ',

    'NASDAQ symbol': 'NWPX',
  },
  {
    symbol: 'NWS',
    'Security Name': 'News Corporation  Class B ',

    'NASDAQ symbol': 'NWS',
  },
  {
    symbol: 'NWSA',
    'Security Name': 'News Corporation   ',

    'NASDAQ symbol': 'NWSA',
  },
  {
    symbol: 'NX',
    'Security Name': 'Quanex Building Products Corporation ',

    'CQS symbol': 'NX',
    'NASDAQ symbol': 'NX',
  },
  {
    symbol: 'NXC',
    'Security Name': 'Nuveen California Select TaxFree ome Portfolio ',

    'CQS symbol': 'NXC',
    'NASDAQ symbol': 'NXC',
  },
  {
    symbol: 'NXE',
    'Security Name': 'Nexgen Energy Ltd Common Shares',

    'CQS symbol': 'NXE',
    'NASDAQ symbol': 'NXE',
  },
  {
    symbol: 'NXGN',
    'Security Name': 'NextGen Healthcare,   ',

    'NASDAQ symbol': 'NXGN',
  },
  {
    symbol: 'NXJ',
    'Security Name': 'Nuveen New Jersey Qualified Municipal Fund ',

    'CQS symbol': 'NXJ',
    'NASDAQ symbol': 'NXJ',
  },
  {
    symbol: 'NXN',
    'Security Name': 'Nuveen New York Select TaxFree ome Portfolio ',

    'CQS symbol': 'NXN',
    'NASDAQ symbol': 'NXN',
  },
  {
    symbol: 'NXP',
    'Security Name': 'Nuveen Select Tax Free ome Portfolio ',

    'CQS symbol': 'NXP',
    'NASDAQ symbol': 'NXP',
  },
  {
    symbol: 'NXPI',
    'Security Name': 'NXP Semiconductors NV  ',

    'NASDAQ symbol': 'NXPI',
  },
  {
    symbol: 'NXQ',
    'Security Name': 'Nuveen Select Tax Free ome Portfolio II ',

    'CQS symbol': 'NXQ',
    'NASDAQ symbol': 'NXQ',
  },
  {
    symbol: 'NXR',
    'Security Name': 'Nuveen Select Tax Free ome Portfolio III ',

    'CQS symbol': 'NXR',
    'NASDAQ symbol': 'NXR',
  },
  {
    symbol: 'NXRT',
    'Security Name': 'NexPoint Residential Trust,  ',

    'CQS symbol': 'NXRT',
    'NASDAQ symbol': 'NXRT',
  },
  {
    symbol: 'NXST',
    'Security Name': 'Nexstar Media Group,    ',

    'NASDAQ symbol': 'NXST',
  },
  {
    symbol: 'NXTC',
    'Security Name': 'NextCure,   ',

    'NASDAQ symbol': 'NXTC',
  },
  {
    symbol: 'NXTD',
    'Security Name': 'NXTID   ',

    'NASDAQ symbol': 'NXTD',
  },
  {
    symbol: 'NXTG',
    'Security Name': 'First Trust Indxx NextG ETF',

    'NASDAQ symbol': 'NXTG',
  },
  {
    symbol: 'NYC',
    'Security Name': 'New York City REIT,   ',

    'CQS symbol': 'NYC',
    'NASDAQ symbol': 'NYC',
  },
  {
    symbol: 'NYCB',
    'Security Name': 'New York Community Bancorp,  ',

    'CQS symbol': 'NYCB',
    'NASDAQ symbol': 'NYCB',
  },
  {
    symbol: 'NYCB$A',
    'Security Name':
      'New York Community Bancorp,  Depositary shares, each representing a 1/40th interest in a share of FixedtoFloating Rate Series A Noncumulative Perpetual Preferred Stock',

    'CQS symbol': 'NYCBpA',
    'NASDAQ symbol': 'NYCBA',
  },
  {
    symbol: 'NYCB$U',
    'Security Name':
      'New York Community Bancorp,  New York Community Capital Tr V (BONUSES)',

    'CQS symbol': 'NYCBpU',
    'NASDAQ symbol': 'NYCBU',
  },
  {
    symbol: 'NYF',
    'Security Name': 'iShares New York Muni Bond ETF',

    'CQS symbol': 'NYF',
    'NASDAQ symbol': 'NYF',
  },
  {
    symbol: 'NYMT',
    'Security Name': 'New York Mortgage Trust,   ',

    'NASDAQ symbol': 'NYMT',
  },
  {
    symbol: 'NYMTM',
    'Security Name':
      'New York Mortgage Trust,   7875% Series E FixedtoFloating Rate Cumulative Redeemable Preferred Stock',

    'NASDAQ symbol': 'NYMTM',
  },
  {
    symbol: 'NYMTN',
    'Security Name':
      'New York Mortgage Trust,   800% Series D FixedtoFloating Rate Cumulative Redeemable Preferred Stock',

    'NASDAQ symbol': 'NYMTN',
  },
  {
    symbol: 'NYMTO',
    'Security Name':
      'New York Mortgage Trust,   7875% Series C Cumulative Redeemable Preferred Stock',

    'NASDAQ symbol': 'NYMTO',
  },
  {
    symbol: 'NYMTP',
    'Security Name':
      'New York Mortgage Trust,   775% Series B Cumulative Redeemable Preferred Stock',

    'NASDAQ symbol': 'NYMTP',
  },
  {
    symbol: 'NYMX',
    'Security Name': 'Nymox Pharmaceutical Corporation  ',

    'NASDAQ symbol': 'NYMX',
  },
  {
    symbol: 'NYT',
    'Security Name': 'New York Times Company (The) ',

    'CQS symbol': 'NYT',
    'NASDAQ symbol': 'NYT',
  },
  {
    symbol: 'NYV',
    'Security Name':
      'Nuveen New York Municipal Value Fund 2 Common Shares of Beneficial Interest',

    'CQS symbol': 'NYV',
    'NASDAQ symbol': 'NYV',
  },
  {
    symbol: 'NZF',
    'Security Name': 'Nuveen Municipal Credit ome Fund ',

    'CQS symbol': 'NZF',
    'NASDAQ symbol': 'NZF',
  },
  {
    symbol: 'O',
    'Security Name': 'Realty ome Corporation ',

    'CQS symbol': 'O',
    'NASDAQ symbol': 'O',
  },
  {
    symbol: 'OAC',
    'Security Name': 'Oaktree Acquisition Corp  Ordinary Shares',

    'CQS symbol': 'OAC',
    'NASDAQ symbol': 'OAC',
  },
  {
    symbol: 'OACU',
    'Security Name':
      'Oaktree Acquisition Corp Units, each consisting of one  ordinary share, $00001 par value, and onethird of one redeemable warrant',

    'CQS symbol': 'OACU',
    'NASDAQ symbol': 'OAC=',
  },
  {
    symbol: 'OACW',
    'Security Name':
      'Oaktree Acquisition Corp Warrants, each whole warrant exercisable for one  Ordinary Share at an exercise price of $1150',

    'CQS symbol': 'OACWS',
    'NASDAQ symbol': 'OAC+',
  },
  {
    symbol: 'OACB',
    'Security Name': 'Oaktree Acquisition Corp II  Ordinary Shares',

    'CQS symbol': 'OACB',
    'NASDAQ symbol': 'OACB',
  },
  {
    symbol: 'OACBU',
    'Security Name':
      'Oaktree Acquisition Corp II Units, each consisting of one  ordinary share, and onefourth of one redeemable warrant',

    'CQS symbol': 'OACBU',
    'NASDAQ symbol': 'OACB=',
  },
  {
    symbol: 'OACBW',
    'Security Name':
      'Oaktree Acquisition Corp II Warrants, each whole warrant exercisable for one  ordinary share at an exercise price of $1150',

    'CQS symbol': 'OACBWS',
    'NASDAQ symbol': 'OACB+',
  },
  {
    symbol: 'OAK$A',
    'Security Name':
      'Oaktree Capital Group, LLC 6625% Series A Preferred units',

    'CQS symbol': 'OAKpA',
    'NASDAQ symbol': 'OAKA',
  },
  {
    symbol: 'OAK$B',
    'Security Name':
      'Oaktree Capital Group, LLC 6550% Series B Preferred Units',

    'CQS symbol': 'OAKpB',
    'NASDAQ symbol': 'OAKB',
  },
  {
    symbol: 'OAS',
    'Security Name': 'Oasis Petroleum   ',

    'NASDAQ symbol': 'OAS',
  },
  {
    symbol: 'OBAS',
    'Security Name': 'Optibase Ltd  Ordinary Shares',

    'NASDAQ symbol': 'OBAS',
  },
  {
    symbol: 'OBCI',
    'Security Name': 'Ocean BioChem,   ',

    'NASDAQ symbol': 'OBCI',
  },
  {
    symbol: 'OBLG',
    'Security Name': 'Oblong  ',

    'CQS symbol': 'OBLG',
    'NASDAQ symbol': 'OBLG',
  },
  {
    symbol: 'OBLN',
    'Security Name': 'Obalon Therapeutics,   ',

    'NASDAQ symbol': 'OBLN',
  },
  {
    symbol: 'OBNK',
    'Security Name': 'Origin Bancorp,   ',

    'NASDAQ symbol': 'OBNK',
  },
  {
    symbol: 'OBOR',
    'Security Name': 'KraneShares MSCI One Belt One Road Index ETF',

    'CQS symbol': 'OBOR',
    'NASDAQ symbol': 'OBOR',
  },
  {
    symbol: 'OBSV',
    'Security Name': 'ObsEva SA  Common Shares',

    'NASDAQ symbol': 'OBSV',
  },
  {
    symbol: 'OC',
    'Security Name': 'Owens Corning   New',

    'CQS symbol': 'OC',
    'NASDAQ symbol': 'OC',
  },
  {
    symbol: 'OCAU',
    'Security Name':
      'Omnichannel Acquisition Corp Units, each consisting of one share of   and onehalf of one redeemable warrant',

    'CQS symbol': 'OCAU',
    'NASDAQ symbol': 'OCA=',
  },
  {
    symbol: 'OCC',
    'Security Name': 'Optical Cable Corporation  ',

    'NASDAQ symbol': 'OCC',
  },
  {
    symbol: 'OCCI',
    'Security Name': 'OFS Credit Company,   ',

    'NASDAQ symbol': 'OCCI',
  },
  {
    symbol: 'OCCIP',
    'Security Name':
      'OFS Credit Company,   6875% Series A Term Preferred Stock',

    'NASDAQ symbol': 'OCCIP',
  },
  {
    symbol: 'OCFC',
    'Security Name': 'OceanFirst Financial Corp  ',

    'NASDAQ symbol': 'OCFC',
  },
  {
    symbol: 'OCFCP',
    'Security Name': 'OceanFirst Financial Corp  Depositary Shares',

    'NASDAQ symbol': 'OCFCP',
  },
  {
    symbol: 'OCFT',
    'Security Name':
      'OneConnect Financial Technology Co, Ltd American Depositary Shares, each representing three ordinary shares',

    'CQS symbol': 'OCFT',
    'NASDAQ symbol': 'OCFT',
  },
  {
    symbol: 'OCGN',
    'Security Name': 'Ocugen,   ',

    'NASDAQ symbol': 'OCGN',
  },
  {
    symbol: 'OCIO',
    'Security Name': 'ETF Series Solutions Trust ETF',

    'CQS symbol': 'OCIO',
    'NASDAQ symbol': 'OCIO',
  },
  {
    symbol: 'OCN',
    'Security Name': 'Ocwen Financial Corporation NEW ',

    'CQS symbol': 'OCN',
    'NASDAQ symbol': 'OCN',
  },
  {
    symbol: 'OCSI',
    'Security Name': 'Oaktree Strategic ome Corporation  ',

    'NASDAQ symbol': 'OCSI',
  },
  {
    symbol: 'OCSL',
    'Security Name': 'Oaktree Specialty Lending Corporation  ',

    'NASDAQ symbol': 'OCSL',
  },
  {
    symbol: 'OCTZ',
    'Security Name': 'TrueShares Structured Outcome (October) ETF',

    'CQS symbol': 'OCTZ',
    'NASDAQ symbol': 'OCTZ',
  },
  {
    symbol: 'OCUL',
    'Security Name': 'Ocular Therapeutix,   ',

    'NASDAQ symbol': 'OCUL',
  },
  {
    symbol: 'OCUP',
    'Security Name': 'Ocuphire Pharma,   ',

    'NASDAQ symbol': 'OCUP',
  },
  {
    symbol: 'OCX',
    'Security Name': 'OncoCyte Corporation ',

    'CQS symbol': 'OCX',
    'NASDAQ symbol': 'OCX',
  },
  {
    symbol: 'ODC',
    'Security Name': 'OilDri Corporation Of America ',

    'CQS symbol': 'ODC',
    'NASDAQ symbol': 'ODC',
  },
  {
    symbol: 'ODFL',
    'Security Name': 'Old Dominion Freight Line,   ',

    'NASDAQ symbol': 'ODFL',
  },
  {
    symbol: 'ODP',
    'Security Name': 'The ODP Corporation  ',

    'NASDAQ symbol': 'ODP',
  },
  {
    symbol: 'ODT',
    'Security Name': 'Odonate Therapeutics,   ',

    'NASDAQ symbol': 'ODT',
  },
  {
    symbol: 'OEC',
    'Security Name': 'Orion Engineered Carbons SA Common Shares',

    'CQS symbol': 'OEC',
    'NASDAQ symbol': 'OEC',
  },
  {
    symbol: 'OEF',
    'Security Name': 'iShares S&P 100 ETF',

    'CQS symbol': 'OEF',
    'NASDAQ symbol': 'OEF',
  },
  {
    symbol: 'OEG',
    'Security Name': 'Orbital Energy Group,   ',

    'NASDAQ symbol': 'OEG',
  },
  {
    symbol: 'OESX',
    'Security Name': 'Orion Energy Systems,   ',

    'NASDAQ symbol': 'OESX',
  },
  {
    symbol: 'OEUR',
    'Security Name': 'OShares Europe Quality Dividend ETF',

    'CQS symbol': 'OEUR',
    'NASDAQ symbol': 'OEUR',
  },
  {
    symbol: 'OFC',
    'Security Name': 'Corporate Office Properties Trust ',

    'CQS symbol': 'OFC',
    'NASDAQ symbol': 'OFC',
  },
  {
    symbol: 'OFED',
    'Security Name': 'Oconee Federal Financial Corp  ',

    'NASDAQ symbol': 'OFED',
  },
  {
    symbol: 'OFG',
    'Security Name': 'OFG Bancorp ',

    'CQS symbol': 'OFG',
    'NASDAQ symbol': 'OFG',
  },
  {
    symbol: 'OFG$A',
    'Security Name': 'OFG Bancorp Preferred Stock',

    'CQS symbol': 'OFGpA',
    'NASDAQ symbol': 'OFGA',
  },
  {
    symbol: 'OFG$B',
    'Security Name':
      'OFG Bancorp 70% Non Cumulative Monthly ome Preferred Stock Series B',

    'CQS symbol': 'OFGpB',
    'NASDAQ symbol': 'OFGB',
  },
  {
    symbol: 'OFG$D',
    'Security Name':
      'OFG Bancorp 7125% NonCumulative Perpetual Preferred Stock Series D',

    'CQS symbol': 'OFGpD',
    'NASDAQ symbol': 'OFGD',
  },
  {
    symbol: 'OFIX',
    'Security Name': 'Orthofix Medical    ',

    'NASDAQ symbol': 'OFIX',
  },
  {
    symbol: 'OFLX',
    'Security Name': 'Omega Flex,   ',

    'NASDAQ symbol': 'OFLX',
  },
  {
    symbol: 'OFS',
    'Security Name': 'OFS Capital Corporation  ',

    'NASDAQ symbol': 'OFS',
  },
  {
    symbol: 'OFSSG',
    'Security Name': 'OFS Capital Corporation  625% Notes Due 2023',

    'NASDAQ symbol': 'OFSSG',
  },
  {
    symbol: 'OFSSI',
    'Security Name': 'OFS Capital Corporation  595% Notes due 2026',

    'NASDAQ symbol': 'OFSSI',
  },
  {
    symbol: 'OFSSL',
    'Security Name': 'OFS Capital Corporation  6375% Notes due 2025',

    'NASDAQ symbol': 'OFSSL',
  },
  {
    symbol: 'OFSSZ',
    'Security Name': 'OFS Capital Corporation  650% Notes due 2025',

    'NASDAQ symbol': 'OFSSZ',
  },
  {
    symbol: 'OGCP',
    'Security Name':
      'Empire State Realty OP, LP Series 60 Operating Partnership Units Representing Limited Partnership Interests',

    'CQS symbol': 'OGCP',
    'NASDAQ symbol': 'OGCP',
  },
  {
    symbol: 'OGE',
    'Security Name': 'OGE Energy Corp ',

    'CQS symbol': 'OGE',
    'NASDAQ symbol': 'OGE',
  },
  {
    symbol: 'OGEN',
    'Security Name': 'Oragenics  ',

    'CQS symbol': 'OGEN',
    'NASDAQ symbol': 'OGEN',
  },
  {
    symbol: 'OGI',
    'Security Name': 'Organigram Holdings   Common Shares',

    'NASDAQ symbol': 'OGI',
  },
  {
    symbol: 'OGIG',
    'Security Name': "O'Shares Global Internet Giants ETF",

    'CQS symbol': 'OGIG',
    'NASDAQ symbol': 'OGIG',
  },
  {
    symbol: 'OGS',
    'Security Name': 'ONE Gas,  ',

    'CQS symbol': 'OGS',
    'NASDAQ symbol': 'OGS',
  },
  {
    symbol: 'OHI',
    'Security Name': 'Omega Healthcare Investors,  ',

    'CQS symbol': 'OHI',
    'NASDAQ symbol': 'OHI',
  },
  {
    symbol: 'OI',
    'Security Name': 'OI Glass,  ',

    'CQS symbol': 'OI',
    'NASDAQ symbol': 'OI',
  },
  {
    symbol: 'OIA',
    'Security Name': 'Invesco Municipal ome Opportunities Trust ',

    'CQS symbol': 'OIA',
    'NASDAQ symbol': 'OIA',
  },
  {
    symbol: 'OIBRC',
    'Security Name':
      'Oi SA American Depositary Shares, (Each representing 1 Common Share)',

    'CQS symbol': 'OIBRC',
    'NASDAQ symbol': 'OIBRC',
  },
  {
    symbol: 'OIH',
    'Security Name': 'VanEck Vectors Oil Services ETF',

    'CQS symbol': 'OIH',
    'NASDAQ symbol': 'OIH',
  },
  {
    symbol: 'OII',
    'Security Name': 'Oceaneering International,  ',

    'CQS symbol': 'OII',
    'NASDAQ symbol': 'OII',
  },
  {
    symbol: 'OIIM',
    'Security Name':
      'O2Micro International Limited  American Depositary Shares',

    'NASDAQ symbol': 'OIIM',
  },
  {
    symbol: 'OIL',
    'Security Name': 'iPath Pure Beta Crude Oil ETN',

    'CQS symbol': 'OIL',
    'NASDAQ symbol': 'OIL',
  },
  {
    symbol: 'OILK',
    'Security Name': 'ProShares K1 Free Crude Oil Strategy ETF',

    'CQS symbol': 'OILK',
    'NASDAQ symbol': 'OILK',
  },
  {
    symbol: 'OIS',
    'Security Name': 'Oil States International,  ',

    'CQS symbol': 'OIS',
    'NASDAQ symbol': 'OIS',
  },
  {
    symbol: 'OKE',
    'Security Name': 'ONEOK,  ',

    'CQS symbol': 'OKE',
    'NASDAQ symbol': 'OKE',
  },
  {
    symbol: 'OKTA',
    'Security Name': 'Okta,    ',

    'NASDAQ symbol': 'OKTA',
  },
  {
    symbol: 'OLB',
    'Security Name': 'The OLB Group,   ',

    'NASDAQ symbol': 'OLB',
  },
  {
    symbol: 'OLD',
    'Security Name': 'The LongTerm Care ETF',

    'NASDAQ symbol': 'OLD',
  },
  {
    symbol: 'OLED',
    'Security Name': 'Universal Display Corporation  ',

    'NASDAQ symbol': 'OLED',
  },
  {
    symbol: 'OLLI',
    'Security Name': "Ollie's Bargain Outlet Holdings,   ",

    'NASDAQ symbol': 'OLLI',
  },
  {
    symbol: 'OLMA',
    'Security Name': 'Olema Pharmaceuticals,   ',

    'NASDAQ symbol': 'OLMA',
  },
  {
    symbol: 'OLN',
    'Security Name': 'Olin Corporation ',

    'CQS symbol': 'OLN',
    'NASDAQ symbol': 'OLN',
  },
  {
    symbol: 'OLP',
    'Security Name': 'One Liberty Properties,  ',

    'CQS symbol': 'OLP',
    'NASDAQ symbol': 'OLP',
  },
  {
    symbol: 'OM',
    'Security Name': 'Outset Medical,   ',

    'NASDAQ symbol': 'OM',
  },
  {
    symbol: 'OMAB',
    'Security Name':
      'Grupo Aeroportuario del Centro Norte SAB de CV  American Depositary Shares each representing 8 Series B shares',

    'NASDAQ symbol': 'OMAB',
  },
  {
    symbol: 'OMC',
    'Security Name': 'Omnicom Group  ',

    'CQS symbol': 'OMC',
    'NASDAQ symbol': 'OMC',
  },
  {
    symbol: 'OMCL',
    'Security Name': 'Omnicell,   ',

    'NASDAQ symbol': 'OMCL',
  },
  {
    symbol: 'OMER',
    'Security Name': 'Omeros Corporation  ',

    'NASDAQ symbol': 'OMER',
  },
  {
    symbol: 'OMEX',
    'Security Name': 'Odyssey Marine Exploration,   ',

    'NASDAQ symbol': 'OMEX',
  },
  {
    symbol: 'OMF',
    'Security Name': 'OneMain Holdings,  ',

    'CQS symbol': 'OMF',
    'NASDAQ symbol': 'OMF',
  },
  {
    symbol: 'OMFL',
    'Security Name':
      'Invesco ExchangeTraded SelfIndexed Fund Trust Invesco Russell 1000 Dynamic Multifactor ETF',

    'CQS symbol': 'OMFL',
    'NASDAQ symbol': 'OMFL',
  },
  {
    symbol: 'OMFS',
    'Security Name':
      'Invesco ExchangeTraded SelfIndexed Fund Trust Invesco Russell 2000 Dynamic Multifactor ETF',

    'CQS symbol': 'OMFS',
    'NASDAQ symbol': 'OMFS',
  },
  {
    symbol: 'OMI',
    'Security Name': 'Owens & Minor,  ',

    'CQS symbol': 'OMI',
    'NASDAQ symbol': 'OMI',
  },
  {
    symbol: 'OMP',
    'Security Name':
      'Oasis Midstream Partners LP  Common Units, Representing Limited Partner Interests',

    'NASDAQ symbol': 'OMP',
  },
  {
    symbol: 'ON',
    'Security Name': 'ON Semiconductor Corporation  ',

    'NASDAQ symbol': 'ON',
  },
  {
    symbol: 'ONB',
    'Security Name': 'Old National Bancorp  ',

    'NASDAQ symbol': 'ONB',
  },
  {
    symbol: 'ONCR',
    'Security Name': 'Oncorus,   ',

    'NASDAQ symbol': 'ONCR',
  },
  {
    symbol: 'ONCS',
    'Security Name': 'OncoSec Medical orporated  ',

    'NASDAQ symbol': 'ONCS',
  },
  {
    symbol: 'ONCT',
    'Security Name': 'Oncternal Therapeutics,    ',

    'NASDAQ symbol': 'ONCT',
  },
  {
    symbol: 'ONCY',
    'Security Name': 'Oncolytics Biotech   Common Shares',

    'NASDAQ symbol': 'ONCY',
  },
  {
    symbol: 'ONDS',
    'Security Name': 'Ondas Holdings   ',

    'NASDAQ symbol': 'ONDS',
  },
  {
    symbol: 'ONE',
    'Security Name': 'OneSmart International Education Group Limited ADS',

    'CQS symbol': 'ONE',
    'NASDAQ symbol': 'ONE',
  },
  {
    symbol: 'ONEM',
    'Security Name': '1Life Healthcare,   ',

    'NASDAQ symbol': 'ONEM',
  },
  {
    symbol: 'ONEO',
    'Security Name': 'SPDR Russell 1000 Momentum Focus ETF',

    'CQS symbol': 'ONEO',
    'NASDAQ symbol': 'ONEO',
  },
  {
    symbol: 'ONEQ',
    'Security Name': 'Fidelity Nasdaq Composite Index Tracking Stock',

    'NASDAQ symbol': 'ONEQ',
  },
  {
    symbol: 'ONEV',
    'Security Name': 'SPDR Russell 1000 Low Volatility Focus ETF',

    'CQS symbol': 'ONEV',
    'NASDAQ symbol': 'ONEV',
  },
  {
    symbol: 'ONEW',
    'Security Name': 'OneWater Marine    ',

    'NASDAQ symbol': 'ONEW',
  },
  {
    symbol: 'ONEY',
    'Security Name': 'SPDR Russell 1000 Yield Focus ETF',

    'CQS symbol': 'ONEY',
    'NASDAQ symbol': 'ONEY',
  },
  {
    symbol: 'ONLN',
    'Security Name': 'ProShares Online Retail ETF',

    'CQS symbol': 'ONLN',
    'NASDAQ symbol': 'ONLN',
  },
  {
    symbol: 'ONTO',
    'Security Name': 'Onto Innovation  ',

    'CQS symbol': 'ONTO',
    'NASDAQ symbol': 'ONTO',
  },
  {
    symbol: 'ONTX',
    'Security Name': 'Onconova Therapeutics,   ',

    'NASDAQ symbol': 'ONTX',
  },
  {
    symbol: 'ONTXW',
    'Security Name': 'Onconova Therapeutics,   Warrants',

    'NASDAQ symbol': 'ONTXW',
  },
  {
    symbol: 'ONVO',
    'Security Name': 'Organovo Holdings,   ',

    'NASDAQ symbol': 'ONVO',
  },
  {
    symbol: 'OOMA',
    'Security Name': 'Ooma,  ',

    'CQS symbol': 'OOMA',
    'NASDAQ symbol': 'OOMA',
  },
  {
    symbol: 'OPBK',
    'Security Name': 'OP Bancorp  ',

    'NASDAQ symbol': 'OPBK',
  },
  {
    symbol: 'OPCH',
    'Security Name': 'Option Care Health,   ',

    'NASDAQ symbol': 'OPCH',
  },
  {
    symbol: 'OPER',
    'Security Name':
      'ETF Series Solutions ETF ClearShares UltraShort Maturity ETF',

    'CQS symbol': 'OPER',
    'NASDAQ symbol': 'OPER',
  },
  {
    symbol: 'OPES',
    'Security Name': 'Opes Acquisition Corp  ',

    'NASDAQ symbol': 'OPES',
  },
  {
    symbol: 'OPESU',
    'Security Name': 'Opes Acquisition Corp  Unit',

    'NASDAQ symbol': 'OPESU',
  },
  {
    symbol: 'OPESW',
    'Security Name': 'Opes Acquisition Corp  Warrant',

    'NASDAQ symbol': 'OPESW',
  },
  {
    symbol: 'OPGN',
    'Security Name': 'OpGen,   ',

    'NASDAQ symbol': 'OPGN',
  },
  {
    symbol: 'OPHC',
    'Security Name': 'OptimumBank Holdings,   ',

    'NASDAQ symbol': 'OPHC',
  },
  {
    symbol: 'OPI',
    'Security Name':
      'Office Properties ome Trust  Common Shares of Beneficial Interest',

    'NASDAQ symbol': 'OPI',
  },
  {
    symbol: 'OPINI',
    'Security Name': 'Office Properties ome Trust  5875% Senior Notes due 2046',

    'NASDAQ symbol': 'OPINI',
  },
  {
    symbol: 'OPINL',
    'Security Name': 'Office Properties ome Trust  6375% Senior Notes due 2050',

    'NASDAQ symbol': 'OPINL',
  },
  {
    symbol: 'OPK',
    'Security Name': 'Opko Health,   ',

    'NASDAQ symbol': 'OPK',
  },
  {
    symbol: 'OPNT',
    'Security Name': 'Opiant Pharmaceuticals,   ',

    'NASDAQ symbol': 'OPNT',
  },
  {
    symbol: 'OPOF',
    'Security Name': 'Old Point Financial Corporation  ',

    'NASDAQ symbol': 'OPOF',
  },
  {
    symbol: 'OPP',
    'Security Name': 'RiverNorth/DoubleLine Strategic Opportunity Fund,  ',

    'CQS symbol': 'OPP',
    'NASDAQ symbol': 'OPP',
  },
  {
    symbol: 'OPP$A',
    'Security Name':
      'RiverNorth/DoubleLine Strategic Opportunity Fund,  4375% Series A Cumulative Preferred Stock',

    'CQS symbol': 'OPPpA',
    'NASDAQ symbol': 'OPPA',
  },
  {
    symbol: 'OPRA',
    'Security Name': 'Opera Limited  American Depositary Shares',

    'NASDAQ symbol': 'OPRA',
  },
  {
    symbol: 'OPRT',
    'Security Name': 'Oportun Financial Corporation  ',

    'NASDAQ symbol': 'OPRT',
  },
  {
    symbol: 'OPRX',
    'Security Name': 'OptimizeRx Corporation  ',

    'NASDAQ symbol': 'OPRX',
  },
  {
    symbol: 'OPT',
    'Security Name': 'Opthea Limited  American Depositary Shares',

    'NASDAQ symbol': 'OPT',
  },
  {
    symbol: 'OPTN',
    'Security Name': 'OptiNose,   ',

    'NASDAQ symbol': 'OPTN',
  },
  {
    symbol: 'OPTT',
    'Security Name': 'Ocean Power Technologies,   ',

    'NASDAQ symbol': 'OPTT',
  },
  {
    symbol: 'OPY',
    'Security Name': 'Oppenheimer Holdings,    (DE)',

    'CQS symbol': 'OPY',
    'NASDAQ symbol': 'OPY',
  },
  {
    symbol: 'OR',
    'Security Name': 'Osisko Gold Royalties Ltd Common Shares',

    'CQS symbol': 'OR',
    'NASDAQ symbol': 'OR',
  },
  {
    symbol: 'ORA',
    'Security Name': 'Ormat Technologies,  ',

    'CQS symbol': 'ORA',
    'NASDAQ symbol': 'ORA',
  },
  {
    symbol: 'ORAN',
    'Security Name': 'Orange',

    'CQS symbol': 'ORAN',
    'NASDAQ symbol': 'ORAN',
  },
  {
    symbol: 'ORBC',
    'Security Name': 'ORBCOMM   ',

    'NASDAQ symbol': 'ORBC',
  },
  {
    symbol: 'ORC',
    'Security Name': 'Orchid Island Capital,  ',

    'CQS symbol': 'ORC',
    'NASDAQ symbol': 'ORC',
  },
  {
    symbol: 'ORCC',
    'Security Name': 'Owl Rock Capital Corporation ',

    'CQS symbol': 'ORCC',
    'NASDAQ symbol': 'ORCC',
  },
  {
    symbol: 'ORCL',
    'Security Name': 'Oracle Corporation ',

    'CQS symbol': 'ORCL',
    'NASDAQ symbol': 'ORCL',
  },
  {
    symbol: 'ORGO',
    'Security Name': 'Organogenesis Holdings     ',

    'NASDAQ symbol': 'ORGO',
  },
  {
    symbol: 'ORGS',
    'Security Name': 'Orgenesis   ',

    'NASDAQ symbol': 'ORGS',
  },
  {
    symbol: 'ORI',
    'Security Name': 'Old Republic International Corporation ',

    'CQS symbol': 'ORI',
    'NASDAQ symbol': 'ORI',
  },
  {
    symbol: 'ORIC',
    'Security Name': 'Oric Pharmaceuticals,   ',

    'NASDAQ symbol': 'ORIC',
  },
  {
    symbol: 'ORLY',
    'Security Name': "O'Reilly Automotive,   ",

    'NASDAQ symbol': 'ORLY',
  },
  {
    symbol: 'ORMP',
    'Security Name': 'Oramed Pharmaceuticals   ',

    'NASDAQ symbol': 'ORMP',
  },
  {
    symbol: 'ORN',
    'Security Name': 'Orion Group Holdings,  Common',

    'CQS symbol': 'ORN',
    'NASDAQ symbol': 'ORN',
  },
  {
    symbol: 'ORPH',
    'Security Name': 'Orphazyme A/S  American Depositary Shares',

    'NASDAQ symbol': 'ORPH',
  },
  {
    symbol: 'ORRF',
    'Security Name': 'Orrstown Financial Services   ',

    'NASDAQ symbol': 'ORRF',
  },
  {
    symbol: 'ORTX',
    'Security Name': 'Orchard Therapeutics plc  American Depositary Shares',

    'NASDAQ symbol': 'ORTX',
  },
  {
    symbol: 'OSB',
    'Security Name': 'Norbord  ',

    'CQS symbol': 'OSB',
    'NASDAQ symbol': 'OSB',
  },
  {
    symbol: 'OSBC',
    'Security Name': 'Old Second Bancorp,   ',

    'NASDAQ symbol': 'OSBC',
  },
  {
    symbol: 'OSCV',
    'Security Name': 'Opus Small Cap Value ETF',

    'CQS symbol': 'OSCV',
    'NASDAQ symbol': 'OSCV',
  },
  {
    symbol: 'OSG',
    'Security Name': 'Overseas Shipholding Group,   ',

    'CQS symbol': 'OSG',
    'NASDAQ symbol': 'OSG',
  },
  {
    symbol: 'OSH',
    'Security Name': 'Oak Street Health,  ',

    'CQS symbol': 'OSH',
    'NASDAQ symbol': 'OSH',
  },
  {
    symbol: 'OSIS',
    'Security Name': 'OSI Systems,   ',

    'NASDAQ symbol': 'OSIS',
  },
  {
    symbol: 'OSK',
    'Security Name': 'Oshkosh Corporation (Holding Company)',

    'CQS symbol': 'OSK',
    'NASDAQ symbol': 'OSK',
  },
  {
    symbol: 'OSMT',
    'Security Name': 'Osmotica Pharmaceuticals plc  Ordinary Shares',

    'NASDAQ symbol': 'OSMT',
  },
  {
    symbol: 'OSN',
    'Security Name': 'Ossen Innovation Co, Ltd  American Depositary Shares',

    'NASDAQ symbol': 'OSN',
  },
  {
    symbol: 'OSPN',
    'Security Name': 'OneSpan   ',

    'NASDAQ symbol': 'OSPN',
  },
  {
    symbol: 'OSS',
    'Security Name': 'One Stop Systems,   ',

    'NASDAQ symbol': 'OSS',
  },
  {
    symbol: 'OSTK',
    'Security Name': 'Overstockcom,   ',

    'NASDAQ symbol': 'OSTK',
  },
  {
    symbol: 'OSUR',
    'Security Name': 'OraSure Technologies,   ',

    'NASDAQ symbol': 'OSUR',
  },
  {
    symbol: 'OSW',
    'Security Name': 'OneSpaWorld Holdings Limited  Common Shares',

    'NASDAQ symbol': 'OSW',
  },
  {
    symbol: 'OTEL',
    'Security Name': 'Otelco   ',

    'NASDAQ symbol': 'OTEL',
  },
  {
    symbol: 'OTEX',
    'Security Name': 'Open Text Corporation  Common Shares',

    'NASDAQ symbol': 'OTEX',
  },
  {
    symbol: 'OTIC',
    'Security Name': 'Otonomy,   ',

    'NASDAQ symbol': 'OTIC',
  },
  {
    symbol: 'OTIS',
    'Security Name': 'Otis Worldwide Corporation  ',

    'CQS symbol': 'OTIS',
    'NASDAQ symbol': 'OTIS',
  },
  {
    symbol: 'OTLK',
    'Security Name': 'Outlook Therapeutics,   ',

    'NASDAQ symbol': 'OTLK',
  },
  {
    symbol: 'OTLKW',
    'Security Name': 'Outlook Therapeutics,   Series A Warrant',

    'NASDAQ symbol': 'OTLKW',
  },
  {
    symbol: 'OTRAU',
    'Security Name': 'OTR Acquisition Corp  Unit',

    'NASDAQ symbol': 'OTRAU',
  },
  {
    symbol: 'OTRK',
    'Security Name': 'Ontrak,   ',

    'NASDAQ symbol': 'OTRK',
  },
  {
    symbol: 'OTRKP',
    'Security Name':
      'Ontrak,   950% Series A Cumulative Perpetual Preferred Stock',

    'NASDAQ symbol': 'OTRKP',
  },
  {
    symbol: 'OTTR',
    'Security Name': 'Otter Tail Corporation  ',

    'NASDAQ symbol': 'OTTR',
  },
  {
    symbol: 'OUNZ',
    'Security Name': 'VanEck Merk Gold Trust',

    'CQS symbol': 'OUNZ',
    'NASDAQ symbol': 'OUNZ',
  },
  {
    symbol: 'OUSA',
    'Security Name': 'OShares US Quality Dividend ETF',

    'CQS symbol': 'OUSA',
    'NASDAQ symbol': 'OUSA',
  },
  {
    symbol: 'OUSM',
    'Security Name': 'OShares US SmallCap Quality Dividend ETF',

    'CQS symbol': 'OUSM',
    'NASDAQ symbol': 'OUSM',
  },
  {
    symbol: 'OUT',
    'Security Name': 'OUTFRONT Media  ',

    'CQS symbol': 'OUT',
    'NASDAQ symbol': 'OUT',
  },
  {
    symbol: 'OVB',
    'Security Name': 'Overlay Shares Core Bond ETF',

    'CQS symbol': 'OVB',
    'NASDAQ symbol': 'OVB',
  },
  {
    symbol: 'OVBC',
    'Security Name': 'Ohio Valley Banc Corp  ',

    'NASDAQ symbol': 'OVBC',
  },
  {
    symbol: 'OVF',
    'Security Name': 'Overlay Shares Foreign Equity ETF',

    'CQS symbol': 'OVF',
    'NASDAQ symbol': 'OVF',
  },
  {
    symbol: 'OVID',
    'Security Name': 'Ovid Therapeutics   ',

    'NASDAQ symbol': 'OVID',
  },
  {
    symbol: 'OVL',
    'Security Name': 'Overlay Shares Large Cap Equity ETF',

    'CQS symbol': 'OVL',
    'NASDAQ symbol': 'OVL',
  },
  {
    symbol: 'OVLY',
    'Security Name': 'Oak Valley Bancorp (CA)  ',

    'NASDAQ symbol': 'OVLY',
  },
  {
    symbol: 'OVM',
    'Security Name': 'Overlay Shares Municipal Bond ETF',

    'CQS symbol': 'OVM',
    'NASDAQ symbol': 'OVM',
  },
  {
    symbol: 'OVS',
    'Security Name': 'Overlay Shares Small Cap Equity ETF',

    'CQS symbol': 'OVS',
    'NASDAQ symbol': 'OVS',
  },
  {
    symbol: 'OVV',
    'Security Name': 'Ovintiv  (DE)',

    'CQS symbol': 'OVV',
    'NASDAQ symbol': 'OVV',
  },
  {
    symbol: 'OXBR',
    'Security Name': 'Oxbridge Re Holdings Limited  Ordinary Shares',

    'NASDAQ symbol': 'OXBR',
  },
  {
    symbol: 'OXBRW',
    'Security Name': 'Oxbridge Re Holdings Limited  Warrant',

    'NASDAQ symbol': 'OXBRW',
  },
  {
    symbol: 'OXFD',
    'Security Name': 'Oxford Immunotec Global PLC  Ordinary Shares',

    'NASDAQ symbol': 'OXFD',
  },
  {
    symbol: 'OXLC',
    'Security Name': 'Oxford Lane Capital Corp  ',

    'NASDAQ symbol': 'OXLC',
  },
  {
    symbol: 'OXLCM',
    'Security Name':
      'Oxford Lane Capital Corp  675% Series 2024 Term Preferred Stock',

    'NASDAQ symbol': 'OXLCM',
  },
  {
    symbol: 'OXLCO',
    'Security Name':
      'Oxford Lane Capital Corp  Term Preferred Shares, 750% Series 2023',

    'NASDAQ symbol': 'OXLCO',
  },
  {
    symbol: 'OXLCP',
    'Security Name':
      'Oxford Lane Capital Corp  625% Series 2027 Term Preferred Shares',

    'NASDAQ symbol': 'OXLCP',
  },
  {
    symbol: 'OXM',
    'Security Name': 'Oxford Industries,  ',

    'CQS symbol': 'OXM',
    'NASDAQ symbol': 'OXM',
  },
  {
    symbol: 'OXSQ',
    'Security Name': 'Oxford Square Capital Corp  Closed End Fund',

    'NASDAQ symbol': 'OXSQ',
  },
  {
    symbol: 'OXSQL',
    'Security Name': 'Oxford Square Capital Corp  650% Notes due 2024',

    'NASDAQ symbol': 'OXSQL',
  },
  {
    symbol: 'OXSQZ',
    'Security Name': 'Oxford Square Capital Corp  625% Notes due 2026',

    'NASDAQ symbol': 'OXSQZ',
  },
  {
    symbol: 'OXY',
    'Security Name': 'Occidental Petroleum Corporation ',

    'CQS symbol': 'OXY',
    'NASDAQ symbol': 'OXY',
  },
  {
    symbol: 'OXYW',
    'Security Name': 'Occidental Petroleum Corporation Warrants ',

    'CQS symbol': 'OXYWS',
    'NASDAQ symbol': 'OXY+',
  },
  {
    symbol: 'OYST',
    'Security Name': 'Oyster Point Pharma,   ',

    'NASDAQ symbol': 'OYST',
  },
  {
    symbol: 'OZK',
    'Security Name': 'Bank OZK  ',

    'NASDAQ symbol': 'OZK',
  },
  {
    symbol: 'OZON',
    'Security Name':
      'Ozon Holdings PLC  ADS, each ADS representing one ordinary share',

    'NASDAQ symbol': 'OZON',
  },
  {
    symbol: 'PAA',
    'Security Name': 'Plains All American Pipeline, LP ',

    'CQS symbol': 'PAA',
    'NASDAQ symbol': 'PAA',
  },
  {
    symbol: 'PAAS',
    'Security Name': 'Pan American Silver Corp  ',

    'NASDAQ symbol': 'PAAS',
  },
  {
    symbol: 'PAC',
    'Security Name':
      'Grupo Aeroportuario Del Pacifico, SA B de CV Grupo Aeroportuario Del Pacifico, SA de CV (each representing 10 Series B shares)',

    'CQS symbol': 'PAC',
    'NASDAQ symbol': 'PAC',
  },
  {
    symbol: 'PACB',
    'Security Name': 'Pacific Biosciences of California,   ',

    'NASDAQ symbol': 'PACB',
  },
  {
    symbol: 'PACE',
    'Security Name': 'TPG Pace Tech Opportunities Corp  Ordinary Shares',

    'CQS symbol': 'PACE',
    'NASDAQ symbol': 'PACE',
  },
  {
    symbol: 'PACEU',
    'Security Name':
      'TPG Pace Tech Opportunities Corp Units, each consisting of one  ordinary share and onefifth of one Warrant',

    'CQS symbol': 'PACEU',
    'NASDAQ symbol': 'PACE=',
  },
  {
    symbol: 'PACEW',
    'Security Name':
      'TPG Pace Tech Opportunities Corp Warrants, each whole warrant exercisable for one  ordinary share at an exercise price of $1150 per share',

    'CQS symbol': 'PACEWS',
    'NASDAQ symbol': 'PACE+',
  },
  {
    symbol: 'PACK',
    'Security Name': 'Ranpak Holdings Corp  ',

    'CQS symbol': 'PACK',
    'NASDAQ symbol': 'PACK',
  },
  {
    symbol: 'PACW',
    'Security Name': 'PacWest Bancorp  ',

    'NASDAQ symbol': 'PACW',
  },
  {
    symbol: 'PAE',
    'Security Name': 'PAE orporated   ',

    'NASDAQ symbol': 'PAE',
  },
  {
    symbol: 'PAEWW',
    'Security Name': 'PAE orporated  Warrants',

    'NASDAQ symbol': 'PAEWW',
  },
  {
    symbol: 'PAG',
    'Security Name': 'Penske Automotive Group,  ',

    'CQS symbol': 'PAG',
    'NASDAQ symbol': 'PAG',
  },
  {
    symbol: 'PAGP',
    'Security Name':
      'Plains Group Holdings, LP  Shares representing limited partner interests',

    'CQS symbol': 'PAGP',
    'NASDAQ symbol': 'PAGP',
  },
  {
    symbol: 'PAGS',
    'Security Name': 'PagSeguro Digital Ltd  Common Shares',

    'CQS symbol': 'PAGS',
    'NASDAQ symbol': 'PAGS',
  },
  {
    symbol: 'PAHC',
    'Security Name': 'Phibro Animal Health Corporation   ',

    'NASDAQ symbol': 'PAHC',
  },
  {
    symbol: 'PAI',
    'Security Name': 'Western Asset Investment Grade ome Fund ',

    'CQS symbol': 'PAI',
    'NASDAQ symbol': 'PAI',
  },
  {
    symbol: 'PAIC',
    'Security Name': 'Petra Acquisition,   ',

    'NASDAQ symbol': 'PAIC',
  },
  {
    symbol: 'PAICU',
    'Security Name': 'Petra Acquisition,   Units',

    'NASDAQ symbol': 'PAICU',
  },
  {
    symbol: 'PAICW',
    'Security Name': 'Petra Acquisition,   Warrant',

    'NASDAQ symbol': 'PAICW',
  },
  {
    symbol: 'PAK',
    'Security Name': 'Global X MSCI Pakistan ETF',

    'CQS symbol': 'PAK',
    'NASDAQ symbol': 'PAK',
  },
  {
    symbol: 'PALC',
    'Security Name': 'Pacer Lunt Large Cap MultiFactor Alternator ETF',

    'CQS symbol': 'PALC',
    'NASDAQ symbol': 'PALC',
  },
  {
    symbol: 'PALL',
    'Security Name': 'Aberdeen Standard Physical Palladium Shares ETF',

    'CQS symbol': 'PALL',
    'NASDAQ symbol': 'PALL',
  },
  {
    symbol: 'PAM',
    'Security Name': 'Pampa Energia SA Pampa Energia SA',

    'CQS symbol': 'PAM',
    'NASDAQ symbol': 'PAM',
  },
  {
    symbol: 'PAMC',
    'Security Name': 'Pacer Lunt MidCap MultiFactor Alternator ETF',

    'CQS symbol': 'PAMC',
    'NASDAQ symbol': 'PAMC',
  },
  {
    symbol: 'PANA',
    'Security Name': 'Panacea Acquisition Corp  ',

    'CQS symbol': 'PANA',
    'NASDAQ symbol': 'PANA',
  },
  {
    symbol: 'PANAU',
    'Security Name':
      'Panacea Acquisition Corp Units, each consisting of one share of   and onethird of one redeemable warrant',

    'CQS symbol': 'PANAU',
    'NASDAQ symbol': 'PANA=',
  },
  {
    symbol: 'PANAW',
    'Security Name':
      'Panacea Acquisition Corp Redeemable warrants, each whole warrant exercisable for one share of   at an exercise price of $1150',

    'CQS symbol': 'PANAWS',
    'NASDAQ symbol': 'PANA+',
  },
  {
    symbol: 'PAND',
    'Security Name': 'Pandion Therapeutics   ',

    'NASDAQ symbol': 'PAND',
  },
  {
    symbol: 'PANL',
    'Security Name': 'Pangaea Logistics Solutions Ltd  ',

    'NASDAQ symbol': 'PANL',
  },
  {
    symbol: 'PANW',
    'Security Name': 'Palo Alto Networks,  ',

    'CQS symbol': 'PANW',
    'NASDAQ symbol': 'PANW',
  },
  {
    symbol: 'PAPR',
    'Security Name': 'Innovator S&P 500 Power Buffer ETF  April',

    'CQS symbol': 'PAPR',
    'NASDAQ symbol': 'PAPR',
  },
  {
    symbol: 'PAR',
    'Security Name': 'PAR Technology Corporation ',

    'CQS symbol': 'PAR',
    'NASDAQ symbol': 'PAR',
  },
  {
    symbol: 'PARR',
    'Security Name': 'Par Pacific Holdings,   ',

    'CQS symbol': 'PARR',
    'NASDAQ symbol': 'PARR',
  },
  {
    symbol: 'PASG',
    'Security Name': 'Passage Bio,   ',

    'NASDAQ symbol': 'PASG',
  },
  {
    symbol: 'PATI',
    'Security Name': 'Patriot Transportation Holding,   ',

    'NASDAQ symbol': 'PATI',
  },
  {
    symbol: 'PATK',
    'Security Name': 'Patrick Industries,   ',

    'NASDAQ symbol': 'PATK',
  },
  {
    symbol: 'PAUG',
    'Security Name': 'Innovator S&P 500 Power Buffer ETF  August',

    'CQS symbol': 'PAUG',
    'NASDAQ symbol': 'PAUG',
  },
  {
    symbol: 'PAVE',
    'Security Name':
      'Global X Funds Global X US Infrastructure Development ETF',

    'CQS symbol': 'PAVE',
    'NASDAQ symbol': 'PAVE',
  },
  {
    symbol: 'PAVM',
    'Security Name': 'PAVmed   ',

    'NASDAQ symbol': 'PAVM',
  },
  {
    symbol: 'PAVMW',
    'Security Name': 'PAVmed   Warrant',

    'NASDAQ symbol': 'PAVMW',
  },
  {
    symbol: 'PAVMZ',
    'Security Name': 'PAVmed   Series Z Warrant',

    'NASDAQ symbol': 'PAVMZ',
  },
  {
    symbol: 'PAWZ',
    'Security Name': 'ProShares Pet Care ETF',

    'CQS symbol': 'PAWZ',
    'NASDAQ symbol': 'PAWZ',
  },
  {
    symbol: 'PAYA',
    'Security Name': 'Paya Holdings   ',

    'NASDAQ symbol': 'PAYA',
  },
  {
    symbol: 'PAYAW',
    'Security Name': 'Paya Holdings   Warrant',

    'NASDAQ symbol': 'PAYAW',
  },
  {
    symbol: 'PAYC',
    'Security Name': 'Paycom Software,  ',

    'CQS symbol': 'PAYC',
    'NASDAQ symbol': 'PAYC',
  },
  {
    symbol: 'PAYS',
    'Security Name': 'Paysign,   ',

    'NASDAQ symbol': 'PAYS',
  },
  {
    symbol: 'PAYX',
    'Security Name': 'Paychex,   ',

    'NASDAQ symbol': 'PAYX',
  },
  {
    symbol: 'PB',
    'Security Name': 'Prosperity Bancshares,  ',

    'CQS symbol': 'PB',
    'NASDAQ symbol': 'PB',
  },
  {
    symbol: 'PBA',
    'Security Name': 'Pembina Pipeline Corp Ordinary Shares (Canada)',

    'CQS symbol': 'PBA',
    'NASDAQ symbol': 'PBA',
  },
  {
    symbol: 'PBB',
    'Security Name': 'Prospect Capital Corporation 625% Notes due 2024',

    'CQS symbol': 'PBB',
    'NASDAQ symbol': 'PBB',
  },
  {
    symbol: 'PBC',
    'Security Name': 'Prospect Capital Corporation 6875% Notes due 2029',

    'CQS symbol': 'PBC',
    'NASDAQ symbol': 'PBC',
  },
  {
    symbol: 'PBCT',
    'Security Name': "People's United Financial,   ",

    'NASDAQ symbol': 'PBCT',
  },
  {
    symbol: 'PBCTP',
    'Security Name':
      "People's United Financial,   Perpetual Preferred Series A Fixedtofloating Rate",

    'NASDAQ symbol': 'PBCTP',
  },
  {
    symbol: 'PBD',
    'Security Name': 'Invesco Global Clean Energy ETF',

    'CQS symbol': 'PBD',
    'NASDAQ symbol': 'PBD',
  },
  {
    symbol: 'PBDM',
    'Security Name': 'Invesco PureBeta FTSE Developed exNorth America ETF',

    'CQS symbol': 'PBDM',
    'NASDAQ symbol': 'PBDM',
  },
  {
    symbol: 'PBE',
    'Security Name': 'Invesco Dynamic Biotech & Genome ETF',

    'CQS symbol': 'PBE',
    'NASDAQ symbol': 'PBE',
  },
  {
    symbol: 'PBEE',
    'Security Name': 'Invesco PureBeta FTSE Emerging Markets ETF',

    'CQS symbol': 'PBEE',
    'NASDAQ symbol': 'PBEE',
  },
  {
    symbol: 'PBF',
    'Security Name': 'PBF Energy   ',

    'CQS symbol': 'PBF',
    'NASDAQ symbol': 'PBF',
  },
  {
    symbol: 'PBFS',
    'Security Name': 'Pioneer Bancorp,   ',

    'NASDAQ symbol': 'PBFS',
  },
  {
    symbol: 'PBFX',
    'Security Name':
      'PBF Logistics LP Common Units representing limited partner interests',

    'CQS symbol': 'PBFX',
    'NASDAQ symbol': 'PBFX',
  },
  {
    symbol: 'PBH',
    'Security Name': 'Prestige Consumer Healthcare  ',

    'CQS symbol': 'PBH',
    'NASDAQ symbol': 'PBH',
  },
  {
    symbol: 'PBHC',
    'Security Name': 'Pathfinder Bancorp,   ',

    'NASDAQ symbol': 'PBHC',
  },
  {
    symbol: 'PBI',
    'Security Name': 'Pitney Bowes  ',

    'CQS symbol': 'PBI',
    'NASDAQ symbol': 'PBI',
  },
  {
    symbol: 'PBI$B',
    'Security Name': 'Pitney Bowes  670% Notes Due 2043',

    'CQS symbol': 'PBIpB',
    'NASDAQ symbol': 'PBIB',
  },
  {
    symbol: 'PBIP',
    'Security Name': 'Prudential Bancorp,   ',

    'NASDAQ symbol': 'PBIP',
  },
  {
    symbol: 'PBJ',
    'Security Name': 'Invesco Dynamic Food & Beverage ETF',

    'CQS symbol': 'PBJ',
    'NASDAQ symbol': 'PBJ',
  },
  {
    symbol: 'PBLA',
    'Security Name': 'Panbela Therapeutics,   ',

    'NASDAQ symbol': 'PBLA',
  },
  {
    symbol: 'PBND',
    'Security Name': 'Invesco PureBeta US Aggregate Bond ETF',

    'CQS symbol': 'PBND',
    'NASDAQ symbol': 'PBND',
  },
  {
    symbol: 'PBP',
    'Security Name': 'Invesco S&P 500 BuyWrite ETF',

    'CQS symbol': 'PBP',
    'NASDAQ symbol': 'PBP',
  },
  {
    symbol: 'PBPB',
    'Security Name': 'Potbelly Corporation  ',

    'NASDAQ symbol': 'PBPB',
  },
  {
    symbol: 'PBR',
    'Security Name': 'Petroleo Brasileiro SA Petrobras ',

    'CQS symbol': 'PBR',
    'NASDAQ symbol': 'PBR',
  },
  {
    symbol: 'PBRA',
    'Security Name':
      'Petroleo Brasileiro SA Petrobras American Depositary Shares',

    'CQS symbol': 'PBRA',
    'NASDAQ symbol': 'PBRA',
  },
  {
    symbol: 'PBS',
    'Security Name': 'Invesco Dynamic Media ETF',

    'CQS symbol': 'PBS',
    'NASDAQ symbol': 'PBS',
  },
  {
    symbol: 'PBSM',
    'Security Name': 'Invesco PureBeta MSCI USA Small Cap ETF',

    'CQS symbol': 'PBSM',
    'NASDAQ symbol': 'PBSM',
  },
  {
    symbol: 'PBT',
    'Security Name': 'Permian Basin Royalty Trust ',

    'CQS symbol': 'PBT',
    'NASDAQ symbol': 'PBT',
  },
  {
    symbol: 'PBTP',
    'Security Name': 'Invesco PureBeta 05 Yr US TIPS ETF',

    'CQS symbol': 'PBTP',
    'NASDAQ symbol': 'PBTP',
  },
  {
    symbol: 'PBTS',
    'Security Name': 'Powerbridge Technologies Co, Ltd  Ordinary Shares',

    'NASDAQ symbol': 'PBTS',
  },
  {
    symbol: 'PBUS',
    'Security Name': 'Invesco PureBeta MSCI USA ETF',

    'CQS symbol': 'PBUS',
    'NASDAQ symbol': 'PBUS',
  },
  {
    symbol: 'PBW',
    'Security Name': 'Invesco WilderHill Clean Energy ETF',

    'CQS symbol': 'PBW',
    'NASDAQ symbol': 'PBW',
  },
  {
    symbol: 'PBY',
    'Security Name': 'Prospect Capital Corporation 625% Notes due 2028',

    'CQS symbol': 'PBY',
    'NASDAQ symbol': 'PBY',
  },
  {
    symbol: 'PBYI',
    'Security Name': 'Puma Biotechnology   ',

    'NASDAQ symbol': 'PBYI',
  },
  {
    symbol: 'PCAR',
    'Security Name': 'PACCAR   ',

    'NASDAQ symbol': 'PCAR',
  },
  {
    symbol: 'PCB',
    'Security Name': 'PCB Bancorp  ',

    'NASDAQ symbol': 'PCB',
  },
  {
    symbol: 'PCEF',
    'Security Name': 'Invesco CEF ome Composite ETF',

    'CQS symbol': 'PCEF',
    'NASDAQ symbol': 'PCEF',
  },
  {
    symbol: 'PCF',
    'Security Name': 'High ome Securities Fund ',

    'CQS symbol': 'PCF',
    'NASDAQ symbol': 'PCF',
  },
  {
    symbol: 'PCG',
    'Security Name': 'Pacific Gas & Electric Co ',

    'CQS symbol': 'PCG',
    'NASDAQ symbol': 'PCG',
  },
  {
    symbol: 'PCG$A',
    'Security Name': 'Pacific Gas & Electric Co 6% Preferred Stock',

    'CQS symbol': 'PCGpA',
    'NASDAQ symbol': 'PCGA',
  },
  {
    symbol: 'PCG$B',
    'Security Name': 'Pacific Gas & Electric Co 5 1/2% Preferred Stock',

    'CQS symbol': 'PCGpB',
    'NASDAQ symbol': 'PCGB',
  },
  {
    symbol: 'PCG$C',
    'Security Name': 'Pacific Gas & Electric Co 5% 1st Preferred Stock',

    'CQS symbol': 'PCGpC',
    'NASDAQ symbol': 'PCGC',
  },
  {
    symbol: 'PCG$D',
    'Security Name': 'Pacific Gas & Electric Co 5% 1st  Red Preferred Stock',

    'CQS symbol': 'PCGpD',
    'NASDAQ symbol': 'PCGD',
  },
  {
    symbol: 'PCG$E',
    'Security Name': 'Pacific Gas & Electric Co 5% 1st A Preferred Stock',

    'CQS symbol': 'PCGpE',
    'NASDAQ symbol': 'PCGE',
  },
  {
    symbol: 'PCG$G',
    'Security Name': 'Pacific Gas & Electric Co 480% 1st Preferred Stock',

    'CQS symbol': 'PCGpG',
    'NASDAQ symbol': 'PCGG',
  },
  {
    symbol: 'PCG$H',
    'Security Name': 'Pacific Gas & Electric Co 450% 1st Preferred Stock',

    'CQS symbol': 'PCGpH',
    'NASDAQ symbol': 'PCGH',
  },
  {
    symbol: 'PCG$I',
    'Security Name': 'Pacific Gas & Electric Co 436% 1st Preferred Stock',

    'CQS symbol': 'PCGpI',
    'NASDAQ symbol': 'PCGI',
  },
  {
    symbol: 'PCGU',
    'Security Name': 'Pacific Gas & Electric Co Equity Unit',

    'CQS symbol': 'PCGU',
    'NASDAQ symbol': 'PCGU',
  },
  {
    symbol: 'PCH',
    'Security Name': 'PotlatchDeltic Corporation  ',

    'NASDAQ symbol': 'PCH',
  },
  {
    symbol: 'PCI',
    'Security Name':
      'PIMCO Dynamic Credit and Mortgage ome Fund Common Shares of Beneficial Interest',

    'CQS symbol': 'PCI',
    'NASDAQ symbol': 'PCI',
  },
  {
    symbol: 'PCK',
    'Security Name':
      'Pimco California Municipal ome Fund II Common Shares of Beneficial Interest',

    'CQS symbol': 'PCK',
    'NASDAQ symbol': 'PCK',
  },
  {
    symbol: 'PCM',
    'Security Name': 'PCM Fund,  ',

    'CQS symbol': 'PCM',
    'NASDAQ symbol': 'PCM',
  },
  {
    symbol: 'PCN',
    'Security Name': 'Pimco Corporate & ome Strategy Fund ',

    'CQS symbol': 'PCN',
    'NASDAQ symbol': 'PCN',
  },
  {
    symbol: 'PCOM',
    'Security Name': 'Points International, Ltd  Common Shares',

    'NASDAQ symbol': 'PCOM',
  },
  {
    symbol: 'PCPL',
    'Security Name': 'CC Neuberger Pripal Holdings I  Ordinary Shares',

    'CQS symbol': 'PCPL',
    'NASDAQ symbol': 'PCPL',
  },
  {
    symbol: 'PCPLU',
    'Security Name':
      'CC Neuberger Pripal Holdings I Units, each consisting of one  ordinary share and onefourth of one Redeemable Warrant',

    'CQS symbol': 'PCPLU',
    'NASDAQ symbol': 'PCPL=',
  },
  {
    symbol: 'PCPLW',
    'Security Name':
      'CC Neuberger Pripal Holdings I Warrants, each whole warrant exercisable for one  ordinary share at an exercise price of $1150',

    'CQS symbol': 'PCPLWS',
    'NASDAQ symbol': 'PCPL+',
  },
  {
    symbol: 'PCQ',
    'Security Name': 'PIMCO California Municipal ome Fund ',

    'CQS symbol': 'PCQ',
    'NASDAQ symbol': 'PCQ',
  },
  {
    symbol: 'PCRX',
    'Security Name': 'Pacira BioSciences,   ',

    'NASDAQ symbol': 'PCRX',
  },
  {
    symbol: 'PCSA',
    'Security Name': 'Processa Pharmaceuticals,   ',

    'NASDAQ symbol': 'PCSA',
  },
  {
    symbol: 'PCSB',
    'Security Name': 'PCSB Financial Corporation  ',

    'NASDAQ symbol': 'PCSB',
  },
  {
    symbol: 'PCTI',
    'Security Name': 'PCTEL,   ',

    'NASDAQ symbol': 'PCTI',
  },
  {
    symbol: 'PCTY',
    'Security Name': 'Paylocity Holding Corporation  ',

    'NASDAQ symbol': 'PCTY',
  },
  {
    symbol: 'PCVX',
    'Security Name': 'Vaxcyte,   ',

    'NASDAQ symbol': 'PCVX',
  },
  {
    symbol: 'PCY',
    'Security Name': 'Invesco Emerging Markets Sovereign Debt ETF',

    'CQS symbol': 'PCY',
    'NASDAQ symbol': 'PCY',
  },
  {
    symbol: 'PCYG',
    'Security Name': 'Park City Group,   ',

    'NASDAQ symbol': 'PCYG',
  },
  {
    symbol: 'PCYO',
    'Security Name': 'Pure Cycle Corporation  ',

    'NASDAQ symbol': 'PCYO',
  },
  {
    symbol: 'PD',
    'Security Name': 'PagerDuty,  ',

    'CQS symbol': 'PD',
    'NASDAQ symbol': 'PD',
  },
  {
    symbol: 'PDAC',
    'Security Name': 'Peridot Acquisition Corp  Ordinary Shares',

    'CQS symbol': 'PDAC',
    'NASDAQ symbol': 'PDAC',
  },
  {
    symbol: 'PDACU',
    'Security Name':
      'Peridot Acquisition Corp Units, each consisting of one  ordinary share, and onehalf of one redeemable warrant',

    'CQS symbol': 'PDACU',
    'NASDAQ symbol': 'PDAC=',
  },
  {
    symbol: 'PDACW',
    'Security Name':
      'Peridot Acquisition Corp Redeemable Warrants, each whole warrant exercisable for one  ordinary share at an exercise price of $1150',

    'CQS symbol': 'PDACWS',
    'NASDAQ symbol': 'PDAC+',
  },
  {
    symbol: 'PDBC',
    'Security Name':
      'Invesco Optimum Yield Diversified Commodity Strategy No K1 ETF',

    'NASDAQ symbol': 'PDBC',
  },
  {
    symbol: 'PDCE',
    'Security Name': 'PDC Energy,   ',

    'NASDAQ symbol': 'PDCE',
  },
  {
    symbol: 'PDCO',
    'Security Name': 'Patterson Companies,   ',

    'NASDAQ symbol': 'PDCO',
  },
  {
    symbol: 'PDD',
    'Security Name': 'Pinduoduo   American Depositary Shares',

    'NASDAQ symbol': 'PDD',
  },
  {
    symbol: 'PDEC',
    'Security Name': 'Innovator S&P 500 Power Buffer ETF  December',

    'CQS symbol': 'PDEC',
    'NASDAQ symbol': 'PDEC',
  },
  {
    symbol: 'PDEV',
    'Security Name': 'Pripal International MultiFactor ETF',

    'NASDAQ symbol': 'PDEV',
  },
  {
    symbol: 'PDEX',
    'Security Name': 'ProDex,   ',

    'NASDAQ symbol': 'PDEX',
  },
  {
    symbol: 'PDFS',
    'Security Name': 'PDF Solutions,   ',

    'NASDAQ symbol': 'PDFS',
  },
  {
    symbol: 'PDI',
    'Security Name': 'PIMCO Dynamic ome Fund ',

    'CQS symbol': 'PDI',
    'NASDAQ symbol': 'PDI',
  },
  {
    symbol: 'PDLB',
    'Security Name': 'PDL Community Bancorp  ',

    'NASDAQ symbol': 'PDLB',
  },
  {
    symbol: 'PDLI',
    'Security Name': 'PDL BioPharma,   ',

    'NASDAQ symbol': 'PDLI',
  },
  {
    symbol: 'PDM',
    'Security Name': 'Piedmont Office Realty Trust,   ',

    'CQS symbol': 'PDM',
    'NASDAQ symbol': 'PDM',
  },
  {
    symbol: 'PDN',
    'Security Name': 'Invesco FTSE RAFI Developed Markets exUS SmallMid ETF',

    'CQS symbol': 'PDN',
    'NASDAQ symbol': 'PDN',
  },
  {
    symbol: 'PDP',
    'Security Name': 'Invesco DWA Momentum ETF',

    'NASDAQ symbol': 'PDP',
  },
  {
    symbol: 'PDS',
    'Security Name': 'Precision Drilling Corporation ',

    'CQS symbol': 'PDS',
    'NASDAQ symbol': 'PDS',
  },
  {
    symbol: 'PDSB',
    'Security Name': 'PDS Biotechnology Corporation  ',

    'NASDAQ symbol': 'PDSB',
  },
  {
    symbol: 'PDT',
    'Security Name': 'John Hancock Premium Dividend Fund',

    'CQS symbol': 'PDT',
    'NASDAQ symbol': 'PDT',
  },
  {
    symbol: 'PE',
    'Security Name': 'Parsley Energy,   ',

    'CQS symbol': 'PE',
    'NASDAQ symbol': 'PE',
  },
  {
    symbol: 'PEAK',
    'Security Name': 'Healthpeak Properties,  ',

    'CQS symbol': 'PEAK',
    'NASDAQ symbol': 'PEAK',
  },
  {
    symbol: 'PEB',
    'Security Name':
      'Pebblebrook Hotel Trust Common Shares of Beneficial Interest',

    'CQS symbol': 'PEB',
    'NASDAQ symbol': 'PEB',
  },
  {
    symbol: 'PEB$C',
    'Security Name':
      'Pebblebrook Hotel Trust 650% Series C Cumulative Redeemable Preferred Shares of Beneficial Interest',

    'CQS symbol': 'PEBpC',
    'NASDAQ symbol': 'PEBC',
  },
  {
    symbol: 'PEB$D',
    'Security Name':
      'Pebblebrook Hotel Trust 6375% Series D Cumulative Redeemable Preferred Shares of Beneficial Interest',

    'CQS symbol': 'PEBpD',
    'NASDAQ symbol': 'PEBD',
  },
  {
    symbol: 'PEB$E',
    'Security Name':
      'Pebblebrook Hotel Trust 6375% Series E Cumulative Redeemable Preferred Shares of Beneficial Interest',

    'CQS symbol': 'PEBpE',
    'NASDAQ symbol': 'PEBE',
  },
  {
    symbol: 'PEB$F',
    'Security Name':
      'Pebblebrook Hotel Trust 63% Series F Cumulative Redeemable Preferred Shares of Beneficial Interest',

    'CQS symbol': 'PEBpF',
    'NASDAQ symbol': 'PEBF',
  },
  {
    symbol: 'PEBK',
    'Security Name': 'Peoples Bancorp of North Carolina,   ',

    'NASDAQ symbol': 'PEBK',
  },
  {
    symbol: 'PEBO',
    'Security Name': 'Peoples Bancorp   ',

    'NASDAQ symbol': 'PEBO',
  },
  {
    symbol: 'PECK',
    'Security Name': 'The Peck Company Holdings,   ',

    'NASDAQ symbol': 'PECK',
  },
  {
    symbol: 'PED',
    'Security Name': 'Pedevco Corp ',

    'CQS symbol': 'PED',
    'NASDAQ symbol': 'PED',
  },
  {
    symbol: 'PEG',
    'Security Name': 'Public Service Enterprise Group orporated ',

    'CQS symbol': 'PEG',
    'NASDAQ symbol': 'PEG',
  },
  {
    symbol: 'PEGA',
    'Security Name': 'Pegasystems   ',

    'NASDAQ symbol': 'PEGA',
  },
  {
    symbol: 'PEI',
    'Security Name': 'Pennsylvania Real Estate Investment Trust ',

    'CQS symbol': 'PEI',
    'NASDAQ symbol': 'PEI',
  },
  {
    symbol: 'PEI$B',
    'Security Name':
      'Pennsylvania Real Estate Investment Trust Cumulative Redeemable Perpetual Preferred Shares Series B',

    'CQS symbol': 'PEIpB',
    'NASDAQ symbol': 'PEIB',
  },
  {
    symbol: 'PEI$C',
    'Security Name':
      'Pennsylvania Real Estate Investment Trust 720% Series C Cumulative Redeemable Perpetual Preferred Shares',

    'CQS symbol': 'PEIpC',
    'NASDAQ symbol': 'PEIC',
  },
  {
    symbol: 'PEI$D',
    'Security Name':
      'Pennsylvania Real Estate Investment Trust 6875% Series D Cumulative Redeemable Perpetual Preferred Shares',

    'CQS symbol': 'PEIpD',
    'NASDAQ symbol': 'PEID',
  },
  {
    symbol: 'PEIX',
    'Security Name': 'Pacific Ethanol,   ',

    'NASDAQ symbol': 'PEIX',
  },
  {
    symbol: 'PEJ',
    'Security Name': 'Invesco Dynamic Leisure and Entertainment ETF',

    'CQS symbol': 'PEJ',
    'NASDAQ symbol': 'PEJ',
  },
  {
    symbol: 'PEN',
    'Security Name': 'Penumbra,  ',

    'CQS symbol': 'PEN',
    'NASDAQ symbol': 'PEN',
  },
  {
    symbol: 'PENN',
    'Security Name': 'Penn National Gaming,   ',

    'NASDAQ symbol': 'PENN',
  },
  {
    symbol: 'PEO',
    'Security Name': 'Adams Natural Resources Fund,  ',

    'CQS symbol': 'PEO',
    'NASDAQ symbol': 'PEO',
  },
  {
    symbol: 'PEP',
    'Security Name': 'PepsiCo,   ',

    'NASDAQ symbol': 'PEP',
  },
  {
    symbol: 'PERI',
    'Security Name': 'Perion Network Ltd  Ordinary Shares',

    'NASDAQ symbol': 'PERI',
  },
  {
    symbol: 'PESI',
    'Security Name': 'PermaFix Environmental Services,   ',

    'NASDAQ symbol': 'PESI',
  },
  {
    symbol: 'PETQ',
    'Security Name': 'PetIQ,    ',

    'NASDAQ symbol': 'PETQ',
  },
  {
    symbol: 'PETS',
    'Security Name': 'PetMed Express,   ',

    'NASDAQ symbol': 'PETS',
  },
  {
    symbol: 'PETZ',
    'Security Name': 'TDH Holdings,   Common Shares',

    'NASDAQ symbol': 'PETZ',
  },
  {
    symbol: 'PEX',
    'Security Name': 'ProShares Global Listed Private Equity ETF',

    'CQS symbol': 'PEX',
    'NASDAQ symbol': 'PEX',
  },
  {
    symbol: 'PEXL',
    'Security Name': 'Pacer US Export Leaders ETF',

    'CQS symbol': 'PEXL',
    'NASDAQ symbol': 'PEXL',
  },
  {
    symbol: 'PEY',
    'Security Name': 'Invesco High Yield Equity Dividend Achievers ETF',

    'NASDAQ symbol': 'PEY',
  },
  {
    symbol: 'PEZ',
    'Security Name': 'Invesco DWA Consumer Cyclicals Momentum ETF',

    'NASDAQ symbol': 'PEZ',
  },
  {
    symbol: 'PFBC',
    'Security Name': 'Preferred Bank  ',

    'NASDAQ symbol': 'PFBC',
  },
  {
    symbol: 'PFBI',
    'Security Name': 'Premier Financial Bancorp,   ',

    'NASDAQ symbol': 'PFBI',
  },
  {
    symbol: 'PFC',
    'Security Name': 'Premier Financial Corp   ',

    'NASDAQ symbol': 'PFC',
  },
  {
    symbol: 'PFD',
    'Security Name': 'Flaherty & Crumrine Preferred and ome Fund orporated',

    'CQS symbol': 'PFD',
    'NASDAQ symbol': 'PFD',
  },
  {
    symbol: 'PFE',
    'Security Name': 'Pfizer,  ',

    'CQS symbol': 'PFE',
    'NASDAQ symbol': 'PFE',
  },
  {
    symbol: 'PFEB',
    'Security Name': 'Innovator S&P 500 Power Buffer ETF  February',

    'CQS symbol': 'PFEB',
    'NASDAQ symbol': 'PFEB',
  },
  {
    symbol: 'PFF',
    'Security Name': 'iShares Preferred and ome Securities ETF',

    'NASDAQ symbol': 'PFF',
  },
  {
    symbol: 'PFFA',
    'Security Name': 'Virtus InfraCap US Preferred Stock ETF',

    'CQS symbol': 'PFFA',
    'NASDAQ symbol': 'PFFA',
  },
  {
    symbol: 'PFFD',
    'Security Name': 'Global X US Preferred ETF',

    'CQS symbol': 'PFFD',
    'NASDAQ symbol': 'PFFD',
  },
  {
    symbol: 'PFFL',
    'Security Name':
      'ETRACS 2xMonthly Pay Leveraged Preferred Stock Index ETN due September 25, 2048',

    'CQS symbol': 'PFFL',
    'NASDAQ symbol': 'PFFL',
  },
  {
    symbol: 'PFFR',
    'Security Name': 'ETFIS Series Trust I ETF',

    'CQS symbol': 'PFFR',
    'NASDAQ symbol': 'PFFR',
  },
  {
    symbol: 'PFFV',
    'Security Name': 'Global X Variable Rate Preferred ETF',

    'CQS symbol': 'PFFV',
    'NASDAQ symbol': 'PFFV',
  },
  {
    symbol: 'PFG',
    'Security Name': 'Pripal Financial Group   ',

    'NASDAQ symbol': 'PFG',
  },
  {
    symbol: 'PFGC',
    'Security Name': 'Performance Food Group Company ',

    'CQS symbol': 'PFGC',
    'NASDAQ symbol': 'PFGC',
  },
  {
    symbol: 'PFH',
    'Security Name':
      'Prudential Financial,  4125% Junior Subordinated Notes due 2060',

    'CQS symbol': 'PFH',
    'NASDAQ symbol': 'PFH',
  },
  {
    symbol: 'PFHD',
    'Security Name': 'Professional Holding Corp   ',

    'NASDAQ symbol': 'PFHD',
  },
  {
    symbol: 'PFI',
    'Security Name': 'Invesco DWA Financial Momentum ETF',

    'NASDAQ symbol': 'PFI',
  },
  {
    symbol: 'PFIE',
    'Security Name': 'Profire Energy,   ',

    'NASDAQ symbol': 'PFIE',
  },
  {
    symbol: 'PFIG',
    'Security Name': 'Invesco Fundamental Investment Grade Corporate Bond  ETF',

    'CQS symbol': 'PFIG',
    'NASDAQ symbol': 'PFIG',
  },
  {
    symbol: 'PFIN',
    'Security Name': 'P & F Industries,    ',

    'NASDAQ symbol': 'PFIN',
  },
  {
    symbol: 'PFIS',
    'Security Name': 'Peoples Financial Services Corp   ',

    'NASDAQ symbol': 'PFIS',
  },
  {
    symbol: 'PFL',
    'Security Name': 'PIMCO ome Strategy Fund Shares of Beneficial Interest',

    'CQS symbol': 'PFL',
    'NASDAQ symbol': 'PFL',
  },
  {
    symbol: 'PFLD',
    'Security Name': 'AAM Low Duration Preferred and ome Securities ETF',

    'CQS symbol': 'PFLD',
    'NASDAQ symbol': 'PFLD',
  },
  {
    symbol: 'PFLT',
    'Security Name': 'PennantPark Floating Rate Capital Ltd  ',

    'NASDAQ symbol': 'PFLT',
  },
  {
    symbol: 'PFM',
    'Security Name': 'Invesco Dividend Achievers ETF',

    'NASDAQ symbol': 'PFM',
  },
  {
    symbol: 'PFMT',
    'Security Name': 'Performant Financial Corporation  ',

    'NASDAQ symbol': 'PFMT',
  },
  {
    symbol: 'PFN',
    'Security Name': 'PIMCO ome Strategy Fund II',

    'CQS symbol': 'PFN',
    'NASDAQ symbol': 'PFN',
  },
  {
    symbol: 'PFO',
    'Security Name':
      'Flaherty & Crumrine Preferred and ome Opportunity Fund orporated',

    'CQS symbol': 'PFO',
    'NASDAQ symbol': 'PFO',
  },
  {
    symbol: 'PFPT',
    'Security Name': 'Proofpoint,   ',

    'NASDAQ symbol': 'PFPT',
  },
  {
    symbol: 'PFS',
    'Security Name': 'Provident Financial Services,  ',

    'CQS symbol': 'PFS',
    'NASDAQ symbol': 'PFS',
  },
  {
    symbol: 'PFSI',
    'Security Name': 'PennyMac Financial Services,  ',

    'CQS symbol': 'PFSI',
    'NASDAQ symbol': 'PFSI',
  },
  {
    symbol: 'PFSW',
    'Security Name': 'PFSweb,   ',

    'NASDAQ symbol': 'PFSW',
  },
  {
    symbol: 'PFXF',
    'Security Name': 'VanEck Vectors Preferred Securities ex Financials ETF',

    'CQS symbol': 'PFXF',
    'NASDAQ symbol': 'PFXF',
  },
  {
    symbol: 'PG',
    'Security Name': 'Procter & Gamble Company (The) ',

    'CQS symbol': 'PG',
    'NASDAQ symbol': 'PG',
  },
  {
    symbol: 'PGAL',
    'Security Name': 'Global X MSCI Portugal ETF',

    'CQS symbol': 'PGAL',
    'NASDAQ symbol': 'PGAL',
  },
  {
    symbol: 'PGC',
    'Security Name': 'PeapackGladstone Financial Corporation  ',

    'NASDAQ symbol': 'PGC',
  },
  {
    symbol: 'PGEN',
    'Security Name': 'Precigen,   ',

    'NASDAQ symbol': 'PGEN',
  },
  {
    symbol: 'PGF',
    'Security Name': 'Invesco Financial Preferred ETF',

    'CQS symbol': 'PGF',
    'NASDAQ symbol': 'PGF',
  },
  {
    symbol: 'PGHY',
    'Security Name': 'Invesco Global Short Term High Yield Bond ETF',

    'CQS symbol': 'PGHY',
    'NASDAQ symbol': 'PGHY',
  },
  {
    symbol: 'PGJ',
    'Security Name': 'Invesco Golden Dragon China ETF',

    'NASDAQ symbol': 'PGJ',
  },
  {
    symbol: 'PGM',
    'Security Name':
      'iPathA Series B Bloomberg Platinum Subindex Total Return ETN',

    'CQS symbol': 'PGM',
    'NASDAQ symbol': 'PGM',
  },
  {
    symbol: 'PGNY',
    'Security Name': 'Progyny,   ',

    'NASDAQ symbol': 'PGNY',
  },
  {
    symbol: 'PGP',
    'Security Name':
      'Pimco Global Stocksplus & ome Fund Pimco Global StocksPlus & ome Fund Common Shares of Beneficial Interest',

    'CQS symbol': 'PGP',
    'NASDAQ symbol': 'PGP',
  },
  {
    symbol: 'PGR',
    'Security Name': 'Progressive Corporation (The) ',

    'CQS symbol': 'PGR',
    'NASDAQ symbol': 'PGR',
  },
  {
    symbol: 'PGRE',
    'Security Name': 'Paramount Group,  ',

    'CQS symbol': 'PGRE',
    'NASDAQ symbol': 'PGRE',
  },
  {
    symbol: 'PGTI',
    'Security Name': 'PGT Innovations, ',

    'CQS symbol': 'PGTI',
    'NASDAQ symbol': 'PGTI',
  },
  {
    symbol: 'PGX',
    'Security Name': 'Invesco Preferred ETF',

    'CQS symbol': 'PGX',
    'NASDAQ symbol': 'PGX',
  },
  {
    symbol: 'PGZ',
    'Security Name':
      'Pripal Real Estate ome Fund Common Shares of Beneficial Interest',

    'CQS symbol': 'PGZ',
    'NASDAQ symbol': 'PGZ',
  },
  {
    symbol: 'PH',
    'Security Name': 'ParkerHannifin Corporation ',

    'CQS symbol': 'PH',
    'NASDAQ symbol': 'PH',
  },
  {
    symbol: 'PHAS',
    'Security Name': 'PhaseBio Pharmaceuticals,   ',

    'NASDAQ symbol': 'PHAS',
  },
  {
    symbol: 'PHAT',
    'Security Name': 'Phathom Pharmaceuticals,   ',

    'NASDAQ symbol': 'PHAT',
  },
  {
    symbol: 'PHB',
    'Security Name': 'Invesco Fundamental High Yield Corporate Bond ETF',

    'CQS symbol': 'PHB',
    'NASDAQ symbol': 'PHB',
  },
  {
    symbol: 'PHCF',
    'Security Name':
      'Puhui Wealth Investment Management Co, Ltd   Ordinary Shares',

    'NASDAQ symbol': 'PHCF',
  },
  {
    symbol: 'PHD',
    'Security Name':
      'Pioneer Floating Rate Trust Pioneer Floating Rate Trust Shares of Beneficial Interest',

    'CQS symbol': 'PHD',
    'NASDAQ symbol': 'PHD',
  },
  {
    symbol: 'PHDG',
    'Security Name': 'Invesco S&P 500 Downside Hedged ETF',

    'CQS symbol': 'PHDG',
    'NASDAQ symbol': 'PHDG',
  },
  {
    symbol: 'PHG',
    'Security Name': 'Koninklijke Philips NV NY Registry Shares',

    'CQS symbol': 'PHG',
    'NASDAQ symbol': 'PHG',
  },
  {
    symbol: 'PHGE',
    'Security Name': 'BiomX  ',

    'CQS symbol': 'PHGE',
    'NASDAQ symbol': 'PHGE',
  },
  {
    symbol: 'PHGEU',
    'Security Name': 'BiomX  Units',

    'CQS symbol': 'PHGEU',
    'NASDAQ symbol': 'PHGE=',
  },
  {
    symbol: 'PHGEW',
    'Security Name': 'BiomX  Warrants',

    'CQS symbol': 'PHGEWS',
    'NASDAQ symbol': 'PHGE+',
  },
  {
    symbol: 'PHI',
    'Security Name': 'PLDT  Sponsored ADR',

    'CQS symbol': 'PHI',
    'NASDAQ symbol': 'PHI',
  },
  {
    symbol: 'PHICU',
    'Security Name': 'Population Health Investment Co,   Unit',

    'NASDAQ symbol': 'PHICU',
  },
  {
    symbol: 'PHIO',
    'Security Name': 'Phio Pharmaceuticals Corp  ',

    'NASDAQ symbol': 'PHIO',
  },
  {
    symbol: 'PHIOW',
    'Security Name': 'Phio Pharmaceuticals Corp  Warrants',

    'NASDAQ symbol': 'PHIOW',
  },
  {
    symbol: 'PHK',
    'Security Name': 'Pimco High ome Fund Pimco High ome Fund',

    'CQS symbol': 'PHK',
    'NASDAQ symbol': 'PHK',
  },
  {
    symbol: 'PHM',
    'Security Name': 'PulteGroup,  ',

    'CQS symbol': 'PHM',
    'NASDAQ symbol': 'PHM',
  },
  {
    symbol: 'PHO',
    'Security Name': 'Invesco Water Resources ETF',

    'NASDAQ symbol': 'PHO',
  },
  {
    symbol: 'PHR',
    'Security Name': 'Phreesia,  ',

    'CQS symbol': 'PHR',
    'NASDAQ symbol': 'PHR',
  },
  {
    symbol: 'PHT',
    'Security Name':
      'Pioneer High ome Trust Common Shares of Beneficial Interest',

    'CQS symbol': 'PHT',
    'NASDAQ symbol': 'PHT',
  },
  {
    symbol: 'PHUN',
    'Security Name': 'Phunware,   ',

    'NASDAQ symbol': 'PHUN',
  },
  {
    symbol: 'PHUNW',
    'Security Name': 'Phunware,   Warrants',

    'NASDAQ symbol': 'PHUNW',
  },
  {
    symbol: 'PHX',
    'Security Name': 'PHX Minerals  ',

    'CQS symbol': 'PHX',
    'NASDAQ symbol': 'PHX',
  },
  {
    symbol: 'PHYL',
    'Security Name': 'PGIM Active High Yield Bond ETF',

    'CQS symbol': 'PHYL',
    'NASDAQ symbol': 'PHYL',
  },
  {
    symbol: 'PHYS',
    'Security Name': 'Sprott Physical Gold Trust ETV',

    'CQS symbol': 'PHYS',
    'NASDAQ symbol': 'PHYS',
  },
  {
    symbol: 'PI',
    'Security Name': 'Impinj,   ',

    'NASDAQ symbol': 'PI',
  },
  {
    symbol: 'PIAI',
    'Security Name': 'Prime Impact Acquisition I  Ordinary Shares',

    'CQS symbol': 'PIAI',
    'NASDAQ symbol': 'PIAI',
  },
  {
    symbol: 'PIAIU',
    'Security Name':
      'Prime Impact Acquisition I Units, each consisting of one  ordinary share, and onethird of a redeemable Warrant to acquire one  ordinary share',

    'CQS symbol': 'PIAIU',
    'NASDAQ symbol': 'PIAI=',
  },
  {
    symbol: 'PIAIW',
    'Security Name':
      'Prime Impact Acquisition I Warrants, each whole warrant exercisable for one  ordinary share at an exercise price of $1150',

    'CQS symbol': 'PIAIWS',
    'NASDAQ symbol': 'PIAI+',
  },
  {
    symbol: 'PIC',
    'Security Name': 'Pivotal Investment Corporation II  ',

    'CQS symbol': 'PIC',
    'NASDAQ symbol': 'PIC',
  },
  {
    symbol: 'PICU',
    'Security Name': 'Pivotal Investment Corporation II Units',

    'CQS symbol': 'PICU',
    'NASDAQ symbol': 'PIC=',
  },
  {
    symbol: 'PICW',
    'Security Name': 'Pivotal Investment Corporation II Redeemable Warrants',

    'CQS symbol': 'PICWS',
    'NASDAQ symbol': 'PIC+',
  },
  {
    symbol: 'PICB',
    'Security Name': 'Invesco International Corporate Bond ETF',

    'CQS symbol': 'PICB',
    'NASDAQ symbol': 'PICB',
  },
  {
    symbol: 'PICK',
    'Security Name':
      'iShares MSCI Global Select Metals & Mining Producers Fund',

    'CQS symbol': 'PICK',
    'NASDAQ symbol': 'PICK',
  },
  {
    symbol: 'PICO',
    'Security Name': 'PICO Holdings   ',

    'NASDAQ symbol': 'PICO',
  },
  {
    symbol: 'PID',
    'Security Name': 'Invesco International Dividend Achievers ETF',

    'NASDAQ symbol': 'PID',
  },
  {
    symbol: 'PIE',
    'Security Name': 'Invesco DWA Emerging Markets Momentum ETF',

    'NASDAQ symbol': 'PIE',
  },
  {
    symbol: 'PIFI',
    'Security Name': 'ClearShares Piton Intermediate Fixed ome ETF',

    'CQS symbol': 'PIFI',
    'NASDAQ symbol': 'PIFI',
  },
  {
    symbol: 'PIH',
    'Security Name': '1347 Property Insurance Holdings,   ',

    'NASDAQ symbol': 'PIH',
  },
  {
    symbol: 'PIHPP',
    'Security Name':
      '1347 Property Insurance Holdings,   800% Cumulative Series A Preferred Stock',

    'NASDAQ symbol': 'PIHPP',
  },
  {
    symbol: 'PII',
    'Security Name': 'Polaris  ',

    'CQS symbol': 'PII',
    'NASDAQ symbol': 'PII',
  },
  {
    symbol: 'PILL',
    'Security Name': 'Direxion Daily Pharmaceutical & Medical Bull 3X Shares',

    'CQS symbol': 'PILL',
    'NASDAQ symbol': 'PILL',
  },
  {
    symbol: 'PIM',
    'Security Name': 'Putnam Master Intermediate ome Trust ',

    'CQS symbol': 'PIM',
    'NASDAQ symbol': 'PIM',
  },
  {
    symbol: 'PIN',
    'Security Name': 'Invesco India ETF',

    'CQS symbol': 'PIN',
    'NASDAQ symbol': 'PIN',
  },
  {
    symbol: 'P',
    'Security Name': 'Premier,    ',

    'NASDAQ symbol': 'P',
  },
  {
    symbol: 'PINE',
    'Security Name': 'Alpine ome Property Trust,  ',

    'CQS symbol': 'PINE',
    'NASDAQ symbol': 'PINE',
  },
  {
    symbol: 'PING',
    'Security Name': 'Ping Identity Holding Corp ',

    'CQS symbol': 'PING',
    'NASDAQ symbol': 'PING',
  },
  {
    symbol: 'PINS',
    'Security Name': 'Pinterest,   ',

    'CQS symbol': 'PINS',
    'NASDAQ symbol': 'PINS',
  },
  {
    symbol: 'PIO',
    'Security Name': 'Invesco Global Water ETF',

    'NASDAQ symbol': 'PIO',
  },
  {
    symbol: 'PIPPU',
    'Security Name':
      'Pine Island Acquisition Corp Units, each consisting of one share of   and onethird of one redeemable warrant',

    'CQS symbol': 'PIPPU',
    'NASDAQ symbol': 'PIPP=',
  },
  {
    symbol: 'PIPR',
    'Security Name': 'Piper Sandler Companies ',

    'CQS symbol': 'PIPR',
    'NASDAQ symbol': 'PIPR',
  },
  {
    symbol: 'PIRS',
    'Security Name': 'Pieris Pharmaceuticals,   ',

    'NASDAQ symbol': 'PIRS',
  },
  {
    symbol: 'PIXY',
    'Security Name': 'ShiftPixy,   ',

    'NASDAQ symbol': 'PIXY',
  },
  {
    symbol: 'PIZ',
    'Security Name': 'Invesco DWA Developed Markets Momentum ETF',

    'NASDAQ symbol': 'PIZ',
  },
  {
    symbol: 'PJAN',
    'Security Name': 'Innovator S&P 500 Power Buffer ETF  January',

    'CQS symbol': 'PJAN',
    'NASDAQ symbol': 'PJAN',
  },
  {
    symbol: 'PJP',
    'Security Name': 'Invesco Dynamic Pharmaceuticals ETF',

    'CQS symbol': 'PJP',
    'NASDAQ symbol': 'PJP',
  },
  {
    symbol: 'PJT',
    'Security Name': 'PJT Partners   ',

    'CQS symbol': 'PJT',
    'NASDAQ symbol': 'PJT',
  },
  {
    symbol: 'PJUL',
    'Security Name': 'Innovator S&P 500 Power Buffer ETF  July',

    'CQS symbol': 'PJUL',
    'NASDAQ symbol': 'PJUL',
  },
  {
    symbol: 'PJUN',
    'Security Name': 'Innovator S&P 500 Power Buffer ETF  June',

    'CQS symbol': 'PJUN',
    'NASDAQ symbol': 'PJUN',
  },
  {
    symbol: 'PK',
    'Security Name': 'Park Hotels & Resorts   ',

    'CQS symbol': 'PK',
    'NASDAQ symbol': 'PK',
  },
  {
    symbol: 'PKB',
    'Security Name': 'Invesco Dynamic Building & Construction ETF',

    'CQS symbol': 'PKB',
    'NASDAQ symbol': 'PKB',
  },
  {
    symbol: 'PKBK',
    'Security Name': 'Parke Bancorp,   ',

    'NASDAQ symbol': 'PKBK',
  },
  {
    symbol: 'PKE',
    'Security Name': 'Park Aerospace Corp ',

    'CQS symbol': 'PKE',
    'NASDAQ symbol': 'PKE',
  },
  {
    symbol: 'PKG',
    'Security Name': 'Packaging Corporation of America ',

    'CQS symbol': 'PKG',
    'NASDAQ symbol': 'PKG',
  },
  {
    symbol: 'PKI',
    'Security Name': 'PerkinElmer,  ',

    'CQS symbol': 'PKI',
    'NASDAQ symbol': 'PKI',
  },
  {
    symbol: 'PKO',
    'Security Name':
      'Pimco ome Opportunity Fund Common Shares of Beneficial Interest',

    'CQS symbol': 'PKO',
    'NASDAQ symbol': 'PKO',
  },
  {
    symbol: 'PKOH',
    'Security Name': 'ParkOhio Holdings Corp  ',

    'NASDAQ symbol': 'PKOH',
  },
  {
    symbol: 'PKW',
    'Security Name': 'Invesco BuyBack Achievers ETF',

    'NASDAQ symbol': 'PKW',
  },
  {
    symbol: 'PKX',
    'Security Name': 'POSCO ',

    'CQS symbol': 'PKX',
    'NASDAQ symbol': 'PKX',
  },
  {
    symbol: 'PLAB',
    'Security Name': 'Photronics,   ',

    'NASDAQ symbol': 'PLAB',
  },
  {
    symbol: 'PLAG',
    'Security Name': 'Planet Green Holdings Corp ',

    'CQS symbol': 'PLAG',
    'NASDAQ symbol': 'PLAG',
  },
  {
    symbol: 'PLAN',
    'Security Name': 'Anaplan,  ',

    'CQS symbol': 'PLAN',
    'NASDAQ symbol': 'PLAN',
  },
  {
    symbol: 'PLAT',
    'Security Name': 'WisdomTree Growth Leaders Fund',

    'CQS symbol': 'PLAT',
    'NASDAQ symbol': 'PLAT',
  },
  {
    symbol: 'PLAY',
    'Security Name': "Dave & Buster's Entertainment,   ",

    'NASDAQ symbol': 'PLAY',
  },
  {
    symbol: 'PLBC',
    'Security Name': 'Plumas Bancorp  ',

    'NASDAQ symbol': 'PLBC',
  },
  {
    symbol: 'PLC',
    'Security Name': 'Pripal US LargeCap MultiFactor ETF',

    'NASDAQ symbol': 'PLC',
  },
  {
    symbol: 'PLCE',
    'Security Name': "Children's Place,  (The)  ",

    'NASDAQ symbol': 'PLCE',
  },
  {
    symbol: 'PLD',
    'Security Name': 'Prologis,  ',

    'CQS symbol': 'PLD',
    'NASDAQ symbol': 'PLD',
  },
  {
    symbol: 'PLG',
    'Security Name': 'Platinum Group Metals Ltd Ordinary Shares (Canada)',

    'CQS symbol': 'PLG',
    'NASDAQ symbol': 'PLG',
  },
  {
    symbol: 'PLIN',
    'Security Name': 'China Xiangtai Food Co, Ltd  Ordinary Shares',

    'NASDAQ symbol': 'PLIN',
  },
  {
    symbol: 'PLL',
    'Security Name': 'Piedmont Lithium Limited  American Depositary Shares',

    'NASDAQ symbol': 'PLL',
  },
  {
    symbol: 'PLM',
    'Security Name': 'Polymet Mining Corporation Ordinary Shares (Canada)',

    'CQS symbol': 'PLM',
    'NASDAQ symbol': 'PLM',
  },
  {
    symbol: 'PLMR',
    'Security Name': 'Palomar Holdings,   ',

    'NASDAQ symbol': 'PLMR',
  },
  {
    symbol: 'PLNT',
    'Security Name': 'Planet Fitness,  ',

    'CQS symbol': 'PLNT',
    'NASDAQ symbol': 'PLNT',
  },
  {
    symbol: 'PLOW',
    'Security Name': 'Douglas Dynamics,  ',

    'CQS symbol': 'PLOW',
    'NASDAQ symbol': 'PLOW',
  },
  {
    symbol: 'PLPC',
    'Security Name': 'Preformed Line Products Company  ',

    'NASDAQ symbol': 'PLPC',
  },
  {
    symbol: 'PLRX',
    'Security Name': 'Pliant Therapeutics,   ',

    'NASDAQ symbol': 'PLRX',
  },
  {
    symbol: 'PLSE',
    'Security Name': 'Pulse Biosciences,   ',

    'NASDAQ symbol': 'PLSE',
  },
  {
    symbol: 'PLT',
    'Security Name': 'Plantronics,  ',

    'CQS symbol': 'PLT',
    'NASDAQ symbol': 'PLT',
  },
  {
    symbol: 'PLTM',
    'Security Name': 'GraniteShares Platinum Shares ETF',

    'CQS symbol': 'PLTM',
    'NASDAQ symbol': 'PLTM',
  },
  {
    symbol: 'PLTR',
    'Security Name': 'Palantir Technologies   ',

    'CQS symbol': 'PLTR',
    'NASDAQ symbol': 'PLTR',
  },
  {
    symbol: 'PLUG',
    'Security Name': 'Plug Power,   ',

    'NASDAQ symbol': 'PLUG',
  },
  {
    symbol: 'PLUS',
    'Security Name': 'ePlus   ',

    'NASDAQ symbol': 'PLUS',
  },
  {
    symbol: 'PLW',
    'Security Name': 'Invesco 130 Laddered Treasury ETF',

    'NASDAQ symbol': 'PLW',
  },
  {
    symbol: 'PLX',
    'Security Name': 'Protalix BioTherapeutics,  (DE) ',

    'CQS symbol': 'PLX',
    'NASDAQ symbol': 'PLX',
  },
  {
    symbol: 'PLXP',
    'Security Name': 'PLx Pharma   ',

    'NASDAQ symbol': 'PLXP',
  },
  {
    symbol: 'PLXS',
    'Security Name': 'Plexus Corp  ',

    'NASDAQ symbol': 'PLXS',
  },
  {
    symbol: 'PLYA',
    'Security Name': 'Playa Hotels & Resorts NV  Ordinary Shares',

    'NASDAQ symbol': 'PLYA',
  },
  {
    symbol: 'PLYM',
    'Security Name': 'Plymouth Industrial REIT,  ',

    'CQS symbol': 'PLYM',
    'NASDAQ symbol': 'PLYM',
  },
  {
    symbol: 'PLYM$A',
    'Security Name':
      'Plymouth Industrial REIT,  750% Series A Cumulative Redeemable Preferred Stock',

    'CQS symbol': 'PLYMpA',
    'NASDAQ symbol': 'PLYMA',
  },
  {
    symbol: 'PM',
    'Security Name': 'Philip Morris International  ',

    'CQS symbol': 'PM',
    'NASDAQ symbol': 'PM',
  },
  {
    symbol: 'PMAR',
    'Security Name': 'Innovator S&P 500 Power Buffer ETF  March',

    'CQS symbol': 'PMAR',
    'NASDAQ symbol': 'PMAR',
  },
  {
    symbol: 'PMAY',
    'Security Name': 'Innovator S&P 500 Power Buffer ETF  May',

    'CQS symbol': 'PMAY',
    'NASDAQ symbol': 'PMAY',
  },
  {
    symbol: 'PMBC',
    'Security Name': 'Pacific Mercantile Bancorp  ',

    'NASDAQ symbol': 'PMBC',
  },
  {
    symbol: 'PMD',
    'Security Name': 'Psychemedics Corporation  ',

    'NASDAQ symbol': 'PMD',
  },
  {
    symbol: 'PME',
    'Security Name': 'Pingtan Marine Enterprise Ltd  Ordinary Shares',

    'NASDAQ symbol': 'PME',
  },
  {
    symbol: 'PMF',
    'Security Name': 'PIMCO Municipal ome Fund ',

    'CQS symbol': 'PMF',
    'NASDAQ symbol': 'PMF',
  },
  {
    symbol: 'PML',
    'Security Name':
      'Pimco Municipal ome Fund II Common Shares of Beneficial Interest',

    'CQS symbol': 'PML',
    'NASDAQ symbol': 'PML',
  },
  {
    symbol: 'PMM',
    'Security Name': 'Putnam Managed Municipal ome Trust ',

    'CQS symbol': 'PMM',
    'NASDAQ symbol': 'PMM',
  },
  {
    symbol: 'PMO',
    'Security Name': 'Putnam Municipal Opportunities Trust ',

    'CQS symbol': 'PMO',
    'NASDAQ symbol': 'PMO',
  },
  {
    symbol: 'PMT',
    'Security Name':
      'PennyMac Mortgage Investment Trust Common Shares of Beneficial Interest',

    'CQS symbol': 'PMT',
    'NASDAQ symbol': 'PMT',
  },
  {
    symbol: 'PMT$A',
    'Security Name':
      'PennyMac Mortgage Investment Trust 8125% Series A FixedtoFloating Rate Cumulative Redeemable Preferred Shares of Beneficial Interest',

    'CQS symbol': 'PMTpA',
    'NASDAQ symbol': 'PMTA',
  },
  {
    symbol: 'PMT$B',
    'Security Name':
      'PennyMac Mortgage Investment Trust 800% Series B FixedtoFloating Rate Cumulative Redeemable Preferred Shares of Beneficial Interest',

    'CQS symbol': 'PMTpB',
    'NASDAQ symbol': 'PMTB',
  },
  {
    symbol: 'PMVC',
    'Security Name': 'PMV Consumer Acquisition Corp  ',

    'CQS symbol': 'PMVC',
    'NASDAQ symbol': 'PMVC',
  },
  {
    symbol: 'PMVCU',
    'Security Name':
      'PMV Consumer Acquisition Corp Units, each consisting of one share of   and onehalf of one redeemable warrant',

    'CQS symbol': 'PMVCU',
    'NASDAQ symbol': 'PMVC=',
  },
  {
    symbol: 'PMVCW',
    'Security Name':
      'PMV Consumer Acquisition Corp Redeemable Warrants, each whole warrant exercisable for one share of   at an exercise price of $1150',

    'CQS symbol': 'PMVCWS',
    'NASDAQ symbol': 'PMVC+',
  },
  {
    symbol: 'PMVP',
    'Security Name': 'PMV Pharmaceuticals,   ',

    'NASDAQ symbol': 'PMVP',
  },
  {
    symbol: 'PMX',
    'Security Name':
      'PIMCO Municipal ome Fund III Common Shares of Beneficial Interest',

    'CQS symbol': 'PMX',
    'NASDAQ symbol': 'PMX',
  },
  {
    symbol: 'PNBK',
    'Security Name': 'Patriot National Bancorp   ',

    'NASDAQ symbol': 'PNBK',
  },
  {
    symbol: 'PNC',
    'Security Name': 'PNC Financial Services Group,  (The) ',

    'CQS symbol': 'PNC',
    'NASDAQ symbol': 'PNC',
  },
  {
    symbol: 'PNC$P',
    'Security Name':
      'PNC Financial Services Group,  (The) Depositary Shares Representing 1/4000th Perpetual Preferred Series P',

    'CQS symbol': 'PNCpP',
    'NASDAQ symbol': 'PNCP',
  },
  {
    symbol: 'PNF',
    'Security Name': 'PIMCO New York Municipal ome Fund ',

    'CQS symbol': 'PNF',
    'NASDAQ symbol': 'PNF',
  },
  {
    symbol: 'PNFP',
    'Security Name': 'Pinnacle Financial Partners,   ',

    'NASDAQ symbol': 'PNFP',
  },
  {
    symbol: 'PNFPP',
    'Security Name':
      'Pinnacle Financial Partners,   Depositary shares of Pinnacle Financial Partners, , each representing a 1/40th Interest in a share of its 675% FixedRate NonCumulative Perpetual Preferred Stock, Series B',

    'NASDAQ symbol': 'PNFPP',
  },
  {
    symbol: 'PNI',
    'Security Name':
      'Pimco New York Municipal ome Fund II Common Shares of Beneficial Interest',

    'CQS symbol': 'PNI',
    'NASDAQ symbol': 'PNI',
  },
  {
    symbol: 'PNM',
    'Security Name': 'PNM Resources,  (Holding Co) ',

    'CQS symbol': 'PNM',
    'NASDAQ symbol': 'PNM',
  },
  {
    symbol: 'PNNT',
    'Security Name': 'PennantPark Investment Corporation  ',

    'NASDAQ symbol': 'PNNT',
  },
  {
    symbol: 'PNNTG',
    'Security Name': 'PennantPark Investment Corporation  550% Notes Due 2024',

    'NASDAQ symbol': 'PNNTG',
  },
  {
    symbol: 'PNOV',
    'Security Name': 'Innovator S&P 500 Power Buffer ETF  November',

    'CQS symbol': 'PNOV',
    'NASDAQ symbol': 'PNOV',
  },
  {
    symbol: 'PNQI',
    'Security Name': 'Invesco Nasdaq Internet ETF',

    'NASDAQ symbol': 'PNQI',
  },
  {
    symbol: 'PNR',
    'Security Name': 'Pentair plc Ordinary Share',

    'CQS symbol': 'PNR',
    'NASDAQ symbol': 'PNR',
  },
  {
    symbol: 'PNRG',
    'Security Name': 'PrimeEnergy Resources Corporation  ',

    'NASDAQ symbol': 'PNRG',
  },
  {
    symbol: 'PNTG',
    'Security Name': 'The Pennant Group,   ',

    'NASDAQ symbol': 'PNTG',
  },
  {
    symbol: 'PNW',
    'Security Name': 'Pinnacle West Capital Corporation ',

    'CQS symbol': 'PNW',
    'NASDAQ symbol': 'PNW',
  },
  {
    symbol: 'POAI',
    'Security Name': 'Predictive Oncology   ',

    'NASDAQ symbol': 'POAI',
  },
  {
    symbol: 'POCT',
    'Security Name': 'Innovator S&P 500 Power Buffer ETF  October',

    'CQS symbol': 'POCT',
    'NASDAQ symbol': 'POCT',
  },
  {
    symbol: 'PODD',
    'Security Name': 'Insulet Corporation  ',

    'NASDAQ symbol': 'PODD',
  },
  {
    symbol: 'POLA',
    'Security Name': 'Polar Power,   ',

    'NASDAQ symbol': 'POLA',
  },
  {
    symbol: 'POOL',
    'Security Name': 'Pool Corporation  ',

    'NASDAQ symbol': 'POOL',
  },
  {
    symbol: 'POR',
    'Security Name': 'Portland General Electric Co ',

    'CQS symbol': 'POR',
    'NASDAQ symbol': 'POR',
  },
  {
    symbol: 'POST',
    'Security Name': 'Post Holdings,  ',

    'CQS symbol': 'POST',
    'NASDAQ symbol': 'POST',
  },
  {
    symbol: 'POTX',
    'Security Name': 'Global X Cannabis ETF',

    'NASDAQ symbol': 'POTX',
  },
  {
    symbol: 'POWI',
    'Security Name': 'Power Integrations,   ',

    'NASDAQ symbol': 'POWI',
  },
  {
    symbol: 'POWL',
    'Security Name': 'Powell Industries,   ',

    'NASDAQ symbol': 'POWL',
  },
  {
    symbol: 'POWW',
    'Security Name': 'AMMO,   ',

    'NASDAQ symbol': 'POWW',
  },
  {
    symbol: 'PPA',
    'Security Name': 'Invesco Aerospace & Defense ETF ',

    'CQS symbol': 'PPA',
    'NASDAQ symbol': 'PPA',
  },
  {
    symbol: 'PPBI',
    'Security Name': 'Pacific Premier Bancorp   ',

    'NASDAQ symbol': 'PPBI',
  },
  {
    symbol: 'PPC',
    'Security Name': "Pilgrim's Pride Corporation  ",

    'NASDAQ symbol': 'PPC',
  },
  {
    symbol: 'PPD',
    'Security Name': 'PPD,   ',

    'NASDAQ symbol': 'PPD',
  },
  {
    symbol: 'PPG',
    'Security Name': 'PPG Industries,  ',

    'CQS symbol': 'PPG',
    'NASDAQ symbol': 'PPG',
  },
  {
    symbol: 'PPH',
    'Security Name': 'VanEck Vectors Pharmaceutical ETF',

    'NASDAQ symbol': 'PPH',
  },
  {
    symbol: 'PPIH',
    'Security Name': 'PermaPipe International Holdings,   ',

    'NASDAQ symbol': 'PPIH',
  },
  {
    symbol: 'PPL',
    'Security Name': 'PPL Corporation ',

    'CQS symbol': 'PPL',
    'NASDAQ symbol': 'PPL',
  },
  {
    symbol: 'PPLT',
    'Security Name': 'Aberdeen Standard Physical Platinum Shares ETF',

    'CQS symbol': 'PPLT',
    'NASDAQ symbol': 'PPLT',
  },
  {
    symbol: 'PPR',
    'Security Name': 'Voya Prime Rate Trust Shares of Beneficial Interest',

    'CQS symbol': 'PPR',
    'NASDAQ symbol': 'PPR',
  },
  {
    symbol: 'PPSI',
    'Security Name': 'Pioneer Power Solutions,   ',

    'NASDAQ symbol': 'PPSI',
  },
  {
    symbol: 'PPT',
    'Security Name': 'Putnam Premier ome Trust ',

    'CQS symbol': 'PPT',
    'NASDAQ symbol': 'PPT',
  },
  {
    symbol: 'PPTY',
    'Security Name': 'PPTY US Diversified Real Estate ETF',

    'CQS symbol': 'PPTY',
    'NASDAQ symbol': 'PPTY',
  },
  {
    symbol: 'PPX',
    'Security Name':
      'PPL Capital Funding,  2013 Series B Junior Subordinated Notes due 2073',

    'CQS symbol': 'PPX',
    'NASDAQ symbol': 'PPX',
  },
  {
    symbol: 'PQDI',
    'Security Name': 'Pripal Spectrum TaxAdvantaged Dividend Active ETF',

    'CQS symbol': 'PQDI',
    'NASDAQ symbol': 'PQDI',
  },
  {
    symbol: 'PQG',
    'Security Name': 'PQ Group Holdings  ',

    'CQS symbol': 'PQG',
    'NASDAQ symbol': 'PQG',
  },
  {
    symbol: 'PQIN',
    'Security Name': 'PGIM QMA Strategic Alpha International Equity ETF',

    'CQS symbol': 'PQIN',
    'NASDAQ symbol': 'PQIN',
  },
  {
    symbol: 'PQLC',
    'Security Name': 'PGIM QMA Strategic Alpha LargeCap Core ETF',

    'CQS symbol': 'PQLC',
    'NASDAQ symbol': 'PQLC',
  },
  {
    symbol: 'PQSG',
    'Security Name': 'PGIM QMA Strategic Alpha SmallCap Growth ETF',

    'CQS symbol': 'PQSG',
    'NASDAQ symbol': 'PQSG',
  },
  {
    symbol: 'PQSV',
    'Security Name':
      'PGIM ETF Trust ETF PGIM QMA Strategic Alpha SmallCap Value ETF',

    'CQS symbol': 'PQSV',
    'NASDAQ symbol': 'PQSV',
  },
  {
    symbol: 'PRA',
    'Security Name': 'ProAssurance Corporation ',

    'CQS symbol': 'PRA',
    'NASDAQ symbol': 'PRA',
  },
  {
    symbol: 'PRAA',
    'Security Name': 'PRA Group,   ',

    'NASDAQ symbol': 'PRAA',
  },
  {
    symbol: 'PRAH',
    'Security Name': 'PRA Health Sciences,   ',

    'NASDAQ symbol': 'PRAH',
  },
  {
    symbol: 'PRAX',
    'Security Name': 'Praxis Precision Medicines,   ',

    'NASDAQ symbol': 'PRAX',
  },
  {
    symbol: 'PRCP',
    'Security Name': 'Perceptron,   ',

    'NASDAQ symbol': 'PRCP',
  },
  {
    symbol: 'PRDO',
    'Security Name': 'Perdoceo Education Corporation  ',

    'NASDAQ symbol': 'PRDO',
  },
  {
    symbol: 'PRE$G',
    'Security Name':
      'PartnerRe Ltd 650% Series G Cumulative Redeemable Preferred Shares, $100 par value',

    'CQS symbol': 'PREpG',
    'NASDAQ symbol': 'PREG',
  },
  {
    symbol: 'PRE$H',
    'Security Name':
      'PartnerRe Ltd 725% Series H Cumulative Redeemable Preferred Shares, $100 par value',

    'CQS symbol': 'PREpH',
    'NASDAQ symbol': 'PREH',
  },
  {
    symbol: 'PRE$I',
    'Security Name':
      'PartnerRe Ltd 5875% Series I NonCumulative Redeemable Preferred Shares, $100 par value',

    'CQS symbol': 'PREpI',
    'NASDAQ symbol': 'PREI',
  },
  {
    symbol: 'PREF',
    'Security Name': 'Pripal Spectrum Preferred Securities Active ETF',

    'CQS symbol': 'PREF',
    'NASDAQ symbol': 'PREF',
  },
  {
    symbol: 'PRF',
    'Security Name': 'Invesco FTSE RAFI US 1000 ETF',

    'CQS symbol': 'PRF',
    'NASDAQ symbol': 'PRF',
  },
  {
    symbol: 'PRFT',
    'Security Name': 'Perficient,   ',

    'NASDAQ symbol': 'PRFT',
  },
  {
    symbol: 'PRFX',
    'Security Name': 'PainReform Ltd  Ordinary Shares',

    'NASDAQ symbol': 'PRFX',
  },
  {
    symbol: 'PRFZ',
    'Security Name': 'Invesco FTSE RAFI US 1500 SmallMid ETF',

    'NASDAQ symbol': 'PRFZ',
  },
  {
    symbol: 'PRG',
    'Security Name': 'PROG Holdings,  ',

    'CQS symbol': 'PRG',
    'NASDAQ symbol': 'PRG',
  },
  {
    symbol: 'PRGO',
    'Security Name': 'Perrigo Company plc Ordinary Shares',

    'CQS symbol': 'PRGO',
    'NASDAQ symbol': 'PRGO',
  },
  {
    symbol: 'PRGS',
    'Security Name': 'Progress Software Corporation  ',

    'NASDAQ symbol': 'PRGS',
  },
  {
    symbol: 'PRGX',
    'Security Name': 'PRGX Global,   ',

    'NASDAQ symbol': 'PRGX',
  },
  {
    symbol: 'PRI',
    'Security Name': 'Primerica,  ',

    'CQS symbol': 'PRI',
    'NASDAQ symbol': 'PRI',
  },
  {
    symbol: 'PRIF$A',
    'Security Name':
      'Priority ome Fund,  6375% Series A Term Preferred Stock due 2025',

    'CQS symbol': 'PRIFpA',
    'NASDAQ symbol': 'PRIFA',
  },
  {
    symbol: 'PRIF$B',
    'Security Name':
      'Priority ome Fund,  625% Series B Term Preferred Stock due 2023,  par value $001 per share',

    'CQS symbol': 'PRIFpB',
    'NASDAQ symbol': 'PRIFB',
  },
  {
    symbol: 'PRIF$C',
    'Security Name':
      'Priority ome Fund,  6625% Series C Term Preferred Stock due 2024, par value $001 per share',

    'CQS symbol': 'PRIFpC',
    'NASDAQ symbol': 'PRIFC',
  },
  {
    symbol: 'PRIF$D',
    'Security Name':
      'Priority ome Fund,  700% Series D Term Preferred Stock due 2029',

    'CQS symbol': 'PRIFpD',
    'NASDAQ symbol': 'PRIFD',
  },
  {
    symbol: 'PRIF$E',
    'Security Name':
      'Priority ome Fund,  6375% Series E Preferred Stock Due 2024',

    'CQS symbol': 'PRIFpE',
    'NASDAQ symbol': 'PRIFE',
  },
  {
    symbol: 'PRIF$F',
    'Security Name':
      'Priority ome Fund,  6625% Series F Term Preferred Stock due 2027',

    'CQS symbol': 'PRIFpF',
    'NASDAQ symbol': 'PRIFF',
  },
  {
    symbol: 'PRIM',
    'Security Name': 'Primoris Services Corporation  ',

    'NASDAQ symbol': 'PRIM',
  },
  {
    symbol: 'PRK',
    'Security Name': 'Park National Corporation ',

    'CQS symbol': 'PRK',
    'NASDAQ symbol': 'PRK',
  },
  {
    symbol: 'PRLB',
    'Security Name': 'Proto Labs,  ',

    'CQS symbol': 'PRLB',
    'NASDAQ symbol': 'PRLB',
  },
  {
    symbol: 'PRLD',
    'Security Name': 'Prelude Therapeutics orporated  ',

    'NASDAQ symbol': 'PRLD',
  },
  {
    symbol: 'PRMW',
    'Security Name': 'Primo Water Corporation ',

    'CQS symbol': 'PRMW',
    'NASDAQ symbol': 'PRMW',
  },
  {
    symbol: 'PRN',
    'Security Name': 'Invesco DWA Industrials Momentum ETF',

    'NASDAQ symbol': 'PRN',
  },
  {
    symbol: 'PRNT',
    'Security Name': '3D Printing (The) ETF',

    'CQS symbol': 'PRNT',
    'NASDAQ symbol': 'PRNT',
  },
  {
    symbol: 'PRO',
    'Security Name': 'PROS Holdings,  ',

    'CQS symbol': 'PRO',
    'NASDAQ symbol': 'PRO',
  },
  {
    symbol: 'PROF',
    'Security Name': 'Profound Medical Corp  ',

    'NASDAQ symbol': 'PROF',
  },
  {
    symbol: 'PROG',
    'Security Name': 'Progenity,   ',

    'NASDAQ symbol': 'PROG',
  },
  {
    symbol: 'PROS',
    'Security Name': 'ProSight Global,  ',

    'CQS symbol': 'PROS',
    'NASDAQ symbol': 'PROS',
  },
  {
    symbol: 'PROV',
    'Security Name': 'Provident Financial Holdings,   ',

    'NASDAQ symbol': 'PROV',
  },
  {
    symbol: 'PRPB',
    'Security Name': 'CC Neuberger Pripal Holdings II  Ordinary Shares',

    'CQS symbol': 'PRPB',
    'NASDAQ symbol': 'PRPB',
  },
  {
    symbol: 'PRPBU',
    'Security Name':
      'CC Neuberger Pripal Holdings II Units, each consisting of one  ordinary share and onefourth of one redeemable warrant',

    'CQS symbol': 'PRPBU',
    'NASDAQ symbol': 'PRPB=',
  },
  {
    symbol: 'PRPBW',
    'Security Name':
      'CC Neuberger Pripal Holdings II Redeemable warrants, each whole warrant exercisable for one  ordinary share at an exercise price of $1150',

    'CQS symbol': 'PRPBWS',
    'NASDAQ symbol': 'PRPB+',
  },
  {
    symbol: 'PRPH',
    'Security Name': 'ProPhase Labs,   ',

    'NASDAQ symbol': 'PRPH',
  },
  {
    symbol: 'PRPL',
    'Security Name': 'Purple Innovation,   ',

    'NASDAQ symbol': 'PRPL',
  },
  {
    symbol: 'PRPO',
    'Security Name': 'Precipio,   ',

    'NASDAQ symbol': 'PRPO',
  },
  {
    symbol: 'PRQR',
    'Security Name': 'ProQR Therapeutics NV  Ordinary Shares',

    'NASDAQ symbol': 'PRQR',
  },
  {
    symbol: 'PRS',
    'Security Name':
      'Prudential Financial,  5625% Junior Subordinated Notes due 2058',

    'CQS symbol': 'PRS',
    'NASDAQ symbol': 'PRS',
  },
  {
    symbol: 'PRSC',
    'Security Name': 'The Providence Service Corporation  ',

    'NASDAQ symbol': 'PRSC',
  },
  {
    symbol: 'PRSP',
    'Security Name': 'Perspecta   ',

    'CQS symbol': 'PRSP',
    'NASDAQ symbol': 'PRSP',
  },
  {
    symbol: 'PRT',
    'Security Name': 'PermRock Royalty Trust Trust Units',

    'CQS symbol': 'PRT',
    'NASDAQ symbol': 'PRT',
  },
  {
    symbol: 'PRTA',
    'Security Name': 'Prothena Corporation plc  Ordinary Shares',

    'NASDAQ symbol': 'PRTA',
  },
  {
    symbol: 'PRTC',
    'Security Name': 'PureTech Health plc  American Depositary Shares',

    'NASDAQ symbol': 'PRTC',
  },
  {
    symbol: 'PRTH',
    'Security Name': 'Priority Technology Holdings,   ',

    'NASDAQ symbol': 'PRTH',
  },
  {
    symbol: 'PRTK',
    'Security Name': 'Paratek Pharmaceuticals,    ',

    'NASDAQ symbol': 'PRTK',
  },
  {
    symbol: 'PRTS',
    'Security Name': 'CarPartscom,   ',

    'NASDAQ symbol': 'PRTS',
  },
  {
    symbol: 'PRTY',
    'Security Name': 'Party City Holdco  ',

    'CQS symbol': 'PRTY',
    'NASDAQ symbol': 'PRTY',
  },
  {
    symbol: 'PRU',
    'Security Name': 'Prudential Financial,  ',

    'CQS symbol': 'PRU',
    'NASDAQ symbol': 'PRU',
  },
  {
    symbol: 'PRVB',
    'Security Name': 'Provention Bio,   ',

    'NASDAQ symbol': 'PRVB',
  },
  {
    symbol: 'PRVL',
    'Security Name': 'Prevail Therapeutics   ',

    'NASDAQ symbol': 'PRVL',
  },
  {
    symbol: 'PS',
    'Security Name': 'Pluralsight,    ',

    'NASDAQ symbol': 'PS',
  },
  {
    symbol: 'PSA',
    'Security Name': 'Public Storage ',

    'CQS symbol': 'PSA',
    'NASDAQ symbol': 'PSA',
  },
  {
    symbol: 'PSA$B',
    'Security Name':
      'Public Storage Depositary Shares, each representing 1/1,000 of a 540% Cumulative Preferred Share of Beneficial Interest',

    'CQS symbol': 'PSApB',
    'NASDAQ symbol': 'PSAB',
  },
  {
    symbol: 'PSA$C',
    'Security Name':
      'Public Storage Depositary Shares Each Representing 1/1000 of a 5125% Cumulative Preferred Share of Beneficial Interest, Series C',

    'CQS symbol': 'PSApC',
    'NASDAQ symbol': 'PSAC',
  },
  {
    symbol: 'PSA$D',
    'Security Name':
      'Public Storage Depositary Shares Each Representing 1/1000 of a 495% Cumulative Preferred Share of Beneficial Interest, Series D',

    'CQS symbol': 'PSApD',
    'NASDAQ symbol': 'PSAD',
  },
  {
    symbol: 'PSA$E',
    'Security Name':
      'Public Storage Depositary Shares Each Representing 1/1000 of a 490% Cumulative Preferred Share of Beneficial Interest, Series E',

    'CQS symbol': 'PSApE',
    'NASDAQ symbol': 'PSAE',
  },
  {
    symbol: 'PSA$F',
    'Security Name':
      'Public Storage Depositary Shares Each Representing 1/1,000 of a 515% Cumulative Preferred Share of Beneficial Interest, Series F, par value $001 per share',

    'CQS symbol': 'PSApF',
    'NASDAQ symbol': 'PSAF',
  },
  {
    symbol: 'PSA$G',
    'Security Name':
      'Public Storage Depositary Shares, Each Representing 1/1,000 of a 505% Cumulative Preferred Share of Beneficial Interest, Series G',

    'CQS symbol': 'PSApG',
    'NASDAQ symbol': 'PSAG',
  },
  {
    symbol: 'PSA$H',
    'Security Name':
      'Public Storage Depositary Shares Each Representing 1/1,000 of a  560% Cumulative Preferred  Share of Beneficial Interest, Series H',

    'CQS symbol': 'PSApH',
    'NASDAQ symbol': 'PSAH',
  },
  {
    symbol: 'PSA$I',
    'Security Name':
      'Public Storage Depositary Shares Each Representing 1/1,000 of a 4875% Cumulative Preferred Share of Beneficial Interest, Series I, par value $001 per share',

    'CQS symbol': 'PSApI',
    'NASDAQ symbol': 'PSAI',
  },
  {
    symbol: 'PSA$J',
    'Security Name':
      'Public Storage Depositary Shares Each Representing 1/1,000 of a 4700% Cumulative Preferred Share of Beneficial Interest, Series J, par value $001 per share',

    'CQS symbol': 'PSApJ',
    'NASDAQ symbol': 'PSAJ',
  },
  {
    symbol: 'PSA$K',
    'Security Name':
      'Public Storage Depositary Shares Each Representing 1/1,000 of a 475% Cumulative Preferred Share of Beneficial Interest, Series K',

    'CQS symbol': 'PSApK',
    'NASDAQ symbol': 'PSAK',
  },
  {
    symbol: 'PSA$L',
    'Security Name':
      'Public Storage Depositary Shares Each Representing 1/1,000 of a 4625% Cumulative Preferred Share of Beneficial Interest, Series L, par value $001 per share',

    'CQS symbol': 'PSApL',
    'NASDAQ symbol': 'PSAL',
  },
  {
    symbol: 'PSA$M',
    'Security Name':
      'Public Storage Depositary Shares Each Representing 1/1,000 of a 4125% Cumulative Preferred Share of Beneficial Interest, Series M',

    'CQS symbol': 'PSApM',
    'NASDAQ symbol': 'PSAM',
  },
  {
    symbol: 'PSA$N',
    'Security Name':
      'Public Storage Depositary Shares Each Representing 1/1,000 of a 3875% Cumulative Preferred Share of Beneficial Interest, Series N',

    'CQS symbol': 'PSApN',
    'NASDAQ symbol': 'PSAN',
  },
  {
    symbol: 'PSA$O',
    'Security Name':
      'Public Storage Depositary Shares Each Representing 1/1,000 of a 3900% Cumulative Preferred Share of Beneficial Interest, Series O',

    'CQS symbol': 'PSApO',
    'NASDAQ symbol': 'PSAO',
  },
  {
    symbol: 'PSAC',
    'Security Name': 'Property Solutions Acquisition Corp  ',

    'NASDAQ symbol': 'PSAC',
  },
  {
    symbol: 'PSACU',
    'Security Name': 'Property Solutions Acquisition Corp  Unit',

    'NASDAQ symbol': 'PSACU',
  },
  {
    symbol: 'PSACW',
    'Security Name': 'Property Solutions Acquisition Corp  Warrant',

    'NASDAQ symbol': 'PSACW',
  },
  {
    symbol: 'PSB',
    'Security Name': 'PS Business Parks,  ',

    'CQS symbol': 'PSB',
    'NASDAQ symbol': 'PSB',
  },
  {
    symbol: 'PSB$W',
    'Security Name':
      'PS Business Parks,  Depositary Shares Each Representing 1/1000 of a Share of 520% Cumulative Preferred Stock, Series W',

    'CQS symbol': 'PSBpW',
    'NASDAQ symbol': 'PSBW',
  },
  {
    symbol: 'PSB$X',
    'Security Name':
      'PS Business Parks,  Depositary Shares Each Representing 1/1,000 of a Share of 525% Cumulative Preferred Stock, Series X',

    'CQS symbol': 'PSBpX',
    'NASDAQ symbol': 'PSBX',
  },
  {
    symbol: 'PSB$Y',
    'Security Name':
      'PS Business Parks,  520% Cumulative Preferred Stock, Series Y',

    'CQS symbol': 'PSBpY',
    'NASDAQ symbol': 'PSBY',
  },
  {
    symbol: 'PSB$Z',
    'Security Name':
      'PS Business Parks,  Depositary Shares Each Representing 1/1000 of a Share of 4875% Cumulative Preferred Stock, Series Z , par value $001 per share',

    'CQS symbol': 'PSBpZ',
    'NASDAQ symbol': 'PSBZ',
  },
  {
    symbol: 'PSC',
    'Security Name': 'Pripal US SmallCap MultiFactor ETF',

    'NASDAQ symbol': 'PSC',
  },
  {
    symbol: 'PSCC',
    'Security Name': 'Invesco S&P SmallCap Consumer Staples ETF',

    'NASDAQ symbol': 'PSCC',
  },
  {
    symbol: 'PSCD',
    'Security Name': 'Invesco S&P SmallCap Consumer Discretionary ETF',

    'NASDAQ symbol': 'PSCD',
  },
  {
    symbol: 'PSCE',
    'Security Name': 'Invesco S&P SmallCap Energy ETF',

    'NASDAQ symbol': 'PSCE',
  },
  {
    symbol: 'PSCF',
    'Security Name': 'Invesco S&P SmallCap Financials ETF',

    'NASDAQ symbol': 'PSCF',
  },
  {
    symbol: 'PSCH',
    'Security Name': 'Invesco S&P SmallCap Health Care ETF',

    'NASDAQ symbol': 'PSCH',
  },
  {
    symbol: 'PSCI',
    'Security Name': 'Invesco S&P SmallCap Industrials ETF',

    'NASDAQ symbol': 'PSCI',
  },
  {
    symbol: 'PSCM',
    'Security Name': 'Invesco S&P SmallCap Materials ETF',

    'NASDAQ symbol': 'PSCM',
  },
  {
    symbol: 'PSCT',
    'Security Name': 'Invesco S&P SmallCap Information Technology ETF',

    'NASDAQ symbol': 'PSCT',
  },
  {
    symbol: 'PSCU',
    'Security Name':
      'Invesco S&P SmallCap Utilities & Communication Services ETF',

    'NASDAQ symbol': 'PSCU',
  },
  {
    symbol: 'PSEC',
    'Security Name': 'Prospect Capital Corporation  ',

    'NASDAQ symbol': 'PSEC',
  },
  {
    symbol: 'PSEP',
    'Security Name':
      'Innovator ETFs Trust Innovator S&P 500 Power Buffer ETF  September',

    'CQS symbol': 'PSEP',
    'NASDAQ symbol': 'PSEP',
  },
  {
    symbol: 'PSET',
    'Security Name': 'Pripal Quality ETF',

    'NASDAQ symbol': 'PSET',
  },
  {
    symbol: 'PSF',
    'Security Name': 'Cohen & Steers Select Preferred and ome Fund,  ',

    'CQS symbol': 'PSF',
    'NASDAQ symbol': 'PSF',
  },
  {
    symbol: 'PSHG',
    'Security Name': 'Performance Shipping   Common Shares',

    'NASDAQ symbol': 'PSHG',
  },
  {
    symbol: 'PSI',
    'Security Name': 'Invesco Dynamic Semiconductors ETF',

    'CQS symbol': 'PSI',
    'NASDAQ symbol': 'PSI',
  },
  {
    symbol: 'PSJ',
    'Security Name': 'Invesco Dynamic Software ETF',

    'CQS symbol': 'PSJ',
    'NASDAQ symbol': 'PSJ',
  },
  {
    symbol: 'PSK',
    'Security Name': 'SPDR Wells Fargo Preferred Stock ETF',

    'CQS symbol': 'PSK',
    'NASDAQ symbol': 'PSK',
  },
  {
    symbol: 'PSL',
    'Security Name': 'Invesco DWA Consumer Staples Momentum ETF',

    'NASDAQ symbol': 'PSL',
  },
  {
    symbol: 'PSLV',
    'Security Name': 'Sprott Physical Silver Trust ETV',

    'CQS symbol': 'PSLV',
    'NASDAQ symbol': 'PSLV',
  },
  {
    symbol: 'PSM',
    'Security Name': 'Pripal US SmallMidCap MultiFactor ETF',

    'NASDAQ symbol': 'PSM',
  },
  {
    symbol: 'PSMB',
    'Security Name': 'Invesco Balanced MultiAsset Allocation ETF',

    'CQS symbol': 'PSMB',
    'NASDAQ symbol': 'PSMB',
  },
  {
    symbol: 'PSMC',
    'Security Name': 'Invesco Conservative MultiAsset Allocation ETF',

    'CQS symbol': 'PSMC',
    'NASDAQ symbol': 'PSMC',
  },
  {
    symbol: 'PSMG',
    'Security Name': 'Invesco Growth MultiAsset Allocation ETF',

    'CQS symbol': 'PSMG',
    'NASDAQ symbol': 'PSMG',
  },
  {
    symbol: 'PSMM',
    'Security Name':
      'Invesco Moderately Conservative MultiAsset Allocation ETF',

    'CQS symbol': 'PSMM',
    'NASDAQ symbol': 'PSMM',
  },
  {
    symbol: 'PSMT',
    'Security Name': 'PriceSmart,   ',

    'NASDAQ symbol': 'PSMT',
  },
  {
    symbol: 'PSN',
    'Security Name': 'Parsons Corporation ',

    'CQS symbol': 'PSN',
    'NASDAQ symbol': 'PSN',
  },
  {
    symbol: 'PSNL',
    'Security Name': 'Personalis,   ',

    'NASDAQ symbol': 'PSNL',
  },
  {
    symbol: 'PSO',
    'Security Name': 'Pearson, Plc ',

    'CQS symbol': 'PSO',
    'NASDAQ symbol': 'PSO',
  },
  {
    symbol: 'PSP',
    'Security Name': 'Invesco Global Listed Private Equity ETF',

    'CQS symbol': 'PSP',
    'NASDAQ symbol': 'PSP',
  },
  {
    symbol: 'PSQ',
    'Security Name': 'ProShares Short QQQ',

    'CQS symbol': 'PSQ',
    'NASDAQ symbol': 'PSQ',
  },
  {
    symbol: 'PSR',
    'Security Name': 'Invesco Active US Real Estate Fund',

    'CQS symbol': 'PSR',
    'NASDAQ symbol': 'PSR',
  },
  {
    symbol: 'PST',
    'Security Name': 'ProShares UltraShort Lehman 710 Year Treasury',

    'CQS symbol': 'PST',
    'NASDAQ symbol': 'PST',
  },
  {
    symbol: 'PSTG',
    'Security Name': 'Pure Storage,   ',

    'CQS symbol': 'PSTG',
    'NASDAQ symbol': 'PSTG',
  },
  {
    symbol: 'PSTH',
    'Security Name': 'Pershing Square Tontine Holdings, Ltd  ',

    'CQS symbol': 'PSTH',
    'NASDAQ symbol': 'PSTH',
  },
  {
    symbol: 'PSTHW',
    'Security Name':
      'Pershing Square Tontine Holdings, Ltd Warrants, exercisable for one share of   for $2300 per share',

    'CQS symbol': 'PSTHWS',
    'NASDAQ symbol': 'PSTH+',
  },
  {
    symbol: 'PSTI',
    'Security Name': 'Pluristem Therapeutics,   ',

    'NASDAQ symbol': 'PSTI',
  },
  {
    symbol: 'PSTL',
    'Security Name': 'Postal Realty Trust,   ',

    'CQS symbol': 'PSTL',
    'NASDAQ symbol': 'PSTL',
  },
  {
    symbol: 'PSTV',
    'Security Name': 'PLUS THERAPEUTICS,   ',

    'NASDAQ symbol': 'PSTV',
  },
  {
    symbol: 'PSTX',
    'Security Name': 'Poseida Therapeutics,   ',

    'NASDAQ symbol': 'PSTX',
  },
  {
    symbol: 'PSX',
    'Security Name': 'Phillips 66 ',

    'CQS symbol': 'PSX',
    'NASDAQ symbol': 'PSX',
  },
  {
    symbol: 'PSXP',
    'Security Name':
      'Phillips 66 Partners LP Common Units representing limited partner interest in the Partnership',

    'CQS symbol': 'PSXP',
    'NASDAQ symbol': 'PSXP',
  },
  {
    symbol: 'PT',
    'Security Name':
      'Pintec Technology Holdings Limited  American Depositary Shares',

    'NASDAQ symbol': 'PT',
  },
  {
    symbol: 'PTA',
    'Security Name':
      'Cohen & Steers TaxAdvantaged Preferred Securities and ome Fund Common Shares of Beneficial Interest',

    'CQS symbol': 'PTA',
    'NASDAQ symbol': 'PTA',
  },
  {
    symbol: 'PTAC',
    'Security Name': 'PropTech Acquisition Corporation   ',

    'NASDAQ symbol': 'PTAC',
  },
  {
    symbol: 'PTACU',
    'Security Name': 'PropTech Acquisition Corporation  Unit',

    'NASDAQ symbol': 'PTACU',
  },
  {
    symbol: 'PTACW',
    'Security Name': 'PropTech Acquisition Corporation  Warrant',

    'NASDAQ symbol': 'PTACW',
  },
  {
    symbol: 'PTBD',
    'Security Name': 'Pacer Trendpilot US Bond ETF',

    'CQS symbol': 'PTBD',
    'NASDAQ symbol': 'PTBD',
  },
  {
    symbol: 'PTC',
    'Security Name': 'PTC   ',

    'NASDAQ symbol': 'PTC',
  },
  {
    symbol: 'PTCT',
    'Security Name': 'PTC Therapeutics,   ',

    'NASDAQ symbol': 'PTCT',
  },
  {
    symbol: 'PTE',
    'Security Name': 'PolarityTE,   ',

    'NASDAQ symbol': 'PTE',
  },
  {
    symbol: 'PTEN',
    'Security Name': 'PattersonUTI Energy,   ',

    'NASDAQ symbol': 'PTEN',
  },
  {
    symbol: 'PTEU',
    'Security Name': 'Pacer TrendpilotTM European Index ETF',

    'CQS symbol': 'PTEU',
    'NASDAQ symbol': 'PTEU',
  },
  {
    symbol: 'PTF',
    'Security Name': 'Invesco DWA Technology Momentum ETF',

    'NASDAQ symbol': 'PTF',
  },
  {
    symbol: 'PTGX',
    'Security Name': 'Protagonist Therapeutics,   ',

    'NASDAQ symbol': 'PTGX',
  },
  {
    symbol: 'PTH',
    'Security Name': 'Invesco DWA Healthcare Momentum ETF',

    'NASDAQ symbol': 'PTH',
  },
  {
    symbol: 'PTI',
    'Security Name': 'Proteostasis Therapeutics,   ',

    'NASDAQ symbol': 'PTI',
  },
  {
    symbol: 'PTICU',
    'Security Name': 'PropTech Investment Corporation II  Unit',

    'NASDAQ symbol': 'PTICU',
  },
  {
    symbol: 'PTIN',
    'Security Name': 'Pacer Trendpilot International ETF',

    'CQS symbol': 'PTIN',
    'NASDAQ symbol': 'PTIN',
  },
  {
    symbol: 'PTK',
    'Security Name': 'PTK Acquisition Corp ',

    'CQS symbol': 'PTK',
    'NASDAQ symbol': 'PTK',
  },
  {
    symbol: 'PTKU',
    'Security Name': 'PTK Acquisition Corp Units',

    'CQS symbol': 'PTKU',
    'NASDAQ symbol': 'PTK=',
  },
  {
    symbol: 'PTKW',
    'Security Name':
      'PTK Acquisition Corp Warrants, each whole warrant exercisable for one half (1/2) of a share of  at an exercise price of $1150',

    'CQS symbol': 'PTKWS',
    'NASDAQ symbol': 'PTK+',
  },
  {
    symbol: 'PTLC',
    'Security Name': 'Pacer Fund Trust Pacer Trendpilot US Large Cap ETF',

    'CQS symbol': 'PTLC',
    'NASDAQ symbol': 'PTLC',
  },
  {
    symbol: 'PTMC',
    'Security Name': 'Pacer Trendpilot US Mid Cap ETF',

    'CQS symbol': 'PTMC',
    'NASDAQ symbol': 'PTMC',
  },
  {
    symbol: 'PTMN',
    'Security Name': 'Portman Ridge Finance Corporation  ',

    'NASDAQ symbol': 'PTMN',
  },
  {
    symbol: 'PTN',
    'Security Name': 'Palatin Technologies,  ',

    'CQS symbol': 'PTN',
    'NASDAQ symbol': 'PTN',
  },
  {
    symbol: 'PTNQ',
    'Security Name': 'Pacer Trendpilot 100 ETF',

    'CQS symbol': 'PTNQ',
    'NASDAQ symbol': 'PTNQ',
  },
  {
    symbol: 'PTNR',
    'Security Name':
      'Partner Communications Company Ltd  American Depositary Shares, each representing one ordinary share',

    'NASDAQ symbol': 'PTNR',
  },
  {
    symbol: 'PTON',
    'Security Name': 'Peloton Interactive,   ',

    'NASDAQ symbol': 'PTON',
  },
  {
    symbol: 'PTPI',
    'Security Name': 'Petros Pharmaceuticals,   ',

    'NASDAQ symbol': 'PTPI',
  },
  {
    symbol: 'PTR',
    'Security Name': 'PetroChina Company Limited ',

    'CQS symbol': 'PTR',
    'NASDAQ symbol': 'PTR',
  },
  {
    symbol: 'PTRS',
    'Security Name': 'Partners Bancorp  ',

    'NASDAQ symbol': 'PTRS',
  },
  {
    symbol: 'PTSI',
    'Security Name': 'PAM Transportation Services,   ',

    'NASDAQ symbol': 'PTSI',
  },
  {
    symbol: 'PTVCA',
    'Security Name': 'Protective Insurance Corporation   (voting) ',

    'NASDAQ symbol': 'PTVCA',
  },
  {
    symbol: 'PTVCB',
    'Security Name': 'Protective Insurance Corporation  Class B (nonvoting) ',

    'NASDAQ symbol': 'PTVCB',
  },
  {
    symbol: 'PTVE',
    'Security Name': 'Pactiv Evergreen   ',

    'NASDAQ symbol': 'PTVE',
  },
  {
    symbol: 'PTY',
    'Security Name': 'Pimco Corporate & ome Opportunity Fund',

    'CQS symbol': 'PTY',
    'NASDAQ symbol': 'PTY',
  },
  {
    symbol: 'PUI',
    'Security Name': 'Invesco DWA Utilities Momentum ETF',

    'NASDAQ symbol': 'PUI',
  },
  {
    symbol: 'PUK',
    'Security Name': 'Prudential Public Limited Company ',

    'CQS symbol': 'PUK',
    'NASDAQ symbol': 'PUK',
  },
  {
    symbol: 'PUK$',
    'Security Name':
      'Prudential Public Limited Company 675% Perpetual Subordinated Captial Security',

    'CQS symbol': 'PUKp',
    'NASDAQ symbol': 'PUK',
  },
  {
    symbol: 'PUK$A',
    'Security Name':
      "Prudential Public Limited Company 650% Perpetual Subordinated Capital Securities Exchangeable at the Issuer's Option Into NonCumulative Dollar Denominated Preference Shares",

    'CQS symbol': 'PUKpA',
    'NASDAQ symbol': 'PUKA',
  },
  {
    symbol: 'PULM',
    'Security Name': 'Pulmatrix,   ',

    'NASDAQ symbol': 'PULM',
  },
  {
    symbol: 'PULS',
    'Security Name': 'PGIM Ultra Short Bond ETF',

    'CQS symbol': 'PULS',
    'NASDAQ symbol': 'PULS',
  },
  {
    symbol: 'PUMP',
    'Security Name': 'ProPetro Holding Corp ',

    'CQS symbol': 'PUMP',
    'NASDAQ symbol': 'PUMP',
  },
  {
    symbol: 'PUTW',
    'Security Name': 'WisdomTree CBOE S&P 500 PutWrite Strategy Fund',

    'CQS symbol': 'PUTW',
    'NASDAQ symbol': 'PUTW',
  },
  {
    symbol: 'PUYI',
    'Security Name': 'Puyi   American ',

    'NASDAQ symbol': 'PUYI',
  },
  {
    symbol: 'PVAC',
    'Security Name': 'Penn Virginia Corporation  ',

    'NASDAQ symbol': 'PVAC',
  },
  {
    symbol: 'PVBC',
    'Security Name': 'Provident Bancorp,   ',

    'NASDAQ symbol': 'PVBC',
  },
  {
    symbol: 'PVG',
    'Security Name': 'Pretium Resources,  Ordinary Shares (Canada)',

    'CQS symbol': 'PVG',
    'NASDAQ symbol': 'PVG',
  },
  {
    symbol: 'PVH',
    'Security Name': 'PVH Corp ',

    'CQS symbol': 'PVH',
    'NASDAQ symbol': 'PVH',
  },
  {
    symbol: 'PVI',
    'Security Name': 'Invesco VRDO Tax Free Weekly ETF',

    'CQS symbol': 'PVI',
    'NASDAQ symbol': 'PVI',
  },
  {
    symbol: 'PVL',
    'Security Name': 'Permianville Royalty Trust Trust Units ',

    'CQS symbol': 'PVL',
    'NASDAQ symbol': 'PVL',
  },
  {
    symbol: 'PW',
    'Security Name': 'Power REIT (MD) ',

    'CQS symbol': 'PW',
    'NASDAQ symbol': 'PW',
  },
  {
    symbol: 'PW$A',
    'Security Name':
      'Power REIT 775% Series A Cumulative Perpetual Preferred Stock',

    'CQS symbol': 'PWpA',
    'NASDAQ symbol': 'PWA',
  },
  {
    symbol: 'PWB',
    'Security Name': 'Invesco Dynamic Large Cap Growth ETF',

    'CQS symbol': 'PWB',
    'NASDAQ symbol': 'PWB',
  },
  {
    symbol: 'PWC',
    'Security Name': 'Invesco Dynamic Market ETF',

    'CQS symbol': 'PWC',
    'NASDAQ symbol': 'PWC',
  },
  {
    symbol: 'PWFL',
    'Security Name': 'PowerFleet,   ',

    'NASDAQ symbol': 'PWFL',
  },
  {
    symbol: 'PWOD',
    'Security Name': 'Penns Woods Bancorp,   ',

    'NASDAQ symbol': 'PWOD',
  },
  {
    symbol: 'PWR',
    'Security Name': 'Quanta Services,  ',

    'CQS symbol': 'PWR',
    'NASDAQ symbol': 'PWR',
  },
  {
    symbol: 'PWS',
    'Security Name': 'Pacer WealthShield ETF ',

    'CQS symbol': 'PWS',
    'NASDAQ symbol': 'PWS',
  },
  {
    symbol: 'PWV',
    'Security Name': 'Invesco Dynamic Large Cap Value ETF',

    'CQS symbol': 'PWV',
    'NASDAQ symbol': 'PWV',
  },
  {
    symbol: 'PWZ',
    'Security Name': 'Invesco California AMTFree Municipal Bond Portfolio',

    'CQS symbol': 'PWZ',
    'NASDAQ symbol': 'PWZ',
  },
  {
    symbol: 'PXD',
    'Security Name': 'Pioneer Natural Resources Company ',

    'CQS symbol': 'PXD',
    'NASDAQ symbol': 'PXD',
  },
  {
    symbol: 'PXE',
    'Security Name': 'Invesco Dynamic Energy Exploration &Production ETF',

    'CQS symbol': 'PXE',
    'NASDAQ symbol': 'PXE',
  },
  {
    symbol: 'PXF',
    'Security Name': 'Invesco FTSE RAFI Developed Markets exUS ETF',

    'CQS symbol': 'PXF',
    'NASDAQ symbol': 'PXF',
  },
  {
    symbol: 'PXH',
    'Security Name': 'Invesco FTSE RAFI Emerging Markets ETF',

    'CQS symbol': 'PXH',
    'NASDAQ symbol': 'PXH',
  },
  {
    symbol: 'PXI',
    'Security Name': 'Invesco DWA Energy Momentum ETF',

    'NASDAQ symbol': 'PXI',
  },
  {
    symbol: 'PXJ',
    'Security Name': 'Invesco Dynamic Oil & Gas Services ETF',

    'CQS symbol': 'PXJ',
    'NASDAQ symbol': 'PXJ',
  },
  {
    symbol: 'PXLW',
    'Security Name': 'Pixelworks,   ',

    'NASDAQ symbol': 'PXLW',
  },
  {
    symbol: 'PXQ',
    'Security Name': 'Invesco Dynamic Networking ETF',

    'CQS symbol': 'PXQ',
    'NASDAQ symbol': 'PXQ',
  },
  {
    symbol: 'PXS',
    'Security Name': 'Pyxis Tankers   ',

    'NASDAQ symbol': 'PXS',
  },
  {
    symbol: 'PXSAP',
    'Security Name':
      'Pyxis Tankers   775% Series A Cumulative Redeemable Perpetual Preferred Share',

    'NASDAQ symbol': 'PXSAP',
  },
  {
    symbol: 'PXSAW',
    'Security Name': 'Pyxis Tankers   Warrant',

    'NASDAQ symbol': 'PXSAW',
  },
  {
    symbol: 'PY',
    'Security Name': 'Pripal Value ETF',

    'NASDAQ symbol': 'PY',
  },
  {
    symbol: 'PYN',
    'Security Name':
      'PIMCO New York Municipal ome Fund III Common Shares of Beneficial Interest',

    'CQS symbol': 'PYN',
    'NASDAQ symbol': 'PYN',
  },
  {
    symbol: 'PYPD',
    'Security Name': 'PolyPid Ltd  Ordinary Shares',

    'NASDAQ symbol': 'PYPD',
  },
  {
    symbol: 'PYPE',
    'Security Name':
      'ETRACS NYSE Pickens Core Midstream Index ETN due August 20, 2048',

    'CQS symbol': 'PYPE',
    'NASDAQ symbol': 'PYPE',
  },
  {
    symbol: 'PYPL',
    'Security Name': 'PayPal Holdings,   ',

    'NASDAQ symbol': 'PYPL',
  },
  {
    symbol: 'PYS',
    'Security Name': 'Merrill Lynch Depositor  PPlus Tr Ser RRD1 Tr Ctf Cl A',

    'CQS symbol': 'PYS',
    'NASDAQ symbol': 'PYS',
  },
  {
    symbol: 'PYT',
    'Security Name': 'PPlus Tr GSC2 Tr Ctf Fltg Rate',

    'CQS symbol': 'PYT',
    'NASDAQ symbol': 'PYT',
  },
  {
    symbol: 'PYZ',
    'Security Name': 'Invesco DWA Basic Materials Momentum ETF',

    'NASDAQ symbol': 'PYZ',
  },
  {
    symbol: 'PZA',
    'Security Name': 'Invesco National AMTFree Municipal Bond ETFo',

    'CQS symbol': 'PZA',
    'NASDAQ symbol': 'PZA',
  },
  {
    symbol: 'PZC',
    'Security Name':
      'PIMCO California Municipal ome Fund III Common Shares of Beneficial Interest',

    'CQS symbol': 'PZC',
    'NASDAQ symbol': 'PZC',
  },
  {
    symbol: 'PZD',
    'Security Name': 'Invesco Cleantech ETF',

    'CQS symbol': 'PZD',
    'NASDAQ symbol': 'PZD',
  },
  {
    symbol: 'PZG',
    'Security Name': 'Paramount Gold Nevada Corp ',

    'CQS symbol': 'PZG',
    'NASDAQ symbol': 'PZG',
  },
  {
    symbol: 'PZN',
    'Security Name': 'Pzena Investment Management   ',

    'CQS symbol': 'PZN',
    'NASDAQ symbol': 'PZN',
  },
  {
    symbol: 'PZT',
    'Security Name': 'Invesco New York AMTFree Municipal Bond ETF',

    'CQS symbol': 'PZT',
    'NASDAQ symbol': 'PZT',
  },
  {
    symbol: 'PZZA',
    'Security Name': "Papa John's International,   ",

    'NASDAQ symbol': 'PZZA',
  },
  {
    symbol: 'QABA',
    'Security Name': 'First Trust NASDAQ ABA Community Bank Index Fund',

    'NASDAQ symbol': 'QABA',
  },
  {
    symbol: 'QADA',
    'Security Name': 'QAD    ',

    'NASDAQ symbol': 'QADA',
  },
  {
    symbol: 'QADB',
    'Security Name': 'QAD   Class B ',

    'NASDAQ symbol': 'QADB',
  },
  {
    symbol: 'QAI',
    'Security Name': 'IQ Hedge MultiIQ Hedge MultiStrategy Tracker ETF',

    'CQS symbol': 'QAI',
    'NASDAQ symbol': 'QAI',
  },
  {
    symbol: 'QARP',
    'Security Name':
      'Xtrackers Russell 1000 US Quality at a Reasonable Price ETF ETF',

    'CQS symbol': 'QARP',
    'NASDAQ symbol': 'QARP',
  },
  {
    symbol: 'QAT',
    'Security Name': 'iShares MSCI Qatar ETF',

    'NASDAQ symbol': 'QAT',
  },
  {
    symbol: 'QCLN',
    'Security Name': 'First Trust NASDAQ Clean Edge Green Energy Index Fund',

    'NASDAQ symbol': 'QCLN',
  },
  {
    symbol: 'QCOM',
    'Security Name': 'QUALCOMM orporated  ',

    'NASDAQ symbol': 'QCOM',
  },
  {
    symbol: 'QCRH',
    'Security Name': 'QCR Holdings,   ',

    'NASDAQ symbol': 'QCRH',
  },
  {
    symbol: 'QD',
    'Security Name':
      'Qudian  American Depositary Shares, each representing one  Ordinary Share',

    'CQS symbol': 'QD',
    'NASDAQ symbol': 'QD',
  },
  {
    symbol: 'QDEF',
    'Security Name': 'FlexShares Quality Dividend Defensive Index Fund',

    'CQS symbol': 'QDEF',
    'NASDAQ symbol': 'QDEF',
  },
  {
    symbol: 'QDEL',
    'Security Name': 'Quidel Corporation  ',

    'NASDAQ symbol': 'QDEL',
  },
  {
    symbol: 'QDF',
    'Security Name': 'FlexShares Quality Dividend Index Fund',

    'CQS symbol': 'QDF',
    'NASDAQ symbol': 'QDF',
  },
  {
    symbol: 'QDIV',
    'Security Name': 'Global X S&P 500 Quality Dividend ETF',

    'CQS symbol': 'QDIV',
    'NASDAQ symbol': 'QDIV',
  },
  {
    symbol: 'QDYN',
    'Security Name': 'FlexShares Quality Dynamic Index Fund',

    'CQS symbol': 'QDYN',
    'NASDAQ symbol': 'QDYN',
  },
  {
    symbol: 'QED',
    'Security Name': 'IQ Hedge EventDriven Tracker ETF',

    'CQS symbol': 'QED',
    'NASDAQ symbol': 'QED',
  },
  {
    symbol: 'QEFA',
    'Security Name': 'SPDR MSCI EAFE StrategicFactors ETF',

    'CQS symbol': 'QEFA',
    'NASDAQ symbol': 'QEFA',
  },
  {
    symbol: 'QELL',
    'Security Name': 'Qell Acquisition Corp   Ordinary Shares',

    'NASDAQ symbol': 'QELL',
  },
  {
    symbol: 'QELLU',
    'Security Name': 'Qell Acquisition Corp  Unit',

    'NASDAQ symbol': 'QELLU',
  },
  {
    symbol: 'QELLW',
    'Security Name': 'Qell Acquisition Corp  Warrant',

    'NASDAQ symbol': 'QELLW',
  },
  {
    symbol: 'QEMM',
    'Security Name': 'SPDR MSCI Emerging Markets StrategicFactors ETF',

    'CQS symbol': 'QEMM',
    'NASDAQ symbol': 'QEMM',
  },
  {
    symbol: 'QEP',
    'Security Name': 'QEP Resources,  ',

    'CQS symbol': 'QEP',
    'NASDAQ symbol': 'QEP',
  },
  {
    symbol: 'QFIN',
    'Security Name': '360 DigiTech,   American Depositary Shares',

    'NASDAQ symbol': 'QFIN',
  },
  {
    symbol: 'QGEN',
    'Security Name': 'Qiagen NV Common Shares ',

    'CQS symbol': 'QGEN',
    'NASDAQ symbol': 'QGEN',
  },
  {
    symbol: 'QGRO',
    'Security Name': 'American Century STOXX US Quality Growth ETF',

    'CQS symbol': 'QGRO',
    'NASDAQ symbol': 'QGRO',
  },
  {
    symbol: 'QH',
    'Security Name': 'Quhuo Limited  American ',

    'NASDAQ symbol': 'QH',
  },
  {
    symbol: 'QID',
    'Security Name': 'ProShares UltraShort QQQ',

    'CQS symbol': 'QID',
    'NASDAQ symbol': 'QID',
  },
  {
    symbol: 'QINT',
    'Security Name': 'American Century Quality Diversified International ETF',

    'CQS symbol': 'QINT',
    'NASDAQ symbol': 'QINT',
  },
  {
    symbol: 'QIWI',
    'Security Name': 'QIWI plc  American Depositary Shares',

    'NASDAQ symbol': 'QIWI',
  },
  {
    symbol: 'QK',
    'Security Name':
      'Q&K International Group Limited  American Depositary Shares',

    'NASDAQ symbol': 'QK',
  },
  {
    symbol: 'QLC',
    'Security Name':
      'FlexShares Trust FlexShares US Quality Large Cap Index Fund',

    'CQS symbol': 'QLC',
    'NASDAQ symbol': 'QLC',
  },
  {
    symbol: 'QLD',
    'Security Name': 'ProShares Ultra QQQ',

    'CQS symbol': 'QLD',
    'NASDAQ symbol': 'QLD',
  },
  {
    symbol: 'QLGN',
    'Security Name': 'Qualigen Therapeutics,   ',

    'NASDAQ symbol': 'QLGN',
  },
  {
    symbol: 'QLS',
    'Security Name': 'IQ Hedge Long Short Tracker ETF',

    'CQS symbol': 'QLS',
    'NASDAQ symbol': 'QLS',
  },
  {
    symbol: 'QLTA',
    'Security Name': 'iShares Aaa A Rated Corporate Bond ETF',

    'CQS symbol': 'QLTA',
    'NASDAQ symbol': 'QLTA',
  },
  {
    symbol: 'QLV',
    'Security Name': 'FlexShares US Quality Low Volatility Index Fund',

    'CQS symbol': 'QLV',
    'NASDAQ symbol': 'QLV',
  },
  {
    symbol: 'QLVD',
    'Security Name':
      'FlexShares Developed Markets exUS Quality Low Volatility Index Fund',

    'CQS symbol': 'QLVD',
    'NASDAQ symbol': 'QLVD',
  },
  {
    symbol: 'QLVE',
    'Security Name':
      'FlexShares Emerging Markets  Quality Low Volatility Index Fund',

    'CQS symbol': 'QLVE',
    'NASDAQ symbol': 'QLVE',
  },
  {
    symbol: 'QLYS',
    'Security Name': 'Qualys,   ',

    'NASDAQ symbol': 'QLYS',
  },
  {
    symbol: 'QMCO',
    'Security Name': 'Quantum Corporation  ',

    'NASDAQ symbol': 'QMCO',
  },
  {
    symbol: 'QMJ',
    'Security Name': 'Direxion S&P 500 High minus Low Quality ETF',

    'CQS symbol': 'QMJ',
    'NASDAQ symbol': 'QMJ',
  },
  {
    symbol: 'QMN',
    'Security Name': 'IQ Hedge Market Neutral Tracker ETF',

    'CQS symbol': 'QMN',
    'NASDAQ symbol': 'QMN',
  },
  {
    symbol: 'QMOM',
    'Security Name': 'Alpha Architect US Quantitative Momentum ETF',

    'CQS symbol': 'QMOM',
    'NASDAQ symbol': 'QMOM',
  },
  {
    symbol: 'QNST',
    'Security Name': 'QuinStreet,   ',

    'NASDAQ symbol': 'QNST',
  },
  {
    symbol: 'QQEW',
    'Security Name': 'First Trust NASDAQ100 Equal Weighted Index Fund',

    'NASDAQ symbol': 'QQEW',
  },
  {
    symbol: 'QQH',
    'Security Name': 'HCM Defender 100 Index ETF',

    'CQS symbol': 'QQH',
    'NASDAQ symbol': 'QQH',
  },
  {
    symbol: 'QQQ',
    'Security Name': 'Invesco QQQ Trust, Series 1',

    'NASDAQ symbol': 'QQQ',
  },
  {
    symbol: 'QQQE',
    'Security Name': 'Direxion NASDAQ100 Equal Weighted Index Shares',

    'CQS symbol': 'QQQE',
    'NASDAQ symbol': 'QQQE',
  },
  {
    symbol: 'QQQJ',
    'Security Name': 'Invesco NASDAQ Next Gen 100 ETF',

    'NASDAQ symbol': 'QQQJ',
  },
  {
    symbol: 'QQQM',
    'Security Name': 'Invesco NASDAQ 100 ETF',

    'NASDAQ symbol': 'QQQM',
  },
  {
    symbol: 'QQQN',
    'Security Name': 'VictoryShares Nasdaq Next 50 ETF',

    'NASDAQ symbol': 'QQQN',
  },
  {
    symbol: 'QQQX',
    'Security Name':
      'Nuveen NASDAQ 100 Dynamic Overwrite Fund  Shares of Beneficial Interest',

    'NASDAQ symbol': 'QQQX',
  },
  {
    symbol: 'QQXT',
    'Security Name': 'First Trust NASDAQ100 ExTechnology Sector Index Fund',

    'NASDAQ symbol': 'QQXT',
  },
  {
    symbol: 'QRFT',
    'Security Name': 'QRAFT AIEnhanced US Large Cap ETF',

    'CQS symbol': 'QRFT',
    'NASDAQ symbol': 'QRFT',
  },
  {
    symbol: 'QRHC',
    'Security Name': 'Quest Resource Holding Corporation  ',

    'NASDAQ symbol': 'QRHC',
  },
  {
    symbol: 'QRTEA',
    'Security Name': 'Qurate Retail,   Series A ',

    'NASDAQ symbol': 'QRTEA',
  },
  {
    symbol: 'QRTEB',
    'Security Name': 'Qurate Retail,   Series B ',

    'NASDAQ symbol': 'QRTEB',
  },
  {
    symbol: 'QRTEP',
    'Security Name':
      'Qurate Retail,   80% Fixed Rate Cumulative Redeemable Preferred Stock',

    'NASDAQ symbol': 'QRTEP',
  },
  {
    symbol: 'QRVO',
    'Security Name': 'Qorvo,   ',

    'NASDAQ symbol': 'QRVO',
  },
  {
    symbol: 'QS',
    'Security Name': 'QuantumScape Corporation  ',

    'CQS symbol': 'QS',
    'NASDAQ symbol': 'QS',
  },
  {
    symbol: 'QSW',
    'Security Name': 'QuantumScape Corporation Warrants',

    'CQS symbol': 'QSWS',
    'NASDAQ symbol': 'QS+',
  },
  {
    symbol: 'QSR',
    'Security Name': 'Restaurant Brands International  Common Shares',

    'CQS symbol': 'QSR',
    'NASDAQ symbol': 'QSR',
  },
  {
    symbol: 'QSY',
    'Security Name': 'WisdomTree US Quality Shareholder Yield Fund',

    'CQS symbol': 'QSY',
    'NASDAQ symbol': 'QSY',
  },
  {
    symbol: 'QTEC',
    'Security Name': 'First Trust NASDAQ100 Technology Index Fund',

    'NASDAQ symbol': 'QTEC',
  },
  {
    symbol: 'QTNT',
    'Security Name': 'Quotient Limited  Ordinary Shares',

    'NASDAQ symbol': 'QTNT',
  },
  {
    symbol: 'QTRX',
    'Security Name': 'Quanterix Corporation  ',

    'NASDAQ symbol': 'QTRX',
  },
  {
    symbol: 'QTS',
    'Security Name': 'QTS Realty Trust,   ',

    'CQS symbol': 'QTS',
    'NASDAQ symbol': 'QTS',
  },
  {
    symbol: 'QTS$A',
    'Security Name':
      'QTS Realty Trust,  7125% Series A Cumulative Redeemable Perpetual Preferred Stock',

    'CQS symbol': 'QTSpA',
    'NASDAQ symbol': 'QTSA',
  },
  {
    symbol: 'QTS$B',
    'Security Name':
      'QTS Realty Trust,  650% Series B Cumulative Convertible Perpetual Preferred Stock',

    'CQS symbol': 'QTSpB',
    'NASDAQ symbol': 'QTSB',
  },
  {
    symbol: 'QTT',
    'Security Name': 'Qutoutiao   American Depositary Shares',

    'NASDAQ symbol': 'QTT',
  },
  {
    symbol: 'QTUM',
    'Security Name': 'Defiance Quantum ETF',

    'CQS symbol': 'QTUM',
    'NASDAQ symbol': 'QTUM',
  },
  {
    symbol: 'QTWO',
    'Security Name': 'Q2 Holdings,  ',

    'CQS symbol': 'QTWO',
    'NASDAQ symbol': 'QTWO',
  },
  {
    symbol: 'QUAD',
    'Security Name': 'Quad Graphics,   ',

    'CQS symbol': 'QUAD',
    'NASDAQ symbol': 'QUAD',
  },
  {
    symbol: 'QUAL',
    'Security Name': 'iShares MSCI USA Quality Factor ETF',

    'CQS symbol': 'QUAL',
    'NASDAQ symbol': 'QUAL',
  },
  {
    symbol: 'QUIK',
    'Security Name': 'QuickLogic Corporation  ',

    'NASDAQ symbol': 'QUIK',
  },
  {
    symbol: 'QUMU',
    'Security Name': 'Qumu Corporation  ',

    'NASDAQ symbol': 'QUMU',
  },
  {
    symbol: 'QUOT',
    'Security Name': 'Quotient Technology  ',

    'CQS symbol': 'QUOT',
    'NASDAQ symbol': 'QUOT',
  },
  {
    symbol: 'QURE',
    'Security Name': 'uniQure NV  Ordinary Shares',

    'NASDAQ symbol': 'QURE',
  },
  {
    symbol: 'QUS',
    'Security Name': 'SPDR MSCI USA StrategicFactors ETF',

    'CQS symbol': 'QUS',
    'NASDAQ symbol': 'QUS',
  },
  {
    symbol: 'QVAL',
    'Security Name': 'Alpha Architect US Quantitative Value ETF',

    'CQS symbol': 'QVAL',
    'NASDAQ symbol': 'QVAL',
  },
  {
    symbol: 'QVCC',
    'Security Name': 'QVC,  6250% Senior Secured Notes due 2068',

    'CQS symbol': 'QVCC',
    'NASDAQ symbol': 'QVCC',
  },
  {
    symbol: 'QVCD',
    'Security Name': 'QVC,  6375% Senior Secured Notes due 2067',

    'CQS symbol': 'QVCD',
    'NASDAQ symbol': 'QVCD',
  },
  {
    symbol: 'QWLD',
    'Security Name': 'SPDR MSCI World StrategicFactors ETF',

    'CQS symbol': 'QWLD',
    'NASDAQ symbol': 'QWLD',
  },
  {
    symbol: 'QYLD',
    'Security Name': 'Global X NASDAQ100 Covered Call ETF',

    'NASDAQ symbol': 'QYLD',
  },
  {
    symbol: 'QYLG',
    'Security Name': 'Global X Nasdaq 100 Covered Call & Growth ETF',

    'NASDAQ symbol': 'QYLG',
  },
  {
    symbol: 'R',
    'Security Name': 'Ryder System,  ',

    'CQS symbol': 'R',
    'NASDAQ symbol': 'R',
  },
  {
    symbol: 'RA',
    'Security Name': 'Brookfield Real Assets ome Fund  ',

    'CQS symbol': 'RA',
    'NASDAQ symbol': 'RA',
  },
  {
    symbol: 'RAAX',
    'Security Name': 'VanEck Vectors Real Asset Allocation ETF',

    'CQS symbol': 'RAAX',
    'NASDAQ symbol': 'RAAX',
  },
  {
    symbol: 'RACA',
    'Security Name': 'Therapeutics Acquisition Corp   ',

    'NASDAQ symbol': 'RACA',
  },
  {
    symbol: 'RACE',
    'Security Name': 'Ferrari NV Common Shares',

    'CQS symbol': 'RACE',
    'NASDAQ symbol': 'RACE',
  },
  {
    symbol: 'RAD',
    'Security Name': 'Rite Aid Corporation ',

    'CQS symbol': 'RAD',
    'NASDAQ symbol': 'RAD',
  },
  {
    symbol: 'RADA',
    'Security Name': 'RADA Electronic Industries Ltd  Ordinary Shares',

    'NASDAQ symbol': 'RADA',
  },
  {
    symbol: 'RADI',
    'Security Name': 'Radius Global Infrastructure,   ',

    'NASDAQ symbol': 'RADI',
  },
  {
    symbol: 'RAFE',
    'Security Name': 'PIMCO RAFI ESG US ETF',

    'CQS symbol': 'RAFE',
    'NASDAQ symbol': 'RAFE',
  },
  {
    symbol: 'RAIL',
    'Security Name': 'Freightcar America,   ',

    'NASDAQ symbol': 'RAIL',
  },
  {
    symbol: 'RALS',
    'Security Name': 'ProShares RAFI Long Short ETF',

    'CQS symbol': 'RALS',
    'NASDAQ symbol': 'RALS',
  },
  {
    symbol: 'RAMP',
    'Security Name': 'LiveRamp Holdings,  ',

    'CQS symbol': 'RAMP',
    'NASDAQ symbol': 'RAMP',
  },
  {
    symbol: 'RAND',
    'Security Name': 'Rand Capital Corporation  ',

    'NASDAQ symbol': 'RAND',
  },
  {
    symbol: 'RAPT',
    'Security Name': 'RAPT Therapeutics,   ',

    'NASDAQ symbol': 'RAPT',
  },
  {
    symbol: 'RARE',
    'Security Name': 'Ultragenyx Pharmaceutical   ',

    'NASDAQ symbol': 'RARE',
  },
  {
    symbol: 'RAVE',
    'Security Name': 'Rave Restaurant Group,   ',

    'NASDAQ symbol': 'RAVE',
  },
  {
    symbol: 'RAVI',
    'Security Name': 'FlexShares Ready Access Variable ome Fund',

    'CQS symbol': 'RAVI',
    'NASDAQ symbol': 'RAVI',
  },
  {
    symbol: 'RAVN',
    'Security Name': 'Raven Industries,   ',

    'NASDAQ symbol': 'RAVN',
  },
  {
    symbol: 'RBA',
    'Security Name': 'Ritchie Bros Auctioneers orporated ',

    'CQS symbol': 'RBA',
    'NASDAQ symbol': 'RBA',
  },
  {
    symbol: 'RBAC',
    'Security Name': 'RedBall Acquisition Corp  Ordinary Shares',

    'CQS symbol': 'RBAC',
    'NASDAQ symbol': 'RBAC',
  },
  {
    symbol: 'RBACU',
    'Security Name':
      'RedBall Acquisition Corp Units, each consisting of one  ordinary share and onethird of one redeemable warrant',

    'CQS symbol': 'RBACU',
    'NASDAQ symbol': 'RBAC=',
  },
  {
    symbol: 'RBACW',
    'Security Name':
      'RedBall Acquisition Corp Redeemable warrants, each whole warrant exercisable for one  ordinary share at an exercise price of $1150 per share',

    'CQS symbol': 'RBACWS',
    'NASDAQ symbol': 'RBAC+',
  },
  {
    symbol: 'RBB',
    'Security Name': 'RBB Bancorp  ',

    'NASDAQ symbol': 'RBB',
  },
  {
    symbol: 'RBBN',
    'Security Name': 'Ribbon Communications    ',

    'NASDAQ symbol': 'RBBN',
  },
  {
    symbol: 'RBC',
    'Security Name': 'Regal Beloit Corporation ',

    'CQS symbol': 'RBC',
    'NASDAQ symbol': 'RBC',
  },
  {
    symbol: 'RBCAA',
    'Security Name': 'Republic Bancorp,    ',

    'NASDAQ symbol': 'RBCAA',
  },
  {
    symbol: 'RBCN',
    'Security Name': 'Rubicon Technology,   ',

    'NASDAQ symbol': 'RBCN',
  },
  {
    symbol: 'RBIN',
    'Security Name': 'Nationwide RiskBased International Equity ETF',

    'CQS symbol': 'RBIN',
    'NASDAQ symbol': 'RBIN',
  },
  {
    symbol: 'RBKB',
    'Security Name': 'Rhinebeck Bancorp,   ',

    'NASDAQ symbol': 'RBKB',
  },
  {
    symbol: 'RBNC',
    'Security Name': 'Reliant Bancorp,   ',

    'NASDAQ symbol': 'RBNC',
  },
  {
    symbol: 'RBND',
    'Security Name': 'SPDR Bloomberg SASB Corporate Bond ESG Select ETF',

    'CQS symbol': 'RBND',
    'NASDAQ symbol': 'RBND',
  },
  {
    symbol: 'RBUS',
    'Security Name': 'Nationwide RiskBased US Equity ETF',

    'CQS symbol': 'RBUS',
    'NASDAQ symbol': 'RBUS',
  },
  {
    symbol: 'RC',
    'Security Name': 'Ready Capital Corproation ',

    'CQS symbol': 'RC',
    'NASDAQ symbol': 'RC',
  },
  {
    symbol: 'RCA',
    'Security Name':
      'Ready Capital Corporation 700% Convertible Senior Notes due 2023',

    'CQS symbol': 'RCA',
    'NASDAQ symbol': 'RCA',
  },
  {
    symbol: 'RCB',
    'Security Name': 'Ready Capital Corporation 620% Senior Notes due 2026',

    'CQS symbol': 'RCB',
    'NASDAQ symbol': 'RCB',
  },
  {
    symbol: 'RCD',
    'Security Name': 'Invesco S&P 500 Equal Weight Consumer Discretionary ETF',

    'CQS symbol': 'RCD',
    'NASDAQ symbol': 'RCD',
  },
  {
    symbol: 'RCEL',
    'Security Name': 'Avita Therapeutics,   ',

    'NASDAQ symbol': 'RCEL',
  },
  {
    symbol: 'RCG',
    'Security Name': 'RENN Fund,  ',

    'CQS symbol': 'RCG',
    'NASDAQ symbol': 'RCG',
  },
  {
    symbol: 'RCHG',
    'Security Name': 'Recharge Acquisition Corp   ',

    'NASDAQ symbol': 'RCHG',
  },
  {
    symbol: 'RCHGU',
    'Security Name': 'Recharge Acquisition Corp  Unit',

    'NASDAQ symbol': 'RCHGU',
  },
  {
    symbol: 'RCHGW',
    'Security Name': 'Recharge Acquisition Corp  Warrant',

    'NASDAQ symbol': 'RCHGW',
  },
  {
    symbol: 'RCI',
    'Security Name': 'Rogers Communication,  ',

    'CQS symbol': 'RCI',
    'NASDAQ symbol': 'RCI',
  },
  {
    symbol: 'RCII',
    'Security Name': 'RentACenter   ',

    'NASDAQ symbol': 'RCII',
  },
  {
    symbol: 'RCKT',
    'Security Name': 'Rocket Pharmaceuticals,   ',

    'NASDAQ symbol': 'RCKT',
  },
  {
    symbol: 'RCKY',
    'Security Name': 'Rocky Brands,   ',

    'NASDAQ symbol': 'RCKY',
  },
  {
    symbol: 'RCL',
    'Security Name': 'D/B/A Royal Caribbean Cruises Ltd ',

    'CQS symbol': 'RCL',
    'NASDAQ symbol': 'RCL',
  },
  {
    symbol: 'RCM',
    'Security Name': 'R1 RCM   ',

    'NASDAQ symbol': 'RCM',
  },
  {
    symbol: 'RCMT',
    'Security Name': 'RCM Technologies,   ',

    'NASDAQ symbol': 'RCMT',
  },
  {
    symbol: 'RCON',
    'Security Name': 'Recon Technology, Ltd  Ordinary Shares',

    'NASDAQ symbol': 'RCON',
  },
  {
    symbol: 'RCP',
    'Security Name': 'Ready Capital Corporation 650% Senior Notes due 2021',

    'CQS symbol': 'RCP',
    'NASDAQ symbol': 'RCP',
  },
  {
    symbol: 'RCS',
    'Security Name': 'PIMCO Strategic ome Fund, ',

    'CQS symbol': 'RCS',
    'NASDAQ symbol': 'RCS',
  },
  {
    symbol: 'RCUS',
    'Security Name': 'Arcus Biosciences,  ',

    'CQS symbol': 'RCUS',
    'NASDAQ symbol': 'RCUS',
  },
  {
    symbol: 'RDCM',
    'Security Name': 'Radcom Ltd  Ordinary Shares',

    'NASDAQ symbol': 'RDCM',
  },
  {
    symbol: 'RDFI',
    'Security Name': 'Rareview Dynamic Fixed ome ETF',

    'CQS symbol': 'RDFI',
    'NASDAQ symbol': 'RDFI',
  },
  {
    symbol: 'RDFN',
    'Security Name': 'Redfin Corporation  ',

    'NASDAQ symbol': 'RDFN',
  },
  {
    symbol: 'RDHL',
    'Security Name': 'Redhill Biopharma Ltd  American Depositary Shares',

    'NASDAQ symbol': 'RDHL',
  },
  {
    symbol: 'RDI',
    'Security Name': 'Reading International    Nonvoting ',

    'NASDAQ symbol': 'RDI',
  },
  {
    symbol: 'RDIB',
    'Security Name': 'Reading International   Class B Voting ',

    'NASDAQ symbol': 'RDIB',
  },
  {
    symbol: 'RDIV',
    'Security Name':
      'Invesco ExchangeTraded Fund Trust II Invesco S&P Ultra Dividend Revenue ETF',

    'CQS symbol': 'RDIV',
    'NASDAQ symbol': 'RDIV',
  },
  {
    symbol: 'RDN',
    'Security Name': 'Radian Group  ',

    'CQS symbol': 'RDN',
    'NASDAQ symbol': 'RDN',
  },
  {
    symbol: 'RDNT',
    'Security Name': 'RadNet,   ',

    'NASDAQ symbol': 'RDNT',
  },
  {
    symbol: 'RDOG',
    'Security Name': 'ALPS ETF Trust ALPS REIT Dividend Dogs ETF',

    'CQS symbol': 'RDOG',
    'NASDAQ symbol': 'RDOG',
  },
  {
    symbol: 'RDSA',
    'Security Name':
      'Royal Dutch Shell PLC Royal Dutch Shell American Depositary Shares (Each representing two  Ordinary Shares)',

    'CQS symbol': 'RDSA',
    'NASDAQ symbol': 'RDSA',
  },
  {
    symbol: 'RDSB',
    'Security Name':
      'Royal Dutch Shell PLC Royal Dutch Shell PLC American Depositary Shares (Each representing two Class B Ordinary Shares)',

    'CQS symbol': 'RDSB',
    'NASDAQ symbol': 'RDSB',
  },
  {
    symbol: 'RDUS',
    'Security Name': 'Radius Health,   ',

    'NASDAQ symbol': 'RDUS',
  },
  {
    symbol: 'RDVT',
    'Security Name': 'Red Violet,    ',

    'NASDAQ symbol': 'RDVT',
  },
  {
    symbol: 'RDVY',
    'Security Name': 'First Trust Rising Dividend Achievers ETF',

    'NASDAQ symbol': 'RDVY',
  },
  {
    symbol: 'RDWR',
    'Security Name': 'Radware Ltd  Ordinary Shares',

    'NASDAQ symbol': 'RDWR',
  },
  {
    symbol: 'RDY',
    'Security Name': "Dr Reddy's Laboratories Ltd ",

    'CQS symbol': 'RDY',
    'NASDAQ symbol': 'RDY',
  },
  {
    symbol: 'RE',
    'Security Name': 'Everest Re Group, Ltd ',

    'CQS symbol': 'RE',
    'NASDAQ symbol': 'RE',
  },
  {
    symbol: 'REAL',
    'Security Name': 'The RealReal,   ',

    'NASDAQ symbol': 'REAL',
  },
  {
    symbol: 'REC',
    'Security Name': 'Emles Real Estate Credit ETF',

    'CQS symbol': 'REC',
    'NASDAQ symbol': 'REC',
  },
  {
    symbol: 'RECS',
    'Security Name': 'Columbia Research Enhanced Core ETF',

    'CQS symbol': 'RECS',
    'NASDAQ symbol': 'RECS',
  },
  {
    symbol: 'REDU',
    'Security Name': 'RISE Education Cayman Ltd  American Depositary Shares',

    'NASDAQ symbol': 'REDU',
  },
  {
    symbol: 'REED',
    'Security Name': 'Reeds,   ',

    'NASDAQ symbol': 'REED',
  },
  {
    symbol: 'REET',
    'Security Name': 'iShares Trust iShares Global REIT ETF',

    'CQS symbol': 'REET',
    'NASDAQ symbol': 'REET',
  },
  {
    symbol: 'REFR',
    'Security Name': 'Research Frontiers orporated  ',

    'NASDAQ symbol': 'REFR',
  },
  {
    symbol: 'REG',
    'Security Name': 'Regency Centers Corporation  ',

    'NASDAQ symbol': 'REG',
  },
  {
    symbol: 'REGI',
    'Security Name': 'Renewable Energy Group,   ',

    'NASDAQ symbol': 'REGI',
  },
  {
    symbol: 'REGL',
    'Security Name': 'ProShares S&P MidCap 400 Dividend Aristocrats ETF',

    'CQS symbol': 'REGL',
    'NASDAQ symbol': 'REGL',
  },
  {
    symbol: 'REGN',
    'Security Name': 'Regeneron Pharmaceuticals,   ',

    'NASDAQ symbol': 'REGN',
  },
  {
    symbol: 'REI',
    'Security Name': 'Ring Energy,  ',

    'CQS symbol': 'REI',
    'NASDAQ symbol': 'REI',
  },
  {
    symbol: 'REK',
    'Security Name': 'ProShares Short Real Estate',

    'CQS symbol': 'REK',
    'NASDAQ symbol': 'REK',
  },
  {
    symbol: 'REKR',
    'Security Name': 'Rekor Systems,   ',

    'NASDAQ symbol': 'REKR',
  },
  {
    symbol: 'RELL',
    'Security Name': 'Richardson Electronics, Ltd  ',

    'NASDAQ symbol': 'RELL',
  },
  {
    symbol: 'RELV',
    'Security Name': "Reliv' International,   ",

    'NASDAQ symbol': 'RELV',
  },
  {
    symbol: 'RELX',
    'Security Name':
      'RELX PLC PLC American Depositary Shares (Each representing One Ordinary Share)',

    'CQS symbol': 'RELX',
    'NASDAQ symbol': 'RELX',
  },
  {
    symbol: 'REM',
    'Security Name': 'iShares Trust iShares Mortgage Real Estate ETF',

    'CQS symbol': 'REM',
    'NASDAQ symbol': 'REM',
  },
  {
    symbol: 'REML',
    'Security Name':
      'Credit Suisse AG Credit Suisse XLinks Monthly Pay 2xLeveraged Mortgage REIT Exchange Traded Notes (ETNs) due July 11, 2036',

    'CQS symbol': 'REML',
    'NASDAQ symbol': 'REML',
  },
  {
    symbol: 'REMX',
    'Security Name': 'VanEck Vectors Rare Earth Strategic Metals ETF',

    'CQS symbol': 'REMX',
    'NASDAQ symbol': 'REMX',
  },
  {
    symbol: 'RENN',
    'Security Name':
      'Renren  American Depositary Shares, each representing fifteen  ordinary shares',

    'CQS symbol': 'RENN',
    'NASDAQ symbol': 'RENN',
  },
  {
    symbol: 'REPH',
    'Security Name': 'Recro Pharma,   ',

    'NASDAQ symbol': 'REPH',
  },
  {
    symbol: 'REPL',
    'Security Name': 'Replimune Group,   ',

    'NASDAQ symbol': 'REPL',
  },
  {
    symbol: 'RES',
    'Security Name': 'RPC,  ',

    'CQS symbol': 'RES',
    'NASDAQ symbol': 'RES',
  },
  {
    symbol: 'RESD',
    'Security Name': 'WisdomTree International ESG Fund',

    'CQS symbol': 'RESD',
    'NASDAQ symbol': 'RESD',
  },
  {
    symbol: 'RESE',
    'Security Name': 'WisdomTree Emerging Markets ESG Fund',

    'CQS symbol': 'RESE',
    'NASDAQ symbol': 'RESE',
  },
  {
    symbol: 'RESI',
    'Security Name': 'Front Yard Residential Corporation ',

    'CQS symbol': 'RESI',
    'NASDAQ symbol': 'RESI',
  },
  {
    symbol: 'RESN',
    'Security Name': 'Resonant   ',

    'NASDAQ symbol': 'RESN',
  },
  {
    symbol: 'RESP',
    'Security Name': 'WisdomTree US ESG Fund',

    'CQS symbol': 'RESP',
    'NASDAQ symbol': 'RESP',
  },
  {
    symbol: 'RETA',
    'Security Name': 'Reata Pharmaceuticals,    ',

    'NASDAQ symbol': 'RETA',
  },
  {
    symbol: 'RETL',
    'Security Name': 'Direxion Daily Retail Bull 3X Shares ETF',

    'CQS symbol': 'RETL',
    'NASDAQ symbol': 'RETL',
  },
  {
    symbol: 'RETO',
    'Security Name': 'ReTo EcoSolutions,   Common Shares',

    'NASDAQ symbol': 'RETO',
  },
  {
    symbol: 'REV',
    'Security Name': 'Revlon,  New ',

    'CQS symbol': 'REV',
    'NASDAQ symbol': 'REV',
  },
  {
    symbol: 'REVG',
    'Security Name': 'REV Group,  ',

    'CQS symbol': 'REVG',
    'NASDAQ symbol': 'REVG',
  },
  {
    symbol: 'REVS',
    'Security Name': 'Columbia Research Enhanced Value ETF',

    'CQS symbol': 'REVS',
    'NASDAQ symbol': 'REVS',
  },
  {
    symbol: 'REW',
    'Security Name': 'ProShares UltraShort Technology',

    'CQS symbol': 'REW',
    'NASDAQ symbol': 'REW',
  },
  {
    symbol: 'REX',
    'Security Name': 'REX American Resources Corporation',

    'CQS symbol': 'REX',
    'NASDAQ symbol': 'REX',
  },
  {
    symbol: 'REXR',
    'Security Name': 'Rexford Industrial Realty,  ',

    'CQS symbol': 'REXR',
    'NASDAQ symbol': 'REXR',
  },
  {
    symbol: 'REXR$A',
    'Security Name':
      'Rexford Industrial Realty,  5875% Series A Cumulative Redeemable Preferred Stock',

    'CQS symbol': 'REXRpA',
    'NASDAQ symbol': 'REXRA',
  },
  {
    symbol: 'REXR$B',
    'Security Name':
      'Rexford Industrial Realty,  5875% Series B Cumulative Redeemable Preferred Stock',

    'CQS symbol': 'REXRpB',
    'NASDAQ symbol': 'REXRB',
  },
  {
    symbol: 'REXR$C',
    'Security Name':
      'Rexford Industrial Realty,  5625% Series C Cumulative Redeemable Preferred Stock, par value $001 per share',

    'CQS symbol': 'REXRpC',
    'NASDAQ symbol': 'REXRC',
  },
  {
    symbol: 'REYN',
    'Security Name': 'Reynolds Consumer Products   ',

    'NASDAQ symbol': 'REYN',
  },
  {
    symbol: 'REZ',
    'Security Name': 'iShares Residential and Multisector Real Estate ETF',

    'CQS symbol': 'REZ',
    'NASDAQ symbol': 'REZ',
  },
  {
    symbol: 'REZI',
    'Security Name': 'Resideo Technologies,   ',

    'CQS symbol': 'REZI',
    'NASDAQ symbol': 'REZI',
  },
  {
    symbol: 'RF',
    'Security Name': 'Regions Financial Corporation ',

    'CQS symbol': 'RF',
    'NASDAQ symbol': 'RF',
  },
  {
    symbol: 'RF$A',
    'Security Name':
      'Regions Financial Corporation Depositary Shares Representing 1/40th Perpetual Preferred Series A',

    'CQS symbol': 'RFpA',
    'NASDAQ symbol': 'RFA',
  },
  {
    symbol: 'RF$B',
    'Security Name':
      'Regions Financial Corporation Depositary Shares Representing 1/40th Perpetual Preferred Series B',

    'CQS symbol': 'RFpB',
    'NASDAQ symbol': 'RFB',
  },
  {
    symbol: 'RF$C',
    'Security Name':
      'Regions Financial Corporation Depositary Shares, each Representing a 1/40th Interest in a  Share of 5700% FixedtoFloating Rate NonCumulative  Perpetual Preferred Stock, Series C',

    'CQS symbol': 'RFpC',
    'NASDAQ symbol': 'RFC',
  },
  {
    symbol: 'RFAP',
    'Security Name': 'First Trust RiverFront Dynamic Asia Pacific ETF',

    'NASDAQ symbol': 'RFAP',
  },
  {
    symbol: 'RFCI',
    'Security Name': 'RiverFront Dynamic Core ome ETF',

    'CQS symbol': 'RFCI',
    'NASDAQ symbol': 'RFCI',
  },
  {
    symbol: 'RFDA',
    'Security Name': 'RiverFront Dynamic US Dividend Advantage ETF',

    'CQS symbol': 'RFDA',
    'NASDAQ symbol': 'RFDA',
  },
  {
    symbol: 'RFDI',
    'Security Name':
      'First Trust RiverFront Dynamic Developed International ETF',

    'NASDAQ symbol': 'RFDI',
  },
  {
    symbol: 'RFEM',
    'Security Name': 'First Trust RiverFront Dynamic Emerging Markets ETF',

    'NASDAQ symbol': 'RFEM',
  },
  {
    symbol: 'RFEU',
    'Security Name': 'First Trust RiverFront Dynamic Europe ETF',

    'NASDAQ symbol': 'RFEU',
  },
  {
    symbol: 'RFFC',
    'Security Name': 'RiverFront Dynamic US FlexCap ETF',

    'CQS symbol': 'RFFC',
    'NASDAQ symbol': 'RFFC',
  },
  {
    symbol: 'RFG',
    'Security Name': 'Invesco S&P Midcap 400 Pure Growth ETF',

    'CQS symbol': 'RFG',
    'NASDAQ symbol': 'RFG',
  },
  {
    symbol: 'RFI',
    'Security Name': 'Cohen & Steers Total Return Realty Fund,  ',

    'CQS symbol': 'RFI',
    'NASDAQ symbol': 'RFI',
  },
  {
    symbol: 'RFIL',
    'Security Name': 'RF Industries, Ltd  ',

    'NASDAQ symbol': 'RFIL',
  },
  {
    symbol: 'RFL',
    'Security Name': 'Rafael Holdings,  Class B ',

    'CQS symbol': 'RFL',
    'NASDAQ symbol': 'RFL',
  },
  {
    symbol: 'RFM',
    'Security Name': 'RiverNorth Flexible Municipal ome Fund,  ',

    'CQS symbol': 'RFM',
    'NASDAQ symbol': 'RFM',
  },
  {
    symbol: 'RFP',
    'Security Name': 'Resolute Forest Products  ',

    'CQS symbol': 'RFP',
    'NASDAQ symbol': 'RFP',
  },
  {
    symbol: 'RFUN',
    'Security Name': 'RiverFront Dynamic Unconstrained ome ETF',

    'CQS symbol': 'RFUN',
    'NASDAQ symbol': 'RFUN',
  },
  {
    symbol: 'RFV',
    'Security Name': 'Invesco S&P Midcap 400 Pure Value ETF',

    'CQS symbol': 'RFV',
    'NASDAQ symbol': 'RFV',
  },
  {
    symbol: 'RGA',
    'Security Name': 'Reinsurance Group of America, orporated ',

    'CQS symbol': 'RGA',
    'NASDAQ symbol': 'RGA',
  },
  {
    symbol: 'RGCO',
    'Security Name': 'RGC Resources   ',

    'NASDAQ symbol': 'RGCO',
  },
  {
    symbol: 'RGEN',
    'Security Name': 'Repligen Corporation  ',

    'NASDAQ symbol': 'RGEN',
  },
  {
    symbol: 'RGI',
    'Security Name': 'Invesco S&P 500 Equal Weight Industrials Portfolio',

    'CQS symbol': 'RGI',
    'NASDAQ symbol': 'RGI',
  },
  {
    symbol: 'RGLD',
    'Security Name': 'Royal Gold,   ',

    'NASDAQ symbol': 'RGLD',
  },
  {
    symbol: 'RGLS',
    'Security Name': 'Regulus Therapeutics   ',

    'NASDAQ symbol': 'RGLS',
  },
  {
    symbol: 'RGNX',
    'Security Name': 'REGENXBIO   ',

    'NASDAQ symbol': 'RGNX',
  },
  {
    symbol: 'RGP',
    'Security Name': 'Resources Connection,   ',

    'NASDAQ symbol': 'RGP',
  },
  {
    symbol: 'RGR',
    'Security Name': 'Sturm, Ruger & Company,  ',

    'CQS symbol': 'RGR',
    'NASDAQ symbol': 'RGR',
  },
  {
    symbol: 'RGS',
    'Security Name': 'Regis Corporation ',

    'CQS symbol': 'RGS',
    'NASDAQ symbol': 'RGS',
  },
  {
    symbol: 'RGT',
    'Security Name': 'Royce Global Value Trust,  ',

    'CQS symbol': 'RGT',
    'NASDAQ symbol': 'RGT',
  },
  {
    symbol: 'RH',
    'Security Name': 'RH ',

    'CQS symbol': 'RH',
    'NASDAQ symbol': 'RH',
  },
  {
    symbol: 'RHE',
    'Security Name': 'Regional Health Properties,  ',

    'CQS symbol': 'RHE',
    'NASDAQ symbol': 'RHE',
  },
  {
    symbol: 'RHE$A',
    'Security Name':
      'Regional Health Properties,  10875% Series A Cumulative Redeemable Preferred Stock',

    'CQS symbol': 'RHEpA',
    'NASDAQ symbol': 'RHEA',
  },
  {
    symbol: 'RHI',
    'Security Name': 'Robert Half International  ',

    'CQS symbol': 'RHI',
    'NASDAQ symbol': 'RHI',
  },
  {
    symbol: 'RHP',
    'Security Name': 'Ryman Hospitality Properties,  (REIT)',

    'CQS symbol': 'RHP',
    'NASDAQ symbol': 'RHP',
  },
  {
    symbol: 'RHS',
    'Security Name': 'Invesco S&P 500 Equal Weight Consumer Staples ETF  ',

    'CQS symbol': 'RHS',
    'NASDAQ symbol': 'RHS',
  },
  {
    symbol: 'RIBT',
    'Security Name': 'RiceBran Technologies  ',

    'NASDAQ symbol': 'RIBT',
  },
  {
    symbol: 'RICEU',
    'Security Name':
      'Rice Acquisition Corp Uts, each consisting of one share of  , and onehalf of one warrant',

    'CQS symbol': 'RICEU',
    'NASDAQ symbol': 'RICE=',
  },
  {
    symbol: 'RICK',
    'Security Name': 'RCI Hospitality Holdings,   ',

    'NASDAQ symbol': 'RICK',
  },
  {
    symbol: 'RIDE',
    'Security Name': 'Lordstown Motors Corp   ',

    'NASDAQ symbol': 'RIDE',
  },
  {
    symbol: 'RIDEW',
    'Security Name': 'Lordstown Motors Corp  Warrant',

    'NASDAQ symbol': 'RIDEW',
  },
  {
    symbol: 'RIG',
    'Security Name': 'Transocean Ltd (Switzerland) ',

    'CQS symbol': 'RIG',
    'NASDAQ symbol': 'RIG',
  },
  {
    symbol: 'RIGL',
    'Security Name': 'Rigel Pharmaceuticals,   ',

    'NASDAQ symbol': 'RIGL',
  },
  {
    symbol: 'RIGS',
    'Security Name': 'RiverFront Strategic ome Fund',

    'CQS symbol': 'RIGS',
    'NASDAQ symbol': 'RIGS',
  },
  {
    symbol: 'RILY',
    'Security Name': 'B Riley Financial,   ',

    'NASDAQ symbol': 'RILY',
  },
  {
    symbol: 'RILYG',
    'Security Name': 'B Riley Financial,   725% Senior Notes due 2027',

    'NASDAQ symbol': 'RILYG',
  },
  {
    symbol: 'RILYH',
    'Security Name': 'B Riley Financial,   7375% Senior Notes Due 2023',

    'NASDAQ symbol': 'RILYH',
  },
  {
    symbol: 'RILYI',
    'Security Name': 'B Riley Financial,   6875% Senior Notes due 2023',

    'NASDAQ symbol': 'RILYI',
  },
  {
    symbol: 'RILYL',
    'Security Name':
      'B Riley Financial,   Depositary Shares, each representing a 1/1000th fractional interest in a share of Series B Cumulative Perpetual Preferred Stock',

    'NASDAQ symbol': 'RILYL',
  },
  {
    symbol: 'RILYM',
    'Security Name': 'B Riley Financial,   6375% Senior Notes due 2025',

    'NASDAQ symbol': 'RILYM',
  },
  {
    symbol: 'RILYN',
    'Security Name': 'B Riley Financial,   650% Senior Notes Due 2026',

    'NASDAQ symbol': 'RILYN',
  },
  {
    symbol: 'RILYO',
    'Security Name': 'B Riley Financial,   675% Senior Notes due 2024',

    'NASDAQ symbol': 'RILYO',
  },
  {
    symbol: 'RILYP',
    'Security Name':
      'B Riley Financial,   Depositary Shares, each representing a 1/1000th fractional interest in a share of Series A Cumulative Perpetual Preferred Stock',

    'NASDAQ symbol': 'RILYP',
  },
  {
    symbol: 'RILYZ',
    'Security Name': 'B Riley Financial,   750% Senior Notes Due 2027',

    'NASDAQ symbol': 'RILYZ',
  },
  {
    symbol: 'RINF',
    'Security Name': 'ProShares Inflation Expectations ETF',

    'CQS symbol': 'RINF',
    'NASDAQ symbol': 'RINF',
  },
  {
    symbol: 'RING',
    'Security Name': 'iShares MSCI Global Gold Miners ETF',

    'NASDAQ symbol': 'RING',
  },
  {
    symbol: 'RIO',
    'Security Name': 'Rio Tinto Plc ',

    'CQS symbol': 'RIO',
    'NASDAQ symbol': 'RIO',
  },
  {
    symbol: 'RIOT',
    'Security Name': 'Riot Blockchain,   ',

    'NASDAQ symbol': 'RIOT',
  },
  {
    symbol: 'RISN',
    'Security Name': 'Inspire Tactical Balanced ESG ETF',

    'CQS symbol': 'RISN',
    'NASDAQ symbol': 'RISN',
  },
  {
    symbol: 'RIV',
    'Security Name': 'RiverNorth Opportunities Fund,  ',

    'CQS symbol': 'RIV',
    'NASDAQ symbol': 'RIV',
  },
  {
    symbol: 'RIVE',
    'Security Name': 'Riverview Financial Corporation  ',

    'NASDAQ symbol': 'RIVE',
  },
  {
    symbol: 'RJA',
    'Security Name':
      'AB Svensk Ekportkredit (Swedish Export Credit Corporation) ELEMENTS Linked to the Rogers International Commodity Index  Agriculture Total Return Structured Product',

    'CQS symbol': 'RJA',
    'NASDAQ symbol': 'RJA',
  },
  {
    symbol: 'RJF',
    'Security Name': 'Raymond James Financial,  ',

    'CQS symbol': 'RJF',
    'NASDAQ symbol': 'RJF',
  },
  {
    symbol: 'RJI',
    'Security Name':
      'AB Svensk Ekportkredit (Swedish Export Credit Corporation) ELEMENTS Linked to the Rogers International Commodity Index  Total Return Structured Product',

    'CQS symbol': 'RJI',
    'NASDAQ symbol': 'RJI',
  },
  {
    symbol: 'RJN',
    'Security Name':
      'AB Svensk Ekportkredit (Swedish Export Credit Corporation) ELEMENTS Linked to the Rogers International Commodity Index  Energy Total Return Structured Product',

    'CQS symbol': 'RJN',
    'NASDAQ symbol': 'RJN',
  },
  {
    symbol: 'RJZ',
    'Security Name':
      'AB Svensk Ekportkredit (Swedish Export Credit Corporation) ELEMENTS Linked to the Rogers International Commodity Index  Metals Total Return Structured Product',

    'CQS symbol': 'RJZ',
    'NASDAQ symbol': 'RJZ',
  },
  {
    symbol: 'RKDA',
    'Security Name': 'Arcadia Biosciences,   ',

    'NASDAQ symbol': 'RKDA',
  },
  {
    symbol: 'RKT',
    'Security Name': 'Rocket Companies,   ',

    'CQS symbol': 'RKT',
    'NASDAQ symbol': 'RKT',
  },
  {
    symbol: 'RL',
    'Security Name': 'Ralph Lauren Corporation ',

    'CQS symbol': 'RL',
    'NASDAQ symbol': 'RL',
  },
  {
    symbol: 'RLAY',
    'Security Name': 'Relay Therapeutics,   ',

    'NASDAQ symbol': 'RLAY',
  },
  {
    symbol: 'RLGT',
    'Security Name': 'Radiant Logistics,  ',

    'CQS symbol': 'RLGT',
    'NASDAQ symbol': 'RLGT',
  },
  {
    symbol: 'RLGY',
    'Security Name': 'Realogy Holdings Corp ',

    'CQS symbol': 'RLGY',
    'NASDAQ symbol': 'RLGY',
  },
  {
    symbol: 'RLH',
    'Security Name': 'Red Lions Hotels Corporation ',

    'CQS symbol': 'RLH',
    'NASDAQ symbol': 'RLH',
  },
  {
    symbol: 'RLI',
    'Security Name': 'RLI Corp  (DE)',

    'CQS symbol': 'RLI',
    'NASDAQ symbol': 'RLI',
  },
  {
    symbol: 'RLJ',
    'Security Name':
      'RLJ Lodging Trust Common Shares of Beneficial Interest $001 par value',

    'CQS symbol': 'RLJ',
    'NASDAQ symbol': 'RLJ',
  },
  {
    symbol: 'RLJ$A',
    'Security Name':
      'RLJ Lodging Trust $195 Series A Cumulative Convertible  Preferred Shares',

    'CQS symbol': 'RLJpA',
    'NASDAQ symbol': 'RLJA',
  },
  {
    symbol: 'RLMD',
    'Security Name': 'Relmada Therapeutics,   ',

    'NASDAQ symbol': 'RLMD',
  },
  {
    symbol: 'RLY',
    'Security Name': 'SPDR SSgA Multi Asset Real Return ETF',

    'CQS symbol': 'RLY',
    'NASDAQ symbol': 'RLY',
  },
  {
    symbol: 'RM',
    'Security Name': 'Regional Management Corp ',

    'CQS symbol': 'RM',
    'NASDAQ symbol': 'RM',
  },
  {
    symbol: 'RMAX',
    'Security Name': 'RE/MAX Holdings,   ',

    'CQS symbol': 'RMAX',
    'NASDAQ symbol': 'RMAX',
  },
  {
    symbol: 'RMBI',
    'Security Name': 'Richmond Mutual Bancorporation,   ',

    'NASDAQ symbol': 'RMBI',
  },
  {
    symbol: 'RMBL',
    'Security Name': 'RumbleOn,   Class B ',

    'NASDAQ symbol': 'RMBL',
  },
  {
    symbol: 'RMBS',
    'Security Name': 'Rambus,   ',

    'NASDAQ symbol': 'RMBS',
  },
  {
    symbol: 'RMCF',
    'Security Name': 'Rocky Mountain Chocolate Factory,   ',

    'NASDAQ symbol': 'RMCF',
  },
  {
    symbol: 'RMD',
    'Security Name': 'ResMed  ',

    'CQS symbol': 'RMD',
    'NASDAQ symbol': 'RMD',
  },
  {
    symbol: 'RMED',
    'Security Name': 'Ra Medical Systems,  ',

    'CQS symbol': 'RMED',
    'NASDAQ symbol': 'RMED',
  },
  {
    symbol: 'RMG',
    'Security Name': 'RMG Acquisition Corp  ',

    'CQS symbol': 'RMG',
    'NASDAQ symbol': 'RMG',
  },
  {
    symbol: 'RMGU',
    'Security Name': 'RMG Acquisition Corp Unit',

    'CQS symbol': 'RMGU',
    'NASDAQ symbol': 'RMG=',
  },
  {
    symbol: 'RMGW',
    'Security Name':
      'RMG Acquisition Corp Warrants, each whole warrant exercisable for one share of   at an exercise price of $1150',

    'CQS symbol': 'RMGWS',
    'NASDAQ symbol': 'RMG+',
  },
  {
    symbol: 'RMI',
    'Security Name': 'RiverNorth Opportunistic Municipal ome Fund,  ',

    'CQS symbol': 'RMI',
    'NASDAQ symbol': 'RMI',
  },
  {
    symbol: 'RMM',
    'Security Name': 'RiverNorth Managed Duration Municipal ome Fund,  ',

    'CQS symbol': 'RMM',
    'NASDAQ symbol': 'RMM',
  },
  {
    symbol: 'RMNI',
    'Security Name': 'Rimini Street,   ',

    'NASDAQ symbol': 'RMNI',
  },
  {
    symbol: 'RMPL$',
    'Security Name': 'RiverNorth Specialty Finance Corporation 5875% ',

    'CQS symbol': 'RMPLp',
    'NASDAQ symbol': 'RMPL',
  },
  {
    symbol: 'RMR',
    'Security Name': 'The RMR Group    ',

    'NASDAQ symbol': 'RMR',
  },
  {
    symbol: 'RMRM',
    'Security Name': 'RMR Mortgage Trust  ',

    'NASDAQ symbol': 'RMRM',
  },
  {
    symbol: 'RMT',
    'Security Name': 'Royce MicroCap Trust,  ',

    'CQS symbol': 'RMT',
    'NASDAQ symbol': 'RMT',
  },
  {
    symbol: 'RMTI',
    'Security Name': 'Rockwell Medical,   ',

    'NASDAQ symbol': 'RMTI',
  },
  {
    symbol: 'RNA',
    'Security Name': 'Avidity Biosciences,   ',

    'NASDAQ symbol': 'RNA',
  },
  {
    symbol: 'RNDB',
    'Security Name': 'Randolph Bancorp,   ',

    'NASDAQ symbol': 'RNDB',
  },
  {
    symbol: 'RNDM',
    'Security Name': 'First Trust Developed International Equity Select ETF',

    'NASDAQ symbol': 'RNDM',
  },
  {
    symbol: 'RNDV',
    'Security Name': 'First Trust US Equity Dividend Select ETF',

    'NASDAQ symbol': 'RNDV',
  },
  {
    symbol: 'RNEM',
    'Security Name': 'First Trust Emerging Markets Equity Select ETF',

    'NASDAQ symbol': 'RNEM',
  },
  {
    symbol: 'RNET',
    'Security Name': 'RigNet,   ',

    'NASDAQ symbol': 'RNET',
  },
  {
    symbol: 'RNG',
    'Security Name': 'RingCentral,   ',

    'CQS symbol': 'RNG',
    'NASDAQ symbol': 'RNG',
  },
  {
    symbol: 'RNGR',
    'Security Name': 'Ranger Energy Services,   ',

    'CQS symbol': 'RNGR',
    'NASDAQ symbol': 'RNGR',
  },
  {
    symbol: 'RNLC',
    'Security Name': 'First Trust Large Cap US Equity Select ETF',

    'NASDAQ symbol': 'RNLC',
  },
  {
    symbol: 'RNLX',
    'Security Name': 'Renalytix AI plc  American Depositary Shares',

    'NASDAQ symbol': 'RNLX',
  },
  {
    symbol: 'RNMC',
    'Security Name': 'First Trust Mid Cap US Equity Select ETF',

    'NASDAQ symbol': 'RNMC',
  },
  {
    symbol: 'RNP',
    'Security Name':
      'Cohen & Steers REIT and Preferred and ome Fund,  Common Shares',

    'CQS symbol': 'RNP',
    'NASDAQ symbol': 'RNP',
  },
  {
    symbol: 'RNR',
    'Security Name': 'RenaissanceRe Holdings Ltd ',

    'CQS symbol': 'RNR',
    'NASDAQ symbol': 'RNR',
  },
  {
    symbol: 'RNR$E',
    'Security Name':
      'RenaissanceRe Holdings Ltd 5375% Series E Preference Shares',

    'CQS symbol': 'RNRpE',
    'NASDAQ symbol': 'RNRE',
  },
  {
    symbol: 'RNR$F',
    'Security Name':
      'RenaissanceRe Holdings Ltd Depositary Shares, each Representing a 1/1,000th Interest in a 5750% Series F Preference Share',

    'CQS symbol': 'RNRpF',
    'NASDAQ symbol': 'RNRF',
  },
  {
    symbol: 'RNSC',
    'Security Name': 'First Trust Small Cap US Equity Select ETF',

    'NASDAQ symbol': 'RNSC',
  },
  {
    symbol: 'RNST',
    'Security Name': 'Renasant Corporation  ',

    'NASDAQ symbol': 'RNST',
  },
  {
    symbol: 'RNWK',
    'Security Name': 'RealNetworks,   ',

    'NASDAQ symbol': 'RNWK',
  },
  {
    symbol: 'ROAD',
    'Security Name': 'Construction Partners,   ',

    'NASDAQ symbol': 'ROAD',
  },
  {
    symbol: 'ROAM',
    'Security Name': 'Hartford Multifactor Emerging Markets ETF',

    'CQS symbol': 'ROAM',
    'NASDAQ symbol': 'ROAM',
  },
  {
    symbol: 'ROBO',
    'Security Name':
      'Exchange Traded Concepts Trust ROBO Global Robotics and Automation Index ETF',

    'CQS symbol': 'ROBO',
    'NASDAQ symbol': 'ROBO',
  },
  {
    symbol: 'ROBT',
    'Security Name':
      'First Trust Nasdaq Artificial Intelligence and Robotics ETF',

    'NASDAQ symbol': 'ROBT',
  },
  {
    symbol: 'ROCH',
    'Security Name': 'Roth CH Acquisition I Co  ',

    'NASDAQ symbol': 'ROCH',
  },
  {
    symbol: 'ROCHU',
    'Security Name': 'Roth CH Acquisition I Co  Unit',

    'NASDAQ symbol': 'ROCHU',
  },
  {
    symbol: 'ROCHW',
    'Security Name': 'Roth CH Acquisition I Co  Warrant',

    'NASDAQ symbol': 'ROCHW',
  },
  {
    symbol: 'ROCK',
    'Security Name': 'Gibraltar Industries,   ',

    'NASDAQ symbol': 'ROCK',
  },
  {
    symbol: 'RODE',
    'Security Name': 'Hartford Multifactor Diversified International ETF',

    'CQS symbol': 'RODE',
    'NASDAQ symbol': 'RODE',
  },
  {
    symbol: 'RODI',
    'Security Name': 'iPath Return on Disability ETN',

    'CQS symbol': 'RODI',
    'NASDAQ symbol': 'RODI',
  },
  {
    symbol: 'RODM',
    'Security Name': 'Hartford Multifactor Developed Markets (exUS) ETF',

    'CQS symbol': 'RODM',
    'NASDAQ symbol': 'RODM',
  },
  {
    symbol: 'ROG',
    'Security Name': 'Rogers Corporation ',

    'CQS symbol': 'ROG',
    'NASDAQ symbol': 'ROG',
  },
  {
    symbol: 'ROIC',
    'Security Name': 'Retail Opportunity Investments Corp  ',

    'NASDAQ symbol': 'ROIC',
  },
  {
    symbol: 'ROK',
    'Security Name': 'Rockwell Automation,  ',

    'CQS symbol': 'ROK',
    'NASDAQ symbol': 'ROK',
  },
  {
    symbol: 'ROKT',
    'Security Name': 'SPDR S&P Kensho Final Frontiers ETF',

    'CQS symbol': 'ROKT',
    'NASDAQ symbol': 'ROKT',
  },
  {
    symbol: 'ROKU',
    'Security Name': 'Roku,    ',

    'NASDAQ symbol': 'ROKU',
  },
  {
    symbol: 'ROL',
    'Security Name': 'Rollins,  ',

    'CQS symbol': 'ROL',
    'NASDAQ symbol': 'ROL',
  },
  {
    symbol: 'ROLL',
    'Security Name': 'RBC Bearings orporated  ',

    'NASDAQ symbol': 'ROLL',
  },
  {
    symbol: 'ROM',
    'Security Name': 'ProShares Ultra Technology',

    'CQS symbol': 'ROM',
    'NASDAQ symbol': 'ROM',
  },
  {
    symbol: 'ROMO',
    'Security Name': 'Strategy Shares Newfound/ReSolve Robust Momentum ETF',

    'CQS symbol': 'ROMO',
    'NASDAQ symbol': 'ROMO',
  },
  {
    symbol: 'ROOF',
    'Security Name': 'IQ US Real Estate Small Cap ETF',

    'CQS symbol': 'ROOF',
    'NASDAQ symbol': 'ROOF',
  },
  {
    symbol: 'ROOT',
    'Security Name': 'Root,   ',

    'NASDAQ symbol': 'ROOT',
  },
  {
    symbol: 'ROP',
    'Security Name': 'Roper Technologies,  ',

    'CQS symbol': 'ROP',
    'NASDAQ symbol': 'ROP',
  },
  {
    symbol: 'RORO',
    'Security Name': 'ATAC US Rotation ETF',

    'CQS symbol': 'RORO',
    'NASDAQ symbol': 'RORO',
  },
  {
    symbol: 'ROSC',
    'Security Name': 'Hartford Multifactor Small Cap ETF',

    'CQS symbol': 'ROSC',
    'NASDAQ symbol': 'ROSC',
  },
  {
    symbol: 'ROST',
    'Security Name': 'Ross Stores,   ',

    'NASDAQ symbol': 'ROST',
  },
  {
    symbol: 'ROUS',
    'Security Name': 'Hartford Multifactor US Equity ETF',

    'CQS symbol': 'ROUS',
    'NASDAQ symbol': 'ROUS',
  },
  {
    symbol: 'RP',
    'Security Name': 'RealPage,   ',

    'NASDAQ symbol': 'RP',
  },
  {
    symbol: 'RPAI',
    'Security Name': 'Retail Properties of America,   ',

    'CQS symbol': 'RPAI',
    'NASDAQ symbol': 'RPAI',
  },
  {
    symbol: 'RPAR',
    'Security Name': 'RPAR Risk Parity ETF',

    'CQS symbol': 'RPAR',
    'NASDAQ symbol': 'RPAR',
  },
  {
    symbol: 'RPAY',
    'Security Name': 'Repay Holdings Corporation   ',

    'NASDAQ symbol': 'RPAY',
  },
  {
    symbol: 'RPD',
    'Security Name': 'Rapid7,   ',

    'NASDAQ symbol': 'RPD',
  },
  {
    symbol: 'RPG',
    'Security Name': 'Invesco S&P 500 Pure Growth ETF',

    'CQS symbol': 'RPG',
    'NASDAQ symbol': 'RPG',
  },
  {
    symbol: 'RPLA',
    'Security Name': 'Replay Acquisition Corp Ordinary Shares',

    'CQS symbol': 'RPLA',
    'NASDAQ symbol': 'RPLA',
  },
  {
    symbol: 'RPLAU',
    'Security Name':
      'Replay Acquisition Corp Units, each consisting of one Ordinary Share and onehalf of one Warrant',

    'CQS symbol': 'RPLAU',
    'NASDAQ symbol': 'RPLA=',
  },
  {
    symbol: 'RPLAW',
    'Security Name':
      'Replay Acquisition Corp Warrants, each whole warrant exercisable for one Ordinary Share at an exercise price of $1150',

    'CQS symbol': 'RPLAWS',
    'NASDAQ symbol': 'RPLA+',
  },
  {
    symbol: 'RPM',
    'Security Name': 'RPM International  ',

    'CQS symbol': 'RPM',
    'NASDAQ symbol': 'RPM',
  },
  {
    symbol: 'RPRX',
    'Security Name': 'Royalty Pharma plc   Ordinary Shares',

    'NASDAQ symbol': 'RPRX',
  },
  {
    symbol: 'RPT',
    'Security Name': 'RPT Realty ',

    'CQS symbol': 'RPT',
    'NASDAQ symbol': 'RPT',
  },
  {
    symbol: 'RPT$D',
    'Security Name': 'RPT Realty 725% ',

    'CQS symbol': 'RPTpD',
    'NASDAQ symbol': 'RPTD',
  },
  {
    symbol: 'RPTX',
    'Security Name': 'Repare Therapeutics   Common Shares',

    'NASDAQ symbol': 'RPTX',
  },
  {
    symbol: 'RPV',
    'Security Name': 'Invesco S&P 500 Pure Value ETF',

    'CQS symbol': 'RPV',
    'NASDAQ symbol': 'RPV',
  },
  {
    symbol: 'RQI',
    'Security Name': 'Cohen & Steers Quality ome Realty Fund  Common Shares',

    'CQS symbol': 'RQI',
    'NASDAQ symbol': 'RQI',
  },
  {
    symbol: 'RRBI',
    'Security Name': 'Red River Bancshares,   ',

    'NASDAQ symbol': 'RRBI',
  },
  {
    symbol: 'RRC',
    'Security Name': 'Range Resources Corporation ',

    'CQS symbol': 'RRC',
    'NASDAQ symbol': 'RRC',
  },
  {
    symbol: 'RRD',
    'Security Name': 'RR Donnelley & Sons Company ',

    'CQS symbol': 'RRD',
    'NASDAQ symbol': 'RRD',
  },
  {
    symbol: 'RRGB',
    'Security Name': 'Red Robin Gourmet Burgers,   ',

    'NASDAQ symbol': 'RRGB',
  },
  {
    symbol: 'RRR',
    'Security Name': 'Red Rock Resorts,    ',

    'NASDAQ symbol': 'RRR',
  },
  {
    symbol: 'RS',
    'Security Name': 'Reliance Steel & Aluminum Co  (DE)',

    'CQS symbol': 'RS',
    'NASDAQ symbol': 'RS',
  },
  {
    symbol: 'RSF',
    'Security Name': 'RiverNorth Specialty Finance Corporation',

    'CQS symbol': 'RSF',
    'NASDAQ symbol': 'RSF',
  },
  {
    symbol: 'RSG',
    'Security Name': 'Republic Services,  ',

    'CQS symbol': 'RSG',
    'NASDAQ symbol': 'RSG',
  },
  {
    symbol: 'RSP',
    'Security Name': 'Invesco S&P 500 Equal Weight ETF',

    'CQS symbol': 'RSP',
    'NASDAQ symbol': 'RSP',
  },
  {
    symbol: 'RSSS',
    'Security Name': 'Research Solutions,   ',

    'NASDAQ symbol': 'RSSS',
  },
  {
    symbol: 'RSVAU',
    'Security Name': 'Rodgers Silicon Valley Acquisition Corp  Unit',

    'NASDAQ symbol': 'RSVAU',
  },
  {
    symbol: 'RSX',
    'Security Name': 'VanEck Vectors Russia ETF',

    'CQS symbol': 'RSX',
    'NASDAQ symbol': 'RSX',
  },
  {
    symbol: 'RSXJ',
    'Security Name': 'VanEck Vectors Russia SmallCap ETF',

    'CQS symbol': 'RSXJ',
    'NASDAQ symbol': 'RSXJ',
  },
  {
    symbol: 'RTAI',
    'Security Name': 'Rareview Tax Advantaged ome ETF',

    'CQS symbol': 'RTAI',
    'NASDAQ symbol': 'RTAI',
  },
  {
    symbol: 'RTH',
    'Security Name': 'VanEck Vectors Retail ETF',

    'NASDAQ symbol': 'RTH',
  },
  {
    symbol: 'RTLR',
    'Security Name':
      'Rattler Midstream LP  Common Units Representing Limited Partnership Interests',

    'NASDAQ symbol': 'RTLR',
  },
  {
    symbol: 'RTM',
    'Security Name': 'Invesco S&P 500 Equal Weight Materials ETF',

    'CQS symbol': 'RTM',
    'NASDAQ symbol': 'RTM',
  },
  {
    symbol: 'RTP',
    'Security Name': 'Reinvent Technology Partners  Ordinary Shares',

    'CQS symbol': 'RTP',
    'NASDAQ symbol': 'RTP',
  },
  {
    symbol: 'RTPU',
    'Security Name':
      'Reinvent Technology Partners Units, each consisting of one  ordinary share and onefourth of one redeemable warrant',

    'CQS symbol': 'RTPU',
    'NASDAQ symbol': 'RTP=',
  },
  {
    symbol: 'RTPW',
    'Security Name':
      'Reinvent Technology Partners Redeemable Warrants, each whole warrant exercisable for one  ordinary share at an exercise price of $1150',

    'CQS symbol': 'RTPWS',
    'NASDAQ symbol': 'RTP+',
  },
  {
    symbol: 'RTPZU',
    'Security Name': 'Reinvent Technology Partners Z Unit',

    'CQS symbol': 'RTPZU',
    'NASDAQ symbol': 'RTPZ=',
  },
  {
    symbol: 'RTX',
    'Security Name': 'Raytheon Technologies Corporation ',

    'CQS symbol': 'RTX',
    'NASDAQ symbol': 'RTX',
  },
  {
    symbol: 'RUBY',
    'Security Name': 'Rubius Therapeutics,   ',

    'NASDAQ symbol': 'RUBY',
  },
  {
    symbol: 'RUHN',
    'Security Name': 'Ruhnn Holding Limited  American Depositary Shares',

    'NASDAQ symbol': 'RUHN',
  },
  {
    symbol: 'RUN',
    'Security Name': 'Sunrun   ',

    'NASDAQ symbol': 'RUN',
  },
  {
    symbol: 'RUSHA',
    'Security Name': 'Rush Enterprises,    ',

    'NASDAQ symbol': 'RUSHA',
  },
  {
    symbol: 'RUSHB',
    'Security Name': 'Rush Enterprises,   Class B ',

    'NASDAQ symbol': 'RUSHB',
  },
  {
    symbol: 'RUSL',
    'Security Name': 'Direxion Daily Russia Bull 2X Shares',

    'CQS symbol': 'RUSL',
    'NASDAQ symbol': 'RUSL',
  },
  {
    symbol: 'RUTH',
    'Security Name': "Ruth's Hospitality Group,   ",

    'NASDAQ symbol': 'RUTH',
  },
  {
    symbol: 'RVI',
    'Security Name': 'Retail Value   ',

    'CQS symbol': 'RVI',
    'NASDAQ symbol': 'RVI',
  },
  {
    symbol: 'RVLV',
    'Security Name': 'Revolve Group,   ',

    'CQS symbol': 'RVLV',
    'NASDAQ symbol': 'RVLV',
  },
  {
    symbol: 'RVMD',
    'Security Name': 'Revolution Medicines,   ',

    'NASDAQ symbol': 'RVMD',
  },
  {
    symbol: 'RVNC',
    'Security Name': 'Revance Therapeutics,   ',

    'NASDAQ symbol': 'RVNC',
  },
  {
    symbol: 'RVNU',
    'Security Name': 'Xtrackers Municipal Infrastructure Revenue Bond ETF',

    'CQS symbol': 'RVNU',
    'NASDAQ symbol': 'RVNU',
  },
  {
    symbol: 'RVP',
    'Security Name': 'Retractable Technologies,  ',

    'CQS symbol': 'RVP',
    'NASDAQ symbol': 'RVP',
  },
  {
    symbol: 'RVRS',
    'Security Name': 'Reverse Cap Weighted US Large Cap ETF ',

    'CQS symbol': 'RVRS',
    'NASDAQ symbol': 'RVRS',
  },
  {
    symbol: 'RVSB',
    'Security Name': 'Riverview Bancorp   ',

    'NASDAQ symbol': 'RVSB',
  },
  {
    symbol: 'RVT',
    'Security Name': 'Royce Value Trust,  ',

    'CQS symbol': 'RVT',
    'NASDAQ symbol': 'RVT',
  },
  {
    symbol: 'RWGV',
    'Security Name': 'Direxion Russell 1000 Growth Over Value ETF',

    'CQS symbol': 'RWGV',
    'NASDAQ symbol': 'RWGV',
  },
  {
    symbol: 'RWJ',
    'Security Name':
      'Invesco ExchangeTraded Fund Trust II Invesco S&P SmallCap 600 Revenue ETF',

    'CQS symbol': 'RWJ',
    'NASDAQ symbol': 'RWJ',
  },
  {
    symbol: 'RWK',
    'Security Name':
      'Invesco ExchangeTraded Fund Trust II Invesco S&P MidCap 400 Revenue ETF',

    'CQS symbol': 'RWK',
    'NASDAQ symbol': 'RWK',
  },
  {
    symbol: 'RWL',
    'Security Name':
      'Invesco ExchangeTraded Fund Trust II Invesco S&P 500 Revenue ETF',

    'CQS symbol': 'RWL',
    'NASDAQ symbol': 'RWL',
  },
  {
    symbol: 'RWLK',
    'Security Name': 'ReWalk Robotics Ltd  Ordinary Shares',

    'NASDAQ symbol': 'RWLK',
  },
  {
    symbol: 'RWM',
    'Security Name': 'ProShares Short Russell2000',

    'CQS symbol': 'RWM',
    'NASDAQ symbol': 'RWM',
  },
  {
    symbol: 'RWO',
    'Security Name': 'SPDR DJ Wilshire Global Real Estate ETF',

    'CQS symbol': 'RWO',
    'NASDAQ symbol': 'RWO',
  },
  {
    symbol: 'RWR',
    'Security Name': 'SPDR DJ Wilshire REIT ETF',

    'CQS symbol': 'RWR',
    'NASDAQ symbol': 'RWR',
  },
  {
    symbol: 'RWT',
    'Security Name': 'Redwood Trust,  ',

    'CQS symbol': 'RWT',
    'NASDAQ symbol': 'RWT',
  },
  {
    symbol: 'RWVG',
    'Security Name': 'Direxion Russell 1000 Value Over Growth ETF',

    'CQS symbol': 'RWVG',
    'NASDAQ symbol': 'RWVG',
  },
  {
    symbol: 'RWX',
    'Security Name': 'SPDR DJ Wilshire Intl Real Estate',

    'CQS symbol': 'RWX',
    'NASDAQ symbol': 'RWX',
  },
  {
    symbol: 'RXD',
    'Security Name': 'ProShares UltraShort Health Care',

    'CQS symbol': 'RXD',
    'NASDAQ symbol': 'RXD',
  },
  {
    symbol: 'RXI',
    'Security Name': 'iShares Global Consumer Discretionary ETF',

    'CQS symbol': 'RXI',
    'NASDAQ symbol': 'RXI',
  },
  {
    symbol: 'RXL',
    'Security Name': 'ProShares Ultra Health Care',

    'CQS symbol': 'RXL',
    'NASDAQ symbol': 'RXL',
  },
  {
    symbol: 'RXN',
    'Security Name': 'Rexnord Corporation ',

    'CQS symbol': 'RXN',
    'NASDAQ symbol': 'RXN',
  },
  {
    symbol: 'RXT',
    'Security Name': 'Rackspace Technology,   ',

    'NASDAQ symbol': 'RXT',
  },
  {
    symbol: 'RY',
    'Security Name': 'Royal Bank Of Canada ',

    'CQS symbol': 'RY',
    'NASDAQ symbol': 'RY',
  },
  {
    symbol: 'RY$T',
    'Security Name':
      'Royal Bank Of Canada 6750% Fixed Rate/Floating Rate Noncumulative First Preferred Shares, Series C2',

    'CQS symbol': 'RYpT',
    'NASDAQ symbol': 'RYT',
  },
  {
    symbol: 'RYAAY',
    'Security Name':
      'Ryanair Holdings plc  American Depositary Shares, each representing five Ordinary Shares',

    'NASDAQ symbol': 'RYAAY',
  },
  {
    symbol: 'RYAM',
    'Security Name': 'Rayonier Advanced Materials  ',

    'CQS symbol': 'RYAM',
    'NASDAQ symbol': 'RYAM',
  },
  {
    symbol: 'RYB',
    'Security Name':
      'RYB Education,  American depositary shares, each representing one  ordinary share',

    'CQS symbol': 'RYB',
    'NASDAQ symbol': 'RYB',
  },
  {
    symbol: 'RYE',
    'Security Name': 'Invesco S&P 500 Equal Weight Energy ETF',

    'CQS symbol': 'RYE',
    'NASDAQ symbol': 'RYE',
  },
  {
    symbol: 'RYF',
    'Security Name': 'Invesco S&P 500 Equal Weight Financial ETF',

    'CQS symbol': 'RYF',
    'NASDAQ symbol': 'RYF',
  },
  {
    symbol: 'RYH',
    'Security Name': 'Invesco S&P 500 Equal Weight Health Care ETF',

    'CQS symbol': 'RYH',
    'NASDAQ symbol': 'RYH',
  },
  {
    symbol: 'RYI',
    'Security Name': 'Ryerson Holding Corporation ',

    'CQS symbol': 'RYI',
    'NASDAQ symbol': 'RYI',
  },
  {
    symbol: 'RYJ',
    'Security Name': 'Invesco Raymond James SB1 Equity ETF',

    'CQS symbol': 'RYJ',
    'NASDAQ symbol': 'RYJ',
  },
  {
    symbol: 'RYLD',
    'Security Name': 'Global X Russell 2000 Covered Call ETF',

    'CQS symbol': 'RYLD',
    'NASDAQ symbol': 'RYLD',
  },
  {
    symbol: 'RYN',
    'Security Name': 'Rayonier  REIT ',

    'CQS symbol': 'RYN',
    'NASDAQ symbol': 'RYN',
  },
  {
    symbol: 'RYT',
    'Security Name': 'Invesco S&P 500 Equal Weight Technology ETF',

    'CQS symbol': 'RYT',
    'NASDAQ symbol': 'RYT',
  },
  {
    symbol: 'RYTM',
    'Security Name': 'Rhythm Pharmaceuticals,   ',

    'NASDAQ symbol': 'RYTM',
  },
  {
    symbol: 'RYU',
    'Security Name': 'Invesco S&P 500 Equal Weight Utilities ETF',

    'CQS symbol': 'RYU',
    'NASDAQ symbol': 'RYU',
  },
  {
    symbol: 'RZA',
    'Security Name':
      'Reinsurance Group of America, orporated 620% FixedtoFloating Rate Subordinated Debentures due 2042',

    'CQS symbol': 'RZA',
    'NASDAQ symbol': 'RZA',
  },
  {
    symbol: 'RZB',
    'Security Name':
      'Reinsurance Group of America, orporated 575% FixedToFloating Rate Subordinated Debentures due 2056',

    'CQS symbol': 'RZB',
    'NASDAQ symbol': 'RZB',
  },
  {
    symbol: 'RZG',
    'Security Name': 'Invesco S&P Smallcap 600 Pure Growth ETF',

    'CQS symbol': 'RZG',
    'NASDAQ symbol': 'RZG',
  },
  {
    symbol: 'RZLT',
    'Security Name': 'Rezolute,   ',

    'NASDAQ symbol': 'RZLT',
  },
  {
    symbol: 'RZV',
    'Security Name': 'Invesco S&P Smallcap 600 Pure Value ETF',

    'CQS symbol': 'RZV',
    'NASDAQ symbol': 'RZV',
  },
  {
    symbol: 'SA',
    'Security Name': 'Seabridge Gold,  Ordinary Shares (Canada)',

    'CQS symbol': 'SA',
    'NASDAQ symbol': 'SA',
  },
  {
    symbol: 'SAA',
    'Security Name': 'ProShares Ultra SmallCap600',

    'CQS symbol': 'SAA',
    'NASDAQ symbol': 'SAA',
  },
  {
    symbol: 'SABR',
    'Security Name': 'Sabre Corporation  ',

    'NASDAQ symbol': 'SABR',
  },
  {
    symbol: 'SABRP',
    'Security Name':
      'Sabre Corporation  650% Series A Mandatory Convertible Preferred Stock',

    'NASDAQ symbol': 'SABRP',
  },
  {
    symbol: 'SACC',
    'Security Name': 'Sachem Capital Corp 6875% Notes due 2024',

    'CQS symbol': 'SACC',
    'NASDAQ symbol': 'SACC',
  },
  {
    symbol: 'SACH',
    'Security Name': 'Sachem Capital Corp Common Shares',

    'CQS symbol': 'SACH',
    'NASDAQ symbol': 'SACH',
  },
  {
    symbol: 'SAF',
    'Security Name': 'Saratoga Investment Corp 625% Notes due 2023',

    'CQS symbol': 'SAF',
    'NASDAQ symbol': 'SAF',
  },
  {
    symbol: 'SAFE',
    'Security Name': 'Safehold  ',

    'CQS symbol': 'SAFE',
    'NASDAQ symbol': 'SAFE',
  },
  {
    symbol: 'SAFM',
    'Security Name': 'Sanderson Farms,   ',

    'NASDAQ symbol': 'SAFM',
  },
  {
    symbol: 'SAFT',
    'Security Name': 'Safety Insurance Group,   ',

    'NASDAQ symbol': 'SAFT',
  },
  {
    symbol: 'SAGE',
    'Security Name': 'Sage Therapeutics,   ',

    'NASDAQ symbol': 'SAGE',
  },
  {
    symbol: 'SAH',
    'Security Name': 'Sonic Automotive,  ',

    'CQS symbol': 'SAH',
    'NASDAQ symbol': 'SAH',
  },
  {
    symbol: 'SAIA',
    'Security Name': 'Saia,   ',

    'NASDAQ symbol': 'SAIA',
  },
  {
    symbol: 'SAIC',
    'Security Name': 'SCIENCE APPLICATIONS INTERNATIONAL CORPORATION ',

    'CQS symbol': 'SAIC',
    'NASDAQ symbol': 'SAIC',
  },
  {
    symbol: 'SAII',
    'Security Name': 'Software Acquisition Group  II   ',

    'NASDAQ symbol': 'SAII',
  },
  {
    symbol: 'SAIIU',
    'Security Name': 'Software Acquisition Group  II  Unit',

    'NASDAQ symbol': 'SAIIU',
  },
  {
    symbol: 'SAIIW',
    'Security Name': 'Software Acquisition Group  II  Warrant',

    'NASDAQ symbol': 'SAIIW',
  },
  {
    symbol: 'SAIL',
    'Security Name': 'SailPoint Technologies Holdings,  ',

    'CQS symbol': 'SAIL',
    'NASDAQ symbol': 'SAIL',
  },
  {
    symbol: 'SAK',
    'Security Name': 'Saratoga Investment Corp 725% Notes due 2025',

    'CQS symbol': 'SAK',
    'NASDAQ symbol': 'SAK',
  },
  {
    symbol: 'SAL',
    'Security Name': 'Salisbury Bancorp,   ',

    'NASDAQ symbol': 'SAL',
  },
  {
    symbol: 'SALM',
    'Security Name': 'Salem Media Group,    ',

    'NASDAQ symbol': 'SALM',
  },
  {
    symbol: 'SALT',
    'Security Name': 'Scorpio Bulkers  ',

    'CQS symbol': 'SALT',
    'NASDAQ symbol': 'SALT',
  },
  {
    symbol: 'SAM',
    'Security Name': 'Boston Beer Company,  (The) ',

    'CQS symbol': 'SAM',
    'NASDAQ symbol': 'SAM',
  },
  {
    symbol: 'SAMA',
    'Security Name': 'Schultze Special Purpose Acquisition Corp  ',

    'NASDAQ symbol': 'SAMA',
  },
  {
    symbol: 'SAMAU',
    'Security Name': 'Schultze Special Purpose Acquisition Corp  Unit',

    'NASDAQ symbol': 'SAMAU',
  },
  {
    symbol: 'SAMAW',
    'Security Name': 'Schultze Special Purpose Acquisition Corp  Warrant',

    'NASDAQ symbol': 'SAMAW',
  },
  {
    symbol: 'SAMG',
    'Security Name': 'Silvercrest Asset Management Group   ',

    'NASDAQ symbol': 'SAMG',
  },
  {
    symbol: 'SAN',
    'Security Name': 'Banco Santander, SA Sponsored ADR (Spain)',

    'CQS symbol': 'SAN',
    'NASDAQ symbol': 'SAN',
  },
  {
    symbol: 'SAN$B',
    'Security Name':
      'Banco Santander, SA Floating Rate Noncumulative Series 6 Guaranteed Preferred Securities',

    'CQS symbol': 'SANpB',
    'NASDAQ symbol': 'SANB',
  },
  {
    symbol: 'SAND',
    'Security Name': 'Sandstorm Gold Ltd Ordinary Shares (Canada)',

    'CQS symbol': 'SAND',
    'NASDAQ symbol': 'SAND',
  },
  {
    symbol: 'SANM',
    'Security Name': 'Sanmina Corporation  ',

    'NASDAQ symbol': 'SANM',
  },
  {
    symbol: 'SANW',
    'Security Name': 'S&W Seed Company  ',

    'NASDAQ symbol': 'SANW',
  },
  {
    symbol: 'SAP',
    'Security Name': 'SAP  SE ADS',

    'CQS symbol': 'SAP',
    'NASDAQ symbol': 'SAP',
  },
  {
    symbol: 'SAR',
    'Security Name': 'Saratoga Investment Corp New',

    'CQS symbol': 'SAR',
    'NASDAQ symbol': 'SAR',
  },
  {
    symbol: 'SASR',
    'Security Name': 'Sandy Spring Bancorp,   ',

    'NASDAQ symbol': 'SASR',
  },
  {
    symbol: 'SATS',
    'Security Name': 'EchoStar Corporation  ',

    'NASDAQ symbol': 'SATS',
  },
  {
    symbol: 'SAVA',
    'Security Name': 'Cassava Sciences,   ',

    'NASDAQ symbol': 'SAVA',
  },
  {
    symbol: 'SAVE',
    'Security Name': 'Spirit Airlines,  ',

    'CQS symbol': 'SAVE',
    'NASDAQ symbol': 'SAVE',
  },
  {
    symbol: 'SB',
    'Security Name': 'Safe Bulkers,   ($0001 par value)',

    'CQS symbol': 'SB',
    'NASDAQ symbol': 'SB',
  },
  {
    symbol: 'SB$C',
    'Security Name':
      'Safe Bulkers,  Cumulative Redeemable Perpetual Preferred Series C (Marshall Islands)',

    'CQS symbol': 'SBpC',
    'NASDAQ symbol': 'SBC',
  },
  {
    symbol: 'SB$D',
    'Security Name':
      'Safe Bulkers,  Perpetual Preferred Series D (Marshall Islands)',

    'CQS symbol': 'SBpD',
    'NASDAQ symbol': 'SBD',
  },
  {
    symbol: 'SBAC',
    'Security Name': 'SBA Communications Corporation   ',

    'NASDAQ symbol': 'SBAC',
  },
  {
    symbol: 'SBB',
    'Security Name': 'ProShares Short SmallCap600',

    'CQS symbol': 'SBB',
    'NASDAQ symbol': 'SBB',
  },
  {
    symbol: 'SBBA',
    'Security Name': 'Scorpio Tankers  700% Senior Notes due 2025',

    'CQS symbol': 'SBBA',
    'NASDAQ symbol': 'SBBA',
  },
  {
    symbol: 'SBBP',
    'Security Name': 'Strongbridge Biopharma plc  Ordinary Shares',

    'NASDAQ symbol': 'SBBP',
  },
  {
    symbol: 'SBCF',
    'Security Name': 'Seacoast Banking Corporation of Florida  ',

    'NASDAQ symbol': 'SBCF',
  },
  {
    symbol: 'SBE',
    'Security Name': 'Switchback Energy Acquisition Corporation  ',

    'CQS symbol': 'SBE',
    'NASDAQ symbol': 'SBE',
  },
  {
    symbol: 'SBEU',
    'Security Name': 'Switchback Energy Acquisition Corporation Units',

    'CQS symbol': 'SBEU',
    'NASDAQ symbol': 'SBE=',
  },
  {
    symbol: 'SBEW',
    'Security Name': 'Switchback Energy Acquisition Corporation Warrant',

    'CQS symbol': 'SBEWS',
    'NASDAQ symbol': 'SBE+',
  },
  {
    symbol: 'SBFG',
    'Security Name': 'SB Financial Group,   ',

    'NASDAQ symbol': 'SBFG',
  },
  {
    symbol: 'SBG',
    'Security Name': 'Sandbridge Acquisition Corporation  ',

    'CQS symbol': 'SBG',
    'NASDAQ symbol': 'SBG',
  },
  {
    symbol: 'SBGU',
    'Security Name': 'Sandbridge Acquisition Corporation Units',

    'CQS symbol': 'SBGU',
    'NASDAQ symbol': 'SBG=',
  },
  {
    symbol: 'SBGW',
    'Security Name':
      'Sandbridge Acquisition Corporation Warrants, each whole warrant exercisable for one share of   at an exercise price of $1150',

    'CQS symbol': 'SBGWS',
    'NASDAQ symbol': 'SBG+',
  },
  {
    symbol: 'SBGI',
    'Security Name': 'Slair Broadcast Group,    ',

    'NASDAQ symbol': 'SBGI',
  },
  {
    symbol: 'SBH',
    'Security Name':
      'Sally Beauty Holdings,  (Name to be changed from Sally Holdings, ) ',

    'CQS symbol': 'SBH',
    'NASDAQ symbol': 'SBH',
  },
  {
    symbol: 'SBI',
    'Security Name': 'Western Asset Intermediate Muni Fund  ',

    'CQS symbol': 'SBI',
    'NASDAQ symbol': 'SBI',
  },
  {
    symbol: 'SBIO',
    'Security Name': 'ALPS Medical Breakthroughs ETF',

    'CQS symbol': 'SBIO',
    'NASDAQ symbol': 'SBIO',
  },
  {
    symbol: 'SBLK',
    'Security Name': 'Star Bulk Carriers Corp  Common Shares',

    'NASDAQ symbol': 'SBLK',
  },
  {
    symbol: 'SBLKZ',
    'Security Name': 'Star Bulk Carriers Corp  830% Senior Notes due 2022',

    'NASDAQ symbol': 'SBLKZ',
  },
  {
    symbol: 'SBM',
    'Security Name': 'Short Basic Materials',

    'CQS symbol': 'SBM',
    'NASDAQ symbol': 'SBM',
  },
  {
    symbol: 'SBNY',
    'Security Name': 'Signature Bank  ',

    'NASDAQ symbol': 'SBNY',
  },
  {
    symbol: 'SBOW',
    'Security Name': 'SilverBow Resorces,  ',

    'CQS symbol': 'SBOW',
    'NASDAQ symbol': 'SBOW',
  },
  {
    symbol: 'SBR',
    'Security Name': 'Sabine Royalty Trust ',

    'CQS symbol': 'SBR',
    'NASDAQ symbol': 'SBR',
  },
  {
    symbol: 'SBRA',
    'Security Name': 'Sabra Health Care REIT,   ',

    'NASDAQ symbol': 'SBRA',
  },
  {
    symbol: 'SBS',
    'Security Name':
      'Companhia de saneamento Basico Do Estado De Sao Paulo  Sabesp American Depositary Shares (Each repstg 250 Common Shares)',

    'CQS symbol': 'SBS',
    'NASDAQ symbol': 'SBS',
  },
  {
    symbol: 'SBSI',
    'Security Name': 'Southside Bancshares,   ',

    'NASDAQ symbol': 'SBSI',
  },
  {
    symbol: 'SBSW',
    'Security Name': 'D/B/A SibanyeStillwater Limited ADS',

    'CQS symbol': 'SBSW',
    'NASDAQ symbol': 'SBSW',
  },
  {
    symbol: 'SBT',
    'Security Name': 'Sterling Bancorp,   ',

    'NASDAQ symbol': 'SBT',
  },
  {
    symbol: 'SBTX',
    'Security Name': 'Silverback Therapeutics,   ',

    'NASDAQ symbol': 'SBTX',
  },
  {
    symbol: 'SBUG',
    'Security Name': 'iPath Silver ETN',

    'CQS symbol': 'SBUG',
    'NASDAQ symbol': 'SBUG',
  },
  {
    symbol: 'SBUX',
    'Security Name': 'Starbucks Corporation  ',

    'NASDAQ symbol': 'SBUX',
  },
  {
    symbol: 'SC',
    'Security Name': 'Santander Consumer USA Holdings  ',

    'CQS symbol': 'SC',
    'NASDAQ symbol': 'SC',
  },
  {
    symbol: 'SCA',
    'Security Name':
      'Stellus Capital Investment Corporation 575% Notes due 2022',

    'CQS symbol': 'SCA',
    'NASDAQ symbol': 'SCA',
  },
  {
    symbol: 'SCC',
    'Security Name': 'ProShares UltraShort Consumer Services',

    'CQS symbol': 'SCC',
    'NASDAQ symbol': 'SCC',
  },
  {
    symbol: 'SCCB',
    'Security Name': 'Sachem Capital Corp 7125% Notes due 2024',

    'CQS symbol': 'SCCB',
    'NASDAQ symbol': 'SCCB',
  },
  {
    symbol: 'SCCC',
    'Security Name': 'Sachem Capital Corp 775% Notes due 2025',

    'CQS symbol': 'SCCC',
    'NASDAQ symbol': 'SCCC',
  },
  {
    symbol: 'SCCO',
    'Security Name': 'Southern Copper Corporation ',

    'CQS symbol': 'SCCO',
    'NASDAQ symbol': 'SCCO',
  },
  {
    symbol: 'SCD',
    'Security Name': 'LMP Capital and ome Fund  ',

    'CQS symbol': 'SCD',
    'NASDAQ symbol': 'SCD',
  },
  {
    symbol: 'SCE$G',
    'Security Name': 'SCE Trust II Trust Preferred Securities',

    'CQS symbol': 'SCEpG',
    'NASDAQ symbol': 'SCEG',
  },
  {
    symbol: 'SCE$H',
    'Security Name':
      'SCE Trust III Fixed/Floating Rate Trust Preference Securities',

    'CQS symbol': 'SCEpH',
    'NASDAQ symbol': 'SCEH',
  },
  {
    symbol: 'SCE$J',
    'Security Name':
      'Southern California Edison Company 5375% FixedtoFloating Rate Trust Preference Securities',

    'CQS symbol': 'SCEpJ',
    'NASDAQ symbol': 'SCEJ',
  },
  {
    symbol: 'SCE$K',
    'Security Name':
      'Southern California Edison Company 545% FixedtoFloating Rate Trust Preference Securities',

    'CQS symbol': 'SCEpK',
    'NASDAQ symbol': 'SCEK',
  },
  {
    symbol: 'SCE$L',
    'Security Name': 'SCE TRUST VI',

    'CQS symbol': 'SCEpL',
    'NASDAQ symbol': 'SCEL',
  },
  {
    symbol: 'SCHA',
    'Security Name': 'Schwab US SmallCap ETF',

    'CQS symbol': 'SCHA',
    'NASDAQ symbol': 'SCHA',
  },
  {
    symbol: 'SCHB',
    'Security Name': 'Schwab US Broad Market ETF',

    'CQS symbol': 'SCHB',
    'NASDAQ symbol': 'SCHB',
  },
  {
    symbol: 'SCHC',
    'Security Name': 'Schwab International SmallCap Equity ETF',

    'CQS symbol': 'SCHC',
    'NASDAQ symbol': 'SCHC',
  },
  {
    symbol: 'SCHD',
    'Security Name': 'Schwab US Dividend Equity ETF',

    'CQS symbol': 'SCHD',
    'NASDAQ symbol': 'SCHD',
  },
  {
    symbol: 'SCHE',
    'Security Name': 'Schwab Emerging Markets Equity ETF',

    'CQS symbol': 'SCHE',
    'NASDAQ symbol': 'SCHE',
  },
  {
    symbol: 'SCHF',
    'Security Name': 'Schwab International Equity ETF',

    'CQS symbol': 'SCHF',
    'NASDAQ symbol': 'SCHF',
  },
  {
    symbol: 'SCHG',
    'Security Name': 'Schwab US LargeCap Growth ETF',

    'CQS symbol': 'SCHG',
    'NASDAQ symbol': 'SCHG',
  },
  {
    symbol: 'SCHH',
    'Security Name': 'Schwab US REIT ETF',

    'CQS symbol': 'SCHH',
    'NASDAQ symbol': 'SCHH',
  },
  {
    symbol: 'SCHI',
    'Security Name': 'Schwab 510 Year Corporate Bond ETF',

    'CQS symbol': 'SCHI',
    'NASDAQ symbol': 'SCHI',
  },
  {
    symbol: 'SCHJ',
    'Security Name': 'Schwab 15 Year Corporate Bond ETF',

    'CQS symbol': 'SCHJ',
    'NASDAQ symbol': 'SCHJ',
  },
  {
    symbol: 'SCHK',
    'Security Name': 'Schwab 1000 Index ETF',

    'CQS symbol': 'SCHK',
    'NASDAQ symbol': 'SCHK',
  },
  {
    symbol: 'SCHL',
    'Security Name': 'Scholastic Corporation  ',

    'NASDAQ symbol': 'SCHL',
  },
  {
    symbol: 'SCHM',
    'Security Name': 'Schwab US Mid Cap ETF',

    'CQS symbol': 'SCHM',
    'NASDAQ symbol': 'SCHM',
  },
  {
    symbol: 'SCHN',
    'Security Name': 'Schnitzer Steel Industries,    ',

    'NASDAQ symbol': 'SCHN',
  },
  {
    symbol: 'SCHO',
    'Security Name': 'Schwab ShortTerm US Treasury ETF',

    'CQS symbol': 'SCHO',
    'NASDAQ symbol': 'SCHO',
  },
  {
    symbol: 'SCHP',
    'Security Name': 'Schwab US TIPs ETF',

    'CQS symbol': 'SCHP',
    'NASDAQ symbol': 'SCHP',
  },
  {
    symbol: 'SCHQ',
    'Security Name': 'Schwab LongTerm US Treasury ETF',

    'CQS symbol': 'SCHQ',
    'NASDAQ symbol': 'SCHQ',
  },
  {
    symbol: 'SCHR',
    'Security Name': 'Schwab IntermediateTerm US Treasury ETF',

    'CQS symbol': 'SCHR',
    'NASDAQ symbol': 'SCHR',
  },
  {
    symbol: 'SCHV',
    'Security Name': 'Schwab US LargeCap Value ETF',

    'CQS symbol': 'SCHV',
    'NASDAQ symbol': 'SCHV',
  },
  {
    symbol: 'SCHW',
    'Security Name': 'Charles Schwab Corporation (The) ',

    'CQS symbol': 'SCHW',
    'NASDAQ symbol': 'SCHW',
  },
  {
    symbol: 'SCHW$C',
    'Security Name':
      'The Charles Schwab Corporation Depositary Shares each representing 1/40th interest in a share of 6% NonCumulative Perpetual Preferred Stock, Series C',

    'CQS symbol': 'SCHWpC',
    'NASDAQ symbol': 'SCHWC',
  },
  {
    symbol: 'SCHW$D',
    'Security Name':
      'The Charles Schwab Corporation Depositary Shares each representing 1/40th interest in a share of 595% NonCumulative Perpetual Preferred Stock, Series D',

    'CQS symbol': 'SCHWpD',
    'NASDAQ symbol': 'SCHWD',
  },
  {
    symbol: 'SCHX',
    'Security Name': 'Schwab US LargeCap ETF',

    'CQS symbol': 'SCHX',
    'NASDAQ symbol': 'SCHX',
  },
  {
    symbol: 'SCHZ',
    'Security Name': 'Schwab US Aggregate Bond ETF',

    'CQS symbol': 'SCHZ',
    'NASDAQ symbol': 'SCHZ',
  },
  {
    symbol: 'SCI',
    'Security Name': 'Service Corporation International ',

    'CQS symbol': 'SCI',
    'NASDAQ symbol': 'SCI',
  },
  {
    symbol: 'SCJ',
    'Security Name': 'iShares MSCI Japan Sm Cap',

    'CQS symbol': 'SCJ',
    'NASDAQ symbol': 'SCJ',
  },
  {
    symbol: 'SCKT',
    'Security Name': 'Socket Mobile,   ',

    'NASDAQ symbol': 'SCKT',
  },
  {
    symbol: 'SCL',
    'Security Name': 'Stepan Company ',

    'CQS symbol': 'SCL',
    'NASDAQ symbol': 'SCL',
  },
  {
    symbol: 'SCM',
    'Security Name': 'Stellus Capital Investment Corporation ',

    'CQS symbol': 'SCM',
    'NASDAQ symbol': 'SCM',
  },
  {
    symbol: 'SCO',
    'Security Name': 'ProShares UltraShort Bloomberg Crude Oil',

    'CQS symbol': 'SCO',
    'NASDAQ symbol': 'SCO',
  },
  {
    symbol: 'SCOR',
    'Security Name': 'comScore,   ',

    'NASDAQ symbol': 'SCOR',
  },
  {
    symbol: 'SCPE',
    'Security Name': 'SC Health Corporation  Ordinary Shares',

    'CQS symbol': 'SCPE',
    'NASDAQ symbol': 'SCPE',
  },
  {
    symbol: 'SCPEU',
    'Security Name': 'SC Health Corporation Units',

    'CQS symbol': 'SCPEU',
    'NASDAQ symbol': 'SCPE=',
  },
  {
    symbol: 'SCPEW',
    'Security Name': 'SC Health Corporation Warrants',

    'CQS symbol': 'SCPEWS',
    'NASDAQ symbol': 'SCPE+',
  },
  {
    symbol: 'SCPH',
    'Security Name': 'scPharmaceuticals   ',

    'NASDAQ symbol': 'SCPH',
  },
  {
    symbol: 'SCPL',
    'Security Name': 'SciPlay Corporation   ',

    'NASDAQ symbol': 'SCPL',
  },
  {
    symbol: 'SCS',
    'Security Name': 'Steelcase  ',

    'CQS symbol': 'SCS',
    'NASDAQ symbol': 'SCS',
  },
  {
    symbol: 'SCSC',
    'Security Name': 'ScanSource,   ',

    'NASDAQ symbol': 'SCSC',
  },
  {
    symbol: 'SCU',
    'Security Name': 'Sculptor Capital Management,   ',

    'CQS symbol': 'SCU',
    'NASDAQ symbol': 'SCU',
  },
  {
    symbol: 'SCVL',
    'Security Name': 'Shoe Carnival,   ',

    'NASDAQ symbol': 'SCVL',
  },
  {
    symbol: 'SCVX',
    'Security Name': 'SCVX Corp  Ordinary Shares',

    'CQS symbol': 'SCVX',
    'NASDAQ symbol': 'SCVX',
  },
  {
    symbol: 'SCVXU',
    'Security Name':
      'SCVX Corp Units, each consisting of one  ordinary share, $00001 par value per share, and onehalf of one redeemable warrant',

    'CQS symbol': 'SCVXU',
    'NASDAQ symbol': 'SCVX=',
  },
  {
    symbol: 'SCVXW',
    'Security Name':
      'SCVX Corp Redeemable warrants, each whole warrant exercisable for one  ordinary share at an exercise price of $1150',

    'CQS symbol': 'SCVXWS',
    'NASDAQ symbol': 'SCVX+',
  },
  {
    symbol: 'SCWX',
    'Security Name': 'SecureWorks Corp   ',

    'NASDAQ symbol': 'SCWX',
  },
  {
    symbol: 'SCX',
    'Security Name': 'LS Starrett Company (The) ',

    'CQS symbol': 'SCX',
    'NASDAQ symbol': 'SCX',
  },
  {
    symbol: 'SCYX',
    'Security Name': 'SCYNEXIS,   ',

    'NASDAQ symbol': 'SCYX',
  },
  {
    symbol: 'SCZ',
    'Security Name': 'iShares MSCI EAFE SmallCap ETF',

    'NASDAQ symbol': 'SCZ',
  },
  {
    symbol: 'SD',
    'Security Name': 'SandRidge Energy,  ',

    'CQS symbol': 'SD',
    'NASDAQ symbol': 'SD',
  },
  {
    symbol: 'SDC',
    'Security Name': 'SmileDirectClub,   ',

    'NASDAQ symbol': 'SDC',
  },
  {
    symbol: 'SDCI',
    'Security Name': 'USCF SummerHaven Dynamic Commodity Strategy No K1 Fund',

    'CQS symbol': 'SDCI',
    'NASDAQ symbol': 'SDCI',
  },
  {
    symbol: 'SDD',
    'Security Name': 'ProShares UltraShort SmallCap600',

    'CQS symbol': 'SDD',
    'NASDAQ symbol': 'SDD',
  },
  {
    symbol: 'SDEM',
    'Security Name': 'Global X MSCI SuperDividend Emerging Markets ETF',

    'CQS symbol': 'SDEM',
    'NASDAQ symbol': 'SDEM',
  },
  {
    symbol: 'SDG',
    'Security Name': 'iShares MSCI Global Impact ETF',

    'NASDAQ symbol': 'SDG',
  },
  {
    symbol: 'SDGA',
    'Security Name':
      'Impact Shares Sustainable Development Goals Global Equity ETF',

    'CQS symbol': 'SDGA',
    'NASDAQ symbol': 'SDGA',
  },
  {
    symbol: 'SDGR',
    'Security Name': 'Schrodinger,   ',

    'NASDAQ symbol': 'SDGR',
  },
  {
    symbol: 'SDHY',
    'Security Name':
      'PGIM Short Duration High Yield Opportunities Fund Common Shares',

    'CQS symbol': 'SDHY',
    'NASDAQ symbol': 'SDHY',
  },
  {
    symbol: 'SDIV',
    'Security Name': 'Global X SuperDividend ETF',

    'CQS symbol': 'SDIV',
    'NASDAQ symbol': 'SDIV',
  },
  {
    symbol: 'SDOG',
    'Security Name': 'ALPS Sector Dividend Dogs ETF',

    'CQS symbol': 'SDOG',
    'NASDAQ symbol': 'SDOG',
  },
  {
    symbol: 'SDOW',
    'Security Name': 'UltraPro Short Dow30',

    'CQS symbol': 'SDOW',
    'NASDAQ symbol': 'SDOW',
  },
  {
    symbol: 'SDP',
    'Security Name': 'ProShares UltraShort Utilities',

    'CQS symbol': 'SDP',
    'NASDAQ symbol': 'SDP',
  },
  {
    symbol: 'SDPI',
    'Security Name': 'Superior Drilling Products,  ',

    'CQS symbol': 'SDPI',
    'NASDAQ symbol': 'SDPI',
  },
  {
    symbol: 'SDS',
    'Security Name': 'ProShares UltraShort S&P500',

    'CQS symbol': 'SDS',
    'NASDAQ symbol': 'SDS',
  },
  {
    symbol: 'SDVY',
    'Security Name': 'First Trust SMID Cap Rising Dividend Achievers ETF',

    'NASDAQ symbol': 'SDVY',
  },
  {
    symbol: 'SDY',
    'Security Name': 'SPDR S&P Dividend ETF',

    'CQS symbol': 'SDY',
    'NASDAQ symbol': 'SDY',
  },
  {
    symbol: 'SE',
    'Security Name':
      'Sea Limited American Depositary Shares, each representing one  Ordinary Share',

    'CQS symbol': 'SE',
    'NASDAQ symbol': 'SE',
  },
  {
    symbol: 'SEAC',
    'Security Name': 'SeaChange International,   ',

    'NASDAQ symbol': 'SEAC',
  },
  {
    symbol: 'SEAH',
    'Security Name': 'Sports Entertainment Acquisition Corp  ',

    'CQS symbol': 'SEAH',
    'NASDAQ symbol': 'SEAH',
  },
  {
    symbol: 'SEAHU',
    'Security Name':
      'Sports Entertainment Acquisition Corp Units, each consisting of one share of  , and onehalf of one redeemable Warrant',

    'CQS symbol': 'SEAHU',
    'NASDAQ symbol': 'SEAH=',
  },
  {
    symbol: 'SEAHW',
    'Security Name':
      'Sports Entertainment Acquisition Corp Redeemable Warrants, each whole Warrant exercisable for one share of  , each at an exercise price of $1150 per share',

    'CQS symbol': 'SEAHWS',
    'NASDAQ symbol': 'SEAH+',
  },
  {
    symbol: 'SEAS',
    'Security Name': 'SeaWorld Entertainment,  ',

    'CQS symbol': 'SEAS',
    'NASDAQ symbol': 'SEAS',
  },
  {
    symbol: 'SEB',
    'Security Name': 'Seaboard Corporation ',

    'Round Lot Size': '1',

    'CQS symbol': 'SEB',
    'NASDAQ symbol': 'SEB',
  },
  {
    symbol: 'SECO',
    'Security Name': 'Secoo Holding Limited  American Depositary Shares',

    'NASDAQ symbol': 'SECO',
  },
  {
    symbol: 'SECT',
    'Security Name': 'Northern Lights Fund Trust IV Main Sector Rotation ETF',

    'CQS symbol': 'SECT',
    'NASDAQ symbol': 'SECT',
  },
  {
    symbol: 'SEDG',
    'Security Name': 'SolarEdge Technologies,   ',

    'NASDAQ symbol': 'SEDG',
  },
  {
    symbol: 'SEE',
    'Security Name': 'Sealed Air Corporation ',

    'CQS symbol': 'SEE',
    'NASDAQ symbol': 'SEE',
  },
  {
    symbol: 'SEED',
    'Security Name': 'Origin Agritech Limited  ',

    'NASDAQ symbol': 'SEED',
  },
  {
    symbol: 'SEEL',
    'Security Name': 'Seelos Therapeutics,   ',

    'NASDAQ symbol': 'SEEL',
  },
  {
    symbol: 'SEER',
    'Security Name': 'Seer,    ',

    'NASDAQ symbol': 'SEER',
  },
  {
    symbol: 'SEF',
    'Security Name': 'ProShares Short Financials',

    'CQS symbol': 'SEF',
    'NASDAQ symbol': 'SEF',
  },
  {
    symbol: 'SEIC',
    'Security Name': 'SEI Investments Company  ',

    'NASDAQ symbol': 'SEIC',
  },
  {
    symbol: 'SEIX',
    'Security Name': 'Virtus Seix Senior Loan ETF',

    'CQS symbol': 'SEIX',
    'NASDAQ symbol': 'SEIX',
  },
  {
    symbol: 'SELB',
    'Security Name': 'Selecta Biosciences,   ',

    'NASDAQ symbol': 'SELB',
  },
  {
    symbol: 'SELF',
    'Security Name': 'Global Self Storage,   ',

    'NASDAQ symbol': 'SELF',
  },
  {
    symbol: 'SEM',
    'Security Name': 'Select Medical Holdings Corporation ',

    'CQS symbol': 'SEM',
    'NASDAQ symbol': 'SEM',
  },
  {
    symbol: 'SENEA',
    'Security Name': 'Seneca Foods Corp   ',

    'NASDAQ symbol': 'SENEA',
  },
  {
    symbol: 'SENEB',
    'Security Name': 'Seneca Foods Corp  Class B ',

    'NASDAQ symbol': 'SENEB',
  },
  {
    symbol: 'SENS',
    'Security Name': 'Senseonics Holdings,  ',

    'CQS symbol': 'SENS',
    'NASDAQ symbol': 'SENS',
  },
  {
    symbol: 'SEPZ',
    'Security Name':
      'Listed Funds Trust TrueShares Structured Outcome (September) ETF',

    'CQS symbol': 'SEPZ',
    'NASDAQ symbol': 'SEPZ',
  },
  {
    symbol: 'SESN',
    'Security Name': 'Sesen Bio,   ',

    'NASDAQ symbol': 'SESN',
  },
  {
    symbol: 'SF',
    'Security Name': 'Stifel Financial Corporation ',

    'CQS symbol': 'SF',
    'NASDAQ symbol': 'SF',
  },
  {
    symbol: 'SF$A',
    'Security Name':
      'Stifel Financial Corporation Depositary Shares, each representing a 1/1000th interest in a share of 625% NonCumulative Preferred Stock, Series A',

    'CQS symbol': 'SFpA',
    'NASDAQ symbol': 'SFA',
  },
  {
    symbol: 'SF$B',
    'Security Name':
      'Stifel Financial Corporation Depositary Shares, Each Representing 1/1,000th  Interest in a Share of 625% NonCumulative  Preferred Stock, Series B',

    'CQS symbol': 'SFpB',
    'NASDAQ symbol': 'SFB',
  },
  {
    symbol: 'SF$C',
    'Security Name':
      'Stifel Financial Corporation Depositary Shares, Each Representing 1/1,000th Interest in a Share of 6125% Non Cumulative Preferred Stock, Series C',

    'CQS symbol': 'SFpC',
    'NASDAQ symbol': 'SFC',
  },
  {
    symbol: 'SFB',
    'Security Name': 'Stifel Financial Corporation 520% Senior Notes due 2047',

    'CQS symbol': 'SFB',
    'NASDAQ symbol': 'SFB',
  },
  {
    symbol: 'SFBC',
    'Security Name': 'Sound Financial Bancorp,   ',

    'NASDAQ symbol': 'SFBC',
  },
  {
    symbol: 'SFBS',
    'Security Name': 'ServisFirst Bancshares,   ',

    'NASDAQ symbol': 'SFBS',
  },
  {
    symbol: 'SFE',
    'Security Name': 'Safeguard Scientifics,  New ',

    'CQS symbol': 'SFE',
    'NASDAQ symbol': 'SFE',
  },
  {
    symbol: 'SFET',
    'Security Name': 'SafeT Group Ltd  American Depositary Shares',

    'NASDAQ symbol': 'SFET',
  },
  {
    symbol: 'SFHY',
    'Security Name': 'WisdomTree US Short Term High Yield Corporate Bond Fund',

    'CQS symbol': 'SFHY',
    'NASDAQ symbol': 'SFHY',
  },
  {
    symbol: 'SFIG',
    'Security Name': 'WisdomTree US Short Term Corporate Bond Fund',

    'CQS symbol': 'SFIG',
    'NASDAQ symbol': 'SFIG',
  },
  {
    symbol: 'SFIX',
    'Security Name': 'Stitch Fix,    ',

    'NASDAQ symbol': 'SFIX',
  },
  {
    symbol: 'SFL',
    'Security Name': 'SFL Corporation Ltd',

    'CQS symbol': 'SFL',
    'NASDAQ symbol': 'SFL',
  },
  {
    symbol: 'SFM',
    'Security Name': 'Sprouts Farmers Market,   ',

    'NASDAQ symbol': 'SFM',
  },
  {
    symbol: 'SFNC',
    'Security Name': 'Simmons First National Corporation  ',

    'NASDAQ symbol': 'SFNC',
  },
  {
    symbol: 'SFST',
    'Security Name': 'Southern First Bancshares,   ',

    'NASDAQ symbol': 'SFST',
  },
  {
    symbol: 'SFT',
    'Security Name': 'Shift Technologies,    ',

    'NASDAQ symbol': 'SFT',
  },
  {
    symbol: 'SFTTW',
    'Security Name': 'Shift Technologies,   Warrant',

    'NASDAQ symbol': 'SFTTW',
  },
  {
    symbol: 'SFTW',
    'Security Name': 'Osprey Technology Acquisition Corp  ',

    'CQS symbol': 'SFTW',
    'NASDAQ symbol': 'SFTW',
  },
  {
    symbol: 'SFTWU',
    'Security Name':
      'Osprey Technology Acquisition Corp Units, each consisting of one share of   and onehalf of one redeemable Warrant',

    'CQS symbol': 'SFTWU',
    'NASDAQ symbol': 'SFTW=',
  },
  {
    symbol: 'SFTWW',
    'Security Name':
      'Osprey Technology Acquisition Corp Redeemable Warrants, each whole Warrant exercisable for one share of  ',

    'CQS symbol': 'SFTWWS',
    'NASDAQ symbol': 'SFTW+',
  },
  {
    symbol: 'SFUN',
    'Security Name':
      'Fang Holdings Limited American Depositary Shares (Each representing Four  Ordinary Shares, HK$100 par value)',

    'CQS symbol': 'SFUN',
    'NASDAQ symbol': 'SFUN',
  },
  {
    symbol: 'SFY',
    'Security Name': 'SoFi Select 500 ETF',

    'CQS symbol': 'SFY',
    'NASDAQ symbol': 'SFY',
  },
  {
    symbol: 'SFYF',
    'Security Name': 'SoFi 50 ETF',

    'CQS symbol': 'SFYF',
    'NASDAQ symbol': 'SFYF',
  },
  {
    symbol: 'SFYX',
    'Security Name': 'SoFi Next 500 ETF',

    'CQS symbol': 'SFYX',
    'NASDAQ symbol': 'SFYX',
  },
  {
    symbol: 'SG',
    'Security Name': 'Sirius International Insurance Group, Ltd  Common Share',

    'NASDAQ symbol': 'SG',
  },
  {
    symbol: 'SGA',
    'Security Name': 'Saga Communications,    ',

    'NASDAQ symbol': 'SGA',
  },
  {
    symbol: 'SGAMU',
    'Security Name': 'Seaport Global Acquisition Corp  Unit',

    'NASDAQ symbol': 'SGAMU',
  },
  {
    symbol: 'SGBX',
    'Security Name': 'SG Blocks,   ',

    'NASDAQ symbol': 'SGBX',
  },
  {
    symbol: 'SGC',
    'Security Name': 'Superior Group of Companies,   ',

    'NASDAQ symbol': 'SGC',
  },
  {
    symbol: 'SGDJ',
    'Security Name': 'Sprott Junior Gold Miners ETF',

    'CQS symbol': 'SGDJ',
    'NASDAQ symbol': 'SGDJ',
  },
  {
    symbol: 'SGDM',
    'Security Name': 'Sprott Gold Miners ETF',

    'CQS symbol': 'SGDM',
    'NASDAQ symbol': 'SGDM',
  },
  {
    symbol: 'SGEN',
    'Security Name': 'Seagen    ',

    'NASDAQ symbol': 'SGEN',
  },
  {
    symbol: 'SGG',
    'Security Name':
      'iPathA Series B Bloomberg Sugar Subindex Total Return ETN',

    'CQS symbol': 'SGG',
    'NASDAQ symbol': 'SGG',
  },
  {
    symbol: 'SGH',
    'Security Name': 'SMART Global Holdings,   Ordinary Shares',

    'NASDAQ symbol': 'SGH',
  },
  {
    symbol: 'SGLB',
    'Security Name': 'Sigma Labs,   ',

    'NASDAQ symbol': 'SGLB',
  },
  {
    symbol: 'SGLBW',
    'Security Name': 'Sigma Labs,   Warrant',

    'NASDAQ symbol': 'SGLBW',
  },
  {
    symbol: 'SGMA',
    'Security Name': 'SigmaTron International,   ',

    'NASDAQ symbol': 'SGMA',
  },
  {
    symbol: 'SGMO',
    'Security Name': 'Sangamo Therapeutics,   ',

    'NASDAQ symbol': 'SGMO',
  },
  {
    symbol: 'SGMS',
    'Security Name': 'Scientific Games Corp  ',

    'NASDAQ symbol': 'SGMS',
  },
  {
    symbol: 'SGOC',
    'Security Name': 'SGOCO Group, Ltd  Ordinary Shares (Cayman Islands)',

    'NASDAQ symbol': 'SGOC',
  },
  {
    symbol: 'SGOL',
    'Security Name': 'Aberdeen Standard Physical Gold Shares ETF',

    'CQS symbol': 'SGOL',
    'NASDAQ symbol': 'SGOL',
  },
  {
    symbol: 'SGOV',
    'Security Name': 'iShares 03 Month Treasury Bond ETF',

    'CQS symbol': 'SGOV',
    'NASDAQ symbol': 'SGOV',
  },
  {
    symbol: 'SGRP',
    'Security Name': 'SPAR Group,   ',

    'NASDAQ symbol': 'SGRP',
  },
  {
    symbol: 'SGRY',
    'Security Name': 'Surgery Partners,   ',

    'NASDAQ symbol': 'SGRY',
  },
  {
    symbol: 'SGTX',
    'Security Name': 'Sigilon Therapeutics,   ',

    'NASDAQ symbol': 'SGTX',
  },
  {
    symbol: 'SGU',
    'Security Name': 'Star Group LP ',

    'CQS symbol': 'SGU',
    'NASDAQ symbol': 'SGU',
  },
  {
    symbol: 'SH',
    'Security Name': 'ProShares Short S&P500',

    'CQS symbol': 'SH',
    'NASDAQ symbol': 'SH',
  },
  {
    symbol: 'SHAG',
    'Security Name':
      'WisdomTree Yield Enhanced US ShortTerm Aggregate Bond Fund',

    'CQS symbol': 'SHAG',
    'NASDAQ symbol': 'SHAG',
  },
  {
    symbol: 'SHAK',
    'Security Name': 'Shake Shack,   ',

    'CQS symbol': 'SHAK',
    'NASDAQ symbol': 'SHAK',
  },
  {
    symbol: 'SHBI',
    'Security Name': 'Shore Bancshares   ',

    'NASDAQ symbol': 'SHBI',
  },
  {
    symbol: 'SHC',
    'Security Name': 'Sotera Health Company  ',

    'NASDAQ symbol': 'SHC',
  },
  {
    symbol: 'SHE',
    'Security Name': 'SPDR Series Trust SPDR SSGA Gender Diversity Index ETF',

    'CQS symbol': 'SHE',
    'NASDAQ symbol': 'SHE',
  },
  {
    symbol: 'SHEN',
    'Security Name': 'Shenandoah Telecommunications Co  ',

    'NASDAQ symbol': 'SHEN',
  },
  {
    symbol: 'SHG',
    'Security Name':
      'Shinhan Financial Group Co Ltd American Depositary Shares',

    'CQS symbol': 'SHG',
    'NASDAQ symbol': 'SHG',
  },
  {
    symbol: 'SHI',
    'Security Name': 'SINOPEC Shangai Petrochemical Company, Ltd ',

    'CQS symbol': 'SHI',
    'NASDAQ symbol': 'SHI',
  },
  {
    symbol: 'SHIP',
    'Security Name': 'Seanergy Maritime Holdings Corp  ',

    'NASDAQ symbol': 'SHIP',
  },
  {
    symbol: 'SHIPW',
    'Security Name': 'Seanergy Maritime Holdings Corp   Warrants',

    'NASDAQ symbol': 'SHIPW',
  },
  {
    symbol: 'SHIPZ',
    'Security Name': 'Seanergy Maritime Holdings Corp  Class B Warrant',

    'NASDAQ symbol': 'SHIPZ',
  },
  {
    symbol: 'SHLD',
    'Security Name': 'VictoryShares Protect America ETF',

    'NASDAQ symbol': 'SHLD',
  },
  {
    symbol: 'SHLX',
    'Security Name':
      'Shell Midstream Partners, LP Common Units representing Limited Partner Interests',

    'CQS symbol': 'SHLX',
    'NASDAQ symbol': 'SHLX',
  },
  {
    symbol: 'SHM',
    'Security Name':
      'SPDR Nuveen Bloomberg Barclays Short Term Municipal Bond ETF',

    'CQS symbol': 'SHM',
    'NASDAQ symbol': 'SHM',
  },
  {
    symbol: 'SHO',
    'Security Name':
      'Sunstone Hotel Investors,  Sunstone Hotel Investors,  Common Shares',

    'CQS symbol': 'SHO',
    'NASDAQ symbol': 'SHO',
  },
  {
    symbol: 'SHO$E',
    'Security Name':
      'Sunstone Hotel Investors,  6950% Series E Cumulative Redeemable Preferred Stock',

    'CQS symbol': 'SHOpE',
    'NASDAQ symbol': 'SHOE',
  },
  {
    symbol: 'SHO$F',
    'Security Name':
      'Sunstone Hotel Investors,  6450% Series F Cumulative Redeemable Preferred Stock',

    'CQS symbol': 'SHOpF',
    'NASDAQ symbol': 'SHOF',
  },
  {
    symbol: 'SHOO',
    'Security Name': 'Steven Madden, Ltd  ',

    'NASDAQ symbol': 'SHOO',
  },
  {
    symbol: 'SHOP',
    'Security Name': 'Shopify   Subordinate Voting Shares',

    'CQS symbol': 'SHOP',
    'NASDAQ symbol': 'SHOP',
  },
  {
    symbol: 'SHSP',
    'Security Name': 'SharpSpring,   ',

    'NASDAQ symbol': 'SHSP',
  },
  {
    symbol: 'SHV',
    'Security Name': 'iShares Short Treasury Bond ETF',

    'NASDAQ symbol': 'SHV',
  },
  {
    symbol: 'SHW',
    'Security Name': 'SherwinWilliams Company (The) ',

    'CQS symbol': 'SHW',
    'NASDAQ symbol': 'SHW',
  },
  {
    symbol: 'SHY',
    'Security Name': 'iShares 13 Year Treasury Bond ETF',

    'NASDAQ symbol': 'SHY',
  },
  {
    symbol: 'SHYD',
    'Security Name':
      'VanEck Vectors ETF Trust VanEck Vectors Short High Yield Muni ETF',

    'CQS symbol': 'SHYD',
    'NASDAQ symbol': 'SHYD',
  },
  {
    symbol: 'SHYF',
    'Security Name': 'The Shyft Group,   ',

    'NASDAQ symbol': 'SHYF',
  },
  {
    symbol: 'SHYG',
    'Security Name': 'iShares 05 Year High Yield Corporate Bond ETF',

    'CQS symbol': 'SHYG',
    'NASDAQ symbol': 'SHYG',
  },
  {
    symbol: 'SHYL',
    'Security Name': 'Xtrackers Short Duration High Yield Bond ETF',

    'CQS symbol': 'SHYL',
    'NASDAQ symbol': 'SHYL',
  },
  {
    symbol: 'SI',
    'Security Name': 'Silvergate Capital Corporation  ',

    'CQS symbol': 'SI',
    'NASDAQ symbol': 'SI',
  },
  {
    symbol: 'SIBN',
    'Security Name': 'SIBONE,   ',

    'NASDAQ symbol': 'SIBN',
  },
  {
    symbol: 'SIC',
    'Security Name': 'Select Interior Concepts,    ',

    'NASDAQ symbol': 'SIC',
  },
  {
    symbol: 'SID',
    'Security Name': 'Companhia Siderurgica Nacional SA ',

    'CQS symbol': 'SID',
    'NASDAQ symbol': 'SID',
  },
  {
    symbol: 'SIEB',
    'Security Name': 'Siebert Financial Corp  ',

    'NASDAQ symbol': 'SIEB',
  },
  {
    symbol: 'SIEN',
    'Security Name': 'Sientra,   ',

    'NASDAQ symbol': 'SIEN',
  },
  {
    symbol: 'SIF',
    'Security Name': 'SIFCO Industries,  ',

    'CQS symbol': 'SIF',
    'NASDAQ symbol': 'SIF',
  },
  {
    symbol: 'SIFY',
    'Security Name':
      'Sify Technologies Limited  American , each represented by one Equity Share',

    'NASDAQ symbol': 'SIFY',
  },
  {
    symbol: 'SIG',
    'Security Name': 'Signet Jewelers Limited Common Shares',

    'CQS symbol': 'SIG',
    'NASDAQ symbol': 'SIG',
  },
  {
    symbol: 'SIGA',
    'Security Name': 'SIGA Technologies   ',

    'NASDAQ symbol': 'SIGA',
  },
  {
    symbol: 'SIGI',
    'Security Name': 'Selective Insurance Group,   ',

    'NASDAQ symbol': 'SIGI',
  },
  {
    symbol: 'SII',
    'Security Name': 'Sprott  Common Shares',

    'CQS symbol': 'SII',
    'NASDAQ symbol': 'SII',
  },
  {
    symbol: 'SIJ',
    'Security Name': 'ProShares UltraShort Industrials',

    'CQS symbol': 'SIJ',
    'NASDAQ symbol': 'SIJ',
  },
  {
    symbol: 'SIL',
    'Security Name': 'Global X Silver Miners ETF',

    'CQS symbol': 'SIL',
    'NASDAQ symbol': 'SIL',
  },
  {
    symbol: 'SILC',
    'Security Name': 'Silicom Ltd  Ordinary Shares',

    'NASDAQ symbol': 'SILC',
  },
  {
    symbol: 'SILJ',
    'Security Name': 'ETFMG Prime Junior Silver Miners ETF',

    'CQS symbol': 'SILJ',
    'NASDAQ symbol': 'SILJ',
  },
  {
    symbol: 'SILK',
    'Security Name': 'Silk Road Medical,   ',

    'NASDAQ symbol': 'SILK',
  },
  {
    symbol: 'SILV',
    'Security Name': 'SilverCrest Metals  Common Shares',

    'CQS symbol': 'SILV',
    'NASDAQ symbol': 'SILV',
  },
  {
    symbol: 'SIM',
    'Security Name': 'Grupo Simec, SAB de CV American Depositary Shares',

    'CQS symbol': 'SIM',
    'NASDAQ symbol': 'SIM',
  },
  {
    symbol: 'SIMO',
    'Security Name':
      'Silicon Motion Technology Corporation  American Depositary Shares, each representing four ordinary shares',

    'NASDAQ symbol': 'SIMO',
  },
  {
    symbol: 'SIMS',
    'Security Name': 'SPDR S&P Kensho Intelligent Structures ETF ',

    'CQS symbol': 'SIMS',
    'NASDAQ symbol': 'SIMS',
  },
  {
    symbol: 'SINA',
    'Security Name': 'Sina Corporation  Ordinary Shares',

    'NASDAQ symbol': 'SINA',
  },
  {
    symbol: 'SINO',
    'Security Name': 'SinoGlobal Shipping America, Ltd  ',

    'NASDAQ symbol': 'SINO',
  },
  {
    symbol: 'SINT',
    'Security Name': 'SiNtx Technologies,   ',

    'NASDAQ symbol': 'SINT',
  },
  {
    symbol: 'SIOX',
    'Security Name': 'Sio Gene Therapies   ',

    'NASDAQ symbol': 'SIOX',
  },
  {
    symbol: 'SIRI',
    'Security Name': 'Sirius XM Holdings   ',

    'NASDAQ symbol': 'SIRI',
  },
  {
    symbol: 'SITC',
    'Security Name': 'SITE Centers Corp ',

    'CQS symbol': 'SITC',
    'NASDAQ symbol': 'SITC',
  },
  {
    symbol: 'SITC$A',
    'Security Name': 'SITE Centers Corp 6375%  Preferred Shares',

    'CQS symbol': 'SITCpA',
    'NASDAQ symbol': 'SITCA',
  },
  {
    symbol: 'SITC$K',
    'Security Name':
      'SITE Centers Corp DEPOSITARY SH REPSTG 1/20TH PDF CL K % (United States)',

    'CQS symbol': 'SITCpK',
    'NASDAQ symbol': 'SITCK',
  },
  {
    symbol: 'SITE',
    'Security Name': 'SiteOne Landscape Supply,  ',

    'CQS symbol': 'SITE',
    'NASDAQ symbol': 'SITE',
  },
  {
    symbol: 'SITM',
    'Security Name': 'SiTime Corporation  ',

    'NASDAQ symbol': 'SITM',
  },
  {
    symbol: 'SIVB',
    'Security Name': 'SVB Financial Group  ',

    'NASDAQ symbol': 'SIVB',
  },
  {
    symbol: 'SIVBP',
    'Security Name':
      'SVB Financial Group  Depositary Shs each representing a 1/40th interest in a share of 525% FixedRate NonCumulative Perpetual Preferred Stock, Series A',

    'NASDAQ symbol': 'SIVBP',
  },
  {
    symbol: 'SIVR',
    'Security Name': 'Aberdeen Standard Physical Silver Shares ETF',

    'CQS symbol': 'SIVR',
    'NASDAQ symbol': 'SIVR',
  },
  {
    symbol: 'SIX',
    'Security Name': 'Six Flags Entertainment Corporation New ',

    'CQS symbol': 'SIX',
    'NASDAQ symbol': 'SIX',
  },
  {
    symbol: 'SIXA',
    'Security Name': '6 Meridian Mega Cap Equity ETF',

    'CQS symbol': 'SIXA',
    'NASDAQ symbol': 'SIXA',
  },
  {
    symbol: 'SIXH',
    'Security Name': '6 Meridian Hedged EquityIndex Option Strategy ETF',

    'CQS symbol': 'SIXH',
    'NASDAQ symbol': 'SIXH',
  },
  {
    symbol: 'SIXL',
    'Security Name': '6 Meridian Low Beta Equity Strategy ETF',

    'CQS symbol': 'SIXL',
    'NASDAQ symbol': 'SIXL',
  },
  {
    symbol: 'SIXS',
    'Security Name': '6 Meridian Small Cap Equity ETF',

    'CQS symbol': 'SIXS',
    'NASDAQ symbol': 'SIXS',
  },
  {
    symbol: 'SIZE',
    'Security Name': 'iShares MSCI USA Size Factor ETF',

    'CQS symbol': 'SIZE',
    'NASDAQ symbol': 'SIZE',
  },
  {
    symbol: 'SJ',
    'Security Name': 'Scienjoy Holding Corporation  Ordinary Shares',

    'NASDAQ symbol': 'SJ',
  },
  {
    symbol: 'SJB',
    'Security Name': 'ProShares Short High Yield',

    'CQS symbol': 'SJB',
    'NASDAQ symbol': 'SJB',
  },
  {
    symbol: 'SJI',
    'Security Name': 'South Jersey Industries,  ',

    'CQS symbol': 'SJI',
    'NASDAQ symbol': 'SJI',
  },
  {
    symbol: 'SJIJ',
    'Security Name':
      'South Jersey Industries,  5625% Junior Subordinated Notes due 2079',

    'CQS symbol': 'SJIJ',
    'NASDAQ symbol': 'SJIJ',
  },
  {
    symbol: 'SJIU',
    'Security Name': 'South Jersey Industries,  Corporate Units',

    'CQS symbol': 'SJIU',
    'NASDAQ symbol': 'SJIU',
  },
  {
    symbol: 'SJM',
    'Security Name': 'JM Smucker Company (The) New ',

    'CQS symbol': 'SJM',
    'NASDAQ symbol': 'SJM',
  },
  {
    symbol: 'SJNK',
    'Security Name': 'SPDR Bloomberg Barclays Short Term High Yield Bond ETF',

    'CQS symbol': 'SJNK',
    'NASDAQ symbol': 'SJNK',
  },
  {
    symbol: 'SJR',
    'Security Name': 'Shaw Communications  ',

    'CQS symbol': 'SJR',
    'NASDAQ symbol': 'SJR',
  },
  {
    symbol: 'SJT',
    'Security Name': 'San Juan Basin Royalty Trust ',

    'CQS symbol': 'SJT',
    'NASDAQ symbol': 'SJT',
  },
  {
    symbol: 'SJW',
    'Security Name': 'SJW Group  (DE)',

    'CQS symbol': 'SJW',
    'NASDAQ symbol': 'SJW',
  },
  {
    symbol: 'SKF',
    'Security Name': 'ProShares UltraShort Financials',

    'CQS symbol': 'SKF',
    'NASDAQ symbol': 'SKF',
  },
  {
    symbol: 'SKM',
    'Security Name': 'SK Telecom Co, Ltd ',

    'CQS symbol': 'SKM',
    'NASDAQ symbol': 'SKM',
  },
  {
    symbol: 'SKOR',
    'Security Name': 'FlexShares CreditScored US Corporate Bond Index Fund',

    'NASDAQ symbol': 'SKOR',
  },
  {
    symbol: 'SKT',
    'Security Name': 'Tanger Factory Outlet Centers,  ',

    'CQS symbol': 'SKT',
    'NASDAQ symbol': 'SKT',
  },
  {
    symbol: 'SKX',
    'Security Name': 'Skechers USA,  ',

    'CQS symbol': 'SKX',
    'NASDAQ symbol': 'SKX',
  },
  {
    symbol: 'SKY',
    'Security Name': 'Skyline Champion Corporation ',

    'CQS symbol': 'SKY',
    'NASDAQ symbol': 'SKY',
  },
  {
    symbol: 'SKYW',
    'Security Name': 'SkyWest,   ',

    'NASDAQ symbol': 'SKYW',
  },
  {
    symbol: 'SKYY',
    'Security Name': 'First Trust Cloud Computing ETF',

    'NASDAQ symbol': 'SKYY',
  },
  {
    symbol: 'SLAB',
    'Security Name': 'Silicon Laboratories,   ',

    'NASDAQ symbol': 'SLAB',
  },
  {
    symbol: 'SLB',
    'Security Name': 'Schlumberger NV ',

    'CQS symbol': 'SLB',
    'NASDAQ symbol': 'SLB',
  },
  {
    symbol: 'SLCA',
    'Security Name': 'US Silica Holdings,  ',

    'CQS symbol': 'SLCA',
    'NASDAQ symbol': 'SLCA',
  },
  {
    symbol: 'SLCT',
    'Security Name': 'Select Bancorp,   ',

    'NASDAQ symbol': 'SLCT',
  },
  {
    symbol: 'SLDB',
    'Security Name': 'Solid Biosciences   ',

    'NASDAQ symbol': 'SLDB',
  },
  {
    symbol: 'SLF',
    'Security Name': 'Sun Life Financial  ',

    'CQS symbol': 'SLF',
    'NASDAQ symbol': 'SLF',
  },
  {
    symbol: 'SLG',
    'Security Name': 'SL Green Realty Corp ',

    'CQS symbol': 'SLG',
    'NASDAQ symbol': 'SLG',
  },
  {
    symbol: 'SLG$I',
    'Security Name': 'SL Green Realty Corporation Preferred Series I',

    'CQS symbol': 'SLGpI',
    'NASDAQ symbol': 'SLGI',
  },
  {
    symbol: 'SLGG',
    'Security Name': 'Super League Gaming,   ',

    'NASDAQ symbol': 'SLGG',
  },
  {
    symbol: 'SLGL',
    'Security Name': 'SolGel Technologies Ltd  ',

    'NASDAQ symbol': 'SLGL',
  },
  {
    symbol: 'SLGN',
    'Security Name': 'Silgan Holdings   ',

    'NASDAQ symbol': 'SLGN',
  },
  {
    symbol: 'SLM',
    'Security Name': 'SLM Corporation  ',

    'NASDAQ symbol': 'SLM',
  },
  {
    symbol: 'SLMBP',
    'Security Name':
      'SLM Corporation  Floating Rate NonCumulative Preferred Stock, Series B',

    'NASDAQ symbol': 'SLMBP',
  },
  {
    symbol: 'SLN',
    'Security Name': 'Silence Therapeutics Plc  American Depository Share',

    'NASDAQ symbol': 'SLN',
  },
  {
    symbol: 'SLNO',
    'Security Name': 'Soleno Therapeutics,   ',

    'NASDAQ symbol': 'SLNO',
  },
  {
    symbol: 'SLP',
    'Security Name': 'Simulations Plus,   ',

    'NASDAQ symbol': 'SLP',
  },
  {
    symbol: 'SLQD',
    'Security Name': 'iShares 05 Year Investment Grade Corporate Bond ETF',

    'NASDAQ symbol': 'SLQD',
  },
  {
    symbol: 'SLQT',
    'Security Name': 'SelectQuote,  ',

    'CQS symbol': 'SLQT',
    'NASDAQ symbol': 'SLQT',
  },
  {
    symbol: 'SLRC',
    'Security Name': 'Solar Capital Ltd  ',

    'NASDAQ symbol': 'SLRC',
  },
  {
    symbol: 'SLRX',
    'Security Name': 'Salarius Pharmaceuticals,   ',

    'NASDAQ symbol': 'SLRX',
  },
  {
    symbol: 'SLS',
    'Security Name': 'SELLAS Life Sciences Group,    ',

    'NASDAQ symbol': 'SLS',
  },
  {
    symbol: 'SLT',
    'Security Name': 'Pacer Salt High truBeta US Market ETF',

    'CQS symbol': 'SLT',
    'NASDAQ symbol': 'SLT',
  },
  {
    symbol: 'SLV',
    'Security Name': 'iShares Silver Trust',

    'CQS symbol': 'SLV',
    'NASDAQ symbol': 'SLV',
  },
  {
    symbol: 'SLVO',
    'Security Name':
      'Credit Suisse Silver Shares Covered Call Exchange Traded Notes',

    'NASDAQ symbol': 'SLVO',
  },
  {
    symbol: 'SLVP',
    'Security Name': 'iShares MSCI Global Silver Miners Fund',

    'CQS symbol': 'SLVP',
    'NASDAQ symbol': 'SLVP',
  },
  {
    symbol: 'SLX',
    'Security Name': 'VanEck Vectors Steel ETF ',

    'CQS symbol': 'SLX',
    'NASDAQ symbol': 'SLX',
  },
  {
    symbol: 'SLY',
    'Security Name':
      'SPDR S&P 600 Small Cap ETF (based on S&P SmallCap 600 Index  symbol SML)',

    'CQS symbol': 'SLY',
    'NASDAQ symbol': 'SLY',
  },
  {
    symbol: 'SLYG',
    'Security Name':
      'SPDR S&P 600 Small Cap Growth ETF (based on S&P SmallCap 600 Growth Index symbol CGK)',

    'CQS symbol': 'SLYG',
    'NASDAQ symbol': 'SLYG',
  },
  {
    symbol: 'SLYV',
    'Security Name':
      'SPDR S&P 600 Small Cap Value ETF (based on S&P SmallCap Value IndexsymbolCVK',

    'CQS symbol': 'SLYV',
    'NASDAQ symbol': 'SLYV',
  },
  {
    symbol: 'SM',
    'Security Name': 'SM Energy Company ',

    'CQS symbol': 'SM',
    'NASDAQ symbol': 'SM',
  },
  {
    symbol: 'SMAR',
    'Security Name': 'Smartsheet   ',

    'CQS symbol': 'SMAR',
    'NASDAQ symbol': 'SMAR',
  },
  {
    symbol: 'SMB',
    'Security Name': 'VanEck Vectors ETF Trust VanEck Vectors Short Muni ETF',

    'CQS symbol': 'SMB',
    'NASDAQ symbol': 'SMB',
  },
  {
    symbol: 'SMBC',
    'Security Name': 'Southern Missouri Bancorp,   ',

    'NASDAQ symbol': 'SMBC',
  },
  {
    symbol: 'SMBK',
    'Security Name': 'SmartFinancial,   ',

    'NASDAQ symbol': 'SMBK',
  },
  {
    symbol: 'SMCI',
    'Security Name': 'Super Micro Computer,   ',

    'NASDAQ symbol': 'SMCI',
  },
  {
    symbol: 'SMCP',
    'Security Name': 'AlphaMark Actively Managed Small Cap ETF',

    'NASDAQ symbol': 'SMCP',
  },
  {
    symbol: 'SMDD',
    'Security Name': 'UltraPro Short MidCap400',

    'CQS symbol': 'SMDD',
    'NASDAQ symbol': 'SMDD',
  },
  {
    symbol: 'SMDV',
    'Security Name': 'ProShares Russell 2000 Dividend Growers ETF',

    'CQS symbol': 'SMDV',
    'NASDAQ symbol': 'SMDV',
  },
  {
    symbol: 'SMDY',
    'Security Name': 'Syntax Stratified MidCap ETF',

    'CQS symbol': 'SMDY',
    'NASDAQ symbol': 'SMDY',
  },
  {
    symbol: 'SMED',
    'Security Name': 'Sharps Compliance Corp  ',

    'NASDAQ symbol': 'SMED',
  },
  {
    symbol: 'SMEZ',
    'Security Name': 'SPDR EURO STOXX Small Cap ETF',

    'CQS symbol': 'SMEZ',
    'NASDAQ symbol': 'SMEZ',
  },
  {
    symbol: 'SMFG',
    'Security Name':
      'Sumitomo Mitsui Financial Group  Unsponsored American Depositary Shares (Japan)',

    'CQS symbol': 'SMFG',
    'NASDAQ symbol': 'SMFG',
  },
  {
    symbol: 'SMG',
    'Security Name': 'Scotts MiracleGro Company (The) ',

    'CQS symbol': 'SMG',
    'NASDAQ symbol': 'SMG',
  },
  {
    symbol: 'SMH',
    'Security Name': 'VanEck Vectors Semiconductor ETF',

    'NASDAQ symbol': 'SMH',
  },
  {
    symbol: 'SMHB',
    'Security Name':
      'ETRACS Monthly Pay 2x Leveraged Small Cap High Dividend ETN Series B',

    'CQS symbol': 'SMHB',
    'NASDAQ symbol': 'SMHB',
  },
  {
    symbol: 'SMHI',
    'Security Name': 'SEACOR Marine Holdings   ',

    'CQS symbol': 'SMHI',
    'NASDAQ symbol': 'SMHI',
  },
  {
    symbol: 'SMID',
    'Security Name': 'SmithMidland Corporation  ',

    'NASDAQ symbol': 'SMID',
  },
  {
    symbol: 'SMIN',
    'Security Name': 'Ishares MSCI India Small Cap ETF',

    'CQS symbol': 'SMIN',
    'NASDAQ symbol': 'SMIN',
  },
  {
    symbol: 'SMIT',
    'Security Name': 'Schmitt Industries,   ',

    'NASDAQ symbol': 'SMIT',
  },
  {
    symbol: 'SMLF',
    'Security Name': 'iShares MSCI USA SmallCap Multifactor ETF',

    'CQS symbol': 'SMLF',
    'NASDAQ symbol': 'SMLF',
  },
  {
    symbol: 'SMLP',
    'Security Name':
      'Summit Midstream Partners, LP Common Units Representing Limited Partner Interests',

    'CQS symbol': 'SMLP',
    'NASDAQ symbol': 'SMLP',
  },
  {
    symbol: 'SMLV',
    'Security Name': 'SPDR SSGA US Small Cap Low Volatility Index ETF',

    'CQS symbol': 'SMLV',
    'NASDAQ symbol': 'SMLV',
  },
  {
    symbol: 'SMM',
    'Security Name': 'Salient Midstream Common Shares of Beneficial Interest',

    'CQS symbol': 'SMM',
    'NASDAQ symbol': 'SMM',
  },
  {
    symbol: 'SMMC',
    'Security Name': 'South Mountain Merger Corp   ',

    'NASDAQ symbol': 'SMMC',
  },
  {
    symbol: 'SMMCU',
    'Security Name': 'South Mountain Merger Corp  Unit',

    'NASDAQ symbol': 'SMMCU',
  },
  {
    symbol: 'SMMCW',
    'Security Name': 'South Mountain Merger Corp  Warrants',

    'NASDAQ symbol': 'SMMCW',
  },
  {
    symbol: 'SMMD',
    'Security Name': 'iShares Trust iShares Russell 2500 ETF',

    'CQS symbol': 'SMMD',
    'NASDAQ symbol': 'SMMD',
  },
  {
    symbol: 'SMMF',
    'Security Name': 'Summit Financial Group,   ',

    'NASDAQ symbol': 'SMMF',
  },
  {
    symbol: 'SMMT',
    'Security Name': 'Summit Therapeutics    ',

    'NASDAQ symbol': 'SMMT',
  },
  {
    symbol: 'SMMU',
    'Security Name': 'Short Term Municipal Bond Active ExchangeTraded Fund',

    'CQS symbol': 'SMMU',
    'NASDAQ symbol': 'SMMU',
  },
  {
    symbol: 'SMMV',
    'Security Name': 'iShares MSCI USA SmallCap Min Vol Factor ETF',

    'CQS symbol': 'SMMV',
    'NASDAQ symbol': 'SMMV',
  },
  {
    symbol: 'SMN',
    'Security Name': 'ProShares UltraShort Basic Materials',

    'CQS symbol': 'SMN',
    'NASDAQ symbol': 'SMN',
  },
  {
    symbol: 'SMOG',
    'Security Name': 'VanEck Vectors Low Carbon Energy ETF',

    'CQS symbol': 'SMOG',
    'NASDAQ symbol': 'SMOG',
  },
  {
    symbol: 'SMP',
    'Security Name': 'Standard Motor Products,  ',

    'CQS symbol': 'SMP',
    'NASDAQ symbol': 'SMP',
  },
  {
    symbol: 'SMPL',
    'Security Name': 'The Simply Good Foods Company  ',

    'NASDAQ symbol': 'SMPL',
  },
  {
    symbol: 'SMSI',
    'Security Name': 'Smith Micro Software,   ',

    'NASDAQ symbol': 'SMSI',
  },
  {
    symbol: 'SMTC',
    'Security Name': 'Semtech Corporation  ',

    'NASDAQ symbol': 'SMTC',
  },
  {
    symbol: 'SMTI',
    'Security Name': 'Sanara MedTech   ',

    'NASDAQ symbol': 'SMTI',
  },
  {
    symbol: 'SMTS',
    'Security Name': 'Sierra Metals  ',

    'CQS symbol': 'SMTS',
    'NASDAQ symbol': 'SMTS',
  },
  {
    symbol: 'SMTX',
    'Security Name': 'SMTC Corporation  ',

    'NASDAQ symbol': 'SMTX',
  },
  {
    symbol: 'SNA',
    'Security Name': 'SnapOn orporated ',

    'CQS symbol': 'SNA',
    'NASDAQ symbol': 'SNA',
  },
  {
    symbol: 'SNAP',
    'Security Name': 'Snap   ',

    'CQS symbol': 'SNAP',
    'NASDAQ symbol': 'SNAP',
  },
  {
    symbol: 'SNBR',
    'Security Name': 'Sleep Number Corporation  ',

    'NASDAQ symbol': 'SNBR',
  },
  {
    symbol: 'SNCA',
    'Security Name': 'Seneca Biopharma,   ',

    'NASDAQ symbol': 'SNCA',
  },
  {
    symbol: 'SNCR',
    'Security Name': 'Synchronoss Technologies,   ',

    'NASDAQ symbol': 'SNCR',
  },
  {
    symbol: 'SND',
    'Security Name': 'Smart Sand,   ',

    'NASDAQ symbol': 'SND',
  },
  {
    symbol: 'SNDE',
    'Security Name': 'Sundance Energy    ',

    'NASDAQ symbol': 'SNDE',
  },
  {
    symbol: 'SNDL',
    'Security Name': 'Sundial Growers   Common Shares',

    'NASDAQ symbol': 'SNDL',
  },
  {
    symbol: 'SNDR',
    'Security Name': 'Schneider National,  ',

    'CQS symbol': 'SNDR',
    'NASDAQ symbol': 'SNDR',
  },
  {
    symbol: 'SNDX',
    'Security Name': 'Syndax Pharmaceuticals,   ',

    'NASDAQ symbol': 'SNDX',
  },
  {
    symbol: 'SNE',
    'Security Name': 'Sony Corporation ',

    'CQS symbol': 'SNE',
    'NASDAQ symbol': 'SNE',
  },
  {
    symbol: 'SNES',
    'Security Name': 'SenesTech,   ',

    'NASDAQ symbol': 'SNES',
  },
  {
    symbol: 'SNEX',
    'Security Name': 'StoneX Group   ',

    'NASDAQ symbol': 'SNEX',
  },
  {
    symbol: 'SNFCA',
    'Security Name': 'Security National Financial Corporation   ',

    'NASDAQ symbol': 'SNFCA',
  },
  {
    symbol: 'SNGX',
    'Security Name': 'Soligenix,   ',

    'NASDAQ symbol': 'SNGX',
  },
  {
    symbol: 'SNGXW',
    'Security Name': 'Soligenix,   Warrant',

    'NASDAQ symbol': 'SNGXW',
  },
  {
    symbol: 'SNLN',
    'Security Name': 'Highland/iBoxx Senior Loan ETF',

    'NASDAQ symbol': 'SNLN',
  },
  {
    symbol: 'SNMP',
    'Security Name': 'Sanchez Midstream Partners LP ',

    'CQS symbol': 'SNMP',
    'NASDAQ symbol': 'SNMP',
  },
  {
    symbol: 'SNN',
    'Security Name': 'Smith & Nephew SNATS,  ',

    'CQS symbol': 'SNN',
    'NASDAQ symbol': 'SNN',
  },
  {
    symbol: 'SNOA',
    'Security Name': 'Sonoma Pharmaceuticals,   ',

    'NASDAQ symbol': 'SNOA',
  },
  {
    symbol: 'SNOW',
    'Security Name': 'Snowflake   ',

    'CQS symbol': 'SNOW',
    'NASDAQ symbol': 'SNOW',
  },
  {
    symbol: 'SNP',
    'Security Name': 'China Petroleum & Chemical Corporation ',

    'CQS symbol': 'SNP',
    'NASDAQ symbol': 'SNP',
  },
  {
    symbol: 'SNPE',
    'Security Name': 'Xtrackers S&P 500 ESG ETF',

    'CQS symbol': 'SNPE',
    'NASDAQ symbol': 'SNPE',
  },
  {
    symbol: 'SNPR',
    'Security Name': 'Tortoise Acquisition Corp II  Ordinary Shares',

    'CQS symbol': 'SNPR',
    'NASDAQ symbol': 'SNPR',
  },
  {
    symbol: 'SNPRU',
    'Security Name': 'Tortoise Acquisition Corp II Units',

    'CQS symbol': 'SNPRU',
    'NASDAQ symbol': 'SNPR=',
  },
  {
    symbol: 'SNPRW',
    'Security Name':
      'Tortoise Acquisition Corp II Warrants, each whole warrant exercisable for one  ordinary share at an exercise price of $1150 per share',

    'CQS symbol': 'SNPRWS',
    'NASDAQ symbol': 'SNPR+',
  },
  {
    symbol: 'SNPS',
    'Security Name': 'Synopsys,   ',

    'NASDAQ symbol': 'SNPS',
  },
  {
    symbol: 'SNR',
    'Security Name': 'New Senior Investment Group  ',

    'CQS symbol': 'SNR',
    'NASDAQ symbol': 'SNR',
  },
  {
    symbol: 'SNSR',
    'Security Name': 'Global X Internet of Things ETF',

    'NASDAQ symbol': 'SNSR',
  },
  {
    symbol: 'SNSS',
    'Security Name': 'Sunesis Pharmaceuticals,   ',

    'NASDAQ symbol': 'SNSS',
  },
  {
    symbol: 'SNUG',
    'Security Name': 'MerlynAI Tactical Growth & ome ETF',

    'NASDAQ symbol': 'SNUG',
  },
  {
    symbol: 'SNV',
    'Security Name': 'Synovus Financial Corp ',

    'CQS symbol': 'SNV',
    'NASDAQ symbol': 'SNV',
  },
  {
    symbol: 'SNV$D',
    'Security Name':
      'Synovus Financial Corp FixedtoFloating Rate NonCumulative Perpetual Preferred Stock, Series D Liquation Preference $2500 per Share',

    'CQS symbol': 'SNVpD',
    'NASDAQ symbol': 'SNVD',
  },
  {
    symbol: 'SNV$E',
    'Security Name':
      'Synovus Financial Corp 5875% FixedRate Reset NonCumulative Perpetual Preferred Stock, Series E',

    'CQS symbol': 'SNVpE',
    'NASDAQ symbol': 'SNVE',
  },
  {
    symbol: 'SNX',
    'Security Name': 'Synnex Corporation ',

    'CQS symbol': 'SNX',
    'NASDAQ symbol': 'SNX',
  },
  {
    symbol: 'SNY',
    'Security Name': 'Sanofi  American Depositary Shares',

    'NASDAQ symbol': 'SNY',
  },
  {
    symbol: 'SO',
    'Security Name': 'Southern Company (The) ',

    'CQS symbol': 'SO',
    'NASDAQ symbol': 'SO',
  },
  {
    symbol: 'SOAC',
    'Security Name':
      'Sustainable Opportunities Acquisition Corp  Ordinary Shares',

    'CQS symbol': 'SOAC',
    'NASDAQ symbol': 'SOAC',
  },
  {
    symbol: 'SOACU',
    'Security Name':
      'Sustainable Opportunities Acquisition Corp Units, each consisting of one  ordinary share and onehalf of one redeemable warrant',

    'CQS symbol': 'SOACU',
    'NASDAQ symbol': 'SOAC=',
  },
  {
    symbol: 'SOACW',
    'Security Name':
      'Sustainable Opportunities Acquisition Corp Warrants, each whole warrant exercisable for one  ordinary share at an exercise price of $1150',

    'CQS symbol': 'SOACWS',
    'NASDAQ symbol': 'SOAC+',
  },
  {
    symbol: 'SOCL',
    'Security Name': 'Global X Social Media ETF',

    'NASDAQ symbol': 'SOCL',
  },
  {
    symbol: 'SOGO',
    'Security Name':
      'Sogou  American Depositary Shares, each representing one  Ordinary Share',

    'CQS symbol': 'SOGO',
    'NASDAQ symbol': 'SOGO',
  },
  {
    symbol: 'SOHO',
    'Security Name': 'Sotherly Hotels   ',

    'NASDAQ symbol': 'SOHO',
  },
  {
    symbol: 'SOHOB',
    'Security Name':
      'Sotherly Hotels   80% Series B Cumulative Redeemable Perpetual Preferred Stock',

    'NASDAQ symbol': 'SOHOB',
  },
  {
    symbol: 'SOHON',
    'Security Name':
      'Sotherly Hotels   825% Series D Cumulative Redeemable Perpetual Preferred Stock',

    'NASDAQ symbol': 'SOHON',
  },
  {
    symbol: 'SOHOO',
    'Security Name':
      'Sotherly Hotels   7875% Series C Cumulative Redeemable Perpetual Preferred Stock',

    'NASDAQ symbol': 'SOHOO',
  },
  {
    symbol: 'SOHU',
    'Security Name': 'Sohucom Limited   American Depositary Shares',

    'NASDAQ symbol': 'SOHU',
  },
  {
    symbol: 'SOI',
    'Security Name': 'Solaris Oilfield Infrastructure,   ',

    'CQS symbol': 'SOI',
    'NASDAQ symbol': 'SOI',
  },
  {
    symbol: 'SOJB',
    'Security Name':
      'Southern Company (The) Series 2016A 525% Junior Subordinated Notes due October 1, 2076',

    'CQS symbol': 'SOJB',
    'NASDAQ symbol': 'SOJB',
  },
  {
    symbol: 'SOJC',
    'Security Name':
      'Southern Company (The) Series 2017B 525% Junior Subordinated Notes due December 1, 2077',

    'CQS symbol': 'SOJC',
    'NASDAQ symbol': 'SOJC',
  },
  {
    symbol: 'SOJD',
    'Security Name':
      'Southern Company (The) Series 2020A 495% Junior Subordinated Notes due January 30, 2080',

    'CQS symbol': 'SOJD',
    'NASDAQ symbol': 'SOJD',
  },
  {
    symbol: 'SOJE',
    'Security Name':
      'Southern Company (The) Series 2020C 420% Junior Subordinated Notes due October 15, 2060',

    'CQS symbol': 'SOJE',
    'NASDAQ symbol': 'SOJE',
  },
  {
    symbol: 'SOL',
    'Security Name':
      'Renesola Ltd American Depsitary Shares (Each representing 10 shares)',

    'CQS symbol': 'SOL',
    'NASDAQ symbol': 'SOL',
  },
  {
    symbol: 'SOLN',
    'Security Name': 'Southern Company (The) 2019 Series A Corporate Units',

    'CQS symbol': 'SOLN',
    'NASDAQ symbol': 'SOLN',
  },
  {
    symbol: 'SOLO',
    'Security Name': 'Electrameccanica Vehicles Corp Ltd  ',

    'NASDAQ symbol': 'SOLO',
  },
  {
    symbol: 'SOLOW',
    'Security Name': 'Electrameccanica Vehicles Corp Ltd  Warrants',

    'NASDAQ symbol': 'SOLOW',
  },
  {
    symbol: 'SOLY',
    'Security Name': 'Soliton,   ',

    'NASDAQ symbol': 'SOLY',
  },
  {
    symbol: 'SON',
    'Security Name': 'Sonoco Products Company ',

    'CQS symbol': 'SON',
    'NASDAQ symbol': 'SON',
  },
  {
    symbol: 'SONA',
    'Security Name': 'Southern National Bancorp of Virginia,   ',

    'NASDAQ symbol': 'SONA',
  },
  {
    symbol: 'SONM',
    'Security Name': 'Sonim Technologies,   ',

    'NASDAQ symbol': 'SONM',
  },
  {
    symbol: 'SONN',
    'Security Name': 'Sonnet BioTherapeutics Holdings,   ',

    'NASDAQ symbol': 'SONN',
  },
  {
    symbol: 'SONO',
    'Security Name': 'Sonos,   ',

    'NASDAQ symbol': 'SONO',
  },
  {
    symbol: 'SOR',
    'Security Name': 'Source Capital,  ',

    'CQS symbol': 'SOR',
    'NASDAQ symbol': 'SOR',
  },
  {
    symbol: 'SOS',
    'Security Name': 'SOS Limited American Depositary Shares',

    'CQS symbol': 'SOS',
    'NASDAQ symbol': 'SOS',
  },
  {
    symbol: 'SOVB',
    'Security Name': 'Cambria Sovereign Bond ETF',

    'CQS symbol': 'SOVB',
    'NASDAQ symbol': 'SOVB',
  },
  {
    symbol: 'SOXL',
    'Security Name': 'Direxion Daily Semiconductor Bull 3x Shares',

    'CQS symbol': 'SOXL',
    'NASDAQ symbol': 'SOXL',
  },
  {
    symbol: 'SOXS',
    'Security Name': 'Direxion Daily Semiconductor Bear 3x Shares',

    'CQS symbol': 'SOXS',
    'NASDAQ symbol': 'SOXS',
  },
  {
    symbol: 'SOXX',
    'Security Name': 'iShares PHLX SOX Semiconductor Sector Index Fund',

    'NASDAQ symbol': 'SOXX',
  },
  {
    symbol: 'SOYB',
    'Security Name': 'Teucrium Soybean Fund ETV',

    'CQS symbol': 'SOYB',
    'NASDAQ symbol': 'SOYB',
  },
  {
    symbol: 'SP',
    'Security Name': 'SP Plus Corporation  ',

    'NASDAQ symbol': 'SP',
  },
  {
    symbol: 'SPAB',
    'Security Name': 'SPDR Portfolio Aggregate Bond ETF',

    'CQS symbol': 'SPAB',
    'NASDAQ symbol': 'SPAB',
  },
  {
    symbol: 'SPAK',
    'Security Name': 'Defiance Next Gen SPAC Derived ETF',

    'CQS symbol': 'SPAK',
    'NASDAQ symbol': 'SPAK',
  },
  {
    symbol: 'SPB',
    'Security Name': 'Spectrum Brands Holdings,  ',

    'CQS symbol': 'SPB',
    'NASDAQ symbol': 'SPB',
  },
  {
    symbol: 'SPBO',
    'Security Name': 'SPDR Portfolio Corporate Bond ETF',

    'CQS symbol': 'SPBO',
    'NASDAQ symbol': 'SPBO',
  },
  {
    symbol: 'SPCB',
    'Security Name': 'SuperCom, Ltd  Ordinary Shares',

    'NASDAQ symbol': 'SPCB',
  },
  {
    symbol: 'SPCE',
    'Security Name': 'Virgin Galactic Holdings,  ',

    'CQS symbol': 'SPCE',
    'NASDAQ symbol': 'SPCE',
  },
  {
    symbol: 'SPD',
    'Security Name':
      'Simplify Exchange Traded Funds Simplify US Equity PLUS Downside Convexity ETF',

    'CQS symbol': 'SPD',
    'NASDAQ symbol': 'SPD',
  },
  {
    symbol: 'SPDN',
    'Security Name': 'Direxion Daily S&P 500 Bear 1X Shares',

    'CQS symbol': 'SPDN',
    'NASDAQ symbol': 'SPDN',
  },
  {
    symbol: 'SPDV',
    'Security Name': 'AAM S&P 500 High Dividend Value ETF',

    'CQS symbol': 'SPDV',
    'NASDAQ symbol': 'SPDV',
  },
  {
    symbol: 'SPDW',
    'Security Name': 'SPDR Portfolio Developed World exUS ETF',

    'CQS symbol': 'SPDW',
    'NASDAQ symbol': 'SPDW',
  },
  {
    symbol: 'SPE',
    'Security Name': 'Special Opportunities Fund,  ',

    'CQS symbol': 'SPE',
    'NASDAQ symbol': 'SPE',
  },
  {
    symbol: 'SPE$B',
    'Security Name':
      'Special Opportunities Fund  350% Convertible Preferred Stock, Series B',

    'CQS symbol': 'SPEpB',
    'NASDAQ symbol': 'SPEB',
  },
  {
    symbol: 'SPEM',
    'Security Name':
      'SPDR Index Shares Fund SPDR Portfolio Emerging Markets ETF',

    'CQS symbol': 'SPEM',
    'NASDAQ symbol': 'SPEM',
  },
  {
    symbol: 'SPEU',
    'Security Name': 'SPDR Portfolio Europe ETF',

    'CQS symbol': 'SPEU',
    'NASDAQ symbol': 'SPEU',
  },
  {
    symbol: 'SPFF',
    'Security Name': 'Global X Superome Preferred ETF',

    'CQS symbol': 'SPFF',
    'NASDAQ symbol': 'SPFF',
  },
  {
    symbol: 'SPFI',
    'Security Name': 'South Plains Financial,   ',

    'NASDAQ symbol': 'SPFI',
  },
  {
    symbol: 'SPFRU',
    'Security Name':
      'Jaws Spitfire Acquisition Corporation Units, each consisting of one  ordinary share, and onefourth of one redeemable warrant',

    'CQS symbol': 'SPFRU',
    'NASDAQ symbol': 'SPFR=',
  },
  {
    symbol: 'SPG',
    'Security Name': 'Simon Property Group,  ',

    'CQS symbol': 'SPG',
    'NASDAQ symbol': 'SPG',
  },
  {
    symbol: 'SPG$J',
    'Security Name':
      'Simon Property Group,  Simon Property Group 8 3/8% Series J Cumulative Redeemable Preferred Stock',

    'CQS symbol': 'SPGpJ',
    'NASDAQ symbol': 'SPGJ',
  },
  {
    symbol: 'SPGI',
    'Security Name': 'S&P Global  ',

    'CQS symbol': 'SPGI',
    'NASDAQ symbol': 'SPGI',
  },
  {
    symbol: 'SPGM',
    'Security Name': 'SPDR Portfolio MSCI Global Stock Market ETF',

    'CQS symbol': 'SPGM',
    'NASDAQ symbol': 'SPGM',
  },
  {
    symbol: 'SPGP',
    'Security Name': 'Invesco S&P 500 GARP ETF',

    'CQS symbol': 'SPGP',
    'NASDAQ symbol': 'SPGP',
  },
  {
    symbol: 'SPH',
    'Security Name': 'Suburban Propane Partners, LP ',

    'CQS symbol': 'SPH',
    'NASDAQ symbol': 'SPH',
  },
  {
    symbol: 'SPHB',
    'Security Name': 'Invesco S&P 500 High Beta ETF',

    'CQS symbol': 'SPHB',
    'NASDAQ symbol': 'SPHB',
  },
  {
    symbol: 'SPHD',
    'Security Name': 'Invesco S&P 500 High Dividend Low Volatility ETF',

    'CQS symbol': 'SPHD',
    'NASDAQ symbol': 'SPHD',
  },
  {
    symbol: 'SPHQ',
    'Security Name': 'Invesco S&P 500 Quality ETF',

    'CQS symbol': 'SPHQ',
    'NASDAQ symbol': 'SPHQ',
  },
  {
    symbol: 'SPHY',
    'Security Name': 'SPDR Portfolio High Yield Bond ETF',

    'CQS symbol': 'SPHY',
    'NASDAQ symbol': 'SPHY',
  },
  {
    symbol: 'SPI',
    'Security Name': 'SPI Energy Co, Ltd  Ordinary Shares',

    'NASDAQ symbol': 'SPI',
  },
  {
    symbol: 'SPIB',
    'Security Name': 'SPDR Portfolio Intermediate Term Corporate Bond ETF',

    'CQS symbol': 'SPIB',
    'NASDAQ symbol': 'SPIB',
  },
  {
    symbol: 'SPIP',
    'Security Name': 'SPDR Portfolio TIPS ETF',

    'CQS symbol': 'SPIP',
    'NASDAQ symbol': 'SPIP',
  },
  {
    symbol: 'SPKE',
    'Security Name': 'Spark Energy,    ',

    'NASDAQ symbol': 'SPKE',
  },
  {
    symbol: 'SPKEP',
    'Security Name':
      'Spark Energy,   875% Series A FixedtoFloating Rate Cumulative Redeemable Perpetual Preferred Stock',

    'NASDAQ symbol': 'SPKEP',
  },
  {
    symbol: 'SPLB',
    'Security Name': 'SPDR Portfolio Long Term Corporate Bond ETF',

    'CQS symbol': 'SPLB',
    'NASDAQ symbol': 'SPLB',
  },
  {
    symbol: 'SPLG',
    'Security Name': 'SPDR Portfolio S&P 500 ETF',

    'CQS symbol': 'SPLG',
    'NASDAQ symbol': 'SPLG',
  },
  {
    symbol: 'SPLK',
    'Security Name': 'Splunk   ',

    'NASDAQ symbol': 'SPLK',
  },
  {
    symbol: 'SPLP',
    'Security Name': 'Steel Partners Holdings LP LTD PARTNERSHIP UNIT',

    'CQS symbol': 'SPLP',
    'NASDAQ symbol': 'SPLP',
  },
  {
    symbol: 'SPLP$A',
    'Security Name':
      'Steel Partners Holdings LP 60% Series A Preferred Units, no par value',

    'CQS symbol': 'SPLPpA',
    'NASDAQ symbol': 'SPLPA',
  },
  {
    symbol: 'SPLV',
    'Security Name': 'Invesco S&P 500 Low Volatility ETF',

    'CQS symbol': 'SPLV',
    'NASDAQ symbol': 'SPLV',
  },
  {
    symbol: 'SPMB',
    'Security Name': 'SPDR Portfolio Mortgage Backed Bond ETF',

    'CQS symbol': 'SPMB',
    'NASDAQ symbol': 'SPMB',
  },
  {
    symbol: 'SPMD',
    'Security Name': 'SPDR Portfolio S&P 400 Mid Cap ETF  ',

    'CQS symbol': 'SPMD',
    'NASDAQ symbol': 'SPMD',
  },
  {
    symbol: 'SPMO',
    'Security Name': 'Invesco S&P 500 Momentum ETF',

    'CQS symbol': 'SPMO',
    'NASDAQ symbol': 'SPMO',
  },
  {
    symbol: 'SPMV',
    'Security Name': 'Invesco S&P 500 Minimum Variance ETF',

    'CQS symbol': 'SPMV',
    'NASDAQ symbol': 'SPMV',
  },
  {
    symbol: 'SPNE',
    'Security Name': 'SeaSpine Holdings Corporation  ',

    'NASDAQ symbol': 'SPNE',
  },
  {
    symbol: 'SPNS',
    'Security Name': 'Sapiens International Corporation NV  Common Shares',

    'NASDAQ symbol': 'SPNS',
  },
  {
    symbol: 'SPNVU',
    'Security Name':
      'Supernova Partners Acquisition Company,  Units, each consisting of one share of   and onethird of one warrant',

    'CQS symbol': 'SPNVU',
    'NASDAQ symbol': 'SPNV=',
  },
  {
    symbol: 'SPOK',
    'Security Name': 'Spok Holdings,   ',

    'NASDAQ symbol': 'SPOK',
  },
  {
    symbol: 'SPOT',
    'Security Name': 'Spotify Technology SA Ordinary Shares',

    'CQS symbol': 'SPOT',
    'NASDAQ symbol': 'SPOT',
  },
  {
    symbol: 'SPPI',
    'Security Name': 'Spectrum Pharmaceuticals,   ',

    'NASDAQ symbol': 'SPPI',
  },
  {
    symbol: 'SPPP',
    'Security Name': 'Sprott Physical Platinum and Palladium Trust',

    'CQS symbol': 'SPPP',
    'NASDAQ symbol': 'SPPP',
  },
  {
    symbol: 'SPQQ',
    'Security Name': 'Siren Large Cap Blend Index ETF',

    'NASDAQ symbol': 'SPQQ',
  },
  {
    symbol: 'SPR',
    'Security Name': 'Spirit Aerosystems Holdings,  ',

    'CQS symbol': 'SPR',
    'NASDAQ symbol': 'SPR',
  },
  {
    symbol: 'SPRB',
    'Security Name': 'Spruce Biosciences,   ',

    'NASDAQ symbol': 'SPRB',
  },
  {
    symbol: 'SPRO',
    'Security Name': 'Spero Therapeutics,   ',

    'NASDAQ symbol': 'SPRO',
  },
  {
    symbol: 'SPRQU',
    'Security Name': 'Spartan Acquisition Corp II Units',

    'CQS symbol': 'SPRQU',
    'NASDAQ symbol': 'SPRQ=',
  },
  {
    symbol: 'SPRT',
    'Security Name': 'Supportcom,   ',

    'NASDAQ symbol': 'SPRT',
  },
  {
    symbol: 'SPSB',
    'Security Name': 'SPDR Portfolio Short Term Corporate Bond ETF',

    'CQS symbol': 'SPSB',
    'NASDAQ symbol': 'SPSB',
  },
  {
    symbol: 'SPSC',
    'Security Name': 'SPS Commerce,   ',

    'NASDAQ symbol': 'SPSC',
  },
  {
    symbol: 'SPSK',
    'Security Name': 'Tidal ETF Trust SP Funds Dow Jones Global Sukuk ETF',

    'CQS symbol': 'SPSK',
    'NASDAQ symbol': 'SPSK',
  },
  {
    symbol: 'SPSM',
    'Security Name': 'SPDR Portfolio S&P 600 Small Cap ETF',

    'CQS symbol': 'SPSM',
    'NASDAQ symbol': 'SPSM',
  },
  {
    symbol: 'SPT',
    'Security Name': 'Sprout Social,    ',

    'NASDAQ symbol': 'SPT',
  },
  {
    symbol: 'SPTI',
    'Security Name': 'SPDR Portfolio Intermediate Term Treasury ETF',

    'CQS symbol': 'SPTI',
    'NASDAQ symbol': 'SPTI',
  },
  {
    symbol: 'SPTL',
    'Security Name': 'SPDR Portfolio Long Term Treasury ETF',

    'CQS symbol': 'SPTL',
    'NASDAQ symbol': 'SPTL',
  },
  {
    symbol: 'SPTM',
    'Security Name': 'SPDR Portfolio S&P 1500 Composite Stock Market ETF',

    'CQS symbol': 'SPTM',
    'NASDAQ symbol': 'SPTM',
  },
  {
    symbol: 'SPTN',
    'Security Name': 'SpartanNash Company  ',

    'NASDAQ symbol': 'SPTN',
  },
  {
    symbol: 'SPTS',
    'Security Name': 'SPDR Portfolio Short Term Treasury ETF',

    'CQS symbol': 'SPTS',
    'NASDAQ symbol': 'SPTS',
  },
  {
    symbol: 'SPUC',
    'Security Name':
      'Simplify Exchange Traded Funds Simplify US Equity PLUS Upside Convexity ETF',

    'CQS symbol': 'SPUC',
    'NASDAQ symbol': 'SPUC',
  },
  {
    symbol: 'SPUS',
    'Security Name': 'SP Funds S&P 500 Sharia Industry Exclusions ETF',

    'CQS symbol': 'SPUS',
    'NASDAQ symbol': 'SPUS',
  },
  {
    symbol: 'SPUU',
    'Security Name': 'Direxion Daily S&P 500 Bull 2X Shares',

    'CQS symbol': 'SPUU',
    'NASDAQ symbol': 'SPUU',
  },
  {
    symbol: 'SPVM',
    'Security Name': 'Invesco S&P 500 Value with Momentum ETF',

    'CQS symbol': 'SPVM',
    'NASDAQ symbol': 'SPVM',
  },
  {
    symbol: 'SPVU',
    'Security Name': 'Invesco S&P 500 Enhanced Value ETF',

    'CQS symbol': 'SPVU',
    'NASDAQ symbol': 'SPVU',
  },
  {
    symbol: 'SPWH',
    'Security Name': "Sportsman's Warehouse Holdings,   ",

    'NASDAQ symbol': 'SPWH',
  },
  {
    symbol: 'SPWR',
    'Security Name': 'SunPower Corporation  ',

    'NASDAQ symbol': 'SPWR',
  },
  {
    symbol: 'SPXB',
    'Security Name': 'ProShares S&P 500 Bond ETF',

    'CQS symbol': 'SPXB',
    'NASDAQ symbol': 'SPXB',
  },
  {
    symbol: 'SPXC',
    'Security Name': 'SPX Corporation ',

    'CQS symbol': 'SPXC',
    'NASDAQ symbol': 'SPXC',
  },
  {
    symbol: 'SPXE',
    'Security Name': 'ProShares S&P 500 ExEnergy ETF',

    'CQS symbol': 'SPXE',
    'NASDAQ symbol': 'SPXE',
  },
  {
    symbol: 'SPXL',
    'Security Name': 'Direxion Daily S&P 500 Bull 3X Shares',

    'CQS symbol': 'SPXL',
    'NASDAQ symbol': 'SPXL',
  },
  {
    symbol: 'SPXN',
    'Security Name': 'ProShares S&P 500 ExFinancials ETF',

    'CQS symbol': 'SPXN',
    'NASDAQ symbol': 'SPXN',
  },
  {
    symbol: 'SPXS',
    'Security Name': 'Direxion Daily S&P 500 Bear 3X',

    'CQS symbol': 'SPXS',
    'NASDAQ symbol': 'SPXS',
  },
  {
    symbol: 'SPXT',
    'Security Name': 'ProShares S&P 500 ExTechnology ETF',

    'CQS symbol': 'SPXT',
    'NASDAQ symbol': 'SPXT',
  },
  {
    symbol: 'SPXU',
    'Security Name': 'ProShares UltraPro Short S&P500',

    'CQS symbol': 'SPXU',
    'NASDAQ symbol': 'SPXU',
  },
  {
    symbol: 'SPXV',
    'Security Name': 'ProShares S&P 500 ExHealth Care ETF',

    'CQS symbol': 'SPXV',
    'NASDAQ symbol': 'SPXV',
  },
  {
    symbol: 'SPXX',
    'Security Name': 'Nuveen S&P 500 Dynamic Overwrite Fund',

    'CQS symbol': 'SPXX',
    'NASDAQ symbol': 'SPXX',
  },
  {
    symbol: 'SPY',
    'Security Name': 'SPDR S&P 500',

    'CQS symbol': 'SPY',
    'NASDAQ symbol': 'SPY',
  },
  {
    symbol: 'SPYC',
    'Security Name':
      'Simplify Exchange Traded Funds Simplify US Equity PLUS Convexity ETF',

    'CQS symbol': 'SPYC',
    'NASDAQ symbol': 'SPYC',
  },
  {
    symbol: 'SPYD',
    'Security Name':
      'SPDR Series Trust SPDR Portfolio S&P 500 High Dividend ETF',

    'CQS symbol': 'SPYD',
    'NASDAQ symbol': 'SPYD',
  },
  {
    symbol: 'SPYG',
    'Security Name': 'SPDR Series Trust SPDR Portfolio S&P 500 Growth ETF',

    'CQS symbol': 'SPYG',
    'NASDAQ symbol': 'SPYG',
  },
  {
    symbol: 'SPYV',
    'Security Name': 'SPDR Series Trust SPDR Portfolio S&P 500 Value ETF',

    'CQS symbol': 'SPYV',
    'NASDAQ symbol': 'SPYV',
  },
  {
    symbol: 'SPYX',
    'Security Name': 'SPDR S&P 500 Fossil Fuel Reserves Free ETF',

    'CQS symbol': 'SPYX',
    'NASDAQ symbol': 'SPYX',
  },
  {
    symbol: 'SQ',
    'Security Name': 'Square,   ',

    'CQS symbol': 'SQ',
    'NASDAQ symbol': 'SQ',
  },
  {
    symbol: 'SQBG',
    'Security Name': 'Sequential Brands Group,   ',

    'NASDAQ symbol': 'SQBG',
  },
  {
    symbol: 'SQEW',
    'Security Name': 'LeaderShares Equity Skew ETF',

    'CQS symbol': 'SQEW',
    'NASDAQ symbol': 'SQEW',
  },
  {
    symbol: 'SQFT',
    'Security Name': 'Presidio Property Trust,    ',

    'NASDAQ symbol': 'SQFT',
  },
  {
    symbol: 'SQLV',
    'Security Name': 'Legg Mason SmallCap Quality Value ETF',

    'NASDAQ symbol': 'SQLV',
  },
  {
    symbol: 'SQM',
    'Security Name': 'Sociedad Quimica y Minera SA ',

    'CQS symbol': 'SQM',
    'NASDAQ symbol': 'SQM',
  },
  {
    symbol: 'SQNS',
    'Security Name': 'Sequans Communications SA American Depositary Shares',

    'CQS symbol': 'SQNS',
    'NASDAQ symbol': 'SQNS',
  },
  {
    symbol: 'SQQQ',
    'Security Name': 'ProShares UltraPro Short QQQ',

    'NASDAQ symbol': 'SQQQ',
  },
  {
    symbol: 'SQZ',
    'Security Name': 'SQZ Biotechnologies Company ',

    'CQS symbol': 'SQZ',
    'NASDAQ symbol': 'SQZ',
  },
  {
    symbol: 'SR',
    'Security Name': 'Spire  ',

    'CQS symbol': 'SR',
    'NASDAQ symbol': 'SR',
  },
  {
    symbol: 'SR$A',
    'Security Name':
      'Spire  Depositary Shares, each representing a 1/1,000th interest in a share of 590% Series A Cumulative Redeemable Perpetual Preferred Stock',

    'CQS symbol': 'SRpA',
    'NASDAQ symbol': 'SRA',
  },
  {
    symbol: 'SRAC',
    'Security Name': 'Stable Road Acquisition Corp   ',

    'NASDAQ symbol': 'SRAC',
  },
  {
    symbol: 'SRACU',
    'Security Name': 'Stable Road Acquisition Corp  Unit',

    'NASDAQ symbol': 'SRACU',
  },
  {
    symbol: 'SRACW',
    'Security Name': 'Stable Road Acquisition Corp  Warrant',

    'NASDAQ symbol': 'SRACW',
  },
  {
    symbol: 'SRAX',
    'Security Name': 'SRAX,    ',

    'NASDAQ symbol': 'SRAX',
  },
  {
    symbol: 'SRC',
    'Security Name': 'Spirit Realty Capital,  ',

    'CQS symbol': 'SRC',
    'NASDAQ symbol': 'SRC',
  },
  {
    symbol: 'SRC$A',
    'Security Name':
      'Spirit Realty Capital,  6000% Series A Cumulative Redeemable Preferred Stock',

    'CQS symbol': 'SRCpA',
    'NASDAQ symbol': 'SRCA',
  },
  {
    symbol: 'SRCE',
    'Security Name': '1st Source Corporation  ',

    'NASDAQ symbol': 'SRCE',
  },
  {
    symbol: 'SRCL',
    'Security Name': 'Stericycle,   ',

    'NASDAQ symbol': 'SRCL',
  },
  {
    symbol: 'SRDX',
    'Security Name': 'Surmodics,   ',

    'NASDAQ symbol': 'SRDX',
  },
  {
    symbol: 'SRE',
    'Security Name': 'Sempra Energy ',

    'CQS symbol': 'SRE',
    'NASDAQ symbol': 'SRE',
  },
  {
    symbol: 'SRE$A',
    'Security Name':
      'Sempra Energy 6% Mandatory Convertible Preferred Stock, Series A',

    'CQS symbol': 'SREpA',
    'NASDAQ symbol': 'SREA',
  },
  {
    symbol: 'SRE$B',
    'Security Name':
      'Sempra Energy 675% Mandatory Convertible Preferred Stock, Series B',

    'CQS symbol': 'SREpB',
    'NASDAQ symbol': 'SREB',
  },
  {
    symbol: 'SREA',
    'Security Name': 'Sempra Energy 5750% Junior Subordinated Notes due 2079',

    'CQS symbol': 'SREA',
    'NASDAQ symbol': 'SREA',
  },
  {
    symbol: 'SRET',
    'Security Name': 'Global X SuperDividend REIT ETF',

    'NASDAQ symbol': 'SRET',
  },
  {
    symbol: 'SREV',
    'Security Name': 'ServiceSource International,   ',

    'NASDAQ symbol': 'SREV',
  },
  {
    symbol: 'SRG',
    'Security Name': 'Seritage Growth Properties  ',

    'CQS symbol': 'SRG',
    'NASDAQ symbol': 'SRG',
  },
  {
    symbol: 'SRG$A',
    'Security Name':
      'Seritage Growth Properties 700% Series A Cumulative Redeemable Preferred Shares of Beneficial Interest',

    'CQS symbol': 'SRGpA',
    'NASDAQ symbol': 'SRGA',
  },
  {
    symbol: 'SRGA',
    'Security Name': 'Surgalign Holdings,   ',

    'NASDAQ symbol': 'SRGA',
  },
  {
    symbol: 'SRI',
    'Security Name': 'Stoneridge,  ',

    'CQS symbol': 'SRI',
    'NASDAQ symbol': 'SRI',
  },
  {
    symbol: 'SRL',
    'Security Name': 'Scully Royalty Ltd',

    'CQS symbol': 'SRL',
    'NASDAQ symbol': 'SRL',
  },
  {
    symbol: 'SRLN',
    'Security Name': 'SPDR Blackstone GSO Senior Loan ETF',

    'CQS symbol': 'SRLN',
    'NASDAQ symbol': 'SRLN',
  },
  {
    symbol: 'SRLP',
    'Security Name':
      'Sprague Resources LP Common Units representing Limited Partner Interests',

    'CQS symbol': 'SRLP',
    'NASDAQ symbol': 'SRLP',
  },
  {
    symbol: 'SRNE',
    'Security Name': 'Sorrento Therapeutics,   ',

    'NASDAQ symbol': 'SRNE',
  },
  {
    symbol: 'SRPT',
    'Security Name': 'Sarepta Therapeutics,   ',

    'NASDAQ symbol': 'SRPT',
  },
  {
    symbol: 'SRRA',
    'Security Name': 'Sierra Oncology,   ',

    'NASDAQ symbol': 'SRRA',
  },
  {
    symbol: 'SRRK',
    'Security Name': 'Scholar Rock Holding Corporation  ',

    'NASDAQ symbol': 'SRRK',
  },
  {
    symbol: 'SRS',
    'Security Name': 'ProShares UltraShort Real Estate',

    'CQS symbol': 'SRS',
    'NASDAQ symbol': 'SRS',
  },
  {
    symbol: 'SRSAU',
    'Security Name': 'Sarissa Capital Acquisition Corp  Unit',

    'NASDAQ symbol': 'SRSAU',
  },
  {
    symbol: 'SRT',
    'Security Name': 'StarTek,  ',

    'CQS symbol': 'SRT',
    'NASDAQ symbol': 'SRT',
  },
  {
    symbol: 'SRTS',
    'Security Name': 'Sensus Healthcare,   ',

    'NASDAQ symbol': 'SRTS',
  },
  {
    symbol: 'SRTY',
    'Security Name': 'ProShares UltraPro Short Russell2000',

    'CQS symbol': 'SRTY',
    'NASDAQ symbol': 'SRTY',
  },
  {
    symbol: 'SRV',
    'Security Name': 'Cushing MLP & Infrastructure Total Return Fund',

    'CQS symbol': 'SRV',
    'NASDAQ symbol': 'SRV',
  },
  {
    symbol: 'SRVR',
    'Security Name':
      'Pacer Benchmark Data & Infrastructure Real Estate SCTR ETF',

    'CQS symbol': 'SRVR',
    'NASDAQ symbol': 'SRVR',
  },
  {
    symbol: 'SSB',
    'Security Name': 'South State Corporation  ',

    'NASDAQ symbol': 'SSB',
  },
  {
    symbol: 'SSBI',
    'Security Name': 'Summit State Bank  ',

    'NASDAQ symbol': 'SSBI',
  },
  {
    symbol: 'SSD',
    'Security Name': 'Simpson Manufacturing Company,  ',

    'CQS symbol': 'SSD',
    'NASDAQ symbol': 'SSD',
  },
  {
    symbol: 'SSG',
    'Security Name': 'ProShares UltraShort Semiconductors',

    'CQS symbol': 'SSG',
    'NASDAQ symbol': 'SSG',
  },
  {
    symbol: 'SSKN',
    'Security Name': 'Strata Skin Sciences,   ',

    'NASDAQ symbol': 'SSKN',
  },
  {
    symbol: 'SSL',
    'Security Name': 'Sasol Ltd American Depositary Shares',

    'CQS symbol': 'SSL',
    'NASDAQ symbol': 'SSL',
  },
  {
    symbol: 'SSLY',
    'Security Name': 'Syntax Stratified SmallCap ETF',

    'CQS symbol': 'SSLY',
    'NASDAQ symbol': 'SSLY',
  },
  {
    symbol: 'SSNC',
    'Security Name': 'SS&C Technologies Holdings,   ',

    'NASDAQ symbol': 'SSNC',
  },
  {
    symbol: 'SSNT',
    'Security Name': 'SilverSun Technologies,   ',

    'NASDAQ symbol': 'SSNT',
  },
  {
    symbol: 'SSO',
    'Security Name': 'ProShares Ultra S&P500',

    'CQS symbol': 'SSO',
    'NASDAQ symbol': 'SSO',
  },
  {
    symbol: 'SSP',
    'Security Name': 'EW Scripps Company (The)   ',

    'NASDAQ symbol': 'SSP',
  },
  {
    symbol: 'SSPK',
    'Security Name': 'Silver Spike Acquisition Corp   Ordinary Shares',

    'NASDAQ symbol': 'SSPK',
  },
  {
    symbol: 'SSPKU',
    'Security Name': 'Silver Spike Acquisition Corp  Units',

    'NASDAQ symbol': 'SSPKU',
  },
  {
    symbol: 'SSPKW',
    'Security Name': 'Silver Spike Acquisition Corp  Warrants',

    'NASDAQ symbol': 'SSPKW',
  },
  {
    symbol: 'SSPY',
    'Security Name': 'Syntax Stratified LargeCap ETF',

    'CQS symbol': 'SSPY',
    'NASDAQ symbol': 'SSPY',
  },
  {
    symbol: 'SSRM',
    'Security Name': 'SSR Mining   ',

    'NASDAQ symbol': 'SSRM',
  },
  {
    symbol: 'SSSS',
    'Security Name': 'SuRo Capital Corp  ',

    'NASDAQ symbol': 'SSSS',
  },
  {
    symbol: 'SSTI',
    'Security Name': 'ShotSpotter,   ',

    'NASDAQ symbol': 'SSTI',
  },
  {
    symbol: 'SSTK',
    'Security Name': 'Shutterstock,  ',

    'CQS symbol': 'SSTK',
    'NASDAQ symbol': 'SSTK',
  },
  {
    symbol: 'SSUS',
    'Security Name': 'Day Hagan/Ned Davis Research Smart Sector ETF',

    'CQS symbol': 'SSUS',
    'NASDAQ symbol': 'SSUS',
  },
  {
    symbol: 'SSY',
    'Security Name': 'SunLink Health Systems,  ',

    'CQS symbol': 'SSY',
    'NASDAQ symbol': 'SSY',
  },
  {
    symbol: 'SSYS',
    'Security Name': 'Stratasys, Ltd  ',

    'NASDAQ symbol': 'SSYS',
  },
  {
    symbol: 'ST',
    'Security Name': 'Sensata Technologies Holding plc Ordinary Shares',

    'CQS symbol': 'ST',
    'NASDAQ symbol': 'ST',
  },
  {
    symbol: 'STAA',
    'Security Name': 'STAAR Surgical Company  ',

    'NASDAQ symbol': 'STAA',
  },
  {
    symbol: 'STAF',
    'Security Name': 'Staffing 360 Solutions,   ',

    'NASDAQ symbol': 'STAF',
  },
  {
    symbol: 'STAG',
    'Security Name': 'Stag Industrial,  ',

    'CQS symbol': 'STAG',
    'NASDAQ symbol': 'STAG',
  },
  {
    symbol: 'STAG$C',
    'Security Name':
      'Stag Industrial,  6875% Series C Cumulative Redeemable Preferred Stock',

    'CQS symbol': 'STAGpC',
    'NASDAQ symbol': 'STAGC',
  },
  {
    symbol: 'STAR',
    'Security Name': 'iStar  ',

    'CQS symbol': 'STAR',
    'NASDAQ symbol': 'STAR',
  },
  {
    symbol: 'STAR$D',
    'Security Name': 'iStar  Series D Cumulative Redeemable Preferred Stock',

    'CQS symbol': 'STARpD',
    'NASDAQ symbol': 'STARD',
  },
  {
    symbol: 'STAR$G',
    'Security Name': 'iStar  Series G Cumulative Redeemable Preferred Stock',

    'CQS symbol': 'STARpG',
    'NASDAQ symbol': 'STARG',
  },
  {
    symbol: 'STAR$I',
    'Security Name': 'iStar  Series I Cumulative Redeemable Preferred Stock',

    'CQS symbol': 'STARpI',
    'NASDAQ symbol': 'STARI',
  },
  {
    symbol: 'STAY',
    'Security Name': 'Extended Stay America,   Paired Shares',

    'NASDAQ symbol': 'STAY',
  },
  {
    symbol: 'STBA',
    'Security Name': 'S&T Bancorp,   ',

    'NASDAQ symbol': 'STBA',
  },
  {
    symbol: 'STC',
    'Security Name': 'Stewart Information Services Corporation ',

    'CQS symbol': 'STC',
    'NASDAQ symbol': 'STC',
  },
  {
    symbol: 'STCN',
    'Security Name': 'Steel Connect,   ',

    'NASDAQ symbol': 'STCN',
  },
  {
    symbol: 'STE',
    'Security Name': 'STERIS plc (Ireland) Ordinary Shares',

    'CQS symbol': 'STE',
    'NASDAQ symbol': 'STE',
  },
  {
    symbol: 'STEP',
    'Security Name': 'StepStone Group    ',

    'NASDAQ symbol': 'STEP',
  },
  {
    symbol: 'STFC',
    'Security Name': 'State Auto Financial Corporation  ',

    'NASDAQ symbol': 'STFC',
  },
  {
    symbol: 'STG',
    'Security Name':
      'Sunlands Technology Group American Depositary Shares, representing  ordinary shares',

    'CQS symbol': 'STG',
    'NASDAQ symbol': 'STG',
  },
  {
    symbol: 'STICU',
    'Security Name':
      'Northern Star Acquisition Corp Units, each consisting of one share of  and onethird ofA one Warrant',

    'CQS symbol': 'STICU',
    'NASDAQ symbol': 'STIC=',
  },
  {
    symbol: 'STIM',
    'Security Name': 'Neuronetics,   ',

    'NASDAQ symbol': 'STIM',
  },
  {
    symbol: 'STIP',
    'Security Name': 'iShares 05 Year TIPS Bond ETF',

    'CQS symbol': 'STIP',
    'NASDAQ symbol': 'STIP',
  },
  {
    symbol: 'STK',
    'Security Name': 'Columbia Seligman Premium Technology Growth Fund ',

    'CQS symbol': 'STK',
    'NASDAQ symbol': 'STK',
  },
  {
    symbol: 'STKL',
    'Security Name': 'SunOpta,   ',

    'NASDAQ symbol': 'STKL',
  },
  {
    symbol: 'STKS',
    'Security Name': 'The ONE Group Hospitality,   ',

    'NASDAQ symbol': 'STKS',
  },
  {
    symbol: 'STL',
    'Security Name': 'Sterling Bancorp',

    'CQS symbol': 'STL',
    'NASDAQ symbol': 'STL',
  },
  {
    symbol: 'STL$A',
    'Security Name':
      'Sterling Bancorp Depositary Shares each representing ownership of a 1/40th interest in a share of 650% NonCumulative, Perpetual Preferred Stock, Series A',

    'CQS symbol': 'STLpA',
    'NASDAQ symbol': 'STLA',
  },
  {
    symbol: 'STLC',
    'Security Name': 'iShares Factors US Blend Style ETF',

    'CQS symbol': 'STLC',
    'NASDAQ symbol': 'STLC',
  },
  {
    symbol: 'STLD',
    'Security Name': 'Steel Dynamics,   ',

    'NASDAQ symbol': 'STLD',
  },
  {
    symbol: 'STLG',
    'Security Name': 'iShares Factors US Growth Style ETF',

    'CQS symbol': 'STLG',
    'NASDAQ symbol': 'STLG',
  },
  {
    symbol: 'STLV',
    'Security Name': 'iShares Factors US Value Style ETF',

    'CQS symbol': 'STLV',
    'NASDAQ symbol': 'STLV',
  },
  {
    symbol: 'STM',
    'Security Name': 'STMicroelectronics NV ',

    'CQS symbol': 'STM',
    'NASDAQ symbol': 'STM',
  },
  {
    symbol: 'STMB',
    'Security Name': 'iShares Factors US Mid Blend Style ETF',

    'CQS symbol': 'STMB',
    'NASDAQ symbol': 'STMB',
  },
  {
    symbol: 'STMP',
    'Security Name': 'Stampscom   ',

    'NASDAQ symbol': 'STMP',
  },
  {
    symbol: 'STN',
    'Security Name': 'Stantec  ',

    'CQS symbol': 'STN',
    'NASDAQ symbol': 'STN',
  },
  {
    symbol: 'STND',
    'Security Name': 'Standard AVB Financial Corp  ',

    'NASDAQ symbol': 'STND',
  },
  {
    symbol: 'STNE',
    'Security Name': 'StoneCo Ltd   Common Share',

    'NASDAQ symbol': 'STNE',
  },
  {
    symbol: 'STNG',
    'Security Name': 'Scorpio Tankers  Common Shares',

    'CQS symbol': 'STNG',
    'NASDAQ symbol': 'STNG',
  },
  {
    symbol: 'STOK',
    'Security Name': 'Stoke Therapeutics,   ',

    'NASDAQ symbol': 'STOK',
  },
  {
    symbol: 'STON',
    'Security Name': 'StoneMor  ',

    'CQS symbol': 'STON',
    'NASDAQ symbol': 'STON',
  },
  {
    symbol: 'STOR',
    'Security Name': 'STORE Capital Corporation ',

    'CQS symbol': 'STOR',
    'NASDAQ symbol': 'STOR',
  },
  {
    symbol: 'STOT',
    'Security Name': 'SPDR DoubleLine Short Duration Total Return Tactical ETF',

    'CQS symbol': 'STOT',
    'NASDAQ symbol': 'STOT',
  },
  {
    symbol: 'STPK',
    'Security Name': 'Star Peak Energy Transition Corp  ',

    'CQS symbol': 'STPK',
    'NASDAQ symbol': 'STPK',
  },
  {
    symbol: 'STPKU',
    'Security Name':
      'Star Peak Energy Transition Corp Units, each consisting of one share of  , and onethird of one redeemable warrant',

    'CQS symbol': 'STPKU',
    'NASDAQ symbol': 'STPK=',
  },
  {
    symbol: 'STPKW',
    'Security Name':
      'Star Peak Energy Transition Corp Warrants, each whole warrant exercisable for one share of   at an exercise price of $1150',

    'CQS symbol': 'STPKWS',
    'NASDAQ symbol': 'STPK+',
  },
  {
    symbol: 'STPZ',
    'Security Name': 'PIMCO 15 Year US TIPS Index ExchangeTraded Fund',

    'CQS symbol': 'STPZ',
    'NASDAQ symbol': 'STPZ',
  },
  {
    symbol: 'STRA',
    'Security Name': 'Strategic Education,   ',

    'NASDAQ symbol': 'STRA',
  },
  {
    symbol: 'STRL',
    'Security Name': 'Sterling Construction Company   ',

    'NASDAQ symbol': 'STRL',
  },
  {
    symbol: 'STRM',
    'Security Name': 'Streamline Health Solutions,   ',

    'NASDAQ symbol': 'STRM',
  },
  {
    symbol: 'STRO',
    'Security Name': 'Sutro Biopharma,   ',

    'NASDAQ symbol': 'STRO',
  },
  {
    symbol: 'STRS',
    'Security Name': 'Stratus Properties   ',

    'NASDAQ symbol': 'STRS',
  },
  {
    symbol: 'STRT',
    'Security Name': 'STRATTEC SECURITY CORPORATION  ',

    'NASDAQ symbol': 'STRT',
  },
  {
    symbol: 'STSA',
    'Security Name': 'Satsuma Pharmaceuticals,   ',

    'NASDAQ symbol': 'STSA',
  },
  {
    symbol: 'STSB',
    'Security Name': 'iShares Factors US Small Blend Style ETF',

    'CQS symbol': 'STSB',
    'NASDAQ symbol': 'STSB',
  },
  {
    symbol: 'STT',
    'Security Name': 'State Street Corporation ',

    'CQS symbol': 'STT',
    'NASDAQ symbol': 'STT',
  },
  {
    symbol: 'STT$D',
    'Security Name':
      'State Street Corporation Depositary Shares representing 1/4000th Perpetual Preferred Series D',

    'CQS symbol': 'STTpD',
    'NASDAQ symbol': 'STTD',
  },
  {
    symbol: 'STT$G',
    'Security Name':
      'State Street Corporation Depositary shares, each representing a 1/4,000th ownership interest in a share of FixedtoFloating Rate NonCumulative',

    'CQS symbol': 'STTpG',
    'NASDAQ symbol': 'STTG',
  },
  {
    symbol: 'STTK',
    'Security Name': 'Shattuck Labs,   ',

    'NASDAQ symbol': 'STTK',
  },
  {
    symbol: 'STWD',
    'Security Name': 'STARWOOD PROPERTY TRUST,  Starwood Property Trust ',

    'CQS symbol': 'STWD',
    'NASDAQ symbol': 'STWD',
  },
  {
    symbol: 'STWO',
    'Security Name': 'ACON S2 Acquisition Corp   ordinary shares',

    'NASDAQ symbol': 'STWO',
  },
  {
    symbol: 'STWOU',
    'Security Name': 'ACON S2 Acquisition Corp  Unit',

    'NASDAQ symbol': 'STWOU',
  },
  {
    symbol: 'STWOW',
    'Security Name': 'ACON S2 Acquisition Corp  Warrant',

    'NASDAQ symbol': 'STWOW',
  },
  {
    symbol: 'STX',
    'Security Name': 'Seagate Technology PLC  Ordinary Shares (Ireland)',

    'NASDAQ symbol': 'STX',
  },
  {
    symbol: 'STXB',
    'Security Name': 'Spirit of Texas Bancshares,   ',

    'NASDAQ symbol': 'STXB',
  },
  {
    symbol: 'STXS',
    'Security Name': 'Stereotaxis,  ',

    'CQS symbol': 'STXS',
    'NASDAQ symbol': 'STXS',
  },
  {
    symbol: 'STZ',
    'Security Name': 'Constellation Brands,  ',

    'CQS symbol': 'STZ',
    'NASDAQ symbol': 'STZ',
  },
  {
    symbol: 'STZB',
    'Security Name': 'Constellation Brands,  ',

    'CQS symbol': 'STZB',
    'NASDAQ symbol': 'STZB',
  },
  {
    symbol: 'SU',
    'Security Name': 'Suncor Energy   ',

    'CQS symbol': 'SU',
    'NASDAQ symbol': 'SU',
  },
  {
    symbol: 'SUB',
    'Security Name': 'iShares ShortTerm National Muni Bond ETF',

    'CQS symbol': 'SUB',
    'NASDAQ symbol': 'SUB',
  },
  {
    symbol: 'SUI',
    'Security Name': 'Sun Communities,  ',

    'CQS symbol': 'SUI',
    'NASDAQ symbol': 'SUI',
  },
  {
    symbol: 'SULR',
    'Security Name': 'SmartETFs Sustainable Energy II ETF',

    'CQS symbol': 'SULR',
    'NASDAQ symbol': 'SULR',
  },
  {
    symbol: 'SUM',
    'Security Name': 'Summit Materials,   ',

    'CQS symbol': 'SUM',
    'NASDAQ symbol': 'SUM',
  },
  {
    symbol: 'SUMO',
    'Security Name': 'Sumo Logic,   ',

    'NASDAQ symbol': 'SUMO',
  },
  {
    symbol: 'SUMR',
    'Security Name': 'Summer Infant,   ',

    'NASDAQ symbol': 'SUMR',
  },
  {
    symbol: 'SUN',
    'Security Name':
      'Sunoco LP Common Units representing limited partner interests',

    'CQS symbol': 'SUN',
    'NASDAQ symbol': 'SUN',
  },
  {
    symbol: 'SUNS',
    'Security Name': 'Solar Senior Capital Ltd  ',

    'NASDAQ symbol': 'SUNS',
  },
  {
    symbol: 'SUNW',
    'Security Name': 'Sunworks,   ',

    'NASDAQ symbol': 'SUNW',
  },
  {
    symbol: 'SUP',
    'Security Name': 'Superior Industries International,   (DE)',

    'CQS symbol': 'SUP',
    'NASDAQ symbol': 'SUP',
  },
  {
    symbol: 'SUPN',
    'Security Name': 'Supernus Pharmaceuticals,   ',

    'NASDAQ symbol': 'SUPN',
  },
  {
    symbol: 'SUPV',
    'Security Name':
      'Grupo Supervielle SA American Depositary Shares each Representing five Class B shares',

    'CQS symbol': 'SUPV',
    'NASDAQ symbol': 'SUPV',
  },
  {
    symbol: 'SURF',
    'Security Name': 'Surface Oncology,   ',

    'NASDAQ symbol': 'SURF',
  },
  {
    symbol: 'SUSA',
    'Security Name': 'iShares MSCI USA ESG Select ETF',

    'CQS symbol': 'SUSA',
    'NASDAQ symbol': 'SUSA',
  },
  {
    symbol: 'SUSB',
    'Security Name': 'iShares ESG Aware 15 Year USD Corporate Bond ETF',

    'NASDAQ symbol': 'SUSB',
  },
  {
    symbol: 'SUSC',
    'Security Name': 'iShares ESG Aware USD Corporate Bond ETF',

    'NASDAQ symbol': 'SUSC',
  },
  {
    symbol: 'SUSL',
    'Security Name': 'iShares ESG MSCI USA Leaders ETF',

    'NASDAQ symbol': 'SUSL',
  },
  {
    symbol: 'SUZ',
    'Security Name':
      'Suzano SA American Depositary Shares (each representing One Ordinary Share)',

    'CQS symbol': 'SUZ',
    'NASDAQ symbol': 'SUZ',
  },
  {
    symbol: 'SVA',
    'Security Name': 'Sinovac Biotech, Ltd  Ordinary Shares (Antigua/Barbudo)',

    'NASDAQ symbol': 'SVA',
  },
  {
    symbol: 'SVAC',
    'Security Name': 'Starboard Value Acquisition Corp   ',

    'NASDAQ symbol': 'SVAC',
  },
  {
    symbol: 'SVACU',
    'Security Name': 'Starboard Value Acquisition Corp  Unit',

    'NASDAQ symbol': 'SVACU',
  },
  {
    symbol: 'SVACW',
    'Security Name': 'Starboard Value Acquisition Corp  Warrant',

    'NASDAQ symbol': 'SVACW',
  },
  {
    symbol: 'SVAL',
    'Security Name': 'iShares US Small Cap Value Factor ETF',

    'CQS symbol': 'SVAL',
    'NASDAQ symbol': 'SVAL',
  },
  {
    symbol: 'SVBI',
    'Security Name': 'Severn Bancorp   ',

    'NASDAQ symbol': 'SVBI',
  },
  {
    symbol: 'SVC',
    'Security Name': 'Service Properties Trust  Shares of Beneficial Interest',

    'NASDAQ symbol': 'SVC',
  },
  {
    symbol: 'SVM',
    'Security Name': 'Silvercorp Metals  Common Shares',

    'CQS symbol': 'SVM',
    'NASDAQ symbol': 'SVM',
  },
  {
    symbol: 'SVMK',
    'Security Name': 'SVMK   ',

    'NASDAQ symbol': 'SVMK',
  },
  {
    symbol: 'SVRA',
    'Security Name': 'Savara,   ',

    'NASDAQ symbol': 'SVRA',
  },
  {
    symbol: 'SVSVU',
    'Security Name': 'Spring Valley Acquisition Corp  Unit',

    'NASDAQ symbol': 'SVSVU',
  },
  {
    symbol: 'SVT',
    'Security Name': 'Servotronics,  ',

    'CQS symbol': 'SVT',
    'NASDAQ symbol': 'SVT',
  },
  {
    symbol: 'SVVC',
    'Security Name': 'Firsthand Technology Value Fund,   ',

    'NASDAQ symbol': 'SVVC',
  },
  {
    symbol: 'SVXY',
    'Security Name': 'ProShares Short VIX Short Term Futures ETF',

    'CQS symbol': 'SVXY',
    'NASDAQ symbol': 'SVXY',
  },
  {
    symbol: 'SWAN',
    'Security Name':
      'Amplify ETF Trust Amplify BlackSwan Growth & Treasury Core ETF',

    'CQS symbol': 'SWAN',
    'NASDAQ symbol': 'SWAN',
  },
  {
    symbol: 'SWAV',
    'Security Name': 'ShockWave Medical,   ',

    'NASDAQ symbol': 'SWAV',
  },
  {
    symbol: 'SWBI',
    'Security Name': 'Smith & Wesson Brands,   ',

    'NASDAQ symbol': 'SWBI',
  },
  {
    symbol: 'SWCH',
    'Security Name': 'Switch,   ',

    'CQS symbol': 'SWCH',
    'NASDAQ symbol': 'SWCH',
  },
  {
    symbol: 'SWI',
    'Security Name': 'SolarWinds Corporation ',

    'CQS symbol': 'SWI',
    'NASDAQ symbol': 'SWI',
  },
  {
    symbol: 'SWIR',
    'Security Name': 'Sierra Wireless,   ',

    'NASDAQ symbol': 'SWIR',
  },
  {
    symbol: 'SWK',
    'Security Name': 'Stanley Black & Decker,  ',

    'CQS symbol': 'SWK',
    'NASDAQ symbol': 'SWK',
  },
  {
    symbol: 'SWKH',
    'Security Name': 'SWK Holdings Corporation  ',

    'NASDAQ symbol': 'SWKH',
  },
  {
    symbol: 'SWKS',
    'Security Name': 'Skyworks Solutions,   ',

    'NASDAQ symbol': 'SWKS',
  },
  {
    symbol: 'SWM',
    'Security Name': 'SchweitzerMauduit International,  ',

    'CQS symbol': 'SWM',
    'NASDAQ symbol': 'SWM',
  },
  {
    symbol: 'SWN',
    'Security Name': 'Southwestern Energy Company ',

    'CQS symbol': 'SWN',
    'NASDAQ symbol': 'SWN',
  },
  {
    symbol: 'SWT',
    'Security Name': 'Stanley Black & Decker,  Corporate Unit',

    'CQS symbol': 'SWT',
    'NASDAQ symbol': 'SWT',
  },
  {
    symbol: 'SWTX',
    'Security Name': 'SpringWorks Therapeutics,   ',

    'NASDAQ symbol': 'SWTX',
  },
  {
    symbol: 'SWX',
    'Security Name': 'Southwest Gas Holdings,   (DE)',

    'CQS symbol': 'SWX',
    'NASDAQ symbol': 'SWX',
  },
  {
    symbol: 'SWZ',
    'Security Name': 'Swiss Helvetia Fund,  (The) ',

    'CQS symbol': 'SWZ',
    'NASDAQ symbol': 'SWZ',
  },
  {
    symbol: 'SXC',
    'Security Name': 'SunCoke Energy,  ',

    'CQS symbol': 'SXC',
    'NASDAQ symbol': 'SXC',
  },
  {
    symbol: 'SXI',
    'Security Name': 'Standex International Corporation ',

    'CQS symbol': 'SXI',
    'NASDAQ symbol': 'SXI',
  },
  {
    symbol: 'SXT',
    'Security Name': 'Sensient Technologies Corporation ',

    'CQS symbol': 'SXT',
    'NASDAQ symbol': 'SXT',
  },
  {
    symbol: 'SXTC',
    'Security Name': 'China SXT Pharmaceuticals,   ',

    'NASDAQ symbol': 'SXTC',
  },
  {
    symbol: 'SY',
    'Security Name': 'SoYoung International   American ',

    'NASDAQ symbol': 'SY',
  },
  {
    symbol: 'SYBT',
    'Security Name': 'Stock Yards Bancorp,   ',

    'NASDAQ symbol': 'SYBT',
  },
  {
    symbol: 'SYBX',
    'Security Name': 'Synlogic,   ',

    'NASDAQ symbol': 'SYBX',
  },
  {
    symbol: 'SYE',
    'Security Name': 'SPDR MFS Systematic Core Equity ETF',

    'CQS symbol': 'SYE',
    'NASDAQ symbol': 'SYE',
  },
  {
    symbol: 'SYF',
    'Security Name': 'Synchrony Financial ',

    'CQS symbol': 'SYF',
    'NASDAQ symbol': 'SYF',
  },
  {
    symbol: 'SYF$A',
    'Security Name':
      'Synchrony Financial Depositary Shares, each Representing a 1/40th Interest in a Share of 5625% Fixed Rate NonCumulative Perpetual Preferred Stock, Series A',

    'CQS symbol': 'SYFpA',
    'NASDAQ symbol': 'SYFA',
  },
  {
    symbol: 'SYG',
    'Security Name': 'SPDR MFS Systematic Growth Equity ETF',

    'CQS symbol': 'SYG',
    'NASDAQ symbol': 'SYG',
  },
  {
    symbol: 'SYK',
    'Security Name': 'Stryker Corporation ',

    'CQS symbol': 'SYK',
    'NASDAQ symbol': 'SYK',
  },
  {
    symbol: 'SYKE',
    'Security Name': 'Sykes Enterprises, orporated  ',

    'NASDAQ symbol': 'SYKE',
  },
  {
    symbol: 'SYLD',
    'Security Name': 'Cambria Shareholder Yield ETF',

    'CQS symbol': 'SYLD',
    'NASDAQ symbol': 'SYLD',
  },
  {
    symbol: 'SYN',
    'Security Name': 'Synthetic Biologics,  ',

    'CQS symbol': 'SYN',
    'NASDAQ symbol': 'SYN',
  },
  {
    symbol: 'SYNA',
    'Security Name': 'Synaptics orporated  ',

    'NASDAQ symbol': 'SYNA',
  },
  {
    symbol: 'SYNC',
    'Security Name': 'Synacor,   ',

    'NASDAQ symbol': 'SYNC',
  },
  {
    symbol: 'SYNH',
    'Security Name': 'Syneos Health,    ',

    'NASDAQ symbol': 'SYNH',
  },
  {
    symbol: 'SYNL',
    'Security Name': 'Synalloy Corporation  ',

    'NASDAQ symbol': 'SYNL',
  },
  {
    symbol: 'SYPR',
    'Security Name': 'Sypris Solutions,   ',

    'NASDAQ symbol': 'SYPR',
  },
  {
    symbol: 'SYRS',
    'Security Name': 'Syros Pharmaceuticals,   ',

    'NASDAQ symbol': 'SYRS',
  },
  {
    symbol: 'SYTA',
    'Security Name': 'Siyata Mobile,   Common Shares',

    'NASDAQ symbol': 'SYTA',
  },
  {
    symbol: 'SYTAW',
    'Security Name': 'Siyata Mobile,   Warrant',

    'NASDAQ symbol': 'SYTAW',
  },
  {
    symbol: 'SYV',
    'Security Name': 'SPDR MFS Systematic Value Equity ETF',

    'CQS symbol': 'SYV',
    'NASDAQ symbol': 'SYV',
  },
  {
    symbol: 'SYX',
    'Security Name': 'Systemax  ',

    'CQS symbol': 'SYX',
    'NASDAQ symbol': 'SYX',
  },
  {
    symbol: 'SYY',
    'Security Name': 'Sysco Corporation ',

    'CQS symbol': 'SYY',
    'NASDAQ symbol': 'SYY',
  },
  {
    symbol: 'SZC',
    'Security Name':
      'Cushing NextGen Infrastructure ome Fund Common Shares of Beneficial Interest',

    'CQS symbol': 'SZC',
    'NASDAQ symbol': 'SZC',
  },
  {
    symbol: 'SZK',
    'Security Name': 'ProShares UltraShort Consumer Goods',

    'CQS symbol': 'SZK',
    'NASDAQ symbol': 'SZK',
  },
  {
    symbol: 'SZNE',
    'Security Name': 'Pacer CFRAStovall Equal Weight Seasonal Rotation ETF',

    'CQS symbol': 'SZNE',
    'NASDAQ symbol': 'SZNE',
  },
  {
    symbol: 'T',
    'Security Name': 'AT&T ',

    'CQS symbol': 'T',
    'NASDAQ symbol': 'T',
  },
  {
    symbol: 'T$A',
    'Security Name':
      'AT&T  Depositary Shares, each representing a 1/1,000th interest in a share of 5000% Perpetual Preferred Stock, Series A',

    'CQS symbol': 'TpA',
    'NASDAQ symbol': 'TA',
  },
  {
    symbol: 'T$C',
    'Security Name':
      'AT&T  Depositary Shares, each representing a 1/1,000th interest in a share of 4750% Perpetual Preferred Stock, Series C',

    'CQS symbol': 'TpC',
    'NASDAQ symbol': 'TC',
  },
  {
    symbol: 'TA',
    'Security Name': 'TravelCenters of America    ',

    'NASDAQ symbol': 'TA',
  },
  {
    symbol: 'TAAG',
    'Security Name': 'Trend Aggregation Aggressive Growth ETF',

    'CQS symbol': 'TAAG',
    'NASDAQ symbol': 'TAAG',
  },
  {
    symbol: 'TAC',
    'Security Name': 'TransAlta Corporation Ordinary Shares',

    'CQS symbol': 'TAC',
    'NASDAQ symbol': 'TAC',
  },
  {
    symbol: 'TACAU',
    'Security Name':
      'Trepont Acquisition Corp I Units, each consisting of one  ordinary share and onehalf of one redeemable warrant',

    'CQS symbol': 'TACAU',
    'NASDAQ symbol': 'TACA=',
  },
  {
    symbol: 'TACE',
    'Security Name': 'Trend Aggregation Conservative ETF',

    'CQS symbol': 'TACE',
    'NASDAQ symbol': 'TACE',
  },
  {
    symbol: 'TACO',
    'Security Name': 'Del Taco Restaurants,   ',

    'NASDAQ symbol': 'TACO',
  },
  {
    symbol: 'TACT',
    'Security Name': 'TransAct Technologies orporated  ',

    'NASDAQ symbol': 'TACT',
  },
  {
    symbol: 'TADS',
    'Security Name': 'Trend Aggregation Dividend Stock ETF',

    'CQS symbol': 'TADS',
    'NASDAQ symbol': 'TADS',
  },
  {
    symbol: 'TAEQ',
    'Security Name': 'Trend Aggregation US ETF',

    'CQS symbol': 'TAEQ',
    'NASDAQ symbol': 'TAEQ',
  },
  {
    symbol: 'TAGS',
    'Security Name': 'Teucrium Agricultural Fund ETV',

    'CQS symbol': 'TAGS',
    'NASDAQ symbol': 'TAGS',
  },
  {
    symbol: 'TAIL',
    'Security Name': 'Cambria Tail Risk ETF',

    'CQS symbol': 'TAIL',
    'NASDAQ symbol': 'TAIL',
  },
  {
    symbol: 'TAIT',
    'Security Name': 'Taitron Components orporated   ',

    'NASDAQ symbol': 'TAIT',
  },
  {
    symbol: 'TAK',
    'Security Name':
      'Takeda Pharmaceutical Company Limited American Depositary Shares (each representing 1/2 of a share of )',

    'CQS symbol': 'TAK',
    'NASDAQ symbol': 'TAK',
  },
  {
    symbol: 'TAL',
    'Security Name': 'TAL Education Group American Depositary Shares',

    'CQS symbol': 'TAL',
    'NASDAQ symbol': 'TAL',
  },
  {
    symbol: 'TALO',
    'Security Name': 'Talos Energy,  ',

    'CQS symbol': 'TALO',
    'NASDAQ symbol': 'TALO',
  },
  {
    symbol: 'TALOW',
    'Security Name': 'Talos Energy,  Warrants',

    'CQS symbol': 'TALOWS',
    'NASDAQ symbol': 'TALO+',
  },
  {
    symbol: 'TAN',
    'Security Name': 'Invesco Solar ETF',

    'CQS symbol': 'TAN',
    'NASDAQ symbol': 'TAN',
  },
  {
    symbol: 'TANH',
    'Security Name': 'Tantech Holdings Ltd  ',

    'NASDAQ symbol': 'TANH',
  },
  {
    symbol: 'TANNI',
    'Security Name': 'TravelCenters of America    825% Senior Notes due 2028',

    'NASDAQ symbol': 'TANNI',
  },
  {
    symbol: 'TANNL',
    'Security Name': 'TravelCenters of America    800% Senior Notes due 2029',

    'NASDAQ symbol': 'TANNL',
  },
  {
    symbol: 'TANNZ',
    'Security Name': 'TravelCenters of America    800% Senior Notes due 2030',

    'NASDAQ symbol': 'TANNZ',
  },
  {
    symbol: 'TAOP',
    'Security Name': 'Taoping   Ordinary Shares',

    'NASDAQ symbol': 'TAOP',
  },
  {
    symbol: 'TAP',
    'Security Name': 'Molson Coors Beverage Company Class B ',

    'CQS symbol': 'TAP',
    'NASDAQ symbol': 'TAP',
  },
  {
    symbol: 'TAPA',
    'Security Name':
      'Molson Coors Beverage Company Molson Coors Brewing Company  ',

    'CQS symbol': 'TAPA',
    'NASDAQ symbol': 'TAPA',
  },
  {
    symbol: 'TAPR',
    'Security Name': 'iPath Inverse US Treasury Composite ETN',

    'CQS symbol': 'TAPR',
    'NASDAQ symbol': 'TAPR',
  },
  {
    symbol: 'TARA',
    'Security Name': 'Protara Therapeutics,    ',

    'NASDAQ symbol': 'TARA',
  },
  {
    symbol: 'TARO',
    'Security Name': 'Taro Pharmaceutical Industries Ltd Ordinary Shares',

    'CQS symbol': 'TARO',
    'NASDAQ symbol': 'TARO',
  },
  {
    symbol: 'TARS',
    'Security Name': 'Tarsus Pharmaceuticals,   ',

    'NASDAQ symbol': 'TARS',
  },
  {
    symbol: 'TAST',
    'Security Name': 'Carrols Restaurant Group,   ',

    'NASDAQ symbol': 'TAST',
  },
  {
    symbol: 'TAT',
    'Security Name': 'TransAtlantic Petroleum Ltd Ordinary Shares (Bermuda)',

    'CQS symbol': 'TAT',
    'NASDAQ symbol': 'TAT',
  },
  {
    symbol: 'TATT',
    'Security Name': 'TAT Technologies Ltd  Ordinary Shares',

    'NASDAQ symbol': 'TATT',
  },
  {
    symbol: 'TAXF',
    'Security Name': 'American Century Diversified Municipal Bond ETF',

    'CQS symbol': 'TAXF',
    'NASDAQ symbol': 'TAXF',
  },
  {
    symbol: 'TAYD',
    'Security Name': 'Taylor Devices,   ',

    'NASDAQ symbol': 'TAYD',
  },
  {
    symbol: 'TBB',
    'Security Name': 'AT&T  5350% Global Notes due 2066',

    'CQS symbol': 'TBB',
    'NASDAQ symbol': 'TBB',
  },
  {
    symbol: 'TBBK',
    'Security Name': 'The Bancorp,   ',

    'NASDAQ symbol': 'TBBK',
  },
  {
    symbol: 'TBC',
    'Security Name': 'AT&T  5625% Global Notes due 2067',

    'CQS symbol': 'TBC',
    'NASDAQ symbol': 'TBC',
  },
  {
    symbol: 'TBF',
    'Security Name': 'ProShares Short 20+ Year Treasury',

    'CQS symbol': 'TBF',
    'NASDAQ symbol': 'TBF',
  },
  {
    symbol: 'TBI',
    'Security Name': 'TrueBlue,  ',

    'CQS symbol': 'TBI',
    'NASDAQ symbol': 'TBI',
  },
  {
    symbol: 'TBIO',
    'Security Name': 'Translate Bio,   ',

    'NASDAQ symbol': 'TBIO',
  },
  {
    symbol: 'TBJL',
    'Security Name': 'Innovator 20  Year Treasury Bond 9 Buffer ETF  July',

    'CQS symbol': 'TBJL',
    'NASDAQ symbol': 'TBJL',
  },
  {
    symbol: 'TBK',
    'Security Name': 'Triumph Bancorp,   ',

    'NASDAQ symbol': 'TBK',
  },
  {
    symbol: 'TBKCP',
    'Security Name':
      'Triumph Bancorp,   Depositary Shares, Each Representing a 1/40th Interest in a Share of Series C FixedRate NonCumulative Perpetual Preferred Stock ',

    'NASDAQ symbol': 'TBKCP',
  },
  {
    symbol: 'TBLT',
    'Security Name': 'ToughBuilt Industries,   ',

    'NASDAQ symbol': 'TBLT',
  },
  {
    symbol: 'TBLTW',
    'Security Name': 'ToughBuilt Industries,   Warrant',

    'NASDAQ symbol': 'TBLTW',
  },
  {
    symbol: 'TBNK',
    'Security Name': 'Territorial Bancorp   ',

    'NASDAQ symbol': 'TBNK',
  },
  {
    symbol: 'TBPH',
    'Security Name': 'Theravance Biopharma,   Ordinary Shares',

    'NASDAQ symbol': 'TBPH',
  },
  {
    symbol: 'TBT',
    'Security Name': 'ProShares UltraShort Lehman 20  Year Treasury',

    'CQS symbol': 'TBT',
    'NASDAQ symbol': 'TBT',
  },
  {
    symbol: 'TBX',
    'Security Name': 'ProShares Short 7 10 Year Treasury',

    'CQS symbol': 'TBX',
    'NASDAQ symbol': 'TBX',
  },
  {
    symbol: 'TC',
    'Security Name': 'TuanChe Limited  American Depositary Shares',

    'NASDAQ symbol': 'TC',
  },
  {
    symbol: 'TCBI',
    'Security Name': 'Texas Capital Bancshares,   ',

    'NASDAQ symbol': 'TCBI',
  },
  {
    symbol: 'TCBIL',
    'Security Name':
      'Texas Capital Bancshares,   650% Subordinated Notes due 2042',

    'NASDAQ symbol': 'TCBIL',
  },
  {
    symbol: 'TCBIP',
    'Security Name':
      'Texas Capital Bancshares,   Non Cumulative Preferred Perpetual Stock Series A',

    'NASDAQ symbol': 'TCBIP',
  },
  {
    symbol: 'TCBK',
    'Security Name': 'TriCo Bancshares  ',

    'NASDAQ symbol': 'TCBK',
  },
  {
    symbol: 'TCCO',
    'Security Name': 'Technical Communications Corporation  ',

    'NASDAQ symbol': 'TCCO',
  },
  {
    symbol: 'TCDA',
    'Security Name': 'Tricida,   ',

    'NASDAQ symbol': 'TCDA',
  },
  {
    symbol: 'TCF',
    'Security Name': 'TCF Financial Corporation  ',

    'NASDAQ symbol': 'TCF',
  },
  {
    symbol: 'TCFC',
    'Security Name': 'The Community Financial Corporation  ',

    'NASDAQ symbol': 'TCFC',
  },
  {
    symbol: 'TCFCP',
    'Security Name':
      'TCF Financial Corporation  Depositary Shares representing 570% Series C NonCumulative Preferred Stock',

    'NASDAQ symbol': 'TCFCP',
  },
  {
    symbol: 'TCHP',
    'Security Name': 'T Rowe Price Blue Chip Growth ETF',

    'CQS symbol': 'TCHP',
    'NASDAQ symbol': 'TCHP',
  },
  {
    symbol: 'TCI',
    'Security Name': 'Transcontinental Realty Investors,  ',

    'CQS symbol': 'TCI',
    'NASDAQ symbol': 'TCI',
  },
  {
    symbol: 'TCMD',
    'Security Name': 'Tactile Systems Technology,   ',

    'NASDAQ symbol': 'TCMD',
  },
  {
    symbol: 'TCO',
    'Security Name': 'Taubman Centers,  ',

    'CQS symbol': 'TCO',
    'NASDAQ symbol': 'TCO',
  },
  {
    symbol: 'TCO$J',
    'Security Name': 'Taubman Centers,  Preferred Shares Series J',

    'CQS symbol': 'TCOpJ',
    'NASDAQ symbol': 'TCOJ',
  },
  {
    symbol: 'TCO$K',
    'Security Name': 'Taubman Centers,  Preferred Series K',

    'CQS symbol': 'TCOpK',
    'NASDAQ symbol': 'TCOK',
  },
  {
    symbol: 'TCOM',
    'Security Name': 'Tripcom Group Limited  American Depositary Shares',

    'NASDAQ symbol': 'TCOM',
  },
  {
    symbol: 'TCON',
    'Security Name': 'TRACON Pharmaceuticals,   ',

    'NASDAQ symbol': 'TCON',
  },
  {
    symbol: 'TCP',
    'Security Name':
      'TC PipeLines, LP Common Units representing Limited Partner Interests',

    'CQS symbol': 'TCP',
    'NASDAQ symbol': 'TCP',
  },
  {
    symbol: 'TCPC',
    'Security Name': 'BlackRock TCP Capital Corp  ',

    'NASDAQ symbol': 'TCPC',
  },
  {
    symbol: 'TCRR',
    'Security Name': 'TCR2 Therapeutics   ',

    'NASDAQ symbol': 'TCRR',
  },
  {
    symbol: 'TCS',
    'Security Name': 'Container Store (The) ',

    'CQS symbol': 'TCS',
    'NASDAQ symbol': 'TCS',
  },
  {
    symbol: 'TCTL',
    'Security Name': 'Premise Capital Diversified Tactical ETF',

    'CQS symbol': 'TCTL',
    'NASDAQ symbol': 'TCTL',
  },
  {
    symbol: 'TCX',
    'Security Name': 'Tucows   ',

    'NASDAQ symbol': 'TCX',
  },
  {
    symbol: 'TD',
    'Security Name': 'Toronto Dominion Bank (The) ',

    'CQS symbol': 'TD',
    'NASDAQ symbol': 'TD',
  },
  {
    symbol: 'TDA',
    'Security Name': 'Telephone and Data Systems,  5875% Senior Notes due 2061',

    'CQS symbol': 'TDA',
    'NASDAQ symbol': 'TDA',
  },
  {
    symbol: 'TDAC',
    'Security Name': 'Trident Acquisitions Corp  ',

    'NASDAQ symbol': 'TDAC',
  },
  {
    symbol: 'TDACU',
    'Security Name': 'Trident Acquisitions Corp  Units',

    'NASDAQ symbol': 'TDACU',
  },
  {
    symbol: 'TDACW',
    'Security Name': 'Trident Acquisitions Corp  Warrant',

    'NASDAQ symbol': 'TDACW',
  },
  {
    symbol: 'TDC',
    'Security Name': 'Teradata Corporation ',

    'CQS symbol': 'TDC',
    'NASDAQ symbol': 'TDC',
  },
  {
    symbol: 'TDE',
    'Security Name': 'Telephone and Data Systems,  6875% Senior Notes due 2059',

    'CQS symbol': 'TDE',
    'NASDAQ symbol': 'TDE',
  },
  {
    symbol: 'TDF',
    'Security Name': 'Templeton Dragon Fund,  ',

    'CQS symbol': 'TDF',
    'NASDAQ symbol': 'TDF',
  },
  {
    symbol: 'TDG',
    'Security Name': 'Transdigm Group orporated Transdigm Group  ',

    'CQS symbol': 'TDG',
    'NASDAQ symbol': 'TDG',
  },
  {
    symbol: 'TDI',
    'Security Name': 'Telephone and Data Systems,  Sr Nt',

    'CQS symbol': 'TDI',
    'NASDAQ symbol': 'TDI',
  },
  {
    symbol: 'TDIV',
    'Security Name': 'First Trust NASDAQ Technology Dividend Index Fund',

    'NASDAQ symbol': 'TDIV',
  },
  {
    symbol: 'TDJ',
    'Security Name': 'Telephone and Data Systems,  7% Senior Notes due 2060',

    'CQS symbol': 'TDJ',
    'NASDAQ symbol': 'TDJ',
  },
  {
    symbol: 'TDOC',
    'Security Name': 'Teladoc Health,  ',

    'CQS symbol': 'TDOC',
    'NASDAQ symbol': 'TDOC',
  },
  {
    symbol: 'TDS',
    'Security Name': 'Telephone and Data Systems,  Common Shares',

    'CQS symbol': 'TDS',
    'NASDAQ symbol': 'TDS',
  },
  {
    symbol: 'TDSA',
    'Security Name': 'Cabana Target Drawdown 5 ETF',

    'CQS symbol': 'TDSA',
    'NASDAQ symbol': 'TDSA',
  },
  {
    symbol: 'TDSB',
    'Security Name': 'Cabana Target Drawdown 7 ETF',

    'CQS symbol': 'TDSB',
    'NASDAQ symbol': 'TDSB',
  },
  {
    symbol: 'TDSC',
    'Security Name': 'Cabana Target Drawdown 10 ETF',

    'CQS symbol': 'TDSC',
    'NASDAQ symbol': 'TDSC',
  },
  {
    symbol: 'TDSD',
    'Security Name': 'Cabana Target Drawdown 13 ETF',

    'CQS symbol': 'TDSD',
    'NASDAQ symbol': 'TDSD',
  },
  {
    symbol: 'TDSE',
    'Security Name': 'Cabana Target Drawdown 16 ETF',

    'CQS symbol': 'TDSE',
    'NASDAQ symbol': 'TDSE',
  },
  {
    symbol: 'TDTF',
    'Security Name': 'FlexShares iBoxx 5 Year Target Duration TIPS Index Fund',

    'CQS symbol': 'TDTF',
    'NASDAQ symbol': 'TDTF',
  },
  {
    symbol: 'TDTT',
    'Security Name': 'FlexShares iBoxx 3 Year Target Duration TIPS Index Fund',

    'CQS symbol': 'TDTT',
    'NASDAQ symbol': 'TDTT',
  },
  {
    symbol: 'TDV',
    'Security Name': 'ProShares S&P Technology Dividend Aristocrats ETF',

    'CQS symbol': 'TDV',
    'NASDAQ symbol': 'TDV',
  },
  {
    symbol: 'TDVG',
    'Security Name': 'T Rowe Price Dividend Growth ETF',

    'CQS symbol': 'TDVG',
    'NASDAQ symbol': 'TDVG',
  },
  {
    symbol: 'TDW',
    'Security Name': 'Tidewater  ',

    'CQS symbol': 'TDW',
    'NASDAQ symbol': 'TDW',
  },
  {
    symbol: 'TDWA',
    'Security Name':
      'Tidewater  Series A Warrants to purchase shares of  (expiring July 31, 2023)',

    'CQS symbol': 'TDWWSA',
    'NASDAQ symbol': 'TDW+A',
  },
  {
    symbol: 'TDWB',
    'Security Name':
      'Tidewater  Series B Warrants to purchase shares of  (expiring July 31, 2023)',

    'CQS symbol': 'TDWWSB',
    'NASDAQ symbol': 'TDW+B',
  },
  {
    symbol: 'TDWW',
    'Security Name': 'Tidewater  Warrant',

    'CQS symbol': 'TDWWS',
    'NASDAQ symbol': 'TDW+',
  },
  {
    symbol: 'TDY',
    'Security Name': 'Teledyne Technologies orporated ',

    'CQS symbol': 'TDY',
    'NASDAQ symbol': 'TDY',
  },
  {
    symbol: 'TEAF',
    'Security Name':
      'Tortoise Essential Assets ome Term Fund Common Shares of Beneficial Interest',

    'CQS symbol': 'TEAF',
    'NASDAQ symbol': 'TEAF',
  },
  {
    symbol: 'TEAM',
    'Security Name': 'Atlassian Corporation Plc   Ordinary Shares',

    'NASDAQ symbol': 'TEAM',
  },
  {
    symbol: 'TECB',
    'Security Name': 'iShares US Tech Breakthrough Multisector ETF',

    'CQS symbol': 'TECB',
    'NASDAQ symbol': 'TECB',
  },
  {
    symbol: 'TECH',
    'Security Name': 'BioTechne Corp  ',

    'NASDAQ symbol': 'TECH',
  },
  {
    symbol: 'TECK',
    'Security Name': 'Teck Resources Ltd Ordinary Shares',

    'CQS symbol': 'TECK',
    'NASDAQ symbol': 'TECK',
  },
  {
    symbol: 'TECL',
    'Security Name': 'Direxion Technology Bull 3X Shares',

    'CQS symbol': 'TECL',
    'NASDAQ symbol': 'TECL',
  },
  {
    symbol: 'TECS',
    'Security Name': 'Direxion Technology Bear 3X Shares',

    'CQS symbol': 'TECS',
    'NASDAQ symbol': 'TECS',
  },
  {
    symbol: 'TECTP',
    'Security Name':
      'Tectonic Financial,   900% FixedtoFloating Rate Series B NonCumulative Perpetual Preferred Stock',

    'NASDAQ symbol': 'TECTP',
  },
  {
    symbol: 'TEDU',
    'Security Name': 'Tarena International,   American Depositary Shares',

    'NASDAQ symbol': 'TEDU',
  },
  {
    symbol: 'TEF',
    'Security Name': 'Telefonica SA ',

    'CQS symbol': 'TEF',
    'NASDAQ symbol': 'TEF',
  },
  {
    symbol: 'TEGS',
    'Security Name': 'Trend Aggregation ESG ETF',

    'CQS symbol': 'TEGS',
    'NASDAQ symbol': 'TEGS',
  },
  {
    symbol: 'TEI',
    'Security Name': 'Templeton Emerging Markets ome Fund,  ',

    'CQS symbol': 'TEI',
    'NASDAQ symbol': 'TEI',
  },
  {
    symbol: 'TEKKU',
    'Security Name': 'Tekkorp Digital Acquisition Corp  Unit',

    'NASDAQ symbol': 'TEKKU',
  },
  {
    symbol: 'TEL',
    'Security Name': 'TE Connectivity Ltd New Switzerland Registered Shares',

    'CQS symbol': 'TEL',
    'NASDAQ symbol': 'TEL',
  },
  {
    symbol: 'TELA',
    'Security Name': 'TELA Bio,   ',

    'NASDAQ symbol': 'TELA',
  },
  {
    symbol: 'TELL',
    'Security Name': 'Tellurian   ',

    'NASDAQ symbol': 'TELL',
  },
  {
    symbol: 'TEN',
    'Security Name': 'Tenneco   Voting ',

    'CQS symbol': 'TEN',
    'NASDAQ symbol': 'TEN',
  },
  {
    symbol: 'TENB',
    'Security Name': 'Tenable Holdings,   ',

    'NASDAQ symbol': 'TENB',
  },
  {
    symbol: 'TENX',
    'Security Name': 'Tenax Therapeutics,   ',

    'NASDAQ symbol': 'TENX',
  },
  {
    symbol: 'TEO',
    'Security Name': 'Telecom Argentina SA',

    'CQS symbol': 'TEO',
    'NASDAQ symbol': 'TEO',
  },
  {
    symbol: 'TEQI',
    'Security Name': 'T Rowe Price Equity ome ETF',

    'CQS symbol': 'TEQI',
    'NASDAQ symbol': 'TEQI',
  },
  {
    symbol: 'TER',
    'Security Name': 'Teradyne,   ',

    'NASDAQ symbol': 'TER',
  },
  {
    symbol: 'TERM',
    'Security Name': 'EquityCompass Tactical Risk Manager ETF',

    'CQS symbol': 'TERM',
    'NASDAQ symbol': 'TERM',
  },
  {
    symbol: 'TESS',
    'Security Name': 'TESSCO Technologies orporated  ',

    'NASDAQ symbol': 'TESS',
  },
  {
    symbol: 'TEVA',
    'Security Name':
      'Teva Pharmaceutical Industries Limited American Depositary Shares',

    'CQS symbol': 'TEVA',
    'NASDAQ symbol': 'TEVA',
  },
  {
    symbol: 'TEX',
    'Security Name': 'Terex Corporation ',

    'CQS symbol': 'TEX',
    'NASDAQ symbol': 'TEX',
  },
  {
    symbol: 'TFC',
    'Security Name': 'Truist Financial Corporation ',

    'CQS symbol': 'TFC',
    'NASDAQ symbol': 'TFC',
  },
  {
    symbol: 'TFC$F',
    'Security Name':
      'Truist Financial Corporation Depositary Shares Representing 1/1000th Interest Series F Perpetual Preferred',

    'CQS symbol': 'TFCpF',
    'NASDAQ symbol': 'TFCF',
  },
  {
    symbol: 'TFC$G',
    'Security Name': 'Truist Financial Corporation Depositary Shares Series G',

    'CQS symbol': 'TFCpG',
    'NASDAQ symbol': 'TFCG',
  },
  {
    symbol: 'TFC$H',
    'Security Name': 'Truist Financial Corporation Series H ',

    'CQS symbol': 'TFCpH',
    'NASDAQ symbol': 'TFCH',
  },
  {
    symbol: 'TFC$I',
    'Security Name': 'Truist Financial Corporation Depositary Shares',

    'CQS symbol': 'TFCpI',
    'NASDAQ symbol': 'TFCI',
  },
  {
    symbol: 'TFC$O',
    'Security Name':
      'Truist Financial Corporation Depositary Shares, Each Representing a 1/1,000th Interest in a Share of Series O NonCumulative Perpetual Preferred Stock',

    'CQS symbol': 'TFCpO',
    'NASDAQ symbol': 'TFCO',
  },
  {
    symbol: 'TFC$R',
    'Security Name':
      'Truist Financial Corporation Depositary Shares, each representing 1/1,000th interest in a share of Series R NonCumulative Perpetual Preferred Stock',

    'CQS symbol': 'TFCpR',
    'NASDAQ symbol': 'TFCR',
  },
  {
    symbol: 'TFFP',
    'Security Name': 'TFF Pharmaceuticals,   ',

    'NASDAQ symbol': 'TFFP',
  },
  {
    symbol: 'TFI',
    'Security Name': 'SPDR Nuveen Bloomberg Barclays Municipal Bond ETF',

    'CQS symbol': 'TFI',
    'NASDAQ symbol': 'TFI',
  },
  {
    symbol: 'TFII',
    'Security Name': 'TFI International  Common Shares',

    'CQS symbol': 'TFII',
    'NASDAQ symbol': 'TFII',
  },
  {
    symbol: 'TFIV',
    'Security Name': 'Global X Targetome 5 ETF',

    'CQS symbol': 'TFIV',
    'NASDAQ symbol': 'TFIV',
  },
  {
    symbol: 'TFJL',
    'Security Name': 'Innovator 20  Year Treasury Bond 5 Floor ETF  July',

    'CQS symbol': 'TFJL',
    'NASDAQ symbol': 'TFJL',
  },
  {
    symbol: 'TFLO',
    'Security Name': 'iShares Treasury Floating Rate Bond ETF',

    'CQS symbol': 'TFLO',
    'NASDAQ symbol': 'TFLO',
  },
  {
    symbol: 'TFLT',
    'Security Name': 'Global X Targetome Plus 2 ETF',

    'CQS symbol': 'TFLT',
    'NASDAQ symbol': 'TFLT',
  },
  {
    symbol: 'TFSL',
    'Security Name': 'TFS Financial Corporation  ',

    'NASDAQ symbol': 'TFSL',
  },
  {
    symbol: 'TFX',
    'Security Name': 'Teleflex orporated ',

    'CQS symbol': 'TFX',
    'NASDAQ symbol': 'TFX',
  },
  {
    symbol: 'TG',
    'Security Name': 'Tredegar Corporation ',

    'CQS symbol': 'TG',
    'NASDAQ symbol': 'TG',
  },
  {
    symbol: 'TGA',
    'Security Name': 'TransGlobe Energy Corporation  Common Shares',

    'NASDAQ symbol': 'TGA',
  },
  {
    symbol: 'TGB',
    'Security Name': 'Taseko Mines, Ltd ',

    'CQS symbol': 'TGB',
    'NASDAQ symbol': 'TGB',
  },
  {
    symbol: 'TGC',
    'Security Name': 'Tengasco,  ',

    'CQS symbol': 'TGC',
    'NASDAQ symbol': 'TGC',
  },
  {
    symbol: 'TGH',
    'Security Name': 'Textainer Group Holdings Limited Common Shares',

    'CQS symbol': 'TGH',
    'NASDAQ symbol': 'TGH',
  },
  {
    symbol: 'TGI',
    'Security Name': 'Triumph Group,  ',

    'CQS symbol': 'TGI',
    'NASDAQ symbol': 'TGI',
  },
  {
    symbol: 'TGIF',
    'Security Name': 'SoFi Weekly ome ETF',

    'CQS symbol': 'TGIF',
    'NASDAQ symbol': 'TGIF',
  },
  {
    symbol: 'TGLS',
    'Security Name': 'Tecnoglass   Ordinary Shares',

    'NASDAQ symbol': 'TGLS',
  },
  {
    symbol: 'TGNA',
    'Security Name': 'TEGNA ',

    'CQS symbol': 'TGNA',
    'NASDAQ symbol': 'TGNA',
  },
  {
    symbol: 'TGP',
    'Security Name': 'Teekay LNG Partners LP',

    'CQS symbol': 'TGP',
    'NASDAQ symbol': 'TGP',
  },
  {
    symbol: 'TGP$A',
    'Security Name':
      'Teekay LNG Partners LP 900% Series A Cumulative Redeemable Perpetual Preferred Units, representing limited partner interests',

    'CQS symbol': 'TGPpA',
    'NASDAQ symbol': 'TGPA',
  },
  {
    symbol: 'TGP$B',
    'Security Name':
      'Teekay LNG Partners LP 850% Series B FixedtoFloating Rate Cumulative Redeemable Perpetual Preferred Units, representing limited partner interests',

    'CQS symbol': 'TGPpB',
    'NASDAQ symbol': 'TGPB',
  },
  {
    symbol: 'TGRW',
    'Security Name': 'T Rowe Price Growth Stock ETF',

    'CQS symbol': 'TGRW',
    'NASDAQ symbol': 'TGRW',
  },
  {
    symbol: 'TGS',
    'Security Name': 'Transportadora de Gas del Sur SA TGS ',

    'CQS symbol': 'TGS',
    'NASDAQ symbol': 'TGS',
  },
  {
    symbol: 'TGT',
    'Security Name': 'Target Corporation ',

    'CQS symbol': 'TGT',
    'NASDAQ symbol': 'TGT',
  },
  {
    symbol: 'TGTX',
    'Security Name': 'TG Therapeutics,   ',

    'NASDAQ symbol': 'TGTX',
  },
  {
    symbol: 'TH',
    'Security Name': 'Target Hospitality Corp  ',

    'NASDAQ symbol': 'TH',
  },
  {
    symbol: 'THBR',
    'Security Name': 'Thunder Bridge Acquisition II, Ltd   Ordinary Shares',

    'NASDAQ symbol': 'THBR',
  },
  {
    symbol: 'THBRU',
    'Security Name': 'Thunder Bridge Acquisition II, Ltd  Units',

    'NASDAQ symbol': 'THBRU',
  },
  {
    symbol: 'THBRW',
    'Security Name': 'Thunder Bridge Acquisition II, Ltd  Warrants',

    'NASDAQ symbol': 'THBRW',
  },
  {
    symbol: 'THC',
    'Security Name': 'Tenet Healthcare Corporation ',

    'CQS symbol': 'THC',
    'NASDAQ symbol': 'THC',
  },
  {
    symbol: 'THCA',
    'Security Name': 'Tuscan Holdings Corp II  ',

    'NASDAQ symbol': 'THCA',
  },
  {
    symbol: 'THCAU',
    'Security Name': 'Tuscan Holdings Corp II  Unit',

    'NASDAQ symbol': 'THCAU',
  },
  {
    symbol: 'THCAW',
    'Security Name': 'Tuscan Holdings Corp II  Warrant',

    'NASDAQ symbol': 'THCAW',
  },
  {
    symbol: 'THCB',
    'Security Name': 'Tuscan Holdings Corp  ',

    'NASDAQ symbol': 'THCB',
  },
  {
    symbol: 'THCBU',
    'Security Name': 'Tuscan Holdings Corp  Unit',

    'NASDAQ symbol': 'THCBU',
  },
  {
    symbol: 'THCBW',
    'Security Name': 'Tuscan Holdings Corp  Warrant',

    'NASDAQ symbol': 'THCBW',
  },
  {
    symbol: 'THCX',
    'Security Name': 'Spinnaker ETF Series The Cannabis ETF',

    'CQS symbol': 'THCX',
    'NASDAQ symbol': 'THCX',
  },
  {
    symbol: 'THD',
    'Security Name': 'iShares  iShares MSCI Thailand ETF',

    'CQS symbol': 'THD',
    'NASDAQ symbol': 'THD',
  },
  {
    symbol: 'THFF',
    'Security Name': 'First Financial Corporation Indiana  ',

    'NASDAQ symbol': 'THFF',
  },
  {
    symbol: 'THG',
    'Security Name': 'Hanover Insurance Group ',

    'CQS symbol': 'THG',
    'NASDAQ symbol': 'THG',
  },
  {
    symbol: 'THM',
    'Security Name':
      'International Tower Hill Mines, Ltd Ordinary Shares (Canada)',

    'CQS symbol': 'THM',
    'NASDAQ symbol': 'THM',
  },
  {
    symbol: 'THMO',
    'Security Name': 'ThermoGenesis Holdings,   ',

    'NASDAQ symbol': 'THMO',
  },
  {
    symbol: 'THNQ',
    'Security Name': 'ROBO Global Artificial Intelligence ETF',

    'CQS symbol': 'THNQ',
    'NASDAQ symbol': 'THNQ',
  },
  {
    symbol: 'THO',
    'Security Name': 'Thor Industries,  ',

    'CQS symbol': 'THO',
    'NASDAQ symbol': 'THO',
  },
  {
    symbol: 'THQ',
    'Security Name':
      'Tekla Healthcare Opportunies Fund Shares of Beneficial Interest',

    'CQS symbol': 'THQ',
    'NASDAQ symbol': 'THQ',
  },
  {
    symbol: 'THR',
    'Security Name': 'Thermon Group Holdings,  ',

    'CQS symbol': 'THR',
    'NASDAQ symbol': 'THR',
  },
  {
    symbol: 'THRM',
    'Security Name': 'Gentherm   ',

    'NASDAQ symbol': 'THRM',
  },
  {
    symbol: 'THRY',
    'Security Name': 'Thryv Holdings,   ',

    'NASDAQ symbol': 'THRY',
  },
  {
    symbol: 'THS',
    'Security Name': 'Treehouse Foods,  ',

    'CQS symbol': 'THS',
    'NASDAQ symbol': 'THS',
  },
  {
    symbol: 'THTX',
    'Security Name': 'Theratechnologies   Common Shares',

    'NASDAQ symbol': 'THTX',
  },
  {
    symbol: 'THW',
    'Security Name':
      'Tekla World Healthcare Fund Shares of Beneficial Interest',

    'CQS symbol': 'THW',
    'NASDAQ symbol': 'THW',
  },
  {
    symbol: 'THWWW',
    'Security Name': 'Target Hospitality Corp  Warrant expiring 3/15/2024',

    'NASDAQ symbol': 'THWWW',
  },
  {
    symbol: 'THY',
    'Security Name': 'Agility Shares Dynamic Tactical ome ETF',

    'CQS symbol': 'THY',
    'NASDAQ symbol': 'THY',
  },
  {
    symbol: 'TIF',
    'Security Name': 'Tiffany & Co ',

    'CQS symbol': 'TIF',
    'NASDAQ symbol': 'TIF',
  },
  {
    symbol: 'TIG',
    'Security Name': 'Trean Insurance Group,   ',

    'NASDAQ symbol': 'TIG',
  },
  {
    symbol: 'TIGO',
    'Security Name': 'Millicom International Cellular SA  ',

    'NASDAQ symbol': 'TIGO',
  },
  {
    symbol: 'TIGR',
    'Security Name':
      'UP Fintech Holding Limited  American Depositary Shares representing fifteen  Ordinary Shares',

    'NASDAQ symbol': 'TIGR',
  },
  {
    symbol: 'TILE',
    'Security Name': 'Interface,   ',

    'NASDAQ symbol': 'TILE',
  },
  {
    symbol: 'TILT',
    'Security Name':
      'FlexShares Mornigstar US Market Factors Tilt Index Fund ETF',

    'CQS symbol': 'TILT',
    'NASDAQ symbol': 'TILT',
  },
  {
    symbol: 'TIMB',
    'Security Name':
      'TIM SA American Depositary Shares (Each representing 5 Common Shares) ',

    'CQS symbol': 'TIMB',
    'NASDAQ symbol': 'TIMB',
  },
  {
    symbol: 'TINVU',
    'Security Name':
      'Tiga Acquisition Corp Units, each consisting of one  ordinary share and one half of one warrant',

    'CQS symbol': 'TINVU',
    'NASDAQ symbol': 'TINV=',
  },
  {
    symbol: 'TIP',
    'Security Name': 'iShares TIPS Bond ETF',

    'CQS symbol': 'TIP',
    'NASDAQ symbol': 'TIP',
  },
  {
    symbol: 'TIPT',
    'Security Name': 'Tiptree   ',

    'NASDAQ symbol': 'TIPT',
  },
  {
    symbol: 'TIPX',
    'Security Name': 'SPDR Bloomberg Barclays 110 Year TIPS',

    'CQS symbol': 'TIPX',
    'NASDAQ symbol': 'TIPX',
  },
  {
    symbol: 'TIPZ',
    'Security Name': 'PIMCO Broad US TIPS Index ExchangeTraded Fund',

    'CQS symbol': 'TIPZ',
    'NASDAQ symbol': 'TIPZ',
  },
  {
    symbol: 'TISI',
    'Security Name': 'Team,  ',

    'CQS symbol': 'TISI',
    'NASDAQ symbol': 'TISI',
  },
  {
    symbol: 'TITN',
    'Security Name': 'Titan Machinery   ',

    'NASDAQ symbol': 'TITN',
  },
  {
    symbol: 'TJX',
    'Security Name': 'TJX Companies,  (The) ',

    'CQS symbol': 'TJX',
    'NASDAQ symbol': 'TJX',
  },
  {
    symbol: 'TK',
    'Security Name': 'Teekay Corporation ',

    'CQS symbol': 'TK',
    'NASDAQ symbol': 'TK',
  },
  {
    symbol: 'TKAT',
    'Security Name': 'Takung Art Co, Ltd ',

    'CQS symbol': 'TKAT',
    'NASDAQ symbol': 'TKAT',
  },
  {
    symbol: 'TKC',
    'Security Name': 'Turkcell Iletisim Hizmetleri AS ',

    'CQS symbol': 'TKC',
    'NASDAQ symbol': 'TKC',
  },
  {
    symbol: 'TKR',
    'Security Name': 'Timken Company (The) ',

    'CQS symbol': 'TKR',
    'NASDAQ symbol': 'TKR',
  },
  {
    symbol: 'TLC',
    'Security Name': 'Taiwan Liposome Company, Ltd  American Depositary Shares',

    'NASDAQ symbol': 'TLC',
  },
  {
    symbol: 'TLDH',
    'Security Name':
      'FlexShares Currency Hedged Morningstar DM exUS Factor Tilt Index Fund',

    'CQS symbol': 'TLDH',
    'NASDAQ symbol': 'TLDH',
  },
  {
    symbol: 'TLEH',
    'Security Name':
      'FlexShares Currency Hedged Morningstar EM Factor Tilt Index Fund',

    'CQS symbol': 'TLEH',
    'NASDAQ symbol': 'TLEH',
  },
  {
    symbol: 'TLGT',
    'Security Name': 'Teligent,   ',

    'Financial Status': 'H',
    'NASDAQ symbol': 'TLGT',
  },
  {
    symbol: 'TLH',
    'Security Name': 'iShares 1020 Year Treasury Bond ETF',

    'CQS symbol': 'TLH',
    'NASDAQ symbol': 'TLH',
  },
  {
    symbol: 'TLK',
    'Security Name': 'PT Telekomunikasi Indonesia, Tbk',

    'CQS symbol': 'TLK',
    'NASDAQ symbol': 'TLK',
  },
  {
    symbol: 'TLMD',
    'Security Name': 'SOC Telemed,    ',

    'NASDAQ symbol': 'TLMD',
  },
  {
    symbol: 'TLMDW',
    'Security Name': 'SOC Telemed,   Warrants',

    'NASDAQ symbol': 'TLMDW',
  },
  {
    symbol: 'TLND',
    'Security Name': 'Talend SA  American Depositary Shares',

    'NASDAQ symbol': 'TLND',
  },
  {
    symbol: 'TLRY',
    'Security Name': 'Tilray,   Class 2 ',

    'NASDAQ symbol': 'TLRY',
  },
  {
    symbol: 'TLS',
    'Security Name': 'Telos Corporation  ',

    'NASDAQ symbol': 'TLS',
  },
  {
    symbol: 'TLSA',
    'Security Name': 'Tiziana Life Sciences plc  American Depository Share',

    'NASDAQ symbol': 'TLSA',
  },
  {
    symbol: 'TLT',
    'Security Name': 'iShares 20+ Year Treasury Bond ETF',

    'NASDAQ symbol': 'TLT',
  },
  {
    symbol: 'TLTD',
    'Security Name':
      'FlexShares Morningstar Developed Markets exUS Factor Tilt Index Fund',

    'CQS symbol': 'TLTD',
    'NASDAQ symbol': 'TLTD',
  },
  {
    symbol: 'TLTE',
    'Security Name':
      'FlexShares Morningstar Emerging Markets Factor Tilt Index Fund',

    'CQS symbol': 'TLTE',
    'NASDAQ symbol': 'TLTE',
  },
  {
    symbol: 'TLYS',
    'Security Name': "Tilly's,  ",

    'CQS symbol': 'TLYS',
    'NASDAQ symbol': 'TLYS',
  },
  {
    symbol: 'TM',
    'Security Name': 'Toyota Motor Corporation ',

    'CQS symbol': 'TM',
    'NASDAQ symbol': 'TM',
  },
  {
    symbol: 'TMBR',
    'Security Name': 'Timber Pharmaceuticals,  ',

    'CQS symbol': 'TMBR',
    'NASDAQ symbol': 'TMBR',
  },
  {
    symbol: 'TMDI',
    'Security Name': 'Titan Medical   Ordinary Shares',

    'NASDAQ symbol': 'TMDI',
  },
  {
    symbol: 'TMDV',
    'Security Name': 'ProShares Russell US Dividend Growers ETF',

    'CQS symbol': 'TMDV',
    'NASDAQ symbol': 'TMDV',
  },
  {
    symbol: 'TMDX',
    'Security Name': 'TransMedics Group,   ',

    'NASDAQ symbol': 'TMDX',
  },
  {
    symbol: 'TME',
    'Security Name':
      'Tencent Music Entertainment Group American Depositary Shares, each representing two  Ordinary Shares',

    'CQS symbol': 'TME',
    'NASDAQ symbol': 'TME',
  },
  {
    symbol: 'TMF',
    'Security Name': 'Direxion Daily 20Yr Treasury Bull 3x Shrs',

    'CQS symbol': 'TMF',
    'NASDAQ symbol': 'TMF',
  },
  {
    symbol: 'TMFC',
    'Security Name': 'Motley Fool 100 Index ETF ETF',

    'CQS symbol': 'TMFC',
    'NASDAQ symbol': 'TMFC',
  },
  {
    symbol: 'TMHC',
    'Security Name': 'Taylor Morrison Home Corporation ',

    'CQS symbol': 'TMHC',
    'NASDAQ symbol': 'TMHC',
  },
  {
    symbol: 'TMO',
    'Security Name': 'Thermo Fisher Scientific  ',

    'CQS symbol': 'TMO',
    'NASDAQ symbol': 'TMO',
  },
  {
    symbol: 'TMP',
    'Security Name': 'Tompkins Financial Corporation ',

    'CQS symbol': 'TMP',
    'NASDAQ symbol': 'TMP',
  },
  {
    symbol: 'TMPMU',
    'Security Name': 'Turmeric Acquisition Corp  Unit',

    'NASDAQ symbol': 'TMPMU',
  },
  {
    symbol: 'TMQ',
    'Security Name': 'Trilogy Metals  ',

    'CQS symbol': 'TMQ',
    'NASDAQ symbol': 'TMQ',
  },
  {
    symbol: 'TMST',
    'Security Name': 'TimkenSteel Corporation Common Shares',

    'CQS symbol': 'TMST',
    'NASDAQ symbol': 'TMST',
  },
  {
    symbol: 'TMTS',
    'Security Name': 'Spartacus Acquisition Corporation   ',

    'NASDAQ symbol': 'TMTS',
  },
  {
    symbol: 'TMTSU',
    'Security Name': 'Spartacus Acquisition Corporation  Unit',

    'NASDAQ symbol': 'TMTSU',
  },
  {
    symbol: 'TMTSW',
    'Security Name': 'Spartacus Acquisition Corporation  Warrant',

    'NASDAQ symbol': 'TMTSW',
  },
  {
    symbol: 'TMUS',
    'Security Name': 'TMobile US,   ',

    'NASDAQ symbol': 'TMUS',
  },
  {
    symbol: 'TMV',
    'Security Name': 'Direxion Daily 20Year Treasury Bear 3X',

    'CQS symbol': 'TMV',
    'NASDAQ symbol': 'TMV',
  },
  {
    symbol: 'TMX',
    'Security Name': 'Terminix Global Holdings,  ',

    'CQS symbol': 'TMX',
    'NASDAQ symbol': 'TMX',
  },
  {
    symbol: 'TNA',
    'Security Name': 'Direxion Small Cap Bull 3X Shares',

    'CQS symbol': 'TNA',
    'NASDAQ symbol': 'TNA',
  },
  {
    symbol: 'TNAV',
    'Security Name': 'Telenav,   ',

    'NASDAQ symbol': 'TNAV',
  },
  {
    symbol: 'TNC',
    'Security Name': 'Tennant Company ',

    'CQS symbol': 'TNC',
    'NASDAQ symbol': 'TNC',
  },
  {
    symbol: 'TNDM',
    'Security Name': 'Tandem Diabetes Care,   ',

    'NASDAQ symbol': 'TNDM',
  },
  {
    symbol: 'TNET',
    'Security Name': 'TriNet Group,  ',

    'CQS symbol': 'TNET',
    'NASDAQ symbol': 'TNET',
  },
  {
    symbol: 'TNK',
    'Security Name': 'Teekay Tankers Ltd',

    'CQS symbol': 'TNK',
    'NASDAQ symbol': 'TNK',
  },
  {
    symbol: 'TNP',
    'Security Name': 'Tsakos Energy Navigation Ltd Common Shares',

    'CQS symbol': 'TNP',
    'NASDAQ symbol': 'TNP',
  },
  {
    symbol: 'TNP$D',
    'Security Name':
      'Tsakos Energy Navigation Ltd 875% Series D Cumulative Redeemable Perpetual Preferred Shares',

    'CQS symbol': 'TNPpD',
    'NASDAQ symbol': 'TNPD',
  },
  {
    symbol: 'TNP$E',
    'Security Name':
      'Tsakos Energy Navigation Ltd Series E FixedtoFloating Rate Cumulative Redeemable Perpetual Preferred Shares, par value $100',

    'CQS symbol': 'TNPpE',
    'NASDAQ symbol': 'TNPE',
  },
  {
    symbol: 'TNP$F',
    'Security Name':
      'Tsakos Energy Navigation Ltd Series F FixedtoFloating Rate Cumulative Redeemable Perpetual Preferred Shares, par value $100',

    'CQS symbol': 'TNPpF',
    'NASDAQ symbol': 'TNPF',
  },
  {
    symbol: 'TNXP',
    'Security Name': 'Tonix Pharmaceuticals Holding Corp  ',

    'NASDAQ symbol': 'TNXP',
  },
  {
    symbol: 'TOK',
    'Security Name': 'iShares MSCI Kokusai ETF',

    'CQS symbol': 'TOK',
    'NASDAQ symbol': 'TOK',
  },
  {
    symbol: 'TOKE',
    'Security Name': 'Cambria Cannabis ETF',

    'CQS symbol': 'TOKE',
    'NASDAQ symbol': 'TOKE',
  },
  {
    symbol: 'TOL',
    'Security Name': 'Toll Brothers,  ',

    'CQS symbol': 'TOL',
    'NASDAQ symbol': 'TOL',
  },
  {
    symbol: 'TOLZ',
    'Security Name': 'ProShares DJ Brookfield Global Infrastructure ETF',

    'CQS symbol': 'TOLZ',
    'NASDAQ symbol': 'TOLZ',
  },
  {
    symbol: 'TOMZ',
    'Security Name': 'TOMI Environmental Solutions,   ',

    'NASDAQ symbol': 'TOMZ',
  },
  {
    symbol: 'TOPS',
    'Security Name': 'TOP Ships   ',

    'NASDAQ symbol': 'TOPS',
  },
  {
    symbol: 'TOT',
    'Security Name': 'Total SE',

    'CQS symbol': 'TOT',
    'NASDAQ symbol': 'TOT',
  },
  {
    symbol: 'TOTA',
    'Security Name': 'Tottenham Acquisition I Limited  Ordinary Shares',

    'NASDAQ symbol': 'TOTA',
  },
  {
    symbol: 'TOTAR',
    'Security Name': 'Tottenham Acquisition I Limited  Right',

    'NASDAQ symbol': 'TOTAR',
  },
  {
    symbol: 'TOTAU',
    'Security Name': 'Tottenham Acquisition I Limited  Unit',

    'NASDAQ symbol': 'TOTAU',
  },
  {
    symbol: 'TOTAW',
    'Security Name': 'Tottenham Acquisition I Limited  Warrant',

    'NASDAQ symbol': 'TOTAW',
  },
  {
    symbol: 'TOTL',
    'Security Name': 'SPDR DoubleLine Total Return Tactical ETF',

    'CQS symbol': 'TOTL',
    'NASDAQ symbol': 'TOTL',
  },
  {
    symbol: 'TOUR',
    'Security Name': 'Tuniu Corporation  American Depositary Shares',

    'NASDAQ symbol': 'TOUR',
  },
  {
    symbol: 'TOWN',
    'Security Name': 'Towne Bank  ',

    'NASDAQ symbol': 'TOWN',
  },
  {
    symbol: 'TPAY',
    'Security Name': 'Ecofin Digital Payments Infrastructure Fund',

    'CQS symbol': 'TPAY',
    'NASDAQ symbol': 'TPAY',
  },
  {
    symbol: 'TPB',
    'Security Name': 'Turning Point Brands,  ',

    'CQS symbol': 'TPB',
    'NASDAQ symbol': 'TPB',
  },
  {
    symbol: 'TPC',
    'Security Name': 'Tutor Perini Corporation ',

    'CQS symbol': 'TPC',
    'NASDAQ symbol': 'TPC',
  },
  {
    symbol: 'TPCO',
    'Security Name': 'Tribune Publishing Company  ',

    'NASDAQ symbol': 'TPCO',
  },
  {
    symbol: 'TPGY',
    'Security Name': 'TPG Pace Beneficial Finance Corp  Ordinary Shares',

    'CQS symbol': 'TPGY',
    'NASDAQ symbol': 'TPGY',
  },
  {
    symbol: 'TPGYU',
    'Security Name':
      'TPG Pace Beneficial Finance Corp Units, each consisting of one  ordinary share and onefifth of one Warrant',

    'CQS symbol': 'TPGYU',
    'NASDAQ symbol': 'TPGY=',
  },
  {
    symbol: 'TPGYW',
    'Security Name':
      'TPG Pace Beneficial Finance Corp Warrants, each whole warrant exercisable for one  ordinary share at an exercise price of $1150 per share',

    'CQS symbol': 'TPGYWS',
    'NASDAQ symbol': 'TPGY+',
  },
  {
    symbol: 'TPH',
    'Security Name': 'TRI Pointe Group,  ',

    'CQS symbol': 'TPH',
    'NASDAQ symbol': 'TPH',
  },
  {
    symbol: 'TPHD',
    'Security Name': 'Timothy Plan High Dividend Stock ETF',

    'CQS symbol': 'TPHD',
    'NASDAQ symbol': 'TPHD',
  },
  {
    symbol: 'TPHS',
    'Security Name': 'Trinity Place Holdings  ',

    'CQS symbol': 'TPHS',
    'NASDAQ symbol': 'TPHS',
  },
  {
    symbol: 'TPIC',
    'Security Name': 'TPI Composites,   ',

    'NASDAQ symbol': 'TPIC',
  },
  {
    symbol: 'TPIF',
    'Security Name': 'Timothy Plan International ETF',

    'CQS symbol': 'TPIF',
    'NASDAQ symbol': 'TPIF',
  },
  {
    symbol: 'TPL',
    'Security Name': 'Texas Pacific Land Trust ',

    'CQS symbol': 'TPL',
    'NASDAQ symbol': 'TPL',
  },
  {
    symbol: 'TPLC',
    'Security Name': 'Timothy Plan US Large/Mid Cap Core ETF',

    'CQS symbol': 'TPLC',
    'NASDAQ symbol': 'TPLC',
  },
  {
    symbol: 'TPOR',
    'Security Name': 'Direxion Daily Transportation Bull 3X Shares',

    'CQS symbol': 'TPOR',
    'NASDAQ symbol': 'TPOR',
  },
  {
    symbol: 'TPR',
    'Security Name': 'Tapestry,  ',

    'CQS symbol': 'TPR',
    'NASDAQ symbol': 'TPR',
  },
  {
    symbol: 'TPRE',
    'Security Name': 'Third Point Reinsurance Ltd Common Shares',

    'CQS symbol': 'TPRE',
    'NASDAQ symbol': 'TPRE',
  },
  {
    symbol: 'TPSC',
    'Security Name': 'Timothy Plan US Small Cap Core ETF',

    'CQS symbol': 'TPSC',
    'NASDAQ symbol': 'TPSC',
  },
  {
    symbol: 'TPTX',
    'Security Name': 'Turning Point Therapeutics,   ',

    'NASDAQ symbol': 'TPTX',
  },
  {
    symbol: 'TPVG',
    'Security Name': 'TriplePoint Venture Growth BDC Corp ',

    'CQS symbol': 'TPVG',
    'NASDAQ symbol': 'TPVG',
  },
  {
    symbol: 'TPVY',
    'Security Name': 'TriplePoint Venture Growth BDC Corp 575% Notes due 2022',

    'CQS symbol': 'TPVY',
    'NASDAQ symbol': 'TPVY',
  },
  {
    symbol: 'TPX',
    'Security Name': 'Tempur Sealy International,  ',

    'CQS symbol': 'TPX',
    'NASDAQ symbol': 'TPX',
  },
  {
    symbol: 'TPYP',
    'Security Name': 'Tortoise North American Pipeline ETF',

    'CQS symbol': 'TPYP',
    'NASDAQ symbol': 'TPYP',
  },
  {
    symbol: 'TPZ',
    'Security Name': 'Tortoise Power and Energy Infrastructure Fund,  ',

    'CQS symbol': 'TPZ',
    'NASDAQ symbol': 'TPZ',
  },
  {
    symbol: 'TQQQ',
    'Security Name': 'ProShares UltraPro QQQ',

    'NASDAQ symbol': 'TQQQ',
  },
  {
    symbol: 'TR',
    'Security Name': 'Tootsie Roll Industries,  ',

    'CQS symbol': 'TR',
    'NASDAQ symbol': 'TR',
  },
  {
    symbol: 'TRC',
    'Security Name': 'Tejon Ranch Co ',

    'CQS symbol': 'TRC',
    'NASDAQ symbol': 'TRC',
  },
  {
    symbol: 'TRCH',
    'Security Name': 'Torchlight Energy Resources,   ',

    'NASDAQ symbol': 'TRCH',
  },
  {
    symbol: 'TREB',
    'Security Name': 'Trebia Acquisition Corp  Ordinary Shares',

    'CQS symbol': 'TREB',
    'NASDAQ symbol': 'TREB',
  },
  {
    symbol: 'TREBU',
    'Security Name':
      'Trebia Acquisition Corp Units, each consisting of one  Ordinary Share, and onethird of one Warrant',

    'CQS symbol': 'TREBU',
    'NASDAQ symbol': 'TREB=',
  },
  {
    symbol: 'TREBW',
    'Security Name':
      'Trebia Acquisition Corp Warrants, each whole warrant exercisable for one  Ordinary Share at an exercise price of $1150 per share',

    'CQS symbol': 'TREBWS',
    'NASDAQ symbol': 'TREB+',
  },
  {
    symbol: 'TREC',
    'Security Name': 'Trecora Resources ',

    'CQS symbol': 'TREC',
    'NASDAQ symbol': 'TREC',
  },
  {
    symbol: 'TREE',
    'Security Name': 'LendingTree,   ',

    'NASDAQ symbol': 'TREE',
  },
  {
    symbol: 'TREX',
    'Security Name': 'Trex Company,  ',

    'CQS symbol': 'TREX',
    'NASDAQ symbol': 'TREX',
  },
  {
    symbol: 'TRGP',
    'Security Name': 'Targa Resources,  ',

    'CQS symbol': 'TRGP',
    'NASDAQ symbol': 'TRGP',
  },
  {
    symbol: 'TRHC',
    'Security Name': 'Tabula Rasa HealthCare,   ',

    'NASDAQ symbol': 'TRHC',
  },
  {
    symbol: 'TRI',
    'Security Name': 'Thomson Reuters Corp Ordinary Shares',

    'CQS symbol': 'TRI',
    'NASDAQ symbol': 'TRI',
  },
  {
    symbol: 'TRIB',
    'Security Name':
      'Trinity Biotech plc  American Depositary Shares each representing 4 A Ordinary Shares',

    'NASDAQ symbol': 'TRIB',
  },
  {
    symbol: 'TRIL',
    'Security Name': 'Trillium Therapeutics   Common Shares',

    'NASDAQ symbol': 'TRIL',
  },
  {
    symbol: 'TRIP',
    'Security Name': 'TripAdvisor,   ',

    'NASDAQ symbol': 'TRIP',
  },
  {
    symbol: 'TRIT',
    'Security Name': 'Triterras,    Ordinary Shares',

    'NASDAQ symbol': 'TRIT',
  },
  {
    symbol: 'TRITW',
    'Security Name': 'Triterras,   Warrant',

    'NASDAQ symbol': 'TRITW',
  },
  {
    symbol: 'TRMB',
    'Security Name': 'Trimble   ',

    'NASDAQ symbol': 'TRMB',
  },
  {
    symbol: 'TRMD',
    'Security Name': 'TORM plc   ',

    'NASDAQ symbol': 'TRMD',
  },
  {
    symbol: 'TRMK',
    'Security Name': 'Trustmark Corporation  ',

    'NASDAQ symbol': 'TRMK',
  },
  {
    symbol: 'TRMT',
    'Security Name':
      'Tremont Mortgage Trust  Common Shares of Beneficial Interest',

    'NASDAQ symbol': 'TRMT',
  },
  {
    symbol: 'TRN',
    'Security Name': 'Trinity Industries,  ',

    'CQS symbol': 'TRN',
    'NASDAQ symbol': 'TRN',
  },
  {
    symbol: 'TRND',
    'Security Name': 'Pacer Trendpilot Fund of Funds ETF',

    'CQS symbol': 'TRND',
    'NASDAQ symbol': 'TRND',
  },
  {
    symbol: 'TRNE',
    'Security Name': 'Trine Acquisition Corp  ',

    'CQS symbol': 'TRNE',
    'NASDAQ symbol': 'TRNE',
  },
  {
    symbol: 'TRNEU',
    'Security Name': 'Trine Acquisition Corp Units',

    'CQS symbol': 'TRNEU',
    'NASDAQ symbol': 'TRNE=',
  },
  {
    symbol: 'TRNEW',
    'Security Name':
      'Trine Acquisition Corp Warrants, each whole warrant exercisable for one share of   at an exercise price of $1150',

    'CQS symbol': 'TRNEWS',
    'NASDAQ symbol': 'TRNE+',
  },
  {
    symbol: 'TRNO',
    'Security Name': 'Terreno Realty Corporation ',

    'CQS symbol': 'TRNO',
    'NASDAQ symbol': 'TRNO',
  },
  {
    symbol: 'TRNS',
    'Security Name': 'Transcat,   ',

    'NASDAQ symbol': 'TRNS',
  },
  {
    symbol: 'TROW',
    'Security Name': 'T Rowe Price Group,   ',

    'NASDAQ symbol': 'TROW',
  },
  {
    symbol: 'TROX',
    'Security Name': 'Tronox Holdings plc Ordinary Shares (UK)',

    'CQS symbol': 'TROX',
    'NASDAQ symbol': 'TROX',
  },
  {
    symbol: 'TRP',
    'Security Name': 'TC Energy Corporation ',

    'CQS symbol': 'TRP',
    'NASDAQ symbol': 'TRP',
  },
  {
    symbol: 'TRQ',
    'Security Name': 'Turquoise Hill Resources Ltd Ordinary Shares',

    'CQS symbol': 'TRQ',
    'NASDAQ symbol': 'TRQ',
  },
  {
    symbol: 'TRS',
    'Security Name': 'TriMas Corporation  ',

    'NASDAQ symbol': 'TRS',
  },
  {
    symbol: 'TRST',
    'Security Name': 'TrustCo Bank Corp NY  ',

    'NASDAQ symbol': 'TRST',
  },
  {
    symbol: 'TRT',
    'Security Name': 'TrioTech International ',

    'CQS symbol': 'TRT',
    'NASDAQ symbol': 'TRT',
  },
  {
    symbol: 'TRTN',
    'Security Name': 'Triton International Limited Common Shares',

    'CQS symbol': 'TRTN',
    'NASDAQ symbol': 'TRTN',
  },
  {
    symbol: 'TRTN$A',
    'Security Name':
      'Triton International Limited 850% Series A Cumulative Redeemable Perpetual  Preference Shares',

    'CQS symbol': 'TRTNpA',
    'NASDAQ symbol': 'TRTNA',
  },
  {
    symbol: 'TRTN$B',
    'Security Name':
      'Triton International Limited 800% Series B Cumulative Redeemable Perpetual Preference Shares',

    'CQS symbol': 'TRTNpB',
    'NASDAQ symbol': 'TRTNB',
  },
  {
    symbol: 'TRTN$C',
    'Security Name':
      'Triton International Limited 7375% Series C Cumulative Redeemable Perpetual Preference Shares',

    'CQS symbol': 'TRTNpC',
    'NASDAQ symbol': 'TRTNC',
  },
  {
    symbol: 'TRTN$D',
    'Security Name':
      'Triton International Limited 6875% Series D Cumulative Redeemable Perpetual Preference Shares',

    'CQS symbol': 'TRTNpD',
    'NASDAQ symbol': 'TRTND',
  },
  {
    symbol: 'TRTX',
    'Security Name': 'TPG RE Finance Trust,  ',

    'CQS symbol': 'TRTX',
    'NASDAQ symbol': 'TRTX',
  },
  {
    symbol: 'TRTY',
    'Security Name': 'Cambria Trinity ETF',

    'CQS symbol': 'TRTY',
    'NASDAQ symbol': 'TRTY',
  },
  {
    symbol: 'TRU',
    'Security Name': 'TransUnion ',

    'CQS symbol': 'TRU',
    'NASDAQ symbol': 'TRU',
  },
  {
    symbol: 'TRUE',
    'Security Name': 'TrueCar,   ',

    'NASDAQ symbol': 'TRUE',
  },
  {
    symbol: 'TRUP',
    'Security Name': 'Trupanion,   ',

    'NASDAQ symbol': 'TRUP',
  },
  {
    symbol: 'TRV',
    'Security Name': 'The Travelers Companies,  ',

    'CQS symbol': 'TRV',
    'NASDAQ symbol': 'TRV',
  },
  {
    symbol: 'TRVG',
    'Security Name': 'trivago NV  American Depositary Shares',

    'NASDAQ symbol': 'TRVG',
  },
  {
    symbol: 'TRVI',
    'Security Name': 'Trevi Therapeutics,   ',

    'NASDAQ symbol': 'TRVI',
  },
  {
    symbol: 'TRVN',
    'Security Name': 'Trevena,   ',

    'NASDAQ symbol': 'TRVN',
  },
  {
    symbol: 'TRX',
    'Security Name': 'Tanzanian Gold Corporation ',

    'CQS symbol': 'TRX',
    'NASDAQ symbol': 'TRX',
  },
  {
    symbol: 'TRXC',
    'Security Name': 'TransEnterix,  ',

    'CQS symbol': 'TRXC',
    'NASDAQ symbol': 'TRXC',
  },
  {
    symbol: 'TS',
    'Security Name': 'Tenaris SA American Depositary Shares',

    'CQS symbol': 'TS',
    'NASDAQ symbol': 'TS',
  },
  {
    symbol: 'TSBK',
    'Security Name': 'Timberland Bancorp,   ',

    'NASDAQ symbol': 'TSBK',
  },
  {
    symbol: 'TSC',
    'Security Name': 'TriState Capital Holdings,   ',

    'NASDAQ symbol': 'TSC',
  },
  {
    symbol: 'TSCAP',
    'Security Name':
      'TriState Capital Holdings,   Dep Shs Rep 1/40th Int 675% Srs A NonCum Pfd',

    'NASDAQ symbol': 'TSCAP',
  },
  {
    symbol: 'TSCBP',
    'Security Name':
      'TriState Capital Holdings,   Depositary Share, representing a 1/40th Interest in a Share of 6375% FixedtoFloating Rate Series B NonCumulative Perpetual Preferred Stock',

    'NASDAQ symbol': 'TSCBP',
  },
  {
    symbol: 'TSCO',
    'Security Name': 'Tractor Supply Company  ',

    'NASDAQ symbol': 'TSCO',
  },
  {
    symbol: 'TSE',
    'Security Name': 'Trinseo SA Ordinary Shares',

    'CQS symbol': 'TSE',
    'NASDAQ symbol': 'TSE',
  },
  {
    symbol: 'TSEM',
    'Security Name': 'Tower Semiconductor Ltd  Ordinary Shares',

    'NASDAQ symbol': 'TSEM',
  },
  {
    symbol: 'TSHA',
    'Security Name': 'Taysha Gene Therapies,   ',

    'NASDAQ symbol': 'TSHA',
  },
  {
    symbol: 'TSI',
    'Security Name': 'TCW Strategic ome Fund,  ',

    'CQS symbol': 'TSI',
    'NASDAQ symbol': 'TSI',
  },
  {
    symbol: 'TSIAU',
    'Security Name': 'TS Innovation Acquisitions Corp  Unit',

    'NASDAQ symbol': 'TSIAU',
  },
  {
    symbol: 'TSLA',
    'Security Name': 'Tesla,    ',

    'NASDAQ symbol': 'TSLA',
  },
  {
    symbol: 'TSLX',
    'Security Name': 'Sixth Street Specialty Lending,  ',

    'CQS symbol': 'TSLX',
    'NASDAQ symbol': 'TSLX',
  },
  {
    symbol: 'TSM',
    'Security Name': 'Taiwan Semiconductor Manufacturing Company Ltd',

    'CQS symbol': 'TSM',
    'NASDAQ symbol': 'TSM',
  },
  {
    symbol: 'TSN',
    'Security Name': 'Tyson Foods,  ',

    'CQS symbol': 'TSN',
    'NASDAQ symbol': 'TSN',
  },
  {
    symbol: 'TSOC',
    'Security Name': 'Innovator Triple Stacker ETF  October',

    'CQS symbol': 'TSOC',
    'NASDAQ symbol': 'TSOC',
  },
  {
    symbol: 'TSQ',
    'Security Name': 'Townsquare Media,   ',

    'CQS symbol': 'TSQ',
    'NASDAQ symbol': 'TSQ',
  },
  {
    symbol: 'TSRI',
    'Security Name': 'TSR,   ',

    'NASDAQ symbol': 'TSRI',
  },
  {
    symbol: 'TT',
    'Security Name': 'Trane Technologies plc',

    'CQS symbol': 'TT',
    'NASDAQ symbol': 'TT',
  },
  {
    symbol: 'TTAC',
    'Security Name': 'TrimTabs US Free Cash Flow Quality ETF',

    'CQS symbol': 'TTAC',
    'NASDAQ symbol': 'TTAC',
  },
  {
    symbol: 'TTAI',
    'Security Name': 'TrimTabs International Free Cash Flow Quality ETF',

    'CQS symbol': 'TTAI',
    'NASDAQ symbol': 'TTAI',
  },
  {
    symbol: 'TTC',
    'Security Name': 'Toro Company (The) ',

    'CQS symbol': 'TTC',
    'NASDAQ symbol': 'TTC',
  },
  {
    symbol: 'TTCF',
    'Security Name': 'Tattooed Chef,    ',

    'NASDAQ symbol': 'TTCF',
  },
  {
    symbol: 'TTCFW',
    'Security Name': 'Tattooed Chef,   Warrant',

    'NASDAQ symbol': 'TTCFW',
  },
  {
    symbol: 'TTD',
    'Security Name': 'The Trade Desk,    ',

    'NASDAQ symbol': 'TTD',
  },
  {
    symbol: 'TTEC',
    'Security Name': 'TTEC Holdings,   ',

    'NASDAQ symbol': 'TTEC',
  },
  {
    symbol: 'TTEK',
    'Security Name': 'Tetra Tech,   ',

    'NASDAQ symbol': 'TTEK',
  },
  {
    symbol: 'TTGT',
    'Security Name': 'TechTarget,   ',

    'NASDAQ symbol': 'TTGT',
  },
  {
    symbol: 'TTI',
    'Security Name': 'Tetra Technologies,  ',

    'CQS symbol': 'TTI',
    'NASDAQ symbol': 'TTI',
  },
  {
    symbol: 'TTM',
    'Security Name': 'Tata Motors Ltd Tata Motors Limited',

    'CQS symbol': 'TTM',
    'NASDAQ symbol': 'TTM',
  },
  {
    symbol: 'TTMI',
    'Security Name': 'TTM Technologies,   ',

    'NASDAQ symbol': 'TTMI',
  },
  {
    symbol: 'TTNP',
    'Security Name': 'Titan Pharmaceuticals,   ',

    'NASDAQ symbol': 'TTNP',
  },
  {
    symbol: 'TTOO',
    'Security Name': 'T2 Biosystems,   ',

    'NASDAQ symbol': 'TTOO',
  },
  {
    symbol: 'TTP',
    'Security Name': 'Tortoise Pipeline & Energy Fund,  ',

    'CQS symbol': 'TTP',
    'NASDAQ symbol': 'TTP',
  },
  {
    symbol: 'TTT',
    'Security Name': 'ProShares UltraPro Short 20 Year Treasury',

    'CQS symbol': 'TTT',
    'NASDAQ symbol': 'TTT',
  },
  {
    symbol: 'TTWO',
    'Security Name': 'TakeTwo Interactive Software,   ',

    'NASDAQ symbol': 'TTWO',
  },
  {
    symbol: 'TU',
    'Security Name': 'Telus Corporation Ordinary Shares',

    'CQS symbol': 'TU',
    'NASDAQ symbol': 'TU',
  },
  {
    symbol: 'TUFN',
    'Security Name': 'Tufin Software Technologies Ltd Ordinary Shares',

    'CQS symbol': 'TUFN',
    'NASDAQ symbol': 'TUFN',
  },
  {
    symbol: 'TUP',
    'Security Name': 'Tupperware Brands Corporation ',

    'CQS symbol': 'TUP',
    'NASDAQ symbol': 'TUP',
  },
  {
    symbol: 'TUR',
    'Security Name': 'iShares MSCI Turkey ETF',

    'NASDAQ symbol': 'TUR',
  },
  {
    symbol: 'TURN',
    'Security Name': '180 Degree Capital Corp  ',

    'NASDAQ symbol': 'TURN',
  },
  {
    symbol: 'TUSA',
    'Security Name': 'First Trust Total US Market AlphaDEX ETF',

    'NASDAQ symbol': 'TUSA',
  },
  {
    symbol: 'TUSK',
    'Security Name': 'Mammoth Energy Services,   ',

    'NASDAQ symbol': 'TUSK',
  },
  {
    symbol: 'TV',
    'Security Name': 'Grupo Televisa SA ',

    'CQS symbol': 'TV',
    'NASDAQ symbol': 'TV',
  },
  {
    symbol: 'TVC',
    'Security Name': 'Tennessee Valley Authority ',

    'CQS symbol': 'TVC',
    'NASDAQ symbol': 'TVC',
  },
  {
    symbol: 'TVE',
    'Security Name': 'Tennessee Valley Authority',

    'CQS symbol': 'TVE',
    'NASDAQ symbol': 'TVE',
  },
  {
    symbol: 'TVTX',
    'Security Name': 'Travere Therapeutics,   ',

    'NASDAQ symbol': 'TVTX',
  },
  {
    symbol: 'TVTY',
    'Security Name': 'Tivity Health,   ',

    'NASDAQ symbol': 'TVTY',
  },
  {
    symbol: 'TW',
    'Security Name': 'Tradeweb Markets    ',

    'NASDAQ symbol': 'TW',
  },
  {
    symbol: 'TWCT',
    'Security Name': 'TWC Tech Holdings II Corp   ',

    'NASDAQ symbol': 'TWCT',
  },
  {
    symbol: 'TWCTU',
    'Security Name': 'TWC Tech Holdings II Corp  Unit',

    'NASDAQ symbol': 'TWCTU',
  },
  {
    symbol: 'TWCTW',
    'Security Name': 'TWC Tech Holdings II Corp  Warrant',

    'NASDAQ symbol': 'TWCTW',
  },
  {
    symbol: 'TWI',
    'Security Name': 'Titan International,  (DE) ',

    'CQS symbol': 'TWI',
    'NASDAQ symbol': 'TWI',
  },
  {
    symbol: 'TWIN',
    'Security Name': 'Twin Disc, orporated  ',

    'NASDAQ symbol': 'TWIN',
  },
  {
    symbol: 'TWLO',
    'Security Name': 'Twilio   ',

    'CQS symbol': 'TWLO',
    'NASDAQ symbol': 'TWLO',
  },
  {
    symbol: 'TWM',
    'Security Name': 'ProShares UltraShort Russell2000',

    'CQS symbol': 'TWM',
    'NASDAQ symbol': 'TWM',
  },
  {
    symbol: 'TWN',
    'Security Name': 'Taiwan Fund,  (The) ',

    'CQS symbol': 'TWN',
    'NASDAQ symbol': 'TWN',
  },
  {
    symbol: 'TWND',
    'Security Name': 'Tailwind Acquisition Corp  ',

    'CQS symbol': 'TWND',
    'NASDAQ symbol': 'TWND',
  },
  {
    symbol: 'TWNDU',
    'Security Name':
      'Tailwind Acquisition Corp Units, each consisting of one share of   and onehalf of one warrant',

    'CQS symbol': 'TWNDU',
    'NASDAQ symbol': 'TWND=',
  },
  {
    symbol: 'TWNDW',
    'Security Name':
      'Tailwind Acquisition Corp Redeemable Warrants, each whole warrant exercisable for one share of   at an exercise price of $1150',

    'CQS symbol': 'TWNDWS',
    'NASDAQ symbol': 'TWND+',
  },
  {
    symbol: 'TWNK',
    'Security Name': 'Hostess Brands,    ',

    'NASDAQ symbol': 'TWNK',
  },
  {
    symbol: 'TWNKW',
    'Security Name': 'Hostess Brands,   Warrants',

    'NASDAQ symbol': 'TWNKW',
  },
  {
    symbol: 'TWO',
    'Security Name': 'Two Harbors Investment Corp',

    'CQS symbol': 'TWO',
    'NASDAQ symbol': 'TWO',
  },
  {
    symbol: 'TWO$A',
    'Security Name':
      'Two Harbors Investments Corp 8125% Series A FixedtoFloating Rate Cumulative Redeemable Preferred Stock ($2500 liquidation preference per share)',

    'CQS symbol': 'TWOpA',
    'NASDAQ symbol': 'TWOA',
  },
  {
    symbol: 'TWO$B',
    'Security Name':
      'Two Harbors Investments Corp 7625% Series B FixedtoFloating Rate Cumulative Redeemable Preferred Stock',

    'CQS symbol': 'TWOpB',
    'NASDAQ symbol': 'TWOB',
  },
  {
    symbol: 'TWO$C',
    'Security Name':
      'Two Harbors Investments Corp 725% Series C FixedtoFloating Rate Cumulative Redeemable Preferred Stock',

    'CQS symbol': 'TWOpC',
    'NASDAQ symbol': 'TWOC',
  },
  {
    symbol: 'TWO$D',
    'Security Name':
      'Two Harbors Investments Corp 775% Series D Cumulative Redeemable Preferred Stock',

    'CQS symbol': 'TWOpD',
    'NASDAQ symbol': 'TWOD',
  },
  {
    symbol: 'TWO$E',
    'Security Name':
      'Two Harbors Investments Corp 750% Series E Cumulative Redeemable Preferred Stock',

    'CQS symbol': 'TWOpE',
    'NASDAQ symbol': 'TWOE',
  },
  {
    symbol: 'TWOU',
    'Security Name': '2U,   ',

    'NASDAQ symbol': 'TWOU',
  },
  {
    symbol: 'TWST',
    'Security Name': 'Twist Bioscience Corporation  ',

    'NASDAQ symbol': 'TWST',
  },
  {
    symbol: 'TWTR',
    'Security Name': 'Twitter,  ',

    'CQS symbol': 'TWTR',
    'NASDAQ symbol': 'TWTR',
  },
  {
    symbol: 'TX',
    'Security Name':
      'Ternium SA Ternium SA American Depositary Shares (each representing ten shares, USD100 par value)',

    'CQS symbol': 'TX',
    'NASDAQ symbol': 'TX',
  },
  {
    symbol: 'TXG',
    'Security Name': '10x Genomics,   ',

    'NASDAQ symbol': 'TXG',
  },
  {
    symbol: 'TXMD',
    'Security Name': 'TherapeuticsMD,   ',

    'NASDAQ symbol': 'TXMD',
  },
  {
    symbol: 'TXN',
    'Security Name': 'Texas Instruments orporated  ',

    'NASDAQ symbol': 'TXN',
  },
  {
    symbol: 'TXRH',
    'Security Name': 'Texas Roadhouse,   ',

    'NASDAQ symbol': 'TXRH',
  },
  {
    symbol: 'TXT',
    'Security Name': 'Textron  ',

    'CQS symbol': 'TXT',
    'NASDAQ symbol': 'TXT',
  },
  {
    symbol: 'TY',
    'Security Name': 'Tri Continental Corporation ',

    'CQS symbol': 'TY',
    'NASDAQ symbol': 'TY',
  },
  {
    symbol: 'TY$',
    'Security Name': 'Tri Continental Corporation Preferred Stock',

    'CQS symbol': 'TYp',
    'NASDAQ symbol': 'TY',
  },
  {
    symbol: 'TYD',
    'Security Name': 'Direxion Daily 10Yr Treasury Bull 3x Shrs',

    'CQS symbol': 'TYD',
    'NASDAQ symbol': 'TYD',
  },
  {
    symbol: 'TYG',
    'Security Name': 'Tortoise Energy Infrastructure Corporation ',

    'CQS symbol': 'TYG',
    'NASDAQ symbol': 'TYG',
  },
  {
    symbol: 'TYHT',
    'Security Name': 'Shineco,   ',

    'NASDAQ symbol': 'TYHT',
  },
  {
    symbol: 'TYL',
    'Security Name': 'Tyler Technologies,  ',

    'CQS symbol': 'TYL',
    'NASDAQ symbol': 'TYL',
  },
  {
    symbol: 'TYME',
    'Security Name': 'Tyme Technologies,   ',

    'NASDAQ symbol': 'TYME',
  },
  {
    symbol: 'TYO',
    'Security Name': 'Direxion Daily 10Yr Treasury Bear 3x Shrs',

    'CQS symbol': 'TYO',
    'NASDAQ symbol': 'TYO',
  },
  {
    symbol: 'TZA',
    'Security Name': 'Direxion Small Cap Bear 3X Shares',

    'CQS symbol': 'TZA',
    'NASDAQ symbol': 'TZA',
  },
  {
    symbol: 'TZAC',
    'Security Name': 'Tenzing Acquisition Corp  Ordinary Shares',

    'NASDAQ symbol': 'TZAC',
  },
  {
    symbol: 'TZACU',
    'Security Name': 'Tenzing Acquisition Corp  Units',

    'NASDAQ symbol': 'TZACU',
  },
  {
    symbol: 'TZACW',
    'Security Name': 'Tenzing Acquisition Corp  Warrants',

    'NASDAQ symbol': 'TZACW',
  },
  {
    symbol: 'TZOO',
    'Security Name': 'Travelzoo  ',

    'NASDAQ symbol': 'TZOO',
  },
  {
    symbol: 'U',
    'Security Name': 'Unity Software  ',

    'CQS symbol': 'U',
    'NASDAQ symbol': 'U',
  },
  {
    symbol: 'UA',
    'Security Name': 'Under Armour,  Class C ',

    'CQS symbol': 'UA',
    'NASDAQ symbol': 'UA',
  },
  {
    symbol: 'UAA',
    'Security Name': 'Under Armour,   ',

    'CQS symbol': 'UAA',
    'NASDAQ symbol': 'UAA',
  },
  {
    symbol: 'UAE',
    'Security Name': 'iShares MSCI UAE ETF',

    'NASDAQ symbol': 'UAE',
  },
  {
    symbol: 'UAG',
    'Security Name':
      'ETRACS USB Bloomberg Commodity Index Exchange Traded Notes ETRACS UBS Bloomberg CMCI Agriculture ETN',

    'CQS symbol': 'UAG',
    'NASDAQ symbol': 'UAG',
  },
  {
    symbol: 'UAL',
    'Security Name': 'United Airlines Holdings,   ',

    'NASDAQ symbol': 'UAL',
  },
  {
    symbol: 'UAMY',
    'Security Name': 'United States Antimony Corporation ',

    'CQS symbol': 'UAMY',
    'NASDAQ symbol': 'UAMY',
  },
  {
    symbol: 'UAN',
    'Security Name':
      'CVR Partners, LP Common Units representing Limited Partner Interests',

    'CQS symbol': 'UAN',
    'NASDAQ symbol': 'UAN',
  },
  {
    symbol: 'UAPR',
    'Security Name': 'Innovator S&P 500 Ultra Buffer ETF  April',

    'CQS symbol': 'UAPR',
    'NASDAQ symbol': 'UAPR',
  },
  {
    symbol: 'UAUG',
    'Security Name': 'Innovator S&P 500 Ultra Buffer ETF  August ',

    'CQS symbol': 'UAUG',
    'NASDAQ symbol': 'UAUG',
  },
  {
    symbol: 'UAVS',
    'Security Name': 'AgEagle Aerial Systems,  ',

    'CQS symbol': 'UAVS',
    'NASDAQ symbol': 'UAVS',
  },
  {
    symbol: 'UBA',
    'Security Name': 'Urstadt Biddle Properties  ',

    'CQS symbol': 'UBA',
    'NASDAQ symbol': 'UBA',
  },
  {
    symbol: 'UBCP',
    'Security Name': 'United Bancorp,   ',

    'NASDAQ symbol': 'UBCP',
  },
  {
    symbol: 'UBER',
    'Security Name': 'Uber Technologies,  ',

    'CQS symbol': 'UBER',
    'NASDAQ symbol': 'UBER',
  },
  {
    symbol: 'UBFO',
    'Security Name': 'United Security Bancshares  ',

    'NASDAQ symbol': 'UBFO',
  },
  {
    symbol: 'UBG',
    'Security Name':
      'ETRACS USB Bloomberg Commodity Index Exchange Traded Notes ETRACS UBS Bloomberg CMCI Gold ETN',

    'CQS symbol': 'UBG',
    'NASDAQ symbol': 'UBG',
  },
  {
    symbol: 'UBOH',
    'Security Name': 'United Bancshares,   ',

    'NASDAQ symbol': 'UBOH',
  },
  {
    symbol: 'UBOT',
    'Security Name':
      'Direxion Daily Robotics, Artificial Intelligence & Automation Index Bull 2X Shares',

    'CQS symbol': 'UBOT',
    'NASDAQ symbol': 'UBOT',
  },
  {
    symbol: 'UBP',
    'Security Name': 'Urstadt Biddle Properties  ',

    'CQS symbol': 'UBP',
    'NASDAQ symbol': 'UBP',
  },
  {
    symbol: 'UBP$H',
    'Security Name':
      'Urstadt Biddle Properties  6250% Series H Cumulative Redeemable Preferred Stock',

    'CQS symbol': 'UBPpH',
    'NASDAQ symbol': 'UBPH',
  },
  {
    symbol: 'UBP$K',
    'Security Name':
      'Urstadt Biddle Properties  5875% Series K Cumulative Redeemable Preferred Stock',

    'CQS symbol': 'UBPpK',
    'NASDAQ symbol': 'UBPK',
  },
  {
    symbol: 'UBR',
    'Security Name': 'ProShares Ultra MSCI Brazil Capped',

    'CQS symbol': 'UBR',
    'NASDAQ symbol': 'UBR',
  },
  {
    symbol: 'UBS',
    'Security Name': 'UBS Group AG Registered Ordinary Shares',

    'CQS symbol': 'UBS',
    'NASDAQ symbol': 'UBS',
  },
  {
    symbol: 'UBSI',
    'Security Name': 'United Bankshares,   ',

    'NASDAQ symbol': 'UBSI',
  },
  {
    symbol: 'UBT',
    'Security Name': 'ProShares Ultra 20+ Year Treasury',

    'CQS symbol': 'UBT',
    'NASDAQ symbol': 'UBT',
  },
  {
    symbol: 'UBX',
    'Security Name': 'Unity Biotechnology,   ',

    'NASDAQ symbol': 'UBX',
  },
  {
    symbol: 'UCBI',
    'Security Name': 'United Community Banks,   ',

    'NASDAQ symbol': 'UCBI',
  },
  {
    symbol: 'UCBIO',
    'Security Name':
      'United Community Banks,   Depositary Shares each representing 1/1,000th interest in a share of Series I NonCumulative Preferred Stock',

    'NASDAQ symbol': 'UCBIO',
  },
  {
    symbol: 'UCC',
    'Security Name': 'ProShares Ultra Consumer Services',

    'CQS symbol': 'UCC',
    'NASDAQ symbol': 'UCC',
  },
  {
    symbol: 'UCI',
    'Security Name':
      'ETRACS USB Bloomberg Commodity Index Exchange Traded Notes ETRACS UBS Bloomberg CMCI ETN',

    'CQS symbol': 'UCI',
    'NASDAQ symbol': 'UCI',
  },
  {
    symbol: 'UCIB',
    'Security Name':
      'ETRACS UBS Bloomberg Constant Maturity Commodity Index (CMCI) Total Return ETN Series B due April 5, 2038',

    'CQS symbol': 'UCIB',
    'NASDAQ symbol': 'UCIB',
  },
  {
    symbol: 'UCL',
    'Security Name': 'uCloudlink Group   American Depositary Shares',

    'NASDAQ symbol': 'UCL',
  },
  {
    symbol: 'UCO',
    'Security Name': 'ProShares Ultra Bloomberg Crude Oil',

    'CQS symbol': 'UCO',
    'NASDAQ symbol': 'UCO',
  },
  {
    symbol: 'UCON',
    'Security Name': 'First Trust TCW Unconstrained Plus Bond ETF',

    'CQS symbol': 'UCON',
    'NASDAQ symbol': 'UCON',
  },
  {
    symbol: 'UCTT',
    'Security Name': 'Ultra Clean Holdings,   ',

    'NASDAQ symbol': 'UCTT',
  },
  {
    symbol: 'UDEC',
    'Security Name': 'Innovator S&P 500 Ultra Buffer ETF  December',

    'CQS symbol': 'UDEC',
    'NASDAQ symbol': 'UDEC',
  },
  {
    symbol: 'UDN',
    'Security Name': 'Invesco DB USD Index Bearish ETF',

    'CQS symbol': 'UDN',
    'NASDAQ symbol': 'UDN',
  },
  {
    symbol: 'UDOW',
    'Security Name': 'ProShares UltraPro Dow30',

    'CQS symbol': 'UDOW',
    'NASDAQ symbol': 'UDOW',
  },
  {
    symbol: 'UDR',
    'Security Name': 'UDR,  ',

    'CQS symbol': 'UDR',
    'NASDAQ symbol': 'UDR',
  },
  {
    symbol: 'UE',
    'Security Name':
      'Urban Edge Properties Common Shares of Beneficial Interest',

    'CQS symbol': 'UE',
    'NASDAQ symbol': 'UE',
  },
  {
    symbol: 'UEC',
    'Security Name': 'Uranium Energy Corp ',

    'CQS symbol': 'UEC',
    'NASDAQ symbol': 'UEC',
  },
  {
    symbol: 'UEIC',
    'Security Name': 'Universal Electronics   ',

    'NASDAQ symbol': 'UEIC',
  },
  {
    symbol: 'UEPS',
    'Security Name': 'Net 1 UEPS Technologies,   ',

    'NASDAQ symbol': 'UEPS',
  },
  {
    symbol: 'UEVM',
    'Security Name':
      'VictoryShares USAA MSCI Emerging Markets Value Momentum ETF',

    'CQS symbol': 'UEVM',
    'NASDAQ symbol': 'UEVM',
  },
  {
    symbol: 'UFAB',
    'Security Name': 'Unique Fabricating,  ',

    'CQS symbol': 'UFAB',
    'NASDAQ symbol': 'UFAB',
  },
  {
    symbol: 'UFCS',
    'Security Name': 'United Fire Group,   ',

    'NASDAQ symbol': 'UFCS',
  },
  {
    symbol: 'UFEB',
    'Security Name': 'Innovator S&P 500 Ultra Buffer ETF  February',

    'CQS symbol': 'UFEB',
    'NASDAQ symbol': 'UFEB',
  },
  {
    symbol: 'UFI',
    'Security Name': 'Unifi,  New ',

    'CQS symbol': 'UFI',
    'NASDAQ symbol': 'UFI',
  },
  {
    symbol: 'UFO',
    'Security Name': 'Procure Space ETF',

    'NASDAQ symbol': 'UFO',
  },
  {
    symbol: 'UFPI',
    'Security Name': 'UFP Industries,   ',

    'NASDAQ symbol': 'UFPI',
  },
  {
    symbol: 'UFPT',
    'Security Name': 'UFP Technologies,   ',

    'NASDAQ symbol': 'UFPT',
  },
  {
    symbol: 'UFS',
    'Security Name': 'Domtar Corporation (NEW) ',

    'CQS symbol': 'UFS',
    'NASDAQ symbol': 'UFS',
  },
  {
    symbol: 'UG',
    'Security Name': 'UnitedGuardian,   ',

    'NASDAQ symbol': 'UG',
  },
  {
    symbol: 'UGA',
    'Security Name': 'United States Gasoline Fund LP',

    'CQS symbol': 'UGA',
    'NASDAQ symbol': 'UGA',
  },
  {
    symbol: 'UGE',
    'Security Name': 'ProShares Ultra Consumer Goods',

    'CQS symbol': 'UGE',
    'NASDAQ symbol': 'UGE',
  },
  {
    symbol: 'UGI',
    'Security Name': 'UGI Corporation ',

    'CQS symbol': 'UGI',
    'NASDAQ symbol': 'UGI',
  },
  {
    symbol: 'UGL',
    'Security Name': 'ProShares Ultra Gold',

    'CQS symbol': 'UGL',
    'NASDAQ symbol': 'UGL',
  },
  {
    symbol: 'UGP',
    'Security Name':
      'Ultrapar Participacoes SA (New) American Depositary Shares (Each representing one Common Share)',

    'CQS symbol': 'UGP',
    'NASDAQ symbol': 'UGP',
  },
  {
    symbol: 'UHAL',
    'Security Name': 'Amerco  ',

    'NASDAQ symbol': 'UHAL',
  },
  {
    symbol: 'UHS',
    'Security Name': 'Universal Health Services,  ',

    'CQS symbol': 'UHS',
    'NASDAQ symbol': 'UHS',
  },
  {
    symbol: 'UHT',
    'Security Name': 'Universal Health Realty ome Trust ',

    'CQS symbol': 'UHT',
    'NASDAQ symbol': 'UHT',
  },
  {
    symbol: 'UI',
    'Security Name': 'Ubiquiti  ',

    'CQS symbol': 'UI',
    'NASDAQ symbol': 'UI',
  },
  {
    symbol: 'UIHC',
    'Security Name': 'United Insurance Holdings Corp  ',

    'NASDAQ symbol': 'UIHC',
  },
  {
    symbol: 'UIS',
    'Security Name': 'Unisys Corporation New ',

    'CQS symbol': 'UIS',
    'NASDAQ symbol': 'UIS',
  },
  {
    symbol: 'UITB',
    'Security Name': 'VictoryShares USAA Core IntermediateTerm Bond ETF',

    'CQS symbol': 'UITB',
    'NASDAQ symbol': 'UITB',
  },
  {
    symbol: 'UIVM',
    'Security Name': 'VictoryShares USAA MSCI International Value Momentum ETF',

    'CQS symbol': 'UIVM',
    'NASDAQ symbol': 'UIVM',
  },
  {
    symbol: 'UJAN',
    'Security Name': 'Innovator S&P 500 Ultra Buffer ETF  January',

    'CQS symbol': 'UJAN',
    'NASDAQ symbol': 'UJAN',
  },
  {
    symbol: 'UJB',
    'Security Name': 'ProShares Ultra High Yield ETF',

    'CQS symbol': 'UJB',
    'NASDAQ symbol': 'UJB',
  },
  {
    symbol: 'UJUL',
    'Security Name': 'Innovator S&P 500 Ultra Buffer ETF  July',

    'CQS symbol': 'UJUL',
    'NASDAQ symbol': 'UJUL',
  },
  {
    symbol: 'UJUN',
    'Security Name': 'Innovator S&P 500 Ultra Buffer ETF  June',

    'CQS symbol': 'UJUN',
    'NASDAQ symbol': 'UJUN',
  },
  {
    symbol: 'UK',
    'Security Name': 'Ucommune International Ltd   Ordinary Shares',

    'NASDAQ symbol': 'UK',
  },
  {
    symbol: 'UKOMW',
    'Security Name': 'Ucommune International Ltd   Warrant expiring 11/17/2025',

    'NASDAQ symbol': 'UKOMW',
  },
  {
    symbol: 'UL',
    'Security Name': 'Unilever PLC ',

    'CQS symbol': 'UL',
    'NASDAQ symbol': 'UL',
  },
  {
    symbol: 'ULBI',
    'Security Name': 'Ultralife Corporation  ',

    'NASDAQ symbol': 'ULBI',
  },
  {
    symbol: 'ULE',
    'Security Name': 'ProShares Ultra Euro',

    'CQS symbol': 'ULE',
    'NASDAQ symbol': 'ULE',
  },
  {
    symbol: 'ULH',
    'Security Name': 'Universal Logistics Holdings,   ',

    'NASDAQ symbol': 'ULH',
  },
  {
    symbol: 'ULST',
    'Security Name': 'SPDR SSgA Ultra Short Term Bond ETF',

    'CQS symbol': 'ULST',
    'NASDAQ symbol': 'ULST',
  },
  {
    symbol: 'ULTA',
    'Security Name': 'Ulta Beauty,   ',

    'NASDAQ symbol': 'ULTA',
  },
  {
    symbol: 'ULTR',
    'Security Name': 'IQ Ultra Short Duration ETF',

    'CQS symbol': 'ULTR',
    'NASDAQ symbol': 'ULTR',
  },
  {
    symbol: 'ULVM',
    'Security Name': 'VictoryShares USAA MSCI USA Value Momentum ETF',

    'CQS symbol': 'ULVM',
    'NASDAQ symbol': 'ULVM',
  },
  {
    symbol: 'UMAR',
    'Security Name': 'Innovator S&P 500 Ultra Buffer ETF  March',

    'CQS symbol': 'UMAR',
    'NASDAQ symbol': 'UMAR',
  },
  {
    symbol: 'UMAY',
    'Security Name': 'Innovator S&P 500 Ultra Buffer ETF  May',

    'CQS symbol': 'UMAY',
    'NASDAQ symbol': 'UMAY',
  },
  {
    symbol: 'UMBF',
    'Security Name': 'UMB Financial Corporation  ',

    'NASDAQ symbol': 'UMBF',
  },
  {
    symbol: 'UMC',
    'Security Name': 'United Microelectronics Corporation (NEW) ',

    'CQS symbol': 'UMC',
    'NASDAQ symbol': 'UMC',
  },
  {
    symbol: 'UMDD',
    'Security Name': 'UltraPro MidCap400',

    'CQS symbol': 'UMDD',
    'NASDAQ symbol': 'UMDD',
  },
  {
    symbol: 'UMH',
    'Security Name': 'UMH Properties,  ',

    'CQS symbol': 'UMH',
    'NASDAQ symbol': 'UMH',
  },
  {
    symbol: 'UMH$C',
    'Security Name':
      'UMH Properties,  675% Series C Cumulative Redeemable Preferred Stock,  Liquidation Preference $25 per share',

    'CQS symbol': 'UMHpC',
    'NASDAQ symbol': 'UMHC',
  },
  {
    symbol: 'UMH$D',
    'Security Name':
      'UMH Properties,  6375% Series D Cumulative Redeemable Preferred Stock, Liquidation Preference $25 per share',

    'CQS symbol': 'UMHpD',
    'NASDAQ symbol': 'UMHD',
  },
  {
    symbol: 'UMPQ',
    'Security Name': 'Umpqua Holdings Corporation  ',

    'NASDAQ symbol': 'UMPQ',
  },
  {
    symbol: 'UNAM',
    'Security Name': 'Unico American Corporation  ',

    'NASDAQ symbol': 'UNAM',
  },
  {
    symbol: 'UNB',
    'Security Name': 'Union Bankshares,   ',

    'NASDAQ symbol': 'UNB',
  },
  {
    symbol: 'UNF',
    'Security Name': 'Unifirst Corporation ',

    'CQS symbol': 'UNF',
    'NASDAQ symbol': 'UNF',
  },
  {
    symbol: 'UNFI',
    'Security Name': 'United Natural Foods,  ',

    'CQS symbol': 'UNFI',
    'NASDAQ symbol': 'UNFI',
  },
  {
    symbol: 'UNG',
    'Security Name': 'United States Natural Gas Fund LP',

    'CQS symbol': 'UNG',
    'NASDAQ symbol': 'UNG',
  },
  {
    symbol: 'UNH',
    'Security Name': 'UnitedHealth Group orporated  (DE)',

    'CQS symbol': 'UNH',
    'NASDAQ symbol': 'UNH',
  },
  {
    symbol: 'UNIT',
    'Security Name': 'Uniti Group   ',

    'NASDAQ symbol': 'UNIT',
  },
  {
    symbol: 'UNL',
    'Security Name': 'United States 12 Month Natural Gas Fund',

    'CQS symbol': 'UNL',
    'NASDAQ symbol': 'UNL',
  },
  {
    symbol: 'UNM',
    'Security Name': 'Unum Group ',

    'CQS symbol': 'UNM',
    'NASDAQ symbol': 'UNM',
  },
  {
    symbol: 'UNMA',
    'Security Name': 'Unum Group 6250% Junior Subordinated Notes due 2058',

    'CQS symbol': 'UNMA',
    'NASDAQ symbol': 'UNMA',
  },
  {
    symbol: 'UNOV',
    'Security Name': 'Innovator S&P 500 Ultra Buffer ETF  November',

    'CQS symbol': 'UNOV',
    'NASDAQ symbol': 'UNOV',
  },
  {
    symbol: 'UNP',
    'Security Name': 'Union Pacific Corporation ',

    'CQS symbol': 'UNP',
    'NASDAQ symbol': 'UNP',
  },
  {
    symbol: 'UNTY',
    'Security Name': 'Unity Bancorp,   ',

    'NASDAQ symbol': 'UNTY',
  },
  {
    symbol: 'UNVR',
    'Security Name': 'Univar Solutions  ',

    'CQS symbol': 'UNVR',
    'NASDAQ symbol': 'UNVR',
  },
  {
    symbol: 'UOCT',
    'Security Name': 'Innovator S&P 500 Ultra Buffer ETF  October',

    'CQS symbol': 'UOCT',
    'NASDAQ symbol': 'UOCT',
  },
  {
    symbol: 'UONE',
    'Security Name': 'Urban One,     ',

    'NASDAQ symbol': 'UONE',
  },
  {
    symbol: 'UONEK',
    'Security Name': 'Urban One,    Class D ',

    'NASDAQ symbol': 'UONEK',
  },
  {
    symbol: 'UPLD',
    'Security Name': 'Upland Software,   ',

    'NASDAQ symbol': 'UPLD',
  },
  {
    symbol: 'UPRO',
    'Security Name': 'ProShares UltraPro S&P 500',

    'CQS symbol': 'UPRO',
    'NASDAQ symbol': 'UPRO',
  },
  {
    symbol: 'UPS',
    'Security Name': 'United Parcel Service,  ',

    'CQS symbol': 'UPS',
    'NASDAQ symbol': 'UPS',
  },
  {
    symbol: 'UPV',
    'Security Name': 'ProShares Ultra FTSE Europe',

    'CQS symbol': 'UPV',
    'NASDAQ symbol': 'UPV',
  },
  {
    symbol: 'UPW',
    'Security Name': 'ProShares Ultra Utilities',

    'CQS symbol': 'UPW',
    'NASDAQ symbol': 'UPW',
  },
  {
    symbol: 'UPWK',
    'Security Name': 'Upwork   ',

    'NASDAQ symbol': 'UPWK',
  },
  {
    symbol: 'URA',
    'Security Name': 'Global X Uranium ETF',

    'CQS symbol': 'URA',
    'NASDAQ symbol': 'URA',
  },
  {
    symbol: 'URBN',
    'Security Name': 'Urban Outfitters,   ',

    'NASDAQ symbol': 'URBN',
  },
  {
    symbol: 'URE',
    'Security Name': 'ProShares Ultra Real Estate',

    'CQS symbol': 'URE',
    'NASDAQ symbol': 'URE',
  },
  {
    symbol: 'URG',
    'Security Name': 'Ur Energy  Common Shares (Canada)',

    'CQS symbol': 'URG',
    'NASDAQ symbol': 'URG',
  },
  {
    symbol: 'URGN',
    'Security Name': 'UroGen Pharma Ltd  Ordinary Shares',

    'NASDAQ symbol': 'URGN',
  },
  {
    symbol: 'URI',
    'Security Name': 'United Rentals,  ',

    'CQS symbol': 'URI',
    'NASDAQ symbol': 'URI',
  },
  {
    symbol: 'URNM',
    'Security Name': 'NorthShore Global Uranium Mining ETF',

    'CQS symbol': 'URNM',
    'NASDAQ symbol': 'URNM',
  },
  {
    symbol: 'UROV',
    'Security Name': 'Urovant Sciences Ltd  ',

    'NASDAQ symbol': 'UROV',
  },
  {
    symbol: 'URTH',
    'Security Name': 'Ishares MSCI World Index Fund',

    'CQS symbol': 'URTH',
    'NASDAQ symbol': 'URTH',
  },
  {
    symbol: 'URTY',
    'Security Name': 'ProShares UltraPro Russell2000',

    'CQS symbol': 'URTY',
    'NASDAQ symbol': 'URTY',
  },
  {
    symbol: 'USA',
    'Security Name': 'Liberty AllStar Equity Fund ',

    'CQS symbol': 'USA',
    'NASDAQ symbol': 'USA',
  },
  {
    symbol: 'USAC',
    'Security Name':
      'USA Compression Partners, LP Common Units Representing Limited Partner Interests',

    'CQS symbol': 'USAC',
    'NASDAQ symbol': 'USAC',
  },
  {
    symbol: 'USAI',
    'Security Name': 'Pacer American Energy Independence ETF',

    'CQS symbol': 'USAI',
    'NASDAQ symbol': 'USAI',
  },
  {
    symbol: 'USAK',
    'Security Name': 'USA Truck,   ',

    'NASDAQ symbol': 'USAK',
  },
  {
    symbol: 'USAP',
    'Security Name': 'Universal Stainless & Alloy Products,   ',

    'NASDAQ symbol': 'USAP',
  },
  {
    symbol: 'USAS',
    'Security Name':
      'Americas Gold and Silver Corporation Common Shares, no par value',

    'CQS symbol': 'USAS',
    'NASDAQ symbol': 'USAS',
  },
  {
    symbol: 'USAT',
    'Security Name': 'USA Technologies,   ',

    'NASDAQ symbol': 'USAT',
  },
  {
    symbol: 'USAU',
    'Security Name': 'US Gold Corp  ',

    'NASDAQ symbol': 'USAU',
  },
  {
    symbol: 'USB',
    'Security Name': 'US Bancorp ',

    'CQS symbol': 'USB',
    'NASDAQ symbol': 'USB',
  },
  {
    symbol: 'USB$A',
    'Security Name':
      'US Bancorp Depositary Shares, Each representing a 1/100th interest in a share of Series A NonCumulativePerpetual Pfd Stock',

    'CQS symbol': 'USBpA',
    'NASDAQ symbol': 'USBA',
  },
  {
    symbol: 'USB$H',
    'Security Name': 'US Bancorp Depositary Shares repstg 1/1000th Pfd Ser B',

    'CQS symbol': 'USBpH',
    'NASDAQ symbol': 'USBH',
  },
  {
    symbol: 'USB$M',
    'Security Name':
      'US Bancorp Depositary Shares Representing 1/1000th Interest in a Shares Series F',

    'CQS symbol': 'USBpM',
    'NASDAQ symbol': 'USBM',
  },
  {
    symbol: 'USB$O',
    'Security Name': 'US Bancorp Del Dep Shs Repstg 1/1000th Perp Pfd Ser H',

    'CQS symbol': 'USBpO',
    'NASDAQ symbol': 'USBO',
  },
  {
    symbol: 'USB$P',
    'Security Name':
      'US Bancorp Depositary Shares each representing a 1/1,000th interest in a share of Series K NonCumulative Perpetual Preferred Stock',

    'CQS symbol': 'USBpP',
    'NASDAQ symbol': 'USBP',
  },
  {
    symbol: 'USB$Q',
    'Security Name':
      'US Bancorp Depositary Shares, Each Representing a 1/1,000th Interest in a Share of Series L NonCumulative Perpetual Preferred Stock',

    'CQS symbol': 'USBpQ',
    'NASDAQ symbol': 'USBQ',
  },
  {
    symbol: 'USCI',
    'Security Name': 'United States Commodity Index Fund ETV',

    'CQS symbol': 'USCI',
    'NASDAQ symbol': 'USCI',
  },
  {
    symbol: 'USCR',
    'Security Name': 'U S Concrete,   ',

    'NASDAQ symbol': 'USCR',
  },
  {
    symbol: 'USD',
    'Security Name': 'ProShares Ultra Semiconductors',

    'CQS symbol': 'USD',
    'NASDAQ symbol': 'USD',
  },
  {
    symbol: 'USDP',
    'Security Name':
      'USD Partners LP Common Units representing limited partner interest',

    'CQS symbol': 'USDP',
    'NASDAQ symbol': 'USDP',
  },
  {
    symbol: 'USDU',
    'Security Name': 'WisdomTree Bloomberg US Dollar Bullish Fund',

    'CQS symbol': 'USDU',
    'NASDAQ symbol': 'USDU',
  },
  {
    symbol: 'USEG',
    'Security Name': 'US Energy Corp  ',

    'NASDAQ symbol': 'USEG',
  },
  {
    symbol: 'USEP',
    'Security Name':
      'Innovator ETFs Trust Innovator S&P 500 Ultra Buffer ETF  September',

    'CQS symbol': 'USEP',
    'NASDAQ symbol': 'USEP',
  },
  {
    symbol: 'USEQ',
    'Security Name': 'Invesco Russell 1000 Enhanced Equal Weight ETF',

    'CQS symbol': 'USEQ',
    'NASDAQ symbol': 'USEQ',
  },
  {
    symbol: 'USFD',
    'Security Name': 'US Foods Holding Corp ',

    'CQS symbol': 'USFD',
    'NASDAQ symbol': 'USFD',
  },
  {
    symbol: 'USFR',
    'Security Name': 'WisdomTree Floating Rate Treasury Fund',

    'CQS symbol': 'USFR',
    'NASDAQ symbol': 'USFR',
  },
  {
    symbol: 'USHG',
    'Security Name': 'AGFiQ Dynamic Hedged US Equity ETF',

    'CQS symbol': 'USHG',
    'NASDAQ symbol': 'USHG',
  },
  {
    symbol: 'USHY',
    'Security Name': 'iShares Broad USD High Yield Corporate Bond ETF',

    'CQS symbol': 'USHY',
    'NASDAQ symbol': 'USHY',
  },
  {
    symbol: 'USI',
    'Security Name': 'Pripal UltraShort Active ome ETF',

    'CQS symbol': 'USI',
    'NASDAQ symbol': 'USI',
  },
  {
    symbol: 'USIG',
    'Security Name': 'iShares Broad USD Investment Grade Corporate Bond ETF',

    'NASDAQ symbol': 'USIG',
  },
  {
    symbol: 'USIO',
    'Security Name': 'Usio,   ',

    'NASDAQ symbol': 'USIO',
  },
  {
    symbol: 'USL',
    'Security Name': 'United States 12 Month Oil',

    'CQS symbol': 'USL',
    'NASDAQ symbol': 'USL',
  },
  {
    symbol: 'USLB',
    'Security Name': 'Invesco Russell 1000 Low Beta Equal Weight ETF',

    'NASDAQ symbol': 'USLB',
  },
  {
    symbol: 'USLM',
    'Security Name': 'United States Lime & Minerals,   ',

    'NASDAQ symbol': 'USLM',
  },
  {
    symbol: 'USM',
    'Security Name': 'United States Cellular Corporation ',

    'CQS symbol': 'USM',
    'NASDAQ symbol': 'USM',
  },
  {
    symbol: 'USMC',
    'Security Name': 'Pripal US MegaCap ETF',

    'NASDAQ symbol': 'USMC',
  },
  {
    symbol: 'USMF',
    'Security Name': 'WisdomTree US Multifactor Fund',

    'CQS symbol': 'USMF',
    'NASDAQ symbol': 'USMF',
  },
  {
    symbol: 'USMV',
    'Security Name': 'iShares MSCI USA Min Vol Factor ETF',

    'CQS symbol': 'USMV',
    'NASDAQ symbol': 'USMV',
  },
  {
    symbol: 'USNA',
    'Security Name': 'USANA Health Sciences,  ',

    'CQS symbol': 'USNA',
    'NASDAQ symbol': 'USNA',
  },
  {
    symbol: 'USO',
    'Security Name': 'United States Oil Fund',

    'CQS symbol': 'USO',
    'NASDAQ symbol': 'USO',
  },
  {
    symbol: 'USOI',
    'Security Name': 'Credit Suisse XLinks Crude Oil Shares Covered Call ETN',

    'NASDAQ symbol': 'USOI',
  },
  {
    symbol: 'USPH',
    'Security Name': 'US Physical Therapy,  ',

    'CQS symbol': 'USPH',
    'NASDAQ symbol': 'USPH',
  },
  {
    symbol: 'USRT',
    'Security Name': 'iShares Core US REIT ETF',

    'CQS symbol': 'USRT',
    'NASDAQ symbol': 'USRT',
  },
  {
    symbol: 'USSG',
    'Security Name': 'Xtrackers MSCI USA ESG Leaders Equity ETF',

    'CQS symbol': 'USSG',
    'NASDAQ symbol': 'USSG',
  },
  {
    symbol: 'UST',
    'Security Name': 'ProShares Ultra 710 Year Treasury',

    'CQS symbol': 'UST',
    'NASDAQ symbol': 'UST',
  },
  {
    symbol: 'USTB',
    'Security Name': 'VictoryShares USAA Core ShortTerm Bond ETF',

    'CQS symbol': 'USTB',
    'NASDAQ symbol': 'USTB',
  },
  {
    symbol: 'USV',
    'Security Name':
      'ETRACS USB Bloomberg Commodity Index Exchange Traded Notes ETRACS UBS Bloomberg CMCI Silver ETN',

    'CQS symbol': 'USV',
    'NASDAQ symbol': 'USV',
  },
  {
    symbol: 'USVM',
    'Security Name': 'VictoryShares USAA MSCI USA Small Cap Value Momentum ETF',

    'CQS symbol': 'USVM',
    'NASDAQ symbol': 'USVM',
  },
  {
    symbol: 'USWS',
    'Security Name': 'US Well Services,    ',

    'NASDAQ symbol': 'USWS',
  },
  {
    symbol: 'USWSW',
    'Security Name': 'US Well Services,   Warrants',

    'NASDAQ symbol': 'USWSW',
  },
  {
    symbol: 'USX',
    'Security Name': 'US Xpress Enterprises,   ',

    'CQS symbol': 'USX',
    'NASDAQ symbol': 'USX',
  },
  {
    symbol: 'USXF',
    'Security Name': 'iShares ESG Advanced MSCI USA ETF',

    'NASDAQ symbol': 'USXF',
  },
  {
    symbol: 'UTES',
    'Security Name': 'Virtus Reaves Utilities ETF',

    'CQS symbol': 'UTES',
    'NASDAQ symbol': 'UTES',
  },
  {
    symbol: 'UTF',
    'Security Name': 'Cohen & Steers Infrastructure Fund,  ',

    'CQS symbol': 'UTF',
    'NASDAQ symbol': 'UTF',
  },
  {
    symbol: 'UTG',
    'Security Name':
      'Reaves Utility ome Fund Common Shares of Beneficial Interest',

    'CQS symbol': 'UTG',
    'NASDAQ symbol': 'UTG',
  },
  {
    symbol: 'UTHR',
    'Security Name': 'United Therapeutics Corporation  ',

    'NASDAQ symbol': 'UTHR',
  },
  {
    symbol: 'UTI',
    'Security Name': 'Universal Technical Institute  ',

    'CQS symbol': 'UTI',
    'NASDAQ symbol': 'UTI',
  },
  {
    symbol: 'UTL',
    'Security Name': 'UNITIL Corporation ',

    'CQS symbol': 'UTL',
    'NASDAQ symbol': 'UTL',
  },
  {
    symbol: 'UTMD',
    'Security Name': 'Utah Medical Products,   ',

    'NASDAQ symbol': 'UTMD',
  },
  {
    symbol: 'UTRN',
    'Security Name': 'Vesper US Large Cap ShortTerm Reversal Strategy ETF',

    'CQS symbol': 'UTRN',
    'NASDAQ symbol': 'UTRN',
  },
  {
    symbol: 'UTSI',
    'Security Name': 'UTStarcom Holdings Corp  Ordinary Shares',

    'NASDAQ symbol': 'UTSI',
  },
  {
    symbol: 'UTSL',
    'Security Name': 'Direxion Daily Utilities Bull 3X Shares',

    'CQS symbol': 'UTSL',
    'NASDAQ symbol': 'UTSL',
  },
  {
    symbol: 'UTZ',
    'Security Name': 'Utz Brands    ',

    'CQS symbol': 'UTZ',
    'NASDAQ symbol': 'UTZ',
  },
  {
    symbol: 'UTZW',
    'Security Name':
      'Utz Brands,  Warrants, each whole warrant exercisable for one  ordinary share at an exercise price of $1150 per share',

    'CQS symbol': 'UTZWS',
    'NASDAQ symbol': 'UTZ+',
  },
  {
    symbol: 'UUP',
    'Security Name': 'Invesco DB USD Index Bullish Fund ETF',

    'CQS symbol': 'UUP',
    'NASDAQ symbol': 'UUP',
  },
  {
    symbol: 'UUU',
    'Security Name': 'Universal Security Instruments,  ',

    'CQS symbol': 'UUU',
    'NASDAQ symbol': 'UUU',
  },
  {
    symbol: 'UUUU',
    'Security Name': 'Energy Fuels  Ordinary Shares (Canada)',

    'CQS symbol': 'UUUU',
    'NASDAQ symbol': 'UUUU',
  },
  {
    symbol: 'UUUUW',
    'Security Name':
      'Energy Fuels  Warrants, exercisable for one common share until September 20, 2021 at an exercise price of $245',

    'CQS symbol': 'UUUUWS',
    'NASDAQ symbol': 'UUUU+',
  },
  {
    symbol: 'UVE',
    'Security Name': 'UNIVERSAL INSURANCE HOLDINGS  ',

    'CQS symbol': 'UVE',
    'NASDAQ symbol': 'UVE',
  },
  {
    symbol: 'UVSP',
    'Security Name': 'Univest Financial Corporation  ',

    'NASDAQ symbol': 'UVSP',
  },
  {
    symbol: 'UVV',
    'Security Name': 'Universal Corporation ',

    'CQS symbol': 'UVV',
    'NASDAQ symbol': 'UVV',
  },
  {
    symbol: 'UVXY',
    'Security Name': 'ProShares Trust Ultra VIX Short Term Futures ETF',

    'CQS symbol': 'UVXY',
    'NASDAQ symbol': 'UVXY',
  },
  {
    symbol: 'UWM',
    'Security Name': 'ProShares Ultra Russell2000',

    'CQS symbol': 'UWM',
    'NASDAQ symbol': 'UWM',
  },
  {
    symbol: 'UXI',
    'Security Name': 'ProShares Ultra Industrials',

    'CQS symbol': 'UXI',
    'NASDAQ symbol': 'UXI',
  },
  {
    symbol: 'UXIN',
    'Security Name': 'Uxin Limited  American Depositary Shares',

    'NASDAQ symbol': 'UXIN',
  },
  {
    symbol: 'UYG',
    'Security Name': 'ProShares Ultra Financials',

    'CQS symbol': 'UYG',
    'NASDAQ symbol': 'UYG',
  },
  {
    symbol: 'UYM',
    'Security Name': 'ProShares Ultra Basic Materials',

    'CQS symbol': 'UYM',
    'NASDAQ symbol': 'UYM',
  },
  {
    symbol: 'UZA',
    'Security Name':
      'United States Cellular Corporation 695% Senior Notes due 2060',

    'CQS symbol': 'UZA',
    'NASDAQ symbol': 'UZA',
  },
  {
    symbol: 'UZB',
    'Security Name':
      'United States Cellular Corporation 725% Senior Notes due 2063',

    'CQS symbol': 'UZB',
    'NASDAQ symbol': 'UZB',
  },
  {
    symbol: 'UZC',
    'Security Name':
      'United States Cellular Corporation 725% Senior Notes due 2064',

    'CQS symbol': 'UZC',
    'NASDAQ symbol': 'UZC',
  },
  {
    symbol: 'UZD',
    'Security Name':
      'United States Cellular Corporation 6250% Senior Notes due 2069',

    'CQS symbol': 'UZD',
    'NASDAQ symbol': 'UZD',
  },
  {
    symbol: 'V',
    'Security Name': 'Visa ',

    'CQS symbol': 'V',
    'NASDAQ symbol': 'V',
  },
  {
    symbol: 'VAC',
    'Security Name': 'Marriott Vacations Worldwide Corporation ',

    'CQS symbol': 'VAC',
    'NASDAQ symbol': 'VAC',
  },
  {
    symbol: 'VACQ',
    'Security Name': 'Vector Acquisition Corporation   ',

    'NASDAQ symbol': 'VACQ',
  },
  {
    symbol: 'VACQU',
    'Security Name': 'Vector Acquisition Corporation  Unit',

    'NASDAQ symbol': 'VACQU',
  },
  {
    symbol: 'VACQW',
    'Security Name': 'Vector Acquisition Corporation  Warrant',

    'NASDAQ symbol': 'VACQW',
  },
  {
    symbol: 'VALE',
    'Security Name':
      'VALE SA  American Depositary Shares Each Representing one common share',

    'CQS symbol': 'VALE',
    'NASDAQ symbol': 'VALE',
  },
  {
    symbol: 'VALQ',
    'Security Name': 'American Century STOXX US Quality Value ETF',

    'CQS symbol': 'VALQ',
    'NASDAQ symbol': 'VALQ',
  },
  {
    symbol: 'VALT',
    'Security Name': 'ETFMG Sit Ultra Short ETF',

    'CQS symbol': 'VALT',
    'NASDAQ symbol': 'VALT',
  },
  {
    symbol: 'VALU',
    'Security Name': 'Value Line,   ',

    'NASDAQ symbol': 'VALU',
  },
  {
    symbol: 'VAMO',
    'Security Name': 'Cambria ETF Trust Cambria Value and Momentum ETF',

    'CQS symbol': 'VAMO',
    'NASDAQ symbol': 'VAMO',
  },
  {
    symbol: 'VAPO',
    'Security Name': 'Vapotherm,  ',

    'CQS symbol': 'VAPO',
    'NASDAQ symbol': 'VAPO',
  },
  {
    symbol: 'VAR',
    'Security Name': 'Varian Medical Systems,  ',

    'CQS symbol': 'VAR',
    'NASDAQ symbol': 'VAR',
  },
  {
    symbol: 'VAW',
    'Security Name': 'Vanguard Materials ETF',

    'CQS symbol': 'VAW',
    'NASDAQ symbol': 'VAW',
  },
  {
    symbol: 'VB',
    'Security Name': 'Vanguard SmallCap ETF',

    'CQS symbol': 'VB',
    'NASDAQ symbol': 'VB',
  },
  {
    symbol: 'VBF',
    'Security Name': 'Invesco Bond Fund ',

    'CQS symbol': 'VBF',
    'NASDAQ symbol': 'VBF',
  },
  {
    symbol: 'VBFC',
    'Security Name': 'Village Bank and Trust Financial Corp  ',

    'NASDAQ symbol': 'VBFC',
  },
  {
    symbol: 'VBIV',
    'Security Name': 'VBI Vaccines,   Ordinary Shares',

    'NASDAQ symbol': 'VBIV',
  },
  {
    symbol: 'VBK',
    'Security Name': 'Vanguard SmallCap Growth ETF',

    'CQS symbol': 'VBK',
    'NASDAQ symbol': 'VBK',
  },
  {
    symbol: 'VBLT',
    'Security Name': 'Vascular Biogenics Ltd  Ordinary Shares',

    'NASDAQ symbol': 'VBLT',
  },
  {
    symbol: 'VBND',
    'Security Name':
      'ETF Series Solutions Trust Vident Core US Bond Strategy Fund',

    'CQS symbol': 'VBND',
    'NASDAQ symbol': 'VBND',
  },
  {
    symbol: 'VBR',
    'Security Name': 'Vanguard SmallCap Value ETF',

    'CQS symbol': 'VBR',
    'NASDAQ symbol': 'VBR',
  },
  {
    symbol: 'VBTX',
    'Security Name': 'Veritex Holdings,   ',

    'NASDAQ symbol': 'VBTX',
  },
  {
    symbol: 'VC',
    'Security Name': 'Visteon Corporation  ',

    'NASDAQ symbol': 'VC',
  },
  {
    symbol: 'VCEB',
    'Security Name': 'Vanguard World Funds ETF',

    'CQS symbol': 'VCEB',
    'NASDAQ symbol': 'VCEB',
  },
  {
    symbol: 'VCEL',
    'Security Name': 'Vericel Corporation  ',

    'NASDAQ symbol': 'VCEL',
  },
  {
    symbol: 'VCF',
    'Security Name': 'Delaware Investments Colorado Municipal ome Fund,   ',

    'CQS symbol': 'VCF',
    'NASDAQ symbol': 'VCF',
  },
  {
    symbol: 'VCIF',
    'Security Name':
      'Vertical Capital ome Fund Common Shares of Beneficial Interest',

    'CQS symbol': 'VCIF',
    'NASDAQ symbol': 'VCIF',
  },
  {
    symbol: 'VCIT',
    'Security Name': 'Vanguard IntermediateTerm Corporate Bond ETF',

    'NASDAQ symbol': 'VCIT',
  },
  {
    symbol: 'VCLT',
    'Security Name': 'Vanguard LongTerm Corporate Bond ETF',

    'NASDAQ symbol': 'VCLT',
  },
  {
    symbol: 'VCNX',
    'Security Name': 'Vaccinex,   ',

    'NASDAQ symbol': 'VCNX',
  },
  {
    symbol: 'VCR',
    'Security Name': 'Vanguard Consumer Discretion ETF',

    'CQS symbol': 'VCR',
    'NASDAQ symbol': 'VCR',
  },
  {
    symbol: 'VCRA',
    'Security Name': 'Vocera Communications,  ',

    'CQS symbol': 'VCRA',
    'NASDAQ symbol': 'VCRA',
  },
  {
    symbol: 'VCSH',
    'Security Name': 'Vanguard ShortTerm Corporate Bond ETF',

    'NASDAQ symbol': 'VCSH',
  },
  {
    symbol: 'VCTR',
    'Security Name': 'Victory Capital Holdings,   ',

    'NASDAQ symbol': 'VCTR',
  },
  {
    symbol: 'VCV',
    'Security Name': 'Invesco California Value Municipal ome Trust ',

    'CQS symbol': 'VCV',
    'NASDAQ symbol': 'VCV',
  },
  {
    symbol: 'VCVCU',
    'Security Name': '10X Capital Venture Acquisition Corp  Unit',

    'NASDAQ symbol': 'VCVCU',
  },
  {
    symbol: 'VCYT',
    'Security Name': 'Veracyte,   ',

    'NASDAQ symbol': 'VCYT',
  },
  {
    symbol: 'VDC',
    'Security Name': 'Vanguard Consumer Staples ETF',

    'CQS symbol': 'VDC',
    'NASDAQ symbol': 'VDC',
  },
  {
    symbol: 'VDE',
    'Security Name': 'Vanguard Energy ETF',

    'CQS symbol': 'VDE',
    'NASDAQ symbol': 'VDE',
  },
  {
    symbol: 'VEA',
    'Security Name': 'Vanguard FTSE Developed Markets ETF',

    'CQS symbol': 'VEA',
    'NASDAQ symbol': 'VEA',
  },
  {
    symbol: 'VEC',
    'Security Name': 'Vectrus,  ',

    'CQS symbol': 'VEC',
    'NASDAQ symbol': 'VEC',
  },
  {
    symbol: 'VECO',
    'Security Name': 'Veeco Instruments   ',

    'NASDAQ symbol': 'VECO',
  },
  {
    symbol: 'VEDL',
    'Security Name':
      'Vedanta Limited  American Depositary Shares (Each representing four equity shares)',

    'CQS symbol': 'VEDL',
    'NASDAQ symbol': 'VEDL',
  },
  {
    symbol: 'VEEV',
    'Security Name': 'Veeva Systems   ',

    'CQS symbol': 'VEEV',
    'NASDAQ symbol': 'VEEV',
  },
  {
    symbol: 'VEGA',
    'Security Name': 'AdvisorShares STAR Global BuyWrite ETF',

    'CQS symbol': 'VEGA',
    'NASDAQ symbol': 'VEGA',
  },
  {
    symbol: 'VEGI',
    'Security Name': 'iShares MSCI Agriculture Producers Fund',

    'CQS symbol': 'VEGI',
    'NASDAQ symbol': 'VEGI',
  },
  {
    symbol: 'VEGN',
    'Security Name': 'US Vegan Climate Index',

    'CQS symbol': 'VEGN',
    'NASDAQ symbol': 'VEGN',
  },
  {
    symbol: 'VEL',
    'Security Name': 'Velocity Financial,  ',

    'CQS symbol': 'VEL',
    'NASDAQ symbol': 'VEL',
  },
  {
    symbol: 'VEON',
    'Security Name': 'VEON Ltd  American Depositary Shares',

    'NASDAQ symbol': 'VEON',
  },
  {
    symbol: 'VER',
    'Security Name': 'VEREIT,  ',

    'CQS symbol': 'VER',
    'NASDAQ symbol': 'VER',
  },
  {
    symbol: 'VER$F',
    'Security Name':
      'VEREIT,  670% Series F Cumulative Redeemable Preferred Stock',

    'CQS symbol': 'VERpF',
    'NASDAQ symbol': 'VERF',
  },
  {
    symbol: 'VERB',
    'Security Name': 'Verb Technology Company,   ',

    'NASDAQ symbol': 'VERB',
  },
  {
    symbol: 'VERBW',
    'Security Name': 'Verb Technology Company,   Warrant',

    'NASDAQ symbol': 'VERBW',
  },
  {
    symbol: 'VERI',
    'Security Name': 'Veritone,   ',

    'NASDAQ symbol': 'VERI',
  },
  {
    symbol: 'VERO',
    'Security Name': 'Venus Concept    ',

    'NASDAQ symbol': 'VERO',
  },
  {
    symbol: 'VERTU',
    'Security Name':
      'Vertiv Holdings, LLC Units, each consisting of one share of   and onethird of one redeemable warrant',

    'CQS symbol': 'VERTU',
    'NASDAQ symbol': 'VERT=',
  },
  {
    symbol: 'VERU',
    'Security Name': 'Veru   ',

    'NASDAQ symbol': 'VERU',
  },
  {
    symbol: 'VERX',
    'Security Name': 'Vertex,    ',

    'NASDAQ symbol': 'VERX',
  },
  {
    symbol: 'VERY',
    'Security Name': 'Vericity,   ',

    'NASDAQ symbol': 'VERY',
  },
  {
    symbol: 'VET',
    'Security Name': 'Vermilion Energy  Common (Canada)',

    'CQS symbol': 'VET',
    'NASDAQ symbol': 'VET',
  },
  {
    symbol: 'VETS',
    'Security Name': 'Pacer Military Times Best Employers ETF',

    'NASDAQ symbol': 'VETS',
  },
  {
    symbol: 'VEU',
    'Security Name': 'Vanguard FTSE All World Ex US ETF',

    'CQS symbol': 'VEU',
    'NASDAQ symbol': 'VEU',
  },
  {
    symbol: 'VFC',
    'Security Name': 'VF Corporation ',

    'CQS symbol': 'VFC',
    'NASDAQ symbol': 'VFC',
  },
  {
    symbol: 'VFF',
    'Security Name': 'Village Farms International,   Common Shares',

    'NASDAQ symbol': 'VFF',
  },
  {
    symbol: 'VFH',
    'Security Name': 'Vanguard Financials ETF',

    'CQS symbol': 'VFH',
    'NASDAQ symbol': 'VFH',
  },
  {
    symbol: 'VFL',
    'Security Name': 'Delaware Investments National Municipal ome Fund ',

    'CQS symbol': 'VFL',
    'NASDAQ symbol': 'VFL',
  },
  {
    symbol: 'VFLQ',
    'Security Name': 'Vanguard US Liquidity Factor ETF',

    'CQS symbol': 'VFLQ',
    'NASDAQ symbol': 'VFLQ',
  },
  {
    symbol: 'VFMF',
    'Security Name': 'Vanguard US Multifactor ETF',

    'CQS symbol': 'VFMF',
    'NASDAQ symbol': 'VFMF',
  },
  {
    symbol: 'VFMO',
    'Security Name': 'Vanguard US Momentum Factor ETF',

    'CQS symbol': 'VFMO',
    'NASDAQ symbol': 'VFMO',
  },
  {
    symbol: 'VFMV',
    'Security Name': 'Vanguard US Minimum Volatility ETF',

    'CQS symbol': 'VFMV',
    'NASDAQ symbol': 'VFMV',
  },
  {
    symbol: 'VFQY',
    'Security Name': 'Vanguard US Quality Factor ETF',

    'CQS symbol': 'VFQY',
    'NASDAQ symbol': 'VFQY',
  },
  {
    symbol: 'VFVA',
    'Security Name': 'Vanguard US Value Factor ETF',

    'CQS symbol': 'VFVA',
    'NASDAQ symbol': 'VFVA',
  },
  {
    symbol: 'VG',
    'Security Name': 'Vonage Holdings Corp  ',

    'NASDAQ symbol': 'VG',
  },
  {
    symbol: 'VGAC',
    'Security Name': 'VG Acquisition Corp  Ordinary Shares',

    'CQS symbol': 'VGAC',
    'NASDAQ symbol': 'VGAC',
  },
  {
    symbol: 'VGACU',
    'Security Name':
      'VG Acquisition Corp Units, each consisting of one  ordinary share and onethird of one redeemable warrant',

    'CQS symbol': 'VGACU',
    'NASDAQ symbol': 'VGAC=',
  },
  {
    symbol: 'VGACW',
    'Security Name':
      'VG Acquisition Corp Redeemable warrants, each whole warrant exercisable for one  ordinary share at an exercise price of $1150',

    'CQS symbol': 'VGACWS',
    'NASDAQ symbol': 'VGAC+',
  },
  {
    symbol: 'VGI',
    'Security Name':
      'Virtus Global MultiSector ome Fund Common Shares of Beneficial Interest',

    'CQS symbol': 'VGI',
    'NASDAQ symbol': 'VGI',
  },
  {
    symbol: 'VGIT',
    'Security Name': 'Vanguard IntermediateTerm Treasury ETF',

    'NASDAQ symbol': 'VGIT',
  },
  {
    symbol: 'VGK',
    'Security Name': 'Vanguard FTSEEuropean ETF',

    'CQS symbol': 'VGK',
    'NASDAQ symbol': 'VGK',
  },
  {
    symbol: 'VGLT',
    'Security Name': 'Vanguard LongTreasury ETF',

    'NASDAQ symbol': 'VGLT',
  },
  {
    symbol: 'VGM',
    'Security Name': 'Invesco Trust for Investment Grade Municipals  (DE)',

    'CQS symbol': 'VGM',
    'NASDAQ symbol': 'VGM',
  },
  {
    symbol: 'VGR',
    'Security Name': 'Vector Group Ltd ',

    'CQS symbol': 'VGR',
    'NASDAQ symbol': 'VGR',
  },
  {
    symbol: 'VGSH',
    'Security Name': 'Vanguard ShortTerm Treasury ETF',

    'NASDAQ symbol': 'VGSH',
  },
  {
    symbol: 'VGT',
    'Security Name': 'Vanguard Information Tech ETF',

    'CQS symbol': 'VGT',
    'NASDAQ symbol': 'VGT',
  },
  {
    symbol: 'VGZ',
    'Security Name': 'Vista Gold Corp ',

    'CQS symbol': 'VGZ',
    'NASDAQ symbol': 'VGZ',
  },
  {
    symbol: 'VHC',
    'Security Name': 'VirnetX Holding Corp ',

    'CQS symbol': 'VHC',
    'NASDAQ symbol': 'VHC',
  },
  {
    symbol: 'VHI',
    'Security Name': 'Valhi,  ',

    'CQS symbol': 'VHI',
    'NASDAQ symbol': 'VHI',
  },
  {
    symbol: 'VHT',
    'Security Name': 'Vanguard Health Care ETF',

    'CQS symbol': 'VHT',
    'NASDAQ symbol': 'VHT',
  },
  {
    symbol: 'VIAC',
    'Security Name': 'ViacomCBS   Class B ',

    'NASDAQ symbol': 'VIAC',
  },
  {
    symbol: 'VIACA',
    'Security Name': 'ViacomCBS    ',

    'NASDAQ symbol': 'VIACA',
  },
  {
    symbol: 'VIAO',
    'Security Name':
      'VIA optronics AG American Depositary Shares, each representing onefifth of an Ordinary Share',

    'CQS symbol': 'VIAO',
    'NASDAQ symbol': 'VIAO',
  },
  {
    symbol: 'VIAV',
    'Security Name': 'Viavi Solutions   ',

    'NASDAQ symbol': 'VIAV',
  },
  {
    symbol: 'VICE',
    'Security Name': 'AdvisorShares Trust AdvisorShares Vice ETF',

    'CQS symbol': 'VICE',
    'NASDAQ symbol': 'VICE',
  },
  {
    symbol: 'VICI',
    'Security Name': 'VICI Properties  ',

    'CQS symbol': 'VICI',
    'NASDAQ symbol': 'VICI',
  },
  {
    symbol: 'VICR',
    'Security Name': 'Vicor Corporation  ',

    'NASDAQ symbol': 'VICR',
  },
  {
    symbol: 'VIDI',
    'Security Name':
      'ETF Series Solutions Trust Vident International Equity Fund',

    'CQS symbol': 'VIDI',
    'NASDAQ symbol': 'VIDI',
  },
  {
    symbol: 'VIE',
    'Security Name': 'Viela Bio,   ',

    'NASDAQ symbol': 'VIE',
  },
  {
    symbol: 'VIG',
    'Security Name': 'Vanguard Div Appreciation ETF',

    'CQS symbol': 'VIG',
    'NASDAQ symbol': 'VIG',
  },
  {
    symbol: 'VIGI',
    'Security Name': 'Vanguard International Dividend Appreciation ETF',

    'NASDAQ symbol': 'VIGI',
  },
  {
    symbol: 'VIH',
    'Security Name': 'VPC Impact Acquisition Holdings   Ordinary Shares',

    'NASDAQ symbol': 'VIH',
  },
  {
    symbol: 'VIHAU',
    'Security Name': 'VPC Impact Acquisition Holdings  Unit',

    'NASDAQ symbol': 'VIHAU',
  },
  {
    symbol: 'VIHAW',
    'Security Name': 'VPC Impact Acquisition Holdings  Warrant',

    'NASDAQ symbol': 'VIHAW',
  },
  {
    symbol: 'VIOG',
    'Security Name': 'Vanguard S&P SmallCap 600 Growth ETF',

    'CQS symbol': 'VIOG',
    'NASDAQ symbol': 'VIOG',
  },
  {
    symbol: 'VIOO',
    'Security Name': 'Vanguard S&P SmallCap 600 ETF',

    'CQS symbol': 'VIOO',
    'NASDAQ symbol': 'VIOO',
  },
  {
    symbol: 'VIOT',
    'Security Name': 'Viomi Technology Co, Ltd  American Depositary Shares',

    'NASDAQ symbol': 'VIOT',
  },
  {
    symbol: 'VIOV',
    'Security Name': 'Vanguard S&P SmallCap 600 Value ETF',

    'CQS symbol': 'VIOV',
    'NASDAQ symbol': 'VIOV',
  },
  {
    symbol: 'VIPS',
    'Security Name':
      'Vipshop Holdings Limited American Depositary Shares, each representing two ordinary shares',

    'CQS symbol': 'VIPS',
    'NASDAQ symbol': 'VIPS',
  },
  {
    symbol: 'VIR',
    'Security Name': 'Vir Biotechnology,   ',

    'NASDAQ symbol': 'VIR',
  },
  {
    symbol: 'VIRC',
    'Security Name': 'Virco Manufacturing Corporation  ',

    'NASDAQ symbol': 'VIRC',
  },
  {
    symbol: 'VIRS',
    'Security Name': 'Pacer BioThreat Strategy ETF',

    'CQS symbol': 'VIRS',
    'NASDAQ symbol': 'VIRS',
  },
  {
    symbol: 'VIRT',
    'Security Name': 'Virtu Financial,    ',

    'NASDAQ symbol': 'VIRT',
  },
  {
    symbol: 'VIS',
    'Security Name': 'Vanguard Industrials ETF',

    'CQS symbol': 'VIS',
    'NASDAQ symbol': 'VIS',
  },
  {
    symbol: 'VISL',
    'Security Name': 'Vislink Technologies,   ',

    'NASDAQ symbol': 'VISL',
  },
  {
    symbol: 'VIST',
    'Security Name':
      'Vista Oil & Gas, SAB de CV American Depositary Shares, each representing one series A share, with no par value',

    'CQS symbol': 'VIST',
    'NASDAQ symbol': 'VIST',
  },
  {
    symbol: 'VITL',
    'Security Name': 'Vital Farms,   ',

    'NASDAQ symbol': 'VITL',
  },
  {
    symbol: 'VIV',
    'Security Name':
      'Telefonica Brasil SA American Depositary Shares (Each representing One Common Share)',

    'CQS symbol': 'VIV',
    'NASDAQ symbol': 'VIV',
  },
  {
    symbol: 'VIVE',
    'Security Name': 'Viveve Medical,   ',

    'NASDAQ symbol': 'VIVE',
  },
  {
    symbol: 'VIVO',
    'Security Name': 'Meridian Bioscience   ',

    'NASDAQ symbol': 'VIVO',
  },
  {
    symbol: 'VIXM',
    'Security Name': 'ProShares Trust VIX MidTerm Futures ETF',

    'CQS symbol': 'VIXM',
    'NASDAQ symbol': 'VIXM',
  },
  {
    symbol: 'VIXY',
    'Security Name': 'ProShares Trust VIX ShortTerm Futures ETF',

    'CQS symbol': 'VIXY',
    'NASDAQ symbol': 'VIXY',
  },
  {
    symbol: 'VJET',
    'Security Name': 'voxeljet AG  American Depositary Shares',

    'NASDAQ symbol': 'VJET',
  },
  {
    symbol: 'VKI',
    'Security Name':
      'Invesco Advantage Municipal ome Trust II Common Shares of Beneficial Interest (DE)',

    'CQS symbol': 'VKI',
    'NASDAQ symbol': 'VKI',
  },
  {
    symbol: 'VKQ',
    'Security Name': 'Invesco Municipal Trust ',

    'CQS symbol': 'VKQ',
    'NASDAQ symbol': 'VKQ',
  },
  {
    symbol: 'VKTX',
    'Security Name': 'Viking Therapeutics,   ',

    'NASDAQ symbol': 'VKTX',
  },
  {
    symbol: 'VKTXW',
    'Security Name': 'Viking Therapeutics,   Warrants',

    'NASDAQ symbol': 'VKTXW',
  },
  {
    symbol: 'VLDR',
    'Security Name': 'Velodyne Lidar,   ',

    'NASDAQ symbol': 'VLDR',
  },
  {
    symbol: 'VLDRW',
    'Security Name': 'Velodyne Lidar,   Warrant',

    'NASDAQ symbol': 'VLDRW',
  },
  {
    symbol: 'VLGEA',
    'Security Name': 'Village Super Market,    ',

    'NASDAQ symbol': 'VLGEA',
  },
  {
    symbol: 'VLO',
    'Security Name': 'Valero Energy Corporation ',

    'CQS symbol': 'VLO',
    'NASDAQ symbol': 'VLO',
  },
  {
    symbol: 'VLRS',
    'Security Name':
      'Controladora Vuela Compania de Aviacion, SAB de CV American Depositary Shares, each representing ten (10) Ordinary Participation Certificates',

    'CQS symbol': 'VLRS',
    'NASDAQ symbol': 'VLRS',
  },
  {
    symbol: 'VLT',
    'Security Name': 'Invesco High ome Trust II',

    'CQS symbol': 'VLT',
    'NASDAQ symbol': 'VLT',
  },
  {
    symbol: 'VLU',
    'Security Name': 'SPDR S&P 1500 Value Tilt ETF',

    'CQS symbol': 'VLU',
    'NASDAQ symbol': 'VLU',
  },
  {
    symbol: 'VLUE',
    'Security Name': 'iShares MSCI USA Value Factor ETF',

    'CQS symbol': 'VLUE',
    'NASDAQ symbol': 'VLUE',
  },
  {
    symbol: 'VLY',
    'Security Name': 'Valley National Bancorp  ',

    'NASDAQ symbol': 'VLY',
  },
  {
    symbol: 'VLYPO',
    'Security Name':
      'Valley National Bancorp  55% Fixed to Floating Rate Series B NonCumulative Perpetual Preferred Stock',

    'NASDAQ symbol': 'VLYPO',
  },
  {
    symbol: 'VLYPP',
    'Security Name':
      'Valley National Bancorp  625% FixedtoFloating Rate Series A NonCumulative Perpetual Preferred Stock',

    'NASDAQ symbol': 'VLYPP',
  },
  {
    symbol: 'VMAC',
    'Security Name': 'Vistas Media Acquisition Company    ',

    'NASDAQ symbol': 'VMAC',
  },
  {
    symbol: 'VMACU',
    'Security Name': 'Vistas Media Acquisition Company   Unit',

    'NASDAQ symbol': 'VMACU',
  },
  {
    symbol: 'VMACW',
    'Security Name': 'Vistas Media Acquisition Company   Warrant',

    'NASDAQ symbol': 'VMACW',
  },
  {
    symbol: 'VMAR',
    'Security Name': 'Vision Marine Technologies   Common Shares',

    'NASDAQ symbol': 'VMAR',
  },
  {
    symbol: 'VMBS',
    'Security Name': 'Vanguard MortgageBacked Securities ETF',

    'NASDAQ symbol': 'VMBS',
  },
  {
    symbol: 'VMC',
    'Security Name': 'Vulcan Materials Company (Holding Company) ',

    'CQS symbol': 'VMC',
    'NASDAQ symbol': 'VMC',
  },
  {
    symbol: 'VMD',
    'Security Name': 'Viemed Healthcare,   Common Shares',

    'NASDAQ symbol': 'VMD',
  },
  {
    symbol: 'VMI',
    'Security Name': 'Valmont Industries,  ',

    'CQS symbol': 'VMI',
    'NASDAQ symbol': 'VMI',
  },
  {
    symbol: 'VMM',
    'Security Name': 'Delaware Investments Minnesota Municipal ome Fund II,  ',

    'CQS symbol': 'VMM',
    'NASDAQ symbol': 'VMM',
  },
  {
    symbol: 'VMO',
    'Security Name': 'Invesco Municipal Opportunity Trust ',

    'CQS symbol': 'VMO',
    'NASDAQ symbol': 'VMO',
  },
  {
    symbol: 'VMOT',
    'Security Name': 'Alpha Architect Value Momentum Trend ETF',

    'CQS symbol': 'VMOT',
    'NASDAQ symbol': 'VMOT',
  },
  {
    symbol: 'VMW',
    'Security Name': 'Vmware,  , ',

    'CQS symbol': 'VMW',
    'NASDAQ symbol': 'VMW',
  },
  {
    symbol: 'VNCE',
    'Security Name': 'Ve Holding Corp ',

    'CQS symbol': 'VNCE',
    'NASDAQ symbol': 'VNCE',
  },
  {
    symbol: 'VNDA',
    'Security Name': 'Vanda Pharmaceuticals   ',

    'NASDAQ symbol': 'VNDA',
  },
  {
    symbol: 'VNE',
    'Security Name': 'Veoneer,   ',

    'CQS symbol': 'VNE',
    'NASDAQ symbol': 'VNE',
  },
  {
    symbol: 'VNET',
    'Security Name': '21Vianet Group,   American Depositary Shares',

    'NASDAQ symbol': 'VNET',
  },
  {
    symbol: 'VNLA',
    'Security Name': 'Janus Henderson Short Duration ome ETF',

    'CQS symbol': 'VNLA',
    'NASDAQ symbol': 'VNLA',
  },
  {
    symbol: 'VNM',
    'Security Name': 'VanEck Vectors Vietnam ETF',

    'CQS symbol': 'VNM',
    'NASDAQ symbol': 'VNM',
  },
  {
    symbol: 'VNMC',
    'Security Name': 'Natixis Vaughan Nelson Mid Cap ETF',

    'CQS symbol': 'VNMC',
    'NASDAQ symbol': 'VNMC',
  },
  {
    symbol: 'VNO',
    'Security Name': 'Vornado Realty Trust ',

    'CQS symbol': 'VNO',
    'NASDAQ symbol': 'VNO',
  },
  {
    symbol: 'VNO$K',
    'Security Name': 'Vornado Realty Trust Pfd S K',

    'CQS symbol': 'VNOpK',
    'NASDAQ symbol': 'VNOK',
  },
  {
    symbol: 'VNO$L',
    'Security Name': 'Vornado Realty Trust Pfd Ser L %',

    'CQS symbol': 'VNOpL',
    'NASDAQ symbol': 'VNOL',
  },
  {
    symbol: 'VNO$M',
    'Security Name':
      'Vornado Realty Trust 525% Series M Cumulative Redeemable Preferred Shares of Beneficial Interest, liquidation preference $2500 per share, no par value per share',

    'CQS symbol': 'VNOpM',
    'NASDAQ symbol': 'VNOM',
  },
  {
    symbol: 'VNO$N',
    'Security Name':
      'Vornado Realty Trust 525% Series N Cumulative Redeemable Preferred Shares of Beneficial Interest, liquidation preference $2500 per share',

    'CQS symbol': 'VNOpN',
    'NASDAQ symbol': 'VNON',
  },
  {
    symbol: 'VNOM',
    'Security Name': 'Viper Energy Partners LP  Common Unit',

    'NASDAQ symbol': 'VNOM',
  },
  {
    symbol: 'VNQ',
    'Security Name': 'Vanguard Real Estate ETF',

    'CQS symbol': 'VNQ',
    'NASDAQ symbol': 'VNQ',
  },
  {
    symbol: 'VNQI',
    'Security Name': 'Vanguard Global exUS Real Estate ETF',

    'NASDAQ symbol': 'VNQI',
  },
  {
    symbol: 'VNRX',
    'Security Name': 'VolitionRX Limited ',

    'CQS symbol': 'VNRX',
    'NASDAQ symbol': 'VNRX',
  },
  {
    symbol: 'VNSE',
    'Security Name': 'Natixis Vaughan Nelson Select ETF',

    'CQS symbol': 'VNSE',
    'NASDAQ symbol': 'VNSE',
  },
  {
    symbol: 'VNT',
    'Security Name': 'Vontier Corporation  ',

    'CQS symbol': 'VNT',
    'NASDAQ symbol': 'VNT',
  },
  {
    symbol: 'VNTR',
    'Security Name': 'Venator Materials PLC Ordinary Shares',

    'CQS symbol': 'VNTR',
    'NASDAQ symbol': 'VNTR',
  },
  {
    symbol: 'VO',
    'Security Name': 'Vanguard MidCap ETF',

    'CQS symbol': 'VO',
    'NASDAQ symbol': 'VO',
  },
  {
    symbol: 'VOC',
    'Security Name': 'VOC Energy Trust Units of Beneficial Interest',

    'CQS symbol': 'VOC',
    'NASDAQ symbol': 'VOC',
  },
  {
    symbol: 'VOD',
    'Security Name':
      'Vodafone Group Plc  American Depositary Shares each representing ten Ordinary Shares',

    'NASDAQ symbol': 'VOD',
  },
  {
    symbol: 'VOE',
    'Security Name': 'Vanguard MidCap Value ETF',

    'CQS symbol': 'VOE',
    'NASDAQ symbol': 'VOE',
  },
  {
    symbol: 'VOLT',
    'Security Name': 'Volt Information Sciences,  ',

    'CQS symbol': 'VOLT',
    'NASDAQ symbol': 'VOLT',
  },
  {
    symbol: 'VONE',
    'Security Name': 'Vanguard Russell 1000 ETF',

    'NASDAQ symbol': 'VONE',
  },
  {
    symbol: 'VONG',
    'Security Name': 'Vanguard Russell 1000 Growth ETF',

    'NASDAQ symbol': 'VONG',
  },
  {
    symbol: 'VONV',
    'Security Name': 'Vanguard Russell 1000 Value ETF',

    'NASDAQ symbol': 'VONV',
  },
  {
    symbol: 'VOO',
    'Security Name': 'Vanguard S&P 500 ETF',

    'CQS symbol': 'VOO',
    'NASDAQ symbol': 'VOO',
  },
  {
    symbol: 'VOOG',
    'Security Name': 'Vanguard S&P 500 Growth ETF',

    'CQS symbol': 'VOOG',
    'NASDAQ symbol': 'VOOG',
  },
  {
    symbol: 'VOOV',
    'Security Name': 'Vanguard S&P 500 Value ETF',

    'CQS symbol': 'VOOV',
    'NASDAQ symbol': 'VOOV',
  },
  {
    symbol: 'VOT',
    'Security Name': 'Vanguard MidCap Growth ETF',

    'CQS symbol': 'VOT',
    'NASDAQ symbol': 'VOT',
  },
  {
    symbol: 'VOX',
    'Security Name': 'Vanguard Communication Services  ETF',

    'CQS symbol': 'VOX',
    'NASDAQ symbol': 'VOX',
  },
  {
    symbol: 'VOXX',
    'Security Name': 'VOXX International Corporation   ',

    'NASDAQ symbol': 'VOXX',
  },
  {
    symbol: 'VOYA',
    'Security Name': 'Voya Financial,  ',

    'CQS symbol': 'VOYA',
    'NASDAQ symbol': 'VOYA',
  },
  {
    symbol: 'VOYA$B',
    'Security Name':
      'Voya Financial,  Depositary Shares, each representing a 1/40th interest in a share of 535% FixedRate Reset NonCumulative Preferred Stock, Series B',

    'CQS symbol': 'VOYApB',
    'NASDAQ symbol': 'VOYAB',
  },
  {
    symbol: 'VPC',
    'Security Name': 'Virtus Private Credit Strategy ETF',

    'CQS symbol': 'VPC',
    'NASDAQ symbol': 'VPC',
  },
  {
    symbol: 'VPG',
    'Security Name': 'Vishay Precision Group,  ',

    'CQS symbol': 'VPG',
    'NASDAQ symbol': 'VPG',
  },
  {
    symbol: 'VPL',
    'Security Name': 'Vanguard FTSE Pacific ETF',

    'CQS symbol': 'VPL',
    'NASDAQ symbol': 'VPL',
  },
  {
    symbol: 'VPN',
    'Security Name': 'Global X Data Center REITs & Digital Infrastructure ETF',

    'NASDAQ symbol': 'VPN',
  },
  {
    symbol: 'VPU',
    'Security Name': 'Vanguard Utilities ETF',

    'CQS symbol': 'VPU',
    'NASDAQ symbol': 'VPU',
  },
  {
    symbol: 'VPV',
    'Security Name': 'Invesco Pennsylvania Value Municipal ome Trust  (DE)',

    'CQS symbol': 'VPV',
    'NASDAQ symbol': 'VPV',
  },
  {
    symbol: 'VRA',
    'Security Name': 'Vera Bradley,   ',

    'NASDAQ symbol': 'VRA',
  },
  {
    symbol: 'VRAI',
    'Security Name': 'Virtus Real Asset ome ETF',

    'CQS symbol': 'VRAI',
    'NASDAQ symbol': 'VRAI',
  },
  {
    symbol: 'VRAY',
    'Security Name': 'ViewRay,   ',

    'NASDAQ symbol': 'VRAY',
  },
  {
    symbol: 'VRCA',
    'Security Name': 'Verrica Pharmaceuticals   ',

    'NASDAQ symbol': 'VRCA',
  },
  {
    symbol: 'VREX',
    'Security Name': 'Varex Imaging Corporation  ',

    'NASDAQ symbol': 'VREX',
  },
  {
    symbol: 'VRIG',
    'Security Name': 'Invesco Variable Rate Investment Grade ETF',

    'NASDAQ symbol': 'VRIG',
  },
  {
    symbol: 'VRM',
    'Security Name': 'Vroom,   ',

    'NASDAQ symbol': 'VRM',
  },
  {
    symbol: 'VRME',
    'Security Name': 'VerifyMe,   ',

    'NASDAQ symbol': 'VRME',
  },
  {
    symbol: 'VRMEW',
    'Security Name': 'VerifyMe,   Warrant',

    'NASDAQ symbol': 'VRMEW',
  },
  {
    symbol: 'VRNA',
    'Security Name': 'Verona Pharma plc  American Depositary Shares',

    'NASDAQ symbol': 'VRNA',
  },
  {
    symbol: 'VRNS',
    'Security Name': 'Varonis Systems,   ',

    'NASDAQ symbol': 'VRNS',
  },
  {
    symbol: 'VRNT',
    'Security Name': 'Verint Systems   ',

    'NASDAQ symbol': 'VRNT',
  },
  {
    symbol: 'VRP',
    'Security Name': 'Invesco Variable Rate Preferred ETF',

    'CQS symbol': 'VRP',
    'NASDAQ symbol': 'VRP',
  },
  {
    symbol: 'VRRM',
    'Security Name': 'Verra Mobility Corporation   ',

    'NASDAQ symbol': 'VRRM',
  },
  {
    symbol: 'VRS',
    'Security Name': 'Verso Corporation ',

    'CQS symbol': 'VRS',
    'NASDAQ symbol': 'VRS',
  },
  {
    symbol: 'VRSK',
    'Security Name': 'Verisk Analytics,   ',

    'NASDAQ symbol': 'VRSK',
  },
  {
    symbol: 'VRSN',
    'Security Name': 'VeriSign,   ',

    'NASDAQ symbol': 'VRSN',
  },
  {
    symbol: 'VRT',
    'Security Name': 'Vertiv Holdings, LLC  ',

    'CQS symbol': 'VRT',
    'NASDAQ symbol': 'VRT',
  },
  {
    symbol: 'VRTW',
    'Security Name':
      'Vertiv Holdings, LLC Warrants, each whole warrant exercisable for one share of   at an exercise price of $1150',

    'CQS symbol': 'VRTWS',
    'NASDAQ symbol': 'VRT+',
  },
  {
    symbol: 'VRTS',
    'Security Name': 'Virtus Investment Partners,   ',

    'NASDAQ symbol': 'VRTS',
  },
  {
    symbol: 'VRTU',
    'Security Name': 'Virtusa Corporation  ',

    'NASDAQ symbol': 'VRTU',
  },
  {
    symbol: 'VRTV',
    'Security Name': 'Veritiv Corporation ',

    'CQS symbol': 'VRTV',
    'NASDAQ symbol': 'VRTV',
  },
  {
    symbol: 'VRTX',
    'Security Name': 'Vertex Pharmaceuticals orporated  ',

    'NASDAQ symbol': 'VRTX',
  },
  {
    symbol: 'VSAT',
    'Security Name': 'ViaSat,   ',

    'NASDAQ symbol': 'VSAT',
  },
  {
    symbol: 'VSDA',
    'Security Name': 'VictoryShares Dividend Accelerator ETF',

    'NASDAQ symbol': 'VSDA',
  },
  {
    symbol: 'VSEC',
    'Security Name': 'VSE Corporation  ',

    'NASDAQ symbol': 'VSEC',
  },
  {
    symbol: 'VSGX',
    'Security Name': 'Vanguard ESG International Stock ETF',

    'CQS symbol': 'VSGX',
    'NASDAQ symbol': 'VSGX',
  },
  {
    symbol: 'VSH',
    'Security Name': 'Vishay Intertechnology,  ',

    'CQS symbol': 'VSH',
    'NASDAQ symbol': 'VSH',
  },
  {
    symbol: 'VSL',
    'Security Name': 'Volshares Large Cap ETF',

    'CQS symbol': 'VSL',
    'NASDAQ symbol': 'VSL',
  },
  {
    symbol: 'VSMV',
    'Security Name': 'VictoryShares US MultiFactor Minimum Volatility ETF',

    'NASDAQ symbol': 'VSMV',
  },
  {
    symbol: 'VSPR',
    'Security Name': 'Vesper Healthcare Acquisition Corp   ',

    'NASDAQ symbol': 'VSPR',
  },
  {
    symbol: 'VSPRU',
    'Security Name': 'Vesper Healthcare Acquisition Corp  Unit',

    'NASDAQ symbol': 'VSPRU',
  },
  {
    symbol: 'VSPRW',
    'Security Name': 'Vesper Healthcare Acquisition Corp  Warrant',

    'NASDAQ symbol': 'VSPRW',
  },
  {
    symbol: 'VSS',
    'Security Name': 'Vanguard FTSE AllWld exUS SmCp Idx ETF',

    'CQS symbol': 'VSS',
    'NASDAQ symbol': 'VSS',
  },
  {
    symbol: 'VST',
    'Security Name': 'Vistra Corp ',

    'CQS symbol': 'VST',
    'NASDAQ symbol': 'VST',
  },
  {
    symbol: 'VSTA',
    'Security Name':
      'Vistra Corp Warrants to purchase  (Expirig February 2, 2024)',

    'CQS symbol': 'VSTWSA',
    'NASDAQ symbol': 'VST+A',
  },
  {
    symbol: 'VSTA',
    'Security Name': 'Vasta Platform Limited   Ordinary Shares',

    'NASDAQ symbol': 'VSTA',
  },
  {
    symbol: 'VSTM',
    'Security Name': 'Verastem,   ',

    'NASDAQ symbol': 'VSTM',
  },
  {
    symbol: 'VSTO',
    'Security Name': 'Vista Outdoor  ',

    'CQS symbol': 'VSTO',
    'NASDAQ symbol': 'VSTO',
  },
  {
    symbol: 'VT',
    'Security Name': 'Vanguard Total World Stock Index ETF',

    'CQS symbol': 'VT',
    'NASDAQ symbol': 'VT',
  },
  {
    symbol: 'VTA',
    'Security Name':
      'Invesco Credit Opportunities Fund Common Shares of Beneficial Interest',

    'CQS symbol': 'VTA',
    'NASDAQ symbol': 'VTA',
  },
  {
    symbol: 'VTC',
    'Security Name': 'Vanguard Total Corporate Bond ETF',

    'NASDAQ symbol': 'VTC',
  },
  {
    symbol: 'VTEB',
    'Security Name': 'Vanguard TaxExempt Bond ETF',

    'CQS symbol': 'VTEB',
    'NASDAQ symbol': 'VTEB',
  },
  {
    symbol: 'VTGN',
    'Security Name': 'VistaGen Therapeutics,   ',

    'NASDAQ symbol': 'VTGN',
  },
  {
    symbol: 'VTHR',
    'Security Name': 'Vanguard Russell 3000 ETF',

    'NASDAQ symbol': 'VTHR',
  },
  {
    symbol: 'VTI',
    'Security Name': 'Vanguard Total Stock Market ETF',

    'CQS symbol': 'VTI',
    'NASDAQ symbol': 'VTI',
  },
  {
    symbol: 'VTIP',
    'Security Name':
      'Vanguard ShortTerm InflationProtected Securities Index Fund',

    'NASDAQ symbol': 'VTIP',
  },
  {
    symbol: 'VTN',
    'Security Name': 'Invesco Trust for Investment Grade New York Municipals ',

    'CQS symbol': 'VTN',
    'NASDAQ symbol': 'VTN',
  },
  {
    symbol: 'VTNR',
    'Security Name': 'Vertex Energy,   ',

    'NASDAQ symbol': 'VTNR',
  },
  {
    symbol: 'VTOL',
    'Security Name': 'Bristow Group,  ',

    'CQS symbol': 'VTOL',
    'NASDAQ symbol': 'VTOL',
  },
  {
    symbol: 'VTR',
    'Security Name': 'Ventas,  ',

    'CQS symbol': 'VTR',
    'NASDAQ symbol': 'VTR',
  },
  {
    symbol: 'VTRN',
    'Security Name': 'VictoryShares Top Veteran Employers ETF',

    'NASDAQ symbol': 'VTRN',
  },
  {
    symbol: 'VTRS',
    'Security Name': 'Viatris   ',

    'NASDAQ symbol': 'VTRS',
  },
  {
    symbol: 'VTRU',
    'Security Name': 'Vitru Limited  Common Shares',

    'NASDAQ symbol': 'VTRU',
  },
  {
    symbol: 'VTSI',
    'Security Name': 'VirTra,   ',

    'NASDAQ symbol': 'VTSI',
  },
  {
    symbol: 'VTV',
    'Security Name': 'Vanguard Value ETF',

    'CQS symbol': 'VTV',
    'NASDAQ symbol': 'VTV',
  },
  {
    symbol: 'VTVT',
    'Security Name': 'vTv Therapeutics    ',

    'NASDAQ symbol': 'VTVT',
  },
  {
    symbol: 'VTWG',
    'Security Name': 'Vanguard Russell 2000 Growth ETF',

    'NASDAQ symbol': 'VTWG',
  },
  {
    symbol: 'VTWO',
    'Security Name': 'Vanguard Russell 2000 ETF',

    'NASDAQ symbol': 'VTWO',
  },
  {
    symbol: 'VTWV',
    'Security Name': 'Vanguard Russell 2000 Value ETF',

    'NASDAQ symbol': 'VTWV',
  },
  {
    symbol: 'VUG',
    'Security Name': 'Vanguard Growth ETF',

    'CQS symbol': 'VUG',
    'NASDAQ symbol': 'VUG',
  },
  {
    symbol: 'VUSE',
    'Security Name': 'ETF Series Solutions Trust Vident Core US Equity ETF',

    'CQS symbol': 'VUSE',
    'NASDAQ symbol': 'VUSE',
  },
  {
    symbol: 'VUZI',
    'Security Name': 'Vuzix Corporation  ',

    'NASDAQ symbol': 'VUZI',
  },
  {
    symbol: 'VV',
    'Security Name': 'Vanguard LargeCap ETF',

    'CQS symbol': 'VV',
    'NASDAQ symbol': 'VV',
  },
  {
    symbol: 'VVI',
    'Security Name': 'Viad Corp ',

    'CQS symbol': 'VVI',
    'NASDAQ symbol': 'VVI',
  },
  {
    symbol: 'VVNT',
    'Security Name': 'Vivint Smart Home,  ',

    'CQS symbol': 'VVNT',
    'NASDAQ symbol': 'VVNT',
  },
  {
    symbol: 'VVNTW',
    'Security Name': 'Vivint Smart Home,  Warrants',

    'CQS symbol': 'VVNTWS',
    'NASDAQ symbol': 'VVNT+',
  },
  {
    symbol: 'VVPR',
    'Security Name': 'VivoPower International PLC  Ordinary Shares',

    'NASDAQ symbol': 'VVPR',
  },
  {
    symbol: 'VVR',
    'Security Name': 'Invesco Senior ome Trust  (DE)',

    'CQS symbol': 'VVR',
    'NASDAQ symbol': 'VVR',
  },
  {
    symbol: 'VVV',
    'Security Name': 'Valvoline  ',

    'CQS symbol': 'VVV',
    'NASDAQ symbol': 'VVV',
  },
  {
    symbol: 'VWID',
    'Security Name': 'Virtus WMC International Dividend ETF',

    'CQS symbol': 'VWID',
    'NASDAQ symbol': 'VWID',
  },
  {
    symbol: 'VWO',
    'Security Name': 'Vanguard FTSE Emerging Markets ETF',

    'CQS symbol': 'VWO',
    'NASDAQ symbol': 'VWO',
  },
  {
    symbol: 'VWOB',
    'Security Name': 'Vanguard Emerging Markets Government Bond ETF',

    'NASDAQ symbol': 'VWOB',
  },
  {
    symbol: 'VXF',
    'Security Name': 'Vanguard Extended Market ETF',

    'CQS symbol': 'VXF',
    'NASDAQ symbol': 'VXF',
  },
  {
    symbol: 'VXRT',
    'Security Name': 'Vaxart,   ',

    'NASDAQ symbol': 'VXRT',
  },
  {
    symbol: 'VXUS',
    'Security Name': 'Vanguard Total International Stock ETF',

    'NASDAQ symbol': 'VXUS',
  },
  {
    symbol: 'VXX',
    'Security Name': 'iPath Series B S&P 500 VIX ShortTerm Futures ETN',

    'CQS symbol': 'VXX',
    'NASDAQ symbol': 'VXX',
  },
  {
    symbol: 'VXZ',
    'Security Name': 'iPath Series B S&P 500 VIX MidTerm Futures ETN',

    'CQS symbol': 'VXZ',
    'NASDAQ symbol': 'VXZ',
  },
  {
    symbol: 'VYGG',
    'Security Name': 'Vy Global Growth  Ordinary Shares',

    'CQS symbol': 'VYGG',
    'NASDAQ symbol': 'VYGG',
  },
  {
    symbol: 'VYGGU',
    'Security Name':
      'Vy Global Growth Units, each consisting of one  Ordinary Share, and one fifth of one Warrant to acquire one  Ordinary Share',

    'CQS symbol': 'VYGGU',
    'NASDAQ symbol': 'VYGG=',
  },
  {
    symbol: 'VYGGW',
    'Security Name':
      'Vy Global Growth Warrants, each whole warrant exercisable for one  Ordinary Share at an exercise price of $1150',

    'CQS symbol': 'VYGGWS',
    'NASDAQ symbol': 'VYGG+',
  },
  {
    symbol: 'VYGR',
    'Security Name': 'Voyager Therapeutics,   ',

    'NASDAQ symbol': 'VYGR',
  },
  {
    symbol: 'VYM',
    'Security Name': 'Vanguard High Dividend Yield ETF',

    'CQS symbol': 'VYM',
    'NASDAQ symbol': 'VYM',
  },
  {
    symbol: 'VYMI',
    'Security Name': 'Vanguard International High Dividend Yield ETF',

    'NASDAQ symbol': 'VYMI',
  },
  {
    symbol: 'VYNE',
    'Security Name': 'VYNE Therapeutics   ',

    'NASDAQ symbol': 'VYNE',
  },
  {
    symbol: 'VZ',
    'Security Name': 'Verizon Communications  ',

    'CQS symbol': 'VZ',
    'NASDAQ symbol': 'VZ',
  },
  {
    symbol: 'W',
    'Security Name': 'Wayfair   ',

    'CQS symbol': 'W',
    'NASDAQ symbol': 'W',
  },
  {
    symbol: 'WAB',
    'Security Name': 'Westinghouse Air Brake Technologies Corporation ',

    'CQS symbol': 'WAB',
    'NASDAQ symbol': 'WAB',
  },
  {
    symbol: 'WABC',
    'Security Name': 'Westamerica Bancorporation  ',

    'NASDAQ symbol': 'WABC',
  },
  {
    symbol: 'WAFD',
    'Security Name': 'Washington Federal,   ',

    'NASDAQ symbol': 'WAFD',
  },
  {
    symbol: 'WAFU',
    'Security Name': 'Wah Fu Education Group Limited  Ordinary Shares',

    'NASDAQ symbol': 'WAFU',
  },
  {
    symbol: 'WAL',
    'Security Name': 'Western Alliance Bancorporation  (DE)',

    'CQS symbol': 'WAL',
    'NASDAQ symbol': 'WAL',
  },
  {
    symbol: 'WALA',
    'Security Name':
      'Western Alliance Bancorporation 625% Subordinated Debentures due 2056',

    'CQS symbol': 'WALA',
    'NASDAQ symbol': 'WALA',
  },
  {
    symbol: 'WANT',
    'Security Name': 'Direxion Daily Consumer Discretionary Bull 3X Shares',

    'CQS symbol': 'WANT',
    'NASDAQ symbol': 'WANT',
  },
  {
    symbol: 'WASH',
    'Security Name': 'Washington Trust Bancorp,   ',

    'NASDAQ symbol': 'WASH',
  },
  {
    symbol: 'WAT',
    'Security Name': 'Waters Corporation ',

    'CQS symbol': 'WAT',
    'NASDAQ symbol': 'WAT',
  },
  {
    symbol: 'WATT',
    'Security Name': 'Energous Corporation  ',

    'NASDAQ symbol': 'WATT',
  },
  {
    symbol: 'WB',
    'Security Name': 'Weibo Corporation  American Depositary Shares',

    'NASDAQ symbol': 'WB',
  },
  {
    symbol: 'WBA',
    'Security Name': 'Walgreens Boots Alliance,   ',

    'NASDAQ symbol': 'WBA',
  },
  {
    symbol: 'WBAI',
    'Security Name':
      '500com Limited American Depositary Shares, each representing 10  shares',

    'CQS symbol': 'WBAI',
    'NASDAQ symbol': 'WBAI',
  },
  {
    symbol: 'WBIE',
    'Security Name': 'WBI BullBear Rising ome 3000 ETF',

    'CQS symbol': 'WBIE',
    'NASDAQ symbol': 'WBIE',
  },
  {
    symbol: 'WBIF',
    'Security Name': 'WBI BullBear Value 3000 ETF',

    'CQS symbol': 'WBIF',
    'NASDAQ symbol': 'WBIF',
  },
  {
    symbol: 'WBIG',
    'Security Name': 'WBI BullBear Yield 3000 ETF',

    'CQS symbol': 'WBIG',
    'NASDAQ symbol': 'WBIG',
  },
  {
    symbol: 'WBII',
    'Security Name': 'WBI BullBear Global ome ETF',

    'CQS symbol': 'WBII',
    'NASDAQ symbol': 'WBII',
  },
  {
    symbol: 'WBIL',
    'Security Name': 'WBI BullBear Quality 3000 ETF',

    'CQS symbol': 'WBIL',
    'NASDAQ symbol': 'WBIL',
  },
  {
    symbol: 'WBIN',
    'Security Name': 'WBI BullBear Trend Switch US Total Return ETF',

    'CQS symbol': 'WBIN',
    'NASDAQ symbol': 'WBIN',
  },
  {
    symbol: 'WBIT',
    'Security Name':
      'Absolute Shares Trust WBI BullBear Trend Switch US 3000 Total Return ETF',

    'CQS symbol': 'WBIT',
    'NASDAQ symbol': 'WBIT',
  },
  {
    symbol: 'WBIY',
    'Security Name': 'WBI Power Factor High Dividend ETF',

    'CQS symbol': 'WBIY',
    'NASDAQ symbol': 'WBIY',
  },
  {
    symbol: 'WBK',
    'Security Name': 'Westpac Banking Corporation ',

    'CQS symbol': 'WBK',
    'NASDAQ symbol': 'WBK',
  },
  {
    symbol: 'WBND',
    'Security Name': 'Western Asset Total Return ETF',

    'NASDAQ symbol': 'WBND',
  },
  {
    symbol: 'WBS',
    'Security Name': 'Webster Financial Corporation ',

    'CQS symbol': 'WBS',
    'NASDAQ symbol': 'WBS',
  },
  {
    symbol: 'WBS$F',
    'Security Name':
      'Webster Financial Corporation Depositary Shares, Each Representing 1/1,000th Interest in a Share of 525% Series F NonCumulative Perpetual Preferred Stock',

    'CQS symbol': 'WBSpF',
    'NASDAQ symbol': 'WBSF',
  },
  {
    symbol: 'WBT',
    'Security Name': 'Welbilt,  ',

    'CQS symbol': 'WBT',
    'NASDAQ symbol': 'WBT',
  },
  {
    symbol: 'WCC',
    'Security Name': 'WESCO International,  ',

    'CQS symbol': 'WCC',
    'NASDAQ symbol': 'WCC',
  },
  {
    symbol: 'WCC$A',
    'Security Name':
      'WESCO International,  Depositary Shares each representing 1/1,000th interest in a share of Series A FixedRate Reset Cumulative Perpetual Preferred Stock',

    'CQS symbol': 'WCCpA',
    'NASDAQ symbol': 'WCCA',
  },
  {
    symbol: 'WCLD',
    'Security Name': 'WisdomTree Cloud Computing Fund',

    'NASDAQ symbol': 'WCLD',
  },
  {
    symbol: 'WCN',
    'Security Name': 'Waste Connections,  Common Shares',

    'CQS symbol': 'WCN',
    'NASDAQ symbol': 'WCN',
  },
  {
    symbol: 'WD',
    'Security Name': 'Walker & Dunlop,  ',

    'CQS symbol': 'WD',
    'NASDAQ symbol': 'WD',
  },
  {
    symbol: 'WDAY',
    'Security Name': 'Workday,    ',

    'NASDAQ symbol': 'WDAY',
  },
  {
    symbol: 'WDC',
    'Security Name': 'Western Digital Corporation  ',

    'NASDAQ symbol': 'WDC',
  },
  {
    symbol: 'WDFC',
    'Security Name': 'WD40 Company  ',

    'NASDAQ symbol': 'WDFC',
  },
  {
    symbol: 'WDIV',
    'Security Name': 'SPDR S&P Global Dividend',

    'CQS symbol': 'WDIV',
    'NASDAQ symbol': 'WDIV',
  },
  {
    symbol: 'WDR',
    'Security Name': 'Waddell & Reed Financial,  ',

    'CQS symbol': 'WDR',
    'NASDAQ symbol': 'WDR',
  },
  {
    symbol: 'WEA',
    'Security Name': 'Western Asset Bond Fund Share of Beneficial Interest',

    'CQS symbol': 'WEA',
    'NASDAQ symbol': 'WEA',
  },
  {
    symbol: 'WEAT',
    'Security Name': 'Teucrium Wheat Fund ETV',

    'CQS symbol': 'WEAT',
    'NASDAQ symbol': 'WEAT',
  },
  {
    symbol: 'WEBL',
    'Security Name': 'Direxion Daily Dow Jones Internet Bull 3X Shares',

    'CQS symbol': 'WEBL',
    'NASDAQ symbol': 'WEBL',
  },
  {
    symbol: 'WEBS',
    'Security Name': 'Direxion Daily Dow Jones Internet Bear 3X Shares',

    'CQS symbol': 'WEBS',
    'NASDAQ symbol': 'WEBS',
  },
  {
    symbol: 'WEC',
    'Security Name': 'WEC Energy Group,  ',

    'CQS symbol': 'WEC',
    'NASDAQ symbol': 'WEC',
  },
  {
    symbol: 'WEI',
    'Security Name':
      'Weidai Ltd American depositary shares, each  representing one (1)  ordinary share',

    'CQS symbol': 'WEI',
    'NASDAQ symbol': 'WEI',
  },
  {
    symbol: 'WELL',
    'Security Name': 'Welltower  ',

    'CQS symbol': 'WELL',
    'NASDAQ symbol': 'WELL',
  },
  {
    symbol: 'WEN',
    'Security Name': "Wendy's Company (The)  ",

    'NASDAQ symbol': 'WEN',
  },
  {
    symbol: 'WERN',
    'Security Name': 'Werner Enterprises,   ',

    'NASDAQ symbol': 'WERN',
  },
  {
    symbol: 'WES',
    'Security Name':
      'Western Midstream Partners, LP Common Units Representing Limited Partner Interests',

    'CQS symbol': 'WES',
    'NASDAQ symbol': 'WES',
  },
  {
    symbol: 'WETF',
    'Security Name': 'WisdomTree Investments,   ',

    'NASDAQ symbol': 'WETF',
  },
  {
    symbol: 'WEX',
    'Security Name': 'WEX  ',

    'CQS symbol': 'WEX',
    'NASDAQ symbol': 'WEX',
  },
  {
    symbol: 'WEYS',
    'Security Name': 'Weyco Group,   ',

    'NASDAQ symbol': 'WEYS',
  },
  {
    symbol: 'WF',
    'Security Name':
      'Woori Financial Group  American Depositary Shares (each representing three (3) shares of )',

    'CQS symbol': 'WF',
    'NASDAQ symbol': 'WF',
  },
  {
    symbol: 'WFC',
    'Security Name': 'Wells Fargo & Company ',

    'CQS symbol': 'WFC',
    'NASDAQ symbol': 'WFC',
  },
  {
    symbol: 'WFC$A',
    'Security Name':
      'Wells Fargo & Company Depositary Shares, each representing a 1/1,000th interest in a share of NonCumulative Perpetual  Preferred Stock, Series AA',

    'CQS symbol': 'WFCpA',
    'NASDAQ symbol': 'WFCA',
  },
  {
    symbol: 'WFC$L',
    'Security Name':
      'Wells Fargo & Company Wells Fargo & Company 750% NonCumulative Perpetual Convertible  Preferred Stock, Series L',

    'CQS symbol': 'WFCpL',
    'NASDAQ symbol': 'WFCL',
  },
  {
    symbol: 'WFC$N',
    'Security Name':
      'Wells Fargo & Company Dep Shs Repstg 1/1000th Perp Pfd Cl A Ser N',

    'CQS symbol': 'WFCpN',
    'NASDAQ symbol': 'WFCN',
  },
  {
    symbol: 'WFC$O',
    'Security Name':
      'Wells Fargo & Company Depositary Shares Representing 1/1000th Perpetual Preferred  Series O',

    'CQS symbol': 'WFCpO',
    'NASDAQ symbol': 'WFCO',
  },
  {
    symbol: 'WFC$P',
    'Security Name':
      'Wells Fargo & Company Dep Shs Repstg 1/1000th Int Non Cum Perp Cl A Pfd (Ser P)',

    'CQS symbol': 'WFCpP',
    'NASDAQ symbol': 'WFCP',
  },
  {
    symbol: 'WFC$Q',
    'Security Name':
      'Wells Fargo & Company Depositary Shares Representing 1/1000th Interest Perpetual Preferred  Series Q Fixed to Floating',

    'CQS symbol': 'WFCpQ',
    'NASDAQ symbol': 'WFCQ',
  },
  {
    symbol: 'WFC$R',
    'Security Name':
      'Wells Fargo & Company Dep Shs Repstg 1/1000th Int Perp Pfd Cl A (Ser R Fixed To Flltg)',

    'CQS symbol': 'WFCpR',
    'NASDAQ symbol': 'WFCR',
  },
  {
    symbol: 'WFC$T',
    'Security Name':
      'Wells Fargo & Company New Depository Share Representing 1/1000th Perp Preferred  Series T',

    'CQS symbol': 'WFCpT',
    'NASDAQ symbol': 'WFCT',
  },
  {
    symbol: 'WFC$V',
    'Security Name':
      'Wells Fargo & Company Depositary Shares, each representing a 1/1,000th interest in a share of NonCumulative Perpetual  Preferred Stock, Series V',

    'CQS symbol': 'WFCpV',
    'NASDAQ symbol': 'WFCV',
  },
  {
    symbol: 'WFC$W',
    'Security Name':
      'Wells Fargo & Company Depositary Shares, each representing a 1/1,000th interest in a share of NonCumulative Perpetual  Preferred Stock, Series W',

    'CQS symbol': 'WFCpW',
    'NASDAQ symbol': 'WFCW',
  },
  {
    symbol: 'WFC$X',
    'Security Name':
      'Wells Fargo & Company Depositary Shares, each representing a 1/1,000th interest in a share of NonCumulative Perpetual  Preferred Stock, Series X',

    'CQS symbol': 'WFCpX',
    'NASDAQ symbol': 'WFCX',
  },
  {
    symbol: 'WFC$Y',
    'Security Name':
      'Wells Fargo & Company Depositary Shares, each representing a 1/1,000th interest in a share of NonCumulative Perpetual  Preferred Stock, Series Y',

    'CQS symbol': 'WFCpY',
    'NASDAQ symbol': 'WFCY',
  },
  {
    symbol: 'WFC$Z',
    'Security Name':
      'Wells Fargo & Company Depositary Shares, each representing a 1/1,000th interest in a share of NonCumulative Perpetual  Preferred Stock, Series Z',

    'CQS symbol': 'WFCpZ',
    'NASDAQ symbol': 'WFCZ',
  },
  {
    symbol: 'WFH',
    'Security Name': 'Direxion Work From Home ETF',

    'CQS symbol': 'WFH',
    'NASDAQ symbol': 'WFH',
  },
  {
    symbol: 'WFHY',
    'Security Name': 'WisdomTree US High Yield Corporate Bond Fund',

    'CQS symbol': 'WFHY',
    'NASDAQ symbol': 'WFHY',
  },
  {
    symbol: 'WFIG',
    'Security Name': 'WisdomTree US Corporate Bond Fund',

    'CQS symbol': 'WFIG',
    'NASDAQ symbol': 'WFIG',
  },
  {
    symbol: 'WGO',
    'Security Name': 'Winnebago Industries,  ',

    'CQS symbol': 'WGO',
    'NASDAQ symbol': 'WGO',
  },
  {
    symbol: 'WH',
    'Security Name': 'Wyndham Hotels & Resorts,   ',

    'CQS symbol': 'WH',
    'NASDAQ symbol': 'WH',
  },
  {
    symbol: 'WHD',
    'Security Name': 'Cactus,   ',

    'CQS symbol': 'WHD',
    'NASDAQ symbol': 'WHD',
  },
  {
    symbol: 'WHF',
    'Security Name': 'WhiteHorse Finance,   ',

    'NASDAQ symbol': 'WHF',
  },
  {
    symbol: 'WHFBZ',
    'Security Name': 'WhiteHorse Finance,   650% Notes due 2025',

    'NASDAQ symbol': 'WHFBZ',
  },
  {
    symbol: 'WHG',
    'Security Name': 'Westwood Holdings Group  ',

    'CQS symbol': 'WHG',
    'NASDAQ symbol': 'WHG',
  },
  {
    symbol: 'WHLM',
    'Security Name': 'Wilhelmina International,   ',

    'NASDAQ symbol': 'WHLM',
  },
  {
    symbol: 'WHLR',
    'Security Name': 'Wheeler Real Estate Investment Trust,   ',

    'NASDAQ symbol': 'WHLR',
  },
  {
    symbol: 'WHLRD',
    'Security Name':
      'Wheeler Real Estate Investment Trust,   Series D Cumulative Preferred Stock',

    'NASDAQ symbol': 'WHLRD',
  },
  {
    symbol: 'WHLRP',
    'Security Name':
      'Wheeler Real Estate Investment Trust,   Series B Preferred Stock',

    'NASDAQ symbol': 'WHLRP',
  },
  {
    symbol: 'WHR',
    'Security Name': 'Whirlpool Corporation ',

    'CQS symbol': 'WHR',
    'NASDAQ symbol': 'WHR',
  },
  {
    symbol: 'WIA',
    'Security Name': 'Western Asset InflationLinked ome Fund',

    'CQS symbol': 'WIA',
    'NASDAQ symbol': 'WIA',
  },
  {
    symbol: 'WIFI',
    'Security Name': 'Boingo Wireless,   ',

    'NASDAQ symbol': 'WIFI',
  },
  {
    symbol: 'WIL',
    'Security Name': 'iPath Women in Leadership ETN',

    'CQS symbol': 'WIL',
    'NASDAQ symbol': 'WIL',
  },
  {
    symbol: 'WILC',
    'Security Name': 'G WilliFood International,  Ltd  Ordinary Shares',

    'NASDAQ symbol': 'WILC',
  },
  {
    symbol: 'WIMI',
    'Security Name': 'WiMi Hologram Cloud   American Depositary Share',

    'NASDAQ symbol': 'WIMI',
  },
  {
    symbol: 'WINA',
    'Security Name': 'Winmark Corporation  ',

    'NASDAQ symbol': 'WINA',
  },
  {
    symbol: 'W',
    'Security Name': 'Western Asset Short Duration ome ETF',

    'NASDAQ symbol': 'W',
  },
  {
    symbol: 'WING',
    'Security Name': 'Wingstop   ',

    'NASDAQ symbol': 'WING',
  },
  {
    symbol: 'WINT',
    'Security Name': 'Windtree Therapeutics,   ',

    'NASDAQ symbol': 'WINT',
  },
  {
    symbol: 'WIP',
    'Security Name':
      'SPDR FTSE International Government InflationProtected Bond ETF',

    'CQS symbol': 'WIP',
    'NASDAQ symbol': 'WIP',
  },
  {
    symbol: 'WIRE',
    'Security Name': 'Encore Wire Corporation  ',

    'NASDAQ symbol': 'WIRE',
  },
  {
    symbol: 'WISA',
    'Security Name': 'Summit Wireless Technologies,   ',

    'NASDAQ symbol': 'WISA',
  },
  {
    symbol: 'WIT',
    'Security Name': 'Wipro Limited ',

    'CQS symbol': 'WIT',
    'NASDAQ symbol': 'WIT',
  },
  {
    symbol: 'WIW',
    'Security Name': 'Western Asset InflationLinked Opportunities & ome Fund',

    'CQS symbol': 'WIW',
    'NASDAQ symbol': 'WIW',
  },
  {
    symbol: 'WIX',
    'Security Name': 'Wixcom Ltd  Ordinary Shares',

    'NASDAQ symbol': 'WIX',
  },
  {
    symbol: 'WIZ',
    'Security Name': 'MerlynAI BullRider BearFighter ETF',

    'CQS symbol': 'WIZ',
    'NASDAQ symbol': 'WIZ',
  },
  {
    symbol: 'WK',
    'Security Name': 'Workiva   ',

    'CQS symbol': 'WK',
    'NASDAQ symbol': 'WK',
  },
  {
    symbol: 'WKEY',
    'Security Name':
      'WISeKey International Holding AG  American Depositary Shares',

    'NASDAQ symbol': 'WKEY',
  },
  {
    symbol: 'WKHS',
    'Security Name': 'Workhorse Group,   ',

    'NASDAQ symbol': 'WKHS',
  },
  {
    symbol: 'WLDN',
    'Security Name': 'Willdan Group,   ',

    'NASDAQ symbol': 'WLDN',
  },
  {
    symbol: 'WLDR',
    'Security Name': 'Affinity World Leaders Equity ETF ',

    'CQS symbol': 'WLDR',
    'NASDAQ symbol': 'WLDR',
  },
  {
    symbol: 'WLFC',
    'Security Name': 'Willis Lease Finance Corporation  ',

    'NASDAQ symbol': 'WLFC',
  },
  {
    symbol: 'WLK',
    'Security Name': 'Westlake Chemical Corporation ',

    'CQS symbol': 'WLK',
    'NASDAQ symbol': 'WLK',
  },
  {
    symbol: 'WLKP',
    'Security Name':
      'Westlake Chemical Partners LP Common Units representing limited partner interests',

    'CQS symbol': 'WLKP',
    'NASDAQ symbol': 'WLKP',
  },
  {
    symbol: 'WLL',
    'Security Name': 'Whiting Petroleum Corporation  (New)',

    'CQS symbol': 'WLL',
    'NASDAQ symbol': 'WLL',
  },
  {
    symbol: 'WLTW',
    'Security Name':
      'Willis Towers Watson Public Limited Company  Ordinary Shares',

    'NASDAQ symbol': 'WLTW',
  },
  {
    symbol: 'WM',
    'Security Name': 'Waste Management,  ',

    'CQS symbol': 'WM',
    'NASDAQ symbol': 'WM',
  },
  {
    symbol: 'WMB',
    'Security Name': 'Williams Companies,  (The) ',

    'CQS symbol': 'WMB',
    'NASDAQ symbol': 'WMB',
  },
  {
    symbol: 'WMC',
    'Security Name': 'Western Asset Mortgage Capital Corporation ',

    'CQS symbol': 'WMC',
    'NASDAQ symbol': 'WMC',
  },
  {
    symbol: 'WMG',
    'Security Name': 'Warner Music Group Corp   ',

    'NASDAQ symbol': 'WMG',
  },
  {
    symbol: 'WMK',
    'Security Name': 'Weis Markets,  ',

    'CQS symbol': 'WMK',
    'NASDAQ symbol': 'WMK',
  },
  {
    symbol: 'WMS',
    'Security Name': 'Advanced Drainage Systems,  ',

    'CQS symbol': 'WMS',
    'NASDAQ symbol': 'WMS',
  },
  {
    symbol: 'WMT',
    'Security Name': 'Walmart  ',

    'CQS symbol': 'WMT',
    'NASDAQ symbol': 'WMT',
  },
  {
    symbol: 'WNC',
    'Security Name': 'Wabash National Corporation ',

    'CQS symbol': 'WNC',
    'NASDAQ symbol': 'WNC',
  },
  {
    symbol: 'WNEB',
    'Security Name': 'Western New England Bancorp,   ',

    'NASDAQ symbol': 'WNEB',
  },
  {
    symbol: 'WNS',
    'Security Name': 'WNS (Holdings) Limited Sponsored ADR (Jersey)',

    'CQS symbol': 'WNS',
    'NASDAQ symbol': 'WNS',
  },
  {
    symbol: 'WOMN',
    'Security Name':
      'Impact Shares Trust I ETF Impact Shares YWCA Womenas Empowerment ETF',

    'CQS symbol': 'WOMN',
    'NASDAQ symbol': 'WOMN',
  },
  {
    symbol: 'WOOD',
    'Security Name': 'iShares S&P Global Timber & Forestry Index Fund',

    'NASDAQ symbol': 'WOOD',
  },
  {
    symbol: 'WOR',
    'Security Name': 'Worthington Industries,  ',

    'CQS symbol': 'WOR',
    'NASDAQ symbol': 'WOR',
  },
  {
    symbol: 'WORK',
    'Security Name': 'Slack Technologies,   ',

    'CQS symbol': 'WORK',
    'NASDAQ symbol': 'WORK',
  },
  {
    symbol: 'WORX',
    'Security Name': 'SCWorx Corp  ',

    'NASDAQ symbol': 'WORX',
  },
  {
    symbol: 'WOW',
    'Security Name': 'WideOpenWest,  ',

    'CQS symbol': 'WOW',
    'NASDAQ symbol': 'WOW',
  },
  {
    symbol: 'WPC',
    'Security Name': 'W P Carey  REIT',

    'CQS symbol': 'WPC',
    'NASDAQ symbol': 'WPC',
  },
  {
    symbol: 'WPF',
    'Security Name': 'Foley Trasimene Acquisition Corp  CommonStock',

    'CQS symbol': 'WPF',
    'NASDAQ symbol': 'WPF',
  },
  {
    symbol: 'WPFU',
    'Security Name':
      'Foley Trasimene Acquisition Corp Units, each consisting of one   and onethird of one redeemable warrant',

    'CQS symbol': 'WPFU',
    'NASDAQ symbol': 'WPF=',
  },
  {
    symbol: 'WPFW',
    'Security Name':
      'Foley Trasimene Acquisition Corp Warrants, each whole warrant exercisable for one share of   at an exercise price of $1150 per share',

    'CQS symbol': 'WPFWS',
    'NASDAQ symbol': 'WPF+',
  },
  {
    symbol: 'WPG',
    'Security Name': 'Washington Prime Group  ',

    'CQS symbol': 'WPG',
    'NASDAQ symbol': 'WPG',
  },
  {
    symbol: 'WPG$H',
    'Security Name':
      'Washington Prime Group  75% Series H Cumulative Redeemable Preferred SBI',

    'CQS symbol': 'WPGpH',
    'NASDAQ symbol': 'WPGH',
  },
  {
    symbol: 'WPG$I',
    'Security Name':
      'Washington Prime Group  6875% Series I Cumulative Redeemable Preferred SBI',

    'CQS symbol': 'WPGpI',
    'NASDAQ symbol': 'WPGI',
  },
  {
    symbol: 'WPM',
    'Security Name': 'Wheaton Precious Metals Corp Common Shares (Canada)',

    'CQS symbol': 'WPM',
    'NASDAQ symbol': 'WPM',
  },
  {
    symbol: 'WPP',
    'Security Name': 'WPP plc American Depositary Shares',

    'CQS symbol': 'WPP',
    'NASDAQ symbol': 'WPP',
  },
  {
    symbol: 'WPRT',
    'Security Name': 'Westport Fuel Systems   Common Shares',

    'NASDAQ symbol': 'WPRT',
  },
  {
    symbol: 'WPS',
    'Security Name': 'iShares International Developed Property ETF',

    'CQS symbol': 'WPS',
    'NASDAQ symbol': 'WPS',
  },
  {
    symbol: 'WPX',
    'Security Name': 'WPX Energy,  ',

    'CQS symbol': 'WPX',
    'NASDAQ symbol': 'WPX',
  },
  {
    symbol: 'WRAP',
    'Security Name': 'Wrap Technologies,   ',

    'NASDAQ symbol': 'WRAP',
  },
  {
    symbol: 'WRB',
    'Security Name': 'WR Berkley Corporation ',

    'CQS symbol': 'WRB',
    'NASDAQ symbol': 'WRB',
  },
  {
    symbol: 'WRB$C',
    'Security Name':
      'WR Berkley Corporation 5900% Subordinated Debentures due 2056',

    'CQS symbol': 'WRBpC',
    'NASDAQ symbol': 'WRBC',
  },
  {
    symbol: 'WRB$D',
    'Security Name':
      'WR Berkley Corporation 575% Subordinated Debentures due 2056',

    'CQS symbol': 'WRBpD',
    'NASDAQ symbol': 'WRBD',
  },
  {
    symbol: 'WRB$E',
    'Security Name':
      'WR Berkley Corporation 570% Subordinated Debentures due 2058',

    'CQS symbol': 'WRBpE',
    'NASDAQ symbol': 'WRBE',
  },
  {
    symbol: 'WRB$F',
    'Security Name':
      'WR Berkley Corporation 510% Subordinated Debentures due 2059',

    'CQS symbol': 'WRBpF',
    'NASDAQ symbol': 'WRBF',
  },
  {
    symbol: 'WRB$G',
    'Security Name':
      'WR Berkley Corporation 425% Subordinated Debentures due 2060',

    'CQS symbol': 'WRBpG',
    'NASDAQ symbol': 'WRBG',
  },
  {
    symbol: 'WRE',
    'Security Name': 'Washington Real Estate Investment Trust ',

    'CQS symbol': 'WRE',
    'NASDAQ symbol': 'WRE',
  },
  {
    symbol: 'WRI',
    'Security Name': 'Weingarten Realty Investors ',

    'CQS symbol': 'WRI',
    'NASDAQ symbol': 'WRI',
  },
  {
    symbol: 'WRK',
    'Security Name': 'Westrock Company ',

    'CQS symbol': 'WRK',
    'NASDAQ symbol': 'WRK',
  },
  {
    symbol: 'WRLD',
    'Security Name': 'World Acceptance Corporation  ',

    'NASDAQ symbol': 'WRLD',
  },
  {
    symbol: 'WRN',
    'Security Name': 'Western Copper and Gold Corporation ',

    'CQS symbol': 'WRN',
    'NASDAQ symbol': 'WRN',
  },
  {
    symbol: 'WSBC',
    'Security Name': 'WesBanco,   ',

    'NASDAQ symbol': 'WSBC',
  },
  {
    symbol: 'WSBCP',
    'Security Name':
      'WesBanco,   Depositary Shares, Each Representing a 1/40th Interest in a Share of 675% FixedRate Reset NonCumulative Perpetual Preferred Stock, Series A',

    'NASDAQ symbol': 'WSBCP',
  },
  {
    symbol: 'WSBF',
    'Security Name': 'Waterstone Financial,   ',

    'NASDAQ symbol': 'WSBF',
  },
  {
    symbol: 'WSC',
    'Security Name': 'WillScot Mobile Mini Holdings Corp   ',

    'NASDAQ symbol': 'WSC',
  },
  {
    symbol: 'WSFS',
    'Security Name': 'WSFS Financial Corporation  ',

    'NASDAQ symbol': 'WSFS',
  },
  {
    symbol: 'WSG',
    'Security Name':
      'Wanda Sports Group Company Limited  American Depositary Shares',

    'NASDAQ symbol': 'WSG',
  },
  {
    symbol: 'WSM',
    'Security Name': 'WilliamsSonoma,   (DE)',

    'CQS symbol': 'WSM',
    'NASDAQ symbol': 'WSM',
  },
  {
    symbol: 'WSO',
    'Security Name': 'Watsco,  ',

    'CQS symbol': 'WSO',
    'NASDAQ symbol': 'WSO',
  },
  {
    symbol: 'WSOB',
    'Security Name': 'Watsco,  Class B ',

    'CQS symbol': 'WSOB',
    'NASDAQ symbol': 'WSOB',
  },
  {
    symbol: 'WSR',
    'Security Name': 'Whitestone REIT Common Shares',

    'CQS symbol': 'WSR',
    'NASDAQ symbol': 'WSR',
  },
  {
    symbol: 'WST',
    'Security Name': 'West Pharmaceutical Services,  ',

    'CQS symbol': 'WST',
    'NASDAQ symbol': 'WST',
  },
  {
    symbol: 'WSTG',
    'Security Name': 'Wayside Technology Group,   ',

    'NASDAQ symbol': 'WSTG',
  },
  {
    symbol: 'WTBA',
    'Security Name': 'West Bancorporation  ',

    'NASDAQ symbol': 'WTBA',
  },
  {
    symbol: 'WTER',
    'Security Name': 'The Alkaline Water Company   ',

    'NASDAQ symbol': 'WTER',
  },
  {
    symbol: 'WTFC',
    'Security Name': 'Wintrust Financial Corporation  ',

    'NASDAQ symbol': 'WTFC',
  },
  {
    symbol: 'WTFCM',
    'Security Name':
      'Wintrust Financial Corporation  FixedtoFloating Rate NonCumulative Perpetual Preferred Stock, Series D',

    'NASDAQ symbol': 'WTFCM',
  },
  {
    symbol: 'WTFCP',
    'Security Name':
      'Wintrust Financial Corporation  Depositary Shares, Each Representing a 1/1,000th Interest in a Share of 6875% FixedRate Reset NonCumulative Perpetual Preferred Stock, Series E',

    'NASDAQ symbol': 'WTFCP',
  },
  {
    symbol: 'WTI',
    'Security Name': 'W&T Offshore,  ',

    'CQS symbol': 'WTI',
    'NASDAQ symbol': 'WTI',
  },
  {
    symbol: 'WTM',
    'Security Name': 'White Mountains Insurance Group, Ltd ',

    'CQS symbol': 'WTM',
    'NASDAQ symbol': 'WTM',
  },
  {
    symbol: 'WTMF',
    'Security Name': 'WisdomTree Managed Futures Strategy Fund',

    'CQS symbol': 'WTMF',
    'NASDAQ symbol': 'WTMF',
  },
  {
    symbol: 'WTRE',
    'Security Name': 'Watford Holdings Ltd  Common Shares',

    'NASDAQ symbol': 'WTRE',
  },
  {
    symbol: 'WTREP',
    'Security Name':
      'Watford Holdings Ltd  825% Cumulative Redeemable Preference Shares',

    'NASDAQ symbol': 'WTREP',
  },
  {
    symbol: 'WTRG',
    'Security Name': 'Essential Utilities,  ',

    'CQS symbol': 'WTRG',
    'NASDAQ symbol': 'WTRG',
  },
  {
    symbol: 'WTRH',
    'Security Name': 'Waitr Holdings   ',

    'NASDAQ symbol': 'WTRH',
  },
  {
    symbol: 'WTRU',
    'Security Name': 'Essential Utilities,  600% TEU',

    'CQS symbol': 'WTRU',
    'NASDAQ symbol': 'WTRU',
  },
  {
    symbol: 'WTS',
    'Security Name': 'Watts Water Technologies,   ',

    'CQS symbol': 'WTS',
    'NASDAQ symbol': 'WTS',
  },
  {
    symbol: 'WTT',
    'Security Name': 'Wireless Telecom Group,   ',

    'CQS symbol': 'WTT',
    'NASDAQ symbol': 'WTT',
  },
  {
    symbol: 'WTTR',
    'Security Name': 'Select Energy Services,   ',

    'CQS symbol': 'WTTR',
    'NASDAQ symbol': 'WTTR',
  },
  {
    symbol: 'WU',
    'Security Name': 'Western Union Company (The) ',

    'CQS symbol': 'WU',
    'NASDAQ symbol': 'WU',
  },
  {
    symbol: 'WUGI',
    'Security Name': 'Esoterica NextG Economy ETF',

    'CQS symbol': 'WUGI',
    'NASDAQ symbol': 'WUGI',
  },
  {
    symbol: 'WVE',
    'Security Name': 'Wave Life Sciences Ltd  Ordinary Shares',

    'NASDAQ symbol': 'WVE',
  },
  {
    symbol: 'WVFC',
    'Security Name': 'WVS Financial Corp  ',

    'NASDAQ symbol': 'WVFC',
  },
  {
    symbol: 'WVVI',
    'Security Name': 'Willamette Valley Vineyards,   ',

    'NASDAQ symbol': 'WVVI',
  },
  {
    symbol: 'WVVIP',
    'Security Name':
      'Willamette Valley Vineyards,   Series A Redeemable Preferred Stock',

    'NASDAQ symbol': 'WVVIP',
  },
  {
    symbol: 'WW',
    'Security Name': 'WW International,    ',

    'NASDAQ symbol': 'WW',
  },
  {
    symbol: 'WWD',
    'Security Name': 'Woodward,   ',

    'NASDAQ symbol': 'WWD',
  },
  {
    symbol: 'WWE',
    'Security Name': 'World Wrestling Entertainment,   ',

    'CQS symbol': 'WWE',
    'NASDAQ symbol': 'WWE',
  },
  {
    symbol: 'WWJD',
    'Security Name': 'Inspire International ESG ETF',

    'CQS symbol': 'WWJD',
    'NASDAQ symbol': 'WWJD',
  },
  {
    symbol: 'WWR',
    'Security Name': 'Westwater Resources,   ',

    'NASDAQ symbol': 'WWR',
  },
  {
    symbol: 'WWW',
    'Security Name': 'Wolverine World Wide,  ',

    'CQS symbol': 'WWW',
    'NASDAQ symbol': 'WWW',
  },
  {
    symbol: 'WY',
    'Security Name': 'Weyerhaeuser Company ',

    'CQS symbol': 'WY',
    'NASDAQ symbol': 'WY',
  },
  {
    symbol: 'WYND',
    'Security Name': 'Wyndham Destinations,  Common  Stock',

    'CQS symbol': 'WYND',
    'NASDAQ symbol': 'WYND',
  },
  {
    symbol: 'WYNN',
    'Security Name': 'Wynn Resorts, Limited  ',

    'NASDAQ symbol': 'WYNN',
  },
  {
    symbol: 'WYY',
    'Security Name': 'WidePoint Corporation ',

    'CQS symbol': 'WYY',
    'NASDAQ symbol': 'WYY',
  },
  {
    symbol: 'X',
    'Security Name': 'United States Steel Corporation ',

    'CQS symbol': 'X',
    'NASDAQ symbol': 'X',
  },
  {
    symbol: 'XAIR',
    'Security Name': 'Beyond Air,   ',

    'NASDAQ symbol': 'XAIR',
  },
  {
    symbol: 'XAN',
    'Security Name': 'Exantas Capital Corp',

    'CQS symbol': 'XAN',
    'NASDAQ symbol': 'XAN',
  },
  {
    symbol: 'XAN$C',
    'Security Name': 'Exantas Capital Corp ',

    'CQS symbol': 'XANpC',
    'NASDAQ symbol': 'XANC',
  },
  {
    symbol: 'XAR',
    'Security Name': 'SPDR S&P Aerospace & Defense ETF',

    'CQS symbol': 'XAR',
    'NASDAQ symbol': 'XAR',
  },
  {
    symbol: 'XBI',
    'Security Name': 'SPDR Series Trust  SPDR S&P Biotech ETF',

    'CQS symbol': 'XBI',
    'NASDAQ symbol': 'XBI',
  },
  {
    symbol: 'XBIO',
    'Security Name': 'Xenetic Biosciences,   ',

    'NASDAQ symbol': 'XBIO',
  },
  {
    symbol: 'XBIOW',
    'Security Name': 'Xenetic Biosciences,   Warrants',

    'NASDAQ symbol': 'XBIOW',
  },
  {
    symbol: 'XBIT',
    'Security Name': 'XBiotech   ',

    'NASDAQ symbol': 'XBIT',
  },
  {
    symbol: 'XBUY',
    'Security Name': 'Amplify International Online Retail ETF',

    'CQS symbol': 'XBUY',
    'NASDAQ symbol': 'XBUY',
  },
  {
    symbol: 'XCEM',
    'Security Name': 'Columbia EM Core exChina ETF',

    'CQS symbol': 'XCEM',
    'NASDAQ symbol': 'XCEM',
  },
  {
    symbol: 'XCUR',
    'Security Name': 'Exicure,   ',

    'NASDAQ symbol': 'XCUR',
  },
  {
    symbol: 'XDIV',
    'Security Name': 'US Equity ExDividend Fund Series 2027 Shares',

    'CQS symbol': 'XDIV',
    'NASDAQ symbol': 'XDIV',
  },
  {
    symbol: 'XEC',
    'Security Name': 'Cimarex Energy Co ',

    'CQS symbol': 'XEC',
    'NASDAQ symbol': 'XEC',
  },
  {
    symbol: 'XEL',
    'Security Name': 'Xcel Energy   ',

    'NASDAQ symbol': 'XEL',
  },
  {
    symbol: 'XELA',
    'Security Name': 'Exela Technologies,   ',

    'NASDAQ symbol': 'XELA',
  },
  {
    symbol: 'XELB',
    'Security Name': 'Xcel Brands,   ',

    'NASDAQ symbol': 'XELB',
  },
  {
    symbol: 'XENE',
    'Security Name': 'Xenon Pharmaceuticals   Common Shares',

    'NASDAQ symbol': 'XENE',
  },
  {
    symbol: 'XENT',
    'Security Name': 'Intersect ENT,   ',

    'NASDAQ symbol': 'XENT',
  },
  {
    symbol: 'XERS',
    'Security Name': 'Xeris Pharmaceuticals,   ',

    'NASDAQ symbol': 'XERS',
  },
  {
    symbol: 'XES',
    'Security Name':
      'SPDR Series Trust SPDR S&P Oil & Gas Equipment & Services ETF',

    'CQS symbol': 'XES',
    'NASDAQ symbol': 'XES',
  },
  {
    symbol: 'XFLT',
    'Security Name':
      'XAI Octagon Floating Rate & Alternative ome Term Trust Common Shares of Beneficial Interest',

    'CQS symbol': 'XFLT',
    'NASDAQ symbol': 'XFLT',
  },
  {
    symbol: 'XFOR',
    'Security Name': 'X4 Pharmaceuticals,   ',

    'NASDAQ symbol': 'XFOR',
  },
  {
    symbol: 'XGN',
    'Security Name': 'Exagen   ',

    'NASDAQ symbol': 'XGN',
  },
  {
    symbol: 'XHB',
    'Security Name': 'SPDR Series Trust SPDR Homebuilders ETF',

    'CQS symbol': 'XHB',
    'NASDAQ symbol': 'XHB',
  },
  {
    symbol: 'XHE',
    'Security Name': 'SPDR S&P Health Care Equipment',

    'CQS symbol': 'XHE',
    'NASDAQ symbol': 'XHE',
  },
  {
    symbol: 'XHR',
    'Security Name': 'Xenia Hotels & Resorts,  ',

    'CQS symbol': 'XHR',
    'NASDAQ symbol': 'XHR',
  },
  {
    symbol: 'XHS',
    'Security Name': 'SPDR S&P Health Care Services ETF',

    'CQS symbol': 'XHS',
    'NASDAQ symbol': 'XHS',
  },
  {
    symbol: 'XIN',
    'Security Name': 'Xinyuan Real Estate Co Ltd American Depositary Shares',

    'CQS symbol': 'XIN',
    'NASDAQ symbol': 'XIN',
  },
  {
    symbol: 'XITK',
    'Security Name': 'SPDR FactSet Innovative Technology ETF',

    'CQS symbol': 'XITK',
    'NASDAQ symbol': 'XITK',
  },
  {
    symbol: 'XJH',
    'Security Name': 'iShares ESG Screened S&P MidCap ETF',

    'CQS symbol': 'XJH',
    'NASDAQ symbol': 'XJH',
  },
  {
    symbol: 'XJR',
    'Security Name': 'iShares ESG Screened S&P SmallCap ETF',

    'CQS symbol': 'XJR',
    'NASDAQ symbol': 'XJR',
  },
  {
    symbol: 'XLB',
    'Security Name': 'Materials Select Sector SPDR',

    'CQS symbol': 'XLB',
    'NASDAQ symbol': 'XLB',
  },
  {
    symbol: 'XLC',
    'Security Name': 'The Communication Services Select Sector SPDR Fund',

    'CQS symbol': 'XLC',
    'NASDAQ symbol': 'XLC',
  },
  {
    symbol: 'XLE',
    'Security Name': 'SPDR Select Sector Fund  Energy Select Sector',

    'CQS symbol': 'XLE',
    'NASDAQ symbol': 'XLE',
  },
  {
    symbol: 'XLF',
    'Security Name': 'SPDR Select Sector Fund  Financial',

    'CQS symbol': 'XLF',
    'NASDAQ symbol': 'XLF',
  },
  {
    symbol: 'XLG',
    'Security Name': 'Invesco S&P 500 Top 50 ETF',

    'CQS symbol': 'XLG',
    'NASDAQ symbol': 'XLG',
  },
  {
    symbol: 'XLI',
    'Security Name': 'SPDR Select Sector Fund  Industrial',

    'CQS symbol': 'XLI',
    'NASDAQ symbol': 'XLI',
  },
  {
    symbol: 'XLK',
    'Security Name': 'SPDR Select Sector Fund  Technology',

    'CQS symbol': 'XLK',
    'NASDAQ symbol': 'XLK',
  },
  {
    symbol: 'XLNX',
    'Security Name': 'Xilinx,   ',

    'NASDAQ symbol': 'XLNX',
  },
  {
    symbol: 'XLP',
    'Security Name': 'SPDR Select Sector Fund  Consumer Staples',

    'CQS symbol': 'XLP',
    'NASDAQ symbol': 'XLP',
  },
  {
    symbol: 'XLRE',
    'Security Name': 'Real Estate Select Sector SPDR Fund (The)',

    'CQS symbol': 'XLRE',
    'NASDAQ symbol': 'XLRE',
  },
  {
    symbol: 'XLRN',
    'Security Name': 'Acceleron Pharma   ',

    'NASDAQ symbol': 'XLRN',
  },
  {
    symbol: 'XLSR',
    'Security Name': 'SPDR SSGA US Sector Rotation ETF',

    'CQS symbol': 'XLSR',
    'NASDAQ symbol': 'XLSR',
  },
  {
    symbol: 'XLU',
    'Security Name': 'SPDR Select Sector Fund  Utilities',

    'CQS symbol': 'XLU',
    'NASDAQ symbol': 'XLU',
  },
  {
    symbol: 'XLV',
    'Security Name': 'SPDR Select Sector Fund  Health Care',

    'CQS symbol': 'XLV',
    'NASDAQ symbol': 'XLV',
  },
  {
    symbol: 'XLY',
    'Security Name': 'SPDR Select Sector Fund  Consumer Discretionary',

    'CQS symbol': 'XLY',
    'NASDAQ symbol': 'XLY',
  },
  {
    symbol: 'XME',
    'Security Name': 'SPDR S&P Metals & Mining ETF',

    'CQS symbol': 'XME',
    'NASDAQ symbol': 'XME',
  },
  {
    symbol: 'XMHQ',
    'Security Name': 'Invesco S&P MidCap Quality ETF',

    'CQS symbol': 'XMHQ',
    'NASDAQ symbol': 'XMHQ',
  },
  {
    symbol: 'XMLV',
    'Security Name': 'Invesco S&P MidCap Low Volatility ETF',

    'CQS symbol': 'XMLV',
    'NASDAQ symbol': 'XMLV',
  },
  {
    symbol: 'XMMO',
    'Security Name': 'Invesco S&P MidCap Momentum ETF',

    'CQS symbol': 'XMMO',
    'NASDAQ symbol': 'XMMO',
  },
  {
    symbol: 'XMPT',
    'Security Name': 'VanEck Vectors CEF Municipal ome ETF',

    'CQS symbol': 'XMPT',
    'NASDAQ symbol': 'XMPT',
  },
  {
    symbol: 'XMVM',
    'Security Name': 'Invesco S&P MidCap Value with Momentum ETF',

    'CQS symbol': 'XMVM',
    'NASDAQ symbol': 'XMVM',
  },
  {
    symbol: 'XNCR',
    'Security Name': 'Xencor,   ',

    'NASDAQ symbol': 'XNCR',
  },
  {
    symbol: 'XNET',
    'Security Name': 'Xunlei Limited  American Depositary Shares',

    'NASDAQ symbol': 'XNET',
  },
  {
    symbol: 'XNTK',
    'Security Name': 'SPDR NYSE Technology ETF',

    'CQS symbol': 'XNTK',
    'NASDAQ symbol': 'XNTK',
  },
  {
    symbol: 'XOM',
    'Security Name': 'Exxon Mobil Corporation ',

    'CQS symbol': 'XOM',
    'NASDAQ symbol': 'XOM',
  },
  {
    symbol: 'XOMA',
    'Security Name': 'XOMA Corporation  ',

    'NASDAQ symbol': 'XOMA',
  },
  {
    symbol: 'XONE',
    'Security Name': 'The ExOne Company  ',

    'NASDAQ symbol': 'XONE',
  },
  {
    symbol: 'XOP',
    'Security Name': 'SPDR S&P Oil & Gas Explor & Product',

    'CQS symbol': 'XOP',
    'NASDAQ symbol': 'XOP',
  },
  {
    symbol: 'XOUT',
    'Security Name': 'GraniteShares XOUT US Large Cap ETF',

    'CQS symbol': 'XOUT',
    'NASDAQ symbol': 'XOUT',
  },
  {
    symbol: 'XP',
    'Security Name': 'XP    ',

    'NASDAQ symbol': 'XP',
  },
  {
    symbol: 'XPEL',
    'Security Name': 'XPEL,   ',

    'NASDAQ symbol': 'XPEL',
  },
  {
    symbol: 'XPER',
    'Security Name': 'Xperi Holding Corporation  ',

    'NASDAQ symbol': 'XPER',
  },
  {
    symbol: 'XPEV',
    'Security Name':
      'XPeng  American depositary shares, each representing two  ordinary shares',

    'CQS symbol': 'XPEV',
    'NASDAQ symbol': 'XPEV',
  },
  {
    symbol: 'XPH',
    'Security Name': 'SPDR S&P Pharmaceuticals ETF',

    'CQS symbol': 'XPH',
    'NASDAQ symbol': 'XPH',
  },
  {
    symbol: 'XPL',
    'Security Name': 'Solitario Z Corp ',

    'CQS symbol': 'XPL',
    'NASDAQ symbol': 'XPL',
  },
  {
    symbol: 'XPO',
    'Security Name': 'XPO Logistics, ',

    'CQS symbol': 'XPO',
    'NASDAQ symbol': 'XPO',
  },
  {
    symbol: 'XPOAU',
    'Security Name':
      'DPCM Capital,  Units, each consisting of one share of   and onethird of one redeemable warrant',

    'CQS symbol': 'XPOAU',
    'NASDAQ symbol': 'XPOA=',
  },
  {
    symbol: 'XPP',
    'Security Name': 'ProShares Ultra FTSE China 50',

    'CQS symbol': 'XPP',
    'NASDAQ symbol': 'XPP',
  },
  {
    symbol: 'XRAY',
    'Security Name': 'DENTSPLY SIRONA   ',

    'NASDAQ symbol': 'XRAY',
  },
  {
    symbol: 'XRLV',
    'Security Name': 'Invesco S&P 500 exRate Sensitive Low Volatility ETF',

    'CQS symbol': 'XRLV',
    'NASDAQ symbol': 'XRLV',
  },
  {
    symbol: 'XRT',
    'Security Name': 'SPDR S&P Retail ETF',

    'CQS symbol': 'XRT',
    'NASDAQ symbol': 'XRT',
  },
  {
    symbol: 'XRX',
    'Security Name': 'Xerox Holdings Corporation ',

    'CQS symbol': 'XRX',
    'NASDAQ symbol': 'XRX',
  },
  {
    symbol: 'XSD',
    'Security Name': 'SPDR S&P Semiconductor ETF',

    'CQS symbol': 'XSD',
    'NASDAQ symbol': 'XSD',
  },
  {
    symbol: 'XSHD',
    'Security Name': 'Invesco S&P SmallCap High Dividend Low Volatility ETF',

    'CQS symbol': 'XSHD',
    'NASDAQ symbol': 'XSHD',
  },
  {
    symbol: 'XSHQ',
    'Security Name': 'Invesco S&P SmallCap Quality ETF',

    'CQS symbol': 'XSHQ',
    'NASDAQ symbol': 'XSHQ',
  },
  {
    symbol: 'XSLV',
    'Security Name': 'Invesco S&P SmallCap Low Volatility ETF',

    'CQS symbol': 'XSLV',
    'NASDAQ symbol': 'XSLV',
  },
  {
    symbol: 'XSMO',
    'Security Name': 'Invesco S&P SmallCap Momentum ETF',

    'CQS symbol': 'XSMO',
    'NASDAQ symbol': 'XSMO',
  },
  {
    symbol: 'XSOE',
    'Security Name':
      'WisdomTree Emerging Markets ExState Owned Enterprises Fund',

    'CQS symbol': 'XSOE',
    'NASDAQ symbol': 'XSOE',
  },
  {
    symbol: 'XSPA',
    'Security Name': 'XpresSpa Group,    ',

    'NASDAQ symbol': 'XSPA',
  },
  {
    symbol: 'XSVM',
    'Security Name': 'Invesco S&P SmallCap Value with Momentum ETF',

    'CQS symbol': 'XSVM',
    'NASDAQ symbol': 'XSVM',
  },
  {
    symbol: 'XSW',
    'Security Name': 'SPDR S&P Software & Services ETF',

    'CQS symbol': 'XSW',
    'NASDAQ symbol': 'XSW',
  },
  {
    symbol: 'XT',
    'Security Name': 'iShares Exponential Technologies ETF',

    'NASDAQ symbol': 'XT',
  },
  {
    symbol: 'XTL',
    'Security Name': 'SPDR S&P Telecom ETF',

    'CQS symbol': 'XTL',
    'NASDAQ symbol': 'XTL',
  },
  {
    symbol: 'XTLB',
    'Security Name': 'XTL Biopharmaceuticals Ltd  American Depositary Shares',

    'NASDAQ symbol': 'XTLB',
  },
  {
    symbol: 'XTN',
    'Security Name': 'SPDR S&P Transportation ETF',

    'CQS symbol': 'XTN',
    'NASDAQ symbol': 'XTN',
  },
  {
    symbol: 'XTNT',
    'Security Name': 'Xtant Medical Holdings,  ',

    'CQS symbol': 'XTNT',
    'NASDAQ symbol': 'XTNT',
  },
  {
    symbol: 'XVV',
    'Security Name': 'iShares ESG Screened S&P 500 ETF',

    'CQS symbol': 'XVV',
    'NASDAQ symbol': 'XVV',
  },
  {
    symbol: 'XVZ',
    'Security Name': 'iPath S&P 500 Dynamic VIX ETN',

    'CQS symbol': 'XVZ',
    'NASDAQ symbol': 'XVZ',
  },
  {
    symbol: 'XWEB',
    'Security Name': 'SPDR S&P Internet ETF',

    'CQS symbol': 'XWEB',
    'NASDAQ symbol': 'XWEB',
  },
  {
    symbol: 'XXII',
    'Security Name': '22nd Century Group,  ',

    'CQS symbol': 'XXII',
    'NASDAQ symbol': 'XXII',
  },
  {
    symbol: 'XYF',
    'Security Name':
      'X Financial American Depositary Shares, each representing six  Ordinary Shares',

    'CQS symbol': 'XYF',
    'NASDAQ symbol': 'XYF',
  },
  {
    symbol: 'XYL',
    'Security Name': 'Xylem   New',

    'CQS symbol': 'XYL',
    'NASDAQ symbol': 'XYL',
  },
  {
    symbol: 'XYLD',
    'Security Name': 'Global X Funds Global X S&P 500 Covered Call ETF',

    'CQS symbol': 'XYLD',
    'NASDAQ symbol': 'XYLD',
  },
  {
    symbol: 'XYLG',
    'Security Name': 'Global X S&P 500 Covered Call & Growth ETF',

    'CQS symbol': 'XYLG',
    'NASDAQ symbol': 'XYLG',
  },
  {
    symbol: 'Y',
    'Security Name': 'Alleghany Corporation ',

    'CQS symbol': 'Y',
    'NASDAQ symbol': 'Y',
  },
  {
    symbol: 'YAC',
    'Security Name': 'Yucaipa Acquisition Corporation  Ordinary Shares',

    'CQS symbol': 'YAC',
    'NASDAQ symbol': 'YAC',
  },
  {
    symbol: 'YACU',
    'Security Name':
      'Yucaipa Acquisition Corporation Units, each consisting of one  ordinary share and onethird of one redeemable warrant',

    'CQS symbol': 'YACU',
    'NASDAQ symbol': 'YAC=',
  },
  {
    symbol: 'YACW',
    'Security Name':
      'Yucaipa Acquisition Corporation Redeemable Warrants, each whole warrant exercisable for one  ordinary share at an exercise price of $1150',

    'CQS symbol': 'YACWS',
    'NASDAQ symbol': 'YAC+',
  },
  {
    symbol: 'YALA',
    'Security Name':
      'Yalla Group Limited American Depositary Shares, each representing one  Ordinary Share',

    'CQS symbol': 'YALA',
    'NASDAQ symbol': 'YALA',
  },
  {
    symbol: 'YANG',
    'Security Name': 'Direxion Daily FTSE China Bear 3x Shares',

    'CQS symbol': 'YANG',
    'NASDAQ symbol': 'YANG',
  },
  {
    symbol: 'YCBD',
    'Security Name': 'cbdMD,  ',

    'CQS symbol': 'YCBD',
    'NASDAQ symbol': 'YCBD',
  },
  {
    symbol: 'YCBD$A',
    'Security Name':
      'cbdMD,  80% Series A Cumulative Convertible Preferred Stock',

    'CQS symbol': 'YCBDpA',
    'NASDAQ symbol': 'YCBDA',
  },
  {
    symbol: 'YCL',
    'Security Name': 'ProShares Ultra Yen',

    'CQS symbol': 'YCL',
    'NASDAQ symbol': 'YCL',
  },
  {
    symbol: 'YCS',
    'Security Name': 'ProShares UltraShort Yen New',

    'CQS symbol': 'YCS',
    'NASDAQ symbol': 'YCS',
  },
  {
    symbol: 'YELP',
    'Security Name': 'Yelp  ',

    'CQS symbol': 'YELP',
    'NASDAQ symbol': 'YELP',
  },
  {
    symbol: 'YETI',
    'Security Name': 'YETI Holdings,  ',

    'CQS symbol': 'YETI',
    'NASDAQ symbol': 'YETI',
  },
  {
    symbol: 'YEXT',
    'Security Name': 'Yext,  ',

    'CQS symbol': 'YEXT',
    'NASDAQ symbol': 'YEXT',
  },
  {
    symbol: 'YGMZ',
    'Security Name': 'MingZhu Logistics Holdings Limited  Ordinary Shares',

    'NASDAQ symbol': 'YGMZ',
  },
  {
    symbol: 'YGRN',
    'Security Name': 'MicroSectors US Big Oil Index Inverse ETN',

    'CQS symbol': 'YGRN',
    'NASDAQ symbol': 'YGRN',
  },
  {
    symbol: 'YI',
    'Security Name': '111,   American Depositary Shares',

    'NASDAQ symbol': 'YI',
  },
  {
    symbol: 'YINN',
    'Security Name': 'Direxion Daily FTSE China Bull 3x Shares',

    'CQS symbol': 'YINN',
    'NASDAQ symbol': 'YINN',
  },
  {
    symbol: 'YJ',
    'Security Name': 'Yunji   American ',

    'NASDAQ symbol': 'YJ',
  },
  {
    symbol: 'YLCO',
    'Security Name': 'Global X YieldCo & Renewable Energy ome ETF',

    'NASDAQ symbol': 'YLCO',
  },
  {
    symbol: 'YLD',
    'Security Name': 'Pripal Active ome ETF',

    'CQS symbol': 'YLD',
    'NASDAQ symbol': 'YLD',
  },
  {
    symbol: 'YLDE',
    'Security Name': 'ClearBridge Dividend Strategy ESG ETF',

    'NASDAQ symbol': 'YLDE',
  },
  {
    symbol: 'YMAB',
    'Security Name': 'YmAbs Therapeutics,   ',

    'NASDAQ symbol': 'YMAB',
  },
  {
    symbol: 'YNDX',
    'Security Name': 'Yandex NV   Ordinary Shares',

    'NASDAQ symbol': 'YNDX',
  },
  {
    symbol: 'YOLO',
    'Security Name': 'AdvisorShares Pure Cannabis ETF',

    'CQS symbol': 'YOLO',
    'NASDAQ symbol': 'YOLO',
  },
  {
    symbol: 'YORW',
    'Security Name': 'The York Water Company  ',

    'NASDAQ symbol': 'YORW',
  },
  {
    symbol: 'YPF',
    'Security Name': 'YPF Sociedad Anonima ',

    'CQS symbol': 'YPF',
    'NASDAQ symbol': 'YPF',
  },
  {
    symbol: 'YQ',
    'Security Name':
      '17 Education & Technology Group   American Depositary Shares',

    'NASDAQ symbol': 'YQ',
  },
  {
    symbol: 'YRCW',
    'Security Name': 'YRC Worldwide,   ',

    'NASDAQ symbol': 'YRCW',
  },
  {
    symbol: 'YRD',
    'Security Name':
      'Yiren Digital Ltd American Depositary Shares, each representing two ordinary shares',

    'CQS symbol': 'YRD',
    'NASDAQ symbol': 'YRD',
  },
  {
    symbol: 'YSACU',
    'Security Name': 'Yellowstone Acquisition Company  Units',

    'NASDAQ symbol': 'YSACU',
  },
  {
    symbol: 'YSG',
    'Security Name':
      'Yatsen Holding Limited American Depositary Shares, each representing four  ordinary shares',

    'CQS symbol': 'YSG',
    'NASDAQ symbol': 'YSG',
  },
  {
    symbol: 'YTEN',
    'Security Name': 'Yield10 Bioscience,    ',

    'NASDAQ symbol': 'YTEN',
  },
  {
    symbol: 'YTRA',
    'Security Name': 'Yatra Online,   Ordinary Shares',

    'NASDAQ symbol': 'YTRA',
  },
  {
    symbol: 'YUM',
    'Security Name': 'Yum! Brands, ',

    'CQS symbol': 'YUM',
    'NASDAQ symbol': 'YUM',
  },
  {
    symbol: 'YUMC',
    'Security Name': 'Yum China Holdings,  ',

    'CQS symbol': 'YUMC',
    'NASDAQ symbol': 'YUMC',
  },
  {
    symbol: 'YVR',
    'Security Name': 'Liquid Media Group Ltd  Common Shares',

    'NASDAQ symbol': 'YVR',
  },
  {
    symbol: 'YXI',
    'Security Name': 'ProShares Short FTSE China 50',

    'CQS symbol': 'YXI',
    'NASDAQ symbol': 'YXI',
  },
  {
    symbol: 'YY',
    'Security Name': 'JOYY   American Depositary Shares',

    'NASDAQ symbol': 'YY',
  },
  {
    symbol: 'YYY',
    'Security Name': 'Amplify High ome ETF',

    'CQS symbol': 'YYY',
    'NASDAQ symbol': 'YYY',
  },
  {
    symbol: 'Z',
    'Security Name': 'Zillow Group,   Class C Capital Stock',

    'NASDAQ symbol': 'Z',
  },
  {
    symbol: 'ZAGG',
    'Security Name': 'ZAGG   ',

    'NASDAQ symbol': 'ZAGG',
  },
  {
    symbol: 'ZAZZT',
    'Security Name': 'Tick Pilot Test Stock  ',
    ETF: ' ',

    'Test Issue': 'Y',
    'NASDAQ symbol': 'ZAZZT',
  },
  {
    symbol: 'ZBH',
    'Security Name': 'Zimmer Biomet Holdings,  ',

    'CQS symbol': 'ZBH',
    'NASDAQ symbol': 'ZBH',
  },
  {
    symbol: 'ZBRA',
    'Security Name': 'Zebra Technologies Corporation   ',

    'NASDAQ symbol': 'ZBRA',
  },
  {
    symbol: 'ZBZX',
    'Security Name': 'BATS BZX Exchange test issue',

    'Test Issue': 'Y',

    'CQS symbol': 'ZBZX',
    'NASDAQ symbol': 'ZBZX',
  },
  {
    symbol: 'ZBZZT',
    'Security Name': 'Test Pilot Test Stock Class B ',
    ETF: ' ',

    'Test Issue': 'Y',
    'NASDAQ symbol': 'ZBZZT',
  },
  {
    symbol: 'ZCAN',
    'Security Name': 'SPDR Solactive Canada ETF',

    'CQS symbol': 'ZCAN',
    'NASDAQ symbol': 'ZCAN',
  },
  {
    symbol: 'ZCMD',
    'Security Name': 'Zhongchao    Ordinary Shares',

    'NASDAQ symbol': 'ZCMD',
  },
  {
    symbol: 'ZCZZT',
    'Security Name': 'Tick Pilot Test Stock Class C ',
    ETF: ' ',

    'Test Issue': 'Y',
    'NASDAQ symbol': 'ZCZZT',
  },
  {
    symbol: 'ZDEU',
    'Security Name': 'SPDR Solactive Germany ETF',

    'CQS symbol': 'ZDEU',
    'NASDAQ symbol': 'ZDEU',
  },
  {
    symbol: 'ZDGE',
    'Security Name': 'Zedge,  Class B  ',

    'CQS symbol': 'ZDGE',
    'NASDAQ symbol': 'ZDGE',
  },
  {
    symbol: 'ZEAL',
    'Security Name': 'Zealand Pharma A/S  American Depositary Shares',

    'NASDAQ symbol': 'ZEAL',
  },
  {
    symbol: 'ZEN',
    'Security Name': 'Zendesk,  ',

    'CQS symbol': 'ZEN',
    'NASDAQ symbol': 'ZEN',
  },
  {
    symbol: 'ZEUS',
    'Security Name': 'Olympic Steel,   ',

    'NASDAQ symbol': 'ZEUS',
  },
  {
    symbol: 'ZEXIT',
    'Security Name': 'IEX Test Company Test symbol Two for IEX',
    'Listing Exchange': 'V',

    'Test Issue': 'Y',

    'CQS symbol': 'ZEXIT',
    'NASDAQ symbol': 'ZEXIT',
  },
  {
    symbol: 'ZG',
    'Security Name': 'Zillow Group,    ',

    'NASDAQ symbol': 'ZG',
  },
  {
    symbol: 'ZGBR',
    'Security Name': 'SPDR Solactive United Kingdom ETF',

    'CQS symbol': 'ZGBR',
    'NASDAQ symbol': 'ZGBR',
  },
  {
    symbol: 'ZGNX',
    'Security Name': 'Zogenix,   ',

    'NASDAQ symbol': 'ZGNX',
  },
  {
    symbol: 'ZGYH',
    'Security Name': 'Yunhong International   Ordinary Shares',

    'NASDAQ symbol': 'ZGYH',
  },
  {
    symbol: 'ZGYHR',
    'Security Name': 'Yunhong International  Right',

    'NASDAQ symbol': 'ZGYHR',
  },
  {
    symbol: 'ZGYHU',
    'Security Name': 'Yunhong International  Unit',

    'NASDAQ symbol': 'ZGYHU',
  },
  {
    symbol: 'ZGYHW',
    'Security Name': 'Yunhong International  Warrant',

    'NASDAQ symbol': 'ZGYHW',
  },
  {
    symbol: 'ZHOK',
    'Security Name': 'SPDR Solactive Hong Kong ETF',

    'CQS symbol': 'ZHOK',
    'NASDAQ symbol': 'ZHOK',
  },
  {
    symbol: 'ZI',
    'Security Name': 'ZoomInfo Technologies    ',

    'NASDAQ symbol': 'ZI',
  },
  {
    symbol: 'ZIEXT',
    'Security Name': 'IEX Test Company Test symbol One for IEX',
    'Listing Exchange': 'V',

    'Test Issue': 'Y',

    'CQS symbol': 'ZIEXT',
    'NASDAQ symbol': 'ZIEXT',
  },
  {
    symbol: 'ZIG',
    'Security Name': 'The Acquirers Fund',

    'CQS symbol': 'ZIG',
    'NASDAQ symbol': 'ZIG',
  },
  {
    symbol: 'ZION',
    'Security Name': 'Zions Bancorporation NA  ',

    'NASDAQ symbol': 'ZION',
  },
  {
    symbol: 'ZIONL',
    'Security Name':
      'Zions Bancorporation NA  695% FixedtoFloating Rate Subordinated Notes due September 15, 2028',

    'NASDAQ symbol': 'ZIONL',
  },
  {
    symbol: 'ZIONN',
    'Security Name':
      'Zions Bancorporation NA  Depositary Shares each representing a 1/40th ownership interest in a share of Series H 575% NonCumulative Perpetual Preferred Stock',

    'NASDAQ symbol': 'ZIONN',
  },
  {
    symbol: 'ZIONO',
    'Security Name':
      'Zions Bancorporation NA  Depositary Shares each representing a 1/40th ownership interest in a share of Series G Fixed/FloatingRate NonCumulative Perpetual Preferred Stock',

    'NASDAQ symbol': 'ZIONO',
  },
  {
    symbol: 'ZIONP',
    'Security Name':
      'Zions Bancorporation NA  Depositary Shares each representing a 1/40th ownership interest in a share of Series A FloatingRate NonCumulative Perpetual Preferred Stock',

    'NASDAQ symbol': 'ZIONP',
  },
  {
    symbol: 'ZIOP',
    'Security Name': 'ZIOPHARM Oncology   ',

    'NASDAQ symbol': 'ZIOP',
  },
  {
    symbol: 'ZIXI',
    'Security Name': 'Zix Corporation  ',

    'NASDAQ symbol': 'ZIXI',
  },
  {
    symbol: 'ZJPN',
    'Security Name': 'SPDR Solactive Japan ETF',

    'CQS symbol': 'ZJPN',
    'NASDAQ symbol': 'ZJPN',
  },
  {
    symbol: 'ZJZZT',
    'Security Name': 'NASDAQ TEST STOCK',
    ETF: ' ',

    'Test Issue': 'Y',
    'NASDAQ symbol': 'ZJZZT',
  },
  {
    symbol: 'ZKIN',
    'Security Name': 'ZK International Group Co, Ltd  Ordinary Share',

    'NASDAQ symbol': 'ZKIN',
  },
  {
    symbol: 'ZLAB',
    'Security Name': 'Zai Lab Limited  American Depositary Shares',

    'NASDAQ symbol': 'ZLAB',
  },
  {
    symbol: 'ZM',
    'Security Name': 'Zoom Video Communications,    ',

    'NASDAQ symbol': 'ZM',
  },
  {
    symbol: 'ZNGA',
    'Security Name': 'Zynga    ',

    'NASDAQ symbol': 'ZNGA',
  },
  {
    symbol: 'ZNH',
    'Security Name': 'China Southern Airlines Company Limited ',

    'CQS symbol': 'ZNH',
    'NASDAQ symbol': 'ZNH',
  },
  {
    symbol: 'ZNTEU',
    'Security Name': 'Zanite Acquisition Corp  Unit',

    'NASDAQ symbol': 'ZNTEU',
  },
  {
    symbol: 'ZNTL',
    'Security Name': 'Zentalis Pharmaceuticals,   ',

    'NASDAQ symbol': 'ZNTL',
  },
  {
    symbol: 'ZOM',
    'Security Name': 'Zomedica Corp Common Shares',

    'CQS symbol': 'ZOM',
    'NASDAQ symbol': 'ZOM',
  },
  {
    symbol: 'ZROZ',
    'Security Name':
      'PIMCO 25  Year Zero Coupon US Treasury Index ExchangeTraded Fund',

    'CQS symbol': 'ZROZ',
    'NASDAQ symbol': 'ZROZ',
  },
  {
    symbol: 'ZS',
    'Security Name': 'Zscaler,   ',

    'NASDAQ symbol': 'ZS',
  },
  {
    symbol: 'ZSAN',
    'Security Name': 'Zosano Pharma Corporation  ',

    'NASDAQ symbol': 'ZSAN',
  },
  {
    symbol: 'ZSL',
    'Security Name': 'ProShares UltraShort Silver',

    'CQS symbol': 'ZSL',
    'NASDAQ symbol': 'ZSL',
  },
  {
    symbol: 'ZTEST',
    'Security Name': 'BATS BZX Exchange  (test issue)',

    'Test Issue': 'Y',

    'CQS symbol': 'ZTEST',
    'NASDAQ symbol': 'ZTEST',
  },
  {
    symbol: 'ZTO',
    'Security Name':
      'ZTO Express (Cayman)  American Depositary Shares, each representing one  ordinary share',

    'CQS symbol': 'ZTO',
    'NASDAQ symbol': 'ZTO',
  },
  {
    symbol: 'ZTR',
    'Security Name': 'Virtus Total Return Fund ',

    'CQS symbol': 'ZTR',
    'NASDAQ symbol': 'ZTR',
  },
  {
    symbol: 'ZTS',
    'Security Name': 'Zoetis   ',

    'CQS symbol': 'ZTS',
    'NASDAQ symbol': 'ZTS',
  },
  {
    symbol: 'ZUMZ',
    'Security Name': 'Zumiez   ',

    'NASDAQ symbol': 'ZUMZ',
  },
  {
    symbol: 'ZUO',
    'Security Name': 'Zuora,   ',

    'CQS symbol': 'ZUO',
    'NASDAQ symbol': 'ZUO',
  },
  {
    symbol: 'ZVO',
    'Security Name': 'Zovio   ',

    'NASDAQ symbol': 'ZVO',
  },
  {
    symbol: 'ZVV',
    'Security Name': 'NYSE ARCA test stock',

    'Test Issue': 'Y',

    'CQS symbol': 'ZVV',
    'NASDAQ symbol': 'ZVV',
  },
  {
    symbol: 'ZVZZC',
    'Security Name': 'NASDAQ TEST STOCK Nextshares Test Security',
    ETF: ' ',

    'Test Issue': 'Y',
    'NASDAQ symbol': 'ZVZZC',
    NextShares: 'Y',
  },
  {
    symbol: 'ZVZZT',
    'Security Name': 'NASDAQ TEST STOCK',
    ETF: ' ',

    'Test Issue': 'Y',
    'NASDAQ symbol': 'ZVZZT',
  },
  {
    symbol: 'ZWZZT',
    'Security Name': 'NASDAQ TEST STOCK',
    ETF: ' ',

    'Test Issue': 'Y',
    'NASDAQ symbol': 'ZWZZT',
  },
  {
    symbol: 'ZXIET',
    'Security Name': 'IEX Test Company Test symbol Three for IEX',
    'Listing Exchange': 'V',

    'Test Issue': 'Y',

    'CQS symbol': 'ZXIET',
    'NASDAQ symbol': 'ZXIET',
  },
  {
    symbol: 'ZXYZA',
    'Security Name': 'Nasdaq symbology Test ',
    ETF: ' ',

    'Test Issue': 'Y',
    'NASDAQ symbol': 'ZXYZA',
  },
  {
    symbol: 'ZXZZT',
    'Security Name': 'NASDAQ TEST STOCK',
    ETF: ' ',

    'Test Issue': 'Y',
    'NASDAQ symbol': 'ZXZZT',
  },
  {
    symbol: 'ZYME',
    'Security Name': 'Zymeworks  Common Shares',

    'CQS symbol': 'ZYME',
    'NASDAQ symbol': 'ZYME',
  },
  {
    symbol: 'ZYNE',
    'Security Name': 'Zynerba Pharmaceuticals,   ',

    'NASDAQ symbol': 'ZYNE',
  },
  {
    symbol: 'ZYXI',
    'Security Name': 'Zynex,   ',

    'NASDAQ symbol': 'ZYXI',
  },
  {
    'Nasdaq Traded': 'File Creation Time: 1204202021:33',
    symbol: '',
    'Security Name': '',
    'Listing Exchange': '',
    'Market Category': '',
    ETF: '',
    'Round Lot Size': '',
    'Test Issue': '',

    'NASDAQ symbol': '',
    NextShares: '',
  },
];
export default symbols;
